// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"9gZmm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _reactQueryDevtools = require("@tanstack/react-query-devtools");
var _bundle = require("swiper/element/bundle");
var _routes = require("./routes");
var _indexCss = require("./styles/index.css");
// Initialize languages
var _i18N = require("./locales/i18n");
const queryClient = new (0, _reactQuery.QueryClient)({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false
        }
    }
});
(0, _bundle.register)();
const router = (0, _reactRouterDom.createBrowserRouter)((0, _routes.routes));
const root = (0, _clientDefault.default).createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).StrictMode, {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactQuery.QueryClientProvider), {
        client: queryClient,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.RouterProvider), {
                router: router
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQueryDevtools.ReactQueryDevtools), {
                initialIsOpen: false
            })
        ]
    })
}));

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-dom/client":"5Jz9D","react-router-dom":"5o0mA","@tanstack/react-query":"jWXOo","@tanstack/react-query-devtools":"2FMsy","swiper/element/bundle":"cGtHz","./routes":"eCf5Q","./styles/index.css":"dwfBH","./locales/i18n":"2hqMu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g88cO":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"hXpuN"}],"hXpuN":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"BK2ob"}],"BK2ob":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"7PQOg"}],"7PQOg":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"5Jz9D":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"izP7d"}],"izP7d":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"2QglY"}],"2QglY":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"BK2ob","ece50e903283a22f":"2AxYk"}],"2AxYk":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"jGsTY"}],"jGsTY":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"5o0mA":[function(require,module,exports) {
/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "unstable_useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"BK2ob","react-dom":"izP7d","react-router":"iztKD","@remix-run/router":"95h1F","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iztKD":[function(require,module,exports) {
/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}

},{"react":"BK2ob","@remix-run/router":"95h1F","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"95h1F":[function(require,module,exports) {
/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || defaultDataStrategy;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, loaderData, errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState(_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission, fetcherSubmission, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if (isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: ResultType.redirect,
                        response: normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation, nextLocation, historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isHandlerResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await callDataStrategyImpl(unstable_dataStrategy || defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if (isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: ResultType.data,
                    result: undefined
                });
            };
            return _extends({}, match, {
                shouldLoad,
                resolve
            });
        }),
        request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>invariant(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertHandlerResultToDataResult(handlerResult) {
    let { result, type, status } = handlerResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) return {
        type: ResultType.error,
        error: result,
        statusCode: isRouteErrorResponse(result) ? result.status : status
    };
    if (isDeferredData(result)) {
        var _result$init, _result$init2;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, match, controller } = revalidatingFetchers[index];
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if (isRedirectResult(result)) return {
            result,
            idx: i
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectHandlerResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            invariant(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lA3Ur":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"jWXOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesEsmJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryEsmJs.useQuery));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderEsmJs.QueryClientProvider));
parcelHelpers.export(exports, "defaultContext", ()=>(0, _queryClientProviderEsmJs.defaultContext));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderEsmJs.useQueryClient));
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrateEsmJs.Hydrate));
parcelHelpers.export(exports, "useHydrate", ()=>(0, _hydrateEsmJs.useHydrate));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingEsmJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useIsMutatingEsmJs.useIsMutating));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationEsmJs.useMutation));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryEsmJs.useInfiniteQuery));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringEsmJs.IsRestoringProvider));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringEsmJs.useIsRestoring));
var _setBatchUpdatesFnEsmJs = require("./setBatchUpdatesFn.esm.js");
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _useQueriesEsmJs = require("./useQueries.esm.js");
var _useQueryEsmJs = require("./useQuery.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _hydrateEsmJs = require("./Hydrate.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _useIsFetchingEsmJs = require("./useIsFetching.esm.js");
var _useIsMutatingEsmJs = require("./useIsMutating.esm.js");
var _useMutationEsmJs = require("./useMutation.esm.js");
var _useInfiniteQueryEsmJs = require("./useInfiniteQuery.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");

},{"./setBatchUpdatesFn.esm.js":"5gNhh","@tanstack/query-core":"ectfC","./useQueries.esm.js":false,"./useQuery.esm.js":"2ZO5i","./QueryClientProvider.esm.js":"16eFR","./Hydrate.esm.js":false,"./QueryErrorResetBoundary.esm.js":false,"./useIsFetching.esm.js":false,"./useIsMutating.esm.js":false,"./useMutation.esm.js":false,"./useInfiniteQuery.esm.js":false,"./isRestoring.esm.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5gNhh":[function(require,module,exports) {
var _queryCore = require("@tanstack/query-core");
var _reactBatchedUpdatesEsmJs = require("./reactBatchedUpdates.esm.js");
(0, _queryCore.notifyManager).setBatchNotifyFunction((0, _reactBatchedUpdatesEsmJs.unstable_batchedUpdates));

},{"@tanstack/query-core":"ectfC","./reactBatchedUpdates.esm.js":"cTVTz"}],"ectfC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryerEsmJs.CancelledError));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryerEsmJs.isCancelledError));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCacheEsmJs.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClientEsmJs.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserverEsmJs.QueryObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserverEsmJs.QueriesObserver));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserverEsmJs.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCacheEsmJs.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserverEsmJs.MutationObserver));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManagerEsmJs.notifyManager));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManagerEsmJs.focusManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManagerEsmJs.onlineManager));
parcelHelpers.export(exports, "hashQueryKey", ()=>(0, _utilsEsmJs.hashQueryKey));
parcelHelpers.export(exports, "isError", ()=>(0, _utilsEsmJs.isError));
parcelHelpers.export(exports, "isServer", ()=>(0, _utilsEsmJs.isServer));
parcelHelpers.export(exports, "matchQuery", ()=>(0, _utilsEsmJs.matchQuery));
parcelHelpers.export(exports, "parseFilterArgs", ()=>(0, _utilsEsmJs.parseFilterArgs));
parcelHelpers.export(exports, "parseMutationArgs", ()=>(0, _utilsEsmJs.parseMutationArgs));
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>(0, _utilsEsmJs.parseMutationFilterArgs));
parcelHelpers.export(exports, "parseQueryArgs", ()=>(0, _utilsEsmJs.parseQueryArgs));
parcelHelpers.export(exports, "replaceEqualDeep", ()=>(0, _utilsEsmJs.replaceEqualDeep));
parcelHelpers.export(exports, "defaultShouldDehydrateMutation", ()=>(0, _hydrationEsmJs.defaultShouldDehydrateMutation));
parcelHelpers.export(exports, "defaultShouldDehydrateQuery", ()=>(0, _hydrationEsmJs.defaultShouldDehydrateQuery));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydrationEsmJs.dehydrate));
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydrationEsmJs.hydrate));
parcelHelpers.export(exports, "Query", ()=>(0, _queryEsmJs.Query));
var _retryerEsmJs = require("./retryer.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _queryClientEsmJs = require("./queryClient.esm.js");
var _queryObserverEsmJs = require("./queryObserver.esm.js");
var _queriesObserverEsmJs = require("./queriesObserver.esm.js");
var _infiniteQueryObserverEsmJs = require("./infiniteQueryObserver.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _mutationObserverEsmJs = require("./mutationObserver.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _hydrationEsmJs = require("./hydration.esm.js");
var _queryEsmJs = require("./query.esm.js");

},{"./retryer.esm.js":false,"./queryCache.esm.js":false,"./queryClient.esm.js":"1YM2j","./queryObserver.esm.js":"7EQZi","./queriesObserver.esm.js":false,"./infiniteQueryObserver.esm.js":false,"./mutationCache.esm.js":false,"./mutationObserver.esm.js":false,"./notifyManager.esm.js":"a3z5F","./focusManager.esm.js":false,"./onlineManager.esm.js":"kpceT","./utils.esm.js":"dDxAa","./hydration.esm.js":false,"./query.esm.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"57Qre":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function canFetch(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, _onlineManagerEsmJs.onlineManager).isOnline() : true;
}
class CancelledError {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new CancelledError(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, _focusManagerEsmJs.focusManager).isFocused() || config.networkMode !== "always" && !(0, _onlineManagerEsmJs.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, _utilsEsmJs.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if (canFetch(config.networkMode)) run();
    else pause().then(run);
    return {
        promise,
        cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry,
        continueRetry
    };
}

},{"./focusManager.esm.js":"eqwl0","./onlineManager.esm.js":"kpceT","./utils.esm.js":"dDxAa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eqwl0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
class FocusManager extends (0, _subscribableEsmJs.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const focusManager = new FocusManager();

},{"./subscribable.esm.js":"gxATY","./utils.esm.js":"dDxAa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gxATY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
class Subscribable {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dDxAa":[function(require,module,exports) {
// TYPES
// UTILS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "getAbortController", ()=>getAbortController);
parcelHelpers.export(exports, "hashQueryKey", ()=>hashQueryKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isQueryKey", ()=>isQueryKey);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "parseFilterArgs", ()=>parseFilterArgs);
parcelHelpers.export(exports, "parseMutationArgs", ()=>parseMutationArgs);
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>parseMutationFilterArgs);
parcelHelpers.export(exports, "parseQueryArgs", ()=>parseQueryArgs);
parcelHelpers.export(exports, "partialDeepEqual", ()=>partialDeepEqual);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceAt", ()=>replaceAt);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "scheduleMicrotask", ()=>scheduleMicrotask);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
const isServer = typeof window === "undefined" || "Deno" in window;
function noop() {
    return undefined;
}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function parseMutationArgs(arg1, arg2, arg3) {
    if (isQueryKey(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function parseFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (isQueryKey(queryKey)) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, fetching, predicate, mutationKey } = filters;
    if (isQueryKey(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function hashQueryKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function partialMatchKey(a, b) {
    return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function partialDeepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!partialDeepEqual(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function replaceEqualDeep(a, b) {
    if (a === b) return a;
    const array = isPlainArray(a) && isPlainArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function shallowEqualObjects(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function isQueryKey(value) {
    return Array.isArray(value);
}
function isError(value) {
    return value instanceof Error;
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function scheduleMicrotask(callback) {
    sleep(0).then(callback);
}
function getAbortController() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function replaceData(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
    return data;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kpceT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _subscribableEsmJs = require("./subscribable.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
const onlineEvents = [
    "online",
    "offline"
];
class OnlineManager extends (0, _subscribableEsmJs.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, _utilsEsmJs.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const onlineManager = new OnlineManager();

},{"./subscribable.esm.js":"gxATY","./utils.esm.js":"dDxAa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8KdyT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _utilsEsmJs = require("./utils.esm.js");
var _queryEsmJs = require("./query.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class QueryCache extends (0, _subscribableEsmJs.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utilsEsmJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryEsmJs.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, _utilsEsmJs.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, _utilsEsmJs.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}

},{"./utils.esm.js":"dDxAa","./query.esm.js":"2j7i7","./notifyManager.esm.js":"a3z5F","./subscribable.esm.js":"gxATY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2j7i7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
var _utilsEsmJs = require("./utils.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
var _removableEsmJs = require("./removable.esm.js");
// CLASS
class Query extends (0, _removableEsmJs.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsEsmJs.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utilsEsmJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, _utilsEsmJs.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, _retryerEsmJs.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, _retryerEsmJs.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, _retryerEsmJs.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, _retryerEsmJs.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, _retryerEsmJs.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action
            });
        });
    }
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

},{"./utils.esm.js":"dDxAa","./logger.esm.js":"p1vCE","./notifyManager.esm.js":"a3z5F","./retryer.esm.js":"57Qre","./removable.esm.js":"kXynv","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"p1vCE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLogger", ()=>defaultLogger);
const defaultLogger = console;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a3z5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _utilsEsmJs = require("./utils.esm.js");
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, _utilsEsmJs.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch,
        batchCalls,
        schedule,
        setNotifyFunction,
        setBatchNotifyFunction
    };
} // SINGLETON
const notifyManager = createNotifyManager();

},{"./utils.esm.js":"dDxAa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kXynv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _utilsEsmJs = require("./utils.esm.js");
class Removable {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsEsmJs.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, _utilsEsmJs.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

},{"./utils.esm.js":"dDxAa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1YM2j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _utilsEsmJs = require("./utils.esm.js");
var _queryCacheEsmJs = require("./queryCache.esm.js");
var _mutationCacheEsmJs = require("./mutationCache.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _onlineManagerEsmJs = require("./onlineManager.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _infiniteQueryBehaviorEsmJs = require("./infiniteQueryBehavior.esm.js");
var _loggerEsmJs = require("./logger.esm.js");
// CLASS
class QueryClient {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, _queryCacheEsmJs.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, _mutationCacheEsmJs.MutationCache)();
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, _focusManagerEsmJs.focusManager).subscribe(()=>{
            if ((0, _focusManagerEsmJs.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, _onlineManagerEsmJs.onlineManager).subscribe(()=>{
            if ((0, _onlineManagerEsmJs.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, _utilsEsmJs.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        return (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, _utilsEsmJs.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, _notifyManagerEsmJs.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, _utilsEsmJs.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, _utilsEsmJs.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, _infiniteQueryBehaviorEsmJs.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, _utilsEsmJs.noop)).catch((0, _utilsEsmJs.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(queryKey) === (0, _utilsEsmJs.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.hashQueryKey)(mutationKey) === (0, _utilsEsmJs.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, _utilsEsmJs.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, _utilsEsmJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}

},{"./utils.esm.js":"dDxAa","./queryCache.esm.js":"8KdyT","./mutationCache.esm.js":"52jS4","./focusManager.esm.js":"eqwl0","./onlineManager.esm.js":"kpceT","./notifyManager.esm.js":"a3z5F","./infiniteQueryBehavior.esm.js":"auyqJ","./logger.esm.js":"p1vCE","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"52jS4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _mutationEsmJs = require("./mutation.esm.js");
var _utilsEsmJs = require("./utils.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
// CLASS
class MutationCache extends (0, _subscribableEsmJs.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, _mutationEsmJs.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation
        });
    }
    clear() {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, _utilsEsmJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, _notifyManagerEsmJs.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, _utilsEsmJs.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}

},{"./notifyManager.esm.js":"a3z5F","./mutation.esm.js":"juHWc","./utils.esm.js":"dDxAa","./subscribable.esm.js":"gxATY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"juHWc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _loggerEsmJs = require("./logger.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _removableEsmJs = require("./removable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
// CLASS
class Mutation extends (0, _removableEsmJs.Removable) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, _loggerEsmJs.defaultLogger);
        this.observers = [];
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, _retryerEsmJs.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount,
                        error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, _retryerEsmJs.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action
            });
        });
    }
}
function getDefaultState() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

},{"./logger.esm.js":"p1vCE","./notifyManager.esm.js":"a3z5F","./removable.esm.js":"kXynv","./retryer.esm.js":"57Qre","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"auyqJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNextPageParam", ()=>getNextPageParam);
parcelHelpers.export(exports, "getPreviousPageParam", ()=>getPreviousPageParam);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
function infiniteQueryBehavior() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function getNextPageParam(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function hasNextPage(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = getNextPageParam(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function hasPreviousPage(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = getPreviousPageParam(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7EQZi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _utilsEsmJs = require("./utils.esm.js");
var _notifyManagerEsmJs = require("./notifyManager.esm.js");
var _focusManagerEsmJs = require("./focusManager.esm.js");
var _subscribableEsmJs = require("./subscribable.esm.js");
var _retryerEsmJs = require("./retryer.esm.js");
class QueryObserver extends (0, _subscribableEsmJs.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, _utilsEsmJs.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, _utilsEsmJs.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, _utilsEsmJs.isServer) || this.currentResult.isStale || !(0, _utilsEsmJs.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, _utilsEsmJs.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, _utilsEsmJs.isServer) || this.options.enabled === false || !(0, _utilsEsmJs.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, _focusManagerEsmJs.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state } = query;
        let { dataUpdatedAt, error, errorUpdatedAt, fetchStatus, status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, _retryerEsmJs.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, _utilsEsmJs.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status,
            fetchStatus,
            isLoading,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading && isFetching,
            data,
            dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData,
            isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, _utilsEsmJs.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, _retryerEsmJs.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, _notifyManagerEsmJs.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, _utilsEsmJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

},{"./utils.esm.js":"dDxAa","./notifyManager.esm.js":"a3z5F","./focusManager.esm.js":"eqwl0","./subscribable.esm.js":"gxATY","./retryer.esm.js":"57Qre","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cTVTz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>unstable_batchedUpdates);
var _reactDom = require("react-dom");
"use client";
const unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

},{"react-dom":"izP7d","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2ZO5i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryEsmJs = require("./useBaseQuery.esm.js");
"use client";
function useQuery(arg1, arg2, arg3) {
    const parsedOptions = (0, _queryCore.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQueryEsmJs.useBaseQuery)(parsedOptions, (0, _queryCore.QueryObserver));
}

},{"@tanstack/query-core":"ectfC","./useBaseQuery.esm.js":"87yxN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"87yxN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _useSyncExternalStoreEsmJs = require("./useSyncExternalStore.esm.js");
var _queryErrorResetBoundaryEsmJs = require("./QueryErrorResetBoundary.esm.js");
var _queryClientProviderEsmJs = require("./QueryClientProvider.esm.js");
var _isRestoringEsmJs = require("./isRestoring.esm.js");
var _errorBoundaryUtilsEsmJs = require("./errorBoundaryUtils.esm.js");
var _suspenseEsmJs = require("./suspense.esm.js");
"use client";
function useBaseQuery(options, Observer) {
    const queryClient = (0, _queryClientProviderEsmJs.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, _isRestoringEsmJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryEsmJs.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, _queryCore.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, _suspenseEsmJs.ensureStaleTime)(defaultedOptions);
    (0, _errorBoundaryUtilsEsmJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, _errorBoundaryUtilsEsmJs.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = _react.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, _useSyncExternalStoreEsmJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, _suspenseEsmJs.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, _suspenseEsmJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, _errorBoundaryUtilsEsmJs.getHasError)({
        result,
        errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"BK2ob","@tanstack/query-core":"ectfC","./useSyncExternalStore.esm.js":"2MYYH","./QueryErrorResetBoundary.esm.js":"bo93Q","./QueryClientProvider.esm.js":"16eFR","./isRestoring.esm.js":"bgGGO","./errorBoundaryUtils.esm.js":"5tsCG","./suspense.esm.js":"4dNsD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2MYYH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>useSyncExternalStore);
var _indexJs = require("use-sync-external-store/shim/index.js");
"use client";
const useSyncExternalStore = (0, _indexJs.useSyncExternalStore);

},{"use-sync-external-store/shim/index.js":"8RLvf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8RLvf":[function(require,module,exports) {
"use strict";
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"bZrHz"}],"bZrHz":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"BK2ob"}],"bo93Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
var _react = require("react");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const QueryErrorResetBoundaryContext = /*#__PURE__*/ _react.createContext(createValue()); // HOOK
const useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext); // COMPONENT
const QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /*#__PURE__*/ _react.createElement(QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"16eFR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "defaultContext", ()=>defaultContext);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
var _react = require("react");
"use client";
const defaultContext = /*#__PURE__*/ _react.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/ _react.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = defaultContext;
        return window.ReactQueryClientContext;
    }
    return defaultContext;
}
const useQueryClient = ({ context } = {})=>{
    const queryClient = _react.useContext(getQueryClientContext(context, _react.useContext(QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const QueryClientProvider = ({ client, children, context, contextSharing = false })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ _react.createElement(QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: client
    }, children));
};

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bgGGO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
var _react = require("react");
"use client";
const IsRestoringContext = /*#__PURE__*/ _react.createContext(false);
const useIsRestoring = ()=>_react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5tsCG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
var _react = require("react");
var _utilsEsmJs = require("./utils.esm.js");
"use client";
const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const getHasError = ({ result, errorResetBoundary, useErrorBoundary, query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utilsEsmJs.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

},{"react":"BK2ob","./utils.esm.js":"k2mRy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k2mRy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4dNsD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensureStaleTime", ()=>ensureStaleTime);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
const ensureStaleTime = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2FMsy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactQueryDevtools", ()=>ReactQueryDevtools);
parcelHelpers.export(exports, "ReactQueryDevtoolsPanel", ()=>ReactQueryDevtoolsPanel);
var _devtoolsEsmJs = require("./devtools.esm.js");
"use client";
const ReactQueryDevtools = function() {
    return null;
};
const ReactQueryDevtoolsPanel = function() {
    return null;
};

},{"./devtools.esm.js":"8ejNf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8ejNf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactQueryDevtools", ()=>ReactQueryDevtools);
parcelHelpers.export(exports, "ReactQueryDevtoolsPanel", ()=>ReactQueryDevtoolsPanel);
var _rollupPluginBabelHelpersEsmJs = require("./_virtual/_rollupPluginBabelHelpers.esm.js");
var _react = require("react");
var _reactQuery = require("@tanstack/react-query");
var _matchSorterUtils = require("@tanstack/match-sorter-utils");
var _useLocalStorageEsmJs = require("./useLocalStorage.esm.js");
var _useLocalStorageEsmJsDefault = parcelHelpers.interopDefault(_useLocalStorageEsmJs);
var _utilsEsmJs = require("./utils.esm.js");
var _styledComponentsEsmJs = require("./styledComponents.esm.js");
var _screenreaderEsmJs = require("./screenreader.esm.js");
var _screenreaderEsmJsDefault = parcelHelpers.interopDefault(_screenreaderEsmJs);
var _themeEsmJs = require("./theme.esm.js");
var _explorerEsmJs = require("./Explorer.esm.js");
var _explorerEsmJsDefault = parcelHelpers.interopDefault(_explorerEsmJs);
var _logoEsmJs = require("./Logo.esm.js");
var _logoEsmJsDefault = parcelHelpers.interopDefault(_logoEsmJs);
var _indexJs = require("use-sync-external-store/shim/index.js");
"use client";
function ReactQueryDevtools({ initialIsOpen, panelProps = {}, closeButtonProps = {}, toggleButtonProps = {}, position = "bottom-left", containerElement: Container = "aside", context, styleNonce, panelPosition: initialPanelPosition = "bottom", errorTypes = [] }) {
    const rootRef = _react.useRef(null);
    const panelRef = _react.useRef(null);
    const [isOpen, setIsOpen] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsOpen", initialIsOpen);
    const [devtoolsHeight, setDevtoolsHeight] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsHeight", (0, _utilsEsmJs.defaultPanelSize));
    const [devtoolsWidth, setDevtoolsWidth] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsWidth", (0, _utilsEsmJs.defaultPanelSize));
    const [panelPosition = "bottom", setPanelPosition] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsPanelPosition", initialPanelPosition);
    const [isResolvedOpen, setIsResolvedOpen] = _react.useState(false);
    const [isResizing, setIsResizing] = _react.useState(false);
    const isMounted = (0, _utilsEsmJs.useIsMounted)();
    const handleDragStart = (panelElement, startEvent)=>{
        if (!panelElement) return;
        if (startEvent.button !== 0) return; // Only allow left click for drag
        const isVertical = (0, _utilsEsmJs.isVerticalSide)(panelPosition);
        setIsResizing(true);
        const { height, width } = panelElement.getBoundingClientRect();
        const startX = startEvent.clientX;
        const startY = startEvent.clientY;
        let newSize = 0;
        const run = (moveEvent)=>{
            // prevent mouse selecting stuff with mouse drag
            moveEvent.preventDefault(); // calculate the correct size based on mouse position and current panel position
            // hint: it is different formula for the opposite sides
            if (isVertical) {
                newSize = width + (panelPosition === "right" ? startX - moveEvent.clientX : moveEvent.clientX - startX);
                setDevtoolsWidth(newSize);
            } else {
                newSize = height + (panelPosition === "bottom" ? startY - moveEvent.clientY : moveEvent.clientY - startY);
                setDevtoolsHeight(newSize);
            }
            if (newSize < (0, _utilsEsmJs.minPanelSize)) setIsOpen(false);
            else setIsOpen(true);
        };
        const unsub = ()=>{
            if (isResizing) setIsResizing(false);
            document.removeEventListener("mousemove", run, false);
            document.removeEventListener("mouseUp", unsub, false);
        };
        document.addEventListener("mousemove", run, false);
        document.addEventListener("mouseup", unsub, false);
    };
    _react.useEffect(()=>{
        setIsResolvedOpen(isOpen != null ? isOpen : false);
    }, [
        isOpen,
        isResolvedOpen,
        setIsResolvedOpen
    ]); // Toggle panel visibility before/after transition (depending on direction).
    // Prevents focusing in a closed panel.
    _react.useEffect(()=>{
        const ref = panelRef.current;
        if (ref) {
            const handlePanelTransitionStart = ()=>{
                if (isResolvedOpen) ref.style.visibility = "visible";
            };
            const handlePanelTransitionEnd = ()=>{
                if (!isResolvedOpen) ref.style.visibility = "hidden";
            };
            ref.addEventListener("transitionstart", handlePanelTransitionStart);
            ref.addEventListener("transitionend", handlePanelTransitionEnd);
            return ()=>{
                ref.removeEventListener("transitionstart", handlePanelTransitionStart);
                ref.removeEventListener("transitionend", handlePanelTransitionEnd);
            };
        }
        return;
    }, [
        isResolvedOpen
    ]);
    _react.useEffect(()=>{
        var _rootRef$current;
        if (isResolvedOpen && (_rootRef$current = rootRef.current) != null && _rootRef$current.parentElement) {
            const { parentElement } = rootRef.current;
            const styleProp = (0, _utilsEsmJs.getSidedProp)("padding", panelPosition);
            const isVertical = (0, _utilsEsmJs.isVerticalSide)(panelPosition);
            const previousPaddings = (({ padding, paddingTop, paddingBottom, paddingLeft, paddingRight })=>({
                    padding,
                    paddingTop,
                    paddingBottom,
                    paddingLeft,
                    paddingRight
                }))(parentElement.style);
            const run = ()=>{
                // reset the padding
                parentElement.style.padding = "0px";
                parentElement.style.paddingTop = "0px";
                parentElement.style.paddingBottom = "0px";
                parentElement.style.paddingLeft = "0px";
                parentElement.style.paddingRight = "0px"; // set the new padding based on the new panel position
                parentElement.style[styleProp] = (isVertical ? devtoolsWidth : devtoolsHeight) + "px";
            };
            run();
            if (typeof window !== "undefined") {
                window.addEventListener("resize", run);
                return ()=>{
                    window.removeEventListener("resize", run);
                    Object.entries(previousPaddings).forEach(([property, previousValue])=>{
                        parentElement.style[property] = previousValue;
                    });
                };
            }
        }
        return;
    }, [
        isResolvedOpen,
        panelPosition,
        devtoolsHeight,
        devtoolsWidth
    ]);
    const { style: panelStyle = {}, ...otherPanelProps } = panelProps;
    const { style: toggleButtonStyle = {}, onClick: onToggleClick, ...otherToggleButtonProps } = toggleButtonProps; // get computed style based on panel position
    const style = (0, _utilsEsmJs.getSidePanelStyle)({
        position: panelPosition,
        devtoolsTheme: (0, _themeEsmJs.defaultTheme),
        isOpen: isResolvedOpen,
        height: devtoolsHeight,
        width: devtoolsWidth,
        isResizing,
        panelStyle
    }); // Do not render on the server
    if (!isMounted()) return null;
    return /*#__PURE__*/ _react.createElement(Container, {
        ref: rootRef,
        className: "ReactQueryDevtools",
        "aria-label": "React Query Devtools"
    }, /*#__PURE__*/ _react.createElement((0, _themeEsmJs.ThemeProvider), {
        theme: (0, _themeEsmJs.defaultTheme)
    }, /*#__PURE__*/ _react.createElement(ReactQueryDevtoolsPanel, (0, _rollupPluginBabelHelpersEsmJs.extends)({
        ref: panelRef,
        context: context,
        styleNonce: styleNonce,
        position: panelPosition,
        onPositionChange: setPanelPosition,
        showCloseButton: true,
        closeButtonProps: closeButtonProps
    }, otherPanelProps, {
        style: style,
        isOpen: isResolvedOpen,
        setIsOpen: setIsOpen,
        onDragStart: (e)=>handleDragStart(panelRef.current, e),
        errorTypes: errorTypes
    }))), !isResolvedOpen ? /*#__PURE__*/ _react.createElement("button", (0, _rollupPluginBabelHelpersEsmJs.extends)({
        type: "button"
    }, otherToggleButtonProps, {
        "aria-label": "Open React Query Devtools",
        "aria-controls": "ReactQueryDevtoolsPanel",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        onClick: (e)=>{
            setIsOpen(true);
            onToggleClick == null || onToggleClick(e);
        },
        style: {
            background: "none",
            border: 0,
            padding: 0,
            position: "fixed",
            zIndex: 99999,
            display: "inline-flex",
            fontSize: "1.5em",
            margin: ".5em",
            cursor: "pointer",
            width: "fit-content",
            ...position === "top-right" ? {
                top: "0",
                right: "0"
            } : position === "top-left" ? {
                top: "0",
                left: "0"
            } : position === "bottom-right" ? {
                bottom: "0",
                right: "0"
            } : {
                bottom: "0",
                left: "0"
            },
            ...toggleButtonStyle
        }
    }), /*#__PURE__*/ _react.createElement((0, _logoEsmJsDefault.default), {
        "aria-hidden": true
    }), /*#__PURE__*/ _react.createElement((0, _screenreaderEsmJsDefault.default), {
        text: "Open React Query Devtools"
    })) : null);
}
const useSubscribeToQueryCache = (queryCache, getSnapshot, skip = false)=>{
    return (0, _indexJs.useSyncExternalStore)(_react.useCallback((onStoreChange)=>{
        if (!skip) return queryCache.subscribe((0, _reactQuery.notifyManager).batchCalls(onStoreChange));
        return ()=>{
            return;
        };
    }, [
        queryCache,
        skip
    ]), getSnapshot, getSnapshot);
};
const ReactQueryDevtoolsPanel = /*#__PURE__*/ _react.forwardRef(function ReactQueryDevtoolsPanel(props, ref) {
    const { isOpen = true, styleNonce, setIsOpen, context, onDragStart, onPositionChange, showCloseButton, position, closeButtonProps = {}, errorTypes = [], ...panelProps } = props;
    const { onClick: onCloseClick, ...otherCloseButtonProps } = closeButtonProps;
    const queryClient = (0, _reactQuery.useQueryClient)({
        context
    });
    const queryCache = queryClient.getQueryCache();
    const [sort, setSort] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsSortFn", Object.keys((0, _utilsEsmJs.sortFns))[0]);
    const [filter, setFilter] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsFilter", "");
    const [baseSort, setBaseSort] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsBaseSort", 1);
    const sortFn = _react.useMemo(()=>(0, _utilsEsmJs.sortFns)[sort], [
        sort
    ]);
    const queriesCount = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().length, !isOpen);
    const [activeQueryHash, setActiveQueryHash] = (0, _useLocalStorageEsmJsDefault.default)("reactQueryDevtoolsActiveQueryHash", "");
    const queries = _react.useMemo(()=>{
        const unsortedQueries = queryCache.getAll();
        if (queriesCount === 0) return [];
        const filtered = filter ? unsortedQueries.filter((item)=>(0, _matchSorterUtils.rankItem)(item.queryHash, filter).passed) : [
            ...unsortedQueries
        ];
        const sorted = sortFn ? filtered.sort((a, b)=>sortFn(a, b) * baseSort) : filtered;
        return sorted;
    }, [
        baseSort,
        sortFn,
        filter,
        queriesCount,
        queryCache
    ]);
    const [isMockOffline, setMockOffline] = _react.useState(false);
    return /*#__PURE__*/ _react.createElement((0, _themeEsmJs.ThemeProvider), {
        theme: (0, _themeEsmJs.defaultTheme)
    }, /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Panel), (0, _rollupPluginBabelHelpersEsmJs.extends)({
        ref: ref,
        className: "ReactQueryDevtoolsPanel",
        "aria-label": "React Query Devtools Panel",
        id: "ReactQueryDevtoolsPanel"
    }, panelProps, {
        style: {
            height: (0, _utilsEsmJs.defaultPanelSize),
            position: "relative",
            ...panelProps.style
        }
    }), /*#__PURE__*/ _react.createElement("style", {
        nonce: styleNonce,
        dangerouslySetInnerHTML: {
            __html: "\n            .ReactQueryDevtoolsPanel * {\n              scrollbar-color: " + (0, _themeEsmJs.defaultTheme).backgroundAlt + " " + (0, _themeEsmJs.defaultTheme).gray + ";\n            }\n\n            .ReactQueryDevtoolsPanel *::-webkit-scrollbar, .ReactQueryDevtoolsPanel scrollbar {\n              width: 1em;\n              height: 1em;\n            }\n\n            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-track, .ReactQueryDevtoolsPanel scrollbar-track {\n              background: " + (0, _themeEsmJs.defaultTheme).backgroundAlt + ";\n            }\n\n            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-thumb, .ReactQueryDevtoolsPanel scrollbar-thumb {\n              background: " + (0, _themeEsmJs.defaultTheme).gray + ";\n              border-radius: .5em;\n              border: 3px solid " + (0, _themeEsmJs.defaultTheme).backgroundAlt + ";\n            }\n          "
        }
    }), /*#__PURE__*/ _react.createElement("div", {
        style: (0, _utilsEsmJs.getResizeHandleStyle)(position),
        onMouseDown: onDragStart
    }), isOpen && /*#__PURE__*/ _react.createElement("div", {
        style: {
            flex: "1 1 500px",
            minHeight: "40%",
            maxHeight: "100%",
            overflow: "auto",
            borderRight: "1px solid " + (0, _themeEsmJs.defaultTheme).grayAlt,
            display: "flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ _react.createElement("div", {
        style: {
            padding: ".5em",
            background: (0, _themeEsmJs.defaultTheme).backgroundAlt,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }
    }, /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": "Close React Query Devtools",
        "aria-controls": "ReactQueryDevtoolsPanel",
        "aria-haspopup": "true",
        "aria-expanded": "true",
        onClick: ()=>setIsOpen(false),
        style: {
            display: "inline-flex",
            background: "none",
            border: 0,
            padding: 0,
            marginRight: ".5em",
            cursor: "pointer"
        }
    }, /*#__PURE__*/ _react.createElement((0, _logoEsmJsDefault.default), {
        "aria-hidden": true
    }), /*#__PURE__*/ _react.createElement((0, _screenreaderEsmJsDefault.default), {
        text: "Close React Query Devtools"
    })), /*#__PURE__*/ _react.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        }
    }, /*#__PURE__*/ _react.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: ".5em"
        }
    }, /*#__PURE__*/ _react.createElement(QueryStatusCount, {
        queryCache: queryCache
    }), position && onPositionChange ? /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Select), {
        "aria-label": "Panel position",
        value: position,
        style: {
            marginInlineStart: ".5em"
        },
        onChange: (e)=>onPositionChange(e.target.value)
    }, /*#__PURE__*/ _react.createElement("option", {
        value: "left"
    }, "Left"), /*#__PURE__*/ _react.createElement("option", {
        value: "right"
    }, "Right"), /*#__PURE__*/ _react.createElement("option", {
        value: "top"
    }, "Top"), /*#__PURE__*/ _react.createElement("option", {
        value: "bottom"
    }, "Bottom")) : null), /*#__PURE__*/ _react.createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "0.5em"
        }
    }, /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Input), {
        placeholder: "Filter",
        "aria-label": "Filter by queryhash",
        value: filter != null ? filter : "",
        onChange: (e)=>setFilter(e.target.value),
        onKeyDown: (e)=>{
            if (e.key === "Escape") setFilter("");
        },
        style: {
            flex: "1",
            width: "100%"
        }
    }), /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Select), {
        "aria-label": "Sort queries",
        value: sort,
        onChange: (e)=>setSort(e.target.value),
        style: {
            flex: "1",
            minWidth: 75,
            marginRight: ".5em"
        }
    }, Object.keys((0, _utilsEsmJs.sortFns)).map((key)=>/*#__PURE__*/ _react.createElement("option", {
            key: key,
            value: key
        }, "Sort by ", key))), /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>setBaseSort((old)=>old * -1),
        style: {
            padding: ".3em .4em",
            marginRight: ".5em"
        }
    }, baseSort === 1 ? "\u2B06 Asc" : "\u2B07 Desc"), /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        title: "Clear cache",
        "aria-label": "Clear cache",
        type: "button",
        onClick: ()=>queryCache.clear(),
        style: {
            padding: ".3em .4em",
            marginRight: ".5em"
        }
    }, "Clear"), /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>{
            if (isMockOffline) {
                (0, _reactQuery.onlineManager).setOnline(undefined);
                setMockOffline(false);
                window.dispatchEvent(new Event("online"));
            } else {
                (0, _reactQuery.onlineManager).setOnline(false);
                setMockOffline(true);
            }
        },
        "aria-label": isMockOffline ? "Restore offline mock" : "Mock offline behavior",
        title: isMockOffline ? "Restore offline mock" : "Mock offline behavior",
        style: {
            padding: "0",
            height: "2em"
        }
    }, /*#__PURE__*/ _react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "2em",
        height: "2em",
        viewBox: "0 0 24 24",
        stroke: isMockOffline ? (0, _themeEsmJs.defaultTheme).danger : "currentColor",
        fill: "none"
    }, isMockOffline ? /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
    }), /*#__PURE__*/ _react.createElement("line", {
        x1: "12",
        y1: "18",
        x2: "12.01",
        y2: "18"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M9.172 15.172a4 4 0 0 1 5.656 0"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
    }), /*#__PURE__*/ _react.createElement("line", {
        x1: "3",
        y1: "3",
        x2: "21",
        y2: "21"
    })) : /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("path", {
        stroke: "none",
        d: "M0 0h24v24H0z",
        fill: "none"
    }), /*#__PURE__*/ _react.createElement("line", {
        x1: "12",
        y1: "18",
        x2: "12.01",
        y2: "18"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M9.172 15.172a4 4 0 0 1 5.656 0"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M6.343 12.343a8 8 0 0 1 11.314 0"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
    }))), /*#__PURE__*/ _react.createElement((0, _screenreaderEsmJsDefault.default), {
        text: isMockOffline ? "Restore offline mock" : "Mock offline behavior"
    }))))), /*#__PURE__*/ _react.createElement("div", {
        style: {
            overflowY: "auto",
            flex: "1"
        }
    }, queries.map((query)=>{
        return /*#__PURE__*/ _react.createElement(QueryRow, {
            queryKey: query.queryKey,
            activeQueryHash: activeQueryHash,
            setActiveQueryHash: setActiveQueryHash,
            key: query.queryHash,
            queryCache: queryCache
        });
    }))), activeQueryHash && isOpen ? /*#__PURE__*/ _react.createElement(ActiveQuery, {
        activeQueryHash: activeQueryHash,
        queryCache: queryCache,
        queryClient: queryClient,
        errorTypes: errorTypes
    }) : null, showCloseButton ? /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), (0, _rollupPluginBabelHelpersEsmJs.extends)({
        type: "button",
        "aria-controls": "ReactQueryDevtoolsPanel",
        "aria-haspopup": "true",
        "aria-expanded": "true"
    }, otherCloseButtonProps, {
        style: {
            position: "absolute",
            zIndex: 99999,
            margin: ".5em",
            bottom: 0,
            left: 0,
            ...otherCloseButtonProps.style
        },
        onClick: (e)=>{
            setIsOpen(false);
            onCloseClick == null || onCloseClick(e);
        }
    }), "Close") : null));
});
const ActiveQuery = ({ queryCache, activeQueryHash, queryClient, errorTypes })=>{
    var _useSubscribeToQueryC, _useSubscribeToQueryC2;
    const activeQuery = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().find((query)=>query.queryHash === activeQueryHash));
    const activeQueryState = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$getAll$fi;
        return (_queryCache$getAll$fi = queryCache.getAll().find((query)=>query.queryHash === activeQueryHash)) == null ? void 0 : _queryCache$getAll$fi.state;
    });
    const isStale = (_useSubscribeToQueryC = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$getAll$fi2;
        return (_queryCache$getAll$fi2 = queryCache.getAll().find((query)=>query.queryHash === activeQueryHash)) == null ? void 0 : _queryCache$getAll$fi2.isStale();
    })) != null ? _useSubscribeToQueryC : false;
    const observerCount = (_useSubscribeToQueryC2 = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$getAll$fi3;
        return (_queryCache$getAll$fi3 = queryCache.getAll().find((query)=>query.queryHash === activeQueryHash)) == null ? void 0 : _queryCache$getAll$fi3.getObserversCount();
    })) != null ? _useSubscribeToQueryC2 : 0;
    const handleRefetch = ()=>{
        const promise = activeQuery == null ? void 0 : activeQuery.fetch();
        promise == null || promise.catch(noop);
    };
    const currentErrorTypeName = (0, _react.useMemo)(()=>{
        if (activeQuery && activeQueryState != null && activeQueryState.error) {
            const errorType = errorTypes.find((type)=>{
                var _activeQueryState$err;
                return type.initializer(activeQuery).toString() === ((_activeQueryState$err = activeQueryState.error) == null ? void 0 : _activeQueryState$err.toString());
            });
            return errorType == null ? void 0 : errorType.name;
        }
        return undefined;
    }, [
        activeQuery,
        activeQueryState == null ? void 0 : activeQueryState.error,
        errorTypes
    ]);
    if (!activeQuery || !activeQueryState) return null;
    const triggerError = (errorType)=>{
        var _errorType$initialize;
        const error = (_errorType$initialize = errorType == null ? void 0 : errorType.initializer(activeQuery)) != null ? _errorType$initialize : new Error("Unknown error from devtools");
        const __previousQueryOptions = activeQuery.options;
        activeQuery.setState({
            status: "error",
            error,
            fetchMeta: {
                ...activeQuery.state.fetchMeta,
                __previousQueryOptions
            }
        });
    };
    const restoreQueryAfterLoadingOrError = ()=>{
        activeQuery.fetch(activeQuery.state.fetchMeta.__previousQueryOptions, {
            // Make sure this fetch will cancel the previous one
            cancelRefetch: true
        });
    };
    return /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.ActiveQueryPanel), null, /*#__PURE__*/ _react.createElement("div", {
        style: {
            padding: ".5em",
            background: (0, _themeEsmJs.defaultTheme).backgroundAlt,
            position: "sticky",
            top: 0,
            zIndex: 1
        }
    }, "Query Details"), /*#__PURE__*/ _react.createElement("div", {
        style: {
            padding: ".5em"
        }
    }, /*#__PURE__*/ _react.createElement("div", {
        style: {
            marginBottom: ".5em",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between"
        }
    }, /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), {
        style: {
            lineHeight: "1.8em"
        }
    }, /*#__PURE__*/ _react.createElement("pre", {
        style: {
            margin: 0,
            padding: 0,
            overflow: "auto"
        }
    }, (0, _utilsEsmJs.displayValue)(activeQuery.queryKey, true))), /*#__PURE__*/ _react.createElement("span", {
        style: {
            padding: "0.3em .6em",
            borderRadius: "0.4em",
            fontWeight: "bold",
            textShadow: "0 2px 10px black",
            background: (0, _utilsEsmJs.getQueryStatusColor)({
                queryState: activeQueryState,
                isStale: isStale,
                observerCount: observerCount,
                theme: (0, _themeEsmJs.defaultTheme)
            }),
            flexShrink: 0
        }
    }, (0, _utilsEsmJs.getQueryStatusLabel)(activeQuery))), /*#__PURE__*/ _react.createElement("div", {
        style: {
            marginBottom: ".5em",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }
    }, "Observers: ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, observerCount)), /*#__PURE__*/ _react.createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
        }
    }, "Last Updated:", " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, new Date(activeQueryState.dataUpdatedAt).toLocaleTimeString()))), /*#__PURE__*/ _react.createElement("div", {
        style: {
            background: (0, _themeEsmJs.defaultTheme).backgroundAlt,
            padding: ".5em",
            position: "sticky",
            top: 0,
            zIndex: 1
        }
    }, "Actions"), /*#__PURE__*/ _react.createElement("div", {
        style: {
            padding: "0.5em",
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5em",
            alignItems: "flex-end"
        }
    }, /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: handleRefetch,
        disabled: activeQueryState.fetchStatus === "fetching",
        style: {
            background: (0, _themeEsmJs.defaultTheme).active
        }
    }, "Refetch"), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>queryClient.invalidateQueries(activeQuery),
        style: {
            background: (0, _themeEsmJs.defaultTheme).warning,
            color: (0, _themeEsmJs.defaultTheme).inputTextColor
        }
    }, "Invalidate"), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>queryClient.resetQueries(activeQuery),
        style: {
            background: (0, _themeEsmJs.defaultTheme).gray
        }
    }, "Reset"), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>queryClient.removeQueries(activeQuery),
        style: {
            background: (0, _themeEsmJs.defaultTheme).danger
        }
    }, "Remove"), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>{
            var _activeQuery$state$fe;
            // Return early if the query is already restoring
            if (activeQuery.state.fetchStatus === "fetching" && typeof ((_activeQuery$state$fe = activeQuery.state.fetchMeta) == null ? void 0 : _activeQuery$state$fe.__previousQueryOptions) === "undefined") return;
            if (activeQuery.state.data === undefined) restoreQueryAfterLoadingOrError();
            else {
                const __previousQueryOptions = activeQuery.options; // Trigger a fetch in order to trigger suspense as well.
                activeQuery.fetch({
                    ...__previousQueryOptions,
                    queryFn: ()=>{
                        return new Promise(()=>{});
                    },
                    cacheTime: -1
                });
                activeQuery.setState({
                    data: undefined,
                    status: "loading",
                    fetchMeta: {
                        ...activeQuery.state.fetchMeta,
                        __previousQueryOptions
                    }
                });
            }
        },
        style: {
            background: (0, _themeEsmJs.defaultTheme).paused
        }
    }, activeQuery.state.status === "loading" ? "Restore" : "Trigger", " ", "loading"), " ", errorTypes.length === 0 || activeQuery.state.status === "error" ? /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Button), {
        type: "button",
        onClick: ()=>{
            if (!activeQuery.state.error) triggerError();
            else queryClient.resetQueries(activeQuery);
        },
        style: {
            background: (0, _themeEsmJs.defaultTheme).danger
        }
    }, activeQuery.state.status === "error" ? "Restore" : "Trigger", " error") : /*#__PURE__*/ _react.createElement("label", null, "Trigger error:", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Select), {
        value: currentErrorTypeName != null ? currentErrorTypeName : "",
        style: {
            marginInlineStart: ".5em"
        },
        onChange: (e)=>{
            const errorType = errorTypes.find((t)=>t.name === e.target.value);
            triggerError(errorType);
        }
    }, /*#__PURE__*/ _react.createElement("option", {
        key: "",
        value: ""
    }), errorTypes.map((errorType)=>/*#__PURE__*/ _react.createElement("option", {
            key: errorType.name,
            value: errorType.name
        }, errorType.name))))), /*#__PURE__*/ _react.createElement("div", {
        style: {
            background: (0, _themeEsmJs.defaultTheme).backgroundAlt,
            padding: ".5em",
            position: "sticky",
            top: 0,
            zIndex: 1
        }
    }, "Data Explorer"), /*#__PURE__*/ _react.createElement("div", {
        style: {
            padding: ".5em"
        }
    }, /*#__PURE__*/ _react.createElement((0, _explorerEsmJsDefault.default), {
        label: "Data",
        value: activeQueryState.data,
        defaultExpanded: {},
        copyable: true
    })), /*#__PURE__*/ _react.createElement("div", {
        style: {
            background: (0, _themeEsmJs.defaultTheme).backgroundAlt,
            padding: ".5em",
            position: "sticky",
            top: 0,
            zIndex: 1
        }
    }, "Query Explorer"), /*#__PURE__*/ _react.createElement("div", {
        style: {
            padding: ".5em"
        }
    }, /*#__PURE__*/ _react.createElement((0, _explorerEsmJsDefault.default), {
        label: "Query",
        value: activeQuery,
        defaultExpanded: {
            queryKey: true
        }
    })));
};
const QueryStatusCount = ({ queryCache })=>{
    const hasFresh = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().filter((q)=>(0, _utilsEsmJs.getQueryStatusLabel)(q) === "fresh").length);
    const hasFetching = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().filter((q)=>(0, _utilsEsmJs.getQueryStatusLabel)(q) === "fetching").length);
    const hasPaused = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().filter((q)=>(0, _utilsEsmJs.getQueryStatusLabel)(q) === "paused").length);
    const hasStale = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().filter((q)=>(0, _utilsEsmJs.getQueryStatusLabel)(q) === "stale").length);
    const hasInactive = useSubscribeToQueryCache(queryCache, ()=>queryCache.getAll().filter((q)=>(0, _utilsEsmJs.getQueryStatusLabel)(q) === "inactive").length);
    return /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.QueryKeys), null, /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.QueryKey), {
        style: {
            background: (0, _themeEsmJs.defaultTheme).success,
            opacity: hasFresh ? 1 : 0.3
        }
    }, "fresh ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, "(", hasFresh, ")")), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.QueryKey), {
        style: {
            background: (0, _themeEsmJs.defaultTheme).active,
            opacity: hasFetching ? 1 : 0.3
        }
    }, "fetching ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, "(", hasFetching, ")")), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.QueryKey), {
        style: {
            background: (0, _themeEsmJs.defaultTheme).paused,
            opacity: hasPaused ? 1 : 0.3
        }
    }, "paused ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, "(", hasPaused, ")")), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.QueryKey), {
        style: {
            background: (0, _themeEsmJs.defaultTheme).warning,
            color: "black",
            textShadow: "0",
            opacity: hasStale ? 1 : 0.3
        }
    }, "stale ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, "(", hasStale, ")")), " ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.QueryKey), {
        style: {
            background: (0, _themeEsmJs.defaultTheme).gray,
            opacity: hasInactive ? 1 : 0.3
        }
    }, "inactive ", /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), null, "(", hasInactive, ")")));
};
const QueryRow = /*#__PURE__*/ _react.memo(({ queryKey, setActiveQueryHash, activeQueryHash, queryCache })=>{
    var _useSubscribeToQueryC3, _useSubscribeToQueryC4, _useSubscribeToQueryC5, _useSubscribeToQueryC6;
    const queryHash = (_useSubscribeToQueryC3 = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$find;
        return (_queryCache$find = queryCache.find(queryKey)) == null ? void 0 : _queryCache$find.queryHash;
    })) != null ? _useSubscribeToQueryC3 : "";
    const queryState = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$find2;
        return (_queryCache$find2 = queryCache.find(queryKey)) == null ? void 0 : _queryCache$find2.state;
    });
    const isStale = (_useSubscribeToQueryC4 = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$find3;
        return (_queryCache$find3 = queryCache.find(queryKey)) == null ? void 0 : _queryCache$find3.isStale();
    })) != null ? _useSubscribeToQueryC4 : false;
    const isDisabled = (_useSubscribeToQueryC5 = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$find4;
        return (_queryCache$find4 = queryCache.find(queryKey)) == null ? void 0 : _queryCache$find4.isDisabled();
    })) != null ? _useSubscribeToQueryC5 : false;
    const observerCount = (_useSubscribeToQueryC6 = useSubscribeToQueryCache(queryCache, ()=>{
        var _queryCache$find5;
        return (_queryCache$find5 = queryCache.find(queryKey)) == null ? void 0 : _queryCache$find5.getObserversCount();
    })) != null ? _useSubscribeToQueryC6 : 0;
    if (!queryState) return null;
    return /*#__PURE__*/ _react.createElement("div", {
        role: "button",
        "aria-label": "Open query details for " + queryHash,
        onClick: ()=>setActiveQueryHash(activeQueryHash === queryHash ? "" : queryHash),
        style: {
            display: "flex",
            borderBottom: "solid 1px " + (0, _themeEsmJs.defaultTheme).grayAlt,
            cursor: "pointer",
            background: queryHash === activeQueryHash ? "rgba(255,255,255,.1)" : undefined
        }
    }, /*#__PURE__*/ _react.createElement("div", {
        style: {
            flex: "0 0 auto",
            width: "2em",
            height: "2em",
            background: (0, _utilsEsmJs.getQueryStatusColor)({
                queryState,
                isStale,
                observerCount,
                theme: (0, _themeEsmJs.defaultTheme)
            }),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            textShadow: isStale ? "0" : "0 0 10px black",
            color: isStale ? "black" : "white"
        }
    }, observerCount), isDisabled ? /*#__PURE__*/ _react.createElement("div", {
        style: {
            flex: "0 0 auto",
            height: "2em",
            background: (0, _themeEsmJs.defaultTheme).gray,
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            padding: "0 0.5em"
        }
    }, "disabled") : null, /*#__PURE__*/ _react.createElement((0, _styledComponentsEsmJs.Code), {
        style: {
            padding: ".5em"
        }
    }, "" + queryHash));
});
QueryRow.displayName = "QueryRow"; // eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

},{"./_virtual/_rollupPluginBabelHelpers.esm.js":"U0akX","react":"BK2ob","@tanstack/react-query":"jWXOo","@tanstack/match-sorter-utils":"5LX1C","./useLocalStorage.esm.js":"34klo","./utils.esm.js":"2ju2h","./styledComponents.esm.js":"enOyv","./screenreader.esm.js":"bXWWd","./theme.esm.js":"cyfOU","./Explorer.esm.js":"8Btox","./Logo.esm.js":"fLton","use-sync-external-store/shim/index.js":"8RLvf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"U0akX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extends", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5LX1C":[function(require,module,exports) {
/**
 * match-sorter-utils
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareItems", ()=>compareItems);
parcelHelpers.export(exports, "rankItem", ()=>rankItem);
parcelHelpers.export(exports, "rankings", ()=>rankings);
const characterMap = {
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    \u1EA4: "A",
    \u1EAE: "A",
    \u1EB2: "A",
    \u1EB4: "A",
    \u1EB6: "A",
    "\xc6": "AE",
    \u1EA6: "A",
    \u1EB0: "A",
    \u0202: "A",
    "\xc7": "C",
    \u1E08: "C",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    \u1EBE: "E",
    \u1E16: "E",
    \u1EC0: "E",
    \u1E14: "E",
    \u1E1C: "E",
    \u0206: "E",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    \u1E2E: "I",
    \u020A: "I",
    "\xd0": "D",
    "\xd1": "N",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    \u1ED0: "O",
    \u1E4C: "O",
    \u1E52: "O",
    \u020E: "O",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xdd": "Y",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    \u1EA5: "a",
    \u1EAF: "a",
    \u1EB3: "a",
    \u1EB5: "a",
    \u1EB7: "a",
    "\xe6": "ae",
    \u1EA7: "a",
    \u1EB1: "a",
    \u0203: "a",
    "\xe7": "c",
    \u1E09: "c",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    \u1EBF: "e",
    \u1E17: "e",
    \u1EC1: "e",
    \u1E15: "e",
    \u1E1D: "e",
    \u0207: "e",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    \u1E2F: "i",
    \u020B: "i",
    "\xf0": "d",
    "\xf1": "n",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    \u1ED1: "o",
    \u1E4D: "o",
    \u1E53: "o",
    \u020F: "o",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xfd": "y",
    "\xff": "y",
    \u0100: "A",
    \u0101: "a",
    \u0102: "A",
    \u0103: "a",
    \u0104: "A",
    \u0105: "a",
    \u0106: "C",
    \u0107: "c",
    \u0108: "C",
    \u0109: "c",
    \u010A: "C",
    \u010B: "c",
    \u010C: "C",
    \u010D: "c",
    C\u0306: "C",
    c\u0306: "c",
    \u010E: "D",
    \u010F: "d",
    \u0110: "D",
    \u0111: "d",
    \u0112: "E",
    \u0113: "e",
    \u0114: "E",
    \u0115: "e",
    \u0116: "E",
    \u0117: "e",
    \u0118: "E",
    \u0119: "e",
    \u011A: "E",
    \u011B: "e",
    \u011C: "G",
    \u01F4: "G",
    \u011D: "g",
    \u01F5: "g",
    \u011E: "G",
    \u011F: "g",
    \u0120: "G",
    \u0121: "g",
    \u0122: "G",
    \u0123: "g",
    \u0124: "H",
    \u0125: "h",
    \u0126: "H",
    \u0127: "h",
    \u1E2A: "H",
    \u1E2B: "h",
    \u0128: "I",
    \u0129: "i",
    \u012A: "I",
    \u012B: "i",
    \u012C: "I",
    \u012D: "i",
    \u012E: "I",
    \u012F: "i",
    \u0130: "I",
    \u0131: "i",
    \u0132: "IJ",
    \u0133: "ij",
    \u0134: "J",
    \u0135: "j",
    \u0136: "K",
    \u0137: "k",
    \u1E30: "K",
    \u1E31: "k",
    K\u0306: "K",
    k\u0306: "k",
    \u0139: "L",
    \u013A: "l",
    \u013B: "L",
    \u013C: "l",
    \u013D: "L",
    \u013E: "l",
    \u013F: "L",
    \u0140: "l",
    \u0141: "l",
    \u0142: "l",
    \u1E3E: "M",
    \u1E3F: "m",
    M\u0306: "M",
    m\u0306: "m",
    \u0143: "N",
    \u0144: "n",
    \u0145: "N",
    \u0146: "n",
    \u0147: "N",
    \u0148: "n",
    \u0149: "n",
    N\u0306: "N",
    n\u0306: "n",
    \u014C: "O",
    \u014D: "o",
    \u014E: "O",
    \u014F: "o",
    \u0150: "O",
    \u0151: "o",
    \u0152: "OE",
    \u0153: "oe",
    P\u0306: "P",
    p\u0306: "p",
    \u0154: "R",
    \u0155: "r",
    \u0156: "R",
    \u0157: "r",
    \u0158: "R",
    \u0159: "r",
    R\u0306: "R",
    r\u0306: "r",
    \u0212: "R",
    \u0213: "r",
    \u015A: "S",
    \u015B: "s",
    \u015C: "S",
    \u015D: "s",
    \u015E: "S",
    \u0218: "S",
    \u0219: "s",
    \u015F: "s",
    \u0160: "S",
    \u0161: "s",
    \u0162: "T",
    \u0163: "t",
    \u021B: "t",
    \u021A: "T",
    \u0164: "T",
    \u0165: "t",
    \u0166: "T",
    \u0167: "t",
    T\u0306: "T",
    t\u0306: "t",
    \u0168: "U",
    \u0169: "u",
    \u016A: "U",
    \u016B: "u",
    \u016C: "U",
    \u016D: "u",
    \u016E: "U",
    \u016F: "u",
    \u0170: "U",
    \u0171: "u",
    \u0172: "U",
    \u0173: "u",
    \u0216: "U",
    \u0217: "u",
    V\u0306: "V",
    v\u0306: "v",
    \u0174: "W",
    \u0175: "w",
    \u1E82: "W",
    \u1E83: "w",
    X\u0306: "X",
    x\u0306: "x",
    \u0176: "Y",
    \u0177: "y",
    \u0178: "Y",
    Y\u0306: "Y",
    y\u0306: "y",
    \u0179: "Z",
    \u017A: "z",
    \u017B: "Z",
    \u017C: "z",
    \u017D: "Z",
    \u017E: "z",
    \u017F: "s",
    \u0192: "f",
    \u01A0: "O",
    \u01A1: "o",
    \u01AF: "U",
    \u01B0: "u",
    \u01CD: "A",
    \u01CE: "a",
    \u01CF: "I",
    \u01D0: "i",
    \u01D1: "O",
    \u01D2: "o",
    \u01D3: "U",
    \u01D4: "u",
    \u01D5: "U",
    \u01D6: "u",
    \u01D7: "U",
    \u01D8: "u",
    \u01D9: "U",
    \u01DA: "u",
    \u01DB: "U",
    \u01DC: "u",
    \u1EE8: "U",
    \u1EE9: "u",
    \u1E78: "U",
    \u1E79: "u",
    \u01FA: "A",
    \u01FB: "a",
    \u01FC: "AE",
    \u01FD: "ae",
    \u01FE: "O",
    \u01FF: "o",
    "\xde": "TH",
    "\xfe": "th",
    \u1E54: "P",
    \u1E55: "p",
    \u1E64: "S",
    \u1E65: "s",
    X\u0301: "X",
    x\u0301: "x",
    \u0403: "\u0413",
    \u0453: "\u0433",
    \u040C: "\u041A",
    \u045C: "\u043A",
    A\u030B: "A",
    a\u030B: "a",
    E\u030B: "E",
    e\u030B: "e",
    I\u030B: "I",
    i\u030B: "i",
    \u01F8: "N",
    \u01F9: "n",
    \u1ED2: "O",
    \u1ED3: "o",
    \u1E50: "O",
    \u1E51: "o",
    \u1EEA: "U",
    \u1EEB: "u",
    \u1E80: "W",
    \u1E81: "w",
    \u1EF2: "Y",
    \u1EF3: "y",
    \u0200: "A",
    \u0201: "a",
    \u0204: "E",
    \u0205: "e",
    \u0208: "I",
    \u0209: "i",
    \u020C: "O",
    \u020D: "o",
    \u0210: "R",
    \u0211: "r",
    \u0214: "U",
    \u0215: "u",
    B\u030C: "B",
    b\u030C: "b",
    \u010C\u0323: "C",
    \u010D\u0323: "c",
    "\xca\u030C": "E",
    "\xea\u030C": "e",
    F\u030C: "F",
    f\u030C: "f",
    \u01E6: "G",
    \u01E7: "g",
    \u021E: "H",
    \u021F: "h",
    J\u030C: "J",
    \u01F0: "j",
    \u01E8: "K",
    \u01E9: "k",
    M\u030C: "M",
    m\u030C: "m",
    P\u030C: "P",
    p\u030C: "p",
    Q\u030C: "Q",
    q\u030C: "q",
    \u0158\u0329: "R",
    \u0159\u0329: "r",
    \u1E66: "S",
    \u1E67: "s",
    V\u030C: "V",
    v\u030C: "v",
    W\u030C: "W",
    w\u030C: "w",
    X\u030C: "X",
    x\u030C: "x",
    Y\u030C: "Y",
    y\u030C: "y",
    A\u0327: "A",
    a\u0327: "a",
    B\u0327: "B",
    b\u0327: "b",
    \u1E10: "D",
    \u1E11: "d",
    \u0228: "E",
    \u0229: "e",
    \u0190\u0327: "E",
    \u025B\u0327: "e",
    \u1E28: "H",
    \u1E29: "h",
    I\u0327: "I",
    i\u0327: "i",
    \u0197\u0327: "I",
    \u0268\u0327: "i",
    M\u0327: "M",
    m\u0327: "m",
    O\u0327: "O",
    o\u0327: "o",
    Q\u0327: "Q",
    q\u0327: "q",
    U\u0327: "U",
    u\u0327: "u",
    X\u0327: "X",
    x\u0327: "x",
    Z\u0327: "Z",
    z\u0327: "z"
};
const chars = Object.keys(characterMap).join("|");
const allAccents = new RegExp(chars, "g");
function removeAccents(str) {
    return str.replace(allAccents, (match)=>{
        return characterMap[match];
    });
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */ const rankings = {
    CASE_SENSITIVE_EQUAL: 7,
    EQUAL: 6,
    STARTS_WITH: 5,
    WORD_STARTS_WITH: 4,
    CONTAINS: 3,
    ACRONYM: 2,
    MATCHES: 1,
    NO_MATCH: 0
};
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, accessorIndex: Number, accessorThreshold: Number}} - the highest ranking
 */ function rankItem(item, value, options) {
    var _options$threshold;
    options = options || {};
    options.threshold = (_options$threshold = options.threshold) != null ? _options$threshold : rankings.MATCHES;
    if (!options.accessors) {
        // if keys is not specified, then we assume the item given is ready to be matched
        const rank = getMatchRanking(item, value, options);
        return {
            // ends up being duplicate of 'item' in matches but consistent
            rankedValue: item,
            rank,
            accessorIndex: -1,
            accessorThreshold: options.threshold,
            passed: rank >= options.threshold
        };
    }
    const valuesToRank = getAllValuesToRank(item, options.accessors);
    const rankingInfo = {
        rankedValue: item,
        rank: rankings.NO_MATCH,
        accessorIndex: -1,
        accessorThreshold: options.threshold,
        passed: false
    };
    for(let i = 0; i < valuesToRank.length; i++){
        const rankValue = valuesToRank[i];
        let newRank = getMatchRanking(rankValue.itemValue, value, options);
        const { minRanking, maxRanking, threshold = options.threshold } = rankValue.attributes;
        if (newRank < minRanking && newRank >= rankings.MATCHES) newRank = minRanking;
        else if (newRank > maxRanking) newRank = maxRanking;
        newRank = Math.min(newRank, maxRanking);
        if (newRank >= threshold && newRank > rankingInfo.rank) {
            rankingInfo.rank = newRank;
            rankingInfo.passed = true;
            rankingInfo.accessorIndex = i;
            rankingInfo.accessorThreshold = threshold;
            rankingInfo.rankedValue = rankValue.itemValue;
        }
    }
    return rankingInfo;
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */ function getMatchRanking(testString, stringToRank, options) {
    testString = prepareValueForComparison(testString, options);
    stringToRank = prepareValueForComparison(stringToRank, options);
    // too long
    if (stringToRank.length > testString.length) return rankings.NO_MATCH;
    // case sensitive equals
    if (testString === stringToRank) return rankings.CASE_SENSITIVE_EQUAL;
    // Lower casing before further comparison
    testString = testString.toLowerCase();
    stringToRank = stringToRank.toLowerCase();
    // case insensitive equals
    if (testString === stringToRank) return rankings.EQUAL;
    // starts with
    if (testString.startsWith(stringToRank)) return rankings.STARTS_WITH;
    // word starts with
    if (testString.includes(` ${stringToRank}`)) return rankings.WORD_STARTS_WITH;
    // contains
    if (testString.includes(stringToRank)) return rankings.CONTAINS;
    else if (stringToRank.length === 1) // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return rankings.NO_MATCH;
    // acronym
    if (getAcronym(testString).includes(stringToRank)) return rankings.ACRONYM;
    // will return a number between rankings.MATCHES and
    // rankings.MATCHES + 1 depending  on how close of a match it is.
    return getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */ function getAcronym(string) {
    let acronym = "";
    const wordsInString = string.split(" ");
    wordsInString.forEach((wordInString)=>{
        const splitByHyphenWords = wordInString.split("-");
        splitByHyphenWords.forEach((splitByHyphenWord)=>{
            acronym += splitByHyphenWord.substr(0, 1);
        });
    });
    return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */ function getClosenessRanking(testString, stringToRank) {
    let matchingInOrderCharCount = 0;
    let charNumber = 0;
    function findMatchingCharacter(matchChar, string, index) {
        for(let j = index, J = string.length; j < J; j++){
            const stringChar = string[j];
            if (stringChar === matchChar) {
                matchingInOrderCharCount += 1;
                return j + 1;
            }
        }
        return -1;
    }
    function getRanking(spread) {
        const spreadPercentage = 1 / spread;
        const inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
        const ranking = rankings.MATCHES + inOrderPercentage * spreadPercentage;
        return ranking;
    }
    const firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
    if (firstIndex < 0) return rankings.NO_MATCH;
    charNumber = firstIndex;
    for(let i = 1, I = stringToRank.length; i < I; i++){
        const matchChar = stringToRank[i];
        charNumber = findMatchingCharacter(matchChar, testString, charNumber);
        const found = charNumber > -1;
        if (!found) return rankings.NO_MATCH;
    }
    const spread = charNumber - firstIndex;
    return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and accessorIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */ function compareItems(a, b) {
    return a.rank === b.rank ? 0 : a.rank > b.rank ? -1 : 1;
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */ function prepareValueForComparison(value, _ref) {
    let { keepDiacritics } = _ref;
    // value might not actually be a string at this point (we don't get to choose)
    // so part of preparing the value for comparison is ensure that it is a string
    value = `${value}`; // toString
    if (!keepDiacritics) value = removeAccents(value);
    return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */ function getItemValues(item, accessor) {
    let accessorFn = accessor;
    if (typeof accessor === "object") accessorFn = accessor.accessor;
    const value = accessorFn(item);
    // because `value` can also be undefined
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    return [
        String(value)
    ];
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */ function getAllValuesToRank(item, accessors) {
    const allValues = [];
    for(let j = 0, J = accessors.length; j < J; j++){
        const accessor = accessors[j];
        const attributes = getAccessorAttributes(accessor);
        const itemValues = getItemValues(item, accessor);
        for(let i = 0, I = itemValues.length; i < I; i++)allValues.push({
            itemValue: itemValues[i],
            attributes
        });
    }
    return allValues;
}
const defaultKeyAttributes = {
    maxRanking: Infinity,
    minRanking: -Infinity
};
/**
 * Gets all the attributes for the given accessor
 * @param accessor - the accessor from which the attributes will be retrieved
 * @return object containing the accessor's attributes
 */ function getAccessorAttributes(accessor) {
    if (typeof accessor === "function") return defaultKeyAttributes;
    return {
        ...defaultKeyAttributes,
        ...accessor
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"34klo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLocalStorage);
var _react = require("react");
const getItem = (key)=>{
    try {
        const itemValue = localStorage.getItem(key);
        if (typeof itemValue === "string") return JSON.parse(itemValue);
        return undefined;
    } catch  {
        return undefined;
    }
};
function useLocalStorage(key, defaultValue) {
    const [value, setValue] = _react.useState();
    _react.useEffect(()=>{
        const initialValue = getItem(key);
        if (typeof initialValue === "undefined" || initialValue === null) setValue(typeof defaultValue === "function" ? defaultValue() : defaultValue);
        else setValue(initialValue);
    }, [
        defaultValue,
        key
    ]);
    const setter = _react.useCallback((updater)=>{
        setValue((old)=>{
            let newVal = updater;
            if (typeof updater == "function") newVal = updater(old);
            try {
                localStorage.setItem(key, JSON.stringify(newVal));
            } catch  {}
            return newVal;
        });
    }, [
        key
    ]);
    return [
        value,
        setter
    ];
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2ju2h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPanelSize", ()=>defaultPanelSize);
parcelHelpers.export(exports, "displayValue", ()=>displayValue);
parcelHelpers.export(exports, "getOppositeSide", ()=>getOppositeSide);
parcelHelpers.export(exports, "getQueryStatusColor", ()=>getQueryStatusColor);
parcelHelpers.export(exports, "getQueryStatusLabel", ()=>getQueryStatusLabel);
parcelHelpers.export(exports, "getResizeHandleStyle", ()=>getResizeHandleStyle);
parcelHelpers.export(exports, "getSidePanelStyle", ()=>getSidePanelStyle);
parcelHelpers.export(exports, "getSidedProp", ()=>getSidedProp);
parcelHelpers.export(exports, "isVerticalSide", ()=>isVerticalSide);
parcelHelpers.export(exports, "minPanelSize", ()=>minPanelSize);
parcelHelpers.export(exports, "sides", ()=>sides);
parcelHelpers.export(exports, "sortFns", ()=>sortFns);
parcelHelpers.export(exports, "styled", ()=>styled);
parcelHelpers.export(exports, "useIsMounted", ()=>useIsMounted);
var _react = require("react");
var _superjson = require("superjson");
var _superjsonDefault = parcelHelpers.interopDefault(_superjson);
var _themeEsmJs = require("./theme.esm.js");
var _useMediaQueryEsmJs = require("./useMediaQuery.esm.js");
var _useMediaQueryEsmJsDefault = parcelHelpers.interopDefault(_useMediaQueryEsmJs);
function getQueryStatusColor({ queryState, observerCount, isStale, theme }) {
    return queryState.fetchStatus === "fetching" ? theme.active : !observerCount ? theme.gray : queryState.fetchStatus === "paused" ? theme.paused : isStale ? theme.warning : theme.success;
}
function getQueryStatusLabel(query) {
    return query.state.fetchStatus === "fetching" ? "fetching" : !query.getObserversCount() ? "inactive" : query.state.fetchStatus === "paused" ? "paused" : query.isStale() ? "stale" : "fresh";
}
function styled(type, newStyles, queries = {}) {
    return /*#__PURE__*/ _react.forwardRef(({ style, ...rest }, ref)=>{
        const theme = (0, _themeEsmJs.useTheme)();
        const mediaStyles = Object.entries(queries).reduce((current, [key, value])=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            return (0, _useMediaQueryEsmJsDefault.default)(key) ? {
                ...current,
                ...typeof value === "function" ? value(rest, theme) : value
            } : current;
        }, {});
        return /*#__PURE__*/ _react.createElement(type, {
            ...rest,
            style: {
                ...typeof newStyles === "function" ? newStyles(rest, theme) : newStyles,
                ...style,
                ...mediaStyles
            },
            ref
        });
    });
}
function useIsMounted() {
    const mountedRef = _react.useRef(false);
    const isMounted = _react.useCallback(()=>mountedRef.current, []);
    _react.useEffect(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    return isMounted;
}
/**
 * Displays a string regardless the type of the data
 * @param {unknown} value Value to be stringified
 * @param {boolean} beautify Formats json to multiline
 */ const displayValue = (value, beautify = false)=>{
    const { json } = (0, _superjsonDefault.default).serialize(value);
    return JSON.stringify(json, null, beautify ? 2 : undefined);
}; // Sorting functions
const getStatusRank = (q)=>q.state.fetchStatus !== "idle" ? 0 : !q.getObserversCount() ? 3 : q.isStale() ? 2 : 1;
const queryHashSort = (a, b)=>a.queryHash.localeCompare(b.queryHash);
const dateSort = (a, b)=>a.state.dataUpdatedAt < b.state.dataUpdatedAt ? 1 : -1;
const statusAndDateSort = (a, b)=>{
    if (getStatusRank(a) === getStatusRank(b)) return dateSort(a, b);
    return getStatusRank(a) > getStatusRank(b) ? 1 : -1;
};
const sortFns = {
    "Status > Last Updated": statusAndDateSort,
    "Query Hash": queryHashSort,
    "Last Updated": dateSort
};
const minPanelSize = 70;
const defaultPanelSize = 500;
const sides = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Check if the given side is vertical (left/right)
 */ function isVerticalSide(side) {
    return [
        "left",
        "right"
    ].includes(side);
}
/**
 * Get the opposite side, eg 'left' => 'right'. 'top' => 'bottom', etc
 */ function getOppositeSide(side) {
    return sides[side];
}
/**
 * Given as css prop it will return a sided css prop based on a given side
 * Example given `border` and `right` it return `borderRight`
 */ function getSidedProp(prop, side) {
    return "" + prop + (side.charAt(0).toUpperCase() + side.slice(1));
}
function getSidePanelStyle({ position = "bottom", height, width, devtoolsTheme, isOpen, isResizing, panelStyle }) {
    const oppositeSide = getOppositeSide(position);
    const borderSide = getSidedProp("border", oppositeSide);
    const isVertical = isVerticalSide(position);
    return {
        ...panelStyle,
        direction: "ltr",
        position: "fixed",
        [position]: 0,
        [borderSide]: "1px solid " + devtoolsTheme.gray,
        transformOrigin: oppositeSide,
        boxShadow: "0 0 20px rgba(0,0,0,.3)",
        zIndex: 99999,
        // visibility will be toggled after transitions, but set initial state here
        visibility: isOpen ? "visible" : "hidden",
        ...isResizing ? {
            transition: "none"
        } : {
            transition: "all .2s ease"
        },
        ...isOpen ? {
            opacity: 1,
            pointerEvents: "all",
            transform: isVertical ? "translateX(0) scale(1)" : "translateY(0) scale(1)"
        } : {
            opacity: 0,
            pointerEvents: "none",
            transform: isVertical ? "translateX(15px) scale(1.02)" : "translateY(15px) scale(1.02)"
        },
        ...isVertical ? {
            top: 0,
            height: "100vh",
            maxWidth: "90%",
            width: typeof width === "number" && width >= minPanelSize ? width : defaultPanelSize
        } : {
            left: 0,
            width: "100%",
            maxHeight: "90%",
            height: typeof height === "number" && height >= minPanelSize ? height : defaultPanelSize
        }
    };
}
/**
 * Get resize handle style based on a given side
 */ function getResizeHandleStyle(position = "bottom") {
    const isVertical = isVerticalSide(position);
    const oppositeSide = getOppositeSide(position);
    const marginSide = getSidedProp("margin", oppositeSide);
    return {
        position: "absolute",
        cursor: isVertical ? "col-resize" : "row-resize",
        zIndex: 100000,
        [oppositeSide]: 0,
        [marginSide]: "-4px",
        ...isVertical ? {
            top: 0,
            height: "100%",
            width: "4px"
        } : {
            width: "100%",
            height: "4px"
        }
    };
}

},{"react":"BK2ob","superjson":"5NkCd","./theme.esm.js":"cyfOU","./useMediaQuery.esm.js":"eHZ39","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5NkCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuperJSON", ()=>SuperJSON);
parcelHelpers.export(exports, "serialize", ()=>serialize);
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "registerClass", ()=>registerClass);
parcelHelpers.export(exports, "registerCustom", ()=>registerCustom);
parcelHelpers.export(exports, "registerSymbol", ()=>registerSymbol);
parcelHelpers.export(exports, "allowErrorProps", ()=>allowErrorProps);
var _classRegistry = require("./class-registry");
var _registry = require("./registry");
var _customTransformerRegistry = require("./custom-transformer-registry");
var _plainer = require("./plainer");
var _copyAnything = require("copy-anything");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var SuperJSON = /** @class */ function() {
    /**
     * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
     */ function SuperJSON(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.dedupe, dedupe = _c === void 0 ? false : _c;
        this.classRegistry = new (0, _classRegistry.ClassRegistry)();
        this.symbolRegistry = new (0, _registry.Registry)(function(s) {
            var _a;
            return (_a = s.description) !== null && _a !== void 0 ? _a : "";
        });
        this.customTransformerRegistry = new (0, _customTransformerRegistry.CustomTransformerRegistry)();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    SuperJSON.prototype.serialize = function(object) {
        var identities = new Map();
        var output = (0, _plainer.walker)(object, identities, this, this.dedupe);
        var res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = __assign(__assign({}, res.meta), {
            values: output.annotations
        });
        var equalityAnnotations = (0, _plainer.generateReferentialEqualityAnnotations)(identities);
        if (equalityAnnotations) res.meta = __assign(__assign({}, res.meta), {
            referentialEqualities: equalityAnnotations
        });
        return res;
    };
    SuperJSON.prototype.deserialize = function(payload) {
        var json = payload.json, meta = payload.meta;
        var result = (0, _copyAnything.copy)(json);
        if (meta === null || meta === void 0 ? void 0 : meta.values) result = (0, _plainer.applyValueAnnotations)(result, meta.values, this);
        if (meta === null || meta === void 0 ? void 0 : meta.referentialEqualities) result = (0, _plainer.applyReferentialEqualityAnnotations)(result, meta.referentialEqualities);
        return result;
    };
    SuperJSON.prototype.stringify = function(object) {
        return JSON.stringify(this.serialize(object));
    };
    SuperJSON.prototype.parse = function(string) {
        return this.deserialize(JSON.parse(string));
    };
    SuperJSON.prototype.registerClass = function(v, options) {
        this.classRegistry.register(v, options);
    };
    SuperJSON.prototype.registerSymbol = function(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    };
    SuperJSON.prototype.registerCustom = function(transformer, name) {
        this.customTransformerRegistry.register(__assign({
            name: name
        }, transformer));
    };
    SuperJSON.prototype.allowErrorProps = function() {
        var _a;
        var props = [];
        for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
        (_a = this.allowedErrorProps).push.apply(_a, __spreadArray([], __read(props)));
    };
    SuperJSON.defaultInstance = new SuperJSON();
    SuperJSON.serialize = SuperJSON.defaultInstance.serialize.bind(SuperJSON.defaultInstance);
    SuperJSON.deserialize = SuperJSON.defaultInstance.deserialize.bind(SuperJSON.defaultInstance);
    SuperJSON.stringify = SuperJSON.defaultInstance.stringify.bind(SuperJSON.defaultInstance);
    SuperJSON.parse = SuperJSON.defaultInstance.parse.bind(SuperJSON.defaultInstance);
    SuperJSON.registerClass = SuperJSON.defaultInstance.registerClass.bind(SuperJSON.defaultInstance);
    SuperJSON.registerSymbol = SuperJSON.defaultInstance.registerSymbol.bind(SuperJSON.defaultInstance);
    SuperJSON.registerCustom = SuperJSON.defaultInstance.registerCustom.bind(SuperJSON.defaultInstance);
    SuperJSON.allowErrorProps = SuperJSON.defaultInstance.allowErrorProps.bind(SuperJSON.defaultInstance);
    return SuperJSON;
}();
exports.default = SuperJSON;
var serialize = SuperJSON.serialize;
var deserialize = SuperJSON.deserialize;
var stringify = SuperJSON.stringify;
var parse = SuperJSON.parse;
var registerClass = SuperJSON.registerClass;
var registerCustom = SuperJSON.registerCustom;
var registerSymbol = SuperJSON.registerSymbol;
var allowErrorProps = SuperJSON.allowErrorProps;

},{"./class-registry":"f3DxM","./registry":"9KLMQ","./custom-transformer-registry":"3W21J","./plainer":"kQqwU","copy-anything":"6Y8Km","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f3DxM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClassRegistry", ()=>ClassRegistry);
var _registry = require("./registry");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var ClassRegistry = /** @class */ function(_super) {
    __extends(ClassRegistry, _super);
    function ClassRegistry() {
        var _this = _super.call(this, function(c) {
            return c.name;
        }) || this;
        _this.classToAllowedProps = new Map();
        return _this;
    }
    ClassRegistry.prototype.register = function(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            _super.prototype.register.call(this, value, options.identifier);
        } else _super.prototype.register.call(this, value, options);
    };
    ClassRegistry.prototype.getAllowedProps = function(value) {
        return this.classToAllowedProps.get(value);
    };
    return ClassRegistry;
}((0, _registry.Registry));

},{"./registry":"9KLMQ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9KLMQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Registry", ()=>Registry);
var _doubleIndexedKv = require("./double-indexed-kv");
var Registry = /** @class */ function() {
    function Registry(generateIdentifier) {
        this.generateIdentifier = generateIdentifier;
        this.kv = new (0, _doubleIndexedKv.DoubleIndexedKV)();
    }
    Registry.prototype.register = function(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    };
    Registry.prototype.clear = function() {
        this.kv.clear();
    };
    Registry.prototype.getIdentifier = function(value) {
        return this.kv.getByValue(value);
    };
    Registry.prototype.getValue = function(identifier) {
        return this.kv.getByKey(identifier);
    };
    return Registry;
}();

},{"./double-indexed-kv":"ipvCA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ipvCA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DoubleIndexedKV", ()=>DoubleIndexedKV);
var DoubleIndexedKV = /** @class */ function() {
    function DoubleIndexedKV() {
        this.keyToValue = new Map();
        this.valueToKey = new Map();
    }
    DoubleIndexedKV.prototype.set = function(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    };
    DoubleIndexedKV.prototype.getByKey = function(key) {
        return this.keyToValue.get(key);
    };
    DoubleIndexedKV.prototype.getByValue = function(value) {
        return this.valueToKey.get(value);
    };
    DoubleIndexedKV.prototype.clear = function() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    };
    return DoubleIndexedKV;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3W21J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomTransformerRegistry", ()=>CustomTransformerRegistry);
var _util = require("./util");
var CustomTransformerRegistry = /** @class */ function() {
    function CustomTransformerRegistry() {
        this.transfomers = {};
    }
    CustomTransformerRegistry.prototype.register = function(transformer) {
        this.transfomers[transformer.name] = transformer;
    };
    CustomTransformerRegistry.prototype.findApplicable = function(v) {
        return (0, _util.find)(this.transfomers, function(transformer) {
            return transformer.isApplicable(v);
        });
    };
    CustomTransformerRegistry.prototype.findByName = function(name) {
        return this.transfomers[name];
    };
    return CustomTransformerRegistry;
}();

},{"./util":"e0tU1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e0tU1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "forEach", ()=>forEach);
parcelHelpers.export(exports, "includes", ()=>includes);
parcelHelpers.export(exports, "findArr", ()=>findArr);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function valuesOfObj(record) {
    if ("values" in Object) // eslint-disable-next-line es5/no-es6-methods
    return Object.values(record);
    var values = [];
    // eslint-disable-next-line no-restricted-syntax
    for(var key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function find(record, predicate) {
    var values = valuesOfObj(record);
    if ("find" in values) // eslint-disable-next-line es5/no-es6-methods
    return values.find(predicate);
    var valuesNotNever = values;
    for(var i = 0; i < valuesNotNever.length; i++){
        var value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
    return undefined;
}
function forEach(record, run) {
    Object.entries(record).forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return run(value, key);
    });
}
function includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function findArr(record, predicate) {
    for(var i = 0; i < record.length; i++){
        var value = record[i];
        if (predicate(value)) return value;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kQqwU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyValueAnnotations", ()=>applyValueAnnotations);
parcelHelpers.export(exports, "applyReferentialEqualityAnnotations", ()=>applyReferentialEqualityAnnotations);
parcelHelpers.export(exports, "generateReferentialEqualityAnnotations", ()=>generateReferentialEqualityAnnotations);
parcelHelpers.export(exports, "walker", ()=>walker);
var _is = require("./is");
var _pathstringifier = require("./pathstringifier");
var _transformer = require("./transformer");
var _util = require("./util");
var _accessDeep = require("./accessDeep");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
function traverse(tree, walker, origin) {
    if (origin === void 0) origin = [];
    if (!tree) return;
    if (!(0, _is.isArray)(tree)) {
        (0, _util.forEach)(tree, function(subtree, key) {
            return traverse(subtree, walker, __spreadArray(__spreadArray([], __read(origin)), __read((0, _pathstringifier.parsePath)(key))));
        });
        return;
    }
    var _a = __read(tree, 2), nodeValue = _a[0], children = _a[1];
    if (children) (0, _util.forEach)(children, function(child, key) {
        traverse(child, walker, __spreadArray(__spreadArray([], __read(origin)), __read((0, _pathstringifier.parsePath)(key))));
    });
    walker(nodeValue, origin);
}
function applyValueAnnotations(plain, annotations, superJson) {
    traverse(annotations, function(type, path) {
        plain = (0, _accessDeep.setDeep)(plain, path, function(v) {
            return (0, _transformer.untransformValue)(v, type, superJson);
        });
    });
    return plain;
}
function applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        var object = (0, _accessDeep.getDeep)(plain, (0, _pathstringifier.parsePath)(path));
        identicalPaths.map((0, _pathstringifier.parsePath)).forEach(function(identicalObjectPath) {
            plain = (0, _accessDeep.setDeep)(plain, identicalObjectPath, function() {
                return object;
            });
        });
    }
    if ((0, _is.isArray)(annotations)) {
        var _a = __read(annotations, 2), root = _a[0], other = _a[1];
        root.forEach(function(identicalPath) {
            plain = (0, _accessDeep.setDeep)(plain, (0, _pathstringifier.parsePath)(identicalPath), function() {
                return plain;
            });
        });
        if (other) (0, _util.forEach)(other, apply);
    } else (0, _util.forEach)(annotations, apply);
    return plain;
}
var isDeep = function(object, superJson) {
    return (0, _is.isPlainObject)(object) || (0, _is.isArray)(object) || (0, _is.isMap)(object) || (0, _is.isSet)(object) || (0, _transformer.isInstanceOfRegisteredClass)(object, superJson);
};
function addIdentity(object, path, identities) {
    var existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function generateReferentialEqualityAnnotations(identitites) {
    var result = {};
    var rootEqualityPaths = undefined;
    identitites.forEach(function(paths) {
        if (paths.length <= 1) return;
        var _a = __read(paths.map(function(path) {
            return path.map(String);
        }).sort(function(a, b) {
            return a.length - b.length;
        })), shortestPath = _a[0], identicalPaths = _a.slice(1);
        if (shortestPath.length === 0) rootEqualityPaths = identicalPaths.map((0, _pathstringifier.stringifyPath));
        else result[(0, _pathstringifier.stringifyPath)(shortestPath)] = identicalPaths.map((0, _pathstringifier.stringifyPath));
    });
    if (rootEqualityPaths) {
        if ((0, _is.isEmptyObject)(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return (0, _is.isEmptyObject)(result) ? undefined : result;
}
var walker = function(object, identities, superJson, dedupe, path, objectsInThisPath, seenObjects) {
    var _a;
    if (path === void 0) path = [];
    if (objectsInThisPath === void 0) objectsInThisPath = [];
    if (seenObjects === void 0) seenObjects = new Map();
    var primitive = (0, _is.isPrimitive)(object);
    if (!primitive) {
        addIdentity(object, path, identities);
        var seen = seenObjects.get(object);
        if (seen) // short-circuit result if we've seen this object before
        return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!isDeep(object, superJson)) {
        var transformed_1 = (0, _transformer.transformValue)(object, superJson);
        var result_1 = transformed_1 ? {
            transformedValue: transformed_1.value,
            annotations: [
                transformed_1.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result_1);
        return result_1;
    }
    if ((0, _util.includes)(objectsInThisPath, object)) // prevent circular references
    return {
        transformedValue: null
    };
    var transformationResult = (0, _transformer.transformValue)(object, superJson);
    var transformed = (_a = transformationResult === null || transformationResult === void 0 ? void 0 : transformationResult.value) !== null && _a !== void 0 ? _a : object;
    var transformedValue = (0, _is.isArray)(transformed) ? [] : {};
    var innerAnnotations = {};
    (0, _util.forEach)(transformed, function(value, index) {
        var recursiveResult = walker(value, identities, superJson, dedupe, __spreadArray(__spreadArray([], __read(path)), [
            index
        ]), __spreadArray(__spreadArray([], __read(objectsInThisPath)), [
            object
        ]), seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ((0, _is.isArray)(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ((0, _is.isPlainObject)(recursiveResult.annotations)) (0, _util.forEach)(recursiveResult.annotations, function(tree, key) {
            innerAnnotations[(0, _pathstringifier.escapeKey)(index) + "." + key] = tree;
        });
    });
    var result = (0, _is.isEmptyObject)(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : undefined
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};

},{"./is":"1IKxK","./pathstringifier":"b9GcF","./transformer":"4masb","./util":"e0tU1","./accessDeep":"93RCN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1IKxK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUndefined", ()=>isUndefined);
parcelHelpers.export(exports, "isNull", ()=>isNull);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isEmptyObject", ()=>isEmptyObject);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isNaNValue", ()=>isNaNValue);
parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
parcelHelpers.export(exports, "isBigint", ()=>isBigint);
parcelHelpers.export(exports, "isInfinite", ()=>isInfinite);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
parcelHelpers.export(exports, "isURL", ()=>isURL);
var getType = function(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
};
var isUndefined = function(payload) {
    return typeof payload === "undefined";
};
var isNull = function(payload) {
    return payload === null;
};
var isPlainObject = function(payload) {
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var isEmptyObject = function(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
};
var isArray = function(payload) {
    return Array.isArray(payload);
};
var isString = function(payload) {
    return typeof payload === "string";
};
var isNumber = function(payload) {
    return typeof payload === "number" && !isNaN(payload);
};
var isBoolean = function(payload) {
    return typeof payload === "boolean";
};
var isRegExp = function(payload) {
    return payload instanceof RegExp;
};
var isMap = function(payload) {
    return payload instanceof Map;
};
var isSet = function(payload) {
    return payload instanceof Set;
};
var isSymbol = function(payload) {
    return getType(payload) === "Symbol";
};
var isDate = function(payload) {
    return payload instanceof Date && !isNaN(payload.valueOf());
};
var isError = function(payload) {
    return payload instanceof Error;
};
var isNaNValue = function(payload) {
    return typeof payload === "number" && isNaN(payload);
};
var isPrimitive = function(payload) {
    return isBoolean(payload) || isNull(payload) || isUndefined(payload) || isNumber(payload) || isString(payload) || isSymbol(payload);
};
var isBigint = function(payload) {
    return typeof payload === "bigint";
};
var isInfinite = function(payload) {
    return payload === Infinity || payload === -Infinity;
};
var isTypedArray = function(payload) {
    return ArrayBuffer.isView(payload) && !(payload instanceof DataView);
};
var isURL = function(payload) {
    return payload instanceof URL;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b9GcF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeKey", ()=>escapeKey);
parcelHelpers.export(exports, "stringifyPath", ()=>stringifyPath);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
var escapeKey = function(key) {
    return key.replace(/\./g, "\\.");
};
var stringifyPath = function(path) {
    return path.map(String).map(escapeKey).join(".");
};
var parsePath = function(string) {
    var result = [];
    var segment = "";
    for(var i = 0; i < string.length; i++){
        var char = string.charAt(i);
        var isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
            segment += ".";
            i++;
            continue;
        }
        var isEndOfSegment = char === ".";
        if (isEndOfSegment) {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    var lastSegment = segment;
    result.push(lastSegment);
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4masb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInstanceOfRegisteredClass", ()=>isInstanceOfRegisteredClass);
parcelHelpers.export(exports, "transformValue", ()=>transformValue);
parcelHelpers.export(exports, "untransformValue", ()=>untransformValue);
var _is = require("./is");
var _util = require("./util");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
function simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var simpleRules = [
    simpleTransformation((0, _is.isUndefined), "undefined", function() {
        return null;
    }, function() {
        return undefined;
    }),
    simpleTransformation((0, _is.isBigint), "bigint", function(v) {
        return v.toString();
    }, function(v) {
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    simpleTransformation((0, _is.isDate), "Date", function(v) {
        return v.toISOString();
    }, function(v) {
        return new Date(v);
    }),
    simpleTransformation((0, _is.isError), "Error", function(v, superJson) {
        var baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach(function(prop) {
            baseError[prop] = v[prop];
        });
        return baseError;
    }, function(v, superJson) {
        var e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach(function(prop) {
            e[prop] = v[prop];
        });
        return e;
    }),
    simpleTransformation((0, _is.isRegExp), "regexp", function(v) {
        return "" + v;
    }, function(regex) {
        var body = regex.slice(1, regex.lastIndexOf("/"));
        var flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    simpleTransformation((0, _is.isSet), "set", // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(v) {
        return __spreadArray([], __read(v.values()));
    }, function(v) {
        return new Set(v);
    }),
    simpleTransformation((0, _is.isMap), "map", function(v) {
        return __spreadArray([], __read(v.entries()));
    }, function(v) {
        return new Map(v);
    }),
    simpleTransformation(function(v) {
        return (0, _is.isNaNValue)(v) || (0, _is.isInfinite)(v);
    }, "number", function(v) {
        if ((0, _is.isNaNValue)(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    simpleTransformation(function(v) {
        return v === 0 && 1 / v === -Infinity;
    }, "number", function() {
        return "-0";
    }, Number),
    simpleTransformation((0, _is.isURL), "URL", function(v) {
        return v.toString();
    }, function(v) {
        return new URL(v);
    })
];
function compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var symbolRule = compositeTransformation(function(s, superJson) {
    if ((0, _is.isSymbol)(s)) {
        var isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
    }
    return false;
}, function(s, superJson) {
    var identifier = superJson.symbolRegistry.getIdentifier(s);
    return [
        "symbol",
        identifier
    ];
}, function(v) {
    return v.description;
}, function(_, a, superJson) {
    var value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce(function(obj, ctor) {
    obj[ctor.name] = ctor;
    return obj;
}, {});
var typedArrayRule = compositeTransformation((0, _is.isTypedArray), function(v) {
    return [
        "typed-array",
        v.constructor.name
    ];
}, function(v) {
    return __spreadArray([], __read(v));
}, function(v, a) {
    var ctor = constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass === null || potentialClass === void 0 ? void 0 : potentialClass.constructor) {
        var isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
        return isRegistered;
    }
    return false;
}
var classRule = compositeTransformation(isInstanceOfRegisteredClass, function(clazz, superJson) {
    var identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
    return [
        "class",
        identifier
    ];
}, function(clazz, superJson) {
    var allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return __assign({}, clazz);
    var result = {};
    allowedProps.forEach(function(prop) {
        result[prop] = clazz[prop];
    });
    return result;
}, function(v, a, superJson) {
    var clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
    return Object.assign(Object.create(clazz.prototype), v);
});
var customRule = compositeTransformation(function(value, superJson) {
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, function(value, superJson) {
    var transformer = superJson.customTransformerRegistry.findApplicable(value);
    return [
        "custom",
        transformer.name
    ];
}, function(value, superJson) {
    var transformer = superJson.customTransformerRegistry.findApplicable(value);
    return transformer.serialize(value);
}, function(v, a, superJson) {
    var transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var compositeRules = [
    classRule,
    symbolRule,
    customRule,
    typedArrayRule
];
var transformValue = function(value, superJson) {
    var applicableCompositeRule = (0, _util.findArr)(compositeRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    var applicableSimpleRule = (0, _util.findArr)(simpleRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
    return undefined;
};
var simpleRulesByAnnotation = {};
simpleRules.forEach(function(rule) {
    simpleRulesByAnnotation[rule.annotation] = rule;
});
var untransformValue = function(json, type, superJson) {
    if ((0, _is.isArray)(type)) switch(type[0]){
        case "symbol":
            return symbolRule.untransform(json, type, superJson);
        case "class":
            return classRule.untransform(json, type, superJson);
        case "custom":
            return customRule.untransform(json, type, superJson);
        case "typed-array":
            return typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        var transformation = simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};

},{"./is":"1IKxK","./util":"e0tU1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"93RCN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDeep", ()=>getDeep);
parcelHelpers.export(exports, "setDeep", ()=>setDeep);
var _is = require("./is");
var _util = require("./util");
var getNthKey = function(value, n) {
    var keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function validatePath(path) {
    if ((0, _util.includes)(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ((0, _util.includes)(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ((0, _util.includes)(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var getDeep = function(object, path) {
    validatePath(path);
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if ((0, _is.isSet)(object)) object = getNthKey(object, +key);
        else if ((0, _is.isMap)(object)) {
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var setDeep = function(object, path, mapper) {
    validatePath(path);
    if (path.length === 0) return mapper(object);
    var parent = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if ((0, _is.isArray)(parent)) {
            var index = +key;
            parent = parent[index];
        } else if ((0, _is.isPlainObject)(parent)) parent = parent[key];
        else if ((0, _is.isSet)(parent)) {
            var row = +key;
            parent = getNthKey(parent, row);
        } else if ((0, _is.isMap)(parent)) {
            var isEnd = i === path.length - 2;
            if (isEnd) break;
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    var lastKey = path[path.length - 1];
    if ((0, _is.isArray)(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ((0, _is.isPlainObject)(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ((0, _is.isSet)(parent)) {
        var oldValue = getNthKey(parent, +lastKey);
        var newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent["delete"](oldValue);
            parent.add(newValue);
        }
    }
    if ((0, _is.isMap)(parent)) {
        var row = +path[path.length - 2];
        var keyToRow = getNthKey(parent, row);
        var type = +lastKey === 0 ? "key" : "value";
        switch(type){
            case "key":
                var newKey = mapper(keyToRow);
                parent.set(newKey, parent.get(keyToRow));
                if (newKey !== keyToRow) parent["delete"](keyToRow);
                break;
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};

},{"./is":"1IKxK","./util":"e0tU1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6Y8Km":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
var _isWhat = require("is-what");
function assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function copy(target, options = {}) {
    if ((0, _isWhat.isArray)(target)) return target.map((item)=>copy(item, options));
    if (!(0, _isWhat.isPlainObject)(target)) return target;
    const props = Object.getOwnPropertyNames(target);
    const symbols = Object.getOwnPropertySymbols(target);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ((0, _isWhat.isArray)(options.props) && !options.props.includes(key)) return carry;
        const val = target[key];
        const newVal = copy(val, options);
        assignProp(carry, key, newVal, target, options.nonenumerable);
        return carry;
    }, {});
}

},{"is-what":"5E4fY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5E4fY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getType", ()=>getType);
parcelHelpers.export(exports, "isAnyObject", ()=>isAnyObject);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBlob", ()=>isBlob);
parcelHelpers.export(exports, "isBoolean", ()=>isBoolean);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isEmptyArray", ()=>isEmptyArray);
parcelHelpers.export(exports, "isEmptyObject", ()=>isEmptyObject);
parcelHelpers.export(exports, "isEmptyString", ()=>isEmptyString);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "isFile", ()=>isFile);
parcelHelpers.export(exports, "isFullArray", ()=>isFullArray);
parcelHelpers.export(exports, "isFullObject", ()=>isFullObject);
parcelHelpers.export(exports, "isFullString", ()=>isFullString);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isInstanceOf", ()=>isInstanceOf);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isNaNValue", ()=>isNaNValue);
parcelHelpers.export(exports, "isNegativeNumber", ()=>isNegativeNumber);
parcelHelpers.export(exports, "isNull", ()=>isNull);
parcelHelpers.export(exports, "isNullOrUndefined", ()=>isNullOrUndefined);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isObjectLike", ()=>isObjectLike);
parcelHelpers.export(exports, "isOneOf", ()=>isOneOf);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPositiveNumber", ()=>isPositiveNumber);
parcelHelpers.export(exports, "isPrimitive", ()=>isPrimitive);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isType", ()=>isType);
parcelHelpers.export(exports, "isUndefined", ()=>isUndefined);
parcelHelpers.export(exports, "isWeakMap", ()=>isWeakMap);
parcelHelpers.export(exports, "isWeakSet", ()=>isWeakSet);
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function isUndefined(payload) {
    return getType(payload) === "Undefined";
}
function isNull(payload) {
    return getType(payload) === "Null";
}
function isPlainObject(payload) {
    if (getType(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function isObject(payload) {
    return isPlainObject(payload);
}
function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
function isAnyObject(payload) {
    return getType(payload) === "Object";
}
function isObjectLike(payload) {
    return isAnyObject(payload);
}
function isFunction(payload) {
    return typeof payload === "function";
}
function isArray(payload) {
    return getType(payload) === "Array";
}
function isFullArray(payload) {
    return isArray(payload) && payload.length > 0;
}
function isEmptyArray(payload) {
    return isArray(payload) && payload.length === 0;
}
function isString(payload) {
    return getType(payload) === "String";
}
function isFullString(payload) {
    return isString(payload) && payload !== "";
}
function isEmptyString(payload) {
    return payload === "";
}
function isNumber(payload) {
    return getType(payload) === "Number" && !isNaN(payload);
}
function isPositiveNumber(payload) {
    return isNumber(payload) && payload > 0;
}
function isNegativeNumber(payload) {
    return isNumber(payload) && payload < 0;
}
function isBoolean(payload) {
    return getType(payload) === "Boolean";
}
function isRegExp(payload) {
    return getType(payload) === "RegExp";
}
function isMap(payload) {
    return getType(payload) === "Map";
}
function isWeakMap(payload) {
    return getType(payload) === "WeakMap";
}
function isSet(payload) {
    return getType(payload) === "Set";
}
function isWeakSet(payload) {
    return getType(payload) === "WeakSet";
}
function isSymbol(payload) {
    return getType(payload) === "Symbol";
}
function isDate(payload) {
    return getType(payload) === "Date" && !isNaN(payload);
}
function isBlob(payload) {
    return getType(payload) === "Blob";
}
function isFile(payload) {
    return getType(payload) === "File";
}
function isPromise(payload) {
    return getType(payload) === "Promise";
}
function isError(payload) {
    return getType(payload) === "Error";
}
function isNaNValue(payload) {
    return getType(payload) === "Number" && isNaN(payload);
}
function isPrimitive(payload) {
    return isBoolean(payload) || isNull(payload) || isUndefined(payload) || isNumber(payload) || isString(payload) || isSymbol(payload);
}
const isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function isType(payload, type) {
    if (!(type instanceof Function)) throw new TypeError("Type must be a function");
    if (!Object.prototype.hasOwnProperty.call(type, "prototype")) throw new TypeError("Type is not a class");
    const name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}
function isInstanceOf(value, classOrClassName) {
    if (typeof classOrClassName === "function") {
        for(let p = value; p; p = Object.getPrototypeOf(p)){
            if (isType(p, classOrClassName)) return true;
        }
        return false;
    } else {
        for(let p = value; p; p = Object.getPrototypeOf(p)){
            if (getType(p) === classOrClassName) return true;
        }
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cyfOU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "defaultTheme", ()=>defaultTheme);
parcelHelpers.export(exports, "useTheme", ()=>useTheme);
var _rollupPluginBabelHelpersEsmJs = require("./_virtual/_rollupPluginBabelHelpers.esm.js");
var _react = require("react");
"use client";
const defaultTheme = {
    background: "#0b1521",
    backgroundAlt: "#132337",
    foreground: "white",
    gray: "#3f4e60",
    grayAlt: "#222e3e",
    inputBackgroundColor: "#fff",
    inputTextColor: "#000",
    success: "#00ab52",
    danger: "#ff0085",
    active: "#006bff",
    paused: "#8c49eb",
    warning: "#ffb200"
};
const ThemeContext = /*#__PURE__*/ _react.createContext(defaultTheme);
function ThemeProvider({ theme, ...rest }) {
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, (0, _rollupPluginBabelHelpersEsmJs.extends)({
        value: theme
    }, rest));
}
function useTheme() {
    return _react.useContext(ThemeContext);
}

},{"./_virtual/_rollupPluginBabelHelpers.esm.js":"U0akX","react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eHZ39":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMediaQuery);
var _react = require("react");
function useMediaQuery(query) {
    // Keep track of the preference in state, start with the current match
    const [isMatch, setIsMatch] = _react.useState(()=>{
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return;
    }); // Watch for changes
    _react.useEffect(()=>{
        if (typeof window !== "undefined") {
            // Create a matcher
            const matcher = window.matchMedia(query); // Create our handler
            const onChange = ({ matches })=>setIsMatch(matches); // Listen for changes
            matcher.addListener(onChange);
            return ()=>{
                // Stop listening for changes
                matcher.removeListener(onChange);
            };
        }
        return;
    }, [
        isMatch,
        query,
        setIsMatch
    ]);
    return isMatch;
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"enOyv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActiveQueryPanel", ()=>ActiveQueryPanel);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "Code", ()=>Code);
parcelHelpers.export(exports, "Input", ()=>Input);
parcelHelpers.export(exports, "Panel", ()=>Panel);
parcelHelpers.export(exports, "QueryKey", ()=>QueryKey);
parcelHelpers.export(exports, "QueryKeys", ()=>QueryKeys);
parcelHelpers.export(exports, "Select", ()=>Select);
var _utilsEsmJs = require("./utils.esm.js");
const Panel = (0, _utilsEsmJs.styled)("div", (_props, theme)=>({
        fontSize: "clamp(12px, 1.5vw, 14px)",
        fontFamily: "sans-serif",
        display: "flex",
        backgroundColor: theme.background,
        color: theme.foreground
    }), {
    "(max-width: 700px)": {
        flexDirection: "column"
    },
    "(max-width: 600px)": {
        fontSize: ".9em" // flexDirection: 'column',
    }
});
const ActiveQueryPanel = (0, _utilsEsmJs.styled)("div", ()=>({
        flex: "1 1 500px",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        height: "100%"
    }), {
    "(max-width: 700px)": (_props, theme)=>({
            borderTop: "2px solid " + theme.gray
        })
});
const Button = (0, _utilsEsmJs.styled)("button", (props, theme)=>({
        appearance: "none",
        fontSize: ".9em",
        fontWeight: "bold",
        background: theme.gray,
        border: "0",
        borderRadius: ".3em",
        color: "white",
        padding: ".5em",
        opacity: props.disabled ? ".5" : undefined,
        cursor: "pointer"
    }));
const QueryKeys = (0, _utilsEsmJs.styled)("span", {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5em",
    fontSize: "0.9em"
});
const QueryKey = (0, _utilsEsmJs.styled)("span", {
    display: "inline-flex",
    alignItems: "center",
    padding: ".2em .4em",
    fontWeight: "bold",
    textShadow: "0 0 10px black",
    borderRadius: ".2em"
});
const Code = (0, _utilsEsmJs.styled)("code", {
    fontSize: ".9em",
    color: "inherit",
    background: "inherit"
});
const Input = (0, _utilsEsmJs.styled)("input", (_props, theme)=>({
        backgroundColor: theme.inputBackgroundColor,
        border: 0,
        borderRadius: ".2em",
        color: theme.inputTextColor,
        fontSize: ".9em",
        lineHeight: "1.3",
        padding: ".3em .4em"
    }));
const Select = (0, _utilsEsmJs.styled)("select", (_props, theme)=>({
        display: "inline-block",
        fontSize: ".9em",
        fontFamily: "sans-serif",
        fontWeight: "normal",
        lineHeight: "1.3",
        padding: ".3em 1.5em .3em .5em",
        height: "auto",
        border: 0,
        borderRadius: ".2em",
        appearance: "none",
        WebkitAppearance: "none",
        backgroundColor: theme.inputBackgroundColor,
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23444444'><polygon points='0,25 100,25 50,75'/></svg>\")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right .55em center",
        backgroundSize: ".65em auto, 100%",
        color: theme.inputTextColor
    }), {
    "(max-width: 500px)": {
        display: "none"
    }
});

},{"./utils.esm.js":"2ju2h","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bXWWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScreenReader);
var _react = require("react");
function ScreenReader({ text }) {
    return /*#__PURE__*/ _react.createElement("span", {
        style: {
            position: "absolute",
            width: "0.1px",
            height: "0.1px",
            overflow: "hidden"
        }
    }, text);
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8Btox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyButton", ()=>CopyButton);
parcelHelpers.export(exports, "DefaultRenderer", ()=>DefaultRenderer);
parcelHelpers.export(exports, "Entry", ()=>Entry);
parcelHelpers.export(exports, "ExpandButton", ()=>ExpandButton);
parcelHelpers.export(exports, "Expander", ()=>Expander);
parcelHelpers.export(exports, "Info", ()=>Info);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "LabelButton", ()=>LabelButton);
parcelHelpers.export(exports, "SubEntries", ()=>SubEntries);
parcelHelpers.export(exports, "Value", ()=>Value);
parcelHelpers.export(exports, "chunkArray", ()=>chunkArray);
parcelHelpers.export(exports, "default", ()=>Explorer);
var _rollupPluginBabelHelpersEsmJs = require("./_virtual/_rollupPluginBabelHelpers.esm.js");
var _react = require("react");
var _superjson = require("superjson");
var _superjsonDefault = parcelHelpers.interopDefault(_superjson);
var _utilsEsmJs = require("./utils.esm.js");
"use client";
const Entry = (0, _utilsEsmJs.styled)("div", {
    fontFamily: "Menlo, monospace",
    fontSize: "1em",
    lineHeight: "1.7",
    outline: "none",
    wordBreak: "break-word"
});
const Label = (0, _utilsEsmJs.styled)("span", {
    color: "white"
});
const LabelButton = (0, _utilsEsmJs.styled)("button", {
    cursor: "pointer",
    color: "white"
});
const ExpandButton = (0, _utilsEsmJs.styled)("button", {
    cursor: "pointer",
    color: "inherit",
    font: "inherit",
    outline: "inherit",
    background: "transparent",
    border: "none",
    padding: 0
});
const CopyButton = ({ value })=>{
    const [copyState, setCopyState] = _react.useState("NoCopy");
    return /*#__PURE__*/ _react.createElement("button", {
        onClick: copyState === "NoCopy" ? ()=>{
            navigator.clipboard.writeText((0, _superjsonDefault.default).stringify(value)).then(()=>{
                setCopyState("SuccessCopy");
                setTimeout(()=>{
                    setCopyState("NoCopy");
                }, 1500);
            }, (err)=>{
                console.error("Failed to copy: ", err);
                setCopyState("ErrorCopy");
                setTimeout(()=>{
                    setCopyState("NoCopy");
                }, 1500);
            });
        } : undefined,
        style: {
            cursor: "pointer",
            color: "inherit",
            font: "inherit",
            outline: "inherit",
            background: "transparent",
            border: "none",
            padding: 0
        }
    }, copyState === "NoCopy" ? /*#__PURE__*/ _react.createElement(Copier, null) : copyState === "SuccessCopy" ? /*#__PURE__*/ _react.createElement(CopiedCopier, null) : /*#__PURE__*/ _react.createElement(ErrorCopier, null));
};
const Value = (0, _utilsEsmJs.styled)("span", (_props, theme)=>({
        color: theme.danger
    }));
const SubEntries = (0, _utilsEsmJs.styled)("div", {
    marginLeft: ".1em",
    paddingLeft: "1em",
    borderLeft: "2px solid rgba(0,0,0,.15)"
});
const Info = (0, _utilsEsmJs.styled)("span", {
    color: "grey",
    fontSize: ".7em"
});
const Expander = ({ expanded, style = {} })=>/*#__PURE__*/ _react.createElement("span", {
        style: {
            display: "inline-block",
            transition: "all .1s ease",
            transform: "rotate(" + (expanded ? 90 : 0) + "deg) " + (style.transform || ""),
            ...style
        }
    }, "\u25B6");
const Copier = ()=>/*#__PURE__*/ _react.createElement("span", {
        "aria-label": "Copy object to clipboard",
        title: "Copy object to clipboard",
        style: {
            paddingLeft: "1em"
        }
    }, /*#__PURE__*/ _react.createElement("svg", {
        height: "12",
        viewBox: "0 0 16 12",
        width: "10"
    }, /*#__PURE__*/ _react.createElement("path", {
        fill: "currentColor",
        d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"
    }), /*#__PURE__*/ _react.createElement("path", {
        fill: "currentColor",
        d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"
    })));
const ErrorCopier = ()=>/*#__PURE__*/ _react.createElement("span", {
        "aria-label": "Failed copying to clipboard",
        title: "Failed copying to clipboard",
        style: {
            paddingLeft: "1em",
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ _react.createElement("svg", {
        height: "12",
        viewBox: "0 0 16 12",
        width: "10",
        display: "block"
    }, /*#__PURE__*/ _react.createElement("path", {
        fill: "red",
        d: "M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"
    })), /*#__PURE__*/ _react.createElement("span", {
        style: {
            color: "red",
            fontSize: "12px",
            paddingLeft: "4px",
            position: "relative",
            top: "2px"
        }
    }, "See console"));
const CopiedCopier = ()=>/*#__PURE__*/ _react.createElement("span", {
        "aria-label": "Object copied to clipboard",
        title: "Object copied to clipboard",
        style: {
            paddingLeft: "1em",
            display: "inline-block",
            verticalAlign: "middle"
        }
    }, /*#__PURE__*/ _react.createElement("svg", {
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        display: "block"
    }, /*#__PURE__*/ _react.createElement("path", {
        fill: "green",
        d: "M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
    })));
/**
 * Chunk elements in the array by size
 *
 * when the array cannot be chunked evenly by size, the last chunk will be
 * filled with the remaining elements
 *
 * @example
 * chunkArray(['a','b', 'c', 'd', 'e'], 2) // returns [['a','b'], ['c', 'd'], ['e']]
 */ function chunkArray(array, size) {
    if (size < 1) return [];
    let i = 0;
    const result = [];
    while(i < array.length){
        result.push(array.slice(i, i + size));
        i = i + size;
    }
    return result;
}
const DefaultRenderer = ({ handleEntry, label, value, subEntries = [], subEntryPages = [], type, expanded = false, copyable = false, toggleExpanded, pageSize })=>{
    const [expandedPages, setExpandedPages] = _react.useState([]);
    return /*#__PURE__*/ _react.createElement(Entry, {
        key: label
    }, subEntryPages.length ? /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(ExpandButton, {
        onClick: ()=>toggleExpanded()
    }, /*#__PURE__*/ _react.createElement(Expander, {
        expanded: expanded
    }), " ", label, " ", /*#__PURE__*/ _react.createElement(Info, null, String(type).toLowerCase() === "iterable" ? "(Iterable) " : "", subEntries.length, " ", subEntries.length > 1 ? "items" : "item")), copyable ? /*#__PURE__*/ _react.createElement(CopyButton, {
        value: value
    }) : null, expanded ? subEntryPages.length === 1 ? /*#__PURE__*/ _react.createElement(SubEntries, null, subEntries.map(handleEntry)) : /*#__PURE__*/ _react.createElement(SubEntries, null, subEntryPages.map((entries, index)=>/*#__PURE__*/ _react.createElement("div", {
            key: index
        }, /*#__PURE__*/ _react.createElement(Entry, null, /*#__PURE__*/ _react.createElement(LabelButton, {
            onClick: ()=>setExpandedPages((old)=>old.includes(index) ? old.filter((d)=>d !== index) : [
                        ...old,
                        index
                    ])
        }, /*#__PURE__*/ _react.createElement(Expander, {
            expanded: expanded
        }), " [", index * pageSize, " ...", " ", index * pageSize + pageSize - 1, "]"), expandedPages.includes(index) ? /*#__PURE__*/ _react.createElement(SubEntries, null, entries.map(handleEntry)) : null)))) : null) : /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Label, null, label, ":"), " ", /*#__PURE__*/ _react.createElement(Value, null, (0, _utilsEsmJs.displayValue)(value))));
};
function isIterable(x) {
    return Symbol.iterator in x;
}
function Explorer({ value, defaultExpanded, renderer = DefaultRenderer, pageSize = 100, copyable = false, ...rest }) {
    const [expanded, setExpanded] = _react.useState(Boolean(defaultExpanded));
    const toggleExpanded = _react.useCallback(()=>setExpanded((old)=>!old), []);
    let type = typeof value;
    let subEntries = [];
    const makeProperty = (sub)=>{
        const subDefaultExpanded = defaultExpanded === true ? {
            [sub.label]: true
        } : defaultExpanded == null ? void 0 : defaultExpanded[sub.label];
        return {
            ...sub,
            defaultExpanded: subDefaultExpanded
        };
    };
    if (Array.isArray(value)) {
        type = "array";
        subEntries = value.map((d, i)=>makeProperty({
                label: i.toString(),
                value: d
            }));
    } else if (value !== null && typeof value === "object" && isIterable(value) && typeof value[Symbol.iterator] === "function") {
        type = "Iterable";
        subEntries = Array.from(value, (val, i)=>makeProperty({
                label: i.toString(),
                value: val
            }));
    } else if (typeof value === "object" && value !== null) {
        type = "object";
        subEntries = Object.entries(value).map(([key, val])=>makeProperty({
                label: key,
                value: val
            }));
    }
    const subEntryPages = chunkArray(subEntries, pageSize);
    return renderer({
        handleEntry: (entry)=>/*#__PURE__*/ _react.createElement(Explorer, (0, _rollupPluginBabelHelpersEsmJs.extends)({
                key: entry.label,
                value: value,
                renderer: renderer,
                copyable: copyable
            }, rest, entry)),
        type,
        subEntries,
        subEntryPages,
        value,
        expanded,
        copyable,
        toggleExpanded,
        pageSize,
        ...rest
    });
}

},{"./_virtual/_rollupPluginBabelHelpers.esm.js":"U0akX","react":"BK2ob","superjson":"5NkCd","./utils.esm.js":"2ju2h","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fLton":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Logo);
var _rollupPluginBabelHelpersEsmJs = require("./_virtual/_rollupPluginBabelHelpers.esm.js");
var _react = require("react");
function Logo(props) {
    return /*#__PURE__*/ _react.createElement("svg", (0, _rollupPluginBabelHelpersEsmJs.extends)({
        width: "40px",
        height: "40px",
        viewBox: "0 0 190 190",
        version: "1.1"
    }, props), /*#__PURE__*/ _react.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ _react.createElement("g", {
        transform: "translate(-33.000000, 0.000000)"
    }, /*#__PURE__*/ _react.createElement("path", {
        d: "M72.7239712,61.3436237 C69.631224,46.362877 68.9675112,34.8727722 70.9666331,26.5293551 C72.1555965,21.5671678 74.3293088,17.5190846 77.6346064,14.5984631 C81.1241394,11.5150478 85.5360327,10.0020122 90.493257,10.0020122 C98.6712013,10.0020122 107.26826,13.7273214 116.455725,20.8044264 C120.20312,23.6910458 124.092437,27.170411 128.131651,31.2444746 C128.45314,30.8310265 128.816542,30.4410453 129.22143,30.0806152 C140.64098,19.9149716 150.255245,13.5989272 158.478408,11.1636507 C163.367899,9.715636 167.958526,9.57768202 172.138936,10.983031 C176.551631,12.4664684 180.06766,15.5329489 182.548314,19.8281091 C186.642288,26.9166735 187.721918,36.2310983 186.195595,47.7320243 C185.573451,52.4199112 184.50985,57.5263831 183.007094,63.0593153 C183.574045,63.1277086 184.142416,63.2532808 184.705041,63.4395297 C199.193932,68.2358678 209.453582,73.3937462 215.665021,79.2882839 C219.360669,82.7953831 221.773972,86.6998434 222.646365,91.0218204 C223.567176,95.5836746 222.669313,100.159332 220.191548,104.451297 C216.105211,111.529614 208.591643,117.11221 197.887587,121.534031 C193.589552,123.309539 188.726579,124.917559 183.293259,126.363748 C183.541176,126.92292 183.733521,127.516759 183.862138,128.139758 C186.954886,143.120505 187.618598,154.61061 185.619477,162.954027 C184.430513,167.916214 182.256801,171.964297 178.951503,174.884919 C175.46197,177.968334 171.050077,179.48137 166.092853,179.48137 C157.914908,179.48137 149.31785,175.756061 140.130385,168.678956 C136.343104,165.761613 132.410866,162.238839 128.325434,158.108619 C127.905075,158.765474 127.388968,159.376011 126.77857,159.919385 C115.35902,170.085028 105.744755,176.401073 97.5215915,178.836349 C92.6321009,180.284364 88.0414736,180.422318 83.8610636,179.016969 C79.4483686,177.533532 75.9323404,174.467051 73.4516862,170.171891 C69.3577116,163.083327 68.2780823,153.768902 69.8044053,142.267976 C70.449038,137.410634 71.56762,132.103898 73.1575891,126.339009 C72.5361041,126.276104 71.9120754,126.144816 71.2949591,125.940529 C56.8060684,121.144191 46.5464184,115.986312 40.3349789,110.091775 C36.6393312,106.584675 34.2260275,102.680215 33.3536352,98.3582381 C32.4328237,93.7963839 33.3306866,89.2207269 35.8084524,84.9287618 C39.8947886,77.8504443 47.4083565,72.2678481 58.1124133,67.8460273 C62.5385143,66.0176154 67.5637208,64.366822 73.1939394,62.8874674 C72.9933393,62.3969171 72.8349374,61.8811235 72.7239712,61.3436237 Z",
        fill: "#002C4B",
        fillRule: "nonzero",
        transform: "translate(128.000000, 95.000000) scale(-1, 1) translate(-128.000000, -95.000000) "
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M113.396882,64 L142.608177,64 C144.399254,64 146.053521,64.958025 146.944933,66.5115174 L161.577138,92.0115174 C162.461464,93.5526583 162.461464,95.4473417 161.577138,96.9884826 L146.944933,122.488483 C146.053521,124.041975 144.399254,125 142.608177,125 L113.396882,125 C111.605806,125 109.951539,124.041975 109.060126,122.488483 L94.4279211,96.9884826 C93.543596,95.4473417 93.543596,93.5526583 94.4279211,92.0115174 L109.060126,66.5115174 C109.951539,64.958025 111.605806,64 113.396882,64 Z M138.987827,70.2765273 C140.779849,70.2765273 142.434839,71.2355558 143.325899,72.7903404 L154.343038,92.0138131 C155.225607,93.5537825 155.225607,95.4462175 154.343038,96.9861869 L143.325899,116.20966 C142.434839,117.764444 140.779849,118.723473 138.987827,118.723473 L117.017233,118.723473 C115.225211,118.723473 113.570221,117.764444 112.67916,116.20966 L101.662022,96.9861869 C100.779452,95.4462175 100.779452,93.5537825 101.662022,92.0138131 L112.67916,72.7903404 C113.570221,71.2355558 115.225211,70.2765273 117.017233,70.2765273 L138.987827,70.2765273 Z M135.080648,77.1414791 L120.924411,77.1414791 C119.134228,77.1414791 117.480644,78.0985567 116.5889,79.6508285 L116.5889,79.6508285 L109.489217,92.0093494 C108.603232,93.5515958 108.603232,95.4484042 109.489217,96.9906506 L109.489217,96.9906506 L116.5889,109.349172 C117.480644,110.901443 119.134228,111.858521 120.924411,111.858521 L120.924411,111.858521 L135.080648,111.858521 C136.870831,111.858521 138.524416,110.901443 139.41616,109.349172 L139.41616,109.349172 L146.515843,96.9906506 C147.401828,95.4484042 147.401828,93.5515958 146.515843,92.0093494 L146.515843,92.0093494 L139.41616,79.6508285 C138.524416,78.0985567 136.870831,77.1414791 135.080648,77.1414791 L135.080648,77.1414791 Z M131.319186,83.7122186 C133.108028,83.7122186 134.760587,84.6678753 135.652827,86.2183156 L138.983552,92.0060969 C139.87203,93.5500005 139.87203,95.4499995 138.983552,96.9939031 L135.652827,102.781684 C134.760587,104.332125 133.108028,105.287781 131.319186,105.287781 L124.685874,105.287781 C122.897032,105.287781 121.244473,104.332125 120.352233,102.781684 L117.021508,96.9939031 C116.13303,95.4499995 116.13303,93.5500005 117.021508,92.0060969 L120.352233,86.2183156 C121.244473,84.6678753 122.897032,83.7122186 124.685874,83.7122186 L131.319186,83.7122186 Z M128.003794,90.1848875 C126.459294,90.1848875 125.034382,91.0072828 124.263005,92.3424437 C123.491732,93.6774232 123.491732,95.3225768 124.263005,96.6575563 C125.034382,97.9927172 126.459294,98.8151125 128.001266,98.8151125 L128.001266,98.8151125 C129.545766,98.8151125 130.970678,97.9927172 131.742055,96.6575563 C132.513327,95.3225768 132.513327,93.6774232 131.742055,92.3424437 C130.970678,91.0072828 129.545766,90.1848875 128.003794,90.1848875 L128.003794,90.1848875 Z M93,94.5009646 L100.767764,94.5009646",
        fill: "#FFD94C"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M87.8601729,108.357758 C89.1715224,107.608286 90.8360246,108.074601 91.5779424,109.399303 L91.5779424,109.399303 L92.0525843,110.24352 C95.8563392,116.982993 99.8190116,123.380176 103.940602,129.435068 C108.807881,136.585427 114.28184,143.82411 120.362479,151.151115 C121.316878,152.30114 121.184944,154.011176 120.065686,154.997937 L120.065686,154.997937 L119.454208,155.534625 C99.3465389,173.103314 86.2778188,176.612552 80.2480482,166.062341 C74.3500652,155.742717 76.4844915,136.982888 86.6513274,109.782853 C86.876818,109.179582 87.3045861,108.675291 87.8601729,108.357758 Z M173.534177,129.041504 C174.986131,128.785177 176.375496,129.742138 176.65963,131.194242 L176.65963,131.194242 L176.812815,131.986376 C181.782365,157.995459 178.283348,171 166.315764,171 C154.609745,171 139.708724,159.909007 121.612702,137.727022 C121.211349,137.235047 120.994572,136.617371 121,135.981509 C121.013158,134.480686 122.235785,133.274651 123.730918,133.287756 L123.730918,133.287756 L124.684654,133.294531 C132.305698,133.335994 139.714387,133.071591 146.910723,132.501323 C155.409039,131.82788 164.283523,130.674607 173.534177,129.041504 Z M180.408726,73.8119663 C180.932139,72.4026903 182.508386,71.6634537 183.954581,72.149012 L183.954581,72.149012 L184.742552,72.4154854 C210.583763,81.217922 220.402356,90.8916805 214.198332,101.436761 C208.129904,111.751366 190.484347,119.260339 161.26166,123.963678 C160.613529,124.067994 159.948643,123.945969 159.382735,123.618843 C158.047025,122.846729 157.602046,121.158214 158.388848,119.847438 L158.388848,119.847438 L158.889328,119.0105 C162.877183,112.31633 166.481358,105.654262 169.701854,99.0242957 C173.50501,91.1948179 177.073967,82.7907081 180.408726,73.8119663 Z M94.7383398,66.0363218 C95.3864708,65.9320063 96.0513565,66.0540315 96.6172646,66.3811573 C97.9529754,67.153271 98.3979538,68.8417862 97.6111517,70.1525615 L97.6111517,70.1525615 L97.1106718,70.9895001 C93.1228168,77.6836699 89.5186416,84.3457379 86.2981462,90.9757043 C82.49499,98.8051821 78.9260328,107.209292 75.5912744,116.188034 C75.0678608,117.59731 73.4916142,118.336546 72.045419,117.850988 L72.045419,117.850988 L71.2574475,117.584515 C45.4162372,108.782078 35.597644,99.1083195 41.8016679,88.5632391 C47.8700957,78.2486335 65.515653,70.7396611 94.7383398,66.0363218 Z M136.545792,34.4653746 C156.653461,16.8966864 169.722181,13.3874478 175.751952,23.9376587 C181.649935,34.2572826 179.515508,53.0171122 169.348673,80.2171474 C169.123182,80.8204179 168.695414,81.324709 168.139827,81.6422422 C166.828478,82.3917144 165.163975,81.9253986 164.422058,80.6006966 L164.422058,80.6006966 L163.947416,79.7564798 C160.143661,73.0170065 156.180988,66.6198239 152.059398,60.564932 C147.192119,53.4145727 141.71816,46.1758903 135.637521,38.8488847 C134.683122,37.6988602 134.815056,35.9888243 135.934314,35.0020629 L135.934314,35.0020629 Z M90.6842361,18 C102.390255,18 117.291276,29.0909926 135.387298,51.2729777 C135.788651,51.7649527 136.005428,52.3826288 136,53.0184911 C135.986842,54.5193144 134.764215,55.7253489 133.269082,55.7122445 L133.269082,55.7122445 L132.315346,55.7054689 C124.694302,55.6640063 117.285613,55.9284091 110.089277,56.4986773 C101.590961,57.17212 92.7164767,58.325393 83.4658235,59.9584962 C82.0138691,60.2148231 80.6245044,59.2578618 80.3403697,57.805758 L80.3403697,57.805758 L80.1871846,57.0136235 C75.2176347,31.0045412 78.7166519,18 90.6842361,18 Z",
        fill: "#FF4154"
    }))));
}

},{"./_virtual/_rollupPluginBabelHelpers.esm.js":"U0akX","react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cGtHz":[function(require,module,exports) {
/**
 * Swiper Custom Element 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwiperContainer", ()=>SwiperContainer);
parcelHelpers.export(exports, "SwiperSlide", ()=>SwiperSlide);
parcelHelpers.export(exports, "register", ()=>register);
var _swiperBundleMjs = require("./swiper-bundle.mjs");
var _updateSwiperMjs = require("./shared/update-swiper.mjs");
var _getElementParamsMjs = require("./shared/get-element-params.mjs");
var _swiperCoreMjs = require("./shared/swiper-core.mjs");
/* eslint-disable spaced-comment */ const SwiperCSS = `:host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}`;
const SwiperSlideCSS = `::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}`;
class DummyHTMLElement {
}
const ClassToExtend = typeof window === "undefined" || typeof HTMLElement === "undefined" ? DummyHTMLElement : HTMLElement;
const arrowSvg = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `;
const addStyle = (shadowRoot, styles)=>{
    if (typeof CSSStyleSheet !== "undefined" && shadowRoot.adoptedStyleSheets) {
        const styleSheet = new CSSStyleSheet();
        styleSheet.replaceSync(styles);
        shadowRoot.adoptedStyleSheets = [
            styleSheet
        ];
    } else {
        const style = document.createElement("style");
        style.rel = "stylesheet";
        style.textContent = styles;
        shadowRoot.appendChild(style);
    }
};
class SwiperContainer extends ClassToExtend {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    static get nextButtonSvg() {
        return arrowSvg;
    }
    static get prevButtonSvg() {
        return arrowSvg.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
    }
    cssStyles() {
        return [
            SwiperCSS,
            // eslint-disable-line
            ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
        ].join("\n");
    }
    cssLinks() {
        return this.injectStylesUrls || [];
    }
    calcSlideSlots() {
        const currentSideSlots = this.slideSlots || 0;
        // slide slots
        const slideSlotChildren = [
            ...this.querySelectorAll(`[slot^=slide-]`)
        ].map((child)=>{
            return parseInt(child.getAttribute("slot").split("slide-")[1], 10);
        });
        this.slideSlots = slideSlotChildren.length ? Math.max(...slideSlotChildren) + 1 : 0;
        if (!this.rendered) return;
        if (this.slideSlots > currentSideSlots) for(let i = currentSideSlots; i < this.slideSlots; i += 1){
            const slideEl = document.createElement("swiper-slide");
            slideEl.setAttribute("part", `slide slide-${i + 1}`);
            const slotEl = document.createElement("slot");
            slotEl.setAttribute("name", `slide-${i + 1}`);
            slideEl.appendChild(slotEl);
            this.shadowRoot.querySelector(".swiper-wrapper").appendChild(slideEl);
        }
        else if (this.slideSlots < currentSideSlots) {
            const slides = this.swiper.slides;
            for(let i = slides.length - 1; i >= 0; i -= 1)if (i > this.slideSlots) slides[i].remove();
        }
    }
    render() {
        if (this.rendered) return;
        this.calcSlideSlots();
        // local styles
        let localStyles = this.cssStyles();
        if (this.slideSlots > 0) localStyles = localStyles.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1");
        if (localStyles.length) addStyle(this.shadowRoot, localStyles);
        this.cssLinks().forEach((url)=>{
            const linkExists = this.shadowRoot.querySelector(`link[href="${url}"]`);
            if (linkExists) return;
            const linkEl = document.createElement("link");
            linkEl.rel = "stylesheet";
            linkEl.href = url;
            this.shadowRoot.appendChild(linkEl);
        });
        // prettier-ignore
        const el = document.createElement("div");
        el.classList.add("swiper");
        el.part = "container";
        // prettier-ignore
        el.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
            length: this.slideSlots
        }).map((_, index)=>`
        <swiper-slide part="slide slide-${index}">
          <slot name="slide-${index}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${(0, _updateSwiperMjs.n)(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${(0, _updateSwiperMjs.a)(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${(0, _updateSwiperMjs.b)(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `;
        this.shadowRoot.appendChild(el);
        this.rendered = true;
    }
    initialize() {
        var _this = this;
        if (this.initialized) return;
        this.initialized = true;
        const { params: swiperParams, passedParams } = (0, _getElementParamsMjs.g)(this);
        this.swiperParams = swiperParams;
        this.passedParams = passedParams;
        delete this.swiperParams.init;
        this.render();
        // eslint-disable-next-line
        this.swiper = new (0, _swiperCoreMjs.S)(this.shadowRoot.querySelector(".swiper"), {
            ...swiperParams.virtual ? {} : {
                observer: true,
                observeSlideChildren: this.slideSlots > 0
            },
            ...swiperParams,
            touchEventsTarget: "container",
            onAny: function(name) {
                if (name === "observerUpdate") _this.calcSlideSlots();
                const eventName = swiperParams.eventsPrefix ? `${swiperParams.eventsPrefix}${name.toLowerCase()}` : name.toLowerCase();
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                const event = new CustomEvent(eventName, {
                    detail: args,
                    bubbles: name !== "hashChange",
                    cancelable: true
                });
                _this.dispatchEvent(event);
            }
        });
    }
    connectedCallback() {
        if (this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM) return;
        if (this.init === false || this.getAttribute("init") === "false") return;
        this.initialize();
    }
    disconnectedCallback() {
        if (this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM) return;
        if (this.swiper && this.swiper.destroy) this.swiper.destroy();
        this.initialized = false;
    }
    updateSwiperOnPropChange(propName, propValue) {
        const { params: swiperParams, passedParams } = (0, _getElementParamsMjs.g)(this, propName, propValue);
        this.passedParams = passedParams;
        this.swiperParams = swiperParams;
        if (this.swiper && this.swiper.params[propName] === propValue) return;
        (0, _updateSwiperMjs.u)({
            swiper: this.swiper,
            passedParams: this.passedParams,
            changedParams: [
                (0, _updateSwiperMjs.c)(propName)
            ],
            ...propName === "navigation" && passedParams[propName] ? {
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next"
            } : {},
            ...propName === "pagination" && passedParams[propName] ? {
                paginationEl: ".swiper-pagination"
            } : {},
            ...propName === "scrollbar" && passedParams[propName] ? {
                scrollbarEl: ".swiper-scrollbar"
            } : {}
        });
    }
    attributeChangedCallback(attr, prevValue, newValue) {
        if (!this.initialized) return;
        if (prevValue === "true" && newValue === null) newValue = false;
        this.updateSwiperOnPropChange(attr, newValue);
    }
    static get observedAttributes() {
        const attrs = (0, _updateSwiperMjs.p).filter((param)=>param.includes("_")).map((param)=>param.replace(/[A-Z]/g, (v)=>`-${v}`).replace("_", "").toLowerCase());
        return attrs;
    }
}
(0, _updateSwiperMjs.p).forEach((paramName)=>{
    if (paramName === "init") return;
    paramName = paramName.replace("_", "");
    Object.defineProperty(SwiperContainer.prototype, paramName, {
        configurable: true,
        get () {
            return (this.passedParams || {})[paramName];
        },
        set (value) {
            if (!this.passedParams) this.passedParams = {};
            this.passedParams[paramName] = value;
            if (!this.initialized) return;
            this.updateSwiperOnPropChange(paramName, value);
        }
    });
});
class SwiperSlide extends ClassToExtend {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    render() {
        const lazy = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
        addStyle(this.shadowRoot, SwiperSlideCSS);
        this.shadowRoot.appendChild(document.createElement("slot"));
        if (lazy) {
            const lazyDiv = document.createElement("div");
            lazyDiv.classList.add("swiper-lazy-preloader");
            lazyDiv.part.add("preloader");
            this.shadowRoot.appendChild(lazyDiv);
        }
    }
    initialize() {
        this.render();
    }
    connectedCallback() {
        this.initialize();
    }
}
// eslint-disable-next-line
const register = ()=>{
    if (typeof window === "undefined") return;
    if (!window.customElements.get("swiper-container")) window.customElements.define("swiper-container", SwiperContainer);
    if (!window.customElements.get("swiper-slide")) window.customElements.define("swiper-slide", SwiperSlide);
};
if (typeof window !== "undefined") window.SwiperElementRegisterParams = (params)=>{
    (0, _updateSwiperMjs.p).push(...params);
};

},{"./swiper-bundle.mjs":"3lgMU","./shared/update-swiper.mjs":"k1Jbu","./shared/get-element-params.mjs":"ko9vw","./shared/swiper-core.mjs":"9iUsU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3lgMU":[function(require,module,exports) {
/**
 * Swiper 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", ()=>(0, _swiperCoreMjs.S));
parcelHelpers.export(exports, "default", ()=>(0, _swiperCoreMjs.S));
var _swiperCoreMjs = require("./shared/swiper-core.mjs");
var _virtualMjs = require("./modules/virtual.mjs");
var _virtualMjsDefault = parcelHelpers.interopDefault(_virtualMjs);
var _keyboardMjs = require("./modules/keyboard.mjs");
var _keyboardMjsDefault = parcelHelpers.interopDefault(_keyboardMjs);
var _mousewheelMjs = require("./modules/mousewheel.mjs");
var _mousewheelMjsDefault = parcelHelpers.interopDefault(_mousewheelMjs);
var _navigationMjs = require("./modules/navigation.mjs");
var _navigationMjsDefault = parcelHelpers.interopDefault(_navigationMjs);
var _paginationMjs = require("./modules/pagination.mjs");
var _paginationMjsDefault = parcelHelpers.interopDefault(_paginationMjs);
var _scrollbarMjs = require("./modules/scrollbar.mjs");
var _scrollbarMjsDefault = parcelHelpers.interopDefault(_scrollbarMjs);
var _parallaxMjs = require("./modules/parallax.mjs");
var _parallaxMjsDefault = parcelHelpers.interopDefault(_parallaxMjs);
var _zoomMjs = require("./modules/zoom.mjs");
var _zoomMjsDefault = parcelHelpers.interopDefault(_zoomMjs);
var _controllerMjs = require("./modules/controller.mjs");
var _controllerMjsDefault = parcelHelpers.interopDefault(_controllerMjs);
var _a11YMjs = require("./modules/a11y.mjs");
var _a11YMjsDefault = parcelHelpers.interopDefault(_a11YMjs);
var _historyMjs = require("./modules/history.mjs");
var _historyMjsDefault = parcelHelpers.interopDefault(_historyMjs);
var _hashNavigationMjs = require("./modules/hash-navigation.mjs");
var _hashNavigationMjsDefault = parcelHelpers.interopDefault(_hashNavigationMjs);
var _autoplayMjs = require("./modules/autoplay.mjs");
var _autoplayMjsDefault = parcelHelpers.interopDefault(_autoplayMjs);
var _thumbsMjs = require("./modules/thumbs.mjs");
var _thumbsMjsDefault = parcelHelpers.interopDefault(_thumbsMjs);
var _freeModeMjs = require("./modules/free-mode.mjs");
var _freeModeMjsDefault = parcelHelpers.interopDefault(_freeModeMjs);
var _gridMjs = require("./modules/grid.mjs");
var _gridMjsDefault = parcelHelpers.interopDefault(_gridMjs);
var _manipulationMjs = require("./modules/manipulation.mjs");
var _manipulationMjsDefault = parcelHelpers.interopDefault(_manipulationMjs);
var _effectFadeMjs = require("./modules/effect-fade.mjs");
var _effectFadeMjsDefault = parcelHelpers.interopDefault(_effectFadeMjs);
var _effectCubeMjs = require("./modules/effect-cube.mjs");
var _effectCubeMjsDefault = parcelHelpers.interopDefault(_effectCubeMjs);
var _effectFlipMjs = require("./modules/effect-flip.mjs");
var _effectFlipMjsDefault = parcelHelpers.interopDefault(_effectFlipMjs);
var _effectCoverflowMjs = require("./modules/effect-coverflow.mjs");
var _effectCoverflowMjsDefault = parcelHelpers.interopDefault(_effectCoverflowMjs);
var _effectCreativeMjs = require("./modules/effect-creative.mjs");
var _effectCreativeMjsDefault = parcelHelpers.interopDefault(_effectCreativeMjs);
var _effectCardsMjs = require("./modules/effect-cards.mjs");
var _effectCardsMjsDefault = parcelHelpers.interopDefault(_effectCardsMjs);
// Swiper Class
const modules = [
    (0, _virtualMjsDefault.default),
    (0, _keyboardMjsDefault.default),
    (0, _mousewheelMjsDefault.default),
    (0, _navigationMjsDefault.default),
    (0, _paginationMjsDefault.default),
    (0, _scrollbarMjsDefault.default),
    (0, _parallaxMjsDefault.default),
    (0, _zoomMjsDefault.default),
    (0, _controllerMjsDefault.default),
    (0, _a11YMjsDefault.default),
    (0, _historyMjsDefault.default),
    (0, _hashNavigationMjsDefault.default),
    (0, _autoplayMjsDefault.default),
    (0, _thumbsMjsDefault.default),
    (0, _freeModeMjsDefault.default),
    (0, _gridMjsDefault.default),
    (0, _manipulationMjsDefault.default),
    (0, _effectFadeMjsDefault.default),
    (0, _effectCubeMjsDefault.default),
    (0, _effectFlipMjsDefault.default),
    (0, _effectCoverflowMjsDefault.default),
    (0, _effectCreativeMjsDefault.default),
    (0, _effectCardsMjsDefault.default)
];
(0, _swiperCoreMjs.S).use(modules);

},{"./shared/swiper-core.mjs":"9iUsU","./modules/virtual.mjs":"1cIZH","./modules/keyboard.mjs":"2pWor","./modules/mousewheel.mjs":"7JLyi","./modules/navigation.mjs":"9TPAR","./modules/pagination.mjs":"iTrDD","./modules/scrollbar.mjs":"5KChF","./modules/parallax.mjs":"j22GN","./modules/zoom.mjs":"i6IpZ","./modules/controller.mjs":"26yye","./modules/a11y.mjs":"3poTr","./modules/history.mjs":"k3hGm","./modules/hash-navigation.mjs":"2QOuG","./modules/autoplay.mjs":"fe70X","./modules/thumbs.mjs":"e1cnx","./modules/free-mode.mjs":"2QbZl","./modules/grid.mjs":"k7fg0","./modules/manipulation.mjs":"7uSlt","./modules/effect-fade.mjs":"e0vbB","./modules/effect-cube.mjs":"llGQG","./modules/effect-flip.mjs":"eBZ0G","./modules/effect-coverflow.mjs":"czyz8","./modules/effect-creative.mjs":"9ZzGI","./modules/effect-cards.mjs":"bmh2v","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9iUsU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Swiper);
parcelHelpers.export(exports, "d", ()=>defaults);
var _ssrWindowEsmMjs = require("./ssr-window.esm.mjs");
var _utilsMjs = require("./utils.mjs");
let support;
function calcSupport() {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const document1 = (0, _ssrWindowEsmMjs.g)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function getSupport() {
    if (!support) support = calcSupport();
    return support;
}
let deviceCached;
function calcDevice(_temp) {
    let { userAgent } = _temp === void 0 ? {} : _temp;
    const support = getSupport();
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!deviceCached) deviceCached = calcDevice(overrides);
    return deviceCached;
}
let browser;
function calcBrowser() {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const device = getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix,
        need3dFix,
        isWebView
    };
}
function getBrowser() {
    if (!browser) browser = calcBrowser();
    return browser;
}
function Resize(_ref) {
    let { swiper, on, emit } = _ref;
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width, height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize, contentRect, target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function Observer(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const observers = [];
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, _utilsMjs.a)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, _utilsMjs.o)(el, "padding-left") || 0, 10) - parseInt((0, _utilsMjs.o)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, _utilsMjs.o)(el, "padding-top") || 0, 10) - parseInt((0, _utilsMjs.o)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height
    });
}
function updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl, slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, _utilsMjs.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, _utilsMjs.o)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, _utilsMjs.f)(slide, "width", true) : (0, _utilsMjs.f)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth, offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, _utilsMjs.s)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides, rtlTranslate: rtl, snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        if (isFullyVisible) slides[i].classList.add(params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress, isBeginning, isEnd, progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress,
        progressLoop,
        isBeginning,
        isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
const toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function updateSlidesClasses() {
    const swiper = this;
    const { slides, params, slidesEl, activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        nextSlide = slides.filter((slideEl)=>slideEl.column === activeIndex + 1)[0];
        prevSlide = slides.filter((slideEl)=>slideEl.column === activeIndex - 1)[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, _utilsMjs.p)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, _utilsMjs.q)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) unlazy(swiper, i);
    }
};
function getActiveIndexByTranslate(swiper) {
    const { slidesGrid, params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex,
        snapIndex,
        previousRealIndex,
        realIndex,
        previousIndex,
        activeIndex
    });
    if (swiper.initialized) preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var update = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide
};
function getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params, rtlTranslate: rtl, translate, wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, _utilsMjs.j)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params, wrapperEl, progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
    return -this.snapGrid[0];
}
function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params, wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsMjs.r)({
                    swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo
};
function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function transitionEmit(_ref) {
    let { swiper, runCallbacks, direction, step } = _ref;
    const { activeIndex, previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: "Start"
    });
}
function transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: "End"
    });
}
var transition = {
    setTransition,
    transitionStart,
    transitionEnd
};
function slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl, enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsMjs.r)({
                    swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled, params, animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params, snapGrid, slidesGrid, rtlTranslate, enabled, animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params, slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, _utilsMjs.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, _utilsMjs.n)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, _utilsMjs.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, _utilsMjs.n)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var slide = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide
};
function loopCreate(slideRealIndex) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, _utilsMjs.c)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, _utilsMjs.c)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, _utilsMjs.t)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, _utilsMjs.t)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function loopFix(_temp) {
    let { slideRealIndex, slideTo = true, direction, setTranslate, activeSlideIndex, byController, byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides, allowSlidePrev, allowSlideNext, slidesEl, params } = swiper;
    const { centeredSlides } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, _utilsMjs.t)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, _utilsMjs.t)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex,
            direction,
            setTranslate,
            activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function loopDestroy() {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
    loopCreate,
    loopFix,
    loopDestroy
};
function setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var grabCursor = {
    setGrabCursor,
    unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, _ssrWindowEsmMjs.g)() || el === (0, _ssrWindowEsmMjs.a)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const { params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function onTouchStart(event) {
    const swiper = this;
    const document1 = (0, _ssrWindowEsmMjs.g)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params, touches, enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, _utilsMjs.d)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function onTouchMove(event) {
    const document1 = (0, _ssrWindowEsmMjs.g)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params, touches, rtlTranslate: rtl, enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, _utilsMjs.d)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params, touches, rtlTranslate: rtl, slidesGrid, enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, _utilsMjs.d)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, _utilsMjs.d)();
    (0, _utilsMjs.n)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function onResize() {
    const swiper = this;
    const { params, el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function onScroll() {
    const swiper = this;
    const { wrapperEl, rtlTranslate, enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function onLoad(e) {
    const swiper = this;
    processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const events = (swiper, method)=>{
    const document1 = (0, _ssrWindowEsmMjs.g)();
    const { params, el, wrapperEl, device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    else swiper[swiperMethod]("observerUpdate", onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function attachEvents() {
    const swiper = this;
    const { params } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = onScroll.bind(swiper);
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, "on");
}
function detachEvents() {
    const swiper = this;
    events(swiper, "off");
}
var events$1 = {
    attachEvents,
    detachEvents
};
const isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
    const swiper = this;
    const { realIndex, initialized, params, el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, _utilsMjs.u)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value,
                point
            };
        }
        return {
            value: point,
            point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point, value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var breakpoints = {
    setBreakpoint,
    getBreakpoint
};
function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function addClasses() {
    const swiper = this;
    const { classNames, params, rtl, el, device } = swiper;
    // prettier-ignore
    const suffixes = prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function removeClasses() {
    const swiper = this;
    const { el, classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var classes = {
    addClasses,
    removeClasses
};
function checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params } = swiper;
    const { slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var checkOverflow$1 = {
    checkOverflow
};
var defaults = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, _utilsMjs.u)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, _utilsMjs.u)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, _utilsMjs.u)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const prototypes = {
    eventsEmitter,
    update,
    translate,
    transition,
    slide,
    loop,
    grabCursor,
    events: events$1,
    breakpoints,
    checkOverflow: checkOverflow$1,
    classes
};
const extendedDefaults = {};
class Swiper {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, _utilsMjs.u)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, _ssrWindowEsmMjs.g)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, _utilsMjs.u)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params,
                swiper,
                extendParams: moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, _utilsMjs.u)({}, defaults, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, _utilsMjs.u)({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = (0, _utilsMjs.u)({}, swiper.params);
        swiper.passedParams = (0, _utilsMjs.u)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl, params } = this;
        const slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, _utilsMjs.h)(slides[0]);
        return (0, _utilsMjs.h)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl, params } = swiper;
        swiper.slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl,
                classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params, slides, slidesGrid, slidesSizesGrid, size: swiperSize, activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid, params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, _utilsMjs.e)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, _utilsMjs.c)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, _utilsMjs.e)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el,
            wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, _utilsMjs.o)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, _utilsMjs.o)(el, "direction") === "rtl"),
            wrongRTL: (0, _utilsMjs.o)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                processLazyPreloader(swiper, e.target);
            });
        });
        preload(swiper);
        // Init Flag
        swiper.initialized = true;
        preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params, el, wrapperEl, slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, _utilsMjs.v)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, _utilsMjs.u)(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return extendedDefaults;
    }
    static get defaults() {
        return defaults;
    }
    static installModule(mod) {
        if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>Swiper.installModule(m));
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    }
}
Object.keys(prototypes).forEach((prototypeGroup)=>{
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod)=>{
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
});
Swiper.use([
    Resize,
    Observer
]);

},{"./ssr-window.esm.mjs":"lL7gq","./utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lL7gq":[function(require,module,exports) {
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>getWindow);
parcelHelpers.export(exports, "g", ()=>getDocument);
function isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) extend(target[key], src[key]);
    });
}
const ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function getDocument() {
    const doc = typeof document !== "undefined" ? document : {};
    extend(doc, ssrDocument);
    return doc;
}
const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function getWindow() {
    const win = typeof window !== "undefined" ? window : {};
    extend(win, ssrWindow);
    return win;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hqfDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>elementParents);
parcelHelpers.export(exports, "b", ()=>elementOffset);
parcelHelpers.export(exports, "c", ()=>createElement);
parcelHelpers.export(exports, "d", ()=>now);
parcelHelpers.export(exports, "e", ()=>elementChildren);
parcelHelpers.export(exports, "f", ()=>elementOuterSize);
parcelHelpers.export(exports, "g", ()=>getSlideTransformEl);
parcelHelpers.export(exports, "h", ()=>elementIndex);
parcelHelpers.export(exports, "i", ()=>classesToTokens);
parcelHelpers.export(exports, "j", ()=>getTranslate);
parcelHelpers.export(exports, "k", ()=>elementTransitionEnd);
parcelHelpers.export(exports, "l", ()=>isObject);
parcelHelpers.export(exports, "m", ()=>makeElementsArray);
parcelHelpers.export(exports, "n", ()=>nextTick);
parcelHelpers.export(exports, "o", ()=>elementStyle);
parcelHelpers.export(exports, "p", ()=>elementNextAll);
parcelHelpers.export(exports, "q", ()=>elementPrevAll);
parcelHelpers.export(exports, "r", ()=>animateCSSModeScroll);
parcelHelpers.export(exports, "s", ()=>setCSSProperty);
parcelHelpers.export(exports, "t", ()=>showWarning);
parcelHelpers.export(exports, "u", ()=>extend);
parcelHelpers.export(exports, "v", ()=>deleteProps);
var _ssrWindowEsmMjs = require("./ssr-window.esm.mjs");
function classesToTokens(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function nextTick(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function now() {
    return Date.now();
}
function getComputedStyle(el) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function getTranslate(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, _ssrWindowEsmMjs.a)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function isObject(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
    let { swiper, targetPosition, side } = _ref;
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function getSlideTransformEl(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function elementChildren(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function showWarning(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function createElement(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : classesToTokens(classes));
    return el;
}
function elementOffset(el) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    const document1 = (0, _ssrWindowEsmMjs.g)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function elementPrevAll(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function elementNextAll(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function elementStyle(el, prop) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function elementParents(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function elementTransitionEnd(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function elementOuterSize(el, size, includeMargins) {
    const window1 = (0, _ssrWindowEsmMjs.a)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function makeElementsArray(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}

},{"./ssr-window.esm.mjs":"lL7gq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1cIZH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Virtual);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Virtual(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, _ssrWindowEsmMjs.g)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, _utilsMjs.c)("swiper-slide");
        else slideEl = (0, _utilsMjs.c)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit) {
        const { slidesPerView, slidesPerGroup, centeredSlides, loop: isLoop, initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from,
            to,
            offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore,
            slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset,
                from,
                to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, _utilsMjs.e)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, _utilsMjs.s)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide,
        prependSlide,
        removeSlide,
        removeAllSlides,
        update
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2pWor":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Keyboard);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint-disable consistent-return */ function Keyboard(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const document = (0, _ssrWindowEsmMjs.g)();
    const window = (0, _ssrWindowEsmMjs.a)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, _utilsMjs.a)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, _utilsMjs.a)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, _utilsMjs.b)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable,
        disable
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7JLyi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Mousewheel);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint-disable consistent-return */ function Mousewheel(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, _utilsMjs.d)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, _utilsMjs.d)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, _utilsMjs.d)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, _utilsMjs.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, _utilsMjs.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, _utilsMjs.n)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, _utilsMjs.n)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable,
        disable
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9TPAR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Navigation(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl, prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl,
            prevEl
        });
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl, prevEl } = swiper.navigation;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl, prevEl } = swiper.navigation;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl, prevEl } = swiper.navigation;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable,
        disable,
        update,
        init,
        destroy
    });
}

},{"../shared/create-element-if-not-defined.mjs":"bsonl","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bsonl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>createElementIfNotDefined);
var _utilsMjs = require("./utils.mjs");
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, _utilsMjs.e)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, _utilsMjs.c)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

},{"./utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iTrDD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Pagination);
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Pagination(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, _utilsMjs.h)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, _utilsMjs.m)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, _utilsMjs.f)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, _utilsMjs.h)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, _utilsMjs.m)(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, _utilsMjs.a)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el
        });
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el } = swiper.pagination;
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el } = swiper.pagination;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = (0, _utilsMjs.m)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el } = swiper.pagination;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el } = swiper.pagination;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable,
        disable,
        render,
        update,
        init,
        destroy
    });
}

},{"../shared/classes-to-selector.mjs":"jVi6m","../shared/create-element-if-not-defined.mjs":"bsonl","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jVi6m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>classesToSelector);
function classesToSelector(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5KChF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Scrollbar);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
function Scrollbar(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const document = (0, _ssrWindowEsmMjs.g)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl, el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar } = swiper;
        const { dragEl, el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, _utilsMjs.b)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, wrapperEl } = swiper;
        const { el, dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar, wrapperEl } = swiper;
        const { el, dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, wrapperEl } = swiper;
        const { el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, _utilsMjs.n)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar, params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, _classesToSelectorMjs.c)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, _utilsMjs.c)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el,
            dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, _utilsMjs.i)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, _utilsMjs.i)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("changeDirection", ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el } = swiper.scrollbar;
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, _utilsMjs.i)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable,
        disable,
        updateSize,
        setTranslate,
        init,
        destroy
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","../shared/create-element-if-not-defined.mjs":"bsonl","../shared/classes-to-selector.mjs":"jVi6m","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j22GN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Parallax);
var _utilsMjs = require("../shared/utils.mjs");
function Parallax(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el, slides, progress, snapGrid, isElement } = swiper;
        const elements = (0, _utilsMjs.e)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, _utilsMjs.e)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el, hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

},{"../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i6IpZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Zoom);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Zoom(_ref) {
    let { swiper, extendParams, on, emit } = _ref;
    const window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, _utilsMjs.j)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, _utilsMjs.j)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) {
            allowTouchMove();
            return;
        }
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX, originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, _utilsMjs.b)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, _utilsMjs.b)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener,
            activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable,
        disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"26yye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Controller);
var _utilsMjs = require("../shared/utils.mjs");
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function Controller(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, _utilsMjs.n)(()=>{
                    c.updateAutoHeight();
                });
                (0, _utilsMjs.k)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                const onControllerSwiper = (e)=>{
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate,
        setTransition
    });
}

},{"../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3poTr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>A11y);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function A11y(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, _utilsMjs.m)(swiper.navigation.prevEl);
            const nextEls = (0, _utilsMjs.m)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl, prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, _utilsMjs.h)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl, prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, _utilsMjs.m)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, _ssrWindowEsmMjs.g)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl, prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, _utilsMjs.m)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        const document = (0, _ssrWindowEsmMjs.g)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, _utilsMjs.c)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/classes-to-selector.mjs":"jVi6m","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k3hGm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>History);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
function History(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key,
            value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value
        }, null, value);
        else window.history.pushState({
            value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, _ssrWindowEsmMjs.a)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2QOuG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HashNavigation);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function HashNavigation(_ref) {
    let { swiper, extendParams, emit, on } = _ref;
    let initialized = false;
    const document = (0, _ssrWindowEsmMjs.g)();
    const window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fe70X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Autoplay);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function Autoplay(_ref) {
    let { swiper, extendParams, on, emit, params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, _ssrWindowEsmMjs.g)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    const attachDocumentEvents = ()=>{
        const document = (0, _ssrWindowEsmMjs.g)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, _ssrWindowEsmMjs.g)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start,
        stop,
        pause,
        resume
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e1cnx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Thumb);
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Thumb(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, _utilsMjs.l)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, _utilsMjs.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, _ssrWindowEsmMjs.g)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init,
        update
    });
}

},{"../shared/ssr-window.esm.mjs":"lL7gq","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2QbZl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>freeMode);
var _utilsMjs = require("../shared/utils.mjs");
function freeMode(_ref) {
    let { swiper, extendParams, emit, once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, _utilsMjs.d)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params, wrapperEl, rtlTranslate: rtl, snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, _utilsMjs.d)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, _utilsMjs.d)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, _utilsMjs.k)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, _utilsMjs.k)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, _utilsMjs.k)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart,
            onTouchMove,
            onTouchEnd
        }
    });
}

},{"../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k7fg0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Grid);
function Grid(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView } = swiper.params;
        const { rows, fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows, fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides, roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params, el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides,
        unsetSlides,
        updateSlide,
        updateWrapperSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7uSlt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Manipulation);
function appendSlide(slides) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function prependSlide(slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function addSlide(index, slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function removeSlide(slidesIndexes) {
    const swiper = this;
    const { params, activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function Manipulation(_ref) {
    let { swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: appendSlide.bind(swiper),
        prependSlide: prependSlide.bind(swiper),
        addSlide: addSlide.bind(swiper),
        removeSlide: removeSlide.bind(swiper),
        removeAllSlides: removeAllSlides.bind(swiper)
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e0vbB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectFade);
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectFade(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements,
            allSlides: true
        });
    };
    (0, _effectInitMjs.e)({
        effect: "fade",
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/effect-init.mjs":"iBdNE","../shared/effect-target.mjs":"25IM0","../shared/effect-virtual-transition-end.mjs":"bmIAW","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iBdNE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", ()=>effectInit);
function effectInit(params) {
    const { effect, swiper, on, setTranslate, setTransition, overwriteParams, perspective, recreateShadows, getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"25IM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", ()=>effectTarget);
var _utilsMjs = require("./utils.mjs");
function effectTarget(effectParams, slideEl) {
    const transformEl = (0, _utilsMjs.g)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}

},{"./utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bmIAW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", ()=>effectVirtualTransitionEnd);
var _utilsMjs = require("./utils.mjs");
function effectVirtualTransitionEnd(_ref) {
    let { swiper, duration, transformElements, allSlides } = _ref;
    const { activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, _utilsMjs.k)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}

},{"./utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"llGQG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCube);
var _effectInitMjs = require("../shared/effect-init.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCube(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, _utilsMjs.c)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, _utilsMjs.c)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el, wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, _utilsMjs.c)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, _utilsMjs.c)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
                if (swiper.browser && swiper.browser.need3dFix && Math.abs(wrapperRotate) / 90 % 2 === 1) wrapperRotate += 0.001;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el, slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, _effectInitMjs.e)({
        effect: "cube",
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

},{"../shared/effect-init.mjs":"iBdNE","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eBZ0G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectFlip);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectFlip(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, _createShadowMjs.c)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, _createShadowMjs.c)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            if (swiper.browser && swiper.browser.need3dFix) {
                if (Math.abs(rotateY) / 90 % 2 === 1) rotateY += 0.001;
                if (Math.abs(rotateX) / 90 % 2 === 1) rotateX += 0.001;
            }
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements
        });
    };
    (0, _effectInitMjs.e)({
        effect: "flip",
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/create-shadow.mjs":"6zjQH","../shared/effect-init.mjs":"iBdNE","../shared/effect-target.mjs":"25IM0","../shared/effect-virtual-transition-end.mjs":"bmIAW","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6zjQH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>createShadow);
var _utilsMjs = require("./utils.mjs");
function createShadow(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, _utilsMjs.g)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, _utilsMjs.c)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}

},{"./utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"czyz8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCoverflow);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCoverflow(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides, slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            if (swiper.browser && swiper.browser.need3dFix) {
                if (Math.abs(rotateY) / 90 % 2 === 1) rotateY += 0.001;
                if (Math.abs(rotateX) / 90 % 2 === 1) rotateX += 0.001;
            }
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, _createShadowMjs.c)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, _createShadowMjs.c)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, _effectInitMjs.e)({
        effect: "coverflow",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

},{"../shared/create-shadow.mjs":"6zjQH","../shared/effect-init.mjs":"iBdNE","../shared/effect-target.mjs":"25IM0","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9ZzGI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCreative);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCreative(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides, wrapperEl, slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                if (swiper.browser && swiper.browser.need3dFix && Math.abs(val) / 90 % 2 === 1) val += 0.001;
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, _createShadowMjs.c)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements,
            allSlides: true
        });
    };
    (0, _effectInitMjs.e)({
        effect: "creative",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/create-shadow.mjs":"6zjQH","../shared/effect-init.mjs":"iBdNE","../shared/effect-target.mjs":"25IM0","../shared/effect-virtual-transition-end.mjs":"bmIAW","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bmh2v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCards);
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCards(_ref) {
    let { swiper, extendParams, on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides, activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate, isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, _createShadowMjs.c)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, _utilsMjs.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper,
            duration,
            transformElements
        });
    };
    (0, _effectInitMjs.e)({
        effect: "cards",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../shared/create-shadow.mjs":"6zjQH","../shared/effect-init.mjs":"iBdNE","../shared/effect-target.mjs":"25IM0","../shared/effect-virtual-transition-end.mjs":"bmIAW","../shared/utils.mjs":"hqfDh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k1Jbu":[function(require,module,exports) {
/* underscore in name -> watch for changes */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>needsPagination);
parcelHelpers.export(exports, "b", ()=>needsScrollbar);
parcelHelpers.export(exports, "c", ()=>attrToProp);
parcelHelpers.export(exports, "d", ()=>uniqueClasses);
parcelHelpers.export(exports, "e", ()=>extend);
parcelHelpers.export(exports, "i", ()=>isObject);
parcelHelpers.export(exports, "n", ()=>needsNavigation);
parcelHelpers.export(exports, "p", ()=>paramsList);
parcelHelpers.export(exports, "u", ()=>updateSwiper);
parcelHelpers.export(exports, "w", ()=>wrapperClass);
const paramsList = [
    "eventsPrefix",
    "injectStyles",
    "injectStylesUrls",
    "modules",
    "init",
    "_direction",
    "oneWayMovement",
    "swiperElementNodeName",
    "touchEventsTarget",
    "initialSlide",
    "_speed",
    "cssMode",
    "updateOnWindowResize",
    "resizeObserver",
    "nested",
    "focusableElements",
    "_enabled",
    "_width",
    "_height",
    "preventInteractionOnTransition",
    "userAgent",
    "url",
    "_edgeSwipeDetection",
    "_edgeSwipeThreshold",
    "_freeMode",
    "_autoHeight",
    "setWrapperSize",
    "virtualTranslate",
    "_effect",
    "breakpoints",
    "breakpointsBase",
    "_spaceBetween",
    "_slidesPerView",
    "maxBackfaceHiddenSlides",
    "_grid",
    "_slidesPerGroup",
    "_slidesPerGroupSkip",
    "_slidesPerGroupAuto",
    "_centeredSlides",
    "_centeredSlidesBounds",
    "_slidesOffsetBefore",
    "_slidesOffsetAfter",
    "normalizeSlideIndex",
    "_centerInsufficientSlides",
    "_watchOverflow",
    "roundLengths",
    "touchRatio",
    "touchAngle",
    "simulateTouch",
    "_shortSwipes",
    "_longSwipes",
    "longSwipesRatio",
    "longSwipesMs",
    "_followFinger",
    "allowTouchMove",
    "_threshold",
    "touchMoveStopPropagation",
    "touchStartPreventDefault",
    "touchStartForcePreventDefault",
    "touchReleaseOnEdges",
    "uniqueNavElements",
    "_resistance",
    "_resistanceRatio",
    "_watchSlidesProgress",
    "_grabCursor",
    "preventClicks",
    "preventClicksPropagation",
    "_slideToClickedSlide",
    "_loop",
    "loopAdditionalSlides",
    "loopAddBlankSlides",
    "loopPreventsSliding",
    "_rewind",
    "_allowSlidePrev",
    "_allowSlideNext",
    "_swipeHandler",
    "_noSwiping",
    "noSwipingClass",
    "noSwipingSelector",
    "passiveListeners",
    "containerModifierClass",
    "slideClass",
    "slideActiveClass",
    "slideVisibleClass",
    "slideFullyVisibleClass",
    "slideNextClass",
    "slidePrevClass",
    "slideBlankClass",
    "wrapperClass",
    "lazyPreloaderClass",
    "lazyPreloadPrevNext",
    "runCallbacksOnInit",
    "observer",
    "observeParents",
    "observeSlideChildren",
    // modules
    "a11y",
    "_autoplay",
    "_controller",
    "coverflowEffect",
    "cubeEffect",
    "fadeEffect",
    "flipEffect",
    "creativeEffect",
    "cardsEffect",
    "hashNavigation",
    "history",
    "keyboard",
    "mousewheel",
    "_navigation",
    "_pagination",
    "parallax",
    "_scrollbar",
    "_thumbs",
    "virtual",
    "zoom",
    "control"
];
function isObject(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object" && !o.__swiper__;
}
function extend(target, src) {
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
            if (src[key].__swiper__) target[key] = src[key];
            else extend(target[key], src[key]);
        } else target[key] = src[key];
    });
}
function needsNavigation(params) {
    if (params === void 0) params = {};
    return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function needsPagination(params) {
    if (params === void 0) params = {};
    return params.pagination && typeof params.pagination.el === "undefined";
}
function needsScrollbar(params) {
    if (params === void 0) params = {};
    return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function uniqueClasses(classNames) {
    if (classNames === void 0) classNames = "";
    const classes = classNames.split(" ").map((c)=>c.trim()).filter((c)=>!!c);
    const unique = [];
    classes.forEach((c)=>{
        if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(" ");
}
function attrToProp(attrName) {
    if (attrName === void 0) attrName = "";
    return attrName.replace(/-[a-z]/g, (l)=>l.toUpperCase().replace("-", ""));
}
function wrapperClass(className) {
    if (className === void 0) className = "";
    if (!className) return "swiper-wrapper";
    if (!className.includes("swiper-wrapper")) return `swiper-wrapper ${className}`;
    return className;
}
function updateSwiper(_ref) {
    let { swiper, slides, passedParams, changedParams, nextEl, prevEl, scrollbarEl, paginationEl } = _ref;
    const updateParams = changedParams.filter((key)=>key !== "children" && key !== "direction" && key !== "wrapperClass");
    const { params: currentParams, pagination, navigation, scrollbar, virtual, thumbs } = swiper;
    let needThumbsInit;
    let needControllerInit;
    let needPaginationInit;
    let needScrollbarInit;
    let needNavigationInit;
    let loopNeedDestroy;
    let loopNeedEnable;
    let loopNeedReloop;
    if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) needThumbsInit = true;
    if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) needControllerInit = true;
    if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) needPaginationInit = true;
    if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) needScrollbarInit = true;
    if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) needNavigationInit = true;
    const destroyModule = (mod)=>{
        if (!swiper[mod]) return;
        swiper[mod].destroy();
        if (mod === "navigation") {
            if (swiper.isElement) {
                swiper[mod].prevEl.remove();
                swiper[mod].nextEl.remove();
            }
            currentParams[mod].prevEl = undefined;
            currentParams[mod].nextEl = undefined;
            swiper[mod].prevEl = undefined;
            swiper[mod].nextEl = undefined;
        } else {
            if (swiper.isElement) swiper[mod].el.remove();
            currentParams[mod].el = undefined;
            swiper[mod].el = undefined;
        }
    };
    if (changedParams.includes("loop") && swiper.isElement) {
        if (currentParams.loop && !passedParams.loop) loopNeedDestroy = true;
        else if (!currentParams.loop && passedParams.loop) loopNeedEnable = true;
        else loopNeedReloop = true;
    }
    updateParams.forEach((key)=>{
        if (isObject(currentParams[key]) && isObject(passedParams[key])) {
            Object.assign(currentParams[key], passedParams[key]);
            if ((key === "navigation" || key === "pagination" || key === "scrollbar") && "enabled" in passedParams[key] && !passedParams[key].enabled) destroyModule(key);
        } else {
            const newValue = passedParams[key];
            if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
                if (newValue === false) destroyModule(key);
            } else currentParams[key] = passedParams[key];
        }
    });
    if (updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) swiper.controller.control = currentParams.controller.control;
    if (changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled) {
        virtual.slides = slides;
        virtual.update(true);
    } else if (changedParams.includes("virtual") && virtual && currentParams.virtual.enabled) {
        if (slides) virtual.slides = slides;
        virtual.update(true);
    }
    if (changedParams.includes("children") && slides && currentParams.loop) loopNeedReloop = true;
    if (needThumbsInit) {
        const initialized = thumbs.init();
        if (initialized) thumbs.update(true);
    }
    if (needControllerInit) swiper.controller.control = currentParams.controller.control;
    if (needPaginationInit) {
        if (swiper.isElement && (!paginationEl || typeof paginationEl === "string")) {
            paginationEl = document.createElement("div");
            paginationEl.classList.add("swiper-pagination");
            paginationEl.part.add("pagination");
            swiper.el.appendChild(paginationEl);
        }
        if (paginationEl) currentParams.pagination.el = paginationEl;
        pagination.init();
        pagination.render();
        pagination.update();
    }
    if (needScrollbarInit) {
        if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === "string")) {
            scrollbarEl = document.createElement("div");
            scrollbarEl.classList.add("swiper-scrollbar");
            scrollbarEl.part.add("scrollbar");
            swiper.el.appendChild(scrollbarEl);
        }
        if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
        scrollbar.init();
        scrollbar.updateSize();
        scrollbar.setTranslate();
    }
    if (needNavigationInit) {
        if (swiper.isElement) {
            if (!nextEl || typeof nextEl === "string") {
                nextEl = document.createElement("div");
                nextEl.classList.add("swiper-button-next");
                nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
                nextEl.part.add("button-next");
                swiper.el.appendChild(nextEl);
            }
            if (!prevEl || typeof prevEl === "string") {
                prevEl = document.createElement("div");
                prevEl.classList.add("swiper-button-prev");
                prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
                prevEl.part.add("button-prev");
                swiper.el.appendChild(prevEl);
            }
        }
        if (nextEl) currentParams.navigation.nextEl = nextEl;
        if (prevEl) currentParams.navigation.prevEl = prevEl;
        navigation.init();
        navigation.update();
    }
    if (changedParams.includes("allowSlideNext")) swiper.allowSlideNext = passedParams.allowSlideNext;
    if (changedParams.includes("allowSlidePrev")) swiper.allowSlidePrev = passedParams.allowSlidePrev;
    if (changedParams.includes("direction")) swiper.changeDirection(passedParams.direction, false);
    if (loopNeedDestroy || loopNeedReloop) swiper.loopDestroy();
    if (loopNeedEnable || loopNeedReloop) swiper.loopCreate();
    swiper.update();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ko9vw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "g", ()=>getParams);
var _updateSwiperMjs = require("./update-swiper.mjs");
var _swiperCoreMjs = require("./swiper-core.mjs");
const formatValue = (val)=>{
    if (parseFloat(val) === Number(val)) return Number(val);
    if (val === "true") return true;
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "null") return null;
    if (val === "undefined") return undefined;
    if (typeof val === "string" && val.includes("{") && val.includes("}") && val.includes('"')) {
        let v;
        try {
            v = JSON.parse(val);
        } catch (err) {
            v = val;
        }
        return v;
    }
    return val;
};
const modulesParamsList = [
    "a11y",
    "autoplay",
    "controller",
    "cards-effect",
    "coverflow-effect",
    "creative-effect",
    "cube-effect",
    "fade-effect",
    "flip-effect",
    "free-mode",
    "grid",
    "hash-navigation",
    "history",
    "keyboard",
    "mousewheel",
    "navigation",
    "pagination",
    "parallax",
    "scrollbar",
    "thumbs",
    "virtual",
    "zoom"
];
function getParams(element, propName, propValue) {
    const params = {};
    const passedParams = {};
    (0, _updateSwiperMjs.e)(params, (0, _swiperCoreMjs.d));
    const localParamsList = [
        ...(0, _updateSwiperMjs.p),
        "on"
    ];
    const allowedParams = localParamsList.map((key)=>key.replace(/_/, ""));
    // First check props
    localParamsList.forEach((paramName)=>{
        paramName = paramName.replace("_", "");
        if (typeof element[paramName] !== "undefined") passedParams[paramName] = element[paramName];
    });
    // Attributes
    const attrsList = [
        ...element.attributes
    ];
    if (typeof propName === "string" && typeof propValue !== "undefined") attrsList.push({
        name: propName,
        value: (0, _updateSwiperMjs.i)(propValue) ? {
            ...propValue
        } : propValue
    });
    attrsList.forEach((attr)=>{
        const moduleParam = modulesParamsList.filter((mParam)=>attr.name.indexOf(`${mParam}-`) === 0)[0];
        if (moduleParam) {
            const parentObjName = (0, _updateSwiperMjs.c)(moduleParam);
            const subObjName = (0, _updateSwiperMjs.c)(attr.name.split(`${moduleParam}-`)[1]);
            if (typeof passedParams[parentObjName] === "undefined") passedParams[parentObjName] = {};
            if (passedParams[parentObjName] === true) passedParams[parentObjName] = {
                enabled: true
            };
            passedParams[parentObjName][subObjName] = formatValue(attr.value);
        } else {
            const name = (0, _updateSwiperMjs.c)(attr.name);
            if (!allowedParams.includes(name)) return;
            const value = formatValue(attr.value);
            if (passedParams[name] && modulesParamsList.includes(attr.name) && !(0, _updateSwiperMjs.i)(value)) {
                if (passedParams[name].constructor !== Object) passedParams[name] = {};
                passedParams[name].enabled = !!value;
            } else passedParams[name] = value;
        }
    });
    (0, _updateSwiperMjs.e)(params, passedParams);
    if (params.navigation) params.navigation = {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
        ...params.navigation !== true ? params.navigation : {}
    };
    else if (params.navigation === false) delete params.navigation;
    if (params.scrollbar) params.scrollbar = {
        el: ".swiper-scrollbar",
        ...params.scrollbar !== true ? params.scrollbar : {}
    };
    else if (params.scrollbar === false) delete params.scrollbar;
    if (params.pagination) params.pagination = {
        el: ".swiper-pagination",
        ...params.pagination !== true ? params.pagination : {}
    };
    else if (params.pagination === false) delete params.pagination;
    return {
        params,
        passedParams
    };
}

},{"./update-swiper.mjs":"k1Jbu","./swiper-core.mjs":"9iUsU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eCf5Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _homePage = require("./app/pages/HomePage");
var _runtimeBlocksPage = require("./app/pages/RuntimeBlocksPage");
var _runtimeTransactionsPage = require("./app/pages/RuntimeTransactionsPage");
var _runtimeTransactionDetailPage = require("./app/pages/RuntimeTransactionDetailPage");
var _paratimeDashboardPage = require("./app/pages/ParatimeDashboardPage");
var _runtimeBlockDetailPage = require("./app/pages/RuntimeBlockDetailPage");
var _runtimeAccountDetailsPage = require("./app/pages/RuntimeAccountDetailsPage");
var _accountTransactionsCard = require("./app/pages/RuntimeAccountDetailsPage/AccountTransactionsCard");
var _accountTokensCard = require("./app/pages/RuntimeAccountDetailsPage/AccountTokensCard");
var _searchResultsPage = require("./app/pages/SearchResultsPage");
var _routeUtils = require("./app/utils/route-utils");
var _routingErrorPage = require("./app/pages/RoutingErrorPage");
var _themeByNetwork = require("./app/components/ThemeByNetwork");
var _useScopeParam = require("./app/hooks/useScopeParam");
var _tokensOverviewPage = require("./app/pages/TokensOverviewPage");
var _contractCodeCard = require("./app/pages/RuntimeAccountDetailsPage/ContractCodeCard");
var _tokenDashboardPage = require("./app/pages/TokenDashboardPage");
var _accountTokenTransfersCard = require("./app/pages/RuntimeAccountDetailsPage/AccountTokenTransfersCard");
var _accountNFTCollectionCard = require("./app/pages/RuntimeAccountDetailsPage/AccountNFTCollectionCard");
var _tokenTransfersCard = require("./app/pages/TokenDashboardPage/TokenTransfersCard");
var _tokenHoldersCard = require("./app/pages/TokenDashboardPage/TokenHoldersCard");
var _tokenInventoryCard = require("./app/pages/TokenDashboardPage/TokenInventoryCard");
var _nftinstanceDashboardPage = require("./app/pages/NFTInstanceDashboardPage");
var _nftmetadataCard = require("./app/pages/NFTInstanceDashboardPage/NFTMetadataCard");
var _nfttokenTransfersCard = require("./app/pages/NFTInstanceDashboardPage/NFTTokenTransfersCard");
var _consensusDashboardPage = require("app/pages/ConsensusDashboardPage");
var _validatorsPage = require("./app/pages/ValidatorsPage");
var _proposalsPage = require("./app/pages/ProposalsPage");
var _validatorDetailsPage = require("./app/pages/ValidatorDetailsPage");
var _hooks = require("./app/pages/ValidatorDetailsPage/hooks");
var _debondingDelegationsCard = require("./app/pages/ValidatorDetailsPage/DebondingDelegationsCard");
var _delegatorsCard = require("./app/pages/ValidatorDetailsPage/DelegatorsCard");
var _api = require("./oasis-nexus/api");
var _proposalDetailsPage = require("./app/pages/ProposalDetailsPage");
var _consensusBlocksPage = require("./app/pages/ConsensusBlocksPage");
var _consensusAccountsPage = require("./app/pages/ConsensusAccountsPage");
var _consensusTransactionsPage = require("./app/pages/ConsensusTransactionsPage");
var _consensusTransactionDetailPage = require("./app/pages/ConsensusTransactionDetailPage");
var _consensusAccountDetailsPage = require("./app/pages/ConsensusAccountDetailsPage");
var _hooks1 = require("./app/pages/ConsensusAccountDetailsPage/hooks");
var _consensusAccountTransactionsCard = require("./app/pages/ConsensusAccountDetailsPage/ConsensusAccountTransactionsCard");
var _react = require("react");
var _analyticsConsent = require("./app/components/AnalyticsConsent");
const NetworkSpecificPart = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeByNetwork.ThemeByNetwork), {
        isRootTheme: true,
        network: (0, _useScopeParam.useRequiredScopeParam)().network,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
    });
/**
 * In case of being restricted to a specific layer, jump to a dashboard
 *
 * This should be rendered on the landing page, since we don't want the opening graph.
 */ const RedirectToDashboard = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>navigate((0, _routeUtils.RouteUtils).getDashboardRoute({
            network: (0, _routeUtils.fixedNetwork) ?? (0, _routeUtils.RouteUtils).getEnabledNetworksForLayer((0, _routeUtils.fixedLayer))[0],
            layer: (0, _routeUtils.fixedLayer)
        })));
    return null;
};
const routes = [
    {
        errorElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsConsent.AnalyticsConsentProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routingErrorPage.RoutingErrorPage), {})
        }),
        element: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _analyticsConsent.AnalyticsConsentProvider), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.ScrollRestoration), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
            ]
        }),
        children: [
            {
                path: "/",
                element: (0, _routeUtils.fixedLayer) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(RedirectToDashboard, {}) : (0, _themeByNetwork.withDefaultTheme)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homePage.HomePage), {}), true)
            },
            ...!!(0, _routeUtils.fixedNetwork) && !!(0, _routeUtils.fixedLayer) ? [] : [
                {
                    path: "/search",
                    element: (0, _themeByNetwork.withDefaultTheme)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsPage.SearchResultsPage), {}))
                }
            ],
            {
                path: "/:_network/consensus",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NetworkSpecificPart, {}),
                errorElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routingErrorPage.RoutingErrorPage), {}),
                loader: async ({ params })=>{
                    return (0, _routeUtils.assertEnabledScope)({
                        network: params._network,
                        layer: (0, _api.Layer).consensus
                    });
                },
                id: "consensusScope",
                children: [
                    {
                        path: "",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusDashboardPage.ConsensusDashboardPage), {})
                    },
                    {
                        path: `address`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountsPage.ConsensusAccountsPage), {})
                    },
                    {
                        path: `address/:address`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountDetailsPage.ConsensusAccountDetailsPage), {}),
                        loader: (0, _routeUtils.consensusAddressParamLoader)(),
                        children: [
                            {
                                path: "",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountTransactionsCard.ConsensusAccountTransactionsCard), {
                                        ...(0, _hooks1.useConsensusAccountDetailsProps)()
                                    })
                            }
                        ]
                    },
                    {
                        path: `proposal`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalsPage.ProposalsPage), {})
                    },
                    {
                        path: `proposal/:proposalId`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalDetailsPage.ProposalDetailsPage), {}),
                        loader: (0, _routeUtils.proposalIdParamLoader)
                    },
                    {
                        path: `validators`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorsPage.ValidatorsPage), {})
                    },
                    {
                        path: `validators/:address`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorDetailsPage.ValidatorDetailsPage), {}),
                        loader: (0, _routeUtils.consensusAddressParamLoader)(),
                        children: [
                            {
                                path: "",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountTransactionsCard.ConsensusAccountTransactionsCard), {
                                        ...(0, _hooks.useValidatorDetailsProps)()
                                    })
                            },
                            {
                                path: "delegators",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _delegatorsCard.DelegatorsCard), {
                                        ...(0, _hooks.useValidatorDetailsProps)()
                                    })
                            },
                            {
                                path: "debonding-delegations",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _debondingDelegationsCard.DebondingDelegationsCard), {
                                        ...(0, _hooks.useValidatorDetailsProps)()
                                    })
                            }
                        ]
                    },
                    {
                        path: `block`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusBlocksPage.ConsensusBlocksPage), {})
                    },
                    {
                        path: "tx",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionsPage.ConsensusTransactionsPage), {})
                    },
                    {
                        path: `tx/:hash`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionDetailPage.ConsensusTransactionDetailPage), {}),
                        loader: (0, _routeUtils.consensusTransactionParamLoader)
                    }
                ]
            },
            {
                path: "/:_network/:_layer",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NetworkSpecificPart, {}),
                errorElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routingErrorPage.RoutingErrorPage), {}),
                loader: async ({ params })=>{
                    return (0, _routeUtils.assertEnabledScope)({
                        network: params._network,
                        layer: params._layer
                    });
                },
                id: "runtimeScope",
                children: [
                    {
                        path: "",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paratimeDashboardPage.ParatimeDashboardPage), {})
                    },
                    {
                        path: "search",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsPage.SearchResultsPage), {})
                    },
                    {
                        path: `block`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBlocksPage.RuntimeBlocksPage), {})
                    },
                    {
                        path: `block/:blockHeight`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBlockDetailPage.RuntimeBlockDetailPage), {}),
                        loader: (0, _routeUtils.blockHeightParamLoader)
                    },
                    {
                        path: `address/:address`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeAccountDetailsPage.RuntimeAccountDetailsPage), {}),
                        loader: (0, _routeUtils.runtimeAddressParamLoader)(),
                        children: [
                            {
                                path: "",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountTransactionsCard.AccountTransactionsCard), {
                                        ...(0, _runtimeAccountDetailsPage.useRuntimeAccountDetailsProps)()
                                    })
                            },
                            {
                                path: "token-transfers",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountTokenTransfersCard.AccountTokenTransfersCard), {
                                        ...(0, _runtimeAccountDetailsPage.useRuntimeAccountDetailsProps)()
                                    })
                            },
                            {
                                path: "tokens/erc-20",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountTokensCard.AccountTokensCard), {
                                        ...(0, _runtimeAccountDetailsPage.useRuntimeAccountDetailsProps)(),
                                        type: "ERC20"
                                    })
                            },
                            {
                                path: "tokens/erc-721",
                                children: [
                                    {
                                        path: "",
                                        Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountTokensCard.AccountTokensCard), {
                                                ...(0, _runtimeAccountDetailsPage.useRuntimeAccountDetailsProps)(),
                                                type: "ERC721"
                                            })
                                    },
                                    {
                                        path: ":contractAddress",
                                        Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountNFTCollectionCard.AccountNFTCollectionCard), {
                                                ...(0, _runtimeAccountDetailsPage.useRuntimeAccountDetailsProps)()
                                            }),
                                        loader: (0, _routeUtils.runtimeAddressParamLoader)("contractAddress")
                                    }
                                ]
                            },
                            {
                                path: "code",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractCodeCard.ContractCodeCard), {
                                        ...(0, _runtimeAccountDetailsPage.useRuntimeAccountDetailsProps)()
                                    })
                            }
                        ]
                    },
                    {
                        path: `tx`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionsPage.RuntimeTransactionsPage), {})
                    },
                    {
                        path: `tx/:hash`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionDetailPage.RuntimeTransactionDetailPage), {}),
                        loader: (0, _routeUtils.runtimeTransactionParamLoader)
                    },
                    {
                        path: `token`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokensOverviewPage.TokensPage), {})
                    },
                    {
                        path: "token/:address/instance/:instanceId",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nftinstanceDashboardPage.NFTInstanceDashboardPage), {}),
                        loader: (0, _routeUtils.runtimeAddressParamLoader)(),
                        children: [
                            {
                                path: "",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nfttokenTransfersCard.NFTTokenTransfersCard), {
                                        ...(0, _nftinstanceDashboardPage.useNftDetailsProps)()
                                    })
                            },
                            {
                                path: "metadata",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nftmetadataCard.NFTMetadataCard), {
                                        ...(0, _nftinstanceDashboardPage.useNftDetailsProps)()
                                    })
                            }
                        ]
                    },
                    {
                        path: `token/:address`,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDashboardPage.TokenDashboardPage), {}),
                        loader: (0, _routeUtils.runtimeAddressParamLoader)(),
                        children: [
                            {
                                path: "",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTransfersCard.TokenTransfersCard), {
                                        ...(0, _tokenDashboardPage.useTokenDashboardProps)()
                                    })
                            },
                            {
                                path: "holders",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenHoldersCard.TokenHoldersCard), {
                                        ...(0, _tokenDashboardPage.useTokenDashboardProps)()
                                    })
                            },
                            {
                                path: "inventory",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenInventoryCard.TokenInventoryCard), {
                                        ...(0, _tokenDashboardPage.useTokenDashboardProps)()
                                    })
                            },
                            {
                                path: "code",
                                Component: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractCodeCard.ContractCodeCard), {
                                        ...(0, _tokenDashboardPage.useTokenDashboardProps)()
                                    })
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","./app/pages/HomePage":"4aSsi","./app/pages/RuntimeBlocksPage":"dms5e","./app/pages/RuntimeTransactionsPage":"iDLqK","./app/pages/RuntimeTransactionDetailPage":"bZzL6","./app/pages/ParatimeDashboardPage":"5L8bX","./app/pages/RuntimeBlockDetailPage":"jWfMQ","./app/pages/RuntimeAccountDetailsPage":"94Czq","./app/pages/RuntimeAccountDetailsPage/AccountTransactionsCard":"3Ys4k","./app/pages/RuntimeAccountDetailsPage/AccountTokensCard":"iagXb","./app/pages/SearchResultsPage":"7myxv","./app/utils/route-utils":"b2kKi","./app/pages/RoutingErrorPage":"dYU3Z","./app/components/ThemeByNetwork":"4frPX","./app/hooks/useScopeParam":"kKMKx","./app/pages/TokensOverviewPage":"fj3RC","./app/pages/RuntimeAccountDetailsPage/ContractCodeCard":"ii2WJ","./app/pages/TokenDashboardPage":"kpoS5","./app/pages/RuntimeAccountDetailsPage/AccountTokenTransfersCard":"uJl44","./app/pages/RuntimeAccountDetailsPage/AccountNFTCollectionCard":"gDicp","./app/pages/TokenDashboardPage/TokenTransfersCard":"kCyMs","./app/pages/TokenDashboardPage/TokenHoldersCard":"76uS1","./app/pages/TokenDashboardPage/TokenInventoryCard":"8nPci","./app/pages/NFTInstanceDashboardPage":"ia541","./app/pages/NFTInstanceDashboardPage/NFTMetadataCard":"58s3H","./app/pages/NFTInstanceDashboardPage/NFTTokenTransfersCard":"8ZszI","app/pages/ConsensusDashboardPage":"2JtCh","./app/pages/ValidatorsPage":"gC0jq","./app/pages/ProposalsPage":"dn4i4","./app/pages/ValidatorDetailsPage":"2dV6P","./app/pages/ValidatorDetailsPage/hooks":"kDBzG","./app/pages/ValidatorDetailsPage/DebondingDelegationsCard":"g4WHj","./app/pages/ValidatorDetailsPage/DelegatorsCard":"34BOw","./oasis-nexus/api":"dJrPU","./app/pages/ProposalDetailsPage":"eO7IX","./app/pages/ConsensusBlocksPage":"9G5XG","./app/pages/ConsensusAccountsPage":"ffiOi","./app/pages/ConsensusTransactionsPage":"7Ptsx","./app/pages/ConsensusTransactionDetailPage":"hd24o","./app/pages/ConsensusAccountDetailsPage":"40iiU","./app/pages/ConsensusAccountDetailsPage/hooks":"bb6KB","./app/pages/ConsensusAccountDetailsPage/ConsensusAccountTransactionsCard":"dgrrQ","react":"BK2ob","./app/components/AnalyticsConsent":"kSiJ1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4aSsi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zIndexHomePage", ()=>zIndexHomePage);
parcelHelpers.export(exports, "HomePage", ()=>HomePage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _logotype = require("../../components/PageLayout/Logotype");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _backgroundSvg = require("./images/background.svg");
var _backgroundSvgDefault = parcelHelpers.interopDefault(_backgroundSvg);
var _colors = require("../../../styles/theme/colors");
var _search = require("../../components/Search");
var _paraTimeSelector = require("./Graph/ParaTimeSelector");
var _footer = require("../../components/PageLayout/Footer");
var _useScreensize = require("../../hooks/useScreensize");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _infoOutlined = require("@mui/icons-material/InfoOutlined");
var _infoOutlinedDefault = parcelHelpers.interopDefault(_infoOutlined);
var _reactI18Next = require("react-i18next");
var _types = require("./Graph/types");
var _buildBanner = require("../../components/BuildBanner");
var _useSearchQueryNetworkParam = require("../../hooks/useSearchQueryNetworkParam");
var _themeByNetwork = require("../../components/ThemeByNetwork");
var _offlineBanner = require("../../components/OfflineBanner");
var _hook = require("../../components/OfflineBanner/hook");
const zIndexHomePage = {
    paraTimeSelector: 1,
    searchInput: 2,
    logo: 3,
    mobileTooltip: 4
};
const HomepageLayout = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        maxWidth: "100%",
        height: "fill-available",
        minHeight: "100vh",
        backgroundColor: (0, _colors.COLORS).brandDark,
        overflowX: "hidden",
        [theme.breakpoints.up("sm")]: {
            height: "100vh",
            minHeight: "800px",
            "&::before": {
                content: '" "',
                position: "absolute",
                inset: 0,
                backgroundImage: `url("${0, _backgroundSvgDefault.default}")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }
        }
    }));
const Content = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        flex: "1 1 0",
        padding: `0 ${theme.spacing(4)}`,
        [theme.breakpoints.up("sm")]: {
            justifyContent: "flex-end"
        }
    }));
const LogotypeBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        zIndex: zIndexHomePage.logo,
        marginBottom: 40,
        textAlign: "center",
        marginTop: 60,
        [theme.breakpoints.up("sm")]: {
            marginBottom: 60,
            marginTop: "unset"
        }
    }));
const SearchInputContainer = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "transparent"
})(({ theme, transparent })=>({
        position: "relative",
        zIndex: zIndexHomePage.searchInput,
        width: "100%",
        [theme.breakpoints.up("md")]: {
            width: "auto",
            "&:not(:hover)": {
                ...transparent ? {
                    opacity: 0.5
                } : {}
            }
        }
    }));
const SearchInputBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        width: "100%",
        margin: "0 auto",
        [theme.breakpoints.up("sm")]: {
            width: "75vw"
        },
        [theme.breakpoints.up("md")]: {
            width: "50vw"
        }
    }));
const FooterStyled = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        width: "100%",
        flex: "0 0 0",
        padding: `0 ${theme.spacing(6)}`,
        [theme.breakpoints.up("md")]: {
            // needed to make footer elements clickable
            zIndex: zIndexHomePage.paraTimeSelector
        }
    }));
const InfoScreenBtn = (0, _styles.styled)((0, _iconButtonDefault.default))(({ theme })=>({
        position: "absolute",
        top: theme.spacing(6),
        zIndex: zIndexHomePage.paraTimeSelector
    }));
const HomePage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const infoAriaLabel = t("home.helpScreen.infoIconAria");
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { network } = (0, _useSearchQueryNetworkParam.useSearchQueryNetworkParam)();
    const isApiReachable = (0, _hook.useIsApiReachable)(network).reachable;
    const [searchHasFocus, setSearchHasFocus] = (0, _react.useState)(false);
    const [isGraphZoomedIn, setIsGraphZoomedIn] = (0, _react.useState)(false);
    const [step, setStep] = (0, _react.useState)(()=>{
        if (isMobile) return (0, _types.ParaTimeSelectorStep).EnableExplore;
        return (0, _types.ParaTimeSelectorStep).Explore;
    });
    const [showInfoScreen, setShowInfoScreen] = (0, _react.useState)(false);
    const onFocusChange = (hasFocus)=>{
        setSearchHasFocus(hasFocus);
    };
    const onToggleInfoScreenClick = ()=>{
        setStep((0, _types.ParaTimeSelectorStep).ShowHelpScreen);
        setShowInfoScreen(true);
    };
    const searchVariant = isMobile ? "icon" : "button";
    const showInfoScreenBtn = isMobile && step !== (0, _types.ParaTimeSelectorStep).ShowHelpScreen;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildBanner.BuildBanner), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offlineBanner.NetworkOfflineBanner), {
                wantedNetwork: network
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(HomepageLayout, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LogotypeBox, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logotype.Logotype), {
                                    showText: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SearchInputContainer, {
                                transparent: isGraphZoomedIn && !searchHasFocus,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchInputBox, {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _search.Search), {
                                            disabled: !isApiReachable,
                                            variant: searchVariant,
                                            onFocusChange: onFocusChange
                                        })
                                    }),
                                    showInfoScreenBtn && /*#__PURE__*/ (0, _jsxRuntime.jsx)(InfoScreenBtn, {
                                        "aria-label": infoAriaLabel,
                                        onClick: onToggleInfoScreenClick,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoOutlinedDefault.default), {
                                            fontSize: "medium",
                                            sx: {
                                                color: "white"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeByNetwork.ThemeByNetwork), {
                                isRootTheme: false,
                                network: network,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    sx: {
                                        zIndex: zIndexHomePage.paraTimeSelector
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeSelector.ParaTimeSelector), {
                                        step: step,
                                        setStep: setStep,
                                        disabled: searchHasFocus,
                                        showInfoScreen: showInfoScreen,
                                        graphZoomedIn: isGraphZoomedIn,
                                        onGraphZoomedIn: setIsGraphZoomedIn
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FooterStyled, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footer.Footer), {})
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","../../components/PageLayout/Logotype":"h3vde","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","./images/background.svg":"i0F34","../../../styles/theme/colors":"hYvW2","../../components/Search":"fVJkU","./Graph/ParaTimeSelector":"5wvKB","../../components/PageLayout/Footer":"9qROl","../../hooks/useScreensize":"2HEhN","@mui/material/IconButton":"hLmKV","@mui/icons-material/InfoOutlined":"kVA6h","react-i18next":"e210a","./Graph/types":"3zpNP","../../components/BuildBanner":"6VCEO","../../hooks/useSearchQueryNetworkParam":"2W1vT","../../components/ThemeByNetwork":"4frPX","../../components/OfflineBanner":"383jV","../../components/OfflineBanner/hook":"cKMsd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h3vde":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HomePageLink", ()=>HomePageLink);
parcelHelpers.export(exports, "Logotype", ()=>Logotype);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScreensize = require("../../hooks/useScreensize");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactRouterDom = require("react-router-dom");
var _oasisIcon = require("../CustomIcons/OasisIcon");
var _explorerIcon = require("../CustomIcons/ExplorerIcon");
const HomePageLink = ({ color, showText })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        "aria-label": t("home.link"),
        to: "/",
        component: (0, _reactRouterDom.Link),
        sx: {
            display: "inline-flex",
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Logotype, {
            color: color,
            showText: showText
        })
    });
};
const Logotype = ({ color, showText })=>{
    const theme = (0, _styles.useTheme)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const oasisLogoSize = isMobile ? 32 : 40;
    const logoSize = !showText ? {
        height: oasisLogoSize,
        width: oasisLogoSize
    } : {
        height: 40,
        width: 214
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            color: color || theme.palette.layout.main
        },
        children: !showText ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oasisIcon.OasisIcon), {
            sx: logoSize
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _explorerIcon.ExplorerIcon), {
            sx: logoSize
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../hooks/useScreensize":"2HEhN","@mui/material/Link":"fTbCF","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","react-router-dom":"5o0mA","../CustomIcons/OasisIcon":"dFBFD","../CustomIcons/ExplorerIcon":"9lcz2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e210a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trans", ()=>(0, _transJs.Trans));
parcelHelpers.export(exports, "TransWithoutContext", ()=>(0, _transWithoutContextJs.Trans));
parcelHelpers.export(exports, "useTranslation", ()=>(0, _useTranslationJs.useTranslation));
parcelHelpers.export(exports, "withTranslation", ()=>(0, _withTranslationJs.withTranslation));
parcelHelpers.export(exports, "Translation", ()=>(0, _translationJs.Translation));
parcelHelpers.export(exports, "I18nextProvider", ()=>(0, _i18NextProviderJs.I18nextProvider));
parcelHelpers.export(exports, "withSSR", ()=>(0, _withSSRJs.withSSR));
parcelHelpers.export(exports, "useSSR", ()=>(0, _useSSRJs.useSSR));
parcelHelpers.export(exports, "initReactI18next", ()=>(0, _initReactI18NextJs.initReactI18next));
parcelHelpers.export(exports, "setDefaults", ()=>(0, _defaultsJs.setDefaults));
parcelHelpers.export(exports, "getDefaults", ()=>(0, _defaultsJs.getDefaults));
parcelHelpers.export(exports, "setI18n", ()=>(0, _i18NInstanceJs.setI18n));
parcelHelpers.export(exports, "getI18n", ()=>(0, _i18NInstanceJs.getI18n));
parcelHelpers.export(exports, "I18nContext", ()=>(0, _contextJs.I18nContext));
parcelHelpers.export(exports, "composeInitialProps", ()=>(0, _contextJs.composeInitialProps));
parcelHelpers.export(exports, "getInitialProps", ()=>(0, _contextJs.getInitialProps));
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "time", ()=>time);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "select", ()=>select);
parcelHelpers.export(exports, "plural", ()=>plural);
parcelHelpers.export(exports, "selectOrdinal", ()=>selectOrdinal);
var _transJs = require("./Trans.js");
var _transWithoutContextJs = require("./TransWithoutContext.js");
var _useTranslationJs = require("./useTranslation.js");
var _withTranslationJs = require("./withTranslation.js");
var _translationJs = require("./Translation.js");
var _i18NextProviderJs = require("./I18nextProvider.js");
var _withSSRJs = require("./withSSR.js");
var _useSSRJs = require("./useSSR.js");
var _initReactI18NextJs = require("./initReactI18next.js");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
var _contextJs = require("./context.js");
const date = ()=>"";
const time = ()=>"";
const number = ()=>"";
const select = ()=>"";
const plural = ()=>"";
const selectOrdinal = ()=>"";

},{"./Trans.js":"61n37","./TransWithoutContext.js":"c1rFO","./useTranslation.js":"b1NOX","./withTranslation.js":"d56aE","./Translation.js":"2ckID","./I18nextProvider.js":"iU8u8","./withSSR.js":"bmUqM","./useSSR.js":"9zaqa","./initReactI18next.js":"agu28","./defaults.js":"2s5Oe","./i18nInstance.js":"ayw1K","./context.js":"a2yi2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"61n37":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>(0, _transWithoutContextJs.nodesToString));
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _react = require("react");
var _transWithoutContextJs = require("./TransWithoutContext.js");
var _contextJs = require("./context.js");
function Trans(_ref) {
    let { children, count, parent, i18nKey, context, tOptions = {}, values, defaults, components, ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, _transWithoutContextJs.Trans)({
        children,
        count,
        parent,
        i18nKey,
        context,
        tOptions,
        values,
        defaults,
        components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n,
        t: tFromProps,
        shouldUnescape,
        ...additionalProps
    });
}

},{"react":"BK2ob","./TransWithoutContext.js":"c1rFO","./context.js":"a2yi2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c1rFO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>nodesToString);
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _react = require("react");
var _htmlParseStringify = require("html-parse-stringify");
var _htmlParseStringifyDefault = parcelHelpers.interopDefault(_htmlParseStringify);
var _utilsJs = require("./utils.js");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
function hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? getAsArray(children) : children;
}
function hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, _react.isValidElement)(child));
}
function getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function nodesToString(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, _react.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = nodesToString(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, _utilsJs.warn)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, _utilsJs.warn)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, _utilsJs.warn)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if (hasChildren(child)) getData(getChildren(child));
            else if (typeof child === "object" && !(0, _react.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, _htmlParseStringifyDefault.default).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, _react.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, _react.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, _react.createElement)(c.type, {
                ...props,
                key: i,
                ref: c.ref
            }, isVoid ? null : inner);
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = getAsArray(reactNode);
        const astNodes = getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, _react.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if (hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, _react.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, _react.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, _react.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, getAsArray(children || []));
    return getChildren(result[0]);
}
function Trans(_ref) {
    let { children, count, parent, i18nKey, context, tOptions = {}, values, defaults, components, ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, _i18NInstanceJs.getI18n)();
    if (!i18n) {
        (0, _utilsJs.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, _defaultsJs.getDefaults)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = nodesToString(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const combinedTOpts = {
        ...tOptions,
        context: context || tOptions.context,
        count,
        ...values,
        defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, _react.createElement)((0, _react.Fragment), null, comp);
        }
        components[c] = (0, _react.createElement)(Componentized);
    });
    const content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, _react.createElement)(useAsParent, additionalProps, content) : content;
}

},{"react":"BK2ob","html-parse-stringify":"bRcV9","./utils.js":"aC60L","./defaults.js":"2s5Oe","./i18nInstance.js":"ayw1K","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bRcV9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _voidElements = require("void-elements");
var _voidElementsDefault = parcelHelpers.interopDefault(_voidElements);
var t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, _voidElementsDefault.default)[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp(t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i = /^\s*$/, s = Object.create(null);
function a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace(r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + a("", t);
        }, "");
    }
};
exports.default = c;

},{"void-elements":"7Hxmt","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7Hxmt":[function(require,module,exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

},{}],"aC60L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
function warn() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const alreadyWarned = {};
function warnOnce() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") alreadyWarned[args[0]] = new Date();
    warn(...args);
}
const loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function loadNamespaces(i18n, ns, cb) {
    i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function hasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        warnOnce("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function getDisplayName(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2s5Oe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDefaults", ()=>setDefaults);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
var _unescapeJs = require("./unescape.js");
let defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, _unescapeJs.unescape)
};
function setDefaults() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    defaultOptions = {
        ...defaultOptions,
        ...options
    };
}
function getDefaults() {
    return defaultOptions;
}

},{"./unescape.js":"foNqE","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"foNqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unescape", ()=>unescape);
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const unescapeHtmlEntity = (m)=>htmlEntities[m];
const unescape = (text)=>text.replace(matchHtmlEntity, unescapeHtmlEntity);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ayw1K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setI18n", ()=>setI18n);
parcelHelpers.export(exports, "getI18n", ()=>getI18n);
let i18nInstance;
function setI18n(instance) {
    i18nInstance = instance;
}
function getI18n() {
    return i18nInstance;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a2yi2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaults", ()=>(0, _defaultsJs.getDefaults));
parcelHelpers.export(exports, "setDefaults", ()=>(0, _defaultsJs.setDefaults));
parcelHelpers.export(exports, "getI18n", ()=>(0, _i18NInstanceJs.getI18n));
parcelHelpers.export(exports, "setI18n", ()=>(0, _i18NInstanceJs.setI18n));
parcelHelpers.export(exports, "initReactI18next", ()=>(0, _initReactI18NextJs.initReactI18next));
parcelHelpers.export(exports, "I18nContext", ()=>I18nContext);
parcelHelpers.export(exports, "ReportNamespaces", ()=>ReportNamespaces);
parcelHelpers.export(exports, "composeInitialProps", ()=>composeInitialProps);
parcelHelpers.export(exports, "getInitialProps", ()=>getInitialProps);
var _react = require("react");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
var _initReactI18NextJs = require("./initReactI18next.js");
const I18nContext = (0, _react.createContext)();
class ReportNamespaces {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function composeInitialProps(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = getInitialProps();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function getInitialProps() {
    const i18n = (0, _i18NInstanceJs.getI18n)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

},{"react":"BK2ob","./defaults.js":"2s5Oe","./i18nInstance.js":"ayw1K","./initReactI18next.js":"agu28","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"agu28":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initReactI18next", ()=>initReactI18next);
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
const initReactI18next = {
    type: "3rdParty",
    init (instance) {
        (0, _defaultsJs.setDefaults)(instance.options.react);
        (0, _i18NInstanceJs.setI18n)(instance);
    }
};

},{"./defaults.js":"2s5Oe","./i18nInstance.js":"ayw1K","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b1NOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTranslation", ()=>useTranslation);
var _react = require("react");
var _contextJs = require("./context.js");
var _utilsJs = require("./utils.js");
const usePrevious = (value, ignore)=>{
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function alwaysNewT(i18n, language, namespace, keyPrefix) {
    return i18n.getFixedT(language, namespace, keyPrefix);
}
function useMemoizedT(i18n, language, namespace, keyPrefix) {
    return (0, _react.useCallback)(alwaysNewT(i18n, language, namespace, keyPrefix), [
        i18n,
        language,
        namespace,
        keyPrefix
    ]);
}
function useTranslation(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, _contextJs.ReportNamespaces)();
    if (!i18n) {
        (0, _utilsJs.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, _utilsJs.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, _contextJs.getDefaults)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense, keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, _utilsJs.hasLoadedNamespace)(n, i18n, i18nOptions));
    const memoGetT = useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const getT = ()=>memoGetT;
    const getNewT = ()=>alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = (0, _react.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = usePrevious(joinedNS);
    const isMounted = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        const { bindI18n, bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, _utilsJs.loadLanguages)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
            else (0, _utilsJs.loadNamespaces)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getNewT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getNewT);
        function boundReset() {
            if (isMounted.current) setT(getNewT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    (0, _react.useEffect)(()=>{
        if (isMounted.current && ready) setT(getT);
    }, [
        i18n,
        keyPrefix,
        ready
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, _utilsJs.loadLanguages)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, _utilsJs.loadNamespaces)(i18n, namespaces, ()=>resolve());
    });
}

},{"react":"BK2ob","./context.js":"a2yi2","./utils.js":"aC60L","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"d56aE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withTranslation", ()=>withTranslation);
var _react = require("react");
var _useTranslationJs = require("./useTranslation.js");
var _utilsJs = require("./utils.js");
function withTranslation(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, _useTranslationJs.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t,
                i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, _react.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, _utilsJs.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, _react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, _react.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

},{"react":"BK2ob","./useTranslation.js":"b1NOX","./utils.js":"aC60L","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2ckID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Translation", ()=>Translation);
var _useTranslationJs = require("./useTranslation.js");
function Translation(props) {
    const { ns, children, ...options } = props;
    const [t, i18n, ready] = (0, _useTranslationJs.useTranslation)(ns, options);
    return children(t, {
        i18n,
        lng: i18n.language
    }, ready);
}

},{"./useTranslation.js":"b1NOX","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iU8u8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nextProvider", ()=>I18nextProvider);
var _react = require("react");
var _contextJs = require("./context.js");
function I18nextProvider(_ref) {
    let { i18n, defaultNS, children } = _ref;
    const value = (0, _react.useMemo)(()=>({
            i18n,
            defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, _react.createElement)((0, _contextJs.I18nContext).Provider, {
        value
    }, children);
}

},{"react":"BK2ob","./context.js":"a2yi2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bmUqM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSSR", ()=>withSSR);
var _react = require("react");
var _useSSRJs = require("./useSSR.js");
var _contextJs = require("./context.js");
var _utilsJs = require("./utils.js");
function withSSR() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore, initialLanguage, ...rest } = _ref;
            (0, _useSSRJs.useSSR)(initialI18nStore, initialLanguage);
            return (0, _react.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, _contextJs.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, _utilsJs.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

},{"react":"BK2ob","./useSSR.js":"9zaqa","./context.js":"a2yi2","./utils.js":"aC60L","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9zaqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSSR", ()=>useSSR);
var _react = require("react");
var _contextJs = require("./context.js");
function useSSR(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

},{"react":"BK2ob","./context.js":"a2yi2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2HEhN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScreenSize", ()=>useScreenSize);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _styles = require("@mui/material/styles");
const useScreenSize = ()=>{
    const theme = (0, _styles.useTheme)();
    return {
        isMobile: (0, _useMediaQueryDefault.default)(theme.breakpoints.down("sm")),
        isTablet: (0, _useMediaQueryDefault.default)(theme.breakpoints.down("md")),
        isLaptop: (0, _useMediaQueryDefault.default)(theme.breakpoints.down("lg")),
        isDesktop: (0, _useMediaQueryDefault.default)(theme.breakpoints.up("lg"))
    };
};

},{"@mui/material/useMediaQuery":"2E8dG","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2E8dG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useMediaQueryDefault.default));
var _useMediaQuery = require("@mui/system/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);

},{"@mui/system/useMediaQuery":"1OYfr","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1OYfr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useMediaQueryDefault.default));
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
parcelHelpers.exportAll(_useMediaQuery, exports);

},{"./useMediaQuery":"l5WLR","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l5WLR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMediaQuery);
var _react = require("react");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useThemeProps = require("../useThemeProps");
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = _react.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = _react["useSyncExternalStore"];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = _react.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = _react.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = _react.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function useMediaQuery(queryInput, options = {}) {
    const theme = (0, _useThemeWithoutDefaultDefault.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches = false, matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia = null, noSsr = false } = (0, _useThemeProps.getThemeProps)({
        name: "MuiUseMediaQuery",
        props: options,
        theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

},{"react":"BK2ob","@mui/utils/useEnhancedEffect":"2Y1IL","../useThemeProps":"iCTDV","../useThemeWithoutDefault":"gZnLz","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2Y1IL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useEnhancedEffectDefault.default));
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);

},{"./useEnhancedEffect":"fK1A0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fK1A0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== "undefined" ? _react.useLayoutEffect : _react.useEffect;
exports.default = useEnhancedEffect;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iCTDV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _getThemePropsDefault.default));
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
"use client";

},{"./useThemeProps":"dAuPq","./getThemeProps":"lJkK0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dAuPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
"use client";
function useThemeProps({ props, name, defaultTheme, themeId }) {
    let theme = (0, _useThemeDefault.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, _getThemePropsDefault.default)({
        theme,
        name,
        props
    });
    return mergedProps;
}

},{"./getThemeProps":"lJkK0","../useTheme":"ivI3c","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lJkK0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getThemeProps);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, _resolvePropsDefault.default)(theme.components[name].defaultProps, props);
}

},{"@mui/utils/resolveProps":"iAGSM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iAGSM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _resolvePropsDefault.default));
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);

},{"./resolveProps":"l4g2F","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l4g2F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function resolveProps(defaultProps, props) {
    const output = (0, _extendsDefault.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, _extendsDefault.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, _extendsDefault.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8iXse":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ivI3c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
"use client";
const systemDefaultTheme = (0, _createThemeDefault.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _useThemeWithoutDefaultDefault.default)(defaultTheme);
}
exports.default = useTheme;

},{"./createTheme":"aL8dX","./useThemeWithoutDefault":"gZnLz","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aL8dX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "private_createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "unstable_applyStyles", ()=>(0, _applyStylesDefault.default));
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);

},{"./createTheme":"8Z9sc","./createBreakpoints":"5InaR","./applyStyles":"14Ycm","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8Z9sc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _shape = require("./shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _createSpacing = require("./createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _styleFunctionSx = require("../styleFunctionSx/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _defaultSxConfig = require("../styleFunctionSx/defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);
const _excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const breakpoints = (0, _createBreakpointsDefault.default)(breakpointsInput);
    const spacing = (0, _createSpacingDefault.default)(spacingInput);
    let muiTheme = (0, _deepmergeDefault.default)({
        breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, _extendsDefault.default)({
            mode: "light"
        }, paletteInput),
        spacing,
        shape: (0, _extendsDefault.default)({}, (0, _shapeDefault.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, _applyStylesDefault.default);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _defaultSxConfigDefault.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/deepmerge":"5eIl7","./createBreakpoints":"5InaR","./shape":"4Af6z","./createSpacing":"iIfGe","../styleFunctionSx/styleFunctionSx":"fWxrm","../styleFunctionSx/defaultSxConfig":"8y9Cj","./applyStyles":"14Ycm","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dS5Om":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5eIl7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deepmergeDefault.default));
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
parcelHelpers.exportAll(_deepmerge, exports);

},{"./deepmerge":"e52vm","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e52vm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "default", ()=>deepmerge);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function isPlainObject(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
    if (!isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = deepClone(source[key]);
    });
    return output;
}
function deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, _extendsDefault.default)({}, target) : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if (isPlainObject(source[key]) && key in target && isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5InaR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpointKeys", ()=>breakpointKeys);
parcelHelpers.export(exports, "default", ()=>createBreakpoints);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "values",
    "unit",
    "step"
];
const breakpointKeys = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, _extendsDefault.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = "px", step = 5 } = breakpoints, other = (0, _objectWithoutPropertiesLooseDefault.default)(breakpoints, _excluded);
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, _extendsDefault.default)({
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit
    }, other);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4Af6z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shape = {
    borderRadius: 4
};
exports.default = shape;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iIfGe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSpacing);
var _spacing = require("../spacing");
function createSpacing(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, _spacing.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

},{"../spacing":"iL47I","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iL47I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marginKeys", ()=>marginKeys);
parcelHelpers.export(exports, "paddingKeys", ()=>paddingKeys);
parcelHelpers.export(exports, "createUnaryUnit", ()=>createUnaryUnit);
parcelHelpers.export(exports, "createUnarySpacing", ()=>createUnarySpacing);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "getStyleFromPropValue", ()=>getStyleFromPropValue);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "padding", ()=>padding);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
var _style = require("./style");
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _memoize = require("./memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
const properties = {
    m: "margin",
    p: "padding"
};
const directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoizeDefault.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = properties[a];
    const direction = directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const paddingKeys = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, _style.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce((0, _mergeDefault.default), {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
exports.default = spacing;

},{"./responsivePropType":"feixH","./breakpoints":"9bPht","./style":"119Mu","./merge":"jVyOX","./memoize":"ivwNh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"feixH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const responsivePropType = {};
exports.default = responsivePropType;

},{"prop-types":"hRUel","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hRUel":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"fueGx"}],"fueGx":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"7ZLh1"}],"7ZLh1":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"9bPht":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "handleBreakpoints", ()=>handleBreakpoints);
parcelHelpers.export(exports, "createEmptyBreakpointObject", ()=>createEmptyBreakpointObject);
parcelHelpers.export(exports, "removeUnusedBreakpoints", ()=>removeUnusedBreakpoints);
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>mergeBreakpointsInOrder);
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
parcelHelpers.export(exports, "computeBreakpointsBase", ()=>computeBreakpointsBase);
parcelHelpers.export(exports, "resolveBreakpointValues", ()=>resolveBreakpointValues);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
const values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, _extendsDefault.default)({
                    theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, _mergeDefault.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _deepmergeDefault.default)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
exports.default = breakpoints;

},{"@babel/runtime/helpers/esm/extends":"8iXse","prop-types":"hRUel","@mui/utils/deepmerge":"5eIl7","./merge":"jVyOX","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jVyOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
function merge(acc, item) {
    if (!item) return acc;
    return (0, _deepmergeDefault.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
exports.default = merge;

},{"@mui/utils/deepmerge":"5eIl7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"119Mu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "getStyleValue", ()=>getStyleValue);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
exports.default = style;

},{"@mui/utils/capitalize":"zPeBW","./responsivePropType":"feixH","./breakpoints":"9bPht","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"zPeBW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _capitalizeDefault.default));
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);

},{"./capitalize":"1tnZe","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1tnZe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>capitalize);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function capitalize(string) {
    if (typeof string !== "string") throw new Error((0, _formatMuiErrorMessageDefault.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"@mui/utils/formatMuiErrorMessage":"dmYrs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dmYrs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formatMuiErrorMessageDefault.default));
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);

},{"./formatMuiErrorMessage":"863Ns","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"863Ns":[function(require,module,exports) {
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatMuiErrorMessage);
function formatMuiErrorMessage(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ivwNh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fWxrm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>unstable_createStyleFunctionSx);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _merge = require("../merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _style = require("../style");
var _breakpoints = require("../breakpoints");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, _style.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _style.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, _style.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx, theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, _defaultSxConfigDefault.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _breakpoints.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _breakpoints.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme
                            });
                            else css = (0, _mergeDefault.default)(css, breakpointsValues);
                        }
                    } else css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    "sx"
];
exports.default = styleFunctionSx;

},{"@mui/utils/capitalize":"zPeBW","../merge":"jVyOX","../style":"119Mu","../breakpoints":"9bPht","./defaultSxConfig":"8y9Cj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8y9Cj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spacing = require("../spacing");
var _borders = require("../borders");
var _cssGrid = require("../cssGrid");
var _palette = require("../palette");
var _sizing = require("../sizing");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, _borders.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, _borders.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, _palette.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, _palette.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, _palette.paletteTransform)
    },
    // spacing
    p: {
        style: (0, _spacing.padding)
    },
    pt: {
        style: (0, _spacing.padding)
    },
    pr: {
        style: (0, _spacing.padding)
    },
    pb: {
        style: (0, _spacing.padding)
    },
    pl: {
        style: (0, _spacing.padding)
    },
    px: {
        style: (0, _spacing.padding)
    },
    py: {
        style: (0, _spacing.padding)
    },
    padding: {
        style: (0, _spacing.padding)
    },
    paddingTop: {
        style: (0, _spacing.padding)
    },
    paddingRight: {
        style: (0, _spacing.padding)
    },
    paddingBottom: {
        style: (0, _spacing.padding)
    },
    paddingLeft: {
        style: (0, _spacing.padding)
    },
    paddingX: {
        style: (0, _spacing.padding)
    },
    paddingY: {
        style: (0, _spacing.padding)
    },
    paddingInline: {
        style: (0, _spacing.padding)
    },
    paddingInlineStart: {
        style: (0, _spacing.padding)
    },
    paddingInlineEnd: {
        style: (0, _spacing.padding)
    },
    paddingBlock: {
        style: (0, _spacing.padding)
    },
    paddingBlockStart: {
        style: (0, _spacing.padding)
    },
    paddingBlockEnd: {
        style: (0, _spacing.padding)
    },
    m: {
        style: (0, _spacing.margin)
    },
    mt: {
        style: (0, _spacing.margin)
    },
    mr: {
        style: (0, _spacing.margin)
    },
    mb: {
        style: (0, _spacing.margin)
    },
    ml: {
        style: (0, _spacing.margin)
    },
    mx: {
        style: (0, _spacing.margin)
    },
    my: {
        style: (0, _spacing.margin)
    },
    margin: {
        style: (0, _spacing.margin)
    },
    marginTop: {
        style: (0, _spacing.margin)
    },
    marginRight: {
        style: (0, _spacing.margin)
    },
    marginBottom: {
        style: (0, _spacing.margin)
    },
    marginLeft: {
        style: (0, _spacing.margin)
    },
    marginX: {
        style: (0, _spacing.margin)
    },
    marginY: {
        style: (0, _spacing.margin)
    },
    marginInline: {
        style: (0, _spacing.margin)
    },
    marginInlineStart: {
        style: (0, _spacing.margin)
    },
    marginInlineEnd: {
        style: (0, _spacing.margin)
    },
    marginBlock: {
        style: (0, _spacing.margin)
    },
    marginBlockStart: {
        style: (0, _spacing.margin)
    },
    marginBlockEnd: {
        style: (0, _spacing.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, _cssGrid.gap)
    },
    rowGap: {
        style: (0, _cssGrid.rowGap)
    },
    columnGap: {
        style: (0, _cssGrid.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, _sizing.sizingTransform)
    },
    maxWidth: {
        style: (0, _sizing.maxWidth)
    },
    minWidth: {
        transform: (0, _sizing.sizingTransform)
    },
    height: {
        transform: (0, _sizing.sizingTransform)
    },
    maxHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    minHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
exports.default = defaultSxConfig;

},{"../spacing":"iL47I","../borders":"bBx5C","../cssGrid":"jUyRB","../palette":"1TnkM","../sizing":"5jUI1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bBx5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderTransform", ()=>borderTransform);
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "borderTop", ()=>borderTop);
parcelHelpers.export(exports, "borderRight", ()=>borderRight);
parcelHelpers.export(exports, "borderBottom", ()=>borderBottom);
parcelHelpers.export(exports, "borderLeft", ()=>borderLeft);
parcelHelpers.export(exports, "borderColor", ()=>borderColor);
parcelHelpers.export(exports, "borderTopColor", ()=>borderTopColor);
parcelHelpers.export(exports, "borderRightColor", ()=>borderRightColor);
parcelHelpers.export(exports, "borderBottomColor", ()=>borderBottomColor);
parcelHelpers.export(exports, "borderLeftColor", ()=>borderLeftColor);
parcelHelpers.export(exports, "outline", ()=>outline);
parcelHelpers.export(exports, "outlineColor", ()=>outlineColor);
parcelHelpers.export(exports, "borderRadius", ()=>borderRadius);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
function borderTransform(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _styleDefault.default)({
        prop,
        themeKey: "borders",
        transform
    });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = [
    "borderRadius"
];
const borders = (0, _composeDefault.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
exports.default = borders;

},{"./responsivePropType":"feixH","./style":"119Mu","./compose":"jfV4p","./spacing":"iL47I","./breakpoints":"9bPht","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jfV4p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _mergeDefault.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
exports.default = compose;

},{"./merge":"jVyOX","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jUyRB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gap", ()=>gap);
parcelHelpers.export(exports, "columnGap", ()=>columnGap);
parcelHelpers.export(exports, "rowGap", ()=>rowGap);
parcelHelpers.export(exports, "gridColumn", ()=>gridColumn);
parcelHelpers.export(exports, "gridRow", ()=>gridRow);
parcelHelpers.export(exports, "gridAutoFlow", ()=>gridAutoFlow);
parcelHelpers.export(exports, "gridAutoColumns", ()=>gridAutoColumns);
parcelHelpers.export(exports, "gridAutoRows", ()=>gridAutoRows);
parcelHelpers.export(exports, "gridTemplateColumns", ()=>gridTemplateColumns);
parcelHelpers.export(exports, "gridTemplateRows", ()=>gridTemplateRows);
parcelHelpers.export(exports, "gridTemplateAreas", ()=>gridTemplateAreas);
parcelHelpers.export(exports, "gridArea", ()=>gridArea);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
gap.propTypes = {};
gap.filterProps = [
    "gap"
];
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
columnGap.propTypes = {};
columnGap.filterProps = [
    "columnGap"
];
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
rowGap.propTypes = {};
rowGap.filterProps = [
    "rowGap"
];
const gridColumn = (0, _styleDefault.default)({
    prop: "gridColumn"
});
const gridRow = (0, _styleDefault.default)({
    prop: "gridRow"
});
const gridAutoFlow = (0, _styleDefault.default)({
    prop: "gridAutoFlow"
});
const gridAutoColumns = (0, _styleDefault.default)({
    prop: "gridAutoColumns"
});
const gridAutoRows = (0, _styleDefault.default)({
    prop: "gridAutoRows"
});
const gridTemplateColumns = (0, _styleDefault.default)({
    prop: "gridTemplateColumns"
});
const gridTemplateRows = (0, _styleDefault.default)({
    prop: "gridTemplateRows"
});
const gridTemplateAreas = (0, _styleDefault.default)({
    prop: "gridTemplateAreas"
});
const gridArea = (0, _styleDefault.default)({
    prop: "gridArea"
});
const grid = (0, _composeDefault.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
exports.default = grid;

},{"./style":"119Mu","./compose":"jfV4p","./spacing":"iL47I","./breakpoints":"9bPht","./responsivePropType":"feixH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1TnkM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paletteTransform", ()=>paletteTransform);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "bgcolor", ()=>bgcolor);
parcelHelpers.export(exports, "backgroundColor", ()=>backgroundColor);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
function paletteTransform(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const color = (0, _styleDefault.default)({
    prop: "color",
    themeKey: "palette",
    transform: paletteTransform
});
const bgcolor = (0, _styleDefault.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: paletteTransform
});
const backgroundColor = (0, _styleDefault.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: paletteTransform
});
const palette = (0, _composeDefault.default)(color, bgcolor, backgroundColor);
exports.default = palette;

},{"./style":"119Mu","./compose":"jfV4p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5jUI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sizingTransform", ()=>sizingTransform);
parcelHelpers.export(exports, "width", ()=>width);
parcelHelpers.export(exports, "maxWidth", ()=>maxWidth);
parcelHelpers.export(exports, "minWidth", ()=>minWidth);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "maxHeight", ()=>maxHeight);
parcelHelpers.export(exports, "minHeight", ()=>minHeight);
parcelHelpers.export(exports, "sizeWidth", ()=>sizeWidth);
parcelHelpers.export(exports, "sizeHeight", ()=>sizeHeight);
parcelHelpers.export(exports, "boxSizing", ()=>boxSizing);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _breakpoints = require("./breakpoints");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0, _styleDefault.default)({
    prop: "width",
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, _breakpoints.values)[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
maxWidth.filterProps = [
    "maxWidth"
];
const minWidth = (0, _styleDefault.default)({
    prop: "minWidth",
    transform: sizingTransform
});
const height = (0, _styleDefault.default)({
    prop: "height",
    transform: sizingTransform
});
const maxHeight = (0, _styleDefault.default)({
    prop: "maxHeight",
    transform: sizingTransform
});
const minHeight = (0, _styleDefault.default)({
    prop: "minHeight",
    transform: sizingTransform
});
const sizeWidth = (0, _styleDefault.default)({
    prop: "size",
    cssProperty: "width",
    transform: sizingTransform
});
const sizeHeight = (0, _styleDefault.default)({
    prop: "size",
    cssProperty: "height",
    transform: sizingTransform
});
const boxSizing = (0, _styleDefault.default)({
    prop: "boxSizing"
});
const sizing = (0, _composeDefault.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
exports.default = sizing;

},{"./style":"119Mu","./compose":"jfV4p","./breakpoints":"9bPht","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"14Ycm":[function(require,module,exports) {
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>applyStyles);
function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gZnLz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _styledEngine = require("@mui/styled-engine");
"use client";
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = _react.useContext((0, _styledEngine.ThemeContext));
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
exports.default = useTheme;

},{"react":"BK2ob","@mui/styled-engine":"8mH2X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8mH2X":[function(require,module,exports) {
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _react.ThemeContext));
parcelHelpers.export(exports, "keyframes", ()=>(0, _react.keyframes));
parcelHelpers.export(exports, "css", ()=>(0, _react.css));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngineProviderDefault.default));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "default", ()=>styled);
parcelHelpers.export(exports, "internal_processStyles", ()=>internal_processStyles);
/* eslint-disable no-underscore-dangle */ var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _styledEngineProvider = require("./StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
"use client";
function styled(tag, options) {
    const stylesFactory = (0, _styledDefault.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const internal_processStyles = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

},{"@emotion/styled":"fJT2M","@emotion/react":"sV8Gr","./StyledEngineProvider":"jjnq5","./GlobalStyles":"bhCqE","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fJT2M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newStyled);
var _emotionStyledBaseBrowserEsmJs = require("../base/dist/emotion-styled-base.browser.esm.js");
var _emotionStyledBaseBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseBrowserEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var newStyled = (0, _emotionStyledBaseBrowserEsmJsDefault.default).bind();
tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    newStyled[tagName] = newStyled(tagName);
});

},{"../base/dist/emotion-styled-base.browser.esm.js":"dhwth","@babel/runtime/helpers/extends":"cootg","react":"BK2ob","@emotion/is-prop-valid":"qTUbk","@emotion/react":"sV8Gr","@emotion/utils":"7d7hG","@emotion/serialize":"l76pN","@emotion/use-insertion-effect-with-fallbacks":"6uj39","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dhwth":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react1 = require("@emotion/react");
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, _react1.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react.useContext((0, _react1.ThemeContext));
            }
            if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ _react.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@emotion/is-prop-valid":"qTUbk","@emotion/react":"sV8Gr","@emotion/utils":"7d7hG","@emotion/serialize":"l76pN","@emotion/use-insertion-effect-with-fallbacks":"6uj39","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"qTUbk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"bUiop","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bUiop":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"sV8Gr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.a));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElement43C6Fea0BrowserEsmJs.b));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElement43C6Fea0BrowserEsmJs = require("./emotion-element-43c6fea0.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement43C6Fea0BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement43C6Fea0BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement43C6Fea0BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T)));
    if (!(0, _emotionElement43C6Fea0BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"./emotion-element-43c6fea0.browser.esm.js":"5bd11","react":"BK2ob","@emotion/utils":"7d7hG","@emotion/use-insertion-effect-with-fallbacks":"6uj39","@emotion/serialize":"l76pN","@emotion/cache":"7NZgZ","@babel/runtime/helpers/extends":"cootg","@emotion/weak-memoize":"jiUvD","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"kpDQM","hoist-non-react-statics":"fqafm","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5bd11":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>ThemeProvider);
parcelHelpers.export(exports, "b", ()=>withTheme);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: "css"
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== "css" && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"BK2ob","@emotion/cache":"7NZgZ","@babel/runtime/helpers/esm/extends":"8iXse","@emotion/weak-memoize":"jiUvD","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"kpDQM","@emotion/utils":"7d7hG","@emotion/serialize":"l76pN","@emotion/use-insertion-effect-with-fallbacks":"6uj39","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7NZgZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"b6r5o","stylis":"fIEqO","@emotion/weak-memoize":"jiUvD","@emotion/memoize":"bUiop","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b6r5o":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fIEqO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jiUvD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kpDQM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"fqafm","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fqafm":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"itSJh"}],"itSJh":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"lNhU0"}],"lNhU0":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"7d7hG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l76pN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@emotion/hash":"E6lmW","@emotion/unitless":"kM4lq","@emotion/memoize":"bUiop","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"E6lmW":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kM4lq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6uj39":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cootg":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jjnq5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styledEngineProviderDefault.default));
var _styledEngineProvider = require("./StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
"use client";

},{"./StyledEngineProvider":"ahTbF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ahTbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StyledEngineProvider);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
var _jsxRuntime = require("react/jsx-runtime");
"use client";
let cache;
if (typeof document === "object") cache = (0, _cacheDefault.default)({
    key: "css",
    prepend: true
});
function StyledEngineProvider(props) {
    const { injectFirst, children } = props;
    return injectFirst && cache ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.CacheProvider), {
        value: cache,
        children: children
    }) : children;
}

},{"react":"BK2ob","prop-types":"hRUel","@emotion/react":"sV8Gr","@emotion/cache":"7NZgZ","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bhCqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
"use client";

},{"./GlobalStyles":"d8Kaz","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"d8Kaz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalStyles);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Global), {
        styles: globalStyles
    });
}

},{"react":"BK2ob","prop-types":"hRUel","@emotion/react":"sV8Gr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"51PGx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "THEME_ID", ()=>(0, _identifierDefault.default));
parcelHelpers.export(exports, "adaptV4Theme", ()=>(0, _adaptV4ThemeDefault.default));
parcelHelpers.export(exports, "hexToRgb", ()=>(0, _system.hexToRgb));
parcelHelpers.export(exports, "rgbToHex", ()=>(0, _system.rgbToHex));
parcelHelpers.export(exports, "hslToRgb", ()=>(0, _system.hslToRgb));
parcelHelpers.export(exports, "decomposeColor", ()=>(0, _system.decomposeColor));
parcelHelpers.export(exports, "recomposeColor", ()=>(0, _system.recomposeColor));
parcelHelpers.export(exports, "getContrastRatio", ()=>(0, _system.getContrastRatio));
parcelHelpers.export(exports, "getLuminance", ()=>(0, _system.getLuminance));
parcelHelpers.export(exports, "emphasize", ()=>(0, _system.emphasize));
parcelHelpers.export(exports, "alpha", ()=>(0, _system.alpha));
parcelHelpers.export(exports, "darken", ()=>(0, _system.darken));
parcelHelpers.export(exports, "lighten", ()=>(0, _system.lighten));
parcelHelpers.export(exports, "css", ()=>(0, _system.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _system.keyframes));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "createMuiTheme", ()=>(0, _createTheme.createMuiTheme));
parcelHelpers.export(exports, "unstable_createMuiStrictModeTheme", ()=>(0, _createMuiStrictModeThemeDefault.default));
parcelHelpers.export(exports, "createStyles", ()=>(0, _createStylesDefault.default));
parcelHelpers.export(exports, "unstable_getUnit", ()=>(0, _cssUtils.getUnit));
parcelHelpers.export(exports, "unstable_toUnitless", ()=>(0, _cssUtils.toUnitless));
parcelHelpers.export(exports, "responsiveFontSizes", ()=>(0, _responsiveFontSizesDefault.default));
parcelHelpers.export(exports, "duration", ()=>(0, _createTransitions.duration));
parcelHelpers.export(exports, "easing", ()=>(0, _createTransitions.easing));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "experimentalStyled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _system.StyledEngineProvider));
// The legacy utilities from @mui/styles
// These are just empty functions that throws when invoked
parcelHelpers.export(exports, "makeStyles", ()=>(0, _makeStylesDefault.default));
parcelHelpers.export(exports, "withStyles", ()=>(0, _withStylesDefault.default));
parcelHelpers.export(exports, "withTheme", ()=>(0, _withThemeDefault.default));
parcelHelpers.export(exports, "experimental_extendTheme", ()=>(0, _experimentalExtendThemeDefault.default));
parcelHelpers.export(exports, "getOverlayAlpha", ()=>(0, _getOverlayAlphaDefault.default));
parcelHelpers.export(exports, "shouldSkipGeneratingVar", ()=>(0, _shouldSkipGeneratingVarDefault.default));
// Private methods for creating parts of the theme
parcelHelpers.export(exports, "private_createTypography", ()=>(0, _createTypographyDefault.default));
parcelHelpers.export(exports, "private_createMixins", ()=>(0, _createMixinsDefault.default));
parcelHelpers.export(exports, "private_excludeVariablesFromRoot", ()=>(0, _excludeVariablesFromRootDefault.default));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _adaptV4Theme = require("./adaptV4Theme");
var _adaptV4ThemeDefault = parcelHelpers.interopDefault(_adaptV4Theme);
var _system = require("@mui/system");
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createMuiStrictModeTheme = require("./createMuiStrictModeTheme");
var _createMuiStrictModeThemeDefault = parcelHelpers.interopDefault(_createMuiStrictModeTheme);
var _createStyles = require("./createStyles");
var _createStylesDefault = parcelHelpers.interopDefault(_createStyles);
var _cssUtils = require("./cssUtils");
var _responsiveFontSizes = require("./responsiveFontSizes");
var _responsiveFontSizesDefault = parcelHelpers.interopDefault(_responsiveFontSizes);
var _createTransitions = require("./createTransitions");
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _makeStyles = require("./makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _withStyles = require("./withStyles");
var _withStylesDefault = parcelHelpers.interopDefault(_withStyles);
var _withTheme = require("./withTheme");
var _withThemeDefault = parcelHelpers.interopDefault(_withTheme);
var _cssVarsProvider = require("./CssVarsProvider");
parcelHelpers.exportAll(_cssVarsProvider, exports);
var _experimentalExtendTheme = require("./experimental_extendTheme");
var _experimentalExtendThemeDefault = parcelHelpers.interopDefault(_experimentalExtendTheme);
var _getOverlayAlpha = require("./getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _shouldSkipGeneratingVar = require("./shouldSkipGeneratingVar");
var _shouldSkipGeneratingVarDefault = parcelHelpers.interopDefault(_shouldSkipGeneratingVar);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _excludeVariablesFromRoot = require("./excludeVariablesFromRoot");
var _excludeVariablesFromRootDefault = parcelHelpers.interopDefault(_excludeVariablesFromRoot);
"use client";
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(20));
}

},{"@mui/utils/formatMuiErrorMessage":"dmYrs","./identifier":false,"./adaptV4Theme":false,"@mui/system":"6hP1D","./createTheme":"eEMW0","./createMuiStrictModeTheme":false,"./createStyles":false,"./cssUtils":"8iWUp","./responsiveFontSizes":false,"./createTransitions":false,"./useTheme":"3N7Mw","./useThemeProps":"e7SGa","./styled":"axRcE","./ThemeProvider":"9WAlV","./makeStyles":false,"./withStyles":false,"./withTheme":false,"./CssVarsProvider":false,"./experimental_extendTheme":false,"./getOverlayAlpha":false,"./shouldSkipGeneratingVar":false,"./createTypography":false,"./createMixins":false,"./excludeVariablesFromRoot":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kUFJp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = "$$material";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6hP1D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>(0, _styledEngine.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _styledEngine.keyframes));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngine.StyledEngineProvider));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "borders", ()=>(0, _bordersDefault.default));
parcelHelpers.export(exports, "breakpoints", ()=>(0, _breakpointsDefault.default));
parcelHelpers.export(exports, "handleBreakpoints", ()=>(0, _breakpoints.handleBreakpoints));
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>(0, _breakpoints.mergeBreakpointsInOrder));
parcelHelpers.export(exports, "unstable_resolveBreakpointValues", ()=>(0, _breakpoints.resolveBreakpointValues));
parcelHelpers.export(exports, "compose", ()=>(0, _composeDefault.default));
parcelHelpers.export(exports, "display", ()=>(0, _displayDefault.default));
parcelHelpers.export(exports, "flexbox", ()=>(0, _flexboxDefault.default));
parcelHelpers.export(exports, "grid", ()=>(0, _cssGridDefault.default));
parcelHelpers.export(exports, "palette", ()=>(0, _paletteDefault.default));
parcelHelpers.export(exports, "positions", ()=>(0, _positionsDefault.default));
parcelHelpers.export(exports, "shadows", ()=>(0, _shadowsDefault.default));
parcelHelpers.export(exports, "sizing", ()=>(0, _sizingDefault.default));
parcelHelpers.export(exports, "spacing", ()=>(0, _spacingDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleDefault.default));
parcelHelpers.export(exports, "getPath", ()=>(0, _style.getPath));
parcelHelpers.export(exports, "getStyleValue", ()=>(0, _style.getStyleValue));
parcelHelpers.export(exports, "typography", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "unstable_styleFunctionSx", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "unstable_extendSxProp", ()=>(0, _styleFunctionSx.extendSxProp));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _styleFunctionSx.unstable_defaultSxConfig));
parcelHelpers.export(exports, "unstable_getThemeValue", ()=>(0, _getThemeValueDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "createBox", ()=>(0, _createBoxDefault.default));
parcelHelpers.export(exports, "createStyled", ()=>(0, _createStyledDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "createSpacing", ()=>(0, _createSpacingDefault.default));
parcelHelpers.export(exports, "shape", ()=>(0, _shapeDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _useThemeProps.getThemeProps));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeWithoutDefault", ()=>(0, _useThemeWithoutDefaultDefault.default));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _useMediaQueryDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsProvider", ()=>(0, _createCssVarsProviderDefault.default));
parcelHelpers.export(exports, "unstable_createGetCssVar", ()=>(0, _createGetCssVarDefault.default));
parcelHelpers.export(exports, "unstable_cssVarsParser", ()=>(0, _cssVarsParserDefault.default));
parcelHelpers.export(exports, "unstable_prepareCssVars", ()=>(0, _prepareCssVarsDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsTheme", ()=>(0, _createCssVarsThemeDefault.default));
parcelHelpers.export(exports, "responsivePropType", ()=>(0, _responsivePropTypeDefault.default));
parcelHelpers.export(exports, "RtlProvider", ()=>(0, _rtlProviderDefault.default));
/** ----------------- */ /** Layout components */ parcelHelpers.export(exports, "createContainer", ()=>(0, _createContainerDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Unstable_Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _styledEngine = require("@mui/styled-engine");
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _borders = require("./borders");
var _bordersDefault = parcelHelpers.interopDefault(_borders);
parcelHelpers.exportAll(_borders, exports);
var _breakpoints = require("./breakpoints");
var _breakpointsDefault = parcelHelpers.interopDefault(_breakpoints);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _display = require("./display");
var _displayDefault = parcelHelpers.interopDefault(_display);
var _flexbox = require("./flexbox");
var _flexboxDefault = parcelHelpers.interopDefault(_flexbox);
parcelHelpers.exportAll(_flexbox, exports);
var _cssGrid = require("./cssGrid");
var _cssGridDefault = parcelHelpers.interopDefault(_cssGrid);
parcelHelpers.exportAll(_cssGrid, exports);
var _palette = require("./palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
parcelHelpers.exportAll(_palette, exports);
var _positions = require("./positions");
var _positionsDefault = parcelHelpers.interopDefault(_positions);
parcelHelpers.exportAll(_positions, exports);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _sizing = require("./sizing");
var _sizingDefault = parcelHelpers.interopDefault(_sizing);
parcelHelpers.exportAll(_sizing, exports);
var _spacing = require("./spacing");
var _spacingDefault = parcelHelpers.interopDefault(_spacing);
parcelHelpers.exportAll(_spacing, exports);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _typography = require("./typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
parcelHelpers.exportAll(_typography, exports);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _getThemeValue = require("./getThemeValue");
var _getThemeValueDefault = parcelHelpers.interopDefault(_getThemeValue);
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _createBox = require("./createBox");
var _createBoxDefault = parcelHelpers.interopDefault(_createBox);
var _createStyled = require("./createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
parcelHelpers.exportAll(_createStyled, exports);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createTheme/createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _createSpacing = require("./createTheme/createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _shape = require("./createTheme/shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _colorManipulator = require("./colorManipulator");
parcelHelpers.exportAll(_colorManipulator, exports);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _createCssVarsProvider = require("./cssVars/createCssVarsProvider");
var _createCssVarsProviderDefault = parcelHelpers.interopDefault(_createCssVarsProvider);
var _createGetCssVar = require("./cssVars/createGetCssVar");
var _createGetCssVarDefault = parcelHelpers.interopDefault(_createGetCssVar);
var _cssVarsParser = require("./cssVars/cssVarsParser");
var _cssVarsParserDefault = parcelHelpers.interopDefault(_cssVarsParser);
var _prepareCssVars = require("./cssVars/prepareCssVars");
var _prepareCssVarsDefault = parcelHelpers.interopDefault(_prepareCssVars);
var _createCssVarsTheme = require("./cssVars/createCssVarsTheme");
var _createCssVarsThemeDefault = parcelHelpers.interopDefault(_createCssVarsTheme);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _rtlProvider = require("./RtlProvider");
var _rtlProviderDefault = parcelHelpers.interopDefault(_rtlProvider);
parcelHelpers.exportAll(_rtlProvider, exports);
var _createContainer = require("./Container/createContainer");
var _createContainerDefault = parcelHelpers.interopDefault(_createContainer);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
parcelHelpers.exportAll(_container, exports);
var _grid = require("./Unstable_Grid/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _unstableGrid = require("./Unstable_Grid");
parcelHelpers.exportAll(_unstableGrid, exports);
var _stack = require("./Stack/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _stack1 = require("./Stack");
parcelHelpers.exportAll(_stack1, exports);
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(20));
}

},{"@mui/utils/formatMuiErrorMessage":"dmYrs","@mui/styled-engine":"8mH2X","./GlobalStyles":"eL2S2","./borders":false,"./breakpoints":"9bPht","./compose":false,"./display":false,"./flexbox":false,"./cssGrid":false,"./palette":false,"./positions":false,"./shadows":false,"./sizing":false,"./spacing":false,"./style":"119Mu","./typography":false,"./styleFunctionSx":false,"./getThemeValue":false,"./Box":false,"./createBox":"hFYsG","./createStyled":false,"./styled":false,"./createTheme":false,"./createTheme/createBreakpoints":false,"./createTheme/createSpacing":false,"./createTheme/shape":false,"./useThemeProps":false,"./useTheme":"ivI3c","./useThemeWithoutDefault":false,"./useMediaQuery":false,"./colorManipulator":"K69tg","./ThemeProvider":"1PyQz","./cssVars/createCssVarsProvider":false,"./cssVars/createGetCssVar":false,"./cssVars/cssVarsParser":false,"./cssVars/prepareCssVars":false,"./cssVars/createCssVarsTheme":false,"./responsivePropType":false,"./RtlProvider":false,"./Container/createContainer":false,"./Container":false,"./Unstable_Grid/Grid":false,"./Unstable_Grid":false,"./Stack/Stack":false,"./Stack":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eL2S2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
parcelHelpers.exportAll(_globalStyles, exports);
"use client";

},{"./GlobalStyles":"brt9X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"brt9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledEngine = require("@mui/styled-engine");
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function GlobalStyles({ styles, themeId, defaultTheme = {} }) {
    const upperTheme = (0, _useThemeDefault.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
        styles: globalStyles
    });
}
exports.default = GlobalStyles;

},{"react":"BK2ob","prop-types":"hRUel","@mui/styled-engine":"8mH2X","../useTheme":"ivI3c","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fRzFg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "extendSxProp", ()=>(0, _extendSxPropDefault.default));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _defaultSxConfigDefault.default));
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _extendSxProp = require("./extendSxProp");
var _extendSxPropDefault = parcelHelpers.interopDefault(_extendSxProp);
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);

},{"./styleFunctionSx":"fWxrm","./extendSxProp":"8l8Rr","./defaultSxConfig":"8y9Cj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8l8Rr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extendSxProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
const _excluded = [
    "sx"
];
const splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, _defaultSxConfigDefault.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _deepmerge.isPlainObject)(result)) return systemProps;
        return (0, _extendsDefault.default)({}, systemProps, result);
    };
    else finalSx = (0, _extendsDefault.default)({}, systemProps, inSx);
    return (0, _extendsDefault.default)({}, otherProps, {
        sx: finalSx
    });
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/deepmerge":"5eIl7","./defaultSxConfig":"8y9Cj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hFYsG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createBox);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component"
];
function createBox(options = {}) {
    const { themeId, defaultTheme, defaultClassName = "MuiBox-root", generateClassName } = options;
    const BoxRoot = (0, _styledEngineDefault.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, _styleFunctionSxDefault.default));
    const Box = /*#__PURE__*/ _react.forwardRef(function Box(inProps, ref) {
        const theme = (0, _useThemeDefault.default)(defaultTheme);
        const _extendSxProp = (0, _styleFunctionSx.extendSxProp)(inProps), { className, component = "div" } = _extendSxProp, other = (0, _objectWithoutPropertiesLooseDefault.default)(_extendSxProp, _excluded);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxRoot, (0, _extendsDefault.default)({
            as: component,
            ref: ref,
            className: (0, _clsxDefault.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","clsx":"bGtJT","@mui/styled-engine":"8mH2X","./styleFunctionSx":"fRzFg","./useTheme":"ivI3c","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bGtJT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lT59a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Update /system/styled/#api in case if this changes
parcelHelpers.export(exports, "shouldForwardProp", ()=>shouldForwardProp);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable no-underscore-dangle */ var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _deepmerge = require("@mui/utils/deepmerge");
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _getDisplayName = require("@mui/utils/getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
const _excluded = [
    "ownerState"
], _excluded2 = [
    "variants"
], _excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = (0, _createThemeDefault.default)();
const lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({ defaultTheme, theme, themeId }) {
    return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function processStyleArg(callableStyle, _ref) {
    let { ownerState } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, _extendsDefault.default)({
        ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>processStyleArg(resolvedStyle, (0, _extendsDefault.default)({
            ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants = [] } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLooseDefault.default)(resolvedStylesArg, _excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, _extendsDefault.default)({
                ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, _extendsDefault.default)({
                    ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, _styleFunctionSxDefault.default)((0, _extendsDefault.default)({}, props, {
            theme: resolveTheme((0, _extendsDefault.default)({}, props, {
                defaultTheme,
                themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, _objectWithoutPropertiesLooseDefault.default)(inputOptions, _excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngineDefault.default)(tag, (0, _extendsDefault.default)({
            shouldForwardProp: shouldForwardPropOption,
            label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) return (props)=>processStyleArg(stylesArg, (0, _extendsDefault.default)({}, props, {
                    theme: resolveTheme({
                        theme: props.theme,
                        defaultTheme,
                        themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = resolveTheme((0, _extendsDefault.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extendsDefault.default)({}, props, {
                        theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = resolveTheme((0, _extendsDefault.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return processStyleArg({
                    variants: themeVariants
                }, (0, _extendsDefault.default)({}, props, {
                    theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/styled-engine":"8mH2X","@mui/utils/deepmerge":"5eIl7","@mui/utils/capitalize":"zPeBW","@mui/utils/getDisplayName":"hXiYE","./createTheme":"aL8dX","./styleFunctionSx":"fRzFg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hXiYE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getDisplayNameDefault.default));
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
parcelHelpers.exportAll(_getDisplayName, exports);

},{"./getDisplayName":"kE1Xv","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kE1Xv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
parcelHelpers.export(exports, "default", ()=>getDisplayName);
var _reactIs = require("react-is");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
    const match = `${fn}`.match(fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    const functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, _reactIs.ForwardRef:
            return getWrappedName(Component, Component.render, "ForwardRef");
        case 0, _reactIs.Memo:
            return getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

},{"react-is":"k6dAc","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k6dAc":[function(require,module,exports) {
"use strict";
module.exports = require("5b7b73e48aaa1474");

},{"5b7b73e48aaa1474":"6PYfi"}],"6PYfi":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"kgsTC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createStyled = require("./createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
const styled = (0, _createStyledDefault.default)();
exports.default = styled;

},{"./createStyled":"lT59a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"K69tg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ parcelHelpers.export(exports, "hexToRgb", ()=>hexToRgb);
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ parcelHelpers.export(exports, "decomposeColor", ()=>decomposeColor);
parcelHelpers.export(exports, "colorChannel", ()=>colorChannel);
parcelHelpers.export(exports, "private_safeColorChannel", ()=>private_safeColorChannel);
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ parcelHelpers.export(exports, "recomposeColor", ()=>recomposeColor);
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ parcelHelpers.export(exports, "rgbToHex", ()=>rgbToHex);
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ parcelHelpers.export(exports, "hslToRgb", ()=>hslToRgb);
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ parcelHelpers.export(exports, "getLuminance", ()=>getLuminance);
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ parcelHelpers.export(exports, "getContrastRatio", ()=>getContrastRatio);
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "private_safeAlpha", ()=>private_safeAlpha);
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "darken", ()=>darken);
parcelHelpers.export(exports, "private_safeDarken", ()=>private_safeDarken);
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "lighten", ()=>lighten);
parcelHelpers.export(exports, "private_safeLighten", ()=>private_safeLighten);
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "emphasize", ()=>emphasize);
parcelHelpers.export(exports, "private_safeEmphasize", ()=>private_safeEmphasize);
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ parcelHelpers.export(exports, "blend", ()=>blend);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
/* eslint-disable @typescript-eslint/naming-convention */ var _clamp = require("@mui/utils/clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clampDefault.default)(value, min, max);
}
function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return decomposeColor(hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, _formatMuiErrorMessageDefault.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, _formatMuiErrorMessageDefault.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: "rgb",
        values: rgb
    });
}

},{"@mui/utils/formatMuiErrorMessage":"dmYrs","@mui/utils/clamp":"bzSEP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bzSEP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _clampDefault.default));
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);

},{"./clamp":"2pp3R","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2pp3R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
exports.default = clamp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1PyQz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
"use client";

},{"./ThemeProvider":"k44W0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k44W0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _privateTheming = require("@mui/private-theming");
var _exactProp = require("@mui/utils/exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _styledEngine = require("@mui/styled-engine");
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _rtlProvider = require("../RtlProvider");
var _rtlProviderDefault = parcelHelpers.interopDefault(_rtlProvider);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return _react.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, _extendsDefault.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, _extendsDefault.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, _extendsDefault.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _useThemeWithoutDefaultDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateTheming.ThemeProvider), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.ThemeContext).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtlProviderDefault.default), {
                value: rtlValue,
                children: children
            })
        })
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/private-theming":"7C7rj","@mui/utils/exactProp":"1W2Le","@mui/styled-engine":"8mH2X","../useThemeWithoutDefault":"gZnLz","../RtlProvider":"jz0y0","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7C7rj":[function(require,module,exports) {
/**
 * @mui/private-theming v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
parcelHelpers.exportAll(_themeProvider, exports);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);

},{"./ThemeProvider":"6Tm1L","./useTheme":"eNcQH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6Tm1L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "unstable_nested", ()=>(0, _nestedDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);

},{"./ThemeProvider":"fgYeO","./nested":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fgYeO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _themeContext = require("../useTheme/ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);
// To support composition of theme.
var _jsxRuntime = require("react/jsx-runtime");
function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function ThemeProvider(props) {
    const { children, theme: localTheme } = props;
    const outerTheme = (0, _useThemeDefault.default)();
    const theme = _react.useMemo(()=>{
        const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, _nestedDefault.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeContextDefault.default).Provider, {
        value: theme,
        children: children
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/utils":"97HmB","../useTheme/ThemeContext":"kpWEL","../useTheme":"eNcQH","./nested":"lDGx4","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"97HmB":[function(require,module,exports) {
/**
 * @mui/utils v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chainPropTypes", ()=>(0, _chainPropTypesDefault.default));
parcelHelpers.export(exports, "deepmerge", ()=>(0, _deepmergeDefault.default));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _deepmerge.isPlainObject));
parcelHelpers.export(exports, "elementAcceptingRef", ()=>(0, _elementAcceptingRefDefault.default));
parcelHelpers.export(exports, "elementTypeAcceptingRef", ()=>(0, _elementTypeAcceptingRefDefault.default));
parcelHelpers.export(exports, "exactProp", ()=>(0, _exactPropDefault.default));
parcelHelpers.export(exports, "formatMuiErrorMessage", ()=>(0, _formatMuiErrorMessageDefault.default));
parcelHelpers.export(exports, "getDisplayName", ()=>(0, _getDisplayNameDefault.default));
parcelHelpers.export(exports, "HTMLElementType", ()=>(0, _htmlelementTypeDefault.default));
parcelHelpers.export(exports, "ponyfillGlobal", ()=>(0, _ponyfillGlobalDefault.default));
parcelHelpers.export(exports, "refType", ()=>(0, _refTypeDefault.default));
parcelHelpers.export(exports, "unstable_capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "unstable_createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "unstable_debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "unstable_deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "unstable_isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "unstable_ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "unstable_ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "unstable_requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "unstable_setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unstable_unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "unstable_useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "unstable_useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "unstable_useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "unstable_useLazyRef", ()=>(0, _useLazyRefDefault.default));
parcelHelpers.export(exports, "unstable_useTimeout", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "unstable_Timeout", ()=>(0, _useTimeout.Timeout));
parcelHelpers.export(exports, "unstable_useOnMount", ()=>(0, _useOnMountDefault.default));
parcelHelpers.export(exports, "unstable_useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_getScrollbarSize", ()=>(0, _getScrollbarSizeDefault.default));
parcelHelpers.export(exports, "unstable_detectScrollType", ()=>(0, _scrollLeft.detectScrollType));
parcelHelpers.export(exports, "unstable_getNormalizedScrollLeft", ()=>(0, _scrollLeft.getNormalizedScrollLeft));
parcelHelpers.export(exports, "usePreviousProps", ()=>(0, _usePreviousPropsDefault.default));
parcelHelpers.export(exports, "getValidReactChildren", ()=>(0, _getValidReactChildrenDefault.default));
parcelHelpers.export(exports, "visuallyHidden", ()=>(0, _visuallyHiddenDefault.default));
parcelHelpers.export(exports, "integerPropType", ()=>(0, _integerPropTypeDefault.default));
parcelHelpers.export(exports, "internal_resolveProps", ()=>(0, _resolvePropsDefault.default));
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _composeClassesDefault.default));
parcelHelpers.export(exports, "unstable_generateUtilityClass", ()=>(0, _generateUtilityClassDefault.default));
parcelHelpers.export(exports, "unstable_isGlobalState", ()=>(0, _generateUtilityClass.isGlobalState));
parcelHelpers.export(exports, "unstable_generateUtilityClasses", ()=>(0, _generateUtilityClassesDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _classNameGeneratorDefault.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _scrollLeft = require("./scrollLeft");
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);

},{"./chainPropTypes":"8qu3z","./deepmerge":"5eIl7","./elementAcceptingRef":"dHnQP","./elementTypeAcceptingRef":"cSxw6","./exactProp":"1W2Le","./formatMuiErrorMessage":"dmYrs","./getDisplayName":"hXiYE","./HTMLElementType":"lxflV","./ponyfillGlobal":"f59kO","./refType":"l5hTY","./capitalize":"zPeBW","./createChainedFunction":"dlnaY","./debounce":"hrGSO","./deprecatedPropType":"igdME","./isMuiElement":"cTX3z","./ownerDocument":"cuXLy","./ownerWindow":"g0RQa","./requirePropFactory":"eRkfG","./setRef":"HzF9U","./useEnhancedEffect":"2Y1IL","./useId":"8BX8X","./unsupportedProp":"aFFrK","./useControlled":"9keef","./useEventCallback":"gO2kA","./useForkRef":"7x3cc","./useLazyRef":"2YvuP","./useTimeout":"2Xz3c","./useOnMount":"aKrR0","./useIsFocusVisible":"1ARPj","./getScrollbarSize":"1GLWx","./scrollLeft":"17U9S","./usePreviousProps":"fXqMt","./getValidReactChildren":"lbg0x","./visuallyHidden":"bPC4h","./integerPropType":"3uD7f","./resolveProps":"iAGSM","./composeClasses":"jj3MR","./generateUtilityClass":"PMtLM","./generateUtilityClasses":"iDcJO","./ClassNameGenerator":"frL5Z","./clamp":"bzSEP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8qu3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chainPropTypesDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);

},{"./chainPropTypes":"cJ2NM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cJ2NM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>chainPropTypes);
function chainPropTypes(propType1, propType2) {
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dHnQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementAcceptingRefDefault.default));
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);

},{"./elementAcceptingRef":"a6V6j","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a6V6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === "undefined") return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === "function" && !isClassComponent(elementType)) warningHint = "Did you accidentally use a plain function component for an element instead?";
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + "For more information see https://mui.com/r/caveat-with-refs-guide");
    return null;
}
const elementAcceptingRef = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element, acceptingRef);
elementAcceptingRef.isRequired = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element.isRequired, acceptingRef);
exports.default = elementAcceptingRef;

},{"prop-types":"hRUel","../chainPropTypes":"8qu3z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cSxw6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementTypeAcceptingRefDefault.default));
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);

},{"./elementTypeAcceptingRef":"3ae0d","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3ae0d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === "undefined") return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === "function" && !isClassComponent(propValue)) warningHint = "Did you accidentally provide a plain function component instead?";
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + "For more information see https://mui.com/r/caveat-with-refs-guide");
    return null;
}
exports.default = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).elementType, elementTypeAcceptingRef);

},{"prop-types":"hRUel","../chainPropTypes":"8qu3z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1W2Le":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _exactPropDefault.default));
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);

},{"./exactProp":"bFkmI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bFkmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>exactProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lxflV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _htmlelementTypeDefault.default));
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);

},{"./HTMLElementType":"gaN8v","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gaN8v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HTMLElementType);
function HTMLElementType(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f59kO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ponyfillGlobalDefault.default));
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);

},{"./ponyfillGlobal":"49Ivs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"49Ivs":[function(require,module,exports) {
/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l5hTY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _refTypeDefault.default));
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);

},{"./refType":"kSL6g","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kSL6g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const refType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).object
]);
exports.default = refType;

},{"prop-types":"hRUel","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dlnaY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createChainedFunctionDefault.default));
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);

},{"./createChainedFunction":"kuMES","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kuMES":[function(require,module,exports) {
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createChainedFunction);
function createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hrGSO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _debounceDefault.default));
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
parcelHelpers.exportAll(_debounce, exports);

},{"./debounce":"kwWYt","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kwWYt":[function(require,module,exports) {
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"igdME":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deprecatedPropTypeDefault.default));
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);

},{"./deprecatedPropType":"ddAfk","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ddAfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deprecatedPropType);
function deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cTX3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _isMuiElementDefault.default));
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);

},{"./isMuiElement":"WQd50","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"WQd50":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isMuiElement);
var _react = require("react");
function isMuiElement(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ _react.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cuXLy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ownerDocumentDefault.default));
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);

},{"./ownerDocument":"72hj4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"72hj4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g0RQa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ownerWindowDefault.default));
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);

},{"./ownerWindow":"bDaBU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bDaBU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("../ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    const doc = (0, _ownerDocumentDefault.default)(node);
    return doc.defaultView || window;
}

},{"../ownerDocument":"cuXLy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eRkfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _requirePropFactoryDefault.default));
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);

},{"./requirePropFactory":"5PcKa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5PcKa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requirePropFactory);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function requirePropFactory(componentNameInError, Component) {
    return ()=>null;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"HzF9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _setRefDefault.default));
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);

},{"./setRef":"kQOUm","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kQOUm":[function(require,module,exports) {
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRef);
function setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8BX8X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useIdDefault.default));
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);

},{"./useId":"l7iGd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l7iGd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useId);
var _react = require("react");
"use client";
let globalId = 0;
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = _react.useState(idOverride);
    const id = idOverride || defaultId;
    _react.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = _react["useId".toString()];
function useId(idOverride) {
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aFFrK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _unsupportedPropDefault.default));
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);

},{"./unsupportedProp":"7e5cK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7e5cK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unsupportedProp);
function unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9keef":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useControlledDefault.default));
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);

},{"./useControlled":"liAK2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"liAK2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useControlled);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ var _react = require("react");
"use client";
function useControlled({ controlled, default: defaultProp, name, state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = _react.useRef(controlled !== undefined);
    const [valueState, setValue] = _react.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = _react.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gO2kA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useEventCallbackDefault.default));
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);

},{"./useEventCallback":"109Hj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"109Hj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEnhancedEffect = require("../useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = _react.useRef(fn);
    (0, _useEnhancedEffectDefault.default)(()=>{
        ref.current = fn;
    });
    return _react.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
exports.default = useEventCallback;

},{"react":"BK2ob","../useEnhancedEffect":"2Y1IL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7x3cc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useForkRefDefault.default));
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);

},{"./useForkRef":"jWtxc","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jWtxc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForkRef);
var _react = require("react");
var _setRef = require("../setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
"use client";
function useForkRef(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return _react.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, _setRefDefault.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

},{"react":"BK2ob","../setRef":"HzF9U","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2YvuP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useLazyRefDefault.default));
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);

},{"./useLazyRef":"1QE6M","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1QE6M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLazyRef);
var _react = require("react");
"use client";
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
    const ref = _react.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2Xz3c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "Timeout", ()=>(0, _useTimeout.Timeout));
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);

},{"./useTimeout":"e2NIb","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e2NIb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeout", ()=>Timeout);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _useLazyRef = require("../useLazyRef/useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useOnMount = require("../useOnMount/useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
"use client";
class Timeout {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new Timeout();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function useTimeout() {
    const timeout = (0, _useLazyRefDefault.default)(Timeout.create).current;
    (0, _useOnMountDefault.default)(timeout.disposeEffect);
    return timeout;
}

},{"../useLazyRef/useLazyRef":"1QE6M","../useOnMount/useOnMount":"7k4U3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7k4U3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOnMount);
var _react = require("react");
"use client";
const EMPTY = [];
function useOnMount(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ _react.useEffect(fn, EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aKrR0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useOnMountDefault.default));
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);

},{"./useOnMount":"7k4U3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1ARPj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useIsFocusVisibleDefault.default));
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
parcelHelpers.exportAll(_useIsFocusVisible, exports);

},{"./useIsFocusVisible":"2rU0r","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2rU0r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "teardown", ()=>teardown);
parcelHelpers.export(exports, "default", ()=>useIsFocusVisible);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var _react = require("react");
var _useTimeout = require("../useTimeout/useTimeout");
"use client";
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new (0, _useTimeout.Timeout)();
const inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function focusTriggersKeyboardModality(node) {
    const { type, tagName } = node;
    if (tagName === "INPUT" && inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function handlePointerDown() {
    hadKeyboardEvent = false;
}
function handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if (hadFocusVisibleRecently) hadKeyboardEvent = true;
    }
}
function prepare(doc) {
    doc.addEventListener("keydown", handleKeyDown, true);
    doc.addEventListener("mousedown", handlePointerDown, true);
    doc.addEventListener("pointerdown", handlePointerDown, true);
    doc.addEventListener("touchstart", handlePointerDown, true);
    doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function teardown(doc) {
    doc.removeEventListener("keydown", handleKeyDown, true);
    doc.removeEventListener("mousedown", handlePointerDown, true);
    doc.removeEventListener("pointerdown", handlePointerDown, true);
    doc.removeEventListener("touchstart", handlePointerDown, true);
    doc.removeEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
    const { target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
    const ref = _react.useCallback((node)=>{
        if (node != null) prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = _react.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            hadFocusVisibleRecently = true;
            hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if (isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref
    };
}

},{"react":"BK2ob","../useTimeout/useTimeout":"e2NIb","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1GLWx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getScrollbarSizeDefault.default));
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);

},{"./getScrollbarSize":"avzMN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"avzMN":[function(require,module,exports) {
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollbarSize);
function getScrollbarSize(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"17U9S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _scrollLeft = require("./scrollLeft");
parcelHelpers.exportAll(_scrollLeft, exports);

},{"./scrollLeft":"38XjM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"38XjM":[function(require,module,exports) {
// Source from https://github.com/alitaheri/normalize-scroll-left
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */ parcelHelpers.export(exports, "detectScrollType", ()=>detectScrollType);
// Based on https://stackoverflow.com/a/24394376
parcelHelpers.export(exports, "getNormalizedScrollLeft", ()=>getNormalizedScrollLeft);
let cachedType;
function detectScrollType() {
    if (cachedType) return cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    cachedType = "reverse";
    if (dummy.scrollLeft > 0) cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return cachedType;
}
function getNormalizedScrollLeft(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = detectScrollType();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fXqMt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _usePreviousPropsDefault.default));
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);

},{"./usePreviousProps":"lt0zq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lt0zq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const usePreviousProps = (value)=>{
    const ref = _react.useRef({});
    _react.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
exports.default = usePreviousProps;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lbg0x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getValidReactChildrenDefault.default));
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);

},{"./getValidReactChildren":"VjkJ5","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"VjkJ5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getValidReactChildren);
var _react = require("react");
function getValidReactChildren(children) {
    return _react.Children.toArray(children).filter((child)=>/*#__PURE__*/ _react.isValidElement(child));
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bPC4h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _visuallyHiddenDefault.default));
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);

},{"./visuallyHidden":"66hKo","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"66hKo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};
exports.default = visuallyHidden;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3uD7f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _integerPropTypeDefault.default));
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
parcelHelpers.exportAll(_integerPropType, exports);

},{"./integerPropType":"4pxY1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4pxY1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypeByValue", ()=>getTypeByValue);
function getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case "number":
            if (Number.isNaN(value)) return "NaN";
            if (!Number.isFinite(value)) return "Infinity";
            if (value !== Math.floor(value)) return "float";
            return "number";
        case "object":
            if (value === null) return "null";
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === "number" && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !isInteger(propValue)) {
        const propType = getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
    return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
exports.default = validatorNoop;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jj3MR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _composeClassesDefault.default));
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);

},{"./composeClasses":"fnlb7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fnlb7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeClasses);
function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"PMtLM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassDefault.default));
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);

},{"./generateUtilityClass":"18SM7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"18SM7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalStateClasses", ()=>globalStateClasses);
parcelHelpers.export(exports, "default", ()=>generateUtilityClass);
parcelHelpers.export(exports, "isGlobalState", ()=>isGlobalState);
var _classNameGenerator = require("../ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
const globalStateClasses = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, _classNameGeneratorDefault.default).generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"../ClassNameGenerator":"frL5Z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"frL5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _classNameGeneratorDefault.default));
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);

},{"./ClassNameGenerator":"c0ymY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c0ymY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
exports.default = ClassNameGenerator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iDcJO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassesDefault.default));
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);

},{"./generateUtilityClasses":"dETfN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dETfN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateUtilityClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClassDefault.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"../generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kpWEL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const ThemeContext = /*#__PURE__*/ _react.createContext(null);
exports.default = ThemeContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eNcQH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemeDefault.default));
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);

},{"./useTheme":"4eXCg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4eXCg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _themeContext = require("./ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
function useTheme() {
    const theme = _react.useContext((0, _themeContextDefault.default));
    return theme;
}

},{"react":"BK2ob","./ThemeContext":"kpWEL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lDGx4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const hasSymbol = typeof Symbol === "function" && Symbol.for;
exports.default = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jz0y0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRtl", ()=>useRtl);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "value"
];
const RtlContext = /*#__PURE__*/ _react.createContext();
function RtlProvider(_ref) {
    let { value } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RtlContext.Provider, (0, _extendsDefault.default)({
        value: value != null ? value : true
    }, props));
}
const useRtl = ()=>{
    const value = _react.useContext(RtlContext);
    return value != null ? value : false;
};
exports.default = RtlProvider;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3kw3N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "createGrid", ()=>(0, _createGridDefault.default));
parcelHelpers.export(exports, "gridClasses", ()=>(0, _gridClassesDefault.default));
parcelHelpers.export(exports, "unstable_traverseBreakpoints", ()=>(0, _traverseBreakpoints.traverseBreakpoints));
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _createGrid = require("./createGrid");
var _createGridDefault = parcelHelpers.interopDefault(_createGrid);
var _gridProps = require("./GridProps");
parcelHelpers.exportAll(_gridProps, exports);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
parcelHelpers.exportAll(_gridClasses, exports);
var _traverseBreakpoints = require("./traverseBreakpoints");
"use client";

},{"./Grid":false,"./createGrid":"02qgv","./GridProps":false,"./gridClasses":false,"./traverseBreakpoints":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"02qgv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createGrid);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _isMuiElement = require("@mui/utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _styleFunctionSx = require("../styleFunctionSx");
var _createTheme = require("../createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _gridGenerator = require("./gridGenerator");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "className",
    "children",
    "columns",
    "container",
    "component",
    "direction",
    "wrap",
    "spacing",
    "rowSpacing",
    "columnSpacing",
    "disableEqualOverflow",
    "unstable_level"
];
const defaultTheme = (0, _createThemeDefault.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styledDefault.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function useThemePropsDefault(props) {
    return (0, _useThemePropsDefault.default)({
        props,
        name: "MuiGrid",
        defaultTheme
    });
}
function createGrid(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = "MuiGrid" } = options;
    const GridOverflowContext = /*#__PURE__*/ _react.createContext(undefined);
    const useUtilityClasses = (ownerState, theme)=>{
        const { container, direction, spacing, wrap, gridSize } = ownerState;
        const slots = {
            root: [
                "root",
                container && "container",
                wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
                ...(0, _gridGenerator.generateDirectionClasses)(direction),
                ...(0, _gridGenerator.generateSizeClassNames)(gridSize),
                ...container ? (0, _gridGenerator.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, _composeClassesDefault.default)(slots, (slot)=>(0, _generateUtilityClassDefault.default)(componentName, slot), {});
    };
    const GridRoot = createStyledComponent((0, _gridGenerator.generateGridColumnsStyles), (0, _gridGenerator.generateGridColumnSpacingStyles), (0, _gridGenerator.generateGridRowSpacingStyles), (0, _gridGenerator.generateGridSizeStyles), (0, _gridGenerator.generateGridDirectionStyles), (0, _gridGenerator.generateGridStyles), (0, _gridGenerator.generateGridOffsetStyles));
    const Grid = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
        var _inProps$columns, _inProps$spacing, _ref, _inProps$rowSpacing, _ref2, _inProps$columnSpacin, _ref3, _disableEqualOverflow;
        const theme = (0, _useThemeDefault.default)();
        const themeProps = useThemeProps(inProps);
        const props = (0, _styleFunctionSx.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const overflow = _react.useContext(GridOverflowContext);
        const { className, children, columns: columnsProp = 12, container = false, component = "div", direction = "row", wrap = "wrap", spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, disableEqualOverflow: themeDisableEqualOverflow, unstable_level: level = 0 } = props, rest = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
        // Because `disableEqualOverflow` can be set from the theme's defaultProps, the **nested** grid should look at the instance props instead.
        let disableEqualOverflow = themeDisableEqualOverflow;
        if (level && themeDisableEqualOverflow !== undefined) disableEqualOverflow = inProps.disableEqualOverflow;
        // collect breakpoints related props because they can be customized from the theme.
        const gridSize = {};
        const gridOffset = {};
        const other = {};
        Object.entries(rest).forEach(([key, val])=>{
            if (theme.breakpoints.values[key] !== undefined) gridSize[key] = val;
            else if (theme.breakpoints.values[key.replace("Offset", "")] !== undefined) gridOffset[key.replace("Offset", "")] = val;
            else other[key] = val;
        });
        const columns = (_inProps$columns = inProps.columns) != null ? _inProps$columns : level ? undefined : columnsProp;
        const spacing = (_inProps$spacing = inProps.spacing) != null ? _inProps$spacing : level ? undefined : spacingProp;
        const rowSpacing = (_ref = (_inProps$rowSpacing = inProps.rowSpacing) != null ? _inProps$rowSpacing : inProps.spacing) != null ? _ref : level ? undefined : rowSpacingProp;
        const columnSpacing = (_ref2 = (_inProps$columnSpacin = inProps.columnSpacing) != null ? _inProps$columnSpacin : inProps.spacing) != null ? _ref2 : level ? undefined : columnSpacingProp;
        const ownerState = (0, _extendsDefault.default)({}, props, {
            level,
            columns,
            container,
            direction,
            wrap,
            spacing,
            rowSpacing,
            columnSpacing,
            gridSize,
            gridOffset,
            disableEqualOverflow: (_ref3 = (_disableEqualOverflow = disableEqualOverflow) != null ? _disableEqualOverflow : overflow) != null ? _ref3 : false,
            // use context value if exists.
            parentDisableEqualOverflow: overflow // for nested grid
        });
        const classes = useUtilityClasses(ownerState, theme);
        let result = /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, (0, _extendsDefault.default)({
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            children: _react.Children.map(children, (child)=>{
                if (/*#__PURE__*/ _react.isValidElement(child) && (0, _isMuiElementDefault.default)(child, [
                    "Grid"
                ])) {
                    var _child$props$unstable;
                    return /*#__PURE__*/ _react.cloneElement(child, {
                        unstable_level: (_child$props$unstable = child.props.unstable_level) != null ? _child$props$unstable : level + 1
                    });
                }
                return child;
            })
        }));
        if (disableEqualOverflow !== undefined && disableEqualOverflow !== (overflow != null ? overflow : false)) // There are 2 possibilities that should wrap with the GridOverflowContext to communicate with the nested grids:
        // 1. It is the root grid with `disableEqualOverflow`.
        // 2. It is a nested grid with different `disableEqualOverflow` from the context.
        result = /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridOverflowContext.Provider, {
            value: disableEqualOverflow,
            children: result
        });
        return result;
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = "Grid";
    return Grid;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/isMuiElement":"cTX3z","@mui/utils/generateUtilityClass":"PMtLM","@mui/utils/composeClasses":"jj3MR","../styled":"kgsTC","../useThemeProps":"iCTDV","../useTheme":"ivI3c","../styleFunctionSx":"fRzFg","../createTheme":"aL8dX","./gridGenerator":"5O8nE","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5O8nE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateGridSizeStyles", ()=>generateGridSizeStyles);
parcelHelpers.export(exports, "generateGridOffsetStyles", ()=>generateGridOffsetStyles);
parcelHelpers.export(exports, "generateGridColumnsStyles", ()=>generateGridColumnsStyles);
parcelHelpers.export(exports, "generateGridRowSpacingStyles", ()=>generateGridRowSpacingStyles);
parcelHelpers.export(exports, "generateGridColumnSpacingStyles", ()=>generateGridColumnSpacingStyles);
parcelHelpers.export(exports, "generateGridDirectionStyles", ()=>generateGridDirectionStyles);
parcelHelpers.export(exports, "generateGridStyles", ()=>generateGridStyles);
parcelHelpers.export(exports, "generateSizeClassNames", ()=>generateSizeClassNames);
parcelHelpers.export(exports, "generateSpacingClassNames", ()=>generateSpacingClassNames);
parcelHelpers.export(exports, "generateDirectionClasses", ()=>generateDirectionClasses);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _traverseBreakpoints = require("./traverseBreakpoints");
function appendLevel(level) {
    if (!level) return "";
    return `Level${level}`;
}
function isNestedContainer(ownerState) {
    return ownerState.unstable_level > 0 && ownerState.container;
}
function createGetSelfSpacing(ownerState) {
    return function getSelfSpacing(axis) {
        return `var(--Grid-${axis}Spacing${appendLevel(ownerState.unstable_level)})`;
    };
}
function createGetParentSpacing(ownerState) {
    return function getParentSpacing(axis) {
        if (ownerState.unstable_level === 0) return `var(--Grid-${axis}Spacing)`;
        return `var(--Grid-${axis}Spacing${appendLevel(ownerState.unstable_level - 1)})`;
    };
}
function getParentColumns(ownerState) {
    if (ownerState.unstable_level === 0) return `var(--Grid-columns)`;
    return `var(--Grid-columns${appendLevel(ownerState.unstable_level - 1)})`;
}
const generateGridSizeStyles = ({ theme, ownerState })=>{
    const getSelfSpacing = createGetSelfSpacing(ownerState);
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.gridSize, (appendStyle, value)=>{
        let style = {};
        if (value === true) style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        if (value === "auto") style = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        if (typeof value === "number") style = {
            flexGrow: 0,
            flexBasis: "auto",
            width: `calc(100% * ${value} / ${getParentColumns(ownerState)}${isNestedContainer(ownerState) ? ` + ${getSelfSpacing("column")}` : ""})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const generateGridOffsetStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.gridOffset, (appendStyle, value)=>{
        let style = {};
        if (value === "auto") style = {
            marginLeft: "auto"
        };
        if (typeof value === "number") style = {
            marginLeft: value === 0 ? "0px" : `calc(100% * ${value} / ${getParentColumns(ownerState)})`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const generateGridColumnsStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = isNestedContainer(ownerState) ? {
        [`--Grid-columns${appendLevel(ownerState.unstable_level)}`]: getParentColumns(ownerState)
    } : {
        "--Grid-columns": 12
    };
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        appendStyle(styles, {
            [`--Grid-columns${appendLevel(ownerState.unstable_level)}`]: value
        });
    });
    return styles;
};
const generateGridRowSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = createGetParentSpacing(ownerState);
    const styles = isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-rowSpacing${appendLevel(ownerState.unstable_level)}`]: getParentSpacing("row")
    } : {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        var _theme$spacing;
        appendStyle(styles, {
            [`--Grid-rowSpacing${appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : (_theme$spacing = theme.spacing) == null ? void 0 : _theme$spacing.call(theme, value)
        });
    });
    return styles;
};
const generateGridColumnSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const getParentSpacing = createGetParentSpacing(ownerState);
    const styles = isNestedContainer(ownerState) ? {
        // Set the default spacing as its parent spacing.
        // It will be overridden if spacing props are provided
        [`--Grid-columnSpacing${appendLevel(ownerState.unstable_level)}`]: getParentSpacing("column")
    } : {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        var _theme$spacing2;
        appendStyle(styles, {
            [`--Grid-columnSpacing${appendLevel(ownerState.unstable_level)}`]: typeof value === "string" ? value : (_theme$spacing2 = theme.spacing) == null ? void 0 : _theme$spacing2.call(theme, value)
        });
    });
    return styles;
};
const generateGridDirectionStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const generateGridStyles = ({ ownerState })=>{
    const getSelfSpacing = createGetSelfSpacing(ownerState);
    const getParentSpacing = createGetParentSpacing(ownerState);
    return (0, _extendsDefault.default)({
        minWidth: 0,
        boxSizing: "border-box"
    }, ownerState.container && (0, _extendsDefault.default)({
        display: "flex",
        flexWrap: "wrap"
    }, ownerState.wrap && ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }, {
        margin: `calc(${getSelfSpacing("row")} / -2) calc(${getSelfSpacing("column")} / -2)`
    }, ownerState.disableEqualOverflow && {
        margin: `calc(${getSelfSpacing("row")} * -1) 0px 0px calc(${getSelfSpacing("column")} * -1)`
    }), (!ownerState.container || isNestedContainer(ownerState)) && (0, _extendsDefault.default)({
        padding: `calc(${getParentSpacing("row")} / 2) calc(${getParentSpacing("column")} / 2)`
    }, (ownerState.disableEqualOverflow || ownerState.parentDisableEqualOverflow) && {
        padding: `${getParentSpacing("row")} 0px 0px ${getParentSpacing("column")}`
    }));
};
const generateSizeClassNames = (gridSize)=>{
    const classNames = [];
    Object.entries(gridSize).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const generateSpacingClassNames = (spacing, smallestBreakpoint = "xs")=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === "string" && !Number.isNaN(Number(val)) || typeof val === "number" && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === "object" && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === "object") return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};

},{"@babel/runtime/helpers/esm/extends":"8iXse","./traverseBreakpoints":"nABS2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"nABS2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterBreakpointKeys", ()=>filterBreakpointKeys);
parcelHelpers.export(exports, "traverseBreakpoints", ()=>traverseBreakpoints);
const filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === "object") {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.indexOf(key) !== -1) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === "number" || typeof responsive === "string") iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eEMW0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMuiTheme", ()=>createMuiTheme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _createTheme = require("@mui/system/createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _createPalette = require("./createPalette");
var _createPaletteDefault = parcelHelpers.interopDefault(_createPalette);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _createTransitions = require("./createTransitions");
var _createTransitionsDefault = parcelHelpers.interopDefault(_createTransitions);
var _zIndex = require("./zIndex");
var _zIndexDefault = parcelHelpers.interopDefault(_zIndex);
const _excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    if (options.vars) throw new Error((0, _formatMuiErrorMessageDefault.default)(18));
    const palette = (0, _createPaletteDefault.default)(paletteInput);
    const systemTheme = (0, _createThemeDefault.default)(options);
    let muiTheme = (0, _deepmergeDefault.default)(systemTheme, {
        mixins: (0, _createMixinsDefault.default)(systemTheme.breakpoints, mixinsInput),
        palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, _shadowsDefault.default).slice(),
        typography: (0, _createTypographyDefault.default)(palette, typographyInput),
        transitions: (0, _createTransitionsDefault.default)(transitionsInput),
        zIndex: (0, _extendsDefault.default)({}, (0, _zIndexDefault.default))
    });
    muiTheme = (0, _deepmergeDefault.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _styleFunctionSx.unstable_defaultSxConfig), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
    return createTheme(...args);
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/formatMuiErrorMessage":"dmYrs","@mui/utils/deepmerge":"5eIl7","@mui/system/styleFunctionSx":"fRzFg","@mui/system/createTheme":"aL8dX","@mui/utils/generateUtilityClass":"PMtLM","./createMixins":"hXaoq","./createPalette":"cpVeW","./createTypography":"1F9y6","./shadows":"6yoTa","./createTransitions":"8QUl5","./zIndex":"3wnbj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hXaoq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createMixins);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function createMixins(breakpoints, mixins) {
    return (0, _extendsDefault.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cpVeW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "light", ()=>light);
parcelHelpers.export(exports, "dark", ()=>dark);
parcelHelpers.export(exports, "default", ()=>createPalette);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _colorManipulator = require("@mui/system/colorManipulator");
var _common = require("../colors/common");
var _commonDefault = parcelHelpers.interopDefault(_common);
var _grey = require("../colors/grey");
var _greyDefault = parcelHelpers.interopDefault(_grey);
var _purple = require("../colors/purple");
var _purpleDefault = parcelHelpers.interopDefault(_purple);
var _red = require("../colors/red");
var _redDefault = parcelHelpers.interopDefault(_red);
var _orange = require("../colors/orange");
var _orangeDefault = parcelHelpers.interopDefault(_orange);
var _blue = require("../colors/blue");
var _blueDefault = parcelHelpers.interopDefault(_blue);
var _lightBlue = require("../colors/lightBlue");
var _lightBlueDefault = parcelHelpers.interopDefault(_lightBlue);
var _green = require("../colors/green");
var _greenDefault = parcelHelpers.interopDefault(_green);
const _excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const light = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, _commonDefault.default).white,
        default: (0, _commonDefault.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const dark = {
    text: {
        primary: (0, _commonDefault.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, _commonDefault.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
    }
}
function getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, _blueDefault.default)[200],
        light: (0, _blueDefault.default)[50],
        dark: (0, _blueDefault.default)[400]
    };
    return {
        main: (0, _blueDefault.default)[700],
        light: (0, _blueDefault.default)[400],
        dark: (0, _blueDefault.default)[800]
    };
}
function getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, _purpleDefault.default)[200],
        light: (0, _purpleDefault.default)[50],
        dark: (0, _purpleDefault.default)[400]
    };
    return {
        main: (0, _purpleDefault.default)[500],
        light: (0, _purpleDefault.default)[300],
        dark: (0, _purpleDefault.default)[700]
    };
}
function getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, _redDefault.default)[500],
        light: (0, _redDefault.default)[300],
        dark: (0, _redDefault.default)[700]
    };
    return {
        main: (0, _redDefault.default)[700],
        light: (0, _redDefault.default)[400],
        dark: (0, _redDefault.default)[800]
    };
}
function getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, _lightBlueDefault.default)[400],
        light: (0, _lightBlueDefault.default)[300],
        dark: (0, _lightBlueDefault.default)[700]
    };
    return {
        main: (0, _lightBlueDefault.default)[700],
        light: (0, _lightBlueDefault.default)[500],
        dark: (0, _lightBlueDefault.default)[900]
    };
}
function getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, _greenDefault.default)[400],
        light: (0, _greenDefault.default)[300],
        dark: (0, _greenDefault.default)[700]
    };
    return {
        main: (0, _greenDefault.default)[800],
        light: (0, _greenDefault.default)[500],
        dark: (0, _greenDefault.default)[900]
    };
}
function getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, _orangeDefault.default)[400],
        light: (0, _orangeDefault.default)[300],
        dark: (0, _orangeDefault.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, _orangeDefault.default)[500],
        dark: (0, _orangeDefault.default)[900]
    };
}
function createPalette(palette) {
    const { mode = "light", contrastThreshold = 3, tonalOffset = 0.2 } = palette, other = (0, _objectWithoutPropertiesLooseDefault.default)(palette, _excluded);
    const primary = palette.primary || getDefaultPrimary(mode);
    const secondary = palette.secondary || getDefaultSecondary(mode);
    const error = palette.error || getDefaultError(mode);
    const info = palette.info || getDefaultInfo(mode);
    const success = palette.success || getDefaultSuccess(mode);
    const warning = palette.warning || getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color, name, mainShade = 500, lightShade = 300, darkShade = 700 })=>{
        color = (0, _extendsDefault.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, _formatMuiErrorMessageDefault.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, _formatMuiErrorMessageDefault.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        addLightOrDark(color, "light", lightShade, tonalOffset);
        addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark,
        light
    };
    const paletteOutput = (0, _deepmergeDefault.default)((0, _extendsDefault.default)({
        // A collection of common colors.
        common: (0, _extendsDefault.default)({}, (0, _commonDefault.default)),
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        (0, _greyDefault.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        // Generate a rich color object.
        augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/formatMuiErrorMessage":"dmYrs","@mui/utils/deepmerge":"5eIl7","@mui/system/colorManipulator":"9FSVd","../colors/common":"bNATN","../colors/grey":"4xBLr","../colors/purple":"jUnVD","../colors/red":"3eNST","../colors/orange":"2VvZr","../colors/blue":"baMZz","../colors/lightBlue":"cxxHe","../colors/green":"dlY99","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9FSVd":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("a73561c9993d7239");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alpha = alpha;
exports.blend = blend;
exports.colorChannel = void 0;
exports.darken = darken;
exports.decomposeColor = decomposeColor;
exports.emphasize = emphasize;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.hexToRgb = hexToRgb;
exports.hslToRgb = hslToRgb;
exports.lighten = lighten;
exports.private_safeAlpha = private_safeAlpha;
exports.private_safeColorChannel = void 0;
exports.private_safeDarken = private_safeDarken;
exports.private_safeEmphasize = private_safeEmphasize;
exports.private_safeLighten = private_safeLighten;
exports.recomposeColor = recomposeColor;
exports.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault(require("6cffbcaa55ae3b91"));
var _clamp = _interopRequireDefault(require("e0a90cc904ea55f0"));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return decomposeColor(hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, _formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, _formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
exports.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ exports.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: "rgb",
        values: rgb
    });
}

},{"a73561c9993d7239":"hykHy","6cffbcaa55ae3b91":"dmYrs","e0a90cc904ea55f0":"bzSEP"}],"hykHy":[function(require,module,exports) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"bNATN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const common = {
    black: "#000",
    white: "#fff"
};
exports.default = common;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4xBLr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
exports.default = grey;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jUnVD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
exports.default = purple;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3eNST":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
exports.default = red;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2VvZr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
exports.default = orange;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"baMZz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
exports.default = blue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cxxHe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
exports.default = lightBlue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dlY99":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
exports.default = green;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1F9y6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createTypography);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
const _excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
    textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily = defaultFontFamily, // The default font size of the Material Specification.
    fontSize = 14, // px
    fontWeightLight = 300, fontWeightRegular = 400, fontWeightMedium = 500, fontWeightBold = 700, // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, _extendsDefault.default)({
            fontFamily,
            fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === defaultFontFamily ? {
            letterSpacing: `${round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, _deepmergeDefault.default)((0, _extendsDefault.default)({
        htmlFontSize,
        pxToRem,
        fontFamily,
        fontSize,
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/deepmerge":"5eIl7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6yoTa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = [
    "none",
    createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
exports.default = shadows;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8QUl5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easing", ()=>easing);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "default", ()=>createTransitions);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "duration",
    "easing",
    "delay"
];
const easing = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
    const mergedEasing = (0, _extendsDefault.default)({}, easing, inputTransitions.easing);
    const mergedDuration = (0, _extendsDefault.default)({}, duration, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay = 0 } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
    };
    return (0, _extendsDefault.default)({
        getAutoHeightDuration,
        create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3wnbj":[function(require,module,exports) {
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
exports.default = zIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8iWUp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUnitless", ()=>isUnitless);
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
parcelHelpers.export(exports, "getUnit", ()=>getUnit);
// Emulate the sass function "unitless"
parcelHelpers.export(exports, "toUnitless", ()=>toUnitless);
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
parcelHelpers.export(exports, "convertLength", ()=>convertLength);
parcelHelpers.export(exports, "alignProperty", ()=>alignProperty);
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
parcelHelpers.export(exports, "fontGrid", ()=>fontGrid);
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ parcelHelpers.export(exports, "responsiveProperty", ()=>responsiveProperty);
function isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length) {
    return parseFloat(length);
}
function convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = toUnitless(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = toUnitless(length) * toUnitless(baseFontSize);
            else if (fromUnit === "rem") pxLength = toUnitless(length) * toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / toUnitless(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function alignProperty({ size, grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function fontGrid({ lineHeight, pixels, htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function responsiveProperty({ cssProperty, min, max, unit = "rem", breakpoints = [
    600,
    900,
    1200
], transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3N7Mw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _system = require("@mui/system");
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
"use client";
function useTheme() {
    const theme = (0, _system.useTheme)((0, _defaultThemeDefault.default));
    return theme[0, _identifierDefault.default] || theme;
}

},{"react":"BK2ob","@mui/system":"6hP1D","./defaultTheme":"7ToXf","./identifier":"kUFJp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7ToXf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
"use client";
const defaultTheme = (0, _createThemeDefault.default)();
exports.default = defaultTheme;

},{"./createTheme":"eEMW0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e7SGa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _useThemeProps = require("@mui/system/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
"use client";
function useThemeProps({ props, name }) {
    return (0, _useThemePropsDefault.default)({
        props,
        name,
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    });
}

},{"@mui/system/useThemeProps":"iCTDV","./defaultTheme":"7ToXf","./identifier":"kUFJp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"axRcE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slotShouldForwardProp", ()=>(0, _slotShouldForwardPropDefault.default));
parcelHelpers.export(exports, "rootShouldForwardProp", ()=>(0, _rootShouldForwardPropDefault.default));
var _createStyled = require("@mui/system/createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _rootShouldForwardProp = require("./rootShouldForwardProp");
var _rootShouldForwardPropDefault = parcelHelpers.interopDefault(_rootShouldForwardProp);
var _slotShouldForwardProp = require("./slotShouldForwardProp");
var _slotShouldForwardPropDefault = parcelHelpers.interopDefault(_slotShouldForwardProp);
"use client";
const styled = (0, _createStyledDefault.default)({
    themeId: (0, _identifierDefault.default),
    defaultTheme: (0, _defaultThemeDefault.default),
    rootShouldForwardProp: (0, _rootShouldForwardPropDefault.default)
});
exports.default = styled;

},{"@mui/system/createStyled":"e4uS3","./defaultTheme":"7ToXf","./identifier":"kUFJp","./rootShouldForwardProp":"53WDh","./slotShouldForwardProp":"8PiTo","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e4uS3":[function(require,module,exports) {
"use strict";
var _interopRequireDefault = require("de1391ba5333f89c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyled;
exports.shouldForwardProp = shouldForwardProp;
exports.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault(require("b05e701df06cf2b8"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("1c23f895f04bb1f8"));
var _styledEngine = _interopRequireWildcard(require("474b747b46951daf"));
var _deepmerge = require("e7e859a1b9e6ab40");
var _capitalize = _interopRequireDefault(require("8202cda0a3f0a433"));
var _getDisplayName = _interopRequireDefault(require("ba8df200ce7809c8"));
var _createTheme = _interopRequireDefault(require("e9a196e78b4b1fc3"));
var _styleFunctionSx = _interopRequireDefault(require("60bc7d9f0f1dc713"));
const _excluded = [
    "ownerState"
], _excluded2 = [
    "variants"
], _excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
const lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({ defaultTheme, theme, themeId }) {
    return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function processStyleArg(callableStyle, _ref) {
    let { ownerState } = _ref, props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, _extends2.default)({
        ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>processStyleArg(resolvedStyle, (0, _extends2.default)({
            ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants = [] } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, _extends2.default)({
                ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, _extends2.default)({
                    ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
            theme: resolveTheme((0, _extends2.default)({}, props, {
                defaultTheme,
                themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngine.default)(tag, (0, _extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) return (props)=>processStyleArg(stylesArg, (0, _extends2.default)({}, props, {
                    theme: resolveTheme({
                        theme: props.theme,
                        defaultTheme,
                        themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = resolveTheme((0, _extends2.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2.default)({}, props, {
                        theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = resolveTheme((0, _extends2.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return processStyleArg({
                    variants: themeVariants
                }, (0, _extends2.default)({}, props, {
                    theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

},{"de1391ba5333f89c":"hykHy","b05e701df06cf2b8":"cootg","1c23f895f04bb1f8":"9rfl0","474b747b46951daf":"8mH2X","e7e859a1b9e6ab40":"5eIl7","8202cda0a3f0a433":"zPeBW","ba8df200ce7809c8":"hXiYE","e9a196e78b4b1fc3":"aL8dX","60bc7d9f0f1dc713":"fRzFg"}],"9rfl0":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"53WDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slotShouldForwardProp = require("./slotShouldForwardProp");
var _slotShouldForwardPropDefault = parcelHelpers.interopDefault(_slotShouldForwardProp);
const rootShouldForwardProp = (prop)=>(0, _slotShouldForwardPropDefault.default)(prop) && prop !== "classes";
exports.default = rootShouldForwardProp;

},{"./slotShouldForwardProp":"8PiTo","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8PiTo":[function(require,module,exports) {
// copied from @mui/system/createStyled
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
exports.default = slotShouldForwardProp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9WAlV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ThemeProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "theme"
];
function ThemeProvider(_ref) {
    let { theme: themeInput } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const scopedTheme = themeInput[0, _identifierDefault.default];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.ThemeProvider), (0, _extendsDefault.default)({}, props, {
        themeId: scopedTheme ? (0, _identifierDefault.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","@mui/system":"6hP1D","./identifier":"kUFJp","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4u1Fj":[function(require,module,exports) {
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
exports.default = getOverlayAlpha;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fTbCF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "linkClasses", ()=>(0, _linkClassesDefault.default));
var _link = require("./Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _linkClasses = require("./linkClasses");
var _linkClassesDefault = parcelHelpers.interopDefault(_linkClasses);
parcelHelpers.exportAll(_linkClasses, exports);
"use client";

},{"./Link":"b2LXr","./linkClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b2LXr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _linkClasses = require("./linkClasses");
var _linkClassesDefault = parcelHelpers.interopDefault(_linkClasses);
var _getTextDecoration = require("./getTextDecoration");
var _getTextDecorationDefault = parcelHelpers.interopDefault(_getTextDecoration);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, component, focusVisible, underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, _capitalizeDefault.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _linkClasses.getLinkUtilityClass), classes);
};
const LinkRoot = (0, _styledDefault.default)((0, _typographyDefault.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, _capitalizeDefault.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme, ownerState })=>{
    return (0, _extendsDefault.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, _extendsDefault.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, _getTextDecorationDefault.default)({
            theme,
            ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, _linkClassesDefault.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const Link = /*#__PURE__*/ _react.forwardRef(function Link(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className, color = "primary", component = "a", onBlur, onFocus, TypographyClasses, underline = "always", variant = "inherit", sx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    const [focusVisible, setFocusVisible] = _react.useState(false);
    const handlerRef = (0, _useForkRefDefault.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        focusVisible,
        underline,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkRoot, (0, _extendsDefault.default)({
        color: color,
        className: (0, _clsxDefault.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, _getTextDecoration.colorTransformations)).includes(color) ? [
                {
                    color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
exports.default = Link;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/elementTypeAcceptingRef":"cSxw6","@mui/utils/composeClasses":"jj3MR","../utils/capitalize":"iHgWG","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/useIsFocusVisible":"c4NVG","../utils/useForkRef":"5kA2S","../Typography":"f5srd","./linkClasses":"c7IiM","./getTextDecoration":"4rGAL","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iHgWG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
exports.default = (0, _capitalizeDefault.default);

},{"@mui/utils/capitalize":"zPeBW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c4NVG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useIsFocusVisible = require("@mui/utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
"use client";
exports.default = (0, _useIsFocusVisibleDefault.default);

},{"@mui/utils/useIsFocusVisible":"1ARPj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5kA2S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
"use client";
exports.default = (0, _useForkRefDefault.default);

},{"@mui/utils/useForkRef":"7x3cc","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f5srd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "typographyClasses", ()=>(0, _typographyClassesDefault.default));
var _typography = require("./Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _typographyClasses = require("./typographyClasses");
var _typographyClassesDefault = parcelHelpers.interopDefault(_typographyClasses);
parcelHelpers.exportAll(_typographyClasses, exports);
"use client";

},{"./Typography":"9nv99","./typographyClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9nv99":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypographyRoot", ()=>TypographyRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _typographyClasses = require("./typographyClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const useUtilityClasses = (ownerState)=>{
    const { align, gutterBottom, noWrap, paragraph, variant, classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, _capitalizeDefault.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _typographyClasses.getTypographyUtilityClass), classes);
};
const TypographyRoot = (0, _styledDefault.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, _capitalizeDefault.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const transformDeprecatedColors = (color)=>{
    return colorTransformations[color] || color;
};
const Typography = /*#__PURE__*/ _react.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = transformDeprecatedColors(themeProps.color);
    const props = (0, _styleFunctionSx.extendSxProp)((0, _extendsDefault.default)({}, themeProps, {
        color
    }));
    const { align = "inherit", className, component, gutterBottom = false, noWrap = false, paragraph = false, variant = "body1", variantMapping = defaultVariantMapping } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        align,
        color,
        className,
        component,
        gutterBottom,
        noWrap,
        paragraph,
        variant,
        variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || defaultVariantMapping[variant]) || "span";
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypographyRoot, (0, _extendsDefault.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other));
});
exports.default = Typography;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/system/styleFunctionSx":"fRzFg","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","./typographyClasses":"d4J5X","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"d4J5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypographyUtilityClass", ()=>getTypographyUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTypographyUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTypography", slot);
}
const typographyClasses = (0, _generateUtilityClassesDefault.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
exports.default = typographyClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c7IiM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLinkUtilityClass", ()=>getLinkUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getLinkUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiLink", slot);
}
const linkClasses = (0, _generateUtilityClassesDefault.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
exports.default = linkClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4rGAL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorTransformations", ()=>colorTransformations);
var _system = require("@mui/system");
var _colorManipulator = require("@mui/system/colorManipulator");
const colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const transformDeprecatedColors = (color)=>{
    return colorTransformations[color] || color;
};
const getTextDecoration = ({ theme, ownerState })=>{
    const transformedColor = transformDeprecatedColors(ownerState.color);
    const color = (0, _system.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, _system.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, _colorManipulator.alpha)(color, 0.4);
};
exports.default = getTextDecoration;

},{"@mui/system":"6hP1D","@mui/system/colorManipulator":"9FSVd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4d7LG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "boxClasses", ()=>(0, _boxClassesDefault.default));
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
parcelHelpers.exportAll(_boxClasses, exports);
"use client";

},{"./Box":"1hpPD","./boxClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1hpPD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _system = require("@mui/system");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _className = require("../className");
var _styles = require("../styles");
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
"use client";
const defaultTheme = (0, _styles.createTheme)();
const Box = (0, _system.createBox)({
    themeId: (0, _identifierDefault.default),
    defaultTheme,
    defaultClassName: (0, _boxClassesDefault.default).root,
    generateClassName: (0, _className.unstable_ClassNameGenerator).generate
});
exports.default = Box;

},{"@mui/system":"6hP1D","prop-types":"hRUel","../className":"7Owjc","../styles":"51PGx","../styles/identifier":"kUFJp","./boxClasses":"76tO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7Owjc":[function(require,module,exports) {
// eslint-disable-next-line import/prefer-default-export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _utils.unstable_ClassNameGenerator));
var _utils = require("@mui/utils");

},{"@mui/utils":"97HmB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"76tO9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const boxClasses = (0, _generateUtilityClassesDefault.default)("MuiBox", [
    "root"
]);
exports.default = boxClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dFBFD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OasisIcon", ()=>OasisIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
const OasisIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgIconDefault.default), {
        ...props,
        viewBox: "145 145 790 790",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M819.3,266.28c-32.86-33.52-71.73-61.06-114.78-81.11-1.75-.9-3.53-1.72-5.37-2.49-8.46-3.78-17.01-7.38-25.77-10.56-24.51-8.91-50.16-15.41-76.66-19.28-18.53-2.7-37.46-4.16-56.72-4.16-215.77,0-391.32,175.54-391.32,391.32,0,168.1,106.56,311.76,255.67,367.04,17.54,6.5,35.67,11.76,54.28,15.71,26.26,5.58,53.47,8.57,81.36,8.57,148.63,0,278.16-83.31,344.39-205.68,29.91-55.27,46.93-118.5,46.93-185.64,0-106.47-42.79-203.09-112.02-273.72ZM265.4,749.35c-46.24-60.99-70.68-133.75-70.68-210.42,0-130.92,72.58-245.19,179.61-304.7,2.83-1.58,5.63,2.18,3.27,4.4-9.78,9.21-19.16,19.05-28.13,29.53-62.03,72.55-97.77,171.21-98.08,270.77,0,129.26,86.46,268.77,226.15,268.77,124.66,0,226.07-120.57,226.07-268.77,0-69.63-23.34-136.49-63.2-186.11-1.41-1.75.26-4.23,2.41-3.6,67.38,19.93,117.77,97.42,117.77,189.71,0,81.48-29.56,162.59-81.11,222.56-53.43,62.15-125.15,96.4-201.94,96.43-80.87,0-158.26-39.65-212.15-108.56ZM820.8,328.72c46.2,60.84,70.58,133.49,70.51,210.14,0,130.91-72.58,245.19-179.62,304.7-2.83,1.58-5.63-2.18-3.27-4.4,9.78-9.21,19.16-19.06,28.13-29.53,62.03-72.54,97.77-171.21,98.08-270.77,0-129.26-86.46-268.77-226.15-268.77-124.66,0-226.07,120.57-226.07,268.77,0,69.63,23.35,136.5,63.21,186.12,1.4,1.75-.26,4.23-2.41,3.6-67.39-19.92-117.78-97.39-117.78-189.64,0-81.46,29.56-162.56,81.12-222.51,53.45-62.16,125.19-96.4,202.01-96.4,80.81,0,158.17,39.62,212.25,108.69ZM662.71,538.93c0,92.31-44.84,171.97-109.11,207.74-7.96,4.43-17.77,3.88-25.14-1.49l-13.75-10.03c-56.37-41.13-91.39-116.35-91.39-196.29,0-92.3,44.84-171.96,109.12-207.73,7.97-4.43,17.78-3.88,25.14,1.49l13.74,10.03c56.37,41.13,91.39,116.34,91.39,196.29Z"
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eu9eC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _svgIconDefault.default));
parcelHelpers.export(exports, "svgIconClasses", ()=>(0, _svgIconClassesDefault.default));
var _svgIcon = require("./SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _svgIconClasses = require("./svgIconClasses");
var _svgIconClassesDefault = parcelHelpers.interopDefault(_svgIconClasses);
parcelHelpers.exportAll(_svgIconClasses, exports);
"use client";

},{"./SvgIcon":"jhGRb","./svgIconClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jhGRb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _svgIconClasses = require("./svgIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, _capitalizeDefault.default)(color)}`,
            `fontSize${(0, _capitalizeDefault.default)(fontSize)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _svgIconClasses.getSvgIconUtilityClass), classes);
};
const SvgIconRoot = (0, _styledDefault.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalizeDefault.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const SvgIcon = /*#__PURE__*/ _react.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children, className, color = "inherit", component = "svg", fontSize = "medium", htmlColor, inheritViewBox = false, titleAccess, viewBox = "0 0 24 24" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const hasSvgAsChild = /*#__PURE__*/ _react.isValidElement(children) && children.type === "svg";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox,
        viewBox,
        hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SvgIconRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
SvgIcon.muiName = "SvgIcon";
exports.default = SvgIcon;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../utils/capitalize":"iHgWG","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./svgIconClasses":"ceBm6","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ceBm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSvgIconUtilityClass", ()=>getSvgIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSvgIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSvgIcon", slot);
}
const svgIconClasses = (0, _generateUtilityClassesDefault.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
exports.default = svgIconClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9lcz2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExplorerIcon", ()=>ExplorerIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
const ExplorerIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _svgIconDefault.default), {
        ...props,
        viewBox: "0 0 782.02 146.19",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M125.26,21.97c-6.14-6.26-13.4-11.41-21.44-15.15-.33-.17-.66-.32-1-.47-1.58-.71-3.18-1.38-4.81-1.97-4.58-1.66-9.37-2.88-14.32-3.6-3.46-.5-7-.78-10.6-.78C32.79,0,0,32.79,0,73.09c0,31.4,19.9,58.23,47.76,68.56,3.28,1.21,6.66,2.2,10.14,2.93,4.91,1.04,9.99,1.6,15.2,1.6,27.76,0,51.96-15.56,64.33-38.42,5.59-10.32,8.77-22.14,8.77-34.68,0-19.89-7.99-37.94-20.92-51.13ZM21.8,112.2c-8.64-11.39-13.2-24.98-13.2-39.3,0-24.45,13.56-45.8,33.55-56.91,.53-.29,1.05,.41,.61,.82-1.83,1.72-3.58,3.56-5.25,5.52-11.59,13.55-18.26,31.98-18.32,50.58,0,24.14,16.15,50.2,42.24,50.2,23.28,0,42.23-22.52,42.23-50.2,0-13.01-4.36-25.5-11.81-34.76-.26-.33,.05-.79,.45-.67,12.59,3.72,22,18.2,22,35.44,0,15.22-5.52,30.37-15.15,41.57-9.98,11.61-23.38,18.01-37.72,18.01-15.1,0-29.56-7.41-39.63-20.28ZM125.54,33.63c8.63,11.36,13.18,24.94,13.17,39.25,0,24.45-13.56,45.8-33.55,56.92-.53,.29-1.05-.41-.61-.82,1.83-1.72,3.58-3.56,5.25-5.52,11.59-13.55,18.26-31.98,18.32-50.58,0-24.14-16.15-50.2-42.24-50.2-23.28,0-42.23,22.52-42.23,50.2,0,13.01,4.36,25.5,11.81,34.77,.26,.33-.05,.79-.45,.67-12.59-3.72-22-18.19-22-35.42,0-15.22,5.52-30.37,15.15-41.56,9.98-11.61,23.38-18.01,37.73-18.01,15.09,0,29.54,7.4,39.65,20.3Zm-29.53,39.27c0,17.24-8.38,32.12-20.38,38.8-1.49,.83-3.32,.72-4.7-.28l-2.57-1.87c-10.53-7.68-17.07-21.73-17.07-36.67,0-17.24,8.38-32.12,20.38-38.8,1.49-.83,3.32-.72,4.7,.28l2.57,1.87c10.53,7.68,17.07,21.73,17.07,36.66Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M206.83,50.96c-3.26-2.09-7.08-3.13-11.44-3.13s-8.19,1.04-11.48,3.13c-3.29,2.09-5.83,5.07-7.63,8.96-1.8,3.89-2.7,8.52-2.7,13.89s.9,9.93,2.7,13.82c1.8,3.89,4.34,6.88,7.63,8.99,3.29,2.11,7.11,3.17,11.48,3.17s8.18-1.05,11.44-3.17c3.26-2.11,5.8-5.11,7.63-8.99,1.82-3.89,2.73-8.49,2.73-13.82s-.91-10.06-2.73-13.92c-1.82-3.86-4.37-6.84-7.63-8.92Zm-1.91,32.2c-.93,2.59-2.23,4.57-3.89,5.94-1.65,1.37-3.54,2.05-5.65,2.05s-4.01-.68-5.68-2.05c-1.68-1.37-2.99-3.35-3.92-5.94-.94-2.59-1.4-5.71-1.4-9.35s.47-6.76,1.4-9.35c.93-2.59,2.24-4.57,3.92-5.94,1.68-1.37,3.57-2.05,5.68-2.05s3.99,.68,5.65,2.05c1.66,1.37,2.95,3.33,3.89,5.9,.94,2.57,1.4,5.7,1.4,9.39s-.47,6.76-1.4,9.35Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M235.85,50.42l-12.33,45.55c-.4,1.49,.72,2.95,2.25,2.95h5.51c1.06,0,1.99-.72,2.26-1.74l1.89-7.17c.27-1.03,1.2-1.74,2.26-1.74h12.57c1.07,0,2,.72,2.26,1.75l1.85,7.15c.27,1.03,1.2,1.75,2.26,1.75h5.78c1.54,0,2.66-1.46,2.25-2.95l-12.4-45.55c-.28-1.02-1.2-1.72-2.25-1.72h-11.9c-1.05,0-1.98,.71-2.25,1.73Zm5.33,29.21c-1.53,0-2.65-1.45-2.26-2.93l2.07-7.86,.75-3.13c.57-2.39,3.97-2.39,4.54,0l.75,3.13,2.03,7.87c.38,1.48-.73,2.92-2.26,2.92h-5.63Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M321.01,51.03v3.96c0,1.29,1.05,2.34,2.34,2.34h3.75c1.29,0,2.34,1.05,2.34,2.34v28.28c0,1.29-1.05,2.34-2.34,2.34h-3.75c-1.29,0-2.34,1.05-2.34,2.34v3.96c0,1.29,1.05,2.34,2.34,2.34h22.6c1.29,0,2.34-1.05,2.34-2.34v-3.96c0-1.29-1.05-2.34-2.34-2.34h-3.75c-1.29,0-2.34-1.05-2.34-2.34v-28.28c0-1.29,1.05-2.34,2.34-2.34h3.75c1.29,0,2.34-1.05,2.34-2.34v-3.96c0-1.29-1.05-2.34-2.34-2.34h-22.6c-1.29,0-2.34,1.05-2.34,2.34Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M395.58,77.72c-.98-1.85-2.28-3.33-3.89-4.46-1.61-1.13-3.36-2.01-5.25-2.66-1.9-.65-3.8-1.2-5.72-1.65s-3.68-.94-5.29-1.44c-1.61-.5-2.89-1.16-3.85-1.98-.96-.81-1.44-1.89-1.44-3.24,0-1.87,.71-3.31,2.12-4.32,1.41-1.01,3.2-1.51,5.36-1.51,1.49,0,2.89,.25,4.14,.9,1.65,.87,2.78,2.2,3.41,3.15,.43,.65,1.16,1.03,1.94,1.03h6.3c1.63,0,2.8-1.64,2.19-3.16-.43-1.08-.97-2.08-1.64-3-1.77-2.45-4.09-4.32-6.94-5.61-2.85-1.3-5.98-1.94-9.39-1.94-3.69,0-6.91,.65-9.64,1.94-2.73,1.29-4.86,3.06-6.37,5.29-1.51,2.23-2.27,4.74-2.27,7.52s.48,4.9,1.44,6.65c.96,1.75,2.24,3.16,3.85,4.21,1.61,1.06,3.37,1.92,5.29,2.59,1.92,.67,3.83,1.25,5.72,1.73,1.9,.48,3.65,1,5.25,1.55,1.61,.55,2.89,1.26,3.85,2.12,.96,.86,1.44,2.01,1.44,3.45,0,1.97-.73,3.5-2.19,4.61-1.46,1.1-3.42,1.65-5.86,1.65-3.02,0-5.32-.89-6.91-2.66-.66-.74-1.17-1.63-1.54-2.66-.37-1.01-1.3-1.69-2.38-1.69h-5.67c-1.56,0-2.67,1.49-2.25,2.99,.38,1.36,.89,2.64,1.54,3.81,1.58,2.83,3.84,5.01,6.76,6.55,2.93,1.53,6.41,2.3,10.43,2.3,3.65,0,6.9-.64,9.75-1.91,2.85-1.27,5.1-3.02,6.73-5.25,1.63-2.23,2.45-4.83,2.45-7.81s-.49-5.24-1.48-7.09Z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M309.49,77.72c-.98-1.85-2.28-3.33-3.89-4.46-1.61-1.13-3.36-2.01-5.25-2.66-1.9-.65-3.8-1.2-5.72-1.65-1.92-.46-3.68-.94-5.29-1.44-1.61-.5-2.89-1.16-3.85-1.98-.96-.81-1.44-1.89-1.44-3.24,0-1.87,.71-3.31,2.12-4.32,1.41-1.01,3.2-1.51,5.36-1.51,1.49,0,2.89,.25,4.14,.9,1.65,.87,2.78,2.2,3.41,3.15,.43,.65,1.16,1.03,1.94,1.03h6.3c1.63,0,2.8-1.64,2.19-3.16-.43-1.08-.97-2.08-1.64-3-1.77-2.45-4.09-4.32-6.94-5.61-2.85-1.3-5.98-1.94-9.39-1.94-3.69,0-6.91,.65-9.64,1.94-2.73,1.29-4.86,3.06-6.37,5.29-1.51,2.23-2.27,4.74-2.27,7.52s.48,4.9,1.44,6.65c.96,1.75,2.24,3.16,3.85,4.21,1.61,1.06,3.37,1.92,5.29,2.59,1.92,.67,3.83,1.25,5.72,1.73,1.9,.48,3.65,1,5.25,1.55,1.61,.55,2.89,1.26,3.85,2.12,.96,.86,1.44,2.01,1.44,3.45,0,1.97-.73,3.5-2.19,4.61-1.46,1.1-3.42,1.65-5.86,1.65-3.02,0-5.32-.89-6.91-2.66-.66-.74-1.17-1.63-1.54-2.66-.37-1.01-1.3-1.69-2.38-1.69h-5.67c-1.56,0-2.67,1.49-2.25,2.99,.38,1.36,.89,2.64,1.54,3.81,1.58,2.83,3.84,5.01,6.76,6.55,2.93,1.53,6.41,2.3,10.43,2.3,3.65,0,6.9-.64,9.75-1.91,2.85-1.27,5.1-3.02,6.73-5.25,1.63-2.23,2.45-4.83,2.45-7.81s-.49-5.24-1.48-7.09Z"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M425.06,75.81h17.98c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-17.98c-.87,0-1.58-.71-1.58-1.58v-14.53c0-.87,.71-1.58,1.58-1.58h26.75c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-29.49c-1.98,0-3.59,1.61-3.59,3.59v45.02c0,.87,.71,1.58,1.58,1.58h31.79c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-27.04c-.87,0-1.58-.71-1.58-1.58v-16.4c0-.87,.71-1.58,1.58-1.58Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M497.27,49.5h-.26c-.74,0-1.42,.37-1.82,.99l-7.42,11.59-4.13,6.47c-.62,.97-2.05,.97-2.67,0l-4.06-6.39-7.42-11.66c-.4-.62-1.08-1-1.82-1h-.43c-1.7,0-2.73,1.88-1.82,3.31l12.96,20.43c.33,.52,.33,1.18,0,1.69l-13.61,21.44c-.91,1.44,.12,3.31,1.82,3.31h.23c.73,0,1.41-.37,1.81-.98l8.35-12.83,3.99-6.47c.61-1,2.06-1,2.68-.01l4.04,6.41,8.21,12.88c.4,.62,1.08,1,1.82,1h.36c1.7,0,2.73-1.88,1.82-3.31l-13.76-21.72c-.33-.52-.33-1.18,0-1.7l12.93-20.13c.92-1.44-.11-3.32-1.82-3.32Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M540.23,51.33c-2.52-1.22-5.48-1.83-8.88-1.83h-14.54c-2.34,0-4.23,1.9-4.23,4.23v43.8c0,1.19,.97,2.16,2.16,2.16h.5c1.19,0,2.16-.97,2.16-2.16v-16.32c0-.87,.71-1.58,1.58-1.58h11.29c3.55,0,6.67-.63,9.38-1.9,2.71-1.27,4.81-3.04,6.29-5.32,1.48-2.27,2.23-4.93,2.23-7.95s-.7-5.72-2.09-7.95c-1.39-2.23-3.34-3.96-5.86-5.18Zm-.75,21c-2.35,1.99-5.44,2.98-9.28,2.98h-11.22c-.87,0-1.58-.71-1.58-1.58v-18.34c0-.87,.71-1.58,1.58-1.58h12.37c3.5,0,6.32,.97,8.45,2.91,2.13,1.94,3.2,4.52,3.2,7.73s-1.17,5.89-3.52,7.87Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M564.35,49.5h-.5c-1.19,0-2.16,.97-2.16,2.16v46.45c0,.87,.71,1.58,1.58,1.58h28.69c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-23.87c-.87,0-1.58-.71-1.58-1.58V51.65c0-1.19-.97-2.16-2.16-2.16Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M633.53,51.83c-3.07-2.13-6.69-3.2-10.86-3.2s-7.79,1.07-10.86,3.2c-3.07,2.13-5.44,5.15-7.12,9.06-1.68,3.91-2.52,8.47-2.52,13.7s.84,9.78,2.52,13.66c1.68,3.88,4.05,6.9,7.12,9.06,3.07,2.16,6.69,3.23,10.86,3.23s7.79-1.08,10.86-3.23c3.07-2.16,5.44-5.18,7.12-9.06,1.68-3.88,2.52-8.44,2.52-13.66s-.84-9.79-2.52-13.7c-1.68-3.91-4.05-6.93-7.12-9.06Zm2.62,34.12c-1.27,3.26-3.06,5.79-5.36,7.59-2.3,1.8-5.01,2.7-8.13,2.7s-5.82-.9-8.12-2.7c-2.3-1.8-4.09-4.33-5.36-7.59-1.27-3.26-1.9-7.05-1.9-11.36s.64-8.1,1.9-11.36c1.27-3.26,3.06-5.79,5.36-7.58,2.3-1.8,5.01-2.7,8.12-2.7s5.83,.9,8.13,2.7c2.3,1.8,4.09,4.31,5.36,7.55,1.27,3.24,1.91,7.04,1.91,11.4s-.64,8.1-1.91,11.36Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M705.5,75.81h17.98c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-17.98c-.87,0-1.58-.71-1.58-1.58v-14.53c0-.87,.71-1.58,1.58-1.58h26.75c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-29.49c-1.98,0-3.59,1.61-3.59,3.59v43.01c0,1.98,1.61,3.59,3.59,3.59h29.78c1.19,0,2.16-.97,2.16-2.16h0c0-1.19-.97-2.16-2.16-2.16h-27.04c-.87,0-1.58-.71-1.58-1.58v-16.4c0-.87,.71-1.58,1.58-1.58Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M777.13,72.87c1.58-1.34,2.79-2.86,3.63-4.57,.84-1.7,1.26-3.49,1.26-5.36,0-2.83-.71-5.25-2.12-7.26-1.41-2.01-3.34-3.55-5.79-4.6-2.44-1.05-5.2-1.58-8.27-1.58h-16.92c-1.26,0-2.28,1.02-2.28,2.28v45.63c0,1.26,1.02,2.28,2.28,2.28h.19c1.26,0,2.28-1.02,2.28-2.28v-17.95c0-1.26,1.02-2.28,2.28-2.28h4.21c1.45,0,2.81,.67,3.7,1.82l15.28,19.81c.43,.56,1.1,.89,1.8,.89h0c1.89,0,2.96-2.18,1.8-3.67l-13.03-16.84c-.66-.85-.19-2.11,.87-2.3,.95-.17,2.04-.43,3.04-.84,2.28-.77,4.21-1.82,5.79-3.16Zm-13.45,.07h-9.78c-1.39,0-2.52-1.13-2.52-2.52v-14.98c0-.9,.73-1.63,1.63-1.63h12.82c2.01,0,3.86,.37,5.54,1.11,1.68,.74,3.02,1.79,4.03,3.13,1.01,1.34,1.51,2.97,1.51,4.89,0,2.01-.58,3.78-1.73,5.28-1.15,1.51-2.71,2.67-4.67,3.49-1.97,.82-4.24,1.22-6.83,1.22Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M683.65,72.87c1.58-1.34,2.79-2.86,3.63-4.57,.84-1.7,1.26-3.49,1.26-5.36,0-2.83-.71-5.25-2.12-7.26-1.41-2.01-3.34-3.55-5.79-4.6-2.44-1.05-5.2-1.58-8.27-1.58h-16.92c-1.26,0-2.28,1.02-2.28,2.28v45.63c0,1.26,1.02,2.28,2.28,2.28h.19c1.26,0,2.28-1.02,2.28-2.28v-17.95c0-1.26,1.02-2.28,2.28-2.28h4.21c1.45,0,2.81,.67,3.7,1.82l15.28,19.81c.43,.56,1.1,.89,1.8,.89h0c1.89,0,2.96-2.18,1.8-3.67l-13.03-16.84c-.66-.85-.19-2.11,.87-2.3,.95-.17,2.04-.43,3.04-.84,2.28-.77,4.21-1.82,5.79-3.16Zm-13.45,.07h-9.78c-1.39,0-2.52-1.13-2.52-2.52v-14.98c0-.9,.73-1.63,1.63-1.63h12.82c2.01,0,3.86,.37,5.54,1.11,1.68,.74,3.02,1.79,4.03,3.13,1.01,1.34,1.51,2.97,1.51,4.89,0,2.01-.58,3.78-1.73,5.28-1.15,1.51-2.71,2.67-4.67,3.49-1.97,.82-4.24,1.22-6.83,1.22Z"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i0F34":[function(require,module,exports) {
module.exports = require("80daab927b9b181c").getBundleURL("sif1r") + "background.7652ee9a.svg";

},{"80daab927b9b181c":"ccgWN"}],"hYvW2":[function(require,module,exports) {
// Name of the colors -> https://www.color-name.com/
// For consistency use lowercase characters
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLORS", ()=>COLORS);
const COLORS = {
    antiFlashWhite2: "#f1f4f9",
    antiFlashWhite3: "#f0f3f5",
    antiFlashWhite: "#ecf1f6",
    brandDark: "#3333c4",
    brandExtraDark: "#000062",
    brandExtraLight: "#e5e5ef",
    brandLight: "#6665d8",
    brandLightBlue: "#E8F5FF",
    brandMedium: "#0092f6",
    brandMedium15: "#d9effe",
    brightGray2: "#ececec",
    brightGray: "#e6edf3",
    ceil: "#8f8cdf",
    cosmicCobalt: "#222199",
    darkBlueGray: "#5c6098",
    darkBlue: "#030092",
    error: "#d32f2f",
    eucalyptus: "#4cd4a9",
    grayDark: "#31435a",
    grayExtraDark: "#06152b",
    grayLight: "#f4f5f7",
    grayMedium: "#565b61",
    grayMedium2: "#d5d6d7",
    grayMediumLight: "#e3e8ed",
    honeydew: "#e8faf3",
    lavenderGray: "#c5c7ca",
    lightGreen: "#e0f5ee",
    lightSilver: "#d9d9d9",
    linen: "#fae8e8",
    // persianBlue: '#3038c3', use brandDark instead
    platinum: "#e2e2e2",
    vistaBlue: "#8988dd",
    white: "#ffffff",
    white025A: "#ffffff40",
    spaceCadet: "#0f0f5f",
    denimBlue: "#3138bc",
    disabledPagination: "#7575a7",
    purpleBackground: "#e0e0f4",
    inactiveTab: "#e5e5f6",
    disabledPrimaryBackground: "#acadb0",
    disabledPrimaryText: "#d5d6d7",
    errorIndicatorBackground: "#d44c4c",
    aqua: "#00feff",
    shadowBlue: "#8484ab",
    black: "#000000",
    warningColor: "#ed6c02",
    warningBackground: "#faf5e8",
    warningLight: "#fff0e4",
    iconBackground: "#d4d3f2",
    graphLabel: "#191932",
    graphLine: "#01F1E3",
    paraTimeStatus: "#8081ac",
    pink: "#ed32fa",
    pink15: "#fce0fe"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fVJkU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchButton", ()=>SearchButton);
parcelHelpers.export(exports, "Search", ()=>Search);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _search = require("@mui/icons-material/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _reactI18Next = require("react-i18next");
var _colors = require("../../../styles/theme/colors");
var _routeUtils = require("../../utils/route-utils");
var _useScreensize = require("../../hooks/useScreensize");
var _highlightOff = require("@mui/icons-material/HighlightOff");
var _highlightOffDefault = parcelHelpers.interopDefault(_highlightOff);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _searchSuggestionsButtons = require("./SearchSuggestionsButtons");
var _formHelperText = require("@mui/material/FormHelperText");
var _outlinedInput = require("@mui/material/OutlinedInput");
var _searchUtils = require("./search-utils");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _helpers = require("../../utils/helpers");
var _theme = require("../../../styles/theme");
var _collapse = require("@mui/material/Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _config = require("../../../config");
const SearchForm = (0, _styles.styled)("form", {
    shouldForwardProp: (prop)=>![
            "searchVariant"
        ].includes(prop)
})(({ searchVariant })=>({
        // Approximate size of TextField without helperText, so helperText floats.
        height: "47px",
        ...searchVariant === "expandable" ? {
            position: "absolute",
            zIndex: 1,
            // Collapsed
            ":not(:hover, :focus-within)": {
                [`.${(0, _textField.textFieldClasses).root}`]: {
                    [`input, .${(0, _formHelperText.formHelperTextClasses).root}, .${(0, _outlinedInput.outlinedInputClasses).notchedOutline}`]: {
                        display: "none"
                    },
                    [`.${(0, _inputAdornment.inputAdornmentClasses).positionEnd}`]: {
                        marginLeft: 0
                    }
                }
            },
            // Expanded
            ":hover, :focus-within": {
                left: 0,
                width: "100%"
            }
        } : {
            position: "relative",
            width: "100%"
        }
    }));
const SearchButton = (0, _styles.styled)((0, _buttonDefault.default), {
    shouldForwardProp: (prop)=>![
            "searchVariant"
        ].includes(prop)
})(({ theme, searchVariant })=>({
        minWidth: "unset",
        padding: "12px",
        [theme.breakpoints.up("sm")]: {
            ...searchVariant === "button" ? {
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5)
            } : {}
        },
        ...searchVariant === "expandable" ? {
            backgroundColor: (0, _colors.COLORS).brandDark
        } : {}
    }));
SearchButton.defaultProps = {
    variant: "contained",
    color: "primary"
};
const SearchCmp = ({ scope, variant, disabled, onFocusChange: onFocusChangeProp })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const searchPlaceholderTranslated = isMobile ? t("search.mobilePlaceholder") : t("search.placeholder");
    const [value, setValue] = (0, _react.useState)("");
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    const valueInSearchParams = (0, _reactRouterDom.useSearchParams)()[0].get("q") ?? "";
    const [isProblemFresh, setIsProblemFresh] = (0, _react.useState)(false);
    const wordsOfPower = t("search.wordsOfPower");
    const hasWordsOfPower = value.trim().toLowerCase().startsWith(wordsOfPower.toLowerCase());
    const valueWithoutPrefix = hasWordsOfPower ? value.trim().substring(wordsOfPower.length).trim() : value.trim();
    const isTooShort = !!value && valueWithoutPrefix.length < (0, _searchUtils.textSearchMininumLength) && !(0, _helpers.isValidBlockHeight)(valueWithoutPrefix);
    const hasPrivacyProblem = !hasWordsOfPower && (0, _helpers.isValidMnemonic)(valueWithoutPrefix);
    (0, _react.useEffect)(()=>{
        setValue(hasWordsOfPower ? `${wordsOfPower} ${valueInSearchParams}` : valueInSearchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        valueInSearchParams
    ]) // We only want to update the value from code when the URL changes
    ;
    const onChange = (newValue)=>{
        setValue(newValue);
    };
    const onFocusChange = (value)=>{
        setIsFocused(value);
        onFocusChangeProp?.(value);
    };
    const onFormSubmit = (e)=>{
        e?.preventDefault();
        if (value) navigate((0, _routeUtils.RouteUtils).getSearchRoute(scope, valueWithoutPrefix));
    };
    const onClearValue = ()=>{
        setValue("");
    };
    const startAdornment = variant === "button" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
        position: "start",
        disablePointerEvents: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {
            sx: {
                color: isFocused ? (0, _colors.COLORS).grayMediumLight : (0, _colors.COLORS).grayDark
            }
        })
    });
    const searchButtonContent = variant !== "button" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {
        sx: {
            color: (0, _colors.COLORS).grayMediumLight
        }
    }) : t("search.searchBtnText");
    const errorMessage = isTooShort ? t("search.error.tooShort") : undefined;
    const hasError = !!errorMessage;
    const warningMessage = hasPrivacyProblem ? t("search.error.privacy", {
        appName: (0, _config.getAppTitle)(),
        wordsOfPower
    }) : undefined;
    const hasWarning = !!warningMessage;
    const hasProblem = hasError || hasWarning;
    (0, _react.useEffect)(()=>{
        if (hasProblem) {
            const timeout = setTimeout(()=>{
                setIsProblemFresh(false);
            }, (0, _theme.typingDelay));
            return ()=>clearTimeout(timeout);
        } else setIsProblemFresh(true);
    }, [
        hasProblem
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchForm, {
        searchVariant: variant,
        onSubmit: onFormSubmit,
        role: "search",
        "aria-label": searchPlaceholderTranslated,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
            sx: {
                ...!isProblemFresh && hasWarning && !hasError ? {
                    [`& .${(0, _outlinedInput.outlinedInputClasses).error} .${(0, _outlinedInput.outlinedInputClasses).notchedOutline}`]: {
                        borderColor: (0, _colors.COLORS).warningColor
                    }
                } : {}
            },
            value: value,
            onChange: (e)=>onChange(e.target.value),
            error: !isProblemFresh && hasProblem,
            onFocus: ()=>onFocusChange(true),
            onBlur: ()=>onFocusChange(false),
            InputProps: {
                inputProps: {
                    sx: {
                        p: 0
                    }
                },
                startAdornment,
                endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                    position: "end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            value && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                color: "inherit",
                                onClick: onClearValue,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightOffDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchButton, {
                                disabled: disabled || hasProblem,
                                searchVariant: variant,
                                type: "submit",
                                children: searchButtonContent
                            })
                        ]
                    })
                })
            },
            placeholder: searchPlaceholderTranslated,
            fullWidth: true,
            FormHelperTextProps: {
                component: "div",
                sx: {
                    marginTop: 0,
                    marginBottom: 0,
                    marginLeft: variant === "button" ? "48px" : "17px",
                    marginRight: variant === "button" ? "48px" : "17px"
                }
            },
            helperText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                in: !!value && value !== valueInSearchParams,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        py: "10px"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                            in: !isProblemFresh && hasError,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                component: "span",
                                sx: {
                                    display: "inline-flex",
                                    color: (0, _colors.COLORS).errorIndicatorBackground,
                                    fontSize: 12,
                                    lineHeight: 2,
                                    alignItems: "center",
                                    verticalAlign: "middle",
                                    mt: 3,
                                    mb: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                                        sx: {
                                            mr: 3
                                        }
                                    }),
                                    errorMessage
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collapseDefault.default), {
                            in: !isProblemFresh && hasWarning,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                component: "span",
                                sx: {
                                    display: "inline-flex",
                                    color: (0, _colors.COLORS).warningColor,
                                    fontSize: 12,
                                    lineHeight: 2,
                                    alignItems: "center",
                                    verticalAlign: "middle",
                                    mt: 3,
                                    mb: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningDefault.default), {
                                        sx: {
                                            mr: 3
                                        }
                                    }),
                                    warningMessage
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSuggestionsButtons.SearchSuggestionsButtons), {
                            scope: scope,
                            onClickSuggestion: (suggestion)=>{
                                setValue(suggestion);
                            }
                        })
                    ]
                })
            })
        })
    });
};
const Search = /*#__PURE__*/ (0, _react.memo)(SearchCmp);

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","@mui/material/TextField":"3DXXm","@mui/material/InputAdornment":"crO57","@mui/material/styles":"51PGx","@mui/material/Button":"h2G5p","@mui/material/Box":"4d7LG","@mui/icons-material/Search":"3TS3l","react-i18next":"e210a","../../../styles/theme/colors":"hYvW2","../../utils/route-utils":"b2kKi","../../hooks/useScreensize":"2HEhN","@mui/icons-material/HighlightOff":"6SCXD","@mui/icons-material/Error":"dRT6j","@mui/icons-material/Warning":"bYx0X","@mui/material/IconButton":"hLmKV","./SearchSuggestionsButtons":"9eJ5u","@mui/material/FormHelperText":"g4yj4","@mui/material/OutlinedInput":"4FpQa","./search-utils":"bnM2G","@mui/material/Typography":"f5srd","../../utils/helpers":"2aVNs","../../../styles/theme":"i3yrR","@mui/material/Collapse":"j6nL1","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3DXXm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _textFieldDefault.default));
parcelHelpers.export(exports, "textFieldClasses", ()=>(0, _textFieldClassesDefault.default));
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textFieldClasses = require("./textFieldClasses");
var _textFieldClassesDefault = parcelHelpers.interopDefault(_textFieldClasses);
parcelHelpers.exportAll(_textFieldClasses, exports);
"use client";

},{"./TextField":"8gep7","./textFieldClasses":"iHJPa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8gep7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _filledInput = require("../FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _outlinedInput = require("../OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("../InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("../FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("../FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textFieldClasses = require("./textFieldClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const variantComponent = {
    standard: (0, _inputDefault.default),
    filled: (0, _filledInputDefault.default),
    outlined: (0, _outlinedInputDefault.default)
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _textFieldClasses.getTextFieldUtilityClass), classes);
};
const TextFieldRoot = (0, _styledDefault.default)((0, _formControlDefault.default), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const TextField = /*#__PURE__*/ _react.forwardRef(function TextField(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete, autoFocus = false, children, className, color = "primary", defaultValue, disabled = false, error = false, FormHelperTextProps, fullWidth = false, helperText, id: idOverride, InputLabelProps, inputProps, InputProps, inputRef, label, maxRows, minRows, multiline = false, name, onBlur, onChange, onFocus, placeholder, required = false, rows, select = false, SelectProps, type, value, variant = "outlined" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        color,
        disabled,
        error,
        fullWidth,
        multiline,
        required,
        select,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, _useIdDefault.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputComponent, (0, _extendsDefault.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TextFieldRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), (0, _extendsDefault.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _extendsDefault.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), (0, _extendsDefault.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
exports.default = TextField;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/utils/useId":"8BX8X","@mui/utils/refType":"l5hTY","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../Input":"5D6wd","../FilledInput":"kjWVZ","../OutlinedInput":"4FpQa","../InputLabel":"c5mlT","../FormControl":"3AAKV","../FormHelperText":"g4yj4","../Select":"itQ5O","./textFieldClasses":"iHJPa","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5D6wd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "inputClasses", ()=>(0, _inputClassesDefault.default));
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputClasses = require("./inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
parcelHelpers.exportAll(_inputClasses, exports);
"use client";

},{"./Input":"94CR2","./inputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"94CR2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _inputClasses = require("./inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
var _inputBase1 = require("../InputBase/InputBase");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _inputClasses.getInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const InputRoot = (0, _styledDefault.default)((0, _inputBase1.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _inputBase1.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, _extendsDefault.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, _inputClassesDefault.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, _inputClassesDefault.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, _inputClassesDefault.default).disabled}, .${(0, _inputClassesDefault.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, _inputClassesDefault.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const InputInput = (0, _styledDefault.default)((0, _inputBase1.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, _inputBase1.inputOverridesResolver)
})({});
const Input = /*#__PURE__*/ _react.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline, components = {}, componentsProps: componentsPropsProp, fullWidth = false, inputComponent = "input", multiline = false, slotProps, slots = {}, type = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const ownerState = {
        disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _deepmergeDefault.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : InputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
Input.muiName = "Input";
exports.default = Input;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/utils/composeClasses":"jj3MR","@mui/utils/deepmerge":"5eIl7","@mui/utils/refType":"l5hTY","../InputBase":"ffdXP","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./inputClasses":"4bEXJ","../InputBase/InputBase":"b6IV1","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ffdXP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputBaseDefault.default));
parcelHelpers.export(exports, "inputBaseClasses", ()=>(0, _inputBaseClassesDefault.default));
var _inputBase = require("./InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
parcelHelpers.exportAll(_inputBaseClasses, exports);
"use client";

},{"./InputBase":"b6IV1","./inputBaseClasses":"2O3eO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b6IV1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootOverridesResolver", ()=>rootOverridesResolver);
parcelHelpers.export(exports, "inputOverridesResolver", ()=>inputOverridesResolver);
parcelHelpers.export(exports, "InputBaseRoot", ()=>InputBaseRoot);
parcelHelpers.export(exports, "InputBaseComponent", ()=>InputBaseComponent);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _base = require("@mui/base");
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _utils1 = require("./utils");
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const rootOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const inputOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, _capitalizeDefault.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _inputBaseClasses.getInputBaseUtilityClass), classes);
};
const InputBaseRoot = (0, _styledDefault.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: rootOverridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const InputBaseComponent = (0, _styledDefault.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: inputOverridesResolver
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, _extendsDefault.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, _extendsDefault.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, _inputBaseClassesDefault.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const inputGlobalStyles = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const InputBase = /*#__PURE__*/ _react.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete, autoFocus, className, components = {}, componentsProps = {}, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, fullWidth = false, id, inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, slotProps = {}, slots = {}, startAdornment, type = "text", value: valueProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef();
    const handleInputRefWarning = _react.useCallback((instance)=>{}, []);
    const handleInputRef = (0, _useForkRefDefault.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = _react.useState(false);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    _react.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = _react.useCallback((obj)=>{
        if ((0, _utils1.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (isControlled) checkDirty({
            value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, _formatMuiErrorMessageDefault.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    _react.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, _extendsDefault.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, _extendsDefault.default)({
            type: undefined,
            maxRows,
            minRows
        }, inputProps);
        InputComponent = (0, _base.TextareaAutosize);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    _react.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        startAdornment,
        type
    });
    const classes = useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || InputBaseComponent;
    inputProps = (0, _extendsDefault.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            !disableInjectingGlobalStyles && inputGlobalStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _utils.isHostComponent)(Root) && {
                ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, _clsxDefault.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, (0, _extendsDefault.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, _utils.isHostComponent)(Input) && {
                            as: InputComponent,
                            ownerState: (0, _extendsDefault.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, _clsxDefault.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, _extendsDefault.default)({}, fcs, {
                        startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
exports.default = InputBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/formatMuiErrorMessage":"dmYrs","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/elementTypeAcceptingRef":"cSxw6","@mui/utils/refType":"l5hTY","@mui/base":"1g362","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","../FormControl/formControlState":"1tJK6","../FormControl/FormControlContext":"872Eo","../FormControl/useFormControl":"3uzwm","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","../utils/useForkRef":"5kA2S","../utils/useEnhancedEffect":"imwu2","../GlobalStyles":"d55tF","./utils":"3mLMB","./inputBaseClasses":"2O3eO","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1g362":[function(require,module,exports) {
/**
 * @mui/base v5.0.0-beta.40
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClickAwayListener", ()=>(0, _clickAwayListener.ClickAwayListener));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdown.Dropdown));
parcelHelpers.export(exports, "FocusTrap", ()=>(0, _focusTrap.FocusTrap));
parcelHelpers.export(exports, "NoSsr", ()=>(0, _noSsr.NoSsr));
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper));
parcelHelpers.export(exports, "Portal", ()=>(0, _portal.Portal));
parcelHelpers.export(exports, "TextareaAutosize", ()=>(0, _textareaAutosize.TextareaAutosize));
parcelHelpers.export(exports, "unstable_generateUtilityClass", ()=>(0, _generateUtilityClass.generateUtilityClass));
parcelHelpers.export(exports, "unstable_isGlobalState", ()=>(0, _generateUtilityClass.isGlobalState));
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _badge = require("./Badge");
parcelHelpers.exportAll(_badge, exports);
var _button = require("./Button");
parcelHelpers.exportAll(_button, exports);
var _clickAwayListener = require("./ClickAwayListener");
var _composeClasses = require("./composeClasses");
parcelHelpers.exportAll(_composeClasses, exports);
var _dropdown = require("./Dropdown");
var _focusTrap = require("./FocusTrap");
var _formControl = require("./FormControl");
parcelHelpers.exportAll(_formControl, exports);
var _input = require("./Input");
parcelHelpers.exportAll(_input, exports);
var _menu = require("./Menu");
parcelHelpers.exportAll(_menu, exports);
var _menuButton = require("./MenuButton");
parcelHelpers.exportAll(_menuButton, exports);
var _menuItem = require("./MenuItem");
parcelHelpers.exportAll(_menuItem, exports);
var _modal = require("./Modal");
parcelHelpers.exportAll(_modal, exports);
var _noSsr = require("./NoSsr");
var _unstableNumberInput = require("./Unstable_NumberInput");
parcelHelpers.exportAll(_unstableNumberInput, exports);
var _optionGroup = require("./OptionGroup");
parcelHelpers.exportAll(_optionGroup, exports);
var _option = require("./Option");
parcelHelpers.exportAll(_option, exports);
var _popper = require("./Popper");
var _unstablePopup = require("./Unstable_Popup");
parcelHelpers.exportAll(_unstablePopup, exports);
var _portal = require("./Portal");
var _select = require("./Select");
parcelHelpers.exportAll(_select, exports);
var _slider = require("./Slider");
parcelHelpers.exportAll(_slider, exports);
var _snackbar = require("./Snackbar");
parcelHelpers.exportAll(_snackbar, exports);
var _switch = require("./Switch");
parcelHelpers.exportAll(_switch, exports);
var _tablePagination = require("./TablePagination");
parcelHelpers.exportAll(_tablePagination, exports);
var _tabPanel = require("./TabPanel");
parcelHelpers.exportAll(_tabPanel, exports);
var _tabsList = require("./TabsList");
parcelHelpers.exportAll(_tabsList, exports);
var _tabs = require("./Tabs");
parcelHelpers.exportAll(_tabs, exports);
var _tab = require("./Tab");
parcelHelpers.exportAll(_tab, exports);
var _textareaAutosize = require("./TextareaAutosize");
var _transitions = require("./Transitions");
parcelHelpers.exportAll(_transitions, exports);
var _useAutocomplete = require("./useAutocomplete");
parcelHelpers.exportAll(_useAutocomplete, exports);
var _useBadge = require("./useBadge");
parcelHelpers.exportAll(_useBadge, exports);
var _useButton = require("./useButton");
parcelHelpers.exportAll(_useButton, exports);
var _useDropdown = require("./useDropdown");
parcelHelpers.exportAll(_useDropdown, exports);
var _useInput = require("./useInput");
parcelHelpers.exportAll(_useInput, exports);
var _useMenu = require("./useMenu");
parcelHelpers.exportAll(_useMenu, exports);
var _useMenuButton = require("./useMenuButton");
parcelHelpers.exportAll(_useMenuButton, exports);
var _useMenuItem = require("./useMenuItem");
parcelHelpers.exportAll(_useMenuItem, exports);
var _unstableUseNumberInput = require("./unstable_useNumberInput");
parcelHelpers.exportAll(_unstableUseNumberInput, exports);
var _useOption = require("./useOption");
parcelHelpers.exportAll(_useOption, exports);
var _useSelect = require("./useSelect");
parcelHelpers.exportAll(_useSelect, exports);
var _useSlider = require("./useSlider");
parcelHelpers.exportAll(_useSlider, exports);
var _useSnackbar = require("./useSnackbar");
parcelHelpers.exportAll(_useSnackbar, exports);
var _useSwitch = require("./useSwitch");
parcelHelpers.exportAll(_useSwitch, exports);
var _useTab = require("./useTab");
parcelHelpers.exportAll(_useTab, exports);
var _useTabPanel = require("./useTabPanel");
parcelHelpers.exportAll(_useTabPanel, exports);
var _useTabs = require("./useTabs");
parcelHelpers.exportAll(_useTabs, exports);
var _useTabsList = require("./useTabsList");
parcelHelpers.exportAll(_useTabsList, exports);
var _unstableUseModal = require("./unstable_useModal");
parcelHelpers.exportAll(_unstableUseModal, exports);
var _generateUtilityClass = require("./generateUtilityClass");

},{"./utils":false,"./Badge":false,"./Button":false,"./ClickAwayListener":false,"./composeClasses":false,"./Dropdown":false,"./FocusTrap":false,"./FormControl":false,"./Input":false,"./Menu":false,"./MenuButton":false,"./MenuItem":false,"./Modal":false,"./NoSsr":false,"./Unstable_NumberInput":false,"./OptionGroup":false,"./Option":false,"./Popper":false,"./Unstable_Popup":false,"./Portal":false,"./Select":false,"./Slider":false,"./Snackbar":false,"./Switch":false,"./TablePagination":false,"./TabPanel":false,"./TabsList":false,"./Tabs":false,"./Tab":false,"./TextareaAutosize":"17Bhv","./Transitions":false,"./useAutocomplete":false,"./useBadge":false,"./useButton":false,"./useDropdown":false,"./useInput":false,"./useMenu":false,"./useMenuButton":false,"./useMenuItem":false,"./unstable_useNumberInput":false,"./useOption":false,"./useSelect":false,"./useSlider":false,"./useSnackbar":false,"./useSwitch":false,"./useTab":false,"./useTabPanel":false,"./useTabs":false,"./useTabsList":false,"./unstable_useModal":false,"./generateUtilityClass":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iiPtN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "appendOwnerState", ()=>(0, _appendOwnerState.appendOwnerState));
parcelHelpers.export(exports, "areArraysEqual", ()=>(0, _areArraysEqual.areArraysEqual));
parcelHelpers.export(exports, "ClassNameConfigurator", ()=>(0, _classNameConfigurator.ClassNameConfigurator));
parcelHelpers.export(exports, "extractEventHandlers", ()=>(0, _extractEventHandlers.extractEventHandlers));
parcelHelpers.export(exports, "isHostComponent", ()=>(0, _isHostComponent.isHostComponent));
parcelHelpers.export(exports, "resolveComponentProps", ()=>(0, _resolveComponentProps.resolveComponentProps));
parcelHelpers.export(exports, "useRootElementName", ()=>(0, _useRootElementName.useRootElementName));
parcelHelpers.export(exports, "useSlotProps", ()=>(0, _useSlotProps.useSlotProps));
parcelHelpers.export(exports, "mergeSlotProps", ()=>(0, _mergeSlotProps.mergeSlotProps));
parcelHelpers.export(exports, "prepareForSlot", ()=>(0, _prepareForSlot.prepareForSlot));
var _appendOwnerState = require("./appendOwnerState");
var _areArraysEqual = require("./areArraysEqual");
var _classNameConfigurator = require("./ClassNameConfigurator");
var _extractEventHandlers = require("./extractEventHandlers");
var _isHostComponent = require("./isHostComponent");
var _resolveComponentProps = require("./resolveComponentProps");
var _useRootElementName = require("./useRootElementName");
var _useSlotProps = require("./useSlotProps");
var _mergeSlotProps = require("./mergeSlotProps");
var _prepareForSlot = require("./prepareForSlot");
var _polymorphicComponent = require("./PolymorphicComponent");
parcelHelpers.exportAll(_polymorphicComponent, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
"use client";

},{"./appendOwnerState":"pHa3w","./areArraysEqual":false,"./ClassNameConfigurator":false,"./extractEventHandlers":"9VwKW","./isHostComponent":"76V7j","./resolveComponentProps":"eijjP","./useRootElementName":false,"./useSlotProps":"2Mib7","./mergeSlotProps":"2EsK9","./prepareForSlot":false,"./PolymorphicComponent":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"pHa3w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ parcelHelpers.export(exports, "appendOwnerState", ()=>appendOwnerState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _isHostComponent = require("./isHostComponent");
function appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, _isHostComponent.isHostComponent)(elementType)) return otherProps;
    return (0, _extendsDefault.default)({}, otherProps, {
        ownerState: (0, _extendsDefault.default)({}, otherProps.ownerState, ownerState)
    });
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","./isHostComponent":"76V7j","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"76V7j":[function(require,module,exports) {
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHostComponent", ()=>isHostComponent);
function isHostComponent(element) {
    return typeof element === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g5bQg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areArraysEqual", ()=>areArraysEqual);
function areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kCQEI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal hook.
 *
 * Wraps the `generateUtilityClass` function and controls how the classes are generated.
 * Currently it only affects whether the classes are applied or not.
 *
 * @returns Function to be called with the `generateUtilityClass` function specific to a component to generate the classes.
 */ parcelHelpers.export(exports, "useClassNamesOverride", ()=>useClassNamesOverride);
/**
 * Allows to configure the components within to not apply any built-in classes.
 */ parcelHelpers.export(exports, "ClassNameConfigurator", ()=>ClassNameConfigurator);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const defaultContextValue = {
    disableDefaultClasses: false
};
const ClassNameConfiguratorContext = /*#__PURE__*/ _react.createContext(defaultContextValue);
function useClassNamesOverride(generateUtilityClass) {
    const { disableDefaultClasses } = _react.useContext(ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function ClassNameConfigurator(props) {
    const { disableDefaultClasses, children } = props;
    const contextValue = _react.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

},{"react":"BK2ob","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9VwKW":[function(require,module,exports) {
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractEventHandlers", ()=>extractEventHandlers);
function extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eijjP":[function(require,module,exports) {
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveComponentProps", ()=>resolveComponentProps);
function resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"diCq5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 *
 * Use this function determine the host element correctly on the server (in a SSR context, for example Next.js)
 */ parcelHelpers.export(exports, "useRootElementName", ()=>useRootElementName);
var _react = require("react");
"use client";
function useRootElementName(parameters) {
    const { rootElementName: rootElementNameProp = "", componentName } = parameters;
    const [rootElementName, setRootElementName] = _react.useState(rootElementNameProp.toUpperCase());
    const updateRootElementName = _react.useCallback((instance)=>{
        var _instance$tagName;
        setRootElementName((_instance$tagName = instance == null ? void 0 : instance.tagName) != null ? _instance$tagName : "");
    }, []);
    return [
        rootElementName,
        updateRootElementName
    ];
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2Mib7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ parcelHelpers.export(exports, "useSlotProps", ()=>useSlotProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
var _appendOwnerState = require("./appendOwnerState");
var _mergeSlotProps = require("./mergeSlotProps");
var _resolveComponentProps = require("./resolveComponentProps");
"use client";
const _excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false } = parameters, rest = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentProps.resolveComponentProps)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = (0, _mergeSlotProps.mergeSlotProps)((0, _extendsDefault.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, _utils.unstable_useForkRef)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, _appendOwnerState.appendOwnerState)(elementType, (0, _extendsDefault.default)({}, mergedProps, {
        ref
    }), ownerState);
    return props;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils":"97HmB","./appendOwnerState":"pHa3w","./mergeSlotProps":"2EsK9","./resolveComponentProps":"eijjP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2EsK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ parcelHelpers.export(exports, "mergeSlotProps", ()=>mergeSlotProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _extractEventHandlers = require("./extractEventHandlers");
var _omitEventHandlers = require("./omitEventHandlers");
function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, _clsxDefault.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, _extendsDefault.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, _extendsDefault.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, _extractEventHandlers.extractEventHandlers)((0, _extendsDefault.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, _omitEventHandlers.omitEventHandlers)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, _omitEventHandlers.omitEventHandlers)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, _clsxDefault.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, _extendsDefault.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, _extendsDefault.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","clsx":"bGtJT","./extractEventHandlers":"9VwKW","./omitEventHandlers":"aFm9r","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aFm9r":[function(require,module,exports) {
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitEventHandlers", ()=>omitEventHandlers);
function omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aDutu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
var _button = require("./Button");
var _buttonClasses = require("./buttonClasses");
parcelHelpers.exportAll(_buttonClasses, exports);
var _buttonTypes = require("./Button.types");
parcelHelpers.exportAll(_buttonTypes, exports);
"use client";

},{"./Button":"iNb0e","./buttonClasses":false,"./Button.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iNb0e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("../composeClasses");
var _buttonClasses = require("./buttonClasses");
var _useButton = require("../useButton");
var _utils = require("../utils");
var _classNameConfigurator = require("../utils/ClassNameConfigurator");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "action",
    "children",
    "disabled",
    "focusableWhenDisabled",
    "onFocusVisible",
    "slotProps",
    "slots",
    "rootElementName"
];
const useUtilityClasses = (ownerState)=>{
    const { active, disabled, focusVisible } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible",
            active && "active"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _classNameConfigurator.useClassNamesOverride)((0, _buttonClasses.getButtonUtilityClass)));
};
/**
 * The foundation for building custom-styled buttons.
 *
 * Demos:
 *
 * - [Button](https://mui.com/base-ui/react-button/)
 *
 * API:
 *
 * - [Button API](https://mui.com/base-ui/react-button/components-api/#button)
 */ const Button = /*#__PURE__*/ _react.forwardRef(function Button(props, forwardedRef) {
    var _slots$root;
    const { action, children, focusableWhenDisabled = false, slotProps = {}, slots = {}, rootElementName: rootElementNameProp = "button" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const buttonRef = _react.useRef();
    let rootElementName = rootElementNameProp;
    if (typeof slots.root === "string") rootElementName = slots.root;
    else if (other.href || other.to) rootElementName = "a";
    const { active, focusVisible, setFocusVisible, getRootProps } = (0, _useButton.useButton)((0, _extendsDefault.default)({}, props, {
        focusableWhenDisabled,
        rootElementName
    }));
    _react.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), [
        setFocusVisible
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        active,
        focusableWhenDisabled,
        focusVisible
    });
    const classes = useUtilityClasses(ownerState);
    const defaultElement = other.href || other.to ? "a" : "button";
    const Root = (_slots$root = slots.root) != null ? _slots$root : defaultElement;
    const rootProps = (0, _utils.useSlotProps)({
        elementType: Root,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        externalSlotProps: slotProps.root,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState,
        className: classes.root
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
        children: children
    }));
});

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","../composeClasses":"6pdJK","./buttonClasses":"4DVSX","../useButton":"9QEdr","../utils":"iiPtN","../utils/ClassNameConfigurator":"kCQEI","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6pdJK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _utils.unstable_composeClasses));
var _utils = require("@mui/utils");

},{"@mui/utils":"97HmB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4DVSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonUtilityClass", ()=>getButtonUtilityClass);
parcelHelpers.export(exports, "buttonClasses", ()=>buttonClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClasses = require("../generateUtilityClasses");
const COMPONENT_NAME = "Button";
function getButtonUtilityClass(slot) {
    return (0, _generateUtilityClass.generateUtilityClass)(COMPONENT_NAME, slot);
}
const buttonClasses = (0, _generateUtilityClasses.generateUtilityClasses)(COMPONENT_NAME, [
    "root",
    "active",
    "disabled",
    "focusVisible"
]);

},{"../generateUtilityClass":"1p7yp","../generateUtilityClasses":"cyr6u","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1p7yp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUtilityClass", ()=>generateUtilityClass);
parcelHelpers.export(exports, "isGlobalState", ()=>isGlobalState);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
const GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(state) {
    return `${GLOBAL_CLASS_PREFIX}--${state}`;
}
function buildSlotClass(componentName, slot) {
    return `${GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function generateUtilityClass(componentName, slot) {
    const globalStateClass = (0, _generateUtilityClass.globalStateClasses)[slot];
    return globalStateClass ? buildStateClass(globalStateClass) : buildSlotClass(componentName, slot);
}
function isGlobalState(slot) {
    return (0, _generateUtilityClass.globalStateClasses)[slot] !== undefined;
}

},{"@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cyr6u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUtilityClasses", ()=>generateUtilityClasses);
var _generateUtilityClass = require("../generateUtilityClass");
function generateUtilityClasses(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClass.generateUtilityClass)(componentName, slot);
    });
    return result;
}

},{"../generateUtilityClass":"1p7yp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9QEdr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useButton", ()=>(0, _useButton.useButton));
var _useButton = require("./useButton");
var _useButtonTypes = require("./useButton.types");
parcelHelpers.exportAll(_useButtonTypes, exports);
"use client";

},{"./useButton":"f0lCw","./useButton.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f0lCw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Demos:
 *
 * - [Button](https://mui.com/base-ui/react-button/#hook)
 *
 * API:
 *
 * - [useButton API](https://mui.com/base-ui/react-button/hooks-api/#use-button)
 */ parcelHelpers.export(exports, "useButton", ()=>useButton);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _useRootElementName = require("../utils/useRootElementName");
"use client";
function useButton(parameters = {}) {
    const { disabled = false, focusableWhenDisabled, href, rootRef: externalRef, tabIndex, to, type, rootElementName: rootElementNameProp } = parameters;
    const buttonRef = _react.useRef();
    const [active, setActive] = _react.useState(false);
    const { isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, _utils.unstable_useIsFocusVisible)();
    const [focusVisible, setFocusVisible] = _react.useState(false);
    if (disabled && !focusableWhenDisabled && focusVisible) setFocusVisible(false);
    _react.useEffect(()=>{
        isFocusVisibleRef.current = focusVisible;
    }, [
        focusVisible,
        isFocusVisibleRef
    ]);
    const [rootElementName, updateRootElementName] = (0, _useRootElementName.useRootElementName)({
        rootElementName: rootElementNameProp != null ? rootElementNameProp : href || to ? "a" : undefined,
        componentName: "Button"
    });
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            if (focusVisible) event.preventDefault();
            (_otherHandlers$onMous = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous.call(otherHandlers, event);
        };
    const createHandleBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusVisible(false);
            (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu2;
            // Fix for https://github.com/facebook/react/issues/7769
            if (!buttonRef.current) buttonRef.current = event.currentTarget;
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) {
                var _otherHandlers$onFocu;
                setFocusVisible(true);
                (_otherHandlers$onFocu = otherHandlers.onFocusVisible) == null || _otherHandlers$onFocu.call(otherHandlers, event);
            }
            (_otherHandlers$onFocu2 = otherHandlers.onFocus) == null || _otherHandlers$onFocu2.call(otherHandlers, event);
        };
    const isNativeButton = ()=>{
        const button = buttonRef.current;
        return rootElementName === "BUTTON" || rootElementName === "INPUT" && [
            "button",
            "submit",
            "reset"
        ].includes(button == null ? void 0 : button.type) || rootElementName === "A" && (button == null ? void 0 : button.href);
    };
    const createHandleClick = (otherHandlers)=>(event)=>{
            if (!disabled) {
                var _otherHandlers$onClic;
                (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            }
        };
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            if (!disabled) {
                setActive(true);
                document.addEventListener("mouseup", ()=>{
                    setActive(false);
                }, {
                    once: true
                });
            }
            (_otherHandlers$onMous2 = otherHandlers.onMouseDown) == null || _otherHandlers$onMous2.call(otherHandlers, event);
        };
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            if (event.defaultMuiPrevented) return;
            if (event.target === event.currentTarget && !isNativeButton() && event.key === " ") event.preventDefault();
            if (event.target === event.currentTarget && event.key === " " && !disabled) setActive(true);
            // Keyboard accessibility for non interactive elements
            if (event.target === event.currentTarget && !isNativeButton() && event.key === "Enter" && !disabled) {
                var _otherHandlers$onClic2;
                (_otherHandlers$onClic2 = otherHandlers.onClick) == null || _otherHandlers$onClic2.call(otherHandlers, event);
                event.preventDefault();
            }
        };
    const createHandleKeyUp = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyU;
            // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
            // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
            if (event.target === event.currentTarget) setActive(false);
            (_otherHandlers$onKeyU = otherHandlers.onKeyUp) == null || _otherHandlers$onKeyU.call(otherHandlers, event);
            // Keyboard accessibility for non interactive elements
            if (event.target === event.currentTarget && !isNativeButton() && !disabled && event.key === " " && !event.defaultMuiPrevented) {
                var _otherHandlers$onClic3;
                (_otherHandlers$onClic3 = otherHandlers.onClick) == null || _otherHandlers$onClic3.call(otherHandlers, event);
            }
        };
    const handleRef = (0, _utils.unstable_useForkRef)(updateRootElementName, externalRef, focusVisibleRef, buttonRef);
    const buttonProps = {};
    if (tabIndex !== undefined) buttonProps.tabIndex = tabIndex;
    if (rootElementName === "BUTTON") {
        buttonProps.type = type != null ? type : "button";
        if (focusableWhenDisabled) buttonProps["aria-disabled"] = disabled;
        else buttonProps.disabled = disabled;
    } else if (rootElementName === "INPUT") {
        if (type && [
            "button",
            "submit",
            "reset"
        ].includes(type)) {
            if (focusableWhenDisabled) buttonProps["aria-disabled"] = disabled;
            else buttonProps.disabled = disabled;
        }
    } else if (rootElementName !== "") {
        if (!href && !to) {
            buttonProps.role = "button";
            buttonProps.tabIndex = tabIndex != null ? tabIndex : 0;
        }
        if (disabled) {
            buttonProps["aria-disabled"] = disabled;
            buttonProps.tabIndex = focusableWhenDisabled ? tabIndex != null ? tabIndex : 0 : -1;
        }
    }
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extendsDefault.default)({}, (0, _extractEventHandlers.extractEventHandlers)(parameters), (0, _extractEventHandlers.extractEventHandlers)(externalProps));
        const props = (0, _extendsDefault.default)({
            type
        }, externalEventHandlers, buttonProps, externalProps, {
            onBlur: createHandleBlur(externalEventHandlers),
            onClick: createHandleClick(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            onKeyUp: createHandleKeyUp(externalEventHandlers),
            onMouseDown: createHandleMouseDown(externalEventHandlers),
            onMouseLeave: createHandleMouseLeave(externalEventHandlers),
            ref: handleRef
        });
        // onFocusVisible can be present on the props or parameters,
        // but it's not a valid React event handler so it must not be forwarded to the inner component.
        // If present, it will be handled by the focus handler.
        delete props.onFocusVisible;
        return props;
    };
    return {
        getRootProps,
        focusVisible,
        setFocusVisible,
        active,
        rootRef: handleRef
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils":"97HmB","../utils/extractEventHandlers":"9VwKW","../utils/useRootElementName":"diCq5","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fQ8Wr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clickAwayListener = require("./ClickAwayListener");
parcelHelpers.exportAll(_clickAwayListener, exports);

},{"./ClickAwayListener":"dj3s3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dj3s3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClickAwayListener", ()=>ClickAwayListener);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function ClickAwayListener(props) {
    const { children, disableReactTree = false, mouseEvent = "onClick", onClickAway, touchEvent = "onTouchEnd" } = props;
    const movedRef = _react.useRef(false);
    const nodeRef = _react.useRef(null);
    const activatedRef = _react.useRef(false);
    const syntheticEventRef = _react.useRef(false);
    _react.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, _utils.unstable_useForkRef)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, _utils.unstable_useEventCallback)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    _react.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = mapEventPropToEvent(touchEvent);
            const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    _react.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
            const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/ _react.cloneElement(children, childrenProps)
    });
}

},{"react":"BK2ob","prop-types":"hRUel","@mui/utils":"97HmB","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5OCfN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>(0, _focusTrap.FocusTrap));
var _focusTrap = require("./FocusTrap");
var _focusTrapTypes = require("./FocusTrap.types");
parcelHelpers.exportAll(_focusTrapTypes, exports);

},{"./FocusTrap":"5b9rM","./FocusTrap.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5b9rM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>FocusTrap);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || isNonTabbableRadio(node)) return false;
    return true;
}
function defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = getTabIndex(node);
        if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function FocusTrap(props) {
    const { children, disableAutoFocus = false, disableEnforceFocus = false, disableRestoreFocus = false, getTabbable = defaultGetTabbable, isEnabled = defaultIsEnabled, open } = props;
    const ignoreNextEnforceFocus = _react.useRef(false);
    const sentinelStart = _react.useRef(null);
    const sentinelEnd = _react.useRef(null);
    const nodeToRestore = _react.useRef(null);
    const reactFocusEventTarget = _react.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = _react.useRef(false);
    const rootRef = _react.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, _utils.unstable_useForkRef)(children.ref, rootRef);
    const lastKeydown = _react.useRef(null);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _utils.unstable_ownerDocument)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _utils.unstable_ownerDocument)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ _react.cloneElement(children, {
                ref: handleRef,
                onFocus
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}

},{"react":"BK2ob","prop-types":"hRUel","@mui/utils":"97HmB","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2K6Wy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _option = require("./Option");
parcelHelpers.exportAll(_option, exports);
var _optionTypes = require("./Option.types");
parcelHelpers.exportAll(_optionTypes, exports);
var _optionClasses = require("./optionClasses");
parcelHelpers.exportAll(_optionClasses, exports);
"use client";

},{"./Option":"kRJnq","./Option.types":false,"./optionClasses":"e3etZ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kRJnq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Option", ()=>Option);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _composeClasses = require("../composeClasses");
var _optionClasses = require("./optionClasses");
var _utils1 = require("../utils");
var _useOption = require("../useOption");
var _classNameConfigurator = require("../utils/ClassNameConfigurator");
var _useList = require("../useList");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "disabled",
    "label",
    "slotProps",
    "slots",
    "value"
];
function useUtilityClasses(ownerState) {
    const { disabled, highlighted, selected } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            highlighted && "highlighted",
            selected && "selected"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _classNameConfigurator.useClassNamesOverride)((0, _optionClasses.getOptionUtilityClass)));
}
const InnerOption = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(function Option(props, forwardedRef) {
    var _slots$root, _optionRef$current;
    const { children, disabled = false, label, slotProps = {}, slots = {}, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const Root = (_slots$root = slots.root) != null ? _slots$root : "li";
    const optionRef = _react.useRef(null);
    const combinedRef = (0, _utils.unstable_useForkRef)(optionRef, forwardedRef);
    // If `label` is not explicitly provided, the `children` are used for convenience.
    // This is used to populate the select's trigger with the selected option's label.
    const computedLabel = label != null ? label : typeof children === "string" ? children : (_optionRef$current = optionRef.current) == null || (_optionRef$current = _optionRef$current.textContent) == null ? void 0 : _optionRef$current.trim();
    const { getRootProps, selected, highlighted, index } = (0, _useOption.useOption)({
        disabled,
        label: computedLabel,
        rootRef: combinedRef,
        value
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        highlighted,
        index,
        selected
    });
    const classes = useUtilityClasses(ownerState);
    const rootProps = (0, _utils1.useSlotProps)({
        getSlotProps: getRootProps,
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        className: classes.root,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
        children: children
    }));
}));
/**
 * An unstyled option to be used within a Select.
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/)
 *
 * API:
 *
 * - [Option API](https://mui.com/base-ui/react-select/components-api/#option)
 */ const Option = /*#__PURE__*/ _react.forwardRef(function Option(props, ref) {
    const { value } = props;
    // This wrapper component is used as a performance optimization.
    // `useOptionContextStabilizer` ensures that the context value
    // is stable across renders, so that the actual Option re-renders
    // only when it needs to.
    const { contextValue } = (0, _useOption.useOptionContextStabilizer)(value);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useList.ListContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InnerOption, (0, _extendsDefault.default)({}, props, {
            ref: ref
        }))
    });
});

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","@mui/utils":"97HmB","../composeClasses":"6pdJK","./optionClasses":"e3etZ","../utils":"iiPtN","../useOption":"kBDUj","../utils/ClassNameConfigurator":"kCQEI","../useList":"9r6z0","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e3etZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionUtilityClass", ()=>getOptionUtilityClass);
parcelHelpers.export(exports, "optionClasses", ()=>optionClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClasses = require("../generateUtilityClasses");
const COMPONENT_NAME = "Option";
function getOptionUtilityClass(slot) {
    return (0, _generateUtilityClass.generateUtilityClass)(COMPONENT_NAME, slot);
}
const optionClasses = (0, _generateUtilityClasses.generateUtilityClasses)(COMPONENT_NAME, [
    "root",
    "disabled",
    "selected",
    "highlighted"
]);

},{"../generateUtilityClass":"1p7yp","../generateUtilityClasses":"cyr6u","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kBDUj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOption", ()=>(0, _useOption.useOption));
var _useOption = require("./useOption");
var _useOptionTypes = require("./useOption.types");
parcelHelpers.exportAll(_useOptionTypes, exports);
var _useOptionContextStabilizer = require("./useOptionContextStabilizer");
parcelHelpers.exportAll(_useOptionContextStabilizer, exports);
"use client";

},{"./useOption":"fLICV","./useOption.types":false,"./useOptionContextStabilizer":"eY6WF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fLICV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/#hooks)
 *
 * API:
 *
 * - [useOption API](https://mui.com/base-ui/react-select/hooks-api/#use-option)
 */ parcelHelpers.export(exports, "useOption", ()=>useOption);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _useList = require("../useList");
var _useCompound = require("../useCompound");
var _useButton = require("../useButton");
var _combineHooksSlotProps = require("../utils/combineHooksSlotProps");
"use client";
function useOption(params) {
    const { value, label, disabled, rootRef: optionRefParam, id: idParam } = params;
    const { getRootProps: getListItemProps, highlighted, selected } = (0, _useList.useListItem)({
        item: value
    });
    const { getRootProps: getButtonProps, rootRef: buttonRefHandler } = (0, _useButton.useButton)({
        disabled,
        focusableWhenDisabled: true
    });
    const id = (0, _utils.unstable_useId)(idParam);
    const optionRef = _react.useRef(null);
    const selectOption = _react.useMemo(()=>({
            disabled,
            label,
            value,
            ref: optionRef,
            id
        }), [
        disabled,
        label,
        value,
        id
    ]);
    const { index } = (0, _useCompound.useCompoundItem)(value, selectOption);
    const handleRef = (0, _utils.unstable_useForkRef)(optionRefParam, optionRef, buttonRefHandler);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            if (event.defaultMuiPrevented) return;
            if ([
                " ",
                "Enter"
            ].includes(event.key)) event.defaultMuiPrevented = true; // prevent listbox onKeyDown
        };
    const getOwnHandlers = (otherHandlers = {})=>({
            onKeyDown: createHandleKeyDown(otherHandlers)
        });
    return {
        getRootProps: (externalProps = {})=>{
            const externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
            const getCombinedRootProps = (0, _combineHooksSlotProps.combineHooksSlotProps)(getListItemProps, (0, _combineHooksSlotProps.combineHooksSlotProps)(getButtonProps, getOwnHandlers));
            return (0, _extendsDefault.default)({}, externalProps, externalEventHandlers, getCombinedRootProps(externalEventHandlers), {
                id,
                ref: handleRef,
                role: "option",
                "aria-selected": selected
            });
        },
        highlighted,
        index,
        selected,
        rootRef: handleRef
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils":"97HmB","../utils/extractEventHandlers":"9VwKW","../useList":"9r6z0","../useCompound":"3Yrrc","../useButton":"9QEdr","../utils/combineHooksSlotProps":"bO91k","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9r6z0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useList", ()=>(0, _useList.useList));
parcelHelpers.export(exports, "useListItem", ()=>(0, _useListItem.useListItem));
var _useList = require("./useList");
var _useListTypes = require("./useList.types");
parcelHelpers.exportAll(_useListTypes, exports);
var _useListItem = require("./useListItem");
var _useListItemTypes = require("./useListItem.types");
parcelHelpers.exportAll(_useListItemTypes, exports);
var _listReducer = require("./listReducer");
parcelHelpers.exportAll(_listReducer, exports);
var _listActionsTypes = require("./listActions.types");
parcelHelpers.exportAll(_listActionsTypes, exports);
var _listContext = require("./ListContext");
parcelHelpers.exportAll(_listContext, exports);
"use client";

},{"./useList":"4hWo4","./useList.types":false,"./useListItem":"6qHPM","./useListItem.types":false,"./listReducer":"bWIeq","./listActions.types":"k20ID","./ListContext":"kjK2F","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4hWo4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useList", ()=>useList);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _listActionsTypes = require("./listActions.types");
var _listReducer = require("./listReducer");
var _useControllableReducer = require("../utils/useControllableReducer");
var _areArraysEqual = require("../utils/areArraysEqual");
var _useTextNavigation = require("../utils/useTextNavigation");
var _extractEventHandlers = require("../utils/extractEventHandlers");
"use client";
const EMPTY_OBJECT = {};
const NOOP = ()=>{};
const defaultItemComparer = (optionA, optionB)=>optionA === optionB;
const defaultIsItemDisabled = ()=>false;
const defaultItemStringifier = (item)=>typeof item === "string" ? item : String(item);
const defaultGetInitialState = ()=>({
        highlightedValue: null,
        selectedValues: []
    });
/**
 * The useList is a lower-level utility that is used to build list-like components.
 * It's used to manage the state of the list and its items.
 *
 * Supports highlighting a single item and selecting an arbitrary number of items.
 *
 * The state of the list is managed by a controllable reducer - that is a reducer that can have its state
 * controlled from outside.
 *
 * By default, the state consists of `selectedValues` and `highlightedValue` but can be extended by the caller of the hook.
 * Also the actions that can be dispatched and the reducer function can be defined externally.
 *
 * @template ItemValue The type of the item values.
 * @template State The type of the list state. This should be a subtype of `ListState<ItemValue>`.
 * @template CustomAction The type of the actions that can be dispatched (besides the standard ListAction).
 * @template CustomActionContext The shape of additional properties that will be added to actions when dispatched.
 *
 * @ignore - internal hook.
 */ function useList(params) {
    const { controlledProps = EMPTY_OBJECT, disabledItemsFocusable = false, disableListWrap = false, focusManagement = "activeDescendant", getInitialState = defaultGetInitialState, getItemDomElement, getItemId, isItemDisabled = defaultIsItemDisabled, rootRef: externalListRef, onStateChange = NOOP, items, itemComparer = defaultItemComparer, getItemAsString = defaultItemStringifier, onChange, onHighlightChange, onItemsChange, orientation = "vertical", pageSize = 5, reducerActionContext = EMPTY_OBJECT, selectionMode = "single", stateReducer: externalReducer, componentName = "useList" } = params;
    const listRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(externalListRef, listRef);
    const handleHighlightChange = _react.useCallback((event, value, reason)=>{
        onHighlightChange == null || onHighlightChange(event, value, reason);
        if (focusManagement === "DOM" && value != null && (reason === (0, _listActionsTypes.ListActionTypes).itemClick || reason === (0, _listActionsTypes.ListActionTypes).keyDown || reason === (0, _listActionsTypes.ListActionTypes).textNavigation)) {
            var _getItemDomElement;
            getItemDomElement == null || (_getItemDomElement = getItemDomElement(value)) == null || _getItemDomElement.focus();
        }
    }, [
        getItemDomElement,
        onHighlightChange,
        focusManagement
    ]);
    const stateComparers = _react.useMemo(()=>({
            highlightedValue: itemComparer,
            selectedValues: (valuesArray1, valuesArray2)=>(0, _areArraysEqual.areArraysEqual)(valuesArray1, valuesArray2, itemComparer)
        }), [
        itemComparer
    ]);
    // This gets called whenever a reducer changes the state.
    const handleStateChange = _react.useCallback((event, field, value, reason, state)=>{
        onStateChange == null || onStateChange(event, field, value, reason, state);
        switch(field){
            case "highlightedValue":
                handleHighlightChange(event, value, reason);
                break;
            case "selectedValues":
                onChange == null || onChange(event, value, reason);
                break;
            default:
                break;
        }
    }, [
        handleHighlightChange,
        onChange,
        onStateChange
    ]);
    // The following object is added to each action when it's dispatched.
    // It's accessible in the reducer via the `action.context` field.
    const listActionContext = _react.useMemo(()=>{
        return {
            disabledItemsFocusable,
            disableListWrap,
            focusManagement,
            isItemDisabled,
            itemComparer,
            items,
            getItemAsString,
            onHighlightChange: handleHighlightChange,
            orientation,
            pageSize,
            selectionMode,
            stateComparers
        };
    }, [
        disabledItemsFocusable,
        disableListWrap,
        focusManagement,
        isItemDisabled,
        itemComparer,
        items,
        getItemAsString,
        handleHighlightChange,
        orientation,
        pageSize,
        selectionMode,
        stateComparers
    ]);
    const initialState = getInitialState();
    const reducer = externalReducer != null ? externalReducer : (0, _listReducer.listReducer);
    const actionContext = _react.useMemo(()=>(0, _extendsDefault.default)({}, reducerActionContext, listActionContext), [
        reducerActionContext,
        listActionContext
    ]);
    const [state, dispatch] = (0, _useControllableReducer.useControllableReducer)({
        reducer,
        actionContext,
        initialState: initialState,
        controlledProps,
        stateComparers,
        onStateChange: handleStateChange,
        componentName
    });
    const { highlightedValue, selectedValues } = state;
    const handleTextNavigation = (0, _useTextNavigation.useTextNavigation)((searchString, event)=>dispatch({
            type: (0, _listActionsTypes.ListActionTypes).textNavigation,
            event,
            searchString
        }));
    const previousItems = _react.useRef([]);
    _react.useEffect(()=>{
        // Whenever the `items` object changes, we need to determine if the actual items changed.
        // If they did, we need to dispatch an `itemsChange` action, so the selected/highlighted state is updated.
        if ((0, _areArraysEqual.areArraysEqual)(previousItems.current, items, itemComparer)) return;
        dispatch({
            type: (0, _listActionsTypes.ListActionTypes).itemsChange,
            event: null,
            items,
            previousItems: previousItems.current
        });
        previousItems.current = items;
        onItemsChange == null || onItemsChange(items);
    }, [
        items,
        itemComparer,
        dispatch,
        onItemsChange
    ]);
    const createHandleKeyDown = (externalHandlers)=>(event)=>{
            var _externalHandlers$onK;
            (_externalHandlers$onK = externalHandlers.onKeyDown) == null || _externalHandlers$onK.call(externalHandlers, event);
            if (event.defaultMuiPrevented) return;
            const keysToPreventDefault = [
                "Home",
                "End",
                "PageUp",
                "PageDown"
            ];
            if (orientation === "vertical") keysToPreventDefault.push("ArrowUp", "ArrowDown");
            else keysToPreventDefault.push("ArrowLeft", "ArrowRight");
            if (focusManagement === "activeDescendant") // When the child element is focused using the activeDescendant attribute,
            // the list handles keyboard events on its behalf.
            // We have to `preventDefault()` is this case to prevent the browser from
            // scrolling the view when space is pressed or submitting forms when enter is pressed.
            keysToPreventDefault.push(" ", "Enter");
            if (keysToPreventDefault.includes(event.key)) event.preventDefault();
            dispatch({
                type: (0, _listActionsTypes.ListActionTypes).keyDown,
                key: event.key,
                event
            });
            handleTextNavigation(event);
        };
    const createHandleBlur = (externalHandlers)=>(event)=>{
            var _externalHandlers$onB, _listRef$current;
            (_externalHandlers$onB = externalHandlers.onBlur) == null || _externalHandlers$onB.call(externalHandlers, event);
            if (event.defaultMuiPrevented) return;
            if ((_listRef$current = listRef.current) != null && _listRef$current.contains(event.relatedTarget)) // focus remains within the list
            return;
            dispatch({
                type: (0, _listActionsTypes.ListActionTypes).blur,
                event
            });
        };
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        return (0, _extendsDefault.default)({}, externalProps, {
            "aria-activedescendant": focusManagement === "activeDescendant" && highlightedValue != null ? getItemId(highlightedValue) : undefined,
            tabIndex: focusManagement === "DOM" ? -1 : 0,
            ref: handleRef
        }, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onKeyDown: createHandleKeyDown(externalEventHandlers)
        });
    };
    const getItemState = _react.useCallback((item)=>{
        const selected = (selectedValues != null ? selectedValues : []).some((value)=>value != null && itemComparer(item, value));
        const highlighted = highlightedValue != null && itemComparer(item, highlightedValue);
        const focusable = focusManagement === "DOM";
        return {
            focusable,
            highlighted,
            selected
        };
    }, [
        itemComparer,
        selectedValues,
        highlightedValue,
        focusManagement
    ]);
    const contextValue = _react.useMemo(()=>({
            dispatch,
            getItemState
        }), [
        dispatch,
        getItemState
    ]);
    _react.useDebugValue({
        state
    });
    return {
        contextValue,
        dispatch,
        getRootProps,
        rootRef: handleRef,
        state
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils":"97HmB","./listActions.types":"k20ID","./listReducer":"bWIeq","../utils/useControllableReducer":"99YDZ","../utils/areArraysEqual":"g5bQg","../utils/useTextNavigation":"04ovK","../utils/extractEventHandlers":"9VwKW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k20ID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListActionTypes", ()=>ListActionTypes);
const ListActionTypes = {
    blur: "list:blur",
    focus: "list:focus",
    itemClick: "list:itemClick",
    itemHover: "list:itemHover",
    itemsChange: "list:itemsChange",
    keyDown: "list:keyDown",
    resetHighlight: "list:resetHighlight",
    highlightLast: "list:highlightLast",
    textNavigation: "list:textNavigation",
    clearSelection: "list:clearSelection"
}; /**
 * A union of all standard actions that can be dispatched to the list reducer.
 */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bWIeq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the next item to highlight based on the current highlighted item and the search direction.
 *
 * @param previouslyHighlightedValue The item from which to start the search for the next candidate.
 * @param offset The offset from the previously highlighted item to search for the next candidate or a special named value ('reset', 'start', 'end').
 * @param context The list action context.
 *
 * @returns The next item to highlight or null if no item is valid.
 */ parcelHelpers.export(exports, "moveHighlight", ()=>moveHighlight);
/**
 * Toggles the selection of an item.
 *
 * @param item Item to toggle.
 * @param selectedValues Already selected items.
 * @param selectionMode The number of items that can be simultanously selected.
 * @param itemComparer A custom item comparer function.
 *
 * @returns The new array of selected items.
 */ parcelHelpers.export(exports, "toggleSelection", ()=>toggleSelection);
/**
 * Handles item selection in a list.
 *
 * @param item - The item to be selected.
 * @param state - The current state of the list.
 * @param context - The context of the list action.
 * @returns The new state of the list after the item has been selected, or the original state if the item is disabled.
 */ parcelHelpers.export(exports, "handleItemSelection", ()=>handleItemSelection);
parcelHelpers.export(exports, "listReducer", ()=>listReducer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _listActionsTypes = require("./listActions.types");
/**
 * Looks up the next valid item to highlight within the list.
 *
 * @param currentIndex The index of the start of the search.
 * @param lookupDirection Whether to look for the next or previous item.
 * @param items The array of items to search.
 * @param includeDisabledItems Whether to include disabled items in the search.
 * @param isItemDisabled A function that determines whether an item is disabled.
 * @param wrapAround Whether to wrap around the list when searching.
 * @returns The index of the next valid item to highlight or -1 if no valid item is found.
 */ function findValidItemToHighlight(currentIndex, lookupDirection, items, includeDisabledItems, isItemDisabled, wrapAround) {
    if (items.length === 0 || !includeDisabledItems && items.every((item, itemIndex)=>isItemDisabled(item, itemIndex))) return -1;
    let nextFocus = currentIndex;
    for(;;){
        // No valid items found
        if (!wrapAround && lookupDirection === "next" && nextFocus === items.length || !wrapAround && lookupDirection === "previous" && nextFocus === -1) return -1;
        const nextFocusDisabled = includeDisabledItems ? false : isItemDisabled(items[nextFocus], nextFocus);
        if (nextFocusDisabled) {
            nextFocus += lookupDirection === "next" ? 1 : -1;
            if (wrapAround) nextFocus = (nextFocus + items.length) % items.length;
        } else return nextFocus;
    }
}
function moveHighlight(previouslyHighlightedValue, offset, context) {
    var _items$nextIndex;
    const { items, isItemDisabled, disableListWrap, disabledItemsFocusable, itemComparer, focusManagement } = context;
    // TODO: make this configurable
    // The always should be an item highlighted when focus is managed by the DOM
    // so that it's accessible by the `tab` key.
    const defaultHighlightedIndex = focusManagement === "DOM" ? 0 : -1;
    const maxIndex = items.length - 1;
    const previouslyHighlightedIndex = previouslyHighlightedValue == null ? -1 : items.findIndex((item)=>itemComparer(item, previouslyHighlightedValue));
    let nextIndexCandidate;
    let lookupDirection;
    let wrapAround = !disableListWrap;
    switch(offset){
        case "reset":
            if (defaultHighlightedIndex === -1) return null;
            nextIndexCandidate = 0;
            lookupDirection = "next";
            wrapAround = false;
            break;
        case "start":
            nextIndexCandidate = 0;
            lookupDirection = "next";
            wrapAround = false;
            break;
        case "end":
            nextIndexCandidate = maxIndex;
            lookupDirection = "previous";
            wrapAround = false;
            break;
        default:
            {
                const newIndex = previouslyHighlightedIndex + offset;
                if (newIndex < 0) {
                    if (!wrapAround && previouslyHighlightedIndex !== -1 || Math.abs(offset) > 1) {
                        nextIndexCandidate = 0;
                        lookupDirection = "next";
                    } else {
                        nextIndexCandidate = maxIndex;
                        lookupDirection = "previous";
                    }
                } else if (newIndex > maxIndex) {
                    if (!wrapAround || Math.abs(offset) > 1) {
                        nextIndexCandidate = maxIndex;
                        lookupDirection = "previous";
                    } else {
                        nextIndexCandidate = 0;
                        lookupDirection = "next";
                    }
                } else {
                    nextIndexCandidate = newIndex;
                    lookupDirection = offset >= 0 ? "next" : "previous";
                }
            }
    }
    const nextIndex = findValidItemToHighlight(nextIndexCandidate, lookupDirection, items, disabledItemsFocusable, isItemDisabled, wrapAround);
    // If there are no valid items to highlight, return the previously highlighted item (if it's still valid).
    if (nextIndex === -1 && previouslyHighlightedValue !== null && !isItemDisabled(previouslyHighlightedValue, previouslyHighlightedIndex)) return previouslyHighlightedValue;
    return (_items$nextIndex = items[nextIndex]) != null ? _items$nextIndex : null;
}
function toggleSelection(item, selectedValues, selectionMode, itemComparer) {
    if (selectionMode === "none") return [];
    if (selectionMode === "single") {
        // if the item to select has already been selected, return the original array
        if (itemComparer(selectedValues[0], item)) return selectedValues;
        return [
            item
        ];
    }
    // The toggled item is selected; remove it from the selection.
    if (selectedValues.some((sv)=>itemComparer(sv, item))) return selectedValues.filter((sv)=>!itemComparer(sv, item));
    // The toggled item is not selected - add it to the selection.
    return [
        ...selectedValues,
        item
    ];
}
function handleItemSelection(item, state, context) {
    const { itemComparer, isItemDisabled, selectionMode, items } = context;
    const { selectedValues } = state;
    const itemIndex = items.findIndex((i)=>itemComparer(item, i));
    if (isItemDisabled(item, itemIndex)) return state;
    // if the item is already selected, remove it from the selection, otherwise add it
    const newSelectedValues = toggleSelection(item, selectedValues, selectionMode, itemComparer);
    return (0, _extendsDefault.default)({}, state, {
        selectedValues: newSelectedValues,
        highlightedValue: item
    });
}
function handleKeyDown(key, state, context) {
    const previouslySelectedValue = state.highlightedValue;
    const { orientation, pageSize } = context;
    switch(key){
        case "Home":
            return (0, _extendsDefault.default)({}, state, {
                highlightedValue: moveHighlight(previouslySelectedValue, "start", context)
            });
        case "End":
            return (0, _extendsDefault.default)({}, state, {
                highlightedValue: moveHighlight(previouslySelectedValue, "end", context)
            });
        case "PageUp":
            return (0, _extendsDefault.default)({}, state, {
                highlightedValue: moveHighlight(previouslySelectedValue, -pageSize, context)
            });
        case "PageDown":
            return (0, _extendsDefault.default)({}, state, {
                highlightedValue: moveHighlight(previouslySelectedValue, pageSize, context)
            });
        case "ArrowUp":
            if (orientation !== "vertical") break;
            return (0, _extendsDefault.default)({}, state, {
                highlightedValue: moveHighlight(previouslySelectedValue, -1, context)
            });
        case "ArrowDown":
            if (orientation !== "vertical") break;
            return (0, _extendsDefault.default)({}, state, {
                highlightedValue: moveHighlight(previouslySelectedValue, 1, context)
            });
        case "ArrowLeft":
            {
                if (orientation === "vertical") break;
                const offset = orientation === "horizontal-ltr" ? -1 : 1;
                return (0, _extendsDefault.default)({}, state, {
                    highlightedValue: moveHighlight(previouslySelectedValue, offset, context)
                });
            }
        case "ArrowRight":
            {
                if (orientation === "vertical") break;
                const offset = orientation === "horizontal-ltr" ? 1 : -1;
                return (0, _extendsDefault.default)({}, state, {
                    highlightedValue: moveHighlight(previouslySelectedValue, offset, context)
                });
            }
        case "Enter":
        case " ":
            if (state.highlightedValue === null) return state;
            return handleItemSelection(state.highlightedValue, state, context);
        default:
            break;
    }
    return state;
}
function handleBlur(state, context) {
    if (context.focusManagement === "DOM") return state;
    return (0, _extendsDefault.default)({}, state, {
        highlightedValue: null
    });
}
function textCriteriaMatches(nextFocus, searchString, stringifyItem) {
    var _stringifyItem;
    const text = (_stringifyItem = stringifyItem(nextFocus)) == null ? void 0 : _stringifyItem.trim().toLowerCase();
    if (!text || text.length === 0) // Make item not navigable if stringification fails or results in empty string.
    return false;
    return text.indexOf(searchString) === 0;
}
function handleTextNavigation(state, searchString, context) {
    const { items, isItemDisabled, disabledItemsFocusable, getItemAsString } = context;
    const startWithCurrentItem = searchString.length > 1;
    let nextItem = startWithCurrentItem ? state.highlightedValue : moveHighlight(state.highlightedValue, 1, context);
    for(let index = 0; index < items.length; index += 1){
        // Return un-mutated state if looped back to the currently highlighted value
        if (!nextItem || !startWithCurrentItem && state.highlightedValue === nextItem) return state;
        if (textCriteriaMatches(nextItem, searchString, getItemAsString) && (!isItemDisabled(nextItem, items.indexOf(nextItem)) || disabledItemsFocusable)) // The nextItem is the element to be highlighted
        return (0, _extendsDefault.default)({}, state, {
            highlightedValue: nextItem
        });
        // Move to the next element.
        nextItem = moveHighlight(nextItem, 1, context);
    }
    // No item matches the text search criteria
    return state;
}
function handleItemsChange(items, previousItems, state, context) {
    var _state$selectedValues;
    const { itemComparer, focusManagement } = context;
    let newHighlightedValue = null;
    if (state.highlightedValue != null) {
        var _items$find;
        newHighlightedValue = (_items$find = items.find((item)=>itemComparer(item, state.highlightedValue))) != null ? _items$find : null;
    } else if (focusManagement === "DOM" && previousItems.length === 0) newHighlightedValue = moveHighlight(null, "reset", context);
    // exclude selected values that are no longer in the items list
    const selectedValues = (_state$selectedValues = state.selectedValues) != null ? _state$selectedValues : [];
    const newSelectedValues = selectedValues.filter((selectedValue)=>items.some((item)=>itemComparer(item, selectedValue)));
    return (0, _extendsDefault.default)({}, state, {
        highlightedValue: newHighlightedValue,
        selectedValues: newSelectedValues
    });
}
function handleResetHighlight(state, context) {
    return (0, _extendsDefault.default)({}, state, {
        highlightedValue: moveHighlight(null, "reset", context)
    });
}
function handleHighlightLast(state, context) {
    return (0, _extendsDefault.default)({}, state, {
        highlightedValue: moveHighlight(null, "end", context)
    });
}
function handleClearSelection(state, context) {
    return (0, _extendsDefault.default)({}, state, {
        selectedValues: [],
        highlightedValue: moveHighlight(null, "reset", context)
    });
}
function listReducer(state, action) {
    const { type, context } = action;
    switch(type){
        case (0, _listActionsTypes.ListActionTypes).keyDown:
            return handleKeyDown(action.key, state, context);
        case (0, _listActionsTypes.ListActionTypes).itemClick:
            return handleItemSelection(action.item, state, context);
        case (0, _listActionsTypes.ListActionTypes).blur:
            return handleBlur(state, context);
        case (0, _listActionsTypes.ListActionTypes).textNavigation:
            return handleTextNavigation(state, action.searchString, context);
        case (0, _listActionsTypes.ListActionTypes).itemsChange:
            return handleItemsChange(action.items, action.previousItems, state, context);
        case (0, _listActionsTypes.ListActionTypes).resetHighlight:
            return handleResetHighlight(state, context);
        case (0, _listActionsTypes.ListActionTypes).highlightLast:
            return handleHighlightLast(state, context);
        case (0, _listActionsTypes.ListActionTypes).clearSelection:
            return handleClearSelection(state, context);
        default:
            return state;
    }
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","./listActions.types":"k20ID","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"99YDZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The alternative to `React.useReducer` that lets you control the state from the outside.
 *
 * It can be used in an uncontrolled mode, similar to `React.useReducer`, or in a controlled mode, when the state is controlled by the props.
 * It also supports partially controlled state, when some state items are controlled and some are not.
 *
 * The controlled state items are provided via the `controlledProps` parameter.
 * When a reducer action is dispatched, the internal state is updated with the new values.
 * A change event (`onStateChange`) is then triggered (for each changed state item) if the new state is different from the previous state.
 * This event can be used to update the controlled values.
 *
 * The comparison of the previous and next states is done using the `stateComparers` parameter.
 * If a state item has a corresponding comparer, it will be used to determine if the state has changed.
 * This is useful when the state item is an object and you want to compare only a subset of its properties or if it's an array and you want to compare its contents.
 *
 * An additional feature is the `actionContext` parameter. It allows you to add additional properties to every action object,
 * similarly to how React context is implicitly available to every component.
 *
 * @template State - The type of the state calculated by the reducer.
 * @template Action - The type of the actions that can be dispatched.
 * @template ActionContext - The type of the additional properties that will be added to every action object.
 *
 * @ignore - internal hook.
 */ parcelHelpers.export(exports, "useControllableReducer", ()=>useControllableReducer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
"use client";
function areEqual(a, b) {
    return a === b;
}
const EMPTY_OBJECT = {};
const NOOP = ()=>{};
/**
 * Gets the current state augmented with controlled values from the outside.
 * If a state item has a corresponding controlled value, it will be used instead of the internal state.
 */ function getControlledState(internalState, controlledProps) {
    const augmentedState = (0, _extendsDefault.default)({}, internalState);
    Object.keys(controlledProps).forEach((key)=>{
        if (controlledProps[key] !== undefined) augmentedState[key] = controlledProps[key];
    });
    return augmentedState;
}
/**
 * Defines an effect that compares the next state with the previous state and calls
 * the `onStateChange` callback if the state has changed.
 * The comparison is done based on the `stateComparers` parameter.
 */ function useStateChangeDetection(parameters) {
    const { nextState, initialState, stateComparers, onStateChange, controlledProps, lastActionRef } = parameters;
    const internalPreviousStateRef = _react.useRef(initialState);
    _react.useEffect(()=>{
        if (lastActionRef.current === null) // Detect changes only if an action has been dispatched.
        return;
        const previousState = getControlledState(internalPreviousStateRef.current, controlledProps);
        Object.keys(nextState).forEach((key)=>{
            var _stateComparers$key;
            // go through all state keys and compare them with the previous state
            const stateComparer = (_stateComparers$key = stateComparers[key]) != null ? _stateComparers$key : areEqual;
            const nextStateItem = nextState[key];
            const previousStateItem = previousState[key];
            if (previousStateItem == null && nextStateItem != null || previousStateItem != null && nextStateItem == null || previousStateItem != null && nextStateItem != null && !stateComparer(nextStateItem, previousStateItem)) {
                var _event, _type;
                onStateChange == null || onStateChange((_event = lastActionRef.current.event) != null ? _event : null, key, nextStateItem, (_type = lastActionRef.current.type) != null ? _type : "", nextState);
            }
        });
        internalPreviousStateRef.current = nextState;
        lastActionRef.current = null;
    }, [
        internalPreviousStateRef,
        nextState,
        lastActionRef,
        onStateChange,
        stateComparers,
        controlledProps
    ]);
}
function useControllableReducer(parameters) {
    const lastActionRef = _react.useRef(null);
    const { reducer, initialState, controlledProps = EMPTY_OBJECT, stateComparers = EMPTY_OBJECT, onStateChange = NOOP, actionContext, componentName = "" } = parameters;
    const controlledPropsRef = _react.useRef(controlledProps);
    var key;
    // The reducer that is passed to React.useReducer is wrapped with a function that augments the state with controlled values.
    const reducerWithControlledState = _react.useCallback((state, action)=>{
        lastActionRef.current = action;
        const controlledState = getControlledState(state, controlledProps);
        const newState = reducer(controlledState, action);
        return newState;
    }, [
        controlledProps,
        reducer
    ]);
    const [nextState, dispatch] = _react.useReducer(reducerWithControlledState, initialState);
    // The action that is passed to dispatch is augmented with the actionContext.
    const dispatchWithContext = _react.useCallback((action)=>{
        dispatch((0, _extendsDefault.default)({}, action, {
            context: actionContext
        }));
    }, [
        actionContext
    ]);
    useStateChangeDetection({
        nextState,
        initialState,
        stateComparers: stateComparers != null ? stateComparers : EMPTY_OBJECT,
        onStateChange: onStateChange != null ? onStateChange : NOOP,
        controlledProps,
        lastActionRef
    });
    return [
        getControlledState(nextState, controlledProps),
        dispatchWithContext
    ];
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"04ovK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @ignore - internal hook.
 *
 * Provides a handler for text navigation.
 * It's used to navigate a list by typing the first letters of the options.
 *
 * @param callback A function to be called when the navigation should be performed.
 * @returns A function to be used in a keydown event handler.
 */ parcelHelpers.export(exports, "useTextNavigation", ()=>useTextNavigation);
var _react = require("react");
"use client";
const TEXT_NAVIGATION_RESET_TIMEOUT = 500; // milliseconds
function useTextNavigation(callback) {
    const textCriteriaRef = _react.useRef({
        searchString: "",
        lastTime: null
    });
    return _react.useCallback((event)=>{
        if (event.key.length === 1 && event.key !== " ") {
            const textCriteria = textCriteriaRef.current;
            const lowerKey = event.key.toLowerCase();
            const currentTime = performance.now();
            if (textCriteria.searchString.length > 0 && textCriteria.lastTime && currentTime - textCriteria.lastTime > TEXT_NAVIGATION_RESET_TIMEOUT) textCriteria.searchString = lowerKey;
            else if (textCriteria.searchString.length !== 1 || lowerKey !== textCriteria.searchString) // If there is just one character in the buffer and the key is the same, do not append
            textCriteria.searchString += lowerKey;
            textCriteria.lastTime = currentTime;
            callback(textCriteria.searchString, event);
        }
    }, [
        callback
    ]);
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6qHPM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Contains the logic for an item of a list-like component (for example Select, Menu, etc.).
 * It handles the item's mouse events and tab index.
 *
 * @template ItemValue The type of the item's value. This should be consistent with the type of useList's `items` parameter.
 * @ignore - internal hook.
 */ parcelHelpers.export(exports, "useListItem", ()=>useListItem);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _listActionsTypes = require("./listActions.types");
var _listContext = require("./ListContext");
"use client";
function useListItem(parameters) {
    const { handlePointerOverEvents = false, item } = parameters;
    const listContext = _react.useContext((0, _listContext.ListContext));
    if (!listContext) throw new Error("useListItem must be used within a ListProvider");
    const { dispatch, getItemState } = listContext;
    const { highlighted, selected, focusable } = getItemState(item);
    const createHandleClick = _react.useCallback((externalHandlers)=>(event)=>{
            var _externalHandlers$onC;
            (_externalHandlers$onC = externalHandlers.onClick) == null || _externalHandlers$onC.call(externalHandlers, event);
            if (event.defaultPrevented) return;
            dispatch({
                type: (0, _listActionsTypes.ListActionTypes).itemClick,
                item: item,
                event
            });
        }, [
        dispatch,
        item
    ]);
    const createHandlePointerOver = _react.useCallback((externalHandlers)=>(event)=>{
            var _externalHandlers$onM;
            (_externalHandlers$onM = externalHandlers.onMouseOver) == null || _externalHandlers$onM.call(externalHandlers, event);
            if (event.defaultPrevented) return;
            dispatch({
                type: (0, _listActionsTypes.ListActionTypes).itemHover,
                item: item,
                event
            });
        }, [
        dispatch,
        item
    ]);
    let tabIndex;
    if (focusable) tabIndex = highlighted ? 0 : -1;
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        return (0, _extendsDefault.default)({}, externalProps, {
            onClick: createHandleClick(externalEventHandlers),
            onPointerOver: handlePointerOverEvents ? createHandlePointerOver(externalEventHandlers) : undefined,
            tabIndex
        });
    };
    return {
        getRootProps,
        highlighted,
        selected
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","../utils/extractEventHandlers":"9VwKW","./listActions.types":"k20ID","./ListContext":"kjK2F","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kjK2F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListContext", ()=>ListContext);
var _react = require("react");
const ListContext = /*#__PURE__*/ _react.createContext(null);

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3Yrrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useCompoundParent = require("./useCompoundParent");
parcelHelpers.exportAll(_useCompoundParent, exports);
var _useCompoundItem = require("./useCompoundItem");
parcelHelpers.exportAll(_useCompoundItem, exports);
"use client";

},{"./useCompoundParent":"1S5WE","./useCompoundItem":"l1gbB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1S5WE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompoundComponentContext", ()=>CompoundComponentContext);
/**
 * Provides a way for a component to know about its children.
 *
 * Child components register themselves with the `useCompoundItem` hook, passing in arbitrary metadata to the parent.
 *
 * This is a more powerful altervantive to `children` traversal, as child components don't have to be placed
 * directly inside the parent component. They can be anywhere in the tree (and even rendered by other components).
 *
 * The downside is that this doesn't work with SSR as it relies on the useEffect hook.
 *
 * @ignore - internal hook.
 */ parcelHelpers.export(exports, "useCompoundParent", ()=>useCompoundParent);
var _react = require("react");
"use client";
const CompoundComponentContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Sorts the subitems by their position in the DOM.
 */ function sortSubitems(subitems) {
    const subitemsArray = Array.from(subitems.keys()).map((key)=>{
        const subitem = subitems.get(key);
        return {
            key,
            subitem
        };
    });
    subitemsArray.sort((a, b)=>{
        const aNode = a.subitem.ref.current;
        const bNode = b.subitem.ref.current;
        if (aNode === null || bNode === null || aNode === bNode) return 0;
        // eslint-disable-next-line no-bitwise
        return aNode.compareDocumentPosition(bNode) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
    });
    return new Map(subitemsArray.map((item)=>[
            item.key,
            item.subitem
        ]));
}
function useCompoundParent() {
    const [subitems, setSubitems] = _react.useState(new Map());
    const subitemKeys = _react.useRef(new Set());
    const deregisterItem = _react.useCallback(function deregisterItem(id) {
        subitemKeys.current.delete(id);
        setSubitems((previousState)=>{
            const newState = new Map(previousState);
            newState.delete(id);
            return newState;
        });
    }, []);
    const registerItem = _react.useCallback(function registerItem(id, item) {
        let providedOrGeneratedId;
        if (typeof id === "function") providedOrGeneratedId = id(subitemKeys.current);
        else providedOrGeneratedId = id;
        subitemKeys.current.add(providedOrGeneratedId);
        setSubitems((previousState)=>{
            const newState = new Map(previousState);
            newState.set(providedOrGeneratedId, item);
            return newState;
        });
        return {
            id: providedOrGeneratedId,
            deregister: ()=>deregisterItem(providedOrGeneratedId)
        };
    }, [
        deregisterItem
    ]);
    const sortedSubitems = _react.useMemo(()=>sortSubitems(subitems), [
        subitems
    ]);
    const getItemIndex = _react.useCallback(function getItemIndex(id) {
        return Array.from(sortedSubitems.keys()).indexOf(id);
    }, [
        sortedSubitems
    ]);
    const contextValue = _react.useMemo(()=>({
            getItemIndex,
            registerItem,
            totalSubitemCount: subitems.size
        }), [
        getItemIndex,
        registerItem,
        subitems.size
    ]);
    return {
        contextValue,
        subitems: sortedSubitems
    };
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l1gbB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Registers a child component with the parent component.
 *
 * @param id A unique key for the child component. If the `id` is `undefined`, the registration logic will not run (this can sometimes be the case during SSR).
 *   This can be either a value, or a function that generates a value based on already registered siblings' ids.
 *   If a function, it's called with the set of the ids of all the items that have already been registered.
 *   Return `existingKeys.size` if you want to use the index of the new item as the id.
 * @param itemMetadata Arbitrary metadata to pass to the parent component. This should be a stable reference (for example a memoized object), to avoid unnecessary re-registrations.
 *
 * @ignore - internal hook.
 */ parcelHelpers.export(exports, "useCompoundItem", ()=>useCompoundItem);
var _react = require("react");
var _utils = require("@mui/utils");
var _useCompoundParent = require("./useCompoundParent");
"use client";
function useCompoundItem(id, itemMetadata) {
    const context = _react.useContext((0, _useCompoundParent.CompoundComponentContext));
    if (context === null) throw new Error("useCompoundItem must be used within a useCompoundParent");
    const { registerItem } = context;
    const [registeredId, setRegisteredId] = _react.useState(typeof id === "function" ? undefined : id);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const { id: returnedId, deregister } = registerItem(id, itemMetadata);
        setRegisteredId(returnedId);
        return deregister;
    }, [
        registerItem,
        itemMetadata,
        id
    ]);
    return {
        id: registeredId,
        index: registeredId !== undefined ? context.getItemIndex(registeredId) : -1,
        totalItemCount: context.totalSubitemCount
    };
}

},{"react":"BK2ob","@mui/utils":"97HmB","./useCompoundParent":"1S5WE","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bO91k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Combines the two get*Props functions from Base UI hooks into one.
 * Useful when a hook uses two other hooks behind the scenes
 * (such as useSelect that depends on useList and useButton for its root slot).
 *
 * The resulting function will return the combined props.
 * They are merged from left to right, similarly to how Object.assign works.
 *
 * The getSecondProps function will receive the result of the getFirstProps function as its argument,
 * so its event handlers can call the previous handlers and act depending on its result.
 *
 * @param getFirstProps - A getter function that returns the props for the first slot. It receives the external event handlers as its argument.
 * @param getSecondProps - A getter function that returns the props for the second slot. It receives the result of the getFirstProps function as its argument.
 */ parcelHelpers.export(exports, "combineHooksSlotProps", ()=>combineHooksSlotProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function combineHooksSlotProps(getFirstProps, getSecondProps) {
    return function getCombinedProps(external = {}) {
        const firstResult = (0, _extendsDefault.default)({}, external, getFirstProps(external));
        const result = (0, _extendsDefault.default)({}, firstResult, getSecondProps(firstResult));
        return result;
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eY6WF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stabilizes the ListContext value for the Option component, so it doesn't change when sibling Options update.
 *
 * @param value The value of the Option.
 * @returns The stable ListContext value.
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/#hooks)
 *
 * API:
 *
 * - [useOptionContextStabilizer API](https://mui.com/base-ui/react-select/hooks-api/#use-option-context-stabilizer)
 */ parcelHelpers.export(exports, "useOptionContextStabilizer", ()=>useOptionContextStabilizer);
var _react = require("react");
var _useList = require("../useList");
"use client";
function useOptionContextStabilizer(value) {
    const listContext = _react.useContext((0, _useList.ListContext));
    if (!listContext) throw new Error("Option: ListContext was not found.");
    const { getItemState, dispatch } = listContext;
    const { highlighted, selected, focusable } = getItemState(value);
    // The local version of getItemState can be only called with the current Option's value.
    // It doesn't make much sense to render an Option depending on other Options' state anyway.
    const localGetItemState = _react.useCallback((itemValue)=>{
        if (itemValue !== value) throw new Error([
            "Base UI Option: Tried to access the state of another Option.",
            "This is unsupported when the Option uses the OptionContextStabilizer as a performance optimization."
        ].join("/n"));
        return {
            highlighted,
            selected,
            focusable
        };
    }, [
        highlighted,
        selected,
        focusable,
        value
    ]);
    // Create a local (per Option) instance of the ListContext that changes only when
    // the getItemState's return value changes.
    // This makes Options re-render only when their state actually change, not when any Option's state changes.
    const localContextValue = _react.useMemo(()=>({
            dispatch,
            getItemState: localGetItemState
        }), [
        dispatch,
        localGetItemState
    ]);
    return {
        contextValue: localContextValue
    };
}

},{"react":"BK2ob","../useList":"9r6z0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a4mv3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper));
parcelHelpers.export(exports, "popperClasses", ()=>(0, _popperClasses.popperClasses));
parcelHelpers.export(exports, "getPopperUtilityClass", ()=>(0, _popperClasses.getPopperUtilityClass));
var _popper = require("./Popper");
var _popperClasses = require("./popperClasses");
"use client";

},{"./Popper":"9cUeI","./popperClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9cUeI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("@mui/utils");
var _core = require("@popperjs/core");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("../composeClasses");
var _portal = require("../Portal");
var _popperClasses = require("./popperClasses");
var _utils1 = require("../utils");
var _classNameConfigurator = require("../utils/ClassNameConfigurator");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], _excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function isVirtualElement(element) {
    return !isHTMLElement(element);
}
const useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _classNameConfigurator.useClassNamesOverride)((0, _popperClasses.getPopperUtilityClass)));
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/ _react.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl, children, direction, disablePortal, modifiers, open, placement: initialPlacement, popperOptions, popperRef: popperRefProp, slotProps = {}, slots = {}, TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const tooltipRef = _react.useRef(null);
    const ownRef = (0, _utils.unstable_useForkRef)(tooltipRef, forwardedRef);
    const popperRef = _react.useRef(null);
    const handlePopperRef = (0, _utils.unstable_useForkRef)(popperRef, popperRefProp);
    const handlePopperRefRef = _react.useRef(handlePopperRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    _react.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = _react.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = _react.useState(resolveAnchorEl(anchorEl));
    _react.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    _react.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, _core.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, _extendsDefault.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, _utils1.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const Popper = /*#__PURE__*/ _react.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl, children, container: containerProp, direction = "ltr", disablePortal = false, keepMounted = false, modifiers, open, placement = "bottom", popperOptions = defaultPopperOptions, popperRef, style, transition = false, slotProps = {}, slots = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const [exited, setExited] = _react.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? (0, _utils.unstable_ownerDocument)(resolvedAnchorEl).body : (0, _utils.unstable_ownerDocument)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portal.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperTooltip, (0, _extendsDefault.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, _extendsDefault.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","@mui/utils":"97HmB","@popperjs/core":"4k2cP","prop-types":"hRUel","../composeClasses":"6pdJK","../Portal":"o96uw","./popperClasses":"01wV7","../utils":"iiPtN","../utils/ClassNameConfigurator":"kCQEI","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4k2cP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"MeOP3","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3EArf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead"; // pure-logic modifiers
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gEh3b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"djmYA","./dom-utils/getLayoutRect.js":"fwOX3","./dom-utils/listScrollParents.js":"bfID2","./dom-utils/getOffsetParent.js":"fjCAx","./utils/orderModifiers.js":"jfaV3","./utils/debounce.js":"a6Ifh","./utils/mergeByName.js":"880AM","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"2KD9p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"djmYA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"l2wEh","./getNodeScroll.js":"jU4Z5","./getNodeName.js":"cXawf","./instanceOf.js":"2KD9p","./getWindowScrollBarX.js":"jjolS","./getDocumentElement.js":"gwsiN","./isScrollParent.js":"e8DK9","../utils/math.js":"4uzfI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l2wEh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"2KD9p","../utils/math.js":"4uzfI","./getWindow.js":"6MDZ0","./isLayoutViewport.js":"8Z6FH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2KD9p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"6MDZ0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6MDZ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4uzfI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8Z6FH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6bmpj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6bmpj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jU4Z5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"4MHyS","./getWindow.js":"6MDZ0","./instanceOf.js":"2KD9p","./getHTMLElementScroll.js":"aUXsu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4MHyS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"6MDZ0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aUXsu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cXawf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jjolS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"l2wEh","./getDocumentElement.js":"gwsiN","./getWindowScroll.js":"4MHyS","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gwsiN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"2KD9p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e8DK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"021gN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"021gN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"6MDZ0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fwOX3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"l2wEh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bfID2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"8l2nJ","./getParentNode.js":"f7RWg","./getWindow.js":"6MDZ0","./isScrollParent.js":"e8DK9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8l2nJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"f7RWg","./isScrollParent.js":"e8DK9","./getNodeName.js":"cXawf","./instanceOf.js":"2KD9p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f7RWg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"cXawf","./getDocumentElement.js":"gwsiN","./instanceOf.js":"2KD9p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fjCAx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === "html" || (0, _getNodeNameJsDefault.default)(offsetParent) === "body" && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"6MDZ0","./getNodeName.js":"cXawf","./getComputedStyle.js":"021gN","./instanceOf.js":"2KD9p","./isTableElement.js":"lGmVX","./getParentNode.js":"f7RWg","../utils/userAgent.js":"6bmpj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lGmVX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"cXawf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jfaV3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"3EArf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a6Ifh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"880AM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cna1f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"f9xfg","../dom-utils/getDocumentElement.js":"gwsiN","../dom-utils/getBoundingClientRect.js":"l2wEh","./computeOffsets.js":"eOx0o","./rectToClientRect.js":"129AP","../enums.js":"3EArf","../dom-utils/instanceOf.js":"2KD9p","./mergePaddingObject.js":"dfQEa","./expandToHashMap.js":"8PH5P","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f9xfg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"3EArf","./getViewportRect.js":"gSEBy","./getDocumentRect.js":"aF4CD","./listScrollParents.js":"bfID2","./getOffsetParent.js":"fjCAx","./getDocumentElement.js":"gwsiN","./getComputedStyle.js":"021gN","./instanceOf.js":"2KD9p","./getBoundingClientRect.js":"l2wEh","./getParentNode.js":"f7RWg","./contains.js":"j1qcA","./getNodeName.js":"cXawf","../utils/rectToClientRect.js":"129AP","../utils/math.js":"4uzfI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gSEBy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"6MDZ0","./getDocumentElement.js":"gwsiN","./getWindowScrollBarX.js":"jjolS","./isLayoutViewport.js":"8Z6FH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aF4CD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === "rtl") x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gwsiN","./getComputedStyle.js":"021gN","./getWindowScrollBarX.js":"jjolS","./getWindowScroll.js":"4MHyS","../utils/math.js":"4uzfI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j1qcA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"2KD9p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"129AP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eOx0o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"9XOIH","./getVariation.js":"2Q3ms","./getMainAxisFromPlacement.js":"bS5Tf","../enums.js":"3EArf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9XOIH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}

},{"../enums.js":"3EArf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2Q3ms":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split("-")[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bS5Tf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dfQEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gV1xS","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gV1xS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8PH5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"MeOP3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"gEh3b","./modifiers/eventListeners.js":"1NK84","./modifiers/popperOffsets.js":"6MN8l","./modifiers/computeStyles.js":"1blLX","./modifiers/applyStyles.js":"5pvdZ","./modifiers/offset.js":"al7XM","./modifiers/flip.js":"eWblS","./modifiers/preventOverflow.js":"eXIVv","./modifiers/arrow.js":"9Rf6n","./modifiers/hide.js":"gFmpd","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1NK84":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    });
    if (resize) window.addEventListener("resize", instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"6MDZ0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6MN8l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"eOx0o","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1blLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"3EArf","../dom-utils/getOffsetParent.js":"fjCAx","../dom-utils/getWindow.js":"6MDZ0","../dom-utils/getDocumentElement.js":"gwsiN","../dom-utils/getComputedStyle.js":"021gN","../utils/getBasePlacement.js":"9XOIH","../utils/getVariation.js":"2Q3ms","../utils/math.js":"4uzfI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5pvdZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect,
    requires: [
        "computeStyles"
    ]
};

},{"../dom-utils/getNodeName.js":"cXawf","../dom-utils/instanceOf.js":"2KD9p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"al7XM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"9XOIH","../enums.js":"3EArf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eWblS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"7KXLO","../utils/getBasePlacement.js":"9XOIH","../utils/getOppositeVariationPlacement.js":"i1ARB","../utils/detectOverflow.js":"cna1f","../utils/computeAutoPlacement.js":"ai0EF","../enums.js":"3EArf","../utils/getVariation.js":"2Q3ms","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7KXLO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i1ARB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ai0EF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"2Q3ms","../enums.js":"3EArf","./detectOverflow.js":"cna1f","./getBasePlacement.js":"9XOIH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eXIVv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === "x" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

},{"../enums.js":"3EArf","../utils/getBasePlacement.js":"9XOIH","../utils/getMainAxisFromPlacement.js":"bS5Tf","../utils/getAltAxis.js":"9CQT4","../utils/within.js":"g8uyu","../dom-utils/getLayoutRect.js":"fwOX3","../dom-utils/getOffsetParent.js":"fjCAx","../utils/detectOverflow.js":"cna1f","../utils/getVariation.js":"2Q3ms","../utils/getFreshSideObject.js":"gV1xS","../utils/math.js":"4uzfI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9CQT4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g8uyu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"4uzfI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9Rf6n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

},{"../utils/getBasePlacement.js":"9XOIH","../dom-utils/getLayoutRect.js":"fwOX3","../dom-utils/contains.js":"j1qcA","../dom-utils/getOffsetParent.js":"fjCAx","../utils/getMainAxisFromPlacement.js":"bS5Tf","../utils/within.js":"g8uyu","../utils/mergePaddingObject.js":"dfQEa","../utils/expandToHashMap.js":"8PH5P","../enums.js":"3EArf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gFmpd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};

},{"../enums.js":"3EArf","../utils/detectOverflow.js":"cna1f","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"o96uw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>(0, _portal.Portal));
var _portal = require("./Portal");
var _portalTypes = require("./Portal.types");
parcelHelpers.exportAll(_portalTypes, exports);
"use client";

},{"./Portal":"a8GfH","./Portal.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a8GfH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
var _react = require("react");
var _reactDom = require("react-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const Portal = /*#__PURE__*/ _react.forwardRef(function Portal(props, forwardedRef) {
    const { children, container, disablePortal = false } = props;
    const [mountNode, setMountNode] = _react.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, _utils.unstable_useForkRef)(/*#__PURE__*/ _react.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!disablePortal) setMountNode(getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (mountNode && !disablePortal) {
            (0, _utils.unstable_setRef)(forwardedRef, mountNode);
            return ()=>{
                (0, _utils.unstable_setRef)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ _react.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ _react.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: mountNode ? /*#__PURE__*/ _reactDom.createPortal(children, mountNode) : mountNode
    });
});

},{"react":"BK2ob","react-dom":"izP7d","prop-types":"hRUel","@mui/utils":"97HmB","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"01wV7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopperUtilityClass", ()=>getPopperUtilityClass);
parcelHelpers.export(exports, "popperClasses", ()=>popperClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClasses = require("../generateUtilityClasses");
const COMPONENT_NAME = "Popper";
function getPopperUtilityClass(slot) {
    return (0, _generateUtilityClass.generateUtilityClass)(COMPONENT_NAME, slot);
}
const popperClasses = (0, _generateUtilityClasses.generateUtilityClasses)(COMPONENT_NAME, [
    "root"
]);

},{"../generateUtilityClass":"1p7yp","../generateUtilityClasses":"cyr6u","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9hHXa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>(0, _select.Select));
var _select = require("./Select");
var _selectClasses = require("./selectClasses");
parcelHelpers.exportAll(_selectClasses, exports);
var _selectTypes = require("./Select.types");
parcelHelpers.exportAll(_selectTypes, exports);
"use client";

},{"./Select":"Vqk2V","./selectClasses":"kcC7H","./Select.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"Vqk2V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _useSelect = require("../useSelect");
var _utils1 = require("../utils");
var _popup = require("../Unstable_Popup/Popup");
var _composeClasses = require("../composeClasses");
var _selectClasses = require("./selectClasses");
var _defaultOptionStringifier = require("../useSelect/defaultOptionStringifier");
var _classNameConfigurator = require("../utils/ClassNameConfigurator");
var _selectProvider = require("../useSelect/SelectProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "areOptionsEqual",
    "autoComplete",
    "autoFocus",
    "children",
    "defaultValue",
    "defaultListboxOpen",
    "disabled",
    "getSerializedValue",
    "listboxId",
    "listboxOpen",
    "multiple",
    "name",
    "required",
    "onChange",
    "onListboxOpenChange",
    "getOptionAsString",
    "renderValue",
    "placeholder",
    "slotProps",
    "slots",
    "value"
];
function defaultRenderValue(selectedOptions) {
    var _selectedOptions$labe;
    if (Array.isArray(selectedOptions)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: selectedOptions.map((o)=>o.label).join(", ")
    });
    return (_selectedOptions$labe = selectedOptions == null ? void 0 : selectedOptions.label) != null ? _selectedOptions$labe : null;
}
function useUtilityClasses(ownerState) {
    const { active, disabled, open, focusVisible } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible",
            active && "active",
            open && "expanded"
        ],
        listbox: [
            "listbox",
            disabled && "disabled"
        ],
        popup: [
            "popup"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _classNameConfigurator.useClassNamesOverride)((0, _selectClasses.getSelectUtilityClass)));
}
/**
 * The foundation for building custom-styled select components.
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/)
 *
 * API:
 *
 * - [Select API](https://mui.com/base-ui/react-select/components-api/#select)
 */ const Select = /*#__PURE__*/ _react.forwardRef(function Select(props, forwardedRef) {
    var _slots$root, _slots$listbox, _slots$popup, _ref, _renderValue;
    const { areOptionsEqual, autoComplete, autoFocus, children, defaultValue, defaultListboxOpen = false, disabled: disabledProp, getSerializedValue, listboxId, listboxOpen: listboxOpenProp, multiple = false, name, required = false, onChange, onListboxOpenChange, getOptionAsString = (0, _defaultOptionStringifier.defaultOptionStringifier), renderValue: renderValueProp, placeholder, slotProps = {}, slots = {}, value: valueProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const renderValue = renderValueProp != null ? renderValueProp : defaultRenderValue;
    const [buttonDefined, setButtonDefined] = _react.useState(false);
    const buttonRef = _react.useRef(null);
    const listboxRef = _react.useRef(null);
    const Button = (_slots$root = slots.root) != null ? _slots$root : "button";
    const ListboxRoot = (_slots$listbox = slots.listbox) != null ? _slots$listbox : "ul";
    const PopupComponent = (_slots$popup = slots.popup) != null ? _slots$popup : "div";
    const handleButtonRefChange = _react.useCallback((element)=>{
        setButtonDefined(element != null);
    }, []);
    const handleButtonRef = (0, _utils.unstable_useForkRef)(forwardedRef, buttonRef, handleButtonRefChange);
    _react.useEffect(()=>{
        if (autoFocus) buttonRef.current.focus();
    }, [
        autoFocus
    ]);
    const { buttonActive, buttonFocusVisible, contextValue, disabled, getButtonProps, getListboxProps, getHiddenInputProps, getOptionMetadata, value, open } = (0, _useSelect.useSelect)({
        name,
        required,
        getSerializedValue,
        areOptionsEqual,
        buttonRef: handleButtonRef,
        defaultOpen: defaultListboxOpen,
        defaultValue,
        disabled: disabledProp,
        listboxId,
        multiple,
        open: listboxOpenProp,
        onChange,
        onOpenChange: onListboxOpenChange,
        getOptionAsString,
        value: valueProp,
        componentName: "Select"
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        active: buttonActive,
        defaultListboxOpen,
        disabled,
        focusVisible: buttonFocusVisible,
        open,
        multiple,
        renderValue,
        value
    });
    const classes = useUtilityClasses(ownerState);
    const buttonProps = (0, _utils1.useSlotProps)({
        elementType: Button,
        getSlotProps: getButtonProps,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        ownerState,
        className: classes.root
    });
    const listboxProps = (0, _utils1.useSlotProps)({
        elementType: ListboxRoot,
        getSlotProps: getListboxProps,
        externalSlotProps: slotProps.listbox,
        additionalProps: {
            ref: listboxRef
        },
        ownerState,
        className: classes.listbox
    });
    const popupProps = (0, _utils1.useSlotProps)({
        elementType: PopupComponent,
        externalSlotProps: slotProps.popup,
        additionalProps: {
            anchor: buttonRef.current,
            keepMounted: true,
            open,
            placement: "bottom-start",
            role: undefined
        },
        ownerState,
        className: classes.popup
    });
    let selectedOptionsMetadata;
    if (multiple) selectedOptionsMetadata = value.map((v)=>getOptionMetadata(v)).filter((o)=>o !== undefined);
    else {
        var _getOptionMetadata;
        selectedOptionsMetadata = (_getOptionMetadata = getOptionMetadata(value)) != null ? _getOptionMetadata : null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, (0, _extendsDefault.default)({}, buttonProps, {
                children: (_ref = (_renderValue = renderValue(selectedOptionsMetadata)) != null ? _renderValue : placeholder) != null ? _ref : // from https://github.com/mui/material-ui/pull/24563
                _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                }))
            })),
            buttonDefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popup.Popup), (0, _extendsDefault.default)({
                slots: {
                    root: PopupComponent
                }
            }, popupProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListboxRoot, (0, _extendsDefault.default)({}, listboxProps, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectProvider.SelectProvider), {
                        value: contextValue,
                        children: children
                    })
                }))
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _extendsDefault.default)({}, getHiddenInputProps(), {
                autoComplete: autoComplete
            }))
        ]
    });
});

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","@mui/utils":"97HmB","../useSelect":"1693M","../utils":"iiPtN","../Unstable_Popup/Popup":"3LZVj","../composeClasses":"6pdJK","./selectClasses":"kcC7H","../useSelect/defaultOptionStringifier":"emytt","../utils/ClassNameConfigurator":"kCQEI","../useSelect/SelectProvider":"kc9jv","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1693M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelect", ()=>(0, _useSelect.useSelect));
var _useSelect = require("./useSelect");
var _useSelectTypes = require("./useSelect.types");
parcelHelpers.exportAll(_useSelectTypes, exports);
var _selectProvider = require("./SelectProvider");
parcelHelpers.exportAll(_selectProvider, exports);
"use client";

},{"./useSelect":"fAtxk","./useSelect.types":false,"./SelectProvider":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fAtxk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelect", ()=>useSelect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _useButton = require("../useButton");
var _useSelectTypes = require("./useSelect.types");
var _useList = require("../useList");
var _defaultOptionStringifier = require("./defaultOptionStringifier");
var _useCompound = require("../useCompound");
var _extractEventHandlers = require("../utils/extractEventHandlers");
var _selectReducer = require("./selectReducer");
var _combineHooksSlotProps = require("../utils/combineHooksSlotProps");
"use client";
function defaultFormValueProvider(selectedOption) {
    if (Array.isArray(selectedOption)) {
        if (selectedOption.length === 0) return "";
        return JSON.stringify(selectedOption.map((o)=>o.value));
    }
    if ((selectedOption == null ? void 0 : selectedOption.value) == null) return "";
    if (typeof selectedOption.value === "string" || typeof selectedOption.value === "number") return selectedOption.value;
    return JSON.stringify(selectedOption.value);
}
/**
 *
 * Demos:
 *
 * - [Select](https://mui.com/base-ui/react-select/#hooks)
 *
 * API:
 *
 * - [useSelect API](https://mui.com/base-ui/react-select/hooks-api/#use-select)
 */ function useSelect(props) {
    const { areOptionsEqual, buttonRef: buttonRefProp, defaultOpen = false, defaultValue: defaultValueProp, disabled = false, listboxId: listboxIdProp, listboxRef: listboxRefProp, multiple = false, name, required, onChange, onHighlightChange, onOpenChange, open: openProp, options: optionsParam, getOptionAsString = (0, _defaultOptionStringifier.defaultOptionStringifier), getSerializedValue = defaultFormValueProvider, value: valueProp, componentName = "useSelect" } = props;
    const buttonRef = _react.useRef(null);
    const handleButtonRef = (0, _utils.unstable_useForkRef)(buttonRefProp, buttonRef);
    const listboxRef = _react.useRef(null);
    const listboxId = (0, _utils.unstable_useId)(listboxIdProp);
    let defaultValue;
    if (valueProp === undefined && defaultValueProp === undefined) defaultValue = [];
    else if (defaultValueProp !== undefined) {
        if (multiple) defaultValue = defaultValueProp;
        else defaultValue = defaultValueProp == null ? [] : [
            defaultValueProp
        ];
    }
    const value = _react.useMemo(()=>{
        if (valueProp !== undefined) {
            if (multiple) return valueProp;
            return valueProp == null ? [] : [
                valueProp
            ];
        }
        return undefined;
    }, [
        valueProp,
        multiple
    ]);
    const { subitems, contextValue: compoundComponentContextValue } = (0, _useCompound.useCompoundParent)();
    const options = _react.useMemo(()=>{
        if (optionsParam != null) return new Map(optionsParam.map((option, index)=>[
                option.value,
                {
                    value: option.value,
                    label: option.label,
                    disabled: option.disabled,
                    ref: /*#__PURE__*/ _react.createRef(),
                    id: `${listboxId}_${index}`
                }
            ]));
        return subitems;
    }, [
        optionsParam,
        subitems,
        listboxId
    ]);
    const handleListboxRef = (0, _utils.unstable_useForkRef)(listboxRefProp, listboxRef);
    const { getRootProps: getButtonRootProps, active: buttonActive, focusVisible: buttonFocusVisible, rootRef: mergedButtonRef } = (0, _useButton.useButton)({
        disabled,
        rootRef: handleButtonRef
    });
    const optionValues = _react.useMemo(()=>Array.from(options.keys()), [
        options
    ]);
    const getOptionByValue = _react.useCallback((valueToGet)=>{
        // This can't be simply `options.get(valueToGet)` because of the `areOptionsEqual` prop.
        // If it's provided, we assume that the user wants to compare the options by value.
        if (areOptionsEqual !== undefined) {
            const similarValue = optionValues.find((optionValue)=>areOptionsEqual(optionValue, valueToGet));
            return options.get(similarValue);
        }
        return options.get(valueToGet);
    }, [
        options,
        areOptionsEqual,
        optionValues
    ]);
    const isItemDisabled = _react.useCallback((valueToCheck)=>{
        var _option$disabled;
        const option = getOptionByValue(valueToCheck);
        return (_option$disabled = option == null ? void 0 : option.disabled) != null ? _option$disabled : false;
    }, [
        getOptionByValue
    ]);
    const stringifyOption = _react.useCallback((valueToCheck)=>{
        const option = getOptionByValue(valueToCheck);
        if (!option) return "";
        return getOptionAsString(option);
    }, [
        getOptionByValue,
        getOptionAsString
    ]);
    const controlledState = _react.useMemo(()=>({
            selectedValues: value,
            open: openProp
        }), [
        value,
        openProp
    ]);
    const getItemId = _react.useCallback((itemValue)=>{
        var _options$get;
        return (_options$get = options.get(itemValue)) == null ? void 0 : _options$get.id;
    }, [
        options
    ]);
    const handleSelectionChange = _react.useCallback((event, newValues)=>{
        if (multiple) onChange == null || onChange(event, newValues);
        else {
            var _newValues$;
            onChange == null || onChange(event, (_newValues$ = newValues[0]) != null ? _newValues$ : null);
        }
    }, [
        multiple,
        onChange
    ]);
    const handleHighlightChange = _react.useCallback((event, newValue)=>{
        onHighlightChange == null || onHighlightChange(event, newValue != null ? newValue : null);
    }, [
        onHighlightChange
    ]);
    const handleStateChange = _react.useCallback((event, field, fieldValue)=>{
        if (field === "open") {
            onOpenChange == null || onOpenChange(fieldValue);
            if (fieldValue === false && (event == null ? void 0 : event.type) !== "blur") {
                var _buttonRef$current;
                (_buttonRef$current = buttonRef.current) == null || _buttonRef$current.focus();
            }
        }
    }, [
        onOpenChange
    ]);
    const getItemDomElement = _react.useCallback((itemId)=>{
        var _subitems$get$ref$cur, _subitems$get;
        if (itemId == null) return null;
        return (_subitems$get$ref$cur = (_subitems$get = subitems.get(itemId)) == null ? void 0 : _subitems$get.ref.current) != null ? _subitems$get$ref$cur : null;
    }, [
        subitems
    ]);
    const useListParameters = {
        getInitialState: ()=>{
            var _defaultValue;
            return {
                highlightedValue: null,
                selectedValues: (_defaultValue = defaultValue) != null ? _defaultValue : [],
                open: defaultOpen
            };
        },
        getItemId,
        controlledProps: controlledState,
        focusManagement: "DOM",
        getItemDomElement,
        itemComparer: areOptionsEqual,
        isItemDisabled,
        rootRef: handleListboxRef,
        onChange: handleSelectionChange,
        onHighlightChange: handleHighlightChange,
        onStateChange: handleStateChange,
        reducerActionContext: _react.useMemo(()=>({
                multiple
            }), [
            multiple
        ]),
        items: optionValues,
        getItemAsString: stringifyOption,
        selectionMode: multiple ? "multiple" : "single",
        stateReducer: (0, _selectReducer.selectReducer),
        componentName
    };
    const { dispatch, getRootProps: getListboxRootProps, contextValue: listContextValue, state: { open, highlightedValue: highlightedOption, selectedValues: selectedOptions }, rootRef: mergedListRootRef } = (0, _useList.useList)(useListParameters);
    // store the initial open state to prevent focus stealing
    // (the first option gets focused only when the select is opened by the user)
    const isInitiallyOpen = _react.useRef(open);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (open && highlightedOption !== null) {
            var _getOptionByValue;
            const optionRef = (_getOptionByValue = getOptionByValue(highlightedOption)) == null ? void 0 : _getOptionByValue.ref;
            if (!listboxRef.current || !(optionRef != null && optionRef.current)) return;
            if (!isInitiallyOpen.current) optionRef.current.focus({
                preventScroll: true
            });
            const listboxClientRect = listboxRef.current.getBoundingClientRect();
            const optionClientRect = optionRef.current.getBoundingClientRect();
            if (optionClientRect.top < listboxClientRect.top) listboxRef.current.scrollTop -= listboxClientRect.top - optionClientRect.top;
            else if (optionClientRect.bottom > listboxClientRect.bottom) listboxRef.current.scrollTop += optionClientRect.bottom - listboxClientRect.bottom;
        }
    }, [
        open,
        highlightedOption,
        getOptionByValue
    ]);
    const getOptionMetadata = _react.useCallback((optionValue)=>getOptionByValue(optionValue), [
        getOptionByValue
    ]);
    const createHandleButtonClick = (externalEventHandlers)=>(event)=>{
            var _externalEventHandler;
            externalEventHandlers == null || (_externalEventHandler = externalEventHandlers.onClick) == null || _externalEventHandler.call(externalEventHandlers, event);
            if (!event.defaultMuiPrevented) {
                const action = {
                    type: (0, _useSelectTypes.SelectActionTypes).buttonClick,
                    event
                };
                dispatch(action);
            }
        };
    const createHandleButtonKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            if (event.defaultMuiPrevented) return;
            if (event.key === "ArrowDown" || event.key === "ArrowUp") {
                event.preventDefault();
                dispatch({
                    type: (0, _useList.ListActionTypes).keyDown,
                    key: event.key,
                    event
                });
            }
        };
    const getButtonOwnRootProps = (otherHandlers = {})=>({
            onClick: createHandleButtonClick(otherHandlers),
            onKeyDown: createHandleButtonKeyDown(otherHandlers)
        });
    const getSelectTriggerProps = (otherHandlers = {})=>{
        return (0, _extendsDefault.default)({}, otherHandlers, getButtonOwnRootProps(otherHandlers), {
            role: "combobox",
            "aria-expanded": open,
            "aria-controls": listboxId
        });
    };
    const getButtonProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        const combinedProps = (0, _combineHooksSlotProps.combineHooksSlotProps)(getSelectTriggerProps, getButtonRootProps);
        return (0, _extendsDefault.default)({}, externalProps, combinedProps(externalEventHandlers));
    };
    const createListboxHandleBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur, _listboxRef$current;
            (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
            if (event.defaultMuiPrevented) return;
            if ((_listboxRef$current = listboxRef.current) != null && _listboxRef$current.contains(event.relatedTarget) || event.relatedTarget === buttonRef.current) event.defaultMuiPrevented = true;
        };
    const getOwnListboxHandlers = (otherHandlers = {})=>({
            onBlur: createListboxHandleBlur(otherHandlers)
        });
    const getListboxProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        const getCombinedRootProps = (0, _combineHooksSlotProps.combineHooksSlotProps)(getOwnListboxHandlers, getListboxRootProps);
        return (0, _extendsDefault.default)({
            id: listboxId,
            role: "listbox",
            "aria-multiselectable": multiple ? "true" : undefined
        }, externalProps, getCombinedRootProps(externalEventHandlers));
    };
    _react.useDebugValue({
        selectedOptions,
        highlightedOption,
        open
    });
    const contextValue = _react.useMemo(()=>(0, _extendsDefault.default)({}, listContextValue, compoundComponentContextValue), [
        listContextValue,
        compoundComponentContextValue
    ]);
    let selectValue;
    if (props.multiple) selectValue = selectedOptions;
    else selectValue = selectedOptions.length > 0 ? selectedOptions[0] : null;
    let selectedOptionsMetadata;
    if (multiple) selectedOptionsMetadata = selectValue.map((v)=>getOptionMetadata(v)).filter((o)=>o !== undefined);
    else {
        var _getOptionMetadata;
        selectedOptionsMetadata = (_getOptionMetadata = getOptionMetadata(selectValue)) != null ? _getOptionMetadata : null;
    }
    const createHandleHiddenInputChange = (externalEventHandlers)=>(event)=>{
            var _externalEventHandler2;
            externalEventHandlers == null || (_externalEventHandler2 = externalEventHandlers.onChange) == null || _externalEventHandler2.call(externalEventHandlers, event);
            if (event.defaultMuiPrevented) return;
            const option = options.get(event.target.value);
            // support autofill
            if (event.target.value === "") dispatch({
                type: (0, _useList.ListActionTypes).clearSelection
            });
            else if (option !== undefined) dispatch({
                type: (0, _useSelectTypes.SelectActionTypes).browserAutoFill,
                item: option.value,
                event
            });
        };
    const getHiddenInputProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extractEventHandlers.extractEventHandlers)(externalProps);
        return (0, _extendsDefault.default)({
            name,
            tabIndex: -1,
            "aria-hidden": true,
            required: required ? true : undefined,
            value: getSerializedValue(selectedOptionsMetadata),
            style: (0, _utils.visuallyHidden)
        }, externalProps, {
            onChange: createHandleHiddenInputChange(externalEventHandlers)
        });
    };
    return {
        buttonActive,
        buttonFocusVisible,
        buttonRef: mergedButtonRef,
        contextValue,
        disabled,
        dispatch,
        getButtonProps,
        getHiddenInputProps,
        getListboxProps,
        getOptionMetadata,
        listboxRef: mergedListRootRef,
        open,
        options: optionValues,
        value: selectValue,
        highlightedOption
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils":"97HmB","../useButton":"9QEdr","./useSelect.types":"52E58","../useList":"9r6z0","./defaultOptionStringifier":"emytt","../useCompound":"3Yrrc","../utils/extractEventHandlers":"9VwKW","./selectReducer":"c3NOh","../utils/combineHooksSlotProps":"bO91k","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"52E58":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectActionTypes", ()=>SelectActionTypes);
const SelectActionTypes = {
    buttonClick: "buttonClick",
    browserAutoFill: "browserAutoFill"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"emytt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOptionStringifier", ()=>defaultOptionStringifier);
const defaultOptionStringifier = (option)=>{
    const { label, value } = option;
    if (typeof label === "string") return label;
    if (typeof value === "string") return value;
    // Fallback string representation
    return String(option);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c3NOh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectReducer", ()=>selectReducer);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _useList = require("../useList");
var _useSelectTypes = require("./useSelect.types");
function selectReducer(state, action) {
    const { open } = state;
    const { context: { selectionMode } } = action;
    if (action.type === (0, _useSelectTypes.SelectActionTypes).buttonClick) {
        var _state$selectedValues;
        const itemToHighlight = (_state$selectedValues = state.selectedValues[0]) != null ? _state$selectedValues : (0, _useList.moveHighlight)(null, "start", action.context);
        return (0, _extendsDefault.default)({}, state, {
            open: !open,
            highlightedValue: !open ? itemToHighlight : null
        });
    }
    if (action.type === (0, _useSelectTypes.SelectActionTypes).browserAutoFill) return (0, _useList.handleItemSelection)(action.item, state, action.context);
    const newState = (0, _useList.listReducer)(state, action);
    switch(action.type){
        case (0, _useList.ListActionTypes).keyDown:
            if (state.open) {
                if (action.event.key === "Escape") return (0, _extendsDefault.default)({}, newState, {
                    open: false
                });
            } else {
                if (action.event.key === "ArrowDown") {
                    var _state$selectedValues2;
                    return (0, _extendsDefault.default)({}, state, {
                        open: true,
                        highlightedValue: (_state$selectedValues2 = state.selectedValues[0]) != null ? _state$selectedValues2 : (0, _useList.moveHighlight)(null, "start", action.context)
                    });
                }
                if (action.event.key === "ArrowUp") {
                    var _state$selectedValues3;
                    return (0, _extendsDefault.default)({}, state, {
                        open: true,
                        highlightedValue: (_state$selectedValues3 = state.selectedValues[0]) != null ? _state$selectedValues3 : (0, _useList.moveHighlight)(null, "end", action.context)
                    });
                }
            }
            break;
        case (0, _useList.ListActionTypes).itemClick:
            if (selectionMode === "single") return (0, _extendsDefault.default)({}, newState, {
                open: false
            });
            break;
        case (0, _useList.ListActionTypes).blur:
            return (0, _extendsDefault.default)({}, newState, {
                open: false
            });
        default:
            return newState;
    }
    return newState;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","../useList":"9r6z0","./useSelect.types":"52E58","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kc9jv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Sets up the contexts for the underlying Option components.
 *
 * @ignore - do not document.
 */ parcelHelpers.export(exports, "SelectProvider", ()=>SelectProvider);
var _react = require("react");
var _listContext = require("../useList/ListContext");
var _useCompound = require("../useCompound");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function SelectProvider(props) {
    const { value, children } = props;
    const { dispatch, getItemIndex, getItemState, registerItem, totalSubitemCount } = value;
    const listContextValue = _react.useMemo(()=>({
            dispatch,
            getItemState,
            getItemIndex
        }), [
        dispatch,
        getItemIndex,
        getItemState
    ]);
    const compoundComponentContextValue = _react.useMemo(()=>({
            getItemIndex,
            registerItem,
            totalSubitemCount
        }), [
        registerItem,
        getItemIndex,
        totalSubitemCount
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useCompound.CompoundComponentContext).Provider, {
        value: compoundComponentContextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContext.ListContext).Provider, {
            value: listContextValue,
            children: children
        })
    });
}

},{"react":"BK2ob","../useList/ListContext":"kjK2F","../useCompound":"3Yrrc","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3LZVj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popup", ()=>Popup);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactDom = require("@floating-ui/react-dom");
var _utils = require("@mui/utils");
var _composeClasses = require("../composeClasses");
var _portal = require("../Portal");
var _utils1 = require("../utils");
var _classNameConfigurator = require("../utils/ClassNameConfigurator");
var _popupClasses = require("./popupClasses");
var _useTransition = require("../useTransition");
var _popupContext = require("./PopupContext");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "anchor",
    "children",
    "container",
    "disablePortal",
    "keepMounted",
    "middleware",
    "offset",
    "open",
    "placement",
    "slotProps",
    "slots",
    "strategy"
];
function useUtilityClasses(ownerState) {
    const { open } = ownerState;
    const slots = {
        root: [
            "root",
            open && "open"
        ]
    };
    return (0, _composeClasses.unstable_composeClasses)(slots, (0, _classNameConfigurator.useClassNamesOverride)((0, _popupClasses.getPopupUtilityClass)));
}
function resolveAnchor(anchor) {
    return typeof anchor === "function" ? anchor() : anchor;
}
/**
 *
 * Demos:
 *
 * - [Popup](https://mui.com/base-ui/react-popup/)
 *
 * API:
 *
 * - [Popup API](https://mui.com/base-ui/react-popup/components-api/#popup)
 */ const Popup = /*#__PURE__*/ _react.forwardRef(function Popup(props, forwardedRef) {
    var _slots$root;
    const { anchor: anchorProp, children, container, disablePortal = false, keepMounted = false, middleware, offset: offsetProp = 0, open = false, placement = "bottom", slotProps = {}, slots = {}, strategy = "absolute" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { refs, elements, floatingStyles, update, placement: finalPlacement } = (0, _reactDom.useFloating)({
        elements: {
            reference: resolveAnchor(anchorProp)
        },
        open,
        middleware: middleware != null ? middleware : [
            (0, _reactDom.offset)(offsetProp != null ? offsetProp : 0),
            (0, _reactDom.flip)(),
            (0, _reactDom.shift)()
        ],
        placement,
        strategy,
        whileElementsMounted: !keepMounted ? (0, _reactDom.autoUpdate) : undefined
    });
    const handleRef = (0, _utils.unstable_useForkRef)(refs.setFloating, forwardedRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (keepMounted && open && elements.reference && elements.floating) {
            const cleanup = (0, _reactDom.autoUpdate)(elements.reference, elements.floating, update);
            return cleanup;
        }
        return undefined;
    }, [
        keepMounted,
        open,
        elements,
        update
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disablePortal,
        keepMounted,
        offset: (0, _reactDom.offset),
        open,
        placement,
        finalPlacement,
        strategy
    });
    const { contextValue, hasExited: hasTransitionExited } = (0, _useTransition.useTransitionTrigger)(open);
    const visibility = keepMounted && hasTransitionExited ? "hidden" : undefined;
    const classes = useUtilityClasses(ownerState);
    const Root = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : "div";
    const rootProps = (0, _utils1.useSlotProps)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        ownerState,
        className: classes.root,
        additionalProps: {
            ref: handleRef,
            role: "tooltip",
            style: (0, _extendsDefault.default)({}, floatingStyles, {
                visibility
            })
        }
    });
    const popupContextValue = _react.useMemo(()=>({
            placement: finalPlacement
        }), [
        finalPlacement
    ]);
    const shouldRender = keepMounted || !hasTransitionExited;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portal.Portal), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popupContext.PopupContext).Provider, {
            value: popupContextValue,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _useTransition.TransitionContext).Provider, {
                value: contextValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
                    children: children
                }))
            })
        })
    });
});

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","@floating-ui/react-dom":"9PihP","@mui/utils":"97HmB","../composeClasses":"6pdJK","../Portal":"o96uw","../utils":"iiPtN","../utils/ClassNameConfigurator":"kCQEI","./popupClasses":"dAk1L","../useTransition":"bCHED","./PopupContext":"TxH41","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9PihP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoPlacement", ()=>(0, _dom.autoPlacement));
parcelHelpers.export(exports, "autoUpdate", ()=>(0, _dom.autoUpdate));
parcelHelpers.export(exports, "computePosition", ()=>(0, _dom.computePosition));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _dom.detectOverflow));
parcelHelpers.export(exports, "flip", ()=>(0, _dom.flip));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "hide", ()=>(0, _dom.hide));
parcelHelpers.export(exports, "inline", ()=>(0, _dom.inline));
parcelHelpers.export(exports, "limitShift", ()=>(0, _dom.limitShift));
parcelHelpers.export(exports, "offset", ()=>(0, _dom.offset));
parcelHelpers.export(exports, "platform", ()=>(0, _dom.platform));
parcelHelpers.export(exports, "shift", ()=>(0, _dom.shift));
parcelHelpers.export(exports, "size", ()=>(0, _dom.size));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "useFloating", ()=>useFloating);
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options,
        fn (state) {
            const { element, padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element,
                padding
            }).fn(state);
            return {};
        }
    };
};
var index = typeof document !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // biome-ignore lint/suspicious/noSelfCompare: in source
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    const dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    const ref = _react.useRef(value);
    index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    const { placement = "bottom", strategy = "absolute", middleware = [], platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform = true, whileElementsMounted, open } = options;
    const [data, setData] = _react.useState({
        x: 0,
        y: 0,
        strategy,
        placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = _react.useState(middleware);
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = _react.useState(null);
    const [_floating, _setFloating] = _react.useState(null);
    const setReference = _react.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = _react.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = _react.useRef(null);
    const floatingRef = _react.useRef(null);
    const dataRef = _react.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = useLatestRef(whileElementsMounted);
    const platformRef = useLatestRef(platform);
    const update = _react.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement,
            strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = _react.useRef(false);
    index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
    index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = _react.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference,
            setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = _react.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = _react.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = roundByDPR(elements.floating, data.x);
        const y = roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(()=>({
            ...data,
            update,
            refs,
            elements,
            floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}

},{"@floating-ui/dom":"7XyKU","react":"BK2ob","react-dom":"izP7d","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7XyKU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _core.detectOverflow));
parcelHelpers.export(exports, "offset", ()=>(0, _core.offset));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
const topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function isTopLayer(floating) {
    return topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + (0, _dom.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === "rtl") x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const window = (0, _dom.getWindow)(element);
    if (!(0, _dom.isHTMLElement)(element) || isTopLayer(element)) return window;
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && (0, _dom.getComputedStyle)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, _dom.getNodeName)(offsetParent) === "html" || (0, _dom.getNodeName)(offsetParent) === "body" && (0, _dom.getComputedStyle)(offsetParent).position === "static" && !(0, _dom.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, _dom.getContainingBlock)(element) || window;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === "rtl";
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left, top, width, height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === "function", layoutShift = typeof IntersectionObserver === "function", animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"hcjrd","@floating-ui/utils":"1CB66","@floating-ui/utils/dom":"anPxA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hcjrd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = "bottom", strategy = "absolute", middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = "clippingAncestors", rootBoundary = "viewport", elementContext = "floating", altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x,
        y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: "arrow",
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = "bestFit", fallbackAxisSideDirection = "none", flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = "referenceHidden", ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === "left";
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options,
        async fn (state) {
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === "y";
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, _utils.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, _utils.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"1CB66","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1CB66":[function(require,module,exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    "top",
    "right",
    "bottom",
    "left"
];
const alignments = [
    "start",
    "end"
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"anPxA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isContainingBlock(element) {
    const webkit = isWebKit();
    const css = getComputedStyle(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dAk1L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopupUtilityClass", ()=>getPopupUtilityClass);
parcelHelpers.export(exports, "popupClasses", ()=>popupClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClasses = require("../generateUtilityClasses");
const COMPONENT_NAME = "Popup";
function getPopupUtilityClass(slot) {
    return (0, _generateUtilityClass.generateUtilityClass)(COMPONENT_NAME, slot);
}
const popupClasses = (0, _generateUtilityClasses.generateUtilityClasses)(COMPONENT_NAME, [
    "root",
    "open"
]);

},{"../generateUtilityClass":"1p7yp","../generateUtilityClasses":"cyr6u","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bCHED":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useTransitionStateManager = require("./useTransitionStateManager");
parcelHelpers.exportAll(_useTransitionStateManager, exports);
var _useTransitionTrigger = require("./useTransitionTrigger");
parcelHelpers.exportAll(_useTransitionTrigger, exports);
var _transitionContext = require("./TransitionContext");
parcelHelpers.exportAll(_transitionContext, exports);

},{"./useTransitionStateManager":false,"./useTransitionTrigger":"7IvWC","./TransitionContext":"cIbcd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7IvWC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Allows child elements to be transitioned in and out.
 *
 * Demos:
 *
 * - [Transitions](https://mui.com/base-ui/react-transitions/#hooks)
 *
 * API:
 *
 * - [useTransitionTrigger API](https://mui.com/base-ui/react-transitions/hooks-api/#use-transition-trigger)
 */ parcelHelpers.export(exports, "useTransitionTrigger", ()=>useTransitionTrigger);
var _react = require("react");
"use client";
function useTransitionTrigger(requestEnter) {
    const [exitTransitionFinished, setExitTransitionFinished] = _react.useState(true);
    const hasPendingExitTransition = _react.useRef(false);
    const registeredTransitions = _react.useRef(0);
    const [hasTransition, setHasTransition] = _react.useState(false);
    const previousRequestEnter = _react.useRef(requestEnter);
    _react.useEffect(()=>{
        if (!requestEnter && // checking registeredTransitions.current instead of hasTransition to avoid this effect re-firing whenever hasTransition changes
        registeredTransitions.current > 0 && // prevents waiting for a pending transition right after mounting
        previousRequestEnter.current !== requestEnter) {
            hasPendingExitTransition.current = true;
            setExitTransitionFinished(false);
        }
        previousRequestEnter.current = requestEnter;
    }, [
        requestEnter
    ]);
    const handleExited = _react.useCallback(()=>{
        hasPendingExitTransition.current = false;
        setExitTransitionFinished(true);
    }, []);
    const registerTransition = _react.useCallback(()=>{
        registeredTransitions.current += 1;
        setHasTransition(true);
        return ()=>{
            registeredTransitions.current -= 1;
            if (registeredTransitions.current === 0) setHasTransition(false);
        };
    }, []);
    let hasExited;
    if (!hasTransition) // If there are no transitions registered, the `exited` state is opposite of `requestEnter` immediately.
    hasExited = !requestEnter;
    else if (requestEnter) hasExited = false;
    else hasExited = !hasPendingExitTransition.current && exitTransitionFinished;
    const contextValue = _react.useMemo(()=>({
            requestedEnter: requestEnter,
            onExited: handleExited,
            registerTransition,
            hasExited
        }), [
        handleExited,
        requestEnter,
        registerTransition,
        hasExited
    ]);
    return {
        contextValue,
        hasExited
    };
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cIbcd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransitionContext", ()=>TransitionContext);
var _react = require("react");
const TransitionContext = /*#__PURE__*/ _react.createContext(null);

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"TxH41":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopupContext", ()=>PopupContext);
var _react = require("react");
const PopupContext = /*#__PURE__*/ _react.createContext(null);

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kcC7H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectUtilityClass", ()=>getSelectUtilityClass);
parcelHelpers.export(exports, "selectClasses", ()=>selectClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClasses = require("../generateUtilityClasses");
const COMPONENT_NAME = "Select";
function getSelectUtilityClass(slot) {
    return (0, _generateUtilityClass.generateUtilityClass)(COMPONENT_NAME, slot);
}
const selectClasses = (0, _generateUtilityClasses.generateUtilityClasses)(COMPONENT_NAME, [
    "root",
    "button",
    "listbox",
    "popup",
    "active",
    "expanded",
    "disabled",
    "focusVisible"
]);

},{"../generateUtilityClass":"1p7yp","../generateUtilityClasses":"cyr6u","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"17Bhv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextareaAutosize", ()=>(0, _textareaAutosize.TextareaAutosize));
var _textareaAutosize = require("./TextareaAutosize");
var _textareaAutosizeTypes = require("./TextareaAutosize.types");
parcelHelpers.exportAll(_textareaAutosizeTypes, exports);
"use client";

},{"./TextareaAutosize":"glNfM","./TextareaAutosize.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"glNfM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextareaAutosize", ()=>TextareaAutosize);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const TextareaAutosize = /*#__PURE__*/ _react.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange, maxRows, minRows = 1, style, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(forwardedRef, inputRef);
    const shadowRef = _react.useRef(null);
    const calculateTextareaStyles = _react.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, _utils.unstable_ownerWindow)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle,
            overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = _react.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if (isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, _utils.unstable_debounce)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, _utils.unstable_ownerWindow)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", (0, _extendsDefault.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, _extendsDefault.default)({}, styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","@mui/utils":"97HmB","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aOEpF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSnackbar", ()=>(0, _useSnackbar.useSnackbar));
var _useSnackbar = require("./useSnackbar");
var _useSnackbarTypes = require("./useSnackbar.types");
parcelHelpers.exportAll(_useSnackbarTypes, exports);
"use client";

},{"./useSnackbar":"hQsX4","./useSnackbar.types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hQsX4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ parcelHelpers.export(exports, "useSnackbar", ()=>useSnackbar);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _extractEventHandlers = require("../utils/extractEventHandlers");
"use client";
function useSnackbar(parameters = {}) {
    const { autoHideDuration = null, disableWindowBlurListener = false, onClose, open, resumeHideDuration } = parameters;
    const timerAutoHide = (0, _utils.unstable_useTimeout)();
    _react.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, _utils.unstable_useEventCallback)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, _utils.unstable_useEventCallback)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, "timeout");
        });
    });
    _react.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = _react.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    _react.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, _extendsDefault.default)({}, (0, _extractEventHandlers.extractEventHandlers)(parameters), (0, _extractEventHandlers.extractEventHandlers)(externalProps));
        return (0, _extendsDefault.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps,
        onClickAway: handleClickAway
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils":"97HmB","../utils/extractEventHandlers":"9VwKW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5uzVA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_useModal", ()=>(0, _useModal.useModal));
var _useModal = require("./useModal");
var _useModalTypes = require("./useModal.types");
parcelHelpers.exportAll(_useModalTypes, exports);
var _modalManager = require("./ModalManager");
parcelHelpers.exportAll(_modalManager, exports);
"use client";

},{"./useModal":"chi98","./useModal.types":false,"./ModalManager":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"chi98":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ parcelHelpers.export(exports, "useModal", ()=>useModal);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _utils1 = require("../utils");
var _modalManager = require("./ModalManager");
"use client";
function getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new (0, _modalManager.ModalManager)();
function useModal(parameters) {
    const { container, disableEscapeKeyDown = false, disableScrollLock = false, // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager, closeAfterTransition = false, onTransitionEnter, onTransitionExited, children, onClose, open, rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = _react.useRef({});
    const mountNodeRef = _react.useRef(null);
    const modalRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(modalRef, rootRef);
    const [exited, setExited] = _react.useState(!open);
    const hasTransition = getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, _utils.unstable_ownerDocument)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, _utils.unstable_useEventCallback)(()=>{
        const resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = _react.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, _utils.unstable_useEventCallback)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, _modalManager.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = _react.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    _react.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    _react.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, _utils1.extractEventHandlers)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, _extendsDefault.default)({}, propsEventHandlers, otherHandlers);
        return (0, _extendsDefault.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, _extendsDefault.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, _utils.unstable_createChainedFunction)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, _utils.unstable_createChainedFunction)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps,
        getBackdropProps,
        getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal,
        exited,
        hasTransition
    };
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils":"97HmB","../utils":"iiPtN","./ModalManager":"8uhaa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8uhaa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ariaHidden", ()=>ariaHidden);
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ parcelHelpers.export(exports, "ModalManager", ()=>ModalManager);
var _utils = require("@mui/utils");
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    const doc = (0, _utils.unstable_ownerDocument)(container);
    if (doc.body === container) return (0, _utils.unstable_ownerWindow)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function getPaddingRight(element) {
    return parseInt((0, _utils.unstable_ownerWindow)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) ariaHidden(element, show);
    });
}
function findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, _utils.unstable_getScrollbarSize)((0, _utils.unstable_ownerDocument)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, _utils.unstable_ownerDocument)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, _utils.unstable_ownerDocument)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, _utils.unstable_ownerWindow)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value, el, property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class ModalManager {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) ariaHidden(modal.modalRef, false);
        const hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container,
            restore: null,
            hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, ariaHiddenState);
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

},{"@mui/utils":"97HmB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1tJK6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formControlState);
function formControlState({ props, states, muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"872Eo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const FormControlContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = FormControlContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3uzwm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormControl);
var _react = require("react");
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
"use client";
function useFormControl() {
    return _react.useContext((0, _formControlContextDefault.default));
}

},{"react":"BK2ob","./FormControlContext":"872Eo","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"imwu2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
"use client";
exports.default = (0, _useEnhancedEffectDefault.default);

},{"@mui/utils/useEnhancedEffect":"2Y1IL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"d55tF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);

},{"./GlobalStyles":"f8BDK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f8BDK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _defaultTheme = require("../styles/defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function GlobalStyles(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.GlobalStyles), (0, _extendsDefault.default)({}, props, {
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    }));
}
exports.default = GlobalStyles;

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/system":"6hP1D","../styles/defaultTheme":"7ToXf","../styles/identifier":"kUFJp","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3mLMB":[function(require,module,exports) {
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasValue", ()=>hasValue);
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
parcelHelpers.export(exports, "isFilled", ()=>isFilled);
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
parcelHelpers.export(exports, "isAdornedStart", ()=>isAdornedStart);
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== "" || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== "");
}
function isAdornedStart(obj) {
    return obj.startAdornment;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2O3eO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputBaseUtilityClass", ()=>getInputBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInputBase", slot);
}
const inputBaseClasses = (0, _generateUtilityClassesDefault.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
exports.default = inputBaseClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4bEXJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputUtilityClass", ()=>getInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInput", slot);
}
const inputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
exports.default = inputClasses;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","../InputBase":"ffdXP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kjWVZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _filledInputDefault.default));
parcelHelpers.export(exports, "filledInputClasses", ()=>(0, _filledInputClassesDefault.default));
var _filledInput = require("./FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _filledInputClasses = require("./filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
parcelHelpers.exportAll(_filledInputClasses, exports);
"use client";

},{"./FilledInput":"kg5NV","./filledInputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kg5NV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _filledInputClasses = require("./filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
var _inputBase1 = require("../InputBase/InputBase");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _filledInputClasses.getFilledInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const FilledInputRoot = (0, _styledDefault.default)((0, _inputBase1.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _inputBase1.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme, ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, _extendsDefault.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, _filledInputClassesDefault.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, _filledInputClassesDefault.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, _filledInputClassesDefault.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, _filledInputClassesDefault.default).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, _filledInputClassesDefault.default).disabled}, .${(0, _filledInputClassesDefault.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, _filledInputClassesDefault.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const FilledInputInput = (0, _styledDefault.default)((0, _inputBase1.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, _inputBase1.inputOverridesResolver)
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const FilledInput = /*#__PURE__*/ _react.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components = {}, componentsProps: componentsPropsProp, fullWidth = false, // declare here to prevent spreading to DOM
    inputComponent = "input", multiline = false, slotProps, slots = {}, type = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        fullWidth,
        inputComponent,
        multiline,
        type
    });
    const classes = useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState
        },
        input: {
            ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _deepmergeDefault.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : FilledInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
FilledInput.muiName = "Input";
exports.default = FilledInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","@mui/utils/deepmerge":"5eIl7","@mui/utils/refType":"l5hTY","prop-types":"hRUel","@mui/utils/composeClasses":"jj3MR","../InputBase":"ffdXP","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./filledInputClasses":"kTehV","../InputBase/InputBase":"b6IV1","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kTehV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFilledInputUtilityClass", ()=>getFilledInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFilledInput", slot);
}
const filledInputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
exports.default = filledInputClasses;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","../InputBase":"ffdXP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4FpQa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _outlinedInputDefault.default));
parcelHelpers.export(exports, "outlinedInputClasses", ()=>(0, _outlinedInputClassesDefault.default));
var _outlinedInput = require("./OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _outlinedInputClasses = require("./outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
parcelHelpers.exportAll(_outlinedInputClasses, exports);
"use client";

},{"./OutlinedInput":"5lFI6","./outlinedInputClasses":"dl5bx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5lFI6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _notchedOutline = require("./NotchedOutline");
var _notchedOutlineDefault = parcelHelpers.interopDefault(_notchedOutline);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _outlinedInputClasses = require("./outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
var _inputBase = require("../InputBase/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _outlinedInputClasses.getOutlinedInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const OutlinedInputRoot = (0, _styledDefault.default)((0, _inputBase.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, _inputBase.rootOverridesResolver)
})(({ theme, ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, _extendsDefault.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, _outlinedInputClassesDefault.default).focused} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, _outlinedInputClassesDefault.default).error} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, _outlinedInputClassesDefault.default).disabled} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const NotchedOutlineRoot = (0, _styledDefault.default)((0, _notchedOutlineDefault.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const OutlinedInputInput = (0, _styledDefault.default)((0, _inputBase.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, _inputBase.inputOverridesResolver)
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const OutlinedInput = /*#__PURE__*/ _react.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components = {}, fullWidth = false, inputComponent = "input", label, multiline = false, notched, slots = {}, type = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : OutlinedInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, _extendsDefault.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
OutlinedInput.muiName = "Input";
exports.default = OutlinedInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/utils/refType":"l5hTY","@mui/utils/composeClasses":"jj3MR","./NotchedOutline":"7KE3e","../FormControl/useFormControl":"3uzwm","../FormControl/formControlState":"1tJK6","../styles/styled":"axRcE","./outlinedInputClasses":"dl5bx","../InputBase/InputBase":"b6IV1","../styles/useThemeProps":"e7SGa","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7KE3e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotchedOutline);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const NotchedOutlineRoot = (0, _styledDefault.default)("fieldset", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const NotchedOutlineLegend = (0, _styledDefault.default)("legend", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, _extendsDefault.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function NotchedOutline(props) {
    const { className, label, notched } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        notched,
        withLabel
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, (0, _extendsDefault.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            }) : _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","../styles/styled":"axRcE","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dl5bx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOutlinedInputUtilityClass", ()=>getOutlinedInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiOutlinedInput", slot);
}
const outlinedInputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
exports.default = outlinedInputClasses;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","../InputBase":"ffdXP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c5mlT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputLabelDefault.default));
parcelHelpers.export(exports, "inputLabelClasses", ()=>(0, _inputLabelClassesDefault.default));
var _inputLabel = require("./InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _inputLabelClasses = require("./inputLabelClasses");
var _inputLabelClassesDefault = parcelHelpers.interopDefault(_inputLabelClasses);
parcelHelpers.exportAll(_inputLabelClasses, exports);
"use client";

},{"./InputLabel":"41C23","./inputLabelClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"41C23":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formLabel = require("../FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _inputLabelClasses = require("./inputLabelClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, formControl, size, shrink, disableAnimation, variant, required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, _capitalizeDefault.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _inputLabelClasses.getInputLabelUtilityClasses), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const InputLabelRoot = (0, _styledDefault.default)((0, _formLabelDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _formLabel.formLabelClasses).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, _extendsDefault.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, _extendsDefault.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, _extendsDefault.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const InputLabel = /*#__PURE__*/ _react.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation = false, shrink: shrinkProp, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableAnimation,
        formControl: muiFormControl,
        shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelRoot, (0, _extendsDefault.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
exports.default = InputLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/utils/composeClasses":"jj3MR","clsx":"bGtJT","../FormControl/formControlState":"1tJK6","../FormControl/useFormControl":"3uzwm","../FormLabel":"7ps6v","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","../styles/styled":"axRcE","./inputLabelClasses":"dy2Vh","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7ps6v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "formLabelClasses", ()=>(0, _formLabelClassesDefault.default));
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
parcelHelpers.exportAll(_formLabel, exports);
var _formLabelClasses = require("./formLabelClasses");
var _formLabelClassesDefault = parcelHelpers.interopDefault(_formLabelClasses);
parcelHelpers.exportAll(_formLabelClasses, exports);
"use client";

},{"./FormLabel":"9MGaE","./formLabelClasses":"5nESg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9MGaE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormLabelRoot", ()=>FormLabelRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _formLabelClasses = require("./formLabelClasses");
var _formLabelClassesDefault = parcelHelpers.interopDefault(_formLabelClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, color, focused, disabled, error, filled, required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formLabelClasses.getFormLabelUtilityClasses), classes);
};
const FormLabelRoot = (0, _styledDefault.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState }, styles)=>{
        return (0, _extendsDefault.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, _formLabelClassesDefault.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, _formLabelClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _formLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const AsteriskComponent = (0, _styledDefault.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme })=>({
        [`&.${(0, _formLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const FormLabel = /*#__PURE__*/ _react.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children, className, component = "label" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || "primary",
        component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormLabelRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
exports.default = FormLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../FormControl/formControlState":"1tJK6","../FormControl/useFormControl":"3uzwm","../utils/capitalize":"iHgWG","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./formLabelClasses":"5nESg","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5nESg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormLabelUtilityClasses", ()=>getFormLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormLabel", slot);
}
const formLabelClasses = (0, _generateUtilityClassesDefault.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
exports.default = formLabelClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dy2Vh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputLabelUtilityClasses", ()=>getInputLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInputLabel", slot);
}
const inputLabelClasses = (0, _generateUtilityClassesDefault.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
exports.default = inputLabelClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3AAKV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "useFormControl", ()=>(0, _useFormControlDefault.default));
parcelHelpers.export(exports, "formControlClasses", ()=>(0, _formControlClassesDefault.default));
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _useFormControl = require("./useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlClasses = require("./formControlClasses");
var _formControlClassesDefault = parcelHelpers.interopDefault(_formControlClasses);
parcelHelpers.exportAll(_formControlClasses, exports);
"use client";

},{"./FormControl":"6ipUM","./useFormControl":false,"./formControlClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6ipUM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _utils = require("../InputBase/utils");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _formControlClasses = require("./formControlClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, margin, fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, _capitalizeDefault.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formControlClasses.getFormControlUtilityClasses), classes);
};
const FormControlRoot = (0, _styledDefault.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState }, styles)=>{
        return (0, _extendsDefault.default)({}, styles.root, styles[`margin${(0, _capitalizeDefault.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const FormControl = /*#__PURE__*/ _react.forwardRef(function FormControl(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children, className, color = "primary", component = "div", disabled = false, error = false, focused: visuallyFocused, fullWidth = false, hiddenLabel = false, margin = "none", required = false, size = "medium", variant = "outlined" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        error,
        fullWidth,
        hiddenLabel,
        margin,
        required,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = _react.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) _react.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElementDefault.default)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, _isMuiElementDefault.default)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, _utils.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = _react.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) _react.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElementDefault.default)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, _utils.isFilled)(child.props, true) || (0, _utils.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = _react.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = _react.useMemo(()=>{
        return {
            adornedStart,
            setAdornedStart,
            color,
            disabled,
            error,
            filled,
            focused,
            fullWidth,
            hiddenLabel,
            size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect,
            required,
            variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormControlRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
exports.default = FormControl;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","../InputBase/utils":"3mLMB","../utils/capitalize":"iHgWG","../utils/isMuiElement":"b7VqP","./FormControlContext":"872Eo","./formControlClasses":"iHu4Z","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b7VqP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isMuiElement = require("@mui/utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
exports.default = (0, _isMuiElementDefault.default);

},{"@mui/utils/isMuiElement":"cTX3z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iHu4Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormControlUtilityClasses", ()=>getFormControlUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormControlUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormControl", slot);
}
const formControlClasses = (0, _generateUtilityClassesDefault.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
exports.default = formControlClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g4yj4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formHelperTextDefault.default));
parcelHelpers.export(exports, "formHelperTextClasses", ()=>(0, _formHelperTextClassesDefault.default));
var _formHelperText = require("./FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _formHelperTextClasses = require("./formHelperTextClasses");
var _formHelperTextClassesDefault = parcelHelpers.interopDefault(_formHelperTextClasses);
parcelHelpers.exportAll(_formHelperTextClasses, exports);
"use client";

},{"./FormHelperText":"ibkKO","./formHelperTextClasses":"kekCD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ibkKO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _formHelperTextClasses = require("./formHelperTextClasses");
var _formHelperTextClassesDefault = parcelHelpers.interopDefault(_formHelperTextClasses);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, contained, size, disabled, error, filled, focused, required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, _capitalizeDefault.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formHelperTextClasses.getFormHelperTextUtilityClasses), classes);
};
const FormHelperTextRoot = (0, _styledDefault.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, _formHelperTextClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _formHelperTextClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const FormHelperText = /*#__PURE__*/ _react.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children, className, component = "p" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
exports.default = FormHelperText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../FormControl/formControlState":"1tJK6","../FormControl/useFormControl":"3uzwm","../styles/styled":"axRcE","../utils/capitalize":"iHgWG","./formHelperTextClasses":"kekCD","../styles/useThemeProps":"e7SGa","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kekCD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormHelperTextUtilityClasses", ()=>getFormHelperTextUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormHelperTextUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiFormHelperText", slot);
}
const formHelperTextClasses = (0, _generateUtilityClassesDefault.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
exports.default = formHelperTextClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"itQ5O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "selectClasses", ()=>(0, _selectClassesDefault.default));
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectClasses = require("./selectClasses");
var _selectClassesDefault = parcelHelpers.interopDefault(_selectClasses);
parcelHelpers.exportAll(_selectClasses, exports);
"use client";

},{"./Select":"boHBA","./selectClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"boHBA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _selectInput = require("./SelectInput");
var _selectInputDefault = parcelHelpers.interopDefault(_selectInput);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _arrowDropDown = require("../internal/svg-icons/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _nativeSelectInput = require("../NativeSelect/NativeSelectInput");
var _nativeSelectInputDefault = parcelHelpers.interopDefault(_nativeSelectInput);
var _filledInput = require("../FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _outlinedInput = require("../OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], _excluded2 = [
    "root"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    return classes;
};
const styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const StyledInput = (0, _styledDefault.default)((0, _inputDefault.default), styledRootConfig)("");
const StyledOutlinedInput = (0, _styledDefault.default)((0, _outlinedInputDefault.default), styledRootConfig)("");
const StyledFilledInput = (0, _styledDefault.default)((0, _filledInputDefault.default), styledRootConfig)("");
const Select = /*#__PURE__*/ _react.forwardRef(function Select(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth = false, children, classes: classesProp = {}, className, defaultOpen = false, displayEmpty = false, IconComponent = (0, _arrowDropDownDefault.default), id, input, inputProps, label, labelId, MenuProps, multiple = false, native = false, onClose, onOpen, open, renderValue, SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const inputComponent = native ? (0, _nativeSelectInputDefault.default) : (0, _selectInputDefault.default);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        variant,
        classes: classesProp
    });
    const classes = useUtilityClasses(ownerState);
    const restOfClasses = (0, _objectWithoutPropertiesLooseDefault.default)(classes, _excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, _useForkRefDefault.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/ _react.cloneElement(InputComponent, (0, _extendsDefault.default)({
            // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, _extendsDefault.default)({
                children,
                error: fcs.error,
                IconComponent,
                variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id
            } : {
                autoWidth,
                defaultOpen,
                displayEmpty,
                labelId,
                MenuProps,
                onClose,
                onOpen,
                open,
                renderValue,
                SelectDisplayProps: (0, _extendsDefault.default)({
                    id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, _deepmergeDefault.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, _clsxDefault.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant
        }, other))
    });
});
Select.muiName = "Select";
exports.default = Select;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/deepmerge":"5eIl7","./SelectInput":"cuzy0","../FormControl/formControlState":"1tJK6","../FormControl/useFormControl":"3uzwm","../internal/svg-icons/ArrowDropDown":"eDL1b","../Input":"5D6wd","../NativeSelect/NativeSelectInput":"iuFKk","../FilledInput":"kjWVZ","../OutlinedInput":"4FpQa","../styles/useThemeProps":"e7SGa","../utils/useForkRef":"5kA2S","../styles/styled":"axRcE","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cuzy0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _menu = require("../Menu/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _nativeSelectInput = require("../NativeSelect/NativeSelectInput");
var _utils = require("../InputBase/utils");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _selectClasses = require("./selectClasses");
var _selectClassesDefault = parcelHelpers.interopDefault(_selectClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const SelectSelect = (0, _styledDefault.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, _selectClassesDefault.default).select}`]: styles.select
            },
            {
                [`&.${(0, _selectClassesDefault.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, _selectClassesDefault.default).error}`]: styles.error
            },
            {
                [`&.${(0, _selectClassesDefault.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, _nativeSelectInput.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, _selectClassesDefault.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const SelectIcon = (0, _styledDefault.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, _nativeSelectInput.nativeSelectIconStyles));
const SelectNativeInput = (0, _styledDefault.default)("input", {
    shouldForwardProp: (prop)=>(0, _styled.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, _capitalizeDefault.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _selectClasses.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const SelectInput = /*#__PURE__*/ _react.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus, autoWidth, children, className, defaultOpen, defaultValue, disabled, displayEmpty, error = false, IconComponent, inputRef: inputRefProp, labelId, MenuProps = {}, multiple, name, onBlur, onChange, onClose, onFocus, onOpen, open: openProp, readOnly, renderValue, SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [value, setValueState] = (0, _useControlledDefault.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, _useControlledDefault.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = _react.useRef(null);
    const displayRef = _react.useRef(null);
    const [displayNode, setDisplayNode] = _react.useState(null);
    const { current: isOpenControlled } = _react.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = _react.useState();
    const handleRef = (0, _useForkRefDefault.default)(ref, inputRefProp);
    const handleDisplayRef = _react.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    _react.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    _react.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    _react.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    _react.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, _ownerDocumentDefault.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = _react.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value,
                    name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, _utils.isFilled)({
        value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, _formatMuiErrorMessageDefault.default)(2));
            selected = value.some((v)=>areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ _react.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        variant,
        value,
        open,
        error
    });
    const classes = useUtilityClasses(ownerState);
    const paperProps = (0, _extendsDefault.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, _useIdDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSelect, (0, _extendsDefault.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, _clsxDefault.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: isEmpty(display) ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectNativeInput, (0, _extendsDefault.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), (0, _extendsDefault.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, _extendsDefault.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, _extendsDefault.default)({}, MenuProps.slotProps, {
                    paper: (0, _extendsDefault.default)({}, paperProps, {
                        style: (0, _extendsDefault.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
exports.default = SelectInput;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/formatMuiErrorMessage":"dmYrs","react":"BK2ob","react-is":"4ic4g","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/utils/useId":"8BX8X","@mui/utils/refType":"l5hTY","../utils/ownerDocument":"27FrI","../utils/capitalize":"iHgWG","../Menu/Menu":"37kMj","../NativeSelect/NativeSelectInput":"iuFKk","../InputBase/utils":"3mLMB","../styles/styled":"axRcE","../utils/useForkRef":"5kA2S","../utils/useControlled":"bNYR8","./selectClasses":"9Hxj9","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4ic4g":[function(require,module,exports) {
"use strict";
module.exports = require("3df2dc44199c67a0");

},{"3df2dc44199c67a0":"cazs0"}],"cazs0":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"27FrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ownerDocument = require("@mui/utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
exports.default = (0, _ownerDocumentDefault.default);

},{"@mui/utils/ownerDocument":"cuXLy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"37kMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPaper", ()=>MenuPaper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _utils = require("@mui/base/utils");
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _rtlProvider = require("@mui/system/RtlProvider");
var _menuList = require("../MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _popover = require("../Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _menuClasses = require("./menuClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onEntering"
], _excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _menuClasses.getMenuUtilityClass), classes);
};
const MenuRoot = (0, _styledDefault.default)((0, _popoverDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const MenuPaper = (0, _styledDefault.default)((0, _popover.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const MenuMenuList = (0, _styledDefault.default)((0, _menuListDefault.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Menu = /*#__PURE__*/ _react.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus = true, children, className, disableAutoFocusItem = false, MenuListProps = {}, onClose, open, PaperProps = {}, PopoverClasses, transitionDuration = "auto", TransitionProps: { onEntering } = {}, variant = "selectedMenu", slots = {}, slotProps = {} } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const isRtl = (0, _rtlProvider.useRtl)();
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        disableAutoFocusItem,
        MenuListProps,
        onEntering,
        PaperProps,
        transitionDuration,
        TransitionProps,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = _react.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    _react.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : MenuPaper;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, _utils.useSlotProps)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, _utils.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuRoot, (0, _extendsDefault.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, _extendsDefault.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuMenuList, (0, _extendsDefault.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, _clsxDefault.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
exports.default = Menu;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","react-is":"4ic4g","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/base/utils":"iiPtN","@mui/utils/HTMLElementType":"lxflV","@mui/system/RtlProvider":"jz0y0","../MenuList":"hnEqU","../Popover":"cR98g","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./menuClasses":"fmVYx","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hnEqU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuListDefault.default));
var _menuList = require("./MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
"use client";

},{"./MenuList":"85B1W","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"85B1W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _list = require("../List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _getScrollbarSize = require("../utils/getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const MenuList = /*#__PURE__*/ _react.forwardRef(function MenuList(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus = false, autoFocusItem = false, children, className, disabledItemsFocusable = false, disableListWrap = false, onKeyDown, variant = "selectedMenu" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const listRef = _react.useRef(null);
    const textCriteriaRef = _react.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    _react.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, _getScrollbarSizeDefault.default)((0, _ownerDocumentDefault.default)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, _ownerDocumentDefault.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === "End") {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, _useForkRefDefault.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    _react.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = _react.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ _react.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), (0, _extendsDefault.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
exports.default = MenuList;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","react-is":"4ic4g","prop-types":"hRUel","../utils/ownerDocument":"27FrI","../List":"2UkGG","../utils/getScrollbarSize":"9brsI","../utils/useForkRef":"5kA2S","../utils/useEnhancedEffect":"imwu2","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2UkGG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "listClasses", ()=>(0, _listClassesDefault.default));
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listClasses = require("./listClasses");
var _listClassesDefault = parcelHelpers.interopDefault(_listClasses);
parcelHelpers.exportAll(_listClasses, exports);
"use client";

},{"./List":"4kR12","./listClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4kR12":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listClasses = require("./listClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePadding, dense, subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listClasses.getListUtilityClass), classes);
};
const ListRoot = (0, _styledDefault.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const List = /*#__PURE__*/ _react.forwardRef(function List(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children, className, component = "ul", dense = false, disablePadding = false, subheader } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useMemo(()=>({
            dense
        }), [
        dense
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        dense,
        disablePadding
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListRoot, (0, _extendsDefault.default)({
            as: component,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
exports.default = List;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./ListContext":"74mKH","./listClasses":"2dzkG","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"74mKH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 */ const ListContext = /*#__PURE__*/ _react.createContext({});
exports.default = ListContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2dzkG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListUtilityClass", ()=>getListUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiList", slot);
}
const listClasses = (0, _generateUtilityClassesDefault.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
exports.default = listClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9brsI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getScrollbarSize = require("@mui/utils/getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
exports.default = (0, _getScrollbarSizeDefault.default);

},{"@mui/utils/getScrollbarSize":"1GLWx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cR98g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "popoverClasses", ()=>(0, _popoverClassesDefault.default));
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
parcelHelpers.exportAll(_popover, exports);
var _popoverClasses = require("./popoverClasses");
var _popoverClassesDefault = parcelHelpers.interopDefault(_popoverClasses);
parcelHelpers.exportAll(_popoverClasses, exports);
"use client";

},{"./Popover":"cL4Ut","./popoverClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cL4Ut":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffsetTop", ()=>getOffsetTop);
parcelHelpers.export(exports, "getOffsetLeft", ()=>getOffsetLeft);
parcelHelpers.export(exports, "PopoverRoot", ()=>PopoverRoot);
parcelHelpers.export(exports, "PopoverPaper", ()=>PopoverPaper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("../utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popoverClasses = require("./popoverClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onEntering"
], _excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], _excluded3 = [
    "slotProps"
];
function getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _popoverClasses.getPopoverUtilityClass), classes);
};
const PopoverRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const PopoverPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Popover = /*#__PURE__*/ _react.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action, anchorEl, anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition, anchorReference = "anchorEl", children, className, container: containerProp, elevation = 8, marginThreshold = 16, open, PaperProps: PaperPropsProp = {}, slots, slotProps, transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent = (0, _growDefault.default), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering } = {}, disableScrollLock = false } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = _react.useRef();
    const handlePaperRef = (0, _useForkRefDefault.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        anchorOrigin,
        anchorReference,
        elevation,
        marginThreshold,
        externalPaperSlotProps,
        transformOrigin,
        TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps
    });
    const classes = useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = _react.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocumentDefault.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = _react.useCallback((elemRect)=>{
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = _react.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, _ownerWindowDefault.default)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = _react.useState(open);
    const setPositioningStyles = _react.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    _react.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    _react.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    _react.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    _react.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, _debounceDefault.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, _ownerWindowDefault.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, _ownerDocumentDefault.default)(resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
    const paperProps = (0, _utils.useSlotProps)({
        elementType: PaperSlot,
        externalSlotProps: (0, _extendsDefault.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, _extendsDefault.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation,
            ref: handlePaperRef
        },
        ownerState,
        className: (0, _clsxDefault.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, _utils.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container,
            open
        },
        ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded3);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, (0, _extendsDefault.default)({}, rootProps, !(0, _utils.isHostComponent)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, (0, _extendsDefault.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
exports.default = Popover;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","@mui/utils/HTMLElementType":"lxflV","@mui/utils/refType":"l5hTY","@mui/utils/elementTypeAcceptingRef":"cSxw6","@mui/utils/integerPropType":"3uD7f","@mui/utils/chainPropTypes":"8qu3z","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/debounce":"bEAi9","../utils/ownerDocument":"27FrI","../utils/ownerWindow":"iuYVd","../utils/useForkRef":"5kA2S","../Grow":"3JaRg","../Modal":"9y8oQ","../Paper":"9w8HO","./popoverClasses":"9EoXY","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bEAi9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounce = require("@mui/utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
exports.default = (0, _debounceDefault.default);

},{"@mui/utils/debounce":"hrGSO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iuYVd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ownerWindow = require("@mui/utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
exports.default = (0, _ownerWindowDefault.default);

},{"@mui/utils/ownerWindow":"g0RQa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3JaRg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _growDefault.default));
var _grow = require("./Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
"use client";

},{"./Grow":"lgn5U","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lgn5U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _reactTransitionGroup = require("react-transition-group");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils = require("../transitions/utils");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const styles = {
    entering: {
        opacity: 1,
        transform: getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Grow = /*#__PURE__*/ _react.forwardRef(function Grow(props, ref) {
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = "auto", // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const timer = (0, _useTimeoutDefault.default)();
    const autoTimeout = _react.useRef();
    const theme = (0, _useThemeDefault.default)();
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration,
                delay
            }),
            theme.transitions.create("transform", {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration,
                delay
            }),
            theme.transitions.create("transform", {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                style: (0, _extendsDefault.default)({
                    opacity: 0,
                    transform: getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
Grow.muiSupportAuto = true;
exports.default = Grow;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","@mui/utils/useTimeout":"2Xz3c","@mui/utils/elementAcceptingRef":"dHnQP","react-transition-group":"j8hjZ","../styles/useTheme":"3N7Mw","../transitions/utils":"jjBwh","../utils/useForkRef":"5kA2S","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j8hjZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"9Cmqt","./ReplaceTransition":"420zI","./SwitchTransition":"cM5Dt","./TransitionGroup":"ghsuK","./Transition":"dPAQj","./config":"5w5D7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9Cmqt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ""
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/inheritsLoose":"00xhi","prop-types":"hRUel","dom-helpers/addClass":"2QkJ4","dom-helpers/removeClass":"8T1CU","react":"BK2ob","./Transition":"dPAQj","./utils/PropTypes":"80Tdo","./utils/reflow":"6k2FI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"00xhi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"kGlMU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kGlMU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2QkJ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

},{"./hasClass":"jx6x6","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jx6x6":[function(require,module,exports) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8T1CU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = replaceClassName(element.className, className);
    else element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dPAQj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/inheritsLoose":"00xhi","prop-types":"hRUel","react":"BK2ob","react-dom":"izP7d","./config":"5w5D7","./utils/PropTypes":"80Tdo","./TransitionGroupContext":"544EZ","./utils/reflow":"6k2FI","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5w5D7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"80Tdo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"hRUel","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"544EZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6k2FI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"420zI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = (0, _reactDefault.default).Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) {
            var maybeNode = child.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this);
            this.props[handler](maybeNode);
        }
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = (0, _reactDefault.default).Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupDefault.default), props, inProp ? (0, _reactDefault.default).cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : (0, _reactDefault.default).cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}((0, _reactDefault.default).Component);
ReplaceTransition.propTypes = {};
exports.default = ReplaceTransition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/inheritsLoose":"00xhi","prop-types":"hRUel","react":"BK2ob","react-dom":"izP7d","./TransitionGroup":"ghsuK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ghsuK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/assertThisInitialized":"g5pAl","@babel/runtime/helpers/esm/inheritsLoose":"00xhi","prop-types":"hRUel","react":"BK2ob","./TransitionGroupContext":"544EZ","./utils/ChildMapping":"04KBK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g5pAl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"04KBK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, "appear", props),
            enter: getProp(child, "enter", props),
            exit: getProp(child, "exit", props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, "exit", nextProps),
            enter: getProp(child, "enter", nextProps)
        });
    });
    return children;
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cM5Dt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modes", ()=>modes);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _transition = require("./Transition");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
    if (oldChildren === newChildren) return false;
    if ((0, _reactDefault.default).isValidElement(oldChildren) && (0, _reactDefault.default).isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) return false;
    return true;
}
var modes = {
    out: "out-in",
    in: "in-out"
};
var callHook = function callHook(element, name, cb) {
    return function() {
        var _element$props;
        element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
        cb();
    };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(_ref) {
    var current = _ref.current, changeState = _ref.changeState;
    return (0, _reactDefault.default).cloneElement(current, {
        in: false,
        onExited: callHook(current, "onExited", function() {
            changeState((0, _transition.ENTERING), null);
        })
    });
}, _leaveRenders[modes.in] = function(_ref2) {
    var current = _ref2.current, changeState = _ref2.changeState, children = _ref2.children;
    return [
        current,
        (0, _reactDefault.default).cloneElement(children, {
            in: true,
            onEntered: callHook(children, "onEntered", function() {
                changeState((0, _transition.ENTERING));
            })
        })
    ];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(_ref3) {
    var children = _ref3.children, changeState = _ref3.changeState;
    return (0, _reactDefault.default).cloneElement(children, {
        in: true,
        onEntered: callHook(children, "onEntered", function() {
            changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                in: true
            }));
        })
    });
}, _enterRenders[modes.in] = function(_ref4) {
    var current = _ref4.current, children = _ref4.children, changeState = _ref4.changeState;
    return [
        (0, _reactDefault.default).cloneElement(current, {
            in: false,
            onExited: callHook(current, "onExited", function() {
                changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                    in: true
                }));
            })
        }),
        (0, _reactDefault.default).cloneElement(children, {
            in: true
        })
    ];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */ var SwitchTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(SwitchTransition, _React$Component);
    function SwitchTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            status: (0, _transition.ENTERED),
            current: null
        };
        _this.appeared = false;
        _this.changeState = function(status, current) {
            if (current === void 0) current = _this.state.current;
            _this.setState({
                status: status,
                current: current
            });
        };
        return _this;
    }
    var _proto = SwitchTransition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
    };
    SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.children == null) return {
            current: null
        };
        if (state.status === (0, _transition.ENTERING) && props.mode === modes.in) return {
            status: (0, _transition.ENTERING)
        };
        if (state.current && areChildrenDifferent(state.current, props.children)) return {
            status: (0, _transition.EXITING)
        };
        return {
            current: (0, _reactDefault.default).cloneElement(props.children, {
                in: true
            })
        };
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, mode = _this$props.mode, _this$state = this.state, status = _this$state.status, current = _this$state.current;
        var data = {
            children: children,
            current: current,
            changeState: this.changeState,
            status: status
        };
        var component;
        switch(status){
            case 0, _transition.ENTERING:
                component = enterRenders[mode](data);
                break;
            case 0, _transition.EXITING:
                component = leaveRenders[mode](data);
                break;
            case 0, _transition.ENTERED:
                component = current;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: {
                isMounting: !this.appeared
            }
        }, component);
    };
    return SwitchTransition;
}((0, _reactDefault.default).Component);
SwitchTransition.propTypes = {};
SwitchTransition.defaultProps = {
    mode: modes.out
};
exports.default = SwitchTransition;

},{"@babel/runtime/helpers/esm/inheritsLoose":"00xhi","react":"BK2ob","prop-types":"hRUel","./Transition":"dPAQj","./TransitionGroupContext":"544EZ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jjBwh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reflow", ()=>reflow);
parcelHelpers.export(exports, "getTransitionProps", ()=>getTransitionProps);
const reflow = (node)=>node.scrollTop;
function getTransitionProps(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout, easing, style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9y8oQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalManager", ()=>(0, _unstableUseModal.ModalManager));
parcelHelpers.export(exports, "default", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "modalClasses", ()=>(0, _modalClassesDefault.default));
var _unstableUseModal = require("@mui/base/unstable_useModal");
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalClasses = require("./modalClasses");
var _modalClassesDefault = parcelHelpers.interopDefault(_modalClasses);
parcelHelpers.exportAll(_modalClasses, exports);
"use client";

},{"@mui/base/unstable_useModal":false,"./Modal":"apPov","./modalClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"apPov":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _utils = require("@mui/base/utils");
var _unstableUseModal = require("@mui/base/unstable_useModal");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _unstableTrapFocus = require("../Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);
var _portal = require("../Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _backdrop = require("../Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _modalClasses = require("./modalClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const useUtilityClasses = (ownerState)=>{
    const { open, exited, classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _modalClasses.getModalUtilityClass), classes);
};
const ModalRoot = (0, _styledDefault.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const ModalBackdrop = (0, _styledDefault.default)((0, _backdropDefault.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const Modal = /*#__PURE__*/ _react.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, _useThemePropsDefault.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent = ModalBackdrop, BackdropProps, className, closeAfterTransition = false, children, container, component, components = {}, componentsProps = {}, disableAutoFocus = false, disableEnforceFocus = false, disableEscapeKeyDown = false, disablePortal = false, disableRestoreFocus = false, disableScrollLock = false, hideBackdrop = false, keepMounted = false, onBackdropClick, open, slotProps, slots } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const propsWithDefaults = (0, _extendsDefault.default)({}, props, {
        closeAfterTransition,
        disableAutoFocus,
        disableEnforceFocus,
        disableEscapeKeyDown,
        disablePortal,
        disableRestoreFocus,
        disableScrollLock,
        hideBackdrop,
        keepMounted
    });
    const { getRootProps, getBackdropProps, getTransitionProps, portalRef, isTopModal, exited, hasTransition } = (0, _unstableUseModal.unstable_useModal)((0, _extendsDefault.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, _extendsDefault.default)({}, propsWithDefaults, {
        exited
    });
    const classes = useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter, onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, _utils.useSlotProps)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref,
            as: component
        },
        ownerState,
        className: (0, _clsxDefault.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, _utils.useSlotProps)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, _extendsDefault.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, _clsxDefault.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, (0, _extendsDefault.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropSlot, (0, _extendsDefault.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableTrapFocusDefault.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ _react.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
exports.default = Modal;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/HTMLElementType":"lxflV","@mui/utils/elementAcceptingRef":"dHnQP","@mui/base/utils":"iiPtN","@mui/base/unstable_useModal":"5uzVA","@mui/utils/composeClasses":"jj3MR","../Unstable_TrapFocus":"5hbKr","../Portal":"5nBQE","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../Backdrop":"6tOz3","./modalClasses":"2ehOf","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5hbKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _focusTrap.FocusTrap));
var _focusTrap = require("@mui/base/FocusTrap");

},{"@mui/base/FocusTrap":"5OCfN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5nBQE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _portal.Portal));
var _portal = require("@mui/base/Portal");

},{"@mui/base/Portal":"o96uw","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6tOz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _backdropDefault.default));
parcelHelpers.export(exports, "backdropClasses", ()=>(0, _backdropClassesDefault.default));
var _backdrop = require("./Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _backdropClasses = require("./backdropClasses");
var _backdropClassesDefault = parcelHelpers.interopDefault(_backdropClasses);
parcelHelpers.exportAll(_backdropClasses, exports);
"use client";

},{"./Backdrop":"042NY","./backdropClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"042NY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _fade = require("../Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _backdropClasses = require("./backdropClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _backdropClasses.getBackdropUtilityClass), classes);
};
const BackdropRoot = (0, _styledDefault.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const Backdrop = /*#__PURE__*/ _react.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children, className, component = "div", components = {}, componentsProps = {}, invisible = false, open, slotProps = {}, slots = {}, TransitionComponent = (0, _fadeDefault.default), transitionDuration } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        invisible
    });
    const classes = useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropRoot, (0, _extendsDefault.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, _clsxDefault.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, _extendsDefault.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
exports.default = Backdrop;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../Fade":"iV0ht","./backdropClasses":"eUHvc","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iV0ht":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fadeDefault.default));
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
"use client";

},{"./Fade":"imd2l","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"imd2l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils = require("../transitions/utils");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Fade = /*#__PURE__*/ _react.forwardRef(function Fade(props, ref) {
    const theme = (0, _useThemeDefault.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const enableStrictModeCompat = true;
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                style: (0, _extendsDefault.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
exports.default = Fade;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","react-transition-group":"j8hjZ","@mui/utils/elementAcceptingRef":"dHnQP","../styles/useTheme":"3N7Mw","../transitions/utils":"jjBwh","../utils/useForkRef":"5kA2S","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eUHvc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBackdropUtilityClass", ()=>getBackdropUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getBackdropUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiBackdrop", slot);
}
const backdropClasses = (0, _generateUtilityClassesDefault.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
exports.default = backdropClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2ehOf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModalUtilityClass", ()=>getModalUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getModalUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiModal", slot);
}
const modalClasses = (0, _generateUtilityClassesDefault.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
exports.default = modalClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9w8HO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paperDefault.default));
parcelHelpers.export(exports, "paperClasses", ()=>(0, _paperClassesDefault.default));
var _paper = require("./Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _paperClasses = require("./paperClasses");
var _paperClassesDefault = parcelHelpers.interopDefault(_paperClasses);
parcelHelpers.exportAll(_paperClasses, exports);
"use client";

},{"./Paper":"f7Xpr","./paperClasses":"1Vhc6","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f7Xpr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _getOverlayAlpha = require("../styles/getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _paperClasses = require("./paperClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { square, elevation, variant, classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paperClasses.getPaperUtilityClass), classes);
};
const PaperRoot = (0, _styledDefault.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$vars$overlays;
    return (0, _extendsDefault.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, _extendsDefault.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, _colorManipulator.alpha)("#fff", (0, _getOverlayAlphaDefault.default)(ownerState.elevation))}, ${(0, _colorManipulator.alpha)("#fff", (0, _getOverlayAlphaDefault.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const Paper = /*#__PURE__*/ _react.forwardRef(function Paper(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className, component = "div", elevation = 1, square = false, variant = "elevation" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        elevation,
        square,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other));
});
exports.default = Paper;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/integerPropType":"3uD7f","@mui/utils/chainPropTypes":"8qu3z","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/getOverlayAlpha":"4u1Fj","../styles/useThemeProps":"e7SGa","../styles/useTheme":"3N7Mw","./paperClasses":"1Vhc6","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1Vhc6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaperUtilityClass", ()=>getPaperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPaper", slot);
}
const paperClasses = (0, _generateUtilityClassesDefault.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
exports.default = paperClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9EoXY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopoverUtilityClass", ()=>getPopoverUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPopoverUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPopover", slot);
}
const popoverClasses = (0, _generateUtilityClassesDefault.default)("MuiPopover", [
    "root",
    "paper"
]);
exports.default = popoverClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fmVYx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuUtilityClass", ()=>getMenuUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMenuUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiMenu", slot);
}
const menuClasses = (0, _generateUtilityClassesDefault.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
exports.default = menuClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iuFKk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nativeSelectSelectStyles", ()=>nativeSelectSelectStyles);
parcelHelpers.export(exports, "nativeSelectIconStyles", ()=>nativeSelectIconStyles);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _nativeSelectClasses = require("./nativeSelectClasses");
var _nativeSelectClassesDefault = parcelHelpers.interopDefault(_nativeSelectClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, _capitalizeDefault.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _nativeSelectClasses.getNativeSelectUtilityClasses), classes);
};
const nativeSelectSelectStyles = ({ ownerState, theme })=>(0, _extendsDefault.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, _extendsDefault.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, _nativeSelectClassesDefault.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const NativeSelectSelect = (0, _styledDefault.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, _styled.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, _nativeSelectClassesDefault.default).multiple}`]: styles.multiple
            }
        ];
    }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({ ownerState, theme })=>(0, _extendsDefault.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, _nativeSelectClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const NativeSelectIcon = (0, _styledDefault.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})(nativeSelectIconStyles);
/**
 * @ignore - internal component.
 */ const NativeSelectInput = /*#__PURE__*/ _react.forwardRef(function NativeSelectInput(props, ref) {
    const { className, disabled, error, IconComponent, inputRef, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        variant,
        error
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectSelect, (0, _extendsDefault.default)({
                ownerState: ownerState,
                className: (0, _clsxDefault.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
exports.default = NativeSelectInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/refType":"l5hTY","@mui/utils/composeClasses":"jj3MR","../utils/capitalize":"iHgWG","./nativeSelectClasses":"77g3w","../styles/styled":"axRcE","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"77g3w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNativeSelectUtilityClasses", ()=>getNativeSelectUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getNativeSelectUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiNativeSelect", slot);
}
const nativeSelectClasses = (0, _generateUtilityClassesDefault.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
exports.default = nativeSelectClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bNYR8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
"use client";
exports.default = (0, _useControlledDefault.default);

},{"@mui/utils/useControlled":"9keef","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9Hxj9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectUtilityClasses", ()=>getSelectUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSelectUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSelect", slot);
}
const selectClasses = (0, _generateUtilityClassesDefault.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
exports.default = selectClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eDL1b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gZ3fr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSvgIcon);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _svgIcon = require("../SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
/**
 * Private module reserved for @mui packages.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgIconDefault.default), (0, _extendsDefault.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, _svgIconDefault.default).muiName;
    return /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(Component));
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","../SvgIcon":"eu9eC","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iHJPa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTextFieldUtilityClass", ()=>getTextFieldUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTextField", slot);
}
const textFieldClasses = (0, _generateUtilityClassesDefault.default)("MuiTextField", [
    "root"
]);
exports.default = textFieldClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"crO57":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputAdornmentDefault.default));
parcelHelpers.export(exports, "inputAdornmentClasses", ()=>(0, _inputAdornmentClassesDefault.default));
var _inputAdornment = require("./InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputAdornmentClasses = require("./inputAdornmentClasses");
var _inputAdornmentClassesDefault = parcelHelpers.interopDefault(_inputAdornmentClasses);
parcelHelpers.exportAll(_inputAdornmentClasses, exports);
"use client";

},{"./InputAdornment":"dSVhH","./inputAdornmentClasses":"jnjr3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dSVhH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _inputAdornmentClasses = require("./inputAdornmentClasses");
var _inputAdornmentClassesDefault = parcelHelpers.interopDefault(_inputAdornmentClasses);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var _span;
const _excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePointerEvents, hiddenLabel, position, size, variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, _capitalizeDefault.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _inputAdornmentClasses.getInputAdornmentUtilityClass), classes);
};
const InputAdornmentRoot = (0, _styledDefault.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, _inputAdornmentClassesDefault.default).positionStart}&:not(.${(0, _inputAdornmentClassesDefault.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const InputAdornment = /*#__PURE__*/ _react.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children, className, component = "div", disablePointerEvents = false, disableTypography = false, position, variant: variantProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents,
        position,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputAdornmentRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
exports.default = InputAdornment;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../utils/capitalize":"iHgWG","../Typography":"f5srd","../FormControl/FormControlContext":"872Eo","../FormControl/useFormControl":"3uzwm","../styles/styled":"axRcE","./inputAdornmentClasses":"jnjr3","../styles/useThemeProps":"e7SGa","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jnjr3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputAdornmentUtilityClass", ()=>getInputAdornmentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputAdornmentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiInputAdornment", slot);
}
const inputAdornmentClasses = (0, _generateUtilityClassesDefault.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
exports.default = inputAdornmentClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h2G5p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "buttonClasses", ()=>(0, _buttonClassesDefault.default));
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonClasses = require("./buttonClasses");
var _buttonClassesDefault = parcelHelpers.interopDefault(_buttonClasses);
parcelHelpers.exportAll(_buttonClasses, exports);
"use client";

},{"./Button":"hcCSz","./buttonClasses":"3bLuw","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hcCSz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _buttonClasses = require("./buttonClasses");
var _buttonClassesDefault = parcelHelpers.interopDefault(_buttonClasses);
var _buttonGroupContext = require("../ButtonGroup/ButtonGroupContext");
var _buttonGroupContextDefault = parcelHelpers.interopDefault(_buttonGroupContext);
var _buttonGroupButtonContext = require("../ButtonGroup/ButtonGroupButtonContext");
var _buttonGroupButtonContextDefault = parcelHelpers.interopDefault(_buttonGroupButtonContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { color, disableElevation, fullWidth, size, variant, classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, _capitalizeDefault.default)(color)}`,
            `size${(0, _capitalizeDefault.default)(size)}`,
            `${variant}Size${(0, _capitalizeDefault.default)(size)}`,
            `color${(0, _capitalizeDefault.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, _capitalizeDefault.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _buttonClasses.getButtonUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const commonIconStyles = (ownerState)=>(0, _extendsDefault.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const ButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, _extendsDefault.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, _extendsDefault.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, _extendsDefault.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, _buttonClassesDefault.default).focusVisible}`]: (0, _extendsDefault.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, _buttonClassesDefault.default).disabled}`]: (0, _extendsDefault.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, _buttonClassesDefault.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, _buttonClassesDefault.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const ButtonStartIcon = (0, _styledDefault.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, commonIconStyles(ownerState)));
const ButtonEndIcon = (0, _styledDefault.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, commonIconStyles(ownerState)));
const Button = /*#__PURE__*/ _react.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = _react.useContext((0, _buttonGroupContextDefault.default));
    const buttonGroupButtonContextPositionClassName = _react.useContext((0, _buttonGroupButtonContextDefault.default));
    const resolvedProps = (0, _resolvePropsDefault.default)(contextProps, inProps);
    const props = (0, _useThemePropsDefault.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children, color = "primary", component = "button", className, disabled = false, disableElevation = false, disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName, fullWidth = false, size = "medium", startIcon: startIconProp, type, variant = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        disableElevation,
        disableFocusRipple,
        fullWidth,
        size,
        type,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonRoot, (0, _extendsDefault.default)({
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
exports.default = Button;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/resolveProps":"iAGSM","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../ButtonBase":"1prwn","../utils/capitalize":"iHgWG","./buttonClasses":"3bLuw","../ButtonGroup/ButtonGroupContext":"9RpUP","../ButtonGroup/ButtonGroupButtonContext":"8uxK2","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1prwn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonBaseDefault.default));
parcelHelpers.export(exports, "buttonBaseClasses", ()=>(0, _buttonBaseClassesDefault.default));
parcelHelpers.export(exports, "touchRippleClasses", ()=>(0, _touchRippleClassesDefault.default));
var _buttonBase = require("./ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _buttonBaseClasses = require("./buttonBaseClasses");
var _buttonBaseClassesDefault = parcelHelpers.interopDefault(_buttonBaseClasses);
parcelHelpers.exportAll(_buttonBaseClasses, exports);
var _touchRippleClasses = require("./touchRippleClasses");
var _touchRippleClassesDefault = parcelHelpers.interopDefault(_touchRippleClasses);
parcelHelpers.exportAll(_touchRippleClasses, exports);
"use client";

},{"./ButtonBase":"wvgcA","./buttonBaseClasses":"Rw9Xp","./touchRippleClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"wvgcA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonBaseRoot", ()=>ButtonBaseRoot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _touchRipple = require("./TouchRipple");
var _touchRippleDefault = parcelHelpers.interopDefault(_touchRipple);
var _buttonBaseClasses = require("./buttonBaseClasses");
var _buttonBaseClassesDefault = parcelHelpers.interopDefault(_buttonBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { disabled, focusVisible, focusVisibleClassName, classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _buttonBaseClasses.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const ButtonBaseRoot = (0, _styledDefault.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, _buttonBaseClassesDefault.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const ButtonBase = /*#__PURE__*/ _react.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action, centerRipple = false, children, className, component = "button", disabled = false, disableRipple = false, disableTouchRipple = false, focusRipple = false, LinkComponent = "a", onBlur, onClick, onContextMenu, onDragLeave, onFocus, onFocusVisible, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, tabIndex = 0, TouchRippleProps, touchRippleRef, type } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const buttonRef = _react.useRef(null);
    const rippleRef = _react.useRef(null);
    const handleRippleRef = (0, _useForkRefDefault.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    const [focusVisible, setFocusVisible] = _react.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    _react.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = _react.useState(false);
    _react.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    _react.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, _useEventCallbackDefault.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, _useEventCallbackDefault.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = _react.useRef(false);
    const handleKeyDown = (0, _useEventCallbackDefault.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, _useEventCallbackDefault.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, _useForkRefDefault.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        centerRipple,
        component,
        disabled,
        disableRipple,
        disableTouchRipple,
        focusRipple,
        tabIndex,
        focusVisible
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonBaseRoot, (0, _extendsDefault.default)({
        as: ComponentProp,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, _jsxRuntime.jsx)((0, _touchRippleDefault.default), (0, _extendsDefault.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
exports.default = ButtonBase;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/refType":"l5hTY","@mui/utils/elementTypeAcceptingRef":"cSxw6","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/useForkRef":"5kA2S","../utils/useEventCallback":"2AJRL","../utils/useIsFocusVisible":"c4NVG","./TouchRipple":"nR0So","./buttonBaseClasses":"Rw9Xp","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2AJRL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
"use client";
exports.default = (0, _useEventCallbackDefault.default);

},{"@mui/utils/useEventCallback":"gO2kA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"nR0So":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DELAY_RIPPLE", ()=>DELAY_RIPPLE);
parcelHelpers.export(exports, "TouchRippleRoot", ()=>TouchRippleRoot);
parcelHelpers.export(exports, "TouchRippleRipple", ()=>TouchRippleRipple);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _ripple = require("./Ripple");
var _rippleDefault = parcelHelpers.interopDefault(_ripple);
var _touchRippleClasses = require("./touchRippleClasses");
var _touchRippleClassesDefault = parcelHelpers.interopDefault(_touchRippleClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "center",
    "classes",
    "className"
];
let _ = (t)=>t, _t, _t2, _t3, _t4;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = (0, _system.keyframes)(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = (0, _styledDefault.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const TouchRippleRipple = (0, _styledDefault.default)((0, _rippleDefault.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, _touchRippleClassesDefault.default).rippleVisible, enterKeyframe, DURATION, ({ theme })=>theme.transitions.easing.easeInOut, (0, _touchRippleClassesDefault.default).ripplePulsate, ({ theme })=>theme.transitions.duration.shorter, (0, _touchRippleClassesDefault.default).child, (0, _touchRippleClassesDefault.default).childLeaving, exitKeyframe, DURATION, ({ theme })=>theme.transitions.easing.easeInOut, (0, _touchRippleClassesDefault.default).childPulsate, pulsateKeyframe, ({ theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const TouchRipple = /*#__PURE__*/ _react.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes = {}, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [ripples, setRipples] = _react.useState([]);
    const nextKey = _react.useRef(0);
    const rippleCallback = _react.useRef(null);
    _react.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = _react.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, _useTimeoutDefault.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = _react.useRef(null);
    const container = _react.useRef(null);
    const startCommit = _react.useCallback((params)=>{
        const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRipple, {
                    classes: {
                        ripple: (0, _clsxDefault.default)(classes.ripple, (0, _touchRippleClassesDefault.default).ripple),
                        rippleVisible: (0, _clsxDefault.default)(classes.rippleVisible, (0, _touchRippleClassesDefault.default).rippleVisible),
                        ripplePulsate: (0, _clsxDefault.default)(classes.ripplePulsate, (0, _touchRippleClassesDefault.default).ripplePulsate),
                        child: (0, _clsxDefault.default)(classes.child, (0, _touchRippleClassesDefault.default).child),
                        childLeaving: (0, _clsxDefault.default)(classes.childLeaving, (0, _touchRippleClassesDefault.default).childLeaving),
                        childPulsate: (0, _clsxDefault.default)(classes.childPulsate, (0, _touchRippleClassesDefault.default).childPulsate)
                    },
                    timeout: DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = _react.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX, clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate,
                        rippleX,
                        rippleY,
                        rippleSize,
                        cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start(DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = _react.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = _react.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    _react.useImperativeHandle(ref, ()=>({
            pulsate,
            start,
            stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)((0, _touchRippleClassesDefault.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
exports.default = TouchRipple;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","react-transition-group":"j8hjZ","clsx":"bGtJT","@mui/system":"6hP1D","@mui/utils/useTimeout":"2Xz3c","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./Ripple":"jyo48","./touchRippleClasses":"i8LBk","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jyo48":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
function Ripple(props) {
    const { className, classes, pulsate = false, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout } = props;
    const [leaving, setLeaving] = _react.useState(false);
    const rippleClassName = (0, _clsxDefault.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, _clsxDefault.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    _react.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: childClassName
        })
    });
}
exports.default = Ripple;

},{"react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i8LBk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchRippleUtilityClass", ()=>getTouchRippleUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTouchRippleUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTouchRipple", slot);
}
const touchRippleClasses = (0, _generateUtilityClassesDefault.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
exports.default = touchRippleClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"Rw9Xp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonBaseUtilityClass", ()=>getButtonBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getButtonBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiButtonBase", slot);
}
const buttonBaseClasses = (0, _generateUtilityClassesDefault.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
exports.default = buttonBaseClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3bLuw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonUtilityClass", ()=>getButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiButton", slot);
}
const buttonClasses = (0, _generateUtilityClassesDefault.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
exports.default = buttonClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9RpUP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ButtonGroupContext = /*#__PURE__*/ _react.createContext({});
exports.default = ButtonGroupContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8uxK2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ButtonGroupButtonContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = ButtonGroupButtonContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3TS3l":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("fba53bc247860689");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("896a02316301fc50"));
var _jsxRuntime = require("b874acb5710c0313");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");

},{"fba53bc247860689":"hykHy","896a02316301fc50":"gQLSP","b874acb5710c0313":"g88cO"}],"gQLSP":[function(require,module,exports) {
"use strict";
"use client";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _utils.createSvgIcon;
    }
});
var _utils = require("21f2d1dcc9f0020d");

},{"21f2d1dcc9f0020d":"bu04F"}],"bu04F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "createSvgIcon", ()=>(0, _createSvgIconDefault.default));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>unstable_ClassNameGenerator);
var _classNameGenerator = require("@mui/base/ClassNameGenerator");
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _createSvgIcon = require("./createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
"use client";
const unstable_ClassNameGenerator = {
    configure: (generator)=>{
        (0, _classNameGenerator.unstable_ClassNameGenerator).configure(generator);
    }
};

},{"@mui/base/ClassNameGenerator":"u7bKa","./capitalize":"iHgWG","./createChainedFunction":"jieQW","./createSvgIcon":"gZ3fr","./debounce":"bEAi9","./deprecatedPropType":"lfgLP","./isMuiElement":"b7VqP","./ownerDocument":"27FrI","./ownerWindow":"iuYVd","./requirePropFactory":"7Jph4","./setRef":"jVkpT","./useEnhancedEffect":"imwu2","./useId":"gJPxn","./unsupportedProp":"ieG2y","./useControlled":"bNYR8","./useEventCallback":"2AJRL","./useForkRef":"5kA2S","./useIsFocusVisible":"c4NVG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"u7bKa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _utils.unstable_ClassNameGenerator));
var _utils = require("@mui/utils");

},{"@mui/utils":"97HmB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jieQW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createChainedFunction = require("@mui/utils/createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
exports.default = (0, _createChainedFunctionDefault.default);

},{"@mui/utils/createChainedFunction":"dlnaY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lfgLP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deprecatedPropType = require("@mui/utils/deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
exports.default = (0, _deprecatedPropTypeDefault.default);

},{"@mui/utils/deprecatedPropType":"igdME","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7Jph4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requirePropFactory = require("@mui/utils/requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
exports.default = (0, _requirePropFactoryDefault.default);

},{"@mui/utils/requirePropFactory":"eRkfG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jVkpT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setRef = require("@mui/utils/setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
exports.default = (0, _setRefDefault.default);

},{"@mui/utils/setRef":"HzF9U","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gJPxn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
"use client";
exports.default = (0, _useIdDefault.default);

},{"@mui/utils/useId":"8BX8X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ieG2y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unsupportedProp = require("@mui/utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
exports.default = (0, _unsupportedPropDefault.default);

},{"@mui/utils/unsupportedProp":"aFFrK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b2kKi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fixedNetwork", ()=>fixedNetwork);
parcelHelpers.export(exports, "fixedLayer", ()=>fixedLayer);
parcelHelpers.export(exports, "scopeFreedom", ()=>scopeFreedom);
parcelHelpers.export(exports, "RouteUtils", ()=>RouteUtils);
parcelHelpers.export(exports, "consensusAddressParamLoader", ()=>consensusAddressParamLoader);
parcelHelpers.export(exports, "runtimeAddressParamLoader", ()=>runtimeAddressParamLoader);
parcelHelpers.export(exports, "blockHeightParamLoader", ()=>blockHeightParamLoader);
parcelHelpers.export(exports, "consensusTransactionParamLoader", ()=>consensusTransactionParamLoader);
parcelHelpers.export(exports, "runtimeTransactionParamLoader", ()=>runtimeTransactionParamLoader);
parcelHelpers.export(exports, "assertEnabledScope", ()=>assertEnabledScope);
parcelHelpers.export(exports, "proposalIdParamLoader", ()=>proposalIdParamLoader);
parcelHelpers.export(exports, "isScopeSelectorNeeded", ()=>isScopeSelectorNeeded);
var _helpers = require("./helpers");
var _errors = require("../../types/errors");
var _api = require("../../oasis-nexus/api");
var _network = require("../../types/network");
var _config = require("../../config");
var _searchUtils = require("../components/Search/search-utils");
var _layers = require("../../types/layers");
const fixedNetwork = undefined;
const fixedLayer = undefined;
const scopeFreedom = fixedNetwork ? fixedLayer ? "none" : "layer" : fixedLayer ? "network" : "network-layer";
class RouteUtils {
    static ENABLED_LAYERS_FOR_NETWORK = {
        [(0, _network.Network).mainnet]: {
            [(0, _api.Layer).emerald]: true,
            [(0, _api.Layer).sapphire]: true,
            [(0, _api.Layer).cipher]: false,
            [(0, _api.Layer).pontusx]: false,
            // Disable WIP Consensus on production an staging
            [(0, _api.Layer).consensus]: !(0, _config.isStableDeploy)
        },
        [(0, _network.Network).testnet]: {
            [(0, _api.Layer).emerald]: true,
            [(0, _api.Layer).sapphire]: true,
            [(0, _api.Layer).cipher]: false,
            [(0, _api.Layer).pontusx]: true,
            [(0, _api.Layer).consensus]: false
        }
    };
    static getDashboardRoute = ({ network, layer })=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}`;
    };
    static getLatestTransactionsRoute = ({ network, layer })=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/tx`;
    };
    static getTopTokensRoute = ({ network, layer })=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/token`;
    };
    static getLatestBlocksRoute = ({ network, layer })=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/block`;
    };
    static getBlockRoute = ({ network, layer }, blockHeight)=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/block/${encodeURIComponent(blockHeight)}`;
    };
    static getTransactionRoute = (scope, txHash)=>{
        return `/${encodeURIComponent(scope.network)}/${encodeURIComponent(scope.layer)}/tx/${encodeURIComponent(txHash)}`;
    };
    static getAccountRoute = ({ network, layer }, account)=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/address/${encodeURIComponent(account)}`;
    };
    static getAccountsRoute = (network)=>{
        return `/${encodeURIComponent(network)}/consensus/address`;
    };
    static getValidatorsRoute = (network)=>{
        return `/${encodeURIComponent(network)}/consensus/validators`;
    };
    static getValidatorRoute = (network, address)=>{
        return `/${encodeURIComponent(network)}/consensus/validators/${encodeURIComponent(address)}`;
    };
    static getAccountTokensRoute = (scope, account, tokenType, tokenAddress)=>{
        const map = {
            ERC20: `${this.getAccountRoute(scope, account)}/tokens/erc-20`,
            ERC721: `${this.getAccountRoute(scope, account)}/tokens/erc-721`
        };
        const tokenRoutes = map[tokenType];
        if (!tokenRoutes) throw new Error("Unexpected token type");
        return tokenAddress ? `${tokenRoutes}#${encodeURIComponent(tokenAddress)}` : tokenRoutes;
    };
    static getSearchRoute = (scope, searchTerm)=>{
        return scope ? `/${encodeURIComponent(scope.network)}/${encodeURIComponent(scope.layer)}/search?q=${encodeURIComponent(searchTerm)}` : `/search?q=${encodeURIComponent(searchTerm)}`;
    };
    static getTokenRoute = ({ network, layer }, tokenAddress)=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/token/${encodeURIComponent(tokenAddress)}`;
    };
    static getTokenHoldersRoute = ({ network, layer }, tokenAddress)=>{
        return `/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/token/${encodeURIComponent(tokenAddress)}/holders`;
    };
    static getNFTInstanceRoute = ({ network, layer }, contractAddress, instanceId)=>`/${encodeURIComponent(network)}/${encodeURIComponent(layer)}/token/${encodeURIComponent(contractAddress)}/instance/${encodeURIComponent(instanceId)}`;
    static getAllLayersForNetwork(network) {
        const enabled = [];
        const disabled = [];
        Object.values((0, _api.Layer)).forEach((layer)=>{
            if ((!fixedLayer || layer === fixedLayer) && RouteUtils.ENABLED_LAYERS_FOR_NETWORK[network][layer]) enabled.push(layer);
            else disabled.push(layer);
        });
        return {
            enabled,
            disabled
        };
    }
    static getVisibleLayersForNetwork(network, currentScope) {
        return this.getAllLayersForNetwork(network).enabled.filter((layer)=>!(0, _layers.isLayerHidden)(layer) || layer === currentScope?.layer);
    }
    static getProposalsRoute = (network)=>{
        return `/${encodeURIComponent(network)}/consensus/proposal`;
    };
    static getProposalRoute = (network, proposalId)=>{
        return `/${encodeURIComponent(network)}/consensus/proposal/${encodeURIComponent(proposalId)}`;
    };
    static getEnabledScopes() {
        return RouteUtils.getEnabledNetworks().flatMap((network)=>RouteUtils.getAllLayersForNetwork(network).enabled.map((layer)=>({
                    network,
                    layer
                })));
    }
    static getVisibleScopes(currentScope) {
        return RouteUtils.getEnabledScopes().filter(({ network, layer })=>!(0, _layers.isLayerHidden)(layer) || layer === currentScope?.layer);
    }
    /**
   * Get the list of enabled networks.
   *
   * If this Explorer is fixed to a specific network, the only that network will be returned.
   * Furthermore, if this Explorer is fixed to a specific layer, only networks that support that layer are returned.
   */ static getEnabledNetworks() {
        const networks = fixedNetwork ? [
            fixedNetwork
        ] : Object.values((0, _network.Network)).filter((network)=>{
            return this.getAllLayersForNetwork(network).enabled.length > 0;
        });
        return fixedLayer ? networks.filter((network)=>{
            return this.getAllLayersForNetwork(network).enabled.includes(fixedLayer);
        }) : networks;
    }
    static getEnabledNetworksForLayer(layer) {
        const networks = this.getEnabledNetworks();
        return layer ? networks.filter((network)=>{
            return this.getAllLayersForNetwork(network).enabled.includes(layer);
        }) : networks;
    }
}
const validateConsensusAddressParam = (address)=>{
    const isValid = (0, _helpers.isValidOasisAddress)(address);
    if (!isValid) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidAddress);
    return isValid;
};
const validateRuntimeAddressParam = (address)=>{
    const isValid = (0, _helpers.isValidOasisAddress)(address) || (0, _helpers.isValidEthAddress)(address);
    if (!isValid) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidAddress);
    return isValid;
};
const validateBlockHeightParam = (blockHeight)=>{
    const isValid = (0, _helpers.isValidBlockHeight)(blockHeight);
    if (!isValid) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidBlockHeight);
    return isValid;
};
const validateConsensusTxHashParam = (hash)=>{
    const isValid = (0, _helpers.isValidTxOasisHash)(hash);
    if (!isValid) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidTxHash);
    return true;
};
const validateRuntimeTxHashParam = (hash)=>{
    const isValid = (0, _helpers.isValidTxHash)(hash);
    if (!isValid) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidTxHash);
    return true;
};
const validateProposalIdParam = (proposalId)=>{
    const isValid = (0, _helpers.isValidProposalId)(proposalId);
    if (!isValid) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidProposalId);
    return isValid;
};
const consensusAddressParamLoader = (queryParam = "address")=>({ params, request })=>{
        validateConsensusAddressParam(params[queryParam]);
        return {
            address: params[queryParam],
            searchTerm: (0, _searchUtils.getSearchTermFromRequest)(request)
        };
    };
const runtimeAddressParamLoader = (queryParam = "address")=>({ params, request })=>{
        validateRuntimeAddressParam(params[queryParam]);
        return {
            address: params[queryParam],
            searchTerm: (0, _searchUtils.getSearchTermFromRequest)(request)
        };
    };
const blockHeightParamLoader = async ({ params })=>{
    return validateBlockHeightParam(params.blockHeight);
};
const consensusTransactionParamLoader = async ({ params })=>{
    return validateConsensusTxHashParam(params.hash);
};
const runtimeTransactionParamLoader = async ({ params })=>{
    return validateRuntimeTxHashParam(params.hash);
};
const assertEnabledScope = ({ network, layer })=>{
    if (!network || !RouteUtils.getEnabledNetworks().includes(network)) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidUrl);
    if (!layer || // missing param
    !RouteUtils.getAllLayersForNetwork(network).enabled.includes(layer) // unsupported on network
    ) throw new (0, _errors.AppError)((0, _errors.AppErrors).UnsupportedLayer);
    return {
        network,
        layer
    };
};
const proposalIdParamLoader = async ({ params, request })=>{
    validateProposalIdParam(params.proposalId);
    return {
        proposalId: parseInt(params.proposalId),
        searchTerm: (0, _searchUtils.getSearchTermFromRequest)(request)
    };
};
const isScopeSelectorNeeded = (sourceScope)=>{
    switch(scopeFreedom){
        case "network":
            return RouteUtils.getEnabledNetworks().length > 1;
        case "layer":
            return RouteUtils.getVisibleLayersForNetwork(fixedNetwork, sourceScope).length > 1;
        case "network-layer":
            return RouteUtils.getEnabledScopes().length > 1;
        case "none":
            return false;
    }
};

},{"./helpers":"2aVNs","../../types/errors":"gdpNU","../../oasis-nexus/api":"dJrPU","../../types/network":"f0o8N","../../config":"2PXMY","../components/Search/search-utils":"bnM2G","../../types/layers":"gWCJy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2aVNs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidBlockHeight", ()=>isValidBlockHeight);
parcelHelpers.export(exports, "isValidBlockHash", ()=>isValidBlockHash);
parcelHelpers.export(exports, "isValidOasisAddress", ()=>isValidOasisAddress);
parcelHelpers.export(exports, "isValidEthAddress", ()=>isValidEthAddress);
parcelHelpers.export(exports, "isValidProposalId", ()=>isValidProposalId);
parcelHelpers.export(exports, "getEvmBech32Address", ()=>getEvmBech32Address);
parcelHelpers.export(exports, "getOasisAddress", ()=>getOasisAddress);
parcelHelpers.export(exports, "getOasisAddressOrNull", ()=>getOasisAddressOrNull);
parcelHelpers.export(exports, "isValidTxOasisHash", ()=>isValidTxOasisHash);
parcelHelpers.export(exports, "isValidTxEthHash", ()=>isValidTxEthHash);
parcelHelpers.export(exports, "isValidTxHash", ()=>isValidTxHash);
parcelHelpers.export(exports, "base64ToHex", ()=>base64ToHex);
// Convert address from base64 to hex, add prefix, and convert to checksum address
parcelHelpers.export(exports, "getEthAccountAddressFromBase64", ()=>getEthAccountAddressFromBase64);
parcelHelpers.export(exports, "getEthAccountAddressFromPreimage", ()=>getEthAccountAddressFromPreimage);
parcelHelpers.export(exports, "getEthAddressForAccount", ()=>getEthAddressForAccount);
parcelHelpers.export(exports, "uniq", ()=>uniq);
parcelHelpers.export(exports, "fromBaseUnits", ()=>fromBaseUnits);
parcelHelpers.export(exports, "isValidMnemonic", ()=>isValidMnemonic);
parcelHelpers.export(exports, "getAccountSize", ()=>getAccountSize);
var _util = require("@ethereumjs/util");
var _buffer = require("buffer");
var _client = require("@oasisprotocol/client");
var _clientRt = require("@oasisprotocol/client-rt");
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var _bip39 = require("bip39");
var _jsSha512 = require("js-sha512");
const isValidBlockHeight = (blockHeight)=>/^[0-9]+$/.test(blockHeight);
const isValidBlockHash = (hash)=>/^[0-9a-fA-F]{64}$/.test(hash);
const isValidOasisAddress = (addr)=>{
    try {
        _client.staking.addressFromBech32(addr);
        return true;
    } catch (e) {
        return false;
    }
};
const isValidEthAddress = (hexAddress)=>{
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
const isValidProposalId = (proposalId)=>/^[0-9]+$/.test(proposalId);
/** oasis.address.fromData(...) but without being needlessly asynchronous */ function oasisAddressFromDataSync(contextIdentifier, contextVersion, data) {
    const versionU8 = new Uint8Array([
        contextVersion
    ]);
    return _client.misc.concat(versionU8, new Uint8Array((0, _jsSha512.sha512_256).arrayBuffer(_client.misc.concat(_client.misc.fromString(contextIdentifier), versionU8, data))).slice(0, 20));
}
function getEvmBech32Address(evmAddress) {
    const ethAddrU8 = _client.misc.fromHex(evmAddress.replace("0x", ""));
    const addr = oasisAddressFromDataSync(_clientRt.address.V0_SECP256K1ETH_CONTEXT_IDENTIFIER, _clientRt.address.V0_SECP256K1ETH_CONTEXT_VERSION, ethAddrU8);
    return _client.staking.addressToBech32(addr);
}
const getOasisAddress = (address)=>{
    if (isValidOasisAddress(address)) return address;
    else if (isValidEthAddress(address)) return getEvmBech32Address(address);
    else throw new Error("Invalid address");
};
const getOasisAddressOrNull = (address)=>{
    try {
        return getOasisAddress(address);
    } catch (e) {
        return null;
    }
};
const isValidTxOasisHash = (hash)=>/^[0-9a-fA-F]{64}$/.test(hash);
const isValidTxEthHash = (hash)=>/^0x[0-9a-fA-F]{64}$/.test(hash);
const isValidTxHash = (hash)=>isValidTxOasisHash(hash) || isValidTxEthHash(hash);
const base64ToHex = (base64Data)=>`0x${(0, _buffer.Buffer).from(base64Data, "base64").toString("hex")}`;
function getEthAccountAddressFromBase64(base64Address) {
    return (0, _util.toChecksumAddress)(base64ToHex(base64Address));
}
function getEthAccountAddressFromPreimage(preimage) {
    if (preimage?.context !== "oasis-runtime-sdk/address: secp256k1eth" || !preimage.address_data) // We can only determine the ETH address if there was a preimage,
    // and the generation context was secp256k1eth
    return undefined;
    // We need to convert from base64 to hex, add the prefix, and convert to checksum address
    return getEthAccountAddressFromBase64(preimage.address_data);
}
function getEthAddressForAccount(account, possibleEthAddress) {
    // In case of an empty account
    if (account.stats.num_txns <= 0 && possibleEthAddress && isValidEthAddress(possibleEthAddress)) return possibleEthAddress;
    return getEthAccountAddressFromPreimage(account.address_preimage);
}
function uniq(input) {
    return input === undefined ? [] : [
        ...new Set(input)
    ];
}
function fromBaseUnits(valueInBaseUnits, decimals) {
    const value = new (0, _bignumberJsDefault.default)(valueInBaseUnits).shiftedBy(-decimals) // / 10 ** decimals
    ;
    if (value.isNaN()) throw new Error(`Not a number in fromBaseUnits(${valueInBaseUnits})`);
    return value.toFixed();
}
const isValidMnemonic = (candidate)=>(0, _bip39.validateMnemonic)(candidate);
const getAccountSize = (value)=>{
    if (value >= 100000000000000000n) return "XXL";
    else if (value >= 50000000000000000n && value <= 99999999000000000n) return "XL";
    else if (value >= 25000000000000000n && value <= 49999999000000000n) return "L";
    else if (value >= 1000000000000000n && value <= 24999999000000000n) return "M";
    else if (value >= 500000000000000n && value <= 999999000000000n) return "S";
    else if (value >= 100000000000000n && value <= 499990000000009n) return "XS";
    else return "XXS";
};

},{"@ethereumjs/util":"2DkLv","buffer":"eHuUs","@oasisprotocol/client":"1ax6t","@oasisprotocol/client-rt":"6GV4q","bignumber.js":"cQ5xL","bip39":"3u1O4","js-sha512":"9yOC0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2DkLv":[function(require,module,exports) {
/**
 * Constants
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayContainsArray", ()=>(0, _internalJs.arrayContainsArray));
parcelHelpers.export(exports, "fromAscii", ()=>(0, _internalJs.fromAscii));
parcelHelpers.export(exports, "fromUtf8", ()=>(0, _internalJs.fromUtf8));
parcelHelpers.export(exports, "getBinarySize", ()=>(0, _internalJs.getBinarySize));
parcelHelpers.export(exports, "getKeys", ()=>(0, _internalJs.getKeys));
parcelHelpers.export(exports, "isHexPrefixed", ()=>(0, _internalJs.isHexPrefixed));
parcelHelpers.export(exports, "isHexString", ()=>(0, _internalJs.isHexString));
parcelHelpers.export(exports, "padToEven", ()=>(0, _internalJs.padToEven));
parcelHelpers.export(exports, "stripHexPrefix", ()=>(0, _internalJs.stripHexPrefix));
parcelHelpers.export(exports, "toAscii", ()=>(0, _internalJs.toAscii));
var _constantsJs = require("./constants.js");
parcelHelpers.exportAll(_constantsJs, exports);
/**
 * Units helpers
 */ var _unitsJs = require("./units.js");
parcelHelpers.exportAll(_unitsJs, exports);
/**
 * Account class and helper functions
 */ var _accountJs = require("./account.js");
parcelHelpers.exportAll(_accountJs, exports);
/**
 * Address type
 */ var _addressJs = require("./address.js");
parcelHelpers.exportAll(_addressJs, exports);
/**
 * DB type
 */ var _dbJs = require("./db.js");
parcelHelpers.exportAll(_dbJs, exports);
/**
 * Withdrawal type
 */ var _withdrawalJs = require("./withdrawal.js");
parcelHelpers.exportAll(_withdrawalJs, exports);
/**
 * ECDSA signature
 */ var _signatureJs = require("./signature.js");
parcelHelpers.exportAll(_signatureJs, exports);
/**
 * Utilities for manipulating bytes, Uint8Arrays, etc.
 */ var _bytesJs = require("./bytes.js");
parcelHelpers.exportAll(_bytesJs, exports);
/**
 * Helpful TypeScript types
 */ var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
/**
 * Export ethjs-util methods
 */ var _asyncEventEmitterJs = require("./asyncEventEmitter.js");
parcelHelpers.exportAll(_asyncEventEmitterJs, exports);
var _blobsJs = require("./blobs.js");
parcelHelpers.exportAll(_blobsJs, exports);
var _genesisJs = require("./genesis.js");
parcelHelpers.exportAll(_genesisJs, exports);
var _internalJs = require("./internal.js");
var _kzgJs = require("./kzg.js");
parcelHelpers.exportAll(_kzgJs, exports);
var _lockJs = require("./lock.js");
parcelHelpers.exportAll(_lockJs, exports);
var _mapDBJs = require("./mapDB.js");
parcelHelpers.exportAll(_mapDBJs, exports);
var _providerJs = require("./provider.js");
parcelHelpers.exportAll(_providerJs, exports);

},{"./constants.js":"faU8a","./units.js":"4jjEX","./account.js":"iTSF3","./address.js":"5d9Pa","./db.js":"45bFW","./withdrawal.js":"eGSbM","./signature.js":"dW2y2","./bytes.js":"iJ2b1","./types.js":"95Lhp","./asyncEventEmitter.js":"70SHU","./blobs.js":"fjf4u","./genesis.js":"lLGxW","./internal.js":"7QqfV","./kzg.js":"7jqQa","./lock.js":"lDA8q","./mapDB.js":"87ACg","./provider.js":"dq5or","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"faU8a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_UINT64", ()=>MAX_UINT64);
parcelHelpers.export(exports, "MAX_INTEGER", ()=>MAX_INTEGER);
parcelHelpers.export(exports, "MAX_INTEGER_BIGINT", ()=>MAX_INTEGER_BIGINT);
parcelHelpers.export(exports, "SECP256K1_ORDER", ()=>SECP256K1_ORDER);
parcelHelpers.export(exports, "SECP256K1_ORDER_DIV_2", ()=>SECP256K1_ORDER_DIV_2);
parcelHelpers.export(exports, "TWO_POW256", ()=>TWO_POW256);
parcelHelpers.export(exports, "KECCAK256_NULL_S", ()=>KECCAK256_NULL_S);
parcelHelpers.export(exports, "KECCAK256_NULL", ()=>KECCAK256_NULL);
parcelHelpers.export(exports, "KECCAK256_RLP_ARRAY_S", ()=>KECCAK256_RLP_ARRAY_S);
parcelHelpers.export(exports, "KECCAK256_RLP_ARRAY", ()=>KECCAK256_RLP_ARRAY);
parcelHelpers.export(exports, "KECCAK256_RLP_S", ()=>KECCAK256_RLP_S);
parcelHelpers.export(exports, "KECCAK256_RLP", ()=>KECCAK256_RLP);
parcelHelpers.export(exports, "RLP_EMPTY_STRING", ()=>RLP_EMPTY_STRING);
parcelHelpers.export(exports, "MAX_WITHDRAWALS_PER_PAYLOAD", ()=>MAX_WITHDRAWALS_PER_PAYLOAD);
parcelHelpers.export(exports, "RIPEMD160_ADDRESS_STRING", ()=>RIPEMD160_ADDRESS_STRING);
parcelHelpers.export(exports, "BIGINT_NEG1", ()=>BIGINT_NEG1);
parcelHelpers.export(exports, "BIGINT_0", ()=>BIGINT_0);
parcelHelpers.export(exports, "BIGINT_1", ()=>BIGINT_1);
parcelHelpers.export(exports, "BIGINT_2", ()=>BIGINT_2);
parcelHelpers.export(exports, "BIGINT_3", ()=>BIGINT_3);
parcelHelpers.export(exports, "BIGINT_7", ()=>BIGINT_7);
parcelHelpers.export(exports, "BIGINT_8", ()=>BIGINT_8);
parcelHelpers.export(exports, "BIGINT_27", ()=>BIGINT_27);
parcelHelpers.export(exports, "BIGINT_28", ()=>BIGINT_28);
parcelHelpers.export(exports, "BIGINT_31", ()=>BIGINT_31);
parcelHelpers.export(exports, "BIGINT_32", ()=>BIGINT_32);
parcelHelpers.export(exports, "BIGINT_64", ()=>BIGINT_64);
parcelHelpers.export(exports, "BIGINT_128", ()=>BIGINT_128);
parcelHelpers.export(exports, "BIGINT_255", ()=>BIGINT_255);
parcelHelpers.export(exports, "BIGINT_256", ()=>BIGINT_256);
parcelHelpers.export(exports, "BIGINT_96", ()=>BIGINT_96);
parcelHelpers.export(exports, "BIGINT_100", ()=>BIGINT_100);
parcelHelpers.export(exports, "BIGINT_160", ()=>BIGINT_160);
parcelHelpers.export(exports, "BIGINT_224", ()=>BIGINT_224);
parcelHelpers.export(exports, "BIGINT_2EXP96", ()=>BIGINT_2EXP96);
parcelHelpers.export(exports, "BIGINT_2EXP160", ()=>BIGINT_2EXP160);
parcelHelpers.export(exports, "BIGINT_2EXP224", ()=>BIGINT_2EXP224);
parcelHelpers.export(exports, "BIGINT_2EXP256", ()=>BIGINT_2EXP256);
var _secp256K1Js = require("ethereum-cryptography/secp256k1.js");
var _bytesJs = require("./bytes.js");
const MAX_UINT64 = BigInt("0xffffffffffffffff");
const MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935");
const SECP256K1_ORDER = (0, _secp256K1Js.secp256k1).CURVE.n;
const SECP256K1_ORDER_DIV_2 = (0, _secp256K1Js.secp256k1).CURVE.n / BigInt(2);
const TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
const KECCAK256_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
const KECCAK256_NULL = (0, _bytesJs.hexToBytes)(KECCAK256_NULL_S);
const KECCAK256_RLP_ARRAY_S = "0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
const KECCAK256_RLP_ARRAY = (0, _bytesJs.hexToBytes)(KECCAK256_RLP_ARRAY_S);
const KECCAK256_RLP_S = "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
const KECCAK256_RLP = (0, _bytesJs.hexToBytes)(KECCAK256_RLP_S);
const RLP_EMPTY_STRING = Uint8Array.from([
    0x80
]);
const MAX_WITHDRAWALS_PER_PAYLOAD = 16;
const RIPEMD160_ADDRESS_STRING = "0000000000000000000000000000000000000003";
const BIGINT_NEG1 = BigInt(-1);
const BIGINT_0 = BigInt(0);
const BIGINT_1 = BigInt(1);
const BIGINT_2 = BigInt(2);
const BIGINT_3 = BigInt(3);
const BIGINT_7 = BigInt(7);
const BIGINT_8 = BigInt(8);
const BIGINT_27 = BigInt(27);
const BIGINT_28 = BigInt(28);
const BIGINT_31 = BigInt(31);
const BIGINT_32 = BigInt(32);
const BIGINT_64 = BigInt(64);
const BIGINT_128 = BigInt(128);
const BIGINT_255 = BigInt(255);
const BIGINT_256 = BigInt(256);
const BIGINT_96 = BigInt(96);
const BIGINT_100 = BigInt(100);
const BIGINT_160 = BigInt(160);
const BIGINT_224 = BigInt(224);
const BIGINT_2EXP96 = BigInt(79228162514264337593543950336);
const BIGINT_2EXP160 = BigInt(1461501637330902918203684832716283019655932542976);
const BIGINT_2EXP224 = BigInt(26959946667150639794667015087019630673637144422540572481103610249216);
const BIGINT_2EXP256 = BIGINT_2 ** BIGINT_256;

},{"ethereum-cryptography/secp256k1.js":"20vH6","./bytes.js":"iJ2b1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"20vH6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.secp256k1 = void 0;
var secp256k1_1 = require("506d8c52da52467c");
Object.defineProperty(exports, "secp256k1", {
    enumerable: true,
    get: function() {
        return secp256k1_1.secp256k1;
    }
});

},{"506d8c52da52467c":"5kFL2"}],"5kFL2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodeToCurve = exports.hashToCurve = exports.schnorr = exports.secp256k1 = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const sha256_1 = require("a89c1505decc763e");
const utils_1 = require("362802f5a451efcb");
const modular_js_1 = require("6a274edd04635854");
const weierstrass_js_1 = require("4687d8e71912c9bd");
const utils_js_1 = require("49209a65a14a4a44");
const hash_to_curve_js_1 = require("992867e7d1ef8b");
const _shortw_utils_js_1 = require("8a5ef77428763709");
const secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const _1n = BigInt(1);
const _2n = BigInt(2);
const divNearest = (a, b)=>(a + b / _2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function sqrtMod(y) {
    const P = secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, modular_js_1.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, modular_js_1.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, modular_js_1.pow2)(b9, _2n, P) * b2 % P;
    const b22 = (0, modular_js_1.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, modular_js_1.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, modular_js_1.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, modular_js_1.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, modular_js_1.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, modular_js_1.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, modular_js_1.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, modular_js_1.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, modular_js_1.pow2)(t2, _2n, P);
    if (!Fp.eql(Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const Fp = (0, modular_js_1.Field)(secp256k1P, undefined, undefined, {
    sqrt: sqrtMod
});
exports.secp256k1 = (0, _shortw_utils_js_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = (0, modular_js_1.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, modular_js_1.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg,
                k1,
                k2neg,
                k2
            };
        }
    }
}, sha256_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const _0n = BigInt(0);
const fe = (x)=>typeof x === "bigint" && _0n < x && x < secp256k1P;
const ge = (x)=>typeof x === "bigint" && _0n < x && x < secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const TAGGED_HASH_PREFIXES = {};
function taggedHash(tag, ...messages) {
    let tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, sha256_1.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, utils_js_1.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha256_1.sha256)((0, utils_js_1.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const numTo32b = (n)=>(0, utils_js_1.numberToBytesBE)(n, 32);
const modP = (x)=>(0, modular_js_1.mod)(x, secp256k1P);
const modN = (x)=>(0, modular_js_1.mod)(x, secp256k1N);
const Point = exports.secp256k1.ProjectivePoint;
const GmulAdd = (Q, a, b)=>Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    let d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : modN(-d_);
    return {
        scalar: scalar,
        bytes: pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function lift_x(x) {
    if (!fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = modP(x * x);
    const c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n) y = modP(-y); // Return the unique point P such that x(P) = x and
    const p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function challenge(...args) {
    return modN((0, utils_js_1.bytesToNumberBE)(taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function schnorrSign(message, privateKey, auxRand = (0, utils_1.randomBytes)(32)) {
    const m = (0, utils_js_1.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, utils_js_1.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = numTo32b(d ^ (0, utils_js_1.bytesToNumberBE)(taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = modN((0, utils_js_1.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function schnorrVerify(signature, message, publicKey) {
    const sig = (0, utils_js_1.ensureBytes)("signature", signature, 64);
    const m = (0, utils_js_1.ensureBytes)("message", message);
    const pub = (0, utils_js_1.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = lift_x((0, utils_js_1.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, utils_js_1.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!fe(r)) return false;
        const s = (0, utils_js_1.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!ge(s)) return false;
        const e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
exports.schnorr = (()=>({
        getPublicKey: schnorrGetPublicKey,
        sign: schnorrSign,
        verify: schnorrVerify,
        utils: {
            randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
            lift_x,
            pointToBytes,
            numberToBytesBE: utils_js_1.numberToBytesBE,
            bytesToNumberBE: utils_js_1.bytesToNumberBE,
            taggedHash,
            mod: modular_js_1.mod
        }
    }))();
const isoMap = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.isogenyMap)(Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const mapSWU = /* @__PURE__ */ (()=>(0, weierstrass_js_1.mapToCurveSimpleSWU)(Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: Fp.create(BigInt("-11"))
    }))();
const htf = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.createHasher)(exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x, y } = mapSWU(Fp.create(scalars[0]));
        return isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: sha256_1.sha256
    }))();
exports.hashToCurve = (()=>htf.hashToCurve)();
exports.encodeToCurve = (()=>htf.encodeToCurve)();

},{"a89c1505decc763e":"1a1TJ","362802f5a451efcb":"lHXRP","6a274edd04635854":"kA2Sx","4687d8e71912c9bd":"6HGXr","49209a65a14a4a44":"kxYbB","992867e7d1ef8b":"jQr5P","8a5ef77428763709":"7CaxE"}],"1a1TJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha224 = exports.sha256 = void 0;
const _sha2_js_1 = require("f0369f0173e40550");
const utils_js_1 = require("dd2d5fab8dc388cf");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _sha2_js_1.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = IV[0] | 0;
        this.B = IV[1] | 0;
        this.C = IV[2] | 0;
        this.D = IV[3] | 0;
        this.E = IV[4] | 0;
        this.F = IV[5] | 0;
        this.G = IV[6] | 0;
        this.H = IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_js_1.rotr)(W15, 7) ^ (0, utils_js_1.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, utils_js_1.rotr)(W2, 17) ^ (0, utils_js_1.rotr)(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, utils_js_1.rotr)(E, 6) ^ (0, utils_js_1.rotr)(E, 11) ^ (0, utils_js_1.rotr)(E, 25);
            const T1 = H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = (0, utils_js_1.rotr)(A, 2) ^ (0, utils_js_1.rotr)(A, 13) ^ (0, utils_js_1.rotr)(A, 22);
            const T2 = sigma0 + Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class SHA224 extends SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ exports.sha256 = (0, utils_js_1.wrapConstructor)(()=>new SHA256());
exports.sha224 = (0, utils_js_1.wrapConstructor)(()=>new SHA224());

},{"f0369f0173e40550":"blbew","dd2d5fab8dc388cf":"lHXRP"}],"blbew":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHA2 = void 0;
const _assert_js_1 = require("96995f5a2c2249c4");
const utils_js_1 = require("c59c675893fdf798");
// Polyfill for Safari 14
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class SHA2 extends utils_js_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_js_1.createView)(this.buffer);
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { view, buffer, blockLen } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_js_1.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_js_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
exports.SHA2 = SHA2;

},{"96995f5a2c2249c4":"hlTZH","c59c675893fdf798":"lHXRP"}],"hlTZH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
exports.number = number;
function bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function bytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
exports.bytes = bytes;
function hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(hash.outputLen);
    number(hash.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
exports.output = output;
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"lHXRP":[function(require,module,exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.isLE = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("308a0f9b8753b4af");
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    if (!isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    if (!isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === "function") return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
exports.randomBytes = randomBytes;

},{"308a0f9b8753b4af":"lz3jG"}],"lz3jG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

},{}],"kA2Sx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapHashToField = exports.getMinHashLength = exports.getFieldBytesLength = exports.hashToPrivateScalar = exports.FpSqrtEven = exports.FpSqrtOdd = exports.Field = exports.nLength = exports.FpIsSquare = exports.FpDiv = exports.FpInvertBatch = exports.FpPow = exports.validateField = exports.isNegativeLE = exports.FpSqrt = exports.tonelliShanks = exports.invert = exports.pow2 = exports.pow = exports.mod = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields
const utils_js_1 = require("d8ac4b6c79c60614");
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
const _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
const _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n ? result : b + result;
}
exports.mod = mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n) throw new Error("Expected power/modulo > 0");
    if (modulo === _1n) return _0n;
    let res = _1n;
    while(power > _0n){
        if (power & _1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= _1n;
    }
    return res;
}
exports.pow = pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    let res = x;
    while(power-- > _0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
exports.pow2 = pow2;
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n, y = _1n, u = _1n, v = _0n;
    while(a !== _0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n) throw new Error("invert: does not exist");
    return mod(x, modulo);
}
exports.invert = invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - _1n) / _2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
exports.tonelliShanks = tonelliShanks;
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        const c1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, _2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, _2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    _9n;
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
exports.FpSqrt = FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const isNegativeLE = (num, modulo)=>(mod(num, modulo) & _1n) === _1n;
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
const FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, utils_js_1.validateObject)(field, opts);
}
exports.validateField = validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n) throw new Error("Expected power > 0");
    if (power === _0n) return f.ONE;
    if (power === _1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > _0n){
        if (power & _1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
exports.FpPow = FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
exports.FpInvertBatch = FpInvertBatch;
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? invert(rhs, f.ORDER) : f.inv(rhs));
}
exports.FpDiv = FpDiv;
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    const legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
exports.FpIsSquare = FpIsSquare;
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength
    };
}
exports.nLength = nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= _0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER,
        BITS,
        BYTES,
        MASK: (0, utils_js_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: (num)=>mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === _0n,
        isOdd: (num)=>(num & _1n) === _1n,
        neg: (num)=>mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>mod(num * num, ORDER),
        add: (lhs, rhs)=>mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>mod(lhs * rhs, ORDER),
        pow: (num, power)=>FpPow(f, num, power),
        div: (lhs, rhs)=>mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, utils_js_1.numberToBytesLE)(num, BYTES) : (0, utils_js_1.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, utils_js_1.bytesToNumberLE)(bytes) : (0, utils_js_1.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
exports.Field = Field;
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
exports.FpSqrtOdd = FpSqrtOdd;
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
exports.FpSqrtEven = FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, utils_js_1.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberLE)(hash) : (0, utils_js_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
exports.hashToPrivateScalar = hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
exports.getFieldBytesLength = getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
exports.getMinHashLength = getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberBE)(key) : (0, utils_js_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_js_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_js_1.numberToBytesBE)(reduced, fieldLen);
}
exports.mapHashToField = mapHashToField;

},{"d8ac4b6c79c60614":"kxYbB"}],"kxYbB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateObject = exports.createHmacDrbg = exports.bitMask = exports.bitSet = exports.bitGet = exports.bitLen = exports.utf8ToBytes = exports.equalBytes = exports.concatBytes = exports.ensureBytes = exports.numberToVarBytesBE = exports.numberToBytesLE = exports.numberToBytesBE = exports.bytesToNumberLE = exports.bytesToNumberBE = exports.hexToBytes = exports.hexToNumber = exports.numberToHexUnpadded = exports.bytesToHex = exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
exports.isBytes = isBytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    if (!isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
exports.numberToHexUnpadded = numberToHexUnpadded;
function hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
exports.hexToNumber = hexToNumber;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
exports.bytesToNumberBE = bytesToNumberBE;
function bytesToNumberLE(bytes) {
    if (!isBytes(bytes)) throw new Error("Uint8Array expected");
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
exports.bytesToNumberLE = bytesToNumberLE;
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
exports.numberToBytesBE = numberToBytesBE;
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
exports.numberToBytesLE = numberToBytesLE;
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
exports.numberToVarBytesBE = numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if (isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
exports.ensureBytes = ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    let res = new Uint8Array(sum);
    let pad = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
exports.equalBytes = equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function bitLen(n) {
    let len;
    for(len = 0; n > _0n; n >>= _1n, len += 1);
    return len;
}
exports.bitLen = bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function bitGet(n, pos) {
    return n >> BigInt(pos) & _1n;
}
exports.bitGet = bitGet;
/**
 * Sets single bit at position.
 */ const bitSet = (n, pos, value)=>{
    return n | (value ? _1n : _0n) << BigInt(pos);
};
exports.bitSet = bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const bitMask = (n)=>(_2n << BigInt(n - 1)) - _1n;
exports.bitMask = bitMask;
// DRBG
const u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
exports.createHmacDrbg = createHmacDrbg;
// Validating curves and fields
const validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
exports.validateObject = validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

},{}],"6HGXr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapToCurveSimpleSWU = exports.SWUFpSqrtRatio = exports.weierstrass = exports.weierstrassPoints = exports.DER = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b
const mod = require("d8b1615c256fe3fa");
const ut = require("aae491f09795d5ee");
const utils_js_1 = require("aae491f09795d5ee");
const curve_js_1 = require("11f68d725b0f6f5d");
function validatePointOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo, Fp, a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut;
exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = exports.DER;
        const data = typeof hex === "string" ? h2b(hex) : hex;
        if (!ut.isBytes(data)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r,
            s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return ut.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x,
            y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && _0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (ut.isBytes(key)) key = ut.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : ut.bytesToNumberBE((0, utils_js_1.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = mod.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, utils_js_1.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x, y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === _0n) return I;
            assertGE(n); // Will throw on 0
            if (n === _1n) return this;
            const { endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > _0n || k2 > _0n){
                if (k1 & _1n) k1p = k1p.add(d);
                if (k2 & _1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo } = CURVE;
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p, f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return ut.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, curve_js_1.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder
    };
}
exports.weierstrassPoints = weierstrassPoints;
function validateOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return _0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return mod.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return mod.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = ut.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = ut.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & _1n) === _1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x,
                    y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x,
                    y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>ut.bytesToHex(ut.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>ut.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, utils_js_1.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = exports.DER.toSig((0, utils_js_1.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN((0, utils_js_1.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return ut.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return ut.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = mod.getMinHashLength(CURVE.n);
            return mod.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = ut.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = ut.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = ut.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!(_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return ut.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash, randomBytes } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_js_1.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, utils_js_1.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_js_1.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = ut.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === _0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed,
            k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = ut.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, utils_js_1.ensureBytes)("msgHash", msgHash);
        publicKey = (0, utils_js_1.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS, prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || ut.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r, s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign,
        verify,
        ProjectivePoint: Point,
        Signature,
        utils
    };
}
exports.weierstrass = weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = _0n;
    for(let o = q - _1n; o % _2n === _0n; o /= _2n)l += _1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = _2n << c1 - _1n - _1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    const c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > _1n; i--){
            let tv5 = i - _2n; // 18.    tv5 = i - 2
            tv5 = _2n << tv5 - _1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function mapToCurveSimpleSWU(Fp, opts) {
    mod.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid, value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x,
            y
        };
    };
}
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;

},{"d8b1615c256fe3fa":"kA2Sx","aae491f09795d5ee":"kxYbB","11f68d725b0f6f5d":"fGzQs"}],"fGzQs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities
const modular_js_1 = require("72c8f755a25fddc3");
const utils_js_1 = require("f90fcba6ea31de55");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows,
            windowSize
        };
    };
    return {
        constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p,
                f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, modular_js_1.validateField)(curve.Fp);
    (0, utils_js_1.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, modular_js_1.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

},{"72c8f755a25fddc3":"kA2Sx","f90fcba6ea31de55":"kxYbB"}],"jQr5P":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createHasher = exports.isogenyMap = exports.hash_to_field = exports.expand_message_xof = exports.expand_message_xmd = void 0;
const modular_js_1 = require("eccb35e649679ca");
const utils_js_1 = require("202487820f28c009");
function validateDST(dst) {
    if ((0, utils_js_1.isBytes)(dst)) return dst;
    if (typeof dst === "string") return (0, utils_js_1.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const os2ip = utils_js_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function abytes(item) {
    if (!(0, utils_js_1.isBytes)(item)) throw new Error("Uint8Array expected");
}
function isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function expand_message_xmd(msg, DST, lenInBytes, H) {
    abytes(msg);
    abytes(DST);
    isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, utils_js_1.concatBytes)((0, utils_js_1.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, utils_js_1.concatBytes)(DST, i2osp(DST.length, 1));
    const Z_pad = i2osp(0, r_in_bytes);
    const l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, utils_js_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_js_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            strxor(b_0, b[i - 1]),
            i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, utils_js_1.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, utils_js_1.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
exports.expand_message_xmd = expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function expand_message_xof(msg, DST, lenInBytes, k, H) {
    abytes(msg);
    abytes(DST);
    isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen
        }).update((0, utils_js_1.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update(i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update(i2osp(DST.length, 1)).digest();
}
exports.expand_message_xof = expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function hash_to_field(msg, count, options) {
    (0, utils_js_1.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p, k, m, hash, expand, DST: _DST } = options;
    abytes(msg);
    isNum(count);
    const DST = validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_js_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
exports.hash_to_field = hash_to_field;
function isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x,
            y
        };
    };
}
exports.isogenyMap = isogenyMap;
function createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
exports.createHasher = createHasher;

},{"eccb35e649679ca":"kA2Sx","202487820f28c009":"kxYbB"}],"7CaxE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCurve = exports.getHash = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const hmac_1 = require("2bb3ed73a71161e3");
const utils_1 = require("808050cc11f056c7");
const weierstrass_js_1 = require("bceff96a5b87336d");
// connects noble-curves to noble-hashes
function getHash(hash) {
    return {
        hash,
        hmac: (key, ...msgs)=>(0, hmac_1.hmac)(hash, key, (0, utils_1.concatBytes)(...msgs)),
        randomBytes: utils_1.randomBytes
    };
}
exports.getHash = getHash;
function createCurve(curveDef, defHash) {
    const create = (hash)=>(0, weierstrass_js_1.weierstrass)({
            ...curveDef,
            ...getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create
    });
}
exports.createCurve = createCurve;

},{"2bb3ed73a71161e3":"8Kdrk","808050cc11f056c7":"lHXRP","bceff96a5b87336d":"6HGXr"}],"8Kdrk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hmac = exports.HMAC = void 0;
const _assert_js_1 = require("88de570f0f701cc6");
const utils_js_1 = require("337359ae358d0fc");
// HMAC (RFC 2104)
class HMAC extends utils_js_1.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, _assert_js_1.hash)(hash);
        const key = (0, utils_js_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, _assert_js_1.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const hmac = (hash, key, message)=>new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key)=>new HMAC(hash, key);

},{"88de570f0f701cc6":"hlTZH","337359ae358d0fc":"lHXRP"}],"iJ2b1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line no-restricted-imports
parcelHelpers.export(exports, "bytesToUtf8", ()=>(0, _utilsJs.bytesToUtf8));
parcelHelpers.export(exports, "equalsBytes", ()=>(0, _utilsJs.equalsBytes));
parcelHelpers.export(exports, "utf8ToBytes", ()=>(0, _utilsJs.utf8ToBytes));
parcelHelpers.export(exports, "bytesToUnprefixedHex", ()=>bytesToUnprefixedHex);
parcelHelpers.export(exports, "unprefixedHexToBytes", ()=>unprefixedHexToBytes);
parcelHelpers.export(exports, "bytesToHex", ()=>bytesToHex);
parcelHelpers.export(exports, "bytesToBigInt", ()=>bytesToBigInt);
parcelHelpers.export(exports, "bytesToInt", ()=>bytesToInt);
parcelHelpers.export(exports, "hexToBytes", ()=>hexToBytes);
parcelHelpers.export(exports, "intToHex", ()=>intToHex);
parcelHelpers.export(exports, "intToBytes", ()=>intToBytes);
parcelHelpers.export(exports, "bigIntToBytes", ()=>bigIntToBytes);
parcelHelpers.export(exports, "zeros", ()=>zeros);
parcelHelpers.export(exports, "setLengthLeft", ()=>setLengthLeft);
parcelHelpers.export(exports, "setLengthRight", ()=>setLengthRight);
parcelHelpers.export(exports, "unpadBytes", ()=>unpadBytes);
parcelHelpers.export(exports, "unpadArray", ()=>unpadArray);
parcelHelpers.export(exports, "unpadHex", ()=>unpadHex);
parcelHelpers.export(exports, "toBytes", ()=>toBytes);
parcelHelpers.export(exports, "fromSigned", ()=>fromSigned);
parcelHelpers.export(exports, "toUnsigned", ()=>toUnsigned);
parcelHelpers.export(exports, "addHexPrefix", ()=>addHexPrefix);
parcelHelpers.export(exports, "short", ()=>short);
parcelHelpers.export(exports, "validateNoLeadingZeroes", ()=>validateNoLeadingZeroes);
parcelHelpers.export(exports, "bigIntToHex", ()=>bigIntToHex);
parcelHelpers.export(exports, "bigIntMax", ()=>bigIntMax);
parcelHelpers.export(exports, "bigIntMin", ()=>bigIntMin);
parcelHelpers.export(exports, "bigIntToUnpaddedBytes", ()=>bigIntToUnpaddedBytes);
parcelHelpers.export(exports, "intToUnpaddedBytes", ()=>intToUnpaddedBytes);
parcelHelpers.export(exports, "compareBytes", ()=>compareBytes);
parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
parcelHelpers.export(exports, "concatBytes", ()=>concatBytes);
/**
 * @notice Convert a Uint8Array to a 32-bit integer
 * @param {Uint8Array} bytes The input Uint8Array from which to read the 32-bit integer.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {number} The 32-bit integer read from the input Uint8Array.
 */ parcelHelpers.export(exports, "bytesToInt32", ()=>bytesToInt32);
/**
 * @notice Convert a Uint8Array to a 64-bit bigint
 * @param {Uint8Array} bytes The input Uint8Array from which to read the 64-bit bigint.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {bigint} The 64-bit bigint read from the input Uint8Array.
 */ parcelHelpers.export(exports, "bytesToBigInt64", ()=>bytesToBigInt64);
/**
 * @notice Convert a 32-bit integer to a Uint8Array.
 * @param {number} value The 32-bit integer to convert.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {Uint8Array} A Uint8Array of length 4 containing the integer.
 */ parcelHelpers.export(exports, "int32ToBytes", ()=>int32ToBytes);
/**
 * @notice Convert a 64-bit bigint to a Uint8Array.
 * @param {bigint} value The 64-bit bigint to convert.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {Uint8Array} A Uint8Array of length 8 containing the bigint.
 */ parcelHelpers.export(exports, "bigInt64ToBytes", ()=>bigInt64ToBytes);
var _randomJs = require("ethereum-cryptography/random.js");
// eslint-disable-next-line no-restricted-imports
var _utilsJs = require("ethereum-cryptography/utils.js");
var _helpersJs = require("./helpers.js");
var _internalJs = require("./internal.js");
const BIGINT_0 = BigInt(0);
const bytesToUnprefixedHex = (0, _utilsJs.bytesToHex);
// hexToBytes cache
const hexToBytesMapFirstKey = {};
const hexToBytesMapSecondKey = {};
for(let i = 0; i < 16; i++){
    const vSecondKey = i;
    const vFirstKey = i * 16;
    const key = i.toString(16).toLowerCase();
    hexToBytesMapSecondKey[key] = vSecondKey;
    hexToBytesMapSecondKey[key.toUpperCase()] = vSecondKey;
    hexToBytesMapFirstKey[key] = vFirstKey;
    hexToBytesMapFirstKey[key.toUpperCase()] = vFirstKey;
}
/**
 * NOTE: only use this function if the string is even, and only consists of hex characters
 * If this is not the case, this function could return weird results
 * @deprecated
 */ function _unprefixedHexToBytes(hex) {
    const byteLen = hex.length;
    const bytes = new Uint8Array(byteLen / 2);
    for(let i = 0; i < byteLen; i += 2)bytes[i / 2] = hexToBytesMapFirstKey[hex[i]] + hexToBytesMapSecondKey[hex[i + 1]];
    return bytes;
}
const unprefixedHexToBytes = (inp)=>{
    if (inp.slice(0, 2) === "0x") throw new Error("hex string is prefixed with 0x, should be unprefixed");
    else return _unprefixedHexToBytes((0, _internalJs.padToEven)(inp));
};
/****************  Borrowed from @chainsafe/ssz */ // Caching this info costs about ~1000 bytes and speeds up toHexString() by x6
const hexByByte = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
const bytesToHex = (bytes)=>{
    let hex = "0x";
    if (bytes === undefined || bytes.length === 0) return hex;
    for (const byte of bytes)hex += hexByByte[byte];
    return hex;
};
// BigInt cache for the numbers 0 - 256*256-1 (two-byte bytes)
const BIGINT_CACHE = [];
for(let i = 0; i <= 65535; i++)BIGINT_CACHE[i] = BigInt(i);
const bytesToBigInt = (bytes, littleEndian = false)=>{
    if (littleEndian) bytes.reverse();
    const hex = bytesToHex(bytes);
    if (hex === "0x") return BIGINT_0;
    if (hex.length === 4) // If the byte length is 1 (this is faster than checking `bytes.length === 1`)
    return BIGINT_CACHE[bytes[0]];
    if (hex.length === 6) return BIGINT_CACHE[bytes[0] * 256 + bytes[1]];
    return BigInt(hex);
};
const bytesToInt = (bytes)=>{
    const res = Number(bytesToBigInt(bytes));
    if (!Number.isSafeInteger(res)) throw new Error("Number exceeds 53 bits");
    return res;
};
const hexToBytes = (hex)=>{
    if (typeof hex !== "string") throw new Error(`hex argument type ${typeof hex} must be of type string`);
    if (!/^0x[0-9a-fA-F]*$/.test(hex)) throw new Error(`Input must be a 0x-prefixed hexadecimal string, got ${hex}`);
    hex = hex.slice(2);
    if (hex.length % 2 !== 0) hex = (0, _internalJs.padToEven)(hex);
    return _unprefixedHexToBytes(hex);
};
const intToHex = (i)=>{
    if (!Number.isSafeInteger(i) || i < 0) throw new Error(`Received an invalid integer type: ${i}`);
    return `0x${i.toString(16)}`;
};
const intToBytes = (i)=>{
    const hex = intToHex(i);
    return hexToBytes(hex);
};
const bigIntToBytes = (num, littleEndian = false)=>{
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const bytes = toBytes("0x" + (0, _internalJs.padToEven)(num.toString(16)));
    return littleEndian ? bytes.reverse() : bytes;
};
const zeros = (bytes)=>{
    return new Uint8Array(bytes);
};
/**
 * Pads a `Uint8Array` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param {Uint8Array} msg the value to pad
 * @param {number} length the number of bytes the output should be
 * @param {boolean} right whether to start padding form the left or right
 * @return {Uint8Array}
 */ const setLength = (msg, length, right)=>{
    if (right) {
        if (msg.length < length) return new Uint8Array([
            ...msg,
            ...zeros(length - msg.length)
        ]);
        return msg.subarray(0, length);
    } else {
        if (msg.length < length) return new Uint8Array([
            ...zeros(length - msg.length),
            ...msg
        ]);
        return msg.subarray(-length);
    }
};
const setLengthLeft = (msg, length)=>{
    (0, _helpersJs.assertIsBytes)(msg);
    return setLength(msg, length, false);
};
const setLengthRight = (msg, length)=>{
    (0, _helpersJs.assertIsBytes)(msg);
    return setLength(msg, length, true);
};
/**
 * Trims leading zeros from a `Uint8Array`, `number[]` or PrefixedHexString`.
 * @param {Uint8Array|number[]|PrefixedHexString} a
 * @return {Uint8Array|number[]|PrefixedHexString}
 */ const stripZeros = (a)=>{
    let first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
const unpadBytes = (a)=>{
    (0, _helpersJs.assertIsBytes)(a);
    return stripZeros(a);
};
const unpadArray = (a)=>{
    (0, _helpersJs.assertIsArray)(a);
    return stripZeros(a);
};
const unpadHex = (a)=>{
    (0, _helpersJs.assertIsHexString)(a);
    a = (0, _internalJs.stripHexPrefix)(a);
    return "0x" + stripZeros(a);
};
const toBytes = (v)=>{
    if (v === null || v === undefined) return new Uint8Array();
    if (Array.isArray(v) || v instanceof Uint8Array) return Uint8Array.from(v);
    if (typeof v === "string") {
        if (!(0, _internalJs.isHexString)(v)) throw new Error(`Cannot convert string to Uint8Array. toBytes only supports 0x-prefixed hex strings and this string was given: ${v}`);
        return hexToBytes(v);
    }
    if (typeof v === "number") return intToBytes(v);
    if (typeof v === "bigint") {
        if (v < BIGINT_0) throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${v}`);
        let n = v.toString(16);
        if (n.length % 2) n = "0" + n;
        return unprefixedHexToBytes(n);
    }
    if (v.toBytes !== undefined) // converts a `TransformableToBytes` object to a Uint8Array
    return v.toBytes();
    throw new Error("invalid type");
};
const fromSigned = (num)=>{
    return BigInt.asIntN(256, bytesToBigInt(num));
};
const toUnsigned = (num)=>{
    return bigIntToBytes(BigInt.asUintN(256, num));
};
const addHexPrefix = (str)=>{
    if (typeof str !== "string") return str;
    return (0, _internalJs.isHexPrefixed)(str) ? str : "0x" + str;
};
const short = (bytes, maxLength = 50)=>{
    const byteStr = bytes instanceof Uint8Array ? bytesToHex(bytes) : bytes;
    const len = byteStr.slice(0, 2) === "0x" ? maxLength + 2 : maxLength;
    if (byteStr.length <= len) return byteStr;
    return byteStr.slice(0, len) + "\u2026";
};
const validateNoLeadingZeroes = (values)=>{
    for (const [k, v] of Object.entries(values)){
        if (v !== undefined && v.length > 0 && v[0] === 0) throw new Error(`${k} cannot have leading zeroes, received: ${bytesToHex(v)}`);
    }
};
const bigIntToHex = (num)=>{
    return "0x" + num.toString(16);
};
const bigIntMax = (...args)=>args.reduce((m, e)=>e > m ? e : m);
const bigIntMin = (...args)=>args.reduce((m, e)=>e < m ? e : m);
const bigIntToUnpaddedBytes = (value)=>{
    return unpadBytes(bigIntToBytes(value));
};
const intToUnpaddedBytes = (value)=>{
    return unpadBytes(intToBytes(value));
};
const compareBytes = (value1, value2)=>{
    const bigIntValue1 = bytesToBigInt(value1);
    const bigIntValue2 = bytesToBigInt(value2);
    return bigIntValue1 > bigIntValue2 ? 1 : bigIntValue1 < bigIntValue2 ? -1 : 0;
};
const randomBytes = (length)=>{
    return (0, _randomJs.getRandomBytesSync)(length);
};
const concatBytes = (...arrays)=>{
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
};
function bytesToInt32(bytes, littleEndian = false) {
    if (bytes.length < 4) bytes = setLength(bytes, 4, littleEndian);
    const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    return dataView.getUint32(0, littleEndian);
}
function bytesToBigInt64(bytes, littleEndian = false) {
    if (bytes.length < 8) bytes = setLength(bytes, 8, littleEndian);
    const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    return dataView.getBigUint64(0, littleEndian);
}
function int32ToBytes(value, littleEndian = false) {
    const buffer = new ArrayBuffer(4);
    const dataView = new DataView(buffer);
    dataView.setUint32(0, value, littleEndian);
    return new Uint8Array(buffer);
}
function bigInt64ToBytes(value, littleEndian = false) {
    const buffer = new ArrayBuffer(8);
    const dataView = new DataView(buffer);
    dataView.setBigUint64(0, value, littleEndian);
    return new Uint8Array(buffer);
}

},{"ethereum-cryptography/random.js":"iofDM","ethereum-cryptography/utils.js":"fK9OA","./helpers.js":"illO1","./internal.js":"7QqfV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iofDM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRandomBytes = exports.getRandomBytesSync = void 0;
const utils_1 = require("695303df10ec1086");
function getRandomBytesSync(bytes) {
    return (0, utils_1.randomBytes)(bytes);
}
exports.getRandomBytesSync = getRandomBytesSync;
async function getRandomBytes(bytes) {
    return (0, utils_1.randomBytes)(bytes);
}
exports.getRandomBytes = getRandomBytes;

},{"695303df10ec1086":"lHXRP"}],"fK9OA":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = exports.wrapHash = exports.equalsBytes = exports.hexToBytes = exports.bytesToUtf8 = exports.utf8ToBytes = exports.createView = exports.concatBytes = exports.toHex = exports.bytesToHex = exports.assertBytes = exports.assertBool = void 0;
const _assert_1 = __importDefault(require("a5ab7a5629530fc6"));
const utils_1 = require("eef052ebf8c98f84");
const assertBool = _assert_1.default.bool;
exports.assertBool = assertBool;
const assertBytes = _assert_1.default.bytes;
exports.assertBytes = assertBytes;
var utils_2 = require("eef052ebf8c98f84");
Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function() {
        return utils_2.concatBytes;
    }
});
Object.defineProperty(exports, "createView", {
    enumerable: true,
    get: function() {
        return utils_2.createView;
    }
});
Object.defineProperty(exports, "utf8ToBytes", {
    enumerable: true,
    get: function() {
        return utils_2.utf8ToBytes;
    }
});
// buf.toString('utf8') -> bytesToUtf8(buf)
function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof data}`);
    return new TextDecoder().decode(data);
}
exports.bytesToUtf8 = bytesToUtf8;
function hexToBytes(data) {
    const sliced = data.startsWith("0x") ? data.substring(2) : data;
    return (0, utils_1.hexToBytes)(sliced);
}
exports.hexToBytes = hexToBytes;
// buf.equals(buf2) -> equalsBytes(buf, buf2)
function equalsBytes(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
exports.equalsBytes = equalsBytes;
// Internal utils
function wrapHash(hash) {
    return (msg)=>{
        _assert_1.default.bytes(msg);
        return hash(msg);
    };
}
exports.wrapHash = wrapHash;
// TODO(v3): switch away from node crypto, remove this unnecessary variable.
exports.crypto = (()=>{
    const webCrypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
})();

},{"a5ab7a5629530fc6":"hlTZH","eef052ebf8c98f84":"lHXRP"}],"illO1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertIsHexString", ()=>assertIsHexString);
parcelHelpers.export(exports, "assertIsBytes", ()=>assertIsBytes);
parcelHelpers.export(exports, "assertIsArray", ()=>assertIsArray);
parcelHelpers.export(exports, "assertIsString", ()=>assertIsString);
var _internalJs = require("./internal.js");
const assertIsHexString = function(input) {
    if (!(0, _internalJs.isHexString)(input)) {
        const msg = `This method only supports 0x-prefixed hex strings but input was: ${input}`;
        throw new Error(msg);
    }
};
const assertIsBytes = function(input) {
    if (!(input instanceof Uint8Array)) {
        const msg = `This method only supports Uint8Array but input was: ${input}`;
        throw new Error(msg);
    }
};
const assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        const msg = `This method only supports number arrays but input was: ${input}`;
        throw new Error(msg);
    }
};
const assertIsString = function(input) {
    if (typeof input !== "string") {
        const msg = `This method only supports strings but input was: ${input}`;
        throw new Error(msg);
    }
};

},{"./internal.js":"7QqfV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7QqfV":[function(require,module,exports) {
/*
The MIT License

Copyright (c) 2016 Nick Dodson. nickdodson.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param str the string input value
 * @return a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ parcelHelpers.export(exports, "isHexPrefixed", ()=>isHexPrefixed);
parcelHelpers.export(exports, "stripHexPrefix", ()=>stripHexPrefix);
/**
 * Pads a `String` to have an even length
 * @param value
 * @return output
 */ parcelHelpers.export(exports, "padToEven", ()=>padToEven);
/**
 * Get the binary size of a string
 * @param str
 * @returns the number of bytes contained within the string
 */ parcelHelpers.export(exports, "getBinarySize", ()=>getBinarySize);
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param superset
 * @param subset
 *
 */ parcelHelpers.export(exports, "arrayContainsArray", ()=>arrayContainsArray);
/**
 * Should be called to get ascii from its hex representation
 *
 * @param string in hex
 * @returns ascii string representation of hex value
 */ parcelHelpers.export(exports, "toAscii", ()=>toAscii);
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string.
 * Strips leading and trailing 0's.
 *
 * @param string
 * @param optional padding
 * @returns hex representation of input string
 */ parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @param  string
 * @param  optional padding
 * @returns  hex representation of input string
 */ parcelHelpers.export(exports, "fromAscii", ()=>fromAscii);
/**
 * Returns the keys from an array of objects.
 * @example
 * ```js
 * getKeys([{a: '1', b: '2'}, {a: '3', b: '4'}], 'a') => ['1', '3']
 *````
 * @param  params
 * @param  key
 * @param  allowEmpty
 * @returns output just a simple array of output keys
 */ parcelHelpers.export(exports, "getKeys", ()=>getKeys);
/**
 * Is the string a hex string.
 *
 * @param  value
 * @param  length
 * @returns  output the string is a hex string
 */ parcelHelpers.export(exports, "isHexString", ()=>isHexString);
var _bytesJs = require("./bytes.js");
function isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error(`[isHexPrefixed] input must be type 'string', received type ${typeof str}`);
    return str[0] === "0" && str[1] === "x";
}
const stripHexPrefix = (str)=>{
    if (typeof str !== "string") throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
    return isHexPrefixed(str) ? str.slice(2) : str;
};
function padToEven(value) {
    let a = value;
    if (typeof a !== "string") throw new Error(`[padToEven] value must be type 'string', received ${typeof a}`);
    if (a.length % 2) a = `0${a}`;
    return a;
}
function getBinarySize(str) {
    if (typeof str !== "string") throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof str}`);
    return (0, _bytesJs.utf8ToBytes)(str).byteLength;
}
function arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof superset}'`);
    if (Array.isArray(subset) !== true) throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof subset}'`);
    return subset[some === true ? "some" : "every"]((value)=>superset.indexOf(value) >= 0);
}
function toAscii(hex) {
    let str = "";
    let i = 0;
    const l = hex.length;
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        const code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
function fromUtf8(stringValue) {
    const str = (0, _bytesJs.utf8ToBytes)(stringValue);
    return `0x${padToEven((0, _bytesJs.bytesToUnprefixedHex)(str)).replace(/^0+|0+$/g, "")}`;
}
function fromAscii(stringValue) {
    let hex = "";
    for(let i = 0; i < stringValue.length; i++){
        const code = stringValue.charCodeAt(i);
        const n = code.toString(16);
        hex += n.length < 2 ? `0${n}` : n;
    }
    return `0x${hex}`;
}
function getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof params}`);
    if (typeof key !== "string") throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof params}`);
    const result = [];
    for(let i = 0; i < params.length; i++){
        let value = params[i][key];
        if (allowEmpty === true && !value) value = "";
        else if (typeof value !== "string") throw new Error(`invalid abi - expected type 'string', received ${typeof value}`);
        result.push(value);
    }
    return result;
}
function isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length !== "undefined" && length > 0 && value.length !== 2 + 2 * length) return false;
    return true;
}

},{"./bytes.js":"iJ2b1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4jjEX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GWEI_TO_WEI", ()=>GWEI_TO_WEI);
parcelHelpers.export(exports, "formatBigDecimal", ()=>formatBigDecimal);
var _constantsJs = require("./constants.js");
const GWEI_TO_WEI = BigInt(1000000000);
function formatBigDecimal(numerator, denominator, maxDecimalFactor) {
    if (denominator === (0, _constantsJs.BIGINT_0)) denominator = (0, _constantsJs.BIGINT_1);
    const full = numerator / denominator;
    const fraction = (numerator - full * denominator) * maxDecimalFactor / denominator;
    // zeros to be added post decimal are number of zeros in maxDecimalFactor - number of digits in fraction
    const zerosPostDecimal = String(maxDecimalFactor).length - 1 - String(fraction).length;
    return `${full}.${"0".repeat(zerosPostDecimal)}${fraction}`;
}

},{"./constants.js":"faU8a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iTSF3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Account", ()=>Account);
parcelHelpers.export(exports, "isValidAddress", ()=>isValidAddress);
parcelHelpers.export(exports, "toChecksumAddress", ()=>toChecksumAddress);
parcelHelpers.export(exports, "isValidChecksumAddress", ()=>isValidChecksumAddress);
parcelHelpers.export(exports, "generateAddress", ()=>generateAddress);
parcelHelpers.export(exports, "generateAddress2", ()=>generateAddress2);
parcelHelpers.export(exports, "isValidPrivate", ()=>isValidPrivate);
parcelHelpers.export(exports, "isValidPublic", ()=>isValidPublic);
parcelHelpers.export(exports, "pubToAddress", ()=>pubToAddress);
parcelHelpers.export(exports, "publicToAddress", ()=>publicToAddress);
parcelHelpers.export(exports, "privateToPublic", ()=>privateToPublic);
parcelHelpers.export(exports, "privateToAddress", ()=>privateToAddress);
parcelHelpers.export(exports, "importPublic", ()=>importPublic);
parcelHelpers.export(exports, "zeroAddress", ()=>zeroAddress);
parcelHelpers.export(exports, "isZeroAddress", ()=>isZeroAddress);
parcelHelpers.export(exports, "accountBodyFromSlim", ()=>accountBodyFromSlim);
parcelHelpers.export(exports, "accountBodyToSlim", ()=>accountBodyToSlim);
/**
 * Converts a slim account (per snap protocol spec) to the RLP encoded version of the account
 * @param body Array of 4 Uint8Array-like items to represent the account
 * @returns RLP encoded version of the account
 */ parcelHelpers.export(exports, "accountBodyToRLP", ()=>accountBodyToRLP);
var _rlp = require("@ethereumjs/rlp");
var _keccakJs = require("ethereum-cryptography/keccak.js");
var _secp256K1Js = require("ethereum-cryptography/secp256k1.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
var _helpersJs = require("./helpers.js");
var _internalJs = require("./internal.js");
class Account {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ constructor(nonce = (0, _constantsJs.BIGINT_0), balance = (0, _constantsJs.BIGINT_0), storageRoot = (0, _constantsJs.KECCAK256_RLP), codeHash = (0, _constantsJs.KECCAK256_NULL)){
        this.nonce = nonce;
        this.balance = balance;
        this.storageRoot = storageRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    static fromAccountData(accountData) {
        const { nonce, balance, storageRoot, codeHash } = accountData;
        return new Account(nonce !== undefined ? (0, _bytesJs.bytesToBigInt)((0, _bytesJs.toBytes)(nonce)) : undefined, balance !== undefined ? (0, _bytesJs.bytesToBigInt)((0, _bytesJs.toBytes)(balance)) : undefined, storageRoot !== undefined ? (0, _bytesJs.toBytes)(storageRoot) : undefined, codeHash !== undefined ? (0, _bytesJs.toBytes)(codeHash) : undefined);
    }
    static fromRlpSerializedAccount(serialized) {
        const values = (0, _rlp.RLP).decode(serialized);
        if (!Array.isArray(values)) throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(values);
    }
    static fromValuesArray(values) {
        const [nonce, balance, storageRoot, codeHash] = values;
        return new Account((0, _bytesJs.bytesToBigInt)(nonce), (0, _bytesJs.bytesToBigInt)(balance), storageRoot, codeHash);
    }
    _validate() {
        if (this.nonce < (0, _constantsJs.BIGINT_0)) throw new Error("nonce must be greater than zero");
        if (this.balance < (0, _constantsJs.BIGINT_0)) throw new Error("balance must be greater than zero");
        if (this.storageRoot.length !== 32) throw new Error("storageRoot must have a length of 32");
        if (this.codeHash.length !== 32) throw new Error("codeHash must have a length of 32");
    }
    /**
     * Returns an array of Uint8Arrays of the raw bytes for the account, in order.
     */ raw() {
        return [
            (0, _bytesJs.bigIntToUnpaddedBytes)(this.nonce),
            (0, _bytesJs.bigIntToUnpaddedBytes)(this.balance),
            this.storageRoot,
            this.codeHash
        ];
    }
    /**
     * Returns the RLP serialization of the account as a `Uint8Array`.
     */ serialize() {
        return (0, _rlp.RLP).encode(this.raw());
    }
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ isContract() {
        return !(0, _bytesJs.equalsBytes)(this.codeHash, (0, _constantsJs.KECCAK256_NULL));
    }
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ isEmpty() {
        return this.balance === (0, _constantsJs.BIGINT_0) && this.nonce === (0, _constantsJs.BIGINT_0) && (0, _bytesJs.equalsBytes)(this.codeHash, (0, _constantsJs.KECCAK256_NULL));
    }
}
const isValidAddress = function(hexAddress) {
    try {
        (0, _helpersJs.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
const toChecksumAddress = function(hexAddress, eip1191ChainId) {
    (0, _helpersJs.assertIsHexString)(hexAddress);
    const address = (0, _internalJs.stripHexPrefix)(hexAddress).toLowerCase();
    let prefix = "";
    if (eip1191ChainId !== undefined) {
        const chainId = (0, _bytesJs.bytesToBigInt)((0, _bytesJs.toBytes)(eip1191ChainId));
        prefix = chainId.toString() + "0x";
    }
    const bytes = (0, _bytesJs.utf8ToBytes)(prefix + address);
    const hash = (0, _bytesJs.bytesToHex)((0, _keccakJs.keccak256)(bytes)).slice(2);
    let ret = "0x";
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
const isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return isValidAddress(hexAddress) && toChecksumAddress(hexAddress, eip1191ChainId) === hexAddress;
};
const generateAddress = function(from, nonce) {
    (0, _helpersJs.assertIsBytes)(from);
    (0, _helpersJs.assertIsBytes)(nonce);
    if ((0, _bytesJs.bytesToBigInt)(nonce) === (0, _constantsJs.BIGINT_0)) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return (0, _keccakJs.keccak256)((0, _rlp.RLP).encode([
        from,
        Uint8Array.from([])
    ])).subarray(-20);
    // Only take the lower 160bits of the hash
    return (0, _keccakJs.keccak256)((0, _rlp.RLP).encode([
        from,
        nonce
    ])).subarray(-20);
};
const generateAddress2 = function(from, salt, initCode) {
    (0, _helpersJs.assertIsBytes)(from);
    (0, _helpersJs.assertIsBytes)(salt);
    (0, _helpersJs.assertIsBytes)(initCode);
    if (from.length !== 20) throw new Error("Expected from to be of length 20");
    if (salt.length !== 32) throw new Error("Expected salt to be of length 32");
    const address = (0, _keccakJs.keccak256)((0, _bytesJs.concatBytes)((0, _bytesJs.hexToBytes)("0xff"), from, salt, (0, _keccakJs.keccak256)(initCode)));
    return address.subarray(-20);
};
const isValidPrivate = function(privateKey) {
    return (0, _secp256K1Js.secp256k1).utils.isValidPrivateKey(privateKey);
};
const isValidPublic = function(publicKey, sanitize = false) {
    (0, _helpersJs.assertIsBytes)(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    // Automatically checks whether point is on curve
    try {
        (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex((0, _bytesJs.concatBytes)(Uint8Array.from([
            4
        ]), publicKey));
        return true;
    } catch (e) {
        return false;
    }
    if (!sanitize) return false;
    try {
        (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex(publicKey);
        return true;
    } catch (e) {
        return false;
    }
};
const pubToAddress = function(pubKey, sanitize = false) {
    (0, _helpersJs.assertIsBytes)(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex(pubKey).toRawBytes(false).slice(1);
    if (pubKey.length !== 64) throw new Error("Expected pubKey to be of length 64");
    // Only take the lower 160bits of the hash
    return (0, _keccakJs.keccak256)(pubKey).subarray(-20);
};
const publicToAddress = pubToAddress;
const privateToPublic = function(privateKey) {
    (0, _helpersJs.assertIsBytes)(privateKey);
    // skip the type flag and use the X, Y points
    return (0, _secp256K1Js.secp256k1).ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(false).slice(1);
};
const privateToAddress = function(privateKey) {
    return publicToAddress(privateToPublic(privateKey));
};
const importPublic = function(publicKey) {
    (0, _helpersJs.assertIsBytes)(publicKey);
    if (publicKey.length !== 64) publicKey = (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex(publicKey).toRawBytes(false).slice(1);
    return publicKey;
};
const zeroAddress = function() {
    const addressLength = 20;
    const addr = (0, _bytesJs.zeros)(addressLength);
    return (0, _bytesJs.bytesToHex)(addr);
};
const isZeroAddress = function(hexAddress) {
    try {
        (0, _helpersJs.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    const zeroAddr = zeroAddress();
    return zeroAddr === hexAddress;
};
function accountBodyFromSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        storageRoot.length === 0 ? (0, _constantsJs.KECCAK256_RLP) : storageRoot,
        codeHash.length === 0 ? (0, _constantsJs.KECCAK256_NULL) : codeHash
    ];
}
const emptyUint8Arr = new Uint8Array(0);
function accountBodyToSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        (0, _bytesJs.equalsBytes)(storageRoot, (0, _constantsJs.KECCAK256_RLP)) ? emptyUint8Arr : storageRoot,
        (0, _bytesJs.equalsBytes)(codeHash, (0, _constantsJs.KECCAK256_NULL)) ? emptyUint8Arr : codeHash
    ];
}
function accountBodyToRLP(body, couldBeSlim = true) {
    const accountBody = couldBeSlim ? accountBodyFromSlim(body) : body;
    return (0, _rlp.RLP).encode(accountBody);
}

},{"@ethereumjs/rlp":"dtdEx","ethereum-cryptography/keccak.js":"4rF3n","ethereum-cryptography/secp256k1.js":"20vH6","./bytes.js":"iJ2b1","./constants.js":"faU8a","./helpers.js":"illO1","./internal.js":"7QqfV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dtdEx":[function(require,module,exports) {
/**
 * RLP Encoding based on https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "utils", ()=>utils);
parcelHelpers.export(exports, "RLP", ()=>RLP);
function encode(input) {
    if (Array.isArray(input)) {
        const output = [];
        let outputLength = 0;
        for(let i = 0; i < input.length; i++){
            const encoded = encode(input[i]);
            output.push(encoded);
            outputLength += encoded.length;
        }
        return concatBytes(encodeLength(outputLength, 192), ...output);
    }
    const inputBuf = toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return concatBytes(encodeLength(inputBuf.length, 128), inputBuf);
}
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function safeSlice(input, start, end) {
    if (end > input.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function decodeLength(v) {
    if (v[0] === 0) throw new Error("invalid RLP: extra zeros");
    return parseHexByte(bytesToHex(v));
}
function encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = numberToHex(offset + 55 + lLength);
    return Uint8Array.from(hexToBytes(firstByte + hexLength));
}
function decode(input, stream = false) {
    if (typeof input === "undefined" || input === null || input.length === 0) return Uint8Array.from([]);
    const inputBytes = toBytes(input);
    const decoded = _decode(inputBytes);
    if (stream) return {
        data: decoded.data,
        remainder: decoded.remainder.slice()
    };
    if (decoded.remainder.length !== 0) throw new Error("invalid RLP: remainder must be zero");
    return decoded.data;
}
/** Decode an input with RLP */ function _decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.subarray(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
        return {
            data,
            remainder: input.subarray(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = decodeLength(safeSlice(input, 1, llength));
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = safeSlice(input, llength, length + llength);
        return {
            data,
            remainder: input.subarray(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = decodeLength(safeSlice(input, 1, llength));
        if (length < 56) throw new Error("invalid RLP: encoded list too short");
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid RLP: total length is larger than the data");
        innerRemainder = safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(totalLength)
        };
    }
}
const cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += cachedHexes[uint8a[i]];
    return hex;
}
function parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
    return byte;
}
// Caching slows it down 2-3x
function hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function numberToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function isHexPrefixed(str) {
    return str.length >= 2 && str[0] === "0" && str[1] === "x";
}
/** Removes 0x from a given String */ function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === "string") {
        if (isHexPrefixed(v)) return hexToBytes(padToEven(stripHexPrefix(v)));
        return utf8ToBytes(v);
    }
    if (typeof v === "number" || typeof v === "bigint") {
        if (!v) return Uint8Array.from([]);
        return hexToBytes(numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof v);
}
const utils = {
    bytesToHex,
    concatBytes,
    hexToBytes,
    utf8ToBytes
};
const RLP = {
    encode,
    decode
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4rF3n":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keccak512 = exports.keccak384 = exports.keccak256 = exports.keccak224 = void 0;
const sha3_1 = require("b47d5011a60c54b9");
const utils_js_1 = require("e9e893cd9eb08f36");
exports.keccak224 = (0, utils_js_1.wrapHash)(sha3_1.keccak_224);
exports.keccak256 = (()=>{
    const k = (0, utils_js_1.wrapHash)(sha3_1.keccak_256);
    k.create = sha3_1.keccak_256.create;
    return k;
})();
exports.keccak384 = (0, utils_js_1.wrapHash)(sha3_1.keccak_384);
exports.keccak512 = (0, utils_js_1.wrapHash)(sha3_1.keccak_512);

},{"b47d5011a60c54b9":"lAWq8","e9e893cd9eb08f36":"fK9OA"}],"lAWq8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = exports.keccakP = void 0;
const _assert_js_1 = require("14db7b8ea2b5bceb");
const _u64_js_1 = require("45e8a44e40fd6b7f");
const utils_js_1 = require("5a04751f3e786b49");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [
    [],
    [],
    []
];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
class Keccak extends utils_js_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, _assert_js_1.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_js_1.u32)(this.state);
    }
    keccak() {
        keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { blockLen, state } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, _assert_js_1.exists)(this, false);
        (0, _assert_js_1.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, _assert_js_1.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, _assert_js_1.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapConstructor)(()=>new Keccak(blockLen, suffix, outputLen));
exports.sha3_224 = gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ exports.sha3_256 = gen(0x06, 136, 32);
exports.sha3_384 = gen(0x06, 104, 48);
exports.sha3_512 = gen(0x06, 72, 64);
exports.keccak_224 = gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ exports.keccak_256 = gen(0x01, 136, 32);
exports.keccak_384 = gen(0x01, 104, 48);
exports.keccak_512 = gen(0x01, 72, 64);
const genShake = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
exports.shake128 = genShake(0x1f, 168, 16);
exports.shake256 = genShake(0x1f, 136, 32);

},{"14db7b8ea2b5bceb":"hlTZH","45e8a44e40fd6b7f":"iSvPJ","5a04751f3e786b49":"lHXRP"}],"iSvPJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add5L = exports.add5H = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
exports.fromBig = fromBig;
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
exports.split = split;
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
exports.add = add;
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"5d9Pa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handling and generating Ethereum addresses
 */ parcelHelpers.export(exports, "Address", ()=>Address);
var _accountJs = require("./account.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
class Address {
    constructor(bytes){
        if (bytes.length !== 20) throw new Error("Invalid address length");
        this.bytes = bytes;
    }
    /**
     * Returns the zero address.
     */ static zero() {
        return new Address((0, _bytesJs.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ static fromString(str) {
        if (!(0, _accountJs.isValidAddress)(str)) throw new Error("Invalid address");
        return new Address((0, _bytesJs.toBytes)(str));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ static fromPublicKey(pubKey) {
        if (!(pubKey instanceof Uint8Array)) throw new Error("Public key should be Uint8Array");
        const bytes = (0, _accountJs.pubToAddress)(pubKey);
        return new Address(bytes);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ static fromPrivateKey(privateKey) {
        if (!(privateKey instanceof Uint8Array)) throw new Error("Private key should be Uint8Array");
        const bytes = (0, _accountJs.privateToAddress)(privateKey);
        return new Address(bytes);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ static generate(from, nonce) {
        if (typeof nonce !== "bigint") throw new Error("Expected nonce to be a bigint");
        return new Address((0, _accountJs.generateAddress)(from.bytes, (0, _bytesJs.bigIntToBytes)(nonce)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ static generate2(from, salt, initCode) {
        if (!(salt instanceof Uint8Array)) throw new Error("Expected salt to be a Uint8Array");
        if (!(initCode instanceof Uint8Array)) throw new Error("Expected initCode to be a Uint8Array");
        return new Address((0, _accountJs.generateAddress2)(from.bytes, salt, initCode));
    }
    /**
     * Is address equal to another.
     */ equals(address) {
        return (0, _bytesJs.equalsBytes)(this.bytes, address.bytes);
    }
    /**
     * Is address zero.
     */ isZero() {
        return this.equals(Address.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ isPrecompileOrSystemAddress() {
        const address = (0, _bytesJs.bytesToBigInt)(this.bytes);
        const rangeMin = (0, _constantsJs.BIGINT_0);
        const rangeMax = BigInt("0xffff");
        return address >= rangeMin && address <= rangeMax;
    }
    /**
     * Returns hex encoding of address.
     */ toString() {
        return (0, _bytesJs.bytesToHex)(this.bytes);
    }
    /**
     * Returns a new Uint8Array representation of address.
     */ toBytes() {
        return new Uint8Array(this.bytes);
    }
}

},{"./account.js":"iTSF3","./bytes.js":"iJ2b1","./constants.js":"faU8a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"45bFW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyEncoding", ()=>KeyEncoding);
parcelHelpers.export(exports, "ValueEncoding", ()=>ValueEncoding);
var KeyEncoding;
(function(KeyEncoding) {
    KeyEncoding["String"] = "string";
    KeyEncoding["Bytes"] = "view";
    KeyEncoding["Number"] = "number";
})(KeyEncoding || (KeyEncoding = {}));
var ValueEncoding;
(function(ValueEncoding) {
    ValueEncoding["String"] = "string";
    ValueEncoding["Bytes"] = "view";
    ValueEncoding["JSON"] = "json";
})(ValueEncoding || (ValueEncoding = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eGSbM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Representation of EIP-4895 withdrawal data
 */ parcelHelpers.export(exports, "Withdrawal", ()=>Withdrawal);
var _addressJs = require("./address.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
var _typesJs = require("./types.js");
class Withdrawal {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */ constructor(index, validatorIndex, address, /**
     * withdrawal amount in Gwei to match the CL repesentation and eventually ssz withdrawalsRoot
     */ amount){
        this.index = index;
        this.validatorIndex = validatorIndex;
        this.address = address;
        this.amount = amount;
    }
    static fromWithdrawalData(withdrawalData) {
        const { index: indexData, validatorIndex: validatorIndexData, address: addressData, amount: amountData } = withdrawalData;
        const index = (0, _typesJs.toType)(indexData, (0, _typesJs.TypeOutput).BigInt);
        const validatorIndex = (0, _typesJs.toType)(validatorIndexData, (0, _typesJs.TypeOutput).BigInt);
        const address = addressData instanceof (0, _addressJs.Address) ? addressData : new (0, _addressJs.Address)((0, _bytesJs.toBytes)(addressData));
        const amount = (0, _typesJs.toType)(amountData, (0, _typesJs.TypeOutput).BigInt);
        return new Withdrawal(index, validatorIndex, address, amount);
    }
    static fromValuesArray(withdrawalArray) {
        if (withdrawalArray.length !== 4) throw Error(`Invalid withdrawalArray length expected=4 actual=${withdrawalArray.length}`);
        const [index, validatorIndex, address, amount] = withdrawalArray;
        return Withdrawal.fromWithdrawalData({
            index,
            validatorIndex,
            address,
            amount
        });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */ static toBytesArray(withdrawal) {
        const { index, validatorIndex, address, amount } = withdrawal;
        const indexBytes = (0, _typesJs.toType)(index, (0, _typesJs.TypeOutput).BigInt) === (0, _constantsJs.BIGINT_0) ? new Uint8Array() : (0, _typesJs.toType)(index, (0, _typesJs.TypeOutput).Uint8Array);
        const validatorIndexBytes = (0, _typesJs.toType)(validatorIndex, (0, _typesJs.TypeOutput).BigInt) === (0, _constantsJs.BIGINT_0) ? new Uint8Array() : (0, _typesJs.toType)(validatorIndex, (0, _typesJs.TypeOutput).Uint8Array);
        const addressBytes = address instanceof (0, _addressJs.Address) ? address.bytes : (0, _typesJs.toType)(address, (0, _typesJs.TypeOutput).Uint8Array);
        const amountBytes = (0, _typesJs.toType)(amount, (0, _typesJs.TypeOutput).BigInt) === (0, _constantsJs.BIGINT_0) ? new Uint8Array() : (0, _typesJs.toType)(amount, (0, _typesJs.TypeOutput).Uint8Array);
        return [
            indexBytes,
            validatorIndexBytes,
            addressBytes,
            amountBytes
        ];
    }
    raw() {
        return Withdrawal.toBytesArray(this);
    }
    toValue() {
        return {
            index: this.index,
            validatorIndex: this.validatorIndex,
            address: this.address.bytes,
            amount: this.amount
        };
    }
    toJSON() {
        return {
            index: (0, _bytesJs.bigIntToHex)(this.index),
            validatorIndex: (0, _bytesJs.bigIntToHex)(this.validatorIndex),
            address: (0, _bytesJs.bytesToHex)(this.address.bytes),
            amount: (0, _bytesJs.bigIntToHex)(this.amount)
        };
    }
}

},{"./address.js":"5d9Pa","./bytes.js":"iJ2b1","./constants.js":"faU8a","./types.js":"95Lhp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"95Lhp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeOutput", ()=>TypeOutput);
parcelHelpers.export(exports, "toType", ()=>toType);
var _bytesJs = require("./bytes.js");
var _internalJs = require("./internal.js");
var TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BigInt"] = 1] = "BigInt";
    TypeOutput[TypeOutput["Uint8Array"] = 2] = "Uint8Array";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})(TypeOutput || (TypeOutput = {}));
function toType(input, outputType) {
    if (input === null) return null;
    if (input === undefined) return undefined;
    if (typeof input === "string" && !(0, _internalJs.isHexString)(input)) throw new Error(`A string must be provided with a 0x-prefix, given: ${input}`);
    else if (typeof input === "number" && !Number.isSafeInteger(input)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    const output = (0, _bytesJs.toBytes)(input);
    switch(outputType){
        case TypeOutput.Uint8Array:
            return output;
        case TypeOutput.BigInt:
            return (0, _bytesJs.bytesToBigInt)(output);
        case TypeOutput.Number:
            {
                const bigInt = (0, _bytesJs.bytesToBigInt)(output);
                if (bigInt > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                return Number(bigInt);
            }
        case TypeOutput.PrefixedHexString:
            return (0, _bytesJs.bytesToHex)(output);
        default:
            throw new Error("unknown outputType");
    }
}

},{"./bytes.js":"iJ2b1","./internal.js":"7QqfV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dW2y2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the ECDSA signature of a message hash.
 *
 * If `chainId` is provided assume an EIP-155-style signature and calculate the `v` value
 * accordingly, otherwise return a "static" `v` just derived from the `recovery` bit
 */ parcelHelpers.export(exports, "ecsign", ()=>ecsign);
parcelHelpers.export(exports, "calculateSigRecovery", ()=>calculateSigRecovery);
parcelHelpers.export(exports, "ecrecover", ()=>ecrecover);
parcelHelpers.export(exports, "toRpcSig", ()=>toRpcSig);
parcelHelpers.export(exports, "toCompactSig", ()=>toCompactSig);
parcelHelpers.export(exports, "fromRpcSig", ()=>fromRpcSig);
parcelHelpers.export(exports, "isValidSignature", ()=>isValidSignature);
parcelHelpers.export(exports, "hashPersonalMessage", ()=>hashPersonalMessage);
var _keccakJs = require("ethereum-cryptography/keccak.js");
var _secp256K1Js = require("ethereum-cryptography/secp256k1.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
var _helpersJs = require("./helpers.js");
function ecsign(msgHash, privateKey, chainId) {
    const sig = (0, _secp256K1Js.secp256k1).sign(msgHash, privateKey);
    const buf = sig.toCompactRawBytes();
    const r = buf.slice(0, 32);
    const s = buf.slice(32, 64);
    const v = chainId === undefined ? BigInt(sig.recovery + 27) : BigInt(sig.recovery + 35) + BigInt(chainId) * (0, _constantsJs.BIGINT_2);
    return {
        r,
        s,
        v
    };
}
function calculateSigRecovery(v, chainId) {
    if (v === (0, _constantsJs.BIGINT_0) || v === (0, _constantsJs.BIGINT_1)) return v;
    if (chainId === undefined) return v - (0, _constantsJs.BIGINT_27);
    return v - (chainId * (0, _constantsJs.BIGINT_2) + BigInt(35));
}
function isValidSigRecovery(recovery) {
    return recovery === (0, _constantsJs.BIGINT_0) || recovery === (0, _constantsJs.BIGINT_1);
}
const ecrecover = function(msgHash, v, r, s, chainId) {
    const signature = (0, _bytesJs.concatBytes)((0, _bytesJs.setLengthLeft)(r, 32), (0, _bytesJs.setLengthLeft)(s, 32));
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    const sig = (0, _secp256K1Js.secp256k1).Signature.fromCompact(signature).addRecoveryBit(Number(recovery));
    const senderPubKey = sig.recoverPublicKey(msgHash);
    return senderPubKey.toRawBytes(false).slice(1);
};
const toRpcSig = function(v, r, s, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return (0, _bytesJs.bytesToHex)((0, _bytesJs.concatBytes)((0, _bytesJs.setLengthLeft)(r, 32), (0, _bytesJs.setLengthLeft)(s, 32), (0, _bytesJs.toBytes)(v)));
};
const toCompactSig = function(v, r, s, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    const ss = Uint8Array.from([
        ...s
    ]);
    if (v > BigInt(28) && v % (0, _constantsJs.BIGINT_2) === (0, _constantsJs.BIGINT_1) || v === (0, _constantsJs.BIGINT_1) || v === BigInt(28)) ss[0] |= 0x80;
    return (0, _bytesJs.bytesToHex)((0, _bytesJs.concatBytes)((0, _bytesJs.setLengthLeft)(r, 32), (0, _bytesJs.setLengthLeft)(ss, 32)));
};
const fromRpcSig = function(sig) {
    const bytes = (0, _bytesJs.toBytes)(sig);
    let r;
    let s;
    let v;
    if (bytes.length >= 65) {
        r = bytes.subarray(0, 32);
        s = bytes.subarray(32, 64);
        v = (0, _bytesJs.bytesToBigInt)(bytes.subarray(64));
    } else if (bytes.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = bytes.subarray(0, 32);
        s = bytes.subarray(32, 64);
        v = BigInt((0, _bytesJs.bytesToInt)(bytes.subarray(32, 33)) >> 7);
        s[0] &= 0x7f;
    } else throw new Error("Invalid signature length");
    // support both versions of `eth_sign` responses
    if (v < 27) v = v + (0, _constantsJs.BIGINT_27);
    return {
        v,
        r,
        s
    };
};
const isValidSignature = function(v, r, s, homesteadOrLater = true, chainId) {
    if (r.length !== 32 || s.length !== 32) return false;
    if (!isValidSigRecovery(calculateSigRecovery(v, chainId))) return false;
    const rBigInt = (0, _bytesJs.bytesToBigInt)(r);
    const sBigInt = (0, _bytesJs.bytesToBigInt)(s);
    if (rBigInt === (0, _constantsJs.BIGINT_0) || rBigInt >= (0, _constantsJs.SECP256K1_ORDER) || sBigInt === (0, _constantsJs.BIGINT_0) || sBigInt >= (0, _constantsJs.SECP256K1_ORDER)) return false;
    if (homesteadOrLater && sBigInt >= (0, _constantsJs.SECP256K1_ORDER_DIV_2)) return false;
    return true;
};
const hashPersonalMessage = function(message) {
    (0, _helpersJs.assertIsBytes)(message);
    const prefix = (0, _bytesJs.utf8ToBytes)(`\u0019Ethereum Signed Message:\n${message.length}`);
    return (0, _keccakJs.keccak256)((0, _bytesJs.concatBytes)(prefix, message));
};

},{"ethereum-cryptography/keccak.js":"4rF3n","ethereum-cryptography/secp256k1.js":"20vH6","./bytes.js":"iJ2b1","./constants.js":"faU8a","./helpers.js":"illO1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"70SHU":[function(require,module,exports) {
/**
 * Ported to Typescript from original implementation below:
 * https://github.com/ahultgren/async-eventemitter -- MIT licensed
 *
 * Type Definitions based on work by: patarapolw <https://github.com/patarapolw> -- MIT licensed
 * that was contributed to Definitely Typed below:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/async-eventemitter
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncEventEmitter", ()=>AsyncEventEmitter);
var _events = require("events");
async function runInSeries(context, tasks, data) {
    let error;
    for await (const task of tasks)try {
        if (task.length < 2) //sync
        task.call(context, data);
        else await new Promise((resolve, reject)=>{
            task.call(context, data, (error)=>{
                if (error) reject(error);
                else resolve();
            });
        });
    } catch (e) {
        error = e;
    }
    if (error) throw error;
}
class AsyncEventEmitter extends (0, _events.EventEmitter) {
    emit(event, ...args) {
        let [data, callback] = args;
        const self = this;
        let listeners = self._events[event] ?? [];
        // Optional data argument
        if (callback === undefined && typeof data === "function") {
            callback = data;
            data = undefined;
        }
        // Special treatment of internal newListener and removeListener events
        if (event === "newListener" || event === "removeListener") {
            data = {
                event: data,
                fn: callback
            };
            callback = undefined;
        }
        // A single listener is just a function not an array...
        listeners = Array.isArray(listeners) ? listeners : [
            listeners
        ];
        runInSeries(self, listeners.slice(), data).then(callback).catch(callback);
        return self.listenerCount(event) > 0;
    }
    once(event, listener) {
        const self = this;
        let g;
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        // Hack to support set arity
        if (listener.length >= 2) g = function(e, next) {
            self.removeListener(event, g);
            listener(e, next);
        };
        else g = function(e) {
            self.removeListener(event, g);
            listener(e, g);
        };
        self.on(event, g);
        return self;
    }
    first(event, listener) {
        let listeners = this._events[event] ?? [];
        // Contract
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        listeners.unshift(listener);
        return this;
    }
    before(event, target, listener) {
        return this.beforeOrAfter(event, target, listener);
    }
    after(event, target, listener) {
        return this.beforeOrAfter(event, target, listener, "after");
    }
    beforeOrAfter(event, target, listener, beforeOrAfter) {
        let listeners = this._events[event] ?? [];
        let i;
        let index;
        const add = beforeOrAfter === "after" ? 1 : 0;
        // Contract
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        if (typeof target !== "function") throw new TypeError("target must be a function");
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        index = listeners.length;
        for(i = listeners.length; i--;)if (listeners[i] === target) {
            index = i + add;
            break;
        }
        listeners.splice(index, 0, listener);
        return this;
    }
    on(event, listener) {
        return super.on(event, listener);
    }
    addListener(event, listener) {
        return super.addListener(event, listener);
    }
    prependListener(event, listener) {
        return super.prependListener(event, listener);
    }
    prependOnceListener(event, listener) {
        return super.prependOnceListener(event, listener);
    }
    removeAllListeners(event) {
        return super.removeAllListeners(event);
    }
    removeListener(event, listener) {
        return super.removeListener(event, listener);
    }
    eventNames() {
        return super.eventNames();
    }
    listeners(event) {
        return super.listeners(event);
    }
    listenerCount(event) {
        return super.listenerCount(event);
    }
    getMaxListeners() {
        return super.getMaxListeners();
    }
    setMaxListeners(maxListeners) {
        return super.setMaxListeners(maxListeners);
    }
}

},{"events":"e5CcG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e5CcG":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"fjf4u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBlobs", ()=>getBlobs);
parcelHelpers.export(exports, "blobsToCommitments", ()=>blobsToCommitments);
parcelHelpers.export(exports, "blobsToProofs", ()=>blobsToProofs);
parcelHelpers.export(exports, "computeVersionedHash", ()=>computeVersionedHash);
parcelHelpers.export(exports, "commitmentsToVersionedHashes", ()=>commitmentsToVersionedHashes);
var _sha256Js = require("ethereum-cryptography/sha256.js");
var _bytesJs = require("./bytes.js");
/**
 * These utilities for constructing blobs are borrowed from https://github.com/Inphi/eip4844-interop.git
 */ const BYTES_PER_FIELD_ELEMENT = 32;
const FIELD_ELEMENTS_PER_BLOB = 4096;
const USEFUL_BYTES_PER_BLOB = 32 * FIELD_ELEMENTS_PER_BLOB;
const MAX_BLOBS_PER_TX = 2;
const MAX_USEFUL_BYTES_PER_TX = USEFUL_BYTES_PER_BLOB * MAX_BLOBS_PER_TX - 1;
const BLOB_SIZE = BYTES_PER_FIELD_ELEMENT * FIELD_ELEMENTS_PER_BLOB;
function get_padded(data, blobs_len) {
    const pdata = new Uint8Array(blobs_len * USEFUL_BYTES_PER_BLOB).fill(0);
    pdata.set(data);
    pdata[data.byteLength] = 0x80;
    return pdata;
}
function get_blob(data) {
    const blob = new Uint8Array(BLOB_SIZE);
    for(let i = 0; i < FIELD_ELEMENTS_PER_BLOB; i++){
        const chunk = new Uint8Array(32);
        chunk.set(data.subarray(i * 31, (i + 1) * 31), 0);
        blob.set(chunk, i * 32);
    }
    return blob;
}
const getBlobs = (input)=>{
    const data = (0, _bytesJs.utf8ToBytes)(input);
    const len = data.byteLength;
    if (len === 0) throw Error("invalid blob data");
    if (len > MAX_USEFUL_BYTES_PER_TX) throw Error("blob data is too large");
    const blobs_len = Math.ceil(len / USEFUL_BYTES_PER_BLOB);
    const pdata = get_padded(data, blobs_len);
    const blobs = [];
    for(let i = 0; i < blobs_len; i++){
        const chunk = pdata.subarray(i * USEFUL_BYTES_PER_BLOB, (i + 1) * USEFUL_BYTES_PER_BLOB);
        const blob = get_blob(chunk);
        blobs.push(blob);
    }
    return blobs;
};
const blobsToCommitments = (kzg, blobs)=>{
    const commitments = [];
    for (const blob of blobs)commitments.push(kzg.blobToKzgCommitment(blob));
    return commitments;
};
const blobsToProofs = (kzg, blobs, commitments)=>{
    const proofs = blobs.map((blob, ctx)=>kzg.computeBlobKzgProof(blob, commitments[ctx]));
    return proofs;
};
const computeVersionedHash = (commitment, blobCommitmentVersion)=>{
    const computedVersionedHash = new Uint8Array(32);
    computedVersionedHash.set([
        blobCommitmentVersion
    ], 0);
    computedVersionedHash.set((0, _sha256Js.sha256)(commitment).subarray(1), 1);
    return computedVersionedHash;
};
const commitmentsToVersionedHashes = (commitments)=>{
    const hashes = [];
    for (const commitment of commitments)hashes.push(computeVersionedHash(commitment, 0x01));
    return hashes;
};

},{"ethereum-cryptography/sha256.js":"lVGC2","./bytes.js":"iJ2b1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lVGC2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha256 = void 0;
const sha256_1 = require("7ce5164216c73417");
const utils_js_1 = require("f8a15c9f2976d5e3");
exports.sha256 = (0, utils_js_1.wrapHash)(sha256_1.sha256);

},{"7ce5164216c73417":"1a1TJ","f8a15c9f2976d5e3":"fK9OA"}],"lLGxW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parses the geth genesis state into Blockchain {@link GenesisState}
 * @param json representing the `alloc` key in a Geth genesis file
 */ parcelHelpers.export(exports, "parseGethGenesisState", ()=>parseGethGenesisState);
var _bytesJs = require("./bytes.js");
var _internalJs = require("./internal.js");
function parseGethGenesisState(json) {
    const state = {};
    for (let address of Object.keys(json.alloc)){
        let { balance, code, storage, nonce } = json.alloc[address];
        // create a map with lowercase for easy lookups
        address = (0, _bytesJs.addHexPrefix)(address.toLowerCase());
        balance = (0, _internalJs.isHexPrefixed)(balance) ? balance : (0, _bytesJs.bigIntToHex)(BigInt(balance));
        code = code !== undefined ? (0, _bytesJs.addHexPrefix)(code) : undefined;
        storage = storage !== undefined ? Object.entries(storage) : undefined;
        nonce = nonce !== undefined ? (0, _bytesJs.addHexPrefix)(nonce) : undefined;
        state[address] = [
            balance,
            code,
            storage,
            nonce
        ];
    }
    return state;
}

},{"./bytes.js":"iJ2b1","./internal.js":"7QqfV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7jqQa":[function(require,module,exports) {
/**
 * @deprecated This initialization method is deprecated since trusted setup loading is done directly in the reference KZG library
 * initialization or should othewise be assured independently before KZG libary usage.
 *
 * @param kzgLib a KZG implementation (defaults to c-kzg)
 * @param a dictionary of trusted setup options
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initKZG", ()=>initKZG);
function initKZG(kzg, _trustedSetupPath) {
    kzg.loadTrustedSetup();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lDA8q":[function(require,module,exports) {
// Based on https://github.com/jsoendermann/semaphore-async-await/blob/master/src/Semaphore.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lock", ()=>Lock);
class Lock {
    constructor(){
        this.permits = 1;
        this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */ async acquire() {
        if (this.permits > 0) {
            this.permits -= 1;
            return Promise.resolve(true);
        }
        // If there is no permit available, we return a promise that resolves once the semaphore gets
        // signaled enough times that permits is equal to one.
        return new Promise((resolver)=>this.promiseResolverQueue.push(resolver));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */ release() {
        this.permits += 1;
        if (this.permits > 1 && this.promiseResolverQueue.length > 0) // eslint-disable-next-line no-console
        console.warn("Lock.permits should never be > 0 when there is someone waiting.");
        else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
            // If there is someone else waiting, immediately consume the permit that was released
            // at the beginning of this function and let the waiting function resume.
            this.permits -= 1;
            const nextResolver = this.promiseResolverQueue.shift();
            if (nextResolver) nextResolver(true);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"87ACg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapDB", ()=>MapDB);
var _bytesJs = require("./bytes.js");
class MapDB {
    constructor(database){
        this._database = database ?? new Map();
    }
    async get(key) {
        const dbKey = key instanceof Uint8Array ? (0, _bytesJs.bytesToUnprefixedHex)(key) : key.toString();
        return this._database.get(dbKey);
    }
    async put(key, val) {
        const dbKey = key instanceof Uint8Array ? (0, _bytesJs.bytesToUnprefixedHex)(key) : key.toString();
        this._database.set(dbKey, val);
    }
    async del(key) {
        const dbKey = key instanceof Uint8Array ? (0, _bytesJs.bytesToUnprefixedHex)(key) : key.toString();
        this._database.delete(dbKey);
    }
    async batch(opStack) {
        for (const op of opStack){
            if (op.type === "del") await this.del(op.key);
            if (op.type === "put") await this.put(op.key, op.value);
        }
    }
    /**
     * Note that the returned shallow copy will share the underlying database with the original
     *
     * @returns DB
     */ shallowCopy() {
        return new MapDB(this._database);
    }
    open() {
        return Promise.resolve();
    }
}

},{"./bytes.js":"iJ2b1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dq5or":[function(require,module,exports) {
/**
 * Makes a simple RPC call to a remote Ethereum JSON-RPC provider and passes through the response.
 * No parameter or response validation is done.
 *
 * @param url the URL for the JSON RPC provider
 * @param params the parameters for the JSON-RPC method - refer to
 * https://ethereum.org/en/developers/docs/apis/json-rpc/ for details on RPC methods
 * @returns the `result` field from the JSON-RPC response
 * @example
 * ```ts
 * const provider = 'https://mainnet.infura.io/v3/...'
 * const params = {
 *   method: 'eth_getBlockByNumber',
 *   params: ['latest', false],
 * }
 *  const block = await fetchFromProvider(provider, params)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchFromProvider", ()=>fetchFromProvider);
parcelHelpers.export(exports, "getProvider", ()=>getProvider);
const fetchFromProvider = async (url, params)=>{
    const data = JSON.stringify({
        method: params.method,
        params: params.params,
        jsonrpc: "2.0",
        id: 1
    });
    const res = await fetch(url, {
        headers: {
            "content-type": "application/json"
        },
        method: "POST",
        body: data
    });
    if (!res.ok) throw new Error(`JSONRpcError: ${JSON.stringify({
        method: params.method,
        status: res.status,
        message: await res.text().catch(()=>{
            return "Could not parse error message likely because of a network error";
        })
    }, null, 2)}`);
    const json = await res.json();
    // TODO we should check json.error here
    return json.result;
};
const getProvider = (provider)=>{
    if (typeof provider === "string") return provider;
    else if (typeof provider === "object" && provider._getConnection !== undefined) return provider._getConnection().url;
    else throw new Error("Must provide valid provider URL or Web3Provider");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eHuUs":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"e0M17","aceacb6a4531a9d2":"ll77X"}],"e0M17":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"ll77X":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"1ax6t":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.worker = exports.upgrade = exports.types = exports.storage = exports.staking = exports.signature = exports.scheduler = exports.runtime = exports.roothash = exports.registry = exports.quantity = exports.misc = exports.keymanager = exports.hdkey = exports.hash = exports.governance = exports.genesis = exports.control = exports.consensus = exports.common = exports.client = exports.beacon = exports.address = void 0;
exports.address = require("f5e3fa9828f078d9");
exports.beacon = require("ecee47f0159c5fd9");
exports.client = require("5a9b796f38f49317");
exports.common = require("5471bdac7cf8b668");
exports.consensus = require("b1096c40702d9df4");
exports.control = require("ae8a6fe8960c38e7");
exports.genesis = require("4e12defdd4dac402");
exports.governance = require("591199ea3acdf7f9");
exports.hash = require("9e2fa77af053f2ea");
exports.hdkey = require("68c5a435883894c5");
exports.keymanager = require("40fe56562d6cb2fd");
exports.misc = require("6fff6f682d93b146");
exports.quantity = require("39b191858b1d59f0");
exports.registry = require("942e9636542f3d85");
exports.roothash = require("3f3a34f565e7f2f1");
exports.runtime = require("9e94bdc42a9194c9");
exports.scheduler = require("43e2c1cf8c068dc6");
exports.signature = require("a6e3cb2b58bfc777");
exports.staking = require("846e0ad17dfdfc92");
exports.storage = require("238aad1ce8e0027f");
exports.types = require("aa443c570075dd71");
exports.upgrade = require("b24b4816be8bb26b");
exports.worker = require("fd5d0058a00d72");

},{"f5e3fa9828f078d9":"7SCvB","ecee47f0159c5fd9":"5QI1M","5a9b796f38f49317":"iXWTb","5471bdac7cf8b668":"dzunb","b1096c40702d9df4":"9UvMb","ae8a6fe8960c38e7":"chNDh","4e12defdd4dac402":"6l4rn","591199ea3acdf7f9":"dqeaU","9e2fa77af053f2ea":"1sr6I","68c5a435883894c5":"7po7g","40fe56562d6cb2fd":"eKbWP","6fff6f682d93b146":"agInO","39b191858b1d59f0":"5AKEy","942e9636542f3d85":"gkdQA","3f3a34f565e7f2f1":"9Gjb7","9e94bdc42a9194c9":"dkWme","43e2c1cf8c068dc6":"kvmvD","a6e3cb2b58bfc777":"3x9Lz","846e0ad17dfdfc92":"j4wDp","238aad1ce8e0027f":"9xDmt","aa443c570075dd71":"dAERu","b24b4816be8bb26b":"gg3CQ","fd5d0058a00d72":"3inc7"}],"7SCvB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromBech32 = exports.toBech32 = exports.fromData = void 0;
const bech32_1 = require("a029b3b56c3794d0");
const hash = require("639bb6bf64b44f9b");
const misc = require("6f2e4191aba97196");
async function fromData(contextIdentifier, contextVersion, data) {
    const versionU8 = new Uint8Array([
        contextVersion
    ]);
    return misc.concat(versionU8, (await hash.hash(misc.concat(misc.fromString(contextIdentifier), versionU8, data))).slice(0, 20));
}
exports.fromData = fromData;
function toBech32(prefix, addr) {
    return bech32_1.bech32.encode(prefix, bech32_1.bech32.toWords(addr));
}
exports.toBech32 = toBech32;
function fromBech32(expectedPrefix, str) {
    const { prefix, words } = bech32_1.bech32.decode(str);
    if (prefix !== expectedPrefix) throw new Error(`wrong prefix: ${prefix}, expected ${expectedPrefix}`);
    return new Uint8Array(bech32_1.bech32.fromWords(words));
}
exports.fromBech32 = fromBech32;

},{"a029b3b56c3794d0":"akagq","639bb6bf64b44f9b":"1sr6I","6f2e4191aba97196":"agInO"}],"akagq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bech32m = exports.bech32 = void 0;
const ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
const ALPHABET_MAP = {};
for(let z = 0; z < ALPHABET.length; z++){
    const x = ALPHABET.charAt(z);
    ALPHABET_MAP[x] = z;
}
function polymodStep(pre) {
    const b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function prefixChk(prefix) {
    let chk = 1;
    for(let i = 0; i < prefix.length; ++i){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = polymodStep(chk) ^ c >> 5;
    }
    chk = polymodStep(chk);
    for(let i = 0; i < prefix.length; ++i){
        const v = prefix.charCodeAt(i);
        chk = polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function convert(data, inBits, outBits, pad) {
    let value = 0;
    let bits = 0;
    const maxV = (1 << outBits) - 1;
    const result = [];
    for(let i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function toWords(bytes) {
    return convert(bytes, 8, 5, true);
}
function fromWordsUnsafe(words) {
    const res = convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function fromWords(words) {
    const res = convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function getLibraryFromEncoding(encoding) {
    let ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        let chk = prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        let result = prefix + "1";
        for(let i = 0; i < words.length; ++i){
            const x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = polymodStep(chk) ^ x;
            result += ALPHABET.charAt(x);
        }
        for(let i = 0; i < 6; ++i)chk = polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(let i = 0; i < 6; ++i){
            const v = chk >> (5 - i) * 5 & 0x1f;
            result += ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        const lowered = str.toLowerCase();
        const uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        const split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        const prefix = str.slice(0, split);
        const wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        let chk = prefixChk(prefix);
        if (typeof chk === "string") return chk;
        const words = [];
        for(let i = 0; i < wordChars.length; ++i){
            const c = wordChars.charAt(i);
            const v = ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix,
            words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    }
    function decode(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe,
        decode,
        encode,
        toWords,
        fromWordsUnsafe,
        fromWords
    };
}
exports.bech32 = getLibraryFromEncoding("bech32");
exports.bech32m = getLibraryFromEncoding("bech32m");

},{}],"1sr6I":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hash = void 0;
const js_sha512_1 = require("e0077b2ee14e91a2");
async function hash(data) {
    return new Uint8Array(js_sha512_1.sha512_256.arrayBuffer(data));
}
exports.hash = hash;

},{"e0077b2ee14e91a2":"9yOC0"}],"9yOC0":[function(require,module,exports) {
var process = require("e419cd92b0e74748");
var global = arguments[3];
/*
 * [js-sha512]{@link https://github.com/emn178/js-sha512}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA512_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA512_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
    if (NODE_JS) root = global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA512_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA512_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428A2F98,
        0xD728AE22,
        0x71374491,
        0x23EF65CD,
        0xB5C0FBCF,
        0xEC4D3B2F,
        0xE9B5DBA5,
        0x8189DBBC,
        0x3956C25B,
        0xF348B538,
        0x59F111F1,
        0xB605D019,
        0x923F82A4,
        0xAF194F9B,
        0xAB1C5ED5,
        0xDA6D8118,
        0xD807AA98,
        0xA3030242,
        0x12835B01,
        0x45706FBE,
        0x243185BE,
        0x4EE4B28C,
        0x550C7DC3,
        0xD5FFB4E2,
        0x72BE5D74,
        0xF27B896F,
        0x80DEB1FE,
        0x3B1696B1,
        0x9BDC06A7,
        0x25C71235,
        0xC19BF174,
        0xCF692694,
        0xE49B69C1,
        0x9EF14AD2,
        0xEFBE4786,
        0x384F25E3,
        0x0FC19DC6,
        0x8B8CD5B5,
        0x240CA1CC,
        0x77AC9C65,
        0x2DE92C6F,
        0x592B0275,
        0x4A7484AA,
        0x6EA6E483,
        0x5CB0A9DC,
        0xBD41FBD4,
        0x76F988DA,
        0x831153B5,
        0x983E5152,
        0xEE66DFAB,
        0xA831C66D,
        0x2DB43210,
        0xB00327C8,
        0x98FB213F,
        0xBF597FC7,
        0xBEEF0EE4,
        0xC6E00BF3,
        0x3DA88FC2,
        0xD5A79147,
        0x930AA725,
        0x06CA6351,
        0xE003826F,
        0x14292967,
        0x0A0E6E70,
        0x27B70A85,
        0x46D22FFC,
        0x2E1B2138,
        0x5C26C926,
        0x4D2C6DFC,
        0x5AC42AED,
        0x53380D13,
        0x9D95B3DF,
        0x650A7354,
        0x8BAF63DE,
        0x766A0ABB,
        0x3C77B2A8,
        0x81C2C92E,
        0x47EDAEE6,
        0x92722C85,
        0x1482353B,
        0xA2BFE8A1,
        0x4CF10364,
        0xA81A664B,
        0xBC423001,
        0xC24B8B70,
        0xD0F89791,
        0xC76C51A3,
        0x0654BE30,
        0xD192E819,
        0xD6EF5218,
        0xD6990624,
        0x5565A910,
        0xF40E3585,
        0x5771202A,
        0x106AA070,
        0x32BBD1B8,
        0x19A4C116,
        0xB8D2D0C8,
        0x1E376C08,
        0x5141AB53,
        0x2748774C,
        0xDF8EEB99,
        0x34B0BCB5,
        0xE19B48A8,
        0x391C0CB3,
        0xC5C95A63,
        0x4ED8AA4A,
        0xE3418ACB,
        0x5B9CCA4F,
        0x7763E373,
        0x682E6FF3,
        0xD6B2B8A3,
        0x748F82EE,
        0x5DEFB2FC,
        0x78A5636F,
        0x43172F60,
        0x84C87814,
        0xA1F0AB72,
        0x8CC70208,
        0x1A6439EC,
        0x90BEFFFA,
        0x23631E28,
        0xA4506CEB,
        0xDE82BDE9,
        0xBEF9A3F7,
        0xB2C67915,
        0xC67178F2,
        0xE372532B,
        0xCA273ECE,
        0xEA26619C,
        0xD186B8C7,
        0x21C0C207,
        0xEADA7DD6,
        0xCDE0EB1E,
        0xF57D4F7F,
        0xEE6ED178,
        0x06F067AA,
        0x72176FBA,
        0x0A637DC5,
        0xA2C898A6,
        0x113F9804,
        0xBEF90DAE,
        0x1B710B35,
        0x131C471B,
        0x28DB77F5,
        0x23047D84,
        0x32CAAB7B,
        0x40C72493,
        0x3C9EBE0A,
        0x15C9BEBC,
        0x431D67C4,
        0x9C100D4C,
        0x4CC5D4BE,
        0xCB3E42B6,
        0x597F299C,
        0xFC657E2A,
        0x5FCB6FAB,
        0x3AD6FAEC,
        0x6C44198C,
        0x4A475817
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA512_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, bits) {
        return function(message) {
            return new Sha512(bits, true).update(message)[outputType]();
        };
    };
    var createMethod = function(bits) {
        var method = createOutputMethod("hex", bits);
        method.create = function() {
            return new Sha512(bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, bits);
        }
        return method;
    };
    var createHmacOutputMethod = function(outputType, bits) {
        return function(key, message) {
            return new HmacSha512(key, bits, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(bits) {
        var method = createHmacOutputMethod("hex", bits);
        method.create = function(key) {
            return new HmacSha512(key, bits);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, bits);
        }
        return method;
    };
    function Sha512(bits, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (bits == 384) {
            this.h0h = 0xCBBB9D5D;
            this.h0l = 0xC1059ED8;
            this.h1h = 0x629A292A;
            this.h1l = 0x367CD507;
            this.h2h = 0x9159015A;
            this.h2l = 0x3070DD17;
            this.h3h = 0x152FECD8;
            this.h3l = 0xF70E5939;
            this.h4h = 0x67332667;
            this.h4l = 0xFFC00B31;
            this.h5h = 0x8EB44A87;
            this.h5l = 0x68581511;
            this.h6h = 0xDB0C2E0D;
            this.h6l = 0x64F98FA7;
            this.h7h = 0x47B5481D;
            this.h7l = 0xBEFA4FA4;
        } else if (bits == 256) {
            this.h0h = 0x22312194;
            this.h0l = 0xFC2BF72C;
            this.h1h = 0x9F555FA3;
            this.h1l = 0xC84C64C2;
            this.h2h = 0x2393B86B;
            this.h2l = 0x6F53B151;
            this.h3h = 0x96387719;
            this.h3l = 0x5940EABD;
            this.h4h = 0x96283EE2;
            this.h4l = 0xA88EFFE3;
            this.h5h = 0xBE5E1E25;
            this.h5l = 0x53863992;
            this.h6h = 0x2B0199FC;
            this.h6l = 0x2C85B8AA;
            this.h7h = 0x0EB72DDC;
            this.h7l = 0x81C52CA2;
        } else if (bits == 224) {
            this.h0h = 0x8C3D37C8;
            this.h0l = 0x19544DA2;
            this.h1h = 0x73E19966;
            this.h1l = 0x89DCD4D6;
            this.h2h = 0x1DFAB7AE;
            this.h2l = 0x32FF9C82;
            this.h3h = 0x679DD514;
            this.h3l = 0x582F9FCF;
            this.h4h = 0x0F6D2B69;
            this.h4l = 0x7BD44DA8;
            this.h5h = 0x77E36F73;
            this.h5l = 0x04C48942;
            this.h6h = 0x3F9D85A8;
            this.h6l = 0x6A1D36C8;
            this.h7h = 0x1112E6AD;
            this.h7l = 0x91D692A1;
        } else {
            this.h0h = 0x6A09E667;
            this.h0l = 0xF3BCC908;
            this.h1h = 0xBB67AE85;
            this.h1l = 0x84CAA73B;
            this.h2h = 0x3C6EF372;
            this.h2l = 0xFE94F82B;
            this.h3h = 0xA54FF53A;
            this.h3l = 0x5F1D36F1;
            this.h4h = 0x510E527F;
            this.h4l = 0xADE682D1;
            this.h5h = 0x9B05688C;
            this.h5l = 0x2B3E6C1F;
            this.h6h = 0x1F83D9AB;
            this.h6l = 0xFB41BD6B;
            this.h7h = 0x5BE0CD19;
            this.h7l = 0x137E2179;
        }
        this.bits = bits;
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
    }
    Sha512.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 128; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 128; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 128) {
                this.block = blocks[32];
                this.start = i - 128;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha512.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[32] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[32];
        if (i >= 112) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = blocks[16] = blocks[17] = blocks[18] = blocks[19] = blocks[20] = blocks[21] = blocks[22] = blocks[23] = blocks[24] = blocks[25] = blocks[26] = blocks[27] = blocks[28] = blocks[29] = blocks[30] = blocks[31] = blocks[32] = 0;
        }
        blocks[30] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[31] = this.bytes << 3;
        this.hash();
    };
    Sha512.prototype.hash = function() {
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, blocks = this.blocks, j, s0h, s0l, s1h, s1l, c1, c2, c3, c4, abh, abl, dah, dal, cdh, cdl, bch, bcl, majh, majl, t1h, t1l, t2h, t2l, chh, chl;
        for(j = 32; j < 160; j += 2){
            t1h = blocks[j - 30];
            t1l = blocks[j - 29];
            s0h = (t1h >>> 1 | t1l << 31) ^ (t1h >>> 8 | t1l << 24) ^ t1h >>> 7;
            s0l = (t1l >>> 1 | t1h << 31) ^ (t1l >>> 8 | t1h << 24) ^ (t1l >>> 7 | t1h << 25);
            t1h = blocks[j - 4];
            t1l = blocks[j - 3];
            s1h = (t1h >>> 19 | t1l << 13) ^ (t1l >>> 29 | t1h << 3) ^ t1h >>> 6;
            s1l = (t1l >>> 19 | t1h << 13) ^ (t1h >>> 29 | t1l << 3) ^ (t1l >>> 6 | t1h << 26);
            t1h = blocks[j - 32];
            t1l = blocks[j - 31];
            t2h = blocks[j - 14];
            t2l = blocks[j - 13];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (s0l & 0xFFFF) + (s1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (s0l >>> 16) + (s1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (s0h & 0xFFFF) + (s1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (s0h >>> 16) + (s1h >>> 16) + (c3 >>> 16);
            blocks[j] = c4 << 16 | c3 & 0xFFFF;
            blocks[j + 1] = c2 << 16 | c1 & 0xFFFF;
        }
        var ah = h0h, al = h0l, bh = h1h, bl = h1l, ch = h2h, cl = h2l, dh = h3h, dl = h3l, eh = h4h, el = h4l, fh = h5h, fl = h5l, gh = h6h, gl = h6l, hh = h7h, hl = h7l;
        bch = bh & ch;
        bcl = bl & cl;
        for(j = 0; j < 160; j += 8){
            s0h = (ah >>> 28 | al << 4) ^ (al >>> 2 | ah << 30) ^ (al >>> 7 | ah << 25);
            s0l = (al >>> 28 | ah << 4) ^ (ah >>> 2 | al << 30) ^ (ah >>> 7 | al << 25);
            s1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (el >>> 9 | eh << 23);
            s1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (eh >>> 9 | el << 23);
            abh = ah & bh;
            abl = al & bl;
            majh = abh ^ ah & ch ^ bch;
            majl = abl ^ al & cl ^ bcl;
            chh = eh & fh ^ ~eh & gh;
            chl = el & fl ^ ~el & gl;
            t1h = blocks[j];
            t1l = blocks[j + 1];
            t2h = K[j];
            t2l = K[j + 1];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (hl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (hl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (hh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (dl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (dl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (dh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (dh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            hh = c4 << 16 | c3 & 0xFFFF;
            hl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            dh = c4 << 16 | c3 & 0xFFFF;
            dl = c2 << 16 | c1 & 0xFFFF;
            s0h = (dh >>> 28 | dl << 4) ^ (dl >>> 2 | dh << 30) ^ (dl >>> 7 | dh << 25);
            s0l = (dl >>> 28 | dh << 4) ^ (dh >>> 2 | dl << 30) ^ (dh >>> 7 | dl << 25);
            s1h = (hh >>> 14 | hl << 18) ^ (hh >>> 18 | hl << 14) ^ (hl >>> 9 | hh << 23);
            s1l = (hl >>> 14 | hh << 18) ^ (hl >>> 18 | hh << 14) ^ (hh >>> 9 | hl << 23);
            dah = dh & ah;
            dal = dl & al;
            majh = dah ^ dh & bh ^ abh;
            majl = dal ^ dl & bl ^ abl;
            chh = hh & eh ^ ~hh & fh;
            chl = hl & el ^ ~hl & fl;
            t1h = blocks[j + 2];
            t1l = blocks[j + 3];
            t2h = K[j + 2];
            t2l = K[j + 3];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (gl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (gl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (gh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (cl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (cl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (ch & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (ch >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            gh = c4 << 16 | c3 & 0xFFFF;
            gl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            ch = c4 << 16 | c3 & 0xFFFF;
            cl = c2 << 16 | c1 & 0xFFFF;
            s0h = (ch >>> 28 | cl << 4) ^ (cl >>> 2 | ch << 30) ^ (cl >>> 7 | ch << 25);
            s0l = (cl >>> 28 | ch << 4) ^ (ch >>> 2 | cl << 30) ^ (ch >>> 7 | cl << 25);
            s1h = (gh >>> 14 | gl << 18) ^ (gh >>> 18 | gl << 14) ^ (gl >>> 9 | gh << 23);
            s1l = (gl >>> 14 | gh << 18) ^ (gl >>> 18 | gh << 14) ^ (gh >>> 9 | gl << 23);
            cdh = ch & dh;
            cdl = cl & dl;
            majh = cdh ^ ch & ah ^ dah;
            majl = cdl ^ cl & al ^ dal;
            chh = gh & hh ^ ~gh & eh;
            chl = gl & hl ^ ~gl & el;
            t1h = blocks[j + 4];
            t1l = blocks[j + 5];
            t2h = K[j + 4];
            t2l = K[j + 5];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (fl & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (fl >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (fh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (bl & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (bl >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (bh & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (bh >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            fh = c4 << 16 | c3 & 0xFFFF;
            fl = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            bh = c4 << 16 | c3 & 0xFFFF;
            bl = c2 << 16 | c1 & 0xFFFF;
            s0h = (bh >>> 28 | bl << 4) ^ (bl >>> 2 | bh << 30) ^ (bl >>> 7 | bh << 25);
            s0l = (bl >>> 28 | bh << 4) ^ (bh >>> 2 | bl << 30) ^ (bh >>> 7 | bl << 25);
            s1h = (fh >>> 14 | fl << 18) ^ (fh >>> 18 | fl << 14) ^ (fl >>> 9 | fh << 23);
            s1l = (fl >>> 14 | fh << 18) ^ (fl >>> 18 | fh << 14) ^ (fh >>> 9 | fl << 23);
            bch = bh & ch;
            bcl = bl & cl;
            majh = bch ^ bh & dh ^ cdh;
            majl = bcl ^ bl & dl ^ cdl;
            chh = fh & gh ^ ~fh & hh;
            chl = fl & gl ^ ~fl & hl;
            t1h = blocks[j + 6];
            t1l = blocks[j + 7];
            t2h = K[j + 6];
            t2l = K[j + 7];
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF) + (chl & 0xFFFF) + (s1l & 0xFFFF) + (el & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (chl >>> 16) + (s1l >>> 16) + (el >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (chh & 0xFFFF) + (s1h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (chh >>> 16) + (s1h >>> 16) + (eh >>> 16) + (c3 >>> 16);
            t1h = c4 << 16 | c3 & 0xFFFF;
            t1l = c2 << 16 | c1 & 0xFFFF;
            c1 = (majl & 0xFFFF) + (s0l & 0xFFFF);
            c2 = (majl >>> 16) + (s0l >>> 16) + (c1 >>> 16);
            c3 = (majh & 0xFFFF) + (s0h & 0xFFFF) + (c2 >>> 16);
            c4 = (majh >>> 16) + (s0h >>> 16) + (c3 >>> 16);
            t2h = c4 << 16 | c3 & 0xFFFF;
            t2l = c2 << 16 | c1 & 0xFFFF;
            c1 = (al & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (al >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (ah & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (ah >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            eh = c4 << 16 | c3 & 0xFFFF;
            el = c2 << 16 | c1 & 0xFFFF;
            c1 = (t2l & 0xFFFF) + (t1l & 0xFFFF);
            c2 = (t2l >>> 16) + (t1l >>> 16) + (c1 >>> 16);
            c3 = (t2h & 0xFFFF) + (t1h & 0xFFFF) + (c2 >>> 16);
            c4 = (t2h >>> 16) + (t1h >>> 16) + (c3 >>> 16);
            ah = c4 << 16 | c3 & 0xFFFF;
            al = c2 << 16 | c1 & 0xFFFF;
        }
        c1 = (h0l & 0xFFFF) + (al & 0xFFFF);
        c2 = (h0l >>> 16) + (al >>> 16) + (c1 >>> 16);
        c3 = (h0h & 0xFFFF) + (ah & 0xFFFF) + (c2 >>> 16);
        c4 = (h0h >>> 16) + (ah >>> 16) + (c3 >>> 16);
        this.h0h = c4 << 16 | c3 & 0xFFFF;
        this.h0l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h1l & 0xFFFF) + (bl & 0xFFFF);
        c2 = (h1l >>> 16) + (bl >>> 16) + (c1 >>> 16);
        c3 = (h1h & 0xFFFF) + (bh & 0xFFFF) + (c2 >>> 16);
        c4 = (h1h >>> 16) + (bh >>> 16) + (c3 >>> 16);
        this.h1h = c4 << 16 | c3 & 0xFFFF;
        this.h1l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h2l & 0xFFFF) + (cl & 0xFFFF);
        c2 = (h2l >>> 16) + (cl >>> 16) + (c1 >>> 16);
        c3 = (h2h & 0xFFFF) + (ch & 0xFFFF) + (c2 >>> 16);
        c4 = (h2h >>> 16) + (ch >>> 16) + (c3 >>> 16);
        this.h2h = c4 << 16 | c3 & 0xFFFF;
        this.h2l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h3l & 0xFFFF) + (dl & 0xFFFF);
        c2 = (h3l >>> 16) + (dl >>> 16) + (c1 >>> 16);
        c3 = (h3h & 0xFFFF) + (dh & 0xFFFF) + (c2 >>> 16);
        c4 = (h3h >>> 16) + (dh >>> 16) + (c3 >>> 16);
        this.h3h = c4 << 16 | c3 & 0xFFFF;
        this.h3l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h4l & 0xFFFF) + (el & 0xFFFF);
        c2 = (h4l >>> 16) + (el >>> 16) + (c1 >>> 16);
        c3 = (h4h & 0xFFFF) + (eh & 0xFFFF) + (c2 >>> 16);
        c4 = (h4h >>> 16) + (eh >>> 16) + (c3 >>> 16);
        this.h4h = c4 << 16 | c3 & 0xFFFF;
        this.h4l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h5l & 0xFFFF) + (fl & 0xFFFF);
        c2 = (h5l >>> 16) + (fl >>> 16) + (c1 >>> 16);
        c3 = (h5h & 0xFFFF) + (fh & 0xFFFF) + (c2 >>> 16);
        c4 = (h5h >>> 16) + (fh >>> 16) + (c3 >>> 16);
        this.h5h = c4 << 16 | c3 & 0xFFFF;
        this.h5l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h6l & 0xFFFF) + (gl & 0xFFFF);
        c2 = (h6l >>> 16) + (gl >>> 16) + (c1 >>> 16);
        c3 = (h6h & 0xFFFF) + (gh & 0xFFFF) + (c2 >>> 16);
        c4 = (h6h >>> 16) + (gh >>> 16) + (c3 >>> 16);
        this.h6h = c4 << 16 | c3 & 0xFFFF;
        this.h6l = c2 << 16 | c1 & 0xFFFF;
        c1 = (h7l & 0xFFFF) + (hl & 0xFFFF);
        c2 = (h7l >>> 16) + (hl >>> 16) + (c1 >>> 16);
        c3 = (h7h & 0xFFFF) + (hh & 0xFFFF) + (c2 >>> 16);
        c4 = (h7h >>> 16) + (hh >>> 16) + (c3 >>> 16);
        this.h7h = c4 << 16 | c3 & 0xFFFF;
        this.h7l = c2 << 16 | c1 & 0xFFFF;
    };
    Sha512.prototype.hex = function() {
        this.finalize();
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, bits = this.bits;
        var hex = HEX_CHARS[h0h >> 28 & 0x0F] + HEX_CHARS[h0h >> 24 & 0x0F] + HEX_CHARS[h0h >> 20 & 0x0F] + HEX_CHARS[h0h >> 16 & 0x0F] + HEX_CHARS[h0h >> 12 & 0x0F] + HEX_CHARS[h0h >> 8 & 0x0F] + HEX_CHARS[h0h >> 4 & 0x0F] + HEX_CHARS[h0h & 0x0F] + HEX_CHARS[h0l >> 28 & 0x0F] + HEX_CHARS[h0l >> 24 & 0x0F] + HEX_CHARS[h0l >> 20 & 0x0F] + HEX_CHARS[h0l >> 16 & 0x0F] + HEX_CHARS[h0l >> 12 & 0x0F] + HEX_CHARS[h0l >> 8 & 0x0F] + HEX_CHARS[h0l >> 4 & 0x0F] + HEX_CHARS[h0l & 0x0F] + HEX_CHARS[h1h >> 28 & 0x0F] + HEX_CHARS[h1h >> 24 & 0x0F] + HEX_CHARS[h1h >> 20 & 0x0F] + HEX_CHARS[h1h >> 16 & 0x0F] + HEX_CHARS[h1h >> 12 & 0x0F] + HEX_CHARS[h1h >> 8 & 0x0F] + HEX_CHARS[h1h >> 4 & 0x0F] + HEX_CHARS[h1h & 0x0F] + HEX_CHARS[h1l >> 28 & 0x0F] + HEX_CHARS[h1l >> 24 & 0x0F] + HEX_CHARS[h1l >> 20 & 0x0F] + HEX_CHARS[h1l >> 16 & 0x0F] + HEX_CHARS[h1l >> 12 & 0x0F] + HEX_CHARS[h1l >> 8 & 0x0F] + HEX_CHARS[h1l >> 4 & 0x0F] + HEX_CHARS[h1l & 0x0F] + HEX_CHARS[h2h >> 28 & 0x0F] + HEX_CHARS[h2h >> 24 & 0x0F] + HEX_CHARS[h2h >> 20 & 0x0F] + HEX_CHARS[h2h >> 16 & 0x0F] + HEX_CHARS[h2h >> 12 & 0x0F] + HEX_CHARS[h2h >> 8 & 0x0F] + HEX_CHARS[h2h >> 4 & 0x0F] + HEX_CHARS[h2h & 0x0F] + HEX_CHARS[h2l >> 28 & 0x0F] + HEX_CHARS[h2l >> 24 & 0x0F] + HEX_CHARS[h2l >> 20 & 0x0F] + HEX_CHARS[h2l >> 16 & 0x0F] + HEX_CHARS[h2l >> 12 & 0x0F] + HEX_CHARS[h2l >> 8 & 0x0F] + HEX_CHARS[h2l >> 4 & 0x0F] + HEX_CHARS[h2l & 0x0F] + HEX_CHARS[h3h >> 28 & 0x0F] + HEX_CHARS[h3h >> 24 & 0x0F] + HEX_CHARS[h3h >> 20 & 0x0F] + HEX_CHARS[h3h >> 16 & 0x0F] + HEX_CHARS[h3h >> 12 & 0x0F] + HEX_CHARS[h3h >> 8 & 0x0F] + HEX_CHARS[h3h >> 4 & 0x0F] + HEX_CHARS[h3h & 0x0F];
        if (bits >= 256) hex += HEX_CHARS[h3l >> 28 & 0x0F] + HEX_CHARS[h3l >> 24 & 0x0F] + HEX_CHARS[h3l >> 20 & 0x0F] + HEX_CHARS[h3l >> 16 & 0x0F] + HEX_CHARS[h3l >> 12 & 0x0F] + HEX_CHARS[h3l >> 8 & 0x0F] + HEX_CHARS[h3l >> 4 & 0x0F] + HEX_CHARS[h3l & 0x0F];
        if (bits >= 384) hex += HEX_CHARS[h4h >> 28 & 0x0F] + HEX_CHARS[h4h >> 24 & 0x0F] + HEX_CHARS[h4h >> 20 & 0x0F] + HEX_CHARS[h4h >> 16 & 0x0F] + HEX_CHARS[h4h >> 12 & 0x0F] + HEX_CHARS[h4h >> 8 & 0x0F] + HEX_CHARS[h4h >> 4 & 0x0F] + HEX_CHARS[h4h & 0x0F] + HEX_CHARS[h4l >> 28 & 0x0F] + HEX_CHARS[h4l >> 24 & 0x0F] + HEX_CHARS[h4l >> 20 & 0x0F] + HEX_CHARS[h4l >> 16 & 0x0F] + HEX_CHARS[h4l >> 12 & 0x0F] + HEX_CHARS[h4l >> 8 & 0x0F] + HEX_CHARS[h4l >> 4 & 0x0F] + HEX_CHARS[h4l & 0x0F] + HEX_CHARS[h5h >> 28 & 0x0F] + HEX_CHARS[h5h >> 24 & 0x0F] + HEX_CHARS[h5h >> 20 & 0x0F] + HEX_CHARS[h5h >> 16 & 0x0F] + HEX_CHARS[h5h >> 12 & 0x0F] + HEX_CHARS[h5h >> 8 & 0x0F] + HEX_CHARS[h5h >> 4 & 0x0F] + HEX_CHARS[h5h & 0x0F] + HEX_CHARS[h5l >> 28 & 0x0F] + HEX_CHARS[h5l >> 24 & 0x0F] + HEX_CHARS[h5l >> 20 & 0x0F] + HEX_CHARS[h5l >> 16 & 0x0F] + HEX_CHARS[h5l >> 12 & 0x0F] + HEX_CHARS[h5l >> 8 & 0x0F] + HEX_CHARS[h5l >> 4 & 0x0F] + HEX_CHARS[h5l & 0x0F];
        if (bits == 512) hex += HEX_CHARS[h6h >> 28 & 0x0F] + HEX_CHARS[h6h >> 24 & 0x0F] + HEX_CHARS[h6h >> 20 & 0x0F] + HEX_CHARS[h6h >> 16 & 0x0F] + HEX_CHARS[h6h >> 12 & 0x0F] + HEX_CHARS[h6h >> 8 & 0x0F] + HEX_CHARS[h6h >> 4 & 0x0F] + HEX_CHARS[h6h & 0x0F] + HEX_CHARS[h6l >> 28 & 0x0F] + HEX_CHARS[h6l >> 24 & 0x0F] + HEX_CHARS[h6l >> 20 & 0x0F] + HEX_CHARS[h6l >> 16 & 0x0F] + HEX_CHARS[h6l >> 12 & 0x0F] + HEX_CHARS[h6l >> 8 & 0x0F] + HEX_CHARS[h6l >> 4 & 0x0F] + HEX_CHARS[h6l & 0x0F] + HEX_CHARS[h7h >> 28 & 0x0F] + HEX_CHARS[h7h >> 24 & 0x0F] + HEX_CHARS[h7h >> 20 & 0x0F] + HEX_CHARS[h7h >> 16 & 0x0F] + HEX_CHARS[h7h >> 12 & 0x0F] + HEX_CHARS[h7h >> 8 & 0x0F] + HEX_CHARS[h7h >> 4 & 0x0F] + HEX_CHARS[h7h & 0x0F] + HEX_CHARS[h7l >> 28 & 0x0F] + HEX_CHARS[h7l >> 24 & 0x0F] + HEX_CHARS[h7l >> 20 & 0x0F] + HEX_CHARS[h7l >> 16 & 0x0F] + HEX_CHARS[h7l >> 12 & 0x0F] + HEX_CHARS[h7l >> 8 & 0x0F] + HEX_CHARS[h7l >> 4 & 0x0F] + HEX_CHARS[h7l & 0x0F];
        return hex;
    };
    Sha512.prototype.toString = Sha512.prototype.hex;
    Sha512.prototype.digest = function() {
        this.finalize();
        var h0h = this.h0h, h0l = this.h0l, h1h = this.h1h, h1l = this.h1l, h2h = this.h2h, h2l = this.h2l, h3h = this.h3h, h3l = this.h3l, h4h = this.h4h, h4l = this.h4l, h5h = this.h5h, h5l = this.h5l, h6h = this.h6h, h6l = this.h6l, h7h = this.h7h, h7l = this.h7l, bits = this.bits;
        var arr = [
            h0h >> 24 & 0xFF,
            h0h >> 16 & 0xFF,
            h0h >> 8 & 0xFF,
            h0h & 0xFF,
            h0l >> 24 & 0xFF,
            h0l >> 16 & 0xFF,
            h0l >> 8 & 0xFF,
            h0l & 0xFF,
            h1h >> 24 & 0xFF,
            h1h >> 16 & 0xFF,
            h1h >> 8 & 0xFF,
            h1h & 0xFF,
            h1l >> 24 & 0xFF,
            h1l >> 16 & 0xFF,
            h1l >> 8 & 0xFF,
            h1l & 0xFF,
            h2h >> 24 & 0xFF,
            h2h >> 16 & 0xFF,
            h2h >> 8 & 0xFF,
            h2h & 0xFF,
            h2l >> 24 & 0xFF,
            h2l >> 16 & 0xFF,
            h2l >> 8 & 0xFF,
            h2l & 0xFF,
            h3h >> 24 & 0xFF,
            h3h >> 16 & 0xFF,
            h3h >> 8 & 0xFF,
            h3h & 0xFF
        ];
        if (bits >= 256) arr.push(h3l >> 24 & 0xFF, h3l >> 16 & 0xFF, h3l >> 8 & 0xFF, h3l & 0xFF);
        if (bits >= 384) arr.push(h4h >> 24 & 0xFF, h4h >> 16 & 0xFF, h4h >> 8 & 0xFF, h4h & 0xFF, h4l >> 24 & 0xFF, h4l >> 16 & 0xFF, h4l >> 8 & 0xFF, h4l & 0xFF, h5h >> 24 & 0xFF, h5h >> 16 & 0xFF, h5h >> 8 & 0xFF, h5h & 0xFF, h5l >> 24 & 0xFF, h5l >> 16 & 0xFF, h5l >> 8 & 0xFF, h5l & 0xFF);
        if (bits == 512) arr.push(h6h >> 24 & 0xFF, h6h >> 16 & 0xFF, h6h >> 8 & 0xFF, h6h & 0xFF, h6l >> 24 & 0xFF, h6l >> 16 & 0xFF, h6l >> 8 & 0xFF, h6l & 0xFF, h7h >> 24 & 0xFF, h7h >> 16 & 0xFF, h7h >> 8 & 0xFF, h7h & 0xFF, h7l >> 24 & 0xFF, h7l >> 16 & 0xFF, h7l >> 8 & 0xFF, h7l & 0xFF);
        return arr;
    };
    Sha512.prototype.array = Sha512.prototype.digest;
    Sha512.prototype.arrayBuffer = function() {
        this.finalize();
        var bits = this.bits;
        var buffer = new ArrayBuffer(bits / 8);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0h);
        dataView.setUint32(4, this.h0l);
        dataView.setUint32(8, this.h1h);
        dataView.setUint32(12, this.h1l);
        dataView.setUint32(16, this.h2h);
        dataView.setUint32(20, this.h2l);
        dataView.setUint32(24, this.h3h);
        if (bits >= 256) dataView.setUint32(28, this.h3l);
        if (bits >= 384) {
            dataView.setUint32(32, this.h4h);
            dataView.setUint32(36, this.h4l);
            dataView.setUint32(40, this.h5h);
            dataView.setUint32(44, this.h5l);
        }
        if (bits == 512) {
            dataView.setUint32(48, this.h6h);
            dataView.setUint32(52, this.h6l);
            dataView.setUint32(56, this.h7h);
            dataView.setUint32(60, this.h7l);
        }
        return buffer;
    };
    Sha512.prototype.clone = function() {
        var hash = new Sha512(this.bits, false);
        this.copyTo(hash);
        return hash;
    };
    Sha512.prototype.copyTo = function(hash) {
        var i = 0, attrs = [
            "h0h",
            "h0l",
            "h1h",
            "h1l",
            "h2h",
            "h2l",
            "h3h",
            "h3l",
            "h4h",
            "h4l",
            "h5h",
            "h5l",
            "h6h",
            "h6l",
            "h7h",
            "h7l",
            "start",
            "bytes",
            "hBytes",
            "finalized",
            "hashed",
            "lastByteIndex"
        ];
        for(i = 0; i < attrs.length; ++i)hash[attrs[i]] = this[attrs[i]];
        for(i = 0; i < this.blocks.length; ++i)hash.blocks[i] = this.blocks[i];
    };
    function HmacSha512(key, bits, sharedMemory) {
        var notString, type = typeof key;
        if (type !== "string") {
            if (type === "object") {
                if (key === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var length = key.length;
        if (!notString) {
            var bytes = [], length = key.length, index = 0, code;
            for(var i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        }
        if (key.length > 128) key = new Sha512(bits, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(var i = 0; i < 128; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha512.call(this, bits, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha512.prototype = new Sha512();
    HmacSha512.prototype.finalize = function() {
        Sha512.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha512.call(this, this.bits, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha512.prototype.finalize.call(this);
        }
    };
    HmacSha512.prototype.clone = function() {
        var hash = new HmacSha512([], this.bits, false);
        this.copyTo(hash);
        hash.inner = this.inner;
        for(var i = 0; i < this.oKeyPad.length; ++i)hash.oKeyPad[i] = this.oKeyPad[i];
        return hash;
    };
    var exports = createMethod(512);
    exports.sha512 = exports;
    exports.sha384 = createMethod(384);
    exports.sha512_256 = createMethod(256);
    exports.sha512_224 = createMethod(224);
    exports.sha512.hmac = createHmacMethod(512);
    exports.sha384.hmac = createHmacMethod(384);
    exports.sha512_256.hmac = createHmacMethod(256);
    exports.sha512_224.hmac = createHmacMethod(224);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha512 = exports.sha512;
        root.sha384 = exports.sha384;
        root.sha512_256 = exports.sha512_256;
        root.sha512_224 = exports.sha512_224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

},{"e419cd92b0e74748":"cSDX6"}],"cSDX6":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"agInO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.concat = exports.fromString = exports.toStringUTF8 = exports.fromBase64 = exports.toBase64 = exports.fromHex = exports.toHex = exports.fromCBOR = exports.toCBOR = void 0;
const cborg = require("ce8233d4899ade92");
const HEX_DIGITS = "0123456789abcdef";
// oasis-core routinely uses maps with non-string keys, e.g. in a staking Delegations response. We
// can't pick and choose which CBOR maps to decode into objects and which to decode in to Maps, so
// walk through the data after decoding and find any string-keys-only and recreate them as objects.
function objsFromMaps(v) {
    if (v instanceof Map) {
        let keysCompatible = true;
        for (const key of v.keys())if (typeof key !== "string") {
            keysCompatible = false;
            break;
        }
        if (v.size > 0 && keysCompatible) {
            // Recreate as an object.
            const o = {};
            for (const [key, val] of v)o[key] = objsFromMaps(val);
            return o;
        } else {
            // Leave as a Map. We'd miss empty structs, but we wouldn't dare use such a thing,
            // would we?
            const m = new Map();
            for (const [key, val] of v)m.set(objsFromMaps(key), objsFromMaps(val));
            return m;
        }
    } else if (v instanceof Array) {
        const a = [];
        for (const elem of v)a.push(objsFromMaps(elem));
        return a;
    } else return v;
}
function toCBOR(v) {
    return cborg.encode(v);
}
exports.toCBOR = toCBOR;
function fromCBOR(u8) {
    // oasis-core uses a special case to unmarshal an empty byte string to `nil`.
    if (!u8.length) return undefined;
    return objsFromMaps(cborg.decode(u8, {
        useMaps: true
    }));
}
exports.fromCBOR = fromCBOR;
function toHex(u8) {
    let hex = "";
    for (const b of u8)hex += HEX_DIGITS[b >>> 4] + HEX_DIGITS[b & 0xf];
    return hex;
}
exports.toHex = toHex;
function fromHex(hex) {
    let byteLength = hex.length >> 1;
    const u8 = new Uint8Array(byteLength);
    for(let i = 0; i < byteLength; i++)u8[i] = parseInt(hex.substr(2 * i, 2), 16);
    return u8;
}
exports.fromHex = fromHex;
function toBase64(u8) {
    return btoa(String.fromCharCode(...u8));
}
exports.toBase64 = toBase64;
function fromBase64(base64) {
    const binaryStr = atob(base64);
    const byteLength = binaryStr.length;
    const u8 = new Uint8Array(byteLength);
    for(let i = 0; i < byteLength; i++)u8[i] = binaryStr.charCodeAt(i);
    return u8;
}
exports.fromBase64 = fromBase64;
function toStringUTF8(u8) {
    return new TextDecoder().decode(u8);
}
exports.toStringUTF8 = toStringUTF8;
function fromString(str) {
    return new TextEncoder().encode(str);
}
exports.fromString = fromString;
function concat(...parts) {
    let length = 0;
    for (const part of parts)length += part.length;
    let result = new Uint8Array(length);
    let pos = 0;
    for (const part of parts){
        result.set(part, pos);
        pos += part.length;
    }
    return result;
}
exports.concat = concat;

},{"ce8233d4899ade92":"2YIql"}],"2YIql":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var encode = require("3b3b89f138917eb3");
var decode = require("b75a80531c8b6f28");
var token = require("42eaad425c67d01d");
exports.encode = encode.encode;
exports.decode = decode.decode;
exports.Token = token.Token;
exports.Type = token.Type;

},{"3b3b89f138917eb3":"flgNM","b75a80531c8b6f28":"5hFFw","42eaad425c67d01d":"4KSiO"}],"flgNM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var is = require("ec2a75c0822da05a");
var token = require("f97da2246e129d0b");
var bl = require("42f42a44fa64497f");
var common = require("b5d2fc01673063f5");
var jump = require("cfd3b54ebbbc9572");
var byteUtils = require("5812fb0dc3e1aead");
var _0uint = require("2f81eabd9c20c1da");
var _1negint = require("2d335d99064f4ad");
var _2bytes = require("996d587692e4d604");
var _3string = require("674fabc1677e8487");
var _4array = require("4548a2e1d33a5968");
var _5map = require("f63d29142cec98f3");
var _6tag = require("a9849610cf505e07");
var _7float = require("4d97fc016ada6d46");
const defaultEncodeOptions = {
    float64: false,
    mapSorter,
    quickEncodeToken: jump.quickEncodeToken
};
function makeCborEncoders() {
    const encoders = [];
    encoders[token.Type.uint.major] = _0uint.encodeUint;
    encoders[token.Type.negint.major] = _1negint.encodeNegint;
    encoders[token.Type.bytes.major] = _2bytes.encodeBytes;
    encoders[token.Type.string.major] = _3string.encodeString;
    encoders[token.Type.array.major] = _4array.encodeArray;
    encoders[token.Type.map.major] = _5map.encodeMap;
    encoders[token.Type.tag.major] = _6tag.encodeTag;
    encoders[token.Type.float.major] = _7float.encodeFloat;
    return encoders;
}
const cborEncoders = makeCborEncoders();
const buf = new bl.Bl();
class Ref {
    constructor(obj, parent){
        this.obj = obj;
        this.parent = parent;
    }
    includes(obj) {
        let p = this;
        do {
            if (p.obj === obj) return true;
        }while (p = p.parent);
        return false;
    }
    static createCheck(stack, obj) {
        if (stack && stack.includes(obj)) throw new Error(`${common.encodeErrPrefix} object contains circular references`);
        return new Ref(obj, stack);
    }
}
const simpleTokens = {
    null: new token.Token(token.Type.null, null),
    undefined: new token.Token(token.Type.undefined, undefined),
    true: new token.Token(token.Type.true, true),
    false: new token.Token(token.Type.false, false),
    emptyArray: new token.Token(token.Type.array, 0),
    emptyMap: new token.Token(token.Type.map, 0)
};
const typeEncoders = {
    number (obj, _typ, _options, _refStack) {
        if (!Number.isInteger(obj) || !Number.isSafeInteger(obj)) return new token.Token(token.Type.float, obj);
        else if (obj >= 0) return new token.Token(token.Type.uint, obj);
        else return new token.Token(token.Type.negint, obj);
    },
    bigint (obj, _typ, _options, _refStack) {
        if (obj >= BigInt(0)) return new token.Token(token.Type.uint, obj);
        else return new token.Token(token.Type.negint, obj);
    },
    Uint8Array (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.bytes, obj);
    },
    string (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.string, obj);
    },
    boolean (obj, _typ, _options, _refStack) {
        return obj ? simpleTokens.true : simpleTokens.false;
    },
    null (_obj, _typ, _options, _refStack) {
        return simpleTokens.null;
    },
    undefined (_obj, _typ, _options, _refStack) {
        return simpleTokens.undefined;
    },
    ArrayBuffer (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.bytes, new Uint8Array(obj));
    },
    DataView (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.bytes, new Uint8Array(obj.buffer, obj.byteOffset, obj.byteLength));
    },
    Array (obj, _typ, options, refStack) {
        if (!obj.length) {
            if (options.addBreakTokens === true) return [
                simpleTokens.emptyArray,
                new token.Token(token.Type.break)
            ];
            return simpleTokens.emptyArray;
        }
        refStack = Ref.createCheck(refStack, obj);
        const entries = [];
        let i = 0;
        for (const e of obj)entries[i++] = objectToTokens(e, options, refStack);
        if (options.addBreakTokens) return [
            new token.Token(token.Type.array, obj.length),
            entries,
            new token.Token(token.Type.break)
        ];
        return [
            new token.Token(token.Type.array, obj.length),
            entries
        ];
    },
    Object (obj, typ, options, refStack) {
        const isMap = typ !== "Object";
        const keys = isMap ? obj.keys() : Object.keys(obj);
        const length = isMap ? obj.size : keys.length;
        if (!length) {
            if (options.addBreakTokens === true) return [
                simpleTokens.emptyMap,
                new token.Token(token.Type.break)
            ];
            return simpleTokens.emptyMap;
        }
        refStack = Ref.createCheck(refStack, obj);
        const entries = [];
        let i = 0;
        for (const key of keys)entries[i++] = [
            objectToTokens(key, options, refStack),
            objectToTokens(isMap ? obj.get(key) : obj[key], options, refStack)
        ];
        sortMapEntries(entries, options);
        if (options.addBreakTokens) return [
            new token.Token(token.Type.map, length),
            entries,
            new token.Token(token.Type.break)
        ];
        return [
            new token.Token(token.Type.map, length),
            entries
        ];
    }
};
typeEncoders.Map = typeEncoders.Object;
typeEncoders.Buffer = typeEncoders.Uint8Array;
for (const typ of "Uint8Clamped Uint16 Uint32 Int8 Int16 Int32 BigUint64 BigInt64 Float32 Float64".split(" "))typeEncoders[`${typ}Array`] = typeEncoders.DataView;
function objectToTokens(obj, options = {}, refStack) {
    const typ = is.is(obj);
    const customTypeEncoder = options && options.typeEncoders && options.typeEncoders[typ] || typeEncoders[typ];
    if (typeof customTypeEncoder === "function") {
        const tokens = customTypeEncoder(obj, typ, options, refStack);
        if (tokens != null) return tokens;
    }
    const typeEncoder = typeEncoders[typ];
    if (!typeEncoder) throw new Error(`${common.encodeErrPrefix} unsupported type: ${typ}`);
    return typeEncoder(obj, typ, options, refStack);
}
function sortMapEntries(entries, options) {
    if (options.mapSorter) entries.sort(options.mapSorter);
}
function mapSorter(e1, e2) {
    const keyToken1 = Array.isArray(e1[0]) ? e1[0][0] : e1[0];
    const keyToken2 = Array.isArray(e2[0]) ? e2[0][0] : e2[0];
    if (keyToken1.type !== keyToken2.type) return keyToken1.type.compare(keyToken2.type);
    const major = keyToken1.type.major;
    const tcmp = cborEncoders[major].compareTokens(keyToken1, keyToken2);
    if (tcmp === 0) console.warn("WARNING: complex key types used, CBOR key sorting guarantees are gone");
    return tcmp;
}
function tokensToEncoded(buf, tokens, encoders, options) {
    if (Array.isArray(tokens)) for (const token of tokens)tokensToEncoded(buf, token, encoders, options);
    else encoders[tokens.type.major](buf, tokens, options);
}
function encodeCustom(data, encoders, options) {
    const tokens = objectToTokens(data, options);
    if (!Array.isArray(tokens) && options.quickEncodeToken) {
        const quickBytes = options.quickEncodeToken(tokens);
        if (quickBytes) return quickBytes;
        const encoder = encoders[tokens.type.major];
        if (encoder.encodedSize) {
            const size = encoder.encodedSize(tokens, options);
            const buf = new bl.Bl(size);
            encoder(buf, tokens, options);
            if (buf.chunks.length !== 1) throw new Error(`Unexpected error: pre-calculated length for ${tokens} was wrong`);
            return byteUtils.asU8A(buf.chunks[0]);
        }
    }
    buf.reset();
    tokensToEncoded(buf, tokens, encoders, options);
    return buf.toBytes(true);
}
function encode(data, options) {
    options = Object.assign({}, defaultEncodeOptions, options);
    return encodeCustom(data, cborEncoders, options);
}
exports.Ref = Ref;
exports.encode = encode;
exports.encodeCustom = encodeCustom;
exports.makeCborEncoders = makeCborEncoders;
exports.objectToTokens = objectToTokens;

},{"ec2a75c0822da05a":"2CZ42","f97da2246e129d0b":"4KSiO","42f42a44fa64497f":"5VdiE","b5d2fc01673063f5":"ddTQW","cfd3b54ebbbc9572":"7MGTE","5812fb0dc3e1aead":"cnzBn","2f81eabd9c20c1da":"iLmxl","2d335d99064f4ad":"lxhwa","996d587692e4d604":"7WuSE","674fabc1677e8487":"6ApoK","4548a2e1d33a5968":"eNWAz","f63d29142cec98f3":"hEJjG","a9849610cf505e07":"52sw2","4d97fc016ada6d46":"8ZyBv"}],"2CZ42":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const typeofs = [
    "string",
    "number",
    "bigint",
    "symbol"
];
const objectTypeNames = [
    "Function",
    "Generator",
    "AsyncGenerator",
    "GeneratorFunction",
    "AsyncGeneratorFunction",
    "AsyncFunction",
    "Observable",
    "Array",
    "Buffer",
    "Object",
    "RegExp",
    "Date",
    "Error",
    "Map",
    "Set",
    "WeakMap",
    "WeakSet",
    "ArrayBuffer",
    "SharedArrayBuffer",
    "DataView",
    "Promise",
    "URL",
    "HTMLElement",
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Uint16Array",
    "Int32Array",
    "Uint32Array",
    "Float32Array",
    "Float64Array",
    "BigInt64Array",
    "BigUint64Array"
];
function is(value) {
    if (value === null) return "null";
    if (value === undefined) return "undefined";
    if (value === true || value === false) return "boolean";
    const typeOf = typeof value;
    if (typeofs.includes(typeOf)) return typeOf;
    if (typeOf === "function") return "Function";
    if (Array.isArray(value)) return "Array";
    if (isBuffer(value)) return "Buffer";
    const objectType = getObjectType(value);
    if (objectType) return objectType;
    return "Object";
}
function isBuffer(value) {
    return value && value.constructor && value.constructor.isBuffer && value.constructor.isBuffer.call(null, value);
}
function getObjectType(value) {
    const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
    if (objectTypeNames.includes(objectTypeName)) return objectTypeName;
    return undefined;
}
exports.is = is;

},{}],"4KSiO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class Type {
    constructor(major, name, terminal){
        this.major = major;
        this.majorEncoded = major << 5;
        this.name = name;
        this.terminal = terminal;
    }
    toString() {
        return `Type[${this.major}].${this.name}`;
    }
    compare(typ) {
        return this.major < typ.major ? -1 : this.major > typ.major ? 1 : 0;
    }
}
Type.uint = new Type(0, "uint", true);
Type.negint = new Type(1, "negint", true);
Type.bytes = new Type(2, "bytes", true);
Type.string = new Type(3, "string", true);
Type.array = new Type(4, "array", false);
Type.map = new Type(5, "map", false);
Type.tag = new Type(6, "tag", false);
Type.float = new Type(7, "float", true);
Type.false = new Type(7, "false", true);
Type.true = new Type(7, "true", true);
Type.null = new Type(7, "null", true);
Type.undefined = new Type(7, "undefined", true);
Type.break = new Type(7, "break", true);
class Token {
    constructor(type, value, encodedLength){
        this.type = type;
        this.value = value;
        this.encodedLength = encodedLength;
        this.encodedBytes = undefined;
        this.byteValue = undefined;
    }
    toString() {
        return `Token[${this.type}].${this.value}`;
    }
}
exports.Token = Token;
exports.Type = Type;

},{}],"5VdiE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var byteUtils = require("ecfb3bfaabc74275");
const defaultChunkSize = 256;
class Bl {
    constructor(chunkSize = defaultChunkSize){
        this.chunkSize = chunkSize;
        this.cursor = 0;
        this.maxCursor = -1;
        this.chunks = [];
        this._initReuseChunk = null;
    }
    reset() {
        this.cursor = 0;
        this.maxCursor = -1;
        if (this.chunks.length) this.chunks = [];
        if (this._initReuseChunk !== null) {
            this.chunks.push(this._initReuseChunk);
            this.maxCursor = this._initReuseChunk.length - 1;
        }
    }
    push(bytes) {
        let topChunk = this.chunks[this.chunks.length - 1];
        const newMax = this.cursor + bytes.length;
        if (newMax <= this.maxCursor + 1) {
            const chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
            topChunk.set(bytes, chunkPos);
        } else {
            if (topChunk) {
                const chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
                if (chunkPos < topChunk.length) {
                    this.chunks[this.chunks.length - 1] = topChunk.subarray(0, chunkPos);
                    this.maxCursor = this.cursor - 1;
                }
            }
            if (bytes.length < 64 && bytes.length < this.chunkSize) {
                topChunk = byteUtils.alloc(this.chunkSize);
                this.chunks.push(topChunk);
                this.maxCursor += topChunk.length;
                if (this._initReuseChunk === null) this._initReuseChunk = topChunk;
                topChunk.set(bytes, 0);
            } else {
                this.chunks.push(bytes);
                this.maxCursor += bytes.length;
            }
        }
        this.cursor += bytes.length;
    }
    toBytes(reset = false) {
        let byts;
        if (this.chunks.length === 1) {
            const chunk = this.chunks[0];
            if (reset && this.cursor > chunk.length / 2) {
                byts = this.cursor === chunk.length ? chunk : chunk.subarray(0, this.cursor);
                this._initReuseChunk = null;
                this.chunks = [];
            } else byts = byteUtils.slice(chunk, 0, this.cursor);
        } else byts = byteUtils.concat(this.chunks, this.cursor);
        if (reset) this.reset();
        return byts;
    }
}
exports.Bl = Bl;

},{"ecfb3bfaabc74275":"cnzBn"}],"cnzBn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const useBuffer = globalThis.process && !globalThis.process.browser && globalThis.Buffer && typeof globalThis.Buffer.isBuffer === "function";
const textDecoder = new TextDecoder();
const textEncoder = new TextEncoder();
function isBuffer(buf) {
    return useBuffer && globalThis.Buffer.isBuffer(buf);
}
function asU8A(buf) {
    if (!(buf instanceof Uint8Array)) return Uint8Array.from(buf);
    return isBuffer(buf) ? new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength) : buf;
}
const toString = useBuffer ? (bytes, start, end)=>{
    return end - start > 64 ? globalThis.Buffer.from(bytes.subarray(start, end)).toString("utf8") : utf8Slice(bytes, start, end);
} : (bytes, start, end)=>{
    return end - start > 64 ? textDecoder.decode(bytes.subarray(start, end)) : utf8Slice(bytes, start, end);
};
const fromString = useBuffer ? (string)=>{
    return string.length > 64 ? globalThis.Buffer.from(string) : utf8ToBytes(string);
} : (string)=>{
    return string.length > 64 ? textEncoder.encode(string) : utf8ToBytes(string);
};
const fromArray = (arr)=>{
    return Uint8Array.from(arr);
};
const slice = useBuffer ? (bytes, start, end)=>{
    if (isBuffer(bytes)) return new Uint8Array(bytes.subarray(start, end));
    return bytes.slice(start, end);
} : (bytes, start, end)=>{
    return bytes.slice(start, end);
};
const concat = useBuffer ? (chunks, length)=>{
    chunks = chunks.map((c)=>c instanceof Uint8Array ? c : globalThis.Buffer.from(c));
    return asU8A(globalThis.Buffer.concat(chunks, length));
} : (chunks, length)=>{
    const out = new Uint8Array(length);
    let off = 0;
    for (let b of chunks){
        if (off + b.length > out.length) b = b.subarray(0, out.length - off);
        out.set(b, off);
        off += b.length;
    }
    return out;
};
const alloc = useBuffer ? (size)=>{
    return globalThis.Buffer.allocUnsafe(size);
} : (size)=>{
    return new Uint8Array(size);
};
const toHex = useBuffer ? (d)=>{
    if (typeof d === "string") return d;
    return globalThis.Buffer.from(toBytes(d)).toString("hex");
} : (d)=>{
    if (typeof d === "string") return d;
    return Array.prototype.reduce.call(toBytes(d), (p, c)=>`${p}${c.toString(16).padStart(2, "0")}`, "");
};
const fromHex = useBuffer ? (hex)=>{
    if (hex instanceof Uint8Array) return hex;
    return globalThis.Buffer.from(hex, "hex");
} : (hex)=>{
    if (hex instanceof Uint8Array) return hex;
    if (!hex.length) return new Uint8Array(0);
    return new Uint8Array(hex.split("").map((c, i, d)=>i % 2 === 0 ? `0x${c}${d[i + 1]}` : "").filter(Boolean).map((e)=>parseInt(e, 16)));
};
function toBytes(obj) {
    if (obj instanceof Uint8Array && obj.constructor.name === "Uint8Array") return obj;
    if (obj instanceof ArrayBuffer) return new Uint8Array(obj);
    if (ArrayBuffer.isView(obj)) return new Uint8Array(obj.buffer, obj.byteOffset, obj.byteLength);
    throw new Error("Unknown type, must be binary type");
}
function compare(b1, b2) {
    if (isBuffer(b1) && isBuffer(b2)) return b1.compare(b2);
    for(let i = 0; i < b1.length; i++){
        if (b1[i] === b2[i]) continue;
        return b1[i] < b2[i] ? -1 : 1;
    }
    return 0;
}
function utf8ToBytes(string, units = Infinity) {
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
                if (codePoint > 56319) {
                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
                    continue;
                } else if (i + 1 === length) {
                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
                    continue;
                }
                leadSurrogate = codePoint;
                continue;
            }
            if (codePoint < 56320) {
                if ((units -= 3) > -1) bytes.push(239, 191, 189);
                leadSurrogate = codePoint;
                continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
            if ((units -= 3) > -1) bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 2048) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function utf8Slice(buf, offset, end) {
    const res = [];
    while(offset < end){
        const firstByte = buf[offset];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (offset + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 128) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[offset + 1];
                    if ((secondByte & 192) === 128) {
                        tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                        if (tempCodePoint > 127) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[offset + 1];
                    thirdByte = buf[offset + 2];
                    if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                        tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                        if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[offset + 1];
                    thirdByte = buf[offset + 2];
                    fourthByte = buf[offset + 3];
                    if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                        tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                        if (tempCodePoint > 65535 && tempCodePoint < 1114112) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
        } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        offset += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
const MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
exports.alloc = alloc;
exports.asU8A = asU8A;
exports.compare = compare;
exports.concat = concat;
exports.decodeCodePointsArray = decodeCodePointsArray;
exports.fromArray = fromArray;
exports.fromHex = fromHex;
exports.fromString = fromString;
exports.slice = slice;
exports.toHex = toHex;
exports.toString = toString;
exports.useBuffer = useBuffer;

},{}],"ddTQW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const decodeErrPrefix = "CBOR decode error:";
const encodeErrPrefix = "CBOR encode error:";
const uintMinorPrefixBytes = [];
uintMinorPrefixBytes[23] = 1;
uintMinorPrefixBytes[24] = 2;
uintMinorPrefixBytes[25] = 3;
uintMinorPrefixBytes[26] = 5;
uintMinorPrefixBytes[27] = 9;
function assertEnoughData(data, pos, need) {
    if (data.length - pos < need) throw new Error(`${decodeErrPrefix} not enough data for type`);
}
exports.assertEnoughData = assertEnoughData;
exports.decodeErrPrefix = decodeErrPrefix;
exports.encodeErrPrefix = encodeErrPrefix;
exports.uintMinorPrefixBytes = uintMinorPrefixBytes;

},{}],"7MGTE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("29e8810831c8a803");
var _0uint = require("efc4559b22d9669a");
var _1negint = require("b7e0d56f865ae009");
var _2bytes = require("2bbcf7bef2f1195d");
var _3string = require("3edb62615aa04539");
var _4array = require("f7b93d0dd2ef7ce0");
var _5map = require("df46a7f6d4858b86");
var _6tag = require("2c2755be0a2e2a24");
var _7float = require("62f61dbbe78c9769");
var common = require("b1ebc97b8a651431");
var byteUtils = require("af3858d0b4d053bb");
function invalidMinor(data, pos, minor) {
    throw new Error(`${common.decodeErrPrefix} encountered invalid minor (${minor}) for major ${data[pos] >>> 5}`);
}
function errorer(msg) {
    return ()=>{
        throw new Error(`${common.decodeErrPrefix} ${msg}`);
    };
}
const jump = [];
for(let i = 0; i <= 23; i++)jump[i] = invalidMinor;
jump[24] = _0uint.decodeUint8;
jump[25] = _0uint.decodeUint16;
jump[26] = _0uint.decodeUint32;
jump[27] = _0uint.decodeUint64;
jump[28] = invalidMinor;
jump[29] = invalidMinor;
jump[30] = invalidMinor;
jump[31] = invalidMinor;
for(let i = 32; i <= 55; i++)jump[i] = invalidMinor;
jump[56] = _1negint.decodeNegint8;
jump[57] = _1negint.decodeNegint16;
jump[58] = _1negint.decodeNegint32;
jump[59] = _1negint.decodeNegint64;
jump[60] = invalidMinor;
jump[61] = invalidMinor;
jump[62] = invalidMinor;
jump[63] = invalidMinor;
for(let i = 64; i <= 87; i++)jump[i] = _2bytes.decodeBytesCompact;
jump[88] = _2bytes.decodeBytes8;
jump[89] = _2bytes.decodeBytes16;
jump[90] = _2bytes.decodeBytes32;
jump[91] = _2bytes.decodeBytes64;
jump[92] = invalidMinor;
jump[93] = invalidMinor;
jump[94] = invalidMinor;
jump[95] = errorer("indefinite length bytes/strings are not supported");
for(let i = 96; i <= 119; i++)jump[i] = _3string.decodeStringCompact;
jump[120] = _3string.decodeString8;
jump[121] = _3string.decodeString16;
jump[122] = _3string.decodeString32;
jump[123] = _3string.decodeString64;
jump[124] = invalidMinor;
jump[125] = invalidMinor;
jump[126] = invalidMinor;
jump[127] = errorer("indefinite length bytes/strings are not supported");
for(let i = 128; i <= 151; i++)jump[i] = _4array.decodeArrayCompact;
jump[152] = _4array.decodeArray8;
jump[153] = _4array.decodeArray16;
jump[154] = _4array.decodeArray32;
jump[155] = _4array.decodeArray64;
jump[156] = invalidMinor;
jump[157] = invalidMinor;
jump[158] = invalidMinor;
jump[159] = _4array.decodeArrayIndefinite;
for(let i = 160; i <= 183; i++)jump[i] = _5map.decodeMapCompact;
jump[184] = _5map.decodeMap8;
jump[185] = _5map.decodeMap16;
jump[186] = _5map.decodeMap32;
jump[187] = _5map.decodeMap64;
jump[188] = invalidMinor;
jump[189] = invalidMinor;
jump[190] = invalidMinor;
jump[191] = _5map.decodeMapIndefinite;
for(let i = 192; i <= 215; i++)jump[i] = _6tag.decodeTagCompact;
jump[216] = _6tag.decodeTag8;
jump[217] = _6tag.decodeTag16;
jump[218] = _6tag.decodeTag32;
jump[219] = _6tag.decodeTag64;
jump[220] = invalidMinor;
jump[221] = invalidMinor;
jump[222] = invalidMinor;
jump[223] = invalidMinor;
for(let i = 224; i <= 243; i++)jump[i] = errorer("simple values are not supported");
jump[244] = invalidMinor;
jump[245] = invalidMinor;
jump[246] = invalidMinor;
jump[247] = _7float.decodeUndefined;
jump[248] = errorer("simple values are not supported");
jump[249] = _7float.decodeFloat16;
jump[250] = _7float.decodeFloat32;
jump[251] = _7float.decodeFloat64;
jump[252] = invalidMinor;
jump[253] = invalidMinor;
jump[254] = invalidMinor;
jump[255] = _7float.decodeBreak;
const quick = [];
for(let i = 0; i < 24; i++)quick[i] = new token.Token(token.Type.uint, i, 1);
for(let i = -1; i >= -24; i--)quick[31 - i] = new token.Token(token.Type.negint, i, 1);
quick[64] = new token.Token(token.Type.bytes, new Uint8Array(0), 1);
quick[96] = new token.Token(token.Type.string, "", 1);
quick[128] = new token.Token(token.Type.array, 0, 1);
quick[160] = new token.Token(token.Type.map, 0, 1);
quick[244] = new token.Token(token.Type.false, false, 1);
quick[245] = new token.Token(token.Type.true, true, 1);
quick[246] = new token.Token(token.Type.null, null, 1);
function quickEncodeToken(token$1) {
    switch(token$1.type){
        case token.Type.false:
            return byteUtils.fromArray([
                244
            ]);
        case token.Type.true:
            return byteUtils.fromArray([
                245
            ]);
        case token.Type.null:
            return byteUtils.fromArray([
                246
            ]);
        case token.Type.bytes:
            if (!token$1.value.length) return byteUtils.fromArray([
                64
            ]);
            return;
        case token.Type.string:
            if (token$1.value === "") return byteUtils.fromArray([
                96
            ]);
            return;
        case token.Type.array:
            if (token$1.value === 0) return byteUtils.fromArray([
                128
            ]);
            return;
        case token.Type.map:
            if (token$1.value === 0) return byteUtils.fromArray([
                160
            ]);
            return;
        case token.Type.uint:
            if (token$1.value < 24) return byteUtils.fromArray([
                Number(token$1.value)
            ]);
            return;
        case token.Type.negint:
            if (token$1.value >= -24) return byteUtils.fromArray([
                31 - Number(token$1.value)
            ]);
    }
}
exports.jump = jump;
exports.quick = quick;
exports.quickEncodeToken = quickEncodeToken;

},{"29e8810831c8a803":"4KSiO","efc4559b22d9669a":"iLmxl","b7e0d56f865ae009":"lxhwa","2bbcf7bef2f1195d":"7WuSE","3edb62615aa04539":"6ApoK","f7b93d0dd2ef7ce0":"eNWAz","df46a7f6d4858b86":"hEJjG","2c2755be0a2e2a24":"52sw2","62f61dbbe78c9769":"8ZyBv","b1ebc97b8a651431":"ddTQW","af3858d0b4d053bb":"cnzBn"}],"iLmxl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("6a5fc7ff5fb02684");
var common = require("b1bda3a8a0f90508");
const uintBoundaries = [
    24,
    256,
    65536,
    4294967296,
    BigInt("18446744073709551616")
];
function readUint8(data, offset, options) {
    common.assertEnoughData(data, offset, 1);
    const value = data[offset];
    if (options.strict === true && value < uintBoundaries[0]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    return value;
}
function readUint16(data, offset, options) {
    common.assertEnoughData(data, offset, 2);
    const value = data[offset] << 8 | data[offset + 1];
    if (options.strict === true && value < uintBoundaries[1]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    return value;
}
function readUint32(data, offset, options) {
    common.assertEnoughData(data, offset, 4);
    const value = data[offset] * 16777216 + (data[offset + 1] << 16) + (data[offset + 2] << 8) + data[offset + 3];
    if (options.strict === true && value < uintBoundaries[2]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    return value;
}
function readUint64(data, offset, options) {
    common.assertEnoughData(data, offset, 8);
    const hi = data[offset] * 16777216 + (data[offset + 1] << 16) + (data[offset + 2] << 8) + data[offset + 3];
    const lo = data[offset + 4] * 16777216 + (data[offset + 5] << 16) + (data[offset + 6] << 8) + data[offset + 7];
    const value = (BigInt(hi) << BigInt(32)) + BigInt(lo);
    if (options.strict === true && value < uintBoundaries[3]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    if (value <= Number.MAX_SAFE_INTEGER) return Number(value);
    if (options.allowBigInt === true) return value;
    throw new Error(`${common.decodeErrPrefix} integers outside of the safe integer range are not supported`);
}
function decodeUint8(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint8(data, pos + 1, options), 2);
}
function decodeUint16(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint16(data, pos + 1, options), 3);
}
function decodeUint32(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint32(data, pos + 1, options), 5);
}
function decodeUint64(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint64(data, pos + 1, options), 9);
}
function encodeUint(buf, token) {
    return encodeUintValue(buf, 0, token.value);
}
function encodeUintValue(buf, major, uint) {
    if (uint < uintBoundaries[0]) {
        const nuint = Number(uint);
        buf.push([
            major | nuint
        ]);
    } else if (uint < uintBoundaries[1]) {
        const nuint = Number(uint);
        buf.push([
            major | 24,
            nuint
        ]);
    } else if (uint < uintBoundaries[2]) {
        const nuint = Number(uint);
        buf.push([
            major | 25,
            nuint >>> 8,
            nuint & 255
        ]);
    } else if (uint < uintBoundaries[3]) {
        const nuint = Number(uint);
        buf.push([
            major | 26,
            nuint >>> 24 & 255,
            nuint >>> 16 & 255,
            nuint >>> 8 & 255,
            nuint & 255
        ]);
    } else {
        const buint = BigInt(uint);
        if (buint < uintBoundaries[4]) {
            const set = [
                major | 27,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            let lo = Number(buint & BigInt(4294967295));
            let hi = Number(buint >> BigInt(32) & BigInt(4294967295));
            set[8] = lo & 255;
            lo = lo >> 8;
            set[7] = lo & 255;
            lo = lo >> 8;
            set[6] = lo & 255;
            lo = lo >> 8;
            set[5] = lo & 255;
            set[4] = hi & 255;
            hi = hi >> 8;
            set[3] = hi & 255;
            hi = hi >> 8;
            set[2] = hi & 255;
            hi = hi >> 8;
            set[1] = hi & 255;
            buf.push(set);
        } else throw new Error(`${common.decodeErrPrefix} encountered BigInt larger than allowable range`);
    }
}
encodeUint.encodedSize = function encodedSize(token) {
    return encodeUintValue.encodedSize(token.value);
};
encodeUintValue.encodedSize = function encodedSize(uint) {
    if (uint < uintBoundaries[0]) return 1;
    if (uint < uintBoundaries[1]) return 2;
    if (uint < uintBoundaries[2]) return 3;
    if (uint < uintBoundaries[3]) return 5;
    return 9;
};
encodeUint.compareTokens = function compareTokens(tok1, tok2) {
    return tok1.value < tok2.value ? -1 : tok1.value > tok2.value ? 1 : 0;
};
exports.decodeUint16 = decodeUint16;
exports.decodeUint32 = decodeUint32;
exports.decodeUint64 = decodeUint64;
exports.decodeUint8 = decodeUint8;
exports.encodeUint = encodeUint;
exports.encodeUintValue = encodeUintValue;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.readUint64 = readUint64;
exports.readUint8 = readUint8;
exports.uintBoundaries = uintBoundaries;

},{"6a5fc7ff5fb02684":"4KSiO","b1bda3a8a0f90508":"ddTQW"}],"lxhwa":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("442378fa5d3fd9eb");
var _0uint = require("c024facf79cf5306");
var common = require("8e3895163a18dff6");
function decodeNegint8(data, pos, _minor, options) {
    return new token.Token(token.Type.negint, -1 - _0uint.readUint8(data, pos + 1, options), 2);
}
function decodeNegint16(data, pos, _minor, options) {
    return new token.Token(token.Type.negint, -1 - _0uint.readUint16(data, pos + 1, options), 3);
}
function decodeNegint32(data, pos, _minor, options) {
    return new token.Token(token.Type.negint, -1 - _0uint.readUint32(data, pos + 1, options), 5);
}
const neg1b = BigInt(-1);
const pos1b = BigInt(1);
function decodeNegint64(data, pos, _minor, options) {
    const int = _0uint.readUint64(data, pos + 1, options);
    if (typeof int !== "bigint") {
        const value = -1 - int;
        if (value >= Number.MIN_SAFE_INTEGER) return new token.Token(token.Type.negint, value, 9);
    }
    if (options.allowBigInt !== true) throw new Error(`${common.decodeErrPrefix} integers outside of the safe integer range are not supported`);
    return new token.Token(token.Type.negint, neg1b - BigInt(int), 9);
}
function encodeNegint(buf, token) {
    const negint = token.value;
    const unsigned = typeof negint === "bigint" ? negint * neg1b - pos1b : negint * -1 - 1;
    _0uint.encodeUintValue(buf, token.type.majorEncoded, unsigned);
}
encodeNegint.encodedSize = function encodedSize(token) {
    const negint = token.value;
    const unsigned = typeof negint === "bigint" ? negint * neg1b - pos1b : negint * -1 - 1;
    if (unsigned < _0uint.uintBoundaries[0]) return 1;
    if (unsigned < _0uint.uintBoundaries[1]) return 2;
    if (unsigned < _0uint.uintBoundaries[2]) return 3;
    if (unsigned < _0uint.uintBoundaries[3]) return 5;
    return 9;
};
encodeNegint.compareTokens = function compareTokens(tok1, tok2) {
    return tok1.value < tok2.value ? 1 : tok1.value > tok2.value ? -1 : 0;
};
exports.decodeNegint16 = decodeNegint16;
exports.decodeNegint32 = decodeNegint32;
exports.decodeNegint64 = decodeNegint64;
exports.decodeNegint8 = decodeNegint8;
exports.encodeNegint = encodeNegint;

},{"442378fa5d3fd9eb":"4KSiO","c024facf79cf5306":"iLmxl","8e3895163a18dff6":"ddTQW"}],"7WuSE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("e5fa5fecced10c3f");
var common = require("b42b6d1506e0be5d");
var _0uint = require("c8caa8feff3d44c3");
var byteUtils = require("b8ddce3603d641d2");
function toToken(data, pos, prefix, length) {
    common.assertEnoughData(data, pos, prefix + length);
    const buf = byteUtils.slice(data, pos + prefix, pos + prefix + length);
    return new token.Token(token.Type.bytes, buf, prefix + length);
}
function decodeBytesCompact(data, pos, minor, _options) {
    return toToken(data, pos, 1, minor);
}
function decodeBytes8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options));
}
function decodeBytes16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options));
}
function decodeBytes32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options));
}
function decodeBytes64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === "bigint") throw new Error(`${common.decodeErrPrefix} 64-bit integer bytes lengths not supported`);
    return toToken(data, pos, 9, l);
}
function tokenBytes(token$1) {
    if (token$1.encodedBytes === undefined) token$1.encodedBytes = token$1.type === token.Type.string ? byteUtils.fromString(token$1.value) : token$1.value;
    return token$1.encodedBytes;
}
function encodeBytes(buf, token) {
    const bytes = tokenBytes(token);
    _0uint.encodeUintValue(buf, token.type.majorEncoded, bytes.length);
    buf.push(bytes);
}
encodeBytes.encodedSize = function encodedSize(token) {
    const bytes = tokenBytes(token);
    return _0uint.encodeUintValue.encodedSize(bytes.length) + bytes.length;
};
encodeBytes.compareTokens = function compareTokens(tok1, tok2) {
    return compareBytes(tokenBytes(tok1), tokenBytes(tok2));
};
function compareBytes(b1, b2) {
    return b1.length < b2.length ? -1 : b1.length > b2.length ? 1 : byteUtils.compare(b1, b2);
}
exports.compareBytes = compareBytes;
exports.decodeBytes16 = decodeBytes16;
exports.decodeBytes32 = decodeBytes32;
exports.decodeBytes64 = decodeBytes64;
exports.decodeBytes8 = decodeBytes8;
exports.decodeBytesCompact = decodeBytesCompact;
exports.encodeBytes = encodeBytes;

},{"e5fa5fecced10c3f":"4KSiO","b42b6d1506e0be5d":"ddTQW","c8caa8feff3d44c3":"iLmxl","b8ddce3603d641d2":"cnzBn"}],"6ApoK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("6cffd868494ddcee");
var common = require("c609cb350f2835d1");
var _0uint = require("8acb5e72b5e5cce6");
var _2bytes = require("5bbca5c6f30bdfd6");
var byteUtils = require("d2b2e97a7c39982a");
function toToken(data, pos, prefix, length, options) {
    const totLength = prefix + length;
    common.assertEnoughData(data, pos, totLength);
    const tok = new token.Token(token.Type.string, byteUtils.toString(data, pos + prefix, pos + totLength), totLength);
    if (options.retainStringBytes === true) tok.byteValue = byteUtils.slice(data, pos + prefix, pos + totLength);
    return tok;
}
function decodeStringCompact(data, pos, minor, options) {
    return toToken(data, pos, 1, minor, options);
}
function decodeString8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options), options);
}
function decodeString16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options), options);
}
function decodeString32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options), options);
}
function decodeString64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === "bigint") throw new Error(`${common.decodeErrPrefix} 64-bit integer string lengths not supported`);
    return toToken(data, pos, 9, l, options);
}
const encodeString = _2bytes.encodeBytes;
exports.decodeString16 = decodeString16;
exports.decodeString32 = decodeString32;
exports.decodeString64 = decodeString64;
exports.decodeString8 = decodeString8;
exports.decodeStringCompact = decodeStringCompact;
exports.encodeString = encodeString;

},{"6cffd868494ddcee":"4KSiO","c609cb350f2835d1":"ddTQW","8acb5e72b5e5cce6":"iLmxl","5bbca5c6f30bdfd6":"7WuSE","d2b2e97a7c39982a":"cnzBn"}],"eNWAz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("ed71a5f66f1a4fbf");
var _0uint = require("f6df0ec2c9ca76b0");
var common = require("35f04e82a2a4f151");
function toToken(_data, _pos, prefix, length) {
    return new token.Token(token.Type.array, length, prefix);
}
function decodeArrayCompact(data, pos, minor, _options) {
    return toToken(data, pos, 1, minor);
}
function decodeArray8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options));
}
function decodeArray16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options));
}
function decodeArray32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options));
}
function decodeArray64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === "bigint") throw new Error(`${common.decodeErrPrefix} 64-bit integer array lengths not supported`);
    return toToken(data, pos, 9, l);
}
function decodeArrayIndefinite(data, pos, _minor, options) {
    if (options.allowIndefinite === false) throw new Error(`${common.decodeErrPrefix} indefinite length items not allowed`);
    return toToken(data, pos, 1, Infinity);
}
function encodeArray(buf, token$1) {
    _0uint.encodeUintValue(buf, token.Type.array.majorEncoded, token$1.value);
}
encodeArray.compareTokens = _0uint.encodeUint.compareTokens;
encodeArray.encodedSize = function encodedSize(token) {
    return _0uint.encodeUintValue.encodedSize(token.value);
};
exports.decodeArray16 = decodeArray16;
exports.decodeArray32 = decodeArray32;
exports.decodeArray64 = decodeArray64;
exports.decodeArray8 = decodeArray8;
exports.decodeArrayCompact = decodeArrayCompact;
exports.decodeArrayIndefinite = decodeArrayIndefinite;
exports.encodeArray = encodeArray;

},{"ed71a5f66f1a4fbf":"4KSiO","f6df0ec2c9ca76b0":"iLmxl","35f04e82a2a4f151":"ddTQW"}],"hEJjG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("77ec5bc62d7f7541");
var _0uint = require("acda14c93d7a6c0f");
var common = require("d488b60a13b57bf6");
function toToken(_data, _pos, prefix, length) {
    return new token.Token(token.Type.map, length, prefix);
}
function decodeMapCompact(data, pos, minor, _options) {
    return toToken(data, pos, 1, minor);
}
function decodeMap8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options));
}
function decodeMap16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options));
}
function decodeMap32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options));
}
function decodeMap64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === "bigint") throw new Error(`${common.decodeErrPrefix} 64-bit integer map lengths not supported`);
    return toToken(data, pos, 9, l);
}
function decodeMapIndefinite(data, pos, _minor, options) {
    if (options.allowIndefinite === false) throw new Error(`${common.decodeErrPrefix} indefinite length items not allowed`);
    return toToken(data, pos, 1, Infinity);
}
function encodeMap(buf, token$1) {
    _0uint.encodeUintValue(buf, token.Type.map.majorEncoded, token$1.value);
}
encodeMap.compareTokens = _0uint.encodeUint.compareTokens;
encodeMap.encodedSize = function encodedSize(token) {
    return _0uint.encodeUintValue.encodedSize(token.value);
};
exports.decodeMap16 = decodeMap16;
exports.decodeMap32 = decodeMap32;
exports.decodeMap64 = decodeMap64;
exports.decodeMap8 = decodeMap8;
exports.decodeMapCompact = decodeMapCompact;
exports.decodeMapIndefinite = decodeMapIndefinite;
exports.encodeMap = encodeMap;

},{"77ec5bc62d7f7541":"4KSiO","acda14c93d7a6c0f":"iLmxl","d488b60a13b57bf6":"ddTQW"}],"52sw2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("2f4509d0a0142f23");
var _0uint = require("fc7a770869b7a8f3");
function decodeTagCompact(_data, _pos, minor, _options) {
    return new token.Token(token.Type.tag, minor, 1);
}
function decodeTag8(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint8(data, pos + 1, options), 2);
}
function decodeTag16(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint16(data, pos + 1, options), 3);
}
function decodeTag32(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint32(data, pos + 1, options), 5);
}
function decodeTag64(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint64(data, pos + 1, options), 9);
}
function encodeTag(buf, token$1) {
    _0uint.encodeUintValue(buf, token.Type.tag.majorEncoded, token$1.value);
}
encodeTag.compareTokens = _0uint.encodeUint.compareTokens;
encodeTag.encodedSize = function encodedSize(token) {
    return _0uint.encodeUintValue.encodedSize(token.value);
};
exports.decodeTag16 = decodeTag16;
exports.decodeTag32 = decodeTag32;
exports.decodeTag64 = decodeTag64;
exports.decodeTag8 = decodeTag8;
exports.decodeTagCompact = decodeTagCompact;
exports.encodeTag = encodeTag;

},{"2f4509d0a0142f23":"4KSiO","fc7a770869b7a8f3":"iLmxl"}],"8ZyBv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var token = require("574d07bd71f75604");
var common = require("2cda160f97f0be62");
var _0uint = require("f7945f7014a9bebe");
const MINOR_FALSE = 20;
const MINOR_TRUE = 21;
const MINOR_NULL = 22;
const MINOR_UNDEFINED = 23;
function decodeUndefined(_data, _pos, _minor, options) {
    if (options.allowUndefined === false) throw new Error(`${common.decodeErrPrefix} undefined values are not supported`);
    else if (options.coerceUndefinedToNull === true) return new token.Token(token.Type.null, null, 1);
    return new token.Token(token.Type.undefined, undefined, 1);
}
function decodeBreak(_data, _pos, _minor, options) {
    if (options.allowIndefinite === false) throw new Error(`${common.decodeErrPrefix} indefinite length items not allowed`);
    return new token.Token(token.Type.break, undefined, 1);
}
function createToken(value, bytes, options) {
    if (options) {
        if (options.allowNaN === false && Number.isNaN(value)) throw new Error(`${common.decodeErrPrefix} NaN values are not supported`);
        if (options.allowInfinity === false && (value === Infinity || value === -Infinity)) throw new Error(`${common.decodeErrPrefix} Infinity values are not supported`);
    }
    return new token.Token(token.Type.float, value, bytes);
}
function decodeFloat16(data, pos, _minor, options) {
    return createToken(readFloat16(data, pos + 1), 3, options);
}
function decodeFloat32(data, pos, _minor, options) {
    return createToken(readFloat32(data, pos + 1), 5, options);
}
function decodeFloat64(data, pos, _minor, options) {
    return createToken(readFloat64(data, pos + 1), 9, options);
}
function encodeFloat(buf, token$1, options) {
    const float = token$1.value;
    if (float === false) buf.push([
        token.Type.float.majorEncoded | MINOR_FALSE
    ]);
    else if (float === true) buf.push([
        token.Type.float.majorEncoded | MINOR_TRUE
    ]);
    else if (float === null) buf.push([
        token.Type.float.majorEncoded | MINOR_NULL
    ]);
    else if (float === undefined) buf.push([
        token.Type.float.majorEncoded | MINOR_UNDEFINED
    ]);
    else {
        let decoded;
        let success = false;
        if (!options || options.float64 !== true) {
            encodeFloat16(float);
            decoded = readFloat16(ui8a, 1);
            if (float === decoded || Number.isNaN(float)) {
                ui8a[0] = 249;
                buf.push(ui8a.slice(0, 3));
                success = true;
            } else {
                encodeFloat32(float);
                decoded = readFloat32(ui8a, 1);
                if (float === decoded) {
                    ui8a[0] = 250;
                    buf.push(ui8a.slice(0, 5));
                    success = true;
                }
            }
        }
        if (!success) {
            encodeFloat64(float);
            decoded = readFloat64(ui8a, 1);
            ui8a[0] = 251;
            buf.push(ui8a.slice(0, 9));
        }
    }
}
encodeFloat.encodedSize = function encodedSize(token, options) {
    const float = token.value;
    if (float === false || float === true || float === null || float === undefined) return 1;
    if (!options || options.float64 !== true) {
        encodeFloat16(float);
        let decoded = readFloat16(ui8a, 1);
        if (float === decoded || Number.isNaN(float)) return 3;
        encodeFloat32(float);
        decoded = readFloat32(ui8a, 1);
        if (float === decoded) return 5;
    }
    return 9;
};
const buffer = new ArrayBuffer(9);
const dataView = new DataView(buffer, 1);
const ui8a = new Uint8Array(buffer, 0);
function encodeFloat16(inp) {
    if (inp === Infinity) dataView.setUint16(0, 31744, false);
    else if (inp === -Infinity) dataView.setUint16(0, 64512, false);
    else if (Number.isNaN(inp)) dataView.setUint16(0, 32256, false);
    else {
        dataView.setFloat32(0, inp);
        const valu32 = dataView.getUint32(0);
        const exponent = (valu32 & 2139095040) >> 23;
        const mantissa = valu32 & 8388607;
        if (exponent === 255) dataView.setUint16(0, 31744, false);
        else if (exponent === 0) dataView.setUint16(0, (inp & 2147483648) >> 16 | mantissa >> 13, false);
        else {
            const logicalExponent = exponent - 127;
            if (logicalExponent < -24) dataView.setUint16(0, 0);
            else if (logicalExponent < -14) dataView.setUint16(0, (valu32 & 2147483648) >> 16 | 1 << 24 + logicalExponent, false);
            else dataView.setUint16(0, (valu32 & 2147483648) >> 16 | logicalExponent + 15 << 10 | mantissa >> 13, false);
        }
    }
}
function readFloat16(ui8a, pos) {
    if (ui8a.length - pos < 2) throw new Error(`${common.decodeErrPrefix} not enough data for float16`);
    const half = (ui8a[pos] << 8) + ui8a[pos + 1];
    if (half === 31744) return Infinity;
    if (half === 64512) return -Infinity;
    if (half === 32256) return NaN;
    const exp = half >> 10 & 31;
    const mant = half & 1023;
    let val;
    if (exp === 0) val = mant * 2 ** -24;
    else if (exp !== 31) val = (mant + 1024) * 2 ** (exp - 25);
    else val = mant === 0 ? Infinity : NaN;
    return half & 32768 ? -val : val;
}
function encodeFloat32(inp) {
    dataView.setFloat32(0, inp, false);
}
function readFloat32(ui8a, pos) {
    if (ui8a.length - pos < 4) throw new Error(`${common.decodeErrPrefix} not enough data for float32`);
    const offset = (ui8a.byteOffset || 0) + pos;
    return new DataView(ui8a.buffer, offset, 4).getFloat32(0, false);
}
function encodeFloat64(inp) {
    dataView.setFloat64(0, inp, false);
}
function readFloat64(ui8a, pos) {
    if (ui8a.length - pos < 8) throw new Error(`${common.decodeErrPrefix} not enough data for float64`);
    const offset = (ui8a.byteOffset || 0) + pos;
    return new DataView(ui8a.buffer, offset, 8).getFloat64(0, false);
}
encodeFloat.compareTokens = _0uint.encodeUint.compareTokens;
exports.decodeBreak = decodeBreak;
exports.decodeFloat16 = decodeFloat16;
exports.decodeFloat32 = decodeFloat32;
exports.decodeFloat64 = decodeFloat64;
exports.decodeUndefined = decodeUndefined;
exports.encodeFloat = encodeFloat;

},{"574d07bd71f75604":"4KSiO","2cda160f97f0be62":"ddTQW","f7945f7014a9bebe":"iLmxl"}],"5hFFw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var common = require("caefc7605aaf4464");
var token = require("136f3b9c10f1046");
var jump = require("50bdb97cb7018123");
const defaultDecodeOptions = {
    strict: false,
    allowIndefinite: true,
    allowUndefined: true,
    allowBigInt: true
};
class Tokeniser {
    constructor(data, options = {}){
        this.pos = 0;
        this.data = data;
        this.options = options;
    }
    done() {
        return this.pos >= this.data.length;
    }
    next() {
        const byt = this.data[this.pos];
        let token = jump.quick[byt];
        if (token === undefined) {
            const decoder = jump.jump[byt];
            if (!decoder) throw new Error(`${common.decodeErrPrefix} no decoder for major type ${byt >>> 5} (byte 0x${byt.toString(16).padStart(2, "0")})`);
            const minor = byt & 31;
            token = decoder(this.data, this.pos, minor, this.options);
        }
        this.pos += token.encodedLength;
        return token;
    }
}
const DONE = Symbol.for("DONE");
const BREAK = Symbol.for("BREAK");
function tokenToArray(token, tokeniser, options) {
    const arr = [];
    for(let i = 0; i < token.value; i++){
        const value = tokensToObject(tokeniser, options);
        if (value === BREAK) {
            if (token.value === Infinity) break;
            throw new Error(`${common.decodeErrPrefix} got unexpected break to lengthed array`);
        }
        if (value === DONE) throw new Error(`${common.decodeErrPrefix} found array but not enough entries (got ${i}, expected ${token.value})`);
        arr[i] = value;
    }
    return arr;
}
function tokenToMap(token, tokeniser, options) {
    const useMaps = options.useMaps === true;
    const obj = useMaps ? undefined : {};
    const m = useMaps ? new Map() : undefined;
    for(let i = 0; i < token.value; i++){
        const key = tokensToObject(tokeniser, options);
        if (key === BREAK) {
            if (token.value === Infinity) break;
            throw new Error(`${common.decodeErrPrefix} got unexpected break to lengthed map`);
        }
        if (key === DONE) throw new Error(`${common.decodeErrPrefix} found map but not enough entries (got ${i} [no key], expected ${token.value})`);
        if (useMaps !== true && typeof key !== "string") throw new Error(`${common.decodeErrPrefix} non-string keys not supported (got ${typeof key})`);
        if (options.rejectDuplicateMapKeys === true) {
            if (useMaps && m.has(key) || !useMaps && key in obj) throw new Error(`${common.decodeErrPrefix} found repeat map key "${key}"`);
        }
        const value = tokensToObject(tokeniser, options);
        if (value === DONE) throw new Error(`${common.decodeErrPrefix} found map but not enough entries (got ${i} [no value], expected ${token.value})`);
        if (useMaps) m.set(key, value);
        else obj[key] = value;
    }
    return useMaps ? m : obj;
}
function tokensToObject(tokeniser, options) {
    if (tokeniser.done()) return DONE;
    const token$1 = tokeniser.next();
    if (token$1.type === token.Type.break) return BREAK;
    if (token$1.type.terminal) return token$1.value;
    if (token$1.type === token.Type.array) return tokenToArray(token$1, tokeniser, options);
    if (token$1.type === token.Type.map) return tokenToMap(token$1, tokeniser, options);
    if (token$1.type === token.Type.tag) {
        if (options.tags && typeof options.tags[token$1.value] === "function") {
            const tagged = tokensToObject(tokeniser, options);
            return options.tags[token$1.value](tagged);
        }
        throw new Error(`${common.decodeErrPrefix} tag not supported (${token$1.value})`);
    }
    throw new Error("unsupported");
}
function decode(data, options) {
    if (!(data instanceof Uint8Array)) throw new Error(`${common.decodeErrPrefix} data to decode must be a Uint8Array`);
    options = Object.assign({}, defaultDecodeOptions, options);
    const tokeniser = options.tokenizer || new Tokeniser(data, options);
    const decoded = tokensToObject(tokeniser, options);
    if (decoded === DONE) throw new Error(`${common.decodeErrPrefix} did not find any content to decode`);
    if (decoded === BREAK) throw new Error(`${common.decodeErrPrefix} got unexpected break`);
    if (!tokeniser.done()) throw new Error(`${common.decodeErrPrefix} too many terminals, data makes no sense`);
    return decoded;
}
exports.Tokeniser = Tokeniser;
exports.decode = decode;
exports.tokensToObject = tokensToObject;

},{"caefc7605aaf4464":"ddTQW","136f3b9c10f1046":"4KSiO","50bdb97cb7018123":"7MGTE"}],"5QI1M":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setEpochWrapper = exports.vrfProveWrapper = exports.ERR_BEACON_NOT_AVAILABLE_CODE = exports.MODULE_NAME = exports.BACKEND_VRF = exports.BACKEND_INSECURE = exports.METHOD_SET_EPOCH = exports.METHOD_VRF_PROVE = void 0;
const consensus = require("ae591ae3bb2afd45");
/**
 * MethodVRFProve is the method name for a VRF proof.
 */ exports.METHOD_VRF_PROVE = "beacon.VRFProve";
/**
 * MethodSetEpoch is the method name for setting epochs.
 */ exports.METHOD_SET_EPOCH = "000_beacon.SetEpoch";
/**
 * BackendInsecure is the name of the insecure backend.
 */ exports.BACKEND_INSECURE = "insecure";
/**
 * BackendVRF is the name of the VRF backend.
 */ exports.BACKEND_VRF = "vrf";
/**
 * ModuleName is a unique module name for the beacon module.
 */ exports.MODULE_NAME = "beacon";
/**
 * ErrBeaconNotAvailable is the error returned when a beacon is not
 * available for the requested height for any reason.
 */ exports.ERR_BEACON_NOT_AVAILABLE_CODE = 1;
function vrfProveWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_VRF_PROVE);
}
exports.vrfProveWrapper = vrfProveWrapper;
function setEpochWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_SET_EPOCH);
}
exports.setEpochWrapper = setEpochWrapper;

},{"ae591ae3bb2afd45":"9UvMb"}],"9UvMb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.visitTransaction = exports.TransactionWrapper = exports.hashSignedTransaction = exports.signSignedTransaction = exports.openSignedTransaction = exports.TRANSACTION_ERR_UPGRADE_PENDING = exports.TRANSACTION_ERR_GAS_PRICE_TOO_LOW_CODE = exports.TRANSACTION_ERR_INSUFFICIENT_FEE_BALANCE_CODE = exports.TRANSACTION_ERR_INVALID_NONCE_CODE = exports.TRANSACTION_MODULE_NAME = exports.ERR_INVALID_ARGUMENT_CODE = exports.ERR_DUPLICATE_TX_CODE = exports.ERR_UNSUPPORTED_CODE = exports.ERR_VERSION_NOT_FOUND_CODE = exports.ERR_OVERSIZED_TX_CODE = exports.ERR_NO_COMMITTED_BLOCKS_CODE = exports.MODULE_NAME = exports.TENDERMINT_BACKEND_NAME = exports.GAS_OP_TX_BYTE = exports.FEATURE_FULL_NODE = exports.FEATURE_SERVICES = exports.TRANSACTION_SIGNATURE_CONTEXT = exports.HEIGHT_LATEST = void 0;
const hash = require("4f0d1fc2254d4f36");
const misc = require("545a900ca1c9e1dc");
const quantity = require("8f83dc114c64df6");
const signature = require("bc5abe6e9c631876");
/**
 * HeightLatest is the height that represents the most recent block height.
 */ exports.HEIGHT_LATEST = 0n;
/**
 * SignatureContext is the context used for signing transactions.
 */ exports.TRANSACTION_SIGNATURE_CONTEXT = "oasis-core/consensus: tx";
/**
 * FeatureServices indicates support for communicating with consensus services.
 */ exports.FEATURE_SERVICES = 1;
/**
 * FeatureFullNode indicates that the consensus backend is independently fully verifying all
 * consensus-layer blocks.
 */ exports.FEATURE_FULL_NODE = 2;
/**
 * GasOpTxByte is the gas operation identifier for costing each transaction byte.
 */ exports.GAS_OP_TX_BYTE = "tx_byte";
/**
 * BackendName is the consensus backend name.
 */ exports.TENDERMINT_BACKEND_NAME = "tendermint";
/**
 * moduleName is the module name used for error definitions.
 */ exports.MODULE_NAME = "consensus";
/**
 * ErrNoCommittedBlocks is the error returned when there are no committed
 * blocks and as such no state can be queried.
 */ exports.ERR_NO_COMMITTED_BLOCKS_CODE = 1;
/**
 * ErrOversizedTx is the error returned when the given transaction is too big to be processed.
 */ exports.ERR_OVERSIZED_TX_CODE = 2;
/**
 * ErrVersionNotFound is the error returned when the given version (height) cannot be found,
 * possibly because it was pruned.
 */ exports.ERR_VERSION_NOT_FOUND_CODE = 3;
/**
 * ErrUnsupported is the error returned when the given method is not supported by the consensus
 * backend.
 */ exports.ERR_UNSUPPORTED_CODE = 4;
/**
 * ErrDuplicateTx is the error returned when the transaction already exists in the mempool.
 */ exports.ERR_DUPLICATE_TX_CODE = 5;
/**
 * ErrInvalidArgument is the error returned when the request contains an invalid argument.
 */ exports.ERR_INVALID_ARGUMENT_CODE = 6;
/**
 * moduleName is the module name used for error definitions.
 */ exports.TRANSACTION_MODULE_NAME = "consensus/transaction";
/**
 * ErrInvalidNonce is the error returned when a nonce is invalid.
 */ exports.TRANSACTION_ERR_INVALID_NONCE_CODE = 1;
/**
 * ErrInsufficientFeeBalance is the error returned when there is insufficient
 * balance to pay consensus fees.
 */ exports.TRANSACTION_ERR_INSUFFICIENT_FEE_BALANCE_CODE = 2;
/**
 * ErrGasPriceTooLow is the error returned when the gas price is too low.
 */ exports.TRANSACTION_ERR_GAS_PRICE_TOO_LOW_CODE = 3;
/**
 * ErrUpgradePending is the error returned when an upgrade is pending and the transaction thus
 * cannot be processed right now. The submitter should retry the transaction in this case.
 */ exports.TRANSACTION_ERR_UPGRADE_PENDING = 4;
async function openSignedTransaction(chainContext, signed) {
    const context = signature.combineChainContext(exports.TRANSACTION_SIGNATURE_CONTEXT, chainContext);
    return misc.fromCBOR(await signature.openSigned(context, signed));
}
exports.openSignedTransaction = openSignedTransaction;
async function signSignedTransaction(signer, chainContext, transaction) {
    const context = signature.combineChainContext(exports.TRANSACTION_SIGNATURE_CONTEXT, chainContext);
    return await signature.signSigned(signer, context, misc.toCBOR(transaction));
}
exports.signSignedTransaction = signSignedTransaction;
/**
 * This special hex-hash-of-the-CBOR-encoded signed transaction is useful for interoperability
 * with block explorers, so here's a special function for doing it.
 */ async function hashSignedTransaction(signed) {
    return misc.toHex(await hash.hash(misc.toCBOR(signed)));
}
exports.hashSignedTransaction = hashSignedTransaction;
class TransactionWrapper {
    constructor(method){
        this.transaction = {
            nonce: 0n,
            fee: {
                amount: quantity.fromBigInt(0n),
                gas: 0n
            },
            method
        };
        this.signedTransaction = null;
    }
    setNonce(nonce) {
        this.transaction.nonce = nonce;
        return this;
    }
    setFeeAmount(amount) {
        this.transaction.fee.amount = amount;
        return this;
    }
    setFeeGas(gas) {
        this.transaction.fee.gas = gas;
        return this;
    }
    setBody(body) {
        this.transaction.body = body;
        return this;
    }
    async estimateGas(nic, signer) {
        return await nic.consensusEstimateGas({
            signer,
            transaction: this.transaction
        });
    }
    async sign(signer, chainContext) {
        this.signedTransaction = await signSignedTransaction(signer, chainContext, this.transaction);
    }
    async hash() {
        return await hashSignedTransaction(this.signedTransaction);
    }
    async submit(nic) {
        await nic.consensusSubmitTx(this.signedTransaction);
    }
}
exports.TransactionWrapper = TransactionWrapper;
/**
 * Calls one of the handlers based on the given transaction method.
 * @param handlers Handlers, use an intersection of other modules'
 * `ConsensusTransactionHandlers` types to initialize the fields.
 * @param tx The transaction
 * @returns `true` if the transaction method matched one of the handlers
 */ function visitTransaction(handlers, tx) {
    if (handlers[tx.method]) {
        handlers[tx.method](tx.body);
        return true;
    }
    return false;
}
exports.visitTransaction = visitTransaction;

},{"4f0d1fc2254d4f36":"1sr6I","545a900ca1c9e1dc":"agInO","8f83dc114c64df6":"5AKEy","bc5abe6e9c631876":"3x9Lz"}],"5AKEy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromBigInt = exports.toBigInt = void 0;
const misc = require("b20403d5d17a1d2");
function toBigInt(q) {
    if (q.length === 0) return 0n;
    return BigInt("0x" + misc.toHex(q));
}
exports.toBigInt = toBigInt;
function fromBigInt(bi) {
    if (bi === 0n) return new Uint8Array();
    let hex = bi.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    return misc.fromHex(hex);
}
exports.fromBigInt = fromBigInt;

},{"b20403d5d17a1d2":"agInO"}],"3x9Lz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.visitMessage = exports.NaclSigner = exports.BlindContextSigner = exports.signMultiSigned = exports.openMultiSigned = exports.signSigned = exports.openSigned = exports.verify = exports.prepareSignerMessage = exports.combineChainContext = exports.CHAIN_CONTEXT_SEPARATOR = void 0;
const nacl = require("b5e966506aa4a940");
const hash = require("5321d378b70494be");
const misc = require("95e5ec0afb648406");
exports.CHAIN_CONTEXT_SEPARATOR = " for chain ";
function combineChainContext(context, chainContext) {
    return `${context}${exports.CHAIN_CONTEXT_SEPARATOR}${chainContext}`;
}
exports.combineChainContext = combineChainContext;
async function prepareSignerMessage(context, message) {
    return await hash.hash(misc.concat(misc.fromString(context), message));
}
exports.prepareSignerMessage = prepareSignerMessage;
async function verify(publicKey, context, message, signature) {
    const signerMessage = await prepareSignerMessage(context, message);
    const sigOk = nacl.sign.detached.verify(signerMessage, signature, publicKey);
    return sigOk;
}
exports.verify = verify;
async function openSigned(context, signed) {
    const sigOk = await verify(signed.signature.public_key, context, signed.untrusted_raw_value, signed.signature.signature);
    if (!sigOk) throw new Error("signature verification failed");
    return signed.untrusted_raw_value;
}
exports.openSigned = openSigned;
async function signSigned(signer, context, rawValue) {
    return {
        untrusted_raw_value: rawValue,
        signature: {
            public_key: signer.public(),
            signature: await signer.sign(context, rawValue)
        }
    };
}
exports.signSigned = signSigned;
async function openMultiSigned(context, multiSigned) {
    const signerMessage = await prepareSignerMessage(context, multiSigned.untrusted_raw_value);
    for (const signature of multiSigned.signatures){
        const sigOk = nacl.sign.detached.verify(signerMessage, signature.signature, signature.public_key);
        if (!sigOk) throw new Error("signature verification failed");
    }
    return multiSigned.untrusted_raw_value;
}
exports.openMultiSigned = openMultiSigned;
async function signMultiSigned(signers, context, rawValue) {
    const signatures = [];
    for (const signer of signers)signatures.push({
        public_key: signer.public(),
        signature: await signer.sign(context, rawValue)
    });
    return {
        untrusted_raw_value: rawValue,
        signatures: signatures
    };
}
exports.signMultiSigned = signMultiSigned;
class BlindContextSigner {
    constructor(signer){
        this.signer = signer;
    }
    public() {
        return this.signer.public();
    }
    async sign(context, message) {
        const signerMessage = await prepareSignerMessage(context, message);
        return await this.signer.sign(signerMessage);
    }
}
exports.BlindContextSigner = BlindContextSigner;
/**
 * An in-memory signer based on tweetnacl. We've included this for development.
 */ class NaclSigner {
    constructor(key, note){
        if (note !== "this key is not important") throw new Error("insecure signer implementation");
        this.key = key;
    }
    /**
     * Generate a keypair from a random seed
     * @param note Set to 'this key is not important' to acknowledge the risks
     * @returns Instance of NaclSigner
     */ static fromRandom(note) {
        const secret = new Uint8Array(32);
        crypto.getRandomValues(secret);
        return NaclSigner.fromSeed(secret, note);
    }
    /**
     * Instanciate from a given secret
     * @param secret 64 bytes ed25519 secret (h) that will be used to sign messages
     * @param note Set to 'this key is not important' to acknowledge the risks
     * @returns Instance of NaclSigner
     */ static fromSecret(secret, note) {
        const key = nacl.sign.keyPair.fromSecretKey(secret);
        return new NaclSigner(key, note);
    }
    /**
     * Instanciate from a given seed
     * @param seed 32 bytes ed25519 seed (k) that will deterministically generate a private key
     * @param note Set to 'this key is not important' to acknowledge the risks
     * @returns Instance of NaclSigner
     */ static fromSeed(seed, note) {
        const key = nacl.sign.keyPair.fromSeed(seed);
        return new NaclSigner(key, note);
    }
    /**
     * Returns the 32 bytes public key of this key pair
     * @returns Public key
     */ public() {
        return this.key.publicKey;
    }
    /**
     * Signs the given message
     * @param message Bytes to sign
     * @returns Signed message
     */ async sign(message) {
        return nacl.sign.detached(message, this.key.secretKey);
    }
}
exports.NaclSigner = NaclSigner;
/**
 * Calls one of the handlers based on the given context.
 * @param handlers Handlers, use an intersection of other modules'
 * `SignatureMessageHandlers*` types to initialize the fields.
 * @param context The context string as would be given to `ContextSigner.sign`
 * @param message The messsage as would be given to `ContextSigner.sign`
 * @returns `true` if the context matched one of the handlers
 */ function visitMessage(handlers, context, message) {
    // This doesn't support dynamic suffixes.
    {
        const parts = context.split(exports.CHAIN_CONTEXT_SEPARATOR);
        if (parts.length === 2) {
            const [context2, chainContext] = parts;
            if (handlers.withChainContext?.[context2]) {
                handlers.withChainContext[context2](chainContext, misc.fromCBOR(message));
                return true;
            }
            return false;
        }
    }
    if (handlers.bare?.[context]) {
        handlers.bare[context](misc.fromCBOR(message));
        return true;
    }
    return false;
}
exports.visitMessage = visitMessage;

},{"b5e966506aa4a940":"dbRqa","5321d378b70494be":"1sr6I","95e5ec0afb648406":"agInO"}],"dbRqa":[function(require,module,exports) {
(function(nacl) {
    "use strict";
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = require("64deaebb838d47b8");
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

},{"64deaebb838d47b8":"dayUX"}],"dayUX":[function(require,module,exports) {
"use strict";

},{}],"iXWTb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NodeInternal = exports.GRPCWrapper = exports.OasisCodedError = void 0;
const grpcWeb = require("9d1eb17909bce9fe");
const proto = require("6db49ae9491abcda");
const misc = require("f5d0aed926730b6");
function toCBOR(v) {
    // gRPC cannot handle nil arguments unmarshalled from CBOR, so we use a special case to
    // marshal `nil` to an empty byte string.
    if (v == null) return new Uint8Array();
    return misc.toCBOR(v);
}
function createMethodDescriptorUnary(serviceName, methodName) {
    const MethodType = grpcWeb.MethodType;
    return new grpcWeb.MethodDescriptor(`/oasis-core.${serviceName}/${methodName}`, MethodType.UNARY, null, null, toCBOR, misc.fromCBOR);
}
function createMethodDescriptorServerStreaming(serviceName, methodName) {
    const MethodType = grpcWeb.MethodType;
    return new grpcWeb.MethodDescriptor(`/oasis-core.${serviceName}/${methodName}`, MethodType.SERVER_STREAMING, null, null, toCBOR, misc.fromCBOR);
}
class OasisCodedError extends Error {
}
exports.OasisCodedError = OasisCodedError;
class GRPCWrapper {
    constructor(base){
        this.client = new grpcWeb.GrpcWebClientBase({});
        this.base = base;
    }
    callUnary(desc, request) {
        const method = this.base + desc.getName();
        // Some browsers with enormous market share aren't able to preserve the stack between here
        // and our `.catch` callback below. Save a copy explicitly.
        const invocationStack = new Error().stack;
        return this.client.thenableCall(method, request, // @ts-expect-error metadata nullability not modeled
        null, desc).catch((e)=>{
            if (e.metadata?.["grpc-status-details-bin"]) {
                const statusU8 = misc.fromBase64(e.metadata["grpc-status-details-bin"]);
                const status = proto.google.rpc.Status.decode(statusU8);
                const details = status.details;
                // `errorFromGrpc` from oasis-core checks for exactly one entry in Details.
                // We additionally check that the type URL is empty, consistent with how
                // `errorToGrpc` leaves it blank.
                if (details.length === 1 && details[0].type_url === "" && details[0].value) {
                    const grpcError = misc.fromCBOR(details[0].value);
                    const innerMessage = e.message || `Message missing, module=${grpcError.module} code=${grpcError.code}`;
                    const message = `callUnary method ${method}: ${innerMessage}`;
                    // @ts-expect-error options and cause not modeled
                    const wrapped = new OasisCodedError(message, {
                        cause: e
                    });
                    wrapped.oasisCode = grpcError.code;
                    wrapped.oasisModule = grpcError.module;
                    wrapped.stack += `
Cause stack:
${e.stack}
End of cause stack
Invocation stack:
${invocationStack}
End of invocation stack`;
                    throw wrapped;
                }
            }
            // Just in case there's some non-Error rejection reason that doesn't come with metadata
            // from oasis-core as expected above, try using JSON to stringify it so that we don't
            // end up with [object Object].
            const innerMessage = e instanceof Error ? e.toString() : JSON.stringify(e);
            const message = `callUnary method ${method}: ${innerMessage}`;
            // @ts-expect-error options and cause not modeled
            const wrapped = new Error(message, {
                cause: e
            });
            wrapped.stack += `
Cause stack:
${e.stack}
End of cause stack
Invocation stack:
${invocationStack}
End of invocation stack`;
            throw wrapped;
        });
    }
    callServerStreaming(desc, request) {
        return this.client.serverStreaming(this.base + desc.getName(), request, // @ts-expect-error metadata nullability not modeled
        null, desc);
    }
}
exports.GRPCWrapper = GRPCWrapper;
const methodDescriptorBeaconConsensusParameters = createMethodDescriptorUnary("Beacon", "ConsensusParameters");
const methodDescriptorBeaconGetBaseEpoch = createMethodDescriptorUnary("Beacon", "GetBaseEpoch");
const methodDescriptorBeaconGetBeacon = createMethodDescriptorUnary("Beacon", "GetBeacon");
const methodDescriptorBeaconGetEpoch = createMethodDescriptorUnary("Beacon", "GetEpoch");
const methodDescriptorBeaconGetEpochBlock = createMethodDescriptorUnary("Beacon", "GetEpochBlock");
const methodDescriptorBeaconGetFutureEpoch = createMethodDescriptorUnary("Beacon", "GetFutureEpoch");
const methodDescriptorBeaconStateToGenesis = createMethodDescriptorUnary("Beacon", "StateToGenesis");
const methodDescriptorBeaconWaitEpoch = createMethodDescriptorUnary("Beacon", "WaitEpoch");
const methodDescriptorBeaconWatchEpochs = createMethodDescriptorServerStreaming("Beacon", "WatchEpochs");
const methodDescriptorBeaconWatchLatestEpoch = createMethodDescriptorServerStreaming("Beacon", "WatchLatestEpoch");
const methodDescriptorSchedulerConsensusParameters = createMethodDescriptorUnary("Scheduler", "ConsensusParameters");
const methodDescriptorSchedulerGetCommittees = createMethodDescriptorUnary("Scheduler", "GetCommittees");
const methodDescriptorSchedulerGetValidators = createMethodDescriptorUnary("Scheduler", "GetValidators");
const methodDescriptorSchedulerStateToGenesis = createMethodDescriptorUnary("Scheduler", "StateToGenesis");
const methodDescriptorSchedulerWatchCommittees = createMethodDescriptorServerStreaming("Scheduler", "WatchCommittees");
const methodDescriptorRegistryConsensusParameters = createMethodDescriptorUnary("Registry", "ConsensusParameters");
const methodDescriptorRegistryGetEntities = createMethodDescriptorUnary("Registry", "GetEntities");
const methodDescriptorRegistryGetEntity = createMethodDescriptorUnary("Registry", "GetEntity");
const methodDescriptorRegistryGetEvents = createMethodDescriptorUnary("Registry", "GetEvents");
const methodDescriptorRegistryGetNode = createMethodDescriptorUnary("Registry", "GetNode");
const methodDescriptorRegistryGetNodeByConsensusAddress = createMethodDescriptorUnary("Registry", "GetNodeByConsensusAddress");
const methodDescriptorRegistryGetNodeStatus = createMethodDescriptorUnary("Registry", "GetNodeStatus");
const methodDescriptorRegistryGetNodes = createMethodDescriptorUnary("Registry", "GetNodes");
const methodDescriptorRegistryGetRuntime = createMethodDescriptorUnary("Registry", "GetRuntime");
const methodDescriptorRegistryGetRuntimes = createMethodDescriptorUnary("Registry", "GetRuntimes");
const methodDescriptorRegistryStateToGenesis = createMethodDescriptorUnary("Registry", "StateToGenesis");
const methodDescriptorRegistryWatchEntities = createMethodDescriptorServerStreaming("Registry", "WatchEntities");
const methodDescriptorRegistryWatchEvents = createMethodDescriptorServerStreaming("Registry", "WatchEvents");
const methodDescriptorRegistryWatchNodeList = createMethodDescriptorServerStreaming("Registry", "WatchNodeList");
const methodDescriptorRegistryWatchNodes = createMethodDescriptorServerStreaming("Registry", "WatchNodes");
const methodDescriptorRegistryWatchRuntimes = createMethodDescriptorServerStreaming("Registry", "WatchRuntimes");
const methodDescriptorStakingAccount = createMethodDescriptorUnary("Staking", "Account");
const methodDescriptorStakingAddresses = createMethodDescriptorUnary("Staking", "Addresses");
const methodDescriptorStakingAllowance = createMethodDescriptorUnary("Staking", "Allowance");
const methodDescriptorStakingCommissionScheduleAddresses = createMethodDescriptorUnary("Staking", "CommissionScheduleAddresses");
const methodDescriptorStakingCommonPool = createMethodDescriptorUnary("Staking", "CommonPool");
const methodDescriptorStakingConsensusParameters = createMethodDescriptorUnary("Staking", "ConsensusParameters");
const methodDescriptorStakingDebondingDelegationInfosFor = createMethodDescriptorUnary("Staking", "DebondingDelegationInfosFor");
const methodDescriptorStakingDebondingDelegationsFor = createMethodDescriptorUnary("Staking", "DebondingDelegationsFor");
const methodDescriptorStakingDebondingDelegationsTo = createMethodDescriptorUnary("Staking", "DebondingDelegationsTo");
const methodDescriptorStakingDelegationInfosFor = createMethodDescriptorUnary("Staking", "DelegationInfosFor");
const methodDescriptorStakingDelegationsFor = createMethodDescriptorUnary("Staking", "DelegationsFor");
const methodDescriptorStakingDelegationsTo = createMethodDescriptorUnary("Staking", "DelegationsTo");
const methodDescriptorStakingGetEvents = createMethodDescriptorUnary("Staking", "GetEvents");
const methodDescriptorStakingGovernanceDeposits = createMethodDescriptorUnary("Staking", "GovernanceDeposits");
const methodDescriptorStakingLastBlockFees = createMethodDescriptorUnary("Staking", "LastBlockFees");
const methodDescriptorStakingStateToGenesis = createMethodDescriptorUnary("Staking", "StateToGenesis");
const methodDescriptorStakingThreshold = createMethodDescriptorUnary("Staking", "Threshold");
const methodDescriptorStakingTokenSymbol = createMethodDescriptorUnary("Staking", "TokenSymbol");
const methodDescriptorStakingTokenValueExponent = createMethodDescriptorUnary("Staking", "TokenValueExponent");
const methodDescriptorStakingTotalSupply = createMethodDescriptorUnary("Staking", "TotalSupply");
const methodDescriptorStakingWatchEvents = createMethodDescriptorServerStreaming("Staking", "WatchEvents");
const methodDescriptorKeyManagerGetEphemeralSecret = createMethodDescriptorUnary("KeyManager", "GetEphemeralSecret");
const methodDescriptorKeyManagerGetMasterSecret = createMethodDescriptorUnary("KeyManager", "GetMasterSecret");
const methodDescriptorKeyManagerGetStatus = createMethodDescriptorUnary("KeyManager", "GetStatus");
const methodDescriptorKeyManagerGetStatuses = createMethodDescriptorUnary("KeyManager", "GetStatuses");
const methodDescriptorKeyManagerStateToGenesis = createMethodDescriptorUnary("KeyManager", "StateToGenesis");
const methodDescriptorKeyManagerWatchEphemeralSecrets = createMethodDescriptorServerStreaming("KeyManager", "WatchEphemeralSecrets");
const methodDescriptorKeyManagerWatchMasterSecrets = createMethodDescriptorServerStreaming("KeyManager", "WatchMasterSecrets");
const methodDescriptorKeyManagerWatchStatuses = createMethodDescriptorServerStreaming("KeyManager", "WatchStatuses");
const methodDescriptorRootHashConsensusParameters = createMethodDescriptorUnary("RootHash", "ConsensusParameters");
const methodDescriptorRootHashGetEvents = createMethodDescriptorUnary("RootHash", "GetEvents");
const methodDescriptorRootHashGetGenesisBlock = createMethodDescriptorUnary("RootHash", "GetGenesisBlock");
const methodDescriptorRootHashGetIncomingMessageQueue = createMethodDescriptorUnary("RootHash", "GetIncomingMessageQueue");
const methodDescriptorRootHashGetIncomingMessageQueueMeta = createMethodDescriptorUnary("RootHash", "GetIncomingMessageQueueMeta");
const methodDescriptorRootHashGetLastRoundResults = createMethodDescriptorUnary("RootHash", "GetLastRoundResults");
const methodDescriptorRootHashGetLatestBlock = createMethodDescriptorUnary("RootHash", "GetLatestBlock");
const methodDescriptorRootHashGetRuntimeState = createMethodDescriptorUnary("RootHash", "GetRuntimeState");
const methodDescriptorRootHashStateToGenesis = createMethodDescriptorUnary("RootHash", "StateToGenesis");
const methodDescriptorRootHashWatchBlocks = createMethodDescriptorServerStreaming("RootHash", "WatchBlocks");
const methodDescriptorRootHashWatchEvents = createMethodDescriptorServerStreaming("RootHash", "WatchEvents");
const methodDescriptorRootHashWatchExecutorCommitments = createMethodDescriptorServerStreaming("RootHash", "WatchExecutorCommitments");
const methodDescriptorGovernanceActiveProposals = createMethodDescriptorUnary("Governance", "ActiveProposals");
const methodDescriptorGovernanceConsensusParameters = createMethodDescriptorUnary("Governance", "ConsensusParameters");
const methodDescriptorGovernanceGetEvents = createMethodDescriptorUnary("Governance", "GetEvents");
const methodDescriptorGovernancePendingUpgrades = createMethodDescriptorUnary("Governance", "PendingUpgrades");
const methodDescriptorGovernanceProposal = createMethodDescriptorUnary("Governance", "Proposal");
const methodDescriptorGovernanceProposals = createMethodDescriptorUnary("Governance", "Proposals");
const methodDescriptorGovernanceStateToGenesis = createMethodDescriptorUnary("Governance", "StateToGenesis");
const methodDescriptorGovernanceVotes = createMethodDescriptorUnary("Governance", "Votes");
const methodDescriptorGovernanceWatchEvents = createMethodDescriptorServerStreaming("Governance", "WatchEvents");
const methodDescriptorStorageGetCheckpointChunk = createMethodDescriptorServerStreaming("Storage", "GetCheckpointChunk");
const methodDescriptorStorageGetCheckpoints = createMethodDescriptorUnary("Storage", "GetCheckpoints");
const methodDescriptorStorageGetDiff = createMethodDescriptorServerStreaming("Storage", "GetDiff");
const methodDescriptorStorageSyncGet = createMethodDescriptorUnary("Storage", "SyncGet");
const methodDescriptorStorageSyncGetPrefixes = createMethodDescriptorUnary("Storage", "SyncGetPrefixes");
const methodDescriptorStorageSyncIterate = createMethodDescriptorUnary("Storage", "SyncIterate");
const methodDescriptorStorageWorkerGetLastSyncedRound = createMethodDescriptorUnary("StorageWorker", "GetLastSyncedRound");
const methodDescriptorStorageWorkerPauseCheckpointer = createMethodDescriptorUnary("StorageWorker", "PauseCheckpointer");
const methodDescriptorRuntimeClientCheckTx = createMethodDescriptorUnary("RuntimeClient", "CheckTx");
const methodDescriptorRuntimeClientGetBlock = createMethodDescriptorUnary("RuntimeClient", "GetBlock");
const methodDescriptorRuntimeClientGetEvents = createMethodDescriptorUnary("RuntimeClient", "GetEvents");
const methodDescriptorRuntimeClientGetGenesisBlock = createMethodDescriptorUnary("RuntimeClient", "GetGenesisBlock");
const methodDescriptorRuntimeClientGetLastRetainedBlock = createMethodDescriptorUnary("RuntimeClient", "GetLastRetainedBlock");
const methodDescriptorRuntimeClientGetTransactions = createMethodDescriptorUnary("RuntimeClient", "GetTransactions");
const methodDescriptorRuntimeClientGetTransactionsWithResults = createMethodDescriptorUnary("RuntimeClient", "GetTransactionsWithResults");
const methodDescriptorRuntimeClientQuery = createMethodDescriptorUnary("RuntimeClient", "Query");
const methodDescriptorRuntimeClientSubmitTx = createMethodDescriptorUnary("RuntimeClient", "SubmitTx");
const methodDescriptorRuntimeClientSubmitTxMeta = createMethodDescriptorUnary("RuntimeClient", "SubmitTxMeta");
const methodDescriptorRuntimeClientSubmitTxNoWait = createMethodDescriptorUnary("RuntimeClient", "SubmitTxNoWait");
const methodDescriptorRuntimeClientWatchBlocks = createMethodDescriptorServerStreaming("RuntimeClient", "WatchBlocks");
const methodDescriptorConsensusEstimateGas = createMethodDescriptorUnary("Consensus", "EstimateGas");
const methodDescriptorConsensusGetBlock = createMethodDescriptorUnary("Consensus", "GetBlock");
const methodDescriptorConsensusGetChainContext = createMethodDescriptorUnary("Consensus", "GetChainContext");
const methodDescriptorConsensusGetGenesisDocument = createMethodDescriptorUnary("Consensus", "GetGenesisDocument");
const methodDescriptorConsensusGetLightBlock = createMethodDescriptorUnary("Consensus", "GetLightBlock");
const methodDescriptorConsensusGetLightBlockForState = createMethodDescriptorUnary("Consensus", "GetLightBlockForState");
const methodDescriptorConsensusGetNextBlockState = createMethodDescriptorUnary("Consensus", "GetNextBlockState");
const methodDescriptorConsensusGetParameters = createMethodDescriptorUnary("Consensus", "GetParameters");
const methodDescriptorConsensusGetSignerNonce = createMethodDescriptorUnary("Consensus", "GetSignerNonce");
const methodDescriptorConsensusGetStatus = createMethodDescriptorUnary("Consensus", "GetStatus");
const methodDescriptorConsensusGetTransactions = createMethodDescriptorUnary("Consensus", "GetTransactions");
const methodDescriptorConsensusGetTransactionsWithProofs = createMethodDescriptorUnary("Consensus", "GetTransactionsWithProofs");
const methodDescriptorConsensusGetTransactionsWithResults = createMethodDescriptorUnary("Consensus", "GetTransactionsWithResults");
const methodDescriptorConsensusGetUnconfirmedTransactions = createMethodDescriptorUnary("Consensus", "GetUnconfirmedTransactions");
const methodDescriptorConsensusStateToGenesis = createMethodDescriptorUnary("Consensus", "StateToGenesis");
const methodDescriptorConsensusSubmitEvidence = createMethodDescriptorUnary("Consensus", "SubmitEvidence");
const methodDescriptorConsensusSubmitTx = createMethodDescriptorUnary("Consensus", "SubmitTx");
const methodDescriptorConsensusSubmitTxNoWait = createMethodDescriptorUnary("Consensus", "SubmitTxNoWait");
const methodDescriptorConsensusSubmitTxWithProof = createMethodDescriptorUnary("Consensus", "SubmitTxWithProof");
const methodDescriptorConsensusWatchBlocks = createMethodDescriptorServerStreaming("Consensus", "WatchBlocks");
const methodDescriptorConsensusStateSyncGet = createMethodDescriptorUnary("Consensus", "StateSyncGet");
const methodDescriptorConsensusStateSyncGetPrefixes = createMethodDescriptorUnary("Consensus", "StateSyncGetPrefixes");
const methodDescriptorConsensusStateSyncIterate = createMethodDescriptorUnary("Consensus", "StateSyncIterate");
const methodDescriptorNodeControllerCancelUpgrade = createMethodDescriptorUnary("NodeController", "CancelUpgrade");
const methodDescriptorNodeControllerGetStatus = createMethodDescriptorUnary("NodeController", "GetStatus");
const methodDescriptorNodeControllerIsReady = createMethodDescriptorUnary("NodeController", "IsReady");
const methodDescriptorNodeControllerIsSynced = createMethodDescriptorUnary("NodeController", "IsSynced");
const methodDescriptorNodeControllerRequestShutdown = createMethodDescriptorUnary("NodeController", "RequestShutdown");
const methodDescriptorNodeControllerUpgradeBinary = createMethodDescriptorUnary("NodeController", "UpgradeBinary");
const methodDescriptorNodeControllerWaitReady = createMethodDescriptorUnary("NodeController", "WaitReady");
const methodDescriptorNodeControllerWaitSync = createMethodDescriptorUnary("NodeController", "WaitSync");
const methodDescriptorDebugControllerSetEpoch = createMethodDescriptorUnary("DebugController", "SetEpoch");
const methodDescriptorDebugControllerWaitNodesRegistered = createMethodDescriptorUnary("DebugController", "WaitNodesRegistered");
class NodeInternal extends GRPCWrapper {
    constructor(base){
        super(base);
    }
    /**
     * ConsensusParameters returns the beacon consensus parameters.
     */ beaconConsensusParameters(height) {
        return this.callUnary(methodDescriptorBeaconConsensusParameters, height);
    }
    /**
     * GetBaseEpoch returns the base epoch.
     */ beaconGetBaseEpoch() {
        return this.callUnary(methodDescriptorBeaconGetBaseEpoch, undefined);
    }
    /**
     * GetBeacon gets the beacon for the provided block height.
     * Calling this method with height `consensus.HeightLatest` should
     * return the beacon for the latest finalized block.
     */ beaconGetBeacon(height) {
        return this.callUnary(methodDescriptorBeaconGetBeacon, height);
    }
    /**
     * GetEpoch returns the epoch number at the specified block height.
     * Calling this method with height `consensus.HeightLatest`, should
     * return the epoch of latest known block.
     */ beaconGetEpoch(height) {
        return this.callUnary(methodDescriptorBeaconGetEpoch, height);
    }
    /**
     * GetEpochBlock returns the block height at the start of the said
     * epoch.
     */ beaconGetEpochBlock(epoch) {
        return this.callUnary(methodDescriptorBeaconGetEpochBlock, epoch);
    }
    /**
     * GetFutureEpoch returns any future epoch that is currently scheduled
     * to occur at a specific height.
     *
     * Note that this may return a nil state in case no future epoch is
     * currently scheduled.
     */ beaconGetFutureEpoch(height) {
        return this.callUnary(methodDescriptorBeaconGetFutureEpoch, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ beaconStateToGenesis(height) {
        return this.callUnary(methodDescriptorBeaconStateToGenesis, height);
    }
    /**
     * WaitEpoch waits for a specific epoch.
     *
     * Note that an epoch is considered reached even if any epoch greater
     * than the one specified is reached (e.g., that the current epoch
     * is already in the future).
     */ beaconWaitEpoch(epoch) {
        return this.callUnary(methodDescriptorBeaconWaitEpoch, epoch);
    }
    /**
     * WatchEpochs returns a channel that produces a stream of messages
     * on epoch transitions.
     *
     * Upon subscription the current epoch is sent immediately.
     */ beaconWatchEpochs() {
        return this.callServerStreaming(methodDescriptorBeaconWatchEpochs, undefined);
    }
    /**
     * WatchLatestEpoch returns a channel that produces a stream of
     * messages on epoch transitions. If an epoch transition happens
     * before the previous epoch is read from the channel, the old
     * epochs are overwritten.
     *
     * Upon subscription the current epoch is sent immediately.
     */ beaconWatchLatestEpoch() {
        return this.callServerStreaming(methodDescriptorBeaconWatchLatestEpoch, undefined);
    }
    /**
     * ConsensusParameters returns the scheduler consensus parameters.
     */ schedulerConsensusParameters(height) {
        return this.callUnary(methodDescriptorSchedulerConsensusParameters, height);
    }
    /**
     * GetCommittees returns the vector of committees for a given
     * runtime ID, at the specified block height, and optional callback
     * for querying the beacon for a given epoch/block height.
     *
     * Iff the callback is nil, `beacon.GetBlockBeacon` will be used.
     */ schedulerGetCommittees(request) {
        return this.callUnary(methodDescriptorSchedulerGetCommittees, request);
    }
    /**
     * GetValidators returns the vector of consensus validators for
     * a given epoch.
     */ schedulerGetValidators(height) {
        return this.callUnary(methodDescriptorSchedulerGetValidators, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ schedulerStateToGenesis(height) {
        return this.callUnary(methodDescriptorSchedulerStateToGenesis, height);
    }
    /**
     * WatchCommittees returns a channel that produces a stream of
     * Committee.
     *
     * Upon subscription, all committees for the current epoch will
     * be sent immediately.
     */ schedulerWatchCommittees() {
        return this.callServerStreaming(methodDescriptorSchedulerWatchCommittees, undefined);
    }
    /**
     * ConsensusParameters returns the registry consensus parameters.
     */ registryConsensusParameters(height) {
        return this.callUnary(methodDescriptorRegistryConsensusParameters, height);
    }
    /**
     * GetEntities gets a list of all registered entities.
     */ registryGetEntities(height) {
        return this.callUnary(methodDescriptorRegistryGetEntities, height);
    }
    /**
     * GetEntity gets an entity by ID.
     */ registryGetEntity(query) {
        return this.callUnary(methodDescriptorRegistryGetEntity, query);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ registryGetEvents(height) {
        return this.callUnary(methodDescriptorRegistryGetEvents, height);
    }
    /**
     * GetNode gets a node by ID.
     */ registryGetNode(query) {
        return this.callUnary(methodDescriptorRegistryGetNode, query);
    }
    /**
     * GetNodeByConsensusAddress looks up a node by its consensus address at the
     * specified block height. The nature and format of the consensus address depends
     * on the specific consensus backend implementation used.
     */ registryGetNodeByConsensusAddress(query) {
        return this.callUnary(methodDescriptorRegistryGetNodeByConsensusAddress, query);
    }
    /**
     * GetNodeStatus returns a node's status.
     */ registryGetNodeStatus(query) {
        return this.callUnary(methodDescriptorRegistryGetNodeStatus, query);
    }
    /**
     * GetNodes gets a list of all registered nodes.
     */ registryGetNodes(height) {
        return this.callUnary(methodDescriptorRegistryGetNodes, height);
    }
    /**
     * GetRuntime gets a runtime by ID.
     */ registryGetRuntime(query) {
        return this.callUnary(methodDescriptorRegistryGetRuntime, query);
    }
    /**
     * GetRuntimes returns the registered Runtimes at the specified
     * block height.
     */ registryGetRuntimes(query) {
        return this.callUnary(methodDescriptorRegistryGetRuntimes, query);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ registryStateToGenesis(height) {
        return this.callUnary(methodDescriptorRegistryStateToGenesis, height);
    }
    /**
     * WatchEntities returns a channel that produces a stream of
     * EntityEvent on entity registration changes.
     */ registryWatchEntities() {
        return this.callServerStreaming(methodDescriptorRegistryWatchEntities, undefined);
    }
    /**
     * WatchEvents returns a channel that produces a stream of Events.
     */ registryWatchEvents() {
        return this.callServerStreaming(methodDescriptorRegistryWatchEvents, undefined);
    }
    /**
     * WatchNodeList returns a channel that produces a stream of NodeList.
     * Upon subscription, the node list for the current epoch will be sent
     * immediately.
     *
     * Each node list will be sorted by node ID in lexicographically ascending
     * order.
     */ registryWatchNodeList() {
        return this.callServerStreaming(methodDescriptorRegistryWatchNodeList, undefined);
    }
    /**
     * WatchNodes returns a channel that produces a stream of
     * NodeEvent on node registration changes.
     */ registryWatchNodes() {
        return this.callServerStreaming(methodDescriptorRegistryWatchNodes, undefined);
    }
    /**
     * WatchRuntimes returns a stream of Runtime.  Upon subscription,
     * all runtimes will be sent immediately.
     */ registryWatchRuntimes() {
        return this.callServerStreaming(methodDescriptorRegistryWatchRuntimes, undefined);
    }
    /**
     * Account returns the account descriptor for the given account.
     */ stakingAccount(query) {
        return this.callUnary(methodDescriptorStakingAccount, query);
    }
    /**
     * Addresses returns the addresses of all accounts with a non-zero general
     * or escrow balance.
     */ stakingAddresses(height) {
        return this.callUnary(methodDescriptorStakingAddresses, height);
    }
    /**
     * Allowance looks up the allowance for the given owner/beneficiary combination.
     */ stakingAllowance(query) {
        return this.callUnary(methodDescriptorStakingAllowance, query);
    }
    /**
     * CommissionScheduleAddresses returns the addresses of all accounts with
     * non-empty commission schedule.
     */ stakingCommissionScheduleAddresses(height) {
        return this.callUnary(methodDescriptorStakingCommissionScheduleAddresses, height);
    }
    /**
     * CommonPool returns the common pool balance.
     */ stakingCommonPool(height) {
        return this.callUnary(methodDescriptorStakingCommonPool, height);
    }
    /**
     * ConsensusParameters returns the staking consensus parameters.
     */ stakingConsensusParameters(height) {
        return this.callUnary(methodDescriptorStakingConsensusParameters, height);
    }
    /**
     * DebondingDelegationsInfosFor returns (outgoing) debonding delegations
     * with additional information for the given owner (delegator).
     */ stakingDebondingDelegationInfosFor(query) {
        return this.callUnary(methodDescriptorStakingDebondingDelegationInfosFor, query);
    }
    /**
     * DebondingDelegationsFor returns the list of (outgoing) debonding
     * delegations for the given owner (delegator).
     */ stakingDebondingDelegationsFor(query) {
        return this.callUnary(methodDescriptorStakingDebondingDelegationsFor, query);
    }
    /**
     * DebondingDelegationsTo returns the list of (incoming) debonding
     * delegations to the given account.
     */ stakingDebondingDelegationsTo(query) {
        return this.callUnary(methodDescriptorStakingDebondingDelegationsTo, query);
    }
    /**
     * DelegationsInfosFor returns (outgoing) delegations with additional
     * information for the given owner (delegator).
     */ stakingDelegationInfosFor(query) {
        return this.callUnary(methodDescriptorStakingDelegationInfosFor, query);
    }
    /**
     * DelegationsFor returns the list of (outgoing) delegations for the given
     * owner (delegator).
     */ stakingDelegationsFor(query) {
        return this.callUnary(methodDescriptorStakingDelegationsFor, query);
    }
    /**
     * DelegationsTo returns the list of (incoming) delegations to the given
     * account.
     */ stakingDelegationsTo(query) {
        return this.callUnary(methodDescriptorStakingDelegationsTo, query);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ stakingGetEvents(height) {
        return this.callUnary(methodDescriptorStakingGetEvents, height);
    }
    /**
     * GovernanceDeposits returns the governance deposits account balance.
     */ stakingGovernanceDeposits(height) {
        return this.callUnary(methodDescriptorStakingGovernanceDeposits, height);
    }
    /**
     * LastBlockFees returns the collected fees for previous block.
     */ stakingLastBlockFees(height) {
        return this.callUnary(methodDescriptorStakingLastBlockFees, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ stakingStateToGenesis(height) {
        return this.callUnary(methodDescriptorStakingStateToGenesis, height);
    }
    /**
     * Threshold returns the specific staking threshold by kind.
     */ stakingThreshold(query) {
        return this.callUnary(methodDescriptorStakingThreshold, query);
    }
    /**
     * TokenSymbol returns the token's ticker symbol.
     */ stakingTokenSymbol() {
        return this.callUnary(methodDescriptorStakingTokenSymbol, undefined);
    }
    /**
     * TokenValueExponent is the token's value base-10 exponent, i.e.
     * 1 token = 10**TokenValueExponent base units.
     */ stakingTokenValueExponent() {
        return this.callUnary(methodDescriptorStakingTokenValueExponent, undefined);
    }
    /**
     * TotalSupply returns the total number of base units.
     */ stakingTotalSupply(height) {
        return this.callUnary(methodDescriptorStakingTotalSupply, height);
    }
    /**
     * WatchEvents returns a channel that produces a stream of Events.
     */ stakingWatchEvents() {
        return this.callServerStreaming(methodDescriptorStakingWatchEvents, undefined);
    }
    /**
     * GetEphemeralSecret returns the key manager ephemeral secret.
     */ keyManagerGetEphemeralSecret(query) {
        return this.callUnary(methodDescriptorKeyManagerGetEphemeralSecret, query);
    }
    /**
     * GetMasterSecret returns the key manager master secret.
     */ keyManagerGetMasterSecret(query) {
        return this.callUnary(methodDescriptorKeyManagerGetMasterSecret, query);
    }
    /**
     * GetStatus returns a key manager status by key manager ID.
     */ keyManagerGetStatus(query) {
        return this.callUnary(methodDescriptorKeyManagerGetStatus, query);
    }
    /**
     * GetStatuses returns all currently tracked key manager statuses.
     */ keyManagerGetStatuses(height) {
        return this.callUnary(methodDescriptorKeyManagerGetStatuses, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ keyManagerStateToGenesis(height) {
        return this.callUnary(methodDescriptorKeyManagerStateToGenesis, height);
    }
    /**
     * WatchEphemeralSecrets returns a channel that produces a stream of ephemeral secrets.
     */ keyManagerWatchEphemeralSecrets() {
        return this.callServerStreaming(methodDescriptorKeyManagerWatchEphemeralSecrets, undefined);
    }
    /**
     * WatchMasterSecrets returns a channel that produces a stream of master secrets.
     */ keyManagerWatchMasterSecrets() {
        return this.callServerStreaming(methodDescriptorKeyManagerWatchMasterSecrets, undefined);
    }
    /**
     * WatchStatuses returns a channel that produces a stream of messages
     * containing the key manager statuses as it changes over time.
     *
     * Upon subscription the current status is sent immediately.
     */ keyManagerWatchStatuses() {
        return this.callServerStreaming(methodDescriptorKeyManagerWatchStatuses, undefined);
    }
    /**
     * ConsensusParameters returns the roothash consensus parameters.
     */ rootHashConsensusParameters(height) {
        return this.callUnary(methodDescriptorRootHashConsensusParameters, height);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ rootHashGetEvents(height) {
        return this.callUnary(methodDescriptorRootHashGetEvents, height);
    }
    /**
     * GetGenesisBlock returns the genesis block.
     */ rootHashGetGenesisBlock(request) {
        return this.callUnary(methodDescriptorRootHashGetGenesisBlock, request);
    }
    /**
     * GetIncomingMessageQueue returns the given runtime's queued incoming messages.
     */ rootHashGetIncomingMessageQueue(request) {
        return this.callUnary(methodDescriptorRootHashGetIncomingMessageQueue, request);
    }
    /**
     * GetIncomingMessageQueueMeta returns the given runtime's incoming message queue metadata.
     */ rootHashGetIncomingMessageQueueMeta(request) {
        return this.callUnary(methodDescriptorRootHashGetIncomingMessageQueueMeta, request);
    }
    /**
     * GetLastRoundResults returns the given runtime's last normal round results.
     */ rootHashGetLastRoundResults(request) {
        return this.callUnary(methodDescriptorRootHashGetLastRoundResults, request);
    }
    /**
     * GetLatestBlock returns the latest block.
     *
     * The metadata contained in this block can be further used to get
     * the latest state from the storage backend.
     */ rootHashGetLatestBlock(request) {
        return this.callUnary(methodDescriptorRootHashGetLatestBlock, request);
    }
    /**
     * GetRuntimeState returns the given runtime's state.
     */ rootHashGetRuntimeState(request) {
        return this.callUnary(methodDescriptorRootHashGetRuntimeState, request);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ rootHashStateToGenesis(height) {
        return this.callUnary(methodDescriptorRootHashStateToGenesis, height);
    }
    /**
     * WatchBlocks returns a channel that produces a stream of
     * annotated blocks.
     *
     * The latest block if any will get pushed to the stream immediately.
     * Subsequent blocks will be pushed into the stream as they are
     * confirmed.
     */ rootHashWatchBlocks(runtimeID) {
        return this.callServerStreaming(methodDescriptorRootHashWatchBlocks, runtimeID);
    }
    /**
     * WatchEvents returns a stream of protocol events.
     */ rootHashWatchEvents(runtimeID) {
        return this.callServerStreaming(methodDescriptorRootHashWatchEvents, runtimeID);
    }
    /**
     * WatchExecutorCommitments returns a channel that produces a stream of executor commitments
     * observed in the consensus layer P2P network.
     *
     * Note that these commitments may not have been processed by consensus, commitments may be
     * received in any order and duplicates are possible.
     */ rootHashWatchExecutorCommitments() {
        return this.callServerStreaming(methodDescriptorRootHashWatchExecutorCommitments, undefined);
    }
    /**
     * ActiveProposals returns a list of all proposals that have not yet closed.
     */ governanceActiveProposals(height) {
        return this.callUnary(methodDescriptorGovernanceActiveProposals, height);
    }
    /**
     * ConsensusParameters returns the governance consensus parameters.
     */ governanceConsensusParameters(height) {
        return this.callUnary(methodDescriptorGovernanceConsensusParameters, height);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ governanceGetEvents(height) {
        return this.callUnary(methodDescriptorGovernanceGetEvents, height);
    }
    /**
     * PendingUpgrades returns a list of all pending upgrades.
     */ governancePendingUpgrades(height) {
        return this.callUnary(methodDescriptorGovernancePendingUpgrades, height);
    }
    /**
     * Proposal looks up a specific proposal.
     */ governanceProposal(query) {
        return this.callUnary(methodDescriptorGovernanceProposal, query);
    }
    /**
     * Proposals returns a list of all proposals.
     */ governanceProposals(height) {
        return this.callUnary(methodDescriptorGovernanceProposals, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ governanceStateToGenesis(height) {
        return this.callUnary(methodDescriptorGovernanceStateToGenesis, height);
    }
    /**
     * Votes looks up votes for a specific proposal.
     */ governanceVotes(query) {
        return this.callUnary(methodDescriptorGovernanceVotes, query);
    }
    /**
     * WatchEvents returns a channel that produces a stream of Events.
     */ governanceWatchEvents() {
        return this.callServerStreaming(methodDescriptorGovernanceWatchEvents, undefined);
    }
    /**
     * GetCheckpointChunk fetches a specific chunk from an existing chekpoint.
     */ storageGetCheckpointChunk(chunk) {
        return this.callServerStreaming(methodDescriptorStorageGetCheckpointChunk, chunk);
    }
    /**
     * GetCheckpoints returns a list of checkpoint metadata for all known checkpoints.
     */ storageGetCheckpoints(request) {
        return this.callUnary(methodDescriptorStorageGetCheckpoints, request);
    }
    /**
     * GetDiff returns an iterator of write log entries that must be applied
     * to get from the first given root to the second one.
     */ storageGetDiff(request) {
        return this.callServerStreaming(methodDescriptorStorageGetDiff, request);
    }
    /**
     * SyncGet fetches a single key and returns the corresponding proof.
     */ storageSyncGet(request) {
        return this.callUnary(methodDescriptorStorageSyncGet, request);
    }
    /**
     * SyncGetPrefixes fetches all keys under the given prefixes and returns
     * the corresponding proofs.
     */ storageSyncGetPrefixes(request) {
        return this.callUnary(methodDescriptorStorageSyncGetPrefixes, request);
    }
    /**
     * SyncIterate seeks to a given key and then fetches the specified
     * number of following items based on key iteration order.
     */ storageSyncIterate(request) {
        return this.callUnary(methodDescriptorStorageSyncIterate, request);
    }
    /**
     * GetLastSyncedRound retrieves the last synced round for the storage worker.
     */ storageWorkerGetLastSyncedRound(request) {
        return this.callUnary(methodDescriptorStorageWorkerGetLastSyncedRound, request);
    }
    /**
     * PauseCheckpointer pauses or unpauses the storage worker's checkpointer.
     */ storageWorkerPauseCheckpointer(request) {
        return this.callUnary(methodDescriptorStorageWorkerPauseCheckpointer, request);
    }
    /**
     * CheckTx asks the local runtime to check the specified transaction.
     */ runtimeClientCheckTx(request) {
        return this.callUnary(methodDescriptorRuntimeClientCheckTx, request);
    }
    /**
     * GetBlock fetches the given runtime block.
     */ runtimeClientGetBlock(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetBlock, request);
    }
    /**
     * GetEvents returns all events emitted in a given block.
     */ runtimeClientGetEvents(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetEvents, request);
    }
    /**
     * GetGenesisBlock returns the genesis block.
     */ runtimeClientGetGenesisBlock(runtimeID) {
        return this.callUnary(methodDescriptorRuntimeClientGetGenesisBlock, runtimeID);
    }
    /**
     * GetLastRetainedBlock returns the last retained block.
     */ runtimeClientGetLastRetainedBlock(runtimeID) {
        return this.callUnary(methodDescriptorRuntimeClientGetLastRetainedBlock, runtimeID);
    }
    /**
     * GetTransactions fetches all runtime transactions in a given block.
     */ runtimeClientGetTransactions(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetTransactions, request);
    }
    /**
     * GetTransactionsWithResults fetches all runtime transactions in a given block together with
     * its results (outputs and emitted events).
     */ runtimeClientGetTransactionsWithResults(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetTransactionsWithResults, request);
    }
    /**
     * Query makes a runtime-specific query.
     */ runtimeClientQuery(request) {
        return this.callUnary(methodDescriptorRuntimeClientQuery, request);
    }
    /**
     * SubmitTx submits a transaction to the runtime transaction scheduler and waits
     * for transaction execution results.
     */ runtimeClientSubmitTx(request) {
        return this.callUnary(methodDescriptorRuntimeClientSubmitTx, request);
    }
    /**
     * SubmitTxMeta submits a transaction to the runtime transaction scheduler and waits for
     * transaction execution results.
     *
     * Response includes transaction metadata - e.g. round at which the transaction was included
     * in a block.
     */ runtimeClientSubmitTxMeta(request) {
        return this.callUnary(methodDescriptorRuntimeClientSubmitTxMeta, request);
    }
    /**
     * SubmitTxNoWait submits a transaction to the runtime transaction scheduler but does
     * not wait for transaction execution.
     */ runtimeClientSubmitTxNoWait(request) {
        return this.callUnary(methodDescriptorRuntimeClientSubmitTxNoWait, request);
    }
    /**
     * WatchBlocks subscribes to blocks for a specific runtimes.
     */ runtimeClientWatchBlocks(runtimeID) {
        return this.callServerStreaming(methodDescriptorRuntimeClientWatchBlocks, runtimeID);
    }
    /**
     * EstimateGas calculates the amount of gas required to execute the given transaction.
     */ consensusEstimateGas(req) {
        return this.callUnary(methodDescriptorConsensusEstimateGas, req);
    }
    /**
     * GetBlock returns a consensus block at a specific height.
     */ consensusGetBlock(height) {
        return this.callUnary(methodDescriptorConsensusGetBlock, height);
    }
    /**
     * GetChainContext returns the chain domain separation context.
     */ consensusGetChainContext() {
        return this.callUnary(methodDescriptorConsensusGetChainContext, undefined);
    }
    /**
     * GetGenesisDocument returns the original genesis document.
     */ consensusGetGenesisDocument() {
        return this.callUnary(methodDescriptorConsensusGetGenesisDocument, undefined);
    }
    /**
     * GetLightBlock returns a light version of the consensus layer block that can be used for light
     * client verification.
     */ consensusGetLightBlock(height) {
        return this.callUnary(methodDescriptorConsensusGetLightBlock, height);
    }
    /**
     * GetLightBlockForState returns a light block for the state as of executing the consensus layer
     * block at the specified height. Note that the height of the returned block may differ
     * depending on consensus layer implementation details.
     *
     * In case light block for the given height is not yet available, it returns ErrVersionNotFound.
     */ consensusGetLightBlockForState(height) {
        return this.callUnary(methodDescriptorConsensusGetLightBlockForState, height);
    }
    /**
     * GetNextBlockState returns the state of the next block being voted on by validators.
     */ consensusGetNextBlockState() {
        return this.callUnary(methodDescriptorConsensusGetNextBlockState, undefined);
    }
    /**
     * GetParameters returns the consensus parameters for a specific height.
     */ consensusGetParameters(height) {
        return this.callUnary(methodDescriptorConsensusGetParameters, height);
    }
    /**
     * GetSignerNonce returns the nonce that should be used by the given
     * signer for transmitting the next transaction.
     */ consensusGetSignerNonce(req) {
        return this.callUnary(methodDescriptorConsensusGetSignerNonce, req);
    }
    /**
     * GetStatus returns the current status overview.
     */ consensusGetStatus() {
        return this.callUnary(methodDescriptorConsensusGetStatus, undefined);
    }
    /**
     * GetTransactions returns a list of all transactions contained within a
     * consensus block at a specific height.
     *
     * NOTE: Any of these transactions could be invalid.
     */ consensusGetTransactions(height) {
        return this.callUnary(methodDescriptorConsensusGetTransactions, height);
    }
    /**
     * GetTransactionsWithProofs returns a list of all transactions and their proofs of inclusion
     * contained within a consensus block at a specific height.
     */ consensusGetTransactionsWithProofs(height) {
        return this.callUnary(methodDescriptorConsensusGetTransactionsWithProofs, height);
    }
    /**
     * GetTransactionsWithResults returns a list of transactions and their
     * execution results, contained within a consensus block at a specific
     * height.
     */ consensusGetTransactionsWithResults(height) {
        return this.callUnary(methodDescriptorConsensusGetTransactionsWithResults, height);
    }
    /**
     * GetUnconfirmedTransactions returns a list of transactions currently in the local node's
     * mempool. These have not yet been included in a block.
     */ consensusGetUnconfirmedTransactions() {
        return this.callUnary(methodDescriptorConsensusGetUnconfirmedTransactions, undefined);
    }
    /**
     * StateToGenesis returns the genesis state at the specified block height.
     */ consensusStateToGenesis(height) {
        return this.callUnary(methodDescriptorConsensusStateToGenesis, height);
    }
    /**
     * SubmitEvidence submits evidence of misbehavior.
     */ consensusSubmitEvidence(evidence) {
        return this.callUnary(methodDescriptorConsensusSubmitEvidence, evidence);
    }
    /**
     * SubmitTx submits a signed consensus transaction and waits for the transaction to be included
     * in a block. Use SubmitTxNoWait if you only need to broadcast the transaction.
     */ consensusSubmitTx(tx) {
        return this.callUnary(methodDescriptorConsensusSubmitTx, tx);
    }
    /**
     * SubmitTxNoWait submits a signed consensus transaction, but does not wait for the transaction
     * to be included in a block. Use SubmitTx if you need to wait for execution.
     */ consensusSubmitTxNoWait(tx) {
        return this.callUnary(methodDescriptorConsensusSubmitTxNoWait, tx);
    }
    /**
     * SubmitTxWithProof submits a signed consensus transaction, waits for the transaction to be
     * included in a block and returns a proof of inclusion.
     */ consensusSubmitTxWithProof(tx) {
        return this.callUnary(methodDescriptorConsensusSubmitTxWithProof, tx);
    }
    /**
     * WatchBlocks returns a channel that produces a stream of consensus
     * blocks as they are being finalized.
     */ consensusWatchBlocks() {
        return this.callServerStreaming(methodDescriptorConsensusWatchBlocks, undefined);
    }
    /**
     * SyncGet fetches a single key and returns the corresponding proof.
     */ consensusStateSyncGet(request) {
        return this.callUnary(methodDescriptorConsensusStateSyncGet, request);
    }
    /**
     * SyncGetPrefixes fetches all keys under the given prefixes and returns
     * the corresponding proofs.
     */ consensusStateSyncGetPrefixes(request) {
        return this.callUnary(methodDescriptorConsensusStateSyncGetPrefixes, request);
    }
    /**
     * SyncIterate seeks to a given key and then fetches the specified
     * number of following items based on key iteration order.
     */ consensusStateSyncIterate(request) {
        return this.callUnary(methodDescriptorConsensusStateSyncIterate, request);
    }
    /**
     * CancelUpgrade cancels the specific pending upgrade, unless it is already in progress.
     */ nodeControllerCancelUpgrade(descriptor) {
        return this.callUnary(methodDescriptorNodeControllerCancelUpgrade, descriptor);
    }
    /**
     * GetStatus returns the current status overview of the node.
     */ nodeControllerGetStatus() {
        return this.callUnary(methodDescriptorNodeControllerGetStatus, undefined);
    }
    /**
     * IsReady checks whether the node is ready to accept runtime work.
     */ nodeControllerIsReady() {
        return this.callUnary(methodDescriptorNodeControllerIsReady, undefined);
    }
    /**
     * IsSynced checks whether the node has finished syncing.
     */ nodeControllerIsSynced() {
        return this.callUnary(methodDescriptorNodeControllerIsSynced, undefined);
    }
    /**
     * RequestShutdown requests the node to shut down gracefully.
     *
     * If the wait argument is true then the method will also wait for the
     * shutdown to complete.
     */ nodeControllerRequestShutdown(wait) {
        return this.callUnary(methodDescriptorNodeControllerRequestShutdown, wait);
    }
    /**
     * UpgradeBinary submits an upgrade descriptor to a running node.
     * The node will wait for the appropriate epoch, then update its binaries
     * and shut down.
     */ nodeControllerUpgradeBinary(descriptor) {
        return this.callUnary(methodDescriptorNodeControllerUpgradeBinary, descriptor);
    }
    /**
     * WaitReady waits for the node to accept runtime work.
     */ nodeControllerWaitReady() {
        return this.callUnary(methodDescriptorNodeControllerWaitReady, undefined);
    }
    /**
     * WaitSync waits for the node to finish syncing.
     */ nodeControllerWaitSync() {
        return this.callUnary(methodDescriptorNodeControllerWaitSync, undefined);
    }
    /**
     * SetEpoch manually sets the current epoch to the given epoch.
     *
     * NOTE: This only works with a mock beacon backend and will otherwise
     *       return an error.
     */ debugControllerSetEpoch(epoch) {
        return this.callUnary(methodDescriptorDebugControllerSetEpoch, epoch);
    }
    /**
     * WaitNodesRegistered waits for the given number of nodes to register.
     */ debugControllerWaitNodesRegistered(count) {
        return this.callUnary(methodDescriptorDebugControllerWaitNodesRegistered, count);
    }
}
exports.NodeInternal = NodeInternal;

},{"9d1eb17909bce9fe":"bCKKl","6db49ae9491abcda":"cePIg","f5d0aed926730b6":"agInO"}],"bCKKl":[function(require,module,exports) {
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var global = arguments[3];
var n;
function aa(a) {
    var b = 0;
    return function() {
        return b < a.length ? {
            done: !1,
            value: a[b++]
        } : {
            done: !0
        };
    };
}
var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
};
function ca(a) {
    a = [
        "object" == typeof window && window,
        "object" == typeof self && self,
        "object" == typeof global && global,
        a
    ];
    for(var b = 0; b < a.length; ++b){
        var c = a[b];
        if (c && c.Math == Math) return c;
    }
    throw Error("Cannot find global object");
}
var r = ca(this);
function t() {
    t = function() {};
    r.Symbol || (r.Symbol = da);
}
function ea(a, b) {
    this.a = a;
    ba(this, "description", {
        configurable: !0,
        writable: !0,
        value: b
    });
}
ea.prototype.toString = function() {
    return this.a;
};
var da = function() {
    function a(c) {
        if (this instanceof a) throw new TypeError("Symbol is not a constructor");
        return new ea("jscomp_symbol_" + (c || "") + "_" + b++, c);
    }
    var b = 0;
    return a;
}();
function u() {
    t();
    var a = r.Symbol.iterator;
    a || (a = r.Symbol.iterator = r.Symbol("Symbol.iterator"));
    "function" != typeof Array.prototype[a] && ba(Array.prototype, a, {
        configurable: !0,
        writable: !0,
        value: function() {
            return fa(aa(this));
        }
    });
    u = function() {};
}
function fa(a) {
    u();
    a = {
        next: a
    };
    a[r.Symbol.iterator] = function() {
        return this;
    };
    return a;
}
function ha(a) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : {
        next: aa(a)
    };
}
var ia = "function" == typeof Object.create ? Object.create : function(a) {
    function b() {}
    b.prototype = a;
    return new b;
}, ja;
if ("function" == typeof Object.setPrototypeOf) ja = Object.setPrototypeOf;
else {
    var ka;
    a: {
        var la = {
            V: !0
        }, ma = {};
        try {
            ma.__proto__ = la;
            ka = ma.V;
            break a;
        } catch (a) {}
        ka = !1;
    }
    ja = ka ? function(a, b) {
        a.__proto__ = b;
        if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
        return a;
    } : null;
}
var na = ja;
function oa(a, b) {
    a.prototype = ia(b.prototype);
    a.prototype.constructor = a;
    if (na) na(a, b);
    else for(var c in b)if ("prototype" != c) {
        if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
        } else a[c] = b[c];
    }
    a.O = b.prototype;
}
function pa(a, b) {
    u();
    a instanceof String && (a += "");
    var c = 0, d = {
        next: function() {
            if (c < a.length) {
                var f = c++;
                return {
                    value: b(f, a[f]),
                    done: !1
                };
            }
            d.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return d.next();
        }
    };
    d[Symbol.iterator] = function() {
        return d;
    };
    return d;
}
function v(a, b) {
    if (b) {
        var c = r;
        a = a.split(".");
        for(var d = 0; d < a.length - 1; d++){
            var f = a[d];
            f in c || (c[f] = {});
            c = c[f];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && ba(c, a, {
            configurable: !0,
            writable: !0,
            value: b
        });
    }
}
v("Array.prototype.keys", function(a) {
    return a ? a : function() {
        return pa(this, function(b) {
            return b;
        });
    };
});
v("Array.prototype.find", function(a) {
    return a ? a : function(b, c) {
        a: {
            var d = this;
            d instanceof String && (d = String(d));
            for(var f = d.length, g = 0; g < f; g++){
                var e = d[g];
                if (b.call(c, e, g, d)) {
                    b = e;
                    break a;
                }
            }
            b = void 0;
        }
        return b;
    };
});
v("Object.is", function(a) {
    return a ? a : function(b, c) {
        return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
    };
});
v("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
        var d = this;
        d instanceof String && (d = String(d));
        var f = d.length;
        c = c || 0;
        for(0 > c && (c = Math.max(c + f, 0)); c < f; c++){
            var g = d[c];
            if (g === b || Object.is(g, b)) return !0;
        }
        return !1;
    };
});
v("Promise", function(a) {
    function b(e) {
        this.b = 0;
        this.c = void 0;
        this.a = [];
        var h = this.f();
        try {
            e(h.resolve, h.reject);
        } catch (k) {
            h.reject(k);
        }
    }
    function c() {
        this.a = null;
    }
    function d(e) {
        return e instanceof b ? e : new b(function(h) {
            h(e);
        });
    }
    if (a) return a;
    c.prototype.b = function(e) {
        if (null == this.a) {
            this.a = [];
            var h = this;
            this.c(function() {
                h.g();
            });
        }
        this.a.push(e);
    };
    var f = r.setTimeout;
    c.prototype.c = function(e) {
        f(e, 0);
    };
    c.prototype.g = function() {
        for(; this.a && this.a.length;){
            var e = this.a;
            this.a = [];
            for(var h = 0; h < e.length; ++h){
                var k = e[h];
                e[h] = null;
                try {
                    k();
                } catch (l) {
                    this.f(l);
                }
            }
        }
        this.a = null;
    };
    c.prototype.f = function(e) {
        this.c(function() {
            throw e;
        });
    };
    b.prototype.f = function() {
        function e(l) {
            return function(m) {
                k || (k = !0, l.call(h, m));
            };
        }
        var h = this, k = !1;
        return {
            resolve: e(this.s),
            reject: e(this.g)
        };
    };
    b.prototype.s = function(e) {
        if (e === this) this.g(new TypeError("A Promise cannot resolve to itself"));
        else if (e instanceof b) this.v(e);
        else {
            a: switch(typeof e){
                case "object":
                    var h = null != e;
                    break a;
                case "function":
                    h = !0;
                    break a;
                default:
                    h = !1;
            }
            h ? this.m(e) : this.h(e);
        }
    };
    b.prototype.m = function(e) {
        var h = void 0;
        try {
            h = e.then;
        } catch (k) {
            this.g(k);
            return;
        }
        "function" == typeof h ? this.w(h, e) : this.h(e);
    };
    b.prototype.g = function(e) {
        this.i(2, e);
    };
    b.prototype.h = function(e) {
        this.i(1, e);
    };
    b.prototype.i = function(e, h) {
        if (0 != this.b) throw Error("Cannot settle(" + e + ", " + h + "): Promise already settled in state" + this.b);
        this.b = e;
        this.c = h;
        this.l();
    };
    b.prototype.l = function() {
        if (null != this.a) {
            for(var e = 0; e < this.a.length; ++e)g.b(this.a[e]);
            this.a = null;
        }
    };
    var g = new c;
    b.prototype.v = function(e) {
        var h = this.f();
        e.F(h.resolve, h.reject);
    };
    b.prototype.w = function(e, h) {
        var k = this.f();
        try {
            e.call(h, k.resolve, k.reject);
        } catch (l) {
            k.reject(l);
        }
    };
    b.prototype.then = function(e, h) {
        function k(q, w) {
            return "function" == typeof q ? function(A) {
                try {
                    l(q(A));
                } catch (L) {
                    m(L);
                }
            } : w;
        }
        var l, m, p = new b(function(q, w) {
            l = q;
            m = w;
        });
        this.F(k(e, l), k(h, m));
        return p;
    };
    b.prototype.catch = function(e) {
        return this.then(void 0, e);
    };
    b.prototype.F = function(e, h) {
        function k() {
            switch(l.b){
                case 1:
                    e(l.c);
                    break;
                case 2:
                    h(l.c);
                    break;
                default:
                    throw Error("Unexpected state: " + l.b);
            }
        }
        var l = this;
        null == this.a ? g.b(k) : this.a.push(k);
    };
    b.resolve = d;
    b.reject = function(e) {
        return new b(function(h, k) {
            k(e);
        });
    };
    b.race = function(e) {
        return new b(function(h, k) {
            for(var l = ha(e), m = l.next(); !m.done; m = l.next())d(m.value).F(h, k);
        });
    };
    b.all = function(e) {
        var h = ha(e), k = h.next();
        return k.done ? d([]) : new b(function(l, m) {
            function p(A) {
                return function(L) {
                    q[A] = L;
                    w--;
                    0 == w && l(q);
                };
            }
            var q = [], w = 0;
            do q.push(void 0), w++, d(k.value).F(p(q.length - 1), m), k = h.next();
            while (!k.done);
        });
    };
    return b;
});
var qa = qa || {}, x = this || self;
function y(a, b) {
    a = a.split(".");
    b = b || x;
    for(var c = 0; c < a.length; c++)if (b = b[a[c]], null == b) return null;
    return b;
}
function ra() {}
function sa(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
var ta = "closure_uid_" + (1E9 * Math.random() >>> 0), ua = 0;
function va(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function wa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var f = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(f, d);
            return a.apply(b, f);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function z(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? z = va : z = wa;
    return z.apply(null, arguments);
}
function B(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.O = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
}
function xa(a) {
    this.a = a || {};
}
xa.prototype.get = function(a) {
    return this.a[a];
};
xa.prototype.G = function() {
    return Object.keys(this.a);
};
function C(a, b, c, d) {
    this.f = a;
    this.c = b;
    this.b = c;
    this.a = d;
}
C.prototype.getRequestMessage = function() {
    return this.f;
};
C.prototype.getMethodDescriptor = function() {
    return this.c;
};
C.prototype.getMetadata = function() {
    return this.b;
};
C.prototype.getCallOptions = function() {
    return this.a;
};
function D(a, b, c, d) {
    c = void 0 === c ? {} : c;
    this.c = a;
    this.a = c;
    this.b = b;
    this.f = void 0 === d ? null : d;
}
D.prototype.getResponseMessage = function() {
    return this.c;
};
D.prototype.getMetadata = function() {
    return this.a;
};
D.prototype.getMethodDescriptor = function() {
    return this.b;
};
D.prototype.getStatus = function() {
    return this.f;
};
function ya(a, b, c, d, f, g) {
    this.name = a;
    this.a = f;
    this.b = g;
}
function za(a, b, c) {
    c = void 0 === c ? {} : c;
    var d = void 0 === d ? new xa : d;
    return new C(b, a, c, d);
}
ya.prototype.getName = function() {
    return this.name;
};
ya.prototype.getName = ya.prototype.getName;
function Aa(a) {
    switch(a){
        case 200:
            return 0;
        case 400:
            return 3;
        case 401:
            return 16;
        case 403:
            return 7;
        case 404:
            return 5;
        case 409:
            return 10;
        case 412:
            return 9;
        case 429:
            return 8;
        case 499:
            return 1;
        case 500:
            return 2;
        case 501:
            return 12;
        case 503:
            return 14;
        case 504:
            return 4;
        default:
            return 2;
    }
}
function Ba(a) {
    switch(a){
        case 0:
            return "OK";
        case 1:
            return "CANCELLED";
        case 2:
            return "UNKNOWN";
        case 3:
            return "INVALID_ARGUMENT";
        case 4:
            return "DEADLINE_EXCEEDED";
        case 5:
            return "NOT_FOUND";
        case 6:
            return "ALREADY_EXISTS";
        case 7:
            return "PERMISSION_DENIED";
        case 16:
            return "UNAUTHENTICATED";
        case 8:
            return "RESOURCE_EXHAUSTED";
        case 9:
            return "FAILED_PRECONDITION";
        case 10:
            return "ABORTED";
        case 11:
            return "OUT_OF_RANGE";
        case 12:
            return "UNIMPLEMENTED";
        case 13:
            return "INTERNAL";
        case 14:
            return "UNAVAILABLE";
        case 15:
            return "DATA_LOSS";
        default:
            return "";
    }
}
function E(a, b, c) {
    c = void 0 === c ? {} : c;
    b = Error.call(this, b);
    this.message = b.message;
    "stack" in b && (this.stack = b.stack);
    this.code = a;
    this.metadata = c;
}
oa(E, Error);
E.prototype.toString = function() {
    var a = "RpcError(" + (Ba(this.code) || String(this.code)) + ")";
    this.message && (a += ": " + this.message);
    return a;
};
E.prototype.name = "RpcError";
function Ca(a) {
    this.a = a;
}
Ca.prototype.on = function(a, b) {
    return "data" == a || "error" == a ? this : this.a.on(a, b);
};
Ca.prototype.removeListener = function(a, b) {
    return this.a.removeListener(a, b);
};
Ca.prototype.cancel = function() {
    this.a.cancel();
};
function Da(a) {
    switch(a){
        case 0:
            return "No Error";
        case 1:
            return "Access denied to content document";
        case 2:
            return "File not found";
        case 3:
            return "Firefox silently errored";
        case 4:
            return "Application custom error";
        case 5:
            return "An exception occurred";
        case 6:
            return "Http response at 400 or 500 level";
        case 7:
            return "Request was aborted";
        case 8:
            return "Request timed out";
        case 9:
            return "The resource is not available offline";
        default:
            return "Unrecognized error code";
    }
}
function F(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, F);
    else {
        var b = Error().stack;
        b && (this.stack = b);
    }
    a && (this.message = String(a));
}
B(F, Error);
F.prototype.name = "CustomError";
function Ea(a, b) {
    a = a.split("%s");
    for(var c = "", d = a.length - 1, f = 0; f < d; f++)c += a[f] + (f < b.length ? b[f] : "%s");
    F.call(this, c + a[d]);
}
B(Ea, F);
Ea.prototype.name = "AssertionError";
function Fa(a, b) {
    throw new Ea("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
}
function Ga() {
    this.l = null;
    this.i = [];
    this.m = 0;
    this.b = Ha;
    this.f = this.a = this.h = 0;
    this.c = null;
    this.g = 0;
}
function Ia(a, b) {
    function c(l) {
        l == Ja ? e.h = l : l == G ? e.h = l : Ka(e, h, k, "invalid frame byte");
        e.b = La;
        e.a = 0;
        e.f = 0;
    }
    function d(l) {
        e.f++;
        e.a = (e.a << 8) + l;
        4 == e.f && (e.b = Ma, e.g = 0, "undefined" !== typeof Uint8Array ? e.c = new Uint8Array(e.a) : e.c = Array(e.a), 0 == e.a && g());
    }
    function f(l) {
        e.c[e.g++] = l;
        e.g == e.a && g();
    }
    function g() {
        var l = {};
        l[e.h] = e.c;
        e.i.push(l);
        e.b = Ha;
    }
    var e = a, h, k = 0;
    for(b instanceof Uint8Array || b instanceof Array ? h = b : h = new Uint8Array(b); k < h.length;){
        switch(e.b){
            case Na:
                Ka(e, h, k, "stream already broken");
                break;
            case Ha:
                c(h[k]);
                break;
            case La:
                d(h[k]);
                break;
            case Ma:
                f(h[k]);
                break;
            default:
                throw Error("unexpected parser state: " + e.b);
        }
        e.m++;
        k++;
    }
    a = e.i;
    e.i = [];
    return 0 < a.length ? a : null;
}
var Ha = 0, La = 1, Ma = 2, Na = 3, Ja = 0, G = 128;
function Ka(a, b, c, d) {
    a.b = Na;
    a.l = "The stream is broken @" + a.m + "/" + c + ". Error: " + d + ". With input:\n" + b;
    throw Error(a.l);
}
var Oa = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
var Pa = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function H(a, b) {
    return -1 != a.indexOf(b);
}
function Qa(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var I;
a: {
    var Ra = x.navigator;
    if (Ra) {
        var Sa = Ra.userAgent;
        if (Sa) {
            I = Sa;
            break a;
        }
    }
    I = "";
}
function Ta(a, b) {
    for(var c in a)b.call(void 0, a[c], c, a);
}
function Ua(a, b) {
    var c = {}, d;
    for(d in a)c[d] = b.call(void 0, a[d], d, a);
    return c;
}
var Va = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Wa(a, b) {
    for(var c, d, f = 1; f < arguments.length; f++){
        d = arguments[f];
        for(c in d)a[c] = d[c];
        for(var g = 0; g < Va.length; g++)c = Va[g], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function Xa(a) {
    var b = 1;
    a = a.split(":");
    for(var c = []; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function Ya(a) {
    Ya[" "](a);
    return a;
}
Ya[" "] = ra;
function Za(a) {
    var b = $a;
    return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a(9);
}
var ab = H(I, "Opera"), bb = H(I, "Trident") || H(I, "MSIE"), cb = H(I, "Edge"), db = H(I, "Gecko") && !(H(I.toLowerCase(), "webkit") && !H(I, "Edge")) && !(H(I, "Trident") || H(I, "MSIE")) && !H(I, "Edge"), eb = H(I.toLowerCase(), "webkit") && !H(I, "Edge"), fb;
a: {
    var gb = "", hb = function() {
        var a = I;
        if (db) return /rv:([^\);]+)(\)|;)/.exec(a);
        if (cb) return /Edge\/([\d\.]+)/.exec(a);
        if (bb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if (eb) return /WebKit\/(\S+)/.exec(a);
        if (ab) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    hb && (gb = hb ? hb[1] : "");
    if (bb) {
        var ib, jb = x.document;
        ib = jb ? jb.documentMode : void 0;
        if (null != ib && ib > parseFloat(gb)) {
            fb = String(ib);
            break a;
        }
    }
    fb = gb;
}
var $a = {};
function kb() {
    return Za(function() {
        for(var a = 0, b = Pa(String(fb)).split("."), c = Pa("9").split("."), d = Math.max(b.length, c.length), f = 0; 0 == a && f < d; f++){
            var g = b[f] || "", e = c[f] || "";
            do {
                g = /(\d*)(\D*)(.*)/.exec(g) || [
                    "",
                    "",
                    "",
                    ""
                ];
                e = /(\d*)(\D*)(.*)/.exec(e) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == g[0].length && 0 == e[0].length) break;
                a = Qa(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == e[1].length ? 0 : parseInt(e[1], 10)) || Qa(0 == g[2].length, 0 == e[2].length) || Qa(g[2], e[2]);
                g = g[3];
                e = e[3];
            }while (0 == a);
        }
        return 0 <= a;
    });
}
function lb() {
    0 != mb && (Object.prototype.hasOwnProperty.call(this, ta) && this[ta] || (this[ta] = ++ua));
    this.K = this.K;
}
var mb = 0;
lb.prototype.K = !1;
var nb = Object.freeze || function(a) {
    return a;
};
function J(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.defaultPrevented = !1;
}
J.prototype.b = function() {
    this.defaultPrevented = !0;
};
var ob = function() {
    if (!x.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        x.addEventListener("test", ra, b), x.removeEventListener("test", ra, b);
    } catch (c) {}
    return a;
}();
function K(a, b) {
    J.call(this, a ? a.type : "");
    this.relatedTarget = this.a = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.pointerId = 0;
    this.pointerType = "";
    this.c = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.a = b;
        if (b = a.relatedTarget) {
            if (db) {
                a: {
                    try {
                        Ya(b.nodeName);
                        var f = !0;
                        break a;
                    } catch (g) {}
                    f = !1;
                }
                f || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : pb[a.pointerType] || "";
        this.c = a;
        a.defaultPrevented && K.O.b.call(this);
    }
}
B(K, J);
var pb = nb({
    2: "touch",
    3: "pen",
    4: "mouse"
});
K.prototype.b = function() {
    K.O.b.call(this);
    var a = this.c;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var M = "closure_listenable_" + (1E6 * Math.random() | 0);
var qb = 0;
function rb(a, b, c, d, f) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.H = f;
    this.key = ++qb;
    this.A = this.D = !1;
}
function sb(a) {
    a.A = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.H = null;
}
function tb(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
}
tb.prototype.add = function(a, b, c, d, f) {
    var g = a.toString();
    a = this.a[g];
    a || (a = this.a[g] = [], this.b++);
    var e = ub(a, b, d, f);
    -1 < e ? (b = a[e], c || (b.D = !1)) : (b = new rb(b, this.src, g, !!d, f), b.D = c, a.push(b));
    return b;
};
tb.prototype.remove = function(a, b, c, d) {
    a = a.toString();
    if (!(a in this.a)) return !1;
    var f = this.a[a];
    b = ub(f, b, c, d);
    return -1 < b ? (sb(f[b]), Array.prototype.splice.call(f, b, 1), 0 == f.length && (delete this.a[a], this.b--), !0) : !1;
};
function vb(a, b) {
    var c = b.type;
    if (c in a.a) {
        var d = a.a[c], f = Oa(d, b), g;
        (g = 0 <= f) && Array.prototype.splice.call(d, f, 1);
        g && (sb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
}
function ub(a, b, c, d) {
    for(var f = 0; f < a.length; ++f){
        var g = a[f];
        if (!g.A && g.listener == b && g.capture == !!c && g.H == d) return f;
    }
    return -1;
}
var wb = "closure_lm_" + (1E6 * Math.random() | 0), xb = {}, yb = 0;
function zb(a, b, c, d, f) {
    if (d && d.once) Ab(a, b, c, d, f);
    else if (Array.isArray(b)) for(var g = 0; g < b.length; g++)zb(a, b[g], c, d, f);
    else c = Bb(c), a && a[M] ? a.f.add(String(b), c, !1, sa(d) ? !!d.capture : !!d, f) : Cb(a, b, c, !1, d, f);
}
function Cb(a, b, c, d, f, g) {
    if (!b) throw Error("Invalid event type");
    var e = sa(f) ? !!f.capture : !!f, h = Db(a);
    h || (a[wb] = h = new tb(a));
    c = h.add(b, c, d, e, g);
    if (!c.proxy) {
        d = Eb();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ob || (f = e), void 0 === f && (f = !1), a.addEventListener(b.toString(), d, f);
        else if (a.attachEvent) a.attachEvent(Fb(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        yb++;
    }
}
function Eb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = Gb;
    return a;
}
function Ab(a, b, c, d, f) {
    if (Array.isArray(b)) for(var g = 0; g < b.length; g++)Ab(a, b[g], c, d, f);
    else c = Bb(c), a && a[M] ? a.f.add(String(b), c, !0, sa(d) ? !!d.capture : !!d, f) : Cb(a, b, c, !0, d, f);
}
function Hb(a, b, c, d, f) {
    if (Array.isArray(b)) for(var g = 0; g < b.length; g++)Hb(a, b[g], c, d, f);
    else (d = sa(d) ? !!d.capture : !!d, c = Bb(c), a && a[M]) ? a.f.remove(String(b), c, d, f) : a && (a = Db(a)) && (b = a.a[b.toString()], a = -1, b && (a = ub(b, c, d, f)), (c = -1 < a ? b[a] : null) && Ib(c));
}
function Ib(a) {
    if ("number" !== typeof a && a && !a.A) {
        var b = a.src;
        if (b && b[M]) vb(b.f, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Fb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            yb--;
            (c = Db(b)) ? (vb(c, a), 0 == c.b && (c.src = null, b[wb] = null)) : sb(a);
        }
    }
}
function Fb(a) {
    return a in xb ? xb[a] : xb[a] = "on" + a;
}
function Gb(a, b) {
    if (a.A) a = !0;
    else {
        b = new K(b, this);
        var c = a.listener, d = a.H || a.src;
        a.D && Ib(a);
        a = c.call(d, b);
    }
    return a;
}
function Db(a) {
    a = a[wb];
    return a instanceof tb ? a : null;
}
var Jb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function Bb(a) {
    if ("function" === typeof a) return a;
    a[Jb] || (a[Jb] = function(b) {
        return a.handleEvent(b);
    });
    return a[Jb];
}
function N() {
    lb.call(this);
    this.f = new tb(this);
    this.U = this;
}
B(N, lb);
N.prototype[M] = !0;
N.prototype.addEventListener = function(a, b, c, d) {
    zb(this, a, b, c, d);
};
N.prototype.removeEventListener = function(a, b, c, d) {
    Hb(this, a, b, c, d);
};
function O(a, b) {
    a = a.U;
    var c = b.type || b;
    if ("string" === typeof b) b = new J(b, a);
    else if (b instanceof J) b.target = b.target || a;
    else {
        var d = b;
        b = new J(c, a);
        Wa(b, d);
    }
    a = b.a = a;
    Kb(a, c, !0, b);
    Kb(a, c, !1, b);
}
function Kb(a, b, c, d) {
    if (b = a.f.a[String(b)]) {
        b = b.concat();
        for(var f = !0, g = 0; g < b.length; ++g){
            var e = b[g];
            if (e && !e.A && e.capture == c) {
                var h = e.listener, k = e.H || e.src;
                e.D && vb(a.f, e);
                f = !1 !== h.call(k, d) && f;
            }
        }
    }
}
var Lb = x;
function Mb(a, b, c) {
    if ("function" === typeof a) c && (a = z(a, c));
    else if (a && "function" == typeof a.handleEvent) a = z(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : Lb.setTimeout(a, b || 0);
}
function Nb(a, b) {
    this.name = a;
    this.value = b;
}
Nb.prototype.toString = function() {
    return this.name;
};
var Ob = new Nb("OFF", Infinity), Pb = new Nb("SEVERE", 1E3), Qb = new Nb("CONFIG", 700), Rb = new Nb("FINE", 500);
function Tb() {
    this.clear();
}
var Ub;
Tb.prototype.clear = function() {};
function Vb(a, b, c) {
    this.reset(a || Ob, b, c, void 0, void 0);
}
Vb.prototype.reset = function() {};
function Wb(a, b) {
    this.a = null;
    this.f = [];
    this.b = (void 0 === b ? null : b) || null;
    this.c = [];
    this.g = {
        getName: function() {
            return a;
        }
    };
}
function Xb(a) {
    if (a.a) return a.a;
    if (a.b) return Xb(a.b);
    Fa("Root logger has no level set.");
    return Ob;
}
function Yb(a, b) {
    for(; a;)a.f.forEach(function(c) {
        c(b);
    }), a = a.b;
}
function Zb() {
    this.entries = {};
    var a = new Wb("");
    a.a = Qb;
    this.entries[""] = a;
}
var $b;
function ac(a, b, c) {
    var d = a.entries[b];
    if (d) return void 0 !== c && (d.a = c), d;
    d = ac(a, b.substr(0, b.lastIndexOf(".")));
    var f = new Wb(b, d);
    a.entries[b] = f;
    d.c.push(f);
    void 0 !== c && (f.a = c);
    return f;
}
function bc() {
    $b || ($b = new Zb);
    return $b;
}
function cc(a, b, c) {
    var d;
    if (d = a) {
        if (d = a && b) {
            d = b.value;
            var f = a ? Xb(ac(bc(), a.getName())) : Ob;
            d = d >= f.value;
        }
    }
    d && (b = b || Ob, d = ac(bc(), a.getName()), "function" === typeof c && (c = c()), Ub || (Ub = new Tb), a = a.getName(), a = new Vb(b, c, a), Yb(d, a));
}
function P(a, b) {
    a && cc(a, Rb, b);
}
function dc() {}
dc.prototype.a = null;
function ec(a) {
    var b;
    (b = a.a) || (b = {}, fc(a) && (b[0] = !0, b[1] = !0), b = a.a = b);
    return b;
}
var gc;
function hc() {}
B(hc, dc);
function ic(a) {
    return (a = fc(a)) ? new ActiveXObject(a) : new XMLHttpRequest;
}
function fc(a) {
    if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
        for(var b = [
            "MSXML2.XMLHTTP.6.0",
            "MSXML2.XMLHTTP.3.0",
            "MSXML2.XMLHTTP",
            "Microsoft.XMLHTTP"
        ], c = 0; c < b.length; c++){
            var d = b[c];
            try {
                return new ActiveXObject(d), a.b = d;
            } catch (f) {}
        }
        throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }
    return a.b;
}
gc = new hc;
t();
u();
function jc(a, b) {
    this.b = a[x.Symbol.iterator]();
    this.c = b;
    this.f = 0;
}
jc.prototype[Symbol.iterator] = function() {
    return this;
};
jc.prototype.next = function() {
    var a = this.b.next();
    return {
        value: a.done ? void 0 : this.c.call(void 0, a.value, this.f++),
        done: a.done
    };
};
function kc(a, b) {
    return new jc(a, b);
}
t();
u();
t();
u();
var lc = "StopIteration" in x ? x.StopIteration : {
    message: "StopIteration",
    stack: ""
};
function Q() {}
Q.prototype.next = function() {
    return Q.prototype.a.call(this);
};
Q.prototype.a = function() {
    throw lc;
};
Q.prototype.u = function() {
    return this;
};
function mc(a) {
    if (a instanceof R || a instanceof S || a instanceof T) return a;
    if ("function" == typeof a.next) return new R(function() {
        return nc(a);
    });
    t();
    u();
    if ("function" == typeof a[Symbol.iterator]) return t(), u(), new R(function() {
        return a[Symbol.iterator]();
    });
    if ("function" == typeof a.u) return new R(function() {
        return nc(a.u());
    });
    throw Error("Not an iterator or iterable.");
}
function nc(a) {
    if (!(a instanceof Q)) return a;
    var b = !1;
    return {
        next: function() {
            for(var c; !b;)try {
                c = a.a();
                break;
            } catch (d) {
                if (d !== lc) throw d;
                b = !0;
            }
            return {
                value: c,
                done: b
            };
        }
    };
}
t();
u();
function R(a) {
    this.b = a;
}
R.prototype.u = function() {
    return new S(this.b());
};
R.prototype[Symbol.iterator] = function() {
    return new T(this.b());
};
R.prototype.c = function() {
    return new T(this.b());
};
t();
u();
function S(a) {
    this.b = a;
}
oa(S, Q);
S.prototype.a = function() {
    var a = this.b.next();
    if (a.done) throw lc;
    return a.value;
};
S.prototype.next = function() {
    return S.prototype.a.call(this);
};
S.prototype[Symbol.iterator] = function() {
    return new T(this.b);
};
S.prototype.c = function() {
    return new T(this.b);
};
function T(a) {
    R.call(this, function() {
        return a;
    });
    this.f = a;
}
oa(T, R);
T.prototype.next = function() {
    return this.f.next();
};
function oc(a, b) {
    this.o = {};
    this.j = [];
    this.B = this.size = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else a && this.addAll(a);
}
n = oc.prototype;
n.G = function() {
    pc(this);
    return this.j.concat();
};
n.has = function(a) {
    return U(this.o, a);
};
n.clear = function() {
    this.o = {};
    this.B = this.size = this.j.length = 0;
};
n.remove = function(a) {
    return this.delete(a);
};
n.delete = function(a) {
    return U(this.o, a) ? (delete this.o[a], --this.size, this.B++, this.j.length > 2 * this.size && pc(this), !0) : !1;
};
function pc(a) {
    if (a.size != a.j.length) {
        for(var b = 0, c = 0; b < a.j.length;){
            var d = a.j[b];
            U(a.o, d) && (a.j[c++] = d);
            b++;
        }
        a.j.length = c;
    }
    if (a.size != a.j.length) {
        var f = {};
        for(c = b = 0; b < a.j.length;)d = a.j[b], U(f, d) || (a.j[c++] = d, f[d] = 1), b++;
        a.j.length = c;
    }
}
n.get = function(a, b) {
    return U(this.o, a) ? this.o[a] : b;
};
n.set = function(a, b) {
    U(this.o, a) || (this.size += 1, this.j.push(a), this.B++);
    this.o[a] = b;
};
n.addAll = function(a) {
    if (a instanceof oc) for(var b = a.G(), c = 0; c < b.length; c++)this.set(b[c], a.get(b[c]));
    else for(b in a)this.set(b, a[b]);
};
n.forEach = function(a, b) {
    for(var c = this.G(), d = 0; d < c.length; d++){
        var f = c[d], g = this.get(f);
        a.call(b, g, f, this);
    }
};
n.clone = function() {
    return new oc(this);
};
n.keys = function() {
    return mc(this.u(!0)).c();
};
n.values = function() {
    return mc(this.u(!1)).c();
};
n.entries = function() {
    var a = this;
    return kc(this.keys(), function(b) {
        return [
            b,
            a.get(b)
        ];
    });
};
n.u = function(a) {
    pc(this);
    var b = 0, c = this.B, d = this, f = new Q;
    f.a = function() {
        if (c != d.B) throw Error("The map has changed since the iterator was created");
        if (b >= d.j.length) throw lc;
        var g = d.j[b++];
        return a ? g : d.o[g];
    };
    f.next = f.a.bind(f);
    return f;
};
function U(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var qc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function rc(a) {
    N.call(this);
    this.headers = new oc;
    this.C = a || null;
    this.c = !1;
    this.J = this.a = null;
    this.P = this.v = "";
    this.g = 0;
    this.l = "";
    this.i = this.N = this.s = this.L = !1;
    this.h = 0;
    this.w = null;
    this.m = sc;
    this.I = this.M = !1;
}
B(rc, N);
var sc = "";
rc.prototype.b = ac(bc(), "goog.net.XhrIo", void 0).g;
var tc = /^https?$/i, uc = [
    "POST",
    "PUT"
];
function vc(a, b, c) {
    if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.v + "; newUri=" + b);
    a.v = b;
    a.l = "";
    a.g = 0;
    a.P = "POST";
    a.L = !1;
    a.c = !0;
    a.a = a.C ? ic(a.C) : ic(gc);
    a.J = a.C ? ec(a.C) : ec(gc);
    a.a.onreadystatechange = z(a.R, a);
    try {
        P(a.b, V(a, "Opening Xhr")), a.N = !0, a.a.open("POST", String(b), !0), a.N = !1;
    } catch (g) {
        P(a.b, V(a, "Error opening Xhr: " + g.message));
        wc(a, g);
        return;
    }
    b = c || "";
    c = a.headers.clone();
    var d = c.G().find(function(g) {
        return "content-type" == g.toLowerCase();
    }), f = x.FormData && b instanceof x.FormData;
    !(0 <= Oa(uc, "POST")) || d || f || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    c.forEach(function(g, e) {
        this.a.setRequestHeader(e, g);
    }, a);
    a.m && (a.a.responseType = a.m);
    "withCredentials" in a.a && a.a.withCredentials !== a.M && (a.a.withCredentials = a.M);
    try {
        xc(a), 0 < a.h && (a.I = yc(a.a), P(a.b, V(a, "Will abort after " + a.h + "ms if incomplete, xhr2 " + a.I)), a.I ? (a.a.timeout = a.h, a.a.ontimeout = z(a.T, a)) : a.w = Mb(a.T, a.h, a)), P(a.b, V(a, "Sending request")), a.s = !0, a.a.send(b), a.s = !1;
    } catch (g) {
        P(a.b, V(a, "Send error: " + g.message)), wc(a, g);
    }
}
function yc(a) {
    return bb && kb() && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
n = rc.prototype;
n.T = function() {
    "undefined" != typeof qa && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, P(this.b, V(this, this.l)), O(this, "timeout"), this.abort(8));
};
function wc(a, b) {
    a.c = !1;
    a.a && (a.i = !0, a.a.abort(), a.i = !1);
    a.l = b;
    a.g = 5;
    zc(a);
    Ac(a);
}
function zc(a) {
    a.L || (a.L = !0, O(a, "complete"), O(a, "error"));
}
n.abort = function(a) {
    this.a && this.c && (P(this.b, V(this, "Aborting")), this.c = !1, this.i = !0, this.a.abort(), this.i = !1, this.g = a || 7, O(this, "complete"), O(this, "abort"), Ac(this));
};
n.R = function() {
    this.K || (this.N || this.s || this.i ? Bc(this) : this.W());
};
n.W = function() {
    Bc(this);
};
function Bc(a) {
    if (a.c && "undefined" != typeof qa) {
        if (a.J[1] && 4 == W(a) && 2 == a.getStatus()) P(a.b, V(a, "Local request error detected and ignored"));
        else if (a.s && 4 == W(a)) Mb(a.R, 0, a);
        else if (O(a, "readystatechange"), 4 == W(a)) {
            P(a.b, V(a, "Request complete"));
            a.c = !1;
            try {
                var b = a.getStatus();
                a: switch(b){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var c = !0;
                        break a;
                    default:
                        c = !1;
                }
                var d;
                if (!(d = c)) {
                    var f;
                    if (f = 0 === b) {
                        var g = String(a.v).match(qc)[1] || null;
                        if (!g && x.self && x.self.location) {
                            var e = x.self.location.protocol;
                            g = e.substr(0, e.length - 1);
                        }
                        f = !tc.test(g ? g.toLowerCase() : "");
                    }
                    d = f;
                }
                if (d) O(a, "complete"), O(a, "success");
                else {
                    a.g = 6;
                    try {
                        var h = 2 < W(a) ? a.a.statusText : "";
                    } catch (k) {
                        P(a.b, "Can not get status: " + k.message), h = "";
                    }
                    a.l = h + " [" + a.getStatus() + "]";
                    zc(a);
                }
            } finally{
                Ac(a);
            }
        }
    }
}
function Ac(a) {
    if (a.a) {
        xc(a);
        var b = a.a, c = a.J[0] ? ra : null;
        a.a = null;
        a.J = null;
        O(a, "ready");
        try {
            b.onreadystatechange = c;
        } catch (d) {
            (a = a.b) && cc(a, Pb, "Problem encountered resetting onreadystatechange: " + d.message);
        }
    }
}
function xc(a) {
    a.a && a.I && (a.a.ontimeout = null);
    a.w && (Lb.clearTimeout(a.w), a.w = null);
}
function W(a) {
    return a.a ? a.a.readyState : 0;
}
n.getStatus = function() {
    try {
        return 2 < W(this) ? this.a.status : -1;
    } catch (a) {
        return -1;
    }
};
function Cc(a) {
    try {
        if (!a.a) return null;
        if ("response" in a.a) return a.a.response;
        switch(a.m){
            case sc:
            case "text":
                return a.a.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.a) return a.a.mozResponseArrayBuffer;
        }
        var b = a.b;
        b && cc(b, Pb, "Response type " + a.m + " is not supported on this browser");
        return null;
    } catch (c) {
        return P(a.b, "Can not get response: " + c.message), null;
    }
}
function Dc(a) {
    var b = {};
    a = (a.a && 4 == W(a) ? a.a.getAllResponseHeaders() || "" : "").split("\r\n");
    for(var c = 0; c < a.length; c++)if (!/^[\s\xa0]*$/.test(a[c])) {
        var d = Xa(a[c]), f = d[0];
        d = d[1];
        if ("string" === typeof d) {
            d = d.trim();
            var g = b[f] || [];
            b[f] = g;
            g.push(d);
        }
    }
    return Ua(b, function(e) {
        return e.join(", ");
    });
}
function V(a, b) {
    return b + " [" + a.P + " " + a.v + " " + a.getStatus() + "]";
}
var Ec = {}, Fc = null;
function Gc(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : H("=.", a[b - 1]) && (c = H("=.", a[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), f = 0;
    Hc(a, function(g) {
        d[f++] = g;
    });
    return d.subarray(0, f);
}
function Hc(a, b) {
    function c(k) {
        for(; d < a.length;){
            var l = a.charAt(d++), m = Fc[l];
            if (null != m) return m;
            if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
        }
        return k;
    }
    Ic();
    for(var d = 0;;){
        var f = c(-1), g = c(0), e = c(64), h = c(64);
        if (64 === h && -1 === f) break;
        b(f << 2 | g >> 4);
        64 != e && (b(g << 4 & 240 | e >> 2), 64 != h && b(e << 6 & 192 | h));
    }
}
function Ic() {
    if (!Fc) {
        Fc = {};
        for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], c = 0; 5 > c; c++){
            var d = a.concat(b[c].split(""));
            Ec[c] = d;
            for(var f = 0; f < d.length; f++){
                var g = d[f];
                void 0 === Fc[g] && (Fc[g] = f);
            }
        }
    }
}
var Jc = [
    "content-type",
    "grpc-status",
    "grpc-message"
];
function X(a) {
    this.a = a.Z;
    this.m = null;
    this.b = [];
    this.h = [];
    this.g = [];
    this.f = [];
    this.c = [];
    this.l = !1;
    this.i = 0;
    this.s = new Ga;
    var b = this;
    zb(this.a, "readystatechange", function() {
        var c = b.a;
        if (c = c.a ? c.a.getResponseHeader("Content-Type") : null) {
            c = c.toLowerCase();
            if (0 == c.lastIndexOf("application/grpc-web-text", 0)) {
                c = b.a;
                try {
                    var d = c.a ? c.a.responseText : "";
                } catch (k) {
                    P(c.b, "Can not get responseText: " + k.message), d = "";
                }
                c = d || "";
                d = c.length - c.length % 4;
                c = c.substr(b.i, d - b.i);
                if (0 == c.length) return;
                b.i = d;
                c = Gc(c);
            } else if (0 == c.lastIndexOf("application/grpc", 0)) c = new Uint8Array(Cc(b.a));
            else {
                Y(b, new E(2, "Unknown Content-type received."));
                return;
            }
            d = null;
            try {
                d = Ia(b.s, c);
            } catch (k) {
                Y(b, new E(2, "Error in parsing response body"));
            }
            if (d) for(c = 0; c < d.length; c++){
                if (Ja in d[c]) {
                    var f = d[c][Ja];
                    if (f) {
                        var g = !1, e = void 0;
                        try {
                            e = b.m(f), g = !0;
                        } catch (k) {
                            Y(b, new E(13, "Error when deserializing response data; error: " + k + (", response: " + e)));
                        }
                        if (g) for(f = e, g = 0; g < b.b.length; g++)b.b[g](f);
                    }
                }
                if (G in d[c] && 0 < d[c][G].length) {
                    f = "";
                    for(g = 0; g < d[c][G].length; g++)f += String.fromCharCode(d[c][G][g]);
                    f = f.trim().split("\r\n");
                    g = {};
                    for(e = 0; e < f.length; e++){
                        var h = f[e].indexOf(":");
                        g[f[e].substring(0, h).trim()] = f[e].substring(h + 1).trim();
                    }
                    f = g;
                    g = 0;
                    e = "";
                    "grpc-status" in f && (g = Number(f["grpc-status"]), delete f["grpc-status"]);
                    "grpc-message" in f && (e = f["grpc-message"], delete f["grpc-message"]);
                    Y(b, new E(g, e, f));
                }
            }
        }
    });
    zb(this.a, "complete", function() {
        var c = b.a.g, d = 2, f = "", g = {};
        d = Dc(b.a);
        var e = {};
        for(h in d)d.hasOwnProperty(h) && (e[h.toLowerCase()] = d[h]);
        Object.keys(e).forEach(function(k) {
            Jc.includes(k) || (g[k] = e[k]);
        });
        Kc(b, g);
        var h = -1;
        if (0 != c) {
            switch(c){
                case 7:
                    d = 10;
                    break;
                case 8:
                    d = 4;
                    break;
                case 6:
                    h = b.a.getStatus();
                    d = Aa(h);
                    break;
                default:
                    d = 14;
            }
            10 == d && b.l || (f = Da(c), -1 != h && (f += ", http status code: " + h), Y(b, new E(d, f)));
        } else c = !1, "grpc-status" in e && (d = Number(e["grpc-status"]), "grpc-message" in e && (f = e["grpc-message"]), 0 != d && (Y(b, new E(d, f || "", e)), c = !0)), c || Lc(b);
    });
}
X.prototype.on = function(a, b) {
    "data" == a ? this.b.push(b) : "status" == a ? this.h.push(b) : "metadata" == a ? this.g.push(b) : "end" == a ? this.c.push(b) : "error" == a && this.f.push(b);
    return this;
};
function Mc(a, b) {
    b = a.indexOf(b);
    -1 < b && a.splice(b, 1);
}
X.prototype.removeListener = function(a, b) {
    "data" == a ? Mc(this.b, b) : "status" == a ? Mc(this.h, b) : "metadata" == a ? Mc(this.g, b) : "end" == a ? Mc(this.c, b) : "error" == a && Mc(this.f, b);
    return this;
};
X.prototype.cancel = function() {
    this.l = !0;
    this.a.abort();
};
function Y(a, b) {
    if (0 != b.code) for(var c = new E(b.code, decodeURIComponent(b.message || ""), b.metadata), d = 0; d < a.f.length; d++)a.f[d](c);
    b = {
        code: b.code,
        details: decodeURIComponent(b.message || ""),
        metadata: b.metadata
    };
    for(c = 0; c < a.h.length; c++)a.h[c](b);
}
function Kc(a, b) {
    for(var c = 0; c < a.g.length; c++)a.g[c](b);
}
function Lc(a) {
    for(var b = 0; b < a.c.length; b++)a.c[b]();
}
X.prototype.cancel = X.prototype.cancel;
X.prototype.removeListener = X.prototype.removeListener;
X.prototype.on = X.prototype.on;
function Nc(a) {
    var b = "";
    Ta(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function Z(a, b) {
    a = void 0 === a ? {} : a;
    this.a = a.format || y("format", a) || "text";
    this.g = a.aa || y("suppressCorsPreflight", a) || !1;
    this.f = a.withCredentials || y("withCredentials", a) || !1;
    this.b = a.$ || y("streamInterceptors", a) || [];
    this.h = a.ba || y("unaryInterceptors", a) || [];
    this.c = b || null;
}
Z.prototype.X = function(a, b, c, d, f) {
    var g = this, e = a.substr(0, a.length - d.name.length);
    a = Oc(function(h) {
        return Pc(g, h, e);
    }, this.b).call(this, za(d, b, c));
    Qc(a, f, !1);
    return new Ca(a);
};
Z.prototype.S = function(a, b, c, d) {
    var f = this, g = a.substr(0, a.length - d.name.length);
    return Oc(function(e) {
        return new Promise(function(h, k) {
            var l = Pc(f, e, g), m, p, q;
            Qc(l, function(w, A, L, Sb, Rc) {
                w ? k(w) : Rc ? q = A : L ? p = L : Sb ? m = Sb : (w = e.getMethodDescriptor(), A = m, A = void 0 === A ? {} : A, h(new D(q, w, A, void 0 === p ? null : p)));
            }, !0);
        });
    }, this.h).call(this, za(d, b, c)).then(function(e) {
        return e.getResponseMessage();
    });
};
Z.prototype.unaryCall = function(a, b, c, d) {
    return this.S(a, b, c, d);
};
Z.prototype.Y = function(a, b, c, d) {
    var f = this, g = a.substr(0, a.length - d.name.length);
    return Oc(function(e) {
        return Pc(f, e, g);
    }, this.b).call(this, za(d, b, c));
};
function Pc(a, b, c) {
    var d = b.getMethodDescriptor(), f = c + d.getName();
    c = a.c ? a.c : new rc;
    c.M = a.f;
    var g = new X({
        Z: c
    });
    g.m = d.b;
    var e = b.getMetadata();
    for(h in e)c.headers.set(h, e[h]);
    "text" == a.a ? (c.headers.set("Content-Type", "application/grpc-web-text"), c.headers.set("Accept", "application/grpc-web-text")) : c.headers.set("Content-Type", "application/grpc-web+proto");
    c.headers.set("X-User-Agent", "grpc-web-javascript/0.1");
    c.headers.set("X-Grpc-Web", "1");
    if (c.headers.has("deadline")) {
        var h = Number(c.headers.get("deadline"));
        h = Math.ceil(h - (new Date).getTime());
        c.headers.delete("deadline");
        Infinity === h && (h = 0);
        0 < h && (c.headers.set("grpc-timeout", h + "m"), c.h = Math.max(0, Math.max(1E3, Math.ceil(1.1 * h))));
    }
    if (a.g) {
        e = c.headers;
        h = {};
        for(var k = ha(e.keys()), l = k.next(); !l.done; l = k.next())l = l.value, h[l] = e.get(l);
        c.headers.clear();
        b: {
            for(m in h){
                var m = !1;
                break b;
            }
            m = !0;
        }
        if (!m) {
            if (h = Nc(h), "string" === typeof f) {
                if (m = encodeURIComponent("$httpHeaders"), h = null != h ? "=" + encodeURIComponent(String(h)) : "", m += h) h = f.indexOf("#"), 0 > h && (h = f.length), e = f.indexOf("?"), 0 > e || e > h ? (e = h, k = "") : k = f.substring(e + 1, h), f = [
                    f.substr(0, e),
                    k,
                    f.substr(h)
                ], h = f[1], f[1] = m ? h ? h + "&" + m : m : h, f = f[0] + (f[1] ? "?" + f[1] : "") + f[2];
            } else f.a("$httpHeaders", h);
        }
    }
    b = (0, d.a)(b.getRequestMessage());
    d = b.length;
    m = [
        0,
        0,
        0,
        0
    ];
    h = new Uint8Array(5 + d);
    for(e = 3; 0 <= e; e--)m[e] = d % 256, d >>>= 8;
    h.set(new Uint8Array(m), 1);
    h.set(b, 5);
    b = h;
    if ("text" == a.a) {
        a = b;
        var p;
        void 0 === p && (p = 0);
        Ic();
        p = Ec[p];
        b = Array(Math.floor(a.length / 3));
        d = p[64] || "";
        for(m = h = 0; h < a.length - 2; h += 3){
            l = a[h];
            var q = a[h + 1];
            k = a[h + 2];
            e = p[l >> 2];
            l = p[(l & 3) << 4 | q >> 4];
            q = p[(q & 15) << 2 | k >> 6];
            k = p[k & 63];
            b[m++] = e + l + q + k;
        }
        e = 0;
        k = d;
        switch(a.length - h){
            case 2:
                e = a[h + 1], k = p[(e & 15) << 2] || d;
            case 1:
                a = a[h], b[m] = p[a >> 2] + p[(a & 3) << 4 | e >> 4] + k + d;
        }
        b = b.join("");
    } else "binary" == a.a && (c.m = "arraybuffer");
    vc(c, f, b);
    return g;
}
function Qc(a, b, c) {
    var d = !1, f = null, g = !1;
    a.on("data", function(e) {
        d = !0;
        f = e;
    });
    a.on("error", function(e) {
        0 == e.code || g || (g = !0, b(e, null));
    });
    a.on("status", function(e) {
        0 == e.code || g ? c && b(null, null, e) : (g = !0, b({
            code: e.code,
            message: e.details,
            metadata: e.metadata
        }, null));
    });
    if (c) a.on("metadata", function(e) {
        b(null, null, null, e);
    });
    a.on("end", function() {
        g || (d ? c ? b(null, f, null, null, !0) : b(null, f) : b({
            code: 2,
            message: "Incomplete response"
        }));
        c && b(null, null);
    });
}
function Oc(a, b) {
    var c = a;
    b.forEach(function(d) {
        var f = c;
        c = function(g) {
            return d.intercept(g, f);
        };
    });
    return c;
}
Z.prototype.serverStreaming = Z.prototype.Y;
Z.prototype.unaryCall = Z.prototype.unaryCall;
Z.prototype.thenableCall = Z.prototype.S;
Z.prototype.rpcCall = Z.prototype.X;
module.exports.CallOptions = xa;
module.exports.MethodDescriptor = ya;
module.exports.GrpcWebClientBase = Z;
module.exports.RpcError = E;
module.exports.StatusCode = {
    OK: 0,
    CANCELLED: 1,
    UNKNOWN: 2,
    INVALID_ARGUMENT: 3,
    DEADLINE_EXCEEDED: 4,
    NOT_FOUND: 5,
    ALREADY_EXISTS: 6,
    PERMISSION_DENIED: 7,
    UNAUTHENTICATED: 16,
    RESOURCE_EXHAUSTED: 8,
    FAILED_PRECONDITION: 9,
    ABORTED: 10,
    OUT_OF_RANGE: 11,
    UNIMPLEMENTED: 12,
    INTERNAL: 13,
    UNAVAILABLE: 14,
    DATA_LOSS: 15
};
module.exports.MethodType = {
    UNARY: "unary",
    SERVER_STREAMING: "server_streaming",
    BIDI_STREAMING: "bidi_streaming"
};
Lb = "undefined" !== typeof globalThis && globalThis || self;

},{}],"cePIg":[function(require,module,exports) {
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";
var $protobuf = require("7419f378f226128c");
// Common aliases
var $Reader = $protobuf.Reader, $util = $protobuf.util;
// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
$root.google = function() {
    /**
     * Namespace google.
     * @exports google
     * @namespace
     */ var google = {};
    google.protobuf = function() {
        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */ var protobuf = {};
        protobuf.Any = function() {
            /**
             * Properties of an Any.
             * @memberof google.protobuf
             * @interface IAny
             * @property {string|null} [type_url] Any type_url
             * @property {Uint8Array|null} [value] Any value
             */ /**
             * Constructs a new Any.
             * @memberof google.protobuf
             * @classdesc Represents an Any.
             * @implements IAny
             * @constructor
             * @param {google.protobuf.IAny=} [properties] Properties to set
             */ function Any(properties) {
                if (properties) {
                    for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                }
            }
            /**
             * Any type_url.
             * @member {string} type_url
             * @memberof google.protobuf.Any
             * @instance
             */ Any.prototype.type_url = "";
            /**
             * Any value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.Any
             * @instance
             */ Any.prototype.value = $util.newBuffer([]);
            /**
             * Decodes an Any message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Any
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Any} Any
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */ Any.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Any();
                while(reader.pos < end){
                    var tag = reader.uint32();
                    switch(tag >>> 3){
                        case 1:
                            message.type_url = reader.string();
                            break;
                        case 2:
                            message.value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            /**
             * Gets the default type url for Any
             * @function getTypeUrl
             * @memberof google.protobuf.Any
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */ Any.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
                return typeUrlPrefix + "/google.protobuf.Any";
            };
            return Any;
        }();
        return protobuf;
    }();
    google.rpc = function() {
        /**
         * Namespace rpc.
         * @memberof google
         * @namespace
         */ var rpc = {};
        rpc.Status = function() {
            /**
             * Properties of a Status.
             * @memberof google.rpc
             * @interface IStatus
             * @property {number|null} [code] Status code
             * @property {string|null} [message] Status message
             * @property {Array.<google.protobuf.IAny>|null} [details] Status details
             */ /**
             * Constructs a new Status.
             * @memberof google.rpc
             * @classdesc Represents a Status.
             * @implements IStatus
             * @constructor
             * @param {google.rpc.IStatus=} [properties] Properties to set
             */ function Status(properties) {
                this.details = [];
                if (properties) {
                    for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                }
            }
            /**
             * Status code.
             * @member {number} code
             * @memberof google.rpc.Status
             * @instance
             */ Status.prototype.code = 0;
            /**
             * Status message.
             * @member {string} message
             * @memberof google.rpc.Status
             * @instance
             */ Status.prototype.message = "";
            /**
             * Status details.
             * @member {Array.<google.protobuf.IAny>} details
             * @memberof google.rpc.Status
             * @instance
             */ Status.prototype.details = $util.emptyArray;
            /**
             * Decodes a Status message from the specified reader or buffer.
             * @function decode
             * @memberof google.rpc.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.rpc.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */ Status.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.rpc.Status();
                while(reader.pos < end){
                    var tag = reader.uint32();
                    switch(tag >>> 3){
                        case 1:
                            message.code = reader.int32();
                            break;
                        case 2:
                            message.message = reader.string();
                            break;
                        case 3:
                            if (!(message.details && message.details.length)) message.details = [];
                            message.details.push($root.google.protobuf.Any.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            /**
             * Gets the default type url for Status
             * @function getTypeUrl
             * @memberof google.rpc.Status
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */ Status.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
                return typeUrlPrefix + "/google.rpc.Status";
            };
            return Status;
        }();
        return rpc;
    }();
    return google;
}();
module.exports = $root;

},{"7419f378f226128c":"kV72x"}],"kV72x":[function(require,module,exports) {
// minimal library entry point.
"use strict";
module.exports = require("53502ce49364a9a0");

},{"53502ce49364a9a0":"551pw"}],"551pw":[function(require,module,exports) {
"use strict";
var protobuf = exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ protobuf.build = "minimal";
// Serialization
protobuf.Writer = require("123b8c1671ce76b7");
protobuf.BufferWriter = require("5e89240d6b4d6c84");
protobuf.Reader = require("7e7524d57b18d0d0");
protobuf.BufferReader = require("443298fa9a162adc");
// Utility
protobuf.util = require("682ea4beebbab45d");
protobuf.rpc = require("862afecd43193828");
protobuf.roots = require("14faeab02aebb66b");
protobuf.configure = configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function configure() {
    protobuf.util._configure();
    protobuf.Writer._configure(protobuf.BufferWriter);
    protobuf.Reader._configure(protobuf.BufferReader);
}
// Set up buffer utility according to the environment
configure();

},{"123b8c1671ce76b7":"aCxdP","5e89240d6b4d6c84":"lUtza","7e7524d57b18d0d0":"jcYat","443298fa9a162adc":"4hGz0","682ea4beebbab45d":"iCPIa","862afecd43193828":"23GSx","14faeab02aebb66b":"7Sz5g"}],"aCxdP":[function(require,module,exports) {
"use strict";
module.exports = Writer;
var util = require("5c785c60b384e6c3");
var BufferWriter; // cyclic
var LongBits = util.LongBits, base64 = util.base64, utf8 = util.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new Op(noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var create = function create() {
    return util.Buffer ? function create_buffer_setup() {
        return (Writer.create = function create_buffer() {
            return new BufferWriter();
        })();
    } : function create_array() {
        return new Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ Writer.create = create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ Writer.alloc = function alloc(size) {
    return new util.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if (util.Array !== Array) Writer.alloc = util.pool(Writer.alloc, util.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new Op(fn, len, val);
    this.len += len;
    return this;
};
function writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push(writeVarint64, 10, LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.uint64 = function write_uint64(value) {
    var bits = LongBits.from(value);
    return this._push(writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.int64 = Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.sint64 = function write_sint64(value) {
    var bits = LongBits.from(value).zzEncode();
    return this._push(writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.bool = function write_bool(value) {
    return this._push(writeByte, 1, value ? 1 : 0);
};
function writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push(writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.sfixed32 = Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = LongBits.from(value);
    return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.sfixed64 = Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.float = function write_float(value) {
    return this._push(util.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.double = function write_double(value) {
    return this._push(util.float.writeDoubleLE, 8, value);
};
var writeBytes = util.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push(writeByte, 1, 0);
    if (util.isString(value)) {
        var buf = Writer.alloc(len = base64.length(value));
        base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push(writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.string = function write_string(value) {
    var len = utf8.length(value);
    return len ? this.uint32(len)._push(utf8.write, len, value) : this._push(writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ Writer.prototype.fork = function fork() {
    this.states = new State(this);
    this.head = this.tail = new Op(noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new Op(noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
Writer._configure = function(BufferWriter_) {
    BufferWriter = BufferWriter_;
    Writer.create = create();
    BufferWriter._configure();
};

},{"5c785c60b384e6c3":"iCPIa"}],"iCPIa":[function(require,module,exports) {
var global = arguments[3];
"use strict";
var util = exports;
// used to return a Promise where callback is omitted
util.asPromise = require("217e30ba36d0c075");
// converts to / from base64 encoded strings
util.base64 = require("140216d783bbc015");
// base class of rpc.Service
util.EventEmitter = require("78776c045df9e77b");
// float handling accross browsers
util.float = require("392006759dba32fb");
// requires modules optionally and hides the call from bundlers
util.inquire = require("ac14d008f0aa6436");
// converts to / from utf8 encoded strings
util.utf8 = require("298ebb5f36c5d25a");
// provides a node-like buffer pool in the browser
util.pool = require("dc7a35661f9f9275");
// utility to work with the low and high bits of a 64 bit value
util.LongBits = require("94b513d9f4cac968");
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ util.isNode = Boolean(typeof global !== "undefined" && global && global.process && global.process.versions && global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ util.global = util.isNode && global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || this; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ util.Buffer = function() {
    try {
        var Buffer = util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? util.Buffer ? util._Buffer_allocUnsafe(sizeOrArray) : new util.Array(sizeOrArray) : util.Buffer ? util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ util.Long = /* istanbul ignore next */ util.global.dcodeIO && /* istanbul ignore next */ util.global.dcodeIO.Long || /* istanbul ignore next */ util.global.Long || util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ util.longToHash = function longToHash(value) {
    return value ? util.LongBits.from(value).toHash() : util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = util.LongBits.fromHash(hash);
    if (util.Long) return util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
util.merge = merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError,
            writable: true,
            enumerable: false,
            configurable: true
        },
        name: {
            get: function get() {
                return name;
            },
            set: undefined,
            enumerable: false,
            // configurable: false would accurately preserve the behavior of
            // the original, but I'm guessing that was not intentional.
            // For an actual error subclass, this property would
            // be configurable.
            configurable: true
        },
        toString: {
            value: function value() {
                return this.name + ": " + this.message;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    return CustomError;
}
util.newError = newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ util.ProtocolError = newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
util._configure = function() {
    var Buffer = util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        util._Buffer_from = util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

},{"217e30ba36d0c075":"dgtNO","140216d783bbc015":"d2Yp8","78776c045df9e77b":"dURLg","392006759dba32fb":"20CHu","ac14d008f0aa6436":"dQQU7","298ebb5f36c5d25a":"jiBUm","dc7a35661f9f9275":"7zpjh","94b513d9f4cac968":"kQIcw"}],"dgtNO":[function(require,module,exports) {
"use strict";
module.exports = asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

},{}],"d2Yp8":[function(require,module,exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var base64 = exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var b64 = new Array(64);
// Base64 decoding table
var s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var i = 0; i < 64;)s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = b64[t | b >> 6];
                chunk[i++] = b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = s64[c]) === undefined) throw Error(invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error(invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

},{}],"dURLg":[function(require,module,exports) {
"use strict";
module.exports = EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

},{}],"20CHu":[function(require,module,exports) {
"use strict";
module.exports = factory(factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

},{}],"dQQU7":[function(require,module,exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

},{}],"jiBUm":[function(require,module,exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var utf8 = exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

},{}],"7zpjh":[function(require,module,exports) {
"use strict";
module.exports = pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

},{}],"kQIcw":[function(require,module,exports) {
"use strict";
module.exports = LongBits;
var util = require("670bae0bb8fddc8f");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var zero = LongBits.zero = new LongBits(0, 0);
zero.toNumber = function() {
    return 0;
};
zero.zzEncode = zero.zzDecode = function() {
    return this;
};
zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ LongBits.from = function from(value) {
    if (typeof value === "number") return LongBits.fromNumber(value);
    if (util.isString(value)) {
        /* istanbul ignore else */ if (util.Long) value = util.Long.fromString(value);
        else return LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ LongBits.prototype.toLong = function toLong(unsigned) {
    return util.Long ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ LongBits.fromHash = function fromHash(hash) {
    if (hash === zeroHash) return zero;
    return new LongBits((charCodeAt.call(hash, 0) | charCodeAt.call(hash, 1) << 8 | charCodeAt.call(hash, 2) << 16 | charCodeAt.call(hash, 3) << 24) >>> 0, (charCodeAt.call(hash, 4) | charCodeAt.call(hash, 5) << 8 | charCodeAt.call(hash, 6) << 16 | charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

},{"670bae0bb8fddc8f":"iCPIa"}],"lUtza":[function(require,module,exports) {
"use strict";
module.exports = BufferWriter;
// extends Writer
var Writer = require("e9b2a43e398901ec");
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util = require("8ed11af2c26d797d");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function BufferWriter() {
    Writer.call(this);
}
BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ BufferWriter.alloc = util._Buffer_allocUnsafe;
    BufferWriter.writeBytesBuffer = util.Buffer && util.Buffer.prototype instanceof Uint8Array && util.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if (util.isString(value)) value = util._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push(BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function writeStringBuffer(val, buf, pos) {
    if (val.length < 40) util.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = util.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push(writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ BufferWriter._configure();

},{"e9b2a43e398901ec":"aCxdP","8ed11af2c26d797d":"iCPIa"}],"jcYat":[function(require,module,exports) {
"use strict";
module.exports = Reader;
var util = require("9f80034b34dad30b");
var BufferReader; // cyclic
var LongBits = util.LongBits, utf8 = util.utf8;
/* istanbul ignore next */ function indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new Reader(buffer);
    throw Error("illegal buffer");
};
var create = function create() {
    return util.Buffer ? function create_buffer_setup(buffer) {
        return (Reader.create = function create_buffer(buffer) {
            return util.Buffer.isBuffer(buffer) ? new BufferReader(buffer) : create_array(buffer);
        })(buffer);
    } : create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ Reader.create = create();
Reader.prototype._slice = util.Array.prototype.subarray || /* istanbul ignore next */ util.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw indexOutOfRange(this, 8);
    return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    var value = util.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw indexOutOfRange(this, 4);
    var value = util.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    if (start === end) {
        var nativeBuffer = util.Buffer;
        return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
Reader._configure = function(BufferReader_) {
    BufferReader = BufferReader_;
    Reader.create = create();
    BufferReader._configure();
    var fn = util.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    util.merge(Reader.prototype, {
        int64: function read_int64() {
            return readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return readFixed64.call(this)[fn](false);
        }
    });
};

},{"9f80034b34dad30b":"iCPIa"}],"4hGz0":[function(require,module,exports) {
"use strict";
module.exports = BufferReader;
// extends Reader
var Reader = require("808dd763e7b39931");
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util = require("fcb9b16130e5c787");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function BufferReader(buffer) {
    Reader.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
BufferReader._configure = function() {
    /* istanbul ignore else */ if (util.Buffer) BufferReader.prototype._slice = util.Buffer.prototype.slice;
};
/**
 * @override
 */ BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ BufferReader._configure();

},{"808dd763e7b39931":"jcYat","fcb9b16130e5c787":"iCPIa"}],"23GSx":[function(require,module,exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var rpc = exports;
/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ rpc.Service = require("8d618176461c1566");

},{"8d618176461c1566":"6nqxf"}],"6nqxf":[function(require,module,exports) {
"use strict";
module.exports = Service;
var util = require("873e42e92ef9570e");
// Extends EventEmitter
(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    util.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return util.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

},{"873e42e92ef9570e":"iCPIa"}],"7Sz5g":[function(require,module,exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available across modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

},{}],"dzunb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.signMultiSignedNode = exports.openMultiSignedNode = exports.signSignedEntity = exports.openSignedEntity = exports.IDENTITY_ERR_CERTIFICATE_ROTATION_FORBIDDEN_CODE = exports.IDENTITY_MODULE_NAME = exports.ERR_UNKNOWN_ERROR_CODE = exports.UNKNOWN_MODULE = exports.CODE_NO_ERROR = exports.LATEST_NODE_DESCRIPTOR_VERSION = exports.ENTITY_LATEST_DESCRIPTOR_VERSION = exports.INVALID_VERSION = exports.TEE_HARDWARE_RESERVED = exports.TEE_HARDWARE_INTEL_SGX = exports.TEE_HARDWARE_INVALID = exports.ROLE_STORAGE_RPC = exports.ROLE_CONSENSUS_RPC = exports.ROLE_VALIDATOR = exports.ROLE_KEY_MANAGER = exports.ROLE_COMPUTE_WORKER = void 0;
const misc = require("2b837538c7b092c0");
const signature = require("f58c191fa54a77");
/**
 * RoleComputeWorker is the compute worker role.
 */ exports.ROLE_COMPUTE_WORKER = 1;
/**
 * RoleKeyManager is the the key manager role.
 */ exports.ROLE_KEY_MANAGER = 4;
/**
 * RoleValidator is the validator role.
 */ exports.ROLE_VALIDATOR = 8;
/**
 * RoleConsensusRPC is the public consensus RPC services worker role.
 */ exports.ROLE_CONSENSUS_RPC = 16;
/**
 * RoleStorageRPC is the public storage RPC services worker role.
 */ exports.ROLE_STORAGE_RPC = 32;
/**
 * TEEHardwareInvalid is a non-TEE implementation.
 */ exports.TEE_HARDWARE_INVALID = 0;
/**
 * TEEHardwareIntelSGX is an Intel SGX TEE implementation.
 */ exports.TEE_HARDWARE_INTEL_SGX = 1;
/**
 * TEEHardwareReserved is the first reserved hardware implementation
 * identifier. All equal or greater identifiers are reserved.
 */ exports.TEE_HARDWARE_RESERVED = exports.TEE_HARDWARE_INTEL_SGX + 1;
exports.INVALID_VERSION = 65536;
/**
 * LatestDescriptorVersion is the latest descriptor version that should be
 * used for all new descriptors. Using earlier versions may be rejected.
 */ exports.ENTITY_LATEST_DESCRIPTOR_VERSION = 2;
/**
 * LatestNodeDescriptorVersion is the latest node descriptor version that should be used for all
 * new descriptors. Using earlier versions may be rejected.
 */ exports.LATEST_NODE_DESCRIPTOR_VERSION = 1;
/**
 * CodeNoError is the reserved "no error" code.
 */ exports.CODE_NO_ERROR = 0;
/**
 * UnknownModule is the module name used when the module is unknown.
 */ exports.UNKNOWN_MODULE = "unknown";
exports.ERR_UNKNOWN_ERROR_CODE = 1;
exports.IDENTITY_MODULE_NAME = "identity";
/**
 * ErrCertificateRotationForbidden is returned by RotateCertificates if
 * TLS certificate rotation is forbidden.  This happens when rotation is
 * enabled and an existing TLS certificate was successfully loaded
 * (or a new one was generated and persisted to disk).
 */ exports.IDENTITY_ERR_CERTIFICATE_ROTATION_FORBIDDEN_CODE = 1;
async function openSignedEntity(context, signed) {
    return misc.fromCBOR(await signature.openSigned(context, signed));
}
exports.openSignedEntity = openSignedEntity;
async function signSignedEntity(signer, context, entity) {
    return await signature.signSigned(signer, context, misc.toCBOR(entity));
}
exports.signSignedEntity = signSignedEntity;
async function openMultiSignedNode(context, multiSigned) {
    return misc.fromCBOR(await signature.openMultiSigned(context, multiSigned));
}
exports.openMultiSignedNode = openMultiSignedNode;
async function signMultiSignedNode(signers, context, node) {
    return await signature.signMultiSigned(signers, context, misc.toCBOR(node));
}
exports.signMultiSignedNode = signMultiSignedNode;

},{"2b837538c7b092c0":"agInO","f58c191fa54a77":"3x9Lz"}],"chNDh":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEBUG_ERR_INCOMPATIBLE_BACKEND_CODE = exports.DEBUG_MODULE_NAME = void 0;
/**
 * DebugModuleName is the module name for the debug controller service.
 */ exports.DEBUG_MODULE_NAME = "control/debug";
/**
 * ErrIncompatibleBackend is the error raised when the current beacon
 * backend does not support manually setting the current epoch.
 */ exports.DEBUG_ERR_INCOMPATIBLE_BACKEND_CODE = 1;

},{}],"6l4rn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.chainContext = void 0;
const hash = require("d29eefe720a7be37");
const misc = require("e4fa3f2c0ae5c71f");
async function chainContext(doc) {
    return misc.toHex(await hash.hash(misc.toCBOR(doc)));
}
exports.chainContext = chainContext;

},{"d29eefe720a7be37":"1sr6I","e4fa3f2c0ae5c71f":"agInO"}],"dqeaU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.castVoteWrapper = exports.submitProposalWrapper = exports.ERR_VOTING_IS_CLOSED_CODE = exports.ERR_NOT_ELIGIBLE_CODE = exports.ERR_NO_SUCH_PROPOSAL_CODE = exports.ERR_NO_SUCH_UPGRADE_CODE = exports.ERR_UPGRADE_ALREADY_PENDING_CODE = exports.ERR_UPGRADE_TOO_SOON_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.VOTE_ABSTAIN = exports.VOTE_NO = exports.VOTE_YES = exports.PROPOSAL_CONTENT_INVALID_TEXT = exports.STATE_FAILED = exports.STATE_REJECTED = exports.STATE_PASSED = exports.STATE_ACTIVE = exports.METHOD_CAST_VOTE = exports.METHOD_SUBMIT_PROPOSAL = void 0;
const consensus = require("d4c9b36f836302a3");
/**
 * MethodSubmitProposal submits a new consensus layer governance proposal.
 */ exports.METHOD_SUBMIT_PROPOSAL = "governance.SubmitProposal";
/**
 * MethodCastVote casts a vote for a consensus layer governance proposal.
 */ exports.METHOD_CAST_VOTE = "governance.CastVote";
exports.STATE_ACTIVE = 1;
exports.STATE_PASSED = 2;
exports.STATE_REJECTED = 3;
exports.STATE_FAILED = 4;
/**
 * ProposalContentInvalidText is the textual representation of an invalid
 * ProposalContent.
 */ exports.PROPOSAL_CONTENT_INVALID_TEXT = "(invalid)";
exports.VOTE_YES = 1;
exports.VOTE_NO = 2;
exports.VOTE_ABSTAIN = 3;
/**
 * ModuleName is a unique module name for the governance backend.
 */ exports.MODULE_NAME = "governance";
/**
 * ErrInvalidArgument is the error returned on malformed argument(s).
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrUpgradeTooSoon is the error returned when an upgrade is not enough in the future.
 */ exports.ERR_UPGRADE_TOO_SOON_CODE = 2;
/**
 * ErrUpgradeAlreadyPending is the error returned when an upgrade is already pending.
 */ exports.ERR_UPGRADE_ALREADY_PENDING_CODE = 3;
/**
 * ErrNoSuchUpgrade is the error returned when an upgrade does not exist.
 */ exports.ERR_NO_SUCH_UPGRADE_CODE = 4;
/**
 * ErrNoSuchProposal is the error retrued when a proposal does not exist.
 */ exports.ERR_NO_SUCH_PROPOSAL_CODE = 5;
/**
 * ErrNotEligible is the error returned when a vote caster is not eligible for a vote.
 */ exports.ERR_NOT_ELIGIBLE_CODE = 6;
/**
 * ErrVotingIsClosed is the error returned when a vote is cast for a non-active proposal.
 */ exports.ERR_VOTING_IS_CLOSED_CODE = 7;
function submitProposalWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_SUBMIT_PROPOSAL);
}
exports.submitProposalWrapper = submitProposalWrapper;
function castVoteWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_CAST_VOTE);
}
exports.castVoteWrapper = castVoteWrapper;

},{"d4c9b36f836302a3":"9UvMb"}],"7po7g":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HDKey = void 0;
const js_sha512_1 = require("eb7a3a690d5b4186");
const tweetnacl_1 = require("68ec01cc75dbb18e");
const bip39_1 = require("d87363649df20bf8");
const misc_1 = require("74b6a4fefd80bce");
const ED25519_CURVE = "ed25519 seed";
const HARDENED_OFFSET = 0x80000000;
const pathRegex = new RegExp("^m(\\/[0-9]+')+$");
/**
 * HDKey handles hierarchical key generation according to ADR 0008
 * https://github.com/oasisprotocol/adrs/blob/main/0008-standard-account-key-generation.md
 */ class HDKey {
    /**
     * Generates the keypair matching the supplied parameters
     * @param mnemonic BIP-0039 Mnemonic
     * @param index Account index
     * @param passphrase Optional BIP-0039 passphrase
     * @returns SignKeyPair for these parameters
     */ static async getAccountSigner(mnemonic, index = 0, passphrase) {
        if (index < 0 || index > 0x7fffffff) throw new Error("Account number must be >= 0 and <= 2147483647");
        const seed = await (0, bip39_1.mnemonicToSeed)(mnemonic, passphrase);
        const key = HDKey.makeHDKey(ED25519_CURVE, seed);
        return key.derivePath(`m/44'/474'/${index}'`).keypair;
    }
    /**
     * Generates a mnemonic
     * @param strength Length in bits of the generated mnemonic
     * @returns Generated BIP-0039 Mnemonic
     */ static generateMnemonic(strength = 256) {
        return (0, bip39_1.generateMnemonic)(strength);
    }
    constructor(privateKey, chainCode){
        this.privateKey = privateKey;
        this.chainCode = chainCode;
        this.keypair = tweetnacl_1.sign.keyPair.fromSeed(privateKey);
    }
    /**
     * Returns the HDKey for the given derivation path
     * using SLIP-0010
     * @param path Derivation path, starting with m/
     * @returns Instance of HDKey
     */ derivePath(path) {
        if (!pathRegex.test(path)) throw new Error("Invalid derivation path. Valid paths must use a format similar to : m/44'/474'/0' and all indexes must be hardened");
        const segments = path.split("/").slice(1).map((val)=>val.replace("'", "")).map((el)=>parseInt(el, 10));
        return segments.reduce((parent, segment)=>parent.derive(segment + HARDENED_OFFSET), this);
    }
    /**
     * Derive the child key at the specified index
     * @param index
     * @returns Instance of HDKey
     */ derive(index) {
        const buffer = new ArrayBuffer(4);
        const view = new DataView(buffer);
        view.setUint32(0, index);
        const data = (0, misc_1.concat)(new Uint8Array([
            0
        ]), this.privateKey, new Uint8Array(buffer));
        return HDKey.makeHDKey(this.chainCode, data);
    }
    static makeHDKey(hmacKey, data) {
        //@ts-ignore The types of js-sha512 are outdated
        const hash = js_sha512_1.sha512.hmac.arrayBuffer(hmacKey, data);
        const I = new Uint8Array(hash);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        return new HDKey(IL, IR);
    }
}
exports.HDKey = HDKey;

},{"eb7a3a690d5b4186":"9yOC0","68ec01cc75dbb18e":"dbRqa","d87363649df20bf8":"3u1O4","74b6a4fefd80bce":"agInO"}],"3u1O4":[function(require,module,exports) {
var Buffer = require("ad6c208ed534fe78").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const sha256_1 = require("be2effb341cd7f75");
const sha512_1 = require("d8b171a06d384656");
const pbkdf2_1 = require("5a2385d1e7fed5f7");
const utils_1 = require("b3a9566b6481624b");
const _wordlists_1 = require("7e8652e50b1fc36d");
let DEFAULT_WORDLIST = _wordlists_1._default;
const INVALID_MNEMONIC = "Invalid mnemonic";
const INVALID_ENTROPY = "Invalid entropy";
const INVALID_CHECKSUM = "Invalid mnemonic checksum";
const WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function normalize(str) {
    return (str || "").normalize("NFKD");
}
function lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function binaryToByte(bin) {
    return parseInt(bin, 2);
}
function bytesToBinary(bytes) {
    return bytes.map((x)=>lpad(x.toString(2), "0", 8)).join("");
}
function deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = sha256_1.sha256(Uint8Array.from(entropyBuffer));
    return bytesToBinary(Array.from(hash)).slice(0, CS);
}
function salt(password) {
    return "mnemonic" + (password || "");
}
function mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from(Buffer.from(normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from(Buffer.from(salt(normalize(password)), "utf8"));
    const res = pbkdf2_1.pbkdf2(sha512_1.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return Buffer.from(res);
}
exports.mnemonicToSeedSync = mnemonicToSeedSync;
function mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from(Buffer.from(normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from(Buffer.from(salt(normalize(password)), "utf8"));
    return pbkdf2_1.pbkdf2Async(sha512_1.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>Buffer.from(res));
}
exports.mnemonicToSeed = mnemonicToSeed;
function mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || DEFAULT_WORDLIST;
    if (!wordlist) throw new Error(WORDLIST_REQUIRED);
    const words = normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error(INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error(INVALID_MNEMONIC);
        return lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte);
    if (entropyBytes.length < 16) throw new Error(INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error(INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error(INVALID_ENTROPY);
    const entropy = Buffer.from(entropyBytes);
    const newChecksum = deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error(INVALID_CHECKSUM);
    return entropy.toString("hex");
}
exports.mnemonicToEntropy = mnemonicToEntropy;
function entropyToMnemonic(entropy, wordlist) {
    if (!Buffer.isBuffer(entropy)) entropy = Buffer.from(entropy, "hex");
    wordlist = wordlist || DEFAULT_WORDLIST;
    if (!wordlist) throw new Error(WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError(INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError(INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError(INVALID_ENTROPY);
    const entropyBits = bytesToBinary(Array.from(entropy));
    const checksumBits = deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" // Japanese wordlist
     ? words.join("\u3000") : words.join(" ");
}
exports.entropyToMnemonic = entropyToMnemonic;
function generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError(INVALID_ENTROPY);
    rng = rng || ((size)=>Buffer.from(utils_1.randomBytes(size)));
    return entropyToMnemonic(rng(strength / 8), wordlist);
}
exports.generateMnemonic = generateMnemonic;
function validateMnemonic(mnemonic, wordlist) {
    try {
        mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
exports.validateMnemonic = validateMnemonic;
function setDefaultWordlist(language) {
    const result = _wordlists_1.wordlists[language];
    if (result) DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
exports.setDefaultWordlist = setDefaultWordlist;
function getDefaultWordlist() {
    if (!DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys(_wordlists_1.wordlists).filter((lang)=>{
        if (lang === "JA" || lang === "EN") return false;
        return _wordlists_1.wordlists[lang].every((word, index)=>word === DEFAULT_WORDLIST[index]);
    })[0];
}
exports.getDefaultWordlist = getDefaultWordlist;
var _wordlists_2 = require("7e8652e50b1fc36d");
exports.wordlists = _wordlists_2.wordlists;

},{"ad6c208ed534fe78":"eHuUs","be2effb341cd7f75":"1a1TJ","d8b171a06d384656":"lP8fb","5a2385d1e7fed5f7":"hsTqH","b3a9566b6481624b":"lHXRP","7e8652e50b1fc36d":"mN0OZ"}],"lP8fb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha384 = exports.sha512_256 = exports.sha512_224 = exports.sha512 = exports.SHA512 = void 0;
const _sha2_js_1 = require("de63277d4b9ab571");
const _u64_js_1 = require("eda9289ed6a1f5f2");
const utils_js_1 = require("f18acd6c798648cc");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [SHA512_Kh, SHA512_Kl] = /* @__PURE__ */ (()=>_u64_js_1.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends _sha2_js_1.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = _u64_js_1.default.rotrSH(W15h, W15l, 1) ^ _u64_js_1.default.rotrSH(W15h, W15l, 8) ^ _u64_js_1.default.shrSH(W15h, W15l, 7);
            const s0l = _u64_js_1.default.rotrSL(W15h, W15l, 1) ^ _u64_js_1.default.rotrSL(W15h, W15l, 8) ^ _u64_js_1.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = _u64_js_1.default.rotrSH(W2h, W2l, 19) ^ _u64_js_1.default.rotrBH(W2h, W2l, 61) ^ _u64_js_1.default.shrSH(W2h, W2l, 6);
            const s1l = _u64_js_1.default.rotrSL(W2h, W2l, 19) ^ _u64_js_1.default.rotrBL(W2h, W2l, 61) ^ _u64_js_1.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = _u64_js_1.default.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = _u64_js_1.default.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = _u64_js_1.default.rotrSH(Eh, El, 14) ^ _u64_js_1.default.rotrSH(Eh, El, 18) ^ _u64_js_1.default.rotrBH(Eh, El, 41);
            const sigma1l = _u64_js_1.default.rotrSL(Eh, El, 14) ^ _u64_js_1.default.rotrSL(Eh, El, 18) ^ _u64_js_1.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = _u64_js_1.default.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = _u64_js_1.default.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = _u64_js_1.default.rotrSH(Ah, Al, 28) ^ _u64_js_1.default.rotrBH(Ah, Al, 34) ^ _u64_js_1.default.rotrBH(Ah, Al, 39);
            const sigma0l = _u64_js_1.default.rotrSL(Ah, Al, 28) ^ _u64_js_1.default.rotrBL(Ah, Al, 34) ^ _u64_js_1.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = _u64_js_1.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = _u64_js_1.default.add3L(T1l, sigma0l, MAJl);
            Ah = _u64_js_1.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = _u64_js_1.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = _u64_js_1.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = _u64_js_1.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = _u64_js_1.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = _u64_js_1.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = _u64_js_1.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = _u64_js_1.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = _u64_js_1.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        SHA512_W_H.fill(0);
        SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
exports.SHA512 = SHA512;
class SHA512_224 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class SHA512_256 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class SHA384 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
exports.sha512 = (0, utils_js_1.wrapConstructor)(()=>new SHA512());
exports.sha512_224 = (0, utils_js_1.wrapConstructor)(()=>new SHA512_224());
exports.sha512_256 = (0, utils_js_1.wrapConstructor)(()=>new SHA512_256());
exports.sha384 = (0, utils_js_1.wrapConstructor)(()=>new SHA384());

},{"de63277d4b9ab571":"blbew","eda9289ed6a1f5f2":"iSvPJ","f18acd6c798648cc":"lHXRP"}],"hsTqH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pbkdf2Async = exports.pbkdf2 = void 0;
const _assert_js_1 = require("fbef50acc9ab07d9");
const hmac_js_1 = require("956a90fd4950a619");
const utils_js_1 = require("704e31af7d37dfd5");
// Common prologue and epilogue for sync/async functions
function pbkdf2Init(hash, _password, _salt, _opts) {
    (0, _assert_js_1.hash)(hash);
    const opts = (0, utils_js_1.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c, dkLen, asyncTick } = opts;
    (0, _assert_js_1.number)(c);
    (0, _assert_js_1.number)(dkLen);
    (0, _assert_js_1.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, utils_js_1.toBytes)(_password);
    const salt = (0, utils_js_1.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = hmac_js_1.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c,
        dkLen,
        asyncTick,
        DK,
        PRF,
        PRFSalt
    };
}
function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function pbkdf2(hash, password, salt, opts) {
    const { c, dkLen, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_js_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
exports.pbkdf2 = pbkdf2;
async function pbkdf2Async(hash, password, salt, opts) {
    const { c, dkLen, asyncTick, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_js_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, utils_js_1.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
exports.pbkdf2Async = pbkdf2Async;

},{"fbef50acc9ab07d9":"hlTZH","956a90fd4950a619":"8Kdrk","704e31af7d37dfd5":"lHXRP"}],"mN0OZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const wordlists = {};
exports.wordlists = wordlists;
let _default;
exports._default = _default;
try {
    exports._default = _default = require("ff3f03d3fc43a6ce");
    wordlists.czech = _default;
} catch (err) {}
try {
    exports._default = _default = require("7e65066f2c672ad9");
    wordlists.chinese_simplified = _default;
} catch (err) {}
try {
    exports._default = _default = require("f5f37ba865037007");
    wordlists.chinese_traditional = _default;
} catch (err) {}
try {
    exports._default = _default = require("c7936e26193bfc08");
    wordlists.korean = _default;
} catch (err) {}
try {
    exports._default = _default = require("8162a10bcd0e099");
    wordlists.french = _default;
} catch (err) {}
try {
    exports._default = _default = require("9f2c4ed1777f7a2c");
    wordlists.italian = _default;
} catch (err) {}
try {
    exports._default = _default = require("a676371ce1b1a251");
    wordlists.spanish = _default;
} catch (err) {}
try {
    exports._default = _default = require("622c4295116a42ea");
    wordlists.japanese = _default;
    wordlists.JA = _default;
} catch (err) {}
try {
    exports._default = _default = require("7f2d986dc6b2cd78");
    wordlists.portuguese = _default;
} catch (err) {}
try {
    exports._default = _default = require("b3d0157140a0c238");
    wordlists.english = _default;
    wordlists.EN = _default;
} catch (err) {}

},{"ff3f03d3fc43a6ce":"57ijS","7e65066f2c672ad9":"jEe0B","f5f37ba865037007":"9pJcm","c7936e26193bfc08":"75ccS","8162a10bcd0e099":"iwyYP","9f2c4ed1777f7a2c":"jUQYL","a676371ce1b1a251":"l1LUy","622c4295116a42ea":"kbVZ4","7f2d986dc6b2cd78":"kEY3j","b3d0157140a0c238":"gEopd"}],"57ijS":[function(require,module,exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

},{}],"jEe0B":[function(require,module,exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

},{}],"9pJcm":[function(require,module,exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

},{}],"75ccS":[function(require,module,exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

},{}],"iwyYP":[function(require,module,exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

},{}],"jUQYL":[function(require,module,exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

},{}],"l1LUy":[function(require,module,exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

},{}],"kbVZ4":[function(require,module,exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

},{}],"kEY3j":[function(require,module,exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

},{}],"gEopd":[function(require,module,exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

},{}],"eKbWP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updatePolicyWrapper = exports.ERR_NO_SUCH_STATUS_CODE = exports.MODULE_NAME = exports.METHOD_UPDATE_POLICY = void 0;
const consensus = require("a330902b09770e0c");
/**
 * MethodUpdatePolicy is the method name for policy updates.
 */ exports.METHOD_UPDATE_POLICY = "keymanager.UpdatePolicy";
/**
 * ModuleName is a unique module name for the keymanager module.
 */ exports.MODULE_NAME = "keymanager";
/**
 * ErrNoSuchStatus is the error returned when a key manager status does not
 * exist.
 */ exports.ERR_NO_SUCH_STATUS_CODE = 1;
function updatePolicyWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_UPDATE_POLICY);
}
exports.updatePolicyWrapper = updatePolicyWrapper;

},{"a330902b09770e0c":"9UvMb"}],"gkdQA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerRuntimeWrapper = exports.unfreezeNodeWrapper = exports.registerNodeWrapper = exports.deregisterEntityWrapper = exports.registerEntityWrapper = exports.ERR_ENTITY_HAS_RUNTIMES_CODE = exports.ERR_RUNTIME_UPDATE_NOT_ALLOWED_CODE = exports.ERR_NODE_UPDATE_NOT_ALLOWED_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_ENTITY_HAS_NODES_CODE = exports.ERR_NODE_CANNOT_BE_UNFROZEN_CODE = exports.ERR_NODE_EXPIRED_CODE = exports.ERR_INCORRECT_TX_SIGNER_CODE = exports.ERR_NO_SUCH_RUNTIME_CODE = exports.ERR_NO_SUCH_NODE_CODE = exports.ERR_NO_SUCH_ENTITY_CODE = exports.ERR_TEE_HARDWARE_MISMATCH_CODE = exports.ERR_BAD_CAPABILITIES_TEE_HARDWARE_CODE = exports.ERR_BAD_ENCLAVE_IDENTITY_CODE = exports.ERR_NO_ENCLAVE_FOR_RUNTIME_CODE = exports.ERR_BAD_ENTITY_FOR_RUNTIME_CODE = exports.ERR_BAD_ENTITY_FOR_NODE_CODE = exports.ERR_INVALID_SIGNATURE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.LATEST_RUNTIME_DESCRIPTOR_VERSION = exports.GOVERNANCE_MAX = exports.GOVERNANCE_CONSENSUS = exports.GOVERNANCE_RUNTIME = exports.GOVERNANCE_ENTITY = exports.GOVERNANCE_INVALID = exports.KIND_KEY_MANAGER = exports.KIND_COMPUTE = exports.KIND_INVALID = exports.GAS_OP_UPDATEKEY_MANAGER = exports.GAS_OP_RUNTIME_EPOCH_MAINTENANCE = exports.GAS_OP_REGISTER_RUNTIME = exports.GAS_OP_UNFREEZE_NODE = exports.GAS_OP_REGISTER_NODE = exports.GAS_OP_DEREGISTER_ENTITY = exports.GAS_OP_REGISTER_ENTITY = exports.METHOD_REGISTER_RUNTIME = exports.METHOD_UNFREEZE_NODE = exports.METHOD_REGISTER_NODE = exports.METHOD_DEREGISTER_ENTITY = exports.METHOD_REGISTER_ENTITY = exports.REGISTER_GENESIS_NODE_SIGNATURE_CONTEXT = exports.REGISTER_NODE_SIGNATURE_CONTEXT = exports.REGISTER_GENESIS_ENTITY_SIGNATURE_CONTEXT = exports.REGISTER_ENTITY_SIGNATURE_CONTEXT = void 0;
const consensus = require("f9b5173b089c3a54");
/**
 * RegisterEntitySignatureContext is the context used for entity
 * registration.
 */ exports.REGISTER_ENTITY_SIGNATURE_CONTEXT = "oasis-core/registry: register entity";
/**
 * RegisterGenesisEntitySignatureContext is the context used for
 * entity registration in the genesis document.
 *
 * Note: This is identical to non-gensis registrations to support
 * migrating existing registrations into a new genesis document.
 */ exports.REGISTER_GENESIS_ENTITY_SIGNATURE_CONTEXT = exports.REGISTER_ENTITY_SIGNATURE_CONTEXT;
/**
 * RegisterNodeSignatureContext is the context used for node
 * registration.
 */ exports.REGISTER_NODE_SIGNATURE_CONTEXT = "oasis-core/registry: register node";
/**
 * RegisterGenesisNodeSignatureContext is the context used for
 * node registration in the genesis document.
 *
 * Note: This is identical to non-gensis registrations to support
 * migrating existing registrations into a new genesis document.
 */ exports.REGISTER_GENESIS_NODE_SIGNATURE_CONTEXT = exports.REGISTER_NODE_SIGNATURE_CONTEXT;
/**
 * MethodRegisterEntity is the method name for entity registrations.
 */ exports.METHOD_REGISTER_ENTITY = "registry.RegisterEntity";
/**
 * MethodDeregisterEntity is the method name for entity deregistrations.
 */ exports.METHOD_DEREGISTER_ENTITY = "registry.DeregisterEntity";
/**
 * MethodRegisterNode is the method name for node registrations.
 */ exports.METHOD_REGISTER_NODE = "registry.RegisterNode";
/**
 * MethodUnfreezeNode is the method name for unfreezing nodes.
 */ exports.METHOD_UNFREEZE_NODE = "registry.UnfreezeNode";
/**
 * MethodRegisterRuntime is the method name for registering runtimes.
 */ exports.METHOD_REGISTER_RUNTIME = "registry.RegisterRuntime";
/**
 * GasOpRegisterEntity is the gas operation identifier for entity registration.
 */ exports.GAS_OP_REGISTER_ENTITY = "register_entity";
/**
 * GasOpDeregisterEntity is the gas operation identifier for entity deregistration.
 */ exports.GAS_OP_DEREGISTER_ENTITY = "deregister_entity";
/**
 * GasOpRegisterNode is the gas operation identifier for entity registration.
 */ exports.GAS_OP_REGISTER_NODE = "register_node";
/**
 * GasOpUnfreezeNode is the gas operation identifier for unfreezing nodes.
 */ exports.GAS_OP_UNFREEZE_NODE = "unfreeze_node";
/**
 * GasOpRegisterRuntime is the gas operation identifier for runtime registration.
 */ exports.GAS_OP_REGISTER_RUNTIME = "register_runtime";
/**
 * GasOpRuntimeEpochMaintenance is the gas operation identifier for per-epoch
 * runtime maintenance costs.
 */ exports.GAS_OP_RUNTIME_EPOCH_MAINTENANCE = "runtime_epoch_maintenance";
/**
 * GasOpUpdateKeyManager is the gas operation identifier for key manager
 * policy updates costs.
 */ exports.GAS_OP_UPDATEKEY_MANAGER = "update_keymanager";
/**
 * KindInvalid is an invalid runtime and should never be explicitly set.
 */ exports.KIND_INVALID = 0;
/**
 * KindCompute is a generic compute runtime.
 */ exports.KIND_COMPUTE = 1;
/**
 * KindKeyManager is a key manager runtime.
 */ exports.KIND_KEY_MANAGER = 2;
exports.GOVERNANCE_INVALID = 0;
exports.GOVERNANCE_ENTITY = 1;
exports.GOVERNANCE_RUNTIME = 2;
exports.GOVERNANCE_CONSENSUS = 3;
exports.GOVERNANCE_MAX = exports.GOVERNANCE_CONSENSUS;
/**
 * LatestRuntimeDescriptorVersion is the latest entity descriptor version that should be used
 * for all new descriptors. Using earlier versions may be rejected.
 */ exports.LATEST_RUNTIME_DESCRIPTOR_VERSION = 3;
/**
 * ModuleName is a unique module name for the registry module.
 */ exports.MODULE_NAME = "registry";
/**
 * ErrInvalidArgument is the error returned on malformed argument(s).
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrInvalidSignature is the error returned on an invalid signature.
 */ exports.ERR_INVALID_SIGNATURE_CODE = 2;
/**
 * ErrBadEntityForNode is the error returned when a node registration
 * with an unknown entity is attempted.
 */ exports.ERR_BAD_ENTITY_FOR_NODE_CODE = 3;
/**
 * ErrBadEntityForRuntime is the error returned when a runtime
 * attempts to register with an unknown entity.
 */ exports.ERR_BAD_ENTITY_FOR_RUNTIME_CODE = 4;
/**
 * ErrNoEnclaveForRuntime is the error returned when a TEE runtime
 * registers with no enclave IDs.
 */ exports.ERR_NO_ENCLAVE_FOR_RUNTIME_CODE = 5;
/**
 * ErrBadEnclaveIdentity is the error returned when a node tries to
 * register runtimes with wrong Enclave IDs.
 */ exports.ERR_BAD_ENCLAVE_IDENTITY_CODE = 6;
/**
 * ErrBadCapabilitiesTEEHardware is the error returned when a node tries to
 * register a runtime with bad Capabilities.TEE.Hardware.
 */ exports.ERR_BAD_CAPABILITIES_TEE_HARDWARE_CODE = 7;
/**
 * ErrTEEHardwareMismatch is the error returned when a node tries to
 * register a runtime and Capabilities.TEE.Hardware mismatches the one in
 * the registry.
 */ exports.ERR_TEE_HARDWARE_MISMATCH_CODE = 8;
/**
 * ErrNoSuchEntity is the error returned when an entity does not exist.
 */ exports.ERR_NO_SUCH_ENTITY_CODE = 9;
/**
 * ErrNoSuchNode is the error returned when an node does not exist.
 */ exports.ERR_NO_SUCH_NODE_CODE = 10;
/**
 * ErrNoSuchRuntime is the error returned when an runtime does not exist.
 */ exports.ERR_NO_SUCH_RUNTIME_CODE = 11;
/**
 * ErrIncorrectTxSigner is the error returned when the signer of the transaction
 * is not the correct one.
 */ exports.ERR_INCORRECT_TX_SIGNER_CODE = 12;
/**
 * ErrNodeExpired is the error returned when a node is expired.
 */ exports.ERR_NODE_EXPIRED_CODE = 13;
/**
 * ErrNodeCannotBeUnfrozen is the error returned when a node cannot yet be
 * unfrozen due to the freeze period not being over yet.
 */ exports.ERR_NODE_CANNOT_BE_UNFROZEN_CODE = 14;
/**
 * ErrEntityHasNodes is the error returned when an entity cannot be deregistered
 * as it still has nodes.
 */ exports.ERR_ENTITY_HAS_NODES_CODE = 15;
/**
 * ErrForbidden is the error returned when an operation is forbidden by
 * policy.
 */ exports.ERR_FORBIDDEN_CODE = 16;
/**
 * ErrNodeUpdateNotAllowed is the error returned when trying to update an existing node with
 * disallowed changes.
 */ exports.ERR_NODE_UPDATE_NOT_ALLOWED_CODE = 17;
/**
 * ErrRuntimeUpdateNotAllowed is the error returned when trying to update an existing runtime.
 */ exports.ERR_RUNTIME_UPDATE_NOT_ALLOWED_CODE = 18;
/**
 * ErrEntityHasRuntimes is the error returned when an entity cannot be deregistered as it still
 * has runtimes.
 */ exports.ERR_ENTITY_HAS_RUNTIMES_CODE = 19;
function registerEntityWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_REGISTER_ENTITY);
}
exports.registerEntityWrapper = registerEntityWrapper;
function deregisterEntityWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_DEREGISTER_ENTITY);
}
exports.deregisterEntityWrapper = deregisterEntityWrapper;
function registerNodeWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_REGISTER_NODE);
}
exports.registerNodeWrapper = registerNodeWrapper;
function unfreezeNodeWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_UNFREEZE_NODE);
}
exports.unfreezeNodeWrapper = unfreezeNodeWrapper;
function registerRuntimeWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_REGISTER_RUNTIME);
}
exports.registerRuntimeWrapper = registerRuntimeWrapper;

},{"f9b5173b089c3a54":"9UvMb"}],"9Gjb7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_NO_PROPOSER_COMMITMENT_CODE = exports.ERR_INVALID_ROUND_CODE = exports.ERR_MAJORITY_FAILURE_CODE = exports.ERR_NODE_IS_SCHEDULER_CODE = exports.ERR_TIMEOUT_NOT_CORRECT_ROUND_CODE = exports.ERR_INVALID_MESSAGES_CODE = exports.ERR_BAD_EXECUTOR_COMMITMENT_CODE = exports.ERR_INSUFFICIENT_VOTES_CODE = exports.ERR_STILL_WAITING_CODE = exports.ERR_DISCREPANCY_DETECTED_CODE = exports.ERR_NOT_BASED_ON_CORRECT_BLOCK_CODE = exports.ERR_ALREADY_COMMITTED_CODE = exports.ERR_NOT_IN_COMMITTEE_CODE = exports.ERR_RAK_SIG_INVALID_CODE = exports.ERR_INVALID_COMMITTEE_KIND_CODE = exports.ERR_NO_COMMITTEE_CODE = exports.ERR_NO_RUNTIME_CODE = exports.COMMITMENT_MODULE_NAME = exports.ERR_MAX_IN_MESSAGES_TOO_BIG_CODE = exports.ERR_INCOMING_MESSAGE_INSUFFICIENT_FEE_CODE = exports.ERR_INCOMING_MESSAGE_QUEUE_FULL_CODE = exports.ERR_INVALID_EVIDENCE_CODE = exports.ERR_DUPLICATE_EVIDENCE_CODE = exports.ERR_RUNTIME_DOES_NOT_SLASH_CODE = exports.ERR_MAX_MESSAGES_TOO_BIG_CODE = exports.ERR_PROPOSER_TIMEOUT_NOT_ALLOWED_CODE = exports.ERR_RUNTIME_SUSPENDED_CODE = exports.ERR_NO_EXECUTOR_POOL_CODE = exports.ERR_INVALID_RUNTIME_CODE = exports.ERR_NOT_FOUND_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.FAILURE_STORAGE_UNAVAILABLE = exports.FAILURE_UNKNOWN = exports.FAILURE_NONE = exports.SUSPENDED = exports.EPOCH_TRANSITION = exports.ROUND_FAILED = exports.NORMAL = exports.INVALID = exports.GAS_OP_SUBMIT_MSG = exports.GAS_OP_EVIDENCE = exports.GAS_OP_PROPOSER_TIMEOUT = exports.GAS_OP_COMPUTE_COMMIT = exports.METHOD_SUBMIT_MSG = exports.METHOD_EVIDENCE = exports.METHOD_EXECUTOR_COMMIT = exports.PROPOSAL_SIGNATURE_CONTEXT = exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT = exports.EXECUTOR_SIGNATURE_CONTEXT = void 0;
exports.submitMsgWrapper = exports.evidenceWrapper = exports.executorCommitWrapper = exports.signProposal = exports.verifyProposal = exports.signComputeResultsHeader = exports.verifyComputeResultsHeader = exports.signExecutorCommitment = exports.verifyExecutorCommitment = exports.ERR_BAD_PROPOSER_COMMITMENT_CODE = void 0;
const consensus = require("c59e80cf516a049");
const misc = require("a34dcdb035dea7f");
const signature = require("d0153d9fde8971eb");
/**
 * ExecutorSignatureContext is the signature context used to sign executor
 * worker commitments.
 */ exports.EXECUTOR_SIGNATURE_CONTEXT = "oasis-core/roothash: executor commitment";
/**
 * ComputeResultsHeaderSignatureContext is the signature context used to
 * sign compute results headers with RAK.
 */ exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT = "oasis-core/roothash: compute results header";
/**
 * ProposalSignatureContext is the context used for signing propose batch dispatch messages.
 */ exports.PROPOSAL_SIGNATURE_CONTEXT = "oasis-core/roothash: proposal";
/**
 * MethodExecutorCommit is the method name for executor commit submission.
 */ exports.METHOD_EXECUTOR_COMMIT = "roothash.ExecutorCommit";
/**
 * MethodEvidence is the method name for submitting evidence of node misbehavior.
 */ exports.METHOD_EVIDENCE = "roothash.Evidence";
/**
 * MethodSubmitMsg is the method name for queuing incoming runtime messages.
 */ exports.METHOD_SUBMIT_MSG = "roothash.SubmitMsg";
/**
 * GasOpComputeCommit is the gas operation identifier for compute commits.
 */ exports.GAS_OP_COMPUTE_COMMIT = "compute_commit";
/**
 * GasOpProposerTimeout is the gas operation identifier for executor propose timeout cost.
 */ exports.GAS_OP_PROPOSER_TIMEOUT = "proposer_timeout";
/**
 * GasOpEvidence is the gas operation identifier for evidence submission transaction cost.
 */ exports.GAS_OP_EVIDENCE = "evidence";
/**
 * GasOpSubmitMsg is the gas operation identifier for message submission transaction cost.
 */ exports.GAS_OP_SUBMIT_MSG = "submit_msg";
/**
 * Invalid is an invalid header type and should never be stored.
 */ exports.INVALID = 0;
/**
 * Normal is a normal header.
 */ exports.NORMAL = 1;
/**
 * RoundFailed is a header resulting from a failed round. Such a
 * header contains no transactions but advances the round as normal
 * to prevent replays of old commitments.
 */ exports.ROUND_FAILED = 2;
/**
 * EpochTransition is a header resulting from an epoch transition.
 *
 * Such a header contains no transactions but advances the round as
 * normal.
 * TODO: Consider renaming this to CommitteeTransition.
 */ exports.EPOCH_TRANSITION = 3;
/**
 * Suspended is a header resulting from the runtime being suspended.
 *
 * Such a header contains no transactions but advances the round as
 * normal.
 */ exports.SUSPENDED = 4;
/**
 * FailureNone indicates that no failure has occurred.
 */ exports.FAILURE_NONE = 0;
/**
 * FailureUnknown indicates a generic failure.
 */ exports.FAILURE_UNKNOWN = 1;
/**
 * FailureStorageUnavailable indicates that batch processing failed due to
 * storage being unavailable.
 */ exports.FAILURE_STORAGE_UNAVAILABLE = 2;
/**
 * ModuleName is a unique module name for the roothash module.
 */ exports.MODULE_NAME = "roothash";
/**
 * ErrInvalidArgument is the error returned on malformed argument(s).
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrNotFound is the error returned when a block is not found.
 */ exports.ERR_NOT_FOUND_CODE = 2;
/**
 * ErrInvalidRuntime is the error returned when the passed runtime is invalid.
 */ exports.ERR_INVALID_RUNTIME_CODE = 3;
/**
 * ErrNoExecutorPool is the error returned when there is no executor pool.
 */ exports.ERR_NO_EXECUTOR_POOL_CODE = 4;
/**
 * ErrRuntimeSuspended is the error returned when the passed runtime is suspended.
 */ exports.ERR_RUNTIME_SUSPENDED_CODE = 5;
/**
 * ErrProposerTimeoutNotAllowed is the error returned when proposer timeout is not allowed.
 */ exports.ERR_PROPOSER_TIMEOUT_NOT_ALLOWED_CODE = 6;
/**
 * ErrMaxMessagesTooBig is the error returned when the MaxMessages parameter is set to a value
 * larger than the MaxRuntimeMessages specified in consensus parameters.
 */ exports.ERR_MAX_MESSAGES_TOO_BIG_CODE = 7;
/**
 * ErrRuntimeDoesNotSlash is the error returned when misbehaviour evidence is submitted for a
 * runtime that does not slash.
 */ exports.ERR_RUNTIME_DOES_NOT_SLASH_CODE = 8;
/**
 * ErrDuplicateEvidence is the error returned when submitting already existing evidence.
 */ exports.ERR_DUPLICATE_EVIDENCE_CODE = 9;
/**
 * ErrInvalidEvidence is the error returned when an invalid evidence is submitted.
 */ exports.ERR_INVALID_EVIDENCE_CODE = 10;
/**
 * ErrIncomingMessageQueueFull is the error returned when the incoming message queue is full.
 */ exports.ERR_INCOMING_MESSAGE_QUEUE_FULL_CODE = 11;
/**
 * ErrIncomingMessageInsufficientFee is the error returned when the provided fee is smaller than
 * the configured minimum incoming message submission fee.
 */ exports.ERR_INCOMING_MESSAGE_INSUFFICIENT_FEE_CODE = 12;
/**
 * ErrMaxInMessagesTooBig is the error returned when the MaxInMessages parameter is set to a
 * value larger than the MaxInRuntimeMessages specified in consensus parameters.
 */ exports.ERR_MAX_IN_MESSAGES_TOO_BIG_CODE = 13;
/**
 * moduleName is the module name used for namespacing errors.
 */ exports.COMMITMENT_MODULE_NAME = "roothash/commitment";
exports.ERR_NO_RUNTIME_CODE = 1;
exports.ERR_NO_COMMITTEE_CODE = 2;
exports.ERR_INVALID_COMMITTEE_KIND_CODE = 3;
exports.ERR_RAK_SIG_INVALID_CODE = 4;
exports.ERR_NOT_IN_COMMITTEE_CODE = 5;
exports.ERR_ALREADY_COMMITTED_CODE = 6;
exports.ERR_NOT_BASED_ON_CORRECT_BLOCK_CODE = 7;
exports.ERR_DISCREPANCY_DETECTED_CODE = 8;
exports.ERR_STILL_WAITING_CODE = 9;
exports.ERR_INSUFFICIENT_VOTES_CODE = 10;
exports.ERR_BAD_EXECUTOR_COMMITMENT_CODE = 11;
exports.ERR_INVALID_MESSAGES_CODE = 13;
exports.ERR_TIMEOUT_NOT_CORRECT_ROUND_CODE = 15;
exports.ERR_NODE_IS_SCHEDULER_CODE = 16;
exports.ERR_MAJORITY_FAILURE_CODE = 17;
exports.ERR_INVALID_ROUND_CODE = 18;
exports.ERR_NO_PROPOSER_COMMITMENT_CODE = 19;
exports.ERR_BAD_PROPOSER_COMMITMENT_CODE = 20;
async function verifyExecutorCommitment(chainContext, runtimeID, commitment) {
    const context = `${signature.combineChainContext(exports.EXECUTOR_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signature.verify(commitment.node_id, context, misc.toCBOR(commitment.header), commitment.sig);
}
exports.verifyExecutorCommitment = verifyExecutorCommitment;
async function signExecutorCommitment(signer, chainContext, runtimeID, header) {
    const context = `${signature.combineChainContext(exports.EXECUTOR_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signer.sign(context, misc.toCBOR(header));
}
exports.signExecutorCommitment = signExecutorCommitment;
async function verifyComputeResultsHeader(rakPub, header, rakSig) {
    return await signature.verify(rakPub, exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT, misc.toCBOR(header), rakSig);
}
exports.verifyComputeResultsHeader = verifyComputeResultsHeader;
async function signComputeResultsHeader(rakSigner, header) {
    return await rakSigner.sign(exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT, misc.toCBOR(header));
}
exports.signComputeResultsHeader = signComputeResultsHeader;
async function verifyProposal(chainContext, runtimeID, proposal) {
    const context = `${signature.combineChainContext(exports.PROPOSAL_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signature.verify(proposal.node_id, context, misc.toCBOR(proposal.header), proposal.sig);
}
exports.verifyProposal = verifyProposal;
async function signProposal(signer, chainContext, runtimeID, header) {
    const context = `${signature.combineChainContext(exports.PROPOSAL_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signer.sign(context, misc.toCBOR(header));
}
exports.signProposal = signProposal;
function executorCommitWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_EXECUTOR_COMMIT);
}
exports.executorCommitWrapper = executorCommitWrapper;
function evidenceWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_EVIDENCE);
}
exports.evidenceWrapper = evidenceWrapper;
function submitMsgWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_SUBMIT_MSG);
}
exports.submitMsgWrapper = submitMsgWrapper;

},{"c59e80cf516a049":"9UvMb","a34dcdb035dea7f":"agInO","d0153d9fde8971eb":"3x9Lz"}],"dkWme":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HOST_PROTOCOL_ERR_NOT_READY_CODE = exports.HOST_PROTOCOL_MODULE_NAME = exports.CLIENT_ERR_NO_HOSTED_RUNTIME_CODE = exports.CLIENT_ERR_CHECK_TX_FAILED_CODE = exports.CLIENT_ERR_NOT_SYNCED_CODE = exports.CLIENT_ERR_TRANSACTION_EXPIRED_CODE = exports.CLIENT_ERR_INTERNAL_CODE = exports.CLIENT_ERR_NOT_FOUND_CODE = exports.CLIENT_MODULE_NAME = exports.CLIENT_ROUND_LATEST = void 0;
/**
 * RoundLatest is a special round number always referring to the latest round.
 */ exports.CLIENT_ROUND_LATEST = 0xffffffffffffffffn;
/**
 * ModuleName is the runtime client module name.
 */ exports.CLIENT_MODULE_NAME = "runtime/client";
/**
 * ErrNotFound is an error returned when the item is not found.
 */ exports.CLIENT_ERR_NOT_FOUND_CODE = 1;
/**
 * ErrInternal is an error returned when an unspecified internal error occurs.
 */ exports.CLIENT_ERR_INTERNAL_CODE = 2;
/**
 * ErrTransactionExpired is an error returned when transaction expired.
 */ exports.CLIENT_ERR_TRANSACTION_EXPIRED_CODE = 3;
/**
 * ErrNotSynced is an error returned if transaction is submitted before node has finished
 * initial syncing.
 */ exports.CLIENT_ERR_NOT_SYNCED_CODE = 4;
/**
 * ErrCheckTxFailed is an error returned if the local transaction check fails.
 */ exports.CLIENT_ERR_CHECK_TX_FAILED_CODE = 5;
/**
 * ErrNoHostedRuntime is returned when the hosted runtime is not available locally.
 */ exports.CLIENT_ERR_NO_HOSTED_RUNTIME_CODE = 6;
exports.HOST_PROTOCOL_MODULE_NAME = "rhp/internal";
/**
 * ErrNotReady is the error reported when the Runtime Host Protocol is not initialized.
 */ exports.HOST_PROTOCOL_ERR_NOT_READY_CODE = 1;

},{}],"kvmvD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_COMMITTEE_KIND = exports.KIND_COMPUTE_EXECUTOR = exports.KIND_INVALID = exports.ROLE_BACKUP_WORKER = exports.ROLE_WORKER = exports.ROLE_INVALID = void 0;
/**
 * RoleInvalid is an invalid role (should never appear on the wire).
 */ exports.ROLE_INVALID = 0;
/**
 * RoleWorker indicates the node is a worker.
 */ exports.ROLE_WORKER = 1;
/**
 * RoleBackupWorker indicates the node is a backup worker.
 */ exports.ROLE_BACKUP_WORKER = 2;
/**
 * KindInvalid is an invalid committee.
 */ exports.KIND_INVALID = 0;
/**
 * KindComputeExecutor is an executor committee.
 */ exports.KIND_COMPUTE_EXECUTOR = 1;
/**
 * MaxCommitteeKind is a dummy value used for iterating all committee kinds.
 */ exports.MAX_COMMITTEE_KIND = 2;

},{}],"j4wDp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addressFromRuntimeID = exports.addressFromPublicKey = exports.TOKEN_ERR_INVALID_TOKEN_VALUE_EXPONENT_CODE = exports.TOKEN_MODULE_NAME = exports.ERR_BALANCE_TOO_LOW_CODE = exports.ERR_UNDER_MIN_TRANSFER_AMOUNT_CODE = exports.ERR_UNDER_MIN_DELEGATION_AMOUNT_CODE = exports.ERR_TOO_MANY_ALLOWANCES_CODE = exports.ERR_INVALID_THRESHOLD_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_INSUFFICIENT_STAKE_CODE = exports.ERR_INSUFFICIENT_BALANCE_CODE = exports.ERR_INVALID_SIGNATURE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.GAS_OP_WITHDRAW = exports.GAS_OP_ALLOW = exports.GAS_OP_AMEND_COMMISSION_SCHEDULE = exports.GAS_OP_RECLAIM_ESCROW = exports.GAS_OP_ADD_ESCROW = exports.GAS_OP_BURN = exports.GAS_OP_TRANSFER = exports.SLASH_RUNTIME_LIVENESS = exports.SLASH_RUNTIME_EQUIVOCATION = exports.SLASH_RUNTIME_INCORRECT_RESULTS = exports.SLASH_CONSENSUS_LIGHT_CLIENT_ATTACK = exports.SLASH_BEACON_NONPARTICIPATION = exports.SLASH_BEACON_INVALID_REVEAL = exports.SLASH_BEACON_INVALID_COMMIT = exports.SLASH_CONSENSUS_EQUIVOCATION = exports.KIND_MAX = exports.KIND_RUNTIME_KEY_MANAGER = exports.KIND_RUNTIME_COMPUTE = exports.KIND_NODE_KEY_MANAGER = exports.KIND_NODE_STORAGE = exports.KIND_NODE_COMPUTE = exports.KIND_NODE_VALIDATOR = exports.KIND_ENTITY = exports.METHOD_WITHDRAW = exports.METHOD_ALLOW = exports.METHOD_AMEND_COMMISSION_SCHEDULE = exports.METHOD_RECLAIM_ESCROW = exports.METHOD_ADD_ESCROW = exports.METHOD_BURN = exports.METHOD_TRANSFER = exports.ADDRESS_PREFIX = exports.ADDRESS_RUNTIME_V0_CONTEXT_VERSION = exports.ADDRESS_RUNTIME_V0_CONTEXT_IDENTIFIER = exports.ADDRESS_V0_CONTEXT_VERSION = exports.ADDRESS_V0_CONTEXT_IDENTIFIER = void 0;
exports.withdrawWrapper = exports.allowWrapper = exports.amendCommissionScheduleWrapper = exports.reclaimEscrowWrapper = exports.addEscrowWrapper = exports.burnWrapper = exports.transferWrapper = exports.governanceDepositsAddress = exports.feeAccumulatorAddress = exports.commonPoolAddress = exports.addressFromBech32 = exports.addressToBech32 = void 0;
const address = require("268de560fd7866ca");
const consensus = require("4c6779c2f7c0517b");
const misc = require("3032c700f44d2f83");
/**
 * AddressV0Context is the unique context for v0 staking account addresses.
 */ exports.ADDRESS_V0_CONTEXT_IDENTIFIER = "oasis-core/address: staking";
/**
 * AddressV0Context is the unique context for v0 staking account addresses.
 */ exports.ADDRESS_V0_CONTEXT_VERSION = 0;
/**
 * AddressRuntimeV0Context is the unique context for v0 runtime account addresses.
 */ exports.ADDRESS_RUNTIME_V0_CONTEXT_IDENTIFIER = "oasis-core/address: runtime";
/**
 * AddressRuntimeV0Context is the unique context for v0 runtime account addresses.
 */ exports.ADDRESS_RUNTIME_V0_CONTEXT_VERSION = 0;
/**
 * AddressBech32HRP is the unique human readable part of Bech32 encoded
 * staking account addresses.
 */ exports.ADDRESS_PREFIX = "oasis";
/**
 * MethodTransfer is the method name for transfers.
 */ exports.METHOD_TRANSFER = "staking.Transfer";
/**
 * MethodBurn is the method name for burns.
 */ exports.METHOD_BURN = "staking.Burn";
/**
 * MethodAddEscrow is the method name for escrows.
 */ exports.METHOD_ADD_ESCROW = "staking.AddEscrow";
/**
 * MethodReclaimEscrow is the method name for escrow reclamations.
 */ exports.METHOD_RECLAIM_ESCROW = "staking.ReclaimEscrow";
/**
 * MethodAmendCommissionSchedule is the method name for amending commission schedules.
 */ exports.METHOD_AMEND_COMMISSION_SCHEDULE = "staking.AmendCommissionSchedule";
/**
 * MethodAllow is the method name for setting a beneficiary allowance.
 */ exports.METHOD_ALLOW = "staking.Allow";
/**
 * MethodWithdraw is the method name for
 */ exports.METHOD_WITHDRAW = "staking.Withdraw";
exports.KIND_ENTITY = 0;
exports.KIND_NODE_VALIDATOR = 1;
exports.KIND_NODE_COMPUTE = 2;
exports.KIND_NODE_STORAGE = 3;
exports.KIND_NODE_KEY_MANAGER = 4;
exports.KIND_RUNTIME_COMPUTE = 5;
exports.KIND_RUNTIME_KEY_MANAGER = 6;
exports.KIND_MAX = exports.KIND_RUNTIME_KEY_MANAGER;
/**
 * SlashConsensusEquivocation is slashing due to equivocation.
 */ exports.SLASH_CONSENSUS_EQUIVOCATION = 0x00;
/**
 * SlashBeaconInvalidCommit is slashing due to invalid commit behavior.
 */ exports.SLASH_BEACON_INVALID_COMMIT = 0x01;
/**
 * SlashBeaconInvalidReveal is slashing due to invalid reveal behavior.
 */ exports.SLASH_BEACON_INVALID_REVEAL = 0x02;
/**
 * SlashBeaconNonparticipation is slashing due to nonparticipation.
 */ exports.SLASH_BEACON_NONPARTICIPATION = 0x03;
/**
 * SlashConsensusLightClientAttack is slashing due to light client attacks.
 */ exports.SLASH_CONSENSUS_LIGHT_CLIENT_ATTACK = 0x04;
/**
 * SlashRuntimeIncorrectResults is slashing due to submission of incorrect
 * results in runtime executor commitments.
 */ exports.SLASH_RUNTIME_INCORRECT_RESULTS = 0x80;
/**
 * SlashRuntimeEquivocation is slashing due to signing two different
 * executor commits or proposed batches for the same round.
 */ exports.SLASH_RUNTIME_EQUIVOCATION = 0x81;
/**
 * SlashRuntimeLiveness is slashing due to not doing the required work.
 */ exports.SLASH_RUNTIME_LIVENESS = 0x82;
/**
 * GasOpTransfer is the gas operation identifier for transfer.
 */ exports.GAS_OP_TRANSFER = "transfer";
/**
 * GasOpBurn is the gas operation identifier for burn.
 */ exports.GAS_OP_BURN = "burn";
/**
 * GasOpAddEscrow is the gas operation identifier for add escrow.
 */ exports.GAS_OP_ADD_ESCROW = "add_escrow";
/**
 * GasOpReclaimEscrow is the gas operation identifier for reclaim escrow.
 */ exports.GAS_OP_RECLAIM_ESCROW = "reclaim_escrow";
/**
 * GasOpAmendCommissionSchedule is the gas operation identifier for amend commission schedule.
 */ exports.GAS_OP_AMEND_COMMISSION_SCHEDULE = "amend_commission_schedule";
/**
 * GasOpAllow is the gas operation identifier for allow.
 */ exports.GAS_OP_ALLOW = "allow";
/**
 * GasOpWithdraw is the gas operation identifier for withdraw.
 */ exports.GAS_OP_WITHDRAW = "withdraw";
/**
 * ModuleName is a unique module name for the staking module.
 */ exports.MODULE_NAME = "staking";
/**
 * ErrInvalidArgument is the error returned on malformed arguments.
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrInvalidSignature is the error returned on invalid signature.
 */ exports.ERR_INVALID_SIGNATURE_CODE = 2;
/**
 * ErrInsufficientBalance is the error returned when an operation
 * fails due to insufficient balance.
 */ exports.ERR_INSUFFICIENT_BALANCE_CODE = 3;
/**
 * ErrInsufficientStake is the error returned when an operation fails
 * due to insufficient stake.
 */ exports.ERR_INSUFFICIENT_STAKE_CODE = 4;
/**
 * ErrForbidden is the error returned when an operation is forbidden by
 * policy.
 */ exports.ERR_FORBIDDEN_CODE = 5;
/**
 * ErrInvalidThreshold is the error returned when an invalid threshold kind
 * is specified in a query.
 */ exports.ERR_INVALID_THRESHOLD_CODE = 6;
/**
 * ErrTooManyAllowances is the error returned when the number of allowances per account would
 * exceed the maximum allowed number.
 */ exports.ERR_TOO_MANY_ALLOWANCES_CODE = 7;
/**
 * ErrUnderMinDelegationAmount is the error returned when the given escrow
 * amount is lower than the minimum delegation amount specified in the
 * consensus parameters.
 */ exports.ERR_UNDER_MIN_DELEGATION_AMOUNT_CODE = 8;
/**
 * ErrUnderMinTransferAmount is the error returned when the given transfer
 * or burn or withdrawal amount is lower than the minimum transfer amount
 * specified in the consensus parameters.
 */ exports.ERR_UNDER_MIN_TRANSFER_AMOUNT_CODE = 9;
/**
 * ErrBalanceTooLow is the error returned when an account's balance is
 * below the minimum allowed amount.
 */ exports.ERR_BALANCE_TOO_LOW_CODE = 10;
/**
 * ModuleName is a unique module name for the staking/token module.
 */ exports.TOKEN_MODULE_NAME = "staking/token";
/**
 * ErrInvalidTokenValueExponent is the error returned when an invalid token's
 * value base-10 exponent is specified.
 */ exports.TOKEN_ERR_INVALID_TOKEN_VALUE_EXPONENT_CODE = 1;
async function addressFromPublicKey(pk) {
    return await address.fromData(exports.ADDRESS_V0_CONTEXT_IDENTIFIER, exports.ADDRESS_V0_CONTEXT_VERSION, pk);
}
exports.addressFromPublicKey = addressFromPublicKey;
async function addressFromRuntimeID(id) {
    return await address.fromData(exports.ADDRESS_RUNTIME_V0_CONTEXT_IDENTIFIER, exports.ADDRESS_RUNTIME_V0_CONTEXT_VERSION, id);
}
exports.addressFromRuntimeID = addressFromRuntimeID;
function addressToBech32(addr) {
    return address.toBech32(exports.ADDRESS_PREFIX, addr);
}
exports.addressToBech32 = addressToBech32;
function addressFromBech32(str) {
    return address.fromBech32(exports.ADDRESS_PREFIX, str);
}
exports.addressFromBech32 = addressFromBech32;
/**
 * CommonPoolAddress is the common pool address.
 * The address is reserved to prevent it being accidentally used in the actual ledger.
 */ async function commonPoolAddress() {
    return await addressFromPublicKey(misc.fromHex("1abe11edc001ffffffffffffffffffffffffffffffffffffffffffffffffffff"));
}
exports.commonPoolAddress = commonPoolAddress;
/**
 * FeeAccumulatorAddress is the per-block fee accumulator address.
 * It holds all fees from txs in a block which are later disbursed to validators appropriately.
 * The address is reserved to prevent it being accidentally used in the actual ledger.
 */ async function feeAccumulatorAddress() {
    return await addressFromPublicKey(misc.fromHex("1abe11edfeeaccffffffffffffffffffffffffffffffffffffffffffffffffff"));
}
exports.feeAccumulatorAddress = feeAccumulatorAddress;
/**
 * GovernanceDepositsAddress is the governance deposits address.
 * This address is reserved to prevent it from being accidentally used in the actual ledger.
 */ async function governanceDepositsAddress() {
    return await addressFromPublicKey(misc.fromHex("1abe11eddeaccfffffffffffffffffffffffffffffffffffffffffffffffffff"));
}
exports.governanceDepositsAddress = governanceDepositsAddress;
function transferWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_TRANSFER);
}
exports.transferWrapper = transferWrapper;
function burnWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_BURN);
}
exports.burnWrapper = burnWrapper;
function addEscrowWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_ADD_ESCROW);
}
exports.addEscrowWrapper = addEscrowWrapper;
function reclaimEscrowWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_RECLAIM_ESCROW);
}
exports.reclaimEscrowWrapper = reclaimEscrowWrapper;
function amendCommissionScheduleWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_AMEND_COMMISSION_SCHEDULE);
}
exports.amendCommissionScheduleWrapper = amendCommissionScheduleWrapper;
function allowWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_ALLOW);
}
exports.allowWrapper = allowWrapper;
function withdrawWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_WITHDRAW);
}
exports.withdrawWrapper = withdrawWrapper;

},{"268de560fd7866ca":"7SCvB","4c6779c2f7c0517b":"9UvMb","3032c700f44d2f83":"agInO"}],"9xDmt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MKVS_DB_ERR_UPGRADE_IN_PROGRESS_CODE = exports.MKVS_DB_ERR_INVALID_MULTIPART_VERSION_CODE = exports.MKVS_DB_ERR_MULTIPART_IN_PROGRESS_CODE = exports.MKVS_DB_ERR_READ_ONLY_CODE = exports.MKVS_DB_ERR_NOT_EARLIEST_CODE = exports.MKVS_DB_ERR_BAD_NAMESPACE_CODE = exports.MKVS_DB_ERR_ROOT_MUST_FOLLOW_OLD_CODE = exports.MKVS_DB_ERR_ROOT_NOT_FOUND_CODE = exports.MKVS_DB_ERR_VERSION_WENT_BACKWARDS_CODE = exports.MKVS_DB_ERR_PREVIOUS_VERSION_MISMATCH_CODE = exports.MKVS_DB_ERR_VERSION_NOT_FOUND_CODE = exports.MKVS_DB_ERR_ALREADY_FINALIZED_CODE = exports.MKVS_DB_ERR_NOT_FINALIZED_CODE = exports.MKVS_DB_ERR_WRITE_LOG_NOT_FOUND_CODE = exports.MKVS_DB_ERR_NODE_NOT_FOUND_CODE = exports.MKVS_DB_MODULE_NAME = exports.ERR_CHUNK_CORRUPTED_CODE = exports.ERR_CHUNK_PROOF_VERIFICATION_FAILED_CODE = exports.ERR_CHUNK_ALREADY_RESTORED_CODE = exports.ERR_NO_RESTORE_IN_PROGRESS_CODE = exports.ERR_RESTORE_ALREADY_IN_PROGRESS_CODE = exports.ERR_CHUNK_NOT_FOUND_CODE = exports.ERR_CHECKPOINT_NOT_FOUND_CODE = exports.MKVS_CHECKPOINT_MODULE_NAME = exports.ERR_LIMIT_REACHED_CODE = exports.ERR_UNSUPPORTED_CODE = exports.ERR_EXPECTED_ROOT_MISMATCH_CODE = exports.ERR_NO_ROOTS_CODE = exports.ERR_CANT_PROVE_CODE = exports.MODULE_NAME = exports.ROOT_TYPE_MAX = exports.ROOT_TYPE_IO = exports.ROOT_TYPE_STATE = exports.ROOT_TYPE_INVALID = exports.CHECKPOINT_VERSION = void 0;
exports.CHECKPOINT_VERSION = 1;
/**
 * RootTypeInvalid is an invalid/uninitialized root type.
 */ exports.ROOT_TYPE_INVALID = 0;
/**
 * RootTypeState is the type for state storage roots.
 */ exports.ROOT_TYPE_STATE = 1;
/**
 * RootTypeIO is the type for IO storage roots.
 */ exports.ROOT_TYPE_IO = 2;
/**
 * RootTypeMax is the number of different root types and should be kept at the last one.
 */ exports.ROOT_TYPE_MAX = 2;
/**
 * ModuleName is the storage module name.
 */ exports.MODULE_NAME = "storage";
/**
 * ErrCantProve is the error returned when the backend is incapable
 * of generating proofs (unsupported, no key, etc).
 */ exports.ERR_CANT_PROVE_CODE = 1;
/**
 * ErrNoRoots is the error returned when the generated receipt would
 * not contain any roots.
 */ exports.ERR_NO_ROOTS_CODE = 2;
/**
 * ErrExpectedRootMismatch is the error returned when the expected root
 * does not match the computed root.
 */ exports.ERR_EXPECTED_ROOT_MISMATCH_CODE = 3;
/**
 * ErrUnsupported is the error returned when the called method is not
 * supported by the given backend.
 */ exports.ERR_UNSUPPORTED_CODE = 4;
/**
 * ErrLimitReached means that a configured limit has been reached.
 */ exports.ERR_LIMIT_REACHED_CODE = 5;
exports.MKVS_CHECKPOINT_MODULE_NAME = "storage/mkvs/checkpoint";
/**
 * ErrCheckpointNotFound is the error when a checkpoint is not found.
 */ exports.ERR_CHECKPOINT_NOT_FOUND_CODE = 1;
/**
 * ErrChunkNotFound is the error when a chunk is not found.
 */ exports.ERR_CHUNK_NOT_FOUND_CODE = 2;
/**
 * ErrRestoreAlreadyInProgress is the error when a checkpoint restore is already in progress and
 * the caller wanted to start another restore.
 */ exports.ERR_RESTORE_ALREADY_IN_PROGRESS_CODE = 3;
/**
 * ErrNoRestoreInProgress is the error when no checkpoint restore is currently in progress.
 */ exports.ERR_NO_RESTORE_IN_PROGRESS_CODE = 4;
/**
 * ErrChunkAlreadyRestored is the error when a chunk has already been restored.
 */ exports.ERR_CHUNK_ALREADY_RESTORED_CODE = 5;
/**
 * ErrChunkProofVerificationFailed is the error when a chunk fails proof verification.
 */ exports.ERR_CHUNK_PROOF_VERIFICATION_FAILED_CODE = 6;
/**
 * ErrChunkCorrupted is the error when a chunk is corrupted.
 */ exports.ERR_CHUNK_CORRUPTED_CODE = 7;
/**
 * ModuleName is the module name.
 */ exports.MKVS_DB_MODULE_NAME = "storage/mkvs/db";
/**
 * ErrNodeNotFound indicates that a node with the specified hash couldn't be found
 * in the database.
 */ exports.MKVS_DB_ERR_NODE_NOT_FOUND_CODE = 1;
/**
 * ErrWriteLogNotFound indicates that a write log for the specified storage hashes
 * couldn't be found.
 */ exports.MKVS_DB_ERR_WRITE_LOG_NOT_FOUND_CODE = 2;
/**
 * ErrNotFinalized indicates that the operation requires a version to be finalized
 * but the version is not yet finalized.
 */ exports.MKVS_DB_ERR_NOT_FINALIZED_CODE = 3;
/**
 * ErrAlreadyFinalized indicates that the given version has already been finalized.
 */ exports.MKVS_DB_ERR_ALREADY_FINALIZED_CODE = 4;
/**
 * ErrVersionNotFound indicates that the given version cannot be found.
 */ exports.MKVS_DB_ERR_VERSION_NOT_FOUND_CODE = 5;
/**
 * ErrPreviousVersionMismatch indicates that the version given for the old root does
 * not match the previous version.
 */ exports.MKVS_DB_ERR_PREVIOUS_VERSION_MISMATCH_CODE = 6;
/**
 * ErrVersionWentBackwards indicates that the new version is earlier than an already
 * inserted version.
 */ exports.MKVS_DB_ERR_VERSION_WENT_BACKWARDS_CODE = 7;
/**
 * ErrRootNotFound indicates that the given root cannot be found.
 */ exports.MKVS_DB_ERR_ROOT_NOT_FOUND_CODE = 8;
/**
 * ErrRootMustFollowOld indicates that the passed new root does not follow old root.
 */ exports.MKVS_DB_ERR_ROOT_MUST_FOLLOW_OLD_CODE = 9;
/**
 * ErrBadNamespace indicates that the passed namespace does not match what is
 * actually contained within the database.
 */ exports.MKVS_DB_ERR_BAD_NAMESPACE_CODE = 10;
/**
 * ErrNotEarliest indicates that the given version is not the earliest version.
 */ exports.MKVS_DB_ERR_NOT_EARLIEST_CODE = 11;
/**
 * ErrReadOnly indicates that a write operation failed due to a read-only database.
 */ exports.MKVS_DB_ERR_READ_ONLY_CODE = 12;
/**
 * ErrMultipartInProgress indicates that a multipart restore operation is already
 * in progress.
 */ exports.MKVS_DB_ERR_MULTIPART_IN_PROGRESS_CODE = 13;
/**
 * ErrInvalidMultipartVersion indicates that a Finalize, NewBatch or Commit was called with a version
 * that doesn't match the current multipart restore as set with StartMultipartRestore.
 */ exports.MKVS_DB_ERR_INVALID_MULTIPART_VERSION_CODE = 14;
/**
 * ErrUpgradeInProgress indicates that a database upgrade was started by the upgrader tool and the
 * database is therefore unusable. Run the upgrade tool to finish upgrading.
 */ exports.MKVS_DB_ERR_UPGRADE_IN_PROGRESS_CODE = 15;

},{}],"dAERu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"gg3CQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_BAD_DESCRIPTOR_CODE = exports.ERR_UPGRADE_NOT_FOUND_CODE = exports.ERR_UPGRADE_IN_PROGRESS_CODE = exports.ERR_ALREADY_PENDING_CODE = exports.ERR_STOP_FOR_UPGRADE_CODE = exports.MODULE_NAME = exports.LATEST_PENDING_UPGRADE_VERSION = exports.LATEST_DESCRIPTOR_VERSION = exports.INVALID_UPGRADE_HEIGHT = exports.UPGRADE_STAGE_LAST = exports.UPGRADE_STAGE_CONSENSUS = exports.UPGRADE_STAGE_STARTUP = void 0;
/**
 * UpgradeStageStartup is the startup upgrade stage, executed at the beginning of node startup.
 */ exports.UPGRADE_STAGE_STARTUP = 1;
/**
 * UpgradeStageConsensus is the upgrade stage carried out during consensus events.
 */ exports.UPGRADE_STAGE_CONSENSUS = 2;
exports.UPGRADE_STAGE_LAST = exports.UPGRADE_STAGE_CONSENSUS;
/**
 * InvalidUpgradeHeight means the upgrade epoch hasn't been reached yet.
 */ exports.INVALID_UPGRADE_HEIGHT = 0n;
/**
 * LatestDescriptorVersion is the latest upgrade descriptor version that should be used for
 * descriptors.
 */ exports.LATEST_DESCRIPTOR_VERSION = 1;
/**
 * LatestPendingUpgradeVersion is the latest pending upgrade struct version.
 */ exports.LATEST_PENDING_UPGRADE_VERSION = 1;
/**
 * ModuleName is the upgrade module name.
 */ exports.MODULE_NAME = "upgrade";
/**
 * ErrStopForUpgrade is the error returned by the consensus upgrade function when it detects that
 * the consensus layer has reached the scheduled shutdown epoch and should be interrupted.
 */ exports.ERR_STOP_FOR_UPGRADE_CODE = 1;
/**
 * ErrAlreadyPending is the error returned from SubmitDescriptor when the specific upgrade is already pending.
 */ exports.ERR_ALREADY_PENDING_CODE = 5;
/**
 * ErrUpgradeInProgress is the error returned from CancelUpgrade when the upgrade being cancelled is already in progress.
 */ exports.ERR_UPGRADE_IN_PROGRESS_CODE = 6;
/**
 * ErrUpgradeNotFound is the error returned when the upgrade in question cannot be found.
 */ exports.ERR_UPGRADE_NOT_FOUND_CODE = 7;
/**
 * ErrBadDescriptor is the error returned when the provided descriptor is bad.
 */ exports.ERR_BAD_DESCRIPTOR_CODE = 8;

},{}],"3inc7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STORAGE_ERR_CANT_PAUSE_CHECKPOINTER = exports.STORAGE_ERR_RUNTIME_NOT_FOUND_CODE = exports.STORAGE_MODULE_NAME = void 0;
/**
 * ModuleName is the storage worker module name.
 */ exports.STORAGE_MODULE_NAME = "worker/storage";
/**
 * ErrRuntimeNotFound is the error returned when the called references an unknown runtime.
 */ exports.STORAGE_ERR_RUNTIME_NOT_FOUND_CODE = 1;
/**
 * ErrCantPauseCheckpointer is the error returned when trying to pause the checkpointer without
 * setting the debug flag.
 */ exports.STORAGE_ERR_CANT_PAUSE_CHECKPOINTER = 2;

},{}],"6GV4q":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wrapper = exports.types = exports.transaction = exports.token = exports.signatureSecp256k1 = exports.rewards = exports.mraeDeoxysii = exports.evm = exports.event = exports.core = exports.contracts = exports.consensusAccounts = exports.consensus = exports.callformat = exports.address = exports.accounts = void 0;
exports.accounts = require("6332cef9fffdf06a");
exports.address = require("c9f69ca4b44d455f");
exports.callformat = require("121ac5b3540b2087");
exports.consensus = require("b63d510ded6b0455");
exports.consensusAccounts = require("1d525571edbdb36b");
exports.contracts = require("d4c479c4be826bbc");
exports.core = require("232bc956f3f1c73d");
exports.event = require("6a1d7220aa158db4");
exports.evm = require("666b6d166d411787");
exports.mraeDeoxysii = require("4347924946e7a19a");
exports.rewards = require("b2914ec0b6b4b0f1");
exports.signatureSecp256k1 = require("92591680ba9a63c5");
exports.token = require("3a3bc16de6ae9ee0");
exports.transaction = require("f6dbd98fa7fd37ab");
exports.types = require("96fa2d7c6e768803");
exports.wrapper = require("b1ed2af0ab0fc6c4");

},{"6332cef9fffdf06a":"eeVfw","c9f69ca4b44d455f":"dxfFI","121ac5b3540b2087":"jvDg5","b63d510ded6b0455":"e5B7O","1d525571edbdb36b":"es2VV","d4c479c4be826bbc":"dPU3h","232bc956f3f1c73d":"cT3Ij","6a1d7220aa158db4":"2fcHH","666b6d166d411787":"kt33b","4347924946e7a19a":"8Lo5H","b2914ec0b6b4b0f1":"iRDGW","92591680ba9a63c5":"7X8cr","3a3bc16de6ae9ee0":"7FIY0","f6dbd98fa7fd37ab":"4ceij","96fa2d7c6e768803":"dusBQ","b1ed2af0ab0fc6c4":"87MgA"}],"eeVfw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moduleEventHandler = exports.Wrapper = exports.EVENT_MINT_CODE = exports.EVENT_BURN_CODE = exports.EVENT_TRANSFER_CODE = exports.METHOD_DENOMINATION_INFO = exports.METHOD_ADDRESSES = exports.METHOD_BALANCES = exports.METHOD_NONCE = exports.METHOD_TRANSFER = exports.ERR_NOT_FOUND_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_INSUFFICIENT_BALANCE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("b3665878316c8151");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "accounts";
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_INSUFFICIENT_BALANCE_CODE = 2;
exports.ERR_FORBIDDEN_CODE = 3;
exports.ERR_NOT_FOUND_CODE = 4;
// Callable methods.
exports.METHOD_TRANSFER = "accounts.Transfer";
// Queries.
exports.METHOD_NONCE = "accounts.Nonce";
exports.METHOD_BALANCES = "accounts.Balances";
exports.METHOD_ADDRESSES = "accounts.Addresses";
exports.METHOD_DENOMINATION_INFO = "accounts.DenominationInfo";
exports.EVENT_TRANSFER_CODE = 1;
exports.EVENT_BURN_CODE = 2;
exports.EVENT_MINT_CODE = 3;
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callTransfer() {
        return this.call(exports.METHOD_TRANSFER);
    }
    queryNonce() {
        return this.query(exports.METHOD_NONCE);
    }
    queryBalances() {
        return this.query(exports.METHOD_BALANCES);
    }
    queryAddresses() {
        return this.query(exports.METHOD_ADDRESSES);
    }
    queryDenominationInfo() {
        return this.query(exports.METHOD_DENOMINATION_INFO);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}
exports.moduleEventHandler = moduleEventHandler;

},{"b3665878316c8151":"87MgA"}],"87MgA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Base = exports.QueryWrapper = exports.TransactionWrapper = void 0;
const oasis = require("837ce983c8299deb");
const token = require("3e1a5c6b82507fb2");
const transaction = require("831626837c9123b1");
class TransactionWrapper {
    constructor(runtimeID, method){
        this.runtimeID = runtimeID;
        this.transaction = {
            v: transaction.LATEST_TRANSACTION_VERSION,
            call: {
                method,
                body: undefined
            },
            ai: {
                si: [],
                fee: {
                    amount: [
                        oasis.quantity.fromBigInt(0n),
                        token.NATIVE_DENOMINATION
                    ],
                    gas: 0n,
                    consensus_messages: 0
                }
            }
        };
        this.unverifiedTransaction = null;
    }
    setBody(body) {
        this.transaction.call.body = body;
        return this;
    }
    setSignerInfo(signerInfo) {
        this.transaction.ai.si = signerInfo;
        return this;
    }
    setFeeAmount(amount) {
        this.transaction.ai.fee.amount = amount;
        return this;
    }
    setFeeGas(gas) {
        this.transaction.ai.fee.gas = gas;
        return this;
    }
    setFeeConsensusMessages(maxMessages) {
        this.transaction.ai.fee.consensus_messages = maxMessages;
        return this;
    }
    /**
     * @param proofProviders An array of providers matching the layout of the
     * transaction's signer info.
     */ async sign(proofProviders, consensusChainContext) {
        this.unverifiedTransaction = await transaction.signUnverifiedTransaction(proofProviders, this.runtimeID, consensusChainContext, this.transaction);
    }
    async submit(nic) {
        const response = await nic.runtimeClientSubmitTx({
            runtime_id: this.runtimeID,
            data: oasis.misc.toCBOR(this.unverifiedTransaction)
        });
        const result = oasis.misc.fromCBOR(response);
        if (result.fail) throw result.fail;
        return result.ok;
    }
    async submitNoWait(nic) {
        await nic.runtimeClientSubmitTxNoWait({
            runtime_id: this.runtimeID,
            data: oasis.misc.toCBOR(this.unverifiedTransaction)
        });
    }
}
exports.TransactionWrapper = TransactionWrapper;
class QueryWrapper {
    constructor(runtimeID, method){
        this.request = {
            runtime_id: runtimeID,
            round: oasis.runtime.CLIENT_ROUND_LATEST,
            method: method,
            args: oasis.misc.toCBOR(null)
        };
    }
    setArgs(args) {
        this.request.args = oasis.misc.toCBOR(args);
        return this;
    }
    setRound(round) {
        this.request.round = round;
        return this;
    }
    async query(nic) {
        const response = await nic.runtimeClientQuery(this.request);
        return oasis.misc.fromCBOR(response.data);
    }
}
exports.QueryWrapper = QueryWrapper;
class Base {
    constructor(runtimeID){
        this.runtimeID = runtimeID;
    }
    call(method) {
        return new TransactionWrapper(this.runtimeID, method);
    }
    query(method) {
        return new QueryWrapper(this.runtimeID, method);
    }
}
exports.Base = Base;

},{"837ce983c8299deb":"1ax6t","3e1a5c6b82507fb2":"7FIY0","831626837c9123b1":"4ceij"}],"7FIY0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NATIVE_DENOMINATION = void 0;
/**
 * Denomination in native token.
 */ exports.NATIVE_DENOMINATION = new Uint8Array();

},{}],"4ceij":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.visitCall = exports.signUnverifiedTransaction = exports.proveAny = exports.proveMultisig = exports.proveSignature = exports.signAny = exports.deriveChainContext = exports.CALLFORMAT_ENCRYPTED_X25519DEOXYSII = exports.CALLFORMAT_PLAIN = exports.LATEST_TRANSACTION_VERSION = exports.SIGNATURE_CONTEXT_BASE = void 0;
const oasis = require("94f6f23bb2520103");
/**
 * Transaction signature domain separation context base.
 */ exports.SIGNATURE_CONTEXT_BASE = "oasis-runtime-sdk/tx: v0";
/**
 * The latest transaction format version.
 */ exports.LATEST_TRANSACTION_VERSION = 1;
/**
 * Plain text call data.
 */ exports.CALLFORMAT_PLAIN = 0;
/**
 * Encrypted call data using X25519 for key exchange and Deoxys-II for symmetric encryption.
 */ exports.CALLFORMAT_ENCRYPTED_X25519DEOXYSII = 1;
async function deriveChainContext(runtimeID, consensusChainContext) {
    return oasis.misc.toHex(await oasis.hash.hash(oasis.misc.concat(runtimeID, oasis.misc.fromString(consensusChainContext))));
}
exports.deriveChainContext = deriveChainContext;
async function signAny(pk, signer, context, body) {
    if (pk.ed25519) return await signer.sign(context, body);
    else if (pk.secp256k1) return await signer.sign(context, body);
    else throw new Error("unsupported public key type");
}
exports.signAny = signAny;
async function proveSignature(spec, signer, context, body) {
    if (spec.ed25519) return {
        signature: await signer.sign(context, body)
    };
    else if (spec.secp256k1eth) return {
        signature: await signer.sign(context, body)
    };
    else throw new Error("unsupported signature address specification type");
}
exports.proveSignature = proveSignature;
async function proveMultisig(config, signerSet, context, body) {
    const signatureSet = new Array(config.signers.length);
    for(let i = 0; i < config.signers.length; i++)if (signerSet[i]) signatureSet[i] = await signAny(config.signers[i].public_key, signerSet[i], context, body);
    else signatureSet[i] = null;
    return {
        multisig: signatureSet
    };
}
exports.proveMultisig = proveMultisig;
async function proveAny(addressSpec, proofProvider, context, body) {
    if (addressSpec.signature) return await proveSignature(addressSpec.signature, proofProvider, context, body);
    else if (addressSpec.multisig) return await proveMultisig(addressSpec.multisig, proofProvider, context, body);
    else throw new Error("unsupported address spec type");
}
exports.proveAny = proveAny;
/**
 * @param proofProviders An array of providers matching the layout of the
 * transaction's signer info.
 */ async function signUnverifiedTransaction(proofProviders, runtimeID, consensusChainContext, transaction) {
    const chainContext = await deriveChainContext(runtimeID, consensusChainContext);
    const context = oasis.signature.combineChainContext(exports.SIGNATURE_CONTEXT_BASE, chainContext);
    const body = oasis.misc.toCBOR(transaction);
    const authProofs = new Array(transaction.ai.si.length);
    for(let i = 0; i < transaction.ai.si.length; i++)authProofs[i] = await proveAny(transaction.ai.si[i].address_spec, proofProviders[i], context, body);
    return [
        body,
        authProofs
    ];
}
exports.signUnverifiedTransaction = signUnverifiedTransaction;
function visitCall(handlers, call) {
    if (handlers[call.method]) {
        handlers[call.method](call.body);
        return true;
    }
    return false;
}
exports.visitCall = visitCall;

},{"94f6f23bb2520103":"1ax6t"}],"dxfFI":[function(require,module,exports) {
var Buffer = require("5933e621afc8f33a").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromBech32 = exports.toBech32 = exports.fromMultisigConfig = exports.fromSigspec = exports.V0_MULTISIG_CONTEXT_VERSION = exports.V0_MULTISIG_CONTEXT_IDENTIFIER = exports.V0_SECP256K1ETH_CONTEXT_VERSION = exports.V0_SECP256K1ETH_CONTEXT_IDENTIFIER = void 0;
const oasis = require("4f83ba146bf21943");
const elliptic = require("36da483ad593b8e");
const sha3_1 = require("cf3e64092c64724");
exports.V0_SECP256K1ETH_CONTEXT_IDENTIFIER = "oasis-runtime-sdk/address: secp256k1eth";
exports.V0_SECP256K1ETH_CONTEXT_VERSION = 0;
exports.V0_MULTISIG_CONTEXT_IDENTIFIER = "oasis-runtime-sdk/address: multisig";
exports.V0_MULTISIG_CONTEXT_VERSION = 0;
const SECP256K1 = new elliptic.ec("secp256k1");
async function fromSigspec(spec) {
    if (spec.ed25519) return await oasis.staking.addressFromPublicKey(spec.ed25519);
    else if (spec.secp256k1eth) {
        // Use a scheme such that we can compute Secp256k1 addresses from Ethereum
        // addresses as this makes things more interoperable.
        const untaggedPk = SECP256K1.keyFromPublic(spec.secp256k1eth).getPublic(false, "array").slice(1);
        const hash = new sha3_1.Keccak(256);
        hash.update(Buffer.from(untaggedPk));
        const pkData = hash.digest().slice(12);
        return await oasis.address.fromData(exports.V0_SECP256K1ETH_CONTEXT_IDENTIFIER, exports.V0_SECP256K1ETH_CONTEXT_VERSION, pkData);
    } else throw new Error("unsupported signature address specification type");
}
exports.fromSigspec = fromSigspec;
async function fromMultisigConfig(config) {
    const configU8 = oasis.misc.toCBOR(config);
    return await oasis.address.fromData(exports.V0_MULTISIG_CONTEXT_IDENTIFIER, exports.V0_MULTISIG_CONTEXT_VERSION, configU8);
}
exports.fromMultisigConfig = fromMultisigConfig;
function toBech32(addr) {
    return oasis.staking.addressToBech32(addr);
}
exports.toBech32 = toBech32;
function fromBech32(str) {
    return oasis.staking.addressFromBech32(str);
}
exports.fromBech32 = fromBech32;

},{"5933e621afc8f33a":"eHuUs","4f83ba146bf21943":"1ax6t","36da483ad593b8e":"bxe3Z","cf3e64092c64724":"4OoRA"}],"bxe3Z":[function(require,module,exports) {
"use strict";
var elliptic = exports;
elliptic.version = require("e6672bc3ba1c9961").version;
elliptic.utils = require("5bc72f89931ad0f5");
elliptic.rand = require("7f90d752a36f35cf");
elliptic.curve = require("d11da69c91421223");
elliptic.curves = require("6845bad4ed92c3e4");
// Protocols
elliptic.ec = require("b5f2e1f615acc4b");
elliptic.eddsa = require("79ae761761517980");

},{"e6672bc3ba1c9961":"3jcXd","5bc72f89931ad0f5":"8vyEE","7f90d752a36f35cf":"gs6RB","d11da69c91421223":"cCBJD","6845bad4ed92c3e4":"g0h0a","b5f2e1f615acc4b":"a1xET","79ae761761517980":"gye8o"}],"3jcXd":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

},{}],"8vyEE":[function(require,module,exports) {
"use strict";
var utils = exports;
var BN = require("f4cbcf6f6eb25ca0");
var minAssert = require("d8ee30463f95a0fd");
var minUtils = require("997429d6bbd82d59");
utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;
// Represent num in a w-NAF form
function getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
utils.getNAF = getNAF;
// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
utils.getJSF = getJSF;
function cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
utils.cachedProperty = cachedProperty;
function parseBytes(bytes) {
    return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
}
utils.parseBytes = parseBytes;
function intFromLE(bytes) {
    return new BN(bytes, "hex", "le");
}
utils.intFromLE = intFromLE;

},{"f4cbcf6f6eb25ca0":"aJHtv","d8ee30463f95a0fd":"7j2pj","997429d6bbd82d59":"e97z6"}],"aJHtv":[function(require,module,exports) {
(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = require("bd440367abe2ded7").Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

},{"bd440367abe2ded7":"dayUX"}],"7j2pj":[function(require,module,exports) {
module.exports = assert;
function assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

},{}],"e97z6":[function(require,module,exports) {
"use strict";
var utils = exports;
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
utils.toArray = toArray;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
utils.zero2 = zero2;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
utils.toHex = toHex;
utils.encode = function encode(arr, enc) {
    if (enc === "hex") return toHex(arr);
    else return arr;
};

},{}],"gs6RB":[function(require,module,exports) {
var r;
module.exports = function rand(len) {
    if (!r) r = new Rand(null);
    return r.generate(len);
};
function Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = Rand;
Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};
if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var crypto = require("e8ad0674730919a8");
    if (typeof crypto.randomBytes !== "function") throw new Error("Not supported");
    Rand.prototype._rand = function _rand(n) {
        return crypto.randomBytes(n);
    };
} catch (e) {}

},{"e8ad0674730919a8":"dayUX"}],"cCBJD":[function(require,module,exports) {
"use strict";
var curve = exports;
curve.base = require("59d486bd2037506a");
curve.short = require("eb37617ef6927580");
curve.mont = require("be9c662572da2183");
curve.edwards = require("60763dd06fe64e8d");

},{"59d486bd2037506a":"2cvyf","eb37617ef6927580":"1f96H","be9c662572da2183":"jtW5U","60763dd06fe64e8d":"lb7oi"}],"2cvyf":[function(require,module,exports) {
"use strict";
var BN = require("70865a568c61cc60");
var utils = require("fb5111a3810a8235");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;
function BaseCurve(type, conf) {
    this.type = type;
    this.p = new BN(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);
    // Useful for many curves
    this.zero = new BN(0).toRed(this.red);
    this.one = new BN(1).toRed(this.red);
    this.two = new BN(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new BN(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = BaseCurve;
BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;
BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
BasePoint.prototype.encode = function encode(enc, compact) {
    return utils.encode(this._encode(compact), enc);
};
BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

},{"70865a568c61cc60":"aJHtv","fb5111a3810a8235":"8vyEE"}],"1f96H":[function(require,module,exports) {
"use strict";
var utils = require("89f794ef417dc31c");
var BN = require("c314b0ac30b69c4a");
var inherits = require("6ac4d7c73f24ab9c");
var Base = require("6e622edb7498c94");
var assert = utils.assert;
function ShortCurve(conf) {
    Base.call(this, "short", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;
ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new BN(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new BN(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new BN(vec.a, 16),
            b: new BN(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : BN.mont(num);
    var tinv = new BN(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new BN(1);
    var y1 = new BN(0);
    var x2 = new BN(0);
    var y2 = new BN(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function Point(curve, x, y, isRed) {
    Base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
inherits(Point, Base.BasePoint);
ShortCurve.prototype.point = function point(x, y, isRed) {
    return new Point(this, x, y, isRed);
};
ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return Point.fromJSON(this, obj, red);
};
Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
Point.prototype.mul = function mul(k) {
    k = new BN(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function JPoint(curve, x, y, z) {
    Base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new BN(0);
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = new BN(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);
ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new JPoint(this, x, y, z);
};
JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
JPoint.prototype.mul = function mul(k, kbase) {
    k = new BN(k, kbase);
    return this.curve._wnafMul(this, k);
};
JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

},{"89f794ef417dc31c":"8vyEE","c314b0ac30b69c4a":"aJHtv","6ac4d7c73f24ab9c":"5Bw0w","6e622edb7498c94":"2cvyf"}],"5Bw0w":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"jtW5U":[function(require,module,exports) {
"use strict";
var BN = require("ebdf19f04f3ed250");
var inherits = require("cb5bb4841a749f68");
var Base = require("51280941230b3f98");
var utils = require("ea7949a80be00261");
function MontCurve(conf) {
    Base.call(this, "mont", conf);
    this.a = new BN(conf.a, 16).toRed(this.red);
    this.b = new BN(conf.b, 16).toRed(this.red);
    this.i4 = new BN(4).toRed(this.red).redInvm();
    this.two = new BN(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;
MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function Point(curve, x, z) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new BN(x, 16);
        this.z = new BN(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
inherits(Point, Base.BasePoint);
MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point(utils.toArray(bytes, enc), 1);
};
MontCurve.prototype.point = function point(x, z) {
    return new Point(this, x, z);
};
MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
Point.prototype.precompute = function precompute() {
// No-op
};
Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1] || curve.one);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

},{"ebdf19f04f3ed250":"aJHtv","cb5bb4841a749f68":"5Bw0w","51280941230b3f98":"2cvyf","ea7949a80be00261":"8vyEE"}],"lb7oi":[function(require,module,exports) {
"use strict";
var utils = require("7bd66a4710450b08");
var BN = require("ccef46dcf03d45c6");
var inherits = require("19937272cbe23c92");
var Base = require("108c8ead5f54502b");
var assert = utils.assert;
function EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    Base.call(this, "edwards", conf);
    this.a = new BN(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new BN(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new BN(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;
EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new BN(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new BN(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function Point(curve, x, y, z, t) {
    Base.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new BN(x, 16);
        this.y = new BN(y, 16);
        this.z = z ? new BN(z, 16) : this.curve.one;
        this.t = t && new BN(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
inherits(Point, Base.BasePoint);
EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return Point.fromJSON(this, obj);
};
EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new Point(this, x, y, z, t);
};
Point.fromJSON = function fromJSON(curve, obj) {
    return new Point(curve, obj[0], obj[1], obj[2]);
};
Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;

},{"7bd66a4710450b08":"8vyEE","ccef46dcf03d45c6":"aJHtv","19937272cbe23c92":"5Bw0w","108c8ead5f54502b":"2cvyf"}],"g0h0a":[function(require,module,exports) {
"use strict";
var curves = exports;
var hash = require("1c9db357c0845afa");
var curve = require("47ec78745540f875");
var utils = require("e30b16e4a47a5405");
var assert = utils.assert;
function PresetCurve(options) {
    if (options.type === "short") this.curve = new curve.short(options);
    else if (options.type === "edwards") this.curve = new curve.edwards(options);
    else this.curve = new curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    assert(this.g.validate(), "Invalid curve");
    assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
curves.PresetCurve = PresetCurve;
function defineCurve(name, options) {
    Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: hash.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: hash.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: hash.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: hash.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: hash.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: hash.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var pre;
try {
    pre = require("9eada5f7049e7dfd");
} catch (e) {
    pre = undefined;
}
defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: hash.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        pre
    ]
});

},{"1c9db357c0845afa":"d2Z4J","47ec78745540f875":"cCBJD","e30b16e4a47a5405":"8vyEE","9eada5f7049e7dfd":"1LxXk"}],"d2Z4J":[function(require,module,exports) {
var hash = exports;
hash.utils = require("38593959f18bd562");
hash.common = require("31a457752237e8ad");
hash.sha = require("3e37816d2a2fd68d");
hash.ripemd = require("ce5a13b5bd10f171");
hash.hmac = require("c32fbac97a361580");
// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;

},{"38593959f18bd562":"hm8Ca","31a457752237e8ad":"5mEwp","3e37816d2a2fd68d":"a5mt6","ce5a13b5bd10f171":"jFgpj","c32fbac97a361580":"a3Wix"}],"hm8Ca":[function(require,module,exports) {
"use strict";
var assert = require("6002b0feade022a4");
var inherits = require("d4826c9d0ff1b1f");
exports.inherits = inherits;
function isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if (isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
exports.toArray = toArray;
function toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
    return res;
}
exports.toHex = toHex;
function htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
exports.htonl = htonl;
function toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = htonl(w);
        res += zero8(w.toString(16));
    }
    return res;
}
exports.toHex32 = toHex32;
function zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
exports.zero2 = zero2;
function zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
exports.zero8 = zero8;
function join32(msg, start, end, endian) {
    var len = end - start;
    assert(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
exports.join32 = join32;
function split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
exports.split32 = split32;
function rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
exports.rotr32 = rotr32;
function rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
exports.rotl32 = rotl32;
function sum32(a, b) {
    return a + b >>> 0;
}
exports.sum32 = sum32;
function sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
exports.sum32_3 = sum32_3;
function sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
exports.sum32_4 = sum32_4;
function sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
exports.sum32_5 = sum32_5;
function sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
exports.sum64 = sum64;
function sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
exports.sum64_hi = sum64_hi;
function sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
exports.sum64_lo = sum64_lo;
function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;
function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;
function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;
function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;
function rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;
function rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;
function shr64_hi(ah, al, num) {
    return ah >>> num;
}
exports.shr64_hi = shr64_hi;
function shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
exports.shr64_lo = shr64_lo;

},{"6002b0feade022a4":"7j2pj","d4826c9d0ff1b1f":"5Bw0w"}],"5mEwp":[function(require,module,exports) {
"use strict";
var utils = require("e9291abdfb47ee4f");
var assert = require("ea8841b701712638");
function BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;
BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = utils.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = utils.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    assert(this.pending === null);
    return this._digest(enc);
};
BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

},{"e9291abdfb47ee4f":"hm8Ca","ea8841b701712638":"7j2pj"}],"a5mt6":[function(require,module,exports) {
"use strict";
exports.sha1 = require("3835379564860fd7");
exports.sha224 = require("bb9f72f042233648");
exports.sha256 = require("20a3b0fa42e37dfe");
exports.sha384 = require("ad4827efa7d953c2");
exports.sha512 = require("301292595a944c1d");

},{"3835379564860fd7":"jDpoN","bb9f72f042233648":"4JhUN","20a3b0fa42e37dfe":"hDPv1","ad4827efa7d953c2":"7Gce3","301292595a944c1d":"02lm9"}],"jDpoN":[function(require,module,exports) {
"use strict";
var utils = require("b75f3c1442bf9100");
var common = require("a29e68029e4c48f8");
var shaCommon = require("1be62f90a237cba5");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;
var sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function SHA1() {
    if (!(this instanceof SHA1)) return new SHA1();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
utils.inherits(SHA1, BlockHash);
module.exports = SHA1;
SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;
SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
        e = d;
        d = c;
        c = rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
};
SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"b75f3c1442bf9100":"hm8Ca","a29e68029e4c48f8":"5mEwp","1be62f90a237cba5":"9ZLHN"}],"9ZLHN":[function(require,module,exports) {
"use strict";
var utils = require("f0fb61f828bacd0f");
var rotr32 = utils.rotr32;
function ft_1(s, x, y, z) {
    if (s === 0) return ch32(x, y, z);
    if (s === 1 || s === 3) return p32(x, y, z);
    if (s === 2) return maj32(x, y, z);
}
exports.ft_1 = ft_1;
function ch32(x, y, z) {
    return x & y ^ ~x & z;
}
exports.ch32 = ch32;
function maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
exports.maj32 = maj32;
function p32(x, y, z) {
    return x ^ y ^ z;
}
exports.p32 = p32;
function s0_256(x) {
    return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;
function s1_256(x) {
    return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;
function g0_256(x) {
    return rotr32(x, 7) ^ rotr32(x, 18) ^ x >>> 3;
}
exports.g0_256 = g0_256;
function g1_256(x) {
    return rotr32(x, 17) ^ rotr32(x, 19) ^ x >>> 10;
}
exports.g1_256 = g1_256;

},{"f0fb61f828bacd0f":"hm8Ca"}],"4JhUN":[function(require,module,exports) {
"use strict";
var utils = require("fe5acd040463c159");
var SHA256 = require("fa3503eda3738d05");
function SHA224() {
    if (!(this instanceof SHA224)) return new SHA224();
    SHA256.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;
SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;
SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 7), "big");
    else return utils.split32(this.h.slice(0, 7), "big");
};

},{"fe5acd040463c159":"hm8Ca","fa3503eda3738d05":"hDPv1"}],"hDPv1":[function(require,module,exports) {
"use strict";
var utils = require("32ad3e510bd41f2a");
var common = require("469ad88ad505772a");
var shaCommon = require("fffa7d1ddf1f0b43");
var assert = require("126369f57b5225ed");
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;
var BlockHash = common.BlockHash;
var sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function SHA256() {
    if (!(this instanceof SHA256)) return new SHA256();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = sha256_K;
    this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;
SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;
SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    assert(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
        var T2 = sum32(s0_256(a), maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = sum32(T1, T2);
    }
    this.h[0] = sum32(this.h[0], a);
    this.h[1] = sum32(this.h[1], b);
    this.h[2] = sum32(this.h[2], c);
    this.h[3] = sum32(this.h[3], d);
    this.h[4] = sum32(this.h[4], e);
    this.h[5] = sum32(this.h[5], f);
    this.h[6] = sum32(this.h[6], g);
    this.h[7] = sum32(this.h[7], h);
};
SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};

},{"32ad3e510bd41f2a":"hm8Ca","469ad88ad505772a":"5mEwp","fffa7d1ddf1f0b43":"9ZLHN","126369f57b5225ed":"7j2pj"}],"7Gce3":[function(require,module,exports) {
"use strict";
var utils = require("a696ee34c45713da");
var SHA512 = require("fff95253fdaa49ea");
function SHA384() {
    if (!(this instanceof SHA384)) return new SHA384();
    SHA512.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;
SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;
SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h.slice(0, 12), "big");
    else return utils.split32(this.h.slice(0, 12), "big");
};

},{"a696ee34c45713da":"hm8Ca","fff95253fdaa49ea":"02lm9"}],"02lm9":[function(require,module,exports) {
"use strict";
var utils = require("7753b1fa702fbb54");
var common = require("81b6970d75627ce1");
var assert = require("f660976cede694e2");
var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;
var BlockHash = common.BlockHash;
var sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function SHA512() {
    if (!(this instanceof SHA512)) return new SHA512();
    BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = sha512_K;
    this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;
SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;
SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    assert(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = s1_512_hi(eh, el);
        var c1_lo = s1_512_lo(eh, el);
        var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = s0_512_hi(ah, al);
        c0_lo = s0_512_lo(ah, al);
        c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = sum64_hi(dh, dl, T1_hi, T1_lo);
        el = sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    sum64(this.h, 0, ah, al);
    sum64(this.h, 2, bh, bl);
    sum64(this.h, 4, ch, cl);
    sum64(this.h, 6, dh, dl);
    sum64(this.h, 8, eh, el);
    sum64(this.h, 10, fh, fl);
    sum64(this.h, 12, gh, gl);
    sum64(this.h, 14, hh, hl);
};
SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "big");
    else return utils.split32(this.h, "big");
};
function ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 28);
    var c1_hi = rotr64_hi(xl, xh, 2); // 34
    var c2_hi = rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 28);
    var c1_lo = rotr64_lo(xl, xh, 2); // 34
    var c2_lo = rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 14);
    var c1_hi = rotr64_hi(xh, xl, 18);
    var c2_hi = rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function s1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 14);
    var c1_lo = rotr64_lo(xh, xl, 18);
    var c2_lo = rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 1);
    var c1_hi = rotr64_hi(xh, xl, 8);
    var c2_hi = shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g0_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 1);
    var c1_lo = rotr64_lo(xh, xl, 8);
    var c2_lo = shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_hi(xh, xl) {
    var c0_hi = rotr64_hi(xh, xl, 19);
    var c1_hi = rotr64_hi(xl, xh, 29); // 61
    var c2_hi = shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function g1_512_lo(xh, xl) {
    var c0_lo = rotr64_lo(xh, xl, 19);
    var c1_lo = rotr64_lo(xl, xh, 29); // 61
    var c2_lo = shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

},{"7753b1fa702fbb54":"hm8Ca","81b6970d75627ce1":"5mEwp","f660976cede694e2":"7j2pj"}],"jFgpj":[function(require,module,exports) {
"use strict";
var utils = require("36495272d446418f");
var common = require("ad8cf0490e28e8d7");
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;
function RIPEMD160() {
    if (!(this instanceof RIPEMD160)) return new RIPEMD160();
    BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;
RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;
RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = sum32(rotl32(sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)), s[j]), E);
        A = E;
        E = D;
        D = rotl32(C, 10);
        C = B;
        B = T;
        T = sum32(rotl32(sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)), sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = sum32_3(this.h[1], C, Dh);
    this.h[1] = sum32_3(this.h[2], D, Eh);
    this.h[2] = sum32_3(this.h[3], E, Ah);
    this.h[3] = sum32_3(this.h[4], A, Bh);
    this.h[4] = sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return utils.toHex32(this.h, "little");
    else return utils.split32(this.h, "little");
};
function f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

},{"36495272d446418f":"hm8Ca","ad8cf0490e28e8d7":"5mEwp"}],"a3Wix":[function(require,module,exports) {
"use strict";
var utils = require("596c08b6835a6e2d");
var assert = require("be527907d4f06808");
function Hmac(hash, key, enc) {
    if (!(this instanceof Hmac)) return new Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init(utils.toArray(key, enc));
}
module.exports = Hmac;
Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    assert(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

},{"596c08b6835a6e2d":"hm8Ca","be527907d4f06808":"7j2pj"}],"1LxXk":[function(require,module,exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

},{}],"a1xET":[function(require,module,exports) {
"use strict";
var BN = require("2e69183faf5285a1");
var HmacDRBG = require("b0cb641292e4911d");
var utils = require("eab3e45147b180ba");
var curves = require("a5ce61d26ce01c4c");
var rand = require("f6342f89ac472937");
var assert = utils.assert;
var KeyPair = require("eb5ba559e423f6e9");
var Signature = require("7c5e2c76c574ce41");
function EC(options) {
    if (!(this instanceof EC)) return new EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        assert(Object.prototype.hasOwnProperty.call(curves, options), "Unknown curve " + options);
        options = curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = EC;
EC.prototype.keyPair = function keyPair(options) {
    return new KeyPair(this, options);
};
EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return KeyPair.fromPrivate(this, priv, enc);
};
EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return KeyPair.fromPublic(this, pub, enc);
};
EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new BN(2));
    for(;;){
        var priv = new BN(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new BN(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new HmacDRBG({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new BN(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new BN(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new Signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new BN(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new Signature(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new Signature(signature, enc);
    var n = this.n;
    var e = new BN(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new Signature(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

},{"2e69183faf5285a1":"aJHtv","b0cb641292e4911d":"lh5zB","eab3e45147b180ba":"8vyEE","a5ce61d26ce01c4c":"g0h0a","f6342f89ac472937":"gs6RB","eb5ba559e423f6e9":"aQRFv","7c5e2c76c574ce41":"gImXJ"}],"lh5zB":[function(require,module,exports) {
"use strict";
var hash = require("629972fec592198f");
var utils = require("c20531edfb274a2c");
var assert = require("43ff1863ab3fce20");
function HmacDRBG(options) {
    if (!(this instanceof HmacDRBG)) return new HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = utils.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = utils.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = utils.toArray(options.pers, options.persEnc || "hex");
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;
HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
HmacDRBG.prototype._hmac = function hmac() {
    return new hash.hmac(this.hash, this.K);
};
HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = utils.toArray(entropy, entropyEnc);
    add = utils.toArray(add, addEnc);
    assert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = utils.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return utils.encode(res, enc);
};

},{"629972fec592198f":"d2Z4J","c20531edfb274a2c":"e97z6","43ff1863ab3fce20":"7j2pj"}],"aQRFv":[function(require,module,exports) {
"use strict";
var BN = require("55cc33a33cda153d");
var utils = require("bda8b1ff480a7f3");
var assert = utils.assert;
function KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;
KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof KeyPair) return priv;
    return new KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new BN(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

},{"55cc33a33cda153d":"aJHtv","bda8b1ff480a7f3":"8vyEE"}],"gImXJ":[function(require,module,exports) {
"use strict";
var BN = require("a7ae8f0fe39990e7");
var utils = require("5df7da4811374387");
var assert = utils.assert;
function Signature(options, enc) {
    if (options instanceof Signature) return options;
    if (this._importDER(options, enc)) return;
    assert(options.r && options.s, "Signature without r or s");
    this.r = new BN(options.r, 16);
    this.s = new BN(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;
function Position() {
    this.place = 0;
}
function getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
Signature.prototype._importDER = function _importDER(data, enc) {
    data = utils.toArray(data, enc);
    var p = new Position();
    if (data[p.place++] !== 0x30) return false;
    var len = getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new BN(r);
    this.s = new BN(s);
    this.recoveryParam = null;
    return true;
};
function constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = rmPadding(r);
    s = rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return utils.encode(res, enc);
};

},{"a7ae8f0fe39990e7":"aJHtv","5df7da4811374387":"8vyEE"}],"gye8o":[function(require,module,exports) {
"use strict";
var hash = require("50f9bfa8a484d5d8");
var curves = require("68956d27442d6321");
var utils = require("99ec52641eff141d");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = require("2ad2982d76b37f15");
var Signature = require("76c25a1d63d10c1b");
function EDDSA(curve) {
    assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof EDDSA)) return new EDDSA(curve);
    curve = curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = hash.sha512;
}
module.exports = EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ EDDSA.prototype.sign = function sign(message, secret) {
    message = parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return utils.intFromLE(hash.digest()).umod(this.curve.n);
};
EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return KeyPair.fromPublic(this, pub);
};
EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return KeyPair.fromSecret(this, secret);
};
EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof Signature) return sig;
    return new Signature(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return utils.intFromLE(bytes);
};
EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

},{"50f9bfa8a484d5d8":"d2Z4J","68956d27442d6321":"g0h0a","99ec52641eff141d":"8vyEE","2ad2982d76b37f15":"axZzh","76c25a1d63d10c1b":"a2hhF"}],"axZzh":[function(require,module,exports) {
"use strict";
var utils = require("387ffb9c0bf065ab");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = parseBytes(params.pub);
}
KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof KeyPair) return pub;
    return new KeyPair(eddsa, {
        pub: pub
    });
};
KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof KeyPair) return secret;
    return new KeyPair(eddsa, {
        secret: secret
    });
};
KeyPair.prototype.secret = function secret() {
    return this._secret;
};
cachedProperty(KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
cachedProperty(KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
cachedProperty(KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
cachedProperty(KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
cachedProperty(KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
cachedProperty(KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
KeyPair.prototype.sign = function sign(message) {
    assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
KeyPair.prototype.getSecret = function getSecret(enc) {
    assert(this._secret, "KeyPair is public only");
    return utils.encode(this.secret(), enc);
};
KeyPair.prototype.getPublic = function getPublic(enc) {
    return utils.encode(this.pubBytes(), enc);
};
module.exports = KeyPair;

},{"387ffb9c0bf065ab":"8vyEE"}],"a2hhF":[function(require,module,exports) {
"use strict";
var BN = require("696e2c87f819d166");
var utils = require("51b94bcac1dcb2b2");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof BN) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
cachedProperty(Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
cachedProperty(Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
cachedProperty(Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
cachedProperty(Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
Signature.prototype.toHex = function toHex() {
    return utils.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = Signature;

},{"696e2c87f819d166":"aJHtv","51b94bcac1dcb2b2":"8vyEE"}],"4OoRA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = exports.SHAKE = exports.SHA3Hash = exports.SHA3 = exports.Keccak = void 0;
var _buffer = require("57b68afdffbc31b1");
var _sponge = _interopRequireDefault(require("4018f8c5aa0c40"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var createHash = function createHash(_ref) {
    var allowedSizes = _ref.allowedSizes, defaultSize = _ref.defaultSize, padding = _ref.padding;
    return function Hash() {
        var _this = this;
        var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSize;
        if (!this || this.constructor !== Hash) return new Hash(size);
        if (allowedSizes && !allowedSizes.includes(size)) throw new Error("Unsupported hash length");
        var sponge = new _sponge["default"]({
            capacity: size
        });
        this.update = function(input) {
            var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
            if (_buffer.Buffer.isBuffer(input)) {
                sponge.absorb(input);
                return _this;
            }
            if (typeof input === "string") return _this.update(_buffer.Buffer.from(input, encoding));
            throw new TypeError("Not a string or buffer");
        };
        this.digest = function() {
            var formatOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "binary";
            var options = typeof formatOrOptions === "string" ? {
                format: formatOrOptions
            } : formatOrOptions;
            var buffer = sponge.squeeze({
                buffer: options.buffer,
                padding: options.padding || padding
            });
            if (options.format && options.format !== "binary") return buffer.toString(options.format);
            return buffer;
        };
        this.reset = function() {
            sponge.reset();
            return _this;
        };
        return this;
    };
};
var Keccak = createHash({
    allowedSizes: [
        224,
        256,
        384,
        512
    ],
    defaultSize: 512,
    padding: 1
});
exports.Keccak = Keccak;
var SHA3 = createHash({
    allowedSizes: [
        224,
        256,
        384,
        512
    ],
    defaultSize: 512,
    padding: 6
});
exports.SHA3 = SHA3;
var SHAKE = createHash({
    allowedSizes: [
        128,
        256
    ],
    defaultSize: 256,
    padding: 31
});
exports.SHAKE = SHAKE;
var SHA3Hash = Keccak;
exports.SHA3Hash = SHA3Hash;
SHA3.SHA3Hash = SHA3Hash;
var _default = SHA3;
exports["default"] = _default;

},{"57b68afdffbc31b1":"eHuUs","4018f8c5aa0c40":"8pAzQ"}],"8pAzQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _buffer = require("1b5ff15b423b2a17");
var _permute = _interopRequireDefault(require("3e08b24d7de90079"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var xorWords = function xorWords(I, O) {
    for(var i = 0; i < I.length; i += 8){
        var o = i / 4;
        O[o] ^= I[i + 7] << 24 | I[i + 6] << 16 | I[i + 5] << 8 | I[i + 4];
        O[o + 1] ^= I[i + 3] << 24 | I[i + 2] << 16 | I[i + 1] << 8 | I[i];
    }
    return O;
};
var readWords = function readWords(I, O) {
    for(var o = 0; o < O.length; o += 8){
        var i = o / 4;
        O[o] = I[i + 1];
        O[o + 1] = I[i + 1] >>> 8;
        O[o + 2] = I[i + 1] >>> 16;
        O[o + 3] = I[i + 1] >>> 24;
        O[o + 4] = I[i];
        O[o + 5] = I[i] >>> 8;
        O[o + 6] = I[i] >>> 16;
        O[o + 7] = I[i] >>> 24;
    }
    return O;
};
var Sponge = function Sponge(_ref) {
    var _this = this;
    var capacity = _ref.capacity, padding = _ref.padding;
    var keccak = (0, _permute["default"])();
    var stateSize = 200;
    var blockSize = capacity / 8;
    var queueSize = stateSize - capacity / 4;
    var queueOffset = 0;
    var state = new Uint32Array(stateSize / 4);
    var queue = _buffer.Buffer.allocUnsafe(queueSize);
    this.absorb = function(buffer) {
        for(var i = 0; i < buffer.length; i++){
            queue[queueOffset] = buffer[i];
            queueOffset += 1;
            if (queueOffset >= queueSize) {
                xorWords(queue, state);
                keccak(state);
                queueOffset = 0;
            }
        }
        return _this;
    };
    this.squeeze = function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var output = {
            buffer: options.buffer || _buffer.Buffer.allocUnsafe(blockSize),
            padding: options.padding || padding,
            queue: _buffer.Buffer.allocUnsafe(queue.length),
            state: new Uint32Array(state.length)
        };
        queue.copy(output.queue);
        for(var i = 0; i < state.length; i++)output.state[i] = state[i];
        output.queue.fill(0, queueOffset);
        output.queue[queueOffset] |= output.padding;
        output.queue[queueSize - 1] |= 128;
        xorWords(output.queue, output.state);
        for(var offset = 0; offset < output.buffer.length; offset += queueSize){
            keccak(output.state);
            readWords(output.state, output.buffer.slice(offset, offset + queueSize));
        }
        return output.buffer;
    };
    this.reset = function() {
        queue.fill(0);
        state.fill(0);
        queueOffset = 0;
        return _this;
    };
    return this;
};
var _default = Sponge;
exports["default"] = _default;

},{"1b5ff15b423b2a17":"eHuUs","3e08b24d7de90079":"8Ub0k"}],"8Ub0k":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _chi = _interopRequireDefault(require("294b31cec6b7c410"));
var _iota = _interopRequireDefault(require("534f0f33b630b854"));
var _rhoPi = _interopRequireDefault(require("a8218811f7aedfd0"));
var _theta = _interopRequireDefault(require("b73706c6d86e4eb3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var permute = function permute() {
    var C = new Uint32Array(10);
    var D = new Uint32Array(10);
    var W = new Uint32Array(2);
    return function(A) {
        for(var roundIndex = 0; roundIndex < 24; roundIndex++){
            (0, _theta["default"])({
                A: A,
                C: C,
                D: D,
                W: W
            });
            (0, _rhoPi["default"])({
                A: A,
                C: C,
                W: W
            });
            (0, _chi["default"])({
                A: A,
                C: C
            });
            (0, _iota["default"])({
                A: A,
                roundIndex: roundIndex
            });
        }
        C.fill(0);
        D.fill(0);
        W.fill(0);
    };
};
var _default = permute;
exports["default"] = _default;

},{"294b31cec6b7c410":"2rAZ7","534f0f33b630b854":"cXOXw","a8218811f7aedfd0":"5Hzto","b73706c6d86e4eb3":"5Ctxz"}],"2rAZ7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _copy = _interopRequireDefault(require("dd9ce738cf00f1bc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var chi = function chi(_ref) {
    var A = _ref.A, C = _ref.C;
    for(var y = 0; y < 25; y += 5){
        for(var x = 0; x < 5; x++)(0, _copy["default"])(A, y + x)(C, x);
        for(var _x = 0; _x < 5; _x++){
            var xy = (y + _x) * 2;
            var x1 = (_x + 1) % 5 * 2;
            var x2 = (_x + 2) % 5 * 2;
            A[xy] ^= ~C[x1] & C[x2];
            A[xy + 1] ^= ~C[x1 + 1] & C[x2 + 1];
        }
    }
};
var _default = chi;
exports["default"] = _default;

},{"dd9ce738cf00f1bc":"lRXu4"}],"lRXu4":[function(require,module,exports) {
"use strict";
var copy = function copy(I, i) {
    return function(O, o) {
        var oi = o * 2;
        var ii = i * 2;
        O[oi] = I[ii];
        O[oi + 1] = I[ii + 1];
    };
};
module.exports = copy;

},{}],"cXOXw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _roundConstants = _interopRequireDefault(require("3d7eec0279e7e9f8"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var iota = function iota(_ref) {
    var A = _ref.A, roundIndex = _ref.roundIndex;
    var i = roundIndex * 2;
    A[0] ^= _roundConstants["default"][i];
    A[1] ^= _roundConstants["default"][i + 1];
};
var _default = iota;
exports["default"] = _default;

},{"3d7eec0279e7e9f8":"azIlv"}],"azIlv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var ROUND_CONSTANTS = new Uint32Array([
    0,
    1,
    0,
    32898,
    2147483648,
    32906,
    2147483648,
    2147516416,
    0,
    32907,
    0,
    2147483649,
    2147483648,
    2147516545,
    2147483648,
    32777,
    0,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    2147483648,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    0,
    32778,
    2147483648,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    0,
    2147483649,
    2147483648,
    2147516424
]);
var _default = ROUND_CONSTANTS;
exports["default"] = _default;

},{}],"5Hzto":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _piShuffles = _interopRequireDefault(require("2f52af76f5d1fa9a"));
var _rhoOffsets = _interopRequireDefault(require("f69ab31886f0c60"));
var _copy = _interopRequireDefault(require("96b35dc60d8d826c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var rhoPi = function rhoPi(_ref) {
    var A = _ref.A, C = _ref.C, W = _ref.W;
    (0, _copy["default"])(A, 1)(W, 0);
    var H = 0;
    var L = 0;
    var Wi = 0;
    var ri = 32;
    for(var i = 0; i < 24; i++){
        var j = _piShuffles["default"][i];
        var r = _rhoOffsets["default"][i];
        (0, _copy["default"])(A, j)(C, 0);
        H = W[0];
        L = W[1];
        ri = 32 - r;
        Wi = r < 32 ? 0 : 1;
        W[Wi] = H << r | L >>> ri;
        W[(Wi + 1) % 2] = L << r | H >>> ri;
        (0, _copy["default"])(W, 0)(A, j);
        (0, _copy["default"])(C, 0)(W, 0);
    }
};
var _default = rhoPi;
exports["default"] = _default;

},{"2f52af76f5d1fa9a":"fOkIr","f69ab31886f0c60":"1jokP","96b35dc60d8d826c":"lRXu4"}],"fOkIr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var PI_SHUFFLES = [
    10,
    7,
    11,
    17,
    18,
    3,
    5,
    16,
    8,
    21,
    24,
    4,
    15,
    23,
    19,
    13,
    12,
    2,
    20,
    14,
    22,
    9,
    6,
    1
];
var _default = PI_SHUFFLES;
exports["default"] = _default;

},{}],"1jokP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var RHO_OFFSETS = [
    1,
    3,
    6,
    10,
    15,
    21,
    28,
    36,
    45,
    55,
    2,
    14,
    27,
    41,
    56,
    8,
    25,
    43,
    62,
    18,
    39,
    61,
    20,
    44
];
var _default = RHO_OFFSETS;
exports["default"] = _default;

},{}],"5Ctxz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _copy = _interopRequireDefault(require("98539d59f2455ef5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var theta = function theta(_ref) {
    var A = _ref.A, C = _ref.C, D = _ref.D, W = _ref.W;
    var H = 0;
    var L = 0;
    for(var x = 0; x < 5; x++){
        var x20 = x * 2;
        var x21 = (x + 5) * 2;
        var x22 = (x + 10) * 2;
        var x23 = (x + 15) * 2;
        var x24 = (x + 20) * 2;
        C[x20] = A[x20] ^ A[x21] ^ A[x22] ^ A[x23] ^ A[x24];
        C[x20 + 1] = A[x20 + 1] ^ A[x21 + 1] ^ A[x22 + 1] ^ A[x23 + 1] ^ A[x24 + 1];
    }
    for(var _x = 0; _x < 5; _x++){
        (0, _copy["default"])(C, (_x + 1) % 5)(W, 0);
        H = W[0];
        L = W[1];
        W[0] = H << 1 | L >>> 31;
        W[1] = L << 1 | H >>> 31;
        D[_x * 2] = C[(_x + 4) % 5 * 2] ^ W[0];
        D[_x * 2 + 1] = C[(_x + 4) % 5 * 2 + 1] ^ W[1];
        for(var y = 0; y < 25; y += 5){
            A[(y + _x) * 2] ^= D[_x * 2];
            A[(y + _x) * 2 + 1] ^= D[_x * 2 + 1];
        }
    }
};
var _default = theta;
exports["default"] = _default;

},{"98539d59f2455ef5":"lRXu4"}],"jvDg5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.decodeResult = exports.encodeCall = exports.encodeCallWithNonceAndKeys = exports.CALL_DATA_KEY_PAIR_ID_CONTEXT_BASE = void 0;
const oasis = require("cf1c46ff4b6d4b13");
const deoxysii = require("dbdff0ea2f21c99e");
const nacl = require("24fecc8853fc1b4");
const randomBytes = require("c2bea083dcb62a2b");
const mraeDeoxysii = require("56533476ec3991dc");
const transaction = require("5c62e3088c019d40");
/**
 * Call data key pair ID domain separation context base.
 */ exports.CALL_DATA_KEY_PAIR_ID_CONTEXT_BASE = "oasis-runtime-sdk/private: tx";
/**
 * encodeCallWithNonceAndKeys encodes a call based on its configured call format.
 * It returns the encoded call and any metadata needed to successfully decode the result.
 */ async function encodeCallWithNonceAndKeys(nonce, sk, pk, call, format, config) {
    switch(format){
        case transaction.CALLFORMAT_PLAIN:
            return [
                call,
                undefined
            ];
        case transaction.CALLFORMAT_ENCRYPTED_X25519DEOXYSII:
            if (config?.publicKey === undefined) throw new Error("callformat: runtime call data public key not set");
            const rawCall = oasis.misc.toCBOR(call);
            const zeroBuffer = new Uint8Array(0);
            const sealedCall = mraeDeoxysii.boxSeal(nonce, rawCall, zeroBuffer, config.publicKey.key, sk);
            const envelope = {
                pk: pk,
                nonce: nonce,
                data: sealedCall
            };
            const encoded = {
                format: transaction.CALLFORMAT_ENCRYPTED_X25519DEOXYSII,
                method: "",
                body: oasis.misc.toCBOR(envelope)
            };
            const meta = {
                sk: sk,
                pk: config.publicKey.key
            };
            return [
                encoded,
                meta
            ];
        default:
            throw new Error(`callformat: unsupported call format: ${format}`);
    }
}
exports.encodeCallWithNonceAndKeys = encodeCallWithNonceAndKeys;
/**
 * encodeCall randomly generates nonce and keyPair and then call encodeCallWithNonceAndKeys
 * It returns the encoded call and any metadata needed to successfully decode the result.
 */ async function encodeCall(call, format, config) {
    const nonce = randomBytes(deoxysii.NonceSize);
    const keyPair = nacl.box.keyPair();
    return await encodeCallWithNonceAndKeys(nonce, keyPair.secretKey, keyPair.publicKey, call, format, config);
}
exports.encodeCall = encodeCall;
/**
 * decodeResult performs result decoding based on the specified call format metadata.
 */ async function decodeResult(result, format, meta) {
    switch(format){
        case transaction.CALLFORMAT_PLAIN:
            // In case of plain-text data format, we simply pass on the result unchanged.
            return result;
        case transaction.CALLFORMAT_ENCRYPTED_X25519DEOXYSII:
            if (result.unknown) {
                if (meta) {
                    const envelop = oasis.misc.fromCBOR(result.unknown);
                    const zeroBuffer = new Uint8Array(0);
                    const pt = mraeDeoxysii.boxOpen(envelop?.nonce, envelop?.data, zeroBuffer, meta.pk, meta.sk);
                    return oasis.misc.fromCBOR(pt);
                } else throw new Error(`callformat: MetaEncryptedX25519DeoxysII data is required for callformat: CALLFORMAT_ENCRYPTED_X25519DEOXYSII`);
            } else if (result.fail) throw new Error(`callformat: failed call: module: ${result.fail.module} code: ${result.fail.code} message: ${result.fail.message}`);
            throw Object.assign(new Error(`callformat: unexpected result: ${result.ok}`), {
                source: result
            });
        default:
            throw new Error(`callformat: unsupported call format: ${format}`);
    }
}
exports.decodeResult = decodeResult;

},{"cf1c46ff4b6d4b13":"1ax6t","dbdff0ea2f21c99e":"e0VtN","24fecc8853fc1b4":"dbRqa","c2bea083dcb62a2b":"2Bpdt","56533476ec3991dc":"8Lo5H","5c62e3088c019d40":"4ceij"}],"e0VtN":[function(require,module,exports) {
// Copyright (c) 2019 Oasis Labs Inc. <info@oasislabs.com>
//
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
// BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// @ts-expect-error TODO: missing types
var aes = require("683bdf9420c2f4c1");
var uint32 = require("818d62dfbd72fc9b");
// @ts-expect-error TODO: missing types
var unsafe = require("3d82de62d070f525");
const KeySize = 32;
const NonceSize = 15;
const TagSize = 16;
const stkSize = 16;
const rounds = 16;
const blockSize = 16;
const tweakSize = 16;
const prefixADBlock = 0x02;
const prefixADFinal = 0x06;
const prefixMsgBlock = 0x00;
const prefixMsgFinal = 0x04;
const prefixTag = 0x01;
const prefixShift = 4;
/**
 * @param {Uint8Array} dst
 * @param {Uint8Array} a
 * @param {Uint8Array} b
 * @param {number} n
 */ function xorBytes(dst, a, b, n) {
    for(let i = 0; i < n; i++)dst[i] = a[i] ^ b[i];
}
//
// TWEAKEY routines
//
const rcons = new Uint8Array([
    0x2f,
    0x5e,
    0xbc,
    0x63,
    0xc6,
    0x97,
    0x35,
    0x6a,
    0xd4,
    0xb3,
    0x7d,
    0xfa,
    0xef,
    0xc5,
    0x91,
    0x39,
    0x72
]);
/**
 * @param {Uint8Array} t
 */ function h(t) {
    const tmp = new Uint8Array([
        t[1],
        t[6],
        t[11],
        t[12],
        t[5],
        t[10],
        t[15],
        t[0],
        t[9],
        t[14],
        t[3],
        t[4],
        t[13],
        t[2],
        t[7],
        t[8]
    ]);
    t.set(tmp);
}
/**
 * @param {Uint8Array} t
 */ function lfsr2(t) {
    for(let i = 0; i < stkSize; i++){
        const x = t[i];
        const x7 = x >> 7;
        const x5 = x >> 5 & 1;
        t[i] = x << 1 | x7 ^ x5;
    }
}
/**
 * @param {Uint8Array} t
 */ function lfsr3(t) {
    for(let i = 0; i < stkSize; i++){
        const x = t[i];
        const x0 = x & 1;
        const x6 = x >> 6 & 1;
        t[i] = x >> 1 | (x0 ^ x6) << 7;
    }
}
/**
 * @param {Uint8Array} t
 * @param {number} i
 */ function xorRC(t, i) {
    t[0] ^= 1;
    t[1] ^= 2;
    t[2] ^= 4;
    t[3] ^= 8;
    t[4] ^= rcons[i];
    t[5] ^= rcons[i];
    t[6] ^= rcons[i];
    t[7] ^= rcons[i];
}
/**
 * @param {Uint8Array} key
 * @param {Uint8Array[]} derivedKs
 */ function stkDeriveK(key, derivedKs) {
    let tk2 = key.subarray(16, 32);
    let tk3 = key.subarray(0, 16);
    xorBytes(derivedKs[0], tk2, tk3, stkSize);
    xorRC(derivedKs[0], 0);
    for(let i = 1; i <= rounds; i++){
        lfsr2(tk2);
        h(tk2);
        lfsr3(tk3);
        h(tk3);
        xorBytes(derivedKs[i], tk2, tk3, stkSize);
        xorRC(derivedKs[i], i);
    }
}
/**
 * @param {Uint8Array[]} stks
 * @param {Uint8Array[]} derivedKs
 * @param {Uint8Array} tweak
 */ function deriveSubTweakKeys(stks, derivedKs, tweak) {
    let tk1 = new Uint8Array(tweak);
    xorBytes(stks[0], derivedKs[0], tk1, stkSize);
    for(let i = 1; i <= rounds; i++){
        h(tk1);
        xorBytes(stks[i], derivedKs[i], tk1, stkSize);
    }
}
function newStks() {
    let stks = [];
    for(let i = 0; i <= rounds; i++)stks.push(new Uint8Array(16));
    return stks;
}
//
// Deoxys-BC-384
//
class implCt32 {
    /**
	 * @param {Uint8Array} ciphertext
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array} tweak
	 * @param {Uint8Array} plaintext
	 */ static bcEncrypt(ciphertext, derivedKs, tweak, plaintext) {
        let stks = newStks();
        deriveSubTweakKeys(stks, derivedKs, tweak);
        let q = aes.newQ(), stk = aes.newQ();
        aes.load4xU32(q, plaintext);
        aes.load4xU32(stk, stks[0]);
        aes.addRoundKey(q, stk);
        for(let i = 1; i <= rounds; i++){
            aes.subBytes(q);
            aes.shiftRows(q);
            aes.mixColumns(q);
            aes.load4xU32(stk, stks[i]);
            aes.addRoundKey(q, stk);
        }
        aes.store4xU32(ciphertext, q);
    }
    /**
	 * @param {Uint8Array} ciphertext
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array[]} tweaks
	 * @param {Uint8Array} nonce
	 */ static bcKeystreamx2(ciphertext, derivedKs, tweaks, nonce) {
        let stks = [
            newStks(),
            newStks()
        ];
        for(let i = 0; i < 2; i++)deriveSubTweakKeys(stks[i], derivedKs, tweaks[i]);
        let q = aes.newQ(), stk = aes.newQ();
        aes.rkeyOrtho(q, nonce);
        aes.load8xU32(stk, stks[0][0], stks[1][0]);
        aes.addRoundKey(q, stk);
        for(let i = 1; i <= rounds; i++){
            aes.subBytes(q);
            aes.shiftRows(q);
            aes.mixColumns(q);
            aes.load8xU32(stk, stks[0][i], stks[1][i]);
            aes.addRoundKey(q, stk);
        }
        aes.store8xU32(ciphertext.subarray(0, 16), ciphertext.subarray(16, 32), q);
    }
    /**
	 * @param {Uint8Array} tag
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array} tweak
	 * @param {Uint8Array} plaintext
	 */ static bcTagx1(tag, derivedKs, tweak, plaintext) {
        let stks = newStks();
        deriveSubTweakKeys(stks, derivedKs, tweak);
        let q = aes.newQ(), stk = aes.newQ();
        aes.load4xU32(q, plaintext);
        aes.load4xU32(stk, stks[0]);
        aes.addRoundKey(q, stk);
        for(let i = 1; i <= rounds; i++){
            aes.subBytes(q);
            aes.shiftRows(q);
            aes.mixColumns(q);
            aes.load4xU32(stk, stks[i]);
            aes.addRoundKey(q, stk);
        }
        const tagView = new DataView(tag.buffer);
        let tag0 = tagView.getUint32(0, true);
        let tag1 = tagView.getUint32(4, true);
        let tag2 = tagView.getUint32(8, true);
        let tag3 = tagView.getUint32(12, true);
        aes.ortho(q);
        tag0 = uint32.xor(tag0, q[0]);
        tag1 = uint32.xor(tag1, q[2]);
        tag2 = uint32.xor(tag2, q[4]);
        tag3 = uint32.xor(tag3, q[6]);
        tagView.setUint32(0, tag0, true);
        tagView.setUint32(4, tag1, true);
        tagView.setUint32(8, tag2, true);
        tagView.setUint32(12, tag3, true);
    }
    /**
	 * @param {Uint8Array} tag
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array[]} tweaks
	 * @param {Uint8Array} plaintext
	 */ static bcTagx2(tag, derivedKs, tweaks, plaintext) {
        let stks = [
            newStks(),
            newStks()
        ];
        for(let i = 0; i < 2; i++)deriveSubTweakKeys(stks[i], derivedKs, tweaks[i]);
        let q = aes.newQ(), stk = aes.newQ();
        aes.load8xU32(q, plaintext.subarray(0, 16), plaintext.subarray(16, 32));
        aes.load8xU32(stk, stks[0][0], stks[1][0]);
        aes.addRoundKey(q, stk);
        for(let i = 1; i <= rounds; i++){
            aes.subBytes(q);
            aes.shiftRows(q);
            aes.mixColumns(q);
            aes.load8xU32(stk, stks[0][i], stks[1][i]);
            aes.addRoundKey(q, stk);
        }
        const tagView = new DataView(tag.buffer);
        let tag0 = tagView.getUint32(0, true);
        let tag1 = tagView.getUint32(4, true);
        let tag2 = tagView.getUint32(8, true);
        let tag3 = tagView.getUint32(12, true);
        aes.ortho(q);
        tag0 = uint32.xor(tag0, q[0], q[1]);
        tag1 = uint32.xor(tag1, q[2], q[3]);
        tag2 = uint32.xor(tag2, q[4], q[5]);
        tag3 = uint32.xor(tag3, q[6], q[7]);
        tagView.setUint32(0, tag0, true);
        tagView.setUint32(4, tag1, true);
        tagView.setUint32(8, tag2, true);
        tagView.setUint32(12, tag3, true);
    }
}
class implUnsafeVartime {
    /**
	 * @param {Uint8Array} ciphertext
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array} tweak
	 * @param {Uint8Array} plaintext
	 */ static bcEncrypt(ciphertext, derivedKs, tweak, plaintext) {
        let stks = newStks();
        deriveSubTweakKeys(stks, derivedKs, tweak);
        const plainView = new DataView(plaintext.buffer);
        let s0 = plainView.getUint32(0 + plaintext.byteOffset, false);
        let s1 = plainView.getUint32(4 + plaintext.byteOffset, false);
        let s2 = plainView.getUint32(8 + plaintext.byteOffset, false);
        let s3 = plainView.getUint32(12 + plaintext.byteOffset, false);
        const stksView = new DataView(stks[0].buffer);
        s0 = uint32.xor(s0, stksView.getUint32(0 + stks[0].byteOffset, false));
        s1 = uint32.xor(s1, stksView.getUint32(4 + stks[0].byteOffset, false));
        s2 = uint32.xor(s2, stksView.getUint32(8 + stks[0].byteOffset, false));
        s3 = uint32.xor(s3, stksView.getUint32(12 + stks[0].byteOffset, false));
        for(let i = 1; i <= rounds; i++)[s0, s1, s2, s3] = unsafe.aesencVartime(s0, s1, s2, s3, stks[i]);
        const cipherView = new DataView(ciphertext.buffer);
        cipherView.setUint32(0 + ciphertext.byteOffset, s0, false);
        cipherView.setUint32(4 + ciphertext.byteOffset, s1, false);
        cipherView.setUint32(8 + ciphertext.byteOffset, s2, false);
        cipherView.setUint32(12 + ciphertext.byteOffset, s3, false);
    }
    /**
	 * @param {Uint8Array} ciphertext
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array[]} tweaks
	 * @param {Uint8Array} nonce
	 */ static bcKeystreamx2(ciphertext, derivedKs, tweaks, nonce) {
        this.bcEncrypt(ciphertext.subarray(0, 16), derivedKs, tweaks[0], nonce);
        this.bcEncrypt(ciphertext.subarray(16, 32), derivedKs, tweaks[1], nonce);
    }
    /**
	 * @param {Uint8Array} tag
	 * @param {Uint8Array[]} derivedKs
	 * @param {Uint8Array} tweak
	 * @param {Uint8Array} plaintext
	 */ static bcTagx1(tag, derivedKs, tweak, plaintext) {
        let tmp = new Uint8Array(blockSize);
        this.bcEncrypt(tmp, derivedKs, tweak, plaintext);
        xorBytes(tag, tag, tmp, blockSize);
    }
    /**
 * @param {Uint8Array} tag
 * @param {Uint8Array[]} derivedKs
 * @param {Uint8Array[]} tweaks
 * @param {Uint8Array} plaintext
 */ static bcTagx2(tag, derivedKs, tweaks, plaintext) {
        let tmp = new Uint8Array(2 * blockSize);
        this.bcEncrypt(tmp.subarray(0, 16), derivedKs, tweaks[0], plaintext.subarray(0, 16));
        this.bcEncrypt(tmp.subarray(16, 32), derivedKs, tweaks[1], plaintext.subarray(16, 32));
        xorBytes(tag, tag, tmp.subarray(0, 16), blockSize);
        xorBytes(tag, tag, tmp.subarray(16, 32), blockSize);
    }
}
//
// Put it all together
//
/**
 * @param {Uint8Array} out
 * @param {number} prefix
 * @param {number} blockNr
 */ function encodeTagTweak(out, prefix, blockNr) {
    out.set(new Uint8Array(12));
    new DataView(out.buffer).setUint32(12 + out.byteOffset, blockNr, false);
    out[0] = prefix << prefixShift;
}
/**
 * @param {Uint8Array} out
 * @param {Uint8Array} tag
 * @param {number} blockNr
 */ function encodeEncTweak(out, tag, blockNr) {
    var tmp = new Uint8Array(4);
    new DataView(tmp.buffer).setUint32(0, blockNr, false);
    out.set(tag);
    out[0] |= 0x80;
    xorBytes(out.subarray(12, 16), out.subarray(12, 16), tmp, 4);
}
function newTweaks() {
    let tweaks = [];
    for(let i = 0; i < 2; i++)tweaks.push(new Uint8Array(tweakSize));
    return tweaks;
}
/**
 * @param {typeof implUnsafeVartime | typeof implCt32} impl
 * @param {Uint8Array[]} derivedKs
 * @param {Uint8Array} nonce
 * @param {Uint8Array} dst
 * @param {Uint8Array} ad
 * @param {Uint8Array} msg
 */ function e(impl, derivedKs, nonce, dst, ad, msg) {
    let tweaks = newTweaks();
    let i = 0, j = 0;
    // Associated data.
    let adLen = ad.length;
    let auth = new Uint8Array(TagSize);
    for(i = 0; adLen >= 2 * blockSize; i += 2){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        encodeTagTweak(tweaks[1], prefixADBlock, i + 1);
        impl.bcTagx2(auth, derivedKs, tweaks, ad.subarray(i * blockSize, (i + 2) * blockSize));
        adLen -= 2 * blockSize;
    }
    for(; adLen >= blockSize; i++){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        impl.bcTagx1(auth, derivedKs, tweaks[0], ad.subarray(i * blockSize, (i + 1) * blockSize));
        adLen -= blockSize;
    }
    if (adLen > 0) {
        encodeTagTweak(tweaks[0], prefixADFinal, i);
        let aStar = new Uint8Array(blockSize);
        aStar.set(ad.subarray(ad.length - adLen));
        aStar[adLen] = 0x80;
        impl.bcTagx1(auth, derivedKs, tweaks[0], aStar);
    }
    // Message authentication and tag generation.
    let msgLen = msg.length;
    for(j = 0; msgLen >= 2 * blockSize; j += 2){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        encodeTagTweak(tweaks[1], prefixMsgBlock, j + 1);
        impl.bcTagx2(auth, derivedKs, tweaks, msg.subarray(j * blockSize, (j + 2) * blockSize));
        msgLen -= 2 * blockSize;
    }
    for(; msgLen >= blockSize; j++){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        impl.bcTagx1(auth, derivedKs, tweaks[0], msg.subarray(j * blockSize, (j + 1) * blockSize));
        msgLen -= blockSize;
    }
    if (msgLen > 0) {
        encodeTagTweak(tweaks[0], prefixMsgFinal, j);
        let mStar = new Uint8Array(blockSize);
        mStar.set(msg.subarray(msg.length - msgLen));
        mStar[msgLen] = 0x80;
        impl.bcTagx1(auth, derivedKs, tweaks[0], mStar);
    }
    // Generate the tag.
    let encNonce = new Uint8Array(blockSize);
    encNonce.set(nonce, 1);
    encNonce[0] = prefixTag << prefixShift;
    impl.bcEncrypt(auth, derivedKs, encNonce, auth);
    // Message encryption.
    encNonce[0] = 0;
    msgLen = msg.length;
    let encBlks = new Uint8Array(2 * blockSize);
    for(j = 0; msgLen >= 2 * blockSize; j += 2){
        encodeEncTweak(tweaks[0], auth, j);
        encodeEncTweak(tweaks[1], auth, j + 1);
        impl.bcKeystreamx2(encBlks, derivedKs, tweaks, encNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 2) * blockSize), msg.subarray(j * blockSize, (j + 2) * blockSize), encBlks, 2 * blockSize);
        msgLen -= 2 * blockSize;
    }
    for(; msgLen >= blockSize; j++){
        encodeEncTweak(tweaks[0], auth, j);
        impl.bcEncrypt(encBlks, derivedKs, tweaks[0], encNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 1) * blockSize), msg.subarray(j * blockSize, (j + 1) * blockSize), encBlks, blockSize);
        msgLen -= blockSize;
    }
    if (msgLen > 0) {
        encodeEncTweak(tweaks[0], auth, j);
        impl.bcEncrypt(encBlks, derivedKs, tweaks[0], encNonce);
        xorBytes(dst.subarray(j * blockSize, msg.length), msg.subarray(j * blockSize), encBlks, msgLen);
    }
    // Write the tag to the tail.
    dst.set(auth, msg.length);
}
/**
 * @param {typeof implUnsafeVartime | typeof implCt32} impl
 * @param {Uint8Array[]} derivedKs
 * @param {Uint8Array} nonce
 * @param {Uint8Array} dst
 * @param {Uint8Array} ad
 * @param {Uint8Array} ct
 */ function d(impl, derivedKs, nonce, dst, ad, ct) {
    let ctLen = ct.length - TagSize;
    const ciphertext = ct.subarray(0, ctLen);
    const tag = ct.subarray(ctLen);
    // Message decryption.
    let j = 0;
    let decTweaks = newTweaks();
    let decNonce = new Uint8Array(blockSize);
    decNonce.set(nonce, 1);
    let decBlks = new Uint8Array(2 * blockSize);
    for(j = 0; ctLen >= 2 * blockSize; j += 2){
        encodeEncTweak(decTweaks[0], tag, j);
        encodeEncTweak(decTweaks[1], tag, j + 1);
        impl.bcKeystreamx2(decBlks, derivedKs, decTweaks, decNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 2) * blockSize), ciphertext.subarray(j * blockSize, (j + 2) * blockSize), decBlks, 2 * blockSize);
        ctLen -= 2 * blockSize;
    }
    for(; ctLen >= blockSize; j++){
        encodeEncTweak(decTweaks[0], tag, j);
        impl.bcEncrypt(decBlks, derivedKs, decTweaks[0], decNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 1) * blockSize), ciphertext.subarray(j * blockSize, (j + 1) * blockSize), decBlks, blockSize);
        ctLen -= blockSize;
    }
    if (ctLen > 0) {
        encodeEncTweak(decTweaks[0], tag, j);
        impl.bcEncrypt(decBlks, derivedKs, decTweaks[0], decNonce);
        xorBytes(dst.subarray(j * blockSize), ciphertext.subarray(j * blockSize), decBlks, ctLen);
    }
    // Associated data.
    let i = 0;
    let adLen = ad.length;
    let tweaks = newTweaks();
    let auth = new Uint8Array(TagSize);
    for(i = 0; adLen >= 2 * blockSize; i += 2){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        encodeTagTweak(tweaks[1], prefixADBlock, i + 1);
        impl.bcTagx2(auth, derivedKs, tweaks, ad.subarray(i * blockSize, (i + 2) * blockSize));
        adLen -= 2 * blockSize;
    }
    for(; adLen >= blockSize; i++){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        impl.bcTagx1(auth, derivedKs, tweaks[0], ad.subarray(i * blockSize, (i + 1) * blockSize));
        adLen -= blockSize;
    }
    if (adLen > 0) {
        encodeTagTweak(tweaks[0], prefixADFinal, i);
        let aStar = new Uint8Array(blockSize);
        aStar.set(ad.subarray(ad.length - adLen));
        aStar[adLen] = 0x80;
        impl.bcTagx1(auth, derivedKs, tweaks[0], aStar);
    }
    // Message authentication and tag generation.
    let msgLen = dst.length;
    for(j = 0; msgLen >= 2 * blockSize; j += 2){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        encodeTagTweak(tweaks[1], prefixMsgBlock, j + 1);
        impl.bcTagx2(auth, derivedKs, tweaks, dst.subarray(j * blockSize, (j + 2) * blockSize));
        msgLen -= 2 * blockSize;
    }
    for(; msgLen >= blockSize; j++){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        impl.bcTagx1(auth, derivedKs, tweaks[0], dst.subarray(j * blockSize, (j + 1) * blockSize));
        msgLen -= blockSize;
    }
    if (msgLen > 0) {
        encodeTagTweak(tweaks[0], prefixMsgFinal, j);
        let mStar = new Uint8Array(blockSize);
        mStar.set(dst.subarray(dst.length - msgLen));
        mStar[msgLen] = 0x80;
        impl.bcTagx1(auth, derivedKs, tweaks[0], mStar);
    }
    decNonce[0] = prefixTag << prefixShift;
    impl.bcEncrypt(auth, derivedKs, decNonce, auth);
    // crypto.timingSafeEqual is not implemented on typed arrays.
    if (auth.length != tag.length) return false;
    let eql = true;
    for(i = 0; i < auth.length; i++)// @ts-expect-error TODO: should this return a boolean
    eql &= !(auth[i] ^ tag[i]);
    return eql;
}
// The AEAD implementation.
//
// As much as possible (as long as the key does not change), instances should
// be reused as deriving the K contribution of the Sub-Tweak Key is relatively
// expensive.
class AEAD {
    /**
	 * @param {Uint8Array} key
	 * @param {boolean} useUnsafeVartime
	 */ constructor(key, useUnsafeVartime = false){
        if (key.length != KeySize) throw ErrKeySize;
        /** @type {typeof implUnsafeVartime | typeof implCt32} */ this.impl = useUnsafeVartime ? implUnsafeVartime : implCt32;
        this.derivedKs = newStks();
        stkDeriveK(key, this.derivedKs);
    }
    /**
	 * @param {Uint8Array} nonce
	 * @param {Uint8Array | null} plaintext
	 * @param {Uint8Array | null} associatedData
	 */ encrypt(nonce, plaintext = null, associatedData = null) {
        if (nonce.length != NonceSize) throw ErrNonceSize;
        if (plaintext == null) plaintext = zeroBuffer;
        if (associatedData == null) associatedData = zeroBuffer;
        let dst = new Uint8Array(plaintext.length + TagSize);
        e(this.impl, this.derivedKs, nonce, dst, associatedData, plaintext);
        return dst;
    }
    /**
	 * @param {Uint8Array} nonce
	 * @param {Uint8Array} ciphertext
	 * @param {Uint8Array | null} associatedData
	 */ decrypt(nonce, ciphertext, associatedData = null) {
        if (nonce.length != NonceSize) throw ErrNonceSize;
        if (ciphertext.length < TagSize) throw ErrOpen;
        if (associatedData == null) associatedData = zeroBuffer;
        let dst = new Uint8Array(ciphertext.length - TagSize);
        if (!d(this.impl, this.derivedKs, nonce, dst, associatedData, ciphertext)) {
            dst.set(new Uint8Array(dst.length));
            throw ErrOpen;
        }
        return dst;
    }
}
const zeroBuffer = new Uint8Array(0);
const ErrKeySize = "deoxysii: invalid key size";
const ErrNonceSize = "deoxysii: invalid nonce size";
const ErrOpen = "deoxysii: message authentication failure";
module.exports = {
    KeySize: KeySize,
    NonceSize: NonceSize,
    TagSize: TagSize,
    ErrNonceSize: ErrNonceSize,
    ErrKeySize: ErrKeySize,
    ErrOpen: ErrOpen,
    AEAD: AEAD
};

},{"683bdf9420c2f4c1":"kI82d","818d62dfbd72fc9b":"a0qda","3d82de62d070f525":"aj0J3"}],"kI82d":[function(require,module,exports) {
// Copyright (c) 2016 Thomas Pornin <pornin@bolet.org>
// Copyright (c) 2017 Yawning Angel <yawning at schwanenlied dot me>
// Copyright (c) 2019 Oasis Labs Inc. <info@oasislabs.com>
//
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
// BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var uint32 = require("eada5fc77202b37e");
const rcon = [
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1B,
    0x36
];
const oddsMask = uint32.fromBytesBigEndian(0x55, 0x55, 0x55, 0x55);
const evensMask = uint32.fromBytesBigEndian(0xaa, 0xaa, 0xaa, 0xaa);
const cl4 = uint32.fromBytesBigEndian(0x33, 0x33, 0x33, 0x33);
const ch4 = uint32.fromBytesBigEndian(0xcc, 0xcc, 0xcc, 0xcc);
const cl8 = uint32.fromBytesBigEndian(0x0f, 0x0f, 0x0f, 0x0f);
const ch8 = uint32.fromBytesBigEndian(0xf0, 0xf0, 0xf0, 0xf0);
const shiftRowsMask0 = uint32.fromBytesBigEndian(0x00, 0x00, 0x00, 0xff);
const shiftRowsMask1 = uint32.fromBytesBigEndian(0x00, 0x00, 0xfc, 0x00);
const shiftRowsMask2 = uint32.fromBytesBigEndian(0x00, 0x00, 0x03, 0x00);
const shiftRowsMask3 = uint32.fromBytesBigEndian(0x00, 0xf0, 0x00, 0x00);
const shiftRowsMask4 = uint32.fromBytesBigEndian(0x00, 0x0f, 0x00, 0x00);
const shiftRowsMask5 = uint32.fromBytesBigEndian(0xc0, 0x00, 0x00, 0x00);
const shiftRowsMask6 = uint32.fromBytesBigEndian(0x3f, 0x00, 0x00, 0x00);
function newQ() {
    return new Uint32Array(8); // q
}
// AddRoundKey
function addRoundKey(q, sk) {
    q[0] = uint32.xor(q[0], sk[0]);
    q[1] = uint32.xor(q[1], sk[1]);
    q[2] = uint32.xor(q[2], sk[2]);
    q[3] = uint32.xor(q[3], sk[3]);
    q[4] = uint32.xor(q[4], sk[4]);
    q[5] = uint32.xor(q[5], sk[5]);
    q[6] = uint32.xor(q[6], sk[6]);
    q[7] = uint32.xor(q[7], sk[7]);
}
// SubBytes
function subBytes(q) {
    // This S-box implementation is a straightforward translation of
    // the circuit described by Boyar and Peralta in "A new
    // combinational logic minimization technique with applications
    // to cryptology" (https://eprint.iacr.org/2009/191.pdf).
    //
    // Note that variables x* (input) and s* (output) are numbered
    // in "reverse" order (x0 is the high bit, x7 is the low bit).
    const x0 = q[7];
    const x1 = q[6];
    const x2 = q[5];
    const x3 = q[4];
    const x4 = q[3];
    const x5 = q[2];
    const x6 = q[1];
    const x7 = q[0];
    //
    // Top linear transformation.
    //
    const y14 = uint32.xor(x3, x5);
    const y13 = uint32.xor(x0, x6);
    const y9 = uint32.xor(x0, x3);
    const y8 = uint32.xor(x0, x5);
    const t0 = uint32.xor(x1, x2);
    const y1 = uint32.xor(t0, x7);
    const y4 = uint32.xor(y1, x3);
    const y12 = uint32.xor(y13, y14);
    const y2 = uint32.xor(y1, x0);
    const y5 = uint32.xor(y1, x6);
    const y3 = uint32.xor(y5, y8);
    const t1 = uint32.xor(x4, y12);
    const y15 = uint32.xor(t1, x5);
    const y20 = uint32.xor(t1, x1);
    const y6 = uint32.xor(y15, x7);
    const y10 = uint32.xor(y15, t0);
    const y11 = uint32.xor(y20, y9);
    const y7 = uint32.xor(x7, y11);
    const y17 = uint32.xor(y10, y11);
    const y19 = uint32.xor(y10, y8);
    const y16 = uint32.xor(t0, y11);
    const y21 = uint32.xor(y13, y16);
    const y18 = uint32.xor(x0, y16);
    //
    // Non-linear section.
    //
    const t2 = uint32.and(y12, y15);
    const t3 = uint32.and(y3, y6);
    const t4 = uint32.xor(t3, t2);
    const t5 = uint32.and(y4, x7);
    const t6 = uint32.xor(t5, t2);
    const t7 = uint32.and(y13, y16);
    const t8 = uint32.and(y5, y1);
    const t9 = uint32.xor(t8, t7);
    const t10 = uint32.and(y2, y7);
    const t11 = uint32.xor(t10, t7);
    const t12 = uint32.and(y9, y11);
    const t13 = uint32.and(y14, y17);
    const t14 = uint32.xor(t13, t12);
    const t15 = uint32.and(y8, y10);
    const t16 = uint32.xor(t15, t12);
    const t17 = uint32.xor(t4, t14);
    const t18 = uint32.xor(t6, t16);
    const t19 = uint32.xor(t9, t14);
    const t20 = uint32.xor(t11, t16);
    const t21 = uint32.xor(t17, y20);
    const t22 = uint32.xor(t18, y19);
    const t23 = uint32.xor(t19, y21);
    const t24 = uint32.xor(t20, y18);
    const t25 = uint32.xor(t21, t22);
    const t26 = uint32.and(t21, t23);
    const t27 = uint32.xor(t24, t26);
    const t28 = uint32.and(t25, t27);
    const t29 = uint32.xor(t28, t22);
    const t30 = uint32.xor(t23, t24);
    const t31 = uint32.xor(t22, t26);
    const t32 = uint32.and(t31, t30);
    const t33 = uint32.xor(t32, t24);
    const t34 = uint32.xor(t23, t33);
    const t35 = uint32.xor(t27, t33);
    const t36 = uint32.and(t24, t35);
    const t37 = uint32.xor(t36, t34);
    const t38 = uint32.xor(t27, t36);
    const t39 = uint32.and(t29, t38);
    const t40 = uint32.xor(t25, t39);
    const t41 = uint32.xor(t40, t37);
    const t42 = uint32.xor(t29, t33);
    const t43 = uint32.xor(t29, t40);
    const t44 = uint32.xor(t33, t37);
    const t45 = uint32.xor(t42, t41);
    const z0 = uint32.and(t44, y15);
    const z1 = uint32.and(t37, y6);
    const z2 = uint32.and(t33, x7);
    const z3 = uint32.and(t43, y16);
    const z4 = uint32.and(t40, y1);
    const z5 = uint32.and(t29, y7);
    const z6 = uint32.and(t42, y11);
    const z7 = uint32.and(t45, y17);
    const z8 = uint32.and(t41, y10);
    const z9 = uint32.and(t44, y12);
    const z10 = uint32.and(t37, y3);
    const z11 = uint32.and(t33, y4);
    const z12 = uint32.and(t43, y13);
    const z13 = uint32.and(t40, y5);
    const z14 = uint32.and(t29, y2);
    const z15 = uint32.and(t42, y9);
    const z16 = uint32.and(t45, y14);
    const z17 = uint32.and(t41, y8);
    //
    // Bottom linear transformation.
    //
    const t46 = uint32.xor(z15, z16);
    const t47 = uint32.xor(z10, z11);
    const t48 = uint32.xor(z5, z13);
    const t49 = uint32.xor(z9, z10);
    const t50 = uint32.xor(z2, z12);
    const t51 = uint32.xor(z2, z5);
    const t52 = uint32.xor(z7, z8);
    const t53 = uint32.xor(z0, z3);
    const t54 = uint32.xor(z6, z7);
    const t55 = uint32.xor(z16, z17);
    const t56 = uint32.xor(z12, t48);
    const t57 = uint32.xor(t50, t53);
    const t58 = uint32.xor(z4, t46);
    const t59 = uint32.xor(z3, t54);
    const t60 = uint32.xor(t46, t57);
    const t61 = uint32.xor(z14, t57);
    const t62 = uint32.xor(t52, t58);
    const t63 = uint32.xor(t49, t58);
    const t64 = uint32.xor(z4, t59);
    const t65 = uint32.xor(t61, t62);
    const t66 = uint32.xor(z1, t63);
    const s0 = uint32.xor(t59, t63);
    const s6 = uint32.xor(t56, uint32.not(t62));
    const s7 = uint32.xor(t48, uint32.not(t60));
    const t67 = uint32.xor(t64, t65);
    const s3 = uint32.xor(t53, t66);
    const s4 = uint32.xor(t51, t66);
    const s5 = uint32.xor(t47, t65);
    const s1 = uint32.xor(t64, uint32.not(s3));
    const s2 = uint32.xor(t55, uint32.not(t67));
    q[7] = s0;
    q[6] = s1;
    q[5] = s2;
    q[4] = s3;
    q[3] = s4;
    q[2] = s5;
    q[1] = s6;
    q[0] = s7;
}
// ShiftRows
function shiftRows(q) {
    for(let i = 0; i < 8; i++){
        const x = q[i];
        q[i] = uint32.or(uint32.and(x, shiftRowsMask0), uint32.shiftRight(uint32.and(x, shiftRowsMask1), 2), uint32.shiftLeft(uint32.and(x, shiftRowsMask2), 6), uint32.shiftRight(uint32.and(x, shiftRowsMask3), 4), uint32.shiftLeft(uint32.and(x, shiftRowsMask4), 4), uint32.shiftRight(uint32.and(x, shiftRowsMask5), 6), uint32.shiftLeft(uint32.and(x, shiftRowsMask6), 2));
    }
}
// MixColumns
function mixColumns(q) {
    const q0 = q[0];
    const q1 = q[1];
    const q2 = q[2];
    const q3 = q[3];
    const q4 = q[4];
    const q5 = q[5];
    const q6 = q[6];
    const q7 = q[7];
    const r0 = uint32.or(uint32.shiftRight(q0, 8), uint32.shiftLeft(q0, 24));
    const r1 = uint32.or(uint32.shiftRight(q1, 8), uint32.shiftLeft(q1, 24));
    const r2 = uint32.or(uint32.shiftRight(q2, 8), uint32.shiftLeft(q2, 24));
    const r3 = uint32.or(uint32.shiftRight(q3, 8), uint32.shiftLeft(q3, 24));
    const r4 = uint32.or(uint32.shiftRight(q4, 8), uint32.shiftLeft(q4, 24));
    const r5 = uint32.or(uint32.shiftRight(q5, 8), uint32.shiftLeft(q5, 24));
    const r6 = uint32.or(uint32.shiftRight(q6, 8), uint32.shiftLeft(q6, 24));
    const r7 = uint32.or(uint32.shiftRight(q7, 8), uint32.shiftLeft(q7, 24));
    q[0] = uint32.xor(q7, r7, r0, uint32.rotateRight(uint32.xor(q0, r0), 16));
    q[1] = uint32.xor(q0, r0, q7, r7, r1, uint32.rotateRight(uint32.xor(q1, r1), 16));
    q[2] = uint32.xor(q1, r1, r2, uint32.rotateRight(uint32.xor(q2, r2), 16));
    q[3] = uint32.xor(q2, r2, q7, r7, r3, uint32.rotateRight(uint32.xor(q3, r3), 16));
    q[4] = uint32.xor(q3, r3, q7, r7, r4, uint32.rotateRight(uint32.xor(q4, r4), 16));
    q[5] = uint32.xor(q4, r4, r5, uint32.rotateRight(uint32.xor(q5, r5), 16));
    q[6] = uint32.xor(q5, r5, r6, uint32.rotateRight(uint32.xor(q6, r6), 16));
    q[7] = uint32.xor(q6, r6, r7, uint32.rotateRight(uint32.xor(q7, r7), 16));
}
function load4xU32(q, src) {
    const srcView = new DataView(src.buffer);
    q[0] = srcView.getUint32(0 + src.byteOffset, true);
    q[2] = srcView.getUint32(4 + src.byteOffset, true);
    q[4] = srcView.getUint32(8 + src.byteOffset, true);
    q[6] = srcView.getUint32(12 + src.byteOffset, true);
    q[1] = 0;
    q[3] = 0;
    q[5] = 0;
    q[7] = 0;
    ortho(q);
}
function load8xU32(q, src0, src1) {
    const src0View = new DataView(src0.buffer);
    const src1View = new DataView(src1.buffer);
    q[0] = src0View.getUint32(0 + src0.byteOffset, true);
    q[2] = src0View.getUint32(4 + src0.byteOffset, true);
    q[4] = src0View.getUint32(8 + src0.byteOffset, true);
    q[6] = src0View.getUint32(12 + src0.byteOffset, true);
    q[1] = src1View.getUint32(0 + src1.byteOffset, true);
    q[3] = src1View.getUint32(4 + src1.byteOffset, true);
    q[5] = src1View.getUint32(8 + src1.byteOffset, true);
    q[7] = src1View.getUint32(12 + src1.byteOffset, true);
    ortho(q);
}
function store4xU32(dst, q) {
    ortho(q);
    const dstView = new DataView(dst.buffer);
    dstView.setUint32(0 + dst.byteOffset, q[0], true);
    dstView.setUint32(4 + dst.byteOffset, q[2], true);
    dstView.setUint32(8 + dst.byteOffset, q[4], true);
    dstView.setUint32(12 + dst.byteOffset, q[6], true);
}
function store8xU32(dst0, dst1, q) {
    ortho(q);
    const dst0View = new DataView(dst0.buffer);
    const dst1View = new DataView(dst1.buffer);
    dst0View.setUint32(0 + dst0.byteOffset, q[0], true);
    dst0View.setUint32(4 + dst0.byteOffset, q[2], true);
    dst0View.setUint32(8 + dst0.byteOffset, q[4], true);
    dst0View.setUint32(12 + dst0.byteOffset, q[6], true);
    dst1View.setUint32(0 + dst1.byteOffset, q[1], true);
    dst1View.setUint32(4 + dst1.byteOffset, q[3], true);
    dst1View.setUint32(8 + dst1.byteOffset, q[5], true);
    dst1View.setUint32(12 + dst1.byteOffset, q[7], true);
}
function ortho(q) {
    for(let i = 0; i < 8; i += 2){
        const q0 = q[i];
        const q1 = q[i + 1];
        q[i] = uint32.or(uint32.and(q0, oddsMask), uint32.shiftLeft(uint32.and(q1, oddsMask), 1));
        q[i + 1] = uint32.or(uint32.shiftRight(uint32.and(q0, evensMask), 1), uint32.and(q1, evensMask));
    }
    for(let i = 0; i < 8; i += 4){
        const q0 = q[i];
        const q1 = q[i + 1];
        const q2 = q[i + 2];
        const q3 = q[i + 3];
        q[i] = uint32.or(uint32.and(q0, cl4), uint32.shiftLeft(uint32.and(q2, cl4), 2));
        q[i + 2] = uint32.or(uint32.shiftRight(uint32.and(q0, ch4), 2), uint32.and(q2, ch4));
        q[i + 1] = uint32.or(uint32.and(q1, cl4), uint32.shiftLeft(uint32.and(q3, cl4), 2));
        q[i + 3] = uint32.or(uint32.shiftRight(uint32.and(q1, ch4), 2), uint32.and(q3, ch4));
    }
    for(let i = 0; i < 4; i++){
        const q0 = q[i];
        const q4 = q[i + 4];
        q[i] = uint32.or(uint32.and(q0, cl8), uint32.shiftLeft(uint32.and(q4, cl8), 4));
        q[i + 4] = uint32.or(uint32.shiftRight(uint32.and(q0, ch8), 4), uint32.and(q4, ch8));
    }
}
function rkeyOrtho(q, key) {
    const keyView = new DataView(key.buffer);
    for(let i = 0; i < 4; i++){
        const x = keyView.getUint32(i * 4 + key.byteOffset, true);
        q[i * 2] = x;
        q[i * 2 + 1] = x;
    }
    ortho(q);
    for(let i = 0, j = 0; i < 4; i = i + 1, j = j + 2){
        let x = uint32.or(uint32.and(q[j + 0], oddsMask), uint32.and(q[j + 1], evensMask));
        let y = x;
        x = uint32.and(x, oddsMask);
        q[j] = uint32.or(x, uint32.shiftLeft(x, 1));
        y = uint32.and(y, evensMask);
        q[j + 1] = uint32.or(y, uint32.shiftRight(y, 1));
    }
}
function skeyExpand(skey, numRounds, compSkey) {
    const n = (numRounds + 1) * 4;
    for(let u = 0, v = 0; u < n; u = u + 1, v = v + 2){
        let x = compSkey[u];
        let y = compSkey[u];
        x = uint32.and(x, oddsMask);
        skey[v] = uint32.or(x, uint32.shiftLeft(x, 1));
        y = uint32.and(y, evensMask);
        skey[v + 1] = uint32.or(y, uint32.shiftRight(y, 1));
    }
}
//
// ECB-AES (example/testing), and associated package private helpers.
//
function _subWord(x) {
    let q = new Uint32Array([
        x,
        x,
        x,
        x,
        x,
        x,
        x,
        x
    ]);
    ortho(q);
    subBytes(q);
    ortho(q);
    return q[0];
}
function keySched(compSkey, key) {
    let numRounds = 0;
    const keyLen = key.byteLength;
    switch(keyLen){
        case 16:
            numRounds = 10;
            break;
        case 24:
            numRounds = 12;
            break;
        case 32:
            numRounds = 14;
            break;
        default:
            throw "aes: invalid key length";
    }
    let skey = new Uint32Array(120);
    let tmp = 0;
    const nk = keyLen / 4;
    const nkf = (numRounds + 1) * 4;
    const keyView = new DataView(key.buffer);
    for(let i = 0; i < nk; i++){
        tmp = keyView.getUint32(i * 4 + key.byteOffset, true);
        skey[i * 2] = tmp;
        skey[i * 2 + 1] = tmp;
    }
    for(let i = nk, j = 0, k = 0; i < nkf; i++){
        if (j == 0) {
            tmp = uint32.or(uint32.shiftLeft(tmp, 24), uint32.shiftRight(tmp, 8));
            tmp = uint32.xor(_subWord(tmp), uint32.fromBytesBigEndian(0x00, 0x00, 0x00, rcon[k]));
        } else if (nk > 6 && j == 4) tmp = _subWord(tmp);
        tmp = uint32.xor(tmp, skey[(i - nk) * 2]);
        skey[i * 2] = tmp;
        skey[i * 2 + 1] = tmp;
        j++;
        if (j == nk) {
            j = 0;
            k++;
        }
    }
    for(let i = 0; i < nkf; i += 4){
        let stmp = skey.slice(i * 2, i * 2 + 8);
        ortho(stmp);
        for(let j = 0; j < 8; j++)skey[i * 2 + j] = stmp[j];
    }
    for(let i = 0, j = 0; i < nkf; i = i + 1, j = j + 2)compSkey[i] = uint32.or(uint32.and(skey[j], oddsMask), uint32.and(skey[j + 1], evensMask));
    return numRounds;
}
function _encrypt(numRounds, skey, q) {
    addRoundKey(q, skey);
    for(let u = 1; u < numRounds; u++){
        subBytes(q);
        shiftRows(q);
        mixColumns(q);
        addRoundKey(q, skey.slice(u * 8, u * 8 + 8));
    }
    subBytes(q);
    shiftRows(q);
    addRoundKey(q, skey.slice(numRounds * 8, numRounds * 8 + 8));
}
class ECB {
    constructor(key){
        let skey = new Uint32Array(60);
        this.numRounds = keySched(skey, key);
        this.skeyExpanded = new Uint32Array(120);
        skeyExpand(this.skeyExpanded, this.numRounds, skey);
    }
    encrypt(dst, src) {
        let q = newQ();
        load4xU32(q, src);
        _encrypt(this.numRounds, this.skeyExpanded, q);
        store4xU32(dst, q);
    }
    encrypt2x(dst0, dst1, src0, src1) {
        let q = newQ();
        load8xU32(q, src0, src1);
        _encrypt(this.numRounds, this.skeyExpanded, q);
        store8xU32(dst0, dst1, q);
    }
}
module.exports = {
    // ECB-AES, probably shouldn't be used for more than testing.
    ECB: ECB,
    // Implementation internals, exposed for the purpose of constructing
    // things based on the AES round function.
    newQ,
    load4xU32,
    load8xU32,
    store4xU32,
    store8xU32,
    ortho,
    rkeyOrtho,
    addRoundKey,
    subBytes,
    shiftRows,
    mixColumns,
    skeyExpand,
    keySched
};

},{"eada5fc77202b37e":"a0qda"}],"a0qda":[function(require,module,exports) {
/* jshint bitwise: false */ /**
 * @license (c) Franz X Antesberger 2013
 */ (function(exporter) {
    "use strict";
    var POW_2_32 = 0x0100000000;
    var POW_2_52 = 0x10000000000000;
    //
    //  Creating and Extracting
    //
    /**
     *  Creates an uint32 from the given bytes in big endian order.
     *  @param {Number} highByte the high byte
     *  @param {Number} secondHighByte the 2nd high byte
     *  @param {Number} thirdHighByte the 3rd high byte
     *  @param {Number} lowByte the low byte
     *  @returns highByte concat secondHighByte concat thirdHighByte concat lowByte
     */ exporter.fromBytesBigEndian = function(highByte, secondHighByte, thirdHighByte, lowByte) {
        return (highByte << 24 | secondHighByte << 16 | thirdHighByte << 8 | lowByte) >>> 0;
    };
    /**
     *  Returns the byte.
     *  e.g. when byteNo is 0, the high byte is returned, when byteNo = 3 the low byte is returned.
     *  @param {Number} uint32value the source to be extracted
     *  @param {Number} byteNo 0-3 the byte number, 0 is the high byte, 3 the low byte
     *  @returns {Number} the 0-255 byte according byteNo
     */ exporter.getByteBigEndian = function(uint32value, byteNo) {
        return uint32value >>> 8 * (3 - byteNo) & 0xff;
    };
    /**
     *  Returns the bytes as array.
     *  @param {Number} uint32value the source to be extracted
     *  @returns {Array} the array [highByte, 2ndHighByte, 3rdHighByte, lowByte]
     */ exporter.getBytesBigEndian = function(uint32value) {
        return [
            exporter.getByteBigEndian(uint32value, 0),
            exporter.getByteBigEndian(uint32value, 1),
            exporter.getByteBigEndian(uint32value, 2),
            exporter.getByteBigEndian(uint32value, 3)
        ];
    };
    /**
     *  Converts a given uin32 to a hex string including leading zeros.
     *  @param {Number} uint32value the uint32 to be stringified
     *  @param {Number} optionalMinLength the optional (default 8)
     */ exporter.toHex = function(uint32value, optionalMinLength) {
        optionalMinLength = optionalMinLength || 8;
        var result = uint32value.toString(16);
        if (result.length < optionalMinLength) result = new Array(optionalMinLength - result.length + 1).join("0") + result;
        return result;
    };
    /**
     *  Converts a number to an uint32.
     *  @param {Number} number the number to be converted.
     *  @return {Number} an uint32 value
     */ exporter.toUint32 = function(number) {
        // the shift operator forces js to perform the internal ToUint32 (see ecmascript spec 9.6)
        return number >>> 0;
    };
    /**
     *  Returns the part above the uint32 border.
     *  Depending to the javascript engine, that are the 54-32 = 22 high bits
     *  @param {Number} number the number to extract the high part
     *  @return {Number} the high part of the number
     */ exporter.highPart = function(number) {
        return exporter.toUint32(number / POW_2_32);
    };
    //
    //  Bitwise Logical Operators
    //
    /**
     *  Returns a bitwise OR operation on two or more values.
     *  @param {Number} uint32val0 first uint32 value
     *  @param {Number} argv one or more uint32 values
     *  @return {Number} the bitwise OR uint32 value
     */ exporter.or = function(uint32val0, argv) {
        var result = uint32val0;
        for(var index = 1; index < arguments.length; index += 1)result = result | arguments[index];
        return result >>> 0;
    };
    /**
     *  Returns a bitwise AND operation on two or more values.
     *  @param {Number} uint32val0 first uint32 value
     *  @param {Number} argv one or more uint32 values
     *  @return {Number} the bitwise AND uint32 value
     */ exporter.and = function(uint32val0, argv) {
        var result = uint32val0;
        for(var index = 1; index < arguments.length; index += 1)result = result & arguments[index];
        return result >>> 0;
    };
    /**
     *  Returns a bitwise XOR operation on two or more values.
     *  @param {Number} uint32val0 first uint32 value
     *  @param {Number} argv one or more uint32 values
     *  @return {Number} the bitwise XOR uint32 value
     */ exporter.xor = function(uint32val0, argv) {
        var result = uint32val0;
        for(var index = 1; index < arguments.length; index += 1)result = result ^ arguments[index];
        return result >>> 0;
    };
    exporter.not = function(uint32val) {
        return ~uint32val >>> 0;
    };
    //
    // Shifting and Rotating
    //
    /**
     *  Returns the uint32 representation of a << operation.
     *  @param {Number} uint32val the word to be shifted
     *  @param {Number} numBits the number of bits to be shifted (0-31)
     *  @returns {Number} the uint32 value of the shifted word
     */ exporter.shiftLeft = function(uint32val, numBits) {
        return uint32val << numBits >>> 0;
    };
    /**
     *  Returns the uint32 representation of a >>> operation.
     *  @param {Number} uint32val the word to be shifted
     *  @param {Number} numBits the number of bits to be shifted (0-31)
     *  @returns {Number} the uint32 value of the shifted word
     */ exporter.shiftRight = function(uint32val, numBits) {
        return uint32val >>> numBits;
    };
    exporter.rotateLeft = function(uint32val, numBits) {
        return (uint32val << numBits >>> 0 | uint32val >>> 32 - numBits) >>> 0;
    };
    exporter.rotateRight = function(uint32val, numBits) {
        return (uint32val >>> numBits | uint32val << 32 - numBits >>> 0) >>> 0;
    };
    //
    // Logical Gates
    //
    /**
     *  Bitwise choose bits from y or z, as a bitwise x ? y : z
     */ exporter.choose = function(x, y, z) {
        return (x & (y ^ z) ^ z) >>> 0;
    };
    /**
     * Majority gate for three parameters. Takes bitwise the majority of x, y and z,
     * @see https://en.wikipedia.org/wiki/Majority_function
     */ exporter.majority = function(x, y, z) {
        return (x & (y | z) | y & z) >>> 0;
    };
    //
    //  Arithmetic
    //
    /**
     *  Adds the given values modulus 2^32.
     *  @returns the sum of the given values modulus 2^32
     */ exporter.addMod32 = function(uint32val0 /*, optionalValues*/ ) {
        var result = uint32val0;
        for(var index = 1; index < arguments.length; index += 1)result += arguments[index];
        return result >>> 0;
    };
    /**
     *  Returns the log base 2 of the given value. That is the number of the highest set bit.
     *  @param {Number} uint32val the value, the log2 is calculated of
     *  @return {Number} the logarithm base 2, an integer between 0 and 31
     */ exporter.log2 = function(uint32val) {
        return Math.floor(Math.log(uint32val) / Math.LN2);
    };
    /*
    // this implementation does the same, looks much funnier, but takes 2 times longer (according to jsperf) ...
    var log2_u = new Uint32Array(2);
    var log2_d = new Float64Array(log2_u.buffer);

    exporter.log2 = function (uint32val) {
        // Ported from http://graphics.stanford.edu/~seander/bithacks.html#IntegerLogIEEE64Float to javascript
        // (public domain)
        if (uint32val === 0) {
            return -Infinity;
        }
        // fill in the low part
        log2_u[0] = uint32val;
        // set the mantissa to 2^52
        log2_u[1] = 0x43300000;
        // subtract 2^52
        log2_d[0] -= 0x10000000000000;
        return (log2_u[1] >>> 20) - 0x3FF;
    };
*/ /**
     *  Returns the the low and the high uint32 of the multiplication.
     *  @param {Number} factor1 an uint32
     *  @param {Number} factor2 an uint32
     *  @param {Uint32Array[2]} resultUint32Array2 the Array, where the result will be written to
     *  @returns undefined
     */ exporter.mult = function(factor1, factor2, resultUint32Array2) {
        var high16 = ((factor1 & 0xffff0000) >>> 0) * factor2;
        var low16 = (factor1 & 0x0000ffff) * factor2;
        // the addition is dangerous, because the result will be rounded, so the result depends on the lowest bits, which will be cut away!
        var carry = exporter.toUint32(high16) + exporter.toUint32(low16) >= POW_2_32 ? 1 : 0;
        resultUint32Array2[0] = exporter.highPart(high16) + exporter.highPart(low16) + carry >>> 0;
        resultUint32Array2[1] = (high16 >>> 0) + (low16 >>> 0); // >>> 0;
    };
})(module.exports = {});

},{}],"aj0J3":[function(require,module,exports) {
// Copyright (c) 2019 Oasis Labs Inc. <info@oasislabs.com>
//
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
// BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
var uint32 = require("6956717946fe9867");
const te0 = new Uint32Array([
    0xc66363a5,
    0xf87c7c84,
    0xee777799,
    0xf67b7b8d,
    0xfff2f20d,
    0xd66b6bbd,
    0xde6f6fb1,
    0x91c5c554,
    0x60303050,
    0x02010103,
    0xce6767a9,
    0x562b2b7d,
    0xe7fefe19,
    0xb5d7d762,
    0x4dababe6,
    0xec76769a,
    0x8fcaca45,
    0x1f82829d,
    0x89c9c940,
    0xfa7d7d87,
    0xeffafa15,
    0xb25959eb,
    0x8e4747c9,
    0xfbf0f00b,
    0x41adadec,
    0xb3d4d467,
    0x5fa2a2fd,
    0x45afafea,
    0x239c9cbf,
    0x53a4a4f7,
    0xe4727296,
    0x9bc0c05b,
    0x75b7b7c2,
    0xe1fdfd1c,
    0x3d9393ae,
    0x4c26266a,
    0x6c36365a,
    0x7e3f3f41,
    0xf5f7f702,
    0x83cccc4f,
    0x6834345c,
    0x51a5a5f4,
    0xd1e5e534,
    0xf9f1f108,
    0xe2717193,
    0xabd8d873,
    0x62313153,
    0x2a15153f,
    0x0804040c,
    0x95c7c752,
    0x46232365,
    0x9dc3c35e,
    0x30181828,
    0x379696a1,
    0x0a05050f,
    0x2f9a9ab5,
    0x0e070709,
    0x24121236,
    0x1b80809b,
    0xdfe2e23d,
    0xcdebeb26,
    0x4e272769,
    0x7fb2b2cd,
    0xea75759f,
    0x1209091b,
    0x1d83839e,
    0x582c2c74,
    0x341a1a2e,
    0x361b1b2d,
    0xdc6e6eb2,
    0xb45a5aee,
    0x5ba0a0fb,
    0xa45252f6,
    0x763b3b4d,
    0xb7d6d661,
    0x7db3b3ce,
    0x5229297b,
    0xdde3e33e,
    0x5e2f2f71,
    0x13848497,
    0xa65353f5,
    0xb9d1d168,
    0x00000000,
    0xc1eded2c,
    0x40202060,
    0xe3fcfc1f,
    0x79b1b1c8,
    0xb65b5bed,
    0xd46a6abe,
    0x8dcbcb46,
    0x67bebed9,
    0x7239394b,
    0x944a4ade,
    0x984c4cd4,
    0xb05858e8,
    0x85cfcf4a,
    0xbbd0d06b,
    0xc5efef2a,
    0x4faaaae5,
    0xedfbfb16,
    0x864343c5,
    0x9a4d4dd7,
    0x66333355,
    0x11858594,
    0x8a4545cf,
    0xe9f9f910,
    0x04020206,
    0xfe7f7f81,
    0xa05050f0,
    0x783c3c44,
    0x259f9fba,
    0x4ba8a8e3,
    0xa25151f3,
    0x5da3a3fe,
    0x804040c0,
    0x058f8f8a,
    0x3f9292ad,
    0x219d9dbc,
    0x70383848,
    0xf1f5f504,
    0x63bcbcdf,
    0x77b6b6c1,
    0xafdada75,
    0x42212163,
    0x20101030,
    0xe5ffff1a,
    0xfdf3f30e,
    0xbfd2d26d,
    0x81cdcd4c,
    0x180c0c14,
    0x26131335,
    0xc3ecec2f,
    0xbe5f5fe1,
    0x359797a2,
    0x884444cc,
    0x2e171739,
    0x93c4c457,
    0x55a7a7f2,
    0xfc7e7e82,
    0x7a3d3d47,
    0xc86464ac,
    0xba5d5de7,
    0x3219192b,
    0xe6737395,
    0xc06060a0,
    0x19818198,
    0x9e4f4fd1,
    0xa3dcdc7f,
    0x44222266,
    0x542a2a7e,
    0x3b9090ab,
    0x0b888883,
    0x8c4646ca,
    0xc7eeee29,
    0x6bb8b8d3,
    0x2814143c,
    0xa7dede79,
    0xbc5e5ee2,
    0x160b0b1d,
    0xaddbdb76,
    0xdbe0e03b,
    0x64323256,
    0x743a3a4e,
    0x140a0a1e,
    0x924949db,
    0x0c06060a,
    0x4824246c,
    0xb85c5ce4,
    0x9fc2c25d,
    0xbdd3d36e,
    0x43acacef,
    0xc46262a6,
    0x399191a8,
    0x319595a4,
    0xd3e4e437,
    0xf279798b,
    0xd5e7e732,
    0x8bc8c843,
    0x6e373759,
    0xda6d6db7,
    0x018d8d8c,
    0xb1d5d564,
    0x9c4e4ed2,
    0x49a9a9e0,
    0xd86c6cb4,
    0xac5656fa,
    0xf3f4f407,
    0xcfeaea25,
    0xca6565af,
    0xf47a7a8e,
    0x47aeaee9,
    0x10080818,
    0x6fbabad5,
    0xf0787888,
    0x4a25256f,
    0x5c2e2e72,
    0x381c1c24,
    0x57a6a6f1,
    0x73b4b4c7,
    0x97c6c651,
    0xcbe8e823,
    0xa1dddd7c,
    0xe874749c,
    0x3e1f1f21,
    0x964b4bdd,
    0x61bdbddc,
    0x0d8b8b86,
    0x0f8a8a85,
    0xe0707090,
    0x7c3e3e42,
    0x71b5b5c4,
    0xcc6666aa,
    0x904848d8,
    0x06030305,
    0xf7f6f601,
    0x1c0e0e12,
    0xc26161a3,
    0x6a35355f,
    0xae5757f9,
    0x69b9b9d0,
    0x17868691,
    0x99c1c158,
    0x3a1d1d27,
    0x279e9eb9,
    0xd9e1e138,
    0xebf8f813,
    0x2b9898b3,
    0x22111133,
    0xd26969bb,
    0xa9d9d970,
    0x078e8e89,
    0x339494a7,
    0x2d9b9bb6,
    0x3c1e1e22,
    0x15878792,
    0xc9e9e920,
    0x87cece49,
    0xaa5555ff,
    0x50282878,
    0xa5dfdf7a,
    0x038c8c8f,
    0x59a1a1f8,
    0x09898980,
    0x1a0d0d17,
    0x65bfbfda,
    0xd7e6e631,
    0x844242c6,
    0xd06868b8,
    0x824141c3,
    0x299999b0,
    0x5a2d2d77,
    0x1e0f0f11,
    0x7bb0b0cb,
    0xa85454fc,
    0x6dbbbbd6,
    0x2c16163a
]);
const te1 = new Uint32Array([
    0xa5c66363,
    0x84f87c7c,
    0x99ee7777,
    0x8df67b7b,
    0x0dfff2f2,
    0xbdd66b6b,
    0xb1de6f6f,
    0x5491c5c5,
    0x50603030,
    0x03020101,
    0xa9ce6767,
    0x7d562b2b,
    0x19e7fefe,
    0x62b5d7d7,
    0xe64dabab,
    0x9aec7676,
    0x458fcaca,
    0x9d1f8282,
    0x4089c9c9,
    0x87fa7d7d,
    0x15effafa,
    0xebb25959,
    0xc98e4747,
    0x0bfbf0f0,
    0xec41adad,
    0x67b3d4d4,
    0xfd5fa2a2,
    0xea45afaf,
    0xbf239c9c,
    0xf753a4a4,
    0x96e47272,
    0x5b9bc0c0,
    0xc275b7b7,
    0x1ce1fdfd,
    0xae3d9393,
    0x6a4c2626,
    0x5a6c3636,
    0x417e3f3f,
    0x02f5f7f7,
    0x4f83cccc,
    0x5c683434,
    0xf451a5a5,
    0x34d1e5e5,
    0x08f9f1f1,
    0x93e27171,
    0x73abd8d8,
    0x53623131,
    0x3f2a1515,
    0x0c080404,
    0x5295c7c7,
    0x65462323,
    0x5e9dc3c3,
    0x28301818,
    0xa1379696,
    0x0f0a0505,
    0xb52f9a9a,
    0x090e0707,
    0x36241212,
    0x9b1b8080,
    0x3ddfe2e2,
    0x26cdebeb,
    0x694e2727,
    0xcd7fb2b2,
    0x9fea7575,
    0x1b120909,
    0x9e1d8383,
    0x74582c2c,
    0x2e341a1a,
    0x2d361b1b,
    0xb2dc6e6e,
    0xeeb45a5a,
    0xfb5ba0a0,
    0xf6a45252,
    0x4d763b3b,
    0x61b7d6d6,
    0xce7db3b3,
    0x7b522929,
    0x3edde3e3,
    0x715e2f2f,
    0x97138484,
    0xf5a65353,
    0x68b9d1d1,
    0x00000000,
    0x2cc1eded,
    0x60402020,
    0x1fe3fcfc,
    0xc879b1b1,
    0xedb65b5b,
    0xbed46a6a,
    0x468dcbcb,
    0xd967bebe,
    0x4b723939,
    0xde944a4a,
    0xd4984c4c,
    0xe8b05858,
    0x4a85cfcf,
    0x6bbbd0d0,
    0x2ac5efef,
    0xe54faaaa,
    0x16edfbfb,
    0xc5864343,
    0xd79a4d4d,
    0x55663333,
    0x94118585,
    0xcf8a4545,
    0x10e9f9f9,
    0x06040202,
    0x81fe7f7f,
    0xf0a05050,
    0x44783c3c,
    0xba259f9f,
    0xe34ba8a8,
    0xf3a25151,
    0xfe5da3a3,
    0xc0804040,
    0x8a058f8f,
    0xad3f9292,
    0xbc219d9d,
    0x48703838,
    0x04f1f5f5,
    0xdf63bcbc,
    0xc177b6b6,
    0x75afdada,
    0x63422121,
    0x30201010,
    0x1ae5ffff,
    0x0efdf3f3,
    0x6dbfd2d2,
    0x4c81cdcd,
    0x14180c0c,
    0x35261313,
    0x2fc3ecec,
    0xe1be5f5f,
    0xa2359797,
    0xcc884444,
    0x392e1717,
    0x5793c4c4,
    0xf255a7a7,
    0x82fc7e7e,
    0x477a3d3d,
    0xacc86464,
    0xe7ba5d5d,
    0x2b321919,
    0x95e67373,
    0xa0c06060,
    0x98198181,
    0xd19e4f4f,
    0x7fa3dcdc,
    0x66442222,
    0x7e542a2a,
    0xab3b9090,
    0x830b8888,
    0xca8c4646,
    0x29c7eeee,
    0xd36bb8b8,
    0x3c281414,
    0x79a7dede,
    0xe2bc5e5e,
    0x1d160b0b,
    0x76addbdb,
    0x3bdbe0e0,
    0x56643232,
    0x4e743a3a,
    0x1e140a0a,
    0xdb924949,
    0x0a0c0606,
    0x6c482424,
    0xe4b85c5c,
    0x5d9fc2c2,
    0x6ebdd3d3,
    0xef43acac,
    0xa6c46262,
    0xa8399191,
    0xa4319595,
    0x37d3e4e4,
    0x8bf27979,
    0x32d5e7e7,
    0x438bc8c8,
    0x596e3737,
    0xb7da6d6d,
    0x8c018d8d,
    0x64b1d5d5,
    0xd29c4e4e,
    0xe049a9a9,
    0xb4d86c6c,
    0xfaac5656,
    0x07f3f4f4,
    0x25cfeaea,
    0xafca6565,
    0x8ef47a7a,
    0xe947aeae,
    0x18100808,
    0xd56fbaba,
    0x88f07878,
    0x6f4a2525,
    0x725c2e2e,
    0x24381c1c,
    0xf157a6a6,
    0xc773b4b4,
    0x5197c6c6,
    0x23cbe8e8,
    0x7ca1dddd,
    0x9ce87474,
    0x213e1f1f,
    0xdd964b4b,
    0xdc61bdbd,
    0x860d8b8b,
    0x850f8a8a,
    0x90e07070,
    0x427c3e3e,
    0xc471b5b5,
    0xaacc6666,
    0xd8904848,
    0x05060303,
    0x01f7f6f6,
    0x121c0e0e,
    0xa3c26161,
    0x5f6a3535,
    0xf9ae5757,
    0xd069b9b9,
    0x91178686,
    0x5899c1c1,
    0x273a1d1d,
    0xb9279e9e,
    0x38d9e1e1,
    0x13ebf8f8,
    0xb32b9898,
    0x33221111,
    0xbbd26969,
    0x70a9d9d9,
    0x89078e8e,
    0xa7339494,
    0xb62d9b9b,
    0x223c1e1e,
    0x92158787,
    0x20c9e9e9,
    0x4987cece,
    0xffaa5555,
    0x78502828,
    0x7aa5dfdf,
    0x8f038c8c,
    0xf859a1a1,
    0x80098989,
    0x171a0d0d,
    0xda65bfbf,
    0x31d7e6e6,
    0xc6844242,
    0xb8d06868,
    0xc3824141,
    0xb0299999,
    0x775a2d2d,
    0x111e0f0f,
    0xcb7bb0b0,
    0xfca85454,
    0xd66dbbbb,
    0x3a2c1616
]);
const te2 = new Uint32Array([
    0x63a5c663,
    0x7c84f87c,
    0x7799ee77,
    0x7b8df67b,
    0xf20dfff2,
    0x6bbdd66b,
    0x6fb1de6f,
    0xc55491c5,
    0x30506030,
    0x01030201,
    0x67a9ce67,
    0x2b7d562b,
    0xfe19e7fe,
    0xd762b5d7,
    0xabe64dab,
    0x769aec76,
    0xca458fca,
    0x829d1f82,
    0xc94089c9,
    0x7d87fa7d,
    0xfa15effa,
    0x59ebb259,
    0x47c98e47,
    0xf00bfbf0,
    0xadec41ad,
    0xd467b3d4,
    0xa2fd5fa2,
    0xafea45af,
    0x9cbf239c,
    0xa4f753a4,
    0x7296e472,
    0xc05b9bc0,
    0xb7c275b7,
    0xfd1ce1fd,
    0x93ae3d93,
    0x266a4c26,
    0x365a6c36,
    0x3f417e3f,
    0xf702f5f7,
    0xcc4f83cc,
    0x345c6834,
    0xa5f451a5,
    0xe534d1e5,
    0xf108f9f1,
    0x7193e271,
    0xd873abd8,
    0x31536231,
    0x153f2a15,
    0x040c0804,
    0xc75295c7,
    0x23654623,
    0xc35e9dc3,
    0x18283018,
    0x96a13796,
    0x050f0a05,
    0x9ab52f9a,
    0x07090e07,
    0x12362412,
    0x809b1b80,
    0xe23ddfe2,
    0xeb26cdeb,
    0x27694e27,
    0xb2cd7fb2,
    0x759fea75,
    0x091b1209,
    0x839e1d83,
    0x2c74582c,
    0x1a2e341a,
    0x1b2d361b,
    0x6eb2dc6e,
    0x5aeeb45a,
    0xa0fb5ba0,
    0x52f6a452,
    0x3b4d763b,
    0xd661b7d6,
    0xb3ce7db3,
    0x297b5229,
    0xe33edde3,
    0x2f715e2f,
    0x84971384,
    0x53f5a653,
    0xd168b9d1,
    0x00000000,
    0xed2cc1ed,
    0x20604020,
    0xfc1fe3fc,
    0xb1c879b1,
    0x5bedb65b,
    0x6abed46a,
    0xcb468dcb,
    0xbed967be,
    0x394b7239,
    0x4ade944a,
    0x4cd4984c,
    0x58e8b058,
    0xcf4a85cf,
    0xd06bbbd0,
    0xef2ac5ef,
    0xaae54faa,
    0xfb16edfb,
    0x43c58643,
    0x4dd79a4d,
    0x33556633,
    0x85941185,
    0x45cf8a45,
    0xf910e9f9,
    0x02060402,
    0x7f81fe7f,
    0x50f0a050,
    0x3c44783c,
    0x9fba259f,
    0xa8e34ba8,
    0x51f3a251,
    0xa3fe5da3,
    0x40c08040,
    0x8f8a058f,
    0x92ad3f92,
    0x9dbc219d,
    0x38487038,
    0xf504f1f5,
    0xbcdf63bc,
    0xb6c177b6,
    0xda75afda,
    0x21634221,
    0x10302010,
    0xff1ae5ff,
    0xf30efdf3,
    0xd26dbfd2,
    0xcd4c81cd,
    0x0c14180c,
    0x13352613,
    0xec2fc3ec,
    0x5fe1be5f,
    0x97a23597,
    0x44cc8844,
    0x17392e17,
    0xc45793c4,
    0xa7f255a7,
    0x7e82fc7e,
    0x3d477a3d,
    0x64acc864,
    0x5de7ba5d,
    0x192b3219,
    0x7395e673,
    0x60a0c060,
    0x81981981,
    0x4fd19e4f,
    0xdc7fa3dc,
    0x22664422,
    0x2a7e542a,
    0x90ab3b90,
    0x88830b88,
    0x46ca8c46,
    0xee29c7ee,
    0xb8d36bb8,
    0x143c2814,
    0xde79a7de,
    0x5ee2bc5e,
    0x0b1d160b,
    0xdb76addb,
    0xe03bdbe0,
    0x32566432,
    0x3a4e743a,
    0x0a1e140a,
    0x49db9249,
    0x060a0c06,
    0x246c4824,
    0x5ce4b85c,
    0xc25d9fc2,
    0xd36ebdd3,
    0xacef43ac,
    0x62a6c462,
    0x91a83991,
    0x95a43195,
    0xe437d3e4,
    0x798bf279,
    0xe732d5e7,
    0xc8438bc8,
    0x37596e37,
    0x6db7da6d,
    0x8d8c018d,
    0xd564b1d5,
    0x4ed29c4e,
    0xa9e049a9,
    0x6cb4d86c,
    0x56faac56,
    0xf407f3f4,
    0xea25cfea,
    0x65afca65,
    0x7a8ef47a,
    0xaee947ae,
    0x08181008,
    0xbad56fba,
    0x7888f078,
    0x256f4a25,
    0x2e725c2e,
    0x1c24381c,
    0xa6f157a6,
    0xb4c773b4,
    0xc65197c6,
    0xe823cbe8,
    0xdd7ca1dd,
    0x749ce874,
    0x1f213e1f,
    0x4bdd964b,
    0xbddc61bd,
    0x8b860d8b,
    0x8a850f8a,
    0x7090e070,
    0x3e427c3e,
    0xb5c471b5,
    0x66aacc66,
    0x48d89048,
    0x03050603,
    0xf601f7f6,
    0x0e121c0e,
    0x61a3c261,
    0x355f6a35,
    0x57f9ae57,
    0xb9d069b9,
    0x86911786,
    0xc15899c1,
    0x1d273a1d,
    0x9eb9279e,
    0xe138d9e1,
    0xf813ebf8,
    0x98b32b98,
    0x11332211,
    0x69bbd269,
    0xd970a9d9,
    0x8e89078e,
    0x94a73394,
    0x9bb62d9b,
    0x1e223c1e,
    0x87921587,
    0xe920c9e9,
    0xce4987ce,
    0x55ffaa55,
    0x28785028,
    0xdf7aa5df,
    0x8c8f038c,
    0xa1f859a1,
    0x89800989,
    0x0d171a0d,
    0xbfda65bf,
    0xe631d7e6,
    0x42c68442,
    0x68b8d068,
    0x41c38241,
    0x99b02999,
    0x2d775a2d,
    0x0f111e0f,
    0xb0cb7bb0,
    0x54fca854,
    0xbbd66dbb,
    0x163a2c16
]);
const te3 = new Uint32Array([
    0x6363a5c6,
    0x7c7c84f8,
    0x777799ee,
    0x7b7b8df6,
    0xf2f20dff,
    0x6b6bbdd6,
    0x6f6fb1de,
    0xc5c55491,
    0x30305060,
    0x01010302,
    0x6767a9ce,
    0x2b2b7d56,
    0xfefe19e7,
    0xd7d762b5,
    0xababe64d,
    0x76769aec,
    0xcaca458f,
    0x82829d1f,
    0xc9c94089,
    0x7d7d87fa,
    0xfafa15ef,
    0x5959ebb2,
    0x4747c98e,
    0xf0f00bfb,
    0xadadec41,
    0xd4d467b3,
    0xa2a2fd5f,
    0xafafea45,
    0x9c9cbf23,
    0xa4a4f753,
    0x727296e4,
    0xc0c05b9b,
    0xb7b7c275,
    0xfdfd1ce1,
    0x9393ae3d,
    0x26266a4c,
    0x36365a6c,
    0x3f3f417e,
    0xf7f702f5,
    0xcccc4f83,
    0x34345c68,
    0xa5a5f451,
    0xe5e534d1,
    0xf1f108f9,
    0x717193e2,
    0xd8d873ab,
    0x31315362,
    0x15153f2a,
    0x04040c08,
    0xc7c75295,
    0x23236546,
    0xc3c35e9d,
    0x18182830,
    0x9696a137,
    0x05050f0a,
    0x9a9ab52f,
    0x0707090e,
    0x12123624,
    0x80809b1b,
    0xe2e23ddf,
    0xebeb26cd,
    0x2727694e,
    0xb2b2cd7f,
    0x75759fea,
    0x09091b12,
    0x83839e1d,
    0x2c2c7458,
    0x1a1a2e34,
    0x1b1b2d36,
    0x6e6eb2dc,
    0x5a5aeeb4,
    0xa0a0fb5b,
    0x5252f6a4,
    0x3b3b4d76,
    0xd6d661b7,
    0xb3b3ce7d,
    0x29297b52,
    0xe3e33edd,
    0x2f2f715e,
    0x84849713,
    0x5353f5a6,
    0xd1d168b9,
    0x00000000,
    0xeded2cc1,
    0x20206040,
    0xfcfc1fe3,
    0xb1b1c879,
    0x5b5bedb6,
    0x6a6abed4,
    0xcbcb468d,
    0xbebed967,
    0x39394b72,
    0x4a4ade94,
    0x4c4cd498,
    0x5858e8b0,
    0xcfcf4a85,
    0xd0d06bbb,
    0xefef2ac5,
    0xaaaae54f,
    0xfbfb16ed,
    0x4343c586,
    0x4d4dd79a,
    0x33335566,
    0x85859411,
    0x4545cf8a,
    0xf9f910e9,
    0x02020604,
    0x7f7f81fe,
    0x5050f0a0,
    0x3c3c4478,
    0x9f9fba25,
    0xa8a8e34b,
    0x5151f3a2,
    0xa3a3fe5d,
    0x4040c080,
    0x8f8f8a05,
    0x9292ad3f,
    0x9d9dbc21,
    0x38384870,
    0xf5f504f1,
    0xbcbcdf63,
    0xb6b6c177,
    0xdada75af,
    0x21216342,
    0x10103020,
    0xffff1ae5,
    0xf3f30efd,
    0xd2d26dbf,
    0xcdcd4c81,
    0x0c0c1418,
    0x13133526,
    0xecec2fc3,
    0x5f5fe1be,
    0x9797a235,
    0x4444cc88,
    0x1717392e,
    0xc4c45793,
    0xa7a7f255,
    0x7e7e82fc,
    0x3d3d477a,
    0x6464acc8,
    0x5d5de7ba,
    0x19192b32,
    0x737395e6,
    0x6060a0c0,
    0x81819819,
    0x4f4fd19e,
    0xdcdc7fa3,
    0x22226644,
    0x2a2a7e54,
    0x9090ab3b,
    0x8888830b,
    0x4646ca8c,
    0xeeee29c7,
    0xb8b8d36b,
    0x14143c28,
    0xdede79a7,
    0x5e5ee2bc,
    0x0b0b1d16,
    0xdbdb76ad,
    0xe0e03bdb,
    0x32325664,
    0x3a3a4e74,
    0x0a0a1e14,
    0x4949db92,
    0x06060a0c,
    0x24246c48,
    0x5c5ce4b8,
    0xc2c25d9f,
    0xd3d36ebd,
    0xacacef43,
    0x6262a6c4,
    0x9191a839,
    0x9595a431,
    0xe4e437d3,
    0x79798bf2,
    0xe7e732d5,
    0xc8c8438b,
    0x3737596e,
    0x6d6db7da,
    0x8d8d8c01,
    0xd5d564b1,
    0x4e4ed29c,
    0xa9a9e049,
    0x6c6cb4d8,
    0x5656faac,
    0xf4f407f3,
    0xeaea25cf,
    0x6565afca,
    0x7a7a8ef4,
    0xaeaee947,
    0x08081810,
    0xbabad56f,
    0x787888f0,
    0x25256f4a,
    0x2e2e725c,
    0x1c1c2438,
    0xa6a6f157,
    0xb4b4c773,
    0xc6c65197,
    0xe8e823cb,
    0xdddd7ca1,
    0x74749ce8,
    0x1f1f213e,
    0x4b4bdd96,
    0xbdbddc61,
    0x8b8b860d,
    0x8a8a850f,
    0x707090e0,
    0x3e3e427c,
    0xb5b5c471,
    0x6666aacc,
    0x4848d890,
    0x03030506,
    0xf6f601f7,
    0x0e0e121c,
    0x6161a3c2,
    0x35355f6a,
    0x5757f9ae,
    0xb9b9d069,
    0x86869117,
    0xc1c15899,
    0x1d1d273a,
    0x9e9eb927,
    0xe1e138d9,
    0xf8f813eb,
    0x9898b32b,
    0x11113322,
    0x6969bbd2,
    0xd9d970a9,
    0x8e8e8907,
    0x9494a733,
    0x9b9bb62d,
    0x1e1e223c,
    0x87879215,
    0xe9e920c9,
    0xcece4987,
    0x5555ffaa,
    0x28287850,
    0xdfdf7aa5,
    0x8c8c8f03,
    0xa1a1f859,
    0x89898009,
    0x0d0d171a,
    0xbfbfda65,
    0xe6e631d7,
    0x4242c684,
    0x6868b8d0,
    0x4141c382,
    0x9999b029,
    0x2d2d775a,
    0x0f0f111e,
    0xb0b0cb7b,
    0x5454fca8,
    0xbbbbd66d,
    0x16163a2c
]);
const andMask = uint32.fromBytesBigEndian(0x00, 0x00, 0x00, 0xff);
function aesencVartime(s0, s1, s2, s3, roundKey) {
    const rkView = new DataView(roundKey.buffer);
    const rk0 = rkView.getUint32(0 + roundKey.byteOffset, false);
    const rk1 = rkView.getUint32(4 + roundKey.byteOffset, false);
    const rk2 = rkView.getUint32(8 + roundKey.byteOffset, false);
    const rk3 = rkView.getUint32(12 + roundKey.byteOffset, false);
    const t0 = uint32.xor(te0[uint32.and(uint32.shiftRight(s0, 24), andMask)], te1[uint32.and(uint32.shiftRight(s1, 16), andMask)], te2[uint32.and(uint32.shiftRight(s2, 8), andMask)], te3[uint32.and(s3, andMask)], rk0);
    const t1 = uint32.xor(te0[uint32.and(uint32.shiftRight(s1, 24), andMask)], te1[uint32.and(uint32.shiftRight(s2, 16), andMask)], te2[uint32.and(uint32.shiftRight(s3, 8), andMask)], te3[uint32.and(s0, andMask)], rk1);
    const t2 = uint32.xor(te0[uint32.and(uint32.shiftRight(s2, 24), andMask)], te1[uint32.and(uint32.shiftRight(s3, 16), andMask)], te2[uint32.and(uint32.shiftRight(s0, 8), andMask)], te3[uint32.and(s1, andMask)], rk2);
    const t3 = uint32.xor(te0[uint32.and(uint32.shiftRight(s3, 24), andMask)], te1[uint32.and(uint32.shiftRight(s0, 16), andMask)], te2[uint32.and(uint32.shiftRight(s1, 8), andMask)], te3[uint32.and(s2, andMask)], rk3);
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
module.exports = {
    aesencVartime
};

},{"6956717946fe9867":"a0qda"}],"2Bpdt":[function(require,module,exports) {
var global = arguments[3];
var process = require("9f5c61be6bd9c67a");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295;
function oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}
var Buffer = require("caff9346743c214e").Buffer;
var crypto = global.crypto || global.msCrypto;
if (crypto && crypto.getRandomValues) module.exports = randomBytes;
else module.exports = oldBrowser;
function randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES));
        else crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return process.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

},{"9f5c61be6bd9c67a":"cSDX6","caff9346743c214e":"gN0J8"}],"gN0J8":[function(require,module,exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"eHuUs"}],"8Lo5H":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.boxOpen = exports.boxSeal = exports.deriveSymmetricKey = void 0;
const deoxysii = require("32081e697c14c0a3");
const js_sha512_1 = require("1c8ae92b94406c8b");
const nacl = require("ea61341b4ac7c9cf");
const BOX_KDF_TWEAK = "MRAE_Box_Deoxys-II-256-128";
/**
 * deriveSymmetricKey derives a MRAE AEAD symmetric key suitable for use with the asymmetric
 * box primitives from the provided X25519 public and private keys.
 */ function deriveSymmetricKey(publicKey, privateKey) {
    const pmk = nacl.scalarMult(privateKey, publicKey);
    var kdf = js_sha512_1.sha512_256.hmac.create(BOX_KDF_TWEAK);
    kdf.update(pmk);
    return new Uint8Array(kdf.arrayBuffer());
}
exports.deriveSymmetricKey = deriveSymmetricKey;
/**
 * boxSeal boxes ("seals") the provided additional data and plaintext via
 * Deoxys-II-256-128 using a symmetric key derived from the provided
 * X25519 public and private keys.
 */ function boxSeal(nonce, plainText, associateData, publicKey, privateKey) {
    const sharedKey = deriveSymmetricKey(publicKey, privateKey);
    var aead = new deoxysii.AEAD(sharedKey);
    return aead.encrypt(nonce, plainText, associateData);
}
exports.boxSeal = boxSeal;
/**
 * boxOpen unboxes ("opens") the provided additional data and plaintext via
 * Deoxys-II-256-128 using a symmetric key derived from the provided
 * X25519 public and private keys.
 */ function boxOpen(nonce, ciperText, associateData, publicKey, privateKey) {
    const sharedKey = deriveSymmetricKey(publicKey, privateKey);
    var aead = new deoxysii.AEAD(sharedKey);
    return aead.decrypt(nonce, ciperText, associateData);
}
exports.boxOpen = boxOpen;

},{"32081e697c14c0a3":"e0VtN","1c8ae92b94406c8b":"9yOC0","ea61341b4ac7c9cf":"dbRqa"}],"e5B7O":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.METHOD_PARAMETERS = exports.ERR_AMOUNT_NOT_REPRESENTABLE_CODE = exports.ERR_CONSENSUS_INCOMPATIBLE_SIGNER_CODE = exports.ERR_INTERNAL_STATE_ERROR_CODE = exports.ERR_INVALID_DENOMINATION_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("cbf0dd0b30accf9d");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "consensus";
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_INVALID_DENOMINATION_CODE = 2;
exports.ERR_INTERNAL_STATE_ERROR_CODE = 3;
exports.ERR_CONSENSUS_INCOMPATIBLE_SIGNER_CODE = 4;
exports.ERR_AMOUNT_NOT_REPRESENTABLE_CODE = 5;
// Queries.
exports.METHOD_PARAMETERS = "consensus.Parameters";
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    queryAccount() {
        return this.query(exports.METHOD_PARAMETERS);
    }
}
exports.Wrapper = Wrapper;

},{"cbf0dd0b30accf9d":"87MgA"}],"es2VV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moduleEventHandler = exports.Wrapper = exports.EVENT_WITHDRAW_CODE = exports.EVENT_DEPOSIT_CODE = exports.METHOD_ACCOUNT = exports.METHOD_BALANCE = exports.METHOD_WITHDRAW = exports.METHOD_DEPOSIT = exports.ERR_INSUFFICIENT_WITHDRAW_BALANCE_CODE = exports.ERR_INVALID_DENOMINATION_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("5a631a626d658c0a");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "consensus_accounts";
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_INVALID_DENOMINATION_CODE = 2;
exports.ERR_INSUFFICIENT_WITHDRAW_BALANCE_CODE = 3;
// Callable methods.
exports.METHOD_DEPOSIT = "consensus.Deposit";
exports.METHOD_WITHDRAW = "consensus.Withdraw";
// Queries.
exports.METHOD_BALANCE = "consensus.Balance";
exports.METHOD_ACCOUNT = "consensus.Account";
// Events.
exports.EVENT_DEPOSIT_CODE = 1;
exports.EVENT_WITHDRAW_CODE = 2;
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callDeposit() {
        return this.call(exports.METHOD_DEPOSIT);
    }
    callWithdraw() {
        return this.call(exports.METHOD_WITHDRAW);
    }
    queryBalance() {
        return this.query(exports.METHOD_BALANCE);
    }
    queryAccount() {
        return this.query(exports.METHOD_ACCOUNT);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}
exports.moduleEventHandler = moduleEventHandler;

},{"5a631a626d658c0a":"87MgA"}],"dPU3h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.PUBLIC_KEY_KIND_TRANSACTION = exports.STORE_KIND_CONFIDENTIAL = exports.STORE_KIND_PUBLIC = exports.METHOD_CUSTOM = exports.METHOD_PUBLIC_KEY = exports.METHOD_INSTANCE_RAW_STORAGE = exports.METHOD_INSTANCE_STORAGE = exports.METHOD_INSTANCE = exports.METHOD_CODE_STORAGE = exports.METHOD_CODE = exports.METHOD_CHANGE_UPGRADE_POLICY = exports.METHOD_UPGRADE = exports.METHOD_CALL = exports.METHOD_INSTANTIATE = exports.METHOD_UPLOAD = exports.ERR_CODE_ALREADY_UPGRADED_CODE = exports.ERR_TOO_MANY_SUBCALLS_CODE = exports.ERR_RESULT_TOO_LARGE_CODE = exports.ERR_CALL_DEPTH_EXCEEDED_CODE = exports.ERR_INSUFFICIENT_CALLER_BALANCE_CODE = exports.ERR_UNSUPPORTED_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_EXECUTION_FAILED_CODE = exports.ERR_MODULE_LOADING_FAILED_CODE = exports.ERR_INSTANCE_NOT_FOUND_CODE = exports.ERR_CODE_NOT_FOUND_CODE = exports.ERR_CODE_DECLARES_TOO_MANY_MEMORIES_CODE = exports.ERR_CODE_DECLARES_START_FUNCTION_CODE = exports.ERR_CODE_DECLARES_RESERVED_EXPORT_CODE = exports.ERR_CODE_MISSING_REQUIRED_EXPORT_CODE = exports.ERR_UNSUPPORTED_ABI_CODE = exports.ERR_CODE_MALFORMED_CODE = exports.ERR_CODE_TOO_LARGE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("2b4bb6e4d8250eb6");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "contracts";
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_CODE_TOO_LARGE_CODE = 2;
exports.ERR_CODE_MALFORMED_CODE = 3;
exports.ERR_UNSUPPORTED_ABI_CODE = 4;
exports.ERR_CODE_MISSING_REQUIRED_EXPORT_CODE = 5;
exports.ERR_CODE_DECLARES_RESERVED_EXPORT_CODE = 6;
exports.ERR_CODE_DECLARES_START_FUNCTION_CODE = 7;
exports.ERR_CODE_DECLARES_TOO_MANY_MEMORIES_CODE = 8;
exports.ERR_CODE_NOT_FOUND_CODE = 9;
exports.ERR_INSTANCE_NOT_FOUND_CODE = 10;
exports.ERR_MODULE_LOADING_FAILED_CODE = 11;
exports.ERR_EXECUTION_FAILED_CODE = 12;
exports.ERR_FORBIDDEN_CODE = 13;
exports.ERR_UNSUPPORTED_CODE = 14;
exports.ERR_INSUFFICIENT_CALLER_BALANCE_CODE = 15;
exports.ERR_CALL_DEPTH_EXCEEDED_CODE = 16;
exports.ERR_RESULT_TOO_LARGE_CODE = 17;
exports.ERR_TOO_MANY_SUBCALLS_CODE = 18;
exports.ERR_CODE_ALREADY_UPGRADED_CODE = 19;
// Callable methods.
exports.METHOD_UPLOAD = "contracts.Upload";
exports.METHOD_INSTANTIATE = "contracts.Instantiate";
exports.METHOD_CALL = "contracts.Call";
exports.METHOD_UPGRADE = "contracts.Upgrade";
exports.METHOD_CHANGE_UPGRADE_POLICY = "contracts.ChangeUpgradePolicy";
// Queries.
exports.METHOD_CODE = "contracts.Code";
exports.METHOD_CODE_STORAGE = "contracts.CodeStorage";
exports.METHOD_INSTANCE = "contracts.Instance";
exports.METHOD_INSTANCE_STORAGE = "contracts.InstanceStorage";
exports.METHOD_INSTANCE_RAW_STORAGE = "contracts.InstanceRawStorage";
exports.METHOD_PUBLIC_KEY = "contracts.PublicKey";
exports.METHOD_CUSTOM = "contracts.Custom";
// Store kind.
exports.STORE_KIND_PUBLIC = 0;
exports.STORE_KIND_CONFIDENTIAL = 1;
// Public key kind.
exports.PUBLIC_KEY_KIND_TRANSACTION = 1;
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callUpload() {
        return this.call(exports.METHOD_UPLOAD);
    }
    callInstantiate() {
        return this.call(exports.METHOD_INSTANTIATE);
    }
    callCall() {
        return this.call(exports.METHOD_CALL);
    }
    callUpgrade() {
        return this.call(exports.METHOD_UPGRADE);
    }
    callChangeUpgradePolicy() {
        return this.call(exports.METHOD_CHANGE_UPGRADE_POLICY);
    }
    queryCode() {
        return this.query(exports.METHOD_CODE);
    }
    queryCodeStorage() {
        return this.query(exports.METHOD_CODE_STORAGE);
    }
    queryInstance() {
        return this.query(exports.METHOD_INSTANCE);
    }
    queryInstanceStorage() {
        return this.query(exports.METHOD_INSTANCE_STORAGE);
    }
    queryInstanceRawStorage() {
        return this.query(exports.METHOD_INSTANCE_RAW_STORAGE);
    }
    queryPublicKey() {
        return this.query(exports.METHOD_PUBLIC_KEY);
    }
    queryCustom() {
        return this.query(exports.METHOD_CUSTOM);
    }
}
exports.Wrapper = Wrapper;

},{"2b4bb6e4d8250eb6":"87MgA"}],"cT3Ij":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moduleEventHandler = exports.Wrapper = exports.METHODHANDLERKIND_MESSAGE_RESULT = exports.METHODHANDLERKIND_QUERY = exports.METHODHANDLERKIND_CALL = exports.EVENT_GAS_USED = exports.METHOD_RUNTIME_INFO = exports.METHOD_MIN_GAS_PRICE = exports.METHOD_CALL_DATA_PUBLIC_KEY = exports.METHOD_CHECK_INVARIANTS = exports.METHOD_ESTIMATE_GAS = exports.ERR_FORBIDDEN_BY_NODE_POLICY = exports.ERR_FORBIDDEN_IN_SECURE_BUILD = exports.ERR_GAS_PRICE_TOO_LOW_CODE = exports.ERR_NOT_AUTHENTICATED_CODE = exports.ERR_INVALID_CALL_FORMAT_CODE = exports.ERR_INVARIANT_VIOLATION_CODE = exports.ERR_MULTISIG_TOO_MANY_SIGNERS_CODE = exports.ERR_TOO_MANY_AUTH_CODE = exports.ERR_BATCH_OUT_OF_GAS_CODE = exports.ERR_BATCH_GAS_OVERFLOW_CODE = exports.ERR_OUT_OF_GAS_CODE = exports.ERR_GAS_OVERFLOW_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.ERR_MESSAGE_HANDLER_MISSING_CODE = exports.ERR_MESSAGE_NOT_HANDLED_CODE = exports.ERR_OUT_OF_MESSAGE_SLOTS_CODE = exports.ERR_INSUFFICIENT_FEE_BALANCE_CODE = exports.ERR_INVALID_NONCE_CODE = exports.ERR_INVALID_METHOD_CODE = exports.ERR_INVALID_TRANSACTION_CODE = exports.ERR_MALFORMED_TRANSACTION_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("aab661974e712903");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "core";
exports.ERR_MALFORMED_TRANSACTION_CODE = 1;
exports.ERR_INVALID_TRANSACTION_CODE = 2;
exports.ERR_INVALID_METHOD_CODE = 3;
exports.ERR_INVALID_NONCE_CODE = 4;
exports.ERR_INSUFFICIENT_FEE_BALANCE_CODE = 5;
exports.ERR_OUT_OF_MESSAGE_SLOTS_CODE = 6;
exports.ERR_MESSAGE_NOT_HANDLED_CODE = 8;
exports.ERR_MESSAGE_HANDLER_MISSING_CODE = 9;
exports.ERR_INVALID_ARGUMENT_CODE = 10;
exports.ERR_GAS_OVERFLOW_CODE = 11;
exports.ERR_OUT_OF_GAS_CODE = 12;
exports.ERR_BATCH_GAS_OVERFLOW_CODE = 13;
exports.ERR_BATCH_OUT_OF_GAS_CODE = 14;
exports.ERR_TOO_MANY_AUTH_CODE = 15;
exports.ERR_MULTISIG_TOO_MANY_SIGNERS_CODE = 16;
exports.ERR_INVARIANT_VIOLATION_CODE = 17;
exports.ERR_INVALID_CALL_FORMAT_CODE = 18;
exports.ERR_NOT_AUTHENTICATED_CODE = 19;
exports.ERR_GAS_PRICE_TOO_LOW_CODE = 20;
exports.ERR_FORBIDDEN_IN_SECURE_BUILD = 21;
exports.ERR_FORBIDDEN_BY_NODE_POLICY = 22;
// Queries.
exports.METHOD_ESTIMATE_GAS = "core.EstimateGas";
exports.METHOD_CHECK_INVARIANTS = "core.CheckInvariants";
exports.METHOD_CALL_DATA_PUBLIC_KEY = "core.CallDataPublicKey";
exports.METHOD_MIN_GAS_PRICE = "core.MinGasPrice";
exports.METHOD_RUNTIME_INFO = "core.RuntimeInfo";
// Events.
exports.EVENT_GAS_USED = 1;
// Introspection.
// Keep these in sync with `CoreMethodHandlerInfo.kind`
exports.METHODHANDLERKIND_CALL = "call";
exports.METHODHANDLERKIND_QUERY = "query";
exports.METHODHANDLERKIND_MESSAGE_RESULT = "message_result";
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    queryEstimateGas() {
        return this.query(exports.METHOD_ESTIMATE_GAS);
    }
    queryCheckInvariants() {
        return this.query(exports.METHOD_CHECK_INVARIANTS);
    }
    queryCallDataPublicKey() {
        return this.query(exports.METHOD_CALL_DATA_PUBLIC_KEY);
    }
    queryMinGasPrice() {
        return this.query(exports.METHOD_MIN_GAS_PRICE);
    }
    queryRuntimeInfo() {
        return this.query(exports.METHOD_RUNTIME_INFO);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}
exports.moduleEventHandler = moduleEventHandler;

},{"aab661974e712903":"87MgA"}],"2fcHH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Visitor = exports.toKey = void 0;
const oasis = require("12a686e1e003f133");
function toKey(module, code) {
    const codeBuf = new ArrayBuffer(4);
    const codeDV = new DataView(codeBuf);
    codeDV.setUint32(0, code, false);
    return oasis.misc.concat(oasis.misc.fromString(module), new Uint8Array(codeBuf));
}
exports.toKey = toKey;
class Visitor {
    constructor(modules){
        this.handlers = {};
        for (const [module, codes] of modules)for(const code in codes)this.handlers[oasis.misc.toHex(toKey(module, +code))] = codes[code];
    }
    /**
     * Calls one of the handlers based on a given event's key.
     * @param e The event
     * @returns `true` if the event matched one of the handlers
     */ visit(e) {
        const keyHex = oasis.misc.toHex(e.key);
        if (this.handlers[keyHex]) {
            const values = oasis.misc.fromCBOR(e.value);
            for (const value of values)this.handlers[keyHex](e, value);
            return true;
        }
        return false;
    }
}
exports.Visitor = Visitor;

},{"12a686e1e003f133":"1ax6t"}],"kt33b":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.moduleEventHandler = exports.Wrapper = exports.METHOD_SIMULATE_CALL = exports.METHOD_BALANCE = exports.METHOD_CODE = exports.METHOD_STORAGE = exports.METHOD_CALL = exports.METHOD_CREATE = exports.EVENT_LOG_CODE = exports.ERROR_SIMULATION_TOO_EXPENSIVE = exports.ERROR_REVERTED_CODE = exports.ERROR_FORBIDDEN_CODE = exports.ERR_INSUFFICIENT_BALANCE_CODE = exports.ERR_GAS_LIMIT_TOO_LOW_CODE = exports.ERR_FEE_OVERFLOW_CODE = exports.ERR_INVALID_SIGNER_TYPE_CODE = exports.ERR_EXECUTION_FAILED_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("6e66f1b33519e667");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "evm";
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_EXECUTION_FAILED_CODE = 2;
exports.ERR_INVALID_SIGNER_TYPE_CODE = 3;
exports.ERR_FEE_OVERFLOW_CODE = 4;
exports.ERR_GAS_LIMIT_TOO_LOW_CODE = 5;
exports.ERR_INSUFFICIENT_BALANCE_CODE = 6;
exports.ERROR_FORBIDDEN_CODE = 7;
exports.ERROR_REVERTED_CODE = 8;
exports.ERROR_SIMULATION_TOO_EXPENSIVE = 8;
exports.EVENT_LOG_CODE = 1;
// Callable methods.
exports.METHOD_CREATE = "evm.Create";
exports.METHOD_CALL = "evm.Call";
// Queries.
exports.METHOD_STORAGE = "evm.Storage";
exports.METHOD_CODE = "evm.Code";
exports.METHOD_BALANCE = "evm.Balance";
exports.METHOD_SIMULATE_CALL = "evm.SimulateCall";
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callCreate() {
        return this.call(exports.METHOD_CREATE);
    }
    callCall() {
        return this.call(exports.METHOD_CALL);
    }
    queryStorage() {
        return this.query(exports.METHOD_STORAGE);
    }
    queryCode() {
        return this.query(exports.METHOD_CODE);
    }
    queryBalance() {
        return this.query(exports.METHOD_BALANCE);
    }
    querySimulateCall() {
        return this.query(exports.METHOD_SIMULATE_CALL);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}
exports.moduleEventHandler = moduleEventHandler;

},{"6e66f1b33519e667":"87MgA"}],"iRDGW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.METHOD_PARAMETERS = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("bc17690ea5c12f2c");
/**
 * Unique module name.
 */ exports.MODULE_NAME = "rewards";
exports.ERR_INVALID_ARGUMENT_CODE = 1;
// Queries.
exports.METHOD_PARAMETERS = "rewards.Parameters";
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    queryParameters() {
        return this.query(exports.METHOD_PARAMETERS);
    }
}
exports.Wrapper = Wrapper;

},{"bc17690ea5c12f2c":"87MgA"}],"7X8cr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EllipticSigner = exports.BlindContextSigner = exports.verify = void 0;
const oasis = require("3d4505cdd9f592f0");
const elliptic = require("d479aa4102505280");
const SECP256K1 = new elliptic.ec("secp256k1");
async function verify(context, message, signature, publicKey) {
    const signerMessage = await oasis.signature.prepareSignerMessage(context, message);
    const publicKeyA = Array.from(publicKey);
    // @ts-expect-error acceptance of array-like encoded public key is not modeled
    return SECP256K1.verify(signerMessage, signature, publicKeyA);
}
exports.verify = verify;
class BlindContextSigner {
    constructor(signer){
        this.signer = signer;
    }
    public() {
        return this.signer.public();
    }
    async sign(context, message) {
        const signerMessage = await oasis.signature.prepareSignerMessage(context, message);
        return await this.signer.sign(signerMessage);
    }
}
exports.BlindContextSigner = BlindContextSigner;
class EllipticSigner {
    constructor(key, note){
        if (note !== "this key is not important") throw new Error("insecure signer implementation");
        this.key = key;
    }
    static fromRandom(note) {
        return new EllipticSigner(SECP256K1.genKeyPair(), note);
    }
    static fromPrivate(priv, note) {
        return new EllipticSigner(SECP256K1.keyFromPrivate(priv), note);
    }
    public() {
        return new Uint8Array(this.key.getPublic(true, "array"));
    }
    async sign(message) {
        const sig = this.key.sign(message, {
            canonical: true
        });
        return new Uint8Array(sig.toDER());
    }
}
exports.EllipticSigner = EllipticSigner;

},{"3d4505cdd9f592f0":"1ax6t","d479aa4102505280":"bxe3Z"}],"dusBQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"cQ5xL":[function(require,module,exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(this);

},{}],"gdpNU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppError", ()=>AppError);
parcelHelpers.export(exports, "AppErrors", ()=>AppErrors);
// Adds strict type-check that a type was exhausted
// https://www.typescriptlang.org/docs/handbook/2/narrowing.html#exhaustiveness-checking
// https://stackoverflow.com/questions/41102060/typescript-extending-error-class
parcelHelpers.export(exports, "exhaustedTypeWarning", ()=>exhaustedTypeWarning);
class AppError extends Error {
    type;
    originalError;
    constructor(type, message, originalError){
        super(message ?? type);
        this.type = type;
        this.originalError = originalError;
    }
}
var AppErrors;
(function(AppErrors) {
    AppErrors["Unknown"] = "unknown";
    AppErrors["UnsupportedNetwork"] = "unsupported_network";
    AppErrors["UnsupportedLayer"] = "unsupported_layer";
    AppErrors["InvalidAddress"] = "invalid_address";
    AppErrors["InvalidBlockHeight"] = "invalid_block_height";
    AppErrors["InvalidTxHash"] = "invalid_tx_hash";
    AppErrors["InvalidProposalId"] = "invalid_proposal_id";
    AppErrors["InvalidPageNumber"] = "invalid_page_number";
    AppErrors["PageDoesNotExist"] = "page_does_not_exist";
    AppErrors["NotFoundBlockHeight"] = "not_found_block_height";
    AppErrors["NotFoundTxHash"] = "not_found_tx_hash";
    AppErrors["NotFoundProposalId"] = "not_found_proposal_id";
    AppErrors["InvalidUrl"] = "invalid_url";
    AppErrors["InvalidVote"] = "invalid_vote";
    AppErrors["Storage"] = "storage";
})(AppErrors || (AppErrors = {}));
function exhaustedTypeWarning(messagePrefix, exhaustedType) {
    const message = `${messagePrefix}: Expected type to be exhausted, but this type was not handled: ${JSON.stringify(exhaustedType)}`;
    console.warn(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dJrPU":[function(require,module,exports) {
/** @file Wrappers around generated API */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAccountEmpty", ()=>isAccountEmpty);
parcelHelpers.export(exports, "isAccountNonEmpty", ()=>isAccountNonEmpty);
parcelHelpers.export(exports, "groupAccountTokenBalances", ()=>groupAccountTokenBalances);
parcelHelpers.export(exports, "useGetConsensusTransactions", ()=>useGetConsensusTransactions);
parcelHelpers.export(exports, "useGetRuntimeTransactions", ()=>useGetRuntimeTransactions);
parcelHelpers.export(exports, "useGetConsensusTransactionsTxHash", ()=>useGetConsensusTransactionsTxHash);
parcelHelpers.export(exports, "useGetRuntimeTransactionsTxHash", ()=>useGetRuntimeTransactionsTxHash);
parcelHelpers.export(exports, "useGetConsensusAccountsAddress", ()=>useGetConsensusAccountsAddress);
parcelHelpers.export(exports, "useGetRuntimeAccountsAddress", ()=>useGetRuntimeAccountsAddress);
parcelHelpers.export(exports, "useGetConsensusBlockByHeight", ()=>useGetConsensusBlockByHeight);
parcelHelpers.export(exports, "useGetConsensusBlockByHash", ()=>useGetConsensusBlockByHash);
// TODO: replace with an appropriate API
parcelHelpers.export(exports, "useGetRuntimeBlockByHeight", ()=>useGetRuntimeBlockByHeight);
parcelHelpers.export(exports, "useGetRuntimeBlockByHash", ()=>useGetRuntimeBlockByHash);
parcelHelpers.export(exports, "useGetConsensusBlocks", ()=>useGetConsensusBlocks);
parcelHelpers.export(exports, "useGetRuntimeBlocks", ()=>useGetRuntimeBlocks);
parcelHelpers.export(exports, "useGetRuntimeEvmTokens", ()=>useGetRuntimeEvmTokens);
parcelHelpers.export(exports, "useGetRuntimeEvmTokensAddress", ()=>useGetRuntimeEvmTokensAddress);
parcelHelpers.export(exports, "useGetRuntimeEvents", ()=>useGetRuntimeEvents);
parcelHelpers.export(exports, "useGetRuntimeEvmTokensAddressHolders", ()=>useGetRuntimeEvmTokensAddressHolders);
parcelHelpers.export(exports, "useGetConsensusProposals", ()=>useGetConsensusProposals);
parcelHelpers.export(exports, "useGetConsensusProposalsProposalId", ()=>useGetConsensusProposalsProposalId);
parcelHelpers.export(exports, "useGetConsensusProposalsByName", ()=>useGetConsensusProposalsByName);
parcelHelpers.export(exports, "useGetConsensusValidators", ()=>useGetConsensusValidators);
parcelHelpers.export(exports, "useGetConsensusAccounts", ()=>useGetConsensusAccounts);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDelegations", ()=>useGetConsensusAccountsAddressDelegations);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDebondingDelegationsTo", ()=>useGetConsensusAccountsAddressDebondingDelegationsTo);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDelegationsTo", ()=>useGetConsensusAccountsAddressDelegationsTo);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _config = require("../config");
var _api = require("./generated/api");
var _reactQuery = require("@tanstack/react-query");
var _helpers = require("../app/utils/helpers");
var _getRPCAccountBalances = require("../app/utils/getRPCAccountBalances");
var _util = require("@ethereumjs/util");
parcelHelpers.exportAll(_api, exports);
const isAccountEmpty = (account)=>{
    const { balances, evm_balances, stats } = account;
    const { total_received, total_sent, num_txns } = stats;
    const hasNoBalances = [
        ...balances,
        ...evm_balances
    ].every((b)=>b.balance === "0" || b.balance === "0.0");
    const hasNoTransactions = total_received === "0" && total_sent === "0" && num_txns === 0;
    return hasNoBalances && hasNoTransactions;
};
const isAccountNonEmpty = (account)=>!isAccountEmpty(account);
const groupAccountTokenBalances = (account)=>{
    const tokenBalances = {};
    account.evm_balances.forEach((balance)=>{
        if (balance.token_type) {
            tokenBalances[balance.token_type] ??= [];
            tokenBalances[balance.token_type].push(balance);
        }
    });
    return {
        ...account,
        tokenBalances
    };
};
function arrayify(arrayOrItem) {
    if (arrayOrItem == null) return [];
    if (!Array.isArray(arrayOrItem)) return [
        arrayOrItem
    ];
    return arrayOrItem;
}
const useGetConsensusTransactions = (network, params, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusTransactions(network, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        transactions: data.transactions.map((tx)=>{
                            return {
                                ...tx,
                                network,
                                layer: (0, _api.Layer).consensus,
                                ticker
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const adjustRuntimeTransactionMethod = (method, isLikelyNativeTokenTransfer)=>isLikelyNativeTokenTransfer ? "accounts.Transfer" : method;
const useGetRuntimeTransactions = (network, runtime, params, options)=>{
    return _api.useGetRuntimeTransactions(network, runtime, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        transactions: data.transactions.map((tx)=>{
                            return {
                                ...tx,
                                eth_hash: tx.eth_hash ? `0x${tx.eth_hash}` : undefined,
                                fee: (0, _helpers.fromBaseUnits)(tx.fee, (0, _config.paraTimesConfig)[runtime].decimals),
                                charged_fee: (0, _helpers.fromBaseUnits)(tx.charged_fee, (0, _config.paraTimesConfig)[runtime].decimals),
                                amount: tx.amount ? (0, _helpers.fromBaseUnits)(tx.amount, (0, _config.paraTimesConfig)[runtime].decimals) : undefined,
                                layer: runtime,
                                network,
                                ticker: tx.body?.amount?.Denomination || (0, _config.getTokensForScope)({
                                    network,
                                    layer: runtime
                                })[0].ticker,
                                method: adjustRuntimeTransactionMethod(tx.method, tx.is_likely_native_token_transfer)
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusTransactionsTxHash = (network, txHash, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusTransactionsTxHash(network, txHash, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        layer: (0, _api.Layer).consensus,
                        network,
                        ticker
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetRuntimeTransactionsTxHash = (network, runtime, txHash, options)=>{
    // Sometimes we will call this with an undefined txHash, so we must be careful here.
    const actualHash = txHash?.startsWith("0x") ? txHash.substring(2) : txHash;
    return _api.useGetRuntimeTransactionsTxHash(network, runtime, actualHash, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        transactions: data.transactions.map((tx)=>{
                            return {
                                ...tx,
                                eth_hash: tx.eth_hash ? `0x${tx.eth_hash}` : undefined,
                                fee: (0, _helpers.fromBaseUnits)(tx.fee, (0, _config.paraTimesConfig)[runtime].decimals),
                                charged_fee: (0, _helpers.fromBaseUnits)(tx.charged_fee, (0, _config.paraTimesConfig)[runtime].decimals),
                                amount: tx.amount ? (0, _helpers.fromBaseUnits)(tx.amount, (0, _config.paraTimesConfig)[runtime].decimals) : undefined,
                                layer: runtime,
                                network,
                                ticker: tx.body?.amount?.Denomination || (0, _config.getTokensForScope)({
                                    network,
                                    layer: runtime
                                })[0].ticker,
                                method: adjustRuntimeTransactionMethod(tx.method, tx.is_likely_native_token_transfer)
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusAccountsAddress = (network, address, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusAccountsAddress(network, address, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    // TODO: remove defaults when API is updated
                    const { available, delegations_balance = 0, debonding_delegations_balance = 0 } = data;
                    const total = BigInt(data.available) + BigInt(delegations_balance) + BigInt(debonding_delegations_balance);
                    return {
                        ...data,
                        available: (0, _helpers.fromBaseUnits)(available, (0, _config.consensusDecimals)),
                        total: (0, _helpers.fromBaseUnits)(total.toString(), (0, _config.consensusDecimals)),
                        delegations_balance: (0, _helpers.fromBaseUnits)(delegations_balance.toString(), (0, _config.consensusDecimals)),
                        debonding_delegations_balance: (0, _helpers.fromBaseUnits)(debonding_delegations_balance.toString(), (0, _config.consensusDecimals)),
                        layer: (0, _api.Layer).consensus,
                        network,
                        size: (0, _helpers.getAccountSize)(total),
                        ticker
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetRuntimeAccountsAddress = (network, runtime, address, options)=>{
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const query = _api.useGetRuntimeAccountsAddress(network, runtime, oasisAddress, {
        ...options,
        query: {
            ...options?.query ?? {},
            enabled: !!oasisAddress && (options?.query?.enabled ?? true)
        },
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return groupAccountTokenBalances({
                        ...data,
                        address_eth: (0, _helpers.getEthAddressForAccount)(data, address),
                        evm_contract: data.evm_contract && {
                            ...data.evm_contract,
                            eth_creation_tx: data.evm_contract.eth_creation_tx ? `0x${data.evm_contract.eth_creation_tx}` : undefined
                        },
                        evm_balances: (data.evm_balances || []).filter((token)=>token.balance) // TODO: why do we filter for this? According to the API it must be there
                        .map((token)=>{
                            return {
                                ...token,
                                balance: (0, _helpers.fromBaseUnits)(token.balance, token.token_decimals)
                            };
                        }),
                        balances: (data.balances || []).filter((token)=>token.balance) // TODO: why do we filter for this? According to the API it must be there
                        .map((token)=>{
                            return {
                                ...token,
                                balance: (0, _helpers.fromBaseUnits)(token.balance, token.token_decimals)
                            };
                        }),
                        layer: runtime,
                        network,
                        stats: {
                            ...data.stats,
                            total_received: data.stats?.total_received ? (0, _helpers.fromBaseUnits)(data.stats?.total_received, (0, _config.paraTimesConfig)[runtime].decimals) : "0",
                            total_sent: data.stats?.total_sent ? (0, _helpers.fromBaseUnits)(data.stats?.total_sent, (0, _config.paraTimesConfig)[runtime].decimals) : "0"
                        }
                    });
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
    const runtimeAccount = query.data?.data;
    // TODO: Remove after account balances on Nexus are in sync with the node
    const rpcAccountBalances = (0, _reactQuery.useQuery)({
        enabled: !!oasisAddress,
        queryKey: [
            oasisAddress,
            network,
            runtime
        ],
        queryFn: async ()=>{
            if (!oasisAddress) throw new Error("Needed to fix types - see `enabled`");
            return await (0, _getRPCAccountBalances.getRPCAccountBalances)(oasisAddress, {
                network: network,
                layer: runtime
            });
        }
    }).data;
    const data = rpcAccountBalances && runtimeAccount ? {
        ...runtimeAccount,
        balances: rpcAccountBalances
    } : runtimeAccount;
    return {
        ...query,
        data: query.data ? {
            ...query.data,
            data
        } : query.data
    };
};
function useGetConsensusBlockByHeight(network, blockHeight, options) {
    const result = _api.useGetConsensusBlocksHeight(network, blockHeight, {
        ...options,
        request: {
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (block, headers, status)=>{
                    if (status !== 200) return block;
                    return {
                        ...block,
                        layer: (0, _api.Layer).consensus,
                        network
                    };
                }
            ]
        }
    });
    return result;
}
function useGetConsensusBlockByHash(network, blockHash, options) {
    const result = _api.useGetConsensusBlocks(network, {
        hash: blockHash
    }, {
        ...options,
        request: {
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (block, headers, status)=>{
                    if (status !== 200) return block;
                    return {
                        ...block,
                        layer: (0, _api.Layer).consensus,
                        network
                    };
                }
            ]
        }
    });
    return result;
}
function useGetRuntimeBlockByHeight(network, runtime, blockHeight, options) {
    const params = {
        to: blockHeight,
        limit: 1
    };
    const result = _api.useGetRuntimeBlocks(network, runtime, params, {
        ...options,
        request: {
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                function(data, headers, status) {
                    if (status !== 200) return data;
                    const block = data.blocks[0];
                    if (!block || block.round !== blockHeight) throw new (0, _axiosDefault.default).AxiosError("not found", "ERR_BAD_REQUEST", this, null, {
                        status: 404,
                        statusText: "not found",
                        config: this,
                        data: "not found",
                        headers: {}
                    });
                    return {
                        ...block,
                        layer: runtime,
                        network
                    };
                }
            ]
        }
    });
    return result;
}
function useGetRuntimeBlockByHash(network, runtime, blockHash, options) {
    const params = {
        hash: blockHash
    };
    const result = _api.useGetRuntimeBlocks(network, runtime, params, {
        ...options,
        request: {
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                function(data, headers, status) {
                    if (status !== 200) return data;
                    const block = data.blocks[0];
                    if (!block || block.hash !== blockHash) throw new (0, _axiosDefault.default).AxiosError("not found", "ERR_BAD_REQUEST", this, null, {
                        status: 404,
                        statusText: "not found",
                        config: this,
                        data: "not found",
                        headers: {}
                    });
                    return {
                        ...block,
                        layer: runtime,
                        network
                    };
                }
            ]
        }
    });
    return result;
}
const useGetConsensusBlocks = (network, params, options)=>{
    return _api.useGetConsensusBlocks(network, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        blocks: data.blocks.map((block)=>{
                            return {
                                ...block,
                                layer: (0, _api.Layer).consensus,
                                network
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetRuntimeBlocks = (network, runtime, params, options)=>{
    return _api.useGetRuntimeBlocks(network, runtime, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        blocks: data.blocks.map((block)=>{
                            return {
                                ...block,
                                layer: runtime,
                                network
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetRuntimeEvmTokens = (network, runtime, params, options)=>{
    return _api.useGetRuntimeEvmTokens(network, runtime, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        evm_tokens: data.evm_tokens.map((token)=>{
                            return {
                                ...token,
                                total_supply: token.total_supply ? (0, _helpers.fromBaseUnits)(token.total_supply, token.decimals || 0) : undefined,
                                layer: runtime,
                                network
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetRuntimeEvmTokensAddress = (network, runtime, address, options)=>{
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    return _api.useGetRuntimeEvmTokensAddress(network, runtime, oasisAddress, {
        ...options,
        query: {
            ...options?.query ?? {},
            enabled: !!oasisAddress && (options?.query?.enabled ?? true)
        },
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        total_supply: data.total_supply ? (0, _helpers.fromBaseUnits)(data.total_supply, data.decimals || 0) : undefined,
                        network,
                        layer: runtime
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const fixChecksumAddressInEvmEventParam = (param)=>param.evm_type === "address" ? {
        ...param,
        value: (0, _util.toChecksumAddress)(param.value)
    } : param;
const useGetRuntimeEvents = (network, runtime, params, options)=>{
    return _api.useGetRuntimeEvents(network, runtime, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        events: data.events.map((event)=>{
                            const adjustedHash = event.eth_tx_hash ? `0x${event.eth_tx_hash}` : undefined;
                            if (event.type === (0, _api.RuntimeEventType).accountstransfer || event.type === (0, _api.RuntimeEventType).accountsmint || event.type === (0, _api.RuntimeEventType).accountsburn || event.type === (0, _api.RuntimeEventType).consensus_accountsdeposit || event.type === (0, _api.RuntimeEventType).consensus_accountswithdraw || event.type === (0, _api.RuntimeEventType).consensus_accountsdelegate || event.type === (0, _api.RuntimeEventType).consensus_accountsundelegate_done) return {
                                ...event,
                                evm_log_params: event.evm_log_params?.map(fixChecksumAddressInEvmEventParam),
                                eth_tx_hash: adjustedHash,
                                body: {
                                    ...event.body,
                                    amount: // If there's no denomination then use runtime's native. Otherwise unknown (would have to get by token name?).
                                    event.body.amount.Denomination === "" ? {
                                        ...event.body.amount,
                                        Amount: (0, _helpers.fromBaseUnits)(event.body.amount.Amount, (0, _config.paraTimesConfig)[runtime].decimals),
                                        Denomination: event.body?.Denomination ?? (0, _config.getTokensForScope)({
                                            network,
                                            layer: runtime
                                        })[0].ticker
                                    } : event.body.amount
                                },
                                layer: runtime,
                                network
                            };
                            return {
                                ...event,
                                evm_log_params: event.evm_log_params?.map(fixChecksumAddressInEvmEventParam),
                                eth_tx_hash: adjustedHash,
                                layer: runtime,
                                network
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetRuntimeEvmTokensAddressHolders = (network, runtime, address, params, options)=>{
    return _api.useGetRuntimeEvmTokensAddressHolders(network, runtime, address, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        holders: data.holders.map((holder, index)=>{
                            return {
                                ...holder,
                                rank: index + (params?.offset ?? 0) + 1,
                                layer: runtime,
                                network
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusProposals = (network, params, options)=>{
    return _api.useGetConsensusProposals(network, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        proposals: data.proposals.map((proposal)=>{
                            return {
                                ...proposal,
                                network,
                                layer: (0, _api.Layer).consensus,
                                deposit: (0, _helpers.fromBaseUnits)(proposal.deposit, (0, _config.consensusDecimals))
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusProposalsProposalId = (network, proposalId, options)=>{
    return _api.useGetConsensusProposalsProposalId(network, proposalId, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        network,
                        layer: (0, _api.Layer).consensus,
                        deposit: (0, _helpers.fromBaseUnits)(data.deposit, (0, _config.consensusDecimals))
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusProposalsByName = (network, nameFragment)=>{
    const query = useGetConsensusProposals(network, {}, {
        query: {
            enabled: !!nameFragment
        }
    });
    const { isLoading, isInitialLoading, data, status, error } = query;
    const textMatcher = nameFragment ? (proposal)=>!!proposal.handler && proposal.handler?.includes(nameFragment) : ()=>false;
    const results = data ? query.data.data.proposals.filter(textMatcher) : undefined;
    return {
        isLoading,
        isInitialLoading,
        status,
        error,
        results
    };
};
const useGetConsensusValidators = (network, params, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusValidators(network, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    const validators = data.validators.map((validator)=>{
                        return {
                            ...validator,
                            escrow: (0, _helpers.fromBaseUnits)(validator.escrow, (0, _config.consensusDecimals)),
                            ticker
                        };
                    });
                    const map = new Map();
                    validators.forEach((validator)=>map.set(validator.entity_address, validator));
                    return {
                        ...data,
                        validators,
                        map
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusAccounts = (network, params, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusAccounts(network, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        accounts: data.accounts.map((account)=>{
                            // TODO: remove when API returns total value, looking at query filters we store that data in Nexus
                            // or sum proper fields when they are available. Currently API does not return correct fields in accounts list endpoint
                            // https://github.com/oasisprotocol/explorer/pull/1160#discussion_r1459577303
                            const total = BigInt(account.available);
                            return {
                                ...account,
                                available: (0, _helpers.fromBaseUnits)(account.available, (0, _config.consensusDecimals)),
                                total: (0, _helpers.fromBaseUnits)(total.toString(), (0, _config.consensusDecimals)),
                                layer: (0, _api.Layer).consensus,
                                network,
                                size: (0, _helpers.getAccountSize)(total),
                                ticker
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusAccountsAddressDelegations = (network, address, params, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusAccountsAddressDelegations(network, address, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        delegations: data.delegations.map((delegation)=>{
                            return {
                                ...delegation,
                                amount: (0, _helpers.fromBaseUnits)(delegation.amount, (0, _config.consensusDecimals)),
                                layer: (0, _api.Layer).consensus,
                                network,
                                ticker
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusAccountsAddressDebondingDelegationsTo = (network, address, params, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusAccountsAddressDebondingDelegationsTo(network, address, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        debonding_delegations: data.debonding_delegations.map((delegation)=>{
                            return {
                                ...delegation,
                                amount: (0, _helpers.fromBaseUnits)(delegation.amount, (0, _config.consensusDecimals)),
                                layer: (0, _api.Layer).consensus,
                                network,
                                ticker
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};
const useGetConsensusAccountsAddressDelegationsTo = (network, address, params, options)=>{
    const ticker = (0, _config.getTokensForScope)({
        network,
        layer: (0, _api.Layer).consensus
    })[0].ticker;
    return _api.useGetConsensusAccountsAddressDelegationsTo(network, address, params, {
        ...options,
        request: {
            ...options?.request,
            transformResponse: [
                ...arrayify((0, _axiosDefault.default).defaults.transformResponse),
                (data, headers, status)=>{
                    if (status !== 200) return data;
                    return {
                        ...data,
                        delegations: data.delegations.map((delegation)=>{
                            return {
                                ...delegation,
                                amount: (0, _helpers.fromBaseUnits)(delegation.amount, (0, _config.consensusDecimals)),
                                layer: (0, _api.Layer).consensus,
                                network,
                                ticker
                            };
                        })
                    };
                },
                ...arrayify(options?.request?.transformResponse)
            ]
        }
    });
};

},{"axios":"i7Tjc","../config":"2PXMY","./generated/api":"ckZaB","@tanstack/react-query":"jWXOo","../app/utils/helpers":"2aVNs","../app/utils/getRPCAccountBalances":"giSFO","@ethereumjs/util":"2DkLv","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i7Tjc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"gu8d9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gu8d9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"cwnO9","./helpers/bind.js":"5Zrm2","./core/Axios.js":"8gwwY","./core/mergeConfig.js":"1oh2F","./defaults/index.js":"lLRoz","./helpers/formDataToJSON.js":"jhzg6","./cancel/CanceledError.js":"khNDJ","./cancel/CancelToken.js":"F1u5u","./cancel/isCancel.js":"fXtJv","./env/data.js":"vEV0T","./helpers/toFormData.js":"6DEP4","./core/AxiosError.js":"8bU25","./helpers/spread.js":"2P8We","./helpers/isAxiosError.js":"a2XvZ","./core/AxiosHeaders.js":"3iRb3","./adapters/adapters.js":"1XpIx","./helpers/HttpStatusCode.js":"8LUsT","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cwnO9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== "object") return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
};

},{"./helpers/bind.js":"5Zrm2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5Zrm2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
"use strict";
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8gwwY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"cwnO9","../helpers/buildURL.js":"6gT9w","./InterceptorManager.js":"iwIhR","./dispatchRequest.js":"2VEFq","./mergeConfig.js":"1oh2F","./buildFullPath.js":"iWkap","../helpers/validator.js":"aUzVB","./AxiosHeaders.js":"3iRb3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6gT9w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

},{"../utils.js":"cwnO9","../helpers/AxiosURLSearchParams.js":"fHBCt","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fHBCt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"6DEP4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6DEP4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, _utilsJsDefault.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, "[]")) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"eHuUs","../utils.js":"cwnO9","../core/AxiosError.js":"8bU25","../platform/node/classes/FormData.js":"k6RqS","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8bU25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"cwnO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k6RqS":[function(require,module,exports) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iwIhR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"cwnO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2VEFq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"aAf5u","../cancel/isCancel.js":"fXtJv","../defaults/index.js":"lLRoz","../cancel/CanceledError.js":"khNDJ","../core/AxiosHeaders.js":"3iRb3","../adapters/adapters.js":"1XpIx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aAf5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"cwnO9","../defaults/index.js":"lLRoz","../core/AxiosHeaders.js":"3iRb3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lLRoz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"cwnO9","../core/AxiosError.js":"8bU25","./transitional.js":"i0mSq","../helpers/toFormData.js":"6DEP4","../helpers/toURLEncodedForm.js":"2eUfd","../platform/index.js":"8Of2t","../helpers/formDataToJSON.js":"jhzg6","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i0mSq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2eUfd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"cwnO9","./toFormData.js":"6DEP4","../platform/index.js":"8Of2t","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8Of2t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"h9ZaY","./common/utils.js":"2UiLy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h9ZaY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

},{"./classes/URLSearchParams.js":"7g0ct","./classes/FormData.js":"8sdis","./classes/Blob.js":"188Pz","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7g0ct":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
exports.default = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"fHBCt","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8sdis":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof FormData !== "undefined" ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"188Pz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof Blob !== "undefined" ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2UiLy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = ((product)=>{
    return hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jhzg6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"cwnO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3iRb3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
"use strict";
const $internals = Symbol("internals");
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"cwnO9","../helpers/parseHeaders.js":"4Entg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4Entg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

},{"./../utils.js":"cwnO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fXtJv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
"use strict";
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"khNDJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? "canceled" : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"8bU25","../utils.js":"cwnO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1XpIx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"cwnO9","./http.js":"k6RqS","./xhr.js":"E5ls8","../core/AxiosError.js":"8bU25","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"E5ls8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _cookiesJs = require("./../helpers/cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildURLJs = require("./../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _isURLSameOriginJs = require("./../helpers/isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _speedometerJs = require("../helpers/speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
"use strict";
function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(config.headers).normalize();
        let { responseType, withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, _utilsJsDefault.default).isFormData(requestData)) {
            if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)("Request aborted", (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)("Network Error", (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, _cookiesJsDefault.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(fullPath);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)("Unsupported protocol " + protocol + ":", (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"cwnO9","./../core/settle.js":"aXZrW","./../helpers/cookies.js":"3lFYJ","./../helpers/buildURL.js":"6gT9w","../core/buildFullPath.js":"iWkap","./../helpers/isURLSameOrigin.js":"5EWth","../defaults/transitional.js":"i0mSq","../core/AxiosError.js":"8bU25","../cancel/CanceledError.js":"khNDJ","../helpers/parseProtocol.js":"f660d","../platform/index.js":"8Of2t","../core/AxiosHeaders.js":"3iRb3","../helpers/speedometer.js":"4xrig","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aXZrW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)("Request failed with status code " + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"8bU25","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3lFYJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push("path=" + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"cwnO9","../platform/index.js":"8Of2t","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iWkap":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
"use strict";
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"2EOcB","../helpers/combineURLs.js":"aoYom","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2EOcB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
"use strict";
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aoYom":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
"use strict";
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5EWth":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"cwnO9","../platform/index.js":"8Of2t","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f660d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
"use strict";
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4xrig":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1oh2F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"cwnO9","./AxiosHeaders.js":"3iRb3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aUzVB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
const validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, _axiosErrorJsDefault.default)("options must be an object", (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)("option " + opt + " must be " + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)("Unknown option " + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"vEV0T","../core/AxiosError.js":"8bU25","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"vEV0T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.6.8";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"F1u5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"khNDJ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2P8We":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
"use strict";
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a2XvZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"cwnO9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8LUsT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2PXMY":[function(require,module,exports) {
// We get this from the generated code to avoid circular imports
// eslint-disable-next-line no-restricted-imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "consensusDecimals", ()=>consensusDecimals);
parcelHelpers.export(exports, "outOfDateThreshold", ()=>outOfDateThreshold);
parcelHelpers.export(exports, "RuntimeTypes", ()=>RuntimeTypes);
parcelHelpers.export(exports, "consensusConfig", ()=>consensusConfig);
parcelHelpers.export(exports, "paraTimesConfig", ()=>paraTimesConfig);
parcelHelpers.export(exports, "deploys", ()=>deploys);
parcelHelpers.export(exports, "isStableDeploy", ()=>isStableDeploy);
parcelHelpers.export(exports, "getAppTitle", ()=>getAppTitle);
parcelHelpers.export(exports, "getTokensForScope", ()=>getTokensForScope);
parcelHelpers.export(exports, "getFiatCurrencyForScope", ()=>getFiatCurrencyForScope);
parcelHelpers.export(exports, "showFiatValues", ()=>showFiatValues);
var _api = require("./oasis-nexus/generated/api");
var _ticker = require("./types/ticker");
const consensusDecimals = 9;
const outOfDateThreshold = 120000;
var RuntimeTypes;
(function(RuntimeTypes) {
    RuntimeTypes["Evm"] = "evm";
    RuntimeTypes["Oasis"] = "oasis";
})(RuntimeTypes || (RuntimeTypes = {}));
const consensusConfig = {
    mainnet: {
        tokens: [
            (0, _ticker.NativeToken).ROSE
        ]
    },
    testnet: {
        tokens: [
            (0, _ticker.NativeToken).TEST
        ]
    },
    decimals: consensusDecimals
};
const emeraldConfig = {
    mainnet: {
        activeNodes: 65,
        address: "oasis1qzvlg0grjxwgjj58tx2xvmv26era6t2csqn22pte",
        // Match max_batch_gas https://github.com/oasisprotocol/emerald-paratime/blob/5a36a646b989e510fadc0029178fe96a24cad101/src/lib.rs#L112-L112
        blockGasLimit: 10000000,
        runtimeId: "000000000000000000000000000000000000000000000000e2eaa99fc008f87f",
        tokens: [
            (0, _ticker.NativeToken).ROSE
        ]
    },
    testnet: {
        activeNodes: 32,
        address: "oasis1qr629x0tg9gm5fyhedgs9lw5eh3d8ycdnsxf0run",
        blockGasLimit: 30000000,
        runtimeId: "00000000000000000000000000000000000000000000000072c8215e60d5bca7",
        tokens: [
            (0, _ticker.NativeToken).TEST
        ]
    },
    decimals: 18,
    type: "evm"
};
const cipherConfig = {
    mainnet: {
        activeNodes: 34,
        address: "oasis1qrnu9yhwzap7rqh6tdcdcpz0zf86hwhycchkhvt8",
        blockGasLimit: undefined,
        runtimeId: "000000000000000000000000000000000000000000000000e199119c992377cb",
        tokens: [
            (0, _ticker.NativeToken).ROSE
        ]
    },
    testnet: {
        activeNodes: 15,
        address: "oasis1qqdn25n5a2jtet2s5amc7gmchsqqgs4j0qcg5k0t",
        blockGasLimit: undefined,
        runtimeId: "0000000000000000000000000000000000000000000000000000000000000000",
        tokens: [
            (0, _ticker.NativeToken).TEST
        ]
    },
    decimals: 9,
    type: "oasis"
};
const sapphireConfig = {
    mainnet: {
        activeNodes: 41,
        address: "oasis1qrd3mnzhhgst26hsp96uf45yhq6zlax0cuzdgcfc",
        // See max_batch_gas https://github.com/oasisprotocol/sapphire-paratime/blob/main/runtime/src/lib.rs#L166
        blockGasLimit: 15000000,
        runtimeId: "000000000000000000000000000000000000000000000000f80306c9858e7279",
        tokens: [
            (0, _ticker.NativeToken).ROSE
        ]
    },
    testnet: {
        activeNodes: 21,
        address: "oasis1qqczuf3x6glkgjuf0xgtcpjjw95r3crf7y2323xd",
        // See max_batch_gas https://github.com/oasisprotocol/sapphire-paratime/blob/main/runtime/src/lib.rs#L166
        blockGasLimit: 15000000,
        runtimeId: "000000000000000000000000000000000000000000000000a6d1e3ebf60dff6c",
        tokens: [
            (0, _ticker.NativeToken).TEST
        ]
    },
    decimals: 18,
    type: "evm"
};
const pontusxConfig = {
    mainnet: {
        activeNodes: undefined,
        address: undefined,
        blockGasLimit: undefined,
        runtimeId: undefined,
        tokens: [
            (0, _ticker.NativeToken).EUROe
        ]
    },
    testnet: {
        activeNodes: 1,
        address: "oasis1qr02702pr8ecjuff2z3es254pw9xl6z2yg9qcc6c",
        blockGasLimit: 15000000,
        runtimeId: "0000000000000000000000000000000000000000000000004febe52eb412b421",
        tokens: [
            (0, _ticker.NativeToken).EUROe,
            (0, _ticker.NativeToken).TEST
        ],
        fiatCurrency: "eur"
    },
    decimals: 18,
    type: "evm"
};
const paraTimesConfig = {
    [(0, _api.Layer).cipher]: cipherConfig,
    [(0, _api.Layer).emerald]: emeraldConfig,
    [(0, _api.Layer).sapphire]: sapphireConfig,
    [(0, _api.Layer).pontusx]: pontusxConfig,
    [(0, _api.Layer).consensus]: null
};
const splitUrls = (input)=>input ? input.split(",").filter((s)=>!!s).map((s)=>s.trim()) : [];
const deploys = {
    production: splitUrls("https://explorer.oasis.io, https://explorer.prd.oasis.io"),
    staging: splitUrls("https://explorer.stg.oasis.io"),
    localhost: "http://localhost:1234"
};
const stableDeploys = [
    ...deploys.production,
    ...deploys.staging
];
const isStableDeploy = stableDeploys.some((url)=>window.location.origin === url);
const getAppTitle = ()=>"Oasis Explorer";
const getTokensForScope = (scope)=>{
    if (!scope) return [];
    if (scope.layer !== (0, _api.Layer).consensus) return paraTimesConfig[scope.layer][scope.network].tokens;
    else return consensusConfig[scope.network].tokens;
};
const getFiatCurrencyForScope = (scope)=>(scope ? paraTimesConfig[scope.layer]?.[scope.network]?.fiatCurrency : undefined) ?? "usd";
const showFiatValues = true;

},{"./oasis-nexus/generated/api":"ckZaB","./types/ticker":"898HF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ckZaB":[function(require,module,exports) {
/**
 * Generated by orval v6.24.0 🍺
 * Do not edit manually.
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.
 * OpenAPI spec version: 0.1.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmTokenType", ()=>EvmTokenType);
parcelHelpers.export(exports, "RuntimeEventType", ()=>RuntimeEventType);
parcelHelpers.export(exports, "ProposalState", ()=>ProposalState);
parcelHelpers.export(exports, "AddressDerivationContext", ()=>AddressDerivationContext);
parcelHelpers.export(exports, "ConsensusEventType", ()=>ConsensusEventType);
parcelHelpers.export(exports, "ConsensusTxMethod", ()=>ConsensusTxMethod);
parcelHelpers.export(exports, "Runtime", ()=>Runtime);
parcelHelpers.export(exports, "Layer", ()=>Layer);
parcelHelpers.export(exports, "getStatus", ()=>getStatus);
parcelHelpers.export(exports, "getGetStatusQueryKey", ()=>getGetStatusQueryKey);
parcelHelpers.export(exports, "getGetStatusQueryOptions", ()=>getGetStatusQueryOptions);
parcelHelpers.export(exports, "useGetStatus", ()=>useGetStatus);
parcelHelpers.export(exports, "GetConsensusBlocks", ()=>GetConsensusBlocks);
parcelHelpers.export(exports, "getGetConsensusBlocksQueryKey", ()=>getGetConsensusBlocksQueryKey);
parcelHelpers.export(exports, "getGetConsensusBlocksQueryOptions", ()=>getGetConsensusBlocksQueryOptions);
parcelHelpers.export(exports, "useGetConsensusBlocks", ()=>useGetConsensusBlocks);
parcelHelpers.export(exports, "GetConsensusBlocksHeight", ()=>GetConsensusBlocksHeight);
parcelHelpers.export(exports, "getGetConsensusBlocksHeightQueryKey", ()=>getGetConsensusBlocksHeightQueryKey);
parcelHelpers.export(exports, "getGetConsensusBlocksHeightQueryOptions", ()=>getGetConsensusBlocksHeightQueryOptions);
parcelHelpers.export(exports, "useGetConsensusBlocksHeight", ()=>useGetConsensusBlocksHeight);
parcelHelpers.export(exports, "GetConsensusTransactions", ()=>GetConsensusTransactions);
parcelHelpers.export(exports, "getGetConsensusTransactionsQueryKey", ()=>getGetConsensusTransactionsQueryKey);
parcelHelpers.export(exports, "getGetConsensusTransactionsQueryOptions", ()=>getGetConsensusTransactionsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusTransactions", ()=>useGetConsensusTransactions);
parcelHelpers.export(exports, "GetConsensusTransactionsTxHash", ()=>GetConsensusTransactionsTxHash);
parcelHelpers.export(exports, "getGetConsensusTransactionsTxHashQueryKey", ()=>getGetConsensusTransactionsTxHashQueryKey);
parcelHelpers.export(exports, "getGetConsensusTransactionsTxHashQueryOptions", ()=>getGetConsensusTransactionsTxHashQueryOptions);
parcelHelpers.export(exports, "useGetConsensusTransactionsTxHash", ()=>useGetConsensusTransactionsTxHash);
parcelHelpers.export(exports, "GetConsensusEvents", ()=>GetConsensusEvents);
parcelHelpers.export(exports, "getGetConsensusEventsQueryKey", ()=>getGetConsensusEventsQueryKey);
parcelHelpers.export(exports, "getGetConsensusEventsQueryOptions", ()=>getGetConsensusEventsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEvents", ()=>useGetConsensusEvents);
parcelHelpers.export(exports, "GetConsensusEntities", ()=>GetConsensusEntities);
parcelHelpers.export(exports, "getGetConsensusEntitiesQueryKey", ()=>getGetConsensusEntitiesQueryKey);
parcelHelpers.export(exports, "getGetConsensusEntitiesQueryOptions", ()=>getGetConsensusEntitiesQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEntities", ()=>useGetConsensusEntities);
parcelHelpers.export(exports, "GetConsensusEntitiesEntityId", ()=>GetConsensusEntitiesEntityId);
parcelHelpers.export(exports, "getGetConsensusEntitiesEntityIdQueryKey", ()=>getGetConsensusEntitiesEntityIdQueryKey);
parcelHelpers.export(exports, "getGetConsensusEntitiesEntityIdQueryOptions", ()=>getGetConsensusEntitiesEntityIdQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEntitiesEntityId", ()=>useGetConsensusEntitiesEntityId);
parcelHelpers.export(exports, "GetConsensusEntitiesEntityIdNodes", ()=>GetConsensusEntitiesEntityIdNodes);
parcelHelpers.export(exports, "getGetConsensusEntitiesEntityIdNodesQueryKey", ()=>getGetConsensusEntitiesEntityIdNodesQueryKey);
parcelHelpers.export(exports, "getGetConsensusEntitiesEntityIdNodesQueryOptions", ()=>getGetConsensusEntitiesEntityIdNodesQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEntitiesEntityIdNodes", ()=>useGetConsensusEntitiesEntityIdNodes);
parcelHelpers.export(exports, "GetConsensusEntitiesEntityIdNodesNodeId", ()=>GetConsensusEntitiesEntityIdNodesNodeId);
parcelHelpers.export(exports, "getGetConsensusEntitiesEntityIdNodesNodeIdQueryKey", ()=>getGetConsensusEntitiesEntityIdNodesNodeIdQueryKey);
parcelHelpers.export(exports, "getGetConsensusEntitiesEntityIdNodesNodeIdQueryOptions", ()=>getGetConsensusEntitiesEntityIdNodesNodeIdQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEntitiesEntityIdNodesNodeId", ()=>useGetConsensusEntitiesEntityIdNodesNodeId);
parcelHelpers.export(exports, "GetConsensusValidators", ()=>GetConsensusValidators);
parcelHelpers.export(exports, "getGetConsensusValidatorsQueryKey", ()=>getGetConsensusValidatorsQueryKey);
parcelHelpers.export(exports, "getGetConsensusValidatorsQueryOptions", ()=>getGetConsensusValidatorsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusValidators", ()=>useGetConsensusValidators);
parcelHelpers.export(exports, "GetConsensusValidatorsEntityId", ()=>GetConsensusValidatorsEntityId);
parcelHelpers.export(exports, "getGetConsensusValidatorsEntityIdQueryKey", ()=>getGetConsensusValidatorsEntityIdQueryKey);
parcelHelpers.export(exports, "getGetConsensusValidatorsEntityIdQueryOptions", ()=>getGetConsensusValidatorsEntityIdQueryOptions);
parcelHelpers.export(exports, "useGetConsensusValidatorsEntityId", ()=>useGetConsensusValidatorsEntityId);
parcelHelpers.export(exports, "GetConsensusAccounts", ()=>GetConsensusAccounts);
parcelHelpers.export(exports, "getGetConsensusAccountsQueryKey", ()=>getGetConsensusAccountsQueryKey);
parcelHelpers.export(exports, "getGetConsensusAccountsQueryOptions", ()=>getGetConsensusAccountsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusAccounts", ()=>useGetConsensusAccounts);
parcelHelpers.export(exports, "GetConsensusAccountsAddress", ()=>GetConsensusAccountsAddress);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressQueryKey", ()=>getGetConsensusAccountsAddressQueryKey);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressQueryOptions", ()=>getGetConsensusAccountsAddressQueryOptions);
parcelHelpers.export(exports, "useGetConsensusAccountsAddress", ()=>useGetConsensusAccountsAddress);
parcelHelpers.export(exports, "GetConsensusAccountsAddressDelegations", ()=>GetConsensusAccountsAddressDelegations);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDelegationsQueryKey", ()=>getGetConsensusAccountsAddressDelegationsQueryKey);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDelegationsQueryOptions", ()=>getGetConsensusAccountsAddressDelegationsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDelegations", ()=>useGetConsensusAccountsAddressDelegations);
parcelHelpers.export(exports, "GetConsensusAccountsAddressDelegationsTo", ()=>GetConsensusAccountsAddressDelegationsTo);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDelegationsToQueryKey", ()=>getGetConsensusAccountsAddressDelegationsToQueryKey);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDelegationsToQueryOptions", ()=>getGetConsensusAccountsAddressDelegationsToQueryOptions);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDelegationsTo", ()=>useGetConsensusAccountsAddressDelegationsTo);
parcelHelpers.export(exports, "GetConsensusAccountsAddressDebondingDelegations", ()=>GetConsensusAccountsAddressDebondingDelegations);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDebondingDelegationsQueryKey", ()=>getGetConsensusAccountsAddressDebondingDelegationsQueryKey);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDebondingDelegationsQueryOptions", ()=>getGetConsensusAccountsAddressDebondingDelegationsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDebondingDelegations", ()=>useGetConsensusAccountsAddressDebondingDelegations);
parcelHelpers.export(exports, "GetConsensusAccountsAddressDebondingDelegationsTo", ()=>GetConsensusAccountsAddressDebondingDelegationsTo);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDebondingDelegationsToQueryKey", ()=>getGetConsensusAccountsAddressDebondingDelegationsToQueryKey);
parcelHelpers.export(exports, "getGetConsensusAccountsAddressDebondingDelegationsToQueryOptions", ()=>getGetConsensusAccountsAddressDebondingDelegationsToQueryOptions);
parcelHelpers.export(exports, "useGetConsensusAccountsAddressDebondingDelegationsTo", ()=>useGetConsensusAccountsAddressDebondingDelegationsTo);
parcelHelpers.export(exports, "GetConsensusEpochs", ()=>GetConsensusEpochs);
parcelHelpers.export(exports, "getGetConsensusEpochsQueryKey", ()=>getGetConsensusEpochsQueryKey);
parcelHelpers.export(exports, "getGetConsensusEpochsQueryOptions", ()=>getGetConsensusEpochsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEpochs", ()=>useGetConsensusEpochs);
parcelHelpers.export(exports, "GetConsensusEpochsEpoch", ()=>GetConsensusEpochsEpoch);
parcelHelpers.export(exports, "getGetConsensusEpochsEpochQueryKey", ()=>getGetConsensusEpochsEpochQueryKey);
parcelHelpers.export(exports, "getGetConsensusEpochsEpochQueryOptions", ()=>getGetConsensusEpochsEpochQueryOptions);
parcelHelpers.export(exports, "useGetConsensusEpochsEpoch", ()=>useGetConsensusEpochsEpoch);
parcelHelpers.export(exports, "GetConsensusProposals", ()=>GetConsensusProposals);
parcelHelpers.export(exports, "getGetConsensusProposalsQueryKey", ()=>getGetConsensusProposalsQueryKey);
parcelHelpers.export(exports, "getGetConsensusProposalsQueryOptions", ()=>getGetConsensusProposalsQueryOptions);
parcelHelpers.export(exports, "useGetConsensusProposals", ()=>useGetConsensusProposals);
parcelHelpers.export(exports, "GetConsensusProposalsProposalId", ()=>GetConsensusProposalsProposalId);
parcelHelpers.export(exports, "getGetConsensusProposalsProposalIdQueryKey", ()=>getGetConsensusProposalsProposalIdQueryKey);
parcelHelpers.export(exports, "getGetConsensusProposalsProposalIdQueryOptions", ()=>getGetConsensusProposalsProposalIdQueryOptions);
parcelHelpers.export(exports, "useGetConsensusProposalsProposalId", ()=>useGetConsensusProposalsProposalId);
parcelHelpers.export(exports, "GetConsensusProposalsProposalIdVotes", ()=>GetConsensusProposalsProposalIdVotes);
parcelHelpers.export(exports, "getGetConsensusProposalsProposalIdVotesQueryKey", ()=>getGetConsensusProposalsProposalIdVotesQueryKey);
parcelHelpers.export(exports, "getGetConsensusProposalsProposalIdVotesQueryOptions", ()=>getGetConsensusProposalsProposalIdVotesQueryOptions);
parcelHelpers.export(exports, "useGetConsensusProposalsProposalIdVotes", ()=>useGetConsensusProposalsProposalIdVotes);
parcelHelpers.export(exports, "GetRuntimeBlocks", ()=>GetRuntimeBlocks);
parcelHelpers.export(exports, "getGetRuntimeBlocksQueryKey", ()=>getGetRuntimeBlocksQueryKey);
parcelHelpers.export(exports, "getGetRuntimeBlocksQueryOptions", ()=>getGetRuntimeBlocksQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeBlocks", ()=>useGetRuntimeBlocks);
parcelHelpers.export(exports, "GetRuntimeTransactions", ()=>GetRuntimeTransactions);
parcelHelpers.export(exports, "getGetRuntimeTransactionsQueryKey", ()=>getGetRuntimeTransactionsQueryKey);
parcelHelpers.export(exports, "getGetRuntimeTransactionsQueryOptions", ()=>getGetRuntimeTransactionsQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeTransactions", ()=>useGetRuntimeTransactions);
parcelHelpers.export(exports, "GetRuntimeTransactionsTxHash", ()=>GetRuntimeTransactionsTxHash);
parcelHelpers.export(exports, "getGetRuntimeTransactionsTxHashQueryKey", ()=>getGetRuntimeTransactionsTxHashQueryKey);
parcelHelpers.export(exports, "getGetRuntimeTransactionsTxHashQueryOptions", ()=>getGetRuntimeTransactionsTxHashQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeTransactionsTxHash", ()=>useGetRuntimeTransactionsTxHash);
parcelHelpers.export(exports, "GetRuntimeEvents", ()=>GetRuntimeEvents);
parcelHelpers.export(exports, "getGetRuntimeEventsQueryKey", ()=>getGetRuntimeEventsQueryKey);
parcelHelpers.export(exports, "getGetRuntimeEventsQueryOptions", ()=>getGetRuntimeEventsQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeEvents", ()=>useGetRuntimeEvents);
parcelHelpers.export(exports, "GetRuntimeEvmTokens", ()=>GetRuntimeEvmTokens);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensQueryKey", ()=>getGetRuntimeEvmTokensQueryKey);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensQueryOptions", ()=>getGetRuntimeEvmTokensQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeEvmTokens", ()=>useGetRuntimeEvmTokens);
parcelHelpers.export(exports, "GetRuntimeEvmTokensAddress", ()=>GetRuntimeEvmTokensAddress);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressQueryKey", ()=>getGetRuntimeEvmTokensAddressQueryKey);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressQueryOptions", ()=>getGetRuntimeEvmTokensAddressQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeEvmTokensAddress", ()=>useGetRuntimeEvmTokensAddress);
parcelHelpers.export(exports, "GetRuntimeEvmTokensAddressHolders", ()=>GetRuntimeEvmTokensAddressHolders);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressHoldersQueryKey", ()=>getGetRuntimeEvmTokensAddressHoldersQueryKey);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressHoldersQueryOptions", ()=>getGetRuntimeEvmTokensAddressHoldersQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeEvmTokensAddressHolders", ()=>useGetRuntimeEvmTokensAddressHolders);
parcelHelpers.export(exports, "GetRuntimeEvmTokensAddressNfts", ()=>GetRuntimeEvmTokensAddressNfts);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressNftsQueryKey", ()=>getGetRuntimeEvmTokensAddressNftsQueryKey);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressNftsQueryOptions", ()=>getGetRuntimeEvmTokensAddressNftsQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeEvmTokensAddressNfts", ()=>useGetRuntimeEvmTokensAddressNfts);
parcelHelpers.export(exports, "GetRuntimeEvmTokensAddressNftsId", ()=>GetRuntimeEvmTokensAddressNftsId);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressNftsIdQueryKey", ()=>getGetRuntimeEvmTokensAddressNftsIdQueryKey);
parcelHelpers.export(exports, "getGetRuntimeEvmTokensAddressNftsIdQueryOptions", ()=>getGetRuntimeEvmTokensAddressNftsIdQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeEvmTokensAddressNftsId", ()=>useGetRuntimeEvmTokensAddressNftsId);
parcelHelpers.export(exports, "GetRuntimeAccountsAddress", ()=>GetRuntimeAccountsAddress);
parcelHelpers.export(exports, "getGetRuntimeAccountsAddressQueryKey", ()=>getGetRuntimeAccountsAddressQueryKey);
parcelHelpers.export(exports, "getGetRuntimeAccountsAddressQueryOptions", ()=>getGetRuntimeAccountsAddressQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeAccountsAddress", ()=>useGetRuntimeAccountsAddress);
parcelHelpers.export(exports, "GetRuntimeAccountsAddressNfts", ()=>GetRuntimeAccountsAddressNfts);
parcelHelpers.export(exports, "getGetRuntimeAccountsAddressNftsQueryKey", ()=>getGetRuntimeAccountsAddressNftsQueryKey);
parcelHelpers.export(exports, "getGetRuntimeAccountsAddressNftsQueryOptions", ()=>getGetRuntimeAccountsAddressNftsQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeAccountsAddressNfts", ()=>useGetRuntimeAccountsAddressNfts);
parcelHelpers.export(exports, "GetRuntimeStatus", ()=>GetRuntimeStatus);
parcelHelpers.export(exports, "getGetRuntimeStatusQueryKey", ()=>getGetRuntimeStatusQueryKey);
parcelHelpers.export(exports, "getGetRuntimeStatusQueryOptions", ()=>getGetRuntimeStatusQueryOptions);
parcelHelpers.export(exports, "useGetRuntimeStatus", ()=>useGetRuntimeStatus);
parcelHelpers.export(exports, "GetLayerStatsTxVolume", ()=>GetLayerStatsTxVolume);
parcelHelpers.export(exports, "getGetLayerStatsTxVolumeQueryKey", ()=>getGetLayerStatsTxVolumeQueryKey);
parcelHelpers.export(exports, "getGetLayerStatsTxVolumeQueryOptions", ()=>getGetLayerStatsTxVolumeQueryOptions);
parcelHelpers.export(exports, "useGetLayerStatsTxVolume", ()=>useGetLayerStatsTxVolume);
parcelHelpers.export(exports, "GetLayerStatsActiveAccounts", ()=>GetLayerStatsActiveAccounts);
parcelHelpers.export(exports, "getGetLayerStatsActiveAccountsQueryKey", ()=>getGetLayerStatsActiveAccountsQueryKey);
parcelHelpers.export(exports, "getGetLayerStatsActiveAccountsQueryOptions", ()=>getGetLayerStatsActiveAccountsQueryOptions);
parcelHelpers.export(exports, "useGetLayerStatsActiveAccounts", ()=>useGetLayerStatsActiveAccounts);
var _reactQuery = require("@tanstack/react-query");
var _replaceNetworkWithBaseURL = require("../replaceNetworkWithBaseURL");
var _replaceNetworkWithBaseURLDefault = parcelHelpers.interopDefault(_replaceNetworkWithBaseURL);
const EvmTokenType = {
    ERC20: "ERC20",
    ERC721: "ERC721"
};
const RuntimeEventType = {
    accountstransfer: "accounts.transfer",
    accountsburn: "accounts.burn",
    accountsmint: "accounts.mint",
    consensus_accountsdeposit: "consensus_accounts.deposit",
    consensus_accountswithdraw: "consensus_accounts.withdraw",
    consensus_accountsdelegate: "consensus_accounts.delegate",
    consensus_accountsundelegate_start: "consensus_accounts.undelegate_start",
    consensus_accountsundelegate_done: "consensus_accounts.undelegate_done",
    coregas_used: "core.gas_used",
    evmlog: "evm.log"
};
const ProposalState = {
    active: "active",
    passed: "passed",
    failed: "failed",
    rejected: "rejected"
};
const AddressDerivationContext = {
    "oasis-core/address:_staking": "oasis-core/address: staking",
    "oasis-runtime-sdk/address:_secp256k1eth": "oasis-runtime-sdk/address: secp256k1eth",
    "oasis-runtime-sdk/address:_sr25519": "oasis-runtime-sdk/address: sr25519",
    "oasis-runtime-sdk/address:_multisig": "oasis-runtime-sdk/address: multisig",
    "oasis-runtime-sdk/address:_module": "oasis-runtime-sdk/address: module",
    "oasis-runtime-sdk/address:_runtime": "oasis-runtime-sdk/address: runtime"
};
const ConsensusEventType = {
    governanceproposal_executed: "governance.proposal_executed",
    governanceproposal_finalized: "governance.proposal_finalized",
    governanceproposal_submitted: "governance.proposal_submitted",
    governancevote: "governance.vote",
    registryentity: "registry.entity",
    registrynode_unfrozen: "registry.node_unfrozen",
    registrynode: "registry.node",
    registryruntime: "registry.runtime",
    registryruntime_suspended: "registry.runtime_suspended",
    roothashexecution_discrepancy: "roothash.execution_discrepancy",
    roothashexecutor_committed: "roothash.executor_committed",
    roothashfinalized: "roothash.finalized",
    stakingallowance_change: "staking.allowance_change",
    stakingburn: "staking.burn",
    stakingescrowadd: "staking.escrow.add",
    stakingescrowdebonding_start: "staking.escrow.debonding_start",
    stakingescrowreclaim: "staking.escrow.reclaim",
    stakingescrowtake: "staking.escrow.take",
    stakingtransfer: "staking.transfer"
};
const ConsensusTxMethod = {
    stakingTransfer: "staking.Transfer",
    stakingAddEscrow: "staking.AddEscrow",
    stakingReclaimEscrow: "staking.ReclaimEscrow",
    stakingAmendCommissionSchedule: "staking.AmendCommissionSchedule",
    stakingAllow: "staking.Allow",
    stakingWithdraw: "staking.Withdraw",
    roothashExecutorCommit: "roothash.ExecutorCommit",
    roothashExecutorProposerTimeout: "roothash.ExecutorProposerTimeout",
    registryRegisterEntity: "registry.RegisterEntity",
    registryRegisterNode: "registry.RegisterNode",
    registryRegisterRuntime: "registry.RegisterRuntime",
    governanceCastVote: "governance.CastVote",
    governanceSubmitProposal: "governance.SubmitProposal",
    beaconPVSSCommit: "beacon.PVSSCommit",
    beaconPVSSReveal: "beacon.PVSSReveal",
    beaconVRFProve: "beacon.VRFProve"
};
const Runtime = {
    emerald: "emerald",
    sapphire: "sapphire",
    cipher: "cipher",
    pontusx: "pontusx"
};
const Layer = {
    emerald: "emerald",
    sapphire: "sapphire",
    cipher: "cipher",
    pontusx: "pontusx",
    consensus: "consensus"
};
const getStatus = (network, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/`,
        method: "GET",
        signal
    }, options);
};
const getGetStatusQueryKey = (network)=>{
    return [
        `/${network}/`
    ];
};
const getGetStatusQueryOptions = (network, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStatusQueryKey(network);
    const queryFn = ({ signal })=>getStatus(network, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetStatus = (network, options)=>{
    const queryOptions = getGetStatusQueryOptions(network, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusBlocks = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/blocks`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusBlocksQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/blocks`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusBlocksQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusBlocksQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusBlocks(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusBlocks = (network, params, options)=>{
    const queryOptions = getGetConsensusBlocksQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusBlocksHeight = (network, height, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/blocks/${encodeURIComponent(String(height))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusBlocksHeightQueryKey = (network, height)=>{
    return [
        `/${network}/consensus/blocks/${height}`
    ];
};
const getGetConsensusBlocksHeightQueryOptions = (network, height, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusBlocksHeightQueryKey(network, height);
    const queryFn = ({ signal })=>GetConsensusBlocksHeight(network, height, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && height),
        ...queryOptions
    };
};
const useGetConsensusBlocksHeight = (network, height, options)=>{
    const queryOptions = getGetConsensusBlocksHeightQueryOptions(network, height, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusTransactions = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/transactions`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusTransactionsQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusTransactionsQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusTransactionsQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusTransactions(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusTransactions = (network, params, options)=>{
    const queryOptions = getGetConsensusTransactionsQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusTransactionsTxHash = (network, txHash, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/transactions/${encodeURIComponent(String(txHash))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusTransactionsTxHashQueryKey = (network, txHash)=>{
    return [
        `/${network}/consensus/transactions/${txHash}`
    ];
};
const getGetConsensusTransactionsTxHashQueryOptions = (network, txHash, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusTransactionsTxHashQueryKey(network, txHash);
    const queryFn = ({ signal })=>GetConsensusTransactionsTxHash(network, txHash, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && txHash),
        ...queryOptions
    };
};
const useGetConsensusTransactionsTxHash = (network, txHash, options)=>{
    const queryOptions = getGetConsensusTransactionsTxHashQueryOptions(network, txHash, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEvents = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/events`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusEventsQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/events`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusEventsQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEventsQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusEvents(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusEvents = (network, params, options)=>{
    const queryOptions = getGetConsensusEventsQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEntities = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/entities`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusEntitiesQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/entities`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusEntitiesQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEntitiesQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusEntities(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusEntities = (network, params, options)=>{
    const queryOptions = getGetConsensusEntitiesQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEntitiesEntityId = (network, entityId, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/entities/${encodeURIComponent(String(entityId))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusEntitiesEntityIdQueryKey = (network, entityId)=>{
    return [
        `/${network}/consensus/entities/${entityId}`
    ];
};
const getGetConsensusEntitiesEntityIdQueryOptions = (network, entityId, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEntitiesEntityIdQueryKey(network, entityId);
    const queryFn = ({ signal })=>GetConsensusEntitiesEntityId(network, entityId, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && entityId),
        ...queryOptions
    };
};
const useGetConsensusEntitiesEntityId = (network, entityId, options)=>{
    const queryOptions = getGetConsensusEntitiesEntityIdQueryOptions(network, entityId, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEntitiesEntityIdNodes = (network, entityId, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/entities/${encodeURIComponent(String(entityId))}/nodes`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusEntitiesEntityIdNodesQueryKey = (network, entityId, params)=>{
    return [
        `/${network}/consensus/entities/${entityId}/nodes`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusEntitiesEntityIdNodesQueryOptions = (network, entityId, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEntitiesEntityIdNodesQueryKey(network, entityId, params);
    const queryFn = ({ signal })=>GetConsensusEntitiesEntityIdNodes(network, entityId, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && entityId),
        ...queryOptions
    };
};
const useGetConsensusEntitiesEntityIdNodes = (network, entityId, params, options)=>{
    const queryOptions = getGetConsensusEntitiesEntityIdNodesQueryOptions(network, entityId, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEntitiesEntityIdNodesNodeId = (network, entityId, nodeId, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/entities/${encodeURIComponent(String(entityId))}/nodes/${encodeURIComponent(String(nodeId))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusEntitiesEntityIdNodesNodeIdQueryKey = (network, entityId, nodeId)=>{
    return [
        `/${network}/consensus/entities/${entityId}/nodes/${nodeId}`
    ];
};
const getGetConsensusEntitiesEntityIdNodesNodeIdQueryOptions = (network, entityId, nodeId, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEntitiesEntityIdNodesNodeIdQueryKey(network, entityId, nodeId);
    const queryFn = ({ signal })=>GetConsensusEntitiesEntityIdNodesNodeId(network, entityId, nodeId, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && entityId && nodeId),
        ...queryOptions
    };
};
const useGetConsensusEntitiesEntityIdNodesNodeId = (network, entityId, nodeId, options)=>{
    const queryOptions = getGetConsensusEntitiesEntityIdNodesNodeIdQueryOptions(network, entityId, nodeId, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusValidators = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/validators`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusValidatorsQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/validators`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusValidatorsQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusValidatorsQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusValidators(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusValidators = (network, params, options)=>{
    const queryOptions = getGetConsensusValidatorsQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusValidatorsEntityId = (network, entityId, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/validators/${encodeURIComponent(String(entityId))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusValidatorsEntityIdQueryKey = (network, entityId)=>{
    return [
        `/${network}/consensus/validators/${entityId}`
    ];
};
const getGetConsensusValidatorsEntityIdQueryOptions = (network, entityId, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusValidatorsEntityIdQueryKey(network, entityId);
    const queryFn = ({ signal })=>GetConsensusValidatorsEntityId(network, entityId, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && entityId),
        ...queryOptions
    };
};
const useGetConsensusValidatorsEntityId = (network, entityId, options)=>{
    const queryOptions = getGetConsensusValidatorsEntityIdQueryOptions(network, entityId, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusAccounts = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/accounts`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusAccountsQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/accounts`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusAccountsQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusAccountsQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusAccounts(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusAccounts = (network, params, options)=>{
    const queryOptions = getGetConsensusAccountsQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusAccountsAddress = (network, address, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/accounts/${encodeURIComponent(String(address))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusAccountsAddressQueryKey = (network, address)=>{
    return [
        `/${network}/consensus/accounts/${address}`
    ];
};
const getGetConsensusAccountsAddressQueryOptions = (network, address, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusAccountsAddressQueryKey(network, address);
    const queryFn = ({ signal })=>GetConsensusAccountsAddress(network, address, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && address),
        ...queryOptions
    };
};
const useGetConsensusAccountsAddress = (network, address, options)=>{
    const queryOptions = getGetConsensusAccountsAddressQueryOptions(network, address, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusAccountsAddressDelegations = (network, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/accounts/${encodeURIComponent(String(address))}/delegations`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusAccountsAddressDelegationsQueryKey = (network, address, params)=>{
    return [
        `/${network}/consensus/accounts/${address}/delegations`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusAccountsAddressDelegationsQueryOptions = (network, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusAccountsAddressDelegationsQueryKey(network, address, params);
    const queryFn = ({ signal })=>GetConsensusAccountsAddressDelegations(network, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && address),
        ...queryOptions
    };
};
const useGetConsensusAccountsAddressDelegations = (network, address, params, options)=>{
    const queryOptions = getGetConsensusAccountsAddressDelegationsQueryOptions(network, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusAccountsAddressDelegationsTo = (network, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/accounts/${encodeURIComponent(String(address))}/delegations_to`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusAccountsAddressDelegationsToQueryKey = (network, address, params)=>{
    return [
        `/${network}/consensus/accounts/${address}/delegations_to`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusAccountsAddressDelegationsToQueryOptions = (network, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusAccountsAddressDelegationsToQueryKey(network, address, params);
    const queryFn = ({ signal })=>GetConsensusAccountsAddressDelegationsTo(network, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && address),
        ...queryOptions
    };
};
const useGetConsensusAccountsAddressDelegationsTo = (network, address, params, options)=>{
    const queryOptions = getGetConsensusAccountsAddressDelegationsToQueryOptions(network, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusAccountsAddressDebondingDelegations = (network, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/accounts/${encodeURIComponent(String(address))}/debonding_delegations`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusAccountsAddressDebondingDelegationsQueryKey = (network, address, params)=>{
    return [
        `/${network}/consensus/accounts/${address}/debonding_delegations`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusAccountsAddressDebondingDelegationsQueryOptions = (network, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusAccountsAddressDebondingDelegationsQueryKey(network, address, params);
    const queryFn = ({ signal })=>GetConsensusAccountsAddressDebondingDelegations(network, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && address),
        ...queryOptions
    };
};
const useGetConsensusAccountsAddressDebondingDelegations = (network, address, params, options)=>{
    const queryOptions = getGetConsensusAccountsAddressDebondingDelegationsQueryOptions(network, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusAccountsAddressDebondingDelegationsTo = (network, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/accounts/${encodeURIComponent(String(address))}/debonding_delegations_to`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusAccountsAddressDebondingDelegationsToQueryKey = (network, address, params)=>{
    return [
        `/${network}/consensus/accounts/${address}/debonding_delegations_to`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusAccountsAddressDebondingDelegationsToQueryOptions = (network, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusAccountsAddressDebondingDelegationsToQueryKey(network, address, params);
    const queryFn = ({ signal })=>GetConsensusAccountsAddressDebondingDelegationsTo(network, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && address),
        ...queryOptions
    };
};
const useGetConsensusAccountsAddressDebondingDelegationsTo = (network, address, params, options)=>{
    const queryOptions = getGetConsensusAccountsAddressDebondingDelegationsToQueryOptions(network, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEpochs = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/epochs`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusEpochsQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/epochs`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusEpochsQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEpochsQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusEpochs(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusEpochs = (network, params, options)=>{
    const queryOptions = getGetConsensusEpochsQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusEpochsEpoch = (network, epoch, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/epochs/${encodeURIComponent(String(epoch))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusEpochsEpochQueryKey = (network, epoch)=>{
    return [
        `/${network}/consensus/epochs/${epoch}`
    ];
};
const getGetConsensusEpochsEpochQueryOptions = (network, epoch, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusEpochsEpochQueryKey(network, epoch);
    const queryFn = ({ signal })=>GetConsensusEpochsEpoch(network, epoch, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && epoch),
        ...queryOptions
    };
};
const useGetConsensusEpochsEpoch = (network, epoch, options)=>{
    const queryOptions = getGetConsensusEpochsEpochQueryOptions(network, epoch, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusProposals = (network, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/proposals`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusProposalsQueryKey = (network, params)=>{
    return [
        `/${network}/consensus/proposals`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusProposalsQueryOptions = (network, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusProposalsQueryKey(network, params);
    const queryFn = ({ signal })=>GetConsensusProposals(network, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!network,
        ...queryOptions
    };
};
const useGetConsensusProposals = (network, params, options)=>{
    const queryOptions = getGetConsensusProposalsQueryOptions(network, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusProposalsProposalId = (network, proposalId, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/proposals/${encodeURIComponent(String(proposalId))}`,
        method: "GET",
        signal
    }, options);
};
const getGetConsensusProposalsProposalIdQueryKey = (network, proposalId)=>{
    return [
        `/${network}/consensus/proposals/${proposalId}`
    ];
};
const getGetConsensusProposalsProposalIdQueryOptions = (network, proposalId, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusProposalsProposalIdQueryKey(network, proposalId);
    const queryFn = ({ signal })=>GetConsensusProposalsProposalId(network, proposalId, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && proposalId),
        ...queryOptions
    };
};
const useGetConsensusProposalsProposalId = (network, proposalId, options)=>{
    const queryOptions = getGetConsensusProposalsProposalIdQueryOptions(network, proposalId, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetConsensusProposalsProposalIdVotes = (network, proposalId, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/consensus/proposals/${encodeURIComponent(String(proposalId))}/votes`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetConsensusProposalsProposalIdVotesQueryKey = (network, proposalId, params)=>{
    return [
        `/${network}/consensus/proposals/${proposalId}/votes`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetConsensusProposalsProposalIdVotesQueryOptions = (network, proposalId, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConsensusProposalsProposalIdVotesQueryKey(network, proposalId, params);
    const queryFn = ({ signal })=>GetConsensusProposalsProposalIdVotes(network, proposalId, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && proposalId),
        ...queryOptions
    };
};
const useGetConsensusProposalsProposalIdVotes = (network, proposalId, params, options)=>{
    const queryOptions = getGetConsensusProposalsProposalIdVotesQueryOptions(network, proposalId, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeBlocks = (network, runtime, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/blocks`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeBlocksQueryKey = (network, runtime, params)=>{
    return [
        `/${network}/${runtime}/blocks`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeBlocksQueryOptions = (network, runtime, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeBlocksQueryKey(network, runtime, params);
    const queryFn = ({ signal })=>GetRuntimeBlocks(network, runtime, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime),
        ...queryOptions
    };
};
const useGetRuntimeBlocks = (network, runtime, params, options)=>{
    const queryOptions = getGetRuntimeBlocksQueryOptions(network, runtime, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeTransactions = (network, runtime, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/transactions`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeTransactionsQueryKey = (network, runtime, params)=>{
    return [
        `/${network}/${runtime}/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeTransactionsQueryOptions = (network, runtime, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeTransactionsQueryKey(network, runtime, params);
    const queryFn = ({ signal })=>GetRuntimeTransactions(network, runtime, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime),
        ...queryOptions
    };
};
const useGetRuntimeTransactions = (network, runtime, params, options)=>{
    const queryOptions = getGetRuntimeTransactionsQueryOptions(network, runtime, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeTransactionsTxHash = (network, runtime, txHash, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/transactions/${encodeURIComponent(String(txHash))}`,
        method: "GET",
        signal
    }, options);
};
const getGetRuntimeTransactionsTxHashQueryKey = (network, runtime, txHash)=>{
    return [
        `/${network}/${runtime}/transactions/${txHash}`
    ];
};
const getGetRuntimeTransactionsTxHashQueryOptions = (network, runtime, txHash, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeTransactionsTxHashQueryKey(network, runtime, txHash);
    const queryFn = ({ signal })=>GetRuntimeTransactionsTxHash(network, runtime, txHash, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && txHash),
        ...queryOptions
    };
};
const useGetRuntimeTransactionsTxHash = (network, runtime, txHash, options)=>{
    const queryOptions = getGetRuntimeTransactionsTxHashQueryOptions(network, runtime, txHash, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeEvents = (network, runtime, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/events`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeEventsQueryKey = (network, runtime, params)=>{
    return [
        `/${network}/${runtime}/events`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeEventsQueryOptions = (network, runtime, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeEventsQueryKey(network, runtime, params);
    const queryFn = ({ signal })=>GetRuntimeEvents(network, runtime, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime),
        ...queryOptions
    };
};
const useGetRuntimeEvents = (network, runtime, params, options)=>{
    const queryOptions = getGetRuntimeEventsQueryOptions(network, runtime, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeEvmTokens = (network, runtime, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/evm_tokens`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeEvmTokensQueryKey = (network, runtime, params)=>{
    return [
        `/${network}/${runtime}/evm_tokens`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeEvmTokensQueryOptions = (network, runtime, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeEvmTokensQueryKey(network, runtime, params);
    const queryFn = ({ signal })=>GetRuntimeEvmTokens(network, runtime, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime),
        ...queryOptions
    };
};
const useGetRuntimeEvmTokens = (network, runtime, params, options)=>{
    const queryOptions = getGetRuntimeEvmTokensQueryOptions(network, runtime, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeEvmTokensAddress = (network, runtime, address, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/evm_tokens/${encodeURIComponent(String(address))}`,
        method: "GET",
        signal
    }, options);
};
const getGetRuntimeEvmTokensAddressQueryKey = (network, runtime, address)=>{
    return [
        `/${network}/${runtime}/evm_tokens/${address}`
    ];
};
const getGetRuntimeEvmTokensAddressQueryOptions = (network, runtime, address, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeEvmTokensAddressQueryKey(network, runtime, address);
    const queryFn = ({ signal })=>GetRuntimeEvmTokensAddress(network, runtime, address, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && address),
        ...queryOptions
    };
};
const useGetRuntimeEvmTokensAddress = (network, runtime, address, options)=>{
    const queryOptions = getGetRuntimeEvmTokensAddressQueryOptions(network, runtime, address, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeEvmTokensAddressHolders = (network, runtime, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/evm_tokens/${encodeURIComponent(String(address))}/holders`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeEvmTokensAddressHoldersQueryKey = (network, runtime, address, params)=>{
    return [
        `/${network}/${runtime}/evm_tokens/${address}/holders`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeEvmTokensAddressHoldersQueryOptions = (network, runtime, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeEvmTokensAddressHoldersQueryKey(network, runtime, address, params);
    const queryFn = ({ signal })=>GetRuntimeEvmTokensAddressHolders(network, runtime, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && address),
        ...queryOptions
    };
};
const useGetRuntimeEvmTokensAddressHolders = (network, runtime, address, params, options)=>{
    const queryOptions = getGetRuntimeEvmTokensAddressHoldersQueryOptions(network, runtime, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeEvmTokensAddressNfts = (network, runtime, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/evm_tokens/${encodeURIComponent(String(address))}/nfts`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeEvmTokensAddressNftsQueryKey = (network, runtime, address, params)=>{
    return [
        `/${network}/${runtime}/evm_tokens/${address}/nfts`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeEvmTokensAddressNftsQueryOptions = (network, runtime, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeEvmTokensAddressNftsQueryKey(network, runtime, address, params);
    const queryFn = ({ signal })=>GetRuntimeEvmTokensAddressNfts(network, runtime, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && address),
        ...queryOptions
    };
};
const useGetRuntimeEvmTokensAddressNfts = (network, runtime, address, params, options)=>{
    const queryOptions = getGetRuntimeEvmTokensAddressNftsQueryOptions(network, runtime, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeEvmTokensAddressNftsId = (network, runtime, address, id, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/evm_tokens/${encodeURIComponent(String(address))}/nfts/${encodeURIComponent(String(id))}`,
        method: "GET",
        signal
    }, options);
};
const getGetRuntimeEvmTokensAddressNftsIdQueryKey = (network, runtime, address, id)=>{
    return [
        `/${network}/${runtime}/evm_tokens/${address}/nfts/${id}`
    ];
};
const getGetRuntimeEvmTokensAddressNftsIdQueryOptions = (network, runtime, address, id, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeEvmTokensAddressNftsIdQueryKey(network, runtime, address, id);
    const queryFn = ({ signal })=>GetRuntimeEvmTokensAddressNftsId(network, runtime, address, id, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && address && id),
        ...queryOptions
    };
};
const useGetRuntimeEvmTokensAddressNftsId = (network, runtime, address, id, options)=>{
    const queryOptions = getGetRuntimeEvmTokensAddressNftsIdQueryOptions(network, runtime, address, id, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeAccountsAddress = (network, runtime, address, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/accounts/${encodeURIComponent(String(address))}`,
        method: "GET",
        signal
    }, options);
};
const getGetRuntimeAccountsAddressQueryKey = (network, runtime, address)=>{
    return [
        `/${network}/${runtime}/accounts/${address}`
    ];
};
const getGetRuntimeAccountsAddressQueryOptions = (network, runtime, address, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeAccountsAddressQueryKey(network, runtime, address);
    const queryFn = ({ signal })=>GetRuntimeAccountsAddress(network, runtime, address, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && address),
        ...queryOptions
    };
};
const useGetRuntimeAccountsAddress = (network, runtime, address, options)=>{
    const queryOptions = getGetRuntimeAccountsAddressQueryOptions(network, runtime, address, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeAccountsAddressNfts = (network, runtime, address, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/accounts/${encodeURIComponent(String(address))}/nfts`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetRuntimeAccountsAddressNftsQueryKey = (network, runtime, address, params)=>{
    return [
        `/${network}/${runtime}/accounts/${address}/nfts`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetRuntimeAccountsAddressNftsQueryOptions = (network, runtime, address, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeAccountsAddressNftsQueryKey(network, runtime, address, params);
    const queryFn = ({ signal })=>GetRuntimeAccountsAddressNfts(network, runtime, address, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime && address),
        ...queryOptions
    };
};
const useGetRuntimeAccountsAddressNfts = (network, runtime, address, params, options)=>{
    const queryOptions = getGetRuntimeAccountsAddressNftsQueryOptions(network, runtime, address, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetRuntimeStatus = (network, runtime, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(runtime))}/status`,
        method: "GET",
        signal
    }, options);
};
const getGetRuntimeStatusQueryKey = (network, runtime)=>{
    return [
        `/${network}/${runtime}/status`
    ];
};
const getGetRuntimeStatusQueryOptions = (network, runtime, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRuntimeStatusQueryKey(network, runtime);
    const queryFn = ({ signal })=>GetRuntimeStatus(network, runtime, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && runtime),
        ...queryOptions
    };
};
const useGetRuntimeStatus = (network, runtime, options)=>{
    const queryOptions = getGetRuntimeStatusQueryOptions(network, runtime, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetLayerStatsTxVolume = (network, layer, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(layer))}/stats/tx_volume`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetLayerStatsTxVolumeQueryKey = (network, layer, params)=>{
    return [
        `/${network}/${layer}/stats/tx_volume`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetLayerStatsTxVolumeQueryOptions = (network, layer, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLayerStatsTxVolumeQueryKey(network, layer, params);
    const queryFn = ({ signal })=>GetLayerStatsTxVolume(network, layer, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && layer),
        ...queryOptions
    };
};
const useGetLayerStatsTxVolume = (network, layer, params, options)=>{
    const queryOptions = getGetLayerStatsTxVolumeQueryOptions(network, layer, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
const GetLayerStatsActiveAccounts = (network, layer, params, options, signal)=>{
    return (0, _replaceNetworkWithBaseURLDefault.default)({
        url: `/${encodeURIComponent(String(network))}/${encodeURIComponent(String(layer))}/stats/active_accounts`,
        method: "GET",
        params,
        signal
    }, options);
};
const getGetLayerStatsActiveAccountsQueryKey = (network, layer, params)=>{
    return [
        `/${network}/${layer}/stats/active_accounts`,
        ...params ? [
            params
        ] : []
    ];
};
const getGetLayerStatsActiveAccountsQueryOptions = (network, layer, params, options)=>{
    const { query: queryOptions, request: requestOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLayerStatsActiveAccountsQueryKey(network, layer, params);
    const queryFn = ({ signal })=>GetLayerStatsActiveAccounts(network, layer, params, requestOptions, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(network && layer),
        ...queryOptions
    };
};
const useGetLayerStatsActiveAccounts = (network, layer, params, options)=>{
    const queryOptions = getGetLayerStatsActiveAccountsQueryOptions(network, layer, params, options);
    const query = (0, _reactQuery.useQuery)(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};

},{"@tanstack/react-query":"jWXOo","../replaceNetworkWithBaseURL":"6uA9h","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6uA9h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceNetworkWithBaseURL", ()=>replaceNetworkWithBaseURL);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
const replaceNetworkWithBaseURL = (config, requestOverrides)=>{
    if (config.url?.startsWith("/mainnet/")) config.url = config.url.replace("/mainnet/", "https://nexus.oasis.io/v1/");
    else if (config.url?.startsWith("/testnet/")) config.url = config.url.replace("/testnet/", "https://testnet.nexus.oasis.io/v1/");
    else throw new Error(`Expected URL to be prefixed with network: ${config.url}`);
    return (0, _axiosDefault.default)({
        ...config,
        ...requestOverrides
    });
};
exports.default = replaceNetworkWithBaseURL;

},{"axios":"i7Tjc","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"898HF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ticker", ()=>Ticker);
parcelHelpers.export(exports, "NativeToken", ()=>NativeToken);
parcelHelpers.export(exports, "getNameForTicker", ()=>getNameForTicker);
const Ticker = {
    ROSE: "ROSE",
    TEST: "TEST",
    EUROe: "EUROe"
};
const NativeToken = {
    ROSE: {
        ticker: Ticker.ROSE,
        geckoId: "oasis-network"
    },
    TEST: {
        ticker: Ticker.TEST,
        free: true
    },
    EUROe: {
        ticker: Ticker.EUROe,
        geckoId: "euroe-stablecoin"
    }
};
const getNameForTicker = (_t, ticker)=>{
    // TODO: how do we translate ticker names?
    return ticker;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"giSFO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRPCAccountBalances", ()=>getRPCAccountBalances);
var _client = require("@oasisprotocol/client");
var _clientRt = require("@oasisprotocol/client-rt");
var _network = require("../../types/network");
var _config = require("../../config");
var _helpers = require("./helpers");
const grpcUrls = {
    [(0, _network.Network).mainnet]: "https://grpc.oasis.dev",
    [(0, _network.Network).testnet]: "https://testnet.grpc.oasis.dev"
};
async function getRPCAccountBalances(oasisAddress, scope) {
    const paratimeConfig = (0, _config.paraTimesConfig)[scope.layer][scope.network];
    if (!paratimeConfig.runtimeId) throw new Error("Paratime is not configured");
    const nic = new _client.client.NodeInternal(grpcUrls[scope.network]);
    const accountsWrapper = new _clientRt.accounts.Wrapper(_client.misc.fromHex(paratimeConfig.runtimeId));
    const rawBalances = (await accountsWrapper.queryBalances().setArgs({
        address: _client.staking.addressFromBech32(oasisAddress)
    }).query(nic)).balances;
    return [
        ...rawBalances.entries()
    ].map(([denomination, amount])=>{
        return {
            balance: _client.quantity.toBigInt(amount).toString(),
            token_symbol: _client.misc.toStringUTF8(denomination) || (0, _config.getTokensForScope)(scope)[0].ticker,
            token_decimals: (0, _config.paraTimesConfig)[scope.layer].decimals
        };
    }).map((token)=>{
        return {
            ...token,
            balance: (0, _helpers.fromBaseUnits)(token.balance, token.token_decimals)
        };
    });
}

},{"@oasisprotocol/client":"1ax6t","@oasisprotocol/client-rt":"6GV4q","../../types/network":"f0o8N","../../config":"2PXMY","./helpers":"2aVNs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f0o8N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Network", ()=>Network);
parcelHelpers.export(exports, "getNetworkNames", ()=>getNetworkNames);
parcelHelpers.export(exports, "getFilterForNetwork", ()=>getFilterForNetwork);
parcelHelpers.export(exports, "getInverseFilterForNetwork", ()=>getInverseFilterForNetwork);
parcelHelpers.export(exports, "isOnMainnet", ()=>isOnMainnet);
parcelHelpers.export(exports, "isNotOnMainnet", ()=>isNotOnMainnet);
parcelHelpers.export(exports, "isOnTestnet", ()=>isOnTestnet);
parcelHelpers.export(exports, "isNotMainnet", ()=>isNotMainnet);
const Network = {
    mainnet: "mainnet",
    testnet: "testnet"
};
const getNetworkNames = (t)=>({
        [Network.mainnet]: t("common.mainnet"),
        [Network.testnet]: t("common.testnet")
    });
const getFilterForNetwork = (network)=>(item)=>item.network === network;
const getInverseFilterForNetwork = (network)=>(item)=>item.network !== network;
const isOnMainnet = getFilterForNetwork(Network.mainnet);
const isNotOnMainnet = getInverseFilterForNetwork(Network.mainnet);
const isOnTestnet = getFilterForNetwork(Network.testnet);
const isNotMainnet = (network)=>network !== Network.mainnet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bnM2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchSuggestionTerms", ()=>searchSuggestionTerms);
parcelHelpers.export(exports, "textSearchMininumLength", ()=>textSearchMininumLength);
parcelHelpers.export(exports, "validateAndNormalize", ()=>validateAndNormalize);
parcelHelpers.export(exports, "isSearchValid", ()=>isSearchValid);
parcelHelpers.export(exports, "getSearchTermFromRequest", ()=>getSearchTermFromRequest);
parcelHelpers.export(exports, "useParamSearch", ()=>useParamSearch);
var _reactRouterDom = require("react-router-dom");
var _helpers = require("../../utils/helpers");
var _routeUtils = require("../../utils/route-utils");
var _errors = require("../../../types/errors");
var _useScopeParam = require("../../hooks/useScopeParam");
const searchSuggestionTerms = {
    mainnet: {
        emerald: {
            suggestedBlock: "4260",
            suggestedTransaction: "0x2f461f83745e1fa1177138aa815e210e1c69305db8065af9015b2e490a5033f1",
            suggestedAccount: "0x0266562AB0aE2a80C14373029a70F73A9A3dB9d3",
            suggestedTokenFragment: "yuzu"
        },
        sapphire: {
            suggestedBlock: "4260",
            suggestedTransaction: "0x5900415a3fbb39325d5dfe145d1eccd1586a2afe12a204de34ecac0c808ac3f7",
            suggestedAccount: "0x90adE3B7065fa715c7a150313877dF1d33e777D5",
            suggestedTokenFragment: "mock"
        },
        cipher: undefined,
        pontusx: undefined,
        consensus: undefined
    },
    testnet: {
        emerald: {
            suggestedBlock: "1398623",
            suggestedTransaction: "0x7b118fadc9e6569b933edf3a9b8c442eb145fc22613bc11111b8aeb223d4e271",
            suggestedAccount: "0x6d5A9A4C063b840ef3fe792E5DD6232fbf2c0982",
            suggestedTokenFragment: "yuzu"
        },
        sapphire: {
            suggestedBlock: "4260",
            suggestedTransaction: "0xd9b5c08be1cb74229abedd9b3e1afb8b43228085a6abf72993db415959ab6b35",
            suggestedAccount: "0xfA3AC9f65C9D75EE3978ab76c6a1105f03156204",
            suggestedTokenFragment: "USD"
        },
        cipher: undefined,
        pontusx: {
            suggestedBlock: "390632",
            suggestedTransaction: "0x244f71bcc67a0359c0d1e417b302ec3b358193769399e71f0112c58135f0fc82",
            suggestedAccount: "0xC09c6A1d5538E7ed135d6146241c8da11e92130B",
            suggestedTokenFragment: "Ocean"
        },
        consensus: undefined
    }
};
const textSearchMininumLength = 3;
const validateAndNormalize = {
    blockHeight: (searchTerm)=>{
        // Remove localized digit group separators
        if ((0, _helpers.isValidBlockHeight)(searchTerm.replaceAll(/[^0-9a-zA-Z]/g, ""))) return searchTerm.replaceAll(/[^0-9a-zA-Z]/g, "");
    },
    blockHash: (searchTerm)=>{
        if ((0, _helpers.isValidBlockHash)(searchTerm.toLowerCase().replace("0x", ""))) return searchTerm.toLowerCase().replace("0x", "");
        if ((0, _helpers.isValidBlockHash)(searchTerm.toLowerCase())) return searchTerm.toLowerCase();
    },
    // TODO: do we need to differentiate between consensus and evm hashes?
    // TODO: normalize to 0x prefix for evm?
    txHash: (searchTerm)=>{
        if ((0, _helpers.isValidTxHash)(searchTerm.toLowerCase().replace("0x", ""))) return searchTerm.toLowerCase().replace("0x", "");
        if ((0, _helpers.isValidTxHash)(searchTerm.toLowerCase())) return searchTerm.toLowerCase();
    },
    consensusAccount: (searchTerm)=>{
        if ((0, _helpers.isValidOasisAddress)(searchTerm.replace(/\s/g, "").toLowerCase())) return searchTerm.replace(/\s/g, "").toLowerCase();
    },
    evmAccount: (searchTerm)=>{
        if ((0, _helpers.isValidEthAddress)(`0x${searchTerm}`)) return `0x${searchTerm.toLowerCase()}`;
        if ((0, _helpers.isValidEthAddress)(searchTerm)) return searchTerm.toLowerCase();
    },
    evmBech32Account: (searchTerm)=>{
        const evmAccount = validateAndNormalize.evmAccount(searchTerm);
        if (evmAccount) // TODO: remove conversion when API supports querying by EVM address
        return (0, _helpers.getEvmBech32Address)(evmAccount);
    },
    evmTokenNameFragment: (searchTerm)=>{
        if (searchTerm?.length >= textSearchMininumLength) return searchTerm.toLowerCase();
    },
    networkProposalNameFragment: (searchTerm)=>{
        if (searchTerm?.length >= textSearchMininumLength) return searchTerm.toLowerCase();
    }
};
function isSearchValid(searchTerm) {
    return Object.values(validateAndNormalize).some((fn)=>!!fn(searchTerm));
}
const getSearchTermFromRequest = (request)=>new URL(request.url).searchParams.get("q")?.trim() ?? "";
const useParamSearch = ()=>{
    const network = (0, _useScopeParam.useNetworkParam)();
    if (!!network && !(0, _routeUtils.RouteUtils).getEnabledNetworks().includes(network)) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidUrl);
    const searchTerm = (0, _reactRouterDom.useSearchParams)()[0].get("q")?.trim() ?? "";
    const normalized = Object.fromEntries(Object.entries(validateAndNormalize).map(([key, fn])=>[
            key,
            fn(searchTerm)
        ]));
    return {
        searchTerm,
        ...normalized
    };
};

},{"react-router-dom":"5o0mA","../../utils/helpers":"2aVNs","../../utils/route-utils":"b2kKi","../../../types/errors":"gdpNU","../../hooks/useScopeParam":"kKMKx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kKMKx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNetworkParam", ()=>useNetworkParam);
parcelHelpers.export(exports, "useScopeParam", ()=>useScopeParam);
parcelHelpers.export(exports, "useRequiredScopeParam", ()=>useRequiredScopeParam);
var _reactRouterDom = require("react-router-dom");
var _errors = require("../../types/errors");
const useNetworkParam = ()=>{
    const { network } = (0, _reactRouterDom.useParams)();
    return network;
};
const useScopeParam = ()=>{
    const runtimeScope = (0, _reactRouterDom.useRouteLoaderData)("runtimeScope");
    const consensusScope = (0, _reactRouterDom.useRouteLoaderData)("consensusScope");
    return runtimeScope ?? consensusScope ?? undefined;
};
const useRequiredScopeParam = ()=>{
    const scope = useScopeParam();
    if (!scope) throw new (0, _errors.AppError)((0, _errors.AppErrors).UnsupportedNetwork);
    return scope;
};

},{"react-router-dom":"5o0mA","../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gWCJy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFilterForLayer", ()=>getFilterForLayer);
parcelHelpers.export(exports, "orderByLayer", ()=>orderByLayer);
parcelHelpers.export(exports, "doesLayerSupportEncryptedTransactions", ()=>doesLayerSupportEncryptedTransactions);
parcelHelpers.export(exports, "doesAnyOfTheseLayersSupportEncryptedTransactions", ()=>doesAnyOfTheseLayersSupportEncryptedTransactions);
parcelHelpers.export(exports, "isLayerHidden", ()=>isLayerHidden);
parcelHelpers.export(exports, "isNotOnHiddenLayer", ()=>isNotOnHiddenLayer);
var _helpers = require("../app/utils/helpers");
// Here we need to import from the generated code, in order to break
// a cycle of imports which confuse jest
// eslint-disable-next-line no-restricted-imports
var _api = require("../oasis-nexus/generated/api");
const getFilterForLayer = (layer)=>(item)=>item.layer === layer;
const layerOrder = {
    [(0, _api.Layer).consensus]: 1,
    [(0, _api.Layer).sapphire]: 2,
    [(0, _api.Layer).emerald]: 3,
    [(0, _api.Layer).cipher]: 4,
    [(0, _api.Layer).pontusx]: 5
};
const hiddenLayers = [
    (0, _api.Layer).pontusx
];
const orderByLayer = (itemA, itemB)=>layerOrder[itemA.layer] - layerOrder[itemB.layer];
const layersWithEncryptedTransactions = [
    (0, _api.Layer).sapphire,
    (0, _api.Layer).cipher
];
const doesLayerSupportEncryptedTransactions = (layer)=>layersWithEncryptedTransactions.includes(layer);
const doesAnyOfTheseLayersSupportEncryptedTransactions = (layers)=>(0, _helpers.uniq)(layers).some(doesLayerSupportEncryptedTransactions);
const isLayerHidden = (layer)=>hiddenLayers.includes(layer);
const isNotOnHiddenLayer = (item)=>!isLayerHidden(item.layer);

},{"../app/utils/helpers":"2aVNs","../oasis-nexus/generated/api":"ckZaB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6SCXD":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("dcf8064735de4cc9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("15ba16bbd3f4e545"));
var _jsxRuntime = require("e6bda49c3e2c6fd");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "HighlightOff");

},{"dcf8064735de4cc9":"hykHy","15ba16bbd3f4e545":"gQLSP","e6bda49c3e2c6fd":"g88cO"}],"dRT6j":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("7b6bec045d2c0e45");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("a0755c411e3b87b1"));
var _jsxRuntime = require("21c44aa95307b304");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error");

},{"7b6bec045d2c0e45":"hykHy","a0755c411e3b87b1":"gQLSP","21c44aa95307b304":"g88cO"}],"bYx0X":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("8ee63de35adad671");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("844049b74d6acb38"));
var _jsxRuntime = require("59ceb3871d77d8c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning");

},{"8ee63de35adad671":"hykHy","844049b74d6acb38":"gQLSP","59ceb3871d77d8c":"g88cO"}],"hLmKV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _iconButtonDefault.default));
parcelHelpers.export(exports, "iconButtonClasses", ()=>(0, _iconButtonClassesDefault.default));
var _iconButton = require("./IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _iconButtonClasses = require("./iconButtonClasses");
var _iconButtonClassesDefault = parcelHelpers.interopDefault(_iconButtonClasses);
parcelHelpers.exportAll(_iconButtonClasses, exports);
"use client";

},{"./IconButton":"7qQAV","./iconButtonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7qQAV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _iconButtonClasses = require("./iconButtonClasses");
var _iconButtonClassesDefault = parcelHelpers.interopDefault(_iconButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, color, edge, size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, _capitalizeDefault.default)(color)}`,
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _iconButtonClasses.getIconButtonUtilityClass), classes);
};
const IconButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, _capitalizeDefault.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme, ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, _extendsDefault.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, _extendsDefault.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, _extendsDefault.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, _iconButtonClassesDefault.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const IconButton = /*#__PURE__*/ _react.forwardRef(function IconButton(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge = false, children, className, color = "default", disabled = false, disableFocusRipple = false, size = "medium" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        edge,
        color,
        disabled,
        disableFocusRipple,
        size
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconButtonRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
exports.default = IconButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/chainPropTypes":"8qu3z","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../ButtonBase":"1prwn","../utils/capitalize":"iHgWG","./iconButtonClasses":"jCMPb","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jCMPb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconButtonUtilityClass", ()=>getIconButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getIconButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiIconButton", slot);
}
const iconButtonClasses = (0, _generateUtilityClassesDefault.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
exports.default = iconButtonClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9eJ5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuggestionButton", ()=>SuggestionButton);
parcelHelpers.export(exports, "SearchSuggestionsButtons", ()=>SearchSuggestionsButtons);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactI18Next = require("react-i18next");
var _colors = require("../../../styles/theme/colors");
var _widgets = require("@mui/icons-material/Widgets");
var _widgetsDefault = parcelHelpers.interopDefault(_widgets);
var _repeat = require("@mui/icons-material/Repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _accountBalanceWallet = require("@mui/icons-material/AccountBalanceWallet");
var _accountBalanceWalletDefault = parcelHelpers.interopDefault(_accountBalanceWallet);
var _token = require("@mui/icons-material/Token");
var _tokenDefault = parcelHelpers.interopDefault(_token);
var _searchUtils = require("./search-utils");
var _optionalBreak = require("../OptionalBreak");
const PlainTextButton = (0, _styles.styled)((0, _buttonDefault.default))({
    fontSize: "inherit",
    textTransform: "none",
    paddingLeft: 0,
    paddingRight: 0,
    minWidth: 0,
    height: "1em"
});
PlainTextButton.defaultProps = {
    variant: "text",
    color: "inherit"
};
const SuggestionButton = (0, _styles.styled)(PlainTextButton)({
    gap: "0.2ch"
});
const SearchSuggestionsButtons = ({ scope, onClickSuggestion })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { suggestedBlock, suggestedTransaction, suggestedAccount, suggestedTokenFragment } = (scope?.network && scope?.layer && (0, _searchUtils.searchSuggestionTerms)[scope.network][scope.layer]) ?? (0, _searchUtils.searchSuggestionTerms)["mainnet"]["sapphire"];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            component: "span",
            sx: {
                color: (0, _colors.COLORS).grayExtraDark,
                fontSize: 12
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                t: t,
                i18nKey: "search.searchSuggestions",
                components: {
                    OptionalBreak: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionalBreak.OptionalBreak), {}),
                    BlockIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetsDefault.default), {
                        sx: {
                            fontSize: "18px"
                        }
                    }),
                    BlockLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SuggestionButton, {
                        onClick: ()=>onClickSuggestion(suggestedBlock)
                    }),
                    TransactionIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repeatDefault.default), {
                        sx: {
                            fontSize: "18px"
                        }
                    }),
                    TransactionLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SuggestionButton, {
                        onClick: ()=>onClickSuggestion(suggestedTransaction)
                    }),
                    AccountIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountBalanceWalletDefault.default), {
                        sx: {
                            fontSize: "18px"
                        }
                    }),
                    AccountLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SuggestionButton, {
                        onClick: ()=>onClickSuggestion(suggestedAccount)
                    }),
                    TokenIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDefault.default), {
                        sx: {
                            fontSize: "18px"
                        }
                    }),
                    TokenLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SuggestionButton, {
                        onClick: ()=>onClickSuggestion(suggestedTokenFragment)
                    })
                }
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@mui/material/Button":"h2G5p","react-i18next":"e210a","../../../styles/theme/colors":"hYvW2","@mui/icons-material/Widgets":"6Adxk","@mui/icons-material/Repeat":"cnQ0o","@mui/icons-material/AccountBalanceWallet":"409sQ","@mui/icons-material/Token":"3Dzi3","./search-utils":"bnM2G","../OptionalBreak":"2mW6j","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6Adxk":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("1080c4e50d3ab655");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("764dbb38799534c1"));
var _jsxRuntime = require("40ca61582dd8941a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M13 13v8h8v-8zM3 21h8v-8H3zM3 3v8h8V3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66z"
}), "Widgets");

},{"1080c4e50d3ab655":"hykHy","764dbb38799534c1":"gQLSP","40ca61582dd8941a":"g88cO"}],"cnQ0o":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("f2ba5442151c527f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("a69268133f629431"));
var _jsxRuntime = require("3359631754f3d27");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 7h10v3l4-4-4-4v3H5v6h2zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2z"
}), "Repeat");

},{"f2ba5442151c527f":"hykHy","a69268133f629431":"gQLSP","3359631754f3d27":"g88cO"}],"409sQ":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("ef1c238faa54acb7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("f05345f958bd44fc"));
var _jsxRuntime = require("933fbac9ee15476e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2zm-9-2h10V8H12zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
}), "AccountBalanceWallet");

},{"ef1c238faa54acb7":"hykHy","f05345f958bd44fc":"gQLSP","933fbac9ee15476e":"g88cO"}],"3Dzi3":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("e08e62ee11d61a8e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("589f71378ec3275f"));
var _jsxRuntime = require("86b22aab119f8670");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19.97 6.43 12 2 4.03 6.43 9.1 9.24C9.83 8.48 10.86 8 12 8s2.17.48 2.9 1.24zM10 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2m1 9.44L3 17V8.14l5.13 2.85c-.09.32-.13.66-.13 1.01 0 1.86 1.27 3.43 3 3.87zm2 0v-5.57c1.73-.44 3-2.01 3-3.87 0-.35-.04-.69-.13-1.01L21 8.14V17z"
}), "Token");

},{"e08e62ee11d61a8e":"hykHy","589f71378ec3275f":"gQLSP","86b22aab119f8670":"g88cO"}],"2mW6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionalBreak", ()=>OptionalBreak);
var _styles = require("@mui/material/styles");
const OptionalBreak = (0, _styles.styled)("span")({
    display: "inline-block"
});

},{"@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i3yrR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _defaultTheme.defaultTheme));
parcelHelpers.export(exports, "testnetTheme", ()=>(0, _theme.testnetTheme));
parcelHelpers.export(exports, "tooltipDelay", ()=>tooltipDelay);
parcelHelpers.export(exports, "typingDelay", ()=>typingDelay);
parcelHelpers.export(exports, "getThemesForNetworks", ()=>getThemesForNetworks);
var _network = require("../../types/network");
var _defaultTheme = require("./defaultTheme");
var _theme = require("./testnet/theme");
const tooltipDelay = 500;
const typingDelay = 1000;
const getThemesForNetworks = ()=>({
        [(0, _network.Network).mainnet]: (0, _defaultTheme.defaultTheme),
        [(0, _network.Network).testnet]: (0, _theme.testnetTheme)
    });

},{"../../types/network":"f0o8N","./defaultTheme":"jzWWg","./testnet/theme":"lY0f3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jzWWg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTheme", ()=>defaultTheme);
var _styles = require("@mui/material/styles");
var _colors = require("./colors");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _inputBase = require("@mui/material/InputBase");
var _inputAdornment = require("@mui/material/InputAdornment");
var _tab = require("@mui/material/Tab");
var _menuItem = require("@mui/material/MenuItem");
var _switch = require("@mui/material/Switch");
var _buttonBase = require("@mui/material/ButtonBase");
const defaultTheme = (0, _styles.createTheme)({
    breakpoints: {
        values: {
            ...(0, _styles.createTheme)().breakpoints.values,
            lg: 1024
        }
    },
    palette: {
        background: {
            default: (0, _colors.COLORS).brandDark,
            empty: (0, _colors.COLORS).brandExtraDark
        },
        layout: {
            main: (0, _colors.COLORS).white,
            border: (0, _colors.COLORS).brandDark,
            contrastMain: (0, _colors.COLORS).brandExtraDark,
            contrastSecondary: (0, _colors.COLORS).white,
            darkBorder: (0, _colors.COLORS).brandExtraDark,
            hoverBorder: (0, _colors.COLORS).white,
            lightBorder: (0, _colors.COLORS).aqua,
            secondary: (0, _colors.COLORS).brandDark,
            primaryBackground: (0, _colors.COLORS).brandExtraDark,
            secondaryBackground: (0, _colors.COLORS).iconBackground,
            networkBubbleBorder: (0, _colors.COLORS).white,
            titleOnBackground: (0, _colors.COLORS).white,
            graphZoomOutText: (0, _colors.COLORS).white,
            helpScreenIconColor: (0, _colors.COLORS).aqua
        },
        primary: {
            main: (0, _colors.COLORS).brandMedium
        },
        secondary: {
            main: (0, _colors.COLORS).lightSilver
        },
        success: {
            main: (0, _colors.COLORS).eucalyptus,
            contrastText: (0, _colors.COLORS).white
        },
        tertiary: {
            main: (0, _colors.COLORS).brandLight,
            contrastText: (0, _colors.COLORS).white
        }
    },
    spacing: [
        0,
        2,
        4,
        8,
        16,
        32,
        64,
        128
    ],
    typography: {
        fontFamily: `"Figtree Variable", "Helvetica", "Arial", sans-serif`,
        fontWeightLight: 200,
        fontWeightRegular: 400,
        fontWeightBold: 700,
        body2: {
            fontSize: "16px"
        },
        h1: {
            fontSize: "24px",
            fontWeight: 500,
            lineHeight: "140%",
            color: (0, _colors.COLORS).brandExtraDark
        },
        h2: {
            fontSize: "24px",
            fontWeight: 600,
            lineHeight: "32px",
            color: (0, _colors.COLORS).brandExtraDark
        },
        h3: {
            fontSize: "24px",
            fontWeight: 600,
            lineHeight: "32px",
            color: (0, _colors.COLORS).brandExtraDark
        },
        h4: {
            fontSize: "18px",
            fontWeight: 700,
            color: (0, _colors.COLORS).brandExtraDark,
            lineHeight: "22px"
        },
        h5: {
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "24px",
            color: (0, _colors.COLORS).brandExtraDark
        },
        caption: {
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            color: (0, _colors.COLORS).brandExtraDark
        }
    },
    components: {
        MuiAlert: {
            variants: [
                {
                    props: {
                        severity: "error"
                    },
                    style: ()=>({
                            color: (0, _colors.COLORS).errorIndicatorBackground
                        })
                },
                {
                    props: {
                        severity: "warning"
                    },
                    style: ()=>({
                            color: (0, _colors.COLORS).warningColor,
                            backgroundColor: (0, _colors.COLORS).warningBackground
                        })
                }
            ],
            styleOverrides: {
                root: ({ theme })=>({
                        alignItems: "center",
                        padding: theme.spacing(2, 3),
                        borderRadius: 10
                    }),
                icon: {
                    padding: 0
                },
                message: {
                    padding: 0
                }
            }
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(0, 0, 0, 0.9)"
                }
            }
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    fontSize: "18px",
                    lineHeight: "23px",
                    height: "47px",
                    borderRadius: 47,
                    textTransform: "capitalize",
                    "&:disabled": {
                        backgroundColor: (0, _colors.COLORS).lavenderGray,
                        color: (0, _colors.COLORS).white
                    }
                },
                containedPrimary: {
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: (0, _colors.COLORS).grayMediumLight,
                    ":disabled": {
                        backgroundColor: (0, _colors.COLORS).disabledPrimaryBackground,
                        color: (0, _colors.COLORS).disabledPrimaryText,
                        borderColor: (0, _colors.COLORS).grayMediumLight
                    },
                    "&:hover, &:focus-visible": {
                        backgroundColor: (0, _colors.COLORS).brandLight,
                        borderColor: (0, _colors.COLORS).brandLight
                    },
                    "&:active": {
                        backgroundColor: (0, _colors.COLORS).brandExtraDark,
                        borderColor: (0, _colors.COLORS).brandExtraDark
                    }
                },
                outlinedSecondary: {
                    borderColor: (0, _colors.COLORS).brandExtraDark,
                    color: (0, _colors.COLORS).brandExtraDark,
                    backgroundColor: (0, _colors.COLORS).white,
                    ":disabled": {
                        backgroundColor: (0, _colors.COLORS).disabledPrimaryBackground,
                        color: (0, _colors.COLORS).disabledPrimaryText,
                        borderColor: (0, _colors.COLORS).grayMediumLight
                    },
                    "&:hover, &:focus-visible": {
                        backgroundColor: (0, _colors.COLORS).grayMediumLight,
                        borderColor: (0, _colors.COLORS).brandExtraDark
                    },
                    "&:active": {
                        backgroundColor: (0, _colors.COLORS).grayMedium,
                        borderColor: (0, _colors.COLORS).brandExtraDark
                    }
                },
                textPrimary: {
                    color: (0, _colors.COLORS).brandDark,
                    "&&:hover, &&:focus-visible, &&:active": {
                        color: (0, _colors.COLORS).brandExtraDark,
                        backgroundColor: "transparent",
                        textDecoration: "underline"
                    }
                },
                textSizeMedium: {
                    fontSize: "16px"
                },
                textSizeSmall: {
                    fontSize: "14px"
                }
            },
            variants: [
                {
                    props: {
                        color: "primary"
                    },
                    style: ()=>({
                            "&:hover, &:focus-visible": {
                                backgroundColor: (0, _colors.COLORS).brandDark
                            },
                            "&:active": {
                                backgroundColor: (0, _colors.COLORS).brandExtraDark
                            }
                        })
                },
                {
                    props: {
                        color: "secondary"
                    },
                    style: ()=>({
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: (0, _colors.COLORS).brandExtraDark,
                            "&:hover, &:focus-visible": {
                                backgroundColor: (0, _colors.COLORS).platinum
                            },
                            "&:active": {
                                backgroundColor: (0, _colors.COLORS).brightGray2
                            },
                            "&:disabled": {
                                border: "none"
                            }
                        })
                },
                {
                    props: {
                        color: "secondary",
                        variant: "contained"
                    },
                    style: ()=>({
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: (0, _colors.COLORS).grayLight,
                            backgroundColor: (0, _colors.COLORS).brandExtraDark,
                            color: (0, _colors.COLORS).white,
                            "&:hover, &:focus-visible": {
                                borderColor: (0, _colors.COLORS).brandExtraDark,
                                backgroundColor: (0, _colors.COLORS).white,
                                color: (0, _colors.COLORS).brandExtraDark
                            }
                        })
                },
                {
                    props: {
                        color: "secondary",
                        variant: "text"
                    },
                    style: ()=>({
                            color: (0, _colors.COLORS).white,
                            borderWidth: "0",
                            backgroundColor: "transparent",
                            "&:hover, &:focus-visible": {
                                backgroundColor: "transparent"
                            },
                            "&:disabled": {
                                backgroundColor: "transparent"
                            }
                        })
                },
                {
                    props: {
                        color: "tertiary"
                    },
                    style: ()=>({
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderColor: (0, _colors.COLORS).brandLight,
                            backgroundColor: (0, _colors.COLORS).brandLight,
                            "&:hover, &:focus-visible": {
                                backgroundColor: (0, _colors.COLORS).brandExtraDark,
                                borderColor: (0, _colors.COLORS).brandExtraDark
                            },
                            "&:active": {
                                backgroundColor: (0, _colors.COLORS).brandExtraDark,
                                borderColor: (0, _colors.COLORS).brandExtraDark
                            },
                            "&:disabled": {
                                border: "none"
                            }
                        })
                }
            ]
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    // Fixes accessibility: MUI relied on ripples to show focus.
                    "&:focus-visible": {
                        outline: "revert"
                    }
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                switchBase: {
                    // Fixes accessibility: MUI relied on ripples to show focus.
                    // https://css-tricks.com/copy-the-browsers-native-focus-styles/
                    [`&.${(0, _buttonBase.buttonBaseClasses).focusVisible} .${(0, _switch.switchClasses).thumb}`]: (0, _styles.css)`
            outline: 5px auto Highlight;
            outline: 5px auto -webkit-focus-ring-color;
          `
                }
            }
        },
        MuiCard: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: ({ theme })=>({
                        borderRadius: 12,
                        [theme.breakpoints.down("sm")]: {
                            marginBottom: theme.spacing(4),
                            padding: theme.spacing(4, 4, 0),
                            ":has(table)": {
                                paddingRight: 0
                            }
                        },
                        [theme.breakpoints.up("sm")]: {
                            marginBottom: theme.spacing(5),
                            padding: theme.spacing(5, 5, 0)
                        }
                    })
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: 0
                }
            }
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                li: {
                    fontSize: "24px"
                },
                separator: {
                    color: (0, _colors.COLORS).brandDark,
                    fontSize: "24px",
                    paddingRight: 3,
                    paddingLeft: 3
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: ({ theme })=>({
                        color: (0, _colors.COLORS).brandExtraDark,
                        fontSize: "24px",
                        margin: 0,
                        paddingBottom: theme.spacing(4),
                        paddingLeft: 0,
                        paddingTop: 0,
                        paddingRight: 0,
                        [theme.breakpoints.down("sm")]: {
                            paddingRight: theme.spacing(4)
                        }
                    }),
                action: {
                    margin: 0,
                    fontWeight: 400,
                    fontSize: "16px",
                    color: (0, _colors.COLORS).brandExtraDark
                },
                title: {
                    fontWeight: 700
                },
                subheader: {
                    fontStyle: "italic",
                    color: (0, _colors.COLORS).grayMedium
                }
            }
        },
        MuiChip: {
            variants: [
                {
                    props: {
                        color: "tertiary"
                    },
                    style: ()=>({
                            color: (0, _colors.COLORS).brandExtraDark,
                            backgroundColor: (0, _colors.COLORS).purpleBackground,
                            borderColor: (0, _colors.COLORS).brandDark
                        })
                },
                {
                    props: {
                        color: "primary"
                    },
                    style: ({ theme })=>({
                            color: (0, _colors.COLORS).grayMedium,
                            backgroundColor: (0, _colors.COLORS).grayMediumLight,
                            borderColor: (0, _colors.COLORS).grayMedium,
                            borderWidth: theme.spacing(1)
                        })
                },
                {
                    props: {
                        variant: "outlined-selected",
                        color: "secondary"
                    },
                    style: ()=>({
                            border: `solid 1px ${(0, _colors.COLORS).grayMediumLight}`,
                            backgroundColor: (0, _colors.COLORS).grayMediumLight,
                            ":hover, :focus-visible": {
                                backgroundColor: (0, _colors.COLORS).grayMediumLight
                            }
                        })
                }
            ],
            styleOverrides: {
                colorSecondary: {
                    color: (0, _colors.COLORS).brandExtraDark
                },
                root: ({ theme })=>({
                        fontSize: "15px",
                        lineHeight: "18px",
                        fontWeight: 400,
                        borderRadius: 9,
                        gap: 2,
                        padding: theme.spacing(3)
                    }),
                label: {
                    padding: 0
                },
                icon: {
                    marginLeft: 0,
                    marginRight: 2
                }
            }
        },
        MuiDivider: {
            variants: [
                {
                    props: {
                        variant: "layout"
                    },
                    style: ({ theme })=>({
                            // More customizable than borderStyle: 'dashed',
                            borderImage: `repeating-linear-gradient(90deg, ${theme.palette.layout.main}, ${theme.palette.layout.main} 5px, transparent 5px, transparent 12px) 1`,
                            marginBottom: theme.spacing(5)
                        })
                },
                {
                    props: {
                        variant: "card"
                    },
                    style: ({ theme })=>({
                            // More customizable than borderStyle: 'dashed',
                            borderImage: `repeating-linear-gradient(90deg, ${(0, _colors.COLORS).brandDark}, ${(0, _colors.COLORS).brandDark} 5px, transparent 5px, transparent 12px) 1`,
                            margin: "40px -12px",
                            [theme.breakpoints.down("sm")]: {
                                margin: "20px -12px"
                            }
                        })
                }
            ]
        },
        MuiDrawer: {
            styleOverrides: {
                paperAnchorTop: ({ theme })=>({
                        borderRadius: "0 0 12px 12px",
                        padding: theme.spacing(4, "5%")
                    }),
                paper: ({ theme })=>({
                        [theme.breakpoints.down("md")]: {
                            height: "100vh"
                        }
                    })
            }
        },
        MuiImageList: {
            styleOverrides: {
                root: ({ theme })=>({
                        [theme.breakpoints.up("sm")]: {
                            // default gridTemplateColumns is set by cols prop default number via inline styles
                            // and cannot be overridden without !important statement
                            gridTemplateColumns: `repeat(auto-fill, minmax(210px, auto))!important`
                        }
                    })
            }
        },
        MuiImageListItem: {
            styleOverrides: {
                root: {
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: (0, _colors.COLORS).brandExtraDark,
                    borderRadius: 8,
                    overflow: "hidden",
                    transition: "border-color, box-shadow 250ms ease-in-out",
                    "&:hover, &:focus-visible": {
                        boxShadow: "0px 8px 8px 0px rgba(0, 0, 0, 0.15)",
                        borderColor: (0, _colors.COLORS).brandDark
                    }
                }
            }
        },
        MuiImageListItemBar: {
            styleOverrides: {
                root: ({ theme })=>({
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    })
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: (0, _colors.COLORS).brandDark,
                    fontWeight: 700,
                    textDecoration: "none"
                }
            }
        },
        MuiPaper: {
            variants: [
                {
                    props: {
                        variant: "content"
                    },
                    style: ({ theme })=>({
                            backgroundColor: (0, _colors.COLORS).brightGray,
                            boxShadow: "none",
                            color: (0, _colors.COLORS).darkBlueGray,
                            padding: theme.spacing(4)
                        })
                }
            ],
            styleOverrides: {
                root: ()=>({
                        borderRadius: 12
                    })
            }
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    backgroundColor: (0, _colors.COLORS).grayLight,
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: (0, _colors.COLORS).vistaBlue,
                    borderRadius: 5
                },
                bar: {
                    borderRadius: 5
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: ({ theme })=>({
                        [theme.breakpoints.down("sm")]: {
                            paddingRight: theme.spacing(4),
                            // force scrollbar to cover the whole table horizontally
                            marginLeft: `-${theme.spacing(4)}`,
                            width: `calc(100% + ${theme.spacing(4)})`
                        }
                    })
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: ({ theme })=>({
                        borderColor: (0, _colors.COLORS).antiFlashWhite2,
                        color: (0, _colors.COLORS).grayExtraDark,
                        whiteSpace: "nowrap",
                        padding: theme.spacing(4, 3),
                        a: {
                            color: (0, _colors.COLORS).brandDark,
                            fontWeight: 700,
                            textDecoration: "none"
                        }
                    }),
                head: {
                    border: 0,
                    color: (0, _colors.COLORS).grayDark,
                    fontWeight: 400
                }
            }
        },
        MuiTooltip: {
            defaultProps: {
                TransitionComponent: (0, _fadeDefault.default),
                TransitionProps: {
                    timeout: 600
                }
            },
            styleOverrides: {
                arrow: {
                    color: (0, _colors.COLORS).brandExtraDark
                },
                tooltip: ({ theme })=>({
                        backgroundColor: (0, _colors.COLORS).brandExtraDark,
                        borderRadius: theme.spacing(3),
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                        fontSize: "13px",
                        fontWeight: 700,
                        maxWidth: "400px",
                        padding: theme.spacing(3, 4)
                    })
            }
        },
        MuiTypography: {
            variants: [
                {
                    props: {
                        variant: "mono"
                    },
                    style: ()=>({
                            fontFamily: "Roboto Mono Variable, monospace",
                            fontWeight: 700
                        })
                },
                {
                    props: {
                        variant: "footer"
                    },
                    style: ({ theme })=>({
                            color: theme.palette.layout.main,
                            fontWeight: 400,
                            fontSize: "12px",
                            lineHeight: "18px"
                        })
                },
                {
                    props: {
                        variant: "select"
                    },
                    style: ()=>({
                            color: (0, _colors.COLORS).white,
                            fontWeight: 400,
                            fontSize: "16px",
                            lineHeight: "20px"
                        })
                }
            ]
        },
        MuiUseMediaQuery: {
            defaultProps: {
                noSsr: true
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    padding: 0
                },
                input: {
                    backgroundColor: (0, _colors.COLORS).white,
                    color: (0, _colors.COLORS).grayDark,
                    "&::placeholder": {
                        color: (0, _colors.COLORS).grayDark
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    padding: 0,
                    [`&.${(0, _outlinedInput.outlinedInputClasses).focused} .${(0, _outlinedInput.outlinedInputClasses).notchedOutline}`]: {
                        borderWidth: "3px"
                    }
                },
                notchedOutline: {
                    borderColor: "transparent"
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: ({ theme })=>({
                        borderRadius: "24px",
                        backgroundColor: (0, _colors.COLORS).grayMediumLight,
                        [`.${(0, _inputBase.inputBaseClasses).root}`]: {
                            borderRadius: "24px",
                            backgroundColor: (0, _colors.COLORS).white,
                            // Prevent first child's edges overflowing due to border-radius
                            [`&.${(0, _inputBase.inputBaseClasses).adornedStart} .${(0, _inputAdornment.inputAdornmentClasses).positionStart}`]: {
                                marginLeft: theme.spacing(4)
                            },
                            [`&:not(.${(0, _inputBase.inputBaseClasses).adornedStart}) .${(0, _inputBase.inputBaseClasses).input}`]: {
                                marginLeft: theme.spacing(4)
                            }
                        },
                        ":focus-within": {
                            boxShadow: "0px 4px 50px 15px rgba(0, 0, 98, 0.54)"
                        },
                        transition: "box-shadow 250ms ease-in-out"
                    })
            }
        },
        MuiInputAdornment: {
            variants: [
                {
                    props: {
                        position: "end"
                    },
                    style: {
                        height: "100%",
                        maxHeight: "100%"
                    }
                }
            ]
        },
        MuiPagination: {
            variants: [
                {
                    props: {
                        showFirstButton: true,
                        showLastButton: true
                    },
                    style: {
                        // Swap First and Previous page buttons
                        "li:nth-of-type(2)": {
                            order: -1
                        },
                        // Swap Last and Next page buttons
                        "li:nth-last-of-type(2)": {
                            order: 1
                        }
                    }
                }
            ]
        },
        MuiPaginationItem: {
            variants: [
                {
                    props: {
                        selected: false
                    },
                    style: {
                        color: (0, _colors.COLORS).brandExtraDark
                    }
                },
                {
                    props: {
                        selected: true
                    },
                    style: {
                        backgroundColor: "unset !important",
                        color: (0, _colors.COLORS).disabledPagination
                    }
                },
                {
                    props: {
                        type: "page"
                    },
                    style: {
                        minWidth: 0
                    }
                }
            ]
        },
        MuiTabs: {
            styleOverrides: {
                root: ({ theme })=>({
                        // neglect the default border radius of sibling element (Card component in most cases)
                        "&& + *": {
                            borderTopLeftRadius: 0,
                            [theme.breakpoints.down("sm")]: {
                                borderTopRightRadius: 0
                            }
                        }
                    }),
                indicator: {
                    display: "none"
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: ({ theme })=>({
                        "&:hover, &:focus-visible": {
                            color: (0, _colors.COLORS).brandExtraDark,
                            backgroundColor: (0, _colors.COLORS).grayLight
                        },
                        [`&.${(0, _tab.tabClasses).selected}`]: {
                            color: (0, _colors.COLORS).brandExtraDark,
                            backgroundColor: (0, _colors.COLORS).white
                        },
                        fontSize: "16px",
                        fontWeight: 700,
                        color: (0, _colors.COLORS).brandDark,
                        backgroundColor: (0, _colors.COLORS).inactiveTab,
                        marginRight: theme.spacing(2),
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        textTransform: "capitalize",
                        [theme.breakpoints.down("sm")]: {
                            padding: theme.spacing(3, 4)
                        },
                        [theme.breakpoints.up("sm")]: {
                            padding: theme.spacing(4, 5)
                        }
                    })
            }
        },
        MuiMobileStepper: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent"
                },
                dot: ({ theme })=>({
                        width: "30px",
                        height: "4px",
                        background: "transparent",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: theme.palette.layout.main,
                        borderRadius: theme.spacing(2)
                    }),
                dotActive: ({ theme })=>({
                        background: theme.palette.layout.main
                    })
            }
        },
        MuiIconButton: {
            variants: [
                {
                    props: {
                        color: "primary"
                    },
                    style: ()=>({
                            background: (0, _colors.COLORS).white,
                            svg: {
                                color: (0, _colors.COLORS).brandExtraDark
                            },
                            "&:hover, &:focus-visible": {
                                background: (0, _colors.COLORS).white
                            }
                        })
                }
            ]
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    color: (0, _colors.COLORS).grayExtraDark,
                    [`&.${(0, _menuItem.menuItemClasses).selected}`]: {
                        color: (0, _colors.COLORS).brandDark,
                        backgroundColor: (0, _colors.COLORS).grayLight,
                        "&:hover": {
                            color: (0, _colors.COLORS).brandDark,
                            backgroundColor: (0, _colors.COLORS).grayMediumLight
                        }
                    },
                    [`&.${(0, _menuItem.menuItemClasses).disabled}`]: {
                        color: (0, _colors.COLORS).grayMedium,
                        opacity: 1
                    },
                    "&:hover": {
                        color: (0, _colors.COLORS).grayExtraDark,
                        backgroundColor: (0, _colors.COLORS).grayMediumLight
                    }
                }
            }
        },
        MuiList: {
            styleOverrides: {
                padding: {
                    paddingTop: 0
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: "inherit"
                }
            }
        }
    }
});

},{"@mui/material/styles":"51PGx","./colors":"hYvW2","@mui/material/Fade":"iV0ht","@mui/material/OutlinedInput":"4FpQa","@mui/material/InputBase":"ffdXP","@mui/material/InputAdornment":"crO57","@mui/material/Tab":"3JDbc","@mui/material/MenuItem":"7xWsk","@mui/material/Switch":"9qXnI","@mui/material/ButtonBase":"1prwn","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3JDbc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "tabClasses", ()=>(0, _tabClassesDefault.default));
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabClasses = require("./tabClasses");
var _tabClassesDefault = parcelHelpers.interopDefault(_tabClasses);
parcelHelpers.exportAll(_tabClasses, exports);
"use client";

},{"./Tab":"fmkWo","./tabClasses":"7aZVu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fmkWo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _unsupportedProp = require("../utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _tabClasses = require("./tabClasses");
var _tabClassesDefault = parcelHelpers.interopDefault(_tabClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, textColor, fullWidth, wrapped, icon, label, selected, disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, _capitalizeDefault.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tabClasses.getTabUtilityClass), classes);
};
const TabRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, _capitalizeDefault.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, _tabClassesDefault.default).iconWrapper}`]: (0, _extendsDefault.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, _tabClassesDefault.default).selected}`]: {
            opacity: 1
        },
        [`&.${(0, _tabClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, _tabClassesDefault.default).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, _tabClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, _tabClassesDefault.default).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, _tabClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const Tab = /*#__PURE__*/ _react.forwardRef(function Tab(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className, disabled = false, disableFocusRipple = false, // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition = "top", // eslint-disable-next-line react/prop-types
    indicator, label, onChange, onClick, onFocus, // eslint-disable-next-line react/prop-types
    selected, // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, // eslint-disable-next-line react/prop-types
    textColor = "inherit", value, wrapped = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        disableFocusRipple,
        selected,
        icon: !!iconProp,
        iconPosition,
        label: !!label,
        fullWidth,
        textColor,
        wrapped
    });
    const classes = useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ _react.isValidElement(iconProp) ? /*#__PURE__*/ _react.cloneElement(iconProp, {
        className: (0, _clsxDefault.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabRoot, (0, _extendsDefault.default)({
        focusRipple: !disableFocusRipple,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
exports.default = Tab;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../ButtonBase":"1prwn","../utils/capitalize":"iHgWG","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","../utils/unsupportedProp":"ieG2y","./tabClasses":"7aZVu","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7aZVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabUtilityClass", ()=>getTabUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTabUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTab", slot);
}
const tabClasses = (0, _generateUtilityClassesDefault.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
exports.default = tabClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7xWsk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "menuItemClasses", ()=>(0, _menuItemClassesDefault.default));
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _menuItemClasses = require("./menuItemClasses");
parcelHelpers.exportAll(_menuItemClasses, exports);
var _menuItemClassesDefault = parcelHelpers.interopDefault(_menuItemClasses);
"use client";

},{"./MenuItem":"iHRUo","./menuItemClasses":"cDxAd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iHRUo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _divider = require("../Divider");
var _listItemIcon = require("../ListItemIcon");
var _listItemText = require("../ListItemText");
var _menuItemClasses = require("./menuItemClasses");
var _menuItemClassesDefault = parcelHelpers.interopDefault(_menuItemClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { disabled, dense, divider, disableGutters, selected, classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _menuItemClasses.getMenuItemUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const MenuItemRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _menuItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _menuItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, _divider.dividerClasses).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, _divider.dividerClasses).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, _listItemText.listItemTextClasses).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, _listItemText.listItemTextClasses).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, _listItemIcon.listItemIconClasses).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, _extendsDefault.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, _listItemIcon.listItemIconClasses).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const MenuItem = /*#__PURE__*/ _react.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus = false, component = "li", dense = false, divider = false, disableGutters = false, focusVisibleClassName, role = "menuitem", tabIndex: tabIndexProp, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        dense: childContext.dense,
        divider,
        disableGutters
    });
    const classes = useUtilityClasses(props);
    const handleRef = (0, _useForkRefDefault.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuItemRoot, (0, _extendsDefault.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
exports.default = MenuItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../List/ListContext":"74mKH","../ButtonBase":"1prwn","../utils/useEnhancedEffect":"imwu2","../utils/useForkRef":"5kA2S","../Divider":"3hI6U","../ListItemIcon":"kjw1a","../ListItemText":"lneG9","./menuItemClasses":"cDxAd","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3hI6U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dividerDefault.default));
parcelHelpers.export(exports, "dividerClasses", ()=>(0, _dividerClassesDefault.default));
var _divider = require("./Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _dividerClasses = require("./dividerClasses");
var _dividerClassesDefault = parcelHelpers.interopDefault(_dividerClasses);
parcelHelpers.exportAll(_dividerClasses, exports);
"use client";

},{"./Divider":"lMvnX","./dividerClasses":"3hl3m","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lMvnX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _dividerClasses = require("./dividerClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { absolute, children, classes, flexItem, light, orientation, textAlign, variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dividerClasses.getDividerUtilityClass), classes);
};
const DividerRoot = (0, _styledDefault.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, _colorManipulator.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const DividerWrapper = (0, _styledDefault.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const Divider = /*#__PURE__*/ _react.forwardRef(function Divider(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute = false, children, className, component = children ? "div" : "hr", flexItem = false, light = false, orientation = "horizontal", role = component !== "hr" ? "separator" : undefined, textAlign = "center", variant = "fullWidth" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        absolute,
        component,
        flexItem,
        light,
        orientation,
        role,
        textAlign,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ Divider.muiSkipListHighlight = true;
exports.default = Divider;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./dividerClasses":"3hl3m","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3hl3m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDividerUtilityClass", ()=>getDividerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDividerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDivider", slot);
}
const dividerClasses = (0, _generateUtilityClassesDefault.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
exports.default = dividerClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kjw1a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemIconDefault.default));
parcelHelpers.export(exports, "listItemIconClasses", ()=>(0, _listItemIconClassesDefault.default));
var _listItemIcon = require("./ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemIconClasses = require("./listItemIconClasses");
var _listItemIconClassesDefault = parcelHelpers.interopDefault(_listItemIconClasses);
parcelHelpers.exportAll(_listItemIconClasses, exports);
"use client";

},{"./ListItemIcon":"8ibtM","./listItemIconClasses":"iRHpq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8ibtM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listItemIconClasses = require("./listItemIconClasses");
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemIconClasses.getListItemIconUtilityClass), classes);
};
const ListItemIconRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const ListItemIcon = /*#__PURE__*/ _react.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemIconRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = ListItemIcon;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./listItemIconClasses":"iRHpq","../List/ListContext":"74mKH","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iRHpq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemIconUtilityClass", ()=>getListItemIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemIcon", slot);
}
const listItemIconClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
exports.default = listItemIconClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lneG9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemTextDefault.default));
parcelHelpers.export(exports, "listItemTextClasses", ()=>(0, _listItemTextClassesDefault.default));
var _listItemText = require("./ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _listItemTextClasses = require("./listItemTextClasses");
var _listItemTextClassesDefault = parcelHelpers.interopDefault(_listItemTextClasses);
parcelHelpers.exportAll(_listItemTextClasses, exports);
"use client";

},{"./ListItemText":"5hzpj","./listItemTextClasses":"bSfJL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5hzpj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _listItemTextClasses = require("./listItemTextClasses");
var _listItemTextClassesDefault = parcelHelpers.interopDefault(_listItemTextClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, inset, primary, secondary, dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemTextClasses.getListItemTextUtilityClass), classes);
};
const ListItemTextRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _listItemTextClassesDefault.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, _listItemTextClassesDefault.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const ListItemText = /*#__PURE__*/ _react.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children, className, disableTypography = false, inset = false, primary: primaryProp, primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { dense } = _react.useContext((0, _listContextDefault.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableTypography,
        inset,
        primary: !!primary,
        secondary: !!secondary,
        dense
    });
    const classes = useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, _typographyDefault.default) && !disableTypography) primary = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, _typographyDefault.default) && !disableTypography) secondary = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemTextRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
exports.default = ListItemText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../Typography":"f5srd","../List/ListContext":"74mKH","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./listItemTextClasses":"bSfJL","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bSfJL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemTextUtilityClass", ()=>getListItemTextUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemTextUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemText", slot);
}
const listItemTextClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
exports.default = listItemTextClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cDxAd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuItemUtilityClass", ()=>getMenuItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMenuItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiMenuItem", slot);
}
const menuItemClasses = (0, _generateUtilityClassesDefault.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
exports.default = menuItemClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9qXnI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _switchDefault.default));
parcelHelpers.export(exports, "switchClasses", ()=>(0, _switchClassesDefault.default));
var _switch = require("./Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _switchClasses = require("./switchClasses");
var _switchClassesDefault = parcelHelpers.interopDefault(_switchClasses);
parcelHelpers.exportAll(_switchClasses, exports);
"use client";

},{"./Switch":"eb0Wn","./switchClasses":"dCztg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eb0Wn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @inheritedComponent IconButton
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _switchBase = require("../internal/SwitchBase");
var _switchBaseDefault = parcelHelpers.interopDefault(_switchBase);
var _zeroStyled = require("../zero-styled");
var _switchClasses = require("./switchClasses");
var _switchClassesDefault = parcelHelpers.interopDefault(_switchClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const useThemeProps = (0, _zeroStyled.createUseThemeProps)("MuiSwitch");
const useUtilityClasses = (ownerState)=>{
    const { classes, edge, size, color, checked, disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, _capitalizeDefault.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _switchClasses.getSwitchUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const SwitchRoot = (0, _zeroStyled.styled)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, _capitalizeDefault.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inline-flex",
    width: 58,
    height: 38,
    overflow: "hidden",
    padding: 12,
    boxSizing: "border-box",
    position: "relative",
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: "middle",
    // For correct alignment with the text.
    "@media print": {
        colorAdjust: "exact"
    },
    variants: [
        {
            props: {
                edge: "start"
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: "end"
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, _switchClassesDefault.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, _switchClassesDefault.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, _switchClassesDefault.default).checked}`]: {
                        transform: "translateX(16px)"
                    }
                }
            }
        }
    ]
});
const SwitchSwitchBase = (0, _zeroStyled.styled)((0, _switchBaseDefault.default), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, _switchClassesDefault.default).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, _switchClassesDefault.default).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, _switchClassesDefault.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, _switchClassesDefault.default).checked} + .${(0, _switchClassesDefault.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, _switchClassesDefault.default).disabled} + .${(0, _switchClassesDefault.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, _switchClassesDefault.default).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme })=>({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color
                    },
                    style: {
                        [`&.${(0, _switchClassesDefault.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            "&:hover": {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                "@media (hover: none)": {
                                    backgroundColor: "transparent"
                                }
                            },
                            [`&.${(0, _switchClassesDefault.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, _switchClassesDefault.default).checked} + .${(0, _switchClassesDefault.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const SwitchTrack = (0, _zeroStyled.styled)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const SwitchThumb = (0, _zeroStyled.styled)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const Switch = /*#__PURE__*/ _react.forwardRef(function Switch(inProps, ref) {
    const props = useThemeProps({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className, color = "primary", edge = false, size = "medium", sx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        edge,
        size
    });
    const classes = useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SwitchRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchSwitchBase, (0, _extendsDefault.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, _extendsDefault.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
exports.default = Switch;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/refType":"l5hTY","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../utils/capitalize":"iHgWG","../internal/SwitchBase":"7yInk","../zero-styled":"2ZQJP","./switchClasses":"dCztg","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7yInk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _switchBaseClasses = require("./switchBaseClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, checked, disabled, edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _switchBaseClasses.getSwitchBaseUtilityClass), classes);
};
const SwitchBaseRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default))(({ ownerState })=>(0, _extendsDefault.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const SwitchBaseInput = (0, _styledDefault.default)("input", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const SwitchBase = /*#__PURE__*/ _react.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus, checked: checkedProp, checkedIcon, className, defaultChecked, disabled: disabledProp, disableFocusRipple = false, edge = false, icon, id, inputProps, inputRef, name, onBlur, onChange, onFocus, readOnly, required = false, tabIndex, type, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [checked, setCheckedState] = (0, _useControlledDefault.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, _useFormControlDefault.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        checked,
        disabled,
        disableFocusRipple,
        edge
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SwitchBaseRoot, (0, _extendsDefault.default)({
        component: "span",
        className: (0, _clsxDefault.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchBaseInput, (0, _extendsDefault.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
exports.default = SwitchBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/refType":"l5hTY","@mui/utils/composeClasses":"jj3MR","../utils/capitalize":"iHgWG","../styles/styled":"axRcE","../utils/useControlled":"bNYR8","../FormControl/useFormControl":"3uzwm","../ButtonBase":"1prwn","./switchBaseClasses":"bXQiU","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bXQiU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSwitchBaseUtilityClass", ()=>getSwitchBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSwitchBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("PrivateSwitchBase", slot);
}
const switchBaseClasses = (0, _generateUtilityClassesDefault.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
exports.default = switchBaseClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2ZQJP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "createUseThemeProps", ()=>createUseThemeProps);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
function createUseThemeProps(name) {
    return 0, _useThemePropsDefault.default;
}

},{"../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dCztg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSwitchUtilityClass", ()=>getSwitchUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSwitchUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSwitch", slot);
}
const switchClasses = (0, _generateUtilityClassesDefault.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
exports.default = switchClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lY0f3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testnetTheme", ()=>testnetTheme);
var _utils = require("@mui/utils");
var _styles = require("@mui/material/styles");
var _colors = require("./colors");
var _defaultTheme = require("../defaultTheme");
const testnetTheme = (0, _styles.createTheme)((0, _utils.deepmerge)((0, _defaultTheme.defaultTheme), {
    palette: {
        background: {
            default: (0, _colors.COLORS).testnetLight,
            empty: (0, _colors.COLORS).white
        },
        layout: {
            main: (0, _colors.COLORS).brandExtraDark,
            border: (0, _colors.COLORS).testnet,
            contrastMain: (0, _colors.COLORS).brandExtraDark,
            contrastSecondary: (0, _colors.COLORS).testnet,
            darkBorder: (0, _colors.COLORS).testnet,
            hoverBorder: (0, _colors.COLORS).testnet,
            lightBorder: (0, _colors.COLORS).testnet,
            secondary: (0, _colors.COLORS).testnet,
            primaryBackground: (0, _colors.COLORS).testnetLight,
            secondaryBackground: (0, _colors.COLORS).white,
            networkBubbleBorder: (0, _colors.COLORS).testnet,
            titleOnBackground: (0, _colors.COLORS).grayExtraDark,
            graphZoomOutText: (0, _colors.COLORS).brandDark,
            helpScreenIconColor: (0, _colors.COLORS).brandExtraDark
        }
    }
}));

},{"@mui/utils":"97HmB","@mui/material/styles":"51PGx","./colors":"i4QXC","../defaultTheme":"jzWWg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i4QXC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLORS", ()=>COLORS);
var _colors = require("../colors");
const COLORS = {
    ...(0, _colors.COLORS),
    testnet: "#ffa800",
    testnetLight: "#fff0e4"
};

},{"../colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j6nL1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "collapseClasses", ()=>(0, _collapseClassesDefault.default));
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _collapseClasses = require("./collapseClasses");
var _collapseClassesDefault = parcelHelpers.interopDefault(_collapseClasses);
parcelHelpers.exportAll(_collapseClasses, exports);
"use client";

},{"./Collapse":"eCuXE","./collapseClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eCuXE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _createTransitions = require("../styles/createTransitions");
var _utils = require("../transitions/utils");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils1 = require("../utils");
var _collapseClasses = require("./collapseClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const useUtilityClasses = (ownerState)=>{
    const { orientation, classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _collapseClasses.getCollapseUtilityClass), classes);
};
const CollapseRoot = (0, _styledDefault.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, _extendsDefault.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const CollapseWrapper = (0, _styledDefault.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState })=>(0, _extendsDefault.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const CollapseWrapperInner = (0, _styledDefault.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState })=>(0, _extendsDefault.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Collapse = /*#__PURE__*/ _react.forwardRef(function Collapse(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener, children, className, collapsedSize: collapsedSizeProp = "0px", component, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, orientation = "vertical", style, timeout = (0, _createTransitions.duration).standard, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = useUtilityClasses(ownerState);
    const theme = (0, _useThemeDefault.default)();
    const timer = (0, _useTimeoutDefault.default)();
    const wrapperRef = _react.useRef(null);
    const autoTransitionDuration = _react.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _utils1.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseRoot, (0, _extendsDefault.default)({
                as: component,
                className: (0, _clsxDefault.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, _extendsDefault.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, _extendsDefault.default)({}, ownerState, {
                    state
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapper, {
                    ownerState: (0, _extendsDefault.default)({}, ownerState, {
                        state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapperInner, {
                        ownerState: (0, _extendsDefault.default)({}, ownerState, {
                            state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
Collapse.muiSupportAuto = true;
exports.default = Collapse;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","clsx":"bGtJT","prop-types":"hRUel","react-transition-group":"j8hjZ","@mui/utils/useTimeout":"2Xz3c","@mui/utils/elementTypeAcceptingRef":"cSxw6","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../styles/createTransitions":"8QUl5","../transitions/utils":"jjBwh","../styles/useTheme":"3N7Mw","../utils":"bu04F","./collapseClasses":"4SmjP","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4SmjP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCollapseUtilityClass", ()=>getCollapseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCollapseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCollapse", slot);
}
const collapseClasses = (0, _generateUtilityClassesDefault.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
exports.default = collapseClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5wvKB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExploreBtn", ()=>ExploreBtn);
parcelHelpers.export(exports, "ZoomOutBtn", ()=>ZoomOutBtn);
parcelHelpers.export(exports, "ParaTimeSelector", ()=>ParaTimeSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paratimeSelectorGlowSvg = require("../images/paratime-selector-glow.svg");
var _paratimeSelectorGlowSvgDefault = parcelHelpers.interopDefault(_paratimeSelectorGlowSvg);
var _paratimeSelectorGlobeSvg = require("../images/paratime-selector-globe.svg");
var _paratimeSelectorGlobeSvgDefault = parcelHelpers.interopDefault(_paratimeSelectorGlobeSvg);
var _paratimeSelectorGlowTestnetSvg = require("../images/paratime-selector-glow-testnet.svg");
var _paratimeSelectorGlowTestnetSvgDefault = parcelHelpers.interopDefault(_paratimeSelectorGlowTestnetSvg);
var _paratimeSelectorGlobeTestnetSvg = require("../images/paratime-selector-globe-testnet.svg");
var _paratimeSelectorGlobeTestnetSvgDefault = parcelHelpers.interopDefault(_paratimeSelectorGlobeTestnetSvg);
var _graph = require("../Graph");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactI18Next = require("react-i18next");
var _types = require("../types");
var _paraTimeSelectorUtils = require("../para-time-selector-utils");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _useScreensize = require("../../../../hooks/useScreensize");
var _reactQuickPinchZoom = require("react-quick-pinch-zoom");
var _reactQuickPinchZoomDefault = parcelHelpers.interopDefault(_reactQuickPinchZoom);
var _chevronLeft = require("@mui/icons-material/ChevronLeft");
var _chevronLeftDefault = parcelHelpers.interopDefault(_chevronLeft);
var _graphUtils = require("../Graph/graph-utils");
var _useResizeObserver = require("use-resize-observer");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);
var _helpScreen = require("../HelpScreen");
var _helpScreenDefault = parcelHelpers.interopDefault(_helpScreen);
var _networkSelector = require("../NetworkSelector");
var _api = require("../../../../../oasis-nexus/api");
var _network = require("../../../../../types/network");
var _useSearchQueryNetworkParam = require("../../../../hooks/useSearchQueryNetworkParam");
var _storage = require("../../../../utils/storage");
var _storage1 = require("../../../../../types/storage");
var _graphTooltipMobile = require("../GraphTooltipMobile");
var _routeUtils = require("../../../../utils/route-utils");
const ParaTimeSelectorGlow = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "disabled" && prop !== "network"
})(({ disabled, network, theme })=>({
        position: "relative",
        width: "130vw",
        height: "130vw",
        marginTop: "-5vh",
        backgroundImage: `url("${network === (0, _network.Network).testnet ? (0, _paratimeSelectorGlowTestnetSvgDefault.default) : (0, _paratimeSelectorGlowSvgDefault.default)}")`,
        transitionProperty: "background-image",
        transitionDuration: `${theme.transitions.duration.complex}ms`,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        ...disabled ? {
            opacity: 0.25
        } : {},
        [theme.breakpoints.up("sm")]: {
            width: "80vh",
            height: "80vh",
            marginTop: "-17vh"
        }
    }));
const ParaTimeSelectorGlobe = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "network"
})(({ network, theme })=>({
        position: "absolute",
        width: "65%",
        paddingBottom: "65%",
        left: "50%",
        bottom: "6%",
        transform: "translateX(-50%)",
        color: theme.palette.layout.main,
        backgroundImage: `url("${network === (0, _network.Network).testnet ? (0, _paratimeSelectorGlobeTestnetSvgDefault.default) : (0, _paratimeSelectorGlobeSvgDefault.default)}")`,
        transitionProperty: "background-image",
        transitionDuration: `${theme.transitions.duration.complex}ms`,
        transitionTimingFunction: theme.transitions.easing.easeInOut,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
        borderRadius: "50%"
    }));
const ExploreBtn = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        fontWeight: 700,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        width: "max-content",
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6)
        }
    }));
ExploreBtn.defaultProps = {
    color: "secondary",
    variant: "contained"
};
const ZoomOutBtn = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        color: theme.palette.layout.graphZoomOutText,
        position: "absolute",
        top: theme.spacing(5),
        left: "50%",
        transform: "translateX(-50%)",
        lineHeight: "18px",
        textTransform: "none",
        "&&:hover, &&:active": {
            color: theme.palette.layout.graphZoomOutText,
            textDecoration: "none"
        },
        "&&": {
            backgroundColor: "transparent"
        }
    }));
ZoomOutBtn.defaultProps = {
    color: "primary",
    variant: "text",
    startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronLeftDefault.default), {})
};
const ZoomOutBtnFade = (0, _styles.styled)((0, _fadeDefault.default))(()=>({
        transitionDelay: "500ms !important"
    }));
// border affecting scale (quick-pinch-zoom)
const QuickPinchZoomOuter = (0, _styles.styled)("div")(({ theme })=>({
        "> div": {
            position: "absolute",
            inset: 0,
            borderWidth: 10,
            borderStyle: "solid",
            borderRadius: "50%",
            borderColor: theme.palette.layout.darkBorder
        },
        [theme.breakpoints.up("sm")]: {
            "> div": {
                borderWidth: 15
            }
        }
    }));
const QuickPinchZoomInner = (0, _styles.styled)("div")(()=>({
        position: "absolute",
        width: "100%",
        height: "100%"
    }));
const localStore = (0, _storage.storage)();
const ParaTimeSelectorCmp = ({ disabled, step, setStep, showInfoScreen, graphZoomedIn, onGraphZoomedIn })=>{
    const graphRef = (0, _react.useRef)(null);
    const quickPinchZoomRef = (0, _react.useRef)(null);
    const quickPinchZoomInnerRef = (0, _react.useRef)(null);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const exploreBtnTextTranslated = t("home.exploreBtnText");
    const { network, setNetwork } = (0, _useSearchQueryNetworkParam.useSearchQueryNetworkParam)();
    // Using object here to force side effect trigger when setting to the same layer
    const [selectedLayer, setSelectedLayer] = (0, _react.useState)();
    const [activeMobileGraphTooltip, setActiveMobileGraphTooltip] = (0, _react.useState)({
        current: null
    });
    const [scale, setScale] = (0, _react.useState)(1);
    const { width, height } = (0, _useResizeObserverDefault.default)({
        ref: graphRef
    });
    (0, _react.useEffect)(()=>{
        if (selectedLayer) quickPinchZoomRef.current?.scaleTo((0, _graphUtils.GraphUtils).getScaleTo(selectedLayer.current, {
            width,
            height
        }));
    }, [
        selectedLayer,
        width,
        height
    ]);
    (0, _react.useEffect)(()=>{
        // Switch from mobile -> desktop view while on help screen
        if (!isMobile && step === (0, _types.ParaTimeSelectorStep).ShowHelpScreen) setStep((0, _types.ParaTimeSelectorStep).Explore);
    }, [
        isMobile,
        step,
        setStep
    ]);
    const onExploreClick = ()=>{
        const mobileHelpScreenShown = localStore.get((0, _storage1.StorageKeys).MobileHelpScreenShown);
        if (!mobileHelpScreenShown) setStep((0, _types.ParaTimeSelectorStep).ShowHelpScreen);
        else setStep((0, _types.ParaTimeSelectorStep).Explore);
    };
    const onZoomOutClick = ()=>{
        setSelectedLayer({
            current: (0, _api.Layer).consensus
        });
    };
    const onPinchZoom = ({ x, y, scale })=>{
        if (step !== (0, _types.ParaTimeSelectorStep).Explore) return;
        const transformValue = (0, _reactQuickPinchZoom.make3dTransformValue)({
            x,
            y,
            scale
        });
        setScale(scale);
        quickPinchZoomInnerRef.current?.style.setProperty("transform", transformValue);
    };
    const clearSelectedLayer = ()=>{
        if (selectedLayer?.current) setSelectedLayer(undefined);
    };
    (0, _react.useEffect)(()=>{
        // true when scale larger than "safe" zoom, due to viewport
        const isZoomedIn = scale > 1.5;
        onGraphZoomedIn(isZoomedIn);
    }, [
        scale,
        onGraphZoomedIn
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ParaTimeSelectorGlow, {
                disabled: disabled,
                network: network,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ParaTimeSelectorGlobe, {
                        network: network,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuickPinchZoomOuter, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuickPinchZoomDefault.default), {
                                    ref: quickPinchZoomRef,
                                    onUpdate: onPinchZoom,
                                    maxZoom: 2.5,
                                    minZoom: 0.5,
                                    onDragEnd: clearSelectedLayer,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuickPinchZoomInner, {
                                        ref: quickPinchZoomInnerRef,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graph.Graph), {
                                            ref: graphRef,
                                            network: network,
                                            disabled: disabled,
                                            transparent: (0, _paraTimeSelectorUtils.ParaTimeSelectorUtils).getIsGraphTransparent(step),
                                            selectedLayer: selectedLayer?.current,
                                            setSelectedLayer: (layer)=>setSelectedLayer({
                                                    current: layer
                                                }),
                                            scale: scale,
                                            setActiveMobileGraphTooltip: setActiveMobileGraphTooltip,
                                            isZoomedIn: graphZoomedIn
                                        })
                                    })
                                })
                            }),
                            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ZoomOutBtnFade, {
                                in: graphZoomedIn,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ZoomOutBtn, {
                                    onClick: onZoomOutClick,
                                    disabled: disabled,
                                    children: t("home.zoomOutBtnText")
                                })
                            }),
                            isMobile && (0, _paraTimeSelectorUtils.ParaTimeSelectorUtils).showExploreBtn(step) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExploreBtn, {
                                onClick: onExploreClick,
                                "aria-label": exploreBtnTextTranslated,
                                sx: {
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)"
                                },
                                children: t("home.exploreBtnText")
                            }),
                            (0, _paraTimeSelectorUtils.ParaTimeSelectorUtils).showMobileHelpScreen(step, isMobile, showInfoScreen) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpScreenDefault.default), {
                                setParaTimeStep: setStep
                            })
                        ]
                    }),
                    !(0, _routeUtils.fixedNetwork) && step === (0, _types.ParaTimeSelectorStep).Explore && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkSelector.NetworkSelector), {
                        network: network,
                        setNetwork: (network)=>setNetwork(network ?? (0, _network.Network).mainnet)
                    })
                ]
            }),
            activeMobileGraphTooltip.current && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _graphTooltipMobile.GraphTooltipMobile), {
                network: network,
                layer: activeMobileGraphTooltip.current,
                onClose: ()=>{
                    setActiveMobileGraphTooltip({
                        current: null
                    });
                }
            })
        ]
    });
};
const ParaTimeSelector = /*#__PURE__*/ (0, _react.memo)(ParaTimeSelectorCmp);

},{"react/jsx-runtime":"g88cO","react":"BK2ob","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","../images/paratime-selector-glow.svg":"dVTxE","../images/paratime-selector-globe.svg":"7fUQi","../images/paratime-selector-glow-testnet.svg":"4enOt","../images/paratime-selector-globe-testnet.svg":"6szoo","../Graph":"tpXDM","@mui/material/Button":"h2G5p","react-i18next":"e210a","../types":"3zpNP","../para-time-selector-utils":"4g6ag","@mui/material/Fade":"iV0ht","../../../../hooks/useScreensize":"2HEhN","react-quick-pinch-zoom":"6igNy","@mui/icons-material/ChevronLeft":"5sXJ8","../Graph/graph-utils":"bTeKH","use-resize-observer":"5z6PJ","../HelpScreen":"a6Lai","../NetworkSelector":"lHYBB","../../../../../oasis-nexus/api":"dJrPU","../../../../../types/network":"f0o8N","../../../../hooks/useSearchQueryNetworkParam":"2W1vT","../../../../utils/storage":"lxVX3","../../../../../types/storage":"8d6ef","../GraphTooltipMobile":"5ibUV","../../../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dVTxE":[function(require,module,exports) {
module.exports = require("3e2544330e027973").getBundleURL("sif1r") + "paratime-selector-glow.428132fa.svg";

},{"3e2544330e027973":"ccgWN"}],"7fUQi":[function(require,module,exports) {
module.exports = require("ed62749f09efdb4").getBundleURL("sif1r") + "paratime-selector-globe.0ad455d3.svg";

},{"ed62749f09efdb4":"ccgWN"}],"4enOt":[function(require,module,exports) {
module.exports = require("3f75bdbfab023eef").getBundleURL("sif1r") + "paratime-selector-glow-testnet.fa73b1cf.svg";

},{"3f75bdbfab023eef":"ccgWN"}],"6szoo":[function(require,module,exports) {
module.exports = require("e69182150168263f").getBundleURL("sif1r") + "paratime-selector-globe-testnet.52b04c00.svg";

},{"e69182150168263f":"ccgWN"}],"tpXDM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Graph", ()=>Graph);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _styles = require("@mui/material/styles");
var _react = require("react");
var _routeUtils = require("../../../../utils/route-utils");
var _useScreensize = require("../../../../hooks/useScreensize");
var _api = require("../../../../../oasis-nexus/api");
var _network = require("../../../../../types/network");
var _colors = require("../../../../../styles/theme/testnet/colors");
var _reactI18Next = require("react-i18next");
var _hook = require("../../../../components/OfflineBanner/hook");
const GraphStyled = (0, _styles.styled)("svg", {
    shouldForwardProp: (prop)=>![
            "disabled",
            "transparent",
            "selectedLayer",
            "hoveredLayer"
        ].includes(prop)
})(({ theme, disabled, transparent, selectedLayer, hoveredLayer })=>({
        position: "absolute",
        left: "50%",
        top: "45%",
        width: "80%",
        height: "80%",
        transform: "translate(-50%, -50%)",
        ...disabled || transparent ? {
            pointerEvents: "none"
        } : {},
        ...transparent ? {
            opacity: 0.25
        } : {},
        '[id]:not([aria-disabled="true"])': {
            cursor: "pointer"
        },
        path: {
            ...selectedLayer && selectedLayer !== (0, _api.Layer).consensus ? {
                [`&:not(.${selectedLayer})`]: {
                    opacity: 0.5
                },
                "&.status-icon": {
                    opacity: 1
                }
            } : {}
        },
        "g[id$=circle]": {
            "ellipse:not(:last-child)": {
                display: "inline"
            },
            "ellipse:last-child": {
                display: "none"
            },
            ...selectedLayer && selectedLayer !== (0, _api.Layer).consensus ? {
                [`&:not([id=${selectedLayer}-circle])`]: {
                    opacity: 0.5
                }
            } : {}
        },
        [theme.breakpoints.up("md")]: {
            "g[id$=circle]": {
                "&:hover, &:focus-visible": {
                    "ellipse:not(.hover-bg)": {
                        display: "none"
                    },
                    "ellipse.hover-bg": {
                        display: "inline"
                    },
                    "circle:not(.no-hide)": {
                        display: "none"
                    }
                }
            },
            [`g[id$=${hoveredLayer}-circle]`]: {
                "ellipse:not(.hover-bg)": {
                    display: "none"
                },
                "ellipse.hover-bg": {
                    display: "inline"
                },
                "circle:not(.no-hide)": {
                    display: "none"
                }
            }
        },
        text: {
            userSelect: "none",
            pointerEvents: "none"
        },
        "g.highlight": {
            "&:hover, &:focus-visible": {
                path: {
                    strokeWidth: 4
                }
            }
        },
        "&.testnet": {
            "g.highlight": {
                "&:hover, &:focus-visible": {
                    path: {
                        stroke: (0, _colors.COLORS).brandExtraDark
                    }
                }
            }
        }
    }));
const preventDoubleClick = {
    onDoubleClick: (e)=>e.preventDefault()
};
const handleHover = (layer, set)=>({
        onMouseEnter: ()=>{
            set(layer);
        },
        onMouseLeave: ()=>{
            set(null);
        }
    });
const GraphLayerStatus = ({ children, fillText, iconX, iconY, textX, textY, outOfDate })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (outOfDate === undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
        x: textX,
        y: textY,
        fill: fillText,
        fontSize: "12px",
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                x: textX,
                y: textY,
                fill: fillText,
                fontSize: "12px",
                children: [
                    children,
                    !outOfDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        dx: "-40",
                        dy: "12",
                        fontSize: "7px",
                        children: t("home.online")
                    }),
                    outOfDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        dx: "-40",
                        dy: "12",
                        fontSize: "7px",
                        children: t("home.offline")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: `translate(${iconX}, ${iconY}) scale(0.4)`,
                children: [
                    !outOfDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "status-icon",
                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
                        fill: (0, _colors.COLORS).eucalyptus
                    }),
                    outOfDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: "status-icon",
                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
                        fill: (0, _colors.COLORS).error
                    })
                ]
            })
        ]
    });
};
const ConsensusStatus = ({ network, statusChange })=>{
    const { outOfDate } = (0, _hook.useConsensusFreshness)(network);
    (0, _react.useEffect)(()=>{
        statusChange(outOfDate);
        return ()=>{
            statusChange(undefined);
        };
    }, [
        outOfDate,
        statusChange
    ]);
    return null;
};
const RuntimeStatus = ({ scope, statusChange })=>{
    const { outOfDate } = (0, _hook.useRuntimeFreshness)(scope);
    (0, _react.useEffect)(()=>{
        statusChange(outOfDate);
        return ()=>{
            statusChange(undefined);
        };
    }, [
        outOfDate,
        statusChange
    ]);
    return null;
};
const LayerStatus = ({ scope, statusChange })=>scope.layer === (0, _api.Layer).consensus ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsensusStatus, {
        network: scope.network,
        statusChange: statusChange
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimeStatus, {
        scope: scope,
        statusChange: statusChange
    });
const GraphCmp = ({ disabled = false, transparent = false, selectedLayer, network, setSelectedLayer, scale, setActiveMobileGraphTooltip, isZoomedIn }, ref)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const [hoveredLayer, setHoveredLayer] = (0, _react.useState)(null);
    const [outOfDateMap, setOutOfDateMap] = (0, _react.useState)({});
    (0, _react.useEffect)(()=>{
        setActiveMobileGraphTooltip({
            current: null
        });
    // should only close tooltips on isMobile change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isMobile
    ]);
    (0, _react.useEffect)(()=>{
        setOutOfDateMap({});
    }, [
        network
    ]);
    const isLayerDisabled = (Layer)=>{
        return !(0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled.includes(Layer);
    };
    const disabledMap = {
        [(0, _api.Layer).emerald]: isLayerDisabled((0, _api.Layer).emerald),
        [(0, _api.Layer).consensus]: isLayerDisabled((0, _api.Layer).consensus),
        [(0, _api.Layer).cipher]: isLayerDisabled((0, _api.Layer).cipher),
        [(0, _api.Layer).sapphire]: isLayerDisabled((0, _api.Layer).sapphire)
    };
    const enabledLayers = (0, _react.useMemo)(()=>(0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled, [
        network
    ]);
    const onSelectLayer = (layer)=>{
        if (isMobile && (isZoomedIn || layer === (0, _api.Layer).consensus)) {
            setSelectedLayer(layer);
            setActiveMobileGraphTooltip({
                current: layer
            });
            return;
        }
        if ((!isMobile && !isZoomedIn || layer === selectedLayer) && (0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled.includes(layer)) {
            navigate((0, _routeUtils.RouteUtils).getDashboardRoute({
                network,
                layer
            }));
            return;
        }
        if (!disabledMap[layer]) setSelectedLayer(layer);
    };
    const graphThemes = {
        mainnet: {
            cipherCircle: "url(#paint7_radial_6093_287252)",
            cipherCircleFilter: "url(#filter2_dii_6093_287252)",
            cipherCircleFill: (0, _colors.COLORS).darkBlue,
            emeraldCircle: "url(#paint6_radial_6093_287252)",
            emeraldCircleFilter: "url(#filter0_dii_6093_287252)",
            sapphireCircle: "url(#paint7_radial_6093_287252)",
            sapphireCircleFilter: "url(#filter1_dii_6093_287252)",
            consensusCircle: (0, _colors.COLORS).brandExtraDark,
            line: (0, _colors.COLORS).aqua,
            text: (0, _colors.COLORS).white,
            textBackground: (0, _colors.COLORS).graphLabel,
            textBorder: (0, _colors.COLORS).graphLine,
            circleBorder: (0, _colors.COLORS).brandExtraDark,
            hoverBackground: (0, _colors.COLORS).aqua,
            hoverText: (0, _colors.COLORS).brandExtraDark
        },
        testnet: {
            cipherCircle: (0, _colors.COLORS).testnet,
            cipherCircleFilter: "url(#filter2_di_6093_290291)",
            cipherCircleFill: (0, _colors.COLORS).testnet,
            emeraldCircle: (0, _colors.COLORS).testnet,
            emeraldCircleFilter: "url(#filter0_di_6093_290291)",
            sapphireCircle: (0, _colors.COLORS).testnet,
            sapphireCircleFilter: "url(#filter1_di_6093_290291)",
            consensusCircle: (0, _colors.COLORS).testnetLight,
            line: (0, _colors.COLORS).testnet,
            text: (0, _colors.COLORS).brandExtraDark,
            textBackground: (0, _colors.COLORS).testnetLight,
            textBorder: (0, _colors.COLORS).testnet,
            circleBorder: (0, _colors.COLORS).testnet,
            hoverBackground: (0, _colors.COLORS).brandExtraDark,
            hoverText: (0, _colors.COLORS).white
        }
    };
    const graphTheme = graphThemes[network];
    const layers = (0, _react.useMemo)(()=>enabledLayers.map((layer)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerStatus, {
                scope: {
                    network,
                    layer
                },
                statusChange: (outOfDate)=>setOutOfDateMap((prevValue)=>({
                            ...prevValue,
                            [layer]: outOfDate
                        }))
            }, layer)), [
        network,
        enabledLayers
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isZoomedIn && network && layers,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GraphStyled, {
                width: "396",
                height: "387",
                viewBox: "0 0 396 387",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                disabled: disabled,
                transparent: transparent,
                preserveAspectRatio: "xMidYMid slice",
                ref: ref,
                className: network,
                selectedLayer: selectedLayer,
                hoveredLayer: hoveredLayer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M257.947 218.31C259.1 209.19 258.447 199.932 256.023 191.064C253.598 182.197 249.452 173.894 243.819 166.629C238.186 159.364 231.177 153.28 223.193 148.724C215.208 144.168 206.405 141.229 197.285 140.075C188.164 138.921 178.906 139.575 170.039 141.999C161.172 144.423 152.868 148.57 145.604 154.203C138.339 159.836 132.255 166.844 127.698 174.829C123.142 182.813 120.203 191.617 119.05 200.737C117.896 209.857 118.549 219.115 120.974 227.982C123.398 236.85 127.545 245.153 133.178 252.418C138.811 259.683 145.819 265.767 153.804 270.323C161.788 274.879 170.591 277.818 179.712 278.972C188.832 280.126 198.09 279.472 206.957 277.048C215.825 274.624 224.128 270.477 231.393 264.844C238.657 259.211 244.742 252.202 249.298 244.218C253.854 236.233 256.793 227.43 257.947 218.31L257.947 218.31Z",
                        stroke: graphTheme.line,
                        strokeWidth: "6.16169",
                        strokeDasharray: "0.27 2.71"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).emerald,
                        d: "M195.673 102.451L155.947 76.6719",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).emerald,
                        d: "M195.674 102.451L235.399 73.925",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).consensus,
                        d: "M183.768 210.158L308.693 202.227",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).consensus,
                        d: "M187.221 212.965L195.884 103.508",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).consensus,
                        d: "M167.502 240L132.572 287.516",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).sapphire,
                        d: "M121.083 308.697L87.666 342.253",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).sapphire,
                        d: "M127.501 299.77L163.137 333.266",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).sapphire,
                        d: "M112.336 295.148L69.5934 271.379",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        className: (0, _api.Layer).emerald,
                        d: "M197.319 77.6547L196.607 28.753",
                        stroke: graphTheme.line,
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        style: {
                            pointerEvents: !disabledMap.emerald ? "auto" : "none"
                        },
                        className: "highlight",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: (0, _routeUtils.RouteUtils).getLatestTransactionsRoute({
                                network,
                                layer: (0, _api.Layer).emerald
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    className: (0, _api.Layer).emerald,
                                    d: "M250.839 37.333C262.715 37.333 272.341 46.9589 272.341 58.833C272.341 70.7071 262.715 80.333 250.839 80.333C238.964 80.333 229.338 70.7071 229.338 58.833C229.338 46.9589 238.964 37.333 250.839 37.333Z",
                                    fill: graphTheme.circleBorder,
                                    stroke: graphTheme.line
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                    x: "240",
                                    y: "61.83",
                                    fill: graphTheme.text,
                                    fontSize: "10px",
                                    children: t("home.txns")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        style: {
                            pointerEvents: !disabledMap.emerald ? "auto" : "none"
                        },
                        className: "highlight",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: (0, _routeUtils.RouteUtils).getLatestBlocksRoute({
                                network,
                                layer: (0, _api.Layer).emerald
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    className: (0, _api.Layer).emerald,
                                    d: "M139.839 39.333C151.715 39.333 161.341 48.9589 161.341 60.833C161.341 72.7071 151.715 82.333 139.839 82.333C127.964 82.333 118.338 72.7071 118.338 60.833C118.338 48.9589 127.964 39.333 139.839 39.333Z",
                                    fill: graphTheme.circleBorder,
                                    stroke: graphTheme.line
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                    x: "126.872",
                                    y: "63.833",
                                    fill: graphTheme.text,
                                    fontSize: "10px",
                                    children: t("home.blocks")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        style: {
                            pointerEvents: !disabledMap.emerald ? "auto" : "none"
                        },
                        className: "highlight",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: (0, _routeUtils.RouteUtils).getTopTokensRoute({
                                network,
                                layer: (0, _api.Layer).emerald
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    className: (0, _api.Layer).emerald,
                                    d: "M196.839 3.27392C208.715 3.27392 218.341 12.8998 218.341 24.7739C218.341 36.648 208.715 46.2739 196.839 46.2739C184.964 46.2739 175.338 36.648 175.338 24.7739C175.338 12.8998 184.964 3.27393 196.839 3.27392Z",
                                    fill: graphTheme.circleBorder,
                                    stroke: graphTheme.line
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                    x: "182.607",
                                    y: "27.77",
                                    fill: graphTheme.text,
                                    fontSize: "10px",
                                    children: t("common.tokens")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        style: {
                            pointerEvents: !disabledMap.sapphire ? "auto" : "none"
                        },
                        className: "highlight",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: (0, _routeUtils.RouteUtils).getLatestBlocksRoute({
                                network,
                                layer: (0, _api.Layer).sapphire
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    className: (0, _api.Layer).sapphire,
                                    d: "M78.8395 331.333C90.7145 331.333 100.341 340.959 100.341 352.833C100.341 364.707 90.7145 374.333 78.8395 374.333C66.9644 374.333 57.3379 364.707 57.3379 352.833C57.3379 340.959 66.9644 331.333 78.8395 331.333Z",
                                    fill: graphTheme.circleBorder,
                                    stroke: graphTheme.line
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                    x: "64.872",
                                    y: "355.83",
                                    fill: graphTheme.text,
                                    fontSize: "10px",
                                    children: t("home.blocks")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        style: {
                            pointerEvents: !disabledMap.sapphire ? "auto" : "none"
                        },
                        className: "highlight",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: (0, _routeUtils.RouteUtils).getLatestTransactionsRoute({
                                network,
                                layer: (0, _api.Layer).sapphire
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    className: (0, _api.Layer).sapphire,
                                    d: "M176.839 323.333C188.715 323.333 198.341 332.959 198.341 344.833C198.341 356.707 188.715 366.333 176.839 366.333C164.964 366.333 155.338 356.707 155.338 344.833C155.338 332.959 164.964 323.333 176.839 323.333Z",
                                    fill: graphTheme.circleBorder,
                                    stroke: graphTheme.line
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                    x: "167",
                                    y: "347.83",
                                    fill: graphTheme.text,
                                    fontSize: "10px",
                                    children: t("home.txns")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        style: {
                            pointerEvents: !disabledMap.sapphire ? "auto" : "none"
                        },
                        className: "highlight",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: (0, _routeUtils.RouteUtils).getTopTokensRoute({
                                network,
                                layer: (0, _api.Layer).sapphire
                            }),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    className: (0, _api.Layer).sapphire,
                                    d: "M65.8395 245.333C77.7145 245.333 87.3411 254.959 87.3411 266.833C87.3411 278.707 77.7145 288.333 65.8395 288.333C53.9644 288.333 44.3379 278.707 44.3379 266.833C44.3379 254.959 53.9644 245.333 65.8395 245.333Z",
                                    fill: graphTheme.circleBorder,
                                    stroke: graphTheme.line
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                    x: "51.60",
                                    y: "269.833",
                                    fill: graphTheme.text,
                                    fontSize: "10px",
                                    children: t("common.tokens")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).emerald}-circle`,
                        "aria-disabled": disabledMap[(0, _api.Layer).emerald],
                        onClick: ()=>onSelectLayer((0, _api.Layer).emerald),
                        filter: graphTheme.emeraldCircleFilter,
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).emerald, setHoveredLayer),
                        children: [
                            network === (0, _network.Network).mainnet && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "195.702",
                                cy: "94.6959",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: "#030092"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "195.702",
                                cy: "94.6959",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.emeraldCircle
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                className: "hover-bg",
                                cx: "195.702",
                                cy: "94.6959",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.hoverBackground
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).emerald}-label`,
                        "aria-disabled": disabledMap[(0, _api.Layer).emerald],
                        onClick: ()=>onSelectLayer((0, _api.Layer).emerald),
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).emerald, setHoveredLayer),
                        children: [
                            (isMobile || hoveredLayer !== (0, _api.Layer).emerald) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphLayerStatus, {
                                iconX: 201,
                                iconY: 102,
                                textX: 174,
                                textY: 97,
                                fillText: graphTheme.text,
                                outOfDate: outOfDateMap.emerald,
                                children: t("common.emerald")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).emerald && !disabledMap[(0, _api.Layer).emerald] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                x: "181.5",
                                y: "97",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: t("common.view")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).emerald && disabledMap[(0, _api.Layer).emerald] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                x: "177.4",
                                y: "97",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-4",
                                        dy: "-5",
                                        children: t("home.coming")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-35",
                                        dy: "12",
                                        children: t("home.soon")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).sapphire}-circle`,
                        "aria-disabled": disabledMap[(0, _api.Layer).sapphire],
                        onClick: ()=>onSelectLayer((0, _api.Layer).sapphire),
                        filter: graphTheme.sapphireCircleFilter,
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).sapphire, setHoveredLayer),
                        children: [
                            network === (0, _network.Network).mainnet && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "123.702",
                                cy: "302.696",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: "#030092"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "123.702",
                                cy: "302.696",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.sapphireCircle
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                className: "hover-bg",
                                cx: "123.702",
                                cy: "302.696",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.hoverBackground
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).sapphire}-label`,
                        "aria-disabled": disabledMap[(0, _api.Layer).sapphire],
                        onClick: ()=>onSelectLayer((0, _api.Layer).sapphire),
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).sapphire, setHoveredLayer),
                        children: [
                            (isMobile || hoveredLayer !== (0, _api.Layer).sapphire) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphLayerStatus, {
                                iconX: 130,
                                iconY: 310,
                                textX: 100,
                                textY: 305,
                                fillText: graphTheme.text,
                                outOfDate: outOfDateMap.sapphire,
                                children: t("common.sapphire")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).sapphire && !disabledMap[(0, _api.Layer).sapphire] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                x: "109.5",
                                y: "307",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: t("common.view")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).sapphire && disabledMap[(0, _api.Layer).sapphire] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                x: "106",
                                y: "305",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-4",
                                        dy: "-5",
                                        children: t("home.coming")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-35",
                                        dy: "12",
                                        children: t("home.soon")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).consensus}-circle`,
                        onClick: ()=>onSelectLayer((0, _api.Layer).consensus),
                        "aria-disabled": disabledMap[(0, _api.Layer).consensus],
                        ...handleHover((0, _api.Layer).consensus, setHoveredLayer),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                className: "no-hide",
                                opacity: "0.25",
                                cx: "188.995",
                                cy: "209.993",
                                r: "52.9926",
                                transform: "rotate(-90 188.995 209.993)",
                                fill: graphTheme.line,
                                ...preventDoubleClick
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: "188.502",
                                cy: "209.5",
                                r: "42.5",
                                transform: "rotate(-90 188.502 209.5)",
                                fill: graphTheme.line,
                                ...preventDoubleClick
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                cx: "189.002",
                                cy: "210",
                                r: "36",
                                transform: "rotate(-90 189.002 210)",
                                fill: graphTheme.consensusCircle,
                                ...preventDoubleClick
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                className: "hover-bg",
                                cx: "188.502",
                                cy: "209.5",
                                rx: "42.5",
                                ry: "42.5",
                                transform: "rotate(-90 188.995 209.5)",
                                fill: graphTheme.hoverBackground
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).consensus}-label`,
                        "aria-disabled": disabledMap[(0, _api.Layer).consensus],
                        onClick: ()=>onSelectLayer((0, _api.Layer).consensus),
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).consensus, setHoveredLayer),
                        children: [
                            (isMobile || hoveredLayer !== (0, _api.Layer).consensus) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphLayerStatus, {
                                iconX: 201,
                                iconY: 216,
                                textX: 159,
                                textY: 212,
                                fillText: graphTheme.text,
                                outOfDate: outOfDateMap.consensus,
                                children: t("common.consensus")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).consensus && !disabledMap[(0, _api.Layer).consensus] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                x: "173",
                                y: "214",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: t("common.view")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).consensus && disabledMap[(0, _api.Layer).consensus] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                x: "170",
                                y: "212",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-4",
                                        dy: "-5",
                                        children: t("home.coming")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-35",
                                        dy: "12",
                                        children: t("home.soon")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        filter: graphTheme.cipherCircleFilter,
                        "aria-disabled": disabledMap[(0, _api.Layer).cipher],
                        onClick: ()=>onSelectLayer((0, _api.Layer).cipher),
                        id: `${(0, _api.Layer).cipher}-circle`,
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).cipher, setHoveredLayer),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "306.702",
                                cy: "201.696",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.cipherCircleFill
                            }),
                            network === (0, _network.Network).mainnet && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                cx: "306.702",
                                cy: "201.696",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.cipherCircle
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                                className: "hover-bg",
                                cx: "306.702",
                                cy: "201.696",
                                rx: "31.6963",
                                ry: "31.6959",
                                fill: graphTheme.hoverBackground
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: `${(0, _api.Layer).cipher}-label`,
                        "aria-disabled": disabledMap[(0, _api.Layer).cipher],
                        onClick: ()=>onSelectLayer((0, _api.Layer).cipher),
                        ...preventDoubleClick,
                        ...handleHover((0, _api.Layer).cipher, setHoveredLayer),
                        children: [
                            (isMobile || hoveredLayer !== (0, _api.Layer).cipher) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                x: "290",
                                y: "205",
                                fill: graphTheme.text,
                                fontSize: "12px",
                                children: t("common.cipher")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).cipher && !disabledMap[(0, _api.Layer).cipher] && /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                x: "294",
                                y: "205",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: t("common.view")
                            }),
                            !isMobile && hoveredLayer === (0, _api.Layer).cipher && disabledMap[(0, _api.Layer).cipher] && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                x: "290",
                                y: "205",
                                fill: graphTheme.hoverText,
                                fontSize: "12px",
                                fontWeight: "700",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-4",
                                        dy: "-5",
                                        children: t("home.coming")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                        dx: "-35",
                                        dy: "12",
                                        children: t("home.soon")
                                    })
                                ]
                            })
                        ]
                    }),
                    network === (0, _network.Network).testnet && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                                id: "filter0_di_6093_290291",
                                x: "114.629",
                                y: "16.0917",
                                width: "162.147",
                                height: "162.146",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "2.46886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "24.6886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0.47451 0 0 0 0 0.313726 0 0 0 0 0 0 0 0 1 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "BackgroundImageFix",
                                        result: "effect1_dropShadow_6093_290291"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "effect1_dropShadow_6093_290291",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "1.23443"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "3.08607"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "shape",
                                        result: "effect2_innerShadow_6093_290291"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                                id: "filter1_di_6093_290291",
                                x: "42.6287",
                                y: "224.092",
                                width: "162.147",
                                height: "162.146",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "2.46886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "24.6886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0.47451 0 0 0 0 0.313726 0 0 0 0 0 0 0 0 1 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "BackgroundImageFix",
                                        result: "effect1_dropShadow_6093_290291"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "effect1_dropShadow_6093_290291",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "1.23443"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "3.08607"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "shape",
                                        result: "effect2_innerShadow_6093_290291"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                                id: "filter2_di_6093_290291",
                                x: "225.629",
                                y: "123.092",
                                width: "162.147",
                                height: "162.146",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "2.46886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "24.6886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0.47451 0 0 0 0 0.313726 0 0 0 0 0 0 0 0 1 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "BackgroundImageFix",
                                        result: "effect1_dropShadow_6093_290291"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "effect1_dropShadow_6093_290291",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "1.23443"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "3.08607"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "shape",
                                        result: "effect2_innerShadow_6093_290291"
                                    })
                                ]
                            })
                        ]
                    }),
                    network === (0, _network.Network).mainnet && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                                id: "filter0_dii_6093_287252",
                                x: "114.629",
                                y: "16.0917",
                                width: "162.147",
                                height: "162.146",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "2.46886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "24.6886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0.135917 0 0 0 0 0 0 0 0 0 0.970833 0 0 0 1 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "BackgroundImageFix",
                                        result: "effect1_dropShadow_6093_287252"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "effect1_dropShadow_6093_287252",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dx: "6.17215",
                                        dy: "9.87544"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "6.17215"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0.996078 0 0 0 0 1 0 0 0 0.95 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "shape",
                                        result: "effect2_innerShadow_6093_287252"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "1.23443"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "3.08607"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "effect2_innerShadow_6093_287252",
                                        result: "effect3_innerShadow_6093_287252"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                                id: "filter1_dii_6093_287252",
                                x: "42.6287",
                                y: "224.092",
                                width: "162.147",
                                height: "162.146",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "2.46886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "24.6886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0.135917 0 0 0 0 0 0 0 0 0 0.970833 0 0 0 1 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "BackgroundImageFix",
                                        result: "effect1_dropShadow_6093_287252"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "effect1_dropShadow_6093_287252",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dx: "6.17215",
                                        dy: "9.87544"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "6.17215"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0.996078 0 0 0 0 1 0 0 0 0.95 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "shape",
                                        result: "effect2_innerShadow_6093_287252"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "1.23443"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "3.08607"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "effect2_innerShadow_6093_287252",
                                        result: "effect3_innerShadow_6093_287252"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                                id: "filter2_dii_6093_287252",
                                x: "225.629",
                                y: "123.092",
                                width: "162.147",
                                height: "162.146",
                                filterUnits: "userSpaceOnUse",
                                colorInterpolationFilters: "sRGB",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                        floodOpacity: "0",
                                        result: "BackgroundImageFix"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "2.46886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "24.6886"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0.135917 0 0 0 0 0 0 0 0 0 0.970833 0 0 0 1 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "BackgroundImageFix",
                                        result: "effect1_dropShadow_6093_287252"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in: "SourceGraphic",
                                        in2: "effect1_dropShadow_6093_287252",
                                        result: "shape"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dx: "6.17215",
                                        dy: "9.87544"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "6.17215"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0.996078 0 0 0 0 1 0 0 0 0.95 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "shape",
                                        result: "effect2_innerShadow_6093_287252"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        in: "SourceAlpha",
                                        type: "matrix",
                                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                        result: "hardAlpha"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                        dy: "1.23443"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                        stdDeviation: "3.08607"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                        in2: "hardAlpha",
                                        operator: "arithmetic",
                                        k2: "-1",
                                        k3: "1"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                        type: "matrix",
                                        values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.58 0"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                        mode: "normal",
                                        in2: "effect2_innerShadow_6093_287252",
                                        result: "effect3_innerShadow_6093_287252"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                id: "paint0_linear_6093_287252",
                                x1: "164.188",
                                y1: "82.5885",
                                x2: "180.881",
                                y2: "93.5764",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#02EAE4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#2C3BD5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                id: "paint1_linear_6093_287252",
                                x1: "225.045",
                                y1: "79.419",
                                x2: "206.45",
                                y2: "94.4218",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#02EAE4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#2C3BD5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                id: "paint2_linear_6093_287252",
                                x1: "95.1547",
                                y1: "335.409",
                                x2: "109.349",
                                y2: "321.34",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#02EAE4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#2C3BD5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                id: "paint3_linear_6093_287252",
                                x1: "155.753",
                                y1: "324.162",
                                x2: "137.454",
                                y2: "308.801",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#02EAE4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#2C3BD5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                id: "paint4_linear_6093_287252",
                                x1: "78.978",
                                y1: "278.402",
                                x2: "100.478",
                                y2: "288.824",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#02EAE4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#2C3BD5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                id: "paint5_linear_6093_287252",
                                x1: "195.2",
                                y1: "40.3895",
                                x2: "196.887",
                                y2: "64.2225",
                                gradientUnits: "userSpaceOnUse",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#02EAE4"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#2C3BD5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                                id: "paint6_radial_6093_287252",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(208.634 82.7783) rotate(110.974) scale(65.1743 65.1749)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#3244E8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#000210",
                                        stopOpacity: "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                                id: "paint7_radial_6093_287252",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(136.634 290.778) rotate(110.974) scale(65.1743 65.1749)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#3244E8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#000210",
                                        stopOpacity: "0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                                id: "paint8_radial_6093_287252",
                                cx: "0",
                                cy: "0",
                                r: "1",
                                gradientUnits: "userSpaceOnUse",
                                gradientTransform: "translate(319.634 189.778) rotate(110.974) scale(65.1743 65.1749)",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        stopColor: "#3244E8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                        offset: "1",
                                        stopColor: "#000210",
                                        stopOpacity: "0"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const Graph = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(GraphCmp));

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/styles":"51PGx","react":"BK2ob","../../../../utils/route-utils":"b2kKi","../../../../hooks/useScreensize":"2HEhN","../../../../../oasis-nexus/api":"dJrPU","../../../../../types/network":"f0o8N","../../../../../styles/theme/testnet/colors":"i4QXC","react-i18next":"e210a","../../../../components/OfflineBanner/hook":"cKMsd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cKMsd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsApiReachable", ()=>useIsApiReachable);
parcelHelpers.export(exports, "useConsensusFreshness", ()=>useConsensusFreshness);
parcelHelpers.export(exports, "useRuntimeFreshness", ()=>useRuntimeFreshness);
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _useFormattedTimestamp = require("../../hooks/useFormattedTimestamp");
var _config = require("../../../config");
const useIsApiReachable = (network)=>{
    const query = (0, _api.useGetStatus)(network);
    if (query.isPaused) return {
        reachable: false,
        reason: "userOffline"
    };
    if (query.isFetched && !query.isSuccess) return {
        reachable: false,
        reason: "apiOffline"
    };
    return {
        reachable: true
    };
};
const useFreshness = (network, query)=>{
    const isApiReachable = useIsApiReachable(network).reachable;
    const data = query.data?.data;
    const lastUpdate = (0, _useFormattedTimestamp.useFormattedTimestampStringWithDistance)(data?.latest_block_time);
    const latestBlock = data?.latest_block;
    if (query.isError) return {
        unavailable: true,
        outOfDate: true
    };
    if (query.isLoading) return {
        outOfDate: undefined
    };
    if (!isApiReachable) // The error state will be handled by NetworkOfflineBanner,
    // no need to display another banner whining about obsolete data.
    return {
        outOfDate: false
    };
    if (!query.isSuccess || !data) return {
        outOfDate: true
    };
    if (data.latest_block === -1) return {
        outOfDate: true
    };
    const timeSinceLastUpdate = query.dataUpdatedAt - new Date(data.latest_block_time).getTime();
    return {
        outOfDate: timeSinceLastUpdate > (0, _config.outOfDateThreshold),
        lastUpdate: lastUpdate,
        latestBlock
    };
};
const useConsensusFreshness = (network)=>{
    const query = (0, _api.useGetStatus)(network);
    return useFreshness(network, query);
};
const useRuntimeFreshness = (scope, queryParams = {})=>{
    if (scope.layer === (0, _api.Layer).consensus) throw new (0, _errors.AppError)((0, _errors.AppErrors).UnsupportedLayer);
    const query = (0, _api.useGetRuntimeStatus)(scope.network, scope.layer, {
        query: {
            refetchInterval: queryParams.polling ? 8000 : undefined
        }
    });
    return useFreshness(scope.network, query);
};

},{"../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","../../hooks/useFormattedTimestamp":"kCD95","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kCD95":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormattedTimestamp", ()=>useFormattedTimestamp);
parcelHelpers.export(exports, "useFormattedTimestampWithDistance", ()=>useFormattedTimestampWithDistance);
parcelHelpers.export(exports, "useFormattedTimestampStringWithDistance", ()=>useFormattedTimestampStringWithDistance);
var _formatDistanceStrict = require("date-fns/formatDistanceStrict");
var _reactI18Next = require("react-i18next");
var _useScreensize = require("./useScreensize");
const useFormattedTimestamp = (timestamp)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!timestamp) return "";
    return t("common.formattedDateTime", {
        timestamp,
        formatParams: {
            timestamp: {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                timeZoneName: "short"
            }
        }
    });
};
const useFormattedTimestampWithDistance = (timestamp)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (!timestamp) return "";
    const distance = (0, _formatDistanceStrict.formatDistanceStrict)(timestamp, new Date(), {
        addSuffix: true
    });
    return isMobile ? distance : t("common.formattedBlockTimestamp", {
        timestamp,
        distance,
        formatParams: {
            timestamp: {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                timeZoneName: "short"
            }
        }
    });
};
const useFormattedTimestampStringWithDistance = (timestamp)=>useFormattedTimestampWithDistance(timestamp ? new Date(timestamp) : undefined);

},{"date-fns/formatDistanceStrict":"6vO2f","react-i18next":"e210a","./useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6vO2f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link formatDistanceStrict} function options.
 */ /**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */ /**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */ parcelHelpers.export(exports, "formatDistanceStrict", ()=>formatDistanceStrict);
var _defaultLocaleMjs = require("./_lib/defaultLocale.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
var _compareAscMjs = require("./compareAsc.mjs");
var _constantsMjs = require("./constants.mjs");
var _toDateMjs = require("./toDate.mjs");
function formatDistanceStrict(date, baseDate, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleMjs.defaultLocale);
    const comparison = (0, _compareAscMjs.compareAsc)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, _toDateMjs.toDate)(baseDate);
        dateRight = (0, _toDateMjs.toDate)(date);
    } else {
        dateLeft = (0, _toDateMjs.toDate)(date);
        dateRight = (0, _toDateMjs.toDate)(baseDate);
    }
    const roundingMethod = (0, _getRoundingMethodMjs.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = dateRight.getTime() - dateLeft.getTime();
    const minutes = milliseconds / (0, _constantsMjs.millisecondsInMinute);
    const timezoneOffset = (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateRight) - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / (0, _constantsMjs.millisecondsInMinute);
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < (0, _constantsMjs.minutesInDay)) unit = "hour";
        else if (dstNormalizedMinutes < (0, _constantsMjs.minutesInMonth)) unit = "day";
        else if (dstNormalizedMinutes < (0, _constantsMjs.minutesInYear)) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / (0, _constantsMjs.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / (0, _constantsMjs.minutesInMonth));
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / (0, _constantsMjs.minutesInYear));
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}
// Fallback for modularized imports:
exports.default = formatDistanceStrict;

},{"./_lib/defaultLocale.mjs":"432Kk","./_lib/defaultOptions.mjs":"26vSa","./_lib/getRoundingMethod.mjs":"bQuCq","./_lib/getTimezoneOffsetInMilliseconds.mjs":"k77PV","./compareAsc.mjs":"5MIdq","./constants.mjs":"9jF9P","./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"432Kk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLocale", ()=>(0, _enUSMjs.enUS));
var _enUSMjs = require("../locale/en-US.mjs");

},{"../locale/en-US.mjs":"jzomf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jzomf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _formatDistanceMjs = require("./en-US/_lib/formatDistance.mjs");
var _formatLongMjs = require("./en-US/_lib/formatLong.mjs");
var _formatRelativeMjs = require("./en-US/_lib/formatRelative.mjs");
var _localizeMjs = require("./en-US/_lib/localize.mjs");
var _matchMjs = require("./en-US/_lib/match.mjs");
const enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceMjs.formatDistance),
    formatLong: (0, _formatLongMjs.formatLong),
    formatRelative: (0, _formatRelativeMjs.formatRelative),
    localize: (0, _localizeMjs.localize),
    match: (0, _matchMjs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// Fallback for modularized imports:
exports.default = enUS;

},{"./en-US/_lib/formatDistance.mjs":"iWd4B","./en-US/_lib/formatLong.mjs":"i8qUp","./en-US/_lib/formatRelative.mjs":"br4hz","./en-US/_lib/localize.mjs":"eN2bf","./en-US/_lib/match.mjs":"9Dhey","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iWd4B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i8qUp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", ()=>formatLong);
var _buildFormatLongFnMjs = require("../../_lib/buildFormatLongFn.mjs");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = {
    date: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnMjs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.mjs":"3QNd3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3QNd3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"br4hz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", ()=>formatRelative);
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eN2bf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", ()=>localize);
var _buildLocalizeFnMjs = require("../../_lib/buildLocalizeFn.mjs");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = {
    ordinalNumber,
    era: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnMjs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.mjs":"6xlic","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6xlic":[function(require,module,exports) {
/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9Dhey":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
var _buildMatchFnMjs = require("../../_lib/buildMatchFn.mjs");
var _buildMatchPatternFnMjs = require("../../_lib/buildMatchPatternFn.mjs");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = {
    ordinalNumber: (0, _buildMatchPatternFnMjs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnMjs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.mjs":"errqt","../../_lib/buildMatchPatternFn.mjs":"6WlAH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"errqt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", ()=>buildMatchFn);
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6WlAH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"26vSa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bQuCq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", ()=>getRoundingMethod);
function getRoundingMethod(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k77PV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
var _toDateMjs = require("../toDate.mjs");
function getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"../toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3SqwM":[function(require,module,exports) {
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toDate", ()=>toDate);
function toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5MIdq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ parcelHelpers.export(exports, "compareAsc", ()=>compareAsc);
var _toDateMjs = require("./toDate.mjs");
function compareAsc(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
// Fallback for modularized imports:
exports.default = compareAsc;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9jF9P":[function(require,module,exports) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "millisecondsInWeek", ()=>millisecondsInWeek);
parcelHelpers.export(exports, "millisecondsInDay", ()=>millisecondsInDay);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minutesInYear", ()=>minutesInYear);
parcelHelpers.export(exports, "minutesInMonth", ()=>minutesInMonth);
parcelHelpers.export(exports, "minutesInDay", ()=>minutesInDay);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
const daysInWeek = 7;
const daysInYear = 365.2425;
const maxTime = Math.pow(10, 8) * 86400000;
const minTime = -maxTime;
const millisecondsInWeek = 604800000;
const millisecondsInDay = 86400000;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInSecond = 1000;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
const minutesInHour = 60;
const monthsInQuarter = 3;
const monthsInYear = 12;
const quartersInYear = 4;
const secondsInHour = 3600;
const secondsInMinute = 60;
const secondsInDay = secondsInHour * 24;
const secondsInWeek = secondsInDay * 7;
const secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = secondsInYear / 12;
const secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3zpNP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeSelectorStep", ()=>ParaTimeSelectorStep);
var ParaTimeSelectorStep;
(function(ParaTimeSelectorStep) {
    /**
   * Graph interactions disabled - explore button shown on top of graph
   */ ParaTimeSelectorStep[ParaTimeSelectorStep["EnableExplore"] = 0] = "EnableExplore";
    /**
   * Show help screen
   */ ParaTimeSelectorStep[ParaTimeSelectorStep["ShowHelpScreen"] = 1] = "ShowHelpScreen";
    /**
   * Graph interactions enabled
   */ ParaTimeSelectorStep[ParaTimeSelectorStep["Explore"] = 2] = "Explore";
})(ParaTimeSelectorStep || (ParaTimeSelectorStep = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4g6ag":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeSelectorUtils", ()=>ParaTimeSelectorUtils);
var _types = require("./types");
var _storage = require("../../../utils/storage");
var _storage1 = require("../../../../types/storage");
const localStore = (0, _storage.storage)();
class ParaTimeSelectorUtils {
    static getIsGraphTransparent(step) {
        return step !== (0, _types.ParaTimeSelectorStep).Explore;
    }
    static showExploreBtn(step) {
        return step === (0, _types.ParaTimeSelectorStep).EnableExplore;
    }
    static showMobileHelpScreen(step, isMobile, showInfoScreen) {
        const mobileHelpScreenShown = localStore.get((0, _storage1.StorageKeys).MobileHelpScreenShown);
        if (!showInfoScreen && (!isMobile || mobileHelpScreenShown)) return false;
        return step === (0, _types.ParaTimeSelectorStep).ShowHelpScreen;
    }
}

},{"./types":"3zpNP","../../../utils/storage":"lxVX3","../../../../types/storage":"8d6ef","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lxVX3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storage", ()=>storage);
var _errors = require("../../types/errors");
const storage = (storage = localStorage)=>{
    const set = (key, value)=>{
        try {
            const serializedValue = JSON.stringify(value);
            storage.setItem(key, serializedValue);
        } catch (error) {
            throw new (0, _errors.AppError)((0, _errors.AppErrors).Storage);
        }
    };
    const get = (key)=>{
        try {
            const serializedValue = storage.getItem(key);
            if (!serializedValue) return;
            return JSON.parse(serializedValue);
        } catch (error) {
            throw new (0, _errors.AppError)((0, _errors.AppErrors).Storage);
        }
    };
    const removeItem = (key)=>{
        storage.removeItem(key);
    };
    const clear = ()=>{
        storage.clear();
    };
    return {
        set,
        get,
        removeItem,
        clear
    };
};

},{"../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8d6ef":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageKeys", ()=>StorageKeys);
var StorageKeys;
(function(StorageKeys) {
    StorageKeys["MobileHelpScreenShown"] = "mobile-help-screen-shown";
})(StorageKeys || (StorageKeys = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6igNy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTranslate3DSupport", ()=>(0, _utils.hasTranslate3DSupport));
parcelHelpers.export(exports, "make2dTransformValue", ()=>(0, _utils.make2dTransformValue));
parcelHelpers.export(exports, "make3dTransformValue", ()=>(0, _utils.make3dTransformValue));
parcelHelpers.export(exports, "isTouch", ()=>(0, _utils.isTouch));
var _component = require("./PinchZoom/component");
var _componentDefault = parcelHelpers.interopDefault(_component);
var _utils = require("./utils");
exports.default = (0, _componentDefault.default);

},{"./PinchZoom/component":"03LjP","./utils":"HgiOj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"03LjP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stylesCss = require("./styles.css");
var _utils = require("../utils");
var _getOffsetBounds = require("./getOffsetBounds");
var classnames = function(base, other) {
    return other ? "".concat(base, " ").concat(other) : base;
};
var abs = Math.abs, min = Math.min, sqrt = Math.sqrt;
var isSsr = typeof window === "undefined";
var isMac = isSsr ? false : /(Mac)/i.test(navigator.platform);
var isDragInteraction = function(i) {
    return i === "drag";
};
var isZoomInteraction = function(i) {
    return i === "zoom";
};
var isZoomGesture = function(wheelEvent) {
    return isMac && wheelEvent.ctrlKey;
};
var cancelEvent = function(event) {
    event.stopPropagation();
    event.preventDefault();
};
var getDistance = function(a, b) {
    var x = a.x - b.x;
    var y = a.y - b.y;
    return sqrt(x * x + y * y);
};
var calculateScale = function(startTouches, endTouches) {
    var startDistance = getDistance(startTouches[0], startTouches[1]);
    var endDistance = getDistance(endTouches[0], endTouches[1]);
    return endDistance / startDistance;
};
var isCloseTo = function(value, expected) {
    return value > expected - 0.01 && value < expected + 0.01;
};
var swing = function(p) {
    return -Math.cos(p * Math.PI) / 2 + 0.5;
};
var getPointByPageCoordinates = function(touch) {
    return {
        x: touch.pageX,
        y: touch.pageY
    };
};
var getPageCoordinatesByTouches = function(touches) {
    return Array.from(touches).map(getPointByPageCoordinates);
};
var sum = function(a, b) {
    return a + b;
};
var getVectorAvg = function(vectors) {
    return {
        x: vectors.map(function(_a) {
            var x = _a.x;
            return x;
        }).reduce(sum, 0) / vectors.length,
        y: vectors.map(function(_a) {
            var y = _a.y;
            return y;
        }).reduce(sum, 0) / vectors.length
    };
};
var clamp = function(min, max, value) {
    return value < min ? min : value > max ? max : value;
};
var shouldInterceptWheel = function(event) {
    return !(event.ctrlKey || event.metaKey);
};
var getElementSize = function(element) {
    if (element) {
        var offsetWidth = element.offsetWidth, offsetHeight = element.offsetHeight;
        // Any DOMElement
        if (offsetWidth && offsetHeight) return {
            width: offsetWidth,
            height: offsetHeight
        };
        // Svg support
        var style = getComputedStyle(element);
        var width = parseFloat(style.width);
        var height = parseFloat(style.height);
        if (height && width) return {
            width: width,
            height: height
        };
    }
    return {
        width: 0,
        height: 0
    };
};
var calculateVelocity = function(startPoint, endPoint) {
    return {
        x: endPoint.x - startPoint.x,
        y: endPoint.y - startPoint.y
    };
};
var comparePoints = function(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
};
var noup = function() {};
var zeroPoint = {
    x: 0,
    y: 0
};
var PinchZoom = /** @class */ function(_super) {
    (0, _tslib.__extends)(PinchZoom, _super);
    function PinchZoom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._prevDragMovePoint = null;
        _this._containerObserver = null;
        _this._fingers = 0;
        _this._firstMove = true;
        _this._initialOffset = (0, _tslib.__assign)({}, zeroPoint);
        _this._interaction = null;
        _this._isDoubleTap = false;
        _this._isOffsetsSet = false;
        _this._lastDragPosition = null;
        _this._lastScale = 1;
        _this._lastTouchStart = 0;
        _this._lastZoomCenter = null;
        _this._listenMouseMove = false;
        _this._nthZoom = 0;
        _this._offset = (0, _tslib.__assign)({}, zeroPoint);
        _this._startOffset = (0, _tslib.__assign)({}, zeroPoint);
        _this._startTouches = null;
        _this._updatePlaned = false;
        _this._wheelTimeOut = null;
        _this._zoomFactor = 1;
        _this._initialZoomFactor = 1;
        _this._draggingPoint = (0, _tslib.__assign)({}, zeroPoint);
        // It help reduce behavior difference between touch and mouse events
        _this._ignoreNextClick = false;
        // @ts-ignore
        _this._containerRef = (0, _react.createRef)();
        _this._handleClick = function(clickEvent) {
            if (_this._ignoreNextClick) {
                _this._ignoreNextClick = false;
                clickEvent.stopPropagation();
            }
        };
        _this._onResize = function() {
            var _a;
            if ((_a = _this._containerRef) === null || _a === void 0 ? void 0 : _a.current) {
                _this._updateInitialZoomFactor();
                _this._setupOffsets();
                _this._update();
            }
        };
        _this._handlerOnTouchEnd = _this._handlerIfEnable(function(touchEndEvent) {
            _this._fingers = touchEndEvent.touches.length;
            if (_this.props.shouldCancelHandledTouchEndEvents && (isZoomInteraction(_this._interaction) || isDragInteraction(_this._interaction) && (_this._startOffset.x !== _this._offset.x || _this._startOffset.y !== _this._offset.y))) cancelEvent(touchEndEvent);
            if (isDragInteraction(_this._interaction) && !_this._enoughToDrag()) _this._handleClick(touchEndEvent);
            _this._updateInteraction(touchEndEvent);
        });
        _this._handlerOnTouchStart = _this._handlerIfEnable(function(touchStartEvent) {
            _this._firstMove = true;
            _this._fingers = touchStartEvent.touches.length;
            _this._detectDoubleTap(touchStartEvent);
        });
        _this._handlerOnTouchMove = _this._handlerIfEnable(function(touchMoveEvent) {
            if (_this._isDoubleTap) return;
            _this._collectInertia(touchMoveEvent);
            if (_this._firstMove) {
                _this._updateInteraction(touchMoveEvent);
                if (_this._interaction) cancelEvent(touchMoveEvent);
                _this._startOffset = (0, _tslib.__assign)({}, _this._offset);
                _this._startTouches = getPageCoordinatesByTouches(touchMoveEvent.touches);
            } else {
                if (isZoomInteraction(_this._interaction)) {
                    if (_this._startTouches && _this._startTouches.length === 2 && touchMoveEvent.touches.length === 2) _this._handleZoom(touchMoveEvent, calculateScale(_this._startTouches, getPageCoordinatesByTouches(touchMoveEvent.touches)));
                } else if (isDragInteraction(_this._interaction)) _this._handleDrag(touchMoveEvent);
                if (_this._interaction) {
                    cancelEvent(touchMoveEvent);
                    _this._update();
                }
            }
            _this._firstMove = false;
        });
        _this._handlerWheel = function(wheelEvent) {
            if (_this.props.shouldInterceptWheel(wheelEvent)) return;
            cancelEvent(wheelEvent);
            var pageX = wheelEvent.pageX, pageY = wheelEvent.pageY, deltaY = wheelEvent.deltaY, deltaMode = wheelEvent.deltaMode;
            var scaleDelta = 1;
            if (isZoomGesture(wheelEvent) || deltaMode === 1) scaleDelta = 15;
            var likeTouchEvent = {
                touches: [
                    // @ts-ignore
                    {
                        pageX: pageX,
                        pageY: pageY
                    }
                ]
            };
            var center = _this._getOffsetByFirstTouch(likeTouchEvent);
            var dScale = deltaY * scaleDelta;
            _this._stopAnimation();
            _this._scaleTo(_this._zoomFactor - dScale / _this.props.wheelScaleFactor, center);
            _this._update();
            clearTimeout(// @ts-ignore
            _this._wheelTimeOut);
            _this._wheelTimeOut = setTimeout(function() {
                return _this._sanitize();
            }, 100);
        };
        // @ts-ignore
        _this._handlers = _this.props.isTouch() ? [
            [
                "touchstart",
                _this._handlerOnTouchStart
            ],
            [
                "touchend",
                _this._handlerOnTouchEnd
            ],
            [
                "touchmove",
                _this._handlerOnTouchMove
            ]
        ] : [
            [
                "mousemove",
                _this.simulate(_this._handlerOnTouchMove),
                _this.props._document
            ],
            [
                "mouseup",
                _this.simulate(_this._handlerOnTouchEnd),
                _this.props._document
            ],
            [
                "mousedown",
                _this.simulate(_this._handlerOnTouchStart)
            ],
            [
                "click",
                _this._handleClick
            ],
            [
                "wheel",
                _this._handlerWheel
            ]
        ];
        return _this;
    }
    PinchZoom.prototype._handleDragStart = function(event) {
        this._ignoreNextClick = true;
        this.props.onDragStart();
        this._stopAnimation();
        this._resetInertia();
        this._lastDragPosition = null;
        this._hasInteraction = true;
        this._draggingPoint = this._offset;
        this._handleDrag(event);
    };
    PinchZoom.prototype._handleDrag = function(event) {
        var touch = this._getOffsetByFirstTouch(event);
        if (this._enoughToDrag()) this._drag(touch, this._lastDragPosition);
        else this._virtualDrag(touch, this._lastDragPosition);
        this._offset = this._sanitizeOffset(this._offset);
        this._lastDragPosition = touch;
    };
    PinchZoom.prototype._resetInertia = function() {
        this._velocity = null;
        this._prevDragMovePoint = null;
    };
    PinchZoom.prototype._realizeInertia = function() {
        var _this = this;
        var _a = this.props, inertiaFriction = _a.inertiaFriction, inertia = _a.inertia;
        if (!inertia || !this._velocity) return;
        var _b = this._velocity, x = _b.x, y = _b.y;
        if (x || y) {
            this._stopAnimation();
            this._resetInertia();
            var renderFrame = function() {
                x *= inertiaFriction;
                y *= inertiaFriction;
                if (!x && !y) return _this._stopAnimation();
                var prevOffset = (0, _tslib.__assign)({}, _this._offset);
                _this._addOffset({
                    x: x,
                    y: y
                });
                _this._offset = _this._sanitizeOffset(_this._offset);
                if (comparePoints(prevOffset, _this._offset)) return _this._stopAnimation();
                _this._update({
                    isAnimation: true
                });
            };
            this._animate(renderFrame, {
                duration: 9999
            });
        }
    };
    PinchZoom.prototype._collectInertia = function(_a) {
        var touches = _a.touches;
        if (!this.props.inertia) return;
        var currentCoordinates = getPageCoordinatesByTouches(touches)[0];
        var prevPoint = this._prevDragMovePoint;
        if (prevPoint) this._velocity = calculateVelocity(currentCoordinates, prevPoint);
        this._prevDragMovePoint = currentCoordinates;
    };
    PinchZoom.prototype._handleDragEnd = function() {
        this.props.onDragEnd();
        this._end();
        this._realizeInertia();
    };
    PinchZoom.prototype._handleZoomStart = function() {
        this.props.onZoomStart();
        this._stopAnimation();
        this._lastScale = 1;
        this._nthZoom = 0;
        this._lastZoomCenter = null;
        this._hasInteraction = true;
    };
    PinchZoom.prototype._handleZoom = function(event, newScale) {
        var touchCenter = getVectorAvg(this._getOffsetTouches(event));
        var scale = newScale / this._lastScale;
        this._lastScale = newScale;
        // The first touch events are thrown away since they are not precise
        this._nthZoom += 1;
        if (this._nthZoom > 3) {
            this._scale(scale, touchCenter);
            this._drag(touchCenter, this._lastZoomCenter);
            if (this.props.enforceBoundsDuringZoom) this._offset = this._sanitizeOffset(this._offset);
        }
        this._lastZoomCenter = touchCenter;
    };
    PinchZoom.prototype._handleZoomEnd = function() {
        this.props.onZoomEnd();
        this._end();
    };
    PinchZoom.prototype._handleDoubleTap = function(event) {
        var _this = this;
        if (this._hasInteraction || this.props.tapZoomFactor === 0) return;
        var needZoomOut = this.props.doubleTapZoomOutOnMaxScale && this._zoomFactor === this.props.maxZoom || this.props.doubleTapToggleZoom && this._zoomFactor > 1;
        this.props.onDoubleTap();
        this._ignoreNextClick = true;
        var zoomFactor = this._zoomFactor + this.props.tapZoomFactor;
        var startZoomFactor = this._zoomFactor;
        var updateProgress = function(progress) {
            _this._scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
        };
        var center = this._getOffsetByFirstTouch(event);
        this._isDoubleTap = true;
        if (startZoomFactor > zoomFactor) center = this._getCurrentZoomCenter();
        needZoomOut ? this._zoomOutAnimation() : this._animate(updateProgress);
    };
    PinchZoom.prototype._computeInitialOffset = function() {
        var rect = this._getContainerRect();
        var _a = this._getChildSize(), width = _a.width, height = _a.height;
        var x = -abs(width * this._getInitialZoomFactor() - rect.width) / 2;
        var y = -abs(height * this._getInitialZoomFactor() - rect.height) / 2;
        this._initialOffset = {
            x: x,
            y: y
        };
    };
    PinchZoom.prototype._resetOffset = function() {
        this._offset = (0, _tslib.__assign)({}, this._initialOffset);
    };
    PinchZoom.prototype._setupOffsets = function() {
        if (this.props.setOffsetsOnce && this._isOffsetsSet) return;
        this._isOffsetsSet = true;
        this._computeInitialOffset();
        this._resetOffset();
    };
    PinchZoom.prototype._sanitizeOffset = function(offset) {
        var rect = this._getContainerRect();
        var _a = this._getChildSize(), width = _a.width, height = _a.height;
        var elWidth = width * this._getInitialZoomFactor() * this._zoomFactor;
        var elHeight = height * this._getInitialZoomFactor() * this._zoomFactor;
        var _b = (0, _getOffsetBounds.getOffsetBounds)({
            containerDimension: rect.width,
            childDimension: elWidth,
            padding: this.props.horizontalPadding,
            centerContained: this.props.centerContained
        }), minOffsetX = _b[0], maxOffsetX = _b[1];
        var _c = (0, _getOffsetBounds.getOffsetBounds)({
            containerDimension: rect.height,
            childDimension: elHeight,
            padding: this.props.verticalPadding,
            centerContained: this.props.centerContained
        }), minOffsetY = _c[0], maxOffsetY = _c[1];
        return {
            x: clamp(minOffsetX, maxOffsetX, offset.x),
            y: clamp(minOffsetY, maxOffsetY, offset.y)
        };
    };
    PinchZoom.prototype.alignCenter = function(options) {
        var _this = this;
        var _a = (0, _tslib.__assign)({
            duration: 250,
            animated: true
        }, options), __x = _a.x, __y = _a.y, scale = _a.scale, animated = _a.animated, duration = _a.duration;
        // Bug-Fix: https://github.com/retyui/react-quick-pinch-zoom/issues/58
        var x = __x * this._initialZoomFactor;
        var y = __y * this._initialZoomFactor;
        var startZoomFactor = this._zoomFactor;
        var startOffset = (0, _tslib.__assign)({}, this._offset);
        var rect = this._getContainerRect();
        var containerCenter = {
            x: rect.width / 2,
            y: rect.height / 2
        };
        this._zoomFactor = 1;
        this._offset = {
            x: -(containerCenter.x - x),
            y: -(containerCenter.y - y)
        };
        this._scaleTo(scale, containerCenter);
        this._stopAnimation();
        if (!animated) return this._update();
        var diffZoomFactor = this._zoomFactor - startZoomFactor;
        var diffOffset = {
            x: this._offset.x - startOffset.x,
            y: this._offset.y - startOffset.y
        };
        this._zoomFactor = startZoomFactor;
        this._offset = (0, _tslib.__assign)({}, startOffset);
        var updateFrame = function(progress) {
            var x = startOffset.x + diffOffset.x * progress;
            var y = startOffset.y + diffOffset.y * progress;
            _this._zoomFactor = startZoomFactor + diffZoomFactor * progress;
            _this._offset = _this._sanitizeOffset({
                x: x,
                y: y
            });
            _this._update();
        };
        this._animate(updateFrame, {
            callback: function() {
                return _this._sanitize();
            },
            duration: duration
        });
    };
    PinchZoom.prototype.scaleTo = function(options) {
        var _this = this;
        var _a = (0, _tslib.__assign)({
            duration: 250,
            animated: true
        }, options), x = _a.x, y = _a.y, scale = _a.scale, animated = _a.animated, duration = _a.duration;
        var startZoomFactor = this._zoomFactor;
        var startOffset = (0, _tslib.__assign)({}, this._offset);
        this._zoomFactor = 1;
        this._offset = {
            x: 0,
            y: 0
        };
        this._scaleTo(scale, {
            x: x,
            y: y
        });
        this._stopAnimation();
        if (!animated) return this._update();
        var diffZoomFactor = this._zoomFactor - startZoomFactor;
        var diffOffset = {
            x: this._offset.x - startOffset.x,
            y: this._offset.y - startOffset.y
        };
        this._zoomFactor = startZoomFactor;
        this._offset = (0, _tslib.__assign)({}, startOffset);
        var updateFrame = function(progress) {
            var x = startOffset.x + diffOffset.x * progress;
            var y = startOffset.y + diffOffset.y * progress;
            _this._zoomFactor = startZoomFactor + diffZoomFactor * progress;
            _this._offset = {
                x: x,
                y: y
            };
            _this._update();
        };
        this._animate(updateFrame, {
            callback: function() {
                return _this._sanitize();
            },
            duration: duration
        });
    };
    PinchZoom.prototype._scaleTo = function(zoomFactor, center) {
        this._scale(zoomFactor / this._zoomFactor, center);
        this._offset = this._sanitizeOffset(this._offset);
    };
    PinchZoom.prototype._scale = function(scale, center) {
        scale = this._scaleZoomFactor(scale);
        this._addOffset({
            x: (scale - 1) * (center.x + this._offset.x),
            y: (scale - 1) * (center.y + this._offset.y)
        });
        this.props.onZoomUpdate();
    };
    PinchZoom.prototype._scaleZoomFactor = function(scale) {
        var originalZoomFactor = this._zoomFactor;
        this._zoomFactor *= scale;
        this._zoomFactor = clamp(this.props.minZoom, this.props.maxZoom, this._zoomFactor);
        return this._zoomFactor / originalZoomFactor;
    };
    PinchZoom.prototype._canDrag = function() {
        return this.props.draggableUnZoomed || !isCloseTo(this._zoomFactor, 1);
    };
    PinchZoom.prototype._drag = function(center, lastCenter) {
        if (lastCenter) {
            var y = -(center.y - lastCenter.y);
            var x = -(center.x - lastCenter.x);
            if (!this.props.lockDragAxis) this._addOffset({
                x: x,
                y: y
            });
            else // lock scroll to position that was changed the most
            if (abs(x) > abs(y)) this._addOffset({
                x: x,
                y: 0
            });
            else this._addOffset({
                y: y,
                x: 0
            });
            this.props.onDragUpdate();
        }
    };
    PinchZoom.prototype._virtualDrag = function(center, lastCenter) {
        if (lastCenter) {
            var y = -(center.y - lastCenter.y);
            var x = -(center.x - lastCenter.x);
            this._draggingPoint = {
                x: x + this._draggingPoint.x,
                y: y + this._draggingPoint.y
            };
        }
    };
    PinchZoom.prototype._addOffset = function(offset) {
        var _a = this._offset, x = _a.x, y = _a.y;
        this._offset = {
            x: x + offset.x,
            y: y + offset.y
        };
    };
    PinchZoom.prototype._sanitize = function() {
        if (this._zoomFactor < this.props.zoomOutFactor) {
            this._resetInertia();
            this._zoomOutAnimation();
        } else if (this._isInsaneOffset()) this._sanitizeOffsetAnimation();
    };
    PinchZoom.prototype._isInsaneOffset = function() {
        var offset = this._offset;
        var sanitizedOffset = this._sanitizeOffset(offset);
        return sanitizedOffset.x !== offset.x || sanitizedOffset.y !== offset.y;
    };
    PinchZoom.prototype._sanitizeOffsetAnimation = function() {
        var _this = this;
        var targetOffset = this._sanitizeOffset(this._offset);
        var startOffset = (0, _tslib.__assign)({}, this._offset);
        var updateProgress = function(progress) {
            var x = startOffset.x + progress * (targetOffset.x - startOffset.x);
            var y = startOffset.y + progress * (targetOffset.y - startOffset.y);
            _this._offset = {
                x: x,
                y: y
            };
            _this._update();
        };
        this._animate(updateProgress);
    };
    PinchZoom.prototype._zoomOutAnimation = function() {
        var _this = this;
        if (this._zoomFactor === 1) return;
        var startZoomFactor = this._zoomFactor;
        var zoomFactor = 1;
        var center = this._getCurrentZoomCenter();
        var updateProgress = function(progress) {
            var scaleFactor = startZoomFactor + progress * (zoomFactor - startZoomFactor);
            _this._scaleTo(scaleFactor, center);
        };
        this._animate(updateProgress);
    };
    PinchZoom.prototype._getInitialZoomFactor = function() {
        return this._initialZoomFactor;
    };
    PinchZoom.prototype._getCurrentZoomCenter = function() {
        var _a = this._offset, x = _a.x, y = _a.y;
        var offsetLeft = x - this._initialOffset.x;
        var offsetTop = y - this._initialOffset.y;
        return {
            x: -1 * x - offsetLeft / (1 / this._zoomFactor - 1),
            y: -1 * y - offsetTop / (1 / this._zoomFactor - 1)
        };
    };
    PinchZoom.prototype._getOffsetByFirstTouch = function(event) {
        return this._getOffsetTouches(event)[0];
    };
    PinchZoom.prototype._getOffsetTouches = function(event) {
        var _document = this.props._document;
        var _html = _document.documentElement;
        var _body = _document.body;
        var _a = this._getContainerRect(), top = _a.top, left = _a.left;
        var scrollTop = _html.scrollTop || _body.scrollTop;
        var scrollLeft = _html.scrollLeft || _body.scrollLeft;
        var posTop = top + scrollTop;
        var posLeft = left + scrollLeft;
        return getPageCoordinatesByTouches(event.touches).map(function(_a) {
            var x = _a.x, y = _a.y;
            return {
                x: x - posLeft,
                y: y - posTop
            };
        });
    };
    PinchZoom.prototype._animate = function(frameFn, options) {
        var _this = this;
        var startTime = new Date().getTime();
        var _a = (0, _tslib.__assign)({
            timeFn: swing,
            callback: function() {},
            duration: this.props.animationDuration
        }, options), timeFn = _a.timeFn, callback = _a.callback, duration = _a.duration;
        var renderFrame = function() {
            if (!_this._inAnimation) return;
            var frameTime = new Date().getTime() - startTime;
            var progress = frameTime / duration;
            if (frameTime >= duration) {
                frameFn(1);
                _this._stopAnimation();
                callback();
                _this._update();
            } else {
                progress = timeFn(progress);
                frameFn(progress);
                _this._update({
                    isAnimation: true
                });
                requestAnimationFrame(renderFrame);
            }
        };
        this._inAnimation = true;
        requestAnimationFrame(renderFrame);
    };
    PinchZoom.prototype._stopAnimation = function() {
        this._inAnimation = false;
    };
    PinchZoom.prototype._end = function() {
        this._hasInteraction = false;
        this._sanitize();
        this._update();
    };
    PinchZoom.prototype._getContainerRect = function() {
        var div = this._containerRef.current;
        return div.getBoundingClientRect();
    };
    PinchZoom.prototype._getChildSize = function() {
        var div = this._containerRef.current;
        return getElementSize(div === null || div === void 0 ? void 0 : div.firstElementChild);
    };
    PinchZoom.prototype._updateInitialZoomFactor = function() {
        var rect = this._getContainerRect();
        var size = this._getChildSize();
        var xZoomFactor = rect.width / size.width;
        var yZoomFactor = rect.height / size.height;
        this._initialZoomFactor = min(xZoomFactor, yZoomFactor);
    };
    PinchZoom.prototype._bindEvents = function() {
        var _this = this;
        var div = this._containerRef.current;
        if (window.ResizeObserver) {
            this._containerObserver = new ResizeObserver(this._onResize);
            this._containerObserver.observe(div);
        } else window.addEventListener("resize", this._onResize);
        this._handlers.forEach(function(_a) {
            var eventName = _a[0], fn = _a[1], target = _a[2];
            (target || div).addEventListener(eventName, fn, true);
        });
        Array.from(div.querySelectorAll("img")).forEach(function(img) {
            return img.addEventListener("load", _this._onResize);
        });
    };
    PinchZoom.prototype._unSubscribe = function() {
        var _this = this;
        var div = this._containerRef.current;
        if (this._containerObserver) {
            this._containerObserver.disconnect();
            this._containerObserver = null;
        }
        window.removeEventListener("resize", this._onResize);
        this._handlers.forEach(function(_a) {
            var eventName = _a[0], fn = _a[1], target = _a[2];
            (target || div).removeEventListener(eventName, fn, true);
        });
        Array.from(div.querySelectorAll("img")).forEach(function(img) {
            return img.removeEventListener("load", _this._onResize);
        });
    };
    PinchZoom.prototype._update = function(options) {
        var _this = this;
        if (this._updatePlaned) return;
        var updateFrame = function() {
            var scale = _this._getInitialZoomFactor() * _this._zoomFactor;
            var x = -_this._offset.x / scale;
            var y = -_this._offset.y / scale;
            _this.props.onUpdate({
                scale: scale,
                x: x,
                y: y
            });
        };
        if (options === null || options === void 0 ? void 0 : options.isAnimation) return updateFrame();
        this._updatePlaned = true;
        requestAnimationFrame(function() {
            _this._updatePlaned = false;
            updateFrame();
        });
    };
    PinchZoom.prototype._handlerIfEnable = function(fn) {
        var _this = this;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (_this.props.enabled) fn.apply(void 0, args);
        };
    };
    PinchZoom.prototype._setInteraction = function(newInteraction, event) {
        var interaction = this._interaction;
        if (interaction !== newInteraction) {
            if (interaction && !newInteraction) {
                if (isZoomInteraction(interaction)) this._handleZoomEnd();
                else if (isDragInteraction(interaction)) this._handleDragEnd();
            }
            if (isZoomInteraction(newInteraction)) this._handleZoomStart();
            else if (isDragInteraction(newInteraction)) this._handleDragStart(event);
        }
        this._interaction = newInteraction;
    };
    PinchZoom.prototype._distanceBetweenNumbers = function(a, b) {
        return a > b ? a - b : b - a;
    };
    PinchZoom.prototype._enoughToDrag = function() {
        if (this._distanceBetweenNumbers(this._startOffset.x, this._draggingPoint.x) > 5 || this._distanceBetweenNumbers(this._startOffset.y, this._draggingPoint.y) > 5) return true;
        return false;
    };
    PinchZoom.prototype._updateInteraction = function(event) {
        var fingers = this._fingers;
        if (fingers === 2) return this._setInteraction("zoom", event);
        if (fingers === 1 && this._canDrag()) return this._setInteraction("drag", event);
        this._setInteraction(null, event);
    };
    PinchZoom.prototype._detectDoubleTap = function(event) {
        var time = new Date().getTime();
        if (this._fingers > 1) this._lastTouchStart = 0;
        if (time - this._lastTouchStart < 300) {
            cancelEvent(event);
            this._handleDoubleTap(event);
            if (isZoomInteraction(this._interaction)) this._handleZoomEnd();
            else if (isDragInteraction(this._interaction)) this._handleDragEnd();
        } else this._isDoubleTap = false;
        if (this._fingers === 1) this._lastTouchStart = time;
    };
    PinchZoom.prototype.simulate = function(fn) {
        var _this = this;
        return function(mouseEvent) {
            var pageX = mouseEvent.pageX, pageY = mouseEvent.pageY, type = mouseEvent.type;
            var isEnd = type === "mouseup";
            var isStart = type === "mousedown";
            if (isStart) {
                mouseEvent.preventDefault();
                _this._listenMouseMove = true;
            }
            if (_this._listenMouseMove) {
                // @ts-ignore
                mouseEvent.touches = isEnd ? [] : [
                    {
                        pageX: pageX,
                        pageY: pageY
                    }
                ];
                fn(// @ts-ignore
                mouseEvent);
            }
            if (isEnd) _this._listenMouseMove = false;
        };
    };
    PinchZoom.prototype.componentDidMount = function() {
        this._bindEvents();
        this._update();
    };
    PinchZoom.prototype.componentWillUnmount = function() {
        this._stopAnimation();
        this._unSubscribe();
    };
    PinchZoom.prototype.render = function() {
        var _a = this.props, children = _a.children, containerProps = _a.containerProps;
        var child = (0, _react.Children).only(children);
        var props = containerProps || {};
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("style", null, (0, _stylesCss.styles)), (0, _reactDefault.default).createElement("div", (0, _tslib.__assign)({}, props, {
            ref: this._containerRef,
            className: classnames((0, _stylesCss.styleRoot), props.className)
        }), (0, _react.cloneElement)(child, {
            className: classnames((0, _stylesCss.styleChild), child.props.className)
        })));
    };
    PinchZoom.defaultProps = {
        animationDuration: 250,
        draggableUnZoomed: true,
        enforceBoundsDuringZoom: false,
        centerContained: false,
        enabled: true,
        inertia: true,
        inertiaFriction: 0.96,
        horizontalPadding: 0,
        isTouch: (0, _utils.isTouch),
        lockDragAxis: false,
        maxZoom: 5,
        minZoom: 0.5,
        onDoubleTap: noup,
        onDragEnd: noup,
        onDragStart: noup,
        onDragUpdate: noup,
        onZoomEnd: noup,
        onZoomStart: noup,
        onZoomUpdate: noup,
        setOffsetsOnce: false,
        shouldInterceptWheel: shouldInterceptWheel,
        shouldCancelHandledTouchEndEvents: false,
        tapZoomFactor: 1,
        verticalPadding: 0,
        wheelScaleFactor: 1500,
        zoomOutFactor: 1.3,
        doubleTapZoomOutOnMaxScale: false,
        doubleTapToggleZoom: false,
        // @ts-expect-error
        _document: isSsr ? null : window.document
    };
    return PinchZoom;
}((0, _react.Component));
var _a, any, element, object, number, func, bool;
exports.default = PinchZoom;

},{"tslib":"2H6U9","react":"BK2ob","./styles.css":"1kqB5","../utils":"HgiOj","./getOffsetBounds":"4rwZE","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2H6U9":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1kqB5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleRoot", ()=>styleRoot);
parcelHelpers.export(exports, "styleChild", ()=>styleChild);
parcelHelpers.export(exports, "styles", ()=>styles);
var styleRoot = "kvfysmfp";
var styleChild = "ufhsfnkm";
var styles = ".".concat(styleRoot, "{overflow:hidden;touch-action:none}.").concat(styleChild, "{transform-origin: 0 0}");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"HgiOj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTouch", ()=>isTouch);
parcelHelpers.export(exports, "make2dTransformValue", ()=>make2dTransformValue);
parcelHelpers.export(exports, "make3dTransformValue", ()=>make3dTransformValue);
parcelHelpers.export(exports, "hasTranslate3DSupport", ()=>hasTranslate3DSupport);
var isSsr = typeof window === "undefined";
var isTouch = function() {
    return !isSsr && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
};
var make2dTransformValue = function(_a) {
    var x = _a.x, y = _a.y, scale = _a.scale;
    return "scale(".concat(scale, ") translate(").concat(x, "px, ").concat(y, "px)");
};
var make3dTransformValue = function(_a) {
    var x = _a.x, y = _a.y, scale = _a.scale;
    return "scale3d(".concat(scale, ",").concat(scale, ", 1) translate3d(").concat(x, "px, ").concat(y, "px, 0)");
};
var hasTranslate3DSupport = function() {
    var css = !isSsr && window.CSS;
    return css && css.supports && css.supports("transform", "translate3d(0,0,0)");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4rwZE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffsetBounds", ()=>getOffsetBounds);
var min = Math.min, max = Math.max;
function getOffsetBounds(_a) {
    var containerDimension = _a.containerDimension, childDimension = _a.childDimension, padding = _a.padding, centerContained = _a.centerContained;
    var diff = childDimension - containerDimension;
    if (diff + 2 * padding <= 0 && centerContained) return [
        diff / 2,
        diff / 2
    ];
    else return [
        min(diff + padding, 0) - padding,
        max(0, diff + padding)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5sXJ8":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("ba1e4328c093dd36");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("83c5ca8882966333"));
var _jsxRuntime = require("dd05b9c53ca3eb31");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");

},{"ba1e4328c093dd36":"hykHy","83c5ca8882966333":"gQLSP","dd05b9c53ca3eb31":"g88cO"}],"bTeKH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphUtils", ()=>GraphUtils);
var _api = require("../../../../../oasis-nexus/api");
var _errors = require("../../../../../types/errors");
class GraphUtils {
    static getScaleTo(layer, { width, height }) {
        const initialValue = {
            scale: 1,
            x: 0,
            y: 0
        };
        if (!width || !height) return initialValue;
        switch(layer){
            case (0, _api.Layer).emerald:
                return {
                    scale: 2.4,
                    x: 0.68 * width,
                    y: 0.1 * height
                };
            case (0, _api.Layer).cipher:
                return {
                    scale: 2.4,
                    x: 1.2 * width,
                    y: 0.7 * height
                };
            case (0, _api.Layer).pontusx:
                // TODO: update this if/when we want to display this layer
                // We meed this case here since this switch/case is declared to be exhaustive.
                return initialValue;
            case (0, _api.Layer).sapphire:
                return {
                    scale: 2.4,
                    x: 0.31 * width,
                    y: 1.1 * height
                };
            case (0, _api.Layer).consensus:
                return {
                    scale: 2.4,
                    x: 0.65 * width,
                    y: 0.65 * height
                };
            default:
                (0, _errors.exhaustedTypeWarning)("Unexpected layer", layer);
                return initialValue;
        }
    }
}

},{"../../../../../oasis-nexus/api":"dJrPU","../../../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5z6PJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
// This could've been more streamlined with internal state instead of abusing
// refs to such extent, but then composing hooks and components could not opt out of unnecessary renders.
function useResolvedElement(subscriber, refOrElement) {
    var lastReportRef = (0, _react.useRef)(null);
    var refOrElementRef = (0, _react.useRef)(null);
    refOrElementRef.current = refOrElement;
    var cbElementRef = (0, _react.useRef)(null); // Calling re-evaluation after each render without using a dep array,
    // as the ref object's current value could've changed since the last render.
    (0, _react.useEffect)(function() {
        evaluateSubscription();
    });
    var evaluateSubscription = (0, _react.useCallback)(function() {
        var cbElement = cbElementRef.current;
        var refOrElement = refOrElementRef.current; // Ugly ternary. But smaller than an if-else block.
        var element = cbElement ? cbElement : refOrElement ? refOrElement instanceof Element ? refOrElement : refOrElement.current : null;
        if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) return;
        if (lastReportRef.current && lastReportRef.current.cleanup) lastReportRef.current.cleanup();
        lastReportRef.current = {
            element: element,
            subscriber: subscriber,
            // Only calling the subscriber, if there's an actual element to report.
            // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
            cleanup: element ? subscriber(element) : undefined
        };
    }, [
        subscriber
    ]); // making sure we call the cleanup function on unmount
    (0, _react.useEffect)(function() {
        return function() {
            if (lastReportRef.current && lastReportRef.current.cleanup) {
                lastReportRef.current.cleanup();
                lastReportRef.current = null;
            }
        };
    }, []);
    return (0, _react.useCallback)(function(element) {
        cbElementRef.current = element;
        evaluateSubscription();
    }, [
        evaluateSubscription
    ]);
}
// We're only using the first element of the size sequences, until future versions of the spec solidify on how
// exactly it'll be used for fragments in multi-column scenarios:
// From the spec:
// > The box size properties are exposed as FrozenArray in order to support elements that have multiple fragments,
// > which occur in multi-column scenarios. However the current definitions of content rect and border box do not
// > mention how those boxes are affected by multi-column layout. In this spec, there will only be a single
// > ResizeObserverSize returned in the FrozenArray, which will correspond to the dimensions of the first column.
// > A future version of this spec will extend the returned FrozenArray to contain the per-fragment size information.
// (https://drafts.csswg.org/resize-observer/#resize-observer-entry-interface)
//
// Also, testing these new box options revealed that in both Chrome and FF everything is returned in the callback,
// regardless of the "box" option.
// The spec states the following on this:
// > This does not have any impact on which box dimensions are returned to the defined callback when the event
// > is fired, it solely defines which box the author wishes to observe layout changes on.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// I'm not exactly clear on what this means, especially when you consider a later section stating the following:
// > This section is non-normative. An author may desire to observe more than one CSS box.
// > In this case, author will need to use multiple ResizeObservers.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// Which is clearly not how current browser implementations behave, and seems to contradict the previous quote.
// For this reason I decided to only return the requested size,
// even though it seems we have access to results for all box types.
// This also means that we get to keep the current api, being able to return a simple { width, height } pair,
// regardless of box option.
function extractSize(entry, boxProp, sizeType) {
    if (!entry[boxProp]) {
        if (boxProp === "contentBoxSize") // The dimensions in `contentBoxSize` and `contentRect` are equivalent according to the spec.
        // See the 6th step in the description for the RO algorithm:
        // https://drafts.csswg.org/resize-observer/#create-and-populate-resizeobserverentry-h
        // > Set this.contentRect to logical this.contentBoxSize given target and observedBox of "content-box".
        // In real browser implementations of course these objects differ, but the width/height values should be equivalent.
        return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return undefined;
    } // A couple bytes smaller than calling Array.isArray() and just as effective here.
    return entry[boxProp][0] ? entry[boxProp][0][sizeType] : // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    entry[boxProp][sizeType];
}
function useResizeObserver(opts) {
    if (opts === void 0) opts = {};
    // Saving the callback as a ref. With this, I don't need to put onResize in the
    // effect dep array, and just passing in an anonymous function without memoising
    // will not reinstantiate the hook's ResizeObserver.
    var onResize = opts.onResize;
    var onResizeRef = (0, _react.useRef)(undefined);
    onResizeRef.current = onResize;
    var round = opts.round || Math.round; // Using a single instance throughout the hook's lifetime
    var resizeObserverRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)({
        width: undefined,
        height: undefined
    }), size = _useState[0], setSize = _useState[1]; // In certain edge cases the RO might want to report a size change just after
    // the component unmounted.
    var didUnmount = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        didUnmount.current = false;
        return function() {
            didUnmount.current = true;
        };
    }, []); // Using a ref to track the previous width / height to avoid unnecessary renders.
    var previous = (0, _react.useRef)({
        width: undefined,
        height: undefined
    }); // This block is kinda like a useEffect, only it's called whenever a new
    // element could be resolved based on the ref option. It also has a cleanup
    // function.
    var refCallback = useResolvedElement((0, _react.useCallback)(function(element) {
        // We only use a single Resize Observer instance, and we're instantiating it on demand, only once there's something to observe.
        // This instance is also recreated when the `box` option changes, so that a new observation is fired if there was a previously observed element with a different box option.
        if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) resizeObserverRef.current = {
            box: opts.box,
            round: round,
            instance: new ResizeObserver(function(entries) {
                var entry = entries[0];
                var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
                var reportedWidth = extractSize(entry, boxProp, "inlineSize");
                var reportedHeight = extractSize(entry, boxProp, "blockSize");
                var newWidth = reportedWidth ? round(reportedWidth) : undefined;
                var newHeight = reportedHeight ? round(reportedHeight) : undefined;
                if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
                    var newSize = {
                        width: newWidth,
                        height: newHeight
                    };
                    previous.current.width = newWidth;
                    previous.current.height = newHeight;
                    if (onResizeRef.current) onResizeRef.current(newSize);
                    else if (!didUnmount.current) setSize(newSize);
                }
            })
        };
        resizeObserverRef.current.instance.observe(element, {
            box: opts.box
        });
        return function() {
            if (resizeObserverRef.current) resizeObserverRef.current.instance.unobserve(element);
        };
    }, [
        opts.box,
        round
    ]), opts.ref);
    return (0, _react.useMemo)(function() {
        return {
            ref: refCallback,
            width: size.width,
            height: size.height
        };
    }, [
        refCallback,
        size.width,
        size.height
    ]);
}

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a6Lai":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GetStartedBtn", ()=>GetStartedBtn);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _mobileStepper = require("@mui/material/MobileStepper");
var _mobileStepperDefault = parcelHelpers.interopDefault(_mobileStepper);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _types = require("../types");
var _storage = require("../../../../utils/storage");
var _storage1 = require("../../../../../types/storage");
var _tap = require("../../../../components/CustomIcons/Tap");
var _pinch = require("../../../../components/CustomIcons/Pinch");
var _navigate = require("../../../../components/CustomIcons/Navigate");
const HelpScreenContainer = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        position: "absolute",
        top: "65%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyItems: "flex-end",
        minHeight: "185px",
        width: "90%",
        height: "100%"
    }));
const SwiperBox = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        width: "100%",
        height: "40%"
    }));
const GetStartedBtn = (0, _styles.styled)((0, _buttonDefault.default))({});
GetStartedBtn.defaultProps = {
    variant: "contained",
    color: "primary"
};
const iconSx = (theme)=>({
        overflow: "hidden",
        margin: `0 auto ${theme.spacing(3)}`,
        fontSize: 50
    });
const steps = (t)=>[
        {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigate.NavigateIcon), {
                sx: iconSx
            }),
            label: t("home.helpScreen.navigate")
        },
        {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pinch.PinchIcon), {
                sx: iconSx
            }),
            label: t("home.helpScreen.pinch")
        },
        {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tap.TapIcon), {
                sx: iconSx
            }),
            label: t("home.helpScreen.tap")
        }
    ];
const localStore = (0, _storage.storage)();
const HelpScreen = ({ setParaTimeStep })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [activeStep, setActiveStep] = (0, _react.useState)(0);
    const allSteps = steps(t);
    const totalSteps = allSteps.length;
    const currentStep = allSteps[activeStep];
    const swiperElRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const handleSlideChange = (e)=>{
            const [swiper] = e.detail;
            setActiveStep(swiper.activeIndex);
        };
        const swiperEl = swiperElRef.current;
        swiperEl?.addEventListener("swiperslidechange", handleSlideChange);
        return ()=>{
            swiperEl?.removeEventListener("swiperslidechange", handleSlideChange);
        };
    }, []);
    const onGetStartedClick = ()=>{
        setParaTimeStep((0, _types.ParaTimeSelectorStep).Explore);
        localStore.set((0, _storage1.StorageKeys).MobileHelpScreenShown, true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(HelpScreenContainer, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwiperBox, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("swiper-container", {
                    style: {
                        height: "100%"
                    },
                    ref: swiperElRef,
                    "slides-per-view": "1",
                    children: allSteps.map(({ icon, label }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("swiper-slide", {
                            style: {
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-end"
                            },
                            children: Math.abs(activeStep - index) < totalSteps ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: icon
                            }) : null
                        }, label))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h4",
                color: "inherit",
                sx: {
                    marginBottom: 5,
                    fontWeight: 500,
                    textTransform: "capitalize"
                },
                children: currentStep.label
            }),
            activeStep < 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileStepperDefault.default), {
                variant: "dots",
                steps: totalSteps,
                position: "static",
                activeStep: activeStep,
                backButton: null,
                nextButton: null
            }),
            activeStep > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(GetStartedBtn, {
                onClick: onGetStartedClick,
                children: t("home.helpScreen.getStarted")
            })
        ]
    });
};
exports.default = HelpScreen;

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","@mui/material/MobileStepper":"lRgkC","@mui/material/Typography":"f5srd","@mui/material/Button":"h2G5p","../types":"3zpNP","../../../../utils/storage":"lxVX3","../../../../../types/storage":"8d6ef","../../../../components/CustomIcons/Tap":"iUpnr","../../../../components/CustomIcons/Pinch":"1M1dG","../../../../components/CustomIcons/Navigate":"aFcDZ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lRgkC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mobileStepperDefault.default));
parcelHelpers.export(exports, "mobileStepperClasses", ()=>(0, _mobileStepperClassesDefault.default));
var _mobileStepper = require("./MobileStepper");
var _mobileStepperDefault = parcelHelpers.interopDefault(_mobileStepper);
var _mobileStepperClasses = require("./mobileStepperClasses");
var _mobileStepperClassesDefault = parcelHelpers.interopDefault(_mobileStepperClasses);
parcelHelpers.exportAll(_mobileStepperClasses, exports);
"use client";

},{"./MobileStepper":"lnk6c","./mobileStepperClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lnk6c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _linearProgress = require("../LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _mobileStepperClasses = require("./mobileStepperClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "activeStep",
    "backButton",
    "className",
    "LinearProgressProps",
    "nextButton",
    "position",
    "steps",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, position } = ownerState;
    const slots = {
        root: [
            "root",
            `position${(0, _capitalizeDefault.default)(position)}`
        ],
        dots: [
            "dots"
        ],
        dot: [
            "dot"
        ],
        dotActive: [
            "dotActive"
        ],
        progress: [
            "progress"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _mobileStepperClasses.getMobileStepperUtilityClass), classes);
};
const MobileStepperRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiMobileStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        background: (theme.vars || theme).palette.background.default,
        padding: 8
    }, ownerState.position === "bottom" && {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }, ownerState.position === "top" && {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }));
const MobileStepperDots = (0, _styledDefault.default)("div", {
    name: "MuiMobileStepper",
    slot: "Dots",
    overridesResolver: (props, styles)=>styles.dots
})(({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === "dots" && {
        display: "flex",
        flexDirection: "row"
    }));
const MobileStepperDot = (0, _styledDefault.default)("div", {
    name: "MuiMobileStepper",
    slot: "Dot",
    shouldForwardProp: (prop)=>(0, _styled.slotShouldForwardProp)(prop) && prop !== "dotActive",
    overridesResolver: (props, styles)=>{
        const { dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})(({ theme, ownerState, dotActive })=>(0, _extendsDefault.default)({}, ownerState.variant === "dots" && (0, _extendsDefault.default)({
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.action.disabled,
        borderRadius: "50%",
        width: 8,
        height: 8,
        margin: "0 2px"
    }, dotActive && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    })));
const MobileStepperProgress = (0, _styledDefault.default)((0, _linearProgressDefault.default), {
    name: "MuiMobileStepper",
    slot: "Progress",
    overridesResolver: (props, styles)=>styles.progress
})(({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === "progress" && {
        width: "50%"
    }));
const MobileStepper = /*#__PURE__*/ _react.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiMobileStepper"
    });
    const { activeStep = 0, backButton, className, LinearProgressProps, nextButton, position = "bottom", steps, variant = "dots" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        activeStep,
        position,
        variant
    });
    let value;
    if (variant === "progress") {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(MobileStepperRoot, (0, _extendsDefault.default)({
        square: true,
        elevation: 0,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            backButton,
            variant === "text" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === "dots" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileStepperDots, {
                ownerState: ownerState,
                className: classes.dots,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileStepperDot, {
                        className: (0, _clsxDefault.default)(classes.dot, index === activeStep && classes.dotActive),
                        ownerState: ownerState,
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === "progress" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileStepperProgress, (0, _extendsDefault.default)({
                ownerState: ownerState,
                className: classes.progress,
                variant: "determinate",
                value: value
            }, LinearProgressProps)),
            nextButton
        ]
    }));
});
exports.default = MobileStepper;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/integerPropType":"3uD7f","@mui/utils/composeClasses":"jj3MR","../Paper":"9w8HO","../utils/capitalize":"iHgWG","../LinearProgress":"k46OB","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./mobileStepperClasses":"i8Aqz","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k46OB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _linearProgressDefault.default));
parcelHelpers.export(exports, "linearProgressClasses", ()=>(0, _linearProgressClassesDefault.default));
var _linearProgress = require("./LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _linearProgressClasses = require("./linearProgressClasses");
var _linearProgressClassesDefault = parcelHelpers.interopDefault(_linearProgressClasses);
parcelHelpers.exportAll(_linearProgressClasses, exports);
"use client";

},{"./LinearProgress":"7CZp0","./linearProgressClasses":"BVjbF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7CZp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _system = require("@mui/system");
var _colorManipulator = require("@mui/system/colorManipulator");
var _rtlProvider = require("@mui/system/RtlProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _linearProgressClasses = require("./linearProgressClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let _ = (t)=>t, _t, _t2, _t3, _t4, _t5, _t6;
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = (0, _system.keyframes)(_t3 || (_t3 = _`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, _capitalizeDefault.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, _capitalizeDefault.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, _capitalizeDefault.default)(color)}`,
            variant === "buffer" && `color${(0, _capitalizeDefault.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _linearProgressClasses.getLinearProgressUtilityClass), classes);
};
const getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const LinearProgressDashed = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState, theme })=>{
    const backgroundColor = getColorShade(theme, ownerState.color);
    return (0, _extendsDefault.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, _system.css)(_t4 || (_t4 = _`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, _capitalizeDefault.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${TRANSITION_DURATION}s linear`
    }), ({ ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, _system.css)(_t5 || (_t5 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = (0, _styledDefault.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, _capitalizeDefault.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: getColorShade(theme, ownerState.color),
        transition: `transform .${TRANSITION_DURATION}s linear`
    }), ({ ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, _system.css)(_t6 || (_t6 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const LinearProgress = /*#__PURE__*/ _react.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className, color = "primary", value, valueBuffer, variant = "indeterminate" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const isRtl = (0, _rtlProvider.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LinearProgressRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
exports.default = LinearProgress;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system":"6hP1D","@mui/system/colorManipulator":"9FSVd","@mui/system/RtlProvider":"jz0y0","../utils/capitalize":"iHgWG","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./linearProgressClasses":"BVjbF","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"BVjbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLinearProgressUtilityClass", ()=>getLinearProgressUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getLinearProgressUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiLinearProgress", slot);
}
const linearProgressClasses = (0, _generateUtilityClassesDefault.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
exports.default = linearProgressClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i8Aqz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMobileStepperUtilityClass", ()=>getMobileStepperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMobileStepperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiMobileStepper", slot);
}
const mobileStepperClasses = (0, _generateUtilityClassesDefault.default)("MuiMobileStepper", [
    "root",
    "positionBottom",
    "positionTop",
    "positionStatic",
    "dots",
    "dot",
    "dotActive",
    "progress"
]);
exports.default = mobileStepperClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iUpnr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TapIcon", ()=>TapIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _styles = require("@mui/material/styles");
const TapIcon = ({ secondary, ...restProps })=>{
    const theme = (0, _styles.useTheme)();
    const secondaryColor = secondary ?? theme.palette.layout.helpScreenIconColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _svgIconDefault.default), {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        ...restProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M31.8682 23.8414C34.9708 21.6721 37 18.073 37 14C37 7.37258 31.6274 2 25 2C18.3726 2 13 7.37258 13 14C13 18.073 15.0292 21.6721 18.1318 23.8414",
                stroke: secondaryColor,
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M17.9819 47V14C17.9819 10.134 21.1159 7 24.9819 7C28.8479 7 31.9819 10.134 31.9819 14V47",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M27.9819 19C27.9819 19 26.6489 20 24.9819 20C23.3149 20 21.9819 19 21.9819 19V15C21.9819 13.343 23.3249 12 24.9819 12C26.6389 12 27.9819 13.343 27.9819 15V19Z",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M23 34H27",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M23 38H27",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1M1dG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PinchIcon", ()=>PinchIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _styles = require("@mui/material/styles");
const PinchIcon = ({ secondary, ...restProps })=>{
    const theme = (0, _styles.useTheme)();
    const secondaryColor = secondary ?? theme.palette.layout.helpScreenIconColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _svgIconDefault.default), {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        ...restProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M26.99 18C26.99 16.343 28.333 15 29.99 15C31.647 15 32.99 16.343 32.99 18V20C32.99 18.343 34.333 17 35.99 17C37.647 17 38.99 18.343 38.99 20V23V21.938C38.99 20.281 40.333 18.938 41.99 18.938C43.647 18.938 44.99 20.281 44.99 21.938V32C44.99 40.284 38.274 47 29.99 47C25.848 47 22.098 45.321 19.383 42.607L8.64804 29.089C7.70304 27.899 7.80103 26.19 8.87503 25.115C10.043 23.947 11.936 23.947 13.104 25.115L17.329 29.34C18.68 30.691 20.989 29.734 20.989 27.824V23V6C20.989 4.343 22.332 3 23.989 3C25.646 3 26.989 4.343 26.989 6V20",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M5 20L16 9",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 13V9H12",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M5 16V20H9",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aFcDZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavigateIcon", ()=>NavigateIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _styles = require("@mui/material/styles");
const NavigateIcon = ({ secondary, ...restProps })=>{
    const theme = (0, _styles.useTheme)();
    const secondaryColor = secondary ?? theme.palette.layout.helpScreenIconColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _svgIconDefault.default), {
        width: "50",
        height: "50",
        viewBox: "0 0 50 50",
        ...restProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M14 22C14 20.343 12.657 19 11 19C9.343 19 8 20.343 8 22V32C8 40.284 14.716 47 23 47C31.284 47 38 40.284 38 32V24C38 22.343 36.657 21 35 21C33.343 21 32 22.343 32 24V22C32 20.343 30.657 19 29 19C27.343 19 26 20.343 26 22V20C26 18.343 24.657 17 23 17C21.343 17 20 18.343 20 20V6C20 4.343 18.657 3 17 3C15.343 3 14 4.343 14 6V29V22Z",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M34 3V15",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M32 4L34 2L36 4",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M32 14L34 16L36 14",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M41 9H27",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M39 7L41 9L39 11",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M29 7L27 9L29 11",
                stroke: secondaryColor,
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                fill: "transparent"
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lHYBB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkSelector", ()=>NetworkSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _colors = require("../../../../../styles/theme/colors");
var _network = require("../../../../../types/network");
var _routeUtils = require("../../../../utils/route-utils");
var _select = require("../../../../components/Select");
var _select1 = require("@mui/base/Select");
var _expandLess = require("@mui/icons-material/ExpandLess");
var _expandLessDefault = parcelHelpers.interopDefault(_expandLess);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _content = require("../../../../utils/content");
var _option = require("@mui/base/Option");
const StyledNetworkSelector = (0, _styles.styled)((0, _select.Select))(({ theme })=>({
        position: "absolute",
        bottom: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        width: "100%",
        alignItems: "center",
        [theme.breakpoints.up("sm")]: {
            bottom: theme.spacing(5)
        }
    }));
const StyledButton = (0, _styles.styled)((0, _select.StyledSelectButton))(({ theme })=>({
        height: "44px",
        minWidth: "200px",
        backgroundColor: theme.palette.layout.primaryBackground,
        border: `2px solid ${theme.palette.layout.lightBorder}`,
        color: theme.palette.layout.main,
        "&:hover": {
            backgroundColor: theme.palette.layout.primaryBackground
        },
        [`&.${(0, _select1.selectClasses).focusVisible}`]: {
            backgroundColor: theme.palette.layout.primaryBackground,
            outline: "none",
            border: `2px solid ${theme.palette.layout.main}`
        }
    }));
const StyledListbox = (0, _styles.styled)((0, _select.StyledSelectListbox))(()=>({
        minWidth: "200px",
        background: (0, _colors.COLORS).white,
        color: (0, _colors.COLORS).grayDark
    }));
const StyledOption = (0, _styles.styled)((0, _select.StyledSelectOption))(()=>({
        height: "44px",
        color: (0, _colors.COLORS).grayDark,
        svg: {
            color: (0, _colors.COLORS).grayExtraDark
        },
        [`&:hover:not(.${(0, _option.optionClasses).disabled}),
  &.${(0, _option.optionClasses).highlighted}`]: {
            backgroundColor: (0, _colors.COLORS).grayLight
        }
    }));
const SelectOption = ({ value })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const labels = (0, _network.getNetworkNames)(t);
    const icons = (0, _content.getNetworkIcons)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOption, {
        value: value,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: (theme)=>({
                    display: "flex",
                    gap: theme.spacing(3),
                    pl: theme.spacing(3),
                    alignItems: "center"
                }),
            children: [
                icons[value],
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "inherit",
                    children: labels[value]
                })
            ]
        })
    }, value);
};
const NetworkSelectorButton = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { ownerState, ...restProps } = props;
    const { open, value } = ownerState;
    const { t } = (0, _reactI18Next.useTranslation)();
    const label = (0, _network.getNetworkNames)(t);
    const icons = (0, _content.getNetworkIcons)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledButton, {
        ...restProps,
        ref: ref,
        color: "inherit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: (theme)=>({
                        display: "flex",
                        gap: theme.spacing(3),
                        pl: theme.spacing(3),
                        alignItems: "center"
                    }),
                children: [
                    icons[value],
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "inherit",
                        children: label[value]
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandLessDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {})
        ]
    });
});
const NetworkSelector = ({ network, setNetwork })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const options = (0, _routeUtils.RouteUtils).getEnabledNetworks().map((network)=>({
            label: network,
            value: network
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNetworkSelector, {
        defaultValue: network,
        handleChange: setNetwork,
        options: options,
        placement: "top-start",
        root: NetworkSelectorButton,
        Option: SelectOption,
        listbox: StyledListbox,
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            variant: "caption",
            sx: (theme)=>({
                    color: theme.palette.layout.main
                }),
            children: t("home.selectedNetwork")
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","../../../../../styles/theme/colors":"hYvW2","../../../../../types/network":"f0o8N","../../../../utils/route-utils":"b2kKi","../../../../components/Select":"cRZgF","@mui/base/Select":"9hHXa","@mui/icons-material/ExpandLess":"1zxvS","@mui/icons-material/ExpandMore":"k1OXe","../../../../utils/content":"gyk1M","@mui/base/Option":"2K6Wy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cRZgF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelectButton", ()=>StyledSelectButton);
parcelHelpers.export(exports, "StyledSelectListbox", ()=>StyledSelectListbox);
parcelHelpers.export(exports, "StyledSelectOption", ()=>StyledSelectOption);
parcelHelpers.export(exports, "Select", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _select = require("@mui/base/Select");
var _option = require("@mui/base/Option");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _react = require("react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _expandLess = require("@mui/icons-material/ExpandLess");
var _expandLessDefault = parcelHelpers.interopDefault(_expandLess);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _colors = require("../../../styles/theme/colors");
var _reactI18Next = require("react-i18next");
const StyledSelectButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        height: "36px",
        minWidth: "135px",
        padding: `0 ${theme.spacing(4)}`,
        borderRadius: "36px",
        color: (0, _colors.COLORS).white,
        textTransform: "none",
        justifyContent: "space-between",
        [`&.${(0, _select.selectClasses).focusVisible}`]: {
            backgroundColor: (0, _colors.COLORS).brandExtraDark
        }
    }));
const StyledSelectListbox = (0, _styles.styled)("ul")(({ theme })=>({
        boxSizing: "border-box",
        padding: theme.spacing(0),
        margin: theme.spacing(3, 0),
        minWidth: "135px",
        borderRadius: "12px",
        overflow: "auto",
        outline: 0,
        background: theme.palette.tertiary.main,
        filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))"
    }));
const StyledSelectOption = (0, _styles.styled)((0, _option.Option))(({ theme })=>({
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        listStyle: "none",
        height: "36px",
        padding: `0 ${theme.spacing(4)}`,
        cursor: "default",
        color: (0, _colors.COLORS).white,
        [`&:hover:not(.${(0, _option.optionClasses).disabled})`]: {
            cursor: "pointer"
        },
        [`&:hover:not(.${(0, _option.optionClasses).disabled}),
  &.${(0, _option.optionClasses).highlighted}`]: {
            backgroundColor: (0, _colors.COLORS).brandExtraDark
        },
        [`&.${(0, _option.optionClasses).disabled}`]: {
            backgroundColor: (0, _colors.COLORS).lavenderGray
        },
        [`&&.${(0, _option.optionClasses).selected}`]: {
            opacity: 0.5,
            backgroundColor: "transparent"
        },
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    }));
const StyledPopup = (0, _styles.styled)("div")`
  z-index: 1;
`;
const TertiaryButton = /*#__PURE__*/ (0, _react.forwardRef)(({ children, ownerState, ...restProps }, ref)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSelectButton, {
        ...restProps,
        ref: ref,
        color: "tertiary",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "select",
                children: children ? children : t("select.placeholder")
            }),
            ownerState.open ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandLessDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {})
        ]
    });
});
const CustomSelect = /*#__PURE__*/ (0, _react.forwardRef)(function CustomSelect({ root, listbox, popup, placement, ...restProps }, ref) {
    const slots = {
        root,
        listbox,
        popup,
        ...restProps.slots
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
        ...restProps,
        ref: ref,
        slots: slots,
        slotProps: {
            popup: {
                placement
            }
        }
    });
});
const SelectOption = ({ value, label })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSelectOption, {
        value: value,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            variant: "select",
            children: label
        })
    }, value);
const SelectCmp = ({ label, options, defaultValue, handleChange, placement = "bottom-start", className, root = TertiaryButton, listbox = StyledSelectListbox, popup = StyledPopup, Option = SelectOption })=>{
    const selectId = (0, _react.useId)();
    const onChange = (0, _react.useCallback)((_, selectedValue)=>{
        handleChange?.(selectedValue);
    }, [
        handleChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: className,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: selectId,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomSelect, {
                id: selectId,
                defaultValue: defaultValue,
                onChange: onChange,
                root: root,
                listbox: listbox,
                popup: popup,
                placement: placement,
                children: options.map((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Option, {
                        ...props
                    }, props.value.toString()))
            })
        ]
    });
};
const Select = /*#__PURE__*/ (0, _react.memo)(SelectCmp);

},{"react/jsx-runtime":"g88cO","@mui/base/Select":"9hHXa","@mui/base/Option":"2K6Wy","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","react":"BK2ob","@mui/material/Typography":"f5srd","@mui/material/Button":"h2G5p","@mui/icons-material/ExpandLess":"1zxvS","@mui/icons-material/ExpandMore":"k1OXe","../../../styles/theme/colors":"hYvW2","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1zxvS":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("533062d9db6c12ac");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("460e51dee7c985a"));
var _jsxRuntime = require("2eb8ba69d3ed640e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess");

},{"533062d9db6c12ac":"hykHy","460e51dee7c985a":"gQLSP","2eb8ba69d3ed640e":"g88cO"}],"k1OXe":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("31f98b340ff5cc06");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("25cc493e3d5769f7"));
var _jsxRuntime = require("14165500abad842a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");

},{"31f98b340ff5cc06":"hykHy","25cc493e3d5769f7":"gQLSP","14165500abad842a":"g88cO"}],"gyk1M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLayerLabels", ()=>getLayerLabels);
parcelHelpers.export(exports, "getNetworkIcons", ()=>getNetworkIcons);
var _jsxRuntime = require("react/jsx-runtime");
var _api = require("../../oasis-nexus/api");
var _network = require("../../types/network");
var _mainnet = require("../components/CustomIcons/Mainnet");
var _testnet = require("../components/CustomIcons/Testnet");
const getLayerLabels = (t)=>({
        [(0, _api.Layer).emerald]: t("common.emerald"),
        [(0, _api.Layer).sapphire]: t("common.sapphire"),
        [(0, _api.Layer).cipher]: t("common.cipher"),
        [(0, _api.Layer).pontusx]: t("common.pontusx"),
        [(0, _api.Layer).consensus]: t("common.consensus")
    });
const getNetworkIcons = ({ size } = {})=>({
        [(0, _network.Network).mainnet]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainnet.MainnetIcon), {
            sx: {
                fontSize: size
            }
        }),
        [(0, _network.Network).testnet]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testnet.TestnetIcon), {
            sx: {
                fontSize: size
            }
        })
    });

},{"react/jsx-runtime":"g88cO","../../oasis-nexus/api":"dJrPU","../../types/network":"f0o8N","../components/CustomIcons/Mainnet":"7gTf6","../components/CustomIcons/Testnet":"d97Vn","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7gTf6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainnetIcon", ()=>MainnetIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
const MainnetIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgIconDefault.default), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 18.54L4.62 12.81L3 14.07L12 21.07L21 14.07L19.37 12.8L11.99 18.54V18.54ZM12 16L19.36 10.27L21 9L12 2L3 9L4.63 10.27L12 16Z"
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"d97Vn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TestnetIcon", ()=>TestnetIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _svgIcon = require("@mui/material/SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
const TestnetIcon = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgIconDefault.default), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M19.7999 18.4L13.9999 10.67V6.5L15.3499 4.81C15.6099 4.48 15.3799 4 14.9599 4H9.03993C8.61993 4 8.38993 4.48 8.64993 4.81L9.99993 6.5V10.67L4.19993 18.4C3.70993 19.06 4.17993 20 4.99993 20H18.9999C19.8199 20 20.2899 19.06 19.7999 18.4Z"
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/SvgIcon":"eu9eC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2W1vT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearchQueryNetworkParam", ()=>useSearchQueryNetworkParam);
var _reactRouterDom = require("react-router-dom");
var _network = require("../../types/network");
var _routeUtils = require("../utils/route-utils");
var _errors = require("../../types/errors");
const useSearchQueryNetworkParam = ()=>{
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const networkQueryParam = (0, _routeUtils.fixedNetwork) ?? searchParams.get("network") ?? (0, _network.Network).mainnet;
    if (!(0, _routeUtils.RouteUtils).getEnabledNetworks().includes(networkQueryParam)) throw (0, _errors.AppErrors).InvalidUrl;
    return {
        network: networkQueryParam,
        setNetwork: (network)=>{
            if (network === (0, _network.Network).mainnet) searchParams.delete("network");
            else searchParams.set("network", network);
            setSearchParams(searchParams);
        }
    };
};

},{"react-router-dom":"5o0mA","../../types/network":"f0o8N","../utils/route-utils":"b2kKi","../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5ibUV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphTooltipMobile", ()=>GraphTooltipMobile);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _colors = require("../../../../../styles/theme/colors");
var _accessTime = require("@mui/icons-material/AccessTime");
var _accessTimeDefault = parcelHelpers.interopDefault(_accessTime);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _useScreensize = require("../../../../hooks/useScreensize");
var _reactI18Next = require("react-i18next");
var _api = require("../../../../../oasis-nexus/api");
var _hook = require("../../../../components/OfflineBanner/hook");
var _content = require("../../../../utils/content");
var _reactRouterDom = require("react-router-dom");
var _routeUtils = require("../../../../utils/route-utils");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _index = require("../../index");
const GraphTooltipStyled = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>![
            "isMobile",
            "disabled"
        ].includes(prop)
})(({ isMobile, disabled })=>({
        display: "flex",
        height: "100%",
        border: `2px solid ${(0, _colors.COLORS).aqua}`,
        borderRadius: isMobile ? "12px 12px 0 0" : "0 12px 12px 0",
        cursor: disabled ? "default" : "pointer"
    }));
const GraphTooltipIcon = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>![
            "isMobile"
        ].includes(prop)
})(({ isMobile })=>({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flex: "0 0 120px",
        height: "100%",
        borderRight: `2px solid ${(0, _colors.COLORS).aqua}`,
        backgroundColor: (0, _colors.COLORS).brandExtraDark + (isMobile ? "c0" : ""),
        borderRadius: isMobile ? "12px 0 0 12px" : "0 0 0 0",
        color: (0, _colors.COLORS).white
    }));
const GraphTooltipText = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>![
            "disabled",
            "isMobile"
        ].includes(prop)
})(({ theme, disabled, isMobile })=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flex: "0 1 100%",
        padding: theme.spacing(4),
        backgroundColor: (disabled ? (0, _colors.COLORS).shadowBlue : (0, _colors.COLORS).brandExtraDark) + (isMobile ? "c0" : ""),
        borderRadius: isMobile ? "0 12px 0 0" : "0 12px 12px 0"
    }));
const GraphTooltipHeaderText = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flex: "0 0"
    }));
const GraphTooltipDescriptionText = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        flex: "0 1 100%",
        display: "flex",
        alignItems: "center"
    }));
const MobileBackdrop = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        position: "fixed",
        inset: 0,
        backgroundColor: (0, _colors.COLORS).black,
        opacity: 0.3,
        zIndex: (0, _index.zIndexHomePage).mobileTooltip
    }));
const MobileGraphTooltip = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: 120,
        zIndex: (0, _index.zIndexHomePage).mobileTooltip,
        "> button": {
            position: "fixed",
            right: theme.spacing(2),
            bottom: 125
        }
    }));
const layerTooltipBodyCaption = (t, layer, enabled, outOfDate = false)=>{
    if (!enabled) return t("home.tooltip.coming");
    return layer === (0, _api.Layer).consensus ? outOfDate ? t("common.consensusOutOfDate") : t("common.consensusOnline") : outOfDate ? t("common.paraTimeOutOfDate") : t("common.paraTimeOnline");
};
const useLayerTooltipMap = (network)=>{
    const isSapphireEnabled = (0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled.includes((0, _api.Layer).sapphire);
    const isEmeraldEnabled = (0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled.includes((0, _api.Layer).emerald);
    const isCipherEnabled = (0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled.includes((0, _api.Layer).cipher);
    const isConsensusEnabled = (0, _routeUtils.RouteUtils).getAllLayersForNetwork(network).enabled.includes((0, _api.Layer).consensus);
    const isEmeraldOutOfDate = (0, _hook.useRuntimeFreshness)({
        network,
        layer: (0, _api.Layer).emerald
    }).outOfDate;
    const isSapphireOutOfDate = (0, _hook.useRuntimeFreshness)({
        network,
        layer: (0, _api.Layer).sapphire
    }).outOfDate;
    const isConsensusOutOfDate = (0, _hook.useConsensusFreshness)(network).outOfDate;
    return {
        [(0, _api.Layer).sapphire]: {
            disabled: !isSapphireEnabled,
            body: {
                title: (t)=>t("common.sapphire"),
                caption: (t)=>layerTooltipBodyCaption(t, (0, _api.Layer).sapphire, isSapphireEnabled, isSapphireOutOfDate),
                body: (t)=>t("home.tooltip.sapphireParaTimeDesc")
            },
            ...isSapphireEnabled ? {
                failing: isSapphireOutOfDate
            } : {}
        },
        [(0, _api.Layer).emerald]: {
            disabled: !isEmeraldEnabled,
            body: {
                title: (t)=>t("common.emerald"),
                caption: (t)=>layerTooltipBodyCaption(t, (0, _api.Layer).emerald, isEmeraldEnabled, isEmeraldOutOfDate),
                body: (t)=>t("home.tooltip.emeraldParaTimeDesc")
            },
            ...isEmeraldEnabled ? {
                failing: isEmeraldOutOfDate
            } : {}
        },
        [(0, _api.Layer).cipher]: {
            disabled: !isCipherEnabled,
            body: {
                title: (t)=>t("common.cipher"),
                caption: (t)=>layerTooltipBodyCaption(t, (0, _api.Layer).cipher, isCipherEnabled),
                body: (t)=>t("home.tooltip.cipherParaTimeDesc")
            }
        },
        [(0, _api.Layer).consensus]: {
            disabled: !isConsensusEnabled,
            body: {
                title: (t)=>t("common.consensus"),
                caption: (t)=>layerTooltipBodyCaption(t, (0, _api.Layer).consensus, isConsensusEnabled, isConsensusOutOfDate),
                body: (t)=>t("home.tooltip.consensusDesc")
            },
            ...isConsensusEnabled ? {
                failing: isConsensusOutOfDate
            } : {}
        }
    };
};
const GraphTooltipHeader = ({ disabled, network, layer })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const icons = (0, _content.getNetworkIcons)({
        size: 38
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphTooltipIcon, {
        isMobile: isMobile,
        children: disabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessTimeDefault.default), {
            sx: {
                color: (0, _colors.COLORS).aqua,
                fontSize: 33
            }
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                icons[network],
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "span",
                    color: (0, _colors.COLORS).white,
                    sx: {
                        fontSize: "10px",
                        position: "absolute",
                        bottom: "10px"
                    },
                    children: layer === (0, _api.Layer).consensus ? t("home.tooltip.openConsensus") : t("home.tooltip.openParatime")
                })
            ]
        })
    });
};
const GraphTooltipBody = ({ title, caption, body, disabled, failing })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GraphTooltipText, {
        isMobile: isMobile,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GraphTooltipHeaderText, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "body2",
                        color: (0, _colors.COLORS).white,
                        children: title(t)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            display: "flex",
                            fontSize: "12px",
                            opacity: disabled ? 0.5 : 1
                        },
                        color: (0, _colors.COLORS).white,
                        children: [
                            caption(t),
                            !(disabled || failing) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
                                sx: {
                                    marginLeft: 2
                                },
                                color: "success",
                                fontSize: "small"
                            }),
                            failing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                                sx: {
                                    marginLeft: 2
                                },
                                color: "error",
                                fontSize: "small"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphTooltipDescriptionText, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "caption",
                    color: (0, _colors.COLORS).white,
                    children: body(t)
                })
            })
        ]
    });
};
const GraphTooltipMobile = ({ network, layer, onClose })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const tooltip = useLayerTooltipMap(network)[layer];
    if (!tooltip) return;
    const { body, disabled, failing } = tooltip;
    const navigateTo = ()=>{
        if (disabled) return;
        navigate((0, _routeUtils.RouteUtils).getDashboardRoute({
            network,
            layer
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileBackdrop, {
                onClick: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                in: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(MobileGraphTooltip, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            color: "inherit",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {
                                fontSize: "medium",
                                sx: {
                                    color: (0, _colors.COLORS).white
                                },
                                "aria-label": t("home.tooltip.close")
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(GraphTooltipStyled, {
                            disabled: disabled,
                            isMobile: isMobile,
                            onClick: navigateTo,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphTooltipHeader, {
                                    disabled: disabled,
                                    network: network,
                                    layer: layer
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(GraphTooltipBody, {
                                    ...body,
                                    disabled: disabled,
                                    failing: failing
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","../../../../../styles/theme/colors":"hYvW2","@mui/icons-material/AccessTime":"eNFFh","@mui/material/Typography":"f5srd","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Error":"dRT6j","../../../../hooks/useScreensize":"2HEhN","react-i18next":"e210a","../../../../../oasis-nexus/api":"dJrPU","../../../../components/OfflineBanner/hook":"cKMsd","../../../../utils/content":"gyk1M","react-router-dom":"5o0mA","../../../../utils/route-utils":"b2kKi","@mui/material/Fade":"iV0ht","@mui/material/IconButton":"hLmKV","@mui/icons-material/Close":"9iLku","../../index":"4aSsi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eNFFh":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("9f194fb06bf651ae");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("215b9b1f3330b2e8"));
var _jsxRuntime = require("a003477ac8599da6");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], "AccessTime");

},{"9f194fb06bf651ae":"hykHy","215b9b1f3330b2e8":"gQLSP","a003477ac8599da6":"g88cO"}],"lfaia":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("f67ab80c4d13eef3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("36ee8ae8473e27d8"));
var _jsxRuntime = require("52c745c00027fcc6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle");

},{"f67ab80c4d13eef3":"hykHy","36ee8ae8473e27d8":"gQLSP","52c745c00027fcc6":"g88cO"}],"9iLku":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("239535702eb5ed24");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6c62a682237a7579"));
var _jsxRuntime = require("61f3f716cbb9f2ed");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

},{"239535702eb5ed24":"hykHy","6c62a682237a7579":"gQLSP","61f3f716cbb9f2ed":"g88cO"}],"9qROl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _useConstant = require("../../hooks/useConstant");
var _appendMobileSearch = require("../AppendMobileSearch");
var _externalLinks = require("../../utils/externalLinks");
var _analyticsConsent = require("app/components/AnalyticsConsent");
const FooterBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        padding: theme.spacing(5, 4),
        [theme.breakpoints.up("sm")]: {
            flex: "0 1 100%",
            padding: theme.spacing(5, 0)
        }
    }));
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        alignItems: "center"
    }));
const StyledLinksGroup = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        gap: theme.spacing(3),
        paddingLeft: theme.spacing(2)
    }));
const StyledTypography = (0, _styles.styled)((0, _typographyDefault.default))(()=>({
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap"
    }));
const Footer = ({ scope, mobileSearchAction })=>{
    const theme = (0, _styles.useTheme)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile, isTablet } = (0, _useScreensize.useScreenSize)();
    const currentYear = (0, _useConstant.useConstant)(()=>new Date().getFullYear());
    const hasMobileAction = isMobile && mobileSearchAction;
    const privacyPolicyLinkStyles = hasMobileAction ? {
        order: 1,
        flexBasis: "100%"
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("footer", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FooterBox, {
            children: isTablet ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appendMobileSearch.AppendMobileSearch), {
                scope: scope,
                action: isMobile && mobileSearchAction,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledTypography, {
                    variant: "footer",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                whiteSpace: "nowrap"
                            },
                            children: [
                                t("footer.mobileTitle"),
                                " |"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: privacyPolicyLinkStyles,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsConsent.ReopenAnalyticsConsentButton), {}),
                                !hasMobileAction && " | "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: currentYear
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "footer",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                    t: t,
                                    i18nKey: "footer.version",
                                    components: {
                                        ReleaseLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: "-"
                                        }),
                                        CommitLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                            href: `${(0, _externalLinks.github).commit}${"b641559d9d58116730758a5b9080939a99637808"}`,
                                            rel: "noopener noreferrer",
                                            target: "_blank",
                                            sx: {
                                                color: theme.palette.layout.main
                                            }
                                        })
                                    },
                                    values: {
                                        buildTime: t("common.formattedDateTime", {
                                            timestamp: new Date(Number("1715731340432")),
                                            formatParams: {
                                                timestamp: {
                                                    year: "numeric",
                                                    month: "numeric",
                                                    day: "numeric",
                                                    hour: "numeric",
                                                    minute: "numeric",
                                                    second: "numeric"
                                                }
                                            }
                                        }),
                                        sha: "b641559d9d58116730758a5b9080939a99637808".substring(0, 7),
                                        version: "-"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledLinksGroup, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                                        variant: "footer",
                                        children: [
                                            " | ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                                href: (0, _externalLinks.api).spec,
                                                rel: "noopener noreferrer",
                                                target: "_blank",
                                                sx: {
                                                    color: theme.palette.layout.main
                                                },
                                                children: t("footer.apiDocs")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        variant: "footer",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                            href: (0, _externalLinks.github).home,
                                            rel: "noopener noreferrer",
                                            target: "_blank",
                                            sx: {
                                                color: theme.palette.layout.main
                                            },
                                            children: t("footer.github")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        variant: "footer",
                        children: [
                            t("footer.title"),
                            " | ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsConsent.ReopenAnalyticsConsentButton), {}),
                            " | ",
                            currentYear
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","@mui/material/Link":"fTbCF","../../hooks/useConstant":"cQH4u","../AppendMobileSearch":"7MClM","../../utils/externalLinks":"d3W8q","app/components/AnalyticsConsent":"kSiJ1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cQH4u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConstant", ()=>useConstant);
var _react = require("react");
const useConstant = (fn)=>{
    const ref = (0, _react.useRef)();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
};

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7MClM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppendMobileSearch", ()=>AppendMobileSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _search = require("../Search");
var _useScreensize = require("../../hooks/useScreensize");
const Layout = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "action" && prop !== "isMobile"
})(({ action, isMobile })=>({
        position: "relative",
        alignItems: isMobile ? "center" : "flex-start",
        width: "100%",
        ...action ? {
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr"
        } : {
            display: "flex",
            justifyContent: "space-between"
        }
    }));
const SearchWrapper = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        width: "50px",
        height: "47px",
        marginLeft: "auto"
    }));
const AppendMobileSearch = ({ scope, children, action })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Layout, {
        action: action,
        isMobile: isMobile,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: children
            }),
            action,
            isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _search.Search), {
                    scope: scope,
                    variant: "expandable"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","../Search":"fVJkU","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"d3W8q":[function(require,module,exports) {
/** @file Put all external links into this file so tests make sure links are still reachable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "socialMedia", ()=>socialMedia);
parcelHelpers.export(exports, "docs", ()=>docs);
parcelHelpers.export(exports, "referrals", ()=>referrals);
parcelHelpers.export(exports, "github", ()=>github);
parcelHelpers.export(exports, "faucets", ()=>faucets);
parcelHelpers.export(exports, "dapps", ()=>dapps);
parcelHelpers.export(exports, "api", ()=>api);
parcelHelpers.export(exports, "ipfs", ()=>ipfs);
parcelHelpers.export(exports, "wallet", ()=>wallet);
const socialMedia = {
    telegram: "https://t.me/oasisprotocolcommunity",
    twitter: "https://twitter.com/oasisprotocol",
    discord: "https://oasis.io/discord",
    // This API link is for testing if invite is still valid.
    isDiscordStillValid: "https://oasis.io/discord/invite-api-check",
    youtube: "https://www.youtube.com/channel/UC35UFPcZ2F1wjPxhPrSsESQ",
    reddit: "https://www.reddit.com/r/oasisnetwork/",
    linkedin: undefined,
    docs: undefined,
    home: undefined
};
const docs = {
    home: "https://docs.oasis.io/",
    consensus: "https://docs.oasis.io/core/consensus/",
    consensusTransactions: `https://docs.oasis.io/core/consensus/transactions/`,
    consensusServices: `https://docs.oasis.io/core/consensus/services/`,
    consensusStaking: `https://docs.oasis.io/core/consensus/services/staking/`,
    consensusGenesis: `https://docs.oasis.io/core/consensus/genesis/`,
    consensusVectors: `https://docs.oasis.io/core/consensus/test-vectors/`,
    consensusComet: `https://docs.oasis.io/core/consensus/#cometbft`,
    cipher: `https://docs.oasis.io/dapp/cipher/`,
    emerald: `https://docs.oasis.io/dapp/emerald/`,
    emeraldTestnet: `https://docs.oasis.io/dapp/emerald/#testnet`,
    emeraldTestnetNode: `https://docs.oasis.io/node/testnet/#emerald`,
    emeraldGateway: `https://docs.oasis.io/dapp/emerald/#web3-gateway`,
    sapphire: `https://docs.oasis.io/dapp/sapphire/`,
    token: `https://docs.oasis.io/general/oasis-network/token-metrics-and-distribution`,
    paraTimeTransfer: `https://docs.oasis.io/general/manage-tokens/how-to-transfer-rose-into-paratime`,
    sapphireTestnetNode: `https://docs.oasis.io/node/testnet/#sapphire`,
    sapphireTestnet: `https://docs.oasis.io/dapp/sapphire/#testnet`,
    sapphireTestnetHardhat: `https://docs.oasis.io/dapp/sapphire/quickstart/#add-the-sapphire-testnet-to-hardhat`,
    pontusx1: "https://docs.pontus-x.eu/",
    pontusx2: "https://docs.pontus-x.eu/docs/Development/quick_start",
    pontusx3: "https://github.com/deltaDAO/mvg-portal/blob/main/chains.config.js"
};
const referrals = {
    coinGecko: "https://www.coingecko.com"
};
const github = {
    home: "https://github.com/oasisprotocol/explorer/",
    commit: `https://github.com/oasisprotocol/explorer/commit/`,
    releaseTag: `https://github.com/oasisprotocol/explorer/releases/tag/`
};
const faucets = {
    oasisTestnet: "https://faucet.testnet.oasis.dev/"
};
const dapps = {
    wRose: "https://wrose.oasis.io/"
};
const api = {
    spec: `${"https://nexus.oasis.io/v1/"}spec/v1.html`
};
const ipfs = {
    proxyPrefix: "https://ipfs.io/ipfs/"
};
const wallet = {
    homepage: "https://wallet.oasis.io/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kSiJ1":[function(require,module,exports) {
/* eslint-disable react-hooks/rules-of-hooks -- REACT_APP_ENABLE_OASIS_MATOMO_ANALYTICS won't change in runtime */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsConsentProvider", ()=>AnalyticsConsentProvider);
parcelHelpers.export(exports, "PrivacyPolicyFooterLink", ()=>PrivacyPolicyFooterLink);
parcelHelpers.export(exports, "ReopenAnalyticsConsentButton", ()=>ReopenAnalyticsConsentButton);
parcelHelpers.export(exports, "AnalyticsConsentView", ()=>AnalyticsConsentView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _reactI18Next = require("react-i18next");
var _initializeMatomo = require("./initializeMatomo");
var _themeByNetwork = require("../ThemeByNetwork");
var _network = require("../../../types/network");
var _analyticsIsBlocked = require("./AnalyticsIsBlocked");
var _analyticsDialogLayout = require("./AnalyticsDialogLayout");
const AnalyticsContext = /*#__PURE__*/ (0, _react.createContext)(null);
const AnalyticsConsentProvider = (props)=>{
    if (window.REACT_APP_ENABLE_OASIS_MATOMO_ANALYTICS !== "true") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.children
    });
    const [hasAccepted, setHasAccepted] = (0, _react.useState)("loading");
    (0, _react.useEffect)(()=>{
        _initializeMatomo.addMatomo();
    }, []);
    (0, _react.useEffect)(()=>{
        const setInitialHasAccepted = async ()=>{
            setHasAccepted(await _initializeMatomo.hasAccepted({
                timeout: 10000
            }));
        };
        setInitialHasAccepted();
    }, []);
    const location = (0, _reactRouterDom.useLocation)();
    const [previousURL, setPreviousURL] = (0, _react.useState)(document.referrer);
    (0, _react.useEffect)(()=>{
        const newURL = location.pathname + location.search + location.hash;
        if (hasAccepted === "opted-in") {
            // Adjusted snippet from https://developer.matomo.org/guides/spa-tracking#measuring-single-page-apps-complete-example
            window._paq.push([
                "setReferrerUrl",
                previousURL
            ]);
            window._paq.push([
                "setCustomUrl",
                newURL
            ]);
            window._paq.push([
                "setDocumentTitle",
                document.title
            ]);
            window._paq.push([
                "trackPageView"
            ]);
            window._paq.push([
                "enableLinkTracking"
            ]);
        }
        setPreviousURL(newURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Trigger when URL changes
    }, [
        location.key,
        hasAccepted
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AnalyticsContext.Provider, {
        value: {
            reopenAnalyticsConsent: ()=>{
                if (hasAccepted === "timed_out_matomo_not_loaded" || hasAccepted === "loading") setHasAccepted("timed_out_matomo_not_loaded_force_open");
                else setHasAccepted("not-chosen");
            }
        },
        children: [
            props.children,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _themeByNetwork.ThemeByNetwork), {
                isRootTheme: false,
                network: (0, _network.Network).mainnet,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnalyticsConsentView, {
                        isOpen: hasAccepted === "not-chosen",
                        onAccept: async ()=>{
                            _initializeMatomo.optInForOneYear();
                            setHasAccepted(await _initializeMatomo.hasAccepted({
                                timeout: 10000
                            }));
                        },
                        onDecline: async ()=>{
                            _initializeMatomo.decline();
                            setHasAccepted(await _initializeMatomo.hasAccepted({
                                timeout: 10000
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsIsBlocked.AnalyticsIsBlocked), {
                        isOpen: hasAccepted === "timed_out_matomo_not_loaded_force_open",
                        onReload: ()=>window.location.reload(),
                        onClose: ()=>setHasAccepted("timed_out_matomo_not_loaded")
                    })
                ]
            })
        ]
    });
};
const StyledPrivacyButton = (0, _styles.styled)((0, _buttonDefault.default))(()=>({
        padding: 0,
        textAlign: "left",
        height: "auto",
        fontSize: "inherit",
        fontWeight: 700
    }));
const PrivacyPolicyFooterLink = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        href: "https://oasisprotocol.org/privacy-policy",
        target: "_blank",
        color: "inherit",
        children: t("analyticsConsent.privacyPolicy")
    });
};
const ReopenAnalyticsConsentButton = ()=>{
    if (window.REACT_APP_ENABLE_OASIS_MATOMO_ANALYTICS !== "true") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PrivacyPolicyFooterLink, {});
    const { t } = (0, _reactI18Next.useTranslation)();
    const context = (0, _react.useContext)(AnalyticsContext);
    if (context === null) throw new Error("must be used within AnalyticsContext");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPrivacyButton, {
        size: "small",
        color: "inherit",
        onClick: ()=>context.reopenAnalyticsConsent(),
        children: t("analyticsConsent.settings")
    });
};
const StyledButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5)
    }));
const AnalyticsConsentView = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsDialogLayout.AnalyticsDialogLayout), {
        isOpen: props.isOpen,
        message: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "analyticsConsent.text",
            t: t,
            components: {
                PrivacyPolicyLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    href: "https://oasisprotocol.org/privacy-policy",
                    target: "_blank",
                    sx: {
                        fontWeight: 400,
                        textDecoration: "underline"
                    }
                })
            },
            values: {
                acceptButtonLabel: t("analyticsConsent.acceptButtonLabel")
            }
        }),
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                    onClick: ()=>props.onAccept(),
                    color: "primary",
                    variant: "contained",
                    children: t("analyticsConsent.acceptButtonLabel")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                    onClick: ()=>props.onDecline(),
                    color: "secondary",
                    variant: "outlined",
                    children: t("analyticsConsent.declineButtonLabel")
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","@mui/material/styles":"51PGx","@mui/material/Button":"h2G5p","@mui/material/Link":"fTbCF","react-i18next":"e210a","./initializeMatomo":"g9MoH","../ThemeByNetwork":"4frPX","../../../types/network":"f0o8N","./AnalyticsIsBlocked":"5Rqwx","./AnalyticsDialogLayout":"3c0sd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g9MoH":[function(require,module,exports) {
/// <reference types="matomo-js-client-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "matomoDomain", ()=>matomoDomain);
parcelHelpers.export(exports, "addMatomo", ()=>addMatomo);
parcelHelpers.export(exports, "optInForOneYear", ()=>optInForOneYear);
parcelHelpers.export(exports, "decline", ()=>decline);
parcelHelpers.export(exports, "hasAccepted", ()=>hasAccepted);
var _redact = require("./redact");
// Generate snippet https://matomo.oasis.io/index.php?module=CoreAdminHome&action=trackingCodeGenerator&idSite=1&period=day&date=yesterday&updated=false
// Snippet from https://developer.matomo.org/guides/tracking-javascript-guide#finding-the-piwik-tracking-code
window._paq = window._paq || [];
const matomoDomain = "https://matomo.oasis.io/";
window._paq.push([
    "setSiteId",
    "3"
]);
// https://developer.matomo.org/guides/tracking-consent#step-1-require-consent
// https://matomo.org/faq/general/faq_156/
window._paq.push([
    "requireConsent"
]);
window._paq.push([
    "setDoNotTrack",
    true
]);
window._paq.push([
    "enableLinkTracking"
]);
window._paq.push([
    "setTrackerUrl",
    `${matomoDomain}matomo.php`
]);
// https://developer.matomo.org/guides/tracking-javascript-guide#tracking-one-domain-and-its-subdomains-in-the-same-website
// https://matomo.org/faq/how-to/faq_23654/
// window._paq.push(['setDomains', ['*.domain1.com', '*.domain2.com']])
// window._paq.push(['enableCrossDomainLinking'])
// window._paq.push(['setCookieDomain', '*.example.org'])
window._paq.push([
    "setCustomRequestProcessing",
    (queryString)=>{
        const params = new URLSearchParams(queryString);
        for (const name of [
            "action_name",
            "url",
            "urlref"
        ]){
            const v = params.get(name);
            if (v) params.set(name, (0, _redact.redactURL)(v));
        }
        return params.toString();
    }
]);
let addedMatomo = false;
function addMatomo() {
    if (addedMatomo) return;
    addedMatomo = true;
    const d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
    g.async = true;
    // TODO: Enable SRI and fix CORS on matomo.js to support SRI.
    // Warning: https://github.com/matomo-org/matomo/commits/5.x-dev/js/piwik.min.js
    // changed 5 times between 2023 Feb and 2024 Jan.
    // g.integrity = 'sha384-yGkhmoBpWPCg9IZSGIz64itCivgzaXu+CXflD1GthTMPW3YUjF4FoJ8YUBGDTOF7'
    g.src = `${matomoDomain}matomo.js`;
    s.parentNode?.insertBefore(g, s);
}
function optInForOneYear() {
    // https://developer.matomo.org/guides/tracking-consent#a-if-you-want-to-let-matomo-remember-the-consent
    window._paq.push([
        "rememberConsentGiven",
        8760
    ]);
}
function decline() {
    window._paq.push([
        "forgetConsentGiven"
    ]);
}
async function hasAccepted({ timeout }) {
    return await new Promise((resolve)=>{
        window._paq.push([
            function() {
                if (this.hasRememberedConsent()) resolve("opted-in");
                else {
                    // Can not differentiate between declined and not-chosen without workaround
                    // Based on https://github.com/matomo-org/matomo/blob/082782b/js/piwik.js#L7176-L7192
                    // TODO: remove workaround after https://github.com/matomo-org/matomo/issues/17169 is solved
                    const CONSENT_COOKIE_NAME = "mtm_consent";
                    const CONSENT_REMOVED_COOKIE_NAME = "mtm_consent_removed";
                    if (!getCookieWorkaround(CONSENT_COOKIE_NAME) && !getCookieWorkaround(CONSENT_REMOVED_COOKIE_NAME)) resolve("not-chosen");
                    else resolve("declined");
                }
            }
        ]);
        // If matomo doesn't load and process the queue within timeout then it was probably blocked by an extension.
        setTimeout(()=>resolve("timed_out_matomo_not_loaded"), timeout);
    });
}
function getCookieWorkaround(cookieName) {
    const cookiePattern = new RegExp(`(^|;)[ ]*${cookieName}=([^;]*)`);
    const cookieMatch = cookiePattern.exec(document.cookie);
    return cookieMatch ? decodeURIComponent(cookieMatch[2]) : 0;
}

},{"./redact":"8uuPr","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8uuPr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "redactURL", ()=>redactURL);
function redactURL(u) {
    return u// https://explorer.dev.oasis.io/mainnet/emerald/tx/0xf0f08f00150f5d4273c0cf07f36ee7545e5e130e477a8528271379ce3628e104
    // https://explorer.dev.oasis.io/mainnet/sapphire/address/0xEd03EA9c96ec39097548256E428a163E5f524e47/tokens/erc-721#0xFcfed3be2d333F24854cA8d3A351E772272D5842
    .replaceAll(/0x[a-f0-9]+/gi, "0x...")// https://explorer.dev.oasis.io/mainnet/emerald/address/oasis1qrvha284gfztn7wwq6z50c86ceu28jp7csqhpx9t
    // https://explorer.dev.oasis.io/search?q=oasis1qrvha284gfztn7wwq6z50c86ceu28jp7csqhpx9t
    .replaceAll(/oasis1[a-z0-9]+/gi, "oasis1...")// https://explorer.dev.oasis.io/mainnet/emerald/tx/aa5a562c714c9a4e8ecd88230757bc60f66765e56bd4645e11198457b8b278dd
    .replaceAll(/[0-9a-f]{64}/gi, "...")// https://explorer.dev.oasis.io/search?q=test%20test%20test%20test%20test%20test%20test%20test%20test%20test%20test%20key
    .replaceAll(/([?&]q=)[^&#]*/gi, "$1...");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4frPX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeByNetwork", ()=>ThemeByNetwork);
parcelHelpers.export(exports, "withDefaultTheme", ()=>withDefaultTheme);
var _jsxRuntime = require("react/jsx-runtime");
var _network = require("../../../types/network");
var _styles = require("@mui/material/styles");
var _theme = require("../../../styles/theme");
var _cssBaseline = require("@mui/material/CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
var _routeUtils = require("../../utils/route-utils");
const ThemeByNetwork = ({ network, isRootTheme, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styles.ThemeProvider), {
        theme: (0, _theme.getThemesForNetworks)()[network],
        children: [
            isRootTheme && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cssBaselineDefault.default), {}),
            children
        ]
    });
const withDefaultTheme = (node, alwaysMainnet = false)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ThemeByNetwork, {
        isRootTheme: true,
        network: alwaysMainnet ? (0, _network.Network).mainnet : (0, _routeUtils.fixedNetwork) ?? (0, _network.Network).mainnet,
        children: node
    });

},{"react/jsx-runtime":"g88cO","../../../types/network":"f0o8N","@mui/material/styles":"51PGx","../../../styles/theme":"i3yrR","@mui/material/CssBaseline":"aO8Y3","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aO8Y3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cssBaselineDefault.default));
var _cssBaseline = require("./CssBaseline");
var _cssBaselineDefault = parcelHelpers.interopDefault(_cssBaseline);
"use client";

},{"./CssBaseline":"3P4re","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3P4re":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "body", ()=>body);
parcelHelpers.export(exports, "styles", ()=>styles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const html = (theme, enableColorScheme)=>(0, _extendsDefault.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const body = (theme)=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const styles = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, _extendsDefault.default)({
        html: html(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, _extendsDefault.default)({
            margin: 0
        }, body(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function CssBaseline(inProps) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children, enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
                styles: (theme)=>styles(theme, enableColorScheme)
            }),
            children
        ]
    });
}
exports.default = CssBaseline;

},{"@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","../styles/useThemeProps":"e7SGa","../GlobalStyles":"d55tF","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5Rqwx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsIsBlocked", ()=>AnalyticsIsBlocked);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _reactI18Next = require("react-i18next");
var _analyticsDialogLayout = require("./AnalyticsDialogLayout");
const StyledButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5)
    }));
const AnalyticsIsBlocked = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _analyticsDialogLayout.AnalyticsDialogLayout), {
        isOpen: props.isOpen,
        message: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "analyticsConsent.blockedText",
            t: t,
            components: {
                PrivacyPolicyLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    href: "https://oasisprotocol.org/privacy-policy",
                    target: "_blank",
                    sx: {
                        fontWeight: 400,
                        textDecoration: "underline"
                    }
                })
            }
        }),
        actions: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                    onClick: ()=>props.onReload(),
                    color: "secondary",
                    variant: "outlined",
                    children: t("analyticsConsent.reloadButtonLabel")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                    onClick: ()=>props.onClose(),
                    color: "secondary",
                    variant: "outlined",
                    children: t("analyticsConsent.closeButtonLabel")
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/Button":"h2G5p","@mui/material/Link":"fTbCF","react-i18next":"e210a","./AnalyticsDialogLayout":"3c0sd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3c0sd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsDialogLayout", ()=>AnalyticsDialogLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _snackbar = require("@mui/material/Snackbar");
var _snackbarDefault = parcelHelpers.interopDefault(_snackbar);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _cardActions = require("@mui/material/CardActions");
var _cardActionsDefault = parcelHelpers.interopDefault(_cardActions);
var _useScreensize = require("app/hooks/useScreensize");
const AnalyticsDialogLayout = (props)=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snackbarDefault.default), {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right"
            },
            sx: {
                maxWidth: "450px"
            },
            open: props.isOpen,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
                elevation: 4,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            fontSize: "14px",
                            sx: {
                                paddingBottom: "12px",
                                lineHeight: "1.25"
                            },
                            align: "center",
                            children: props.message
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardActionsDefault.default), {
                        sx: {
                            justifyContent: "center",
                            paddingBottom: isMobile ? "16px" : "32px"
                        },
                        children: props.actions
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Snackbar":"8gbki","@mui/material/Typography":"f5srd","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","@mui/material/CardActions":"k0kVW","app/hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8gbki":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _snackbarDefault.default));
parcelHelpers.export(exports, "snackbarClasses", ()=>(0, _snackbarClassesDefault.default));
var _snackbar = require("./Snackbar");
var _snackbarDefault = parcelHelpers.interopDefault(_snackbar);
var _snackbarClasses = require("./snackbarClasses");
var _snackbarClassesDefault = parcelHelpers.interopDefault(_snackbarClasses);
parcelHelpers.exportAll(_snackbarClasses, exports);
"use client";

},{"./Snackbar":"3npNc","./snackbarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3npNc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clickAwayListener = require("@mui/base/ClickAwayListener");
var _useSnackbar = require("@mui/base/useSnackbar");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _snackbarContent = require("../SnackbarContent");
var _snackbarContentDefault = parcelHelpers.interopDefault(_snackbarContent);
var _snackbarClasses = require("./snackbarClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onEnter",
    "onExited"
], _excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, _capitalizeDefault.default)(anchorOrigin.vertical)}${(0, _capitalizeDefault.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _snackbarClasses.getSnackbarUtilityClass), classes);
};
const SnackbarRoot = (0, _styledDefault.default)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, _capitalizeDefault.default)(ownerState.anchorOrigin.vertical)}${(0, _capitalizeDefault.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme, ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, _extendsDefault.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, _extendsDefault.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const Snackbar = /*#__PURE__*/ _react.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, _useThemeDefault.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action, anchorOrigin: { vertical, horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration = null, children, className, ClickAwayListenerProps, ContentProps, disableWindowBlurListener = false, message, open, TransitionComponent = (0, _growDefault.default), transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter, onExited } = {} } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        anchorOrigin: {
            vertical,
            horizontal
        },
        autoHideDuration,
        disableWindowBlurListener,
        TransitionComponent,
        transitionDuration
    });
    const classes = useUtilityClasses(ownerState);
    const { getRootProps, onClickAway } = (0, _useSnackbar.useSnackbar)((0, _extendsDefault.default)({}, ownerState));
    const [exited, setExited] = _react.useState(true);
    const rootProps = (0, _utils.useSlotProps)({
        elementType: SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState,
        additionalProps: {
            ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clickAwayListener.ClickAwayListener), (0, _extendsDefault.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SnackbarRoot, (0, _extendsDefault.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snackbarContentDefault.default), (0, _extendsDefault.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
exports.default = Snackbar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","@mui/base/ClickAwayListener":"fQ8Wr","@mui/base/useSnackbar":"aOEpF","../styles/styled":"axRcE","../styles/useTheme":"3N7Mw","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","../Grow":"3JaRg","../SnackbarContent":"i3QhG","./snackbarClasses":"hQCs6","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i3QhG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _snackbarContentDefault.default));
parcelHelpers.export(exports, "snackbarContentClasses", ()=>(0, _snackbarContentClassesDefault.default));
var _snackbarContent = require("./SnackbarContent");
var _snackbarContentDefault = parcelHelpers.interopDefault(_snackbarContent);
var _snackbarContentClasses = require("./snackbarContentClasses");
var _snackbarContentClassesDefault = parcelHelpers.interopDefault(_snackbarContentClasses);
parcelHelpers.exportAll(_snackbarContentClasses, exports);
"use client";

},{"./SnackbarContent":"8lz5A","./snackbarContentClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8lz5A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _snackbarContentClasses = require("./snackbarContentClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "action",
    "className",
    "message",
    "role"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _snackbarContentClasses.getSnackbarContentUtilityClass), classes);
};
const SnackbarContentRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
    return (0, _extendsDefault.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const SnackbarContentMessage = (0, _styledDefault.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const SnackbarContentAction = (0, _styledDefault.default)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const SnackbarContent = /*#__PURE__*/ _react.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action, className, message, role = "alert" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SnackbarContentRoot, (0, _extendsDefault.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
exports.default = SnackbarContent;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../Paper":"9w8HO","./snackbarContentClasses":"c3Phy","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c3Phy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSnackbarContentUtilityClass", ()=>getSnackbarContentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSnackbarContentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSnackbarContent", slot);
}
const snackbarContentClasses = (0, _generateUtilityClassesDefault.default)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
exports.default = snackbarContentClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hQCs6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSnackbarUtilityClass", ()=>getSnackbarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSnackbarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSnackbar", slot);
}
const snackbarClasses = (0, _generateUtilityClassesDefault.default)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
exports.default = snackbarClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cTsx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "cardClasses", ()=>(0, _cardClassesDefault.default));
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardClasses = require("./cardClasses");
var _cardClassesDefault = parcelHelpers.interopDefault(_cardClasses);
parcelHelpers.exportAll(_cardClasses, exports);
"use client";

},{"./Card":"gtjfz","./cardClasses":"9IzRN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gtjfz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _cardClasses = require("./cardClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "raised"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardClasses.getCardUtilityClass), classes);
};
const CardRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const Card = /*#__PURE__*/ _react.forwardRef(function Card(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className, raised = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        raised
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
exports.default = Card;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/chainPropTypes":"8qu3z","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../Paper":"9w8HO","./cardClasses":"9IzRN","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9IzRN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardUtilityClass", ()=>getCardUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCard", slot);
}
const cardClasses = (0, _generateUtilityClassesDefault.default)("MuiCard", [
    "root"
]);
exports.default = cardClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kMUKY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardContentDefault.default));
parcelHelpers.export(exports, "cardContentClasses", ()=>(0, _cardContentClassesDefault.default));
var _cardContent = require("./CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _cardContentClasses = require("./cardContentClasses");
var _cardContentClassesDefault = parcelHelpers.interopDefault(_cardContentClasses);
parcelHelpers.exportAll(_cardContentClasses, exports);
"use client";

},{"./CardContent":"waOBc","./cardContentClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"waOBc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _cardContentClasses = require("./cardContentClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardContentClasses.getCardContentUtilityClass), classes);
};
const CardContentRoot = (0, _styledDefault.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const CardContent = /*#__PURE__*/ _react.forwardRef(function CardContent(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className, component = "div" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardContentRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = CardContent;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./cardContentClasses":"6a8Fq","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6a8Fq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardContentUtilityClass", ()=>getCardContentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardContentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCardContent", slot);
}
const cardContentClasses = (0, _generateUtilityClassesDefault.default)("MuiCardContent", [
    "root"
]);
exports.default = cardContentClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k0kVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardActionsDefault.default));
parcelHelpers.export(exports, "cardActionsClasses", ()=>(0, _cardActionsClassesDefault.default));
var _cardActions = require("./CardActions");
var _cardActionsDefault = parcelHelpers.interopDefault(_cardActions);
var _cardActionsClasses = require("./cardActionsClasses");
var _cardActionsClassesDefault = parcelHelpers.interopDefault(_cardActionsClasses);
parcelHelpers.exportAll(_cardActionsClasses, exports);
"use client";

},{"./CardActions":"4PXz4","./cardActionsClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4PXz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _cardActionsClasses = require("./cardActionsClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "disableSpacing",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardActionsClasses.getCardActionsUtilityClass), classes);
};
const CardActionsRoot = (0, _styledDefault.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const CardActions = /*#__PURE__*/ _react.forwardRef(function CardActions(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing = false, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableSpacing
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardActionsRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = CardActions;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./cardActionsClasses":"9JTg7","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9JTg7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardActionsUtilityClass", ()=>getCardActionsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardActionsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCardActions", slot);
}
const cardActionsClasses = (0, _generateUtilityClassesDefault.default)("MuiCardActions", [
    "root",
    "spacing"
]);
exports.default = cardActionsClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kVA6h":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("3b5d7c2ea44001b0");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("d3d5c866dbbb50ce"));
var _jsxRuntime = require("ac0cd8199b29c59");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined");

},{"3b5d7c2ea44001b0":"hykHy","d3d5c866dbbb50ce":"gQLSP","ac0cd8199b29c59":"g88cO"}],"6VCEO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuildBanner", ()=>BuildBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _config = require("../../../config");
var _stickyAlert = require("../StickyAlert");
const useBuildBanners = true;
const BuildBanner = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!useBuildBanners || window.location.origin === (0, _config.deploys).localhost) return null;
    if ((0, _config.deploys).production.includes(window.location.origin)) return null;
    if ((0, _config.deploys).staging.includes(window.location.origin)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stickyAlert.StickyAlert), {
        severity: "warning",
        children: t("banner.buildStaging")
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stickyAlert.StickyAlert), {
        severity: "warning",
        children: t("banner.buildPreview", {
            appTitle: (0, _config.getAppTitle)()
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../../config":"2PXMY","../StickyAlert":"hMBrH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hMBrH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyAlert", ()=>StickyAlert);
var _alert = require("@mui/material/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _styles = require("@mui/material/styles");
const StickyAlert = (0, _styles.styled)((0, _alertDefault.default))(({ theme })=>({
        position: "sticky",
        top: 0,
        zIndex: 1000,
        justifyContent: "center",
        borderRadius: 0,
        fontSize: "14px",
        lineHeight: "18px",
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(4, 0)
        },
        [theme.breakpoints.up("md")]: {
            padding: theme.spacing(3, 0)
        }
    }));

},{"@mui/material/Alert":"5QD1w","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5QD1w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "alertClasses", ()=>(0, _alertClassesDefault.default));
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alertClasses = require("./alertClasses");
var _alertClassesDefault = parcelHelpers.interopDefault(_alertClasses);
parcelHelpers.exportAll(_alertClasses, exports);
"use client";

},{"./Alert":"ggBpb","./alertClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ggBpb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _zeroStyled = require("../zero-styled");
var _useSlot = require("../utils/useSlot");
var _useSlotDefault = parcelHelpers.interopDefault(_useSlot);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _alertClasses = require("./alertClasses");
var _alertClassesDefault = parcelHelpers.interopDefault(_alertClasses);
var _iconButton = require("../IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _successOutlined = require("../internal/svg-icons/SuccessOutlined");
var _successOutlinedDefault = parcelHelpers.interopDefault(_successOutlined);
var _reportProblemOutlined = require("../internal/svg-icons/ReportProblemOutlined");
var _reportProblemOutlinedDefault = parcelHelpers.interopDefault(_reportProblemOutlined);
var _errorOutline = require("../internal/svg-icons/ErrorOutline");
var _errorOutlineDefault = parcelHelpers.interopDefault(_errorOutline);
var _infoOutlined = require("../internal/svg-icons/InfoOutlined");
var _infoOutlinedDefault = parcelHelpers.interopDefault(_infoOutlined);
var _close = require("../internal/svg-icons/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const useThemeProps = (0, _zeroStyled.createUseThemeProps)("MuiAlert");
const useUtilityClasses = (ownerState)=>{
    const { variant, color, severity, classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color || severity)}`,
            `${variant}${(0, _capitalizeDefault.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _alertClasses.getAlertUtilityClass), classes);
};
const AlertRoot = (0, _zeroStyled.styled)((0, _paperDefault.default), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalizeDefault.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, _colorManipulator.darken) : (0, _colorManipulator.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, _colorManipulator.lighten) : (0, _colorManipulator.darken);
    return (0, _extendsDefault.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, _alertClassesDefault.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, _alertClassesDefault.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: (0, _extendsDefault.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const AlertIcon = (0, _zeroStyled.styled)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const AlertMessage = (0, _zeroStyled.styled)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const AlertAction = (0, _zeroStyled.styled)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const defaultIconMapping = {
    success: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _successOutlinedDefault.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportProblemOutlinedDefault.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorOutlineDefault.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoOutlinedDefault.default), {
        fontSize: "inherit"
    })
};
const Alert = /*#__PURE__*/ _react.forwardRef(function Alert(inProps, ref) {
    const props = useThemeProps({
        props: inProps,
        name: "MuiAlert"
    });
    const { action, children, className, closeText = "Close", color, components = {}, componentsProps = {}, icon, iconMapping = defaultIconMapping, onClose, role = "alert", severity = "success", slotProps = {}, slots = {}, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        severity,
        variant,
        colorSeverity: color || severity
    });
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, _extendsDefault.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, _extendsDefault.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, _useSlotDefault.default)("closeButton", {
        elementType: (0, _iconButtonDefault.default),
        externalForwardedProps,
        ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, _useSlotDefault.default)("closeIcon", {
        elementType: (0, _closeDefault.default),
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AlertRoot, (0, _extendsDefault.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseButtonSlot, (0, _extendsDefault.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseIconSlot, (0, _extendsDefault.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
exports.default = Alert;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../zero-styled":"2ZQJP","../utils/useSlot":"3etgu","../utils/capitalize":"iHgWG","../Paper":"9w8HO","./alertClasses":"kIUTR","../IconButton":"hLmKV","../internal/svg-icons/SuccessOutlined":"kURB9","../internal/svg-icons/ReportProblemOutlined":"lu63g","../internal/svg-icons/ErrorOutline":"3miM9","../internal/svg-icons/InfoOutlined":"gjJa4","../internal/svg-icons/Close":"70tii","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3etgu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSlot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _utils = require("@mui/base/utils");
"use client";
const _excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], _excluded2 = [
    "component",
    "slots",
    "slotProps"
], _excluded3 = [
    "component"
];
function useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className, elementType: initialElementType, ownerState, externalForwardedProps, getSlotOwnerState, internalForwardedProps } = parameters, useSlotPropsParams = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const { component: rootComponent, slots = {
        [name]: undefined
    }, slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, _objectWithoutPropertiesLooseDefault.default)(externalForwardedProps, _excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, _utils.resolveComponentProps)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, _utils.mergeSlotProps)((0, _extendsDefault.default)({
        className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef } = _mergeSlotProps, mergedProps = (0, _objectWithoutPropertiesLooseDefault.default)(_mergeSlotProps.props, _excluded3);
    const ref = (0, _useForkRefDefault.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, _extendsDefault.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, _utils.appendOwnerState)(elementType, (0, _extendsDefault.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/useForkRef":"7x3cc","@mui/base/utils":"iiPtN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kIUTR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlertUtilityClass", ()=>getAlertUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAlertUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiAlert", slot);
}
const alertClasses = (0, _generateUtilityClassesDefault.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
exports.default = alertClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kURB9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lu63g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3miM9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gjJa4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"70tii":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"383jV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkOfflineBanner", ()=>NetworkOfflineBanner);
parcelHelpers.export(exports, "OfflineBanner", ()=>OfflineBanner);
parcelHelpers.export(exports, "ConsensusOfflineBanner", ()=>ConsensusOfflineBanner);
parcelHelpers.export(exports, "RuntimeOfflineBanner", ()=>RuntimeOfflineBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScopeParam = require("../../hooks/useScopeParam");
var _network = require("../../../types/network");
var _hook = require("./hook");
var _searchScope = require("../../../types/searchScope");
var _errors = require("../../../types/errors");
var _stickyAlert = require("../StickyAlert");
const NetworkOfflineBanner = ({ wantedNetwork })=>{
    const scope = (0, _useScopeParam.useScopeParam)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const targetNetwork = wantedNetwork || scope?.network || (0, _network.Network).mainnet;
    const isNetworkReachable = (0, _hook.useIsApiReachable)(targetNetwork);
    const networkNames = (0, _network.getNetworkNames)(t);
    const target = networkNames[targetNetwork];
    if (!isNetworkReachable.reachable) {
        if (isNetworkReachable.reason === "userOffline") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stickyAlert.StickyAlert), {
            severity: "warning",
            children: t("home.userOffline", {
                target
            })
        });
        if (isNetworkReachable.reason === "apiOffline") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stickyAlert.StickyAlert), {
            severity: "warning",
            children: t("home.apiOffline", {
                target
            })
        });
        (0, _errors.exhaustedTypeWarning)("Unexpected isNetworkReachable reason", isNetworkReachable.reason);
    }
    return null;
};
const OfflineBanner = ({ layerStatus, scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { outOfDate, lastUpdate, unavailable } = layerStatus;
    if (!outOfDate && !unavailable) return null;
    const target = (0, _searchScope.getNameForScope)(t, scope);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stickyAlert.StickyAlert), {
        severity: "warning",
        children: unavailable ? t("home.layerUnavailable", {
            target
        }) : lastUpdate ? t("home.layerOutOfDateSince", {
            target,
            lastUpdate
        }) : t("home.layerOutOfDate", {
            target
        })
    });
};
const ConsensusOfflineBanner = ()=>{
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const layerStatus = (0, _hook.useConsensusFreshness)(scope.network);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OfflineBanner, {
        layerStatus: layerStatus,
        scope: scope
    });
};
const RuntimeOfflineBanner = ()=>{
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const layerStatus = (0, _hook.useRuntimeFreshness)(scope);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OfflineBanner, {
        layerStatus: layerStatus,
        scope: scope
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../hooks/useScopeParam":"kKMKx","../../../types/network":"f0o8N","./hook":"cKMsd","../../../types/searchScope":"6SEv5","../../../types/errors":"gdpNU","../StickyAlert":"hMBrH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6SEv5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainnetEmerald", ()=>MainnetEmerald);
parcelHelpers.export(exports, "getNameForScope", ()=>getNameForScope);
parcelHelpers.export(exports, "getKeyForScope", ()=>getKeyForScope);
parcelHelpers.export(exports, "isItemInScope", ()=>isItemInScope);
parcelHelpers.export(exports, "getFilterForScope", ()=>getFilterForScope);
parcelHelpers.export(exports, "getInverseFilterForScope", ()=>getInverseFilterForScope);
var _network = require("./network");
var _content = require("../app/utils/content");
var _api = require("../oasis-nexus/api");
const MainnetEmerald = {
    network: (0, _network.Network).mainnet,
    layer: (0, _api.Layer).emerald
};
const getNameForScope = (t, scope)=>`${(0, _content.getLayerLabels)(t)[scope.layer]} ${(0, _network.getNetworkNames)(t)[scope.network]}`;
const getKeyForScope = ({ network, layer })=>`${network}.${layer}`;
const isItemInScope = (item, scope)=>item.network === scope.network && item.layer === scope.layer;
const getFilterForScope = (scope)=>(item)=>isItemInScope(item, scope);
const getInverseFilterForScope = (scope)=>(item)=>!isItemInScope(item, scope);

},{"./network":"f0o8N","../app/utils/content":"gyk1M","../oasis-nexus/api":"dJrPU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dms5e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBlocksPage", ()=>RuntimeBlocksPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _api = require("../../../oasis-nexus/api");
var _blocks = require("../../components/Blocks");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _runtimeBlockDetailPage = require("../RuntimeBlockDetailPage");
var _errors = require("../../../types/errors");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _verticalList = require("../../components/VerticalList");
const PAGE_SIZE = (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
const RuntimeBlocksPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * PAGE_SIZE;
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    // Consensus is not yet enabled in ENABLED_LAYERS, just some preparation
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const blocksQuery = (0, _api.useGetRuntimeBlocks)(scope.network, scope.layer, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + PAGE_SIZE : PAGE_SIZE,
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    }, {
        query: {
            refetchInterval: (0, _config.REFETCH_INTERVAL),
            structuralSharing: (previousState, nextState)=>{
                const oldBlockIds = new Set(previousState?.data.blocks.map((block)=>block.round));
                return {
                    ...nextState,
                    data: {
                        ...nextState.data,
                        blocks: nextState.data.blocks.map((block)=>{
                            return {
                                ...block,
                                markAsNew: previousState ? !oldBlockIds.has(block.round) : false
                            };
                        })
                    }
                };
            },
            // Keep showing data while loading more
            keepPreviousData: tableView === (0, _tableLayoutButton.TableLayout).Vertical
        }
    });
    const { isLoading, isFetched, data } = blocksQuery;
    const blocks = data?.data.blocks;
    if (isFetched && offset && !blocks?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: t("blocks.latest"),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blocks.RuntimeBlocks), {
                        isLoading: isLoading,
                        blocks: blocks,
                        limit: PAGE_SIZE,
                        type: (0, _blocks.BlocksTableType).Desktop,
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        }
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array(PAGE_SIZE).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBlockDetailPage.RuntimeBlockDetailView), {
                                    isLoading: true,
                                    block: undefined,
                                    standalone: true
                                }, key)),
                            !isLoading && data?.data.blocks.map((block)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBlockDetailPage.RuntimeBlockDetailView), {
                                    block: block,
                                    standalone: true
                                }, block.hash))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../../oasis-nexus/api":"dJrPU","../../components/Blocks":"4KkfE","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../RuntimeBlockDetailPage":"jWfMQ","../../../types/errors":"gdpNU","../../components/TableLayoutButton":"5tkdC","../../components/LoadMoreButton":"aeVDT","../../hooks/useScopeParam":"kKMKx","../../components/VerticalList":"gcFw0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"24SOU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMain", ()=>StyledMain);
parcelHelpers.export(exports, "PageLayout", ()=>PageLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _header = require("./Header");
var _footer = require("./Footer");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _buildBanner = require("../BuildBanner");
var _useScopeParam = require("../../hooks/useScopeParam");
var _offlineBanner = require("../OfflineBanner");
var _search = require("../Search");
var _hook = require("../OfflineBanner/hook");
var _network = require("../../../types/network");
var _api = require("../../../oasis-nexus/api");
const StyledMain = (0, _styles.styled)("main")({
    minHeight: "75vh"
});
const PageLayout = ({ children, mobileFooterAction })=>{
    const theme = (0, _styles.useTheme)();
    const { isMobile, isTablet } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useScopeParam)();
    const isApiReachable = (0, _hook.useIsApiReachable)(scope?.network || (0, _network.Network).mainnet).reachable;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildBanner.BuildBanner), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offlineBanner.NetworkOfflineBanner), {}),
            scope && scope.layer !== (0, _api.Layer).consensus && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offlineBanner.RuntimeOfflineBanner), {}),
            scope && scope.layer === (0, _api.Layer).consensus && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offlineBanner.ConsensusOfflineBanner), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    minHeight: "100vh"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: isMobile ? {
                            border: theme.palette.background.default !== theme.palette.layout.border ? `solid 10px ${theme.palette.layout.border}` : "none",
                            borderTop: 0,
                            px: 0,
                            pt: 4
                        } : {
                            border: `solid 15px ${theme.palette.layout.border}`,
                            borderTop: 0,
                            px: "4%",
                            pt: 6
                        },
                        children: [
                            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: {
                                    mb: 6
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _search.Search), {
                                    scope: scope,
                                    variant: isTablet ? "icon" : "button",
                                    disabled: !isApiReachable
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledMain, {
                                children: children
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footer.Footer), {
                                scope: scope,
                                mobileSearchAction: mobileFooterAction
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","./Header":"hFbBA","./Footer":"9qROl","@mui/material/Box":"4d7LG","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","../BuildBanner":"6VCEO","../../hooks/useScopeParam":"kKMKx","../OfflineBanner":"383jV","../Search":"fVJkU","../OfflineBanner/hook":"cKMsd","../../../types/network":"f0o8N","../../../oasis-nexus/api":"dJrPU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hFbBA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _jsxRuntime = require("react/jsx-runtime");
var _appBar = require("@mui/material/AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
var _unstableGrid2 = require("@mui/material/Unstable_Grid2");
var _unstableGrid2Default = parcelHelpers.interopDefault(_unstableGrid2);
var _useScrollTrigger = require("@mui/material/useScrollTrigger");
var _useScrollTriggerDefault = parcelHelpers.interopDefault(_useScrollTrigger);
var _styles = require("@mui/material/styles");
var _logotype = require("./Logotype");
var _networkSelector = require("./NetworkSelector");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _useScopeParam = require("../../hooks/useScopeParam");
var _useScreensize = require("../../hooks/useScreensize");
var _routeUtils = require("../../utils/route-utils");
const Header = ()=>{
    const theme = (0, _styles.useTheme)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useScopeParam)();
    const withScopeSelector = !!scope && (0, _routeUtils.isScopeSelectorNeeded)(scope);
    const scrollTrigger = (0, _useScrollTriggerDefault.default)({
        disableHysteresis: true,
        threshold: 0
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appBarDefault.default), {
        position: "sticky",
        sx: {
            transitionProperty: "background-color",
            transitionDuration: `${theme.transitions.duration.standard}ms`,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            backgroundColor: scrollTrigger ? theme.palette.layout.contrastSecondary : theme.palette.layout.secondary,
            borderRadius: 0,
            boxShadow: scrollTrigger ? "0px 4px 4px rgba(0, 0, 0, 0.25), 0px 34px 24px -9px rgba(50, 77, 171, 0.12)" : "none"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                px: "15px"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
                container: true,
                sx: {
                    px: isMobile ? 0 : "4%",
                    pt: isMobile ? 4 : "15px",
                    pb: 4
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                        md: 3,
                        xs: 4,
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logotype.HomePageLink), {
                            color: scrollTrigger ? theme.palette.layout.contrastMain : undefined,
                            showText: !scrollTrigger && !isMobile
                        })
                    }),
                    withScopeSelector && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                                lg: 6,
                                xs: 8,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkSelector.NetworkSelector), {
                                    layer: scope.layer,
                                    network: scope.network
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                                lg: 3,
                                xs: 0
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/AppBar":"7bhMk","@mui/material/Unstable_Grid2":"eN1IM","@mui/material/useScrollTrigger":"8qduJ","@mui/material/styles":"51PGx","./Logotype":"h3vde","./NetworkSelector":"btY5V","@mui/material/Box":"4d7LG","../../hooks/useScopeParam":"kKMKx","../../hooks/useScreensize":"2HEhN","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7bhMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _appBarDefault.default));
parcelHelpers.export(exports, "appBarClasses", ()=>(0, _appBarClassesDefault.default));
var _appBar = require("./AppBar");
var _appBarDefault = parcelHelpers.interopDefault(_appBar);
var _appBarClasses = require("./appBarClasses");
var _appBarClassesDefault = parcelHelpers.interopDefault(_appBarClasses);
parcelHelpers.exportAll(_appBarClasses, exports);
"use client";

},{"./AppBar":"gDSw7","./appBarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gDSw7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _appBarClasses = require("./appBarClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const useUtilityClasses = (ownerState)=>{
    const { color, position, classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, _capitalizeDefault.default)(color)}`,
            `position${(0, _capitalizeDefault.default)(position)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _appBarClasses.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const AppBarRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`],
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme, ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, _extendsDefault.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, _extendsDefault.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, _extendsDefault.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, _extendsDefault.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const AppBar = /*#__PURE__*/ _react.forwardRef(function AppBar(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className, color = "primary", enableColorOnDark = false, position = "fixed" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        position,
        enableColorOnDark
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppBarRoot, (0, _extendsDefault.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, _clsxDefault.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
exports.default = AppBar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","../Paper":"9w8HO","./appBarClasses":"jaZuP","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jaZuP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAppBarUtilityClass", ()=>getAppBarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAppBarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiAppBar", slot);
}
const appBarClasses = (0, _generateUtilityClassesDefault.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
exports.default = appBarClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eN1IM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _grid2Default.default));
parcelHelpers.export(exports, "grid2Classes", ()=>(0, _grid2ClassesDefault.default));
var _grid2 = require("./Grid2");
var _grid2Default = parcelHelpers.interopDefault(_grid2);
var _grid2Props = require("./Grid2Props");
parcelHelpers.exportAll(_grid2Props, exports);
var _grid2Classes = require("./grid2Classes");
var _grid2ClassesDefault = parcelHelpers.interopDefault(_grid2Classes);
parcelHelpers.exportAll(_grid2Classes, exports);
"use client";

},{"./Grid2":"36QGO","./Grid2Props":false,"./grid2Classes":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"36QGO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _unstableGrid = require("@mui/system/Unstable_Grid");
var _styles = require("../styles");
"use client";
const Grid2 = (0, _unstableGrid.createGrid)({
    createStyledComponent: (0, _styles.styled)("div", {
        name: "MuiGrid2",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    componentName: "MuiGrid2",
    useThemeProps: (inProps)=>(0, _styles.useThemeProps)({
            props: inProps,
            name: "MuiGrid2"
        })
});
exports.default = Grid2;

},{"prop-types":"hRUel","@mui/system/Unstable_Grid":"3kw3N","../styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8qduJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useScrollTriggerDefault.default));
var _useScrollTrigger = require("./useScrollTrigger");
var _useScrollTriggerDefault = parcelHelpers.interopDefault(_useScrollTrigger);
"use client";

},{"./useScrollTrigger":"hXOGq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hXOGq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useScrollTrigger);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
"use client";
const _excluded = [
    "getTrigger",
    "target"
];
function defaultTrigger(store, options) {
    const { disableHysteresis = false, threshold = 100, target } = options;
    const previous = store.current;
    if (target) // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
    if (!disableHysteresis && previous !== undefined) {
        if (store.current < previous) return false;
    }
    return store.current > threshold;
}
const defaultTarget = typeof window !== "undefined" ? window : null;
function useScrollTrigger(options = {}) {
    const { getTrigger = defaultTrigger, target = defaultTarget } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const store = _react.useRef();
    const [trigger, setTrigger] = _react.useState(()=>getTrigger(store, other));
    _react.useEffect(()=>{
        const handleScroll = ()=>{
            setTrigger(getTrigger(store, (0, _extendsDefault.default)({
                target
            }, other)));
        };
        handleScroll(); // Re-evaluate trigger when dependencies change
        target.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            target.removeEventListener("scroll", handleScroll, {
                passive: true
            });
        };
    // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        getTrigger,
        JSON.stringify(other)
    ]);
    return trigger;
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"btY5V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledBox", ()=>StyledBox);
parcelHelpers.export(exports, "NetworkSelector", ()=>NetworkSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _networkButton = require("./NetworkButton");
var _colors = require("../../../styles/theme/colors");
var _network = require("../../../types/network");
var _api = require("../../../oasis-nexus/api");
var _layerPicker = require("./../LayerPicker");
var _routeUtils = require("../../utils/route-utils");
var _hook = require("../OfflineBanner/hook");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        marginLeft: `-${theme.spacing(1)}`,
        zIndex: 1,
        display: "flex",
        borderColor: (0, _colors.COLORS).brandExtraDark,
        borderStyle: "solid",
        borderWidth: "1px 1px 1px 0",
        padding: theme.spacing(2, 3, 2, 2),
        borderTopRightRadius: "9px",
        borderBottomRightRadius: "9px",
        boxShadow: `inset 0px 4px 4px rgba(34, 47, 63, 0.24)`
    }));
const NetworkSelector = (props)=>{
    return props.layer === (0, _api.Layer).consensus ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsensusNetworkSelector, {
        ...props
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimeNetworkSelector, {
        ...props
    });
};
const ConsensusNetworkSelector = ({ layer, network })=>{
    const { outOfDate } = (0, _hook.useConsensusFreshness)(network);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NetworkSelectorView, {
        layer: layer,
        network: network,
        isOutOfDate: outOfDate
    });
};
const RuntimeNetworkSelector = ({ layer, network })=>{
    const { outOfDate } = (0, _hook.useRuntimeFreshness)({
        network,
        layer
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NetworkSelectorView, {
        layer: layer,
        network: network,
        isOutOfDate: outOfDate
    });
};
const NetworkSelectorView = ({ isOutOfDate, layer, network })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { isMobile, isTablet } = (0, _useScreensize.useScreenSize)();
    const labels = (0, _network.getNetworkNames)(t);
    const [openDrawer, setOpenDrawer] = (0, _react.useState)(false);
    const handleDrawerClose = ()=>setOpenDrawer(false);
    const handleDrawerOpen = ()=>setOpenDrawer(true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: isTablet ? "flex-end" : "center"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerPicker.LayerPicker), {
                open: openDrawer,
                onClose: handleDrawerClose,
                onConfirm: (network, layer)=>{
                    handleDrawerClose();
                    navigate((0, _routeUtils.RouteUtils).getDashboardRoute({
                        network,
                        layer
                    }));
                },
                isOutOfDate: isOutOfDate
            }),
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkButton.NetworkButton), {
                isOutOfDate: isOutOfDate,
                layer: layer,
                network: network,
                onClick: handleDrawerOpen
            }),
            !(0, _routeUtils.fixedLayer) && !isTablet && network !== (0, _network.Network).mainnet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "span",
                    sx: {
                        fontSize: "12px",
                        color: (0, _colors.COLORS).brandExtraDark,
                        whiteSpace: "nowrap"
                    },
                    children: t("pageHeader.ribbon", {
                        network: labels[network]
                    })
                })
            }),
            isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkButton.MobileNetworkButton), {
                isOutOfDate: isOutOfDate,
                network: network,
                layer: layer,
                onClick: handleDrawerOpen
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","./NetworkButton":"a0dpU","../../../styles/theme/colors":"hYvW2","../../../types/network":"f0o8N","../../../oasis-nexus/api":"dJrPU","./../LayerPicker":"iHba4","../../utils/route-utils":"b2kKi","../OfflineBanner/hook":"cKMsd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a0dpU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNetworkButton", ()=>StyledNetworkButton);
parcelHelpers.export(exports, "StyledBox", ()=>StyledBox);
parcelHelpers.export(exports, "NetworkButton", ()=>NetworkButton);
parcelHelpers.export(exports, "StyledMobileNetworkButton", ()=>StyledMobileNetworkButton);
parcelHelpers.export(exports, "MobileNetworkButton", ()=>MobileNetworkButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _edit = require("@mui/icons-material/Edit");
var _editDefault = parcelHelpers.interopDefault(_edit);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
var _network = require("../../../types/network");
var _content = require("../../utils/content");
var _layerStatus = require("../LayerStatus");
var _routeUtils = require("../../utils/route-utils");
const StyledNetworkButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        alignItems: "center",
        justifyContent: "space-between",
        height: "auto",
        width: "280px",
        padding: 0,
        borderRadius: "12px",
        borderColor: theme.palette.layout.darkBorder,
        borderWidth: theme.spacing(1),
        backgroundColor: (0, _colors.COLORS).white,
        color: (0, _colors.COLORS).brandDark,
        textAlign: "left",
        overflow: "hidden",
        [`& .${(0, _button.buttonClasses).startIcon}`]: {
            transitionProperty: "background-color, color",
            transitionDuration: `${theme.transitions.duration.standard}ms`,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            padding: `0 ${theme.spacing(4)}`,
            margin: 0
        },
        [`& .${(0, _button.buttonClasses).endIcon}`]: {
            transitionProperty: "background-color, color",
            transitionDuration: `${theme.transitions.duration.standard}ms`,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            height: "47px",
            display: "flex",
            alignItems: "center",
            padding: `0 ${theme.spacing(4)}`,
            borderTopRightRadius: "12px",
            borderBottomRightRadius: "12px",
            borderLeftWidth: theme.spacing(1),
            borderLeftStyle: "solid",
            borderLeftColor: theme.palette.layout.secondary,
            backgroundColor: (0, _colors.COLORS).white
        },
        "&:hover, &:focus-visible": {
            borderWidth: theme.spacing(1),
            color: (0, _colors.COLORS).white,
            borderColor: theme.palette.layout.hoverBorder,
            [`& .${(0, _button.buttonClasses).endIcon}`]: {
                color: (0, _colors.COLORS).brandDark,
                backgroundColor: theme.palette.layout.secondaryBackground,
                borderColor: theme.palette.layout.hoverBorder
            }
        }
    }));
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        flex: 1,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(3)
    }));
const getNetworkButtonLabel = (t, network, layer)=>(0, _routeUtils.fixedLayer // If we are fixed to a layer,
    ) ? (0, _network.getNetworkNames)(t)[network] // let's show the name of the network,
     : (0, _content.getLayerLabels)(t)[layer] // otherwise, the name of the layer.
;
const NetworkButton = ({ isOutOfDate, layer, network, onClick })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const icons = (0, _content.getNetworkIcons)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNetworkButton, {
        sx: {
            ml: 4
        },
        size: "small",
        variant: "outlined",
        startIcon: icons[network],
        endIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editDefault.default), {}),
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
            children: [
                getNetworkButtonLabel(t, network, layer),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerStatus.LayerStatus), {
                    isOutOfDate: isOutOfDate
                })
            ]
        })
    });
};
const StyledMobileNetworkButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        backgroundColor: (0, _colors.COLORS).white,
        borderRadius: "30px",
        border: `solid 1px ${(0, _colors.COLORS).brandExtraDark}`,
        fontSize: "14px",
        fontWeight: 500,
        color: (0, _colors.COLORS).brandDark,
        gap: theme.spacing(3),
        height: "30px",
        padding: `0 ${theme.spacing(4)}`,
        "&:hover, &:focus-visible": {
            backgroundColor: (0, _colors.COLORS).white
        }
    }));
const MobileNetworkButton = ({ isOutOfDate, layer, network, onClick })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMobileNetworkButton, {
        onClick: onClick,
        children: [
            getNetworkButtonLabel(t, network, layer),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerStatus.LayerStatus), {
                isOutOfDate: isOutOfDate
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Button":"h2G5p","@mui/icons-material/Edit":"if1of","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","../../../types/network":"f0o8N","../../utils/content":"gyk1M","../LayerStatus":"Drz23","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"if1of":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("eb27e0798e46a0ef");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("8d8eed843b0d229e"));
var _jsxRuntime = require("153478913a17d1b2");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");

},{"eb27e0798e46a0ef":"hykHy","8d8eed843b0d229e":"gQLSP","153478913a17d1b2":"g88cO"}],"Drz23":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerStatus", ()=>LayerStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
const OutOfDateLayerStatusIcon = ({ tooltip })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const errorIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
        sx: {
            marginLeft: 2
        },
        color: "error",
        fontSize: "small"
    });
    return tooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: t("common.paraTimeOutOfDate"),
        children: errorIcon
    }) : errorIcon;
};
const LayerStatus = ({ isOutOfDate, withLabel = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (typeof isOutOfDate === "undefined") return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            withLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: 10,
                    color: (0, _colors.COLORS).paraTimeStatus,
                    mr: 3
                },
                component: "span",
                children: isOutOfDate ? t("common.paraTimeOutOfDate") : t("common.paraTimeOnline")
            }),
            isOutOfDate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutOfDateLayerStatusIcon, {
                tooltip: !withLabel
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
                sx: {
                    marginLeft: 2
                },
                color: "success",
                fontSize: "small"
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Error":"dRT6j","@mui/material/Tooltip":"3RLHy","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3RLHy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "tooltipClasses", ()=>(0, _tooltipClassesDefault.default));
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipClasses = require("./tooltipClasses");
var _tooltipClassesDefault = parcelHelpers.interopDefault(_tooltipClasses);
parcelHelpers.exportAll(_tooltipClasses, exports);
"use client";

},{"./Tooltip":"dSx0R","./tooltipClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dSx0R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testReset", ()=>testReset);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _rtlProvider = require("@mui/system/RtlProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _popper = require("../Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useId = require("../utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _tooltipClasses = require("./tooltipClasses");
var _tooltipClassesDefault = parcelHelpers.interopDefault(_tooltipClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, disableInteractive, arrow, touch, placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, _capitalizeDefault.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tooltipClasses.getTooltipUtilityClass), classes);
};
const TooltipPopper = (0, _styledDefault.default)((0, _popperDefault.default), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme, ownerState, open })=>(0, _extendsDefault.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, _tooltipClassesDefault.default).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, _tooltipClassesDefault.default).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, _tooltipClassesDefault.default).arrow}`]: (0, _extendsDefault.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, _tooltipClassesDefault.default).arrow}`]: (0, _extendsDefault.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const TooltipTooltip = (0, _styledDefault.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, _capitalizeDefault.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="left"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, _extendsDefault.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, _extendsDefault.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="right"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, _extendsDefault.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, _extendsDefault.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="top"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="bottom"] &`]: (0, _extendsDefault.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const TooltipArrow = (0, _styledDefault.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let hystersisOpen = false;
const hystersisTimer = new (0, _useTimeout.Timeout)();
let cursorPosition = {
    x: 0,
    y: 0
};
function testReset() {
    hystersisOpen = false;
    hystersisTimer.clear();
}
function composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip = /*#__PURE__*/ _react.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow = false, children: childrenProp, components = {}, componentsProps = {}, describeChild = false, disableFocusListener = false, disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener = false, enterDelay = 100, enterNextDelay = 0, enterTouchDelay = 700, followCursor = false, id: idProp, leaveDelay = 0, leaveTouchDelay = 1500, onClose, onOpen, open: openProp, placement = "bottom", PopperComponent: PopperComponentProp, PopperProps = {}, slotProps = {}, slots = {}, title, TransitionComponent: TransitionComponentProp = (0, _growDefault.default), TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ _react.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, _useThemeDefault.default)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const [childNode, setChildNode] = _react.useState();
    const [arrowRef, setArrowRef] = _react.useState(null);
    const ignoreNonTouchEvents = _react.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, _useTimeoutDefault.default)();
    const enterTimer = (0, _useTimeoutDefault.default)();
    const leaveTimer = (0, _useTimeoutDefault.default)();
    const touchTimer = (0, _useTimeoutDefault.default)();
    const [openState, setOpenState] = (0, _useControlledDefault.default)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, _useIdDefault.default)(idProp);
    const prevUserSelect = _react.useRef();
    const stopTouchInteraction = (0, _useEventCallbackDefault.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    _react.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        hystersisTimer.clear();
        hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, _useEventCallbackDefault.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        hystersisTimer.start(800 + leaveDelay, ()=>{
            hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || hystersisOpen && enterNextDelay) enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = _react.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    _react.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, _useForkRefDefault.default)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = _react.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, _extendsDefault.default)({}, nameOrDescProps, other, children.props, {
        className: (0, _clsxDefault.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = _react.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, _extendsDefault.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        isRtl,
        arrow,
        disableInteractive,
        placement,
        PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, _growDefault.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
    const popperProps = (0, _utils.appendOwnerState)(PopperComponent, (0, _extendsDefault.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, _clsxDefault.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, _utils.appendOwnerState)(TransitionComponent, (0, _extendsDefault.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, _utils.appendOwnerState)(TooltipComponent, (0, _extendsDefault.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, _clsxDefault.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, _utils.appendOwnerState)(ArrowComponent, (0, _extendsDefault.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, _clsxDefault.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ _react.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperComponent, (0, _extendsDefault.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, _popperDefault.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: cursorPosition.y,
                            left: cursorPosition.x,
                            right: cursorPosition.x,
                            bottom: cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TooltipComponent, (0, _extendsDefault.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrowComponent, (0, _extendsDefault.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
exports.default = Tooltip;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/useTimeout":"2Xz3c","@mui/utils/elementAcceptingRef":"dHnQP","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","@mui/system/RtlProvider":"jz0y0","../styles/styled":"axRcE","../styles/useTheme":"3N7Mw","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","../Grow":"3JaRg","../Popper":"fIFCV","../utils/useEventCallback":"2AJRL","../utils/useForkRef":"5kA2S","../utils/useId":"gJPxn","../utils/useIsFocusVisible":"c4NVG","../utils/useControlled":"bNYR8","./tooltipClasses":"av8tw","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fIFCV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popperDefault.default));
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
"use client";

},{"./Popper":"irYOp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"irYOp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _popper = require("@mui/base/Popper");
var _useThemeWithoutDefault = require("@mui/system/useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _styles = require("../styles");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const PopperRoot = (0, _styles.styled)((0, _popper.Popper), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const Popper = /*#__PURE__*/ _react.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, _useThemeWithoutDefaultDefault.default)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl, component, components, componentsProps, container, disablePortal, keepMounted, modifiers, open, placement, popperOptions, popperRef, transition, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, _extendsDefault.default)({
        anchorEl,
        container,
        disablePortal,
        keepMounted,
        modifiers,
        open,
        placement,
        popperOptions,
        popperRef,
        transition
    }, other);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperRoot, (0, _extendsDefault.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
exports.default = Popper;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/base/Popper":"a4mv3","@mui/system/useThemeWithoutDefault":"2zGlh","@mui/utils/refType":"l5hTY","@mui/utils/HTMLElementType":"lxflV","prop-types":"hRUel","react":"BK2ob","../styles":"51PGx","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2zGlh":[function(require,module,exports) {
"use strict";
"use client";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ece7d757518cd5f4"));
var _styledEngine = require("4836cf219b195311");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = React.useContext(_styledEngine.ThemeContext);
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var _default = exports.default = useTheme;

},{"ece7d757518cd5f4":"BK2ob","4836cf219b195311":"8mH2X"}],"av8tw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipUtilityClass", ()=>getTooltipUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTooltipUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTooltip", slot);
}
const tooltipClasses = (0, _generateUtilityClassesDefault.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
exports.default = tooltipClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iHba4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerPicker", ()=>LayerPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _drawer = require("@mui/material/Drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _unstableGrid2 = require("@mui/material/Unstable_Grid2");
var _unstableGrid2Default = parcelHelpers.interopDefault(_unstableGrid2);
var _logotype = require("../PageLayout/Logotype");
var _colors = require("../../../styles/theme/colors");
var _useScopeParam = require("../../hooks/useScopeParam");
var _networkMenu = require("./NetworkMenu");
var _layerMenu = require("./LayerMenu");
var _layerDetails = require("./LayerDetails");
var _routeUtils = require("../../utils/route-utils");
var _styles = require("@mui/material/styles");
var _keyboardArrowLeft = require("@mui/icons-material/KeyboardArrowLeft");
var _keyboardArrowLeftDefault = parcelHelpers.interopDefault(_keyboardArrowLeft);
var _useScreensize = require("../../hooks/useScreensize");
var _networkButton = require("../PageLayout/NetworkButton");
const LayerPicker = ({ onClose, onConfirm, open, isOutOfDate })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
        anchor: "top",
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerPickerContent, {
            onClose: onClose,
            onConfirm: onConfirm,
            isOutOfDate: isOutOfDate
        })
    });
const StyledLayerPickerContent = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1
        }
    }));
const StyledContent = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        flex: 1,
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }
    }));
const TabletBackButton = (0, _styles.styled)((0, _buttonDefault.default))({
    color: (0, _colors.COLORS).brandDark,
    width: "fit-content",
    textDecoration: "none"
});
const TabletActionBar = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: "55px",
        paddingBottom: theme.spacing(3)
    }));
const ActionBar = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        justifyContent: "space-around",
        [theme.breakpoints.up("md")]: {
            justifyContent: "flex-end",
            gap: theme.spacing(4)
        }
    }));
var LayerPickerTabletStep;
(function(LayerPickerTabletStep) {
    LayerPickerTabletStep[LayerPickerTabletStep["Network"] = 0] = "Network";
    LayerPickerTabletStep[LayerPickerTabletStep["Layer"] = 1] = "Layer";
    LayerPickerTabletStep[LayerPickerTabletStep["LayerDetails"] = 2] = "LayerDetails";
})(LayerPickerTabletStep || (LayerPickerTabletStep = {}));
const LayerPickerContent = ({ isOutOfDate, onClose, onConfirm })=>{
    const { isMobile, isTablet } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network, layer } = (0, _useScopeParam.useRequiredScopeParam)();
    const [selectedLayer, setSelectedLayer] = (0, _react.useState)(layer);
    const [selectedNetwork, setSelectedNetwork] = (0, _react.useState)(network);
    const [tabletStep, setTabletStep] = (0, _react.useState)(2);
    const selectNetwork = (newNetwork)=>{
        const enabledLayers = (0, _routeUtils.RouteUtils).getAllLayersForNetwork(newNetwork).enabled;
        const targetLayer = enabledLayers.includes(selectedLayer) ? selectedLayer : enabledLayers[0];
        setSelectedNetwork(newNetwork);
        setSelectedLayer(targetLayer);
    };
    const handleConfirm = ()=>onConfirm(selectedNetwork, selectedLayer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledLayerPickerContent, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    mb: isTablet ? 0 : 5,
                    color: "red",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logotype.HomePageLink), {
                    color: (0, _colors.COLORS).brandExtraDark,
                    showText: !isMobile
                })
            }),
            isTablet && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabletActionBar, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            // Do we need a "back to networks" button ?
                            ((0, _routeUtils.scopeFreedom) === "network-layer" && tabletStep === 1 || // Stepping back from layers
                            (0, _routeUtils.scopeFreedom) === "network" && tabletStep === 2) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabletBackButton, {
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowLeftDefault.default), {}),
                                onClick: ()=>{
                                    setTabletStep(0);
                                },
                                children: t("layerPicker.viewNetworks")
                            }),
                            (0, _routeUtils.scopeFreedom) !== "network" && tabletStep === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabletBackButton, {
                                variant: "text",
                                startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowLeftDefault.default), {}),
                                onClick: ()=>{
                                    setTabletStep(1);
                                },
                                children: t("layerPicker.viewLayers")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkButton.MobileNetworkButton), {
                        isOutOfDate: isOutOfDate,
                        network: network,
                        layer: layer,
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledContent, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
                        container: true,
                        children: [
                            (0, _routeUtils.scopeFreedom) !== "layer" && (!isTablet || isTablet && tabletStep === 0) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkMenu.NetworkMenu), {
                                    activeNetwork: network,
                                    selectedNetwork: selectedNetwork,
                                    setSelectedNetwork: (network)=>{
                                        selectNetwork(network);
                                        setTabletStep((0, _routeUtils.scopeFreedom) === "network" // Are we fixed to a specific layer, selecting only network?
                                         ? 2 : 1);
                                    }
                                })
                            }),
                            (0, _routeUtils.scopeFreedom) !== "network" && (!isTablet || isTablet && tabletStep === 1) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                                xs: 12,
                                md: 3,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerMenu.LayerMenu), {
                                    activeLayer: layer,
                                    network: network,
                                    selectedLayer: selectedLayer,
                                    selectedNetwork: selectedNetwork,
                                    setSelectedLayer: (layer)=>{
                                        setSelectedLayer(layer);
                                        setTabletStep(2);
                                    }
                                })
                            }),
                            (!isTablet || isTablet && tabletStep === 2) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                                xs: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerDetails.LayerDetails), {
                                    handleConfirm: handleConfirm,
                                    selectedLayer: selectedLayer,
                                    network: selectedNetwork,
                                    isOutOfDate: isOutOfDate
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ActionBar, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: onClose,
                                color: "secondary",
                                variant: "outlined",
                                size: "large",
                                children: t("common.cancel")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                onClick: handleConfirm,
                                color: "primary",
                                variant: "contained",
                                size: "large",
                                children: selectedNetwork === network && selectedLayer === layer ? t("layerPicker.goToDashboard") : t("common.select")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Button":"h2G5p","@mui/material/Drawer":"kDhKf","@mui/material/Divider":"3hI6U","@mui/material/Unstable_Grid2":"eN1IM","../PageLayout/Logotype":"h3vde","../../../styles/theme/colors":"hYvW2","../../hooks/useScopeParam":"kKMKx","./NetworkMenu":"hDSDn","./LayerMenu":"7UvPs","./LayerDetails":"9nKBi","../../utils/route-utils":"b2kKi","@mui/material/styles":"51PGx","@mui/icons-material/KeyboardArrowLeft":"4D5Yz","../../hooks/useScreensize":"2HEhN","../PageLayout/NetworkButton":"a0dpU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kDhKf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _drawerDefault.default));
parcelHelpers.export(exports, "drawerClasses", ()=>(0, _drawerClassesDefault.default));
var _drawer = require("./Drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _drawerClasses = require("./drawerClasses");
var _drawerClassesDefault = parcelHelpers.interopDefault(_drawerClasses);
parcelHelpers.exportAll(_drawerClasses, exports);
"use client";

},{"./Drawer":"cXkRj","./drawerClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cXkRj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHorizontal", ()=>isHorizontal);
parcelHelpers.export(exports, "getAnchor", ()=>getAnchor);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _rtlProvider = require("@mui/system/RtlProvider");
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _slide = require("../Slide");
var _slideDefault = parcelHelpers.interopDefault(_slide);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _drawerClasses = require("./drawerClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "BackdropProps"
], _excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, anchor, variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, _capitalizeDefault.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, _capitalizeDefault.default)(anchor)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _drawerClasses.getDrawerUtilityClass), classes);
};
const DrawerRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver
})(({ theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const DrawerDockedRoot = (0, _styledDefault.default)("div", {
    shouldForwardProp: (0, _styled.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver
})({
    flex: "0 0 auto"
});
const DrawerPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, _capitalizeDefault.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, _capitalizeDefault.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function isHorizontal(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function getAnchor({ direction }, anchor) {
    return direction === "rtl" && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const Drawer = /*#__PURE__*/ _react.forwardRef(function Drawer(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, _useThemeDefault.default)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps, children, className, elevation = 16, hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose, open = false, PaperProps = {}, SlideProps, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _slideDefault.default), transitionDuration = defaultTransitionDuration, variant = "temporary" } = props, ModalProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.ModalProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = _react.useRef(false);
    _react.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = getAnchor({
        direction: isRtl ? "rtl" : "ltr"
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        anchor,
        elevation,
        open,
        variant
    }, other);
    const classes = useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerPaper, (0, _extendsDefault.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, _clsxDefault.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerDockedRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: open,
        direction: oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerDockedRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerRoot, (0, _extendsDefault.default)({
        BackdropProps: (0, _extendsDefault.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration
        }),
        className: (0, _clsxDefault.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
exports.default = Drawer;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/integerPropType":"3uD7f","@mui/utils/composeClasses":"jj3MR","@mui/system/RtlProvider":"jz0y0","../Modal":"9y8oQ","../Slide":"gkZ0u","../Paper":"9w8HO","../utils/capitalize":"iHgWG","../styles/useTheme":"3N7Mw","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./drawerClasses":"ijeAj","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gkZ0u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _slideDefault.default));
var _slide = require("./Slide");
var _slideDefault = parcelHelpers.interopDefault(_slide);
"use client";

},{"./Slide":"acjz3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"acjz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTranslateValue", ()=>setTranslateValue);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils = require("../transitions/utils");
var _utils1 = require("../utils");
// Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, _utils1.ownerWindow)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
    const resolvedContainer = resolveContainer(containerProp);
    const transform = getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Slide = /*#__PURE__*/ _react.forwardRef(function Slide(props, ref) {
    const theme = (0, _useThemeDefault.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, container: containerProp, direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const childrenRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        setTranslateValue(direction, node, containerProp);
        (0, _utils.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            timeout,
            style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, _extendsDefault.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, _extendsDefault.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            timeout,
            style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        setTranslateValue(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = _react.useCallback(()=>{
        if (childrenRef.current) setTranslateValue(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    _react.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, _debounceDefault.default)(()=>{
            if (childrenRef.current) setTranslateValue(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, _utils1.ownerWindow)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    _react.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                ref: handleRef,
                style: (0, _extendsDefault.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
exports.default = Slide;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","react-transition-group":"j8hjZ","@mui/utils/chainPropTypes":"8qu3z","@mui/utils/HTMLElementType":"lxflV","@mui/utils/elementAcceptingRef":"dHnQP","../utils/debounce":"bEAi9","../utils/useForkRef":"5kA2S","../styles/useTheme":"3N7Mw","../transitions/utils":"jjBwh","../utils":"bu04F","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ijeAj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDrawerUtilityClass", ()=>getDrawerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDrawerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiDrawer", slot);
}
const drawerClasses = (0, _generateUtilityClassesDefault.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
exports.default = drawerClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hDSDn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkMenuItem", ()=>NetworkMenuItem);
parcelHelpers.export(exports, "NetworkMenu", ()=>NetworkMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _colors = require("../../../styles/theme/colors");
var _network = require("../../../types/network");
var _routeUtils = require("../../utils/route-utils");
var _content = require("../../utils/content");
const NetworkMenuItem = ({ activeNetwork, divider, network, selectedNetwork, setHoveredNetwork, setSelectedNetwork })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const labels = (0, _network.getNetworkNames)(t);
    const icons = (0, _content.getNetworkIcons)();
    const activeNetworkSelection = network === selectedNetwork;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
        divider: divider,
        onMouseEnter: ()=>{
            setHoveredNetwork(network);
        },
        onMouseLeave: ()=>{
            setHoveredNetwork(undefined);
        },
        selected: activeNetworkSelection,
        tabIndex: activeNetworkSelection ? 0 : -1,
        onClick: ()=>{
            setSelectedNetwork(network);
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                children: icons[network]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemTextDefault.default), {
                children: [
                    labels[network],
                    activeNetwork === network && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            fontSize: "10px",
                            fontStyle: "italic",
                            color: (0, _colors.COLORS).grayMedium,
                            ml: 2
                        },
                        children: t("layerPicker.selected")
                    })
                ]
            }),
            network === selectedNetwork && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {})
        ]
    });
};
const NetworkMenu = ({ activeNetwork, selectedNetwork, setSelectedNetwork })=>{
    const [hoveredNetwork, setHoveredNetwork] = (0, _react.useState)();
    const options = (0, _routeUtils.RouteUtils).getEnabledNetworks();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuListDefault.default), {
        children: options.map((network, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NetworkMenuItem, {
                activeNetwork: activeNetwork,
                divider: index !== options.length - 1,
                hoveredNetwork: hoveredNetwork,
                selectedNetwork: selectedNetwork,
                setHoveredNetwork: setHoveredNetwork,
                setSelectedNetwork: setSelectedNetwork,
                network: network
            }, network))
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Typography":"f5srd","@mui/icons-material/KeyboardArrowRight":"4u9xI","@mui/material/MenuList":"hnEqU","@mui/material/MenuItem":"7xWsk","@mui/material/ListItemText":"lneG9","@mui/material/ListItemIcon":"kjw1a","../../../styles/theme/colors":"hYvW2","../../../types/network":"f0o8N","../../utils/route-utils":"b2kKi","../../utils/content":"gyk1M","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4u9xI":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("2dfd7b2d38f9c33a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b0c93802295799a4"));
var _jsxRuntime = require("3e900950a1367c45");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), "KeyboardArrowRight");

},{"2dfd7b2d38f9c33a":"hykHy","b0c93802295799a4":"gQLSP","3e900950a1367c45":"g88cO"}],"7UvPs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisabledLayerMenuItem", ()=>DisabledLayerMenuItem);
parcelHelpers.export(exports, "LayerMenuItem", ()=>LayerMenuItem);
parcelHelpers.export(exports, "LayerMenu", ()=>LayerMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _menuList = require("@mui/material/MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _colors = require("../../../styles/theme/colors");
var _api = require("../../../oasis-nexus/api");
var _content = require("../../utils/content");
var _routeUtils = require("../../utils/route-utils");
var _layers = require("../../../types/layers");
var _useScreensize = require("../../hooks/useScreensize");
var _useScopeParam = require("../../hooks/useScopeParam");
const LayerMenuItemCaption = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        component: "span",
        sx: {
            fontSize: "10px",
            fontStyle: "italic",
            color: (0, _colors.COLORS).grayMedium,
            ml: 2
        },
        children: children
    });
const DisabledLayerMenuItem = ({ divider, layer })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const labels = (0, _content.getLayerLabels)(t);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: t("layerPicker.comingSoonTitle"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                disabled: true,
                divider: divider,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemTextDefault.default), {
                    children: [
                        labels[layer],
                        isTablet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerMenuItemCaption, {
                            children: t("layerPicker.comingSoonLabel")
                        })
                    ]
                })
            })
        })
    });
};
const LayerMenuItem = ({ activeLayer, divider, layer, network, selectedLayer, selectedNetwork, setHoveredLayer, setSelectedLayer })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const labels = (0, _content.getLayerLabels)(t);
    const activeLayerSelection = layer === selectedLayer;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuItemDefault.default), {
        divider: divider,
        onMouseEnter: ()=>{
            setHoveredLayer(layer);
        },
        onMouseLeave: ()=>{
            setHoveredLayer();
        },
        onClick: ()=>{
            setSelectedLayer(layer);
        },
        selected: activeLayerSelection,
        tabIndex: activeLayerSelection ? 0 : -1,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemTextDefault.default), {
                children: [
                    labels[layer],
                    selectedNetwork === network && activeLayer === layer && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerMenuItemCaption, {
                        children: t("layerPicker.selected")
                    })
                ]
            }),
            layer === selectedLayer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {})
        ]
    });
};
const LayerMenu = ({ activeLayer, network, selectedLayer, selectedNetwork, setSelectedLayer })=>{
    const currentScope = (0, _useScopeParam.useScopeParam)();
    const [hoveredLayer, setHoveredLayer] = (0, _react.useState)();
    const options = Object.values((0, _api.Layer))// Don't show hidden layers, unless we are already viewing them.
    .filter((layer)=>!(0, _layers.isLayerHidden)(layer) || layer === currentScope?.layer).map((layer)=>({
            layer,
            enabled: (0, _routeUtils.RouteUtils).getAllLayersForNetwork(selectedNetwork || network).enabled.includes(layer)
        })).sort((0, _layers.orderByLayer));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuListDefault.default), {
        children: options.map((option, index)=>{
            if (!option.enabled) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DisabledLayerMenuItem, {
                divider: index !== options.length - 1,
                layer: option.layer
            }, option.layer);
            else return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerMenuItem, {
                activeLayer: activeLayer,
                divider: index !== options.length - 1,
                hoveredLayer: hoveredLayer,
                layer: option.layer,
                network: network,
                selectedLayer: selectedLayer,
                selectedNetwork: selectedNetwork,
                setHoveredLayer: setHoveredLayer,
                setSelectedLayer: setSelectedLayer
            }, option.layer);
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Typography":"f5srd","@mui/icons-material/KeyboardArrowRight":"4u9xI","@mui/material/MenuList":"hnEqU","@mui/material/MenuItem":"7xWsk","@mui/material/ListItemText":"lneG9","@mui/material/Tooltip":"3RLHy","../../../styles/theme/colors":"hYvW2","../../../oasis-nexus/api":"dJrPU","../../utils/content":"gyk1M","../../utils/route-utils":"b2kKi","../../../types/layers":"gWCJy","../../hooks/useScreensize":"2HEhN","../../hooks/useScopeParam":"kKMKx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9nKBi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledButton", ()=>StyledButton);
parcelHelpers.export(exports, "LayerDetails", ()=>LayerDetails);
parcelHelpers.export(exports, "LayerDetailsSection", ()=>LayerDetailsSection);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _circle = require("../Circle");
var _colors = require("../../../styles/theme/colors");
var _network = require("../../../types/network");
var _api = require("../../../oasis-nexus/api");
var _reactRouterDom = require("react-router-dom");
var _externalLinks = require("../../utils/externalLinks");
var _textList = require("../TextList");
var _content = require("../../utils/content");
var _searchScope = require("../../../types/searchScope");
var _hook = require("../OfflineBanner/hook");
var _layerStatus = require("../LayerStatus");
var _useScreensize = require("../../hooks/useScreensize");
const getDetails = (t)=>({
        [(0, _network.Network).mainnet]: {
            [(0, _api.Layer).emerald]: {
                description: t("layerPicker.mainnet.emerald"),
                rpcHttp: "https://emerald.oasis.dev",
                rpcWebSockets: "wss://emerald.oasis.dev/ws",
                chainHexId: "0xa516",
                chainDecimalId: "42262",
                docs: (0, _externalLinks.docs).emerald
            },
            [(0, _api.Layer).sapphire]: {
                description: t("layerPicker.mainnet.sapphire"),
                rpcHttp: "https://sapphire.oasis.io",
                rpcWebSockets: "wss://sapphire.oasis.io/ws",
                chainHexId: "0x5afe",
                chainDecimalId: "23294",
                docs: (0, _externalLinks.docs).sapphire
            }
        },
        [(0, _network.Network).testnet]: {
            [(0, _api.Layer).emerald]: {
                description: t("layerPicker.testnet.emerald"),
                rpcHttp: "https://testnet.emerald.oasis.dev",
                rpcWebSockets: "wss://testnet.emerald.oasis.dev/ws",
                chainHexId: "0xa515",
                chainDecimalId: "42261",
                docs: (0, _externalLinks.docs).emerald
            },
            [(0, _api.Layer).sapphire]: {
                description: t("layerPicker.testnet.sapphire"),
                rpcHttp: "https://testnet.sapphire.oasis.dev",
                rpcWebSockets: "wss://testnet.sapphire.oasis.dev/ws",
                chainHexId: "0x5aff",
                chainDecimalId: "23295",
                docs: (0, _externalLinks.docs).sapphire
            },
            [(0, _api.Layer).pontusx]: {
                description: t("layerPicker.testnet.pontusx"),
                rpcHttp: "https://pontusx.not.si:443",
                chainHexId: "0x7ec8",
                chainDecimalId: "32456",
                docs: (0, _externalLinks.docs).pontusx1
            }
        }
    });
const StyledButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        height: 30,
        paddingLeft: 0,
        marginRight: theme.spacing(3),
        fontSize: 24,
        color: (0, _colors.COLORS).brandDark,
        fontWeight: 700,
        "&&:hover, &&:active, &&:focus-visible": {
            color: (0, _colors.COLORS).brandDark,
            textDecoration: "none",
            borderRadius: 0
        }
    }));
// Prevent modal height from changing height when switching between layers
const contentMinHeight = "270px";
const LayerDetails = (props)=>props.selectedLayer === (0, _api.Layer).consensus ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsensusDetails, {
        ...props
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimeDetails, {
        ...props
    });
const ConsensusDetails = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { handleConfirm, network, selectedLayer } = props;
    const isOutOfDate = (0, _hook.useConsensusFreshness)(network).outOfDate;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayerDetailsSection, {
        docsUrl: (0, _externalLinks.docs).consensus,
        handleConfirm: handleConfirm,
        isOutOfDate: isOutOfDate,
        selectedLayer: selectedLayer,
        network: network,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
            sx: {
                fontSize: "14px",
                color: (0, _colors.COLORS).brandExtraDark,
                pb: 4
            },
            children: t("layerPicker.consensus")
        })
    });
};
const RuntimeDetails = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { handleConfirm, network, selectedLayer } = props;
    const isOutOfDate = (0, _hook.useRuntimeFreshness)({
        network,
        layer: selectedLayer
    }).outOfDate;
    const details = getDetails(t)[network][selectedLayer];
    if (!details) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LayerDetailsSection, {
        docsUrl: details.docs,
        handleConfirm: handleConfirm,
        isOutOfDate: isOutOfDate,
        selectedLayer: selectedLayer,
        network: network,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: "14px",
                    color: (0, _colors.COLORS).brandExtraDark,
                    pb: 4
                },
                children: details.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _textList.TextList), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textList.TextListItem), {
                        children: t("layerPicker.rpcHttp", {
                            endpoint: details.rpcHttp
                        })
                    }),
                    details.rpcWebSockets && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textList.TextListItem), {
                        children: t("layerPicker.rpcWebSockets", {
                            endpoint: details.rpcWebSockets
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _textList.TextListItem), {
                        children: [
                            t("layerPicker.chainId"),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _textList.TextList), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textList.TextListItem), {
                                        children: t("layerPicker.hex", {
                                            id: details.chainHexId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textList.TextListItem), {
                                        children: t("layerPicker.decimal", {
                                            id: details.chainDecimalId
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const LayerDetailsSection = ({ children, docsUrl, handleConfirm, isOutOfDate, network, selectedLayer })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const theme = (0, _styles.useTheme)();
    const { isMobile, isTablet } = (0, _useScreensize.useScreenSize)();
    const labels = (0, _network.getNetworkNames)(t);
    const layerLabels = (0, _content.getLayerLabels)(t);
    const icons = (0, _content.getNetworkIcons)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            px: isTablet ? 2 : 5,
            py: 4,
            display: "flex",
            minHeight: contentMinHeight
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    pt: 1,
                    pr: 4,
                    color: (0, _colors.COLORS).brandDark
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circle.Circle), {
                    color: (0, _colors.COLORS).white,
                    size: 5,
                    sx: {
                        borderColor: (0, _colors.COLORS).brandDark,
                        borderWidth: theme.spacing(1),
                        borderStyle: "solid"
                    },
                    children: icons[network]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            pb: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                                variant: "text",
                                onClick: handleConfirm,
                                children: (0, _searchScope.getNameForScope)(t, {
                                    network,
                                    layer: selectedLayer
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerStatus.LayerStatus), {
                                isOutOfDate: isOutOfDate,
                                withLabel: !isMobile && selectedLayer !== (0, _api.Layer).consensus
                            })
                        ]
                    }),
                    children,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _linkDefault.default), {
                        component: (0, _reactRouterDom.Link),
                        to: docsUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            fontSize: "14px",
                            fontWeight: 400
                        },
                        children: [
                            t("layerPicker.readMore", {
                                layer: layerLabels[selectedLayer],
                                network: labels[network]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {
                                sx: {
                                    fontSize: "16px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Button":"h2G5p","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@mui/icons-material/OpenInNew":"9yVXZ","@mui/material/Link":"fTbCF","../Circle":"8Poag","../../../styles/theme/colors":"hYvW2","../../../types/network":"f0o8N","../../../oasis-nexus/api":"dJrPU","react-router-dom":"5o0mA","../../utils/externalLinks":"d3W8q","../TextList":"fVePs","../../utils/content":"gyk1M","../../../types/searchScope":"6SEv5","../OfflineBanner/hook":"cKMsd","../LayerStatus":"Drz23","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9yVXZ":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("e2fa2d905ac58114");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ae1c288d5833efff"));
var _jsxRuntime = require("fbc157c28865ae1d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew");

},{"e2fa2d905ac58114":"hykHy","ae1c288d5833efff":"gQLSP","fbc157c28865ae1d":"g88cO"}],"8Poag":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("@mui/material/styles");
const Circle = (0, _styles.styled)((0, _boxDefault.default))(({ color, size, theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: theme.spacing(size),
        minWidth: theme.spacing(size),
        height: theme.spacing(size),
        backgroundColor: color,
        borderRadius: theme.spacing(size),
        color: "inherit"
    }));

},{"@mui/material/Box":"4d7LG","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fVePs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextList", ()=>TextList);
parcelHelpers.export(exports, "TextListItem", ()=>TextListItem);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _colors = require("../../../styles/theme/colors");
const StyledList = (0, _styles.styled)((0, _listDefault.default))(({ theme })=>({
        listStyleType: "disc",
        listStylePosition: "outside",
        color: (0, _colors.COLORS).brandExtraDark,
        fontSize: "14px",
        paddingLeft: theme.spacing(4),
        "& ul": {
            paddingTop: 0,
            paddingBottom: 0
        }
    }));
const TextList = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledList, {
        children: children
    });
const StyledListItem = (0, _styles.styled)((0, _listItemDefault.default))(({ theme })=>({
        display: "list-item",
        padding: 0,
        paddingBottom: theme.spacing(1)
    }));
const TextListItem = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledListItem, {
        children: children
    });

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/List":"2UkGG","@mui/material/ListItem":"iWY3X","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iWY3X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemDefault.default));
parcelHelpers.export(exports, "listItemClasses", ()=>(0, _listItemClassesDefault.default));
var _listItem = require("./ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemClasses = require("./listItemClasses");
var _listItemClassesDefault = parcelHelpers.interopDefault(_listItemClasses);
parcelHelpers.exportAll(_listItemClasses, exports);
"use client";

},{"./ListItem":"0QHhk","./listItemClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"0QHhk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
parcelHelpers.export(exports, "ListItemRoot", ()=>ListItemRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemClasses = require("./listItemClasses");
var _listItemClassesDefault = parcelHelpers.interopDefault(_listItemClasses);
var _listItemButton = require("../ListItemButton");
var _listItemSecondaryAction = require("../ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className"
], _excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { alignItems, button, classes, dense, disabled, disableGutters, disablePadding, divider, hasSecondaryAction, selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemClasses.getListItemUtilityClass), classes);
};
const ListItemRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, _extendsDefault.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, _listItemButton.listItemButtonClasses).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, _listItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _listItemClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _listItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _listItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _listItemClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const ListItemContainer = (0, _styledDefault.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const ListItem = /*#__PURE__*/ _react.forwardRef(function ListItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems = "center", autoFocus = false, button = false, children: childrenProp, className, component: componentProp, components = {}, componentsProps = {}, ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense = false, disabled = false, disableGutters = false, disablePadding = false, divider = false, focusVisibleClassName, secondaryAction, selected = false, slotProps = {}, slots = {} } = props, ContainerProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.ContainerProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = _react.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, _isMuiElementDefault.default)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems,
        autoFocus,
        button,
        dense: childContext.dense,
        disabled,
        disableGutters,
        disablePadding,
        divider,
        hasSecondaryAction,
        selected
    });
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRefDefault.default)(listItemRef, ref);
    const Root = slots.root || components.Root || ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, rootProps.className, className),
        disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, _clsxDefault.default)((0, _listItemClassesDefault.default).focusVisible, focusVisibleClassName);
        Component = (0, _buttonBaseDefault.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemContainer, (0, _extendsDefault.default)({
                as: ContainerComponent,
                className: (0, _clsxDefault.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _utils.isHostComponent)(Root) && {
                        as: Component,
                        ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, _utils.isHostComponent)(Root) && {
            ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemSecondaryActionDefault.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
exports.default = ListItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","@mui/utils/elementTypeAcceptingRef":"cSxw6","@mui/utils/chainPropTypes":"8qu3z","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../ButtonBase":"1prwn","../utils/isMuiElement":"b7VqP","../utils/useEnhancedEffect":"imwu2","../utils/useForkRef":"5kA2S","../List/ListContext":"74mKH","./listItemClasses":"BcEIu","../ListItemButton":"98VkT","../ListItemSecondaryAction":"fIHMj","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"BcEIu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemUtilityClass", ()=>getListItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItem", slot);
}
const listItemClasses = (0, _generateUtilityClassesDefault.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
exports.default = listItemClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"98VkT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemButtonDefault.default));
parcelHelpers.export(exports, "listItemButtonClasses", ()=>(0, _listItemButtonClassesDefault.default));
var _listItemButton = require("./ListItemButton");
var _listItemButtonDefault = parcelHelpers.interopDefault(_listItemButton);
var _listItemButtonClasses = require("./listItemButtonClasses");
var _listItemButtonClassesDefault = parcelHelpers.interopDefault(_listItemButtonClasses);
parcelHelpers.exportAll(_listItemButtonClasses, exports);
"use client";

},{"./ListItemButton":false,"./listItemButtonClasses":"5mJpr","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5mJpr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemButtonUtilityClass", ()=>getListItemButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemButton", slot);
}
const listItemButtonClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
exports.default = listItemButtonClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fIHMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemSecondaryActionDefault.default));
parcelHelpers.export(exports, "listItemSecondaryActionClasses", ()=>(0, _listItemSecondaryActionClassesDefault.default));
var _listItemSecondaryAction = require("./ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _listItemSecondaryActionClasses = require("./listItemSecondaryActionClasses");
var _listItemSecondaryActionClassesDefault = parcelHelpers.interopDefault(_listItemSecondaryActionClasses);
parcelHelpers.exportAll(_listItemSecondaryActionClasses, exports);
"use client";

},{"./ListItemSecondaryAction":"f9jNK","./listItemSecondaryActionClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f9jNK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemSecondaryActionClasses = require("./listItemSecondaryActionClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { disableGutters, classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemSecondaryActionClasses.getListItemSecondaryActionClassesUtilityClass), classes);
};
const ListItemSecondaryActionRoot = (0, _styledDefault.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const ListItemSecondaryAction = /*#__PURE__*/ _react.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemSecondaryActionRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
exports.default = ListItemSecondaryAction;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../List/ListContext":"74mKH","./listItemSecondaryActionClasses":"ckN6k","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ckN6k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemSecondaryActionClassesUtilityClass", ()=>getListItemSecondaryActionClassesUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiListItemSecondaryAction", slot);
}
const listItemSecondaryActionClasses = (0, _generateUtilityClassesDefault.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
exports.default = listItemSecondaryActionClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4D5Yz":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("27b2404c577e1596");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("55a9743d3da36dc8"));
var _jsxRuntime = require("2ca9b5bc935cb2bf");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), "KeyboardArrowLeft");

},{"27b2404c577e1596":"hykHy","55a9743d3da36dc8":"gQLSP","2ca9b5bc935cb2bf":"g88cO"}],"dvWuD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubPageCard", ()=>SubPageCard);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
const StyledBox = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "featured"
})(({ featured, theme })=>(0, _styles.css)`
    ${featured && {
        margin: `-${theme.spacing(5)} -${theme.spacing(6)} ${theme.spacing(5)}`,
        padding: theme.spacing(5, 6, 4),
        borderRadius: "12px",
        boxShadow: "-20px 4px 40px rgba(34, 47, 63, 0.24)"
    }};
  `);
const StyledCard = (0, _styles.styled)((0, _cardDefault.default), {
    shouldForwardProp: (prop)=>prop !== "featured" && prop !== "noPadding"
})(({ featured, noPadding, theme })=>(0, _styles.css)`
    ${noPadding && {
        "&&": {
            padding: 0
        }
    }}
    ${featured && {
        [theme.breakpoints.up("sm")]: {
            paddingRight: theme.spacing(6),
            paddingLeft: theme.spacing(6)
        }
    }};
  `);
const StyledCardContent = (0, _styles.styled)((0, _cardContentDefault.default), {
    shouldForwardProp: (prop)=>prop !== "noPadding"
})(({ noPadding })=>({
        "&&": noPadding ? {
            padding: 0
        } : {}
    }));
const TitleSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
        variant: "text",
        sx: {
            display: "inline-block",
            width: "100%"
        }
    });
const SubPageCard = ({ children, featured, isLoadingTitle, title, subheader, action, noPadding = false, mainTitle = false })=>{
    const theme = (0, _styles.useTheme)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            isMobile && (title || subheader || action) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    position: "relative",
                    display: "flex",
                    alignItems: "baseline",
                    mb: 4,
                    mx: 4
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: mainTitle ? "h2" : "h3",
                        component: mainTitle ? "h2" : "h3",
                        sx: {
                            display: "inline"
                        },
                        color: theme.palette.layout.titleOnBackground,
                        children: isLoadingTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSkeleton, {}) : title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "subtitle1",
                        sx: {
                            ml: "1ex",
                            display: "inline",
                            fontStyle: "italic"
                        },
                        color: theme.palette.layout.titleOnBackground,
                        children: subheader
                    }),
                    action && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            marginLeft: "auto"
                        },
                        children: action
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCard, {
                featured: featured,
                noPadding: noPadding,
                children: [
                    !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
                        featured: featured,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                            title: isLoadingTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSkeleton, {}) : title,
                            titleTypographyProps: {
                                display: "inline",
                                component: mainTitle ? "h2" : "h3",
                                variant: mainTitle ? "h2" : "h3"
                            },
                            subheader: subheader,
                            subheaderTypographyProps: {
                                display: "inline",
                                marginLeft: "1ex"
                            },
                            action: action
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCardContent, {
                        noPadding: noPadding,
                        children: children
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","@mui/material/Skeleton":"i7d9z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dpqJL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "cardHeaderClasses", ()=>(0, _cardHeaderClassesDefault.default));
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardHeaderClasses = require("./cardHeaderClasses");
var _cardHeaderClassesDefault = parcelHelpers.interopDefault(_cardHeaderClasses);
parcelHelpers.exportAll(_cardHeaderClasses, exports);
"use client";

},{"./CardHeader":"13KoK","./cardHeaderClasses":"bmG78","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"13KoK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _cardHeaderClasses = require("./cardHeaderClasses");
var _cardHeaderClassesDefault = parcelHelpers.interopDefault(_cardHeaderClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardHeaderClasses.getCardHeaderUtilityClass), classes);
};
const CardHeaderRoot = (0, _styledDefault.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, _extendsDefault.default)({
            [`& .${(0, _cardHeaderClassesDefault.default).title}`]: styles.title,
            [`& .${(0, _cardHeaderClassesDefault.default).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const CardHeaderAvatar = (0, _styledDefault.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const CardHeaderAction = (0, _styledDefault.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const CardHeaderContent = (0, _styledDefault.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const CardHeader = /*#__PURE__*/ _react.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action, avatar, className, component = "div", disableTypography = false, subheader: subheaderProp, subheaderTypographyProps, title: titleProp, titleTypographyProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        disableTypography
    });
    const classes = useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, _typographyDefault.default) && !disableTypography) title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, _typographyDefault.default) && !disableTypography) subheader = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CardHeaderRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
exports.default = CardHeader;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../Typography":"f5srd","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./cardHeaderClasses":"bmG78","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bmG78":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardHeaderUtilityClass", ()=>getCardHeaderUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardHeaderUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiCardHeader", slot);
}
const cardHeaderClasses = (0, _generateUtilityClassesDefault.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
exports.default = cardHeaderClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i7d9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _skeletonDefault.default));
parcelHelpers.export(exports, "skeletonClasses", ()=>(0, _skeletonClassesDefault.default));
var _skeleton = require("./Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _skeletonClasses = require("./skeletonClasses");
parcelHelpers.exportAll(_skeletonClasses, exports);
var _skeletonClassesDefault = parcelHelpers.interopDefault(_skeletonClasses);
"use client";

},{"./Skeleton":"inYOf","./skeletonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"inYOf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styles = require("../styles");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _skeletonClasses = require("./skeletonClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let _ = (t)=>t, _t, _t2, _t3, _t4;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, animation, hasChildren, width, height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _skeletonClasses.getSkeletonUtilityClass), classes);
};
const pulseKeyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = (0, _styledDefault.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme, ownerState })=>{
    const radiusUnit = (0, _styles.unstable_getUnit)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, _styles.unstable_toUnitless)(theme.shape.borderRadius);
    return (0, _extendsDefault.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, _styles.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState })=>ownerState.animation === "pulse" && (0, _system.css)(_t3 || (_t3 = _`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({ ownerState, theme })=>ownerState.animation === "wave" && (0, _system.css)(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/ _react.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation = "pulse", className, component = "span", height, style, variant = "text", width } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        animation,
        component,
        variant,
        hasChildren: Boolean(other.children)
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, _extendsDefault.default)({
            width,
            height
        }, style)
    }));
});
exports.default = Skeleton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","clsx":"bGtJT","prop-types":"hRUel","@mui/system":"6hP1D","@mui/utils/composeClasses":"jj3MR","../styles":"51PGx","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./skeletonClasses":"b5g0c","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b5g0c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkeletonUtilityClass", ()=>getSkeletonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSkeletonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiSkeleton", slot);
}
const skeletonClasses = (0, _generateUtilityClassesDefault.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
exports.default = skeletonClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4KkfE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlocksTableType", ()=>BlocksTableType);
var _runtimeBlocks = require("./RuntimeBlocks");
parcelHelpers.exportAll(_runtimeBlocks, exports);
var _consensusBlocks = require("./ConsensusBlocks");
parcelHelpers.exportAll(_consensusBlocks, exports);
var BlocksTableType;
(function(BlocksTableType) {
    BlocksTableType[BlocksTableType["Mobile"] = 0] = "Mobile";
    BlocksTableType[BlocksTableType["DesktopLite"] = 1] = "DesktopLite";
    BlocksTableType[BlocksTableType["Desktop"] = 2] = "Desktop";
})(BlocksTableType || (BlocksTableType = {}));

},{"./RuntimeBlocks":"ffmaz","./ConsensusBlocks":"1ZpvN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ffmaz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBlocks", ()=>RuntimeBlocks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _progressBar = require("../../components/ProgressBar");
var _table = require("../../components/Table");
var _config = require("../../../config");
var _blockLink = require("./BlockLink");
var _useScreensize = require("../../hooks/useScreensize");
var _index = require("./index");
var _age = require("../Age");
const RuntimeBlocks = ({ isLoading, blocks, type = (0, _index.BlocksTableType).Desktop, pagination, limit })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLaptop } = (0, _useScreensize.useScreenSize)();
    const tableColumns = [
        {
            key: "fill",
            content: t("common.fill")
        },
        {
            key: "height",
            content: t("common.height"),
            align: (0, _table.TableCellAlign).Right
        },
        {
            key: "age",
            content: t("common.age"),
            align: (0, _table.TableCellAlign).Right
        },
        ...type === (0, _index.BlocksTableType).Desktop || type === (0, _index.BlocksTableType).DesktopLite ? [
            {
                key: "transaction",
                content: isLaptop ? t("common.transactionAbbreviation") : t("common.transactions"),
                align: (0, _table.TableCellAlign).Right
            }
        ] : [],
        ...type === (0, _index.BlocksTableType).Desktop ? [
            {
                key: "hash",
                content: t("common.hash")
            }
        ] : [],
        {
            key: "size",
            content: t("common.size"),
            align: (0, _table.TableCellAlign).Right
        },
        ...type === (0, _index.BlocksTableType).Desktop ? [
            {
                key: "gasUsed",
                content: t("common.gasUsed"),
                align: (0, _table.TableCellAlign).Right
            }
        ] : [],
        ...type === (0, _index.BlocksTableType).Desktop ? [
            {
                key: "gasLimit",
                content: t("common.gasLimit"),
                align: (0, _table.TableCellAlign).Right
            }
        ] : []
    ];
    const tableRows = blocks?.map((block)=>{
        const blockGasLimit = (0, _config.paraTimesConfig)[block.layer]?.[block.network]?.blockGasLimit;
        if (!blockGasLimit) throw new Error("blockGasLimit is not configured");
        return {
            key: block.hash,
            data: [
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBar.VerticalProgressBar), {
                        value: 100 * block.gas_used / blockGasLimit
                    }),
                    key: "fill"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: block,
                        height: block.round
                    }),
                    key: "block"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _age.Age), {
                        sinceTimestamp: block.timestamp
                    }),
                    key: "timestamp"
                },
                ...type === (0, _index.BlocksTableType).Desktop || type === (0, _index.BlocksTableType).DesktopLite ? [
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: block.num_transactions.toLocaleString(),
                        key: "txs"
                    }
                ] : [],
                ...type === (0, _index.BlocksTableType).Desktop ? [
                    {
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockHashLink), {
                            scope: block,
                            hash: block.hash,
                            height: block.round
                        }),
                        key: "hash"
                    }
                ] : [],
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: t("common.bytes", {
                        value: block.size,
                        formatParams: {
                            value: {
                                style: "unit",
                                unit: "byte",
                                unitDisplay: "long"
                            }
                        }
                    }),
                    key: "size"
                },
                ...type === (0, _index.BlocksTableType).Desktop ? [
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: block.gas_used.toLocaleString(),
                        key: "gasUsed"
                    }
                ] : [],
                ...type === (0, _index.BlocksTableType).Desktop ? [
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: blockGasLimit.toLocaleString(),
                        key: "gasLimit"
                    }
                ] : []
            ],
            highlight: block.markAsNew
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("blocks.latest"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/ProgressBar":"5Dj8t","../../components/Table":"j3qb1","../../../config":"2PXMY","./BlockLink":"g8oEe","../../hooks/useScreensize":"2HEhN","./index":"4KkfE","../Age":"eWnEg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5Dj8t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalProgressBar", ()=>VerticalProgressBar);
parcelHelpers.export(exports, "ProgressBar", ()=>ProgressBar);
parcelHelpers.export(exports, "BrandProgressBar", ()=>BrandProgressBar);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _linearProgress = require("@mui/material/LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _styles = require("@mui/material/styles");
var _colors = require("styles/theme/colors");
const barSize = 36;
const VerticalProgressBar = ({ value })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            width: barSize,
            height: barSize,
            transform: "rotate(-90deg)"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLinearProgress, {
            variant: "determinate",
            value: value
        })
    });
};
const StyledLinearProgress = (0, _styles.styled)((0, _linearProgressDefault.default))(()=>({
        [`&.${(0, _linearProgress.linearProgressClasses).determinate} > .${(0, _linearProgress.linearProgressClasses).bar1Determinate}`]: {
            backgroundColor: (0, _colors.COLORS).brandDark
        },
        height: barSize,
        width: barSize
    }));
const ProgressBar = (0, _styles.styled)((0, _linearProgressDefault.default))(()=>({
        [`&.${(0, _linearProgress.linearProgressClasses).determinate} > .${(0, _linearProgress.linearProgressClasses).bar1Determinate}`]: {
            backgroundColor: (0, _colors.COLORS).eucalyptus
        },
        borderColor: (0, _colors.COLORS).eucalyptus,
        backgroundColor: (0, _colors.COLORS).honeydew,
        height: "12px",
        width: "85px"
    }));
const BrandProgressBar = (0, _styles.styled)((0, _linearProgressDefault.default))(()=>({
        [`&.${(0, _linearProgress.linearProgressClasses).determinate} > .${(0, _linearProgress.linearProgressClasses).bar1Determinate}`]: {
            backgroundColor: (0, _colors.COLORS).brandDark
        },
        borderColor: (0, _colors.COLORS).grayLight,
        backgroundColor: (0, _colors.COLORS).grayLight,
        height: "12px"
    }));

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/LinearProgress":"k46OB","@mui/material/styles":"51PGx","styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j3qb1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableCellAlign", ()=>TableCellAlign);
parcelHelpers.export(exports, "Table", ()=>Table);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _useScreensize = require("../../hooks/useScreensize");
var _colors = require("../../../styles/theme/colors");
var _tablePagination = require("./TablePagination");
var _animations = require("../../../styles/theme/animations");
// in designs table row has 61px height, but we need to take into account border and padding here
const textSkeletonHeight = 28;
const SkeletonTableRows = ({ rowsNumber, columnsNumber })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: [
            ...Array(rowsNumber)
        ].map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    colSpan: columnsNumber,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                        variant: "text",
                        height: textSkeletonHeight
                    })
                })
            }, index))
    });
const StyledTableRow = (0, _styles.styled)((0, _tableRowDefault.default), {
    shouldForwardProp: (prop)=>prop !== "highlight"
})(({ highlight })=>({
        ...highlight && (0, _animations.backgroundColorAnimation)
    }));
var TableCellAlign;
(function(TableCellAlign) {
    TableCellAlign["Center"] = "center";
    TableCellAlign["Left"] = "left";
    TableCellAlign["Right"] = "right";
})(TableCellAlign || (TableCellAlign = {}));
const stickyColumnStyles = {
    position: "sticky",
    left: 0,
    backgroundColor: (0, _colors.COLORS).antiFlashWhite,
    zIndex: 1
};
const extraHorizontalPaddingStyles = {
    px: 4
};
const Table = ({ columns, isLoading, name, pagination, rows, rowsNumber = 5, stickyColumn = false, extraHorizontalSpaceOnMobile = false, alwaysWaitWhileLoading = false })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (!isLoading && !rows?.length) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                    "aria-label": name,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
                                children: columns.map((column, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                        align: column.align,
                                        sx: {
                                            width: column.width || "auto",
                                            ...stickyColumn && !index && isMobile ? stickyColumnStyles : {}
                                        },
                                        children: column.content
                                    }, column.key))
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableBodyDefault.default), {
                            children: [
                                (alwaysWaitWhileLoading || !rows) && isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonTableRows, {
                                    rowsNumber: rowsNumber,
                                    columnsNumber: columns.length
                                }),
                                rows?.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableRow, {
                                        highlight: row.highlight,
                                        children: row.data.map((cell, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                align: cell.align,
                                                sx: {
                                                    ...stickyColumn && !index && isMobile ? stickyColumnStyles : {},
                                                    ...extraHorizontalSpaceOnMobile && isMobile ? extraHorizontalPaddingStyles : {}
                                                },
                                                children: cell.content
                                            }, cell.key))
                                    }, row.key))
                            ]
                        })
                    ]
                })
            }),
            pagination && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablePagination.TablePagination), {
                    ...pagination
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","@mui/material/Skeleton":"i7d9z","@mui/material/TableContainer":"4v1O8","@mui/material/Table":"7XUZM","@mui/material/TableHead":"9JUxY","@mui/material/TableBody":"1L7nL","@mui/material/TableRow":"2fJxU","@mui/material/TableCell":"7tad7","../../hooks/useScreensize":"2HEhN","../../../styles/theme/colors":"hYvW2","./TablePagination":"davz5","../../../styles/theme/animations":"aWqrd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4v1O8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableContainerDefault.default));
parcelHelpers.export(exports, "tableContainerClasses", ()=>(0, _tableContainerClassesDefault.default));
var _tableContainer = require("./TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableContainerClasses = require("./tableContainerClasses");
var _tableContainerClassesDefault = parcelHelpers.interopDefault(_tableContainerClasses);
parcelHelpers.exportAll(_tableContainerClasses, exports);
"use client";

},{"./TableContainer":"8fHcq","./tableContainerClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8fHcq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableContainerClasses = require("./tableContainerClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableContainerClasses.getTableContainerUtilityClass), classes);
};
const TableContainerRoot = (0, _styledDefault.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const TableContainer = /*#__PURE__*/ _react.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className, component = "div" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableContainerRoot, (0, _extendsDefault.default)({
        ref: ref,
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
exports.default = TableContainer;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tableContainerClasses":"gcptk","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gcptk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableContainerUtilityClass", ()=>getTableContainerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableContainerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTableContainer", slot);
}
const tableContainerClasses = (0, _generateUtilityClassesDefault.default)("MuiTableContainer", [
    "root"
]);
exports.default = tableContainerClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7XUZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "tableClasses", ()=>(0, _tableClassesDefault.default));
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableClasses = require("./tableClasses");
var _tableClassesDefault = parcelHelpers.interopDefault(_tableClasses);
parcelHelpers.exportAll(_tableClasses, exports);
"use client";

},{"./Table":"Rztun","./tableClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"Rztun":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _tableContext = require("./TableContext");
var _tableContextDefault = parcelHelpers.interopDefault(_tableContext);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableClasses = require("./tableClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableClasses.getTableUtilityClass), classes);
};
const TableRoot = (0, _styledDefault.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, _extendsDefault.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const defaultComponent = "table";
const Table = /*#__PURE__*/ _react.forwardRef(function Table(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className, component = defaultComponent, padding = "normal", size = "medium", stickyHeader = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        padding,
        size,
        stickyHeader
    });
    const classes = useUtilityClasses(ownerState);
    const table = _react.useMemo(()=>({
            padding,
            size,
            stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContextDefault.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableRoot, (0, _extendsDefault.default)({
            as: component,
            role: component === defaultComponent ? null : "table",
            ref: ref,
            className: (0, _clsxDefault.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
exports.default = Table;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","./TableContext":"iY8U5","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tableClasses":"c2UUU","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iY8U5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 */ const TableContext = /*#__PURE__*/ _react.createContext();
exports.default = TableContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c2UUU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableUtilityClass", ()=>getTableUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTable", slot);
}
const tableClasses = (0, _generateUtilityClassesDefault.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
exports.default = tableClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9JUxY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableHeadDefault.default));
parcelHelpers.export(exports, "tableHeadClasses", ()=>(0, _tableHeadClassesDefault.default));
var _tableHead = require("./TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableHeadClasses = require("./tableHeadClasses");
var _tableHeadClassesDefault = parcelHelpers.interopDefault(_tableHeadClasses);
parcelHelpers.exportAll(_tableHeadClasses, exports);
"use client";

},{"./TableHead":"c268b","./tableHeadClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c268b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableHeadClasses = require("./tableHeadClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableHeadClasses.getTableHeadUtilityClass), classes);
};
const TableHeadRoot = (0, _styledDefault.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const tablelvl2 = {
    variant: "head"
};
const defaultComponent = "thead";
const TableHead = /*#__PURE__*/ _react.forwardRef(function TableHead(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className, component = defaultComponent } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablelvl2ContextDefault.default).Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableHeadRoot, (0, _extendsDefault.default)({
            as: component,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref,
            role: component === defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
exports.default = TableHead;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../Table/Tablelvl2Context":"l5Ar4","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tableHeadClasses":"efDsV","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l5Ar4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const Tablelvl2Context = /*#__PURE__*/ _react.createContext();
exports.default = Tablelvl2Context;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"efDsV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableHeadUtilityClass", ()=>getTableHeadUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableHeadUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTableHead", slot);
}
const tableHeadClasses = (0, _generateUtilityClassesDefault.default)("MuiTableHead", [
    "root"
]);
exports.default = tableHeadClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1L7nL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableBodyDefault.default));
parcelHelpers.export(exports, "tableBodyClasses", ()=>(0, _tableBodyClassesDefault.default));
var _tableBody = require("./TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableBodyClasses = require("./tableBodyClasses");
var _tableBodyClassesDefault = parcelHelpers.interopDefault(_tableBodyClasses);
parcelHelpers.exportAll(_tableBodyClasses, exports);
"use client";

},{"./TableBody":"726O8","./tableBodyClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"726O8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableBodyClasses = require("./tableBodyClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableBodyClasses.getTableBodyUtilityClass), classes);
};
const TableBodyRoot = (0, _styledDefault.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const tablelvl2 = {
    variant: "body"
};
const defaultComponent = "tbody";
const TableBody = /*#__PURE__*/ _react.forwardRef(function TableBody(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className, component = defaultComponent } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablelvl2ContextDefault.default).Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableBodyRoot, (0, _extendsDefault.default)({
            className: (0, _clsxDefault.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
exports.default = TableBody;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","../Table/Tablelvl2Context":"l5Ar4","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tableBodyClasses":"99r9R","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"99r9R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableBodyUtilityClass", ()=>getTableBodyUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableBodyUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTableBody", slot);
}
const tableBodyClasses = (0, _generateUtilityClassesDefault.default)("MuiTableBody", [
    "root"
]);
exports.default = tableBodyClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2fJxU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableRowDefault.default));
parcelHelpers.export(exports, "tableRowClasses", ()=>(0, _tableRowClassesDefault.default));
var _tableRow = require("./TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableRowClasses = require("./tableRowClasses");
var _tableRowClassesDefault = parcelHelpers.interopDefault(_tableRowClasses);
parcelHelpers.exportAll(_tableRowClasses, exports);
"use client";

},{"./TableRow":"acsB4","./tableRowClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"acsB4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableRowClasses = require("./tableRowClasses");
var _tableRowClassesDefault = parcelHelpers.interopDefault(_tableRowClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, selected, hover, head, footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableRowClasses.getTableRowUtilityClass), classes);
};
const TableRowRoot = (0, _styledDefault.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, _tableRowClassesDefault.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, _tableRowClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const TableRow = /*#__PURE__*/ _react.forwardRef(function TableRow(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className, component = defaultComponent, hover = false, selected = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const tablelvl2 = _react.useContext((0, _tablelvl2ContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        hover,
        selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableRowRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        role: component === defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
exports.default = TableRow;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../Table/Tablelvl2Context":"l5Ar4","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tableRowClasses":"5MAQo","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5MAQo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableRowUtilityClass", ()=>getTableRowUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableRowUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTableRow", slot);
}
const tableRowClasses = (0, _generateUtilityClassesDefault.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
exports.default = tableRowClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7tad7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableCellDefault.default));
parcelHelpers.export(exports, "tableCellClasses", ()=>(0, _tableCellClassesDefault.default));
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableCellClasses = require("./tableCellClasses");
var _tableCellClassesDefault = parcelHelpers.interopDefault(_tableCellClasses);
parcelHelpers.exportAll(_tableCellClasses, exports);
"use client";

},{"./TableCell":"bijyL","./tableCellClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bijyL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _tableContext = require("../Table/TableContext");
var _tableContextDefault = parcelHelpers.interopDefault(_tableContext);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableCellClasses = require("./tableCellClasses");
var _tableCellClassesDefault = parcelHelpers.interopDefault(_tableCellClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, align, padding, size, stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, _capitalizeDefault.default)(align)}`,
            padding !== "normal" && `padding${(0, _capitalizeDefault.default)(padding)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableCellClasses.getTableCellUtilityClass), classes);
};
const TableCellRoot = (0, _styledDefault.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, _capitalizeDefault.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, _capitalizeDefault.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, _colorManipulator.lighten)((0, _colorManipulator.alpha)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, _tableCellClassesDefault.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const TableCell = /*#__PURE__*/ _react.forwardRef(function TableCell(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align = "inherit", className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection, variant: variantProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const table = _react.useContext((0, _tableContextDefault.default));
    const tablelvl2 = _react.useContext((0, _tablelvl2ContextDefault.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        align,
        component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCellRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
exports.default = TableCell;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../utils/capitalize":"iHgWG","../Table/TableContext":"iY8U5","../Table/Tablelvl2Context":"l5Ar4","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tableCellClasses":"h2B7D","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h2B7D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableCellUtilityClass", ()=>getTableCellUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableCellUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTableCell", slot);
}
const tableCellClasses = (0, _generateUtilityClassesDefault.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
exports.default = tableCellClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"davz5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TablePagination", ()=>TablePagination);
var _jsxRuntime = require("react/jsx-runtime");
var _pagination = require("@mui/material/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationItem = require("@mui/material/PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
const TablePagination = ({ selectedPage, linkToPage, rowsPerPage, totalCount, isTotalCountClipped })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!totalCount) return null;
    const totalCountBoundary = totalCount + (selectedPage - 1) * rowsPerPage;
    const numberOfPages = Math.ceil(totalCountBoundary / rowsPerPage);
    if (numberOfPages <= 1) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
        count: numberOfPages,
        page: selectedPage,
        renderItem: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationItemDefault.default), {
                slots: {
                    first: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: t("pagination.first")
                        }),
                    last: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: isTotalCountClipped ? "\u2026" : t("pagination.last")
                        })
                },
                component: (0, _reactRouterDom.Link),
                to: item.page == null ? "" : linkToPage(item.page),
                preventScrollReset: true,
                ...item,
                sx: isTotalCountClipped && item.type === "last" ? {
                    pointerEvents: "none",
                    cursor: "default"
                } : {}
            }),
        showFirstButton: true,
        showLastButton: true,
        size: "small",
        sx: {
            marginTop: 5
        }
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Pagination":"foWEw","@mui/material/PaginationItem":"gONMy","react-i18next":"e210a","react-router-dom":"5o0mA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"foWEw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "paginationClasses", ()=>(0, _paginationClassesDefault.default));
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationClasses = require("./paginationClasses");
var _paginationClassesDefault = parcelHelpers.interopDefault(_paginationClasses);
parcelHelpers.exportAll(_paginationClasses, exports);
"use client";

},{"./Pagination":"hX54Y","./paginationClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hX54Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _paginationClasses = require("./paginationClasses");
var _usePagination = require("../usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
var _paginationItem = require("../PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paginationClasses.getPaginationUtilityClass), classes);
};
const PaginationRoot = (0, _styledDefault.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const PaginationUl = (0, _styledDefault.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const Pagination = /*#__PURE__*/ _react.forwardRef(function Pagination(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount = 1, className, color = "standard", count = 1, defaultPage = 1, disabled = false, getItemAriaLabel = defaultGetAriaLabel, hideNextButton = false, hidePrevButton = false, renderItem = (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationItemDefault.default), (0, _extendsDefault.default)({}, item)), shape = "circular", showFirstButton = false, showLastButton = false, siblingCount = 1, size = "medium", variant = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { items } = (0, _usePaginationDefault.default)((0, _extendsDefault.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        boundaryCount,
        color,
        count,
        defaultPage,
        disabled,
        getItemAriaLabel,
        hideNextButton,
        hidePrevButton,
        renderItem,
        shape,
        showFirstButton,
        showLastButton,
        siblingCount,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationRoot, (0, _extendsDefault.default)({
        "aria-label": "pagination navigation",
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    children: renderItem((0, _extendsDefault.default)({}, item, {
                        color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape,
                        size,
                        variant
                    }))
                }, index))
        })
    }));
});
exports.default = Pagination;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/utils/integerPropType":"3uD7f","../styles/useThemeProps":"e7SGa","./paginationClasses":"9ep1j","../usePagination":"cdDTL","../PaginationItem":"gONMy","../styles/styled":"axRcE","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9ep1j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaginationUtilityClass", ()=>getPaginationUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaginationUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPagination", slot);
}
const paginationClasses = (0, _generateUtilityClassesDefault.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
exports.default = paginationClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cdDTL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _usePaginationDefault.default));
var _usePagination = require("./usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
"use client";

},{"./usePagination":"6JLiS","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6JLiS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePagination);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
"use client";
const _excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function usePagination(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount = 1, componentName = "usePagination", count = 1, defaultPage = 1, disabled = false, hideNextButton = false, hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton = false, showLastButton = false, siblingCount = 1 } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [page, setPageState] = (0, _useControlledDefault.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, _extendsDefault.default)({
        items
    }, other);
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@mui/utils/useControlled":"9keef","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gONMy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationItemDefault.default));
parcelHelpers.export(exports, "paginationItemClasses", ()=>(0, _paginationItemClassesDefault.default));
var _paginationItem = require("./PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _paginationItemClasses = require("./paginationItemClasses");
var _paginationItemClassesDefault = parcelHelpers.interopDefault(_paginationItemClasses);
parcelHelpers.exportAll(_paginationItemClasses, exports);
"use client";

},{"./PaginationItem":"gkkYj","./paginationItemClasses":"eXOi7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gkkYj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _rtlProvider = require("@mui/system/RtlProvider");
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _paginationItemClasses = require("./paginationItemClasses");
var _paginationItemClassesDefault = parcelHelpers.interopDefault(_paginationItemClasses);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _firstPage = require("../internal/svg-icons/FirstPage");
var _firstPageDefault = parcelHelpers.interopDefault(_firstPage);
var _lastPage = require("../internal/svg-icons/LastPage");
var _lastPageDefault = parcelHelpers.interopDefault(_lastPage);
var _navigateBefore = require("../internal/svg-icons/NavigateBefore");
var _navigateBeforeDefault = parcelHelpers.interopDefault(_navigateBefore);
var _navigateNext = require("../internal/svg-icons/NavigateNext");
var _navigateNextDefault = parcelHelpers.interopDefault(_navigateNext);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, selected, size, shape, type, variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, _capitalizeDefault.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, _capitalizeDefault.default)(color)}`,
            color !== "standard" && `${variant}${(0, _capitalizeDefault.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paginationItemClasses.getPaginationItemUtilityClass), classes);
};
const PaginationItemEllipsis = (0, _styledDefault.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const PaginationItemPage = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === "text" && {
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: (0, _extendsDefault.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: (0, _extendsDefault.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const PaginationItemPageIcon = (0, _styledDefault.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const PaginationItem = /*#__PURE__*/ _react.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className, color = "standard", component, components = {}, disabled = false, page, selected = false, shape = "circular", size = "medium", slots = {}, type = "page", variant = "text" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        disabled,
        selected,
        shape,
        size,
        type,
        variant
    });
    const isRtl = (0, _rtlProvider.useRtl)();
    const classes = useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, _navigateNextDefault.default),
        next: slots.previous || components.previous || (0, _navigateBeforeDefault.default),
        last: slots.first || components.first || (0, _firstPageDefault.default),
        first: slots.last || components.last || (0, _lastPageDefault.default)
    } : {
        previous: slots.previous || components.previous || (0, _navigateBeforeDefault.default),
        next: slots.next || components.next || (0, _navigateNextDefault.default),
        first: slots.first || components.first || (0, _firstPageDefault.default),
        last: slots.last || components.last || (0, _lastPageDefault.default)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaginationItemPage, (0, _extendsDefault.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
exports.default = PaginationItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","@mui/system/RtlProvider":"jz0y0","../styles/useThemeProps":"e7SGa","./paginationItemClasses":"eXOi7","../ButtonBase":"1prwn","../utils/capitalize":"iHgWG","../internal/svg-icons/FirstPage":"8Xsi8","../internal/svg-icons/LastPage":"89EPg","../internal/svg-icons/NavigateBefore":"3g00q","../internal/svg-icons/NavigateNext":"l3VpW","../styles/styled":"axRcE","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eXOi7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaginationItemUtilityClass", ()=>getPaginationItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaginationItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiPaginationItem", slot);
}
const paginationItemClasses = (0, _generateUtilityClassesDefault.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
exports.default = paginationItemClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8Xsi8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"89EPg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3g00q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l3VpW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aWqrd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backgroundColorAnimation", ()=>backgroundColorAnimation);
var _styles = require("@mui/material/styles");
var _colors = require("./colors");
var _config = require("../../app/config");
const backgroundColorKeyframes = (0, _styles.keyframes)`
  0% {
    background-color: ${(0, _colors.COLORS).white}
  }
  20% {
    background-color: ${(0, _colors.COLORS).lightGreen}
  }
  80% {
    background-color: ${(0, _colors.COLORS).lightGreen}
  }
  100% {
    background-color: ${(0, _colors.COLORS).white}
  }
`;
const backgroundColorAnimationDuration = `${Math.max(500, (0, _config.REFETCH_INTERVAL) - 2000)}ms`;
const backgroundColorAnimation = {
    animationName: backgroundColorKeyframes,
    animationDuration: backgroundColorAnimationDuration,
    animationIterationCount: 1,
    animationTimingFunction: "ease-in-out"
};

},{"@mui/material/styles":"51PGx","./colors":"hYvW2","../../app/config":"in6G4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"in6G4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NUMBER_OF_ITEMS_ON_DASHBOARD", ()=>NUMBER_OF_ITEMS_ON_DASHBOARD);
parcelHelpers.export(exports, "NUMBER_OF_ITEMS_ON_SEPARATE_PAGE", ()=>NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
parcelHelpers.export(exports, "REFETCH_INTERVAL", ()=>REFETCH_INTERVAL);
parcelHelpers.export(exports, "API_MAX_TOTAL_COUNT", ()=>API_MAX_TOTAL_COUNT);
const NUMBER_OF_ITEMS_ON_DASHBOARD = 5;
const NUMBER_OF_ITEMS_ON_SEPARATE_PAGE = 10;
const REFETCH_INTERVAL = 5000;
const API_MAX_TOTAL_COUNT = 1000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g8oEe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockLink", ()=>BlockLink);
parcelHelpers.export(exports, "BlockHashLink", ()=>BlockHashLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routeUtils = require("../../utils/route-utils");
var _trimLinkLabel = require("../TrimLinkLabel");
var _useScreensize = require("../../hooks/useScreensize");
var _adaptiveTrimmer = require("../AdaptiveTrimmer/AdaptiveTrimmer");
const BlockLink = ({ scope, height })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: (0, _routeUtils.RouteUtils).getBlockRoute(scope, height),
            children: height.toLocaleString()
        })
    });
const BlockHashLink = ({ scope, hash, height, alwaysTrim })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const to = (0, _routeUtils.RouteUtils).getBlockRoute(scope, height);
    if (alwaysTrim) // Table view
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trimLinkLabel.TrimLinkLabel), {
            label: hash,
            to: to
        })
    });
    if (!isTablet) // Desktop view
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: to,
            children: hash
        })
    });
    // Mobile view
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        sx: {
            maxWidth: "100%",
            overflowX: "hidden"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: to,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adaptiveTrimmer.AdaptiveTrimmer), {
                text: hash,
                strategy: "middle"
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Typography":"f5srd","@mui/material/Link":"fTbCF","../../utils/route-utils":"b2kKi","../TrimLinkLabel":"it9ks","../../hooks/useScreensize":"2HEhN","../AdaptiveTrimmer/AdaptiveTrimmer":"5yrqk","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"it9ks":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrimLinkLabel", ()=>TrimLinkLabel);
parcelHelpers.export(exports, "TrimEndLinkLabel", ()=>TrimEndLinkLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _trimLongString = require("../../utils/trimLongString");
var _theme = require("../../../styles/theme");
var _highlightedTrimmedText = require("../HighlightedText/HighlightedTrimmedText");
const TrimLinkLabel = ({ label, to })=>{
    const trimmedLabel = (0, _trimLongString.trimLongString)(label);
    if (!trimmedLabel) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrimLink, {
        label: label,
        to: to,
        trimmedLabel: trimmedLabel
    });
};
const TrimEndLinkLabel = ({ label, to, trimStart, highlightedPart })=>{
    const trimmedLabel = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedTrimmedText.HighlightedTrimmedText), {
        text: label,
        pattern: highlightedPart,
        fragmentLength: trimStart
    });
    if (!trimmedLabel) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrimLink, {
        label: label,
        to: to,
        trimmedLabel: trimmedLabel
    });
};
const TrimLink = ({ label, to, trimmedLabel })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: label,
        enterDelay: (0, _theme.tooltipDelay),
        enterNextDelay: (0, _theme.tooltipDelay),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: to,
            children: trimmedLabel
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","@mui/material/Tooltip":"3RLHy","../../utils/trimLongString":"jHX4k","../../../styles/theme":"i3yrR","../HighlightedText/HighlightedTrimmedText":"01WK8","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jHX4k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trimLongString", ()=>trimLongString);
function trimLongString(value, trimStart = 6, trimEnd = 6, ellipsis = "\u2026") {
    if (!value) return;
    const trimmedLength = trimStart + ellipsis.length + trimEnd;
    if (trimmedLength > value.length) return value;
    return `${value.slice(0, trimStart)}${ellipsis}${trimEnd ? value.slice(-trimEnd) : ""}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"01WK8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HighlightedTrimmedText", ()=>HighlightedTrimmedText);
var _jsxRuntime = require("react/jsx-runtime");
var _index = require("./index");
var _textTrimming = require("./text-trimming");
const HighlightedTrimmedText = (props)=>{
    const { text, pattern, fragmentLength, options } = props;
    const { part, match } = (0, _textTrimming.trimAroundMatch)(text, pattern, {
        fragmentLength
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.HighlightedText), {
        text: part,
        pattern: pattern,
        part: match,
        options: options
    });
};

},{"react/jsx-runtime":"g88cO","./index":"hpIrd","./text-trimming":"dTsKd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hpIrd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HighlightedText", ()=>HighlightedText);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _textMatching = require("./text-matching");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const defaultHighlightStyle = {
    background: "#FFFF5480",
    padding: "4px",
    margin: "-4px"
};
const defaultHighlight = {
    sx: defaultHighlightStyle
};
const HighlightedText = ({ text, pattern, part, options = defaultHighlight })=>{
    const { sx = defaultHighlightStyle, findOptions = {} } = options;
    // Have we been told what to highlight exactly? If not, look for the pattern
    const task = part ?? (0, _textMatching.findTextMatch)(text, [
        pattern
    ], findOptions);
    if (text === undefined) return undefined // Nothing to display
    ;
    if (task === (0, _textMatching.NO_MATCH)) return text // We don't have to highlight anything
    ;
    const beginning = text.substring(0, task.startPos);
    const focus = text.substring(task.startPos, task.endPos);
    const end = text.substring(task.endPos);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            beginning,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                component: "mark",
                sx: sx,
                children: focus
            }),
            end
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","./text-matching":"aii9s","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aii9s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NO_MATCH", ()=>NO_MATCH);
parcelHelpers.export(exports, "findTextMatch", ()=>findTextMatch);
parcelHelpers.export(exports, "hasTextMatch", ()=>hasTextMatch);
var _textNormalization = require("./text-normalization");
const NO_MATCH = "NO_MATCH";
const findTextMatch = (rawCorpus, search, options = {})=>{
    const normalizedCorpus = (0, _textNormalization.normalizeTextForSearch)(rawCorpus || "", options);
    const matches = search.filter((s)=>!!s).map((rawPattern)=>{
        const normalizedPattern = (0, _textNormalization.normalizeTextForSearch)(rawPattern, options);
        const matchStart = normalizedCorpus.indexOf(normalizedPattern);
        return matchStart !== -1 ? {
            startPos: matchStart,
            endPos: matchStart + rawPattern.length
        } : "NO_MATCH";
    }).filter((m)=>m !== NO_MATCH);
    return matches[0] ?? NO_MATCH;
};
const hasTextMatch = (rawCorpus, search, options = {})=>findTextMatch(rawCorpus, search, options) !== NO_MATCH;

},{"./text-normalization":"5isSW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5isSW":[function(require,module,exports) {
/**
 * Options for doing text search
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeTextForSearch", ()=>normalizeTextForSearch);
const normalizeTextForSearch = (text, options = {})=>{
    const { caseSensitive = false, diacriticSensitive = false } = options;
    const stage1 = diacriticSensitive ? text : text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return caseSensitive ? stage1 : stage1.toLowerCase();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dTsKd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a part of the corpus that contains the match to the pattern, if any
 *
 * If the corpus is undefined or empty, undefined is returned.
 *
 * If either the pattern is undefined or empty, or there is no match,
 * an adequately sized part from the beginning of the corpus is returned.
 *
 * If there is a match, but the corpus is at most as long as the desired fragment length,
 * the whole corpus is returned.
 *
 * If there is a match, and the corpus is longer than the desired fragment length,
 * then a part of a corpus is returned, so that the match is within the returned part,
 * around the middle.
 */ parcelHelpers.export(exports, "trimAroundMatch", ()=>trimAroundMatch);
var _textMatching = require("./text-matching");
function trimAroundMatch(corpus, pattern, options = {}) {
    const { fragmentLength = 80, ...matchOptions } = options;
    if (!corpus) // there is nothing to see here
    return {
        part: undefined,
        match: (0, _textMatching.NO_MATCH)
    };
    // do we have a match?
    const match = pattern ? (0, _textMatching.findTextMatch)(corpus, [
        pattern
    ], matchOptions) : (0, _textMatching.NO_MATCH);
    if (corpus.length <= fragmentLength) // the whole corpus fits into the max size, no need to cut.
    return {
        part: corpus,
        match
    };
    // how much extra space do we have?
    const buffer = fragmentLength - (pattern || "").length;
    const matchStart = match === (0, _textMatching.NO_MATCH) ? 0 : match.startPos;
    // We will start before the start of the match, by buffer / 2 chars
    const startPos = Math.max(Math.min(matchStart - Math.floor(buffer / 2), corpus.length - fragmentLength), 0);
    const endPos = Math.min(startPos + fragmentLength, corpus.length);
    // Do the trimming
    const prefix = startPos ? "\u2026" : "";
    const postFix = endPos < corpus.length - 1 ? "\u2026" : "";
    const part = prefix + corpus.substring(startPos, endPos) + postFix;
    // compile the result
    return {
        part,
        match: match === (0, _textMatching.NO_MATCH) ? (0, _textMatching.NO_MATCH) : {
            startPos: Math.max(0, matchStart - startPos + prefix.length),
            endPos: Math.min(part.length, match.endPos - startPos + prefix.length)
        }
    };
}

},{"./text-matching":"aii9s","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5yrqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveTrimmer", ()=>AdaptiveTrimmer);
var _jsxRuntime = require("react/jsx-runtime");
var _adaptiveDynamicTrimmer = require("./AdaptiveDynamicTrimmer");
var _trimLongString = require("app/utils/trimLongString");
const AdaptiveTrimmer = ({ text = "", strategy = "end", extraTooltip })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adaptiveDynamicTrimmer.AdaptiveDynamicTrimmer), {
        getFullContent: ()=>({
                content: text,
                length: text.length
            }),
        getShortenedContent: (length)=>strategy === "middle" ? (0, _trimLongString.trimLongString)(text, Math.floor(length / 2) - 1, Math.floor(length / 2) - 1) : (0, _trimLongString.trimLongString)(text, length, 0),
        extraTooltip: extraTooltip
    });

},{"react/jsx-runtime":"g88cO","./AdaptiveDynamicTrimmer":"cmh8D","app/utils/trimLongString":"jHX4k","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cmh8D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdaptiveDynamicTrimmer", ()=>AdaptiveDynamicTrimmer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _maybeWithTooltip = require("./MaybeWithTooltip");
const AdaptiveDynamicTrimmer = ({ getFullContent, getShortenedContent, extraTooltip })=>{
    // Initial setup
    const textRef = (0, _react.useRef)(null);
    const { content: fullContent, length: fullLength } = getFullContent();
    // Data about the currently rendered version
    const [currentContent, setCurrentContent] = (0, _react.useState)();
    const [currentLength, setCurrentLength] = (0, _react.useState)(0);
    // Known good - this fits
    const [largestKnownGood, setLargestKnownGood] = (0, _react.useState)(0);
    // Known bad - this doesn't fit
    const [smallestKnownBad, setSmallestKnownBad] = (0, _react.useState)(fullLength + 1);
    // Are we exploring our possibilities now?
    const [inDiscovery, setInDiscovery] = (0, _react.useState)(false);
    const attemptContent = (0, _react.useCallback)((content, length)=>{
        setCurrentContent(content);
        setCurrentLength(length);
    }, []);
    const attemptShortenedContent = (0, _react.useCallback)((length)=>{
        const content = getShortenedContent(length);
        attemptContent(content, length);
    }, [
        attemptContent,
        getShortenedContent
    ]);
    const initDiscovery = (0, _react.useCallback)(()=>{
        setLargestKnownGood(0);
        setSmallestKnownBad(fullLength + 1);
        attemptContent(fullContent, fullLength);
        setInDiscovery(true);
    }, [
        fullContent,
        fullLength,
        attemptContent
    ]);
    (0, _react.useEffect)(()=>{
        initDiscovery();
        const handleResize = ()=>{
            initDiscovery();
        };
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        initDiscovery
    ]);
    (0, _react.useEffect)(()=>{
        if (inDiscovery) {
            if (!textRef.current) return;
            const isOverflow = textRef.current.scrollWidth > textRef.current.clientWidth;
            if (isOverflow) {
                // This is too much
                // Update known bad length
                const newSmallestKnownBad = Math.min(currentLength, smallestKnownBad);
                setSmallestKnownBad(newSmallestKnownBad);
                // We should try something smaller
                attemptShortenedContent(Math.floor((largestKnownGood + newSmallestKnownBad) / 2));
            } else {
                // This is OK
                // Update known good length
                const newLargestKnownGood = Math.max(currentLength, largestKnownGood);
                setLargestKnownGood(currentLength);
                if (currentLength === fullLength) // The whole thing fits, so we are good.
                setInDiscovery(false);
                else if (currentLength + 1 === smallestKnownBad) // This the best we can do, for now
                setInDiscovery(false);
                else // So far, so good, but we should try something longer
                attemptShortenedContent(Math.floor((newLargestKnownGood + smallestKnownBad) / 2));
            }
        }
    }, [
        attemptShortenedContent,
        currentLength,
        fullContent,
        fullLength,
        inDiscovery,
        initDiscovery,
        largestKnownGood,
        smallestKnownBad
    ]);
    const title = currentLength !== fullLength ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: fullContent
            }),
            extraTooltip && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 2
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {}),
                    extraTooltip
                ]
            })
        ]
    }) : extraTooltip;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        ref: textRef,
        sx: {
            overflow: "hidden",
            maxWidth: "100%",
            textWrap: "nowrap"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maybeWithTooltip.MaybeWithTooltip), {
            title: title,
            spanSx: {
                whiteSpace: "nowrap"
            },
            children: currentContent
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","@mui/material/Box":"4d7LG","@mui/icons-material/Info":"kPVDs","./MaybeWithTooltip":"5Bddp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kPVDs":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("47a6f4581a16ed9c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("caa96ff3f2966434"));
var _jsxRuntime = require("36850a226f59e697");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), "Info");

},{"47a6f4581a16ed9c":"hykHy","caa96ff3f2966434":"gQLSP","36850a226f59e697":"g88cO"}],"5Bddp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MaybeWithTooltip", ()=>MaybeWithTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const MaybeWithTooltip = ({ title, children, spanSx })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        placement: "top",
        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: 2,
                overflowWrap: "anywhere"
            },
            children: title
        }),
        disableFocusListener: !title,
        disableHoverListener: !title,
        disableTouchListener: !title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            component: "span",
            sx: spanSx,
            children: children
        })
    });

},{"react/jsx-runtime":"g88cO","@mui/material/Tooltip":"3RLHy","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eWnEg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Age", ()=>Age);
var _jsxRuntime = require("react/jsx-runtime");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _dateFormatter = require("../../utils/dateFormatter");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _useFormattedTimestamp = require("../../hooks/useFormattedTimestamp");
var _theme = require("../../../styles/theme");
var _formatDistanceStrict = require("date-fns/formatDistanceStrict");
const Age = ({ sinceTimestamp })=>{
    const date = new Date(sinceTimestamp);
    const actualTime = (0, _useFormattedTimestamp.useFormattedTimestamp)(date);
    const distance = (0, _dateFormatter.formatDistanceToNow)(date);
    const distanceWithSuffix = (0, _formatDistanceStrict.formatDistanceStrict)(sinceTimestamp, new Date(), {
        addSuffix: true
    });
    const title = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            actualTime,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                fontWeight: 100,
                children: distanceWithSuffix
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: title,
        enterDelay: (0, _theme.tooltipDelay),
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            children: distance
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Tooltip":"3RLHy","../../utils/dateFormatter":"fg4MA","@mui/material/Box":"4d7LG","../../hooks/useFormattedTimestamp":"kCD95","../../../styles/theme":"i3yrR","date-fns/formatDistanceStrict":"6vO2f","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fg4MA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intlDateFormat", ()=>intlDateFormat);
parcelHelpers.export(exports, "formatDistanceToNow", ()=>formatDistanceToNow);
var _constants = require("date-fns/constants");
var _differenceInSeconds = require("date-fns/differenceInSeconds");
var _intlFormatDistance = require("date-fns/intlFormatDistance");
const dateFormat = new Intl.DateTimeFormat();
const intlDateFormat = (date)=>dateFormat.format(date);
const formatDistanceToNow = (date, baseDate = new Date(), locale = "en-US")=>{
    const diffInSeconds = (0, _differenceInSeconds.differenceInSeconds)(date, baseDate);
    let unit;
    // Simplified from date-fns code, but without quarters
    if (Math.abs(diffInSeconds) < (0, _constants.secondsInMinute)) unit = "second";
    else if (Math.abs(diffInSeconds) < (0, _constants.secondsInHour)) unit = "minute";
    else if (Math.abs(diffInSeconds) < (0, _constants.secondsInDay)) unit = "hour";
    else if (Math.abs(diffInSeconds) < (0, _constants.secondsInWeek)) unit = "day";
    else if (Math.abs(diffInSeconds) < (0, _constants.secondsInMonth)) unit = "week";
    else if (Math.abs(diffInSeconds) < (0, _constants.secondsInYear)) unit = "month";
    else unit = "year";
    return (0, _intlFormatDistance.intlFormatDistance)(date, baseDate, {
        unit,
        style: "short",
        numeric: "always",
        locale
    }).replace(/ ago$/, "").replace(/^in /, "").replace(/\.$/, "");
};

},{"date-fns/constants":"9jF9P","date-fns/differenceInSeconds":"hYtJb","date-fns/intlFormatDistance":"jx02B","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hYtJb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInSeconds} function options.
 */ /**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInSeconds", ()=>differenceInSeconds);
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
function differenceInSeconds(dateLeft, dateRight, options) {
    const diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInSeconds;

},{"./_lib/getRoundingMethod.mjs":"bQuCq","./differenceInMilliseconds.mjs":"dk2Iq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dk2Iq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */ parcelHelpers.export(exports, "differenceInMilliseconds", ()=>differenceInMilliseconds);
var _toDateMjs = require("./toDate.mjs");
function differenceInMilliseconds(dateLeft, dateRight) {
    return +(0, _toDateMjs.toDate)(dateLeft) - +(0, _toDateMjs.toDate)(dateRight);
}
// Fallback for modularized imports:
exports.default = differenceInMilliseconds;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jx02B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link intlFormatDistance} function options.
 */ /**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */ /**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */ parcelHelpers.export(exports, "intlFormatDistance", ()=>intlFormatDistance);
var _constantsMjs = require("./constants.mjs");
var _differenceInCalendarDaysMjs = require("./differenceInCalendarDays.mjs");
var _differenceInCalendarMonthsMjs = require("./differenceInCalendarMonths.mjs");
var _differenceInCalendarQuartersMjs = require("./differenceInCalendarQuarters.mjs");
var _differenceInCalendarWeeksMjs = require("./differenceInCalendarWeeks.mjs");
var _differenceInCalendarYearsMjs = require("./differenceInCalendarYears.mjs");
var _differenceInHoursMjs = require("./differenceInHours.mjs");
var _differenceInMinutesMjs = require("./differenceInMinutes.mjs");
var _differenceInSecondsMjs = require("./differenceInSeconds.mjs");
var _toDateMjs = require("./toDate.mjs");
function intlFormatDistance(date, baseDate, options) {
    let value = 0;
    let unit;
    const dateLeft = (0, _toDateMjs.toDate)(date);
    const dateRight = (0, _toDateMjs.toDate)(baseDate);
    if (!options?.unit) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        const diffInSeconds = (0, _differenceInSecondsMjs.differenceInSeconds)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInMinute)) {
            value = (0, _differenceInSecondsMjs.differenceInSeconds)(dateLeft, dateRight);
            unit = "second";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInHour)) {
            value = (0, _differenceInMinutesMjs.differenceInMinutes)(dateLeft, dateRight);
            unit = "minute";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInDay) && Math.abs((0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(dateLeft, dateRight)) < 1) {
            value = (0, _differenceInHoursMjs.differenceInHours)(dateLeft, dateRight);
            unit = "hour";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInWeek) && (value = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = "day";
        else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInMonth)) {
            value = (0, _differenceInCalendarWeeksMjs.differenceInCalendarWeeks)(dateLeft, dateRight);
            unit = "week";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInQuarter)) {
            value = (0, _differenceInCalendarMonthsMjs.differenceInCalendarMonths)(dateLeft, dateRight);
            unit = "month";
        } else if (Math.abs(diffInSeconds) < (0, _constantsMjs.secondsInYear)) {
            if ((0, _differenceInCalendarQuartersMjs.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, _differenceInCalendarQuartersMjs.differenceInCalendarQuarters)(dateLeft, dateRight);
                unit = "quarter";
            } else {
                value = (0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(dateLeft, dateRight);
                unit = "year";
            }
        } else {
            value = (0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(dateLeft, dateRight);
            unit = "year";
        }
    } else {
        // Get the value if unit is specified
        unit = options?.unit;
        if (unit === "second") value = (0, _differenceInSecondsMjs.differenceInSeconds)(dateLeft, dateRight);
        else if (unit === "minute") value = (0, _differenceInMinutesMjs.differenceInMinutes)(dateLeft, dateRight);
        else if (unit === "hour") value = (0, _differenceInHoursMjs.differenceInHours)(dateLeft, dateRight);
        else if (unit === "day") value = (0, _differenceInCalendarDaysMjs.differenceInCalendarDays)(dateLeft, dateRight);
        else if (unit === "week") value = (0, _differenceInCalendarWeeksMjs.differenceInCalendarWeeks)(dateLeft, dateRight);
        else if (unit === "month") value = (0, _differenceInCalendarMonthsMjs.differenceInCalendarMonths)(dateLeft, dateRight);
        else if (unit === "quarter") value = (0, _differenceInCalendarQuartersMjs.differenceInCalendarQuarters)(dateLeft, dateRight);
        else if (unit === "year") value = (0, _differenceInCalendarYearsMjs.differenceInCalendarYears)(dateLeft, dateRight);
    }
    const rtf = new Intl.RelativeTimeFormat(options?.locale, {
        localeMatcher: options?.localeMatcher,
        numeric: options?.numeric || "auto",
        style: options?.style
    });
    return rtf.format(value, unit);
}
// Fallback for modularized imports:
exports.default = intlFormatDistance;

},{"./constants.mjs":"9jF9P","./differenceInCalendarDays.mjs":"73bj1","./differenceInCalendarMonths.mjs":"isiOH","./differenceInCalendarQuarters.mjs":"cBnok","./differenceInCalendarWeeks.mjs":"9Q1ox","./differenceInCalendarYears.mjs":"h4A2g","./differenceInHours.mjs":"762wf","./differenceInMinutes.mjs":"63jt8","./differenceInSeconds.mjs":"hYtJb","./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"73bj1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", ()=>differenceInCalendarDays);
var _constantsMjs = require("./constants.mjs");
var _startOfDayMjs = require("./startOfDay.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, _startOfDayMjs.startOfDay)(dateLeft);
    const startOfDayRight = (0, _startOfDayMjs.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, _constantsMjs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarDays;

},{"./constants.mjs":"9jF9P","./startOfDay.mjs":"cbNPM","./_lib/getTimezoneOffsetInMilliseconds.mjs":"k77PV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cbNPM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", ()=>startOfDay);
var _toDateMjs = require("./toDate.mjs");
function startOfDay(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"isiOH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */ parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>differenceInCalendarMonths);
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarMonths(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarMonths;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cBnok":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */ parcelHelpers.export(exports, "differenceInCalendarQuarters", ()=>differenceInCalendarQuarters);
var _getQuarterMjs = require("./getQuarter.mjs");
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarQuarters(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const quarterDiff = (0, _getQuarterMjs.getQuarter)(_dateLeft) - (0, _getQuarterMjs.getQuarter)(_dateRight);
    return yearDiff * 4 + quarterDiff;
}
// Fallback for modularized imports:
exports.default = differenceInCalendarQuarters;

},{"./getQuarter.mjs":"jxNUx","./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jxNUx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */ parcelHelpers.export(exports, "getQuarter", ()=>getQuarter);
var _toDateMjs = require("./toDate.mjs");
function getQuarter(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
// Fallback for modularized imports:
exports.default = getQuarter;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9Q1ox":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarWeeks} function options.
 */ /**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInCalendarWeeks", ()=>differenceInCalendarWeeks);
var _constantsMjs = require("./constants.mjs");
var _startOfWeekMjs = require("./startOfWeek.mjs");
var _getTimezoneOffsetInMillisecondsMjs = require("./_lib/getTimezoneOffsetInMilliseconds.mjs");
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
    const startOfWeekLeft = (0, _startOfWeekMjs.startOfWeek)(dateLeft, options);
    const startOfWeekRight = (0, _startOfWeekMjs.startOfWeek)(dateRight, options);
    const timestampLeft = +startOfWeekLeft - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
    const timestampRight = +startOfWeekRight - (0, _getTimezoneOffsetInMillisecondsMjs.getTimezoneOffsetInMilliseconds)(startOfWeekRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a days is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, _constantsMjs.millisecondsInWeek));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarWeeks;

},{"./constants.mjs":"9jF9P","./startOfWeek.mjs":"46DUW","./_lib/getTimezoneOffsetInMilliseconds.mjs":"k77PV","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"46DUW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
var _toDateMjs = require("./toDate.mjs");
var _defaultOptionsMjs = require("./_lib/defaultOptions.mjs");
function startOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsMjs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateMjs.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeek;

},{"./toDate.mjs":"3SqwM","./_lib/defaultOptions.mjs":"26vSa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h4A2g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */ parcelHelpers.export(exports, "differenceInCalendarYears", ()=>differenceInCalendarYears);
var _toDateMjs = require("./toDate.mjs");
function differenceInCalendarYears(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
// Fallback for modularized imports:
exports.default = differenceInCalendarYears;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"762wf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInHours} function options.
 */ /**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */ parcelHelpers.export(exports, "differenceInHours", ()=>differenceInHours);
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _constantsMjs = require("./constants.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
function differenceInHours(dateLeft, dateRight, options) {
    const diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsMjs.millisecondsInHour);
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInHours;

},{"./_lib/getRoundingMethod.mjs":"bQuCq","./constants.mjs":"9jF9P","./differenceInMilliseconds.mjs":"dk2Iq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"63jt8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInMinutes} function options.
 */ /**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */ parcelHelpers.export(exports, "differenceInMinutes", ()=>differenceInMinutes);
var _getRoundingMethodMjs = require("./_lib/getRoundingMethod.mjs");
var _constantsMjs = require("./constants.mjs");
var _differenceInMillisecondsMjs = require("./differenceInMilliseconds.mjs");
function differenceInMinutes(dateLeft, dateRight, options) {
    const diff = (0, _differenceInMillisecondsMjs.differenceInMilliseconds)(dateLeft, dateRight) / (0, _constantsMjs.millisecondsInMinute);
    return (0, _getRoundingMethodMjs.getRoundingMethod)(options?.roundingMethod)(diff);
}
// Fallback for modularized imports:
exports.default = differenceInMinutes;

},{"./_lib/getRoundingMethod.mjs":"bQuCq","./constants.mjs":"9jF9P","./differenceInMilliseconds.mjs":"dk2Iq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1ZpvN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusBlocks", ()=>ConsensusBlocks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _table = require("../../components/Table");
var _blockLink = require("./BlockLink");
var _useScreensize = require("../../hooks/useScreensize");
var _index = require("./index");
var _age = require("../Age");
const ConsensusBlocks = ({ isLoading, blocks, type = (0, _index.BlocksTableType).Desktop, pagination, limit })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLaptop } = (0, _useScreensize.useScreenSize)();
    const tableColumns = [
        {
            key: "height",
            content: t("common.height"),
            align: (0, _table.TableCellAlign).Left
        },
        ...type === (0, _index.BlocksTableType).Desktop ? [
            {
                key: "hash",
                content: t("common.hash")
            }
        ] : [],
        ...type === (0, _index.BlocksTableType).Desktop || type === (0, _index.BlocksTableType).DesktopLite ? [
            {
                key: "transaction",
                content: isLaptop ? t("common.transactionAbbreviation") : t("common.transactions"),
                align: (0, _table.TableCellAlign).Right
            }
        ] : [],
        // { key: 'proposer', content: t('common.proposer'), align: TableCellAlign.Left },
        {
            key: "age",
            content: t("common.age"),
            align: (0, _table.TableCellAlign).Right
        }
    ];
    const tableRows = blocks?.map((block)=>{
        return {
            key: block.hash,
            data: [
                {
                    align: (0, _table.TableCellAlign).Left,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: block,
                        height: block.height
                    }),
                    key: "block"
                },
                ...type === (0, _index.BlocksTableType).Desktop ? [
                    {
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockHashLink), {
                            scope: block,
                            hash: block.hash,
                            height: block.height,
                            alwaysTrim: true
                        }),
                        key: "hash"
                    }
                ] : [],
                ...type === (0, _index.BlocksTableType).Desktop || type === (0, _index.BlocksTableType).DesktopLite ? [
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: block.num_transactions.toLocaleString(),
                        key: "txs"
                    }
                ] : [],
                // {
                //   key: 'proposer',
                //   content:
                //     'The Validator Who Has Mined This Block Who Might Actually Have A Really Really Annoyingly Long Name',
                // },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _age.Age), {
                        sinceTimestamp: block.timestamp
                    }),
                    key: "timestamp"
                }
            ],
            highlight: block.markAsNew
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("blocks.latest"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Table":"j3qb1","./BlockLink":"g8oEe","../../hooks/useScreensize":"2HEhN","./index":"4KkfE","../Age":"eWnEg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jOnBC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSearchParamsPagination", ()=>useSearchParamsPagination);
var _reactRouterDom = require("react-router-dom");
var _errors = require("../../../types/errors");
function useSearchParamsPagination(paramName) {
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const selectedPageString = searchParams.get(paramName);
    const selectedPage = parseInt(selectedPageString ?? "1", 10);
    if (isNaN(selectedPage) || !!selectedPageString && selectedPage.toString() !== selectedPageString) // This would be nicer, but this would also trigger react-error-overlay (besides our error boundary).
    // We don't want that, so now, we are stuck with throwing a string, instead of a proper error.
    // throw new AppError(AppErrors.InvalidPageNumber)
    throw (0, _errors.AppErrors).InvalidPageNumber;
    function linkToPage(page) {
        const newSearchParams = new URLSearchParams(searchParams);
        if (page > 1) newSearchParams.set(paramName, page.toString());
        else newSearchParams.delete(paramName);
        return {
            search: newSearchParams.toString()
        };
    }
    return {
        selectedPage,
        linkToPage
    };
}

},{"react-router-dom":"5o0mA","../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jWfMQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBlockDetailPage", ()=>RuntimeBlockDetailPage);
parcelHelpers.export(exports, "RuntimeBlockDetailView", ()=>RuntimeBlockDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _useScreensize = require("../../hooks/useScreensize");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _skeleton = require("../../components/Skeleton");
var _useFormattedTimestamp = require("../../hooks/useFormattedTimestamp");
var _transactionsCard = require("./TransactionsCard");
var _errors = require("../../../types/errors");
var _config = require("../../../config");
var _blockLink = require("../../components/Blocks/BlockLink");
var _routeUtils = require("../../utils/route-utils");
var _useScopeParam = require("../../hooks/useScopeParam");
var _dashboardLink = require("../ParatimeDashboardPage/DashboardLink");
var _eventsCard = require("./EventsCard");
var _blockNavigationButtons = require("../../components/BlockNavigationButtons");
const RuntimeBlockDetailPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const blockHeight = parseInt((0, _reactRouterDom.useParams)().blockHeight, 10);
    const { isLoading, data } = (0, _api.useGetRuntimeBlockByHeight)(scope.network, scope.layer, blockHeight);
    if (!data && !isLoading) throw (0, _errors.AppErrors).NotFoundBlockHeight;
    const block = data?.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
                featured: true,
                title: t("common.block"),
                mainTitle: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimeBlockDetailView, {
                    enableBlockNavigation: true,
                    isLoading: isLoading,
                    block: block
                })
            }),
            !!block?.num_transactions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionsCard.TransactionsCard), {
                scope: scope,
                blockHeight: blockHeight
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventsCard.EventsCard), {
                scope: scope,
                blockHeight: blockHeight
            })
        ]
    });
};
const RuntimeBlockDetailView = ({ enableBlockNavigation, isLoading, block, showLayer, standalone = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const formattedTime = (0, _useFormattedTimestamp.useFormattedTimestampStringWithDistance)(block?.timestamp);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 7
    });
    if (!block) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const transactionsAnchor = `${(0, _routeUtils.RouteUtils).getBlockRoute(block, block.round)}#${(0, _transactionsCard.transactionsContainerId)}`;
    const transactionLabel = block.num_transactions.toLocaleString();
    const blockGasLimit = (0, _config.paraTimesConfig)[block.layer]?.[block.network]?.blockGasLimit;
    if (!blockGasLimit) throw new Error("blockGasLimit is not configured");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "100px" : "200px",
        standalone: standalone,
        highlight: block.markAsNew,
        children: [
            showLayer && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.paratime")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardLink.DashboardLink), {
                            scope: block
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.height")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: block,
                        height: block.round
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: block.round.toString()
                    }),
                    enableBlockNavigation && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockNavigationButtons.PrevBlockButton), {
                                scope: block,
                                currentRound: block.round
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockNavigationButtons.NextBlockButton), {
                                scope: block,
                                currentRound: block.round
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.hash")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockHashLink), {
                        scope: block,
                        hash: block.hash,
                        height: block.round
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: block.hash.toString()
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.timestamp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: formattedTime
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.size")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: t("common.bytes", {
                    value: block.size,
                    formatParams: {
                        value: {
                            style: "unit",
                            unit: "byte",
                            unitDisplay: "long"
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.transactions")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: block.num_transactions ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    href: transactionsAnchor,
                    children: transactionLabel
                }) : transactionLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.gasUsed")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: t("block.gasUsed", {
                    value: block.gas_used,
                    percentage: block.gas_used / blockGasLimit,
                    formatParams: {
                        percentage: {
                            style: "percent",
                            maximumFractionDigits: 2
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.gasLimit")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: blockGasLimit.toLocaleString()
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","../../hooks/useScreensize":"2HEhN","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../components/StyledDescriptionList":"bndrS","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../components/CopyToClipboard":"iTQvM","../../components/Skeleton":"eB5vc","../../hooks/useFormattedTimestamp":"kCD95","./TransactionsCard":"dxrfu","../../../types/errors":"gdpNU","../../../config":"2PXMY","../../components/Blocks/BlockLink":"g8oEe","../../utils/route-utils":"b2kKi","../../hooks/useScopeParam":"kKMKx","../ParatimeDashboardPage/DashboardLink":"k1EO2","./EventsCard":"53s87","../../components/BlockNavigationButtons":"eaPrf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bndrS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineDescriptionList", ()=>InlineDescriptionList);
parcelHelpers.export(exports, "StyledDescriptionList", ()=>StyledDescriptionList);
parcelHelpers.export(exports, "StyledListTitleWithAvatar", ()=>StyledListTitleWithAvatar);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
var _animations = require("../../../styles/theme/animations");
const InlineDescriptionList = (0, _styles.styled)("dl", {
    shouldForwardProp: (prop)=>prop !== "titleWidth" && prop !== "descriptionWidth"
})`
  display: grid;
  grid-template-columns:
    ${(props)=>props.titleWidth ?? "max-content"}
    ${(props)=>props.descriptionWidth ?? "auto"};
  margin: 0;
  dd {
    margin: 0;
    padding-left: ${({ theme })=>theme.spacing(4)};
  }
`;
const StyledDescriptionList = (0, _styles.styled)(InlineDescriptionList, {
    shouldForwardProp: (prop)=>prop !== "standalone" && prop !== "highlight"
})(({ theme, standalone, highlight })=>({
        "dt, dd": {
            display: "flex",
            boxShadow: `0px 1px 0px ${(0, _colors.COLORS).grayLight}`,
            ":last-of-type": {
                boxShadow: "none"
            },
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(3, 0)
            },
            [theme.breakpoints.up("sm")]: {
                padding: theme.spacing(4, 0)
            }
        },
        dt: {
            color: (0, _colors.COLORS).grayDark,
            alignItems: "start"
        },
        dd: {
            color: (0, _colors.COLORS).brandExtraDark,
            overflowWrap: "anywhere",
            alignItems: "center",
            maxWidth: "100%",
            overflowX: "hidden"
        },
        ...standalone && {
            "&&": {
                padding: theme.spacing(3, 4),
                backgroundColor: (0, _colors.COLORS).white,
                marginBottom: theme.spacing(4),
                borderRadius: "12px"
            }
        },
        ...highlight && (0, _animations.backgroundColorAnimation)
    }));
const StyledListTitleWithAvatar = (0, _styles.styled)("dt")(({ theme })=>({
        "&&": {
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(2, 0)
            },
            [theme.breakpoints.up("sm")]: {
                padding: theme.spacing(3, 0)
            }
        }
    }));

},{"@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","../../../styles/theme/animations":"aWqrd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iTQvM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyToClipboard", ()=>CopyToClipboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _contentCopy = require("@mui/icons-material/ContentCopy");
var _contentCopyDefault = parcelHelpers.interopDefault(_contentCopy);
var _colors = require("../../../styles/theme/colors");
var _buttonBase = require("@mui/material/ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const clipboardTooltipDuration = 2000;
const StyledIconButton = (0, _styles.styled)((0, _buttonBaseDefault.default))(({ theme })=>({
        display: "inline-flex",
        alignItems: "center",
        border: 0,
        background: "none",
        cursor: "pointer",
        fontSize: "inherit",
        fontFamily: "inherit",
        padding: 0,
        marginLeft: theme.spacing(4)
    }));
const CopyToClipboard = ({ value, label })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const timeout = (0, _react.useRef)(undefined);
    const ariaLabel = t("clipboard.label");
    const [isCopied, setIsCopied] = (0, _react.useState)(false);
    const handleCopyToClipboard = (0, _react.useCallback)(()=>{
        if (isCopied) return;
        window.navigator.clipboard.writeText(value);
        setIsCopied(true);
    }, [
        isCopied,
        value
    ]);
    const hideTooltip = (0, _react.useCallback)(()=>timeout.current = window.setTimeout(()=>setIsCopied(false), clipboardTooltipDuration), []);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (timeout.current) window.clearTimeout(timeout.current);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        onOpen: hideTooltip,
        open: isCopied,
        placement: "right",
        title: t("clipboard.success"),
        children: label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "outlined",
            color: "secondary",
            onClick: handleCopyToClipboard,
            "aria-label": ariaLabel,
            children: label
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIconButton, {
            color: "inherit",
            onClick: handleCopyToClipboard,
            "aria-label": ariaLabel,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentCopyDefault.default), {
                sx: {
                    fontSize: "1.25em",
                    color: (0, _colors.COLORS).brandDark
                }
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Tooltip":"3RLHy","@mui/icons-material/ContentCopy":"ctpcy","../../../styles/theme/colors":"hYvW2","@mui/material/ButtonBase":"1prwn","@mui/material/styles":"51PGx","@mui/material/Button":"h2G5p","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ctpcy":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("2fd6242b20ec4c67");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("338a968334381571"));
var _jsxRuntime = require("19ac748d8b34c381");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy");

},{"2fd6242b20ec4c67":"hykHy","338a968334381571":"gQLSP","19ac748d8b34c381":"g88cO"}],"eB5vc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextSkeleton", ()=>TextSkeleton);
var _jsxRuntime = require("react/jsx-runtime");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
const TextSkeleton = ({ numberOfRows })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: [
            ...Array(numberOfRows).keys()
        ].map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                height: 30,
                sx: {
                    my: 4
                }
            }, i))
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Skeleton":"i7d9z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dxrfu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transactionsContainerId", ()=>transactionsContainerId);
parcelHelpers.export(exports, "TransactionsCard", ()=>TransactionsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _scrollingCard = require("../../components/PageLayout/ScrollingCard");
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _config = require("../../config");
var _api = require("../../../oasis-nexus/api");
var _transactions = require("../../components/Transactions");
var _errorBoundary = require("../../components/ErrorBoundary");
var _errors = require("../../../types/errors");
const transactionsContainerId = "transactions";
const TransactionList = ({ scope, blockHeight })=>{
    const txsPagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const txsOffset = (txsPagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    if (scope.layer === (0, _api.Layer).consensus) // Loading transactions for consensus blocks is not yet supported.
    // Should use useGetConsensusTransactions()
    throw (0, _errors.AppErrors).UnsupportedLayer;
    const transactionsQuery = (0, _api.useGetRuntimeTransactions)(scope.network, scope.layer, {
        block: blockHeight,
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: txsOffset
    });
    const { isLoading, isFetched, data } = transactionsQuery;
    const transactions = data?.data.transactions;
    if (isFetched && txsPagination.selectedPage > 1 && !transactions?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.RuntimeTransactions), {
        transactions: transactions,
        isLoading: isLoading,
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        pagination: {
            selectedPage: txsPagination.selectedPage,
            linkToPage: txsPagination.linkToPage,
            totalCount: data?.data.total_count,
            isTotalCountClipped: data?.data.is_total_count_clipped,
            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
        }
    });
};
const TransactionsCard = ({ scope, blockHeight })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _scrollingCard.ScrollingCard), {
        id: transactionsContainerId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("common.transactions")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransactionList, {
                        scope: scope,
                        blockHeight: blockHeight
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/PageLayout/ScrollingCard":"2xGtb","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../components/Table/useSearchParamsPagination":"jOnBC","../../config":"in6G4","../../../oasis-nexus/api":"dJrPU","../../components/Transactions":"k0qMF","../../components/ErrorBoundary":"246yY","../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2xGtb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollingCard", ()=>ScrollingCard);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _linkableDiv = require("./LinkableDiv");
const ScrollingCard = (props)=>{
    const { id, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
        id: id,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
            ...rest
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Card":"cTsx6","./LinkableDiv":"dLOUR","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dLOUR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkableDiv", ()=>LinkableDiv);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
const LinkableDiv = (props)=>{
    const { id } = props;
    const { hash } = (0, _reactRouterDom.useLocation)();
    const divRef = (0, _react.useRef)(null);
    const element = divRef.current;
    (0, _react.useEffect)(()=>{
        if (hash === `#${id}`) {
            if (element) element.scrollIntoView({
                block: "start"
            });
            else setTimeout(()=>{
                if (divRef.current) divRef.current.scrollIntoView({
                    block: "start"
                });
            });
        }
    }, [
        id,
        hash,
        element
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: divRef
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k0qMF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtimeTransactions = require("./RuntimeTransactions");
parcelHelpers.exportAll(_runtimeTransactions, exports);
var _consensusTransactions = require("./ConsensusTransactions");
parcelHelpers.exportAll(_consensusTransactions, exports);

},{"./RuntimeTransactions":"lpv31","./ConsensusTransactions":"2qpf4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lpv31":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactions", ()=>RuntimeTransactions);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _lock = require("@mui/icons-material/Lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _table = require("../../components/Table");
var _statusIcon = require("../StatusIcon");
var _runtimeTransactionMethod = require("../../components/RuntimeTransactionMethod");
var _roundedBalance = require("../../components/RoundedBalance");
var _colors = require("../../../styles/theme/colors");
var _blockLink = require("../Blocks/BlockLink");
var _accountLink = require("../Account/AccountLink");
var _transactionLink = require("./TransactionLink");
var _layers = require("../../../types/layers");
var _transactionEncryptionStatus = require("../TransactionEncryptionStatus");
var _age = require("../Age");
const iconSize = "28px";
const StyledCircle = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: iconSize,
        height: iconSize,
        color: (0, _colors.COLORS).eucalyptus,
        backgroundColor: (0, _colors.COLORS).lightGreen,
        borderRadius: iconSize,
        marginLeft: theme.spacing(3),
        marginRight: `-${theme.spacing(4)}`
    }));
const RuntimeTransactions = ({ isLoading, limit, pagination, transactions, ownAddress, verbose = true })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    // We only want to show encryption status of we are listing transactions
    // from paratimes that actually support encrypting transactions
    const canHaveEncryption = (0, _layers.doesAnyOfTheseLayersSupportEncryptedTransactions)(transactions?.map((tx)=>tx.layer));
    const tableColumns = [
        {
            key: "status",
            content: t("common.status")
        },
        ...verbose && canHaveEncryption ? [
            {
                key: "encrypted",
                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lockDefault.default), {
                    htmlColor: (0, _colors.COLORS).grayMedium
                })
            }
        ] : [],
        {
            key: "hash",
            content: t("common.hash")
        },
        {
            key: "block",
            content: t("common.block")
        },
        {
            key: "age",
            content: t("common.age"),
            align: (0, _table.TableCellAlign).Right
        },
        ...verbose ? [
            {
                key: "type",
                content: t("common.type")
            },
            {
                key: "from",
                content: t("common.from"),
                width: "150px"
            },
            {
                key: "to",
                content: t("common.to"),
                width: "150px"
            },
            {
                key: "txnFee",
                content: t("common.transactionFee"),
                align: (0, _table.TableCellAlign).Right,
                width: "250px"
            },
            {
                key: "value",
                align: (0, _table.TableCellAlign).Right,
                content: t("common.value"),
                width: "250px"
            }
        ] : []
    ];
    const tableRows = transactions?.map((transaction)=>{
        const targetAddress = transaction.to_eth || transaction.to;
        return {
            key: `${transaction.hash}${transaction.index}`,
            data: [
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
                        success: transaction.success,
                        error: transaction.error
                    }),
                    key: "success"
                },
                ...verbose && canHaveEncryption ? [
                    {
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionEncryptionStatus.TransactionEncryptionStatus), {
                            envelope: transaction.encryption_envelope
                        }),
                        key: "encrypted"
                    }
                ] : [],
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionLink.TransactionLink), {
                        scope: transaction,
                        alwaysTrim: true,
                        hash: transaction.eth_hash || transaction.hash
                    }),
                    key: "hash"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: transaction,
                        height: transaction.round
                    }),
                    key: "round"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _age.Age), {
                        sinceTimestamp: transaction.timestamp
                    }),
                    key: "timestamp"
                },
                ...verbose ? [
                    {
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionMethod.RuntimeTransactionMethod), {
                            method: transaction.method,
                            truncate: true
                        }),
                        key: "type"
                    },
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                pr: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                    labelOnly: !!ownAddress && (transaction.sender_0_eth === ownAddress || transaction.sender_0 === ownAddress),
                                    scope: transaction,
                                    address: transaction.sender_0_eth || transaction.sender_0,
                                    alwaysTrim: true
                                }),
                                targetAddress && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCircle, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {
                                        fontSize: "inherit"
                                    })
                                })
                            ]
                        }),
                        key: "from"
                    },
                    {
                        content: targetAddress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                            labelOnly: !!ownAddress && (transaction.to_eth === ownAddress || transaction.to === ownAddress),
                            scope: transaction,
                            address: targetAddress,
                            alwaysTrim: true
                        }) : null,
                        key: "to"
                    },
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                            value: transaction.charged_fee,
                            ticker: transaction.ticker
                        }),
                        key: "fee_amount"
                    },
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                            value: transaction.amount,
                            ticker: transaction.ticker
                        }),
                        key: "value"
                    }
                ] : []
            ],
            highlight: transaction.markAsNew
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("transactions.latest"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/icons-material/ArrowForward":"bwHID","@mui/icons-material/Lock":"esPb2","../../components/Table":"j3qb1","../StatusIcon":"3VOhR","../../components/RuntimeTransactionMethod":"gVAQO","../../components/RoundedBalance":"af34T","../../../styles/theme/colors":"hYvW2","../Blocks/BlockLink":"g8oEe","../Account/AccountLink":"43Jgs","./TransactionLink":"eIjbt","../../../types/layers":"gWCJy","../TransactionEncryptionStatus":"as1nW","../Age":"eWnEg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bwHID":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("a1f204aaf56b561b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4ee17709ef0f2985"));
var _jsxRuntime = require("2df9b1e75d4cc01d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");

},{"a1f204aaf56b561b":"hykHy","4ee17709ef0f2985":"gQLSP","2df9b1e75d4cc01d":"g88cO"}],"esPb2":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("6a4959641801179b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("42cc80b615169caf"));
var _jsxRuntime = require("66d33689361b20b3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1z"
}), "Lock");

},{"6a4959641801179b":"hykHy","42cc80b615169caf":"gQLSP","66d33689361b20b3":"g88cO"}],"3VOhR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "statusIcon", ()=>statusIcon);
parcelHelpers.export(exports, "StyledBox", ()=>StyledBox);
parcelHelpers.export(exports, "ErrorBox", ()=>ErrorBox);
parcelHelpers.export(exports, "StatusIcon", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
var _help = require("@mui/icons-material/Help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _useTxErrorMessage = require("../../hooks/useTxErrorMessage");
const statusBgColor = {
    unknown: (0, _colors.COLORS).grayMediumLight,
    success: (0, _colors.COLORS).honeydew,
    failure: (0, _colors.COLORS).linen
};
const statusFgColor = {
    unknown: (0, _colors.COLORS).grayMedium,
    success: (0, _colors.COLORS).eucalyptus,
    failure: (0, _colors.COLORS).errorIndicatorBackground
};
const statusIcon = {
    unknown: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpDefault.default), {
        color: "inherit",
        fontSize: "inherit"
    }),
    success: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
        color: "success",
        fontSize: "inherit"
    }),
    failure: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
        color: "error",
        fontSize: "inherit"
    })
};
const StyledBox = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "success" && prop !== "withText"
})(({ success, withText })=>{
    const status = success === undefined ? "unknown" : success ? "success" : "failure";
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: withText ? undefined : "28px",
        minHeight: "28px",
        fontSize: "15px",
        backgroundColor: statusBgColor[status],
        color: statusFgColor[status],
        borderRadius: 10,
        padding: 4,
        paddingLeft: 12,
        paddingRight: 12
    };
});
const ErrorBox = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "28px",
        fontSize: "12px",
        backgroundColor: (0, _colors.COLORS).grayLight,
        color: (0, _colors.COLORS).errorIndicatorBackground,
        borderRadius: 10,
        paddingLeft: 12,
        paddingRight: 12
    }));
const StatusIcon = ({ success, error, withText })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const status = success === undefined ? "unknown" : success ? "success" : "failure";
    const statusLabel = {
        unknown: t("common.unknown"),
        success: t("common.success"),
        failure: t("common.failed")
    };
    const errorMessage = (0, _useTxErrorMessage.useTxErrorMessage)(error);
    if (withText) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
                success: success,
                error: error,
                withText: withText,
                children: [
                    statusLabel[status],
                    "\xa0",
                    statusIcon[status]
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ErrorBox, {
                children: errorMessage
            })
        ]
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: errorMessage ? `${statusLabel[status]}: ${errorMessage}` : statusLabel[status],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
            success: success,
            error: error,
            withText: withText,
            children: statusIcon[status]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Cancel":"l7K6K","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","@mui/icons-material/Help":"jIKks","@mui/material/Tooltip":"3RLHy","../../hooks/useTxErrorMessage":"48kJp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l7K6K":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("2a06ddcf2f2cee42");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("12bc78a3cf4c0fb6"));
var _jsxRuntime = require("e4bc108cadf11e17");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), "Cancel");

},{"2a06ddcf2f2cee42":"hykHy","12bc78a3cf4c0fb6":"gQLSP","e4bc108cadf11e17":"g88cO"}],"jIKks":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("fe30786413a088e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("278450463edeae3d"));
var _jsxRuntime = require("850942b26a82c060");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), "Help");

},{"fe30786413a088e":"hykHy","278450463edeae3d":"gQLSP","850942b26a82c060":"g88cO"}],"48kJp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTxErrorMessage", ()=>useTxErrorMessage);
var _reactI18Next = require("react-i18next");
const useTxErrorMessage = (error)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!error) return undefined;
    if (error.module === "evm" && error.code === 8 && !error.message) // EVM reverted, with missing error message
    return `${t("errors.revertedWithoutMessage")} (${t("errors.code")} ${error.code})`;
    else // Anything else
    return `${error.message} (${t("errors.code")} ${error.code})`;
};

},{"react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gVAQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionMethod", ()=>RuntimeTransactionMethod);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _textSnippet = require("@mui/icons-material/TextSnippet");
var _textSnippetDefault = parcelHelpers.interopDefault(_textSnippet);
var _fileCopy = require("@mui/icons-material/FileCopy");
var _fileCopyDefault = parcelHelpers.interopDefault(_fileCopy);
var _arrowDownward = require("@mui/icons-material/ArrowDownward");
var _arrowDownwardDefault = parcelHelpers.interopDefault(_arrowDownward);
var _arrowUpward = require("@mui/icons-material/ArrowUpward");
var _arrowUpwardDefault = parcelHelpers.interopDefault(_arrowUpward);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _questionMark = require("@mui/icons-material/QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _lan = require("@mui/icons-material/Lan");
var _lanDefault = parcelHelpers.interopDefault(_lan);
var _lanOutlined = require("@mui/icons-material/LanOutlined");
var _lanOutlinedDefault = parcelHelpers.interopDefault(_lanOutlined);
var _consensusTransactionMethod = require("../ConsensusTransactionMethod");
const getRuntimeTransactionLabel = (t, method)=>{
    switch(method){
        case undefined:
            // Method may be undefined if the transaction was malformed.
            return t("transactions.method.unavailable");
        case "evm.Call":
            return t("transactions.method.evm.call");
        case "evm.Create":
            return t("transactions.method.evm.create");
        case "consensus.Deposit":
            return t("transactions.method.consensus.deposit");
        case "consensus.Withdraw":
            return t("transactions.method.consensus.withdraw");
        case "accounts.Transfer":
            return t("transactions.method.accounts.transfer");
        case "consensus.Delegate":
            return t("transactions.method.consensus.delegate");
        case "consensus.Undelegate":
            return t("transactions.method.consensus.undelegate");
        default:
            return method || t("common.unknown");
    }
};
const getRuntimeTransactionIcon = (method, label, truncate)=>{
    const props = {
        border: false,
        label,
        truncate
    };
    switch(method){
        case "evm.Call":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textSnippetDefault.default), {}),
                ...props
            });
        case "evm.Create":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileCopyDefault.default), {}),
                ...props
            });
        case "consensus.Deposit":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDownwardDefault.default), {}),
                ...props
            });
        case "consensus.Withdraw":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "orange",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowUpwardDefault.default), {}),
                ...props
            });
        case "consensus.Delegate":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lanDefault.default), {}),
                ...props
            });
        case "consensus.Undelegate":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lanOutlinedDefault.default), {}),
                ...props
            });
        case "accounts.Transfer":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {}),
                ...props
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "gray",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionMarkDefault.default), {}),
                ...props
            });
    }
};
const RuntimeTransactionMethod = ({ method, truncate })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const label = getRuntimeTransactionLabel(t, method);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: getRuntimeTransactionIcon(method, label, truncate)
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/TextSnippet":"jcElt","@mui/icons-material/FileCopy":"grQM9","@mui/icons-material/ArrowDownward":"7cLed","@mui/icons-material/ArrowUpward":"l2vTC","@mui/icons-material/ArrowForward":"bwHID","@mui/icons-material/QuestionMark":"c96Ve","@mui/icons-material/Lan":"hUYtK","@mui/icons-material/LanOutlined":"kdoX4","../ConsensusTransactionMethod":"2QV5X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jcElt":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("d7d4cfeb483706bb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("cdbb6bfa1c23e91c"));
var _jsxRuntime = require("49cfe014584e689a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m20.41 8.41-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42M7 7h7v2H7zm10 10H7v-2h10zm0-4H7v-2h10z"
}), "TextSnippet");

},{"d7d4cfeb483706bb":"hykHy","cdbb6bfa1c23e91c":"gQLSP","49cfe014584e689a":"g88cO"}],"grQM9":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("8f0692d09efee1d7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("41e2c91d9307287c"));
var _jsxRuntime = require("7645abe0b7979002");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2zm-1 7h5.5L14 6.5z"
}), "FileCopy");

},{"8f0692d09efee1d7":"hykHy","41e2c91d9307287c":"gQLSP","7645abe0b7979002":"g88cO"}],"7cLed":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("b328e42da4ccd689");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("e22146c7a01494b7"));
var _jsxRuntime = require("e2a6b4c0308ac802");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), "ArrowDownward");

},{"b328e42da4ccd689":"hykHy","e22146c7a01494b7":"gQLSP","e2a6b4c0308ac802":"g88cO"}],"l2vTC":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("60d4a2fe54efc149");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("710eab3f568a148a"));
var _jsxRuntime = require("6a59ea857af29621");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), "ArrowUpward");

},{"60d4a2fe54efc149":"hykHy","710eab3f568a148a":"gQLSP","6a59ea857af29621":"g88cO"}],"c96Ve":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("c83a01475e7e5447");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("bda2686ed43fb553"));
var _jsxRuntime = require("5a34cf37bcb0c76e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15M14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2"
}), "QuestionMark");

},{"c83a01475e7e5447":"hykHy","bda2686ed43fb553":"gQLSP","5a34cf37bcb0c76e":"g88cO"}],"hUYtK":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("33cb071962f7b196");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("449950b89c6edf87"));
var _jsxRuntime = require("916c40d24a295fce");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3z"
}), "Lan");

},{"33cb071962f7b196":"hykHy","449950b89c6edf87":"gQLSP","916c40d24a295fce":"g88cO"}],"kdoX4":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("71104a13db33e680");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("bb8edfe76625efe4"));
var _jsxRuntime = require("bc06b7c09c5a9e13");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3zM10 7V4h4v3zM9 17v3H5v-3zm10 0v3h-4v-3z"
}), "LanOutlined");

},{"71104a13db33e680":"hykHy","bb8edfe76625efe4":"gQLSP","bc06b7c09c5a9e13":"g88cO"}],"2QV5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorMap", ()=>colorMap);
parcelHelpers.export(exports, "MethodIcon", ()=>MethodIcon);
parcelHelpers.export(exports, "ConsensusTransactionMethod", ()=>ConsensusTransactionMethod);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _accountBalance = require("@mui/icons-material/AccountBalance");
var _accountBalanceDefault = parcelHelpers.interopDefault(_accountBalance);
var _arrowDownward = require("@mui/icons-material/ArrowDownward");
var _arrowDownwardDefault = parcelHelpers.interopDefault(_arrowDownward);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _dns = require("@mui/icons-material/Dns");
var _dnsDefault = parcelHelpers.interopDefault(_dns);
var _exitToApp = require("@mui/icons-material/ExitToApp");
var _exitToAppDefault = parcelHelpers.interopDefault(_exitToApp);
var _howToVote = require("@mui/icons-material/HowToVote");
var _howToVoteDefault = parcelHelpers.interopDefault(_howToVote);
var _libraryAddCheck = require("@mui/icons-material/LibraryAddCheck");
var _libraryAddCheckDefault = parcelHelpers.interopDefault(_libraryAddCheck);
var _miscellaneousServices = require("@mui/icons-material/MiscellaneousServices");
var _miscellaneousServicesDefault = parcelHelpers.interopDefault(_miscellaneousServices);
var _person = require("@mui/icons-material/Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _priceChange = require("@mui/icons-material/PriceChange");
var _priceChangeDefault = parcelHelpers.interopDefault(_priceChange);
var _questionMark = require("@mui/icons-material/QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _theme = require("../../../styles/theme");
var _api = require("../../../oasis-nexus/api");
var _colors = require("../../../styles/theme/colors");
const colorMap = {
    blue: {
        primary: (0, _colors.COLORS).brandMedium,
        secondary: (0, _colors.COLORS).brandLightBlue
    },
    green: {
        primary: (0, _colors.COLORS).eucalyptus,
        secondary: (0, _colors.COLORS).honeydew
    },
    gray: {
        primary: (0, _colors.COLORS).grayMedium,
        secondary: (0, _colors.COLORS).grayMediumLight
    },
    orange: {
        primary: (0, _colors.COLORS).warningColor,
        secondary: (0, _colors.COLORS).warningLight
    }
};
const iconRatio = 0.75;
const MethodIcon = (props)=>{
    const { label, reverseLabel, truncate } = props;
    const enableTruncate = truncate && label && !reverseLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            enableTruncate && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIconWithTruncatedLabel, {
                ...props
            }),
            !enableTruncate && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIconContent, {
                ...props
            })
        ]
    });
};
const MethodIconContent = ({ border = true, color = "blue", icon, label, reverseLabel, size = 40, truncate, elementRef })=>{
    const theme = colorMap[color];
    if (!theme) throw new Error(`Invalid color: ${color}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        ref: elementRef,
        gap: 3,
        sx: {
            display: "inline-flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: size,
                    minWidth: size,
                    height: size,
                    borderRadius: size,
                    color: theme.primary,
                    border: border ? `solid 2px ${theme.primary}` : "none",
                    backgroundColor: theme.secondary
                },
                children: /*#__PURE__*/ (0, _react.cloneElement)(icon, {
                    sx: {
                        fontSize: Math.ceil(size * iconRatio)
                    }
                })
            }),
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontWeight: "inherit",
                    textTransform: "capitalize",
                    order: reverseLabel ? -1 : 0,
                    ...truncate ? {
                        minWidth: "100px",
                        // all properties are needed to enable overflow, maxWidth allows to squeeze content
                        maxWidth: "1px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    } : {}
                },
                children: label
            })
        ]
    });
};
const MethodIconWithTruncatedLabel = (props)=>{
    const elementRef = (0, _react.useRef)(null);
    const [truncate, setTruncate] = (0, _react.useState)(false);
    const [baseLabelWidth, setBaseLabelWidth] = (0, _react.useState)(0);
    const applyTruncate = (0, _react.useCallback)(()=>{
        if (elementRef.current) {
            const elementWidth = elementRef.current.offsetWidth;
            const parentWidth = elementRef.current.parentNode?.offsetWidth;
            setTruncate(elementWidth === parentWidth || baseLabelWidth > parentWidth);
        }
    }, [
        elementRef,
        baseLabelWidth
    ]);
    (0, _react.useLayoutEffect)(()=>{
        if (elementRef.current) {
            setBaseLabelWidth(elementRef.current.offsetWidth);
            applyTruncate();
        }
        const handleResize = ()=>{
            applyTruncate();
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        applyTruncate,
        elementRef,
        props.label,
        props.size
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: props.label,
        enterDelay: (0, _theme.tooltipDelay),
        enterNextDelay: (0, _theme.tooltipDelay),
        disableFocusListener: !truncate,
        disableHoverListener: !truncate,
        disableTouchListener: !truncate,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIconContent, {
                ...props,
                elementRef: elementRef,
                truncate: truncate
            })
        })
    });
};
const getConsensusTransactionMethod = (t, method, truncate)=>{
    const props = {
        truncate
    };
    switch(method){
        case (0, _api.ConsensusTxMethod).stakingTransfer:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {}),
                label: t("transactions.method.stakingTransfer"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).stakingAddEscrow:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exitToAppDefault.default), {}),
                label: t("transactions.method.stakingAddEscrow"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).stakingReclaimEscrow:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exitToAppDefault.default), {}),
                label: t("transactions.method.stakingReclaimEscrow"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).stakingAmendCommissionSchedule:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _priceChangeDefault.default), {}),
                label: t("transactions.method.stakingAmendCommissionSchedule"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).stakingAllow:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _libraryAddCheckDefault.default), {}),
                label: t("transactions.method.stakingAllow"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).stakingWithdraw:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDownwardDefault.default), {}),
                label: t("transactions.method.stakingWithdraw"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).roothashExecutorCommit:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscellaneousServicesDefault.default), {}),
                label: t("transactions.method.roothashExecutorCommit"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).roothashExecutorProposerTimeout:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscellaneousServicesDefault.default), {}),
                label: t("transactions.method.roothashExecutorProposerTimeout"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).registryRegisterEntity:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDefault.default), {}),
                label: t("transactions.method.registryRegisterEntity"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).registryRegisterNode:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnsDefault.default), {}),
                label: t("transactions.method.registryRegisterNode"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).registryRegisterRuntime:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscellaneousServicesDefault.default), {}),
                label: t("transactions.method.registryRegisterRuntime"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).governanceCastVote:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _howToVoteDefault.default), {}),
                label: t("transactions.method.governanceCastVote"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).governanceSubmitProposal:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountBalanceDefault.default), {}),
                label: t("transactions.method.governanceSubmitProposal"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).beaconPVSSCommit:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscellaneousServicesDefault.default), {}),
                label: t("transactions.method.beaconPVSSCommit"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).beaconPVSSReveal:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscellaneousServicesDefault.default), {}),
                label: t("transactions.method.beaconPVSSReveal"),
                ...props
            });
        case (0, _api.ConsensusTxMethod).beaconVRFProve:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miscellaneousServicesDefault.default), {}),
                label: t("transactions.method.beaconVRFProve"),
                ...props
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MethodIcon, {
                color: "gray",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionMarkDefault.default), {}),
                label: method || t("common.unknown"),
                ...props
            });
    }
};
const ConsensusTransactionMethod = ({ method, truncate })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: getConsensusTransactionMethod(t, method, truncate)
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/icons-material/AccountBalance":"aOpsR","@mui/icons-material/ArrowDownward":"7cLed","@mui/icons-material/ArrowForward":"bwHID","@mui/icons-material/Dns":"9R9Rt","@mui/icons-material/ExitToApp":"3HzJ5","@mui/icons-material/HowToVote":"ans4Z","@mui/icons-material/LibraryAddCheck":"lb5Jz","@mui/icons-material/MiscellaneousServices":"jXahc","@mui/icons-material/Person":"3ChS7","@mui/icons-material/PriceChange":"3tprb","@mui/icons-material/QuestionMark":"c96Ve","@mui/material/Tooltip":"3RLHy","../../../styles/theme":"i3yrR","../../../oasis-nexus/api":"dJrPU","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aOpsR":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("84f5f01db4f03420");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("41d815630f04519f"));
var _jsxRuntime = require("de4fa3a21e0781");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"
}), "AccountBalance");

},{"84f5f01db4f03420":"hykHy","41d815630f04519f":"gQLSP","de4fa3a21e0781":"g88cO"}],"9R9Rt":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("bb61a49c6d1207e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6f7defd883b95c42"));
var _jsxRuntime = require("e5e4a612e6e2b716");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1M7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1M7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), "Dns");

},{"bb61a49c6d1207e":"hykHy","6f7defd883b95c42":"gQLSP","e5e4a612e6e2b716":"g88cO"}],"3HzJ5":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("8ba315334f5a111b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("8b2bdea8cce5ab76"));
var _jsxRuntime = require("386bf2a31fe81b44");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "ExitToApp");

},{"8ba315334f5a111b":"hykHy","8b2bdea8cce5ab76":"gQLSP","386bf2a31fe81b44":"g88cO"}],"ans4Z":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("1b62e747fdbf8cbd");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("f04adad1ebce21b1"));
var _jsxRuntime = require("ff7e51b4a84e0bbd");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19c1.1 0 2-.89 2-2v-4zm-1-5.05-4.95 4.95-3.54-3.54 4.95-4.95zm-4.24-5.66L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41L14.16 2.3c-.38-.4-1.01-.4-1.4-.01"
}), "HowToVote");

},{"1b62e747fdbf8cbd":"hykHy","f04adad1ebce21b1":"gQLSP","ff7e51b4a84e0bbd":"g88cO"}],"lb5Jz":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("2d3d84fd565b5995");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("50987a757d36c37f"));
var _jsxRuntime = require("c3d7644af7a1b980");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4z"
}), "LibraryAddCheck");

},{"2d3d84fd565b5995":"hykHy","50987a757d36c37f":"gQLSP","c3d7644af7a1b980":"g88cO"}],"jXahc":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("73ad73e23915b4b");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("368c8329100829bb"));
var _jsxRuntime = require("1e35513a8a3fb94b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m14.17 13.71 1.4-2.42c.09-.15.05-.34-.08-.45l-1.48-1.16c.03-.22.05-.45.05-.68s-.02-.46-.05-.69l1.48-1.16c.13-.11.17-.3.08-.45l-1.4-2.42c-.09-.15-.27-.21-.43-.15l-1.74.7c-.36-.28-.75-.51-1.18-.69l-.26-1.85c-.03-.16-.18-.29-.35-.29h-2.8c-.17 0-.32.13-.35.3L6.8 4.15c-.42.18-.82.41-1.18.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.42c-.09.15-.05.34.08.45l1.48 1.16c-.03.22-.05.45-.05.68s.02.46.05.69l-1.48 1.16c-.13.11-.17.3-.08.45l1.4 2.42c.09.15.27.21.43.15l1.74-.7c.36.28.75.51 1.18.69l.26 1.85c.03.16.18.29.35.29h2.8c.17 0 .32-.13.35-.3l.26-1.85c.42-.18.82-.41 1.18-.69l1.74.7c.16.06.34 0 .43-.15M8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m13.11 7.67-.96-.74c.02-.14.04-.29.04-.44 0-.15-.01-.3-.04-.44l.95-.74c.08-.07.11-.19.05-.29l-.9-1.55c-.05-.1-.17-.13-.28-.1l-1.11.45c-.23-.18-.48-.33-.76-.44l-.17-1.18c-.01-.12-.11-.2-.21-.2h-1.79c-.11 0-.21.08-.22.19l-.17 1.18c-.27.12-.53.26-.76.44l-1.11-.45c-.1-.04-.22 0-.28.1l-.9 1.55c-.05.1-.04.22.05.29l.95.74c-.02.14-.03.29-.03.44 0 .15.01.3.03.44l-.95.74c-.08.07-.11.19-.05.29l.9 1.55c.05.1.17.13.28.1l1.11-.45c.23.18.48.33.76.44l.17 1.18c.02.11.11.19.22.19h1.79c.11 0 .21-.08.22-.19l.17-1.18c.27-.12.53-.26.75-.44l1.12.45c.1.04.22 0 .28-.1l.9-1.55c.06-.09.03-.21-.05-.28m-4.29.16c-.74 0-1.35-.6-1.35-1.35s.6-1.35 1.35-1.35 1.35.6 1.35 1.35-.61 1.35-1.35 1.35"
}), "MiscellaneousServices");

},{"73ad73e23915b4b":"hykHy","368c8329100829bb":"gQLSP","1e35513a8a3fb94b":"g88cO"}],"3ChS7":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("ffa2e5f361de2684");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7ba8b00450bd1ab6"));
var _jsxRuntime = require("8bc838c1ac3a31d0");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), "Person");

},{"ffa2e5f361de2684":"hykHy","7ba8b00450bd1ab6":"gQLSP","8bc838c1ac3a31d0":"g88cO"}],"3tprb":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("93813223d79e693d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7c73ef09818af61c"));
var _jsxRuntime = require("9c24bd7d0e1722b6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m-8 6H8v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1H8v-1H6v-2h4v-1H7c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1V7h2v1h2zm4 6.25-2-2h4zM14 10l2-2 2 2z"
}), "PriceChange");

},{"93813223d79e693d":"hykHy","7c73ef09818af61c":"gQLSP","9c24bd7d0e1722b6":"g88cO"}],"af34T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoundedBalance", ()=>RoundedBalance);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _theme = require("../../../styles/theme");
var _ticker = require("../../../types/ticker");
var _tokenLink = require("../Tokens/TokenLink");
var _placeholderLabel = require("../../utils/PlaceholderLabel");
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
const numberOfDecimals = 5;
const RoundedBalance = ({ ticker, value, scope, tokenAddress, tickerAsLink, compactLargeNumbers })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!value) return null;
    const number = new (0, _bignumberJsDefault.default)(value);
    const truncatedNumber = number.decimalPlaces(numberOfDecimals, (0, _bignumberJsDefault.default).ROUND_DOWN);
    const tickerName = ticker ? (0, _ticker.getNameForTicker)(t, ticker) : "";
    const tickerLink = tickerAsLink && !!scope && !!tokenAddress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
        scope: scope,
        address: tokenAddress,
        name: tickerName
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _placeholderLabel.PlaceholderLabel), {
        label: tickerName
    });
    if (number.isGreaterThan(100000) && compactLargeNumbers) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: t("common.valueInToken", {
            ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(value),
            ticker: tickerName
        }),
        enterDelay: (0, _theme.tooltipDelay),
        enterNextDelay: (0, _theme.tooltipDelay),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                t("common.valuePair", {
                    value: value,
                    formatParams: {
                        value: {
                            notation: "compact"
                        }
                    }
                }),
                "\xa0",
                tickerName
            ]
        })
    });
    if (number.isEqualTo(truncatedNumber)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
        t: t,
        i18nKey: "common.valueInTokenWithLink",
        values: {
            ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(value)
        },
        components: {
            TickerLink: tickerLink
        }
    });
    const almostZero = !number.isZero() && truncatedNumber.isZero();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
            arrow: true,
            placement: "top",
            title: t("common.valueInToken", {
                ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(value),
                ticker: tickerName
            }),
            enterDelay: (0, _theme.tooltipDelay),
            enterNextDelay: (0, _theme.tooltipDelay),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    t: t,
                    i18nKey: almostZero ? "common.lessThanAmount" : "common.roundedValueInToken",
                    values: {
                        value: truncatedNumber.toFixed(numberOfDecimals),
                        formatParams: {
                            value: {
                                minimumFractionDigits: numberOfDecimals,
                                maximumFractionDigits: numberOfDecimals
                            }
                        }
                    },
                    shouldUnescape: true,
                    components: {
                        TickerLink: tickerLink
                    }
                })
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","bignumber.js":"cQ5xL","@mui/material/Tooltip":"3RLHy","../../../styles/theme":"i3yrR","../../../types/ticker":"898HF","../Tokens/TokenLink":"ksoba","../../utils/PlaceholderLabel":"6CHug","../../../locales/getPreciseNumberFormat":"gj0Jj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ksoba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenLink", ()=>TokenLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routeUtils = require("../../utils/route-utils");
var _highlightedText = require("../HighlightedText");
const TokenLink = ({ scope, address, name, highlightedPart })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        component: (0, _reactRouterDom.Link),
        to: (0, _routeUtils.RouteUtils).getTokenRoute(scope, address),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedText.HighlightedText), {
            text: name,
            pattern: highlightedPart
        }) ?? address
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../utils/route-utils":"b2kKi","../HighlightedText":"hpIrd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6CHug":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PlaceholderLabel", ()=>PlaceholderLabel);
var _jsxRuntime = require("react/jsx-runtime");
const PlaceholderLabel = ({ label })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: label
    });

},{"react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gj0Jj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPreciseNumberFormat", ()=>getPreciseNumberFormat);
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
const isPreciseIntlSupported = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 20
})// @ts-expect-error Missing types for NumberFormat v3
.format("111222333444555666777888999.111222333444555666")// Chrome 115 and Firefox 116 return '111,222,333,444,555,666,777,888,999.111222333444555666'
// Firefox 115 and Safari 16.5 return '111,222,333,444,555,670,000,000,000'
.at(-1) === "6";
function getPreciseNumberFormat(value) {
    const decimalPlaces = new (0, _bignumberJsDefault.default)(value).decimalPlaces();
    const isFloatPrecise = new (0, _bignumberJsDefault.default)(value).isEqualTo(parseFloat(value));
    // Fallback if types are not strict enough to prevent value=undefined and ''
    if (value == null || value === "" || decimalPlaces == null) // Note: changing this to { value: '-' } would still display "NaN"
    return {
        value: "NaN"
    };
    return {
        value: value,
        formatParams: {
            value: {
                // TODO: Intl internals only work up to maximumFractionDigits: 20.
                // `new Intl.NumberFormat(undefined, { maximumFractionDigits: 21 }).format('1')`
                // throws an error, i18n silences it, and displays unformatted original string
                maximumFractionDigits: (isPreciseIntlSupported || isFloatPrecise) && decimalPlaces <= 20 ? 20 : Infinity
            }
        }
    };
}

},{"bignumber.js":"cQ5xL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"43Jgs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountLink", ()=>AccountLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _useScreensize = require("../../hooks/useScreensize");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routeUtils = require("../../utils/route-utils");
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _trimLongString = require("../../utils/trimLongString");
var _maybeWithTooltip = require("../AdaptiveTrimmer/MaybeWithTooltip");
var _adaptiveTrimmer = require("../AdaptiveTrimmer/AdaptiveTrimmer");
const WithTypographyAndLink = ({ children, to, mobile, labelOnly })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        component: "span",
        sx: {
            ...mobile ? {
                maxWidth: "100%",
                overflowX: "hidden"
            } : {}
        },
        children: labelOnly ? children : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: to,
            children: children
        })
    });
};
const AccountLink = ({ scope, address, alwaysTrim, alwaysTrimOnTable, extraTooltip, labelOnly })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const to = (0, _routeUtils.RouteUtils).getAccountRoute(scope, address);
    const extraTooltipWithIcon = extraTooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {}),
            extraTooltip
        ]
    }) : undefined;
    // Are we in a situation when we should always trim?
    if (alwaysTrim || alwaysTrimOnTable && isTablet) // In a table, we only ever want a short line
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WithTypographyAndLink, {
        to: to,
        labelOnly: labelOnly,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maybeWithTooltip.MaybeWithTooltip), {
            title: address,
            children: (0, _trimLongString.trimLongString)(address, 6, 6)
        })
    });
    if (!isTablet) // Details in desktop mode.
    // We want one long line
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WithTypographyAndLink, {
        to: to,
        labelOnly: labelOnly,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _maybeWithTooltip.MaybeWithTooltip), {
            title: extraTooltipWithIcon,
            children: [
                address,
                " "
            ]
        })
    });
    // We need to show the data in details mode on mobile.
    // Line adaptively shortened to fill available space
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WithTypographyAndLink, {
        to: to,
        mobile: true,
        labelOnly: labelOnly,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adaptiveTrimmer.AdaptiveTrimmer), {
            text: address,
            strategy: "middle",
            extraTooltip: extraTooltip
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","../../hooks/useScreensize":"2HEhN","@mui/material/Link":"fTbCF","../../utils/route-utils":"b2kKi","@mui/icons-material/Info":"kPVDs","@mui/material/Typography":"f5srd","../../utils/trimLongString":"jHX4k","../AdaptiveTrimmer/MaybeWithTooltip":"5Bddp","../AdaptiveTrimmer/AdaptiveTrimmer":"5yrqk","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eIjbt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionLink", ()=>TransactionLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _useScreensize = require("../../hooks/useScreensize");
var _routeUtils = require("../../utils/route-utils");
var _adaptiveTrimmer = require("../AdaptiveTrimmer/AdaptiveTrimmer");
var _maybeWithTooltip = require("../AdaptiveTrimmer/MaybeWithTooltip");
var _trimLongString = require("../../utils/trimLongString");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const WithTypographyAndLink = ({ children, mobile, to })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        component: "span",
        sx: {
            ...mobile ? {
                maxWidth: "85%"
            } : {}
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: to,
            children: children
        })
    });
const TransactionLink = ({ alwaysTrim, hash, scope, extraTooltip })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const to = (0, _routeUtils.RouteUtils).getTransactionRoute(scope, hash);
    const extraToolTipWithIcon = extraTooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            alignContent: "center",
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {}),
            extraTooltip
        ]
    }) : undefined;
    if (alwaysTrim) // Table mode
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WithTypographyAndLink, {
        to: to,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maybeWithTooltip.MaybeWithTooltip), {
            title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                children: [
                    hash,
                    extraToolTipWithIcon
                ]
            }),
            children: (0, _trimLongString.trimLongString)(hash, 6, 6)
        })
    });
    if (!isTablet) // Desktop mode
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WithTypographyAndLink, {
        to: to,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maybeWithTooltip.MaybeWithTooltip), {
            title: extraToolTipWithIcon,
            children: hash
        })
    });
    // Mobile mode
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WithTypographyAndLink, {
        mobile: true,
        to: to,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adaptiveTrimmer.AdaptiveTrimmer), {
            text: hash,
            strategy: "middle",
            extraTooltip: extraTooltip
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","@mui/material/Typography":"f5srd","@mui/icons-material/Info":"kPVDs","../../hooks/useScreensize":"2HEhN","../../utils/route-utils":"b2kKi","../AdaptiveTrimmer/AdaptiveTrimmer":"5yrqk","../AdaptiveTrimmer/MaybeWithTooltip":"5Bddp","../../utils/trimLongString":"jHX4k","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"as1nW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionEncrypted", ()=>TransactionEncrypted);
parcelHelpers.export(exports, "TransactionNotEncrypted", ()=>TransactionNotEncrypted);
parcelHelpers.export(exports, "TransactionEncryptionStatus", ()=>TransactionEncryptionStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _lock = require("@mui/icons-material/Lock");
var _lockDefault = parcelHelpers.interopDefault(_lock);
var _noEncryptionGmailerrorred = require("@mui/icons-material/NoEncryptionGmailerrorred");
var _noEncryptionGmailerrorredDefault = parcelHelpers.interopDefault(_noEncryptionGmailerrorred);
var _colors = require("../../../styles/theme/colors");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _theme = require("../../../styles/theme");
const TransactionEncrypted = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: t("transaction.tooltips.txEncrypted"),
        enterDelay: (0, _theme.tooltipDelay),
        enterNextDelay: (0, _theme.tooltipDelay),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lockDefault.default), {
            htmlColor: (0, _colors.COLORS).eucalyptus
        })
    });
};
const TransactionNotEncrypted = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            t: t,
            i18nKey: "transaction.tooltips.txNotEncrypted"
        }),
        enterDelay: (0, _theme.tooltipDelay),
        enterNextDelay: (0, _theme.tooltipDelay),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noEncryptionGmailerrorredDefault.default), {
            htmlColor: (0, _colors.COLORS).grayMedium2
        })
    });
};
const TransactionEncryptionStatus = ({ envelope })=>envelope ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransactionEncrypted, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransactionNotEncrypted, {});

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/Lock":"esPb2","@mui/icons-material/NoEncryptionGmailerrorred":"7ETav","../../../styles/theme/colors":"hYvW2","@mui/material/Tooltip":"3RLHy","../../../styles/theme":"i3yrR","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7ETav":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("d7b3da06cfd33b69");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("49cda44d98869a19"));
var _jsxRuntime = require("72e6fabb1684d6e4");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.27L20 17.17V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.21 0-4.07 1.45-4.73 3.44L8.9 6.07zM2.1 2.1.69 3.51 5.3 8.13C4.55 8.42 4 9.15 4 10v10c0 1.1.9 2 2 2h12c.34 0 .65-.09.93-.24l1.56 1.56 1.41-1.41zM12 17c-1.1 0-2-.9-2-2 0-.59.27-1.12.68-1.49l2.81 2.81c-.37.41-.9.68-1.49.68"
}), "NoEncryptionGmailerrorred");

},{"d7b3da06cfd33b69":"hykHy","49cda44d98869a19":"gQLSP","72e6fabb1684d6e4":"g88cO"}],"2qpf4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusTransactions", ()=>ConsensusTransactions);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _table = require("../../components/Table");
var _roundedBalance = require("../../components/RoundedBalance");
var _blockLink = require("../Blocks/BlockLink");
var _accountLink = require("../Account/AccountLink");
var _statusIcon = require("../StatusIcon");
var _age = require("../Age");
var _transactionLink = require("./TransactionLink");
var _consensusTransactionMethod = require("../ConsensusTransactionMethod");
const ConsensusTransactions = ({ isLoading, limit, pagination, transactions, ownAddress, verbose = true })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const tableColumns = [
        {
            key: "status",
            content: t("common.status")
        },
        {
            key: "hash",
            content: t("common.hash")
        },
        {
            key: "block",
            content: t("common.block")
        },
        {
            key: "age",
            content: t("common.age")
        },
        ...verbose ? [
            {
                key: "method",
                content: t("common.method")
            },
            {
                key: "from",
                content: t("common.from"),
                width: "150px"
            },
            {
                key: "to",
                content: t("common.to"),
                width: "150px"
            },
            {
                key: "txnFee",
                content: t("common.transactionFee"),
                align: (0, _table.TableCellAlign).Right,
                width: "250px"
            },
            {
                key: "value",
                align: (0, _table.TableCellAlign).Right,
                content: t("common.value"),
                width: "250px"
            }
        ] : []
    ];
    const tableRows = transactions?.map((transaction)=>({
            key: `${transaction.hash}${transaction.index}`,
            data: [
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
                        success: transaction.success,
                        error: transaction.error
                    }),
                    key: "success"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionLink.TransactionLink), {
                        scope: transaction,
                        alwaysTrim: true,
                        hash: transaction.hash
                    }),
                    key: "hash"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: transaction,
                        height: transaction.block
                    }),
                    key: "round"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _age.Age), {
                        sinceTimestamp: transaction.timestamp
                    }),
                    key: "timestamp"
                },
                ...verbose ? [
                    {
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.ConsensusTransactionMethod), {
                            method: transaction.method,
                            truncate: true
                        }),
                        key: "method"
                    },
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                pr: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                labelOnly: !!ownAddress && transaction.sender === ownAddress,
                                scope: transaction,
                                address: transaction.sender,
                                alwaysTrim: true
                            })
                        }),
                        key: "from"
                    },
                    {
                        // TODO: show recipients address when props is added to API
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        }),
                        key: "to"
                    },
                    {
                        align: (0, _table.TableCellAlign).Right,
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                            value: transaction.fee,
                            ticker: transaction.ticker
                        }),
                        key: "fee_amount"
                    },
                    {
                        align: (0, _table.TableCellAlign).Right,
                        // TODO: show RoundedBalance when API returns amount prop
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        }),
                        key: "value"
                    }
                ] : []
            ],
            highlight: transaction.markAsNew
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("transactions.latest"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","../../components/Table":"j3qb1","../../components/RoundedBalance":"af34T","../Blocks/BlockLink":"g8oEe","../Account/AccountLink":"43Jgs","../StatusIcon":"3VOhR","../Age":"eWnEg","./TransactionLink":"eIjbt","../ConsensusTransactionMethod":"2QV5X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"246yY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _errorDisplay = require("../ErrorDisplay");
class ErrorBoundary extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDisplay.ErrorDisplay), {
            error: this.state.error,
            light: this.props.light
        });
        return this.props.children;
    }
}

},{"react/jsx-runtime":"g88cO","react":"BK2ob","../ErrorDisplay":"enjir","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"enjir":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorFormatter", ()=>errorFormatter);
parcelHelpers.export(exports, "ErrorDisplay", ()=>ErrorDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _emptyState = require("../EmptyState");
var _errors = require("../../../types/errors");
var _goToFirstPageLink = require("../Table/GoToFirstPageLink");
const errorMap = {
    [(0, _errors.AppErrors).Unknown]: (t, error)=>({
            title: t("errors.unknown"),
            message: error.message
        }),
    [(0, _errors.AppErrors).InvalidAddress]: (t)=>({
            title: t("errors.invalidAddress"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).InvalidBlockHeight]: (t)=>({
            title: t("errors.invalidBlockHeight"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).InvalidTxHash]: (t)=>({
            title: t("errors.invalidTxHash"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).InvalidProposalId]: (t)=>({
            title: t("errors.invalidProposalId"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).InvalidPageNumber]: (t)=>({
            title: t("errors.invalidPageNumber"),
            message: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                t: t,
                i18nKey: "errors.validateURLOrGoToFirstPage",
                components: {
                    FirstPageLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goToFirstPageLink.GoToFirstPageLink), {})
                }
            })
        }),
    [(0, _errors.AppErrors).PageDoesNotExist]: (t)=>({
            title: t("errors.pageDoesNotExist"),
            message: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                t: t,
                i18nKey: "errors.validateURLOrGoToFirstPage",
                components: {
                    FirstPageLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goToFirstPageLink.GoToFirstPageLink), {})
                }
            })
        }),
    [(0, _errors.AppErrors).NotFoundBlockHeight]: (t)=>({
            title: t("errors.notFoundBlockHeight"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).NotFoundTxHash]: (t)=>({
            title: t("errors.notFoundTx"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).NotFoundProposalId]: (t)=>({
            title: t("errors.notFoundProposal"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).InvalidUrl]: (t)=>({
            title: t("errors.invalidUrl"),
            message: t("errors.validateURL")
        }),
    [(0, _errors.AppErrors).UnsupportedLayer]: (t)=>({
            title: t("errors.error"),
            message: t("errors.unsupportedLayer")
        }),
    [(0, _errors.AppErrors).UnsupportedNetwork]: (t)=>({
            title: t("errors.error"),
            message: t("errors.unsupportedNetwork")
        }),
    [(0, _errors.AppErrors).Storage]: (t)=>({
            title: t("errors.error"),
            message: t("errors.storage")
        }),
    [(0, _errors.AppErrors).InvalidVote]: (t)=>({
            title: t("errors.invalidVote"),
            message: null
        })
};
const errorFormatter = (t, error)=>{
    return errorMap[error.code](t, error);
};
const ErrorDisplay = ({ error, light })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    let errorPayload;
    if ((0, _reactRouterDom.isRouteErrorResponse)(error)) errorPayload = {
        code: (0, _errors.AppErrors).Unknown,
        message: error.statusText
    };
    else if (error instanceof (0, _errors.AppError)) errorPayload = {
        code: error.type,
        message: error.message
    };
    else if (error instanceof Error) errorPayload = {
        code: (0, _errors.AppErrors).Unknown,
        message: error.message
    };
    else if (typeof error === "string" && errorMap[error]) errorPayload = {
        code: error,
        message: "oops"
    };
    else errorPayload = {
        code: (0, _errors.AppErrors).Unknown,
        message: error
    };
    const { title, message } = errorFormatter(t, errorPayload);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
        title: title,
        description: message,
        light: light
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","../EmptyState":"5d6vv","../../../types/errors":"gdpNU","../Table/GoToFirstPageLink":"i2BTa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5d6vv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyState", ()=>EmptyState);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _backgroundEmptyStateSvg = require("./images/background-empty-state.svg");
var _backgroundEmptyStateSvgDefault = parcelHelpers.interopDefault(_backgroundEmptyStateSvg);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "250px",
        color: theme.palette.layout.main,
        backgroundColor: theme.palette.background.empty,
        backgroundImage: `url("${0, _backgroundEmptyStateSvgDefault.default}")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: 12
    }));
const StyledBoxLight = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: "250px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
    }));
const EmptyState = ({ description, title, light })=>{
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "24px",
                    fontWeight: 600
                },
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "16px"
                },
                children: description
            })
        ]
    });
    return light ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBoxLight, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
                color: "error",
                fontSize: "large"
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
        children: content
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","./images/background-empty-state.svg":"c3wWB","@mui/icons-material/Cancel":"l7K6K","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"c3wWB":[function(require,module,exports) {
module.exports = require("e456a89c89d3875b").getBundleURL("sif1r") + "background-empty-state.a5413910.svg";

},{"e456a89c89d3875b":"ccgWN"}],"i2BTa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoToFirstPageLink", ()=>GoToFirstPageLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
const GoToFirstPageLink = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const wantedParamName = searchParams.has("page") ? "page" : undefined;
    const label = t("errors.loadFirstPage");
    const newSearchParams = new URLSearchParams(searchParams);
    if (wantedParamName) newSearchParams.delete(wantedParamName);
    const href = (0, _reactRouterDom.useHref)({
        search: newSearchParams.toString()
    });
    // Ideally, we should use a router link here, but even if we change the URL without a reload,
    // I can't get the error boundary to recover from the error state.
    // when jumping to the first page, the ErrorBoundary component stays in place, only the internals change.
    // But to show the first page, the Error Boundary component would need to switch back from the "error" state
    // to the "normal" state, which doesn't happen automatically.
    // In needs a manual `setState()` for recovering, which is hard to channel through,
    // but even if we do it (which I did as an experiment), we find that
    // the data around the ErrorBoundary is somewhat weird, and the updated URL is not reflected right away,
    // so we just end up running into the same exception again...
    // Apparently the solution is to umount and rerender the component outside the error boundary.
    // But that's hard to do selectively, so it's easier to just do a full refresh.
    return wantedParamName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        href: href,
        sx: {
            cursor: "pointer"
        },
        children: label
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: label
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k1EO2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardLink", ()=>DashboardLink);
var _jsxRuntime = require("react/jsx-runtime");
var _searchScope = require("../../../types/searchScope");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _routeUtils = require("../../utils/route-utils");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
const DashboardLink = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            component: (0, _reactRouterDom.Link),
            to: (0, _routeUtils.RouteUtils).getDashboardRoute(scope),
            children: (0, _searchScope.getNameForScope)(t, scope)
        })
    });
};

},{"react/jsx-runtime":"g88cO","../../../types/searchScope":"6SEv5","@mui/material/Typography":"f5srd","../../utils/route-utils":"b2kKi","@mui/material/Link":"fTbCF","react-router-dom":"5o0mA","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"53s87":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventsContainerId", ()=>eventsContainerId);
parcelHelpers.export(exports, "EventsCard", ()=>EventsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _scrollingCard = require("../../components/PageLayout/ScrollingCard");
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _api = require("../../../oasis-nexus/api");
var _errorBoundary = require("../../components/ErrorBoundary");
var _errors = require("../../../types/errors");
var _runtimeEventsDetailedList = require("../../components/RuntimeEvents/RuntimeEventsDetailedList");
var _addressSwitch = require("../../components/AddressSwitch");
var _emptyState = require("../../components/EmptyState");
const eventsContainerId = "events";
const EventsList = ({ scope, blockHeight })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (scope.layer === (0, _api.Layer).consensus) // Loading events for consensus blocks is not yet supported.
    // Should use useGetConsensusEvents()
    throw (0, _errors.AppErrors).UnsupportedLayer;
    const eventsQuery = (0, _api.useGetRuntimeEvents)(scope.network, scope.layer, {
        block: blockHeight,
        // TODO: search for tx_hash = null
        limit: 100
    });
    const { isLoading, isError, data } = eventsQuery;
    const events = data?.data.events;
    if (!events?.length && !isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
        description: t("runtimeEvent.cantFindMatchingEvents"),
        title: t("runtimeEvent.noEvents"),
        light: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeEventsDetailedList.RuntimeEventsDetailedList), {
        scope: scope,
        events: events,
        isLoading: isLoading,
        isError: isError,
        addressSwitchOption: (0, _addressSwitch.AddressSwitchOption).ETH
    });
};
const EventsCard = ({ scope, blockHeight })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _scrollingCard.ScrollingCard), {
        id: eventsContainerId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("common.events")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventsList, {
                        scope: scope,
                        blockHeight: blockHeight
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/PageLayout/ScrollingCard":"2xGtb","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../../oasis-nexus/api":"dJrPU","../../components/ErrorBoundary":"246yY","../../../types/errors":"gdpNU","../../components/RuntimeEvents/RuntimeEventsDetailedList":"8KNdh","../../components/AddressSwitch":"eKQmb","../../components/EmptyState":"5d6vv","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8KNdh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEventsDetailedList", ()=>RuntimeEventsDetailedList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _cardEmptyState = require("../CardEmptyState");
var _skeleton = require("../Skeleton");
var _runtimeEventDetails = require("./RuntimeEventDetails");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
const RuntimeEventDetailsWithSeparator = ({ scope, event, isFirst, addressSwitchOption })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !isFirst && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "card"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeEventDetails.RuntimeEventDetails), {
                scope: scope,
                event: event,
                addressSwitchOption: addressSwitchOption
            })
        ]
    });
};
const RuntimeEventsDetailedList = ({ scope, events, isLoading, isError, addressSwitchOption })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("runtimeEvent.cantLoadEvents")
            }),
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
                numberOfRows: 10
            }),
            events && events.map((event, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimeEventDetailsWithSeparator, {
                    scope: scope,
                    isFirst: !index,
                    event: event,
                    addressSwitchOption: addressSwitchOption
                }, `event-${index}`))
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../CardEmptyState":"aiX1q","../Skeleton":"eB5vc","./RuntimeEventDetails":"b73VP","@mui/material/Divider":"3hI6U","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aiX1q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardEmptyState", ()=>CardEmptyState);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _reportProblem = require("@mui/icons-material/ReportProblem");
var _reportProblemDefault = parcelHelpers.interopDefault(_reportProblem);
var _colors = require("../../../styles/theme/colors");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        gap: theme.spacing(4),
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(5, 2, 6)
        },
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(6, 4, 7)
        }
    }));
const CardEmptyState = ({ label })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportProblemDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).warningColor,
                    fontSize: "60px"
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).grayDark
                },
                children: label
            })
        ]
    });

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@mui/icons-material/ReportProblem":"b2rMP","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b2rMP":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("c05db14944854fcf");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("16ac8b9cf1dbf525"));
var _jsxRuntime = require("1da79dbba14ce73b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "ReportProblem");

},{"c05db14944854fcf":"hykHy","16ac8b9cf1dbf525":"gQLSP","1da79dbba14ce73b":"g88cO"}],"b73VP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventTypeIcon", ()=>EventTypeIcon);
parcelHelpers.export(exports, "RuntimeEventDetails", ()=>RuntimeEventDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _api = require("../../../oasis-nexus/api");
var _reactI18Next = require("react-i18next");
var _styledDescriptionList = require("../StyledDescriptionList");
var _useScreensize = require("../../hooks/useScreensize");
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _accountLink = require("../Account/AccountLink");
var _copyToClipboard = require("../CopyToClipboard");
var _addressSwitch = require("../AddressSwitch");
var _helpers = require("../../utils/helpers");
var _errors = require("../../../types/errors");
var _longDataDisplay = require("../LongDataDisplay");
var _parseEvmEvent = require("../../utils/parseEvmEvent");
var _tokenTransferIcon = require("../Tokens/TokenTransferIcon");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _stream = require("@mui/icons-material/Stream");
var _streamDefault = parcelHelpers.interopDefault(_stream);
var _localFireDepartment = require("@mui/icons-material/LocalFireDepartment");
var _localFireDepartmentDefault = parcelHelpers.interopDefault(_localFireDepartment);
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
var _eventError = require("./EventError");
var _accountLinkWithAddressSwitch = require("../Account/AccountLinkWithAddressSwitch");
var _arrowDownward = require("@mui/icons-material/ArrowDownward");
var _arrowDownwardDefault = parcelHelpers.interopDefault(_arrowDownward);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _arrowUpward = require("@mui/icons-material/ArrowUpward");
var _arrowUpwardDefault = parcelHelpers.interopDefault(_arrowUpward);
var _lan = require("@mui/icons-material/Lan");
var _lanDefault = parcelHelpers.interopDefault(_lan);
var _lanOutlined = require("@mui/icons-material/LanOutlined");
var _lanOutlinedDefault = parcelHelpers.interopDefault(_lanOutlined);
var _consensusTransactionMethod = require("../ConsensusTransactionMethod");
var Buffer = require("62c924388f1bfcec").Buffer;
const getRuntimeEventMethodLabel = (t, method)=>{
    switch(method){
        case (0, _api.RuntimeEventType).accountstransfer:
            return t("runtimeEvent.accountstransfer");
        case (0, _api.RuntimeEventType).evmlog:
            return t("runtimeEvent.evmLog");
        case (0, _api.RuntimeEventType).coregas_used:
            return t("runtimeEvent.gasUsed");
        case (0, _api.RuntimeEventType).consensus_accountswithdraw:
            return t("runtimeEvent.consensusWithdrawal");
        case (0, _api.RuntimeEventType).consensus_accountsdeposit:
            return t("runtimeEvent.consensusDeposit");
        case (0, _api.RuntimeEventType).consensus_accountsdelegate:
            return t("runtimeEvent.consensusDelegate");
        case (0, _api.RuntimeEventType).consensus_accountsundelegate_start:
            return t("runtimeEvent.consensusUndelegateStart");
        case (0, _api.RuntimeEventType).consensus_accountsundelegate_done:
            return t("runtimeEvent.consensusUndelegateDone");
        case (0, _api.RuntimeEventType).accountsmint:
            return t("runtimeEvent.accountsmint");
        case (0, _api.RuntimeEventType).accountsburn:
            return t("runtimeEvent.accountsburn");
        default:
            return method || t("common.unknown");
    }
};
const EventTypeIcon = ({ eventType })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const label = getRuntimeEventMethodLabel(t, eventType);
    const props = {
        border: false,
        label,
        reverseLabel: true,
        size: 25
    };
    const eventTypeIcons = {
        [(0, _api.RuntimeEventType).accountstransfer]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            color: "green",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).evmlog]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
        [(0, _api.RuntimeEventType).coregas_used]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
        [(0, _api.RuntimeEventType).consensus_accountswithdraw]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            color: "orange",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowUpwardDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).consensus_accountsdeposit]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            color: "green",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDownwardDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).consensus_accountsdelegate]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lanDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).consensus_accountsundelegate_start]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lanOutlinedDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).consensus_accountsundelegate_done]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lanDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).accountsmint]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            color: "green",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamDefault.default), {}),
            ...props
        }),
        [(0, _api.RuntimeEventType).accountsburn]: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
            color: "orange",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _localFireDepartmentDefault.default), {}),
            ...props
        })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
            children: eventTypeIcons[eventType]
        })
    });
};
const EvmEventParamData = ({ scope, param, address, alwaysTrimOnTable })=>{
    /**
   * According to the API docs:
   *
   * Values of EVM type `int128`, `uint128`, `int256`, `uint256`, `fixed`, and `ufixed` are represented as strings.
   * Values of EVM type `address` and `address payable` are represented as lowercase hex strings with a "0x" prefix.
   * Values of EVM type `bytes` and `bytes<N>` are represented as base64 strings.
   * Values of other EVM types (integer types, strings, arrays, etc.) are represented as their JSON counterpart.
   */ switch(param.evm_type){
        // TODO: handle more EVM types
        case "address":
            return address ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                address: address,
                scope: scope,
                alwaysTrimOnTable: alwaysTrimOnTable
            }) : null;
        case "uint256":
            // TODO: format with BigNumber
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: param.value
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: JSON.stringify(param.value, null, "  ")
            });
    }
};
const EvmLogRow = ({ scope, param, addressSwitchOption })=>{
    const evmAddress = param.evm_type === "address" ? param.value : undefined;
    const oasisAddress = evmAddress ? (0, _helpers.getOasisAddress)(evmAddress) : undefined;
    const address = addressSwitchOption === (0, _addressSwitch.AddressSwitchOption).Oasis ? oasisAddress : evmAddress;
    const getCopyToClipboardValue = ()=>{
        if (address) return address;
        return typeof param.value === "string" ? param.value : JSON.stringify(param.value, null, "  ");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                children: param.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                children: param.evm_type
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(EvmEventParamData, {
                        scope: scope,
                        param: param,
                        address: address,
                        alwaysTrimOnTable: true
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                    value: getCopyToClipboardValue()
                })
            })
        ]
    });
};
const RuntimeEventDetails = ({ scope, event, addressSwitchOption })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const eventName = getRuntimeEventMethodLabel(t, event.type);
    switch(event.type){
        case (0, _api.RuntimeEventType).coregas_used:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    eventName,
                    ": ",
                    event.body.amount.toLocaleString()
                ]
            });
        case (0, _api.RuntimeEventType).evmlog:
            {
                const { parsedEvmLogName } = (0, _parseEvmEvent.parseEvmEvent)(event);
                const emittingEthAddress = `0x${Buffer.from(event.body.address, "base64").toString("hex")}`;
                const emittingOasisAddress = (0, _helpers.getOasisAddress)(emittingEthAddress);
                if (!event.evm_log_name && !event.evm_log_params) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                            children: eventName
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        t("runtimeEvent.fields.topics"),
                        ":",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "mono",
                            fontWeight: 400,
                            sx: {
                                display: "block",
                                whiteSpace: "pre-wrap",
                                overflowWrap: "break-word"
                            },
                            children: event.body.topics/* @ts-expect-error -- Event body is missing types */ .map((base64Topic, index)=>{
                                return `${index}: 0x${Buffer.from(base64Topic, "base64").toString("hex")}`;
                            }).join("\n")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        t("runtimeEvent.fields.data"),
                        ":",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _longDataDisplay.LongDataDisplay), {
                            data: `0x${Buffer.from(event.body.data, "base64").toString("hex")}`,
                            fontWeight: 400
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        t("runtimeEvent.fields.emittingContract"),
                        ":",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.WrappedAccountLinkWithAddressSwitch), {
                            scope: scope,
                            addressSwitchOption: addressSwitchOption,
                            ethAddress: emittingEthAddress,
                            oasisAddress: emittingOasisAddress
                        })
                    ]
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTransferIcon.TokenTransferIcon), {
                                    reverseLabel: true,
                                    method: parsedEvmLogName,
                                    size: 25
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        event.evm_log_params && event.evm_log_params.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                            sx: {
                                border: "1px solid lightgray"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                children: t("common.name")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                children: t("common.type")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                                children: t("common.data")
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                                    children: event.evm_log_params.map((param, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(EvmLogRow, {
                                            scope: scope,
                                            param: param,
                                            addressSwitchOption: addressSwitchOption
                                        }, `param-${index}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        t("runtimeEvent.fields.emittingContract"),
                        ":",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.WrappedAccountLinkWithAddressSwitch), {
                            scope: scope,
                            addressSwitchOption: addressSwitchOption,
                            ethAddress: emittingEthAddress,
                            oasisAddress: emittingOasisAddress
                        })
                    ]
                });
            }
        case (0, _api.RuntimeEventType).accountsburn:
        case (0, _api.RuntimeEventType).accountsmint:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTypeIcon, {
                        eventType: event.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                        titleWidth: isMobile ? "100px" : "200px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.owner")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.owner_eth,
                                    oasisAddress: event.body.owner
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.amount")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueInToken", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(event.body.amount.Amount),
                                    ticker: event.body.amount.Denomination
                                })
                            })
                        ]
                    })
                ]
            });
        case (0, _api.RuntimeEventType).accountstransfer:
        case (0, _api.RuntimeEventType).consensus_accountsdeposit:
        case (0, _api.RuntimeEventType).consensus_accountswithdraw:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTypeIcon, {
                        eventType: event.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                        titleWidth: isMobile ? "100px" : "200px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventError.MaybeEventErrorLine), {
                                event: event
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.from")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.from_eth,
                                    oasisAddress: event.body.from
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.to")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.to_eth,
                                    oasisAddress: event.body.to
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.amount")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueInToken", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(event.body.amount.Amount),
                                    ticker: event.body.amount?.Denomination
                                })
                            })
                        ]
                    })
                ]
            });
        case (0, _api.RuntimeEventType).consensus_accountsdelegate:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTypeIcon, {
                        eventType: event.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                        titleWidth: isMobile ? "100px" : "200px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventError.MaybeEventErrorLine), {
                                event: event
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.from")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.from_eth,
                                    oasisAddress: event.body.from
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.to")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.to_eth,
                                    oasisAddress: event.body.to
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.amount")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueInToken", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(event.body.amount.Amount),
                                    ticker: event.body.amount.Denomination
                                })
                            })
                        ]
                    })
                ]
            });
        case (0, _api.RuntimeEventType).consensus_accountsundelegate_start:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTypeIcon, {
                        eventType: event.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                        titleWidth: isMobile ? "100px" : "200px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventError.MaybeEventErrorLine), {
                                event: event
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.from")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.from_eth,
                                    oasisAddress: event.body.from
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.to")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.to_eth,
                                    oasisAddress: event.body.to
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.activeShares")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueLong", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(event.body.shares)
                                })
                            })
                        ]
                    })
                ]
            });
        case (0, _api.RuntimeEventType).consensus_accountsundelegate_done:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventTypeIcon, {
                        eventType: event.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                        titleWidth: isMobile ? "100px" : "200px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventError.MaybeEventErrorLine), {
                                event: event
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.from")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.from_eth,
                                    oasisAddress: event.body.from
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.to")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLinkWithAddressSwitch.AccountLinkWithAddressSwitch), {
                                    scope: scope,
                                    addressSwitchOption: addressSwitchOption,
                                    ethAddress: event.body.to_eth,
                                    oasisAddress: event.body.to
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.amount")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueInToken", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(event.body.amount.Amount),
                                    ticker: event.body.amount.Denomination
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("runtimeEvent.fields.debondingShares")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueLong", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(event.body.shares)
                                })
                            })
                        ]
                    })
                ]
            });
        default:
            (0, _errors.exhaustedTypeWarning)("Unexpected event type", event.type);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                        children: event.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                        children: JSON.stringify(event, null, " ")
                    })
                ]
            });
    }
};

},{"62c924388f1bfcec":"eHuUs","react/jsx-runtime":"g88cO","../../../oasis-nexus/api":"dJrPU","react-i18next":"e210a","../StyledDescriptionList":"bndrS","../../hooks/useScreensize":"2HEhN","@mui/material/Table":"7XUZM","@mui/material/TableHead":"9JUxY","@mui/material/TableRow":"2fJxU","@mui/material/TableCell":"7tad7","@mui/material/TableBody":"1L7nL","../Account/AccountLink":"43Jgs","../CopyToClipboard":"iTQvM","../AddressSwitch":"eKQmb","../../utils/helpers":"2aVNs","../../../types/errors":"gdpNU","../LongDataDisplay":"6B93E","../../utils/parseEvmEvent":"2rjsg","../Tokens/TokenTransferIcon":"epRIa","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/icons-material/Stream":"iO4Su","@mui/icons-material/LocalFireDepartment":"lwsIA","../../../locales/getPreciseNumberFormat":"gj0Jj","./EventError":"4wOsE","../Account/AccountLinkWithAddressSwitch":"98d3W","@mui/icons-material/ArrowDownward":"7cLed","@mui/icons-material/ArrowForward":"bwHID","@mui/icons-material/ArrowUpward":"l2vTC","@mui/icons-material/Lan":"hUYtK","@mui/icons-material/LanOutlined":"kdoX4","../ConsensusTransactionMethod":"2QV5X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eKQmb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressSwitchOption", ()=>AddressSwitchOption);
parcelHelpers.export(exports, "AddressSwitch", ()=>AddressSwitch);
var _jsxRuntime = require("react/jsx-runtime");
var _switch = require("@mui/material/Switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _styles = require("@mui/material/styles");
var _oasisSvg = require("./images/oasis.svg");
var _oasisSvgDefault = parcelHelpers.interopDefault(_oasisSvg);
var _ethSvg = require("./images/eth.svg");
var _ethSvgDefault = parcelHelpers.interopDefault(_ethSvg);
var _colors = require("../../../styles/theme/colors");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactI18Next = require("react-i18next");
var _useScreensize = require("../../hooks/useScreensize");
const StyledAddressSwitch = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(3)
    }));
const StyledSwitch = (0, _styles.styled)((0, _switchDefault.default))(()=>({
        zoom: 2,
        margin: "-8px",
        [`.${(0, _switch.switchClasses).switchBase} .${(0, _switch.switchClasses).thumb}`]: {
            backgroundColor: (0, _colors.COLORS).brandMedium,
            backgroundImage: `url("${0, _oasisSvgDefault.default}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "15px"
        },
        [`.${(0, _switch.switchClasses).switchBase}.${(0, _switch.switchClasses).checked} .${(0, _switch.switchClasses).thumb}`]: {
            backgroundColor: (0, _colors.COLORS).lightSilver,
            backgroundImage: `url("${0, _ethSvgDefault.default}")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "10px"
        },
        [`&&&& .${(0, _switch.switchClasses).track}`]: {
            opacity: 1,
            backgroundColor: (0, _colors.COLORS).grayMedium2
        }
    }));
var AddressSwitchOption;
(function(AddressSwitchOption) {
    AddressSwitchOption["Oasis"] = "oasis";
    AddressSwitchOption["ETH"] = "eth";
})(AddressSwitchOption || (AddressSwitchOption = {}));
const AddressSwitch = ({ selected = "eth", onSelectionChange })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const checked = selected === "eth";
    const onChange = (event, checked)=>{
        onSelectionChange(checked ? "eth" : "oasis");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledAddressSwitch, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    color: selected === "oasis" ? isMobile ? (0, _colors.COLORS).white : (0, _colors.COLORS).brandExtraDark : (0, _colors.COLORS).grayMedium2,
                    fontSize: "10px"
                },
                children: t("common.oasis")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSwitch, {
                checked: checked,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    color: selected === "eth" ? isMobile ? (0, _colors.COLORS).white : (0, _colors.COLORS).brandExtraDark : (0, _colors.COLORS).grayMedium2,
                    fontSize: "10px"
                },
                children: t("common.eth")
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Switch":"9qXnI","@mui/material/styles":"51PGx","./images/oasis.svg":"btrek","./images/eth.svg":"7DILM","../../../styles/theme/colors":"hYvW2","@mui/material/Typography":"f5srd","@mui/material/Box":"4d7LG","react-i18next":"e210a","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"btrek":[function(require,module,exports) {
module.exports = require("7f6c6f2066d508c1").getBundleURL("sif1r") + "oasis.3f0060d9.svg";

},{"7f6c6f2066d508c1":"ccgWN"}],"7DILM":[function(require,module,exports) {
module.exports = require("b2c9277ad08cb582").getBundleURL("sif1r") + "eth.28f57e49.svg";

},{"b2c9277ad08cb582":"ccgWN"}],"6B93E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LongDataDisplay", ()=>LongDataDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
const StyledButton = (0, _styles.styled)((0, _buttonDefault.default))(({ theme })=>({
        color: (0, _colors.COLORS).brandDark,
        fontWeight: 700,
        minWidth: "auto",
        height: "auto",
        padding: 0,
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(3, 0, 0, 0)
        },
        [theme.breakpoints.up("sm")]: {
            margin: theme.spacing(4, 0, 0, 0)
        },
        "&&:hover, &&:active, &&:focus-visible": {
            color: (0, _colors.COLORS).brandDark,
            textDecoration: "none",
            borderRadius: 0
        }
    }));
const lineHeight = 22;
const LongDataDisplay = ({ data, fontWeight = 700, collapsedLinesNumber = 2 })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    const [isOverflowing, setIsOverflowing] = (0, _react.useState)(false);
    const textRef = (0, _react.useRef)(null);
    const collapsedContainerMaxHeight = collapsedLinesNumber * lineHeight;
    (0, _react.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (textRef.current) {
                const isOverflow = textRef.current.scrollHeight > textRef.current.clientHeight;
                setIsOverflowing(isOverflow);
            }
        };
        checkOverflow();
        const handleResize = ()=>{
            checkOverflow();
        };
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "mono",
                ref: textRef,
                sx: {
                    fontWeight,
                    maxHeight: isExpanded ? "none" : collapsedContainerMaxHeight,
                    overflow: "hidden",
                    lineHeight: `${lineHeight}px`,
                    overflowWrap: "anywhere",
                    display: "-webkit-box",
                    WebkitLineClamp: isExpanded ? "none" : collapsedLinesNumber,
                    WebkitBoxOrient: "vertical"
                },
                children: data
            }),
            (isOverflowing || isExpanded) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                onClick: ()=>setIsExpanded(!isExpanded),
                children: isExpanded ? t("common.hide") : t("common.show")
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Button":"h2G5p","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2rjsg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseEvmEvent", ()=>parseEvmEvent);
const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
function parseEvmEvent(event) {
    const fromAddress = event.evm_log_params?.find((param)=>param.name === "from")?.value;
    const toAddress = event.evm_log_params?.find((param)=>param.name === "to")?.value;
    const isMinting = fromAddress === NULL_ADDRESS;
    const isBurning = toAddress === NULL_ADDRESS;
    const parsedEvmLogName = isMinting ? "Minting" : isBurning ? "Burning" : event.evm_log_name || undefined;
    return {
        fromAddress,
        toAddress,
        isMinting,
        isBurning,
        parsedEvmLogName
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"epRIa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenTransferIcon", ()=>TokenTransferIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _stream = require("@mui/icons-material/Stream");
var _streamDefault = parcelHelpers.interopDefault(_stream);
var _localFireDepartment = require("@mui/icons-material/LocalFireDepartment");
var _localFireDepartmentDefault = parcelHelpers.interopDefault(_localFireDepartment);
var _approval = require("@mui/icons-material/Approval");
var _approvalDefault = parcelHelpers.interopDefault(_approval);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _questionMark = require("@mui/icons-material/QuestionMark");
var _questionMarkDefault = parcelHelpers.interopDefault(_questionMark);
var _consensusTransactionMethod = require("../ConsensusTransactionMethod");
const getTokenTransferLabel = (t, name)=>{
    switch(name){
        case undefined:
            return t("tokens.transferEventType.unavailable");
        case "Transfer":
            return t("tokens.transferEventType.transfer");
        case "Approval":
            return t("tokens.transferEventType.approval");
        case "Minting":
            return t("tokens.transferEventType.minting");
        case "Burning":
            return t("tokens.transferEventType.burning");
        default:
            return name || t("common.unknown");
    }
};
const getTokenTransferIcon = (name, label, reverseLabel, size)=>{
    const props = {
        border: false,
        label,
        reverseLabel,
        size
    };
    switch(name){
        case "Transfer":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {}),
                ...props
            });
        case "Approval":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _approvalDefault.default), {}),
                ...props
            });
        case "Minting":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "green",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _streamDefault.default), {}),
                ...props
            });
        case "Burning":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "orange",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _localFireDepartmentDefault.default), {}),
                ...props
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.MethodIcon), {
                color: "gray",
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionMarkDefault.default), {}),
                ...props
            });
    }
};
const TokenTransferIcon = ({ method, reverseLabel, size })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const label = getTokenTransferLabel(t, method);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: getTokenTransferIcon(method, label, reverseLabel, size)
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/Stream":"iO4Su","@mui/icons-material/LocalFireDepartment":"lwsIA","@mui/icons-material/Approval":"1e1RF","@mui/icons-material/ArrowForward":"bwHID","@mui/icons-material/QuestionMark":"c96Ve","../ConsensusTransactionMethod":"2QV5X","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iO4Su":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("464a20f62dcb36a9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7d20c67eeec94a7"));
var _jsxRuntime = require("c63d86def83f8cc3");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "20",
        cy: "12",
        r: "2"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "4",
        cy: "12",
        r: "2"
    }, "1"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "12",
        cy: "20",
        r: "2"
    }, "2"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M10.05 8.59 6.03 4.55h-.01l-.31-.32-1.42 1.41 4.02 4.05.01-.01.31.32zm3.893.027 4.405-4.392L19.76 5.64l-4.405 4.393zM10.01 15.36l-1.42-1.41-4.03 4.01-.32.33 1.41 1.41 4.03-4.02zm9.75 2.94-3.99-4.01-.36-.35L14 15.35l3.99 4.01.35.35z"
    }, "3"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "12",
        cy: "4",
        r: "2"
    }, "4")
], "Stream");

},{"464a20f62dcb36a9":"hykHy","7d20c67eeec94a7":"gQLSP","c63d86def83f8cc3":"g88cO"}],"lwsIA":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("5763a78d3f8dd118");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("e564f7bcb9f363d4"));
var _jsxRuntime = require("bb01b8e1e1ad4ed2");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"
    }, "1")
], "LocalFireDepartment");

},{"5763a78d3f8dd118":"hykHy","e564f7bcb9f363d4":"gQLSP","bb01b8e1e1ad4ed2":"g88cO"}],"1e1RF":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("3df49c2274c4996a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b396ce745c71e09f"));
var _jsxRuntime = require("c915ed0302bba512");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2m14 2H6v-2h12zM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5m0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3z"
}), "Approval");

},{"3df49c2274c4996a":"hykHy","b396ce745c71e09f":"gQLSP","c915ed0302bba512":"g88cO"}],"4wOsE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventError", ()=>EventError);
parcelHelpers.export(exports, "MaybeEventErrorLine", ()=>MaybeEventErrorLine);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _statusIcon = require("../StatusIcon");
const EventError = ({ event })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const error = event.body.error;
    if (!error) return null;
    const errorMessage = `${t("errors.code")} ${error.code}, ${t("errors.module")}: ${error.module}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _statusIcon.StyledBox), {
                success: false,
                error: undefined,
                withText: true,
                children: [
                    t("common.failed"),
                    "\xa0",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
                        color: "error",
                        fontSize: "inherit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.ErrorBox), {
                children: errorMessage
            })
        ]
    });
};
const MaybeEventErrorLine = ({ event })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return event.body.error && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.status")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                style: {
                    flexWrap: "wrap",
                    gap: "10px"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventError, {
                    event: event
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/Cancel":"l7K6K","../StatusIcon":"3VOhR","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"98d3W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountLinkWithAddressSwitch", ()=>AccountLinkWithAddressSwitch);
parcelHelpers.export(exports, "WrappedAccountLinkWithAddressSwitch", ()=>WrappedAccountLinkWithAddressSwitch);
var _jsxRuntime = require("react/jsx-runtime");
var _accountLink = require("./AccountLink");
var _withAddressSwitch = require("./withAddressSwitch");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const AccountLinkWithAddressSwitch = (0, _withAddressSwitch.withAddressSwitch)((0, _accountLink.AccountLink));
const WrappedAccountLinkWithAddressSwitch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: "inline-flex",
            maxWidth: "100%",
            paddingRight: "0.5em"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccountLinkWithAddressSwitch, {
            ...props
        })
    });

},{"react/jsx-runtime":"g88cO","./AccountLink":"43Jgs","./withAddressSwitch":"gNl70","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gNl70":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withAddressSwitch", ()=>withAddressSwitch);
var _jsxRuntime = require("react/jsx-runtime");
var _addressSwitch = require("../AddressSwitch");
var _copyToClipboard = require("../CopyToClipboard");
const withAddressSwitch = (Component)=>(props)=>{
        const { addressSwitchOption, ethAddress, oasisAddress, ...restProps } = props;
        const addressesByType = {
            [(0, _addressSwitch.AddressSwitchOption).Oasis]: oasisAddress,
            [(0, _addressSwitch.AddressSwitchOption).ETH]: ethAddress
        };
        const displayedAddress = addressesByType[addressSwitchOption] ?? ethAddress ?? oasisAddress;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                    ...restProps,
                    address: displayedAddress
                }),
                displayedAddress && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                    value: displayedAddress
                })
            ]
        });
    };

},{"react/jsx-runtime":"g88cO","../AddressSwitch":"eKQmb","../CopyToClipboard":"iTQvM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eaPrf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrevBlockButton", ()=>PrevBlockButton);
parcelHelpers.export(exports, "NextBlockButton", ()=>NextBlockButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
var _paginationItem = require("@mui/material/PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _colors = require("../../../styles/theme/colors");
var _hook = require("../OfflineBanner/hook");
var _routeUtils = require("../../utils/route-utils");
const PrevBlockButton = ({ scope, currentRound })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const disabled = currentRound === 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabled ? t("blocks.viewingFirst") : t("blocks.viewPrevious"),
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationItemDefault.default), {
                component: (0, _reactRouterDom.Link),
                to: (0, _routeUtils.RouteUtils).getBlockRoute(scope, currentRound - 1),
                type: "previous",
                disabled: disabled,
                sx: {
                    marginLeft: 4,
                    marginRight: 1,
                    background: (0, _colors.COLORS).grayMediumLight
                }
            })
        })
    });
};
const NextBlockButton = ({ scope, currentRound })=>{
    const { latestBlock } = (0, _hook.useRuntimeFreshness)(scope);
    const { t } = (0, _reactI18Next.useTranslation)();
    const disabled = !!latestBlock && currentRound >= latestBlock;
    // If the next button is disabled, we want to poll the freshness info, because it will probably be enabled in a few secs
    /** This changes the value of {@link latestBlock}. */ (0, _hook.useRuntimeFreshness)(scope, {
        polling: disabled
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: disabled ? t("blocks.viewingLatest") : t("blocks.viewNext"),
        placement: "top",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationItemDefault.default), {
                component: (0, _reactRouterDom.Link),
                to: (0, _routeUtils.RouteUtils).getBlockRoute(scope, currentRound + 1),
                type: "next",
                disabled: disabled,
                sx: {
                    background: (0, _colors.COLORS).grayMediumLight
                }
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","react-i18next":"e210a","@mui/material/PaginationItem":"gONMy","@mui/material/Box":"4d7LG","@mui/material/Tooltip":"3RLHy","../../../styles/theme/colors":"hYvW2","../OfflineBanner/hook":"cKMsd","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5tkdC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableLayout", ()=>TableLayout);
parcelHelpers.export(exports, "TableLayoutButton", ()=>TableLayoutButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _pivotTableChart = require("@mui/icons-material/PivotTableChart");
var _pivotTableChartDefault = parcelHelpers.interopDefault(_pivotTableChart);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var TableLayout;
(function(TableLayout) {
    TableLayout["Horizontal"] = "horizontal";
    TableLayout["Vertical"] = "vertical";
})(TableLayout || (TableLayout = {}));
const TableLayoutButton = ({ tableView, setTableView })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "right",
        title: t("tableLayoutButton.changeView"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            color: "primary",
            onClick: ()=>{
                setTableView(tableView === "horizontal" ? "vertical" : "horizontal");
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pivotTableChartDefault.default), {
                fontSize: "medium"
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/IconButton":"hLmKV","@mui/icons-material/PivotTableChart":"hklGY","@mui/material/Tooltip":"3RLHy","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hklGY":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("54d62f6aaaa1040e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("232bfa33bcd13422"));
var _jsxRuntime = require("b874e863ea348b64");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 8h11V5c0-1.1-.9-2-2-2h-9zM3 8h5V3H5c-1.1 0-2 .9-2 2zm2 13h3V10H3v9c0 1.1.9 2 2 2m8 1-4-4 4-4zm1-9 4-4 4 4zm.58 6H13v-2h1.58c1.33 0 2.42-1.08 2.42-2.42V13h2v1.58c0 2.44-1.98 4.42-4.42 4.42"
}), "PivotTableChart");

},{"54d62f6aaaa1040e":"hykHy","232bfa33bcd13422":"gQLSP","b874e863ea348b64":"g88cO"}],"aeVDT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadMoreButton", ()=>LoadMoreButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _styles = require("@mui/material/styles");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _colors = require("../../../styles/theme/colors");
var _reactI18Next = require("react-i18next");
const StyledLoadMoreButton = (0, _styles.styled)((0, _buttonDefault.default))(()=>({
        backgroundColor: (0, _colors.COLORS).brandDark
    }));
const LoadMoreButton = ({ isLoading, pagination })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        component: (0, _reactRouterDom.Link),
        to: pagination.linkToPage(pagination.selectedPage + 1),
        preventScrollReset: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLoadMoreButton, {
            color: "primary",
            variant: "contained",
            disabled: isLoading,
            children: t("common.loadMore")
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","@mui/material/styles":"51PGx","@mui/material/Button":"h2G5p","../../../styles/theme/colors":"hYvW2","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gcFw0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerticalList", ()=>VerticalList);
var _colors = require("styles/theme/colors");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const VerticalList = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: `0 ${theme.spacing(2)}`,
        backgroundColor: (0, _colors.COLORS).brandDark
    }));

},{"styles/theme/colors":"hYvW2","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iDLqK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionsPage", ()=>RuntimeTransactionsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _transactions = require("../../components/Transactions");
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _errors = require("../../../types/errors");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _runtimeTransactionDetailPage = require("../RuntimeTransactionDetailPage");
var _useScopeParam = require("../../hooks/useScopeParam");
var _api1 = require("../../../coin-gecko/api");
var _verticalList = require("../../components/VerticalList");
var _config1 = require("../../../config");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
const RuntimeTransactionsPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * limit;
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    // Consensus is not yet enabled in ENABLED_LAYERS, just some preparation
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const tokenPrices = (0, _api1.useAllTokenPrices)((0, _config1.getFiatCurrencyForScope)(scope));
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const transactionsQuery = (0, _api.useGetRuntimeTransactions)(scope.network, scope.layer, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + limit : limit,
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    }, {
        query: {
            refetchInterval: (0, _config.REFETCH_INTERVAL),
            structuralSharing: (previousState, nextState)=>{
                const oldTxHashes = new Set(previousState?.data.transactions.map((tx)=>tx.hash));
                return {
                    ...nextState,
                    data: {
                        ...nextState.data,
                        transactions: nextState.data.transactions.map((tx)=>{
                            return {
                                ...tx,
                                markAsNew: previousState ? !oldTxHashes.has(tx.hash) : false
                            };
                        })
                    }
                };
            },
            // Keep showing data while loading more
            keepPreviousData: tableView === (0, _tableLayoutButton.TableLayout).Vertical
        }
    });
    const { isLoading, isFetched, data } = transactionsQuery;
    const transactions = data?.data.transactions;
    if (isFetched && pagination.selectedPage > 1 && !transactions?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: t("transactions.latest"),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.RuntimeTransactions), {
                        transactions: data?.data.transactions,
                        isLoading: isLoading,
                        limit: limit,
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: limit
                        }
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array(limit).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionDetailPage.RuntimeTransactionDetailView), {
                                    isLoading: true,
                                    transaction: undefined,
                                    tokenPrices: tokenPrices,
                                    standalone: true
                                }, key)),
                            !isLoading && data?.data.transactions.map((tx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionDetailPage.RuntimeTransactionDetailView), {
                                    transaction: tx,
                                    tokenPrices: tokenPrices,
                                    standalone: true
                                }, tx.hash))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../components/Transactions":"k0qMF","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../../../types/errors":"gdpNU","../../components/LoadMoreButton":"aeVDT","../../components/TableLayoutButton":"5tkdC","../RuntimeTransactionDetailPage":"bZzL6","../../hooks/useScopeParam":"kKMKx","../../../coin-gecko/api":"2VRI5","../../components/VerticalList":"gcFw0","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bZzL6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionDetailPage", ()=>RuntimeTransactionDetailPage);
parcelHelpers.export(exports, "RuntimeTransactionDetailView", ()=>RuntimeTransactionDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
var _api = require("../../../oasis-nexus/api");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _statusIcon = require("../../components/StatusIcon");
var _runtimeTransactionMethod = require("../../components/RuntimeTransactionMethod");
var _useFormattedTimestamp = require("../../hooks/useFormattedTimestamp");
var _styles = require("@mui/material/styles");
var _useScreensize = require("../../hooks/useScreensize");
var _accountLink = require("../../components/Account/AccountLink");
var _alert = require("@mui/material/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _copyToClipboard = require("../../components/CopyToClipboard");
var _errors = require("../../../types/errors");
var _skeleton = require("../../components/Skeleton");
var _blockLink = require("../../components/Blocks/BlockLink");
var _transactionLink = require("../../components/Transactions/TransactionLink");
var _transactionEvents = require("../../components/Transactions/TransactionEvents");
var _useScopeParam = require("../../hooks/useScopeParam");
var _dashboardLink = require("../ParatimeDashboardPage/DashboardLink");
var _ticker = require("../../../types/ticker");
var _api1 = require("../../../coin-gecko/api");
var _currentFiatValue = require("./CurrentFiatValue");
var _addressSwitch = require("../../components/AddressSwitch");
var _transactionEncryptionStatus = require("../../components/TransactionEncryptionStatus");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _longDataDisplay = require("../../components/LongDataDisplay");
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
var _helpers = require("../../utils/helpers");
var _dappBanner = require("../../components/DappBanner");
var _config = require("../../../config");
/**
 * Find the wanted transaction, in case there are more.
 *
 * Normally we want the successful one. If there is none, then the latest.
 */ function useWantedTransaction(transactionsList) {
    const transactions = transactionsList?.transactions ?? [];
    if (!transactions.length) // Loading or error
    return {};
    else if (transactions.length === 1) return {
        wantedTransaction: transactions[0]
    };
    else {
        const successfulOne = transactions.find((transaction)=>transaction.success);
        const latestOne = transactions.sort((a, b)=>b.round - a.round)[0];
        return {
            warningMultipleTransactionsSameHash: true,
            wantedTransaction: successfulOne ?? latestOne
        };
    }
}
const StyledAlert = (0, _styles.styled)((0, _alertDefault.default))(()=>({
        marginBottom: "1em"
    }));
const RuntimeTransactionDetailPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    // Consensus is not yet enabled in ENABLED_LAYERS, just some preparation
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const hash = (0, _reactRouterDom.useParams)().hash;
    const [addressSwitchOption, setAddressSwitchOption] = (0, _react.useState)((0, _addressSwitch.AddressSwitchOption).ETH);
    const { isLoading, data } = (0, _api.useGetRuntimeTransactionsTxHash)(scope.network, scope.layer, hash);
    const { wantedTransaction: transaction, warningMultipleTransactionsSameHash } = useWantedTransaction(data?.data);
    const tokenPrices = (0, _api1.useAllTokenPrices)((0, _config.getFiatCurrencyForScope)(scope));
    if (!transaction && !isLoading) throw (0, _errors.AppErrors).NotFoundTxHash;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            warningMultipleTransactionsSameHash && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledAlert, {
                severity: "error",
                children: t("transaction.warningMultipleTransactionsSameHash")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
                featured: true,
                title: t("transaction.header"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressSwitch.AddressSwitch), {
                    selected: addressSwitchOption,
                    onSelectionChange: (addressSwitch)=>setAddressSwitchOption(addressSwitch)
                }),
                mainTitle: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimeTransactionDetailView, {
                    isLoading: isLoading,
                    transaction: transaction,
                    tokenPrices: tokenPrices,
                    addressSwitchOption: addressSwitchOption
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dappBanner.DappBanner), {
                scope: scope,
                ethAddress: transaction?.sender_0_eth
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dappBanner.DappBanner), {
                scope: scope,
                ethAddress: transaction?.to_eth
            }),
            transaction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
                title: t("common.events"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionEvents.TransactionEvents), {
                    transaction: transaction,
                    addressSwitchOption: addressSwitchOption
                })
            })
        ]
    });
};
const RuntimeTransactionDetailView = ({ isLoading, transaction, showLayer, standalone = false, tokenPrices, addressSwitchOption = (0, _addressSwitch.AddressSwitchOption).ETH })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const formattedTimestamp = (0, _useFormattedTimestamp.useFormattedTimestampStringWithDistance)(transaction?.timestamp);
    const isOasisAddressFormat = addressSwitchOption === (0, _addressSwitch.AddressSwitchOption).Oasis;
    const hash = isOasisAddressFormat ? transaction?.hash : transaction?.eth_hash;
    const from = isOasisAddressFormat ? transaction?.sender_0 : transaction?.sender_0_eth;
    const to = isOasisAddressFormat ? transaction?.to : transaction?.to_eth;
    const ticker = transaction?.ticker || (0, _ticker.Ticker).ROSE;
    const tickerName = (0, _ticker.getNameForTicker)(t, ticker);
    const tokenPriceInfo = tokenPrices[ticker];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
                numberOfRows: 10
            }),
            transaction && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                titleWidth: isMobile ? "100px" : "200px",
                standalone: standalone,
                highlight: transaction.markAsNew,
                children: [
                    showLayer && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.paratime")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardLink.DashboardLink), {
                                    scope: transaction
                                })
                            })
                        ]
                    }),
                    (transaction?.hash || transaction?.eth_hash) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.hash")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionLink.TransactionLink), {
                                        scope: transaction,
                                        hash: hash || (isOasisAddressFormat ? transaction?.eth_hash : transaction?.hash),
                                        extraTooltip: hash ? isOasisAddressFormat ? t("transaction.tooltips.txTooltipOasis") : t("transaction.tooltips.txTooltipEth") : t("transaction.tooltips.txTooltipHashUnavailable")
                                    }),
                                    hash && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                        value: hash
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.status")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        style: {
                            flexWrap: "wrap",
                            gap: "10px"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
                            success: transaction.success,
                            error: transaction.error,
                            withText: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.block")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                            scope: transaction,
                            height: transaction.round
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.type")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionMethod.RuntimeTransactionMethod), {
                            method: transaction.method
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("transactions.encryption.format")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: transaction.encryption_envelope ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                transaction.encryption_envelope.format,
                                " \xa0 ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionEncryptionStatus.TransactionEncrypted), {})
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                t("transactions.encryption.plain"),
                                " \xa0 ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionEncryptionStatus.TransactionNotEncrypted), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.timestamp")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: formattedTimestamp
                    }),
                    (transaction?.sender_0 || transaction?.sender_0_eth) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.from")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                        scope: transaction,
                                        address: from || (isOasisAddressFormat ? transaction?.sender_0_eth : transaction?.sender_0),
                                        extraTooltip: from ? isOasisAddressFormat ? t("transaction.tooltips.senderTooltipOasis") : t("transaction.tooltips.senderTooltipEth") : t("transaction.tooltips.senderTooltipUnavailable")
                                    }),
                                    from && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                        value: from
                                    })
                                ]
                            })
                        ]
                    }),
                    (transaction?.to || transaction?.to_eth) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.to")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                        scope: transaction,
                                        address: to || (isOasisAddressFormat ? transaction?.to_eth : transaction?.to),
                                        extraTooltip: to ? isOasisAddressFormat ? t("transaction.tooltips.recipientTooltipOasis") : t("transaction.tooltips.recipientTooltipEth") : t("transaction.tooltips.recipientTooltipUnavailable")
                                    }),
                                    to && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                        value: to
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.value")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: transaction.amount != null ? t("common.valueInToken", {
                            ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(transaction.amount),
                            ticker: tickerName
                        }) : t("common.missing")
                    }),
                    (0, _config.showFiatValues) && transaction.amount !== undefined && !!tokenPriceInfo && !tokenPriceInfo.isLoading && !tokenPriceInfo.isFree && tokenPriceInfo.price !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("currentFiatValue.title")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _currentFiatValue.CurrentFiatValue), {
                                    amount: transaction.amount,
                                    ...tokenPriceInfo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.transactionFee")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: t("common.valueInToken", {
                            ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(transaction.charged_fee),
                            ticker: tickerName
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.gasUsed")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: transaction.gas_used.toLocaleString()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.gasLimit")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: transaction.gas_limit.toLocaleString()
                    }),
                    !!transaction.body?.data && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("transaction.rawData")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _longDataDisplay.LongDataDisplay), {
                                    data: (0, _helpers.base64ToHex)(transaction.body.data)
                                })
                            })
                        ]
                    }),
                    !transaction.encryption_envelope && transaction.body?.init_code && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("transaction.rawData")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _longDataDisplay.LongDataDisplay), {
                                    data: (0, _helpers.base64ToHex)(transaction.body.init_code)
                                })
                            })
                        ]
                    }),
                    transaction.encryption_envelope && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            transaction.encryption_envelope.public_key !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        children: t("transactions.encryption.publicKey")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "mono",
                                            sx: {
                                                overflowWrap: "anywhere"
                                            },
                                            children: transaction.encryption_envelope.public_key
                                        })
                                    })
                                ]
                            }),
                            transaction.encryption_envelope.data_nonce !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        children: t("transactions.encryption.dataNonce")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "mono",
                                            sx: {
                                                overflowWrap: "anywhere"
                                            },
                                            children: transaction.encryption_envelope.data_nonce
                                        })
                                    })
                                ]
                            }),
                            transaction.encryption_envelope.data !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        children: t("transactions.encryption.encryptedData")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _longDataDisplay.LongDataDisplay), {
                                            data: transaction.encryption_envelope.data
                                        })
                                    })
                                ]
                            }),
                            transaction.encryption_envelope.result_nonce !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        children: t("transactions.encryption.resultNonce")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                            variant: "mono",
                                            sx: {
                                                fontWeight: 400
                                            },
                                            children: transaction.encryption_envelope.result_nonce
                                        })
                                    })
                                ]
                            }),
                            transaction.encryption_envelope.result !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                        children: t("transactions.encryption.encryptedResult")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _longDataDisplay.LongDataDisplay), {
                                            data: transaction.encryption_envelope.result,
                                            fontWeight: 400
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","react-i18next":"e210a","../../../oasis-nexus/api":"dJrPU","../../components/StyledDescriptionList":"bndrS","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../components/StatusIcon":"3VOhR","../../components/RuntimeTransactionMethod":"gVAQO","../../hooks/useFormattedTimestamp":"kCD95","@mui/material/styles":"51PGx","../../hooks/useScreensize":"2HEhN","../../components/Account/AccountLink":"43Jgs","@mui/material/Alert":"5QD1w","../../components/CopyToClipboard":"iTQvM","../../../types/errors":"gdpNU","../../components/Skeleton":"eB5vc","../../components/Blocks/BlockLink":"g8oEe","../../components/Transactions/TransactionLink":"eIjbt","../../components/Transactions/TransactionEvents":"4bidP","../../hooks/useScopeParam":"kKMKx","../ParatimeDashboardPage/DashboardLink":"k1EO2","../../../types/ticker":"898HF","../../../coin-gecko/api":"2VRI5","./CurrentFiatValue":"5CgZB","../../components/AddressSwitch":"eKQmb","../../components/TransactionEncryptionStatus":"as1nW","@mui/material/Typography":"f5srd","../../components/LongDataDisplay":"6B93E","../../../locales/getPreciseNumberFormat":"gj0Jj","../../utils/helpers":"2aVNs","../../components/DappBanner":"dtzTP","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4bidP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionEvents", ()=>TransactionEvents);
var _jsxRuntime = require("react/jsx-runtime");
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _runtimeEventsDetailedList = require("../RuntimeEvents/RuntimeEventsDetailedList");
const TransactionEvents = ({ transaction, addressSwitchOption })=>{
    const { network, layer } = transaction;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const eventsQuery = (0, _api.useGetRuntimeEvents)(network, layer, {
        tx_hash: transaction.hash,
        limit: 100
    });
    const { isLoading, data, isError } = eventsQuery;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeEventsDetailedList.RuntimeEventsDetailedList), {
        scope: transaction,
        events: data?.data?.events,
        isLoading: isLoading,
        isError: isError,
        addressSwitchOption: addressSwitchOption
    });
};

},{"react/jsx-runtime":"g88cO","../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","../RuntimeEvents/RuntimeEventsDetailedList":"8KNdh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2VRI5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetTokenPricesFromGecko", ()=>useGetTokenPricesFromGecko);
parcelHelpers.export(exports, "useTokenPrice", ()=>useTokenPrice);
parcelHelpers.export(exports, "useAllTokenPrices", ()=>useAllTokenPrices);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _reactQuery = require("@tanstack/react-query");
var _ticker = require("../types/ticker");
var _config = require("../config");
var _routeUtils = require("../app/utils/route-utils");
var _helpers = require("../app/utils/helpers");
var _errors = require("../types/errors");
const staleTime = 180000 // 3 minutes
;
function useGetTokenPricesFromGecko(tokenIds, fiatCurrency) {
    return (0, _reactQuery.useQuery)([
        "tokenFiatPrices",
        tokenIds,
        fiatCurrency
    ], ()=>(0, _axiosDefault.default).get("https://api.coingecko.com/api/v3/simple/price", {
            params: {
                ids: tokenIds.join(","),
                vs_currencies: fiatCurrency ?? "usd"
            }
        }).then(({ data })=>{
            const result = {};
            Object.keys(data).forEach((key)=>{
                result[key] = data[key][fiatCurrency];
            });
            return result;
        }), {
        staleTime
    });
}
const useTokenPrice = (ticker, fiatCurrency)=>{
    const tokenPrices = useAllTokenPrices(fiatCurrency);
    const price = tokenPrices[ticker];
    if (!price) (0, _errors.exhaustedTypeWarning)("Checking price of unknown token ticker", ticker);
    return price || tokenPrices[(0, _ticker.Ticker).TEST];
};
const useAllTokenPrices = (fiatCurrency)=>{
    const tokens = (0, _helpers.uniq)((0, _routeUtils.RouteUtils).getEnabledScopes().map((0, _config.getTokensForScope)).flat());
    const geckoIds = tokens.map((token)=>token.geckoId).filter((id)=>!!id);
    const { isLoading: geckoIsLoading, data: geckoPrices } = useGetTokenPricesFromGecko(geckoIds, fiatCurrency);
    const results = {};
    tokens.forEach((token)=>{
        results[token.ticker] = {
            isLoading: geckoIsLoading,
            isFree: !!token.free,
            hasUsedCoinGecko: !!token.geckoId,
            price: token.geckoId && geckoPrices ? geckoPrices[token.geckoId] : undefined,
            fiatCurrency: token.geckoId && geckoPrices ? fiatCurrency : "xx"
        };
    });
    return results;
};

},{"axios":"i7Tjc","@tanstack/react-query":"jWXOo","../types/ticker":"898HF","../config":"2PXMY","../app/utils/route-utils":"b2kKi","../app/utils/helpers":"2aVNs","../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5CgZB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CurrentFiatValue", ()=>CurrentFiatValue);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _fiatMoneyAmount = require("../../components/Balance/FiatMoneyAmount");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _coinGeckoReferral = require("../../components/CoinGeckoReferral");
var _help = require("@mui/icons-material/Help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
const CurrentFiatValue = ({ amount, price, fiatCurrency, hasUsedCoinGecko })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return price === undefined ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _fiatMoneyAmount.FiatMoneyAmountBox), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: "inline-flex",
                    alignItems: "center"
                },
                children: [
                    t("common.fiatValueInUSD", {
                        value: new (0, _bignumberJsDefault.default)(amount).multipliedBy(price).toFixed(),
                        formatParams: {
                            value: {
                                currency: fiatCurrency
                            }
                        }
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: t("currentFiatValue.explanation"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _helpDefault.default), {})
                    })
                ]
            }),
            hasUsedCoinGecko && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coinGeckoReferral.CoinGeckoReferral), {})
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Balance/FiatMoneyAmount":"gYaIm","@mui/material/Box":"4d7LG","@mui/material/Tooltip":"3RLHy","../../components/CoinGeckoReferral":"3Cord","@mui/icons-material/Help":"jIKks","bignumber.js":"cQ5xL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gYaIm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FiatMoneyAmountBox", ()=>FiatMoneyAmountBox);
parcelHelpers.export(exports, "FiatMoneyAmount", ()=>FiatMoneyAmount);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _warningAmber = require("@mui/icons-material/WarningAmber");
var _warningAmberDefault = parcelHelpers.interopDefault(_warningAmber);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactI18Next = require("react-i18next");
var _coinGeckoReferral = require("../CoinGeckoReferral");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
const FiatMoneyAmountBox = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 4,
        flex: 1
    }));
const FiatMoneyAmount = ({ value, fiatCurrency, hasUsedCoinGecko, unknownTickers, loading })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FiatMoneyAmountBox, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    t("common.fiatValueInUSD", {
                        value,
                        formatParams: {
                            value: {
                                currency: fiatCurrency
                            }
                        }
                    }),
                    !!unknownTickers.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: t("account.failedToLookUpTickers", {
                            tickers: unknownTickers.join(", ")
                        }),
                        placement: "top",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _warningAmberDefault.default), {})
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                        variant: "rectangular",
                        sx: {
                            height: 200
                        }
                    })
                ]
            }),
            hasUsedCoinGecko && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coinGeckoReferral.CoinGeckoReferral), {})
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/icons-material/WarningAmber":"628Yz","@mui/material/Box":"4d7LG","react-i18next":"e210a","../CoinGeckoReferral":"3Cord","@mui/material/Tooltip":"3RLHy","@mui/material/Skeleton":"i7d9z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"628Yz":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("e2e1649c3b1f56ed");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("79ef85b6b94eae2e"));
var _jsxRuntime = require("21af3f43ee2adffa");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], "WarningAmber");

},{"e2e1649c3b1f56ed":"hykHy","79ef85b6b94eae2e":"gQLSP","21af3f43ee2adffa":"g88cO"}],"3Cord":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CoinGeckoReferral", ()=>CoinGeckoReferral);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _externalLinks = require("../../utils/externalLinks");
var _colors = require("../../../styles/theme/colors");
const CoinGeckoReferral = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        component: "span",
        sx: {
            fontSize: "12px",
            color: (0, _colors.COLORS).brandExtraDark
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "coinGeckoReferral",
            t: t,
            components: {
                CoinGeckoLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    href: (0, _externalLinks.referrals).coinGecko,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    sx: {
                        fontWeight: 400,
                        color: "inherit",
                        textDecoration: "underline"
                    }
                })
            }
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Typography":"f5srd","@mui/material/Link":"fTbCF","../../utils/externalLinks":"d3W8q","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dtzTP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DappBanner", ()=>DappBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactI18Next = require("react-i18next");
var _dapps = require("../../config/dapps");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _useScreensize = require("../../hooks/useScreensize");
const DappBanner = ({ scope, ethAddress })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (!ethAddress) return null;
    const dApp = (0, _dapps.getDappForEthAddress)(t, scope.network, scope.layer, ethAddress);
    return !!dApp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        sx: {
            backgroundColor: (0, _colors.COLORS).brandMedium,
            border: `2px dashed ${(0, _colors.COLORS).white}`
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h3",
                        sx: {
                            color: (0, _colors.COLORS).white,
                            fontSize: isMobile ? "18px" : "24px",
                            fontWeight: 700,
                            lineHeight: "140%" /* 33.6px */ 
                        },
                        children: dApp.description
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        href: dApp.url,
                        sx: {
                            backgroundColor: (0, _colors.COLORS).white,
                            fontSize: "18px",
                            fontWeight: 500,
                            lineHeight: "125%",
                            textTransform: "none"
                        },
                        variant: "outlined",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: dApp.label
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","@mui/material/Box":"4d7LG","react-i18next":"e210a","../../config/dapps":"oDubZ","@mui/material/Button":"h2G5p","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"oDubZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDappForEthAddress", ()=>getDappForEthAddress);
var _api = require("../../../oasis-nexus/api");
var _network = require("../../../types/network");
var _wrose = require("./wrose");
const dappsForToken = {
    [(0, _network.Network).testnet]: {
        [(0, _api.Layer).sapphire]: {
            [(0, _wrose.wRose).testnetAddress]: (0, _wrose.wRose).app
        }
    },
    [(0, _network.Network).mainnet]: {
        [(0, _api.Layer).sapphire]: {
            [(0, _wrose.wRose).mainnetAddress]: (0, _wrose.wRose).app
        }
    }
};
const getDappForEthAddress = (t, network, layer, ethAddress)=>{
    const generator = dappsForToken[network]?.[layer]?.[ethAddress];
    const dApp = generator ? generator(t) : undefined;
    return dApp;
};

},{"../../../oasis-nexus/api":"dJrPU","../../../types/network":"f0o8N","./wrose":"7MDVh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7MDVh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wRose", ()=>wRose);
var _externalLinks = require("../../utils/externalLinks");
const wRose = {
    // The addresses come from https://github.com/oasisprotocol/dapp-wrose/blob/master/src/constants/config.ts for the
    mainnetAddress: "0x8Bc2B030b299964eEfb5e1e0b36991352E56D2D3",
    testnetAddress: "0xB759a0fbc1dA517aF257D5Cf039aB4D86dFB3b94",
    app: (t)=>({
            description: t("dapps.wrose.description"),
            label: t("dapps.wrose.label"),
            url: (0, _externalLinks.dapps).wRose
        })
};

},{"../../utils/externalLinks":"d3W8q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5L8bX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParatimeDashboardPage", ()=>ParatimeDashboardPage);
var _jsxRuntime = require("react/jsx-runtime");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _useScreensize = require("../../hooks/useScreensize");
var _social = require("../../components/Social");
var _learningMaterials = require("./LearningMaterials");
var _latestRuntimeBlocks = require("./LatestRuntimeBlocks");
var _latestRuntimeTransactions = require("./LatestRuntimeTransactions");
var _transactionsStats = require("../../components/TransactionsStats");
var _totalTransactions = require("../../components/TotalTransactions");
var _pageLayout = require("../../components/PageLayout");
var _paraTimeSnapshot = require("./ParaTimeSnapshot");
var _topTokens = require("./TopTokens");
var _useScopeParam = require("../../hooks/useScopeParam");
const ParatimeDashboardPage = ()=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeSnapshot.ParaTimeSnapshot), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout",
                sx: {
                    mt: isMobile ? 4 : 0
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _latestRuntimeTransactions.LatestRuntimeTransactions), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        sx: {
                            display: "flex",
                            order: isMobile ? 1 : 0
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningMaterials.LearningMaterials), {
                            scope: scope
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _latestRuntimeBlocks.LatestRuntimeBlocks), {
                            scope: scope
                        })
                    }),
                    isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topTokens.TopTokens), {
                            scope: scope
                        })
                    })
                ]
            }),
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topTokens.TopTokens), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionsStats.TransactionsStats), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _totalTransactions.TotalTransactions), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social.Social), {})
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Divider":"3hI6U","@mui/material/Grid":"bu56N","../../hooks/useScreensize":"2HEhN","../../components/Social":"atjKu","./LearningMaterials":"3ZqNy","./LatestRuntimeBlocks":"i9aHS","./LatestRuntimeTransactions":"3kNJ9","../../components/TransactionsStats":"efaZm","../../components/TotalTransactions":"a7R3w","../../components/PageLayout":"24SOU","./ParaTimeSnapshot":"9P401","./TopTokens":"hieAl","../../hooks/useScopeParam":"kKMKx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bu56N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "gridClasses", ()=>(0, _gridClassesDefault.default));
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
parcelHelpers.exportAll(_gridClasses, exports);
"use client";

},{"./Grid":"dUErR","./gridClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dUErR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateGrid", ()=>generateGrid);
parcelHelpers.export(exports, "generateDirection", ()=>generateDirection);
parcelHelpers.export(exports, "generateRowGap", ()=>generateRowGap);
parcelHelpers.export(exports, "generateColumnGap", ()=>generateColumnGap);
parcelHelpers.export(exports, "resolveSpacingStyles", ()=>resolveSpacingStyles);
parcelHelpers.export(exports, "resolveSpacingClasses", ()=>resolveSpacingClasses);
// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _requirePropFactory = require("../utils/requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _gridContext = require("./GridContext");
var _gridContextDefault = parcelHelpers.interopDefault(_gridContext);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function generateGrid({ theme, ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, _system.unstable_resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, _extendsDefault.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function generateDirection({ theme, ownerState }) {
    const directionValues = (0, _system.unstable_resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, _system.handleBreakpoints)({
        theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, _gridClassesDefault.default).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function extractZeroValueBreakpointKeys({ breakpoints, values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function generateRowGap({ theme, ownerState }) {
    const { container, rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, _system.unstable_resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, _system.handleBreakpoints)({
            theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${getOffset(themeSpacing)}`,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingTop: getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function generateColumnGap({ theme, ownerState }) {
    const { container, columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, _system.unstable_resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, _system.handleBreakpoints)({
            theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${getOffset(themeSpacing)})`,
                marginLeft: `-${getOffset(themeSpacing)}`,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingLeft: getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function resolveSpacingStyles(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const GridRoot = (0, _styledDefault.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { container, direction, item, spacing, wrap, zeroMinWidth, breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = resolveSpacingStyles(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), generateDirection, generateRowGap, generateColumnGap, generateGrid);
function resolveSpacingClasses(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, container, direction, item, spacing, wrap, zeroMinWidth, breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = resolveSpacingClasses(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _gridClasses.getGridUtilityClass), classes);
};
const Grid = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints } = (0, _useThemeDefault.default)();
    const props = (0, _styleFunctionSx.extendSxProp)(themeProps);
    const { className, columns: columnsProp, columnSpacing: columnSpacingProp, component = "div", container = false, direction = "row", item = false, rowSpacing: rowSpacingProp, spacing = 0, wrap = "wrap", zeroMinWidth = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = _react.useContext((0, _gridContextDefault.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, _extendsDefault.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        columns,
        container,
        direction,
        item,
        rowSpacing,
        columnSpacing,
        wrap,
        zeroMinWidth,
        spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridContextDefault.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, (0, _extendsDefault.default)({
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
exports.default = Grid;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/system":"6hP1D","@mui/system/styleFunctionSx":"fRzFg","@mui/utils/composeClasses":"jj3MR","../utils/requirePropFactory":"7Jph4","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../styles/useTheme":"3N7Mw","./GridContext":"4Gwai","./gridClasses":"dg1Ds","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4Gwai":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 */ const GridContext = /*#__PURE__*/ _react.createContext();
exports.default = GridContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dg1Ds":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridUtilityClass", ()=>getGridUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiGrid", slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClassesDefault.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
exports.default = gridClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"atjKu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Social", ()=>Social);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _unstableGrid2 = require("@mui/material/Unstable_Grid2");
var _unstableGrid2Default = parcelHelpers.interopDefault(_unstableGrid2);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _backgroundSocialPng = require("./images/background-social.png");
var _backgroundSocialPngDefault = parcelHelpers.interopDefault(_backgroundSocialPng);
var _telegramSvg = require("./images/telegram.svg");
var _telegramSvgDefault = parcelHelpers.interopDefault(_telegramSvg);
var _twitterSvg = require("./images/twitter.svg");
var _twitterSvgDefault = parcelHelpers.interopDefault(_twitterSvg);
var _discordSvg = require("./images/discord.svg");
var _discordSvgDefault = parcelHelpers.interopDefault(_discordSvg);
var _youtubeSvg = require("./images/youtube.svg");
var _youtubeSvgDefault = parcelHelpers.interopDefault(_youtubeSvg);
var _redditSvg = require("./images/reddit.svg");
var _redditSvgDefault = parcelHelpers.interopDefault(_redditSvg);
var _linkedIn = require("@mui/icons-material/LinkedIn");
var _linkedInDefault = parcelHelpers.interopDefault(_linkedIn);
var _menuBook = require("@mui/icons-material/MenuBook");
var _menuBookDefault = parcelHelpers.interopDefault(_menuBook);
var _cottage = require("@mui/icons-material/Cottage");
var _cottageDefault = parcelHelpers.interopDefault(_cottage);
var _colors = require("../../../styles/theme/colors");
var _externalLinks = require("../../utils/externalLinks");
const SocialLink = ({ label, href, isMobile, imgSrc, img })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _linkDefault.default), {
        href: href,
        color: (0, _colors.COLORS).white,
        underline: "none",
        sx: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            mx: isMobile ? 4 : 0,
            mt: isMobile ? 4 : 0
        },
        rel: "noopener noreferrer",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    mb: 3
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        imgSrc && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: imgSrc,
                            alt: label,
                            height: 40
                        }),
                        img
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: 18,
                    fontWeight: 700,
                    mb: isMobile ? 4 : 0
                },
                children: label
            })
        ]
    });
};
const iconProps = {
    sx: {
        fontSize: 50,
        margin: "-4px"
    }
};
const Social = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
        container: true,
        sx: {
            px: isMobile ? 5 : 6,
            pt: 5,
            pb: isMobile ? 4 : 5,
            backgroundColor: (0, _colors.COLORS).brandDark,
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: (0, _colors.COLORS).white,
            borderRadius: "12px",
            backgroundImage: `url(${(0, _backgroundSocialPngDefault.default)})`,
            backgroundSize: "cover"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
                xs: 12,
                md: 4,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        sx: {
                            fontSize: 18,
                            fontWeight: 700,
                            mb: 3
                        },
                        color: (0, _colors.COLORS).white,
                        children: t("social.header")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        color: (0, _colors.COLORS).white,
                        sx: {
                            maxWidth: 230
                        },
                        children: t("social.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                xs: 12,
                md: 8,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        justifyContent: isMobile ? "center" : "space-between",
                        width: "100%",
                        height: "100%"
                    },
                    children: [
                        (0, _externalLinks.socialMedia).telegram && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.telegram"),
                            href: (0, _externalLinks.socialMedia).telegram,
                            imgSrc: (0, _telegramSvgDefault.default)
                        }),
                        (0, _externalLinks.socialMedia).twitter && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.twitter"),
                            href: (0, _externalLinks.socialMedia).twitter,
                            imgSrc: (0, _twitterSvgDefault.default)
                        }),
                        (0, _externalLinks.socialMedia).discord && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.discord"),
                            href: (0, _externalLinks.socialMedia).discord,
                            imgSrc: (0, _discordSvgDefault.default)
                        }),
                        (0, _externalLinks.socialMedia).youtube && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.youtube"),
                            href: (0, _externalLinks.socialMedia).youtube,
                            imgSrc: (0, _youtubeSvgDefault.default)
                        }),
                        (0, _externalLinks.socialMedia).reddit && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.reddit"),
                            href: (0, _externalLinks.socialMedia).reddit,
                            imgSrc: (0, _redditSvgDefault.default)
                        }),
                        (0, _externalLinks.socialMedia).linkedin && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.linkedin"),
                            href: (0, _externalLinks.socialMedia).linkedin,
                            img: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkedInDefault.default), {
                                ...iconProps
                            })
                        }),
                        (0, _externalLinks.socialMedia).docs && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.docs"),
                            href: (0, _externalLinks.socialMedia).docs,
                            img: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuBookDefault.default), {
                                ...iconProps
                            })
                        }),
                        (0, _externalLinks.socialMedia).home && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SocialLink, {
                            isMobile: isMobile,
                            label: t("social.home"),
                            href: (0, _externalLinks.socialMedia).home,
                            img: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cottageDefault.default), {
                                ...iconProps
                            })
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Unstable_Grid2":"eN1IM","@mui/material/Link":"fTbCF","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","./images/background-social.png":"kIYiX","./images/telegram.svg":"kNNSg","./images/twitter.svg":"1pcu5","./images/discord.svg":"5Uegc","./images/youtube.svg":"e5w4z","./images/reddit.svg":"6CCdr","@mui/icons-material/LinkedIn":"4SxJd","@mui/icons-material/MenuBook":"fpmeQ","@mui/icons-material/Cottage":"jjTct","../../../styles/theme/colors":"hYvW2","../../utils/externalLinks":"d3W8q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kIYiX":[function(require,module,exports) {
module.exports = require("8f3fdd7acc84743c").getBundleURL("sif1r") + "background-social.9d56e730.png";

},{"8f3fdd7acc84743c":"ccgWN"}],"kNNSg":[function(require,module,exports) {
module.exports = require("beee8d12fe86e036").getBundleURL("sif1r") + "telegram.0ae1e870.svg";

},{"beee8d12fe86e036":"ccgWN"}],"1pcu5":[function(require,module,exports) {
module.exports = require("9713598a6ac09c02").getBundleURL("sif1r") + "twitter.25c9a221.svg";

},{"9713598a6ac09c02":"ccgWN"}],"5Uegc":[function(require,module,exports) {
module.exports = require("a6e56255c8757fef").getBundleURL("sif1r") + "discord.e271280c.svg";

},{"a6e56255c8757fef":"ccgWN"}],"e5w4z":[function(require,module,exports) {
module.exports = require("86c40e1eb3bb6a3a").getBundleURL("sif1r") + "youtube.73dfde61.svg";

},{"86c40e1eb3bb6a3a":"ccgWN"}],"6CCdr":[function(require,module,exports) {
module.exports = require("c745dad77722f988").getBundleURL("sif1r") + "reddit.b42bab17.svg";

},{"c745dad77722f988":"ccgWN"}],"4SxJd":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("6fe33859763e457");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("35ed9598ac4c29ce"));
var _createSvgIcon = _interopRequireDefault(require("935405db5f25d6fd"));
var _jsxRuntime = require("81c2f03d8d2bd071");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), "LinkedIn");

},{"6fe33859763e457":"hykHy","35ed9598ac4c29ce":"BK2ob","935405db5f25d6fd":"gQLSP","81c2f03d8d2bd071":"g88cO"}],"fpmeQ":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("55a7b6b3afef9301");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("66676c81017a8937"));
var _jsxRuntime = require("95eed3eebd3d93df");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1m0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5z"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99M13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83m4.5 1.84c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24"
    }, "1")
], "MenuBook");

},{"55a7b6b3afef9301":"hykHy","66676c81017a8937":"gQLSP","95eed3eebd3d93df":"g88cO"}],"jjTct":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("99e05517d5c8bf36");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("bfd629b35f2b6d42"));
var _jsxRuntime = require("22c77e161593fea4");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 3 6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h7v-6h2v6h7v-9.38l1.79 1.36L23 11.4zm-2-2c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1z"
}), "Cottage");

},{"99e05517d5c8bf36":"hykHy","bfd629b35f2b6d42":"gQLSP","22c77e161593fea4":"g88cO"}],"3ZqNy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LearningMaterials", ()=>LearningMaterials);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _unstableGrid2 = require("@mui/material/Unstable_Grid2");
var _unstableGrid2Default = parcelHelpers.interopDefault(_unstableGrid2);
var _externalLinks = require("../../utils/externalLinks");
var _api = require("../../../oasis-nexus/api");
var _content = require("../../utils/content");
var _network = require("../../../types/network");
var _learningMaterialsCard = require("app/components/LearningMaterialsCard");
var _learningSection = require("../../components/LearningMaterialsCard/LearningSection");
var _errors = require("types/errors");
const getContent = (t)=>{
    const labels = (0, _content.getLayerLabels)(t);
    return {
        [(0, _network.Network).mainnet]: {
            [(0, _api.Layer).emerald]: {
                primary: {
                    description: t("learningMaterials.emerald.description"),
                    header: t("learningMaterials.emerald.header"),
                    url: (0, _externalLinks.docs).emerald
                },
                secondary: {
                    description: t("learningMaterials.token.description"),
                    header: t("learningMaterials.token.header"),
                    url: (0, _externalLinks.docs).token
                },
                tertiary: {
                    description: t("learningMaterials.transfer.description", {
                        layer: labels["emerald"]
                    }),
                    header: t("learningMaterials.transfer.header"),
                    url: (0, _externalLinks.docs).paraTimeTransfer
                }
            },
            [(0, _api.Layer).sapphire]: {
                primary: {
                    description: t("learningMaterials.sapphire.description"),
                    header: t("learningMaterials.sapphire.header"),
                    url: (0, _externalLinks.docs).sapphire
                },
                secondary: {
                    description: t("learningMaterials.token.description"),
                    header: t("learningMaterials.token.header"),
                    url: (0, _externalLinks.docs).token
                },
                tertiary: {
                    description: t("learningMaterials.transfer.description", {
                        layer: labels["sapphire"]
                    }),
                    header: t("learningMaterials.transfer.header"),
                    url: (0, _externalLinks.docs).paraTimeTransfer
                }
            },
            [(0, _api.Layer).cipher]: undefined,
            [(0, _api.Layer).pontusx]: undefined
        },
        [(0, _network.Network).testnet]: {
            [(0, _api.Layer).emerald]: {
                primary: {
                    description: t("learningMaterials.emerald.description"),
                    header: t("learningMaterials.emerald.header"),
                    url: (0, _externalLinks.docs).emeraldTestnet
                },
                secondary: {
                    description: t("learningMaterials.testnet.description"),
                    header: t("learningMaterials.testnet.header"),
                    url: (0, _externalLinks.docs).emeraldTestnetNode
                },
                tertiary: {
                    description: t("learningMaterials.emerald.gatewayDescription"),
                    header: t("learningMaterials.emerald.gateway"),
                    url: (0, _externalLinks.docs).emeraldGateway
                }
            },
            [(0, _api.Layer).sapphire]: {
                primary: {
                    description: t("learningMaterials.sapphire.description"),
                    header: t("learningMaterials.sapphire.header"),
                    url: (0, _externalLinks.docs).sapphireTestnet
                },
                secondary: {
                    description: t("learningMaterials.testnet.description"),
                    header: t("learningMaterials.testnet.header"),
                    url: (0, _externalLinks.docs).sapphireTestnetNode
                },
                tertiary: {
                    description: t("learningMaterials.hardhat.description"),
                    header: t("learningMaterials.hardhat.header", {
                        layer: labels["sapphire"]
                    }),
                    url: (0, _externalLinks.docs).sapphireTestnetHardhat
                }
            },
            [(0, _api.Layer).cipher]: undefined,
            [(0, _api.Layer).pontusx]: {
                primary: {
                    description: t("learningMaterials.pontusx.1.description"),
                    header: t("learningMaterials.pontusx.1.header"),
                    url: (0, _externalLinks.docs).pontusx1
                },
                secondary: {
                    description: t("learningMaterials.pontusx.2.description"),
                    header: t("learningMaterials.pontusx.2.header"),
                    url: (0, _externalLinks.docs).pontusx2
                },
                tertiary: {
                    description: t("learningMaterials.pontusx.2.description"),
                    header: t("learningMaterials.pontusx.3.header"),
                    url: (0, _externalLinks.docs).pontusx3
                }
            }
        }
    };
};
const LearningMaterials = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { layer, network } = scope;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const content = getContent(t)[network][layer];
    if (!content) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningMaterialsCard.LearningMaterialsCard), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
            container: true,
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                    xs: 12,
                    md: 6,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                        description: content.primary.description,
                        title: content.primary.header,
                        url: content.primary.url,
                        sx: {
                            height: "100%"
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
                    xs: 12,
                    md: 6,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                            sx: {
                                pb: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                                description: content.secondary.description,
                                title: content.secondary.header,
                                url: content.secondary.url
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                                description: content.tertiary.description,
                                title: content.tertiary.header,
                                url: content.tertiary.url
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Unstable_Grid2":"eN1IM","../../utils/externalLinks":"d3W8q","../../../oasis-nexus/api":"dJrPU","../../utils/content":"gyk1M","../../../types/network":"f0o8N","app/components/LearningMaterialsCard":"bPrsj","../../components/LearningMaterialsCard/LearningSection":"6r0Nd","types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bPrsj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LearningMaterialsCard", ()=>LearningMaterialsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _colors = require("../../../styles/theme/colors");
var _externalLinks = require("../../utils/externalLinks");
const LearningMaterialsCard = ({ children })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("learningMaterials.header"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    href: (0, _externalLinks.docs).home,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: children
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Link":"fTbCF","../../../styles/theme/colors":"hYvW2","../../utils/externalLinks":"d3W8q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6r0Nd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LearningSection", ()=>LearningSection);
var _jsxRuntime = require("react/jsx-runtime");
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("styles/theme/colors");
var _styledLinks = require("../StyledLinks");
const LearningSection = ({ description, title, url, ...props })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        variant: "content",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "h4",
                sx: {
                    mb: 4
                },
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "body2",
                sx: {
                    color: (0, _colors.COLORS).grayMedium
                },
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledLinks.AnchorCircle), {
                url: url
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Paper":"9w8HO","@mui/material/Typography":"f5srd","styles/theme/colors":"hYvW2","../StyledLinks":"Guhqk","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"Guhqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchorCircle", ()=>AnchorCircle);
parcelHelpers.export(exports, "RouterLinkCircle", ()=>RouterLinkCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _styles = require("@mui/material/styles");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _colors = require("styles/theme/colors");
const styles = {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    backgroundColor: (0, _colors.COLORS).brandDark,
    color: (0, _colors.COLORS).white,
    boxShadow: "0px 10px 8px rgba(117, 60, 239, 0.1)",
    "&:hover, &:focus-visible": {
        backgroundColor: (0, _colors.COLORS).cosmicCobalt
    }
};
const StyledAnchor = (0, _styles.styled)((0, _linkDefault.default))(()=>styles);
const AnchorCircle = ({ url })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledAnchor, {
        href: url,
        rel: "noopener noreferrer",
        target: "_blank",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {
            sx: {
                fontSize: 16
            }
        })
    });
};
const StyledRouterLink = (0, _styles.styled)((0, _reactRouterDom.Link))(()=>styles);
const RouterLinkCircle = ({ to })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledRouterLink, {
        to: to,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {
            sx: {
                fontSize: 16
            }
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/styles":"51PGx","@mui/material/Link":"fTbCF","@mui/icons-material/ArrowForward":"bwHID","styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i9aHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LatestRuntimeBlocks", ()=>LatestRuntimeBlocks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _blocks = require("../../components/Blocks");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _errors = require("../../../types/errors");
var _routeUtils = require("../../utils/route-utils");
var _useScreensize = require("../../hooks/useScreensize");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const LatestRuntimeBlocks = ({ scope })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const blocksQuery = (0, _api.useGetRuntimeBlocks)(network, layer, {
        limit
    }, {
        query: {
            cacheTime: 0
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("blocks.latest"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getLatestBlocksRoute(scope),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blocks.RuntimeBlocks), {
                    isLoading: blocksQuery.isLoading,
                    blocks: blocksQuery.data?.data.blocks,
                    limit: limit,
                    pagination: false,
                    type: isMobile ? (0, _blocks.BlocksTableType).Mobile : (0, _blocks.BlocksTableType).DesktopLite
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../components/Blocks":"4KkfE","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","../../../types/errors":"gdpNU","../../utils/route-utils":"b2kKi","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3kNJ9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LatestRuntimeTransactions", ()=>LatestRuntimeTransactions);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _transactions = require("../../components/Transactions");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _errors = require("../../../types/errors");
var _routeUtils = require("../../utils/route-utils");
var _useScreensize = require("../../hooks/useScreensize");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const LatestRuntimeTransactions = ({ scope })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const transactionsQuery = (0, _api.useGetRuntimeTransactions)(network, layer, {
        limit
    }, {
        query: {
            cacheTime: 0
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("transactions.latest"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getLatestTransactionsRoute(scope),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.RuntimeTransactions), {
                    transactions: transactionsQuery.data?.data.transactions,
                    isLoading: transactionsQuery.isLoading,
                    limit: limit,
                    pagination: false,
                    verbose: !isTablet
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../components/Transactions":"k0qMF","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","../../../types/errors":"gdpNU","../../utils/route-utils":"b2kKi","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"efaZm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionsStats", ()=>TransactionsStats);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _barChart = require("../../components/charts/BarChart");
var _api = require("../../../oasis-nexus/api");
var _chartUtils = require("../../utils/chart-utils");
var _durationPills = require("../../components/DurationPills");
var _cardHeaderWithResponsiveActions = require("../../components/CardHeaderWithResponsiveActions");
var _useScreensize = require("../../hooks/useScreensize");
const TransactionsStats = ({ scope })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const [chartDuration, setChartDuration] = (0, _react.useState)((0, _chartUtils.ChartDuration).MONTH);
    const statsParams = (0, _chartUtils.durationToQueryParams)[chartDuration];
    const dailyVolumeQuery = (0, _api.useGetLayerStatsTxVolume)(scope.network, scope.layer, statsParams, {
        query: {
            keepPreviousData: true,
            staleTime: (0, _chartUtils.chartUseQueryStaleTimeMs)
        }
    });
    const allTime = dailyVolumeQuery.isFetched && chartDuration === (0, _chartUtils.ChartDuration).YEAR;
    const windows = allTime ? (0, _chartUtils.getMonthlyWindowsDailyAverage)(dailyVolumeQuery.data?.data.windows) : dailyVolumeQuery.data?.data.windows;
    const formatParams = allTime ? {
        timestamp: {
            year: "numeric",
            month: "long"
        }
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithResponsiveActions.CardHeaderWithResponsiveActions), {
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _durationPills.DurationPills), {
                    handleChange: setChartDuration,
                    value: chartDuration
                }),
                disableTypography: true,
                component: "h3",
                title: t("transactionStats.header")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                sx: {
                    height: 450
                },
                children: windows && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _barChart.BarChart), {
                    barSize: chartDuration === (0, _chartUtils.ChartDuration).WEEK ? 125 : undefined,
                    barRadius: chartDuration === (0, _chartUtils.ChartDuration).WEEK ? 20 : undefined,
                    cartesianGrid: true,
                    data: windows.slice().reverse(),
                    dataKey: "tx_volume",
                    formatters: {
                        data: (value)=>t("transactionStats.perDay", {
                                value: value.toLocaleString()
                            }),
                        label: (value)=>t("common.formattedDateTime", {
                                timestamp: new Date(value),
                                formatParams
                            })
                    },
                    withLabels: true,
                    margin: {
                        bottom: 16,
                        top: isMobile ? 0 : 16
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","../../components/charts/BarChart":"1e1h7","../../../oasis-nexus/api":"dJrPU","../../utils/chart-utils":"arkVO","../../components/DurationPills":"fLsgt","../../components/CardHeaderWithResponsiveActions":"3R3jX","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1e1h7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarChart", ()=>BarChart);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _recharts = require("recharts");
var _tooltip = require("./Tooltip");
var _colors = require("../../../styles/theme/colors");
var _reactI18Next = require("react-i18next");
const BarChartCmp = ({ barSize = 12, barRadius = 12, cartesianGrid, data, dataKey, formatters, rounded, withLabels, withBarBackground, margin })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.ResponsiveContainer), {
        width: "100%",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.BarChart), {
            data: data,
            margin: margin ?? {
                right: 8,
                bottom: 0,
                left: 8
            },
            children: [
                cartesianGrid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.CartesianGrid), {
                    vertical: false,
                    stroke: (0, _colors.COLORS).antiFlashWhite3
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.YAxis), {
                    domain: [
                        0,
                        (dataMax)=>Number((dataMax * 1.2).toPrecision(2))
                    ],
                    hide: !withLabels,
                    interval: 0,
                    tick: {
                        fill: (0, _colors.COLORS).brandDark,
                        strokeWidth: 0
                    },
                    axisLine: false,
                    tickLine: false,
                    type: "number",
                    tickMargin: 16,
                    tickFormatter: (tick)=>t("common.valuePair", {
                            value: tick,
                            formatParams: {
                                value: {
                                    notation: "compact"
                                }
                            }
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Tooltip), {
                    cursor: false,
                    wrapperStyle: {
                        outline: "none"
                    },
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                        formatters: formatters
                    }),
                    offset: 15
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Bar), {
                    background: withBarBackground ? {
                        fill: (0, _colors.COLORS).grayLight,
                        radius: 20
                    } : undefined,
                    dataKey: dataKey,
                    barSize: barSize,
                    fill: (0, _colors.COLORS).denimBlue,
                    radius: rounded ? barRadius : [
                        barRadius,
                        barRadius,
                        0,
                        0
                    ]
                })
            ]
        })
    });
};
const BarChart = /*#__PURE__*/ (0, _react.memo)(BarChartCmp);

},{"react/jsx-runtime":"g88cO","react":"BK2ob","recharts":"cL2Z5","./Tooltip":"iZVHC","../../../styles/theme/colors":"hYvW2","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cL2Z5":[function(require,module,exports) {
// "export type" declarations on separate lines are in use
// to workaround babel issue(s) 11465 12578
//
// see https://github.com/babel/babel/issues/11464#issuecomment-617606898
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>(0, _surface.Surface));
parcelHelpers.export(exports, "Layer", ()=>(0, _layer.Layer));
parcelHelpers.export(exports, "Legend", ()=>(0, _legend.Legend));
parcelHelpers.export(exports, "DefaultLegendContent", ()=>(0, _defaultLegendContent.DefaultLegendContent));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltip.Tooltip));
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>(0, _defaultTooltipContent.DefaultTooltipContent));
parcelHelpers.export(exports, "ResponsiveContainer", ()=>(0, _responsiveContainer.ResponsiveContainer));
parcelHelpers.export(exports, "Cell", ()=>(0, _cell.Cell));
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
parcelHelpers.export(exports, "Label", ()=>(0, _label.Label));
parcelHelpers.export(exports, "LabelList", ()=>(0, _labelList.LabelList));
parcelHelpers.export(exports, "Customized", ()=>(0, _customized.Customized));
parcelHelpers.export(exports, "Sector", ()=>(0, _sector.Sector));
parcelHelpers.export(exports, "Curve", ()=>(0, _curve.Curve));
parcelHelpers.export(exports, "Rectangle", ()=>(0, _rectangle.Rectangle));
parcelHelpers.export(exports, "Polygon", ()=>(0, _polygon.Polygon));
parcelHelpers.export(exports, "Dot", ()=>(0, _dot.Dot));
parcelHelpers.export(exports, "Cross", ()=>(0, _cross.Cross));
parcelHelpers.export(exports, "Symbols", ()=>(0, _symbols.Symbols));
parcelHelpers.export(exports, "PolarGrid", ()=>(0, _polarGrid.PolarGrid));
parcelHelpers.export(exports, "PolarRadiusAxis", ()=>(0, _polarRadiusAxis.PolarRadiusAxis));
parcelHelpers.export(exports, "PolarAngleAxis", ()=>(0, _polarAngleAxis.PolarAngleAxis));
parcelHelpers.export(exports, "Pie", ()=>(0, _pie.Pie));
parcelHelpers.export(exports, "Radar", ()=>(0, _radar.Radar));
parcelHelpers.export(exports, "RadialBar", ()=>(0, _radialBar.RadialBar));
parcelHelpers.export(exports, "Brush", ()=>(0, _brush.Brush));
parcelHelpers.export(exports, "ReferenceLine", ()=>(0, _referenceLine.ReferenceLine));
parcelHelpers.export(exports, "ReferenceDot", ()=>(0, _referenceDot.ReferenceDot));
parcelHelpers.export(exports, "ReferenceArea", ()=>(0, _referenceArea.ReferenceArea));
parcelHelpers.export(exports, "CartesianAxis", ()=>(0, _cartesianAxis.CartesianAxis));
parcelHelpers.export(exports, "CartesianGrid", ()=>(0, _cartesianGrid.CartesianGrid));
parcelHelpers.export(exports, "Line", ()=>(0, _line.Line));
parcelHelpers.export(exports, "Area", ()=>(0, _area.Area));
parcelHelpers.export(exports, "Bar", ()=>(0, _bar.Bar));
parcelHelpers.export(exports, "Scatter", ()=>(0, _scatter.Scatter));
parcelHelpers.export(exports, "XAxis", ()=>(0, _xaxis.XAxis));
parcelHelpers.export(exports, "YAxis", ()=>(0, _yaxis.YAxis));
parcelHelpers.export(exports, "ZAxis", ()=>(0, _zaxis.ZAxis));
parcelHelpers.export(exports, "ErrorBar", ()=>(0, _errorBar.ErrorBar));
parcelHelpers.export(exports, "LineChart", ()=>(0, _lineChart.LineChart));
parcelHelpers.export(exports, "BarChart", ()=>(0, _barChart.BarChart));
parcelHelpers.export(exports, "PieChart", ()=>(0, _pieChart.PieChart));
parcelHelpers.export(exports, "Treemap", ()=>(0, _treemap.Treemap));
parcelHelpers.export(exports, "Sankey", ()=>(0, _sankey.Sankey));
parcelHelpers.export(exports, "RadarChart", ()=>(0, _radarChart.RadarChart));
parcelHelpers.export(exports, "ScatterChart", ()=>(0, _scatterChart.ScatterChart));
parcelHelpers.export(exports, "AreaChart", ()=>(0, _areaChart.AreaChart));
parcelHelpers.export(exports, "RadialBarChart", ()=>(0, _radialBarChart.RadialBarChart));
parcelHelpers.export(exports, "ComposedChart", ()=>(0, _composedChart.ComposedChart));
parcelHelpers.export(exports, "SunburstChart", ()=>(0, _sunburstChart.SunburstChart));
parcelHelpers.export(exports, "Funnel", ()=>(0, _funnel.Funnel));
parcelHelpers.export(exports, "FunnelChart", ()=>(0, _funnelChart.FunnelChart));
parcelHelpers.export(exports, "Trapezoid", ()=>(0, _trapezoid.Trapezoid));
parcelHelpers.export(exports, "Global", ()=>(0, _global.Global));
var _surface = require("./container/Surface");
var _layer = require("./container/Layer");
var _legend = require("./component/Legend");
var _defaultLegendContent = require("./component/DefaultLegendContent");
var _tooltip = require("./component/Tooltip");
var _defaultTooltipContent = require("./component/DefaultTooltipContent");
var _responsiveContainer = require("./component/ResponsiveContainer");
var _cell = require("./component/Cell");
var _text = require("./component/Text");
var _label = require("./component/Label");
var _labelList = require("./component/LabelList");
var _customized = require("./component/Customized");
var _sector = require("./shape/Sector");
var _curve = require("./shape/Curve");
var _rectangle = require("./shape/Rectangle");
var _polygon = require("./shape/Polygon");
var _dot = require("./shape/Dot");
var _cross = require("./shape/Cross");
var _symbols = require("./shape/Symbols");
var _polarGrid = require("./polar/PolarGrid");
var _polarRadiusAxis = require("./polar/PolarRadiusAxis");
var _polarAngleAxis = require("./polar/PolarAngleAxis");
var _pie = require("./polar/Pie");
var _radar = require("./polar/Radar");
var _radialBar = require("./polar/RadialBar");
var _brush = require("./cartesian/Brush");
var _referenceLine = require("./cartesian/ReferenceLine");
var _referenceDot = require("./cartesian/ReferenceDot");
var _referenceArea = require("./cartesian/ReferenceArea");
var _cartesianAxis = require("./cartesian/CartesianAxis");
var _cartesianGrid = require("./cartesian/CartesianGrid");
var _line = require("./cartesian/Line");
var _area = require("./cartesian/Area");
var _bar = require("./cartesian/Bar");
var _scatter = require("./cartesian/Scatter");
var _xaxis = require("./cartesian/XAxis");
var _yaxis = require("./cartesian/YAxis");
var _zaxis = require("./cartesian/ZAxis");
var _errorBar = require("./cartesian/ErrorBar");
var _lineChart = require("./chart/LineChart");
var _barChart = require("./chart/BarChart");
var _pieChart = require("./chart/PieChart");
var _treemap = require("./chart/Treemap");
var _sankey = require("./chart/Sankey");
var _radarChart = require("./chart/RadarChart");
var _scatterChart = require("./chart/ScatterChart");
var _areaChart = require("./chart/AreaChart");
var _radialBarChart = require("./chart/RadialBarChart");
var _composedChart = require("./chart/ComposedChart");
var _sunburstChart = require("./chart/SunburstChart");
var _funnel = require("./numberAxis/Funnel");
var _funnelChart = require("./chart/FunnelChart");
var _trapezoid = require("./shape/Trapezoid");
var _global = require("./util/Global");

},{"./container/Surface":false,"./container/Layer":false,"./component/Legend":"56zvs","./component/DefaultLegendContent":false,"./component/Tooltip":"1NIRS","./component/DefaultTooltipContent":false,"./component/ResponsiveContainer":"RL5OJ","./component/Cell":"i1Cei","./component/Text":false,"./component/Label":false,"./component/LabelList":false,"./component/Customized":false,"./shape/Sector":false,"./shape/Curve":false,"./shape/Rectangle":false,"./shape/Polygon":false,"./shape/Dot":false,"./shape/Cross":false,"./shape/Symbols":false,"./polar/PolarGrid":false,"./polar/PolarRadiusAxis":false,"./polar/PolarAngleAxis":false,"./polar/Pie":"2dqJh","./polar/Radar":false,"./polar/RadialBar":false,"./cartesian/Brush":false,"./cartesian/ReferenceLine":false,"./cartesian/ReferenceDot":false,"./cartesian/ReferenceArea":false,"./cartesian/CartesianAxis":false,"./cartesian/CartesianGrid":"axPz4","./cartesian/Line":"kZLv6","./cartesian/Area":false,"./cartesian/Bar":"e8121","./cartesian/Scatter":false,"./cartesian/XAxis":false,"./cartesian/YAxis":"hUr9E","./cartesian/ZAxis":false,"./cartesian/ErrorBar":false,"./chart/LineChart":"h8kjL","./chart/BarChart":"kwiN7","./chart/PieChart":"2XOME","./chart/Treemap":false,"./chart/Sankey":false,"./chart/RadarChart":false,"./chart/ScatterChart":false,"./chart/AreaChart":false,"./chart/RadialBarChart":false,"./chart/ComposedChart":false,"./chart/SunburstChart":false,"./numberAxis/Funnel":false,"./chart/FunnelChart":false,"./shape/Trapezoid":false,"./util/Global":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3GjFE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>Surface);
/**
 * @fileOverview Surface
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Surface(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = _objectWithoutProperties(props, _excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, _clsxDefault.default)("recharts-surface", className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({}, (0, _reactUtils.filterProps)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("desc", null, desc), children);
}

},{"react":"BK2ob","clsx":"bGtJT","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"56rQC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCALE_TYPES", ()=>SCALE_TYPES);
parcelHelpers.export(exports, "LEGEND_TYPES", ()=>LEGEND_TYPES);
parcelHelpers.export(exports, "TOOLTIP_TYPES", ()=>TOOLTIP_TYPES);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
parcelHelpers.export(exports, "toArray", ()=>toArray);
/*
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findAllByType", ()=>findAllByType);
/*
 * Return the first matched child by type, return null otherwise.
 * `type` must be a React.ComponentType
 */ parcelHelpers.export(exports, "findChildByType", ()=>findChildByType);
parcelHelpers.export(exports, "withoutType", ()=>withoutType);
parcelHelpers.export(exports, "validateWidthHeight", ()=>validateWidthHeight);
parcelHelpers.export(exports, "isDotProps", ()=>isDotProps);
parcelHelpers.export(exports, "isValidSpreadableProp", ()=>isValidSpreadableProp);
parcelHelpers.export(exports, "filterSvgElements", ()=>filterSvgElements);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "isChildrenEqual", ()=>isChildrenEqual);
parcelHelpers.export(exports, "isSingleChildEqual", ()=>isSingleChildEqual);
parcelHelpers.export(exports, "renderByOrder", ()=>renderByOrder);
parcelHelpers.export(exports, "getReactEventByType", ()=>getReactEventByType);
parcelHelpers.export(exports, "parseChildIndex", ()=>parseChildIndex);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _react = require("react");
var _reactIs = require("react-is");
var _dataUtils = require("./DataUtils");
var _shallowEqual = require("./ShallowEqual");
var _types = require("./types");
var _excluded = [
    "children"
], _excluded2 = [
    "children"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var SCALE_TYPES = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var LEGEND_TYPES = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var TOOLTIP_TYPES = [
    "none"
];
var getDisplayName = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = function toArray(children) {
    if (children === lastChildren && Array.isArray(lastResult)) return lastResult;
    var result = [];
    (0, _react.Children).forEach(children, function(child) {
        if ((0, _isNilDefault.default)(child)) return;
        if ((0, _reactIs.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    lastResult = result;
    lastChildren = children;
    return result;
};
function findAllByType(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var childType = (0, _getDefault.default)(child, "type.displayName") || (0, _getDefault.default)(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function findChildByType(children, type) {
    var result = findAllByType(children, type);
    return result && result[0];
}
var withoutType = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return getDisplayName(t);
    });
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach(function(child) {
        var displayName = (0, _getDefault.default)(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var validateWidthHeight = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0) return false;
    return true;
};
var SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, _isStringDefault.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
var isDotProps = function isDotProps(dot) {
    return dot && _typeof(dot) === "object" && "cx" in dot && "cy" in dot && "r" in dot;
};
var isValidSpreadableProp = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, _types.FilteredElementKeyMap) === null || (0, _types.FilteredElementKeyMap) === void 0 ? void 0 : (0, _types.FilteredElementKeyMap)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, _isFunctionDefault.default)(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, _types.SVGElementPropKeys).includes(key)) || includeEvents && (0, _types.EventKeys).includes(key);
};
var filterSvgElements = function filterSvgElements(children) {
    var svgElements = [];
    toArray(children).forEach(function(entry) {
        if (isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var filterProps = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, _react.Children).count(nextChildren);
    if (count !== (0, _react.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!isSingleChildEqual(nextChild, prevChild)) return false;
    }
    return true;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, _isNilDefault.default)(nextChild) && (0, _isNilDefault.default)(prevChild)) return true;
    if (!(0, _isNilDefault.default)(nextChild) && !(0, _isNilDefault.default)(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = _objectWithoutProperties(_ref, _excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = _objectWithoutProperties(_ref2, _excluded2);
        if (nextChildren && prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, _shallowEqual.shallowEqual)(nextProps, prevProps);
        return false;
    }
    return false;
};
var renderByOrder = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    toArray(children).forEach(function(child, index) {
        if (isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = getDisplayName(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var getReactEventByType = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && REACT_BROWSER_EVENT_MAP[type]) return REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
    return toArray(children).indexOf(child);
};

},{"lodash/get":"1XYRd","lodash/isNil":"4xNOq","lodash/isString":"cpoTe","lodash/isFunction":"56sPA","lodash/isObject":"lgjQC","react":"BK2ob","react-is":"itSJh","./DataUtils":"kHJdD","./ShallowEqual":"36pLK","./types":"73B4U","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1XYRd":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"ciDgX"}],"ciDgX":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"ctqA5","c3296f04fad32769":"cAgQB"}],"ctqA5":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"8PiWS","e823e604d75f975b":"attHx","f5fff1c342107fbd":"7rC1l","b04e8cc634273c23":"8UnqX"}],"8PiWS":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"attHx":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"8PiWS","4cdff6c9e9ff5d38":"5cADF"}],"5cADF":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"3mPah","74644060ad1a1d3c":"edAV6"}],"3mPah":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"P1OwS","9b2aaf31b7bdd837":"lueGL","46d5beb3375f8a28":"gFNWg"}],"P1OwS":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"303fC"}],"303fC":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"lMyZ6"}],"lMyZ6":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"lueGL":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"P1OwS"}],"gFNWg":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"edAV6":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"7rC1l":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"a2ZwF"}],"a2ZwF":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"gJ1Vu"}],"gJ1Vu":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"brkr2"}],"brkr2":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"g1EOM","d2967b0e32ccfa56":"6o7NA","ca21409ea89624c0":"h2lBz","f88fd07f8dd1f67d":"9yrkr","dbf3eae765642a3b":"euXAA"}],"g1EOM":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"cqPdM","a07dcf3fd3097a0c":"1TCzF","92c01c953ef00ded":"dtWm9"}],"cqPdM":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"64Rj7","bc25d439ccd1fb47":"4GaPw","f096b37295a92ab0":"ccsRR","d88173cbc6a133c8":"g2JjZ","afb9b3bae0461cbf":"72lrr"}],"64Rj7":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"4HiOM"}],"4HiOM":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"i9vsD"}],"i9vsD":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"akbDC","16db51a0e009bd8c":"7Dxpb"}],"akbDC":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"56sPA","cabbc2adfaeb27d9":"5Ze5P","cbb5703fe1562e7f":"lgjQC","388b819f47a43aa5":"2QLnS"}],"56sPA":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"3mPah","3cba3c966459d528":"lgjQC"}],"lgjQC":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"5Ze5P":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"j6oZm"}],"j6oZm":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"303fC"}],"2QLnS":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"7Dxpb":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"4GaPw":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"ccsRR":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"4HiOM"}],"g2JjZ":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"4HiOM"}],"72lrr":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"4HiOM"}],"1TCzF":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"aZDDz","b700cb849df2c166":"dxsMI","d76dd90eead6cced":"euXiC","3d210628ba60ec8":"a6IYR","76026bf2d4cfff93":"29FfR"}],"aZDDz":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"dxsMI":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"4IEYj"}],"4IEYj":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"6qU1V"}],"6qU1V":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"euXiC":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"4IEYj"}],"a6IYR":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"4IEYj"}],"29FfR":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"4IEYj"}],"dtWm9":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"i9vsD","29224713b8d411e6":"303fC"}],"6o7NA":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"6jHSG"}],"6jHSG":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"aBULc"}],"aBULc":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"h2lBz":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"6jHSG"}],"9yrkr":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"6jHSG"}],"euXAA":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"6jHSG"}],"8UnqX":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"ZbjMT"}],"ZbjMT":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"P1OwS","8439a3a1551d0706":"2fndP","4b12c9f502d3288a":"8PiWS","a0ebd327d618908a":"5cADF"}],"2fndP":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"cAgQB":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"5cADF"}],"4xNOq":[function(require,module,exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"cpoTe":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"3mPah","46fdd4d2c5d7b4ab":"8PiWS","36ebbb6a9d8b3fe4":"edAV6"}],"kHJdD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mathSign", ()=>mathSign);
parcelHelpers.export(exports, "isPercent", ()=>isPercent);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isNumOrStr", ()=>isNumOrStr);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "getPercentValue", ()=>getPercentValue);
parcelHelpers.export(exports, "getAnyElementOfObject", ()=>getAnyElementOfObject);
parcelHelpers.export(exports, "hasDuplicate", ()=>hasDuplicate);
parcelHelpers.export(exports, "interpolateNumber", ()=>interpolateNumber);
parcelHelpers.export(exports, "findEntryInArray", ()=>findEntryInArray);
parcelHelpers.export(exports, "getLinearRegression", ()=>getLinearRegression);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var mathSign = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var isPercent = function isPercent(value) {
    return (0, _isStringDefault.default)(value) && value.indexOf("%") === value.length - 1;
};
var isNumber = function isNumber(value) {
    return (0, _isNumberDefault.default)(value) && !(0, _isNaNDefault.default)(value);
};
var isNumOrStr = function isNumOrStr(value) {
    return isNumber(value) || (0, _isStringDefault.default)(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
    var id = ++idCounter;
    return "".concat(prefix || "").concat(id);
};
var getPercentValue = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isNumber(percent) && !(0, _isStringDefault.default)(percent)) return defaultValue;
    var value;
    if (isPercent(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, _isNaNDefault.default)(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var hasDuplicate = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var interpolateNumber = function interpolateNumber(numberA, numberB) {
    if (isNumber(numberA) && isNumber(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, _getDefault.default)(entry, specifiedKey)) === specifiedValue;
    });
}
var getLinearRegression = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};

},{"lodash/isString":"cpoTe","lodash/isNaN":"TZX9h","lodash/get":"1XYRd","lodash/isNumber":"1bvcC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"TZX9h":[function(require,module,exports) {
var isNumber = require("3426dfbd8f8be7c7");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return isNumber(value) && value != +value;
}
module.exports = isNaN;

},{"3426dfbd8f8be7c7":"1bvcC"}],"1bvcC":[function(require,module,exports) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"3mPah","6ae0825ac2dae50f":"edAV6"}],"36pLK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
function shallowEqual(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"73B4U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGElementPropKeys", ()=>SVGElementPropKeys);
parcelHelpers.export(exports, "FilteredElementKeyMap", ()=>FilteredElementKeyMap);
parcelHelpers.export(exports, "EventKeys", ()=>EventKeys);
parcelHelpers.export(exports, "adaptEventHandlers", ()=>adaptEventHandlers);
parcelHelpers.export(exports, "adaptEventsOfChild", ()=>adaptEventsOfChild);
var _react = require("react");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var SVGElementPropKeys = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var PolyElementKeys = [
    "points",
    "pathLength"
];
var FilteredElementKeyMap = {
    svg: SVGContainerPropKeys,
    polygon: PolyElementKeys,
    polyline: PolyElementKeys
};
var EventKeys = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (!(0, _isObjectDefault.default)(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if (EventKeys.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
    if (!(0, _isObjectDefault.default)(props) || _typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if (EventKeys.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};

},{"react":"BK2ob","lodash/isObject":"lgjQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eHeGW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "children",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Layer = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = _objectWithoutProperties(props, _excluded);
    var layerClass = (0, _clsxDefault.default)("recharts-layer", className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", _extends({
        className: layerClass
    }, (0, _reactUtils.filterProps)(others, true), {
        ref: ref
    }), children);
});

},{"react":"BK2ob","clsx":"bGtJT","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"56zvs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Legend", ()=>Legend);
/**
 * @fileOverview Legend
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultLegendContent = require("./DefaultLegendContent");
var _dataUtils = require("../util/DataUtils");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "ref"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function defaultUniqBy(entry) {
    return entry.value;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    var ref = props.ref, otherProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultLegendContent.DefaultLegendContent), otherProps);
}
var EPS = 1;
var Legend = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Legend, _PureComponent);
    function Legend() {
        var _this;
        _classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Legend, [].concat(args));
        _defineProperty(_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    _createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    _box.height = this.wrapperNode.offsetHeight;
                    _box.width = this.wrapperNode.offsetWidth;
                    return _box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > EPS || Math.abs(box.height - this.lastBoundingBox.height) > EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return _objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return _objectSpread(_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = _objectSpread(_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: (0, _getUniqPayload.getUniqPayload)(payload, payloadUniqBy, defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, _dataUtils.isNumber)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, _react.PureComponent));
_defineProperty(Legend, "displayName", "Legend");
_defineProperty(Legend, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});

},{"react":"BK2ob","./DefaultLegendContent":"31Jjp","../util/DataUtils":"kHJdD","../util/payload/getUniqPayload":"iTCPB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"31Jjp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultLegendContent", ()=>DefaultLegendContent);
/**
 * @fileOverview Default Legend Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _logUtils = require("../util/LogUtils");
var _surface = require("../container/Surface");
var _symbols = require("../shape/Symbols");
var _types = require("../util/types");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var SIZE = 32;
var DefaultLegendContent = /*#__PURE__*/ function(_PureComponent) {
    _inherits(DefaultLegendContent, _PureComponent);
    function DefaultLegendContent() {
        _classCallCheck(this, DefaultLegendContent);
        return _callSuper(this, DefaultLegendContent, arguments);
    }
    _createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = SIZE / 2;
                var sixthSize = SIZE / 6;
                var thirdSize = SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(data.legendIcon)) {
                    var iconProps = _objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: SIZE,
                    height: SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, _clsxDefault.default)(_defineProperty(_defineProperty({
                        "recharts-legend-item": true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === "none") return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, _isFunctionDefault.default)(entry.value) ? entry.value : null;
                    (0, _logUtils.warn)(!(0, _isFunctionDefault.default)(entry.value), 'The name property is also required when using a function for the dataKey of a chart\'s cartesian components. Ex: <Bar name="Name of my Data"/>' // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", _extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, _react.PureComponent));
_defineProperty(DefaultLegendContent, "displayName", "Legend");
_defineProperty(DefaultLegendContent, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});

},{"react":"BK2ob","lodash/isFunction":"56sPA","clsx":"bGtJT","../util/LogUtils":"jEZ3K","../container/Surface":"3GjFE","../shape/Symbols":"i7d89","../util/types":"73B4U","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jEZ3K":[function(require,module,exports) {
/* eslint no-console: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
var isDev = false;
var warn = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i7d89":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Symbols", ()=>Symbols);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _d3Shape = require("victory-vendor/d3-shape");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "type",
    "size",
    "sizeType"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var symbolFactories = {
    symbolCircle: (0, _d3Shape.symbolCircle),
    symbolCross: (0, _d3Shape.symbolCross),
    symbolDiamond: (0, _d3Shape.symbolDiamond),
    symbolSquare: (0, _d3Shape.symbolSquare),
    symbolStar: (0, _d3Shape.symbolStar),
    symbolTriangle: (0, _d3Shape.symbolTriangle),
    symbolWye: (0, _d3Shape.symbolWye)
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, _upperFirstDefault.default)(type));
    return symbolFactories[name] || (0, _d3Shape.symbolCircle);
};
var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var registerSymbol = function registerSymbol(key, factory) {
    symbolFactories["symbol".concat((0, _upperFirstDefault.default)(key))] = factory;
};
var Symbols = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread(_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = getSymbolFactory(type);
        var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, _reactUtils.filterProps)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, filteredProps, {
        className: (0, _clsxDefault.default)("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
Symbols.registerSymbol = registerSymbol;

},{"react":"BK2ob","lodash/upperFirst":"ko2wy","victory-vendor/d3-shape":"ccJ5o","clsx":"bGtJT","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ko2wy":[function(require,module,exports) {
var createCaseFirst = require("9f71ec962d19127");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst("toUpperCase");
module.exports = upperFirst;

},{"9f71ec962d19127":"1wg4E"}],"1wg4E":[function(require,module,exports) {
var castSlice = require("6cc0e53be1623a5f"), hasUnicode = require("e28707473345265"), stringToArray = require("32980b84821a53a0"), toString = require("e00796f8e204e98");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = createCaseFirst;

},{"6cc0e53be1623a5f":"aOIuq","e28707473345265":"6pyVg","32980b84821a53a0":"hKXmR","e00796f8e204e98":"8UnqX"}],"aOIuq":[function(require,module,exports) {
var baseSlice = require("19fbc2ab8fa927cd");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
module.exports = castSlice;

},{"19fbc2ab8fa927cd":"fnCSY"}],"fnCSY":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"6pyVg":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"hKXmR":[function(require,module,exports) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"jqUHP","d3e31b390208b2ca":"6pyVg","2a468ebcd49732b9":"cVDel"}],"jqUHP":[function(require,module,exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split("");
}
module.exports = asciiToArray;

},{}],"cVDel":[function(require,module,exports) {
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"ccJ5o":[function(require,module,exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("19271802296fa753");

},{"19271802296fa753":"f4vHg"}],"f4vHg":[function(require,module,exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
module.exports = require("176bd3ee52fdecae");

},{"176bd3ee52fdecae":"4UUEf"}],"4UUEf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "arc", {
    enumerable: true,
    get: function() {
        return _arc.default;
    }
});
Object.defineProperty(exports, "area", {
    enumerable: true,
    get: function() {
        return _area.default;
    }
});
Object.defineProperty(exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return _basisOpen.default;
    }
});
Object.defineProperty(exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return _bump.bumpX;
    }
});
Object.defineProperty(exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return _bump.bumpY;
    }
});
Object.defineProperty(exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return _bundle.default;
    }
});
Object.defineProperty(exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return _cardinal.default;
    }
});
Object.defineProperty(exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return _cardinalClosed.default;
    }
});
Object.defineProperty(exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return _cardinalOpen.default;
    }
});
Object.defineProperty(exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return _catmullRom.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return _catmullRomClosed.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return _catmullRomOpen.default;
    }
});
Object.defineProperty(exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return _linearClosed.default;
    }
});
Object.defineProperty(exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneX;
    }
});
Object.defineProperty(exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneY;
    }
});
Object.defineProperty(exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return _natural.default;
    }
});
Object.defineProperty(exports, "curveStep", {
    enumerable: true,
    get: function() {
        return _step.default;
    }
});
Object.defineProperty(exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return _step.stepAfter;
    }
});
Object.defineProperty(exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return _step.stepBefore;
    }
});
Object.defineProperty(exports, "line", {
    enumerable: true,
    get: function() {
        return _line.default;
    }
});
Object.defineProperty(exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "link", {
    enumerable: true,
    get: function() {
        return _link.link;
    }
});
Object.defineProperty(exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return _link.linkHorizontal;
    }
});
Object.defineProperty(exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return _link.linkRadial;
    }
});
Object.defineProperty(exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return _link.linkVertical;
    }
});
Object.defineProperty(exports, "pie", {
    enumerable: true,
    get: function() {
        return _pie.default;
    }
});
Object.defineProperty(exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return _pointRadial.default;
    }
});
Object.defineProperty(exports, "radialArea", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "radialLine", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "stack", {
    enumerable: true,
    get: function() {
        return _stack.default;
    }
});
Object.defineProperty(exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return _expand.default;
    }
});
Object.defineProperty(exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return _none.default;
    }
});
Object.defineProperty(exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return _silhouette.default;
    }
});
Object.defineProperty(exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return _wiggle.default;
    }
});
Object.defineProperty(exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return _appearance.default;
    }
});
Object.defineProperty(exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return _insideOut.default;
    }
});
Object.defineProperty(exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return _none2.default;
    }
});
Object.defineProperty(exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "symbol", {
    enumerable: true,
    get: function() {
        return _symbol.default;
    }
});
Object.defineProperty(exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return _asterisk.default;
    }
});
Object.defineProperty(exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return _circle.default;
    }
});
Object.defineProperty(exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return _diamond.default;
    }
});
Object.defineProperty(exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return _diamond2.default;
    }
});
Object.defineProperty(exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return _plus.default;
    }
});
Object.defineProperty(exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return _square.default;
    }
});
Object.defineProperty(exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return _square2.default;
    }
});
Object.defineProperty(exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return _star.default;
    }
});
Object.defineProperty(exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return _triangle.default;
    }
});
Object.defineProperty(exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return _triangle2.default;
    }
});
Object.defineProperty(exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return _wye.default;
    }
});
Object.defineProperty(exports, "symbolX", {
    enumerable: true,
    get: function() {
        return _x.default;
    }
});
Object.defineProperty(exports, "symbols", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsStroke;
    }
});
var _arc = _interopRequireDefault(require("2d3f5974235d4d97"));
var _area = _interopRequireDefault(require("e7d6d9d0e4901d2e"));
var _line = _interopRequireDefault(require("bce35bc16739dbe5"));
var _pie = _interopRequireDefault(require("74b9b0848a30f56d"));
var _areaRadial = _interopRequireDefault(require("795a4987e33fc84"));
var _lineRadial = _interopRequireDefault(require("b1ce66d1195c070b"));
var _pointRadial = _interopRequireDefault(require("18b93f5355310e1c"));
var _link = require("661c14c96c31c97d");
var _symbol = _interopRequireWildcard(require("974cd54b219b5407"));
var _asterisk = _interopRequireDefault(require("3237a04f4f14fca5"));
var _circle = _interopRequireDefault(require("d06ad8106b0de21c"));
var _cross = _interopRequireDefault(require("871a2983fe1eb51f"));
var _diamond = _interopRequireDefault(require("d1ef85359a4dd212"));
var _diamond2 = _interopRequireDefault(require("3dea65984f117ec1"));
var _plus = _interopRequireDefault(require("1565ec3cf1a7613a"));
var _square = _interopRequireDefault(require("9285c34ad7b613e4"));
var _square2 = _interopRequireDefault(require("c6e9c9d35fa5b5cb"));
var _star = _interopRequireDefault(require("815abfb8fc8798e0"));
var _triangle = _interopRequireDefault(require("431e53334965b545"));
var _triangle2 = _interopRequireDefault(require("64d0ff16b783fd6c"));
var _wye = _interopRequireDefault(require("6bcb4260ac11e7b8"));
var _x = _interopRequireDefault(require("f8ed4fd677a8b4d9"));
var _basisClosed = _interopRequireDefault(require("91e47160fd76a75d"));
var _basisOpen = _interopRequireDefault(require("3cfac39a85530a37"));
var _basis = _interopRequireDefault(require("f697ba81082957cf"));
var _bump = require("2bea78dcacfdca47");
var _bundle = _interopRequireDefault(require("e82aff58f59c7695"));
var _cardinalClosed = _interopRequireDefault(require("c72e75e517eac392"));
var _cardinalOpen = _interopRequireDefault(require("9217e81617e05b4"));
var _cardinal = _interopRequireDefault(require("1dd79a3764c6f2bf"));
var _catmullRomClosed = _interopRequireDefault(require("aee7da70ecf7456b"));
var _catmullRomOpen = _interopRequireDefault(require("6d5f31fa960dcbe2"));
var _catmullRom = _interopRequireDefault(require("3a4d3052f18b3d40"));
var _linearClosed = _interopRequireDefault(require("46142d6a54d00966"));
var _linear = _interopRequireDefault(require("e55fce1282a99ed7"));
var _monotone = require("fad9762fa89b7933");
var _natural = _interopRequireDefault(require("188623ab79fe5f6b"));
var _step = _interopRequireWildcard(require("48bb2877ede27508"));
var _stack = _interopRequireDefault(require("39fd6af83767c8b0"));
var _expand = _interopRequireDefault(require("17e05ad95922030d"));
var _diverging = _interopRequireDefault(require("a216beddff4c3a08"));
var _none = _interopRequireDefault(require("b09a2130bd13b1e0"));
var _silhouette = _interopRequireDefault(require("70400e7acef40477"));
var _wiggle = _interopRequireDefault(require("b9b44fd8f75e0415"));
var _appearance = _interopRequireDefault(require("fd3023466e7ac9e7"));
var _ascending = _interopRequireDefault(require("46c02ef8fc93b026"));
var _descending = _interopRequireDefault(require("a5a0ae33dd14b3b0"));
var _insideOut = _interopRequireDefault(require("43469f5cea84b12e"));
var _none2 = _interopRequireDefault(require("68f36eef1efe200b"));
var _reverse = _interopRequireDefault(require("a5f086840207a549"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"2d3f5974235d4d97":"9P63z","e7d6d9d0e4901d2e":"7NzfB","bce35bc16739dbe5":"hLgwr","74b9b0848a30f56d":"5ZL19","795a4987e33fc84":"2CZIb","b1ce66d1195c070b":"1r41u","18b93f5355310e1c":"bbANQ","661c14c96c31c97d":"f07C9","974cd54b219b5407":"hmsSy","3237a04f4f14fca5":"fdSK9","d06ad8106b0de21c":"ac2kq","871a2983fe1eb51f":"6OTk5","d1ef85359a4dd212":"eOYdW","3dea65984f117ec1":"7c2Zq","1565ec3cf1a7613a":"7FdmY","9285c34ad7b613e4":"70VVK","c6e9c9d35fa5b5cb":"8gZU4","815abfb8fc8798e0":"epJC5","431e53334965b545":"tnr7D","64d0ff16b783fd6c":"5wawP","6bcb4260ac11e7b8":"72y3a","f8ed4fd677a8b4d9":"fuSzE","91e47160fd76a75d":"8TbeW","3cfac39a85530a37":"iegZb","f697ba81082957cf":"8q6s5","2bea78dcacfdca47":"lwiH8","e82aff58f59c7695":"d0xR7","c72e75e517eac392":"gRXvw","9217e81617e05b4":"34TNi","1dd79a3764c6f2bf":"k8D9a","aee7da70ecf7456b":"ll7gY","6d5f31fa960dcbe2":"4ZOL9","3a4d3052f18b3d40":"eUUkv","46142d6a54d00966":"gBXDY","e55fce1282a99ed7":"8oocC","fad9762fa89b7933":"bKjYq","188623ab79fe5f6b":"MTOSC","48bb2877ede27508":"1qmxm","39fd6af83767c8b0":"b0qQy","17e05ad95922030d":"2izUD","a216beddff4c3a08":"bFP8M","b09a2130bd13b1e0":"5QinT","70400e7acef40477":"lHBQk","b9b44fd8f75e0415":"9FPge","fd3023466e7ac9e7":"7VknF","46c02ef8fc93b026":"2LZhd","a5a0ae33dd14b3b0":"4ra6F","43469f5cea84b12e":"dW1pc","68f36eef1efe200b":"9nCy1","a5f086840207a549":"7m1pI"}],"9P63z":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("9b71135f97bb0843");
var _constant = _interopRequireDefault(require("b66d56b93af4da33"));
var _math = require("53b6f54f25927f26");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < _math.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _math.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _math.sqrt)((0, _math.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function _default() {
    var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constant.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - _math.halfPi, a1 = endAngle.apply(this, arguments) - _math.halfPi, da = (0, _math.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, _index.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > _math.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > _math.tau - _math.epsilon) {
            context.moveTo(r1 * (0, _math.cos)(a0), r1 * (0, _math.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > _math.epsilon) {
                context.moveTo(r0 * (0, _math.cos)(a1), r0 * (0, _math.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > _math.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _math.min)((0, _math.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > _math.epsilon) {
                var p0 = (0, _math.asin)(rp / r0 * (0, _math.sin)(ap)), p1 = (0, _math.asin)(rp / r1 * (0, _math.sin)(ap));
                if ((da0 -= p0 * 2) > _math.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > _math.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, _math.cos)(a01), y01 = r1 * (0, _math.sin)(a01), x10 = r0 * (0, _math.cos)(a10), y10 = r0 * (0, _math.sin)(a10); // Apply rounded corners?
            if (rc > _math.epsilon) {
                var x11 = r1 * (0, _math.cos)(a11), y11 = r1 * (0, _math.sin)(a11), x00 = r0 * (0, _math.cos)(a00), y00 = r0 * (0, _math.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < _math.pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _math.sin)((0, _math.acos)((ax * bx + ay * by) / ((0, _math.sqrt)(ax * ax + ay * ay) * (0, _math.sqrt)(bx * bx + by * by))) / 2), lc = (0, _math.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, _math.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, _math.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > _math.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > _math.epsilon) {
                t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > _math.epsilon) || !(da0 > _math.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > _math.epsilon) {
                t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math.pi / 2;
        return [
            (0, _math.cos)(a) * r,
            (0, _math.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

},{"9b71135f97bb0843":"18kLI","b66d56b93af4da33":"fyxRC","53b6f54f25927f26":"hJVMH"}],"18kLI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "path", {
    enumerable: true,
    get: function() {
        return _path.default;
    }
});
var _path = _interopRequireDefault(require("3b0cf72f61f38e1e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"3b0cf72f61f38e1e":"4i3wE"}],"4i3wE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path();
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var _default = path;
exports.default = _default;

},{}],"fyxRC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return function constant() {
        return x;
    };
}

},{}],"hJVMH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abs = void 0;
exports.acos = acos;
exports.asin = asin;
exports.tau = exports.sqrt = exports.sin = exports.pi = exports.min = exports.max = exports.halfPi = exports.epsilon = exports.cos = exports.atan2 = void 0;
const abs = Math.abs;
exports.abs = abs;
const atan2 = Math.atan2;
exports.atan2 = atan2;
const cos = Math.cos;
exports.cos = cos;
const max = Math.max;
exports.max = max;
const min = Math.min;
exports.min = min;
const sin = Math.sin;
exports.sin = sin;
const sqrt = Math.sqrt;
exports.sqrt = sqrt;
const epsilon = 1e-12;
exports.epsilon = epsilon;
const pi = Math.PI;
exports.pi = pi;
const halfPi = pi / 2;
exports.halfPi = halfPi;
const tau = 2 * pi;
exports.tau = tau;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{}],"7NzfB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("500493761fddc3b8");
var _array = _interopRequireDefault(require("bbf8fdbd92f1ebcd"));
var _constant = _interopRequireDefault(require("a5b783eee5be8fa0"));
var _linear = _interopRequireDefault(require("f4129b2496ff7a8b"));
var _line = _interopRequireDefault(require("b3caf3b68a2e9f58"));
var _point = require("ea923553657b0095");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x0, y0, y1) {
    var x1 = null, defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? _point.x : (0, _constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constant.default)(0) : (0, _constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? _point.y : (0, _constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, _line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

},{"500493761fddc3b8":"18kLI","bbf8fdbd92f1ebcd":"398O7","a5b783eee5be8fa0":"fyxRC","f4129b2496ff7a8b":"8oocC","b3caf3b68a2e9f58":"hLgwr","ea923553657b0095":"amJsP"}],"398O7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.slice = void 0;
var slice = Array.prototype.slice;
exports.slice = slice;
function _default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

},{}],"8oocC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function _default(context) {
    return new Linear(context);
}

},{}],"hLgwr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("98710a8cd2690312");
var _array = _interopRequireDefault(require("71eeea1751dcd149"));
var _constant = _interopRequireDefault(require("9083cb1503140862"));
var _linear = _interopRequireDefault(require("c81bc5ab811126a3"));
var _point = require("552145ba71b64707");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x, y) {
    var defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? _point.x : (0, _constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? _point.y : (0, _constant.default)(y);
    function line(data) {
        var i, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

},{"98710a8cd2690312":"18kLI","71eeea1751dcd149":"398O7","9083cb1503140862":"fyxRC","c81bc5ab811126a3":"8oocC","552145ba71b64707":"amJsP"}],"amJsP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.x = x;
exports.y = y;
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{}],"5ZL19":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("b67e0ae37b57d123"));
var _constant = _interopRequireDefault(require("37710d2df9ce0c7a"));
var _descending = _interopRequireDefault(require("a28172d9eab0febf"));
var _identity = _interopRequireDefault(require("e5c1f58030d4bf4f"));
var _math = require("496c2d9cd8d2f75c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default() {
    var value = _identity.default, sortValues = _descending.default, sort = null, startAngle = (0, _constant.default)(0), endAngle = (0, _constant.default)(_math.tau), padAngle = (0, _constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, _array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(_math.tau, Math.max(-_math.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

},{"b67e0ae37b57d123":"398O7","37710d2df9ce0c7a":"fyxRC","a28172d9eab0febf":"jAzsn","e5c1f58030d4bf4f":"jFinj","496c2d9cd8d2f75c":"hJVMH"}],"jAzsn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"jFinj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(d) {
    return d;
}

},{}],"2CZIb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _radial = _interopRequireWildcard(require("d5f2199be7e4428"));
var _area = _interopRequireDefault(require("9fd6b69a882b62b9"));
var _lineRadial = require("4727a97bf0f56e5e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _default() {
    var a = (0, _area.default)().curve(_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, _lineRadial.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, _lineRadial.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, _lineRadial.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, _lineRadial.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return a;
}

},{"d5f2199be7e4428":"cvTo9","9fd6b69a882b62b9":"7NzfB","4727a97bf0f56e5e":"1r41u"}],"cvTo9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.curveRadialLinear = void 0;
exports.default = curveRadial;
var _linear = _interopRequireDefault(require("fcbc4ed98c33ce63"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var curveRadialLinear = curveRadial(_linear.default);
exports.curveRadialLinear = curveRadialLinear;
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"fcbc4ed98c33ce63":"8oocC"}],"1r41u":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.lineRadial = lineRadial;
var _radial = _interopRequireWildcard(require("467073d1fc4d6144"));
var _line = _interopRequireDefault(require("b165a0178810938"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return l;
}
function _default() {
    return lineRadial((0, _line.default)().curve(_radial.curveRadialLinear));
}

},{"467073d1fc4d6144":"cvTo9","b165a0178810938":"hLgwr"}],"bbANQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

},{}],"f07C9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.link = link;
exports.linkHorizontal = linkHorizontal;
exports.linkRadial = linkRadial;
exports.linkVertical = linkVertical;
var _index = require("ae6bae8009c48266");
var _array = require("3bac10be5f465a96");
var _constant = _interopRequireDefault(require("35364e9c346d01b7"));
var _bump = require("ce2d1a2cbddf3802");
var _point = require("be0eb0a3ebd67c05");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    let source = linkSource;
    let target = linkTarget;
    let x = _point.x;
    let y = _point.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = _array.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, _index.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link(_bump.bumpX);
}
function linkVertical() {
    return link(_bump.bumpY);
}
function linkRadial() {
    const l = link(_bump.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"ae6bae8009c48266":"18kLI","3bac10be5f465a96":"398O7","35364e9c346d01b7":"fyxRC","ce2d1a2cbddf3802":"lwiH8","be0eb0a3ebd67c05":"amJsP"}],"lwiH8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bumpRadial = bumpRadial;
exports.bumpX = bumpX;
exports.bumpY = bumpY;
var _pointRadial = _interopRequireDefault(require("b619d14f2ed97e73"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, _pointRadial.default)(this._x0, this._y0);
            const p1 = (0, _pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, _pointRadial.default)(x, this._y0);
            const p3 = (0, _pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"b619d14f2ed97e73":"bbANQ"}],"hmsSy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Symbol;
exports.symbolsStroke = exports.symbolsFill = void 0;
var _index = require("ed221954c3cadd8c");
var _constant = _interopRequireDefault(require("a318f579ae289bb4"));
var _asterisk = _interopRequireDefault(require("4f836b828c4aee2"));
var _circle = _interopRequireDefault(require("a3d59dddf62412f7"));
var _cross = _interopRequireDefault(require("b51ad47cf070e0d4"));
var _diamond = _interopRequireDefault(require("a8375ed091b8d08a"));
var _diamond2 = _interopRequireDefault(require("7c0f9eaf6c7614f0"));
var _plus = _interopRequireDefault(require("459ff396a52f1e2d"));
var _square = _interopRequireDefault(require("174dac6271fe5f76"));
var _square2 = _interopRequireDefault(require("444710f2180a0669"));
var _star = _interopRequireDefault(require("1f31f8ec57f98fa6"));
var _triangle = _interopRequireDefault(require("f4d77aaf9ffb5dbd"));
var _triangle2 = _interopRequireDefault(require("80c17c4ac5160020"));
var _wye = _interopRequireDefault(require("2da15e99e0fdb804"));
var _x = _interopRequireDefault(require("67fc72d8d3ef7cbf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const symbolsFill = [
    _circle.default,
    _cross.default,
    _diamond.default,
    _square.default,
    _star.default,
    _triangle.default,
    _wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
exports.symbolsFill = symbolsFill;
const symbolsStroke = [
    _circle.default,
    _plus.default,
    _x.default,
    _triangle2.default,
    _asterisk.default,
    _square2.default,
    _diamond2.default
];
exports.symbolsStroke = symbolsStroke;
function Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, _constant.default)(type || _circle.default);
    size = typeof size === "function" ? size : (0, _constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, _index.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"ed221954c3cadd8c":"18kLI","a318f579ae289bb4":"fyxRC","4f836b828c4aee2":"fdSK9","a3d59dddf62412f7":"ac2kq","b51ad47cf070e0d4":"6OTk5","a8375ed091b8d08a":"eOYdW","7c0f9eaf6c7614f0":"7c2Zq","459ff396a52f1e2d":"7FdmY","174dac6271fe5f76":"70VVK","444710f2180a0669":"8gZU4","1f31f8ec57f98fa6":"epJC5","f4d77aaf9ffb5dbd":"tnr7D","80c17c4ac5160020":"5wawP","2da15e99e0fdb804":"72y3a","67fc72d8d3ef7cbf":"fuSzE"}],"fdSK9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("48d3e9f7df1a172c");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size + (0, _math.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
exports.default = _default;

},{"48d3e9f7df1a172c":"hJVMH"}],"ac2kq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("8ed2e3009b93c9bf");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / _math.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, _math.tau);
    }
};
exports.default = _default;

},{"8ed2e3009b93c9bf":"hJVMH"}],"6OTk5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("69815bae4b0787ae");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"69815bae4b0787ae":"hJVMH"}],"eOYdW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("856b74e87be6d6a0");
const tan30 = (0, _math.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
var _default = {
    draw (context, size) {
        const y = (0, _math.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"856b74e87be6d6a0":"hJVMH"}],"7c2Zq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("c8441956b7ca25b0");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
exports.default = _default;

},{"c8441956b7ca25b0":"hJVMH"}],"7FdmY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("a4abcfa52e8b0f37");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
exports.default = _default;

},{"a4abcfa52e8b0f37":"hJVMH"}],"70VVK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("e72da19a42674d7c");
var _default = {
    draw (context, size) {
        const w = (0, _math.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
exports.default = _default;

},{"e72da19a42674d7c":"hJVMH"}],"8gZU4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("1c9d5bda227640bf");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
exports.default = _default;

},{"1c9d5bda227640bf":"hJVMH"}],"epJC5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("751667ddf3bfbdc1");
const ka = 0.89081309152928522810;
const kr = (0, _math.sin)(_math.pi / 10) / (0, _math.sin)(7 * _math.pi / 10);
const kx = (0, _math.sin)(_math.tau / 10) * kr;
const ky = -(0, _math.cos)(_math.tau / 10) * kr;
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = _math.tau * i / 5;
            const c = (0, _math.cos)(a);
            const s = (0, _math.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
exports.default = _default;

},{"751667ddf3bfbdc1":"hJVMH"}],"tnr7D":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7bc957b4c8d38817");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const y = -(0, _math.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};
exports.default = _default;

},{"7bc957b4c8d38817":"hJVMH"}],"5wawP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7e4bb208ad9cf3ec");
const sqrt3 = (0, _math.sqrt)(3);
var _default = {
    draw (context, size) {
        const s = (0, _math.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
exports.default = _default;

},{"7e4bb208ad9cf3ec":"hJVMH"}],"72y3a":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("812e1ff9b9a68f0d");
const c = -0.5;
const s = (0, _math.sqrt)(3) / 2;
const k = 1 / (0, _math.sqrt)(12);
const a = (k / 2 + 1) * 3;
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};
exports.default = _default;

},{"812e1ff9b9a68f0d":"hJVMH"}],"fuSzE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("6e8e98e197afefc3");
var _default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
exports.default = _default;

},{"6e8e98e197afefc3":"hJVMH"}],"8TbeW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("8620520ba80e006a"));
var _basis = require("87413069402f4f60");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisClosed(context);
}

},{"8620520ba80e006a":"2PQhx","87413069402f4f60":"8q6s5"}],"2PQhx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default() {}

},{}],"8q6s5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Basis = Basis;
exports.default = _default;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new Basis(context);
}

},{}],"iegZb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("580a0e4914be358e");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisOpen(context);
}

},{"580a0e4914be358e":"8q6s5"}],"d0xR7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _basis = require("202e66c93596d8c0");
function Bundle(context, beta) {
    this._basis = new _basis.Basis(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var _default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new _basis.Basis(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
exports.default = _default;

},{"202e66c93596d8c0":"8q6s5"}],"gRXvw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalClosed = CardinalClosed;
exports.default = void 0;
var _noop = _interopRequireDefault(require("3ac7c5e1248dc9ae"));
var _cardinal = require("cfbcda1bc3207e7e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"3ac7c5e1248dc9ae":"2PQhx","cfbcda1bc3207e7e":"k8D9a"}],"k8D9a":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cardinal = Cardinal;
exports.default = void 0;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{}],"34TNi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalOpen = CardinalOpen;
exports.default = void 0;
var _cardinal = require("cf4363a3b836d23a");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
exports.default = _default;

},{"cf4363a3b836d23a":"k8D9a"}],"ll7gY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalClosed = require("f5ae01d2345d4943");
var _noop = _interopRequireDefault(require("82484b434a1d31db"));
var _catmullRom = require("3bd3d5af820e50ff");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"f5ae01d2345d4943":"gRXvw","82484b434a1d31db":"2PQhx","3bd3d5af820e50ff":"eUUkv"}],"eUUkv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;
var _math = require("d464c344292067de");
var _cardinal = require("2f2af409b067cecd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > _math.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > _math.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"d464c344292067de":"hJVMH","2f2af409b067cecd":"k8D9a"}],"4ZOL9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalOpen = require("97b1c5692429330d");
var _catmullRom = require("9847de9b9e7ea36b");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

},{"97b1c5692429330d":"34TNi","9847de9b9e7ea36b":"eUUkv"}],"gBXDY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("bb3255f3276eba36"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function _default(context) {
    return new LinearClosed(context);
}

},{"bb3255f3276eba36":"2PQhx"}],"bKjYq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monotoneX = monotoneX;
exports.monotoneY = monotoneY;
function sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{}],"MTOSC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function _default(context) {
    return new Natural(context);
}

},{}],"1qmxm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.stepAfter = stepAfter;
exports.stepBefore = stepBefore;
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function _default(context) {
    return new Step(context, 0.5);
}
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{}],"b0qQy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("8b3b605fa9e4fac5"));
var _constant = _interopRequireDefault(require("e744701481d85f49"));
var _none = _interopRequireDefault(require("e54b6b0ae39944a2"));
var _none2 = _interopRequireDefault(require("e9814568a9c80598"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function _default() {
    var keys = (0, _constant.default)([]), order = _none2.default, offset = _none.default, value = stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, _array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? _none2.default : typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? _none.default : _, stack) : offset;
    };
    return stack;
}

},{"8b3b605fa9e4fac5":"398O7","e744701481d85f49":"fyxRC","e54b6b0ae39944a2":"5QinT","e9814568a9c80598":"9nCy1"}],"5QinT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

},{}],"9nCy1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

},{}],"2izUD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("d8cdcff221711407"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, _none.default)(series, order);
}

},{"d8cdcff221711407":"5QinT"}],"bFP8M":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

},{}],"lHBQk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("af9c5fa37c1b1d9e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, _none.default)(series, order);
}

},{"af9c5fa37c1b1d9e":"5QinT"}],"9FPge":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("56eb12e1b2174aaf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, _none.default)(series, order);
}

},{"56eb12e1b2174aaf":"5QinT"}],"7VknF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("4494c675f3e20319"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var peaks = series.map(peak);
    return (0, _none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"4494c675f3e20319":"9nCy1"}],"2LZhd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.sum = sum;
var _none = _interopRequireDefault(require("4a7d728f9a184a25"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var sums = series.map(sum);
    return (0, _none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"4a7d728f9a184a25":"9nCy1"}],"4ra6F":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _ascending = _interopRequireDefault(require("d39a3ba1232418c4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _ascending.default)(series).reverse();
}

},{"d39a3ba1232418c4":"2LZhd"}],"dW1pc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _appearance = _interopRequireDefault(require("7e770dfcdf2ff59a"));
var _ascending = require("12f0fe8581e206");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var n = series.length, i, j, sums = series.map(_ascending.sum), order = (0, _appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

},{"7e770dfcdf2ff59a":"7VknF","12f0fe8581e206":"2LZhd"}],"7m1pI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("175f4f386d8ceefb"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _none.default)(series).reverse();
}

},{"175f4f386d8ceefb":"9nCy1"}],"iTCPB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is configuration option that decides how to filter for unique values only:
 *
 * - `false` means "no filter"
 * - `true` means "use recharts default filter"
 * - function means "use return of this function as the default key"
 */ parcelHelpers.export(exports, "getUniqPayload", ()=>getUniqPayload);
var _uniqBy = require("lodash/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
function getUniqPayload(payload, option, defaultUniqBy) {
    if (option === true) return (0, _uniqByDefault.default)(payload, defaultUniqBy);
    if ((0, _isFunctionDefault.default)(option)) return (0, _uniqByDefault.default)(payload, option);
    return payload;
}

},{"lodash/uniqBy":"9Qfm9","lodash/isFunction":"56sPA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9Qfm9":[function(require,module,exports) {
var baseIteratee = require("ce9604aad32f97ab"), baseUniq = require("9fbd8e46e11f49c4");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function uniqBy(array, iteratee) {
    return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}
module.exports = uniqBy;

},{"ce9604aad32f97ab":"5rKNq","9fbd8e46e11f49c4":"hmtLN"}],"5rKNq":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"l022X","4f010869f7b63154":"4NvlE","28f06147d1eb9502":"aaqsH","3c56f88c4debf449":"8PiWS","aee920e0ef5bf111":"goSul"}],"l022X":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"a7JFa","89e9034a8071e297":"h2mJ2","782598b150762386":"eIYyu"}],"a7JFa":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"c0V50","9003c0cc8ac007b6":"hErvR"}],"c0V50":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"1TCzF","ceda2a63c77c915":"ia2vg","91ee1b348d9d7172":"02v1d","3fe28318f65b9332":"wXQuv","724ca4def8b84e06":"kUV0O","e9ceacb40d9582bd":"eqQz2"}],"ia2vg":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"1TCzF"}],"02v1d":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"wXQuv":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"kUV0O":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"eqQz2":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"1TCzF","1494efbafafa9552":"dtWm9","6049e8027fe9407f":"brkr2"}],"hErvR":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"dFFet","809bbb0c20650dbc":"edAV6"}],"dFFet":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"c0V50","96bc8a1825db53a5":"9px6I","8bdece495e87fb69":"51F3K","bb94920432a68eca":"epzjx","45495edff98e5837":"gOs0s","18256411ae9e2858":"8PiWS","e5ba7abf54247fc5":"8R43p","50d786bb5c7366af":"jPUPw"}],"9px6I":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"hFUsE","1ee20de911db0cb0":"8ql8E","defff3d81be91b23":"cZFKj"}],"hFUsE":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"brkr2","9a831e81e9a1f98c":"8a0xw","1a2b6c8a7399c39f":"QDuSl"}],"8a0xw":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"QDuSl":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"8ql8E":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"cZFKj":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"51F3K":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"P1OwS","dbf6aa5033a0f48":"ho6c3","539966708f906e61":"6qU1V","8142d4017f0a425f":"9px6I","48cddf732eff33ba":"kHx2M","9dc78b26c5daba20":"faMIP"}],"ho6c3":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"303fC"}],"kHx2M":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"faMIP":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"epzjx":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"7OJM3"}],"7OJM3":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"7lat3","aa79b69a13f924db":"ctSra","e3ad83e53433bc8a":"ju9KS"}],"7lat3":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"5SfLp","148b85918856c33a":"8PiWS"}],"5SfLp":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"ctSra":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"hKUJi","6b1c62cea92cdb9":"6Sf9j"}],"hKUJi":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"6Sf9j":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"ju9KS":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"4npYm","e8453365fdacc8da":"fMPLu","7760b47b02971dfa":"5F2le"}],"4npYm":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"dK4LM","9cdb51ffa56f149b":"afwXa","38cd49f1e493b3d7":"8PiWS","b379831fe1873fed":"8R43p","f362a34cd8321bb7":"fS0jT","c019db5297494469":"jPUPw"}],"dK4LM":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"afwXa":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"3t1ZR","bead821d6af018b5":"edAV6"}],"3t1ZR":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"3mPah","b6cdbe52dcf709f8":"edAV6"}],"8R43p":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"303fC","a1e87b138cf75d1d":"jcamu"}],"jcamu":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"fS0jT":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"jPUPw":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"kuCGE","903f50eb1c16d257":"kWC97","fa49853a82034c30":"gazvl"}],"kuCGE":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"3mPah","f661b3a120d7a4cb":"2fpEb","cdd86c83797c0618":"edAV6"}],"2fpEb":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"kWC97":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"gazvl":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"lMyZ6"}],"fMPLu":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6aUp2","3ec652610d8dd5d3":"kwe0j"}],"6aUp2":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"kwe0j":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"hcG93"}],"hcG93":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"5F2le":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"56sPA","f3db08d4d1110aaf":"2fpEb"}],"gOs0s":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"8HJu1","28e3344aae951f13":"dtWm9","b286298be5b1d9a4":"7SCae","3ae50c158f89813":"bxtTw","9f458755f627d456":"ayjc9","8e9160b373d7fe66":"3mPah","b210627dd951641f":"2QLnS"}],"8HJu1":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"i9vsD","f83c375075418382":"303fC"}],"7SCae":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"i9vsD","a5c6637bac681a0":"303fC"}],"bxtTw":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"i9vsD","ca486d41cdf819d4":"303fC"}],"ayjc9":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"i9vsD","7a9a6581834a8452":"303fC"}],"h2mJ2":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"eOGIV","94ffded3a85af2f6":"ju9KS"}],"eOGIV":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"lgjQC"}],"eIYyu":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"4NvlE":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"hErvR","d5ca180f7d6f956a":"1XYRd","3462bb3f546fa1f7":"l0Tra","f5fef07966a1c4ee":"attHx","2a1cd212d48516":"eOGIV","885e72ee7fc6d296":"eIYyu","cd65eaf4a3af29f6":"cAgQB"}],"l0Tra":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"3pbMG","b0aefd36de99e579":"bfzjp"}],"3pbMG":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"bfzjp":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"ctqA5","47ffafdab3ba0d6f":"afwXa","93ebd263ff0131c1":"8PiWS","252ef74480e01958":"fS0jT","23c2f64e75e90a2":"2fpEb","af5ade297cb685ee":"cAgQB"}],"aaqsH":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"goSul":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"bG7wW","abf31da39349df22":"k9LiJ","a387ef4a4373de2c":"attHx","9315973458389ae7":"cAgQB"}],"bG7wW":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"k9LiJ":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"ciDgX"}],"hmtLN":[function(require,module,exports) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"hFUsE","a1d85be956e037a9":"3NEPn","8cd18f86a4a2c118":"6DmZH","3acf9f4a3a78c511":"cZFKj","19b77385b4f7775a":"aGJX8","4568580f7416eb83":"faMIP"}],"3NEPn":[function(require,module,exports) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"csbxo"}],"csbxo":[function(require,module,exports) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"a7XzL","c991ed2b82d165b":"jaQ2d","c0bb8190b05a00a5":"esiPY"}],"a7XzL":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"jaQ2d":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"esiPY":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"6DmZH":[function(require,module,exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"aGJX8":[function(require,module,exports) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"bxtTw","a02c367b3608ccee":"3lKnG","cd8d0af6a14b2f7d":"faMIP"}],"3lKnG":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"1NIRS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
/**
 * @fileOverview Tooltip
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultTooltipContent = require("./DefaultTooltipContent");
var _tooltipBoundingBox = require("./TooltipBoundingBox");
var _global = require("../util/Global");
var _getUniqPayload = require("../util/payload/getUniqPayload");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultUniqBy(entry) {
    return entry.dataKey;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(content)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, _reactDefault.default).createElement(content, props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultTooltipContent.DefaultTooltipContent), props);
}
var Tooltip = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Tooltip, _PureComponent);
    function Tooltip() {
        _classCallCheck(this, Tooltip);
        return _callSuper(this, Tooltip, arguments);
    }
    _createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, _getUniqPayload.getUniqPayload)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipBoundingBox.TooltipBoundingBox), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, renderContent(content, _objectSpread(_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, _react.PureComponent));
_defineProperty(Tooltip, "displayName", "Tooltip");
_defineProperty(Tooltip, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, _global.Global).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});

},{"react":"BK2ob","./DefaultTooltipContent":"fZkQD","./TooltipBoundingBox":"kNY0u","../util/Global":"6FMLK","../util/payload/getUniqPayload":"iTCPB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fZkQD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>DefaultTooltipContent);
/**
 * @fileOverview Default Tooltip Content
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultFormatter(value) {
    return Array.isArray(value) && (0, _dataUtils.isNumOrStr)(value[0]) && (0, _dataUtils.isNumOrStr)(value[1]) ? value.join(" ~ ") : value;
}
var DefaultTooltipContent = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, _sortByDefault.default)(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = _objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = _slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, _reactDefault.default).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = _objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, _isNilDefault.default)(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, _clsxDefault.default)("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, _clsxDefault.default)("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: "status",
        "aria-live": "assertive"
    } : {};
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

},{"react":"BK2ob","lodash/sortBy":"2fKqG","lodash/isNil":"4xNOq","clsx":"bGtJT","../util/DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2fKqG":[function(require,module,exports) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"1hqBq","2553e45e897c3cba":"7b3Lq","9df1e918b0eea173":"afX8J","36218471fd8f4dda":"9nUAa"}],"1hqBq":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"5SfLp","ec5f080ebf5764e8":"a4McM"}],"a4McM":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"P1OwS","ee6f325d7f5309b1":"afwXa","ff8d93236e335297":"8PiWS"}],"7b3Lq":[function(require,module,exports) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"2fndP","56eb179604ce4d19":"ciDgX","41950d167c7e12b5":"5rKNq","b09740a39499ec43":"eTgyt","35a9013ca73ef017":"al5od","b387a5b76e29e664":"kWC97","2ab709818f44804c":"l3xHZ","5cb379329c706719":"aaqsH","8acdbb462385356c":"8PiWS"}],"eTgyt":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"4qPa1","2924e2db4bb5430d":"5F2le"}],"4qPa1":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"3OtiZ","f1e3fc84161ef3ec":"aoUGv"}],"3OtiZ":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"9QA7X","1fb77c53defe5720":"ju9KS"}],"9QA7X":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"eQTN8"}],"eQTN8":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"aoUGv":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"5F2le"}],"al5od":[function(require,module,exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"l3xHZ":[function(require,module,exports) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"1UOIv"}],"1UOIv":[function(require,module,exports) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"5cADF"}],"afX8J":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"aaqsH","ff7d23ff2a2ea6f8":"ccqHa","a11d545e809d14f7":"8WLWl"}],"ccqHa":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"87B0r"}],"87B0r":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"8WLWl":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"hlYXU","9114f59293388d49":"gYvxX"}],"hlYXU":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"iIjnt","eff1240bc0447727":"4GQfl","b00d1e57326793e1":"aaqsH"}],"iIjnt":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"4GQfl":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"i9vsD"}],"gYvxX":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"9nUAa":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"6qU1V","616bc732534dffe0":"5F2le","e781332a36d1bd7":"fS0jT","c8548bf6929b8a5d":"lgjQC"}],"kNY0u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipBoundingBox", ()=>TooltipBoundingBox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _translate = require("../util/tooltip/translate");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var EPSILON = 1;
var TooltipBoundingBox = /*#__PURE__*/ function(_PureComponent) {
    _inherits(TooltipBoundingBox, _PureComponent);
    function TooltipBoundingBox() {
        var _this;
        _classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, TooltipBoundingBox, [].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === "Escape") {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    _createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("keydown", this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, _translate.getTooltipTranslate)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = _objectSpread(_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, _reactDefault.default).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, _react.PureComponent));

},{"react":"BK2ob","../util/tooltip/translate":"5XJ1A","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5XJ1A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipCSSClassName", ()=>getTooltipCSSClassName);
parcelHelpers.export(exports, "getTooltipTranslateXY", ()=>getTooltipTranslateXY);
parcelHelpers.export(exports, "getTransformStyle", ()=>getTransformStyle);
parcelHelpers.export(exports, "getTooltipTranslate", ()=>getTooltipTranslate);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var TOOLTIP_HIDDEN = {
    visibility: "hidden"
};
function getTooltipCSSClassName(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, _clsxDefault.default)(CSS_CLASS_PREFIX, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(CSS_CLASS_PREFIX, "-right"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY < coordinate.y));
}
function getTooltipTranslateXY(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, _dataUtils.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function getTransformStyle(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function getTooltipTranslate(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "x",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = getTooltipTranslateXY({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "y",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = getTransformStyle({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: getTooltipCSSClassName({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}

},{"clsx":"bGtJT","../DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6FMLK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Global", ()=>Global);
var parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var Global = {
    isSsr: parseIsSsrByDefault(),
    get: function get(key) {
        return Global[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") Global[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                Global[k] = key[k];
            });
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"RL5OJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContainer", ()=>ResponsiveContainer);
/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */ var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _reactIs = require("react-is");
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var ResponsiveContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, _react.useRef)(null);
    var onResizeRef = (0, _react.useRef)();
    onResizeRef.current = onResize;
    (0, _react.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, "current", {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn("The usage of ref.current.current is deprecated and will no longer be supported.");
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, _react.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = _slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, _react.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, _react.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, _throttleDefault.default)(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, _react.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, _logUtils.warn)((0, _dataUtils.isPercent)(width) || (0, _dataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, _logUtils.warn)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, _dataUtils.isPercent)(width) ? containerWidth : width;
        var calculatedHeight = (0, _dataUtils.isPercent)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, _logUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, _reactIs.isElement)(children) && (0, _reactUtils.getDisplayName)(children.type).endsWith("Chart");
        return (0, _reactDefault.default).Children.map(children, function(child) {
            if ((0, _reactIs.isElement)(child)) return /*#__PURE__*/ (0, _react.cloneElement)(child, _objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: _objectSpread({
                    height: "100%",
                    width: "100%",
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, _clsxDefault.default)("recharts-responsive-container", className),
        style: _objectSpread(_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});

},{"clsx":"bGtJT","react":"BK2ob","lodash/throttle":"kGoYu","react-is":"itSJh","../util/DataUtils":"kHJdD","../util/LogUtils":"jEZ3K","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kGoYu":[function(require,module,exports) {
var debounce = require("5b383646e2c7b4c6"), isObject = require("a29ce0b3e78d037d");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
module.exports = throttle;

},{"5b383646e2c7b4c6":"dbi2o","a29ce0b3e78d037d":"lgjQC"}],"dbi2o":[function(require,module,exports) {
var isObject = require("3b174a999d6a40ac"), now = require("575b2317167ce20d"), toNumber = require("a13332670c5c0f63");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"3b174a999d6a40ac":"lgjQC","575b2317167ce20d":"2OBVH","a13332670c5c0f63":"6fw7p"}],"2OBVH":[function(require,module,exports) {
var root = require("6439589d9d88d885");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"6439589d9d88d885":"303fC"}],"6fw7p":[function(require,module,exports) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"34l5E","faaa289d287a34a5":"lgjQC","47b3bd23f771891":"5cADF"}],"34l5E":[function(require,module,exports) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"chfAI"}],"chfAI":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"i1Cei":[function(require,module,exports) {
/**
 * @fileOverview Cross
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cell", ()=>Cell);
var Cell = function Cell(_props) {
    return null;
};
Cell.displayName = "Cell";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8RJoX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _global = require("../util/Global");
var _reactUtils = require("../util/ReactUtils");
var _domutils = require("../util/DOMUtils");
var _reduceCSSCalc = require("../util/ReduceCSSCalc");
var _excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], _excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, _isNilDefault.default)(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split(BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, _domutils.getStringSize)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, _domutils.getStringSize)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, _dataUtils.isNumber)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = _slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = _slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, _isNilDefault.default)(children) ? children.toString().split(BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, _global.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return getWordsWithoutCalculate(children);
        return calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = "#808080";
var Text = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill, props = _objectWithoutProperties(_ref5, _excluded);
    var wordsByLines = (0, _react.useMemo)(function() {
        return getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = _objectWithoutProperties(props, _excluded2);
    if (!(0, _dataUtils.isNumOrStr)(propsX) || !(0, _dataUtils.isNumOrStr)(propsY)) return null;
    var x = propsX + ((0, _dataUtils.isNumber)(dx) ? dx : 0);
    var y = propsY + ((0, _dataUtils.isNumber)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, _dataUtils.isNumber)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, (0, _reactUtils.filterProps)(textProps, true), {
        x: x,
        y: y,
        className: (0, _clsxDefault.default)("recharts-text", className),
        textAnchor: textAnchor,
        fill: fill.includes("url") ? DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? "" : " ");
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: words
        }, words);
    }));
};

},{"react":"BK2ob","lodash/isNil":"4xNOq","clsx":"bGtJT","../util/DataUtils":"kHJdD","../util/Global":"6FMLK","../util/ReactUtils":"56rQC","../util/DOMUtils":"iMuyG","../util/ReduceCSSCalc":"ctLi3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iMuyG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleString", ()=>getStyleString);
parcelHelpers.export(exports, "getStringSize", ()=>getStringSize);
parcelHelpers.export(exports, "getOffset", ()=>getOffset);
var _global = require("./Global");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var stringCache = {
    widthCache: {},
    cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function autoCompleteStyle(name, value) {
    if (STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat(_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat(_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var getStyleString = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
    }, "");
};
function removeInvalidKeys(obj) {
    var copyObj = _objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var getStringSize = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, _global.Global).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if (stringCache.widthCache[cacheKey]) return stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = _objectSpread(_objectSpread({}, SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        stringCache.widthCache[cacheKey] = result;
        if (++stringCache.cacheCount > MAX_CACHE_NUM) {
            stringCache.cacheCount = 0;
            stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var getOffset = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};

},{"./Global":"6FMLK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ctLi3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeEvaluateExpression", ()=>safeEvaluateExpression);
parcelHelpers.export(exports, "reduceCSSCalc", ()=>reduceCSSCalc);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = "NaN";
function convertToPx(value, unit) {
    return value * CONVERSION_RATES[unit];
}
var DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        _classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = "";
        if (unit !== "" && !CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = "";
        }
        if (FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = convertToPx(num, unit);
            this.unit = "px";
        }
    }
    _createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = _slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : "");
            }
        }
    ]);
    return DecimalCSS;
}();
function calculateArithmetic(expr) {
    if (expr.includes(STR_NAN)) return STR_NAN;
    var newExpr = expr;
    while(newExpr.includes("*") || newExpr.includes("/")){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = _slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
        var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
        var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = _slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
        var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
        var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes("(")){
        var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = _slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, "");
    newExpr = calculateParentheses(newExpr);
    newExpr = calculateArithmetic(newExpr);
    return newExpr;
}
function safeEvaluateExpression(expression) {
    try {
        return evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return STR_NAN;
    }
}
function reduceCSSCalc(expression) {
    var result = safeEvaluateExpression(expression.slice(5, -1));
    if (result === STR_NAN) // notify the user
    return "";
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cIQWL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Label", ()=>Label);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("./Text");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "offset"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, _isNilDefault.default)(props.children) ? value : props.children;
    if ((0, _isFunctionDefault.default)(formatter)) return formatter(label);
    return label;
};
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, _isNilDefault.default)(labelProps.id) ? (0, _dataUtils.uniqueId)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, _clsxDefault.default)("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, _polarUtils.polarToCartesian)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return _objectSpread(_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return _objectSpread(_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return _objectSpread(_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return _objectSpread(_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return _objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return _objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return _objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return _objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return _objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return _objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, _isObjectDefault.default)(position) && ((0, _dataUtils.isNumber)(position.x) || (0, _dataUtils.isPercent)(position.x)) && ((0, _dataUtils.isNumber)(position.y) || (0, _dataUtils.isPercent)(position.y))) return _objectSpread({
        x: x + (0, _dataUtils.getPercentValue)(position.x, width),
        y: y + (0, _dataUtils.getPercentValue)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return _objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, _dataUtils.isNumber)(viewBox.cx);
};
function Label(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = _objectWithoutProperties(_ref4, _excluded);
    var props = _objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, _isNilDefault.default)(value) && (0, _isNilDefault.default)(children) && !/*#__PURE__*/ (0, _react.isValidElement)(content) && !(0, _isFunctionDefault.default)(content)) return null;
    if (/*#__PURE__*/ (0, _react.isValidElement)(content)) return /*#__PURE__*/ (0, _react.cloneElement)(content, props);
    var label;
    if ((0, _isFunctionDefault.default)(content)) {
        label = /*#__PURE__*/ (0, _react.createElement)(content, props);
        if (/*#__PURE__*/ (0, _react.isValidElement)(label)) return label;
    } else label = getLabel(props);
    var isPolarLabel = isPolar(viewBox);
    var attrs = (0, _reactUtils.filterProps)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        className: (0, _clsxDefault.default)("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
Label.displayName = "Label";
var parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, _dataUtils.isNumber)(width) && (0, _dataUtils.isNumber)(height)) {
        if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, _dataUtils.isNumber)(top) && (0, _dataUtils.isNumber)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, _dataUtils.isNumber)(x) && (0, _dataUtils.isNumber)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, _dataUtils.isNumber)(cx) && (0, _dataUtils.isNumber)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, _dataUtils.isNumOrStr)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, _react.isValidElement)(label)) {
        if (label.type === Label) return /*#__PURE__*/ (0, _react.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(Label, _extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = parseViewBox(parentProps);
    var explicitChildren = (0, _reactUtils.findAllByType)(children, Label).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat(_toConsumableArray(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;

},{"react":"BK2ob","lodash/isNil":"4xNOq","lodash/isFunction":"56sPA","lodash/isObject":"lgjQC","clsx":"bGtJT","./Text":"8RJoX","../util/ReactUtils":"56rQC","../util/DataUtils":"kHJdD","../util/PolarUtils":"iSQPa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iSQPa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIAN", ()=>RADIAN);
parcelHelpers.export(exports, "degreeToRadian", ()=>degreeToRadian);
parcelHelpers.export(exports, "radianToDegree", ()=>radianToDegree);
parcelHelpers.export(exports, "polarToCartesian", ()=>polarToCartesian);
parcelHelpers.export(exports, "getMaxRadius", ()=>getMaxRadius);
parcelHelpers.export(exports, "formatAxisMap", ()=>formatAxisMap);
parcelHelpers.export(exports, "distanceBetweenPoints", ()=>distanceBetweenPoints);
parcelHelpers.export(exports, "getAngleOfPoint", ()=>getAngleOfPoint);
parcelHelpers.export(exports, "formatAngleOfSector", ()=>formatAngleOfSector);
parcelHelpers.export(exports, "inRangeOfSector", ()=>inRangeOfSector);
parcelHelpers.export(exports, "getTickClassName", ()=>getTickClassName);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _react = require("react");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("./DataUtils");
var _chartUtils = require("./ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var RADIAN = Math.PI / 180;
var degreeToRadian = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var radianToDegree = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-RADIAN * angle) * radius,
        y: cy + Math.sin(-RADIAN * angle) * radius
    };
};
var getMaxRadius = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, _dataUtils.getPercentValue)(props.cx, width, width / 2);
    var cy = (0, _dataUtils.getPercentValue)(props.cy, height, height / 2);
    var maxRadius = getMaxRadius(width, height, offset);
    var innerRadius = (0, _dataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, _isNilDefault.default)(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = _slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: radianToDegree(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = getAngleOfPoint({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = formatAngleOfSector(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return _objectSpread(_objectSpread({}, sector), {}, {
        radius: radius,
        angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var getTickClassName = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, _react.isValidElement)(tick) && !(0, _isFunctionDefault.default)(tick) && typeof tick !== "boolean" ? tick.className : "";
};

},{"lodash/isNil":"4xNOq","react":"BK2ob","lodash/isFunction":"56sPA","./DataUtils":"kHJdD","./ChartUtils":"eYWT4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eYWT4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported for backwards compatibility
parcelHelpers.export(exports, "getLegendProps", ()=>(0, _getLegendProps.getLegendProps));
parcelHelpers.export(exports, "getValueByDataKey", ()=>getValueByDataKey);
/**
 * Get domain of data by key.
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */ parcelHelpers.export(exports, "getDomainOfDataByKey", ()=>getDomainOfDataByKey);
parcelHelpers.export(exports, "calculateActiveTickIndex", ()=>calculateActiveTickIndex);
parcelHelpers.export(exports, "getMainColorOfGraphicItem", ()=>getMainColorOfGraphicItem);
parcelHelpers.export(exports, "getBarSizeList", ()=>getBarSizeList);
parcelHelpers.export(exports, "getBarPosition", ()=>getBarPosition);
parcelHelpers.export(exports, "appendOffsetOfLegend", ()=>appendOffsetOfLegend);
parcelHelpers.export(exports, "getDomainOfErrorBars", ()=>getDomainOfErrorBars);
parcelHelpers.export(exports, "parseErrorBarsOfAxis", ()=>parseErrorBarsOfAxis);
parcelHelpers.export(exports, "getDomainOfItemsWithSameAxis", ()=>getDomainOfItemsWithSameAxis);
parcelHelpers.export(exports, "isCategoricalAxis", ()=>isCategoricalAxis);
parcelHelpers.export(exports, "getCoordinatesOfGrid", ()=>getCoordinatesOfGrid);
parcelHelpers.export(exports, "getTicksOfAxis", ()=>getTicksOfAxis);
parcelHelpers.export(exports, "combineEventHandlers", ()=>combineEventHandlers);
parcelHelpers.export(exports, "parseScale", ()=>parseScale);
parcelHelpers.export(exports, "checkDomainOfScale", ()=>checkDomainOfScale);
parcelHelpers.export(exports, "findPositionOfBar", ()=>findPositionOfBar);
parcelHelpers.export(exports, "truncateByDomain", ()=>truncateByDomain);
parcelHelpers.export(exports, "offsetSign", ()=>offsetSign);
parcelHelpers.export(exports, "offsetPositive", ()=>offsetPositive);
parcelHelpers.export(exports, "getStackedData", ()=>getStackedData);
parcelHelpers.export(exports, "getStackGroupsByAxisId", ()=>getStackGroupsByAxisId);
parcelHelpers.export(exports, "getTicksOfScale", ()=>getTicksOfScale);
parcelHelpers.export(exports, "getCateCoordinateOfLine", ()=>getCateCoordinateOfLine);
parcelHelpers.export(exports, "getCateCoordinateOfBar", ()=>getCateCoordinateOfBar);
parcelHelpers.export(exports, "getBaseValueOfBar", ()=>getBaseValueOfBar);
parcelHelpers.export(exports, "getStackedDataOfItem", ()=>getStackedDataOfItem);
parcelHelpers.export(exports, "getDomainOfStackGroups", ()=>getDomainOfStackGroups);
parcelHelpers.export(exports, "MIN_VALUE_REG", ()=>MIN_VALUE_REG);
parcelHelpers.export(exports, "MAX_VALUE_REG", ()=>MAX_VALUE_REG);
parcelHelpers.export(exports, "parseSpecifiedDomain", ()=>parseSpecifiedDomain);
parcelHelpers.export(exports, "getBandSizeOfAxis", ()=>getBandSizeOfAxis);
parcelHelpers.export(exports, "parseDomainOfCategoryAxis", ()=>parseDomainOfCategoryAxis);
parcelHelpers.export(exports, "getTooltipItem", ()=>getTooltipItem);
var _d3Scale = require("victory-vendor/d3-scale");
var _d3Shape = require("victory-vendor/d3-shape");
var _max = require("lodash/max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _min = require("lodash/min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _flatMap = require("lodash/flatMap");
var _flatMapDefault = parcelHelpers.interopDefault(_flatMap);
var _isNaN = require("lodash/isNaN");
var _isNaNDefault = parcelHelpers.interopDefault(_isNaN);
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _rechartsScale = require("recharts-scale");
var _errorBar = require("../cartesian/ErrorBar");
var _dataUtils = require("./DataUtils");
var _reactUtils = require("./ReactUtils");
// TODO: Cause of circular dependency. Needs refactor.
// import { RadiusAxisProps, AngleAxisProps } from '../polar/types';
var _getLegendProps = require("./getLegendProps");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function getValueByDataKey(obj, dataKey, defaultValue) {
    if ((0, _isNilDefault.default)(obj) || (0, _isNilDefault.default)(dataKey)) return defaultValue;
    if ((0, _dataUtils.isNumOrStr)(dataKey)) return (0, _getDefault.default)(obj, dataKey, defaultValue);
    if ((0, _isFunctionDefault.default)(dataKey)) return dataKey(obj);
    return defaultValue;
}
function getDomainOfDataByKey(data, key, type, filterNil) {
    var flattenData = (0, _flatMapDefault.default)(data, function(entry) {
        return getValueByDataKey(entry, key);
    });
    if (type === "number") {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, _dataUtils.isNumber)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, _minDefault.default)(domain),
            (0, _maxDefault.default)(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, _dataUtils.isNumOrStr)(entry) || entry instanceof Date ? entry : "";
    });
}
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, _dataUtils.mathSign)(cur - before) !== (0, _dataUtils.mathSign)(after - cur)) {
                var diffInterval = [];
                if ((0, _dataUtils.mathSign)(after - cur) === (0, _dataUtils.mathSign)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var getBarSizeList = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, _reactUtils.getDisplayName)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, _isNilDefault.default)(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, _isNilDefault.default)(barSize) ? undefined : (0, _dataUtils.getPercentValue)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var getBarPosition = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, _dataUtils.getPercentValue)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat(_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, _dataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat(_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, _getLegendProps.getLegendProps)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && (0, _dataUtils.isNumber)(offset[align])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && (0, _dataUtils.isNumber)(offset[verticalAlign])) return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, _isNilDefault.default)(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar)).filter(function(errorBarChild) {
        return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = getValueByDataKey(entry, dataKey);
            if ((0, _isNilDefault.default)(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, _minDefault.default)(entryValue),
                (0, _maxDefault.default)(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = getValueByDataKey(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, _isNilDefault.default)(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
        return getDomainOfDataByKey(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, _dataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, _isNaNDefault.default)(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var handlerWeakMap = new WeakMap();
var combineEventHandlers = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== "function") return defaultHandler;
    if (!handlerWeakMap.has(defaultHandler)) handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var parseScale = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: _d3Scale.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: _d3Scale.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: _d3Scale.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: _d3Scale.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, _isStringDefault.default)(scale)) {
        var name = "scale".concat((0, _upperFirstDefault.default)(scale));
        return {
            scale: (_d3Scale[name] || _d3Scale.scalePoint)(),
            realScaleType: _d3Scale[name] ? name : "point"
        };
    }
    return (0, _isFunctionDefault.default)(scale) ? {
        scale: scale
    } : {
        scale: _d3Scale.scalePoint(),
        realScaleType: "point"
    };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - EPS;
    var maxValue = Math.max(range[0], range[1]) + EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, _dataUtils.isNumber)(domain[0]) || !(0, _dataUtils.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, _dataUtils.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, _dataUtils.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var offsetSign = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var offsetPositive = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, _isNaNDefault.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var STACK_OFFSET_MAP = {
    sign: offsetSign,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, _d3Shape.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, _d3Shape.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, _d3Shape.stackOffsetWiggle),
    positive: offsetPositive
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = STACK_OFFSET_MAP[offsetType];
    var stack = (0, _d3Shape.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +getValueByDataKey(d, key, 0);
    }).order((0, _d3Shape.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, _dataUtils.isNumOrStr)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, _dataUtils.uniqueId)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: getStackedData(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var getTicksOfScale = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, _minDefault.default)(tickValues),
            (0, _maxDefault.default)(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNilDefault.default)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, _dataUtils.findEntryInArray)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = getValueByDataKey(entry, !(0, _isNilDefault.default)(dataKey) ? dataKey : axis.dataKey);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) : null;
}
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
    return !(0, _isNilDefault.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, _dataUtils.isNumOrStr)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, _minDefault.default)(entry.concat([
                result[0]
            ]).filter((0, _dataUtils.isNumber))),
            (0, _maxDefault.default)(entry.concat([
                result[1]
            ]).filter((0, _dataUtils.isNumber)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, _isFunctionDefault.default)(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, _dataUtils.isNumber)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
        var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, _dataUtils.isNumber)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
        var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, _isFunctionDefault.default)(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, _sortByDefault.default)(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, _isEqualDefault.default)(specifiedDomain, (0, _getDefault.default)(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var getTooltipItem = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType, hide = _graphicalItem$props.hide;
    return _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: getMainColorOfGraphicItem(graphicalItem),
        value: getValueByDataKey(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};

},{"victory-vendor/d3-scale":"97ySI","victory-vendor/d3-shape":"ccJ5o","lodash/max":"dSrfR","lodash/min":"jUDqe","lodash/isNil":"4xNOq","lodash/isFunction":"56sPA","lodash/isString":"cpoTe","lodash/get":"1XYRd","lodash/flatMap":"iJi7N","lodash/isNaN":"TZX9h","lodash/upperFirst":"ko2wy","lodash/isEqual":"hga42","lodash/sortBy":"2fKqG","recharts-scale":"frU7C","../cartesian/ErrorBar":"fppsY","./DataUtils":"kHJdD","./ReactUtils":"56rQC","./getLegendProps":"7zpDK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"97ySI":[function(require,module,exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("ea85efe7e401a98a");

},{"ea85efe7e401a98a":"3wPbS"}],"3wPbS":[function(require,module,exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
module.exports = require("9f3e91243b64b1b0");

},{"9f3e91243b64b1b0":"2a9s6"}],"2a9s6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return _band.default;
    }
});
Object.defineProperty(exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingLog;
    }
});
Object.defineProperty(exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return _diverging.divergingPow;
    }
});
Object.defineProperty(exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSqrt;
    }
});
Object.defineProperty(exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSymlog;
    }
});
Object.defineProperty(exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return _identity.default;
    }
});
Object.defineProperty(exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return _ordinal.implicit;
    }
});
Object.defineProperty(exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return _log.default;
    }
});
Object.defineProperty(exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return _ordinal.default;
    }
});
Object.defineProperty(exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return _band.point;
    }
});
Object.defineProperty(exports, "scalePow", {
    enumerable: true,
    get: function() {
        return _pow.default;
    }
});
Object.defineProperty(exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
Object.defineProperty(exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return _radial.default;
    }
});
Object.defineProperty(exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return _sequential.default;
    }
});
Object.defineProperty(exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialLog;
    }
});
Object.defineProperty(exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialPow;
    }
});
Object.defineProperty(exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return _sequentialQuantile.default;
    }
});
Object.defineProperty(exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSqrt;
    }
});
Object.defineProperty(exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSymlog;
    }
});
Object.defineProperty(exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return _pow.sqrt;
    }
});
Object.defineProperty(exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return _symlog.default;
    }
});
Object.defineProperty(exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return _threshold.default;
    }
});
Object.defineProperty(exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return _time.default;
    }
});
Object.defineProperty(exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return _utcTime.default;
    }
});
Object.defineProperty(exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return _tickFormat.default;
    }
});
var _band = _interopRequireWildcard(require("b63efb80eb4f3997"));
var _identity = _interopRequireDefault(require("599666f8569781e"));
var _linear = _interopRequireDefault(require("81a646a660f644b0"));
var _log = _interopRequireDefault(require("86d5f4344a349716"));
var _symlog = _interopRequireDefault(require("b710ccde4c0e48a2"));
var _ordinal = _interopRequireWildcard(require("64b86754e86644bb"));
var _pow = _interopRequireWildcard(require("b1b95f640cc918be"));
var _radial = _interopRequireDefault(require("a92c7cfb56bc5881"));
var _quantile = _interopRequireDefault(require("592c2efd5d96bbdb"));
var _quantize = _interopRequireDefault(require("e52ffbce45f03bde"));
var _threshold = _interopRequireDefault(require("d72c59b81e30fbb0"));
var _time = _interopRequireDefault(require("8a3bda0d92036416"));
var _utcTime = _interopRequireDefault(require("889651fd1a77d2be"));
var _sequential = _interopRequireWildcard(require("fd5b5906f4fcb1c8"));
var _sequentialQuantile = _interopRequireDefault(require("4430958b59fb539b"));
var _diverging = _interopRequireWildcard(require("f8014e5ceaa878fb"));
var _tickFormat = _interopRequireDefault(require("1391cb83b35daafe"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"b63efb80eb4f3997":"hyLlJ","599666f8569781e":"8ev1f","81a646a660f644b0":"4UkXL","86d5f4344a349716":"colCi","b710ccde4c0e48a2":"8NIsN","64b86754e86644bb":"kOPtd","b1b95f640cc918be":"4wDg3","a92c7cfb56bc5881":"bVHHy","592c2efd5d96bbdb":"cwgwr","e52ffbce45f03bde":"gYued","d72c59b81e30fbb0":"aFH4N","8a3bda0d92036416":"1x5us","889651fd1a77d2be":"2qxfq","fd5b5906f4fcb1c8":"eYiC7","4430958b59fb539b":"1lSf8","f8014e5ceaa878fb":"b6etx","1391cb83b35daafe":"lc0wW"}],"hyLlJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = band;
exports.point = point;
var _index = require("c83c4aaf4d4f3e6c");
var _init = require("691f3ba4feec551a");
var _ordinal = _interopRequireDefault(require("933dd1d51fe58981"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function band() {
    var scale = (0, _ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _index.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return _init.initRange.apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"c83c4aaf4d4f3e6c":"eYjUM","691f3ba4feec551a":"Seiq9","933dd1d51fe58981":"kOPtd"}],"eYjUM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Adder", {
    enumerable: true,
    get: function() {
        return _fsum.Adder;
    }
});
Object.defineProperty(exports, "InternMap", {
    enumerable: true,
    get: function() {
        return _index.InternMap;
    }
});
Object.defineProperty(exports, "InternSet", {
    enumerable: true,
    get: function() {
        return _index.InternSet;
    }
});
Object.defineProperty(exports, "ascending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "bin", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "bisect", {
    enumerable: true,
    get: function() {
        return _bisect.default;
    }
});
Object.defineProperty(exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return _bisect.bisectCenter;
    }
});
Object.defineProperty(exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return _bisect.bisectLeft;
    }
});
Object.defineProperty(exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return _bisect.bisectRight;
    }
});
Object.defineProperty(exports, "bisector", {
    enumerable: true,
    get: function() {
        return _bisector.default;
    }
});
Object.defineProperty(exports, "count", {
    enumerable: true,
    get: function() {
        return _count.default;
    }
});
Object.defineProperty(exports, "cross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "cumsum", {
    enumerable: true,
    get: function() {
        return _cumsum.default;
    }
});
Object.defineProperty(exports, "descending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "deviation", {
    enumerable: true,
    get: function() {
        return _deviation.default;
    }
});
Object.defineProperty(exports, "difference", {
    enumerable: true,
    get: function() {
        return _difference.default;
    }
});
Object.defineProperty(exports, "disjoint", {
    enumerable: true,
    get: function() {
        return _disjoint.default;
    }
});
Object.defineProperty(exports, "every", {
    enumerable: true,
    get: function() {
        return _every.default;
    }
});
Object.defineProperty(exports, "extent", {
    enumerable: true,
    get: function() {
        return _extent.default;
    }
});
Object.defineProperty(exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return _fsum.fcumsum;
    }
});
Object.defineProperty(exports, "filter", {
    enumerable: true,
    get: function() {
        return _filter.default;
    }
});
Object.defineProperty(exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return _group.flatGroup;
    }
});
Object.defineProperty(exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return _group.flatRollup;
    }
});
Object.defineProperty(exports, "fsum", {
    enumerable: true,
    get: function() {
        return _fsum.fsum;
    }
});
Object.defineProperty(exports, "greatest", {
    enumerable: true,
    get: function() {
        return _greatest.default;
    }
});
Object.defineProperty(exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return _greatestIndex.default;
    }
});
Object.defineProperty(exports, "group", {
    enumerable: true,
    get: function() {
        return _group.default;
    }
});
Object.defineProperty(exports, "groupSort", {
    enumerable: true,
    get: function() {
        return _groupSort.default;
    }
});
Object.defineProperty(exports, "groups", {
    enumerable: true,
    get: function() {
        return _group.groups;
    }
});
Object.defineProperty(exports, "histogram", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "index", {
    enumerable: true,
    get: function() {
        return _group.index;
    }
});
Object.defineProperty(exports, "indexes", {
    enumerable: true,
    get: function() {
        return _group.indexes;
    }
});
Object.defineProperty(exports, "intersection", {
    enumerable: true,
    get: function() {
        return _intersection.default;
    }
});
Object.defineProperty(exports, "least", {
    enumerable: true,
    get: function() {
        return _least.default;
    }
});
Object.defineProperty(exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return _leastIndex.default;
    }
});
Object.defineProperty(exports, "map", {
    enumerable: true,
    get: function() {
        return _map.default;
    }
});
Object.defineProperty(exports, "max", {
    enumerable: true,
    get: function() {
        return _max.default;
    }
});
Object.defineProperty(exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return _maxIndex.default;
    }
});
Object.defineProperty(exports, "mean", {
    enumerable: true,
    get: function() {
        return _mean.default;
    }
});
Object.defineProperty(exports, "median", {
    enumerable: true,
    get: function() {
        return _median.default;
    }
});
Object.defineProperty(exports, "merge", {
    enumerable: true,
    get: function() {
        return _merge.default;
    }
});
Object.defineProperty(exports, "min", {
    enumerable: true,
    get: function() {
        return _min.default;
    }
});
Object.defineProperty(exports, "minIndex", {
    enumerable: true,
    get: function() {
        return _minIndex.default;
    }
});
Object.defineProperty(exports, "mode", {
    enumerable: true,
    get: function() {
        return _mode.default;
    }
});
Object.defineProperty(exports, "nice", {
    enumerable: true,
    get: function() {
        return _nice.default;
    }
});
Object.defineProperty(exports, "pairs", {
    enumerable: true,
    get: function() {
        return _pairs.default;
    }
});
Object.defineProperty(exports, "permute", {
    enumerable: true,
    get: function() {
        return _permute.default;
    }
});
Object.defineProperty(exports, "quantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return _quantile.quantileSorted;
    }
});
Object.defineProperty(exports, "quickselect", {
    enumerable: true,
    get: function() {
        return _quickselect.default;
    }
});
Object.defineProperty(exports, "range", {
    enumerable: true,
    get: function() {
        return _range.default;
    }
});
Object.defineProperty(exports, "rank", {
    enumerable: true,
    get: function() {
        return _rank.default;
    }
});
Object.defineProperty(exports, "reduce", {
    enumerable: true,
    get: function() {
        return _reduce.default;
    }
});
Object.defineProperty(exports, "reverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "rollup", {
    enumerable: true,
    get: function() {
        return _group.rollup;
    }
});
Object.defineProperty(exports, "rollups", {
    enumerable: true,
    get: function() {
        return _group.rollups;
    }
});
Object.defineProperty(exports, "scan", {
    enumerable: true,
    get: function() {
        return _scan.default;
    }
});
Object.defineProperty(exports, "shuffle", {
    enumerable: true,
    get: function() {
        return _shuffle.default;
    }
});
Object.defineProperty(exports, "shuffler", {
    enumerable: true,
    get: function() {
        return _shuffle.shuffler;
    }
});
Object.defineProperty(exports, "some", {
    enumerable: true,
    get: function() {
        return _some.default;
    }
});
Object.defineProperty(exports, "sort", {
    enumerable: true,
    get: function() {
        return _sort.default;
    }
});
Object.defineProperty(exports, "subset", {
    enumerable: true,
    get: function() {
        return _subset.default;
    }
});
Object.defineProperty(exports, "sum", {
    enumerable: true,
    get: function() {
        return _sum.default;
    }
});
Object.defineProperty(exports, "superset", {
    enumerable: true,
    get: function() {
        return _superset.default;
    }
});
Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return _freedmanDiaconis.default;
    }
});
Object.defineProperty(exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return _scott.default;
    }
});
Object.defineProperty(exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return _sturges.default;
    }
});
Object.defineProperty(exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return _ticks.tickIncrement;
    }
});
Object.defineProperty(exports, "tickStep", {
    enumerable: true,
    get: function() {
        return _ticks.tickStep;
    }
});
Object.defineProperty(exports, "ticks", {
    enumerable: true,
    get: function() {
        return _ticks.default;
    }
});
Object.defineProperty(exports, "transpose", {
    enumerable: true,
    get: function() {
        return _transpose.default;
    }
});
Object.defineProperty(exports, "union", {
    enumerable: true,
    get: function() {
        return _union.default;
    }
});
Object.defineProperty(exports, "variance", {
    enumerable: true,
    get: function() {
        return _variance.default;
    }
});
Object.defineProperty(exports, "zip", {
    enumerable: true,
    get: function() {
        return _zip.default;
    }
});
var _bisect = _interopRequireWildcard(require("30e30fd80e01d017"));
var _ascending = _interopRequireDefault(require("ba6e167afdeaab0b"));
var _bisector = _interopRequireDefault(require("a8afbc207886cfe5"));
var _count = _interopRequireDefault(require("1ec4d87c2d530b17"));
var _cross = _interopRequireDefault(require("e60cb580083b63b4"));
var _cumsum = _interopRequireDefault(require("2ed7a3899076eb06"));
var _descending = _interopRequireDefault(require("b44226224b8ee28a"));
var _deviation = _interopRequireDefault(require("3bfdfde74e5e3893"));
var _extent = _interopRequireDefault(require("e0c64cb1665c42fc"));
var _fsum = require("8239d81e924c7f9b");
var _group = _interopRequireWildcard(require("e133ef73b59e280f"));
var _groupSort = _interopRequireDefault(require("3c1ee14e652a9a74"));
var _bin = _interopRequireDefault(require("1c3fea00392fd51a"));
var _freedmanDiaconis = _interopRequireDefault(require("39d93dd913508747"));
var _scott = _interopRequireDefault(require("876933b3acb155ad"));
var _sturges = _interopRequireDefault(require("d1e08dd0d72014d7"));
var _max = _interopRequireDefault(require("5653c1d333b623cc"));
var _maxIndex = _interopRequireDefault(require("e384106528492a4"));
var _mean = _interopRequireDefault(require("e8829bf9149c3ef0"));
var _median = _interopRequireDefault(require("d00dfb19fe2fa3dd"));
var _merge = _interopRequireDefault(require("f8db612b317ca902"));
var _min = _interopRequireDefault(require("23890540251f6e67"));
var _minIndex = _interopRequireDefault(require("b9d42ff8895c4de8"));
var _mode = _interopRequireDefault(require("85fe3d40f6f5138d"));
var _nice = _interopRequireDefault(require("e8d14d9a3dedafe6"));
var _pairs = _interopRequireDefault(require("177b2ef4b4963970"));
var _permute = _interopRequireDefault(require("365c2a51c1482713"));
var _quantile = _interopRequireWildcard(require("1d56df0071525856"));
var _quickselect = _interopRequireDefault(require("1d2b63add15610db"));
var _range = _interopRequireDefault(require("879f1890a7517024"));
var _rank = _interopRequireDefault(require("912567809e44cbf8"));
var _least = _interopRequireDefault(require("c6b4300bede89d14"));
var _leastIndex = _interopRequireDefault(require("38f5be9e3fad1ac0"));
var _greatest = _interopRequireDefault(require("7fdad0a7cfab2520"));
var _greatestIndex = _interopRequireDefault(require("acba90bb290c79e9"));
var _scan = _interopRequireDefault(require("4a0a3c353076d5f7"));
var _shuffle = _interopRequireWildcard(require("ca2fb5eb530363f6"));
var _sum = _interopRequireDefault(require("fcc170790ec9f19b"));
var _ticks = _interopRequireWildcard(require("cd372a8370da3735"));
var _transpose = _interopRequireDefault(require("fece81f7cb114699"));
var _variance = _interopRequireDefault(require("68a6cbe5f6ed9d0b"));
var _zip = _interopRequireDefault(require("a43b4c003dde8ae5"));
var _every = _interopRequireDefault(require("aa419cb489a22141"));
var _some = _interopRequireDefault(require("2d20a8f791fd5767"));
var _filter = _interopRequireDefault(require("32260c06b0e9256d"));
var _map = _interopRequireDefault(require("6071cde151b05eb9"));
var _reduce = _interopRequireDefault(require("12d8fb254953b9bd"));
var _reverse = _interopRequireDefault(require("a0b2aacd1379b178"));
var _sort = _interopRequireDefault(require("68390ceda5e75df5"));
var _difference = _interopRequireDefault(require("e3b896de066f5364"));
var _disjoint = _interopRequireDefault(require("a4315b63bcb13bca"));
var _intersection = _interopRequireDefault(require("9f70d47eae5d7300"));
var _subset = _interopRequireDefault(require("56df3047d82ddba3"));
var _superset = _interopRequireDefault(require("f70ec3fe7b14f6c5"));
var _union = _interopRequireDefault(require("7c20e02710d1b117"));
var _index = require("5307d8bb084e9ec1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"30e30fd80e01d017":"6bNiK","ba6e167afdeaab0b":"dQy55","a8afbc207886cfe5":"5YcRn","1ec4d87c2d530b17":"3r1LC","e60cb580083b63b4":"48OgI","2ed7a3899076eb06":"iB0D5","b44226224b8ee28a":"go371","3bfdfde74e5e3893":"1wTUc","e0c64cb1665c42fc":"3ZWwE","8239d81e924c7f9b":"hicJu","e133ef73b59e280f":"1d1mZ","3c1ee14e652a9a74":"daduA","1c3fea00392fd51a":"aWZJg","39d93dd913508747":"dI9xV","876933b3acb155ad":"dT7s9","d1e08dd0d72014d7":"4CFuu","5653c1d333b623cc":"5JR7h","e384106528492a4":"cLRSf","e8829bf9149c3ef0":"sGMQd","d00dfb19fe2fa3dd":"eqbfb","f8db612b317ca902":"5m4BF","23890540251f6e67":"lIXa3","b9d42ff8895c4de8":"djllR","85fe3d40f6f5138d":"ixcQK","e8d14d9a3dedafe6":"1tKIm","177b2ef4b4963970":"iH0Xf","365c2a51c1482713":"gKKIp","1d56df0071525856":"126s4","1d2b63add15610db":"efckU","879f1890a7517024":"aPPHT","912567809e44cbf8":"garpo","c6b4300bede89d14":"8g0OX","38f5be9e3fad1ac0":"32jqV","7fdad0a7cfab2520":"5GJre","acba90bb290c79e9":"iCUcE","4a0a3c353076d5f7":"2FG1c","ca2fb5eb530363f6":"j1ToL","fcc170790ec9f19b":"1N986","cd372a8370da3735":"jdiTt","fece81f7cb114699":"3QFMF","68a6cbe5f6ed9d0b":"7S0wr","a43b4c003dde8ae5":"gSGMY","aa419cb489a22141":"ckXNq","2d20a8f791fd5767":"jxze2","32260c06b0e9256d":"f5Z3W","6071cde151b05eb9":"kGUe3","12d8fb254953b9bd":"j11FK","a0b2aacd1379b178":"5fTEf","68390ceda5e75df5":"bcop5","e3b896de066f5364":"698Wu","a4315b63bcb13bca":"1TnjQ","9f70d47eae5d7300":"6N7A3","56df3047d82ddba3":"62lr5","f70ec3fe7b14f6c5":"i0dTB","7c20e02710d1b117":"9MtYc","5307d8bb084e9ec1":"kIfry"}],"6bNiK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.bisectRight = exports.bisectLeft = exports.bisectCenter = void 0;
var _ascending = _interopRequireDefault(require("c1f158b330aaa13c"));
var _bisector = _interopRequireDefault(require("ae9e5922ca82e11d"));
var _number = _interopRequireDefault(require("7b6cc53664acedc3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ascendingBisect = (0, _bisector.default)(_ascending.default);
const bisectRight = ascendingBisect.right;
exports.bisectRight = bisectRight;
const bisectLeft = ascendingBisect.left;
exports.bisectLeft = bisectLeft;
const bisectCenter = (0, _bisector.default)(_number.default).center;
exports.bisectCenter = bisectCenter;
var _default = bisectRight;
exports.default = _default;

},{"c1f158b330aaa13c":"dQy55","ae9e5922ca82e11d":"5YcRn","7b6cc53664acedc3":"bU5MV"}],"dQy55":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ascending;
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{}],"5YcRn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bisector;
var _ascending = _interopRequireDefault(require("7cbc9edd390ae8bb"));
var _descending = _interopRequireDefault(require("bbf176e93324968c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = _ascending.default;
        compare2 = (d, x)=>(0, _ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === _ascending.default || f === _descending.default ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"7cbc9edd390ae8bb":"dQy55","bbf176e93324968c":"go371"}],"go371":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = descending;
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"bU5MV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
exports.numbers = numbers;
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{}],"3r1LC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = count;
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{}],"48OgI":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cross;
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{}],"iB0D5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cumsum;
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{}],"1wTUc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deviation;
var _variance = _interopRequireDefault(require("51ae5f4f20d14175"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function deviation(values, valueof) {
    const v = (0, _variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"51ae5f4f20d14175":"7S0wr"}],"7S0wr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = variance;
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{}],"3ZWwE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extent;
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{}],"hicJu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Adder = void 0;
exports.fcumsum = fcumsum;
exports.fsum = fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
exports.Adder = Adder;
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{}],"1d1mZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = group;
exports.flatGroup = flatGroup;
exports.flatRollup = flatRollup;
exports.groups = groups;
exports.index = index;
exports.indexes = indexes;
exports.rollup = rollup;
exports.rollups = rollups;
var _index = require("48004d0dfe52b7a6");
var _identity = _interopRequireDefault(require("3cf6030d781ef6b2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function group(values, ...keys) {
    return nest(values, _identity.default, _identity.default, keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, _identity.default, keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, _identity.default, reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, _identity.default, unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new _index.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"48004d0dfe52b7a6":"kIfry","3cf6030d781ef6b2":"3SC9v"}],"kIfry":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InternSet = exports.InternMap = void 0;
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
exports.InternMap = InternMap;
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
exports.InternSet = InternSet;
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"3SC9v":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
function identity(x) {
    return x;
}

},{}],"daduA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = groupSort;
var _ascending = _interopRequireDefault(require("325640508c2e43b"));
var _group = _interopRequireWildcard(require("57a8d19e7d7a16cf"));
var _sort = _interopRequireDefault(require("a759bcb922f07eb1"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sort.default)((0, _group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascending.default)(av, bv) || (0, _ascending.default)(ak, bk)) : (0, _sort.default)((0, _group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascending.default)(ak, bk))).map(([key])=>key);
}

},{"325640508c2e43b":"dQy55","57a8d19e7d7a16cf":"1d1mZ","a759bcb922f07eb1":"bcop5"}],"bcop5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ascendingDefined = ascendingDefined;
exports.compareDefined = compareDefined;
exports.default = sort;
var _ascending = _interopRequireDefault(require("17dda5769044e4af"));
var _permute = _interopRequireDefault(require("45ed8435c3fc2fdf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permute.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = _ascending.default) {
    if (compare === _ascending.default) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"17dda5769044e4af":"dQy55","45ed8435c3fc2fdf":"gKKIp"}],"gKKIp":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = permute;
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{}],"aWZJg":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bin;
var _array = require("2e045be59e43c77");
var _bisect = _interopRequireDefault(require("319eb924a032034c"));
var _constant = _interopRequireDefault(require("2d6358dd303eb77c"));
var _extent = _interopRequireDefault(require("b715ed473e0ab15b"));
var _identity = _interopRequireDefault(require("f9340ffc2d80b8ca"));
var _nice = _interopRequireDefault(require("c13788fe41624795"));
var _ticks = _interopRequireWildcard(require("b122967555bb47b9"));
var _sturges = _interopRequireDefault(require("3587d7f4446a1fc2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bin() {
    var value = _identity.default, domain = _extent.default, threshold = _sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === _extent.default) [x0, x1] = (0, _nice.default)(x0, x1, tn);
            tz = (0, _ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === _extent.default) {
                    const step = (0, _ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant.default)(_array.slice.call(_)) : (0, _constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

},{"2e045be59e43c77":"iW0io","319eb924a032034c":"6bNiK","2d6358dd303eb77c":"kkNiM","b715ed473e0ab15b":"3ZWwE","f9340ffc2d80b8ca":"3SC9v","c13788fe41624795":"1tKIm","b122967555bb47b9":"jdiTt","3587d7f4446a1fc2":"4CFuu"}],"iW0io":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slice = exports.map = void 0;
var array = Array.prototype;
var slice = array.slice;
exports.slice = slice;
var map = array.map;
exports.map = map;

},{}],"kkNiM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constant;
function constant(x) {
    return ()=>x;
}

},{}],"1tKIm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
var _ticks = require("82883d5f91d2ba9");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticks.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"82883d5f91d2ba9":"jdiTt"}],"jdiTt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{}],"4CFuu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdSturges;
var _count = _interopRequireDefault(require("d856b0d375bb9b61"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdSturges(values) {
    return Math.ceil(Math.log((0, _count.default)(values)) / Math.LN2) + 1;
}

},{"d856b0d375bb9b61":"3r1LC"}],"dI9xV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdFreedmanDiaconis;
var _count = _interopRequireDefault(require("84a2a08734413081"));
var _quantile = _interopRequireDefault(require("b453688def319e0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, _quantile.default)(values, 0.75) - (0, _quantile.default)(values, 0.25)) * Math.pow((0, _count.default)(values), -1 / 3)));
}

},{"84a2a08734413081":"3r1LC","b453688def319e0":"126s4"}],"126s4":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
exports.quantileSorted = quantileSorted;
var _max = _interopRequireDefault(require("6377896bac51b475"));
var _min = _interopRequireDefault(require("7403c617ea3dc723"));
var _quickselect = _interopRequireDefault(require("fa6451b912e13124"));
var _number = _interopRequireWildcard(require("de13410c4756be71"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _min.default)(values);
    if (p >= 1) return (0, _max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _max.default)((0, _quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = _number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"6377896bac51b475":"5JR7h","7403c617ea3dc723":"lIXa3","fa6451b912e13124":"efckU","de13410c4756be71":"bU5MV"}],"5JR7h":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = max;
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{}],"lIXa3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = min;
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{}],"efckU":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quickselect;
var _sort = require("c4d7054457278972");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? _sort.ascendingDefined : (0, _sort.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"c4d7054457278972":"bcop5"}],"dT7s9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdScott;
var _count = _interopRequireDefault(require("544301f03b7cfef6"));
var _deviation = _interopRequireDefault(require("9c084667c87040d5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, _count.default)(values)) / (3.49 * (0, _deviation.default)(values)));
}

},{"544301f03b7cfef6":"3r1LC","9c084667c87040d5":"1wTUc"}],"cLRSf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = maxIndex;
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{}],"sGMQd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mean;
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{}],"eqbfb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = median;
var _quantile = _interopRequireDefault(require("73b253d4e179eac9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function median(values, valueof) {
    return (0, _quantile.default)(values, 0.5, valueof);
}

},{"73b253d4e179eac9":"126s4"}],"5m4BF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = merge;
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{}],"djllR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = minIndex;
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{}],"ixcQK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mode;
var _index = require("cc79d9604cb49161");
function mode(values, valueof) {
    const counts = new _index.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"cc79d9604cb49161":"kIfry"}],"iH0Xf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pairs;
exports.pair = pair;
function pairs(values, pairof = pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{}],"aPPHT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = range;
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{}],"garpo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rank;
var _ascending = _interopRequireDefault(require("3d6b2e0137da2f5f"));
var _sort = require("baf9f3a118e8a4c3");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function rank(values, valueof = _ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = _ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === _ascending.default ? (i, j)=>(0, _sort.ascendingDefined)(V[i], V[j]) : (0, _sort.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"3d6b2e0137da2f5f":"dQy55","baf9f3a118e8a4c3":"bcop5"}],"8g0OX":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = least;
var _ascending = _interopRequireDefault(require("86cd41303b4be24c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function least(values, compare = _ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, minValue) < 0 : (0, _ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"86cd41303b4be24c":"dQy55"}],"32jqV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leastIndex;
var _ascending = _interopRequireDefault(require("3a70505afbae26e3"));
var _minIndex = _interopRequireDefault(require("7863dae356808098"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function leastIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"3a70505afbae26e3":"dQy55","7863dae356808098":"djllR"}],"5GJre":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatest;
var _ascending = _interopRequireDefault(require("7e4721a4d28ff20a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatest(values, compare = _ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, maxValue) > 0 : (0, _ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"7e4721a4d28ff20a":"dQy55"}],"iCUcE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatestIndex;
var _ascending = _interopRequireDefault(require("a08614b50d783d7f"));
var _maxIndex = _interopRequireDefault(require("c1f809321f205561"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatestIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"a08614b50d783d7f":"dQy55","c1f809321f205561":"cLRSf"}],"2FG1c":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scan;
var _leastIndex = _interopRequireDefault(require("620579109956e518"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function scan(values, compare) {
    const index = (0, _leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"620579109956e518":"32jqV"}],"j1ToL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.shuffler = shuffler;
var _default = shuffler(Math.random);
exports.default = _default;
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{}],"1N986":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sum;
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{}],"3QFMF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = transpose;
var _min = _interopRequireDefault(require("e91a8bba11a65cd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _min.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"e91a8bba11a65cd":"lIXa3"}],"gSGMY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = zip;
var _transpose = _interopRequireDefault(require("f5cee9197fcba405"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function zip() {
    return (0, _transpose.default)(arguments);
}

},{"f5cee9197fcba405":"3QFMF"}],"ckXNq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = every;
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{}],"jxze2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = some;
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{}],"f5Z3W":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filter;
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{}],"kGUe3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = map;
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{}],"j11FK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduce;
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{}],"5fTEf":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reverse;
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{}],"698Wu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = difference;
var _index = require("53f785431e2265c8");
function difference(values, ...others) {
    values = new _index.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"53f785431e2265c8":"kIfry"}],"1TnjQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = disjoint;
var _index = require("fd3ab907acc87368");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new _index.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"fd3ab907acc87368":"kIfry"}],"6N7A3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = intersection;
var _index = require("57400e6933e84289");
function intersection(values, ...others) {
    values = new _index.InternSet(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof _index.InternSet ? values : new _index.InternSet(values);
}

},{"57400e6933e84289":"kIfry"}],"62lr5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subset;
var _superset = _interopRequireDefault(require("642286ff2d84a077"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function subset(values, other) {
    return (0, _superset.default)(other, values);
}

},{"642286ff2d84a077":"i0dTB"}],"i0dTB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = superset;
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"9MtYc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = union;
var _index = require("c01638dea2a1bd81");
function union(...others) {
    const set = new _index.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"c01638dea2a1bd81":"kIfry"}],"Seiq9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initInterpolator = initInterpolator;
exports.initRange = initRange;
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{}],"kOPtd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ordinal;
exports.implicit = void 0;
var _index = require("fcba4401bac5bf73");
var _init = require("cc7553c4008fe238");
const implicit = Symbol("implicit");
exports.implicit = implicit;
function ordinal() {
    var index = new _index.InternMap(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new _index.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"fcba4401bac5bf73":"eYjUM","cc7553c4008fe238":"Seiq9"}],"8ev1f":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
var _linear = require("f84b1fa17c06395b");
var _number = _interopRequireDefault(require("b36082d6f802f397"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, _number.default) : [
        0,
        1
    ];
    return (0, _linear.linearish)(scale);
}

},{"f84b1fa17c06395b":"4UkXL","b36082d6f802f397":"3DPLQ"}],"4UkXL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = linear;
exports.linearish = linearish;
var _index = require("1483cc73fade9a0f");
var _continuous = _interopRequireWildcard(require("b89b32e6dad66d07"));
var _init = require("a628a2e1a79e7cdb");
var _tickFormat = _interopRequireDefault(require("a55604f9dbd11e62"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _index.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _index.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuous.default)();
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    _init.initRange.apply(scale, arguments);
    return linearish(scale);
}

},{"1483cc73fade9a0f":"eYjUM","b89b32e6dad66d07":"kaFZ5","a628a2e1a79e7cdb":"Seiq9","a55604f9dbd11e62":"lc0wW"}],"kaFZ5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = continuous;
exports.identity = identity;
exports.transformer = transformer;
var _index = require("b27e55bf39279c79");
var _index2 = require("ba6b5a0092937a29");
var _constant = _interopRequireDefault(require("e75211b791b964e7"));
var _number = _interopRequireDefault(require("d695e4a3f96a954d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constant.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _index.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = _index2.interpolate, transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), _index2.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = _index2.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"b27e55bf39279c79":"eYjUM","ba6b5a0092937a29":"2qco8","e75211b791b964e7":"jZ1fG","d695e4a3f96a954d":"3DPLQ"}],"2qco8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "interpolate", {
    enumerable: true,
    get: function() {
        return _value.default;
    }
});
Object.defineProperty(exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return _array.default;
    }
});
Object.defineProperty(exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return _cubehelix.cubehelixLong;
    }
});
Object.defineProperty(exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return _date.default;
    }
});
Object.defineProperty(exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return _discrete.default;
    }
});
Object.defineProperty(exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return _hcl.default;
    }
});
Object.defineProperty(exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return _hcl.hclLong;
    }
});
Object.defineProperty(exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return _hsl.default;
    }
});
Object.defineProperty(exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return _hsl.hslLong;
    }
});
Object.defineProperty(exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return _hue.default;
    }
});
Object.defineProperty(exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return _number.default;
    }
});
Object.defineProperty(exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return _numberArray.default;
    }
});
Object.defineProperty(exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return _object.default;
    }
});
Object.defineProperty(exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return _rgb.default;
    }
});
Object.defineProperty(exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasis;
    }
});
Object.defineProperty(exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasisClosed;
    }
});
Object.defineProperty(exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return _round.default;
    }
});
Object.defineProperty(exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return _string.default;
    }
});
Object.defineProperty(exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformCss;
    }
});
Object.defineProperty(exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformSvg;
    }
});
Object.defineProperty(exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return _zoom.default;
    }
});
Object.defineProperty(exports, "piecewise", {
    enumerable: true,
    get: function() {
        return _piecewise.default;
    }
});
Object.defineProperty(exports, "quantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
var _value = _interopRequireDefault(require("18a1769b74308b38"));
var _array = _interopRequireDefault(require("f99323a27aa06a8c"));
var _basis = _interopRequireDefault(require("66bb1ae08d550d2f"));
var _basisClosed = _interopRequireDefault(require("e0f8689cd9a4ed85"));
var _date = _interopRequireDefault(require("938cc47dd24b27f"));
var _discrete = _interopRequireDefault(require("6ee3a660784662db"));
var _hue = _interopRequireDefault(require("c97b3402df3264f1"));
var _number = _interopRequireDefault(require("c4605d70387a9f89"));
var _numberArray = _interopRequireDefault(require("f5b9681bf316d3c8"));
var _object = _interopRequireDefault(require("2a8363d30def3d49"));
var _round = _interopRequireDefault(require("132735e62b44017c"));
var _string = _interopRequireDefault(require("5f79c0b417d7ffb1"));
var _index = require("9cd31cac42489c2d");
var _zoom = _interopRequireDefault(require("829022ddb9572f68"));
var _rgb = _interopRequireWildcard(require("a08467c6d9046172"));
var _hsl = _interopRequireWildcard(require("1b2f37b38b1c2632"));
var _lab = _interopRequireDefault(require("76284b3c5d04b53e"));
var _hcl = _interopRequireWildcard(require("361bffab7c7a6e6a"));
var _cubehelix = _interopRequireWildcard(require("c6d6249c783d060a"));
var _piecewise = _interopRequireDefault(require("cb02924b4c722e0d"));
var _quantize = _interopRequireDefault(require("d55fda9f4fcff7dd"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"18a1769b74308b38":"gcqkr","f99323a27aa06a8c":"gQAZo","66bb1ae08d550d2f":"cpBZK","e0f8689cd9a4ed85":"aybpC","938cc47dd24b27f":"cNRKy","6ee3a660784662db":"2v3iD","c97b3402df3264f1":"1YxbW","c4605d70387a9f89":"5MrTB","f5b9681bf316d3c8":"aaUYm","2a8363d30def3d49":"ft4y8","132735e62b44017c":"edz0V","5f79c0b417d7ffb1":"4O1fi","9cd31cac42489c2d":"etHcy","829022ddb9572f68":"itRw7","a08467c6d9046172":"eWwGz","1b2f37b38b1c2632":"6H4hC","76284b3c5d04b53e":"8fGeM","361bffab7c7a6e6a":"kLiJ0","c6d6249c783d060a":"gFvlY","cb02924b4c722e0d":"8d0if","d55fda9f4fcff7dd":"kpYJ7"}],"gcqkr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("6b00cb8a35cd7eca");
var _rgb = _interopRequireDefault(require("2f5b9308d0021b3f"));
var _array = require("858d92aa5fbe2d16");
var _date = _interopRequireDefault(require("3b5f3eaf3c70c4df"));
var _number = _interopRequireDefault(require("7aa3212a6360303f"));
var _object = _interopRequireDefault(require("4512622efcc3e244"));
var _string = _interopRequireDefault(require("4f6ec7c7e2d116a"));
var _constant = _interopRequireDefault(require("49fed36e04134ce7"));
var _numberArray = _interopRequireWildcard(require("7635b225e783f2fb"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, _constant.default)(b) : (t === "number" ? _number.default : t === "string" ? (c = (0, _index.color)(b)) ? (b = c, _rgb.default) : _string.default : b instanceof _index.color ? _rgb.default : b instanceof Date ? _date.default : (0, _numberArray.isNumberArray)(b) ? _numberArray.default : Array.isArray(b) ? _array.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object.default : _number.default)(a, b);
}

},{"6b00cb8a35cd7eca":"kzsiG","2f5b9308d0021b3f":"eWwGz","858d92aa5fbe2d16":"gQAZo","3b5f3eaf3c70c4df":"cNRKy","7aa3212a6360303f":"5MrTB","4512622efcc3e244":"ft4y8","4f6ec7c7e2d116a":"4O1fi","49fed36e04134ce7":"4QRqB","7635b225e783f2fb":"aaUYm"}],"kzsiG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "color", {
    enumerable: true,
    get: function() {
        return _color.default;
    }
});
Object.defineProperty(exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "gray", {
    enumerable: true,
    get: function() {
        return _lab.gray;
    }
});
Object.defineProperty(exports, "hcl", {
    enumerable: true,
    get: function() {
        return _lab.hcl;
    }
});
Object.defineProperty(exports, "hsl", {
    enumerable: true,
    get: function() {
        return _color.hsl;
    }
});
Object.defineProperty(exports, "lab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "lch", {
    enumerable: true,
    get: function() {
        return _lab.lch;
    }
});
Object.defineProperty(exports, "rgb", {
    enumerable: true,
    get: function() {
        return _color.rgb;
    }
});
var _color = _interopRequireWildcard(require("60878dcd6741cbf6"));
var _lab = _interopRequireWildcard(require("19fbdf90fb32e3fb"));
var _cubehelix = _interopRequireDefault(require("84a7e361b17f11ef"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"60878dcd6741cbf6":"8WpnJ","19fbdf90fb32e3fb":"17g12","84a7e361b17f11ef":"aWP2B"}],"8WpnJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;
var _define = _interopRequireWildcard(require("1d30727e3b2969dd"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"1d30727e3b2969dd":"6O9mK"}],"6O9mK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.extend = extend;
function _default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{}],"17g12":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hcl = Hcl;
exports.Lab = Lab;
exports.default = lab;
exports.gray = gray;
exports.hcl = hcl;
exports.lch = lch;
var _define = _interopRequireWildcard(require("9a3353011f08cad1"));
var _color = require("3650f0b1e5700098");
var _math = require("ef21497f13ac1079");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Lab, lab, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new _color.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * _math.degrees;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * _math.radians;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _define.default)(Hcl, hcl, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"9a3353011f08cad1":"6O9mK","3650f0b1e5700098":"8WpnJ","ef21497f13ac1079":"4CXyz"}],"4CXyz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.radians = exports.degrees = void 0;
const radians = Math.PI / 180;
exports.radians = radians;
const degrees = 180 / Math.PI;
exports.degrees = degrees;

},{}],"aWP2B":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cubehelix = Cubehelix;
exports.default = cubehelix;
var _define = _interopRequireWildcard(require("4abcf1c064e6684a"));
var _color = require("88aa652eacec148e");
var _math = require("7e69901a6e423f00");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * _math.degrees - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Cubehelix, cubehelix, (0, _define.extend)(_color.Color, {
    brighter (k) {
        k = k == null ? _color.brighter : Math.pow(_color.brighter, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? _color.darker : Math.pow(_color.darker, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new _color.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"4abcf1c064e6684a":"6O9mK","88aa652eacec148e":"8WpnJ","7e69901a6e423f00":"4CXyz"}],"eWwGz":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rgbBasisClosed = exports.rgbBasis = exports.default = void 0;
var _index = require("a71c13c6f95adbd4");
var _basis = _interopRequireDefault(require("6a332a97102860d7"));
var _basisClosed = _interopRequireDefault(require("9304424e5c9a17cf"));
var _color = _interopRequireWildcard(require("7dffa81f3b4437d6"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = function rgbGamma(y) {
    var color = (0, _color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _index.rgb)(start)).r, (end = (0, _index.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
exports.default = _default;
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _index.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline(_basis.default);
exports.rgbBasis = rgbBasis;
var rgbBasisClosed = rgbSpline(_basisClosed.default);
exports.rgbBasisClosed = rgbBasisClosed;

},{"a71c13c6f95adbd4":"kzsiG","6a332a97102860d7":"cpBZK","9304424e5c9a17cf":"aybpC","7dffa81f3b4437d6":"8E5r2"}],"cpBZK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basis = basis;
exports.default = _default;
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function _default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{}],"aybpC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("fa54a771ab54df01");
function _default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, _basis.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{"fa54a771ab54df01":"cpBZK"}],"8E5r2":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nogamma;
exports.gamma = gamma;
exports.hue = hue;
var _constant = _interopRequireDefault(require("c45f0b08e65bfe9d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constant.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constant.default)(isNaN(a) ? b : a);
}

},{"c45f0b08e65bfe9d":"4QRqB"}],"4QRqB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = (x)=>()=>x;
exports.default = _default;

},{}],"gQAZo":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.genericArray = genericArray;
var _value = _interopRequireDefault(require("b86da8c7688bb1d9"));
var _numberArray = _interopRequireWildcard(require("505aa46a393cd613"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    return ((0, _numberArray.isNumberArray)(b) ? _numberArray.default : genericArray)(a, b);
}
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"b86da8c7688bb1d9":"gcqkr","505aa46a393cd613":"aaUYm"}],"aaUYm":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.isNumberArray = isNumberArray;
function _default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{}],"cNRKy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

},{}],"5MrTB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

},{}],"ft4y8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _value = _interopRequireDefault(require("ff3c10c6ba896e53"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, _value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

},{"ff3c10c6ba896e53":"gcqkr"}],"4O1fi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _number = _interopRequireDefault(require("1ec1f242696e82fa"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function _default(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = reA.exec(a)) && (bm = reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, _number.default)(am, bm)
            });
        }
        bi = reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

},{"1ec1f242696e82fa":"5MrTB"}],"2v3iD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

},{}],"1YxbW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _color = require("f9552f2567e33cad");
function _default(a, b) {
    var i = (0, _color.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

},{"f9552f2567e33cad":"8E5r2"}],"edz0V":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

},{}],"etHcy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolateTransformSvg = exports.interpolateTransformCss = void 0;
var _number = _interopRequireDefault(require("3e2d37e598810190"));
var _parse = require("4b3d6acbd4a3c21a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
exports.interpolateTransformCss = interpolateTransformCss;
var interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");
exports.interpolateTransformSvg = interpolateTransformSvg;

},{"3e2d37e598810190":"5MrTB","4b3d6acbd4a3c21a":"kRzwK"}],"kRzwK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCss = parseCss;
exports.parseSvg = parseSvg;
var _decompose = _interopRequireWildcard(require("6801e9b7b9a8c06f"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var svgNode;
/* eslint-disable no-undef */ function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? _decompose.identity : (0, _decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return _decompose.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
    value = value.matrix;
    return (0, _decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"6801e9b7b9a8c06f":"1cMQB"}],"1cMQB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.identity = void 0;
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
exports.identity = identity;
function _default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * degrees,
        skewX: Math.atan(skewX) * degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

},{}],"itRw7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var _default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
exports.default = _default;

},{}],"6H4hC":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hslLong = exports.default = void 0;
var _index = require("8527dae26181d5cf");
var _color = _interopRequireWildcard(require("45faacac073e112a"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hsl)(start)).h, (end = (0, _index.hsl)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hsl(_color.hue);
exports.default = _default;
var hslLong = hsl(_color.default);
exports.hslLong = hslLong;

},{"8527dae26181d5cf":"kzsiG","45faacac073e112a":"8E5r2"}],"8fGeM":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = lab;
var _index = require("bb962b0e100409c3");
var _color = _interopRequireDefault(require("39c4c5a5fff46e6a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function lab(start, end) {
    var l = (0, _color.default)((start = (0, _index.lab)(start)).l, (end = (0, _index.lab)(end)).l), a = (0, _color.default)(start.a, end.a), b = (0, _color.default)(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"bb962b0e100409c3":"kzsiG","39c4c5a5fff46e6a":"8E5r2"}],"kLiJ0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hclLong = exports.default = void 0;
var _index = require("5dab9e1ee5c5ab5d");
var _color = _interopRequireWildcard(require("4a63660e3a72d4d2"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hcl)(start)).h, (end = (0, _index.hcl)(end)).h), c = (0, _color.default)(start.c, end.c), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = hcl(_color.hue);
exports.default = _default;
var hclLong = hcl(_color.default);
exports.hclLong = hclLong;

},{"5dab9e1ee5c5ab5d":"kzsiG","4a63660e3a72d4d2":"8E5r2"}],"gFvlY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.cubehelixLong = void 0;
var _index = require("981aef0afb354b0c");
var _color = _interopRequireWildcard(require("f9336ad633bd893d"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _index.cubehelix)(start)).h, (end = (0, _index.cubehelix)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var _default = cubehelix(_color.hue);
exports.default = _default;
var cubehelixLong = cubehelix(_color.default);
exports.cubehelixLong = cubehelixLong;

},{"981aef0afb354b0c":"kzsiG","f9336ad633bd893d":"8E5r2"}],"8d0if":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = piecewise;
var _value = _interopRequireDefault(require("5c06b65a4f09269b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = _value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"5c06b65a4f09269b":"gcqkr"}],"kpYJ7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

},{}],"jZ1fG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constants;
function constants(x) {
    return function() {
        return x;
    };
}

},{}],"3DPLQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
function number(x) {
    return +x;
}

},{}],"lc0wW":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tickFormat;
var _index = require("a4043605242eb496");
var _index2 = require("8da1e3e06f47624b");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _index.tickStep)(start, stop, count), precision;
    specifier = (0, _index2.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _index2.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _index2.format)(specifier);
}

},{"a4043605242eb496":"eYjUM","8da1e3e06f47624b":"bNxYV"}],"bNxYV":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(exports, "format", {
    enumerable: true,
    get: function() {
        return _defaultLocale.format;
    }
});
Object.defineProperty(exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return _defaultLocale.formatPrefix;
    }
});
Object.defineProperty(exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.default;
    }
});
Object.defineProperty(exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return _precisionFixed.default;
    }
});
Object.defineProperty(exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return _precisionPrefix.default;
    }
});
Object.defineProperty(exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return _precisionRound.default;
    }
});
var _defaultLocale = _interopRequireWildcard(require("2ee0c7b1a22e44e6"));
var _locale = _interopRequireDefault(require("ff358412e51164cd"));
var _formatSpecifier = _interopRequireWildcard(require("60d6396182b4fde8"));
var _precisionFixed = _interopRequireDefault(require("792b165b9b0bcf2d"));
var _precisionPrefix = _interopRequireDefault(require("f2702d774fe2085c"));
var _precisionRound = _interopRequireDefault(require("492f493218059efd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"2ee0c7b1a22e44e6":"5L727","ff358412e51164cd":"l3por","60d6396182b4fde8":"gqsir","792b165b9b0bcf2d":"4Xp16","f2702d774fe2085c":"kxMjH","492f493218059efd":"ltbPl"}],"5L727":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.formatPrefix = exports.format = void 0;
var _locale = _interopRequireDefault(require("317c67875ded3d99"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var format;
exports.format = format;
var formatPrefix;
exports.formatPrefix = formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.format = format = locale.format;
    exports.formatPrefix = formatPrefix = locale.formatPrefix;
    return locale;
}

},{"317c67875ded3d99":"l3por"}],"l3por":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("f55671e2db2b86ef"));
var _formatGroup = _interopRequireDefault(require("e366a511ee4b4f2f"));
var _formatNumerals = _interopRequireDefault(require("86155372ae3c6f7e"));
var _formatSpecifier = _interopRequireDefault(require("1b6c7d0076b09661"));
var _formatTrim = _interopRequireDefault(require("8fea1479564cd384"));
var _formatTypes = _interopRequireDefault(require("8cc741dcfb99dfd9"));
var _formatPrefixAuto = require("10cbdd8f7ac88548");
var _identity = _interopRequireDefault(require("efeab53251079183"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function _default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? _identity.default : (0, _formatGroup.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? _identity.default : (0, _formatNumerals.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, _formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = _formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, _formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, _formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

},{"f55671e2db2b86ef":"BclIO","e366a511ee4b4f2f":"6oZMl","86155372ae3c6f7e":"gh8iE","1b6c7d0076b09661":"gqsir","8fea1479564cd384":"zSKmF","8cc741dcfb99dfd9":"2f5Qj","10cbdd8f7ac88548":"51aHt","efeab53251079183":"jUo17"}],"BclIO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("bc7d6f0e0b7ad989");
function _default(x) {
    return x = (0, _formatDecimal.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

},{"bc7d6f0e0b7ad989":"c4eLN"}],"c4eLN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.formatDecimalParts = formatDecimalParts;
function _default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{}],"6oZMl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

},{}],"gh8iE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

},{}],"gqsir":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatSpecifier = FormatSpecifier;
exports.default = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{}],"zSKmF":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function _default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

},{}],"2f5Qj":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatDecimal = _interopRequireDefault(require("feafbe2a554fb639"));
var _formatPrefixAuto = _interopRequireDefault(require("8d1082b790377352"));
var _formatRounded = _interopRequireDefault(require("35a9fc35835a2a14"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": _formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRounded.default)(x * 100, p),
    "r": _formatRounded.default,
    "s": _formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
exports.default = _default;

},{"feafbe2a554fb639":"c4eLN","8d1082b790377352":"51aHt","35a9fc35835a2a14":"3zZ3R"}],"51aHt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.prefixExponent = void 0;
var _formatDecimal = require("c968343e236e1eff");
var prefixExponent;
exports.prefixExponent = prefixExponent;
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (exports.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

},{"c968343e236e1eff":"c4eLN"}],"3zZ3R":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("8a356ace3ecb0657");
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

},{"8a356ace3ecb0657":"c4eLN"}],"jUo17":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return x;
}

},{}],"4Xp16":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("10ac7ec4cef9eac2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step) {
    return Math.max(0, -(0, _exponent.default)(Math.abs(step)));
}

},{"10ac7ec4cef9eac2":"BclIO"}],"kxMjH":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("a74b6430297cf90d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3 - (0, _exponent.default)(Math.abs(step)));
}

},{"a74b6430297cf90d":"BclIO"}],"ltbPl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("152cf0fffe5db4dc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, _exponent.default)(max) - (0, _exponent.default)(step)) + 1;
}

},{"152cf0fffe5db4dc":"BclIO"}],"colCi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
exports.loggish = loggish;
var _index = require("c2225ae6830156cb");
var _index2 = require("9fe16242a20f801");
var _nice = _interopRequireDefault(require("e1f7cd4bad5fecf5"));
var _continuous = require("cdd2320c22aee987");
var _init = require("54c81c620622cc22");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _index.ticks)(u, v, n);
        } else z = (0, _index.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _index2.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _index2.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuous.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuous.copy)(scale, log()).base(scale.base());
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"c2225ae6830156cb":"eYjUM","9fe16242a20f801":"bNxYV","e1f7cd4bad5fecf5":"8r3z0","cdd2320c22aee987":"kaFZ5","54c81c620622cc22":"Seiq9"}],"8r3z0":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{}],"8NIsN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = symlog;
exports.symlogish = symlogish;
var _linear = require("6b7bc111d415c072");
var _continuous = require("f781e5664611d9c0");
var _init = require("499d293100f0413a");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linear.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, symlog()).constant(scale.constant());
    };
    return _init.initRange.apply(scale, arguments);
}

},{"6b7bc111d415c072":"4UkXL","f781e5664611d9c0":"kaFZ5","499d293100f0413a":"Seiq9"}],"4wDg3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pow;
exports.powish = powish;
exports.sqrt = sqrt;
var _linear = require("94b90569504e034e");
var _continuous = require("6297cca891d63c37");
var _init = require("1b7874ad495edb4c");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform(_continuous.identity, _continuous.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform(_continuous.identity, _continuous.identity) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linear.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow()).exponent(scale.exponent());
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"94b90569504e034e":"4UkXL","6297cca891d63c37":"kaFZ5","1b7874ad495edb4c":"Seiq9"}],"bVHHy":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = radial;
var _continuous = _interopRequireDefault(require("9cc3a5098e156c85"));
var _init = require("116f55aac82ec8e9");
var _linear = require("b2719a0a78ca2805");
var _number = _interopRequireDefault(require("aa73717e632c4a05"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, _number.default)).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return (0, _linear.linearish)(scale);
}

},{"9cc3a5098e156c85":"kaFZ5","116f55aac82ec8e9":"Seiq9","b2719a0a78ca2805":"4UkXL","aa73717e632c4a05":"3DPLQ"}],"cwgwr":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
var _index = require("1587656407247c17");
var _init = require("e93efb9761f1f003");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _index.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _index.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"1587656407247c17":"eYjUM","e93efb9761f1f003":"Seiq9"}],"gYued":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantize;
var _index = require("61f3ae9aeeace72a");
var _linear = require("19f450ffb9fe0ee8");
var _init = require("97a4ee1bb0f33f6b");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return _init.initRange.apply((0, _linear.linearish)(scale), arguments);
}

},{"61f3ae9aeeace72a":"eYjUM","19f450ffb9fe0ee8":"4UkXL","97a4ee1bb0f33f6b":"Seiq9"}],"aFH4N":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = threshold;
var _index = require("4b6954aba910b52b");
var _init = require("5769040792c8fbdc");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"4b6954aba910b52b":"eYjUM","5769040792c8fbdc":"Seiq9"}],"1x5us":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calendar = calendar;
exports.default = time;
var _index = require("d6f26b6733e27d9f");
var _index2 = require("2c6c21fb5fc82ed8");
var _continuous = _interopRequireWildcard(require("33f8922a5dd4a530"));
var _init = require("2234a07f2ca64e26");
var _nice = _interopRequireDefault(require("c7d75e934f92c19f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return _init.initRange.apply(calendar(_index.timeTicks, _index.timeTickInterval, _index.timeYear, _index.timeMonth, _index.timeWeek, _index.timeDay, _index.timeHour, _index.timeMinute, _index.timeSecond, _index2.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d6f26b6733e27d9f":"fg6u5","2c6c21fb5fc82ed8":"bNofk","33f8922a5dd4a530":"kaFZ5","2234a07f2ca64e26":"Seiq9","c7d75e934f92c19f":"8r3z0"}],"fg6u5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "timeDay", {
    enumerable: true,
    get: function() {
        return _day.default;
    }
});
Object.defineProperty(exports, "timeDays", {
    enumerable: true,
    get: function() {
        return _day.days;
    }
});
Object.defineProperty(exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return _week.friday;
    }
});
Object.defineProperty(exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return _week.fridays;
    }
});
Object.defineProperty(exports, "timeHour", {
    enumerable: true,
    get: function() {
        return _hour.default;
    }
});
Object.defineProperty(exports, "timeHours", {
    enumerable: true,
    get: function() {
        return _hour.hours;
    }
});
Object.defineProperty(exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return _interval.default;
    }
});
Object.defineProperty(exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return _minute.default;
    }
});
Object.defineProperty(exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return _minute.minutes;
    }
});
Object.defineProperty(exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return _week.monday;
    }
});
Object.defineProperty(exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return _week.mondays;
    }
});
Object.defineProperty(exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return _month.default;
    }
});
Object.defineProperty(exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return _month.months;
    }
});
Object.defineProperty(exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return _week.saturday;
    }
});
Object.defineProperty(exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return _week.saturdays;
    }
});
Object.defineProperty(exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return _week.thursday;
    }
});
Object.defineProperty(exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return _week.thursdays;
    }
});
Object.defineProperty(exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.timeTickInterval;
    }
});
Object.defineProperty(exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return _ticks.timeTicks;
    }
});
Object.defineProperty(exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return _week.tuesday;
    }
});
Object.defineProperty(exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return _week.tuesdays;
    }
});
Object.defineProperty(exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return _week.wednesday;
    }
});
Object.defineProperty(exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return _week.wednesdays;
    }
});
Object.defineProperty(exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeYear", {
    enumerable: true,
    get: function() {
        return _year.default;
    }
});
Object.defineProperty(exports, "timeYears", {
    enumerable: true,
    get: function() {
        return _year.years;
    }
});
Object.defineProperty(exports, "utcDay", {
    enumerable: true,
    get: function() {
        return _utcDay.default;
    }
});
Object.defineProperty(exports, "utcDays", {
    enumerable: true,
    get: function() {
        return _utcDay.utcDays;
    }
});
Object.defineProperty(exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFriday;
    }
});
Object.defineProperty(exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFridays;
    }
});
Object.defineProperty(exports, "utcHour", {
    enumerable: true,
    get: function() {
        return _utcHour.default;
    }
});
Object.defineProperty(exports, "utcHours", {
    enumerable: true,
    get: function() {
        return _utcHour.utcHours;
    }
});
Object.defineProperty(exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return _utcMinute.default;
    }
});
Object.defineProperty(exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return _utcMinute.utcMinutes;
    }
});
Object.defineProperty(exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMonday;
    }
});
Object.defineProperty(exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMondays;
    }
});
Object.defineProperty(exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return _utcMonth.default;
    }
});
Object.defineProperty(exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return _utcMonth.utcMonths;
    }
});
Object.defineProperty(exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturday;
    }
});
Object.defineProperty(exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturdays;
    }
});
Object.defineProperty(exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursday;
    }
});
Object.defineProperty(exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursdays;
    }
});
Object.defineProperty(exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.utcTickInterval;
    }
});
Object.defineProperty(exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return _ticks.utcTicks;
    }
});
Object.defineProperty(exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesday;
    }
});
Object.defineProperty(exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesdays;
    }
});
Object.defineProperty(exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesday;
    }
});
Object.defineProperty(exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesdays;
    }
});
Object.defineProperty(exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcYear", {
    enumerable: true,
    get: function() {
        return _utcYear.default;
    }
});
Object.defineProperty(exports, "utcYears", {
    enumerable: true,
    get: function() {
        return _utcYear.utcYears;
    }
});
var _interval = _interopRequireDefault(require("792c68a3f8a1926"));
var _millisecond = _interopRequireWildcard(require("2357def356bae18"));
var _second = _interopRequireWildcard(require("1c57489bc0aa2095"));
var _minute = _interopRequireWildcard(require("29ed17b274422d68"));
var _hour = _interopRequireWildcard(require("24ed79de6f4f26d"));
var _day = _interopRequireWildcard(require("82753f475a698669"));
var _week = require("a7e60f089113fd37");
var _month = _interopRequireWildcard(require("340ea3bf33812c65"));
var _year = _interopRequireWildcard(require("e014d3654a0b00fb"));
var _utcMinute = _interopRequireWildcard(require("5ff1ef18d2410f37"));
var _utcHour = _interopRequireWildcard(require("2822e085c5125d78"));
var _utcDay = _interopRequireWildcard(require("ff909be541c31c33"));
var _utcWeek = require("70b57967fcafbaa5");
var _utcMonth = _interopRequireWildcard(require("e41feff472794f13"));
var _utcYear = _interopRequireWildcard(require("9b0775a896f4b4dc"));
var _ticks = require("af413f597619bd05");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"792c68a3f8a1926":"aloPA","2357def356bae18":"4J9PN","1c57489bc0aa2095":"hO5zu","29ed17b274422d68":"fpTCZ","24ed79de6f4f26d":"3cTzB","82753f475a698669":"9VaLt","a7e60f089113fd37":"i50cv","340ea3bf33812c65":"6Tjgb","e014d3654a0b00fb":"jzptJ","5ff1ef18d2410f37":"daZNS","2822e085c5125d78":"k8NEt","ff909be541c31c33":"3hlyO","70b57967fcafbaa5":"cTmS3","e41feff472794f13":"gB2t5","9b0775a896f4b4dc":"k5kiO","af413f597619bd05":"bjSIN"}],"aloPA":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = newInterval;
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{}],"4J9PN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.milliseconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("47fef281020880de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var millisecond = (0, _interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var _default = millisecond;
exports.default = _default;
var milliseconds = millisecond.range;
exports.milliseconds = milliseconds;

},{"47fef281020880de":"aloPA"}],"hO5zu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.seconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("b059f221ba83fd2b"));
var _duration = require("4b017018381ce3ad");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var second = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * _duration.durationSecond);
}, function(start, end) {
    return (end - start) / _duration.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var _default = second;
exports.default = _default;
var seconds = second.range;
exports.seconds = seconds;

},{"b059f221ba83fd2b":"aloPA","4b017018381ce3ad":"dzgJ7"}],"dzgJ7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.durationYear = exports.durationWeek = exports.durationSecond = exports.durationMonth = exports.durationMinute = exports.durationHour = exports.durationDay = void 0;
const durationSecond = 1000;
exports.durationSecond = durationSecond;
const durationMinute = durationSecond * 60;
exports.durationMinute = durationMinute;
const durationHour = durationMinute * 60;
exports.durationHour = durationHour;
const durationDay = durationHour * 24;
exports.durationDay = durationDay;
const durationWeek = durationDay * 7;
exports.durationWeek = durationWeek;
const durationMonth = durationDay * 30;
exports.durationMonth = durationMonth;
const durationYear = durationDay * 365;
exports.durationYear = durationYear;

},{}],"fpTCZ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.minutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("5b81b309635f37c2"));
var _duration = require("52c486da961f0d2c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var minute = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var _default = minute;
exports.default = _default;
var minutes = minute.range;
exports.minutes = minutes;

},{"5b81b309635f37c2":"aloPA","52c486da961f0d2c":"dzgJ7"}],"3cTzB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hours = exports.default = void 0;
var _interval = _interopRequireDefault(require("d36c991e94b8c5d6"));
var _duration = require("b17b3dbdbc5c799e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var hour = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond - date.getMinutes() * _duration.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getHours();
});
var _default = hour;
exports.default = _default;
var hours = hour.range;
exports.hours = hours;

},{"d36c991e94b8c5d6":"aloPA","b17b3dbdbc5c799e":"dzgJ7"}],"9VaLt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.days = void 0;
var _interval = _interopRequireDefault(require("c559f97c050225d3"));
var _duration = require("93d679bd1def1b3c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var day = (0, _interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationDay, (date)=>date.getDate() - 1);
var _default = day;
exports.default = _default;
var days = day.range;
exports.days = days;

},{"c559f97c050225d3":"aloPA","93d679bd1def1b3c":"dzgJ7"}],"i50cv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wednesdays = exports.wednesday = exports.tuesdays = exports.tuesday = exports.thursdays = exports.thursday = exports.sundays = exports.sunday = exports.saturdays = exports.saturday = exports.mondays = exports.monday = exports.fridays = exports.friday = void 0;
var _interval = _interopRequireDefault(require("fb608840fab065f0"));
var _duration = require("136ded3f760de188");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function weekday(i) {
    return (0, _interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationWeek;
    });
}
var sunday = weekday(0);
exports.sunday = sunday;
var monday = weekday(1);
exports.monday = monday;
var tuesday = weekday(2);
exports.tuesday = tuesday;
var wednesday = weekday(3);
exports.wednesday = wednesday;
var thursday = weekday(4);
exports.thursday = thursday;
var friday = weekday(5);
exports.friday = friday;
var saturday = weekday(6);
exports.saturday = saturday;
var sundays = sunday.range;
exports.sundays = sundays;
var mondays = monday.range;
exports.mondays = mondays;
var tuesdays = tuesday.range;
exports.tuesdays = tuesdays;
var wednesdays = wednesday.range;
exports.wednesdays = wednesdays;
var thursdays = thursday.range;
exports.thursdays = thursdays;
var fridays = friday.range;
exports.fridays = fridays;
var saturdays = saturday.range;
exports.saturdays = saturdays;

},{"fb608840fab065f0":"aloPA","136ded3f760de188":"dzgJ7"}],"6Tjgb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.months = exports.default = void 0;
var _interval = _interopRequireDefault(require("7e198ba28f0e25de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var month = (0, _interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var _default = month;
exports.default = _default;
var months = month.range;
exports.months = months;

},{"7e198ba28f0e25de":"aloPA"}],"jzptJ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.years = exports.default = void 0;
var _interval = _interopRequireDefault(require("699a5bdfd0c77e2e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var year = (0, _interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var _default = year;
exports.default = _default;
var years = year.range;
exports.years = years;

},{"699a5bdfd0c77e2e":"aloPA"}],"daZNS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMinutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("64b6a8f5c9bd1c96"));
var _duration = require("32c01369d4e699fb");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMinute = (0, _interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var _default = utcMinute;
exports.default = _default;
var utcMinutes = utcMinute.range;
exports.utcMinutes = utcMinutes;

},{"64b6a8f5c9bd1c96":"aloPA","32c01369d4e699fb":"dzgJ7"}],"k8NEt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcHours = exports.default = void 0;
var _interval = _interopRequireDefault(require("8c74396d670977a"));
var _duration = require("6c82203e6970a1bc");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcHour = (0, _interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var _default = utcHour;
exports.default = _default;
var utcHours = utcHour.range;
exports.utcHours = utcHours;

},{"8c74396d670977a":"aloPA","6c82203e6970a1bc":"dzgJ7"}],"3hlyO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcDays = exports.default = void 0;
var _interval = _interopRequireDefault(require("1f97a562b3e12493"));
var _duration = require("4c0ac820095fab8f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcDay = (0, _interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / _duration.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var _default = utcDay;
exports.default = _default;
var utcDays = utcDay.range;
exports.utcDays = utcDays;

},{"1f97a562b3e12493":"aloPA","4c0ac820095fab8f":"dzgJ7"}],"cTmS3":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcWednesdays = exports.utcWednesday = exports.utcTuesdays = exports.utcTuesday = exports.utcThursdays = exports.utcThursday = exports.utcSundays = exports.utcSunday = exports.utcSaturdays = exports.utcSaturday = exports.utcMondays = exports.utcMonday = exports.utcFridays = exports.utcFriday = void 0;
var _interval = _interopRequireDefault(require("e95c6c72a9a72603"));
var _duration = require("b3779dea703b5e01");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function utcWeekday(i) {
    return (0, _interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / _duration.durationWeek;
    });
}
var utcSunday = utcWeekday(0);
exports.utcSunday = utcSunday;
var utcMonday = utcWeekday(1);
exports.utcMonday = utcMonday;
var utcTuesday = utcWeekday(2);
exports.utcTuesday = utcTuesday;
var utcWednesday = utcWeekday(3);
exports.utcWednesday = utcWednesday;
var utcThursday = utcWeekday(4);
exports.utcThursday = utcThursday;
var utcFriday = utcWeekday(5);
exports.utcFriday = utcFriday;
var utcSaturday = utcWeekday(6);
exports.utcSaturday = utcSaturday;
var utcSundays = utcSunday.range;
exports.utcSundays = utcSundays;
var utcMondays = utcMonday.range;
exports.utcMondays = utcMondays;
var utcTuesdays = utcTuesday.range;
exports.utcTuesdays = utcTuesdays;
var utcWednesdays = utcWednesday.range;
exports.utcWednesdays = utcWednesdays;
var utcThursdays = utcThursday.range;
exports.utcThursdays = utcThursdays;
var utcFridays = utcFriday.range;
exports.utcFridays = utcFridays;
var utcSaturdays = utcSaturday.range;
exports.utcSaturdays = utcSaturdays;

},{"e95c6c72a9a72603":"aloPA","b3779dea703b5e01":"dzgJ7"}],"gB2t5":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMonths = exports.default = void 0;
var _interval = _interopRequireDefault(require("9fc54a6c7da64a87"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMonth = (0, _interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var _default = utcMonth;
exports.default = _default;
var utcMonths = utcMonth.range;
exports.utcMonths = utcMonths;

},{"9fc54a6c7da64a87":"aloPA"}],"k5kiO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcYears = exports.default = void 0;
var _interval = _interopRequireDefault(require("8be30e72f54134d4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcYear = (0, _interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var _default = utcYear;
exports.default = _default;
var utcYears = utcYear.range;
exports.utcYears = utcYears;

},{"8be30e72f54134d4":"aloPA"}],"bjSIN":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcTicks = exports.utcTickInterval = exports.timeTicks = exports.timeTickInterval = void 0;
var _index = require("d7f21fd662cddf99");
var _duration = require("aa18ef34c0be11bc");
var _millisecond = _interopRequireDefault(require("dac51414a1e8276b"));
var _second = _interopRequireDefault(require("d68afea8416c3f1a"));
var _minute = _interopRequireDefault(require("404a139d621a9db2"));
var _hour = _interopRequireDefault(require("9a0bf4314f401b0c"));
var _day = _interopRequireDefault(require("3f04924c68533af9"));
var _week = require("b2b29cfa1ce6c7da");
var _month = _interopRequireDefault(require("5ceb61e7c9c807ec"));
var _year = _interopRequireDefault(require("dd0ef245ed62fdbf"));
var _utcMinute = _interopRequireDefault(require("1e46f3d232f79e5e"));
var _utcHour = _interopRequireDefault(require("3d1ae5dfacd220b4"));
var _utcDay = _interopRequireDefault(require("5fb1b56afb7033e1"));
var _utcWeek = require("536323b8c7eb14e3");
var _utcMonth = _interopRequireDefault(require("856c2c54a9da13b6"));
var _utcYear = _interopRequireDefault(require("f5ebb8abb03b9dec"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            _second.default,
            1,
            _duration.durationSecond
        ],
        [
            _second.default,
            5,
            5 * _duration.durationSecond
        ],
        [
            _second.default,
            15,
            15 * _duration.durationSecond
        ],
        [
            _second.default,
            30,
            30 * _duration.durationSecond
        ],
        [
            minute,
            1,
            _duration.durationMinute
        ],
        [
            minute,
            5,
            5 * _duration.durationMinute
        ],
        [
            minute,
            15,
            15 * _duration.durationMinute
        ],
        [
            minute,
            30,
            30 * _duration.durationMinute
        ],
        [
            hour,
            1,
            _duration.durationHour
        ],
        [
            hour,
            3,
            3 * _duration.durationHour
        ],
        [
            hour,
            6,
            6 * _duration.durationHour
        ],
        [
            hour,
            12,
            12 * _duration.durationHour
        ],
        [
            day,
            1,
            _duration.durationDay
        ],
        [
            day,
            2,
            2 * _duration.durationDay
        ],
        [
            week,
            1,
            _duration.durationWeek
        ],
        [
            month,
            1,
            _duration.durationMonth
        ],
        [
            month,
            3,
            3 * _duration.durationMonth
        ],
        [
            year,
            1,
            _duration.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _index.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _index.tickStep)(start / _duration.durationYear, stop / _duration.durationYear, count));
        if (i === 0) return _millisecond.default.every(Math.max((0, _index.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker(_utcYear.default, _utcMonth.default, _utcWeek.utcSunday, _utcDay.default, _utcHour.default, _utcMinute.default);
exports.utcTickInterval = utcTickInterval;
exports.utcTicks = utcTicks;
const [timeTicks, timeTickInterval] = ticker(_year.default, _month.default, _week.sunday, _day.default, _hour.default, _minute.default);
exports.timeTickInterval = timeTickInterval;
exports.timeTicks = timeTicks;

},{"d7f21fd662cddf99":"eYjUM","aa18ef34c0be11bc":"dzgJ7","dac51414a1e8276b":"4J9PN","d68afea8416c3f1a":"hO5zu","404a139d621a9db2":"fpTCZ","9a0bf4314f401b0c":"3cTzB","3f04924c68533af9":"9VaLt","b2b29cfa1ce6c7da":"i50cv","5ceb61e7c9c807ec":"6Tjgb","dd0ef245ed62fdbf":"jzptJ","1e46f3d232f79e5e":"daZNS","3d1ae5dfacd220b4":"k8NEt","5fb1b56afb7033e1":"3hlyO","536323b8c7eb14e3":"cTmS3","856c2c54a9da13b6":"gB2t5","f5ebb8abb03b9dec":"k5kiO"}],"bNofk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return _isoFormat.default;
    }
});
Object.defineProperty(exports, "isoParse", {
    enumerable: true,
    get: function() {
        return _isoParse.default;
    }
});
Object.defineProperty(exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeFormat;
    }
});
Object.defineProperty(exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "timeParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeParse;
    }
});
Object.defineProperty(exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcFormat;
    }
});
Object.defineProperty(exports, "utcParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcParse;
    }
});
var _defaultLocale = _interopRequireWildcard(require("e254c805352cbe79"));
var _locale = _interopRequireDefault(require("a2049a4646cad099"));
var _isoFormat = _interopRequireDefault(require("8485f996f4dff29b"));
var _isoParse = _interopRequireDefault(require("e2c3ab8c9c293ff5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

},{"e254c805352cbe79":"lgIRb","a2049a4646cad099":"i2yUL","8485f996f4dff29b":"dOJ6v","e2c3ab8c9c293ff5":"1q8W1"}],"lgIRb":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.utcParse = exports.utcFormat = exports.timeParse = exports.timeFormat = void 0;
var _locale = _interopRequireDefault(require("8c8d5f4601afc09e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var timeFormat;
exports.timeFormat = timeFormat;
var timeParse;
exports.timeParse = timeParse;
var utcFormat;
exports.utcFormat = utcFormat;
var utcParse;
exports.utcParse = utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.timeFormat = timeFormat = locale.format;
    exports.timeParse = timeParse = locale.parse;
    exports.utcFormat = utcFormat = locale.utcFormat;
    exports.utcParse = utcParse = locale.utcParse;
    return locale;
}

},{"8c8d5f4601afc09e":"i2yUL"}],"i2yUL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatLocale;
var _index = require("da76bc1e0eef4658");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? _index.utcMonday.ceil(week) : (0, _index.utcMonday)(week);
                    week = _index.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? _index.timeMonday.ceil(week) : (0, _index.timeMonday)(week);
                    week = _index.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            } // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, // note: ignores next directive
percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + _index.timeDay.count((0, _index.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad(_index.timeSunday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad(_index.timeThursday.count((0, _index.timeYear)(d), d) + ((0, _index.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad(_index.timeMonday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + _index.utcDay.count((0, _index.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad(_index.utcSunday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad(_index.utcThursday.count((0, _index.utcYear)(d), d) + ((0, _index.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad(_index.utcMonday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"da76bc1e0eef4658":"fg6u5"}],"dOJ6v":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isoSpecifier = exports.default = void 0;
var _defaultLocale = require("2f8f6a7c55a265a7");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
exports.isoSpecifier = isoSpecifier;
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale.utcFormat)(isoSpecifier);
var _default = formatIso;
exports.default = _default;

},{"2f8f6a7c55a265a7":"lgIRb"}],"1q8W1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isoFormat = require("c9c0e033b3f4cd7a");
var _defaultLocale = require("717272dfdfdf9f58");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
var _default = parseIso;
exports.default = _default;

},{"c9c0e033b3f4cd7a":"dOJ6v","717272dfdfdf9f58":"lgIRb"}],"2qxfq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = utcTime;
var _index = require("ea22621463423769");
var _index2 = require("df08fa54879bdddf");
var _time = require("3d474b4ac409608e");
var _init = require("f5277d460a04562a");
function utcTime() {
    return _init.initRange.apply((0, _time.calendar)(_index.utcTicks, _index.utcTickInterval, _index.utcYear, _index.utcMonth, _index.utcWeek, _index.utcDay, _index.utcHour, _index.utcMinute, _index.utcSecond, _index2.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"ea22621463423769":"fg6u5","df08fa54879bdddf":"bNofk","3d474b4ac409608e":"1x5us","f5277d460a04562a":"Seiq9"}],"eYiC7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = sequential;
exports.sequentialLog = sequentialLog;
exports.sequentialPow = sequentialPow;
exports.sequentialSqrt = sequentialSqrt;
exports.sequentialSymlog = sequentialSymlog;
var _index = require("576a63ed61017ad0");
var _continuous = require("367c19cf7640115e");
var _init = require("4d9ecd8e312987f2");
var _linear = require("7aa8dc079711aa38");
var _log = require("9675a35c284dba6f");
var _symlog = require("e5e6e98809c25bc3");
var _pow = require("814ae7ed84550652");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = _continuous.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"576a63ed61017ad0":"2qco8","367c19cf7640115e":"kaFZ5","4d9ecd8e312987f2":"Seiq9","7aa8dc079711aa38":"4UkXL","9675a35c284dba6f":"colCi","e5e6e98809c25bc3":"8NIsN","814ae7ed84550652":"4wDg3"}],"1lSf8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sequentialQuantile;
var _index = require("eed0055976263d50");
var _continuous = require("21618a239c62366b");
var _init = require("92ad1cf8524c146");
function sequentialQuantile() {
    var domain = [], interpolator = _continuous.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _index.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _index.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return _init.initInterpolator.apply(scale, arguments);
}

},{"eed0055976263d50":"eYjUM","21618a239c62366b":"kaFZ5","92ad1cf8524c146":"Seiq9"}],"b6etx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diverging;
exports.divergingLog = divergingLog;
exports.divergingPow = divergingPow;
exports.divergingSqrt = divergingSqrt;
exports.divergingSymlog = divergingSymlog;
var _index = require("915e51d9b913a910");
var _continuous = require("bf6a55aee26f6305");
var _init = require("dafbeaec64c427e8");
var _linear = require("367c88af554f4c81");
var _log = require("f1b41897387bed31");
var _sequential = require("478631d13f9292c0");
var _symlog = require("f1514783e2b3953d");
var _pow = require("2cbbbabc7f04bb29");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = _continuous.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _index.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return (0, _sequential.copy)(scale, diverging());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"915e51d9b913a910":"2qco8","bf6a55aee26f6305":"kaFZ5","dafbeaec64c427e8":"Seiq9","367c88af554f4c81":"4UkXL","f1b41897387bed31":"colCi","478631d13f9292c0":"eYiC7","f1514783e2b3953d":"8NIsN","2cbbbabc7f04bb29":"4wDg3"}],"dSrfR":[function(require,module,exports) {
var baseExtremum = require("c7d87741ab4129b0"), baseGt = require("dbeef59341d150f4"), identity = require("3c95c3c9fbe3850f");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function max(array) {
    return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
}
module.exports = max;

},{"c7d87741ab4129b0":"1Vacs","dbeef59341d150f4":"9iS5h","3c95c3c9fbe3850f":"aaqsH"}],"1Vacs":[function(require,module,exports) {
var isSymbol = require("6a2d056d200c4854");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = baseExtremum;

},{"6a2d056d200c4854":"5cADF"}],"9iS5h":[function(require,module,exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function baseGt(value, other) {
    return value > other;
}
module.exports = baseGt;

},{}],"jUDqe":[function(require,module,exports) {
var baseExtremum = require("122393f3e0d791dc"), baseLt = require("8122a719ac68b5c4"), identity = require("3161b76b624de11a");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function min(array) {
    return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
}
module.exports = min;

},{"122393f3e0d791dc":"1Vacs","8122a719ac68b5c4":"gX7Ao","3161b76b624de11a":"aaqsH"}],"gX7Ao":[function(require,module,exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function baseLt(value, other) {
    return value < other;
}
module.exports = baseLt;

},{}],"iJi7N":[function(require,module,exports) {
var baseFlatten = require("727a074274bef45"), map = require("19e2d816e1d885f8");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function flatMap(collection, iteratee) {
    return baseFlatten(map(collection, iteratee), 1);
}
module.exports = flatMap;

},{"727a074274bef45":"1hqBq","19e2d816e1d885f8":"263xR"}],"263xR":[function(require,module,exports) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"2fndP","8bad46685c8864d":"5rKNq","51c76ab24fdb66f9":"eTgyt","7cb4cacc4dea406c":"8PiWS"}],"hga42":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"hErvR"}],"frU7C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTickValues", ()=>(0, _getNiceTickValues.getTickValues));
parcelHelpers.export(exports, "getNiceTickValues", ()=>(0, _getNiceTickValues.getNiceTickValues));
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>(0, _getNiceTickValues.getTickValuesFixedDomain));
var _getNiceTickValues = require("./getNiceTickValues");

},{"./getNiceTickValues":"6k0Cu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6k0Cu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNiceTickValues", ()=>getNiceTickValues);
parcelHelpers.export(exports, "getTickValues", ()=>getTickValues);
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>getTickValuesFixedDomain);
/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./util/utils");
var _arithmetic = require("./util/arithmetic");
var _arithmeticDefault = parcelHelpers.interopDefault(_arithmetic);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function getValidInterval(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, _decimalJsLightDefault.default)(0);
    var digitCount = (0, _arithmeticDefault.default).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, _decimalJsLightDefault.default)(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, _decimalJsLightDefault.default)(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, _decimalJsLightDefault.default)(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, _decimalJsLightDefault.default)(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, _decimalJsLightDefault.default)(10).pow((0, _arithmeticDefault.default).getDigitCount(value) - 1);
            middle = new (0, _decimalJsLightDefault.default)(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    } else if (value === 0) middle = new (0, _decimalJsLightDefault.default)(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return middle.add(new (0, _decimalJsLightDefault.default)(n - middleIndex).mul(step)).toNumber();
    }), (0, _utils.range));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, _decimalJsLightDefault.default)(0),
        tickMin: new (0, _decimalJsLightDefault.default)(0),
        tickMax: new (0, _decimalJsLightDefault.default)(0)
    };
     // The step which is easy to understand between two ticks
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, _decimalJsLightDefault.default)(0);
    else {
        // calculate the middle value
        middle = new (0, _decimalJsLightDefault.default)(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, _decimalJsLightDefault.default)(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, _decimalJsLightDefault.default)(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, _decimalJsLightDefault.default)(belowCount).mul(step)),
        tickMax: middle.add(new (0, _decimalJsLightDefault.default)(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getNiceTickValuesFn(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = getValidInterval([
        min,
        max
    ]), _getValidInterval2 = _slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, _utils.reverse)(_values) : _values;
    }
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, _arithmeticDefault.default).rangeStep(tickMin, tickMax.add(new (0, _decimalJsLightDefault.default)(0.1).mul(step)), step);
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFn(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = getValidInterval([
        min,
        max
    ]), _getValidInterval4 = _slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, _utils.compose)((0, _utils.map)(function(n) {
        return new (0, _decimalJsLightDefault.default)(cormin).add(new (0, _decimalJsLightDefault.default)(n).mul(step)).toNumber();
    }), (0, _utils.range));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, _utils.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = _slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = getValidInterval([
        min,
        max
    ]), _getValidInterval6 = _slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat(_toConsumableArray((0, _arithmeticDefault.default).rangeStep(new (0, _decimalJsLightDefault.default)(cormin), new (0, _decimalJsLightDefault.default)(cormax).sub(new (0, _decimalJsLightDefault.default)(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, _utils.reverse)(values) : values;
}
var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
var getTickValues = (0, _utils.memoize)(getTickValuesFn);
var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

},{"decimal.js-light":"9L5hO","./util/utils":"gqfYx","./util/arithmetic":"f51UN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9L5hO":[function(require,module,exports) {
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})(this);

},{}],"gqfYx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLACE_HOLDER", ()=>PLACE_HOLDER);
parcelHelpers.export(exports, "curry", ()=>curry);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "memoize", ()=>memoize);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var identity = function identity(i) {
    return i;
};
var PLACE_HOLDER = {
    "@@functional/placeholder": true
};
var isPlaceHolder = function isPlaceHolder(val) {
    return val === PLACE_HOLDER;
};
var curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== PLACE_HOLDER;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var curry = function curry(fn) {
    return curryN(fn.length, fn);
};
var range = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var map = curry(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var compose = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var reverse = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var memoize = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f51UN":[function(require,module,exports) {
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./utils");
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, _decimalJsLightDefault.default)(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function rangeStep(start, end, step) {
    var num = new (0, _decimalJsLightDefault.default)(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var interpolateNumber = (0, _utils.curry)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var uninterpolateNumber = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var uninterpolateTruncation = (0, _utils.curry)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
exports.default = {
    rangeStep: rangeStep,
    getDigitCount: getDigitCount,
    interpolateNumber: interpolateNumber,
    uninterpolateNumber: uninterpolateNumber,
    uninterpolateTruncation: uninterpolateTruncation
};

},{"decimal.js-light":"9L5hO","./utils":"gqfYx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fppsY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBar", ()=>ErrorBar);
/**
 * @fileOverview Render a group of error bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ErrorBar(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = _objectWithoutProperties(props, _excluded);
    var svgProps = (0, _reactUtils.filterProps)(others, false);
    !!(props.direction === "x" && xAxis.type !== "number") && (0, _tinyInvariantDefault.default)(false);
    var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = _slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === "vertical") {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === "horizontal") {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
            className: "recharts-errorBar",
            key: "bar-".concat(lineCoordinates.map(function(c) {
                return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
            }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, coordinates, {
                key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
            }));
        }));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-errorBars"
    }, errorBars);
}
ErrorBar.defaultProps = {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
};
ErrorBar.displayName = "ErrorBar";

},{"react":"BK2ob","tiny-invariant":"5dVKl","../container/Layer":"eHeGW","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5dVKl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7zpDK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLegendProps", ()=>getLegendProps);
var _legend = require("../component/Legend");
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getLegendProps = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: (0, _chartUtils.getMainColorOfGraphicItem)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return _objectSpread(_objectSpread(_objectSpread({}, legendItem.props), (0, _legend.Legend).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};

},{"../component/Legend":"56zvs","./ChartUtils":"eYWT4","./ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gAcsH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LabelList", ()=>LabelList);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _last = require("lodash/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _label = require("./Label");
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "valueAccessor"
], _excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, _lastDefault.default)(entry.value) : entry.value;
};
function LabelList(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor, restProps = _objectWithoutProperties(_ref, _excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = _objectWithoutProperties(restProps, _excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, _isNilDefault.default)(dataKey) ? valueAccessor(entry, index) : (0, _chartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
        var idProps = (0, _isNilDefault.default)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _label.Label), _extends({}, (0, _reactUtils.filterProps)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, _label.Label).parseViewBox((0, _isNilDefault.default)(clockWise) ? entry : _objectSpread(_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
LabelList.displayName = "LabelList";
function parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label) || (0, _isFunctionDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, _isObjectDefault.default)(label)) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabelList, _extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, _reactUtils.findAllByType)(children, LabelList).map(function(child, index) {
        return /*#__PURE__*/ (0, _react.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat(_toConsumableArray(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent;

},{"react":"BK2ob","lodash/isNil":"4xNOq","lodash/isObject":"lgjQC","lodash/isFunction":"56sPA","lodash/last":"4za7L","./Label":"cIQWL","../container/Layer":"eHeGW","../util/ReactUtils":"56rQC","../util/ChartUtils":"eYWT4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4za7L":[function(require,module,exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"bmghA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sector", ()=>Sector);
/**
 * @fileOverview Sector
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, _polarUtils.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, _polarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, _polarUtils.RADIAN)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var _getTangentCircle = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var Sector = function Sector(sectorProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, _clsxDefault.default)("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, _dataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};

},{"react":"BK2ob","clsx":"bGtJT","../util/ReactUtils":"56rQC","../util/PolarUtils":"iSQPa","../util/DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"63XKr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "Curve", ()=>Curve);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _d3Shape = require("victory-vendor/d3-shape");
var _upperFirst = require("lodash/upperFirst");
var _upperFirstDefault = parcelHelpers.interopDefault(_upperFirst);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CURVE_FACTORIES = {
    curveBasisClosed: (0, _d3Shape.curveBasisClosed),
    curveBasisOpen: (0, _d3Shape.curveBasisOpen),
    curveBasis: (0, _d3Shape.curveBasis),
    curveBumpX: (0, _d3Shape.curveBumpX),
    curveBumpY: (0, _d3Shape.curveBumpY),
    curveLinearClosed: (0, _d3Shape.curveLinearClosed),
    curveLinear: (0, _d3Shape.curveLinear),
    curveMonotoneX: (0, _d3Shape.curveMonotoneX),
    curveMonotoneY: (0, _d3Shape.curveMonotoneY),
    curveNatural: (0, _d3Shape.curveNatural),
    curveStep: (0, _d3Shape.curveStep),
    curveStepAfter: (0, _d3Shape.curveStepAfter),
    curveStepBefore: (0, _d3Shape.curveStepBefore)
};
var defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
    return p.x;
};
var getY = function getY(p) {
    return p.y;
};
var getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, _isFunctionDefault.default)(type)) return type;
    var name = "curve".concat((0, _upperFirstDefault.default)(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return CURVE_FACTORIES[name] || (0, _d3Shape.curveLinear);
};
var getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return _objectSpread(_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
    else if ((0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
    else lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var Curve = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? getPath(props) : path;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, false), (0, _types.adaptEventHandlers)(props), {
        className: (0, _clsxDefault.default)("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};

},{"react":"BK2ob","victory-vendor/d3-shape":"ccJ5o","lodash/upperFirst":"ko2wy","lodash/isFunction":"56sPA","clsx":"bGtJT","../util/types":"73B4U","../util/ReactUtils":"56rQC","../util/DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hrVg4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInRectangle", ()=>isInRectangle);
parcelHelpers.export(exports, "Rectangle", ()=>Rectangle);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var isInRectangle = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var Rectangle = function Rectangle(rectangleProps) {
    var props = _objectSpread(_objectSpread({}, defaultProps), rectangleProps);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: layerClass,
        d: getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
            className: layerClass,
            d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};

},{"react":"BK2ob","clsx":"bGtJT","react-smooth":"apDr4","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"apDr4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configSpring", ()=>(0, _easing.configSpring));
parcelHelpers.export(exports, "configBezier", ()=>(0, _easing.configBezier));
parcelHelpers.export(exports, "AnimateGroup", ()=>(0, _animateGroupDefault.default));
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _easing = require("./easing");
var _animateGroup = require("./AnimateGroup");
var _animateGroupDefault = parcelHelpers.interopDefault(_animateGroup);
exports.default = (0, _animateDefault.default);

},{"./Animate":"l7kiW","./easing":"55HLe","./AnimateGroup":"fq8Pk","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"l7kiW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _fastEquals = require("fast-equals");
var _animateManager = require("./AnimateManager");
var _animateManagerDefault = parcelHelpers.interopDefault(_animateManager);
var _easing = require("./easing");
var _configUpdate = require("./configUpdate");
var _configUpdateDefault = parcelHelpers.interopDefault(_configUpdate);
var _util = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var Animate = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Animate, _PureComponent);
    var _super = _createSuper(Animate);
    function Animate(props, context) {
        var _this;
        _classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return _possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return _possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? _defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    _createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? _defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, _fastEquals.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? _defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation(_objectSpread(_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, _configUpdateDefault.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat(_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, _util.getTransitionVal)(properties, duration, easing);
                    var newStyle = _objectSpread(_objectSpread(_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat(_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, _util.identity));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat(_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, _animateManagerDefault.default)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    _objectSpread(_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = _objectWithoutProperties(_this$props4, _excluded);
                var count = (0, _react.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, _react.cloneElement)(container, _objectSpread(_objectSpread({}, others), {}, {
                        style: _objectSpread(_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, _react.Children).only(children));
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, (0, _react.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, _react.PureComponent));
Animate.displayName = "Animate";
Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
Animate.propTypes = {
    from: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    to: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).string
    ]),
    attributeName: (0, _propTypesDefault.default).string,
    // animation duration
    duration: (0, _propTypesDefault.default).number,
    begin: (0, _propTypesDefault.default).number,
    easing: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    steps: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        duration: (0, _propTypesDefault.default).number.isRequired,
        style: (0, _propTypesDefault.default).object.isRequired,
        easing: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, _propTypesDefault.default).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, _propTypesDefault.default).arrayOf("string"),
        onAnimationEnd: (0, _propTypesDefault.default).func
    })),
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    isActive: (0, _propTypesDefault.default).bool,
    canBegin: (0, _propTypesDefault.default).bool,
    onAnimationEnd: (0, _propTypesDefault.default).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, _propTypesDefault.default).bool,
    onAnimationStart: (0, _propTypesDefault.default).func,
    onAnimationReStart: (0, _propTypesDefault.default).func
};
exports.default = Animate;

},{"react":"BK2ob","prop-types":"hRUel","fast-equals":"klZX2","./AnimateManager":"1VtVC","./easing":"55HLe","./configUpdate":"iwaD6","./util":"6fd9P","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"klZX2":[function(require,module,exports) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});

},{}],"1VtVC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createAnimateManager);
var _setRafTimeout = require("./setRafTimeout");
var _setRafTimeoutDefault = parcelHelpers.interopDefault(_setRafTimeout);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function createAnimateManager() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = _toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, _setRafTimeoutDefault.default)(setStyle.bind(null, restStyles));
            return;
        }
        if (_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}

},{"./setRafTimeout":"5vqVY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5vqVY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRafTimeout);
function safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"55HLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configBezier", ()=>configBezier);
parcelHelpers.export(exports, "configSpring", ()=>configSpring);
parcelHelpers.export(exports, "configEasing", ()=>configEasing);
var _util = require("./util");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        return multyTime(params, t);
    };
};
var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = cubicBezierFactor(c1, c2);
        var newParams = [].concat(_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return multyTime(newParams, t);
    };
};
var configBezier = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, _util.warn)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, _util.warn)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = cubicBezier(x1, x2);
    var curveY = cubicBezier(y1, y2);
    var derCurveX = derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var configSpring = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var configEasing = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return configBezier(easing);
        case "spring":
            return configSpring();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return configBezier(easing);
            (0, _util.warn)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, _util.warn)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};

},{"./util":"6fd9P","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6fd9P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntersectionKeys", ()=>getIntersectionKeys);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "getDashCase", ()=>getDashCase);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "debug", ()=>debug);
parcelHelpers.export(exports, "debugf", ()=>debugf);
parcelHelpers.export(exports, "mapObject", ()=>mapObject);
parcelHelpers.export(exports, "getTransitionVal", ()=>getTransitionVal);
parcelHelpers.export(exports, "warn", ()=>warn);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var identity = function identity(param) {
    return param;
};
var getDashCase = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var log = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var debug = function debug(name) {
    return function(item) {
        log(name, item);
        return item;
    };
};
var debugf = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var mapObject = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var isDev = false;
var warn = function warn(condition, format, a, b, c, d, e, f) {
    if (isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iwaD6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = _slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return _objectSpread(_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, _util.mapObject)(function(key, val) {
        if (needContinue(val)) return _objectSpread(_objectSpread({}, val), {}, {
            velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
// configure update function
exports.default = function(from, to, easing, duration, render) {
    var interKeys = (0, _util.getIntersectionKeys)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, _util.mapObject)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter(needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, _util.mapObject)(function(key, val) {
            return alpha.apply(void 0, _toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, _util.mapObject)(function(key, val) {
                return alpha.apply(void 0, _toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render(_objectSpread(_objectSpread(_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};

},{"./util":"6fd9P","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fq8Pk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _animateGroupChild = require("./AnimateGroupChild");
var _animateGroupChildDefault = parcelHelpers.interopDefault(_animateGroupChild);
function AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.TransitionGroup), {
        component: component
    }, (0, _react.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _animateGroupChildDefault.default), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
AnimateGroup.propTypes = {
    appear: (0, _propTypesDefault.default).object,
    enter: (0, _propTypesDefault.default).object,
    leave: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).element
    ]),
    component: (0, _propTypesDefault.default).any
};
AnimateGroup.defaultProps = {
    component: "span"
};
exports.default = AnimateGroup;

},{"react":"BK2ob","react-transition-group":"j8hjZ","prop-types":"hRUel","./AnimateGroupChild":"cLc5v","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cLc5v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTransitionGroup = require("react-transition-group");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _animate = require("./Animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    _inherits(AnimateGroupChild, _Component);
    var _super = _createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        _classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        _defineProperty(_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        _defineProperty(_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    _createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState(_objectSpread(_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = _objectWithoutProperties(_this$props3, _excluded);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTransitionGroup.Transition), _extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _animateDefault.default), _this2.state, (0, _react.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, _react.Component));
AnimateGroupChild.propTypes = {
    appearOptions: (0, _propTypesDefault.default).object,
    enterOptions: (0, _propTypesDefault.default).object,
    leaveOptions: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).element
};
exports.default = AnimateGroupChild;

},{"react":"BK2ob","react-transition-group":"j8hjZ","prop-types":"hRUel","./Animate":"l7kiW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fqbWG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Polygon", ()=>Polygon);
/**
 * @fileOverview Polygon
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "points",
    "className",
    "baseLinePoints",
    "connectNulls"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var isValidatePoint = function isValidatePoint(point) {
    return point && point.x === +point.x && point.y === +point.y;
};
var getParsedPoints = function getParsedPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var segmentPoints = [
        []
    ];
    points.forEach(function(entry) {
        if (isValidatePoint(entry)) segmentPoints[segmentPoints.length - 1].push(entry);
        else if (segmentPoints[segmentPoints.length - 1].length > 0) // add another path
        segmentPoints.push([]);
    });
    if (isValidatePoint(points[0])) segmentPoints[segmentPoints.length - 1].push(points[0]);
    if (segmentPoints[segmentPoints.length - 1].length <= 0) segmentPoints = segmentPoints.slice(0, -1);
    return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
    var segmentPoints = getParsedPoints(points);
    if (connectNulls) segmentPoints = [
        segmentPoints.reduce(function(res, segPoints) {
            return [].concat(_toConsumableArray(res), _toConsumableArray(segPoints));
        }, [])
    ];
    var polygonPath = segmentPoints.map(function(segPoints) {
        return segPoints.reduce(function(path, point, index) {
            return "".concat(path).concat(index === 0 ? "M" : "L").concat(point.x, ",").concat(point.y);
        }, "");
    }).join("");
    return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
    var outerPath = getSinglePolygonPath(points, connectNulls);
    return "".concat(outerPath.slice(-1) === "Z" ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
var Polygon = function Polygon(props) {
    var points = props.points, className = props.className, baseLinePoints = props.baseLinePoints, connectNulls = props.connectNulls, others = _objectWithoutProperties(props, _excluded);
    if (!points || !points.length) return null;
    var layerClass = (0, _clsxDefault.default)("recharts-polygon", className);
    if (baseLinePoints && baseLinePoints.length) {
        var hasStroke = others.stroke && others.stroke !== "none";
        var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
            className: layerClass
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: rangePath.slice(-1) === "Z" ? others.fill : "none",
            stroke: "none",
            d: rangePath
        })), hasStroke ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: "none",
            d: getSinglePolygonPath(points, connectNulls)
        })) : null, hasStroke ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
            fill: "none",
            d: getSinglePolygonPath(baseLinePoints, connectNulls)
        })) : null);
    }
    var singlePath = getSinglePolygonPath(points, connectNulls);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(others, true), {
        fill: singlePath.slice(-1) === "Z" ? others.fill : "none",
        className: layerClass,
        d: singlePath
    }));
};

},{"react":"BK2ob","clsx":"bGtJT","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jRGax":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dot", ()=>Dot);
/**
 * @fileOverview Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var Dot = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, _clsxDefault.default)("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", _extends({}, (0, _reactUtils.filterProps)(props, false), (0, _types.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

},{"react":"BK2ob","clsx":"bGtJT","../util/types":"73B4U","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"beK47":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cross", ()=>Cross);
/**
 * @fileOverview Cross
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var Cross = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || !(0, _dataUtils.isNumber)(top) || !(0, _dataUtils.isNumber)(left)) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(props, true), {
        className: (0, _clsxDefault.default)("recharts-cross", className),
        d: getPath(x, y, width, height, top, left)
    }));
};

},{"react":"BK2ob","clsx":"bGtJT","../util/DataUtils":"kHJdD","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6wvEW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarRadiusAxis", ()=>PolarRadiusAxis);
/**
 * @fileOverview The axis of polar coordinate system
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _maxBy = require("lodash/maxBy");
var _maxByDefault = parcelHelpers.interopDefault(_maxBy);
var _minBy = require("lodash/minBy");
var _minByDefault = parcelHelpers.interopDefault(_minBy);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _text = require("../component/Text");
var _label = require("../component/Label");
var _layer = require("../container/Layer");
var _polarUtils = require("../util/PolarUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _excluded = [
    "cx",
    "cy",
    "angle",
    "ticks",
    "axisLine"
], _excluded2 = [
    "ticks",
    "tick",
    "angle",
    "tickFormatter",
    "stroke"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var PolarRadiusAxis = /*#__PURE__*/ function(_PureComponent) {
    _inherits(PolarRadiusAxis, _PureComponent);
    function PolarRadiusAxis() {
        _classCallCheck(this, PolarRadiusAxis);
        return _callSuper(this, PolarRadiusAxis, arguments);
    }
    _createClass(PolarRadiusAxis, [
        {
            key: "getTickValueCoord",
            value: /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */ function getTickValueCoord(_ref) {
                var coordinate = _ref.coordinate;
                var _this$props = this.props, angle = _this$props.angle, cx = _this$props.cx, cy = _this$props.cy;
                return (0, _polarUtils.polarToCartesian)(cx, cy, coordinate, angle);
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var orientation = this.props.orientation;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = "end";
                        break;
                    case "right":
                        textAnchor = "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getViewBox",
            value: function getViewBox() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, angle = _this$props2.angle, ticks = _this$props2.ticks;
                var maxRadiusTick = (0, _maxByDefault.default)(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                var minRadiusTick = (0, _minByDefault.default)(ticks, function(entry) {
                    return entry.coordinate || 0;
                });
                return {
                    cx: cx,
                    cy: cy,
                    startAngle: angle,
                    endAngle: angle,
                    innerRadius: minRadiusTick.coordinate || 0,
                    outerRadius: maxRadiusTick.coordinate || 0
                };
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props3 = this.props, cx = _this$props3.cx, cy = _this$props3.cy, angle = _this$props3.angle, ticks = _this$props3.ticks, axisLine = _this$props3.axisLine, others = _objectWithoutProperties(_this$props3, _excluded);
                var extent = ticks.reduce(function(result, entry) {
                    return [
                        Math.min(result[0], entry.coordinate),
                        Math.max(result[1], entry.coordinate)
                    ];
                }, [
                    Infinity,
                    -Infinity
                ]);
                var point0 = (0, _polarUtils.polarToCartesian)(cx, cy, extent[0], angle);
                var point1 = (0, _polarUtils.polarToCartesian)(cx, cy, extent[1], angle);
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(others, false)), {}, {
                    fill: "none"
                }, (0, _reactUtils.filterProps)(axisLine, false)), {}, {
                    x1: point0.x,
                    y1: point0.y,
                    x2: point1.x,
                    y2: point1.y
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
                    className: "recharts-polar-radius-axis-line"
                }, props));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props4 = this.props, ticks = _this$props4.ticks, tick = _this$props4.tick, angle = _this$props4.angle, tickFormatter = _this$props4.tickFormatter, stroke = _this$props4.stroke, others = _objectWithoutProperties(_this$props4, _excluded2);
                var textAnchor = this.getTickTextAnchor();
                var axisProps = (0, _reactUtils.filterProps)(others, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var items = ticks.map(function(entry, i) {
                    var coord = _this.getTickValueCoord(entry);
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i
                    }, coord), {}, {
                        payload: entry
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: (0, _clsxDefault.default)("recharts-polar-radius-axis-tick", (0, _polarUtils.getTickClassName)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-polar-radius-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props5 = this.props, ticks = _this$props5.ticks, axisLine = _this$props5.axisLine, tick = _this$props5.tick;
                if (!ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)("recharts-polar-radius-axis", this.props.className)
                }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), (0, _label.Label).renderCallByParent(this.props, this.getViewBox()));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-polar-radius-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarRadiusAxis;
}((0, _react.PureComponent));
_defineProperty(PolarRadiusAxis, "displayName", "PolarRadiusAxis");
_defineProperty(PolarRadiusAxis, "axisType", "radiusAxis");
_defineProperty(PolarRadiusAxis, "defaultProps", {
    type: "number",
    radiusAxisId: 0,
    cx: 0,
    cy: 0,
    angle: 0,
    orientation: "right",
    stroke: "#ccc",
    axisLine: true,
    tick: true,
    tickCount: 5,
    allowDataOverflow: false,
    scale: "auto",
    allowDuplicatedCategory: true
});

},{"react":"BK2ob","lodash/maxBy":"6LomG","lodash/minBy":"3fYsy","lodash/isFunction":"56sPA","clsx":"bGtJT","../component/Text":"8RJoX","../component/Label":"cIQWL","../container/Layer":"eHeGW","../util/PolarUtils":"iSQPa","../util/types":"73B4U","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6LomG":[function(require,module,exports) {
var baseExtremum = require("dba025d59f90321a"), baseGt = require("d445a3f41a3424f9"), baseIteratee = require("3271a4dbe265890");
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function maxBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt) : undefined;
}
module.exports = maxBy;

},{"dba025d59f90321a":"1Vacs","d445a3f41a3424f9":"9iS5h","3271a4dbe265890":"5rKNq"}],"3fYsy":[function(require,module,exports) {
var baseExtremum = require("515d8abb123de545"), baseIteratee = require("e7a24e488e92031a"), baseLt = require("cba661d625852896");
/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function minBy(array, iteratee) {
    return array && array.length ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt) : undefined;
}
module.exports = minBy;

},{"515d8abb123de545":"1Vacs","e7a24e488e92031a":"5rKNq","cba661d625852896":"gX7Ao"}],"iqrFk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PolarAngleAxis", ()=>PolarAngleAxis);
/**
 * @fileOverview Axis of radial direction
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _polygon = require("../shape/Polygon");
var _text = require("../component/Text");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _polarUtils = require("../util/PolarUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var RADIAN = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = /*#__PURE__*/ function(_PureComponent) {
    _inherits(PolarAngleAxis, _PureComponent);
    function PolarAngleAxis() {
        _classCallCheck(this, PolarAngleAxis);
        return _callSuper(this, PolarAngleAxis, arguments);
    }
    _createClass(PolarAngleAxis, [
        {
            key: "getTickLineCoord",
            value: /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */ function getTickLineCoord(data) {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, radius = _this$props.radius, orientation = _this$props.orientation, tickSize = _this$props.tickSize;
                var tickLineSize = tickSize || 8;
                var p1 = (0, _polarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
                var p2 = (0, _polarUtils.polarToCartesian)(cx, cy, radius + (orientation === "inner" ? -1 : 1) * tickLineSize, data.coordinate);
                return {
                    x1: p1.x,
                    y1: p1.y,
                    x2: p2.x,
                    y2: p2.y
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor(data) {
                var orientation = this.props.orientation;
                var cos = Math.cos(-data.coordinate * RADIAN);
                var textAnchor;
                if (cos > eps) textAnchor = orientation === "outer" ? "start" : "end";
                else if (cos < -eps) textAnchor = orientation === "outer" ? "end" : "start";
                else textAnchor = "middle";
                return textAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props2 = this.props, cx = _this$props2.cx, cy = _this$props2.cy, radius = _this$props2.radius, axisLine = _this$props2.axisLine, axisLineType = _this$props2.axisLineType;
                var props = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), {}, {
                    fill: "none"
                }, (0, _reactUtils.filterProps)(axisLine, false));
                if (axisLineType === "circle") return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    cx: cx,
                    cy: cy,
                    r: radius
                }));
                var ticks = this.props.ticks;
                var points = ticks.map(function(entry) {
                    return (0, _polarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _polygon.Polygon), _extends({
                    className: "recharts-polar-angle-axis-line"
                }, props, {
                    points: points
                }));
            }
        },
        {
            key: "renderTicks",
            value: function renderTicks() {
                var _this = this;
                var _this$props3 = this.props, ticks = _this$props3.ticks, tick = _this$props3.tick, tickLine = _this$props3.tickLine, tickFormatter = _this$props3.tickFormatter, stroke = _this$props3.stroke;
                var axisProps = (0, _reactUtils.filterProps)(this.props, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, _reactUtils.filterProps)(tickLine, false));
                var items = ticks.map(function(entry, i) {
                    var lineCoord = _this.getTickLineCoord(entry);
                    var textAnchor = _this.getTickTextAnchor(entry);
                    var tickProps = _objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), {}, {
                        index: i,
                        payload: entry,
                        x: lineCoord.x2,
                        y: lineCoord.y2
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: (0, _clsxDefault.default)("recharts-polar-angle-axis-tick", (0, _polarUtils.getTickClassName)(tick)),
                        key: "tick-".concat(entry.coordinate)
                    }, (0, _types.adaptEventsOfChild)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
                        className: "recharts-polar-angle-axis-tick-line"
                    }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-polar-angle-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, ticks = _this$props4.ticks, radius = _this$props4.radius, axisLine = _this$props4.axisLine;
                if (radius <= 0 || !ticks || !ticks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)("recharts-polar-angle-axis", this.props.className)
                }, axisLine && this.renderAxisLine(), this.renderTicks());
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-polar-angle-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return PolarAngleAxis;
}((0, _react.PureComponent));
_defineProperty(PolarAngleAxis, "displayName", "PolarAngleAxis");
_defineProperty(PolarAngleAxis, "axisType", "angleAxis");
_defineProperty(PolarAngleAxis, "defaultProps", {
    type: "category",
    angleAxisId: 0,
    scale: "auto",
    cx: 0,
    cy: 0,
    orientation: "outer",
    axisLine: true,
    tickLine: true,
    tickSize: 8,
    tick: true,
    hide: false,
    allowDuplicatedCategory: true
});

},{"react":"BK2ob","lodash/isFunction":"56sPA","clsx":"bGtJT","../container/Layer":"eHeGW","../shape/Dot":"jRGax","../shape/Polygon":"fqbWG","../component/Text":"8RJoX","../util/types":"73B4U","../util/ReactUtils":"56rQC","../util/PolarUtils":"iSQPa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2dqJh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pie", ()=>Pie);
/**
 * @fileOverview Render sectors of a pie
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _curve = require("../shape/Curve");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _labelList = require("../component/LabelList");
var _cell = require("../component/Cell");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _logUtils = require("../util/LogUtils");
var _types = require("../util/types");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _Pie;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Pie = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Pie, _PureComponent);
    function Pie(props) {
        var _this;
        _classCallCheck(this, Pie);
        _this = _callSuper(this, Pie, [
            props
        ]);
        _defineProperty(_assertThisInitialized(_this), "pieRef", null);
        _defineProperty(_assertThisInitialized(_this), "sectorRefs", []);
        _defineProperty(_assertThisInitialized(_this), "id", (0, _dataUtils.uniqueId)("recharts-pie-"));
        _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, _isFunctionDefault.default)(onAnimationEnd)) onAnimationEnd();
        });
        _defineProperty(_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, _isFunctionDefault.default)(onAnimationStart)) onAnimationStart();
        });
        _this.state = {
            isAnimationFinished: !props.isAnimationActive,
            prevIsAnimationActive: props.isAnimationActive,
            prevAnimationId: props.animationId,
            sectorToFocus: 0
        };
        return _this;
    }
    _createClass(Pie, [
        {
            key: "isActiveIndex",
            value: function isActiveIndex(i) {
                var activeIndex = this.props.activeIndex;
                if (Array.isArray(activeIndex)) return activeIndex.indexOf(i) !== -1;
                return i === activeIndex;
            }
        },
        {
            key: "hasActiveIndex",
            value: function hasActiveIndex() {
                var activeIndex = this.props.activeIndex;
                return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
            }
        },
        {
            key: "renderLabels",
            value: function renderLabels(sectors) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, label = _this$props.label, labelLine = _this$props.labelLine, dataKey = _this$props.dataKey, valueKey = _this$props.valueKey;
                var pieProps = (0, _reactUtils.filterProps)(this.props, false);
                var customLabelProps = (0, _reactUtils.filterProps)(label, false);
                var customLabelLineProps = (0, _reactUtils.filterProps)(labelLine, false);
                var offsetRadius = label && label.offsetRadius || 20;
                var labels = sectors.map(function(entry, i) {
                    var midAngle = (entry.startAngle + entry.endAngle) / 2;
                    var endPoint = (0, _polarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
                    var labelProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pieProps), entry), {}, {
                        stroke: "none"
                    }, customLabelProps), {}, {
                        index: i,
                        textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
                    }, endPoint);
                    var lineProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, pieProps), entry), {}, {
                        fill: "none",
                        stroke: entry.fill
                    }, customLabelLineProps), {}, {
                        index: i,
                        points: [
                            (0, _polarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                            endPoint
                        ],
                        key: "line"
                    });
                    var realDataKey = dataKey;
                    // TODO: compatible to lower versions
                    if ((0, _isNilDefault.default)(dataKey) && (0, _isNilDefault.default)(valueKey)) realDataKey = "value";
                    else if ((0, _isNilDefault.default)(dataKey)) realDataKey = valueKey;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, _reactDefault.default).createElement((0, _layer.Layer), {
                        key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps), Pie.renderLabelItem(label, labelProps, (0, _chartUtils.getValueByDataKey)(entry, realDataKey))));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-pie-labels"
                }, labels);
            }
        },
        {
            key: "renderSectorsStatically",
            value: function renderSectorsStatically(sectors) {
                var _this2 = this;
                var _this$props2 = this.props, activeShape = _this$props2.activeShape, blendStroke = _this$props2.blendStroke, inactiveShapeProp = _this$props2.inactiveShape;
                return sectors.map(function(entry, i) {
                    if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
                    var isActive = _this2.isActiveIndex(i);
                    var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
                    var sectorOptions = isActive ? activeShape : inactiveShape;
                    var sectorProps = _objectSpread(_objectSpread({}, entry), {}, {
                        stroke: blendStroke ? entry.fill : entry.stroke,
                        tabIndex: -1
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        ref: function ref(_ref) {
                            if (_ref && !_this2.sectorRefs.includes(_ref)) _this2.sectorRefs.push(_ref);
                        },
                        tabIndex: -1,
                        className: "recharts-pie-sector"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
                        option: sectorOptions,
                        isActive: isActive,
                        shapeType: "sector"
                    }, sectorProps)));
                });
            }
        },
        {
            key: "renderSectorsWithAnimation",
            value: function renderSectorsWithAnimation() {
                var _this3 = this;
                var _this$props3 = this.props, sectors = _this$props3.sectors, isAnimationActive = _this$props3.isAnimationActive, animationBegin = _this$props3.animationBegin, animationDuration = _this$props3.animationDuration, animationEasing = _this$props3.animationEasing, animationId = _this$props3.animationId;
                var _this$state = this.state, prevSectors = _this$state.prevSectors, prevIsAnimationActive = _this$state.prevIsAnimationActive;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
                    onAnimationStart: this.handleAnimationStart,
                    onAnimationEnd: this.handleAnimationEnd
                }, function(_ref2) {
                    var t = _ref2.t;
                    var stepData = [];
                    var first = sectors && sectors[0];
                    var curAngle = first.startAngle;
                    sectors.forEach(function(entry, index) {
                        var prev = prevSectors && prevSectors[index];
                        var paddingAngle = index > 0 ? (0, _getDefault.default)(entry, "paddingAngle", 0) : 0;
                        if (prev) {
                            var angleIp = (0, _dataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
                            var latest = _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + angleIp(t) + paddingAngle
                            });
                            stepData.push(latest);
                            curAngle = latest.endAngle;
                        } else {
                            var endAngle = entry.endAngle, startAngle = entry.startAngle;
                            var interpolatorAngle = (0, _dataUtils.interpolateNumber)(0, endAngle - startAngle);
                            var deltaAngle = interpolatorAngle(t);
                            var _latest = _objectSpread(_objectSpread({}, entry), {}, {
                                startAngle: curAngle + paddingAngle,
                                endAngle: curAngle + deltaAngle + paddingAngle
                            });
                            stepData.push(_latest);
                            curAngle = _latest.endAngle;
                        }
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderSectorsStatically(stepData));
                });
            }
        },
        {
            key: "attachKeyboardHandlers",
            value: function attachKeyboardHandlers(pieRef) {
                var _this4 = this;
                // eslint-disable-next-line no-param-reassign
                pieRef.onkeydown = function(e) {
                    if (!e.altKey) switch(e.key){
                        case "ArrowLeft":
                            var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[next].focus();
                            _this4.setState({
                                sectorToFocus: next
                            });
                            break;
                        case "ArrowRight":
                            var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                            _this4.sectorRefs[_next].focus();
                            _this4.setState({
                                sectorToFocus: _next
                            });
                            break;
                        case "Escape":
                            _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                            _this4.setState({
                                sectorToFocus: 0
                            });
                            break;
                        default:
                    }
                };
            }
        },
        {
            key: "renderSectors",
            value: function renderSectors() {
                var _this$props4 = this.props, sectors = _this$props4.sectors, isAnimationActive = _this$props4.isAnimationActive;
                var prevSectors = this.state.prevSectors;
                if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqualDefault.default)(prevSectors, sectors))) return this.renderSectorsWithAnimation();
                return this.renderSectorsStatically(sectors);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.pieRef) this.attachKeyboardHandlers(this.pieRef);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                var _this$props5 = this.props, hide = _this$props5.hide, sectors = _this$props5.sectors, className = _this$props5.className, label = _this$props5.label, cx = _this$props5.cx, cy = _this$props5.cy, innerRadius = _this$props5.innerRadius, outerRadius = _this$props5.outerRadius, isAnimationActive = _this$props5.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (hide || !sectors || !sectors.length || !(0, _dataUtils.isNumber)(cx) || !(0, _dataUtils.isNumber)(cy) || !(0, _dataUtils.isNumber)(innerRadius) || !(0, _dataUtils.isNumber)(outerRadius)) return null;
                var layerClass = (0, _clsxDefault.default)("recharts-pie", className);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: this.props.rootTabIndex,
                    className: layerClass,
                    ref: function ref(_ref3) {
                        _this5.pieRef = _ref3;
                    }
                }, this.renderSectors(), label && this.renderLabels(sectors), (0, _label.Label).renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, sectors, false));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) return {
                    prevIsAnimationActive: nextProps.isAnimationActive,
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: [],
                    isAnimationFinished: true
                };
                if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curSectors: nextProps.sectors,
                    prevSectors: prevState.curSectors,
                    isAnimationFinished: true
                };
                if (nextProps.sectors !== prevState.curSectors) return {
                    curSectors: nextProps.sectors,
                    isAnimationFinished: true
                };
                return null;
            }
        },
        {
            key: "getTextAnchor",
            value: function getTextAnchor(x, cx) {
                if (x > cx) return "start";
                if (x < cx) return "end";
                return "middle";
            }
        },
        {
            key: "renderLabelLineItem",
            value: function renderLabelLineItem(option, props) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                if ((0, _isFunctionDefault.default)(option)) return option(props);
                var className = (0, _clsxDefault.default)("recharts-pie-label-line", typeof option !== "boolean" ? option.className : "");
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, props, {
                    type: "linear",
                    className: className
                }));
            }
        },
        {
            key: "renderLabelItem",
            value: function renderLabelItem(option, props, value) {
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                var label = value;
                if ((0, _isFunctionDefault.default)(option)) {
                    label = option(props);
                    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(label)) return label;
                }
                var className = (0, _clsxDefault.default)("recharts-pie-label-text", typeof option !== "boolean" && !(0, _isFunctionDefault.default)(option) ? option.className : "");
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    alignmentBaseline: "middle",
                    className: className
                }), label);
            }
        }
    ]);
    return Pie;
}((0, _react.PureComponent));
_Pie = Pie;
_defineProperty(Pie, "displayName", "Pie");
_defineProperty(Pie, "defaultProps", {
    stroke: "#fff",
    fill: "#808080",
    legendType: "rect",
    cx: "50%",
    cy: "50%",
    startAngle: 0,
    endAngle: 360,
    innerRadius: 0,
    outerRadius: "80%",
    paddingAngle: 0,
    labelLine: true,
    hide: false,
    minAngle: 0,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: "ease",
    nameKey: "name",
    blendStroke: false,
    rootTabIndex: 0
});
_defineProperty(Pie, "parseDeltaAngle", function(startAngle, endAngle) {
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
});
_defineProperty(Pie, "getRealPieData", function(item) {
    var _item$props = item.props, data = _item$props.data, children = _item$props.children;
    var presentationProps = (0, _reactUtils.filterProps)(item.props, false);
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    if (data && data.length) return data.map(function(entry, index) {
        return _objectSpread(_objectSpread(_objectSpread({
            payload: entry
        }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
    if (cells && cells.length) return cells.map(function(cell) {
        return _objectSpread(_objectSpread({}, presentationProps), cell.props);
    });
    return [];
});
_defineProperty(Pie, "parseCoordinateOfPie", function(item, offset) {
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, _polarUtils.getMaxRadius)(width, height);
    var cx = left + (0, _dataUtils.getPercentValue)(item.props.cx, width, width / 2);
    var cy = top + (0, _dataUtils.getPercentValue)(item.props.cy, height, height / 2);
    var innerRadius = (0, _dataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
    var outerRadius = (0, _dataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
    var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
});
_defineProperty(Pie, "getComposedData", function(_ref4) {
    var item = _ref4.item, offset = _ref4.offset;
    var pieData = _Pie.getRealPieData(item);
    if (!pieData || !pieData.length) return null;
    var _item$props2 = item.props, cornerRadius = _item$props2.cornerRadius, startAngle = _item$props2.startAngle, endAngle = _item$props2.endAngle, paddingAngle = _item$props2.paddingAngle, dataKey = _item$props2.dataKey, nameKey = _item$props2.nameKey, valueKey = _item$props2.valueKey, tooltipType = _item$props2.tooltipType;
    var minAngle = Math.abs(item.props.minAngle);
    var coordinate = _Pie.parseCoordinateOfPie(item, offset);
    var deltaAngle = _Pie.parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var realDataKey = dataKey;
    if ((0, _isNilDefault.default)(dataKey) && (0, _isNilDefault.default)(valueKey)) {
        (0, _logUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
        realDataKey = "value";
    } else if ((0, _isNilDefault.default)(dataKey)) {
        (0, _logUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
        realDataKey = valueKey;
    }
    var notZeroItemCount = pieData.filter(function(entry) {
        return (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0) !== 0;
    }).length;
    var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
    var sum = pieData.reduce(function(result, entry) {
        var val = (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0);
        return result + ((0, _dataUtils.isNumber)(val) ? val : 0);
    }, 0);
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = pieData.map(function(entry, i) {
            var val = (0, _chartUtils.getValueByDataKey)(entry, realDataKey, 0);
            var name = (0, _chartUtils.getValueByDataKey)(entry, nameKey, i);
            var percent = ((0, _dataUtils.isNumber)(val) ? val : 0) / sum;
            var tempStartAngle;
            if (i) tempStartAngle = prev.endAngle + (0, _dataUtils.mathSign)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, _dataUtils.mathSign)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entry,
                    dataKey: realDataKey,
                    type: tooltipType
                }
            ];
            var tooltipPosition = (0, _polarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = _objectSpread(_objectSpread(_objectSpread({
                percent: percent,
                cornerRadius: cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entry), coordinate), {}, {
                value: (0, _chartUtils.getValueByDataKey)(entry, realDataKey),
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entry,
                paddingAngle: (0, _dataUtils.mathSign)(deltaAngle) * paddingAngle
            });
            return prev;
        });
    }
    return _objectSpread(_objectSpread({}, coordinate), {}, {
        sectors: sectors,
        data: pieData
    });
});

},{"react":"BK2ob","react-smooth":"apDr4","lodash/get":"1XYRd","lodash/isEqual":"hga42","lodash/isNil":"4xNOq","lodash/isFunction":"56sPA","clsx":"bGtJT","../container/Layer":"eHeGW","../shape/Curve":"63XKr","../component/Text":"8RJoX","../component/Label":"cIQWL","../component/LabelList":"gAcsH","../component/Cell":"i1Cei","../util/ReactUtils":"56rQC","../util/Global":"6FMLK","../util/PolarUtils":"iSQPa","../util/DataUtils":"kHJdD","../util/ChartUtils":"eYWT4","../util/LogUtils":"jEZ3K","../util/types":"73B4U","../util/ActiveShapeUtils":"bLvU1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bLvU1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPropsFromShapeOption", ()=>getPropsFromShapeOption);
parcelHelpers.export(exports, "Shape", ()=>Shape);
/**
 * This is an abstraction to handle identifying the active index from a tooltip mouse interaction
 */ parcelHelpers.export(exports, "isFunnel", ()=>isFunnel);
parcelHelpers.export(exports, "isPie", ()=>isPie);
parcelHelpers.export(exports, "isScatter", ()=>isScatter);
parcelHelpers.export(exports, "compareFunnel", ()=>compareFunnel);
parcelHelpers.export(exports, "comparePie", ()=>comparePie);
parcelHelpers.export(exports, "compareScatter", ()=>compareScatter);
/**
 *
 * @param {GetActiveShapeIndexForTooltip} arg an object of incoming attributes from Tooltip
 * @returns {number}
 *
 * To handle possible duplicates in the data set,
 * match both the data value of the active item to a data value on a graph item,
 * and match the mouse coordinates of the active item to the coordinates of in a particular components shape data.
 * This assumes equal lengths of shape objects to data items.
 */ parcelHelpers.export(exports, "getActiveShapeIndexForTooltip", ()=>getActiveShapeIndexForTooltip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _isBoolean = require("lodash/isBoolean");
var _isBooleanDefault = parcelHelpers.interopDefault(_isBoolean);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _rectangle = require("../shape/Rectangle");
var _trapezoid = require("../shape/Trapezoid");
var _sector = require("../shape/Sector");
var _layer = require("../container/Layer");
var _symbols = require("../shape/Symbols");
var _excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function defaultPropTransformer(option, props) {
    return _objectSpread(_objectSpread({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
    return shapeType === "symbols";
}
function ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case "rectangle":
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), elementProps);
        case "trapezoid":
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trapezoid.Trapezoid), elementProps);
        case "sector":
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sector.Sector), elementProps);
        case "symbols":
            if (isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _symbols.Symbols), elementProps);
            break;
        default:
            return null;
    }
}
function getPropsFromShapeOption(option) {
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) return option.props;
    return option;
}
function Shape(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = _objectWithoutProperties(_ref2, _excluded);
    var shape;
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) shape = /*#__PURE__*/ (0, _react.cloneElement)(option, _objectSpread(_objectSpread({}, props), getPropsFromShapeOption(option)));
    else if ((0, _isFunctionDefault.default)(option)) shape = option(props);
    else if ((0, _isPlainObjectDefault.default)(option) && !(0, _isBooleanDefault.default)(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, _reactDefault.default).createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: activeClassName
    }, shape);
    return shape;
}
function isFunnel(graphicalItem, _item) {
    return _item != null && "trapezoids" in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
    return _item != null && "sectors" in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
    return _item != null && "points" in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if (isFunnel(graphicalItem, activeItem)) comparison = compareFunnel;
    else if (isPie(graphicalItem, activeItem)) comparison = comparePie;
    else if (isScatter(graphicalItem, activeItem)) comparison = compareScatter;
    return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if (isFunnel(graphicalItem, activeItem)) shapeKey = "trapezoids";
    else if (isPie(graphicalItem, activeItem)) shapeKey = "sectors";
    else if (isScatter(graphicalItem, activeItem)) shapeKey = "points";
    return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if (isFunnel(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if (isPie(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if (isScatter(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function getActiveShapeIndexForTooltip(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, _isEqualDefault.default)(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}

},{"react":"BK2ob","lodash/isFunction":"56sPA","lodash/isPlainObject":"dQG5F","lodash/isBoolean":"jJOk9","lodash/isEqual":"hga42","../shape/Rectangle":"hrVg4","../shape/Trapezoid":"jWEVW","../shape/Sector":"bmghA","../container/Layer":"eHeGW","../shape/Symbols":"i7d89","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dQG5F":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"3mPah","2ca5b85a120835de":"cNP2R","963b65e043435612":"edAV6"}],"cNP2R":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"hcG93"}],"jJOk9":[function(require,module,exports) {
var baseGetTag = require("763d54281423d9ac"), isObjectLike = require("37c1c7912587466b");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"763d54281423d9ac":"3mPah","37c1c7912587466b":"edAV6"}],"jWEVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trapezoid", ()=>Trapezoid);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var Trapezoid = function Trapezoid(props) {
    var trapezoidProps = _objectSpread(_objectSpread({}, defaultProps), props);
    var pathRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, _react.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, _clsxDefault.default)("recharts-trapezoid", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
        className: layerClass,
        d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({}, (0, _reactUtils.filterProps)(trapezoidProps, true), {
            className: layerClass,
            d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};

},{"react":"BK2ob","clsx":"bGtJT","react-smooth":"apDr4","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5oEK0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Brush", ()=>Brush);
/**
 * @fileOverview Brush
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _d3Scale = require("victory-vendor/d3-scale");
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _chartUtils = require("../util/ChartUtils");
var _dataUtils = require("../util/DataUtils");
var _cssPrefixUtils = require("../util/CssPrefixUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, _d3Scale.scalePoint)().domain((0, _rangeDefault.default)(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var Brush = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Brush, _PureComponent);
    function Brush(props) {
        var _this;
        _classCallCheck(this, Brush);
        _this = _callSuper(this, Brush, [
            props
        ]);
        _defineProperty(_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        _defineProperty(_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        _defineProperty(_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    _createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, _chartUtils.getValueByDataKey)(data[index], dataKey, index);
                return (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState(_defineProperty(_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) return;
                this.setState(_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, _react.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = _objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat(data[startIndex].name, ", Max value: ").concat(data[endIndex].name);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, _clsxDefault.default)("recharts-brush", className);
                var isPanoramic = (0, _reactDefault.default).Children.count(children) === 1;
                var style = (0, _cssPrefixUtils.generatePrefixStyle)("userSelect", "none");
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rectangle = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return _objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, _react.PureComponent));
_defineProperty(Brush, "displayName", "Brush");
_defineProperty(Brush, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});

},{"react":"BK2ob","clsx":"bGtJT","victory-vendor/d3-scale":"97ySI","lodash/isFunction":"56sPA","lodash/range":"1TW0e","../container/Layer":"eHeGW","../component/Text":"8RJoX","../util/ChartUtils":"eYWT4","../util/DataUtils":"kHJdD","../util/CssPrefixUtils":"bBO8b","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1TW0e":[function(require,module,exports) {
var createRange = require("1232c42be39f64d6");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"1232c42be39f64d6":"21R6d"}],"21R6d":[function(require,module,exports) {
var baseRange = require("f5c6552fbc38341a"), isIterateeCall = require("ae36f017fbc9946"), toFinite = require("c59818521cb53c6a");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"f5c6552fbc38341a":"4EPKV","ae36f017fbc9946":"9nUAa","c59818521cb53c6a":"4sIS7"}],"4EPKV":[function(require,module,exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"4sIS7":[function(require,module,exports) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"6fw7p"}],"bBO8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generatePrefixStyle", ()=>generatePrefixStyle);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = PREFIX_LIST.reduce(function(res, entry) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2FQ3N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEndPoints", ()=>getEndPoints);
parcelHelpers.export(exports, "ReferenceLine", ()=>ReferenceLine);
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _some = require("lodash/some");
var _someDefault = parcelHelpers.interopDefault(_some);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartLayoutContext = require("../context/chartLayoutContext");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) line = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) line = option(props);
    else line = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, _ifOverflowMatches.ifOverflowMatches)(props, "discard") && (0, _someDefault.default)(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function ReferenceLine(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, _chartLayoutContext.useClipPathId)();
    var xAxis = (0, _chartLayoutContext.useXAxisOrThrow)(xAxisId);
    var yAxis = (0, _chartLayoutContext.useYAxisOrThrow)(yAxisId);
    var viewBox = (0, _chartLayoutContext.useViewBox)();
    if (!clipPathId || !viewBox) return null;
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, _dataUtils.isNumOrStr)(fixedX);
    var isY = (0, _dataUtils.isNumOrStr)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = _slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)("recharts-reference-line", className)
    }, renderLine(shape, lineProps), (0, _label.Label).renderCallByParent(props, (0, _cartesianUtils.rectWithCoords)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
ReferenceLine.displayName = "ReferenceLine";
ReferenceLine.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};

},{"react":"BK2ob","lodash/isFunction":"56sPA","lodash/some":"iAMW5","clsx":"bGtJT","../container/Layer":"eHeGW","../component/Label":"cIQWL","../util/IfOverflowMatches":"7we0L","../util/DataUtils":"kHJdD","../util/CartesianUtils":"fF7Ih","../util/LogUtils":"jEZ3K","../util/ReactUtils":"56rQC","../context/chartLayoutContext":"5GThP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iAMW5":[function(require,module,exports) {
var arraySome = require("499d9ae1b712c84d"), baseIteratee = require("6137baa4d335eb2f"), baseSome = require("dffda66140b0b703"), isArray = require("21c688a994e48617"), isIterateeCall = require("86e6a8e9c3fc8343");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = some;

},{"499d9ae1b712c84d":"8ql8E","6137baa4d335eb2f":"5rKNq","dffda66140b0b703":"6sqgf","21c688a994e48617":"8PiWS","86e6a8e9c3fc8343":"9nUAa"}],"6sqgf":[function(require,module,exports) {
var baseEach = require("fbf6b3dce93949f8");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome(collection, predicate) {
    var result;
    baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = baseSome;

},{"fbf6b3dce93949f8":"4qPa1"}],"7we0L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ifOverflowMatches", ()=>ifOverflowMatches);
var ifOverflowMatches = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fF7Ih":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatAxisMap", ()=>formatAxisMap);
parcelHelpers.export(exports, "rectWithPoints", ()=>rectWithPoints);
parcelHelpers.export(exports, "rectWithCoords", ()=>rectWithCoords);
parcelHelpers.export(exports, "ScaleHelper", ()=>ScaleHelper);
parcelHelpers.export(exports, "createLabeledScales", ()=>createLabeledScales);
/** Normalizes the angle so that 0 <= angle < 180.
 * @param {number} angle Angle in degrees.
 * @return {number} the normalized angle with a value of at least 0 and never greater or equal to 180. */ parcelHelpers.export(exports, "normalizeAngle", ()=>normalizeAngle);
parcelHelpers.export(exports, "getAngledRectangleWidth", ()=>getAngledRectangleWidth);
var _mapValues = require("lodash/mapValues");
var _mapValuesDefault = parcelHelpers.interopDefault(_mapValues);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _chartUtils = require("./ChartUtils");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
var _bar = require("../cartesian/Bar");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, _reactUtils.findChildByType)(children, (0, _bar.Bar));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
                if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === "no-gap") {
                    var gap = (0, _dataUtils.getPercentValue)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, _chartUtils.parseScale)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, _chartUtils.checkDomainOfScale)(scale);
        var ticks = (0, _chartUtils.getTicksOfScale)(scale, _objectSpread(_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = _objectSpread(_objectSpread(_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, _chartUtils.getBandSizeOfAxis)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, id, finalAxis));
    }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var rectWithCoords = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return rectWithPoints({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var ScaleHelper = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        _classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    _createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
_defineProperty(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, ScaleHelper.create(options[key])));
    }, {});
    return _objectSpread(_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, _mapValuesDefault.default)(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, _everyDefault.default)(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function normalizeAngle(angle) {
    return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = normalizeAngle(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

},{"lodash/mapValues":"ePfI9","lodash/every":"lW9T3","./ChartUtils":"eYWT4","./ReactUtils":"56rQC","./DataUtils":"kHJdD","../cartesian/Bar":"e8121","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ePfI9":[function(require,module,exports) {
var baseAssignValue = require("a3dd03284854d1b5"), baseForOwn = require("3fe946fb5f45d4e9"), baseIteratee = require("8671a2b480ab95e2");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee, 3);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = mapValues;

},{"a3dd03284854d1b5":"hmb5p","3fe946fb5f45d4e9":"3OtiZ","8671a2b480ab95e2":"5rKNq"}],"hmb5p":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"4GQfl"}],"lW9T3":[function(require,module,exports) {
var arrayEvery = require("35998aa94ab060f1"), baseEvery = require("44e7ab95f8b26a55"), baseIteratee = require("1d5621a35ca53be0"), isArray = require("e0e4c2e424adb44f"), isIterateeCall = require("2f9b3b0ab0300132");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function every(collection, predicate, guard) {
    var func = isArray(collection) ? arrayEvery : baseEvery;
    if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee(predicate, 3));
}
module.exports = every;

},{"35998aa94ab060f1":"dW733","44e7ab95f8b26a55":"hYwYK","1d5621a35ca53be0":"5rKNq","e0e4c2e424adb44f":"8PiWS","2f9b3b0ab0300132":"9nUAa"}],"dW733":[function(require,module,exports) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = arrayEvery;

},{}],"hYwYK":[function(require,module,exports) {
var baseEach = require("88b2ceed9e7ead7a");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function baseEvery(collection, predicate) {
    var result = true;
    baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = baseEvery;

},{"88b2ceed9e7ead7a":"4qPa1"}],"e8121":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bar", ()=>Bar);
/**
 * @fileOverview Render a group of bar
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _layer = require("../container/Layer");
var _errorBar = require("./ErrorBar");
var _cell = require("../component/Cell");
var _labelList = require("../component/LabelList");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _chartUtils = require("../util/ChartUtils");
var _types = require("../util/types");
var _barUtils = require("../util/BarUtils");
var _excluded = [
    "value",
    "background"
];
var _Bar;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Bar = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Bar, _PureComponent);
    function Bar() {
        var _this;
        _classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Bar, [].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        _defineProperty(_assertThisInitialized(_this), "id", (0, _dataUtils.uniqueId)("recharts-bar-"));
        _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        _defineProperty(_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    _createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, _reactUtils.filterProps)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = _objectSpread(_objectSpread(_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-bar-rectangle"
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                            var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                            var interpolatorWidth = (0, _dataUtils.interpolateNumber)(prev.width, entry.width);
                            var interpolatorHeight = (0, _dataUtils.interpolateNumber)(prev.height, entry.height);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, _dataUtils.interpolateNumber)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, _dataUtils.interpolateNumber)(0, entry.width);
                        var w = interpolator(t);
                        return _objectSpread(_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqualDefault.default)(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, _reactUtils.filterProps)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = _objectWithoutProperties(entry, _excluded);
                    if (!background) return null;
                    var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, _types.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: "recharts-bar-background-rectangle"
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barUtils.BarRectangle), _extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, _clsxDefault.default)("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, _react.PureComponent));
_Bar = Bar;
_defineProperty(Bar, "displayName", "Bar");
_defineProperty(Bar, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    data: [],
    layout: "vertical",
    activeBar: false,
    isAnimationActive: !(0, _global.Global).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ _defineProperty(Bar, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, _chartUtils.findPositionOfBar)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSizeProp = _item$props.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, _chartUtils.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var cells = (0, _reactUtils.findAllByType)(children, (0, _cell.Cell));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, _chartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, _barUtils.minPointSizeCallback)(minPointSizeProp, _Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, _dataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, _chartUtils.getCateCoordinateOfBar)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, _dataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return _objectSpread(_objectSpread(_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, _chartUtils.getTooltipItem)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return _objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

},{"react":"BK2ob","clsx":"bGtJT","react-smooth":"apDr4","lodash/isEqual":"hga42","lodash/isNil":"4xNOq","../container/Layer":"eHeGW","./ErrorBar":"fppsY","../component/Cell":"i1Cei","../component/LabelList":"gAcsH","../util/DataUtils":"kHJdD","../util/ReactUtils":"56rQC","../util/Global":"6FMLK","../util/ChartUtils":"eYWT4","../util/types":"73B4U","../util/BarUtils":"cpEBu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cpEBu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarRectangle", ()=>BarRectangle);
parcelHelpers.export(exports, "minPointSizeCallback", ()=>minPointSizeCallback);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _activeShapeUtils = require("./ActiveShapeUtils");
var _excluded = [
    "x",
    "y"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = _objectWithoutProperties(_ref, _excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function BarRectangle(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "rectangle",
        propTransformer: typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var minPointSizeCallback = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === "number") return minPointSize;
        var isValueNumber = typeof value === "number";
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, _tinyInvariantDefault.default)(false);
        return defaultValue;
    };
};

},{"react":"BK2ob","tiny-invariant":"5dVKl","./ActiveShapeUtils":"bLvU1","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5GThP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxisContext", ()=>XAxisContext);
parcelHelpers.export(exports, "YAxisContext", ()=>YAxisContext);
parcelHelpers.export(exports, "ViewBoxContext", ()=>ViewBoxContext);
parcelHelpers.export(exports, "OffsetContext", ()=>OffsetContext);
parcelHelpers.export(exports, "ClipPathIdContext", ()=>ClipPathIdContext);
parcelHelpers.export(exports, "ChartHeightContext", ()=>ChartHeightContext);
parcelHelpers.export(exports, "ChartWidthContext", ()=>ChartWidthContext);
parcelHelpers.export(exports, "ChartLayoutContextProvider", ()=>ChartLayoutContextProvider);
parcelHelpers.export(exports, "useClipPathId", ()=>useClipPathId);
parcelHelpers.export(exports, "useXAxisOrThrow", ()=>useXAxisOrThrow);
parcelHelpers.export(exports, "useArbitraryXAxis", ()=>useArbitraryXAxis);
parcelHelpers.export(exports, "useArbitraryYAxis", ()=>useArbitraryYAxis);
parcelHelpers.export(exports, "useYAxisWithFiniteDomainOrRandom", ()=>useYAxisWithFiniteDomainOrRandom);
parcelHelpers.export(exports, "useYAxisOrThrow", ()=>useYAxisOrThrow);
parcelHelpers.export(exports, "useViewBox", ()=>useViewBox);
parcelHelpers.export(exports, "useOffset", ()=>useOffset);
parcelHelpers.export(exports, "useChartWidth", ()=>useChartWidth);
parcelHelpers.export(exports, "useChartHeight", ()=>useChartHeight);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _find = require("lodash/find");
var _findDefault = parcelHelpers.interopDefault(_find);
var _every = require("lodash/every");
var _everyDefault = parcelHelpers.interopDefault(_every);
var _calculateViewBox = require("../util/calculateViewBox");
var _dataUtils = require("../util/DataUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var XAxisContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var YAxisContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ViewBoxContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var OffsetContext = /*#__PURE__*/ (0, _react.createContext)({});
var ClipPathIdContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ChartHeightContext = /*#__PURE__*/ (0, _react.createContext)(0);
var ChartWidthContext = /*#__PURE__*/ (0, _react.createContext)(0);
var ChartLayoutContextProvider = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, _calculateViewBox.calculateViewBox)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, _reactDefault.default).createElement(XAxisContext.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(YAxisContext.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(OffsetContext.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ViewBoxContext.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChartHeightContext.Provider, {
        value: height
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChartWidthContext.Provider, {
        value: width
    }, children)))))));
};
var useClipPathId = function useClipPathId() {
    return (0, _react.useContext)(ClipPathIdContext);
};
function getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "There are no available ids.";
    return "Available ids are: ".concat(keys, ".");
}
var useXAxisOrThrow = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, _react.useContext)(XAxisContext);
    !(xAxisMap != null) && (0, _tinyInvariantDefault.default)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, _tinyInvariantDefault.default)(false);
    return xAxis;
};
var useArbitraryXAxis = function useArbitraryXAxis() {
    var xAxisMap = (0, _react.useContext)(XAxisContext);
    return (0, _dataUtils.getAnyElementOfObject)(xAxisMap);
};
var useArbitraryYAxis = function useArbitraryYAxis() {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    return (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
};
var useYAxisWithFiniteDomainOrRandom = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    var yAxisWithFiniteDomain = (0, _findDefault.default)(yAxisMap, function(axis) {
        return (0, _everyDefault.default)(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, _dataUtils.getAnyElementOfObject)(yAxisMap);
};
var useYAxisOrThrow = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, _react.useContext)(YAxisContext);
    !(yAxisMap != null) && (0, _tinyInvariantDefault.default)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, _tinyInvariantDefault.default)(false);
    return yAxis;
};
var useViewBox = function useViewBox() {
    var viewBox = (0, _react.useContext)(ViewBoxContext);
    return viewBox;
};
var useOffset = function useOffset() {
    return (0, _react.useContext)(OffsetContext);
};
var useChartWidth = function useChartWidth() {
    return (0, _react.useContext)(ChartWidthContext);
};
var useChartHeight = function useChartHeight() {
    return (0, _react.useContext)(ChartHeightContext);
};

},{"react":"BK2ob","tiny-invariant":"5dVKl","lodash/find":"9hnKA","lodash/every":"lW9T3","../util/calculateViewBox":"1RZXT","../util/DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9hnKA":[function(require,module,exports) {
var createFind = require("f180f4459f295340"), findIndex = require("5af87c887948f3ca");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find = createFind(findIndex);
module.exports = find;

},{"f180f4459f295340":"kEphz","5af87c887948f3ca":"27DWa"}],"kEphz":[function(require,module,exports) {
var baseIteratee = require("ad0cafc4de9b66e6"), isArrayLike = require("cfacddc571674e4b"), keys = require("847fe2f1205991cd");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = createFind;

},{"ad0cafc4de9b66e6":"5rKNq","cfacddc571674e4b":"5F2le","847fe2f1205991cd":"ju9KS"}],"27DWa":[function(require,module,exports) {
var baseFindIndex = require("c4739d82cf87a9be"), baseIteratee = require("a250b62014668b1"), toInteger = require("8b47b48a148e503b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"c4739d82cf87a9be":"a7XzL","a250b62014668b1":"5rKNq","8b47b48a148e503b":"j63UA"}],"j63UA":[function(require,module,exports) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"4sIS7"}],"1RZXT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateViewBox", ()=>calculateViewBox);
var _memoize = require("lodash/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var calculateViewBox = (0, _memoizeDefault.default)(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        "l",
        offset.left,
        "t",
        offset.top,
        "w",
        offset.width,
        "h",
        offset.height
    ].join("");
});

},{"lodash/memoize":"gJ1Vu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iewla":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceDot", ()=>ReferenceDot);
/**
 * @fileOverview Reference Dot
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _dot = require("../shape/Dot");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _cartesianUtils = require("../util/CartesianUtils");
var _logUtils = require("../util/LogUtils");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function ReferenceDot(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, _dataUtils.isNumOrStr)(x);
    var isY = (0, _dataUtils.isNumOrStr)(y);
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)("recharts-reference-dot", className)
    }, ReferenceDot.renderDot(shape, dotProps), (0, _label.Label).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
ReferenceDot.displayName = "ReferenceDot";
ReferenceDot.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
ReferenceDot.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dot = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};

},{"react":"BK2ob","lodash/isFunction":"56sPA","clsx":"bGtJT","../container/Layer":"eHeGW","../shape/Dot":"jRGax","../component/Label":"cIQWL","../util/DataUtils":"kHJdD","../util/IfOverflowMatches":"7we0L","../util/CartesianUtils":"fF7Ih","../util/LogUtils":"jEZ3K","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6nv5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReferenceArea", ()=>ReferenceArea);
/**
 * @fileOverview Reference Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _layer = require("../container/Layer");
var _label = require("../component/Label");
var _cartesianUtils = require("../util/CartesianUtils");
var _ifOverflowMatches = require("../util/IfOverflowMatches");
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, _cartesianUtils.createLabeledScales)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, _ifOverflowMatches.ifOverflowMatches)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, _cartesianUtils.rectWithPoints)(p1, p2);
};
function ReferenceArea(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, _logUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, _dataUtils.isNumOrStr)(x1);
    var hasX2 = (0, _dataUtils.isNumOrStr)(x2);
    var hasY1 = (0, _dataUtils.isNumOrStr)(y1);
    var hasY2 = (0, _dataUtils.isNumOrStr)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, _ifOverflowMatches.ifOverflowMatches)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
        className: (0, _clsxDefault.default)("recharts-reference-area", className)
    }, ReferenceArea.renderRect(shape, _objectSpread(_objectSpread({
        clipPath: clipPath
    }, (0, _reactUtils.filterProps)(props, true)), rect)), (0, _label.Label).renderCallByParent(props, rect));
}
ReferenceArea.displayName = "ReferenceArea";
ReferenceArea.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
ReferenceArea.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) rect = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rectangle.Rectangle), _extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};

},{"react":"BK2ob","lodash/isFunction":"56sPA","clsx":"bGtJT","../container/Layer":"eHeGW","../component/Label":"cIQWL","../util/CartesianUtils":"fF7Ih","../util/IfOverflowMatches":"7we0L","../util/DataUtils":"kHJdD","../util/LogUtils":"jEZ3K","../shape/Rectangle":"hrVg4","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dNaHc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianAxis", ()=>CartesianAxis);
/**
 * @fileOverview Cartesian Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _shallowEqual = require("../util/ShallowEqual");
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _types = require("../util/types");
var _reactUtils = require("../util/ReactUtils");
var _getTicks = require("./getTicks");
var _excluded = [
    "viewBox"
], _excluded2 = [
    "viewBox"
], _excluded3 = [
    "ticks"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CartesianAxis = /*#__PURE__*/ function(_Component) {
    _inherits(CartesianAxis, _Component);
    function CartesianAxis(props) {
        var _this;
        _classCallCheck(this, CartesianAxis);
        _this = _callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    _createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = _objectWithoutProperties(_ref, _excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = _objectWithoutProperties(_this$props, _excluded2);
                return !(0, _shallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _shallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _shallowEqual.shallowEqual)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, _dataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(this.props, false)), (0, _reactUtils.filterProps)(axisLine, false)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = _objectSpread(_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, props, {
                    className: (0, _clsxDefault.default)("recharts-cartesian-axis-line", (0, _getDefault.default)(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, _getTicks.getTicks)(_objectSpread(_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, _reactUtils.filterProps)(this.props, false);
                var customTickProps = (0, _reactUtils.filterProps)(tick, false);
                var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, _reactUtils.filterProps)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, tickLineProps, lineCoord, {
                        className: (0, _clsxDefault.default)("recharts-cartesian-axis-tick-line", (0, _getDefault.default)(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = _objectWithoutProperties(_this$props8, _excluded3);
                var finalTicks = ticks;
                if ((0, _isFunctionDefault.default)(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: (0, _clsxDefault.default)("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, _label.Label).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, _react.Component));
_defineProperty(CartesianAxis, "displayName", "CartesianAxis");
_defineProperty(CartesianAxis, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});

},{"react":"BK2ob","lodash/isFunction":"56sPA","lodash/get":"1XYRd","clsx":"bGtJT","../util/ShallowEqual":"36pLK","../container/Layer":"eHeGW","../component/Text":"8RJoX","../component/Label":"cIQWL","../util/DataUtils":"kHJdD","../util/types":"73B4U","../util/ReactUtils":"56rQC","./getTicks":"hpaQn","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hpaQn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTicks", ()=>getTicks);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _dataUtils = require("../util/DataUtils");
var _domutils = require("../util/DOMUtils");
var _global = require("../util/Global");
var _tickUtils = require("../util/TickUtils");
var _getEquidistantTicks = require("./getEquidistantTicks");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread(_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, _tickUtils.isVisible)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = _objectSpread(_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function getTicks(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, _dataUtils.isNumber)(interval) || (0, _global.Global).isSsr) return (0, _tickUtils.getNumberIntervalTicks)(ticks, typeof interval === "number" && (0, _dataUtils.isNumber)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var unitSize = unit && sizeKey === "width" ? (0, _domutils.getStringSize)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, _isFunctionDefault.default)(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === "width" ? (0, _tickUtils.getAngledTickWidth)((0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, _domutils.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, _dataUtils.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, _tickUtils.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === "equidistantPreserveStart") return (0, _getEquidistantTicks.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === "preserveStartEnd");
    else candidates = getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}

},{"lodash/isFunction":"56sPA","../util/DataUtils":"kHJdD","../util/DOMUtils":"iMuyG","../util/Global":"6FMLK","../util/TickUtils":"jebxI","./getEquidistantTicks":"j4xFd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jebxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAngledTickWidth", ()=>getAngledTickWidth);
parcelHelpers.export(exports, "getTickBoundaries", ()=>getTickBoundaries);
parcelHelpers.export(exports, "isVisible", ()=>isVisible);
parcelHelpers.export(exports, "getNumberIntervalTicks", ()=>getNumberIntervalTicks);
var _cartesianUtils = require("./CartesianUtils");
var _getEveryNthWithCondition = require("./getEveryNthWithCondition");
function getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, _cartesianUtils.getAngledRectangleWidth)(size, angle);
}
function getTickBoundaries(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === "width";
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function isVisible(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks, interval) {
    return (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, interval + 1);
}

},{"./CartesianUtils":"fF7Ih","./getEveryNthWithCondition":"fsrzq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fsrzq":[function(require,module,exports) {
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEveryNthWithCondition", ()=>getEveryNthWithCondition);
function getEveryNthWithCondition(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j4xFd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEquidistantTicks", ()=>getEquidistantTicks);
var _tickUtils = require("../util/TickUtils");
var _getEveryNthWithCondition = require("../util/getEveryNthWithCondition");
function getEquidistantTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, _tickUtils.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}

},{"../util/TickUtils":"jebxI","../util/getEveryNthWithCondition":"fsrzq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"axPz4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianGrid", ()=>CartesianGrid);
/**
 * @fileOverview Cartesian Grid
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _logUtils = require("../util/LogUtils");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
var _getTicks = require("./getTicks");
var _cartesianAxis = require("./CartesianAxis");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], _excluded2 = [
    "offset"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === "none") return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
    else if ((0, _isFunctionDefault.default)(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = _objectWithoutProperties(props, _excluded);
        var _filterProps = (0, _reactUtils.filterProps)(others, false), __ = _filterProps.offset, restOfFilteredProps = _objectWithoutProperties(_filterProps, _excluded2);
        lineItem = /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = _objectSpread(_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = _objectSpread(_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), xAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.CartesianAxis).defaultProps), yAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function CartesianGrid(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, _chartLayoutContext.useChartWidth)();
    var chartHeight = (0, _chartLayoutContext.useChartHeight)();
    var offset = (0, _chartLayoutContext.useOffset)();
    var propsIncludingDefaults = _objectSpread(_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : defaultProps.verticalFill,
        x: (0, _dataUtils.isNumber)(props.x) ? props.x : offset.left,
        y: (0, _dataUtils.isNumber)(props.y) ? props.y : offset.top,
        width: (0, _dataUtils.isNumber)(props.width) ? props.width : offset.width,
        height: (0, _dataUtils.isNumber)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, _chartLayoutContext.useArbitraryXAxis)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, _chartLayoutContext.useYAxisWithFiniteDomainOrRandom)();
    if (!(0, _dataUtils.isNumber)(width) || width <= 0 || !(0, _dataUtils.isNumber)(height) || height <= 0 || !(0, _dataUtils.isNumber)(x) || x !== +x || !(0, _dataUtils.isNumber)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunctionDefault.default)(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? _objectSpread(_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, _isFunctionDefault.default)(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? _objectSpread(_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(HorizontalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(VerticalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(HorizontalStripes, _extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(VerticalStripes, _extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
CartesianGrid.displayName = "CartesianGrid";

},{"react":"BK2ob","lodash/isFunction":"56sPA","../util/LogUtils":"jEZ3K","../util/DataUtils":"kHJdD","../util/ReactUtils":"56rQC","../util/ChartUtils":"eYWT4","./getTicks":"hpaQn","./CartesianAxis":"dNaHc","../context/chartLayoutContext":"5GThP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kZLv6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Line", ()=>Line);
/**
 * @fileOverview Line
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSmooth = require("react-smooth");
var _reactSmoothDefault = parcelHelpers.interopDefault(_reactSmooth);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _curve = require("../shape/Curve");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _errorBar = require("./ErrorBar");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _global = require("../util/Global");
var _chartUtils = require("../util/ChartUtils");
var _excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var Line = /*#__PURE__*/ function(_PureComponent) {
    _inherits(Line, _PureComponent);
    function Line() {
        var _this;
        _classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _callSuper(this, Line, [].concat(args));
        _defineProperty(_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        _defineProperty(_assertThisInitialized(_this), "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        _defineProperty(_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat(_toConsumableArray(Line.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(", ");
        });
        _defineProperty(_assertThisInitialized(_this), "id", (0, _dataUtils.uniqueId)("recharts-line-"));
        _defineProperty(_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        _defineProperty(_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        _defineProperty(_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    _createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, _reactUtils.findAllByType)(children, (0, _errorBar.ErrorBar));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, _reactUtils.filterProps)(this.props, false);
                var customDotProps = (0, _reactUtils.filterProps)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = _objectSpread(_objectSpread(_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = _objectWithoutProperties(_this$props3, _excluded);
                var curveProps = _objectSpread(_objectSpread(_objectSpread({}, (0, _reactUtils.filterProps)(others, true)), {}, {
                    fill: "none",
                    className: "recharts-line-curve",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _curve.Curve), _extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSmoothDefault.default), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, _dataUtils.interpolateNumber)(prev.x, entry.x);
                                var interpolatorY = (0, _dataUtils.interpolateNumber)(prev.y, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, _dataUtils.interpolateNumber)(width * 2, entry.x);
                                var _interpolatorY = (0, _dataUtils.interpolateNumber)(height / 2, entry.y);
                                return _objectSpread(_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return _objectSpread(_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, _dataUtils.interpolateNumber)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqualDefault.default)(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, _clsxDefault.default)("recharts-line", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, _isNilDefault.default)(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, _reactUtils.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, _reactUtils.isDotProps)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, _labelList.LabelList).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(option)) dotItem = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(option, props);
                else if ((0, _isFunctionDefault.default)(option)) dotItem = option(props);
                else {
                    var className = (0, _clsxDefault.default)("recharts-line-dot", typeof option !== "boolean" ? option.className : "");
                    dotItem = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), _extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, _react.PureComponent));
_defineProperty(Line, "displayName", "Line");
_defineProperty(Line, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !(0, _global.Global).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ _defineProperty(Line, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
        if (layout === "horizontal") return {
            x: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, _isNilDefault.default)(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, _isNilDefault.default)(value) ? null : xAxis.scale(value),
            y: (0, _chartUtils.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return _objectSpread({
        points: points,
        layout: layout
    }, offset);
});

},{"react":"BK2ob","react-smooth":"apDr4","lodash/isFunction":"56sPA","lodash/isNil":"4xNOq","lodash/isEqual":"hga42","clsx":"bGtJT","../shape/Curve":"63XKr","../shape/Dot":"jRGax","../container/Layer":"eHeGW","../component/LabelList":"gAcsH","./ErrorBar":"fppsY","../util/DataUtils":"kHJdD","../util/ReactUtils":"56rQC","../util/Global":"6FMLK","../util/ChartUtils":"eYWT4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2b8KO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XAxis", ()=>XAxis);
/**
 * @fileOverview X Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chartLayoutContext = require("../context/chartLayoutContext");
var _cartesianAxis = require("./CartesianAxis");
var _chartUtils = require("../util/ChartUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var XAxis = function XAxis(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var axisOptions = (0, _chartLayoutContext.useXAxisOrThrow)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, _reactDefault.default).createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, _chartUtils.getTicksOfAxis)(axis, true);
        }
    })));
};
XAxis.displayName = "XAxis";
XAxis.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};

},{"react":"BK2ob","clsx":"bGtJT","../context/chartLayoutContext":"5GThP","./CartesianAxis":"dNaHc","../util/ChartUtils":"eYWT4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hUr9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YAxis", ()=>YAxis);
/**
 * @fileOverview Y Axis
 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chartLayoutContext = require("../context/chartLayoutContext");
var _cartesianAxis = require("./CartesianAxis");
var _chartUtils = require("../util/ChartUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var YAxis = function YAxis(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var axisOptions = (0, _chartLayoutContext.useYAxisOrThrow)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, _reactDefault.default).createElement((0, _cartesianAxis.CartesianAxis), _extends({}, axisOptions, {
        className: (0, _clsxDefault.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, _chartUtils.getTicksOfAxis)(axis, true);
        }
    })));
};
YAxis.displayName = "YAxis";
YAxis.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};

},{"react":"BK2ob","clsx":"bGtJT","../context/chartLayoutContext":"5GThP","./CartesianAxis":"dNaHc","../util/ChartUtils":"eYWT4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h8kjL":[function(require,module,exports) {
/**
 * @fileOverview Line Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineChart", ()=>LineChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _line = require("../cartesian/Line");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var LineChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: "LineChart",
    GraphicalChild: (0, _line.Line),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"2x1TI","../cartesian/Line":"kZLv6","../cartesian/XAxis":"2b8KO","../cartesian/YAxis":"hUr9E","../util/CartesianUtils":"fF7Ih","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2x1TI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAxisMapByAxes", ()=>getAxisMapByAxes);
parcelHelpers.export(exports, "createDefaultState", ()=>createDefaultState);
parcelHelpers.export(exports, "generateCategoricalChart", ()=>generateCategoricalChart);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
var _isFunction = require("lodash/isFunction");
var _isFunctionDefault = parcelHelpers.interopDefault(_isFunction);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _sortBy = require("lodash/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _throttle = require("lodash/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
// eslint-disable-next-line no-restricted-imports
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _surface = require("../container/Surface");
var _layer = require("../container/Layer");
var _tooltip = require("../component/Tooltip");
var _legend = require("../component/Legend");
var _dot = require("../shape/Dot");
var _rectangle = require("../shape/Rectangle");
var _reactUtils = require("../util/ReactUtils");
var _brush = require("../cartesian/Brush");
var _domutils = require("../util/DOMUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _detectReferenceElementsDomain = require("../util/DetectReferenceElementsDomain");
var _polarUtils = require("../util/PolarUtils");
var _shallowEqual = require("../util/ShallowEqual");
var _events = require("../util/Events");
var _types = require("../util/types");
var _accessibilityManager = require("./AccessibilityManager");
var _isDomainSpecifiedByUser = require("../util/isDomainSpecifiedByUser");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _cursor = require("../component/Cursor");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "item"
], _excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var FULL_WIDTH_AND_HEIGHT = {
    width: "100%",
    height: "100%"
};
var originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function renderAsIs(element) {
    return element;
}
var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return originCoordinate;
};
var getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, _dataUtils.isNumber)(dataStartIndex) && (0, _dataUtils.isNumber)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, _dataUtils.findEntryInArray)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat(_toConsumableArray(result), [
            (0, _chartUtils.getTooltipItem)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, _chartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, _isDomainSpecifiedByUser.isDomainSpecifiedByUser)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, _chartUtils.parseSpecifiedDomain)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, _dataUtils.hasDuplicate)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, _rangeDefault.default)(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, _chartUtils.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, _isNilDefault.default)(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, _isNilDefault.default)(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, _chartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, _chartUtils.getDomainOfDataByKey)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, _chartUtils.parseSpecifiedDomain)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, _rangeDefault.default)(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, _chartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            } else {
                domain = (0, _chartUtils.parseSpecifiedDomain)(originalDomain, (0, _chartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, _detectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
            }
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, _objectSpread(_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, _getDefault.default)(ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, _reactUtils.findAllByType)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = getAxisMapByAxes(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, _dataUtils.getAnyElementOfObject)(axisMap);
    var tooltipTicks = (0, _chartUtils.getTicksOfAxis)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, _sortByDefault.default)(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, _chartUtils.getBandSizeOfAxis)(axis, tooltipTicks)
    };
};
var createDefaultState = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, _reactUtils.getDisplayName)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
    var legendItem = (0, _reactUtils.findChildByType)(children, (0, _legend.Legend));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, orientation, (0, _getDefault.default)(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = _objectSpread(_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, _brush.Brush).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, _chartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return _objectSpread(_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === "xAxis") return axisObj[axisName].width;
    if (axisName === "yAxis") return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var generateCategoricalChart = function generateCategoricalChart(_ref6) {
    var _CategoricalChartWrapper;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === "zAxis") && (0, _tinyInvariantDefault.default)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return _objectSpread(_objectSpread({}, result), {}, _defineProperty(_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, _chartUtils.getTicksOfAxis)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _chartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, _reactUtils.getDisplayName)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, _chartUtils.getBarSizeList)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, _isNilDefault.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, _chartUtils.getBandSizeOfAxis)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, _chartUtils.getBarPosition)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return _objectSpread(_objectSpread({}, pos), {}, {
                        position: _objectSpread(_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: _objectSpread(_objectSpread({}, composedFn(_objectSpread(_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, _defineProperty(_defineProperty(_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, _reactUtils.parseChildIndex)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, _reactUtils.validateWidthHeight)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, _reactUtils.findAllByType)(children, GraphicalChild);
        var stackGroups = (0, _chartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, name, getAxisMap(props, _objectSpread(_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = calculateOffset(_objectSpread(_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, _objectSpread(_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return _objectSpread(_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        _inherits(CategoricalChartWrapper, _Component);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            _classCallCheck(this, CategoricalChartWrapper);
            _this = _callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            _defineProperty(_assertThisInitialized(_this), "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
            _defineProperty(_assertThisInitialized(_this), "accessibilityManager", new (0, _accessibilityManager.AccessibilityManager)());
            _defineProperty(_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState(_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, _objectSpread(_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") return;
                    _this.applySyncEvent(data);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return _objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, _isFunctionDefault.default)(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? _objectSpread(_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, _isFunctionDefault.default)(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, _isFunctionDefault.default)(onMouseLeave)) onMouseLeave(nextState, e);
            });
            _defineProperty(_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, _reactUtils.getReactEventByType)(e);
                var event = (0, _getDefault.default)(_this.props, "".concat(eventName));
                if (eventName && (0, _isFunctionDefault.default)(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = _objectSpread(_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, _isFunctionDefault.default)(onClick)) onClick(_nextState2, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, _isFunctionDefault.default)(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, _isFunctionDefault.default)(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            _defineProperty(_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            _defineProperty(_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            _defineProperty(_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            _defineProperty(_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, _events.eventCenter).emit((0, _events.SYNC_EVENT), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            _defineProperty(_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState(_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === "value") {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : originCoordinate;
                    _this.setState(_objectSpread(_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            _defineProperty(_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || "_recharts-cursor";
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cursor.Cursor), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, _getDefault.default)(element, "type.axisType");
                var axisMap = (0, _getDefault.default)(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, axisOption), {}, {
                    className: (0, _clsxDefault.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, _chartUtils.getTicksOfAxis)(axisOption, true)
                }));
            });
            _defineProperty(_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, _dataUtils.getAnyElementOfObject)(radiusAxisMap);
                var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, _chartUtils.getTicksOfAxis)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, _chartUtils.getTicksOfAxis)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ _defineProperty(_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, _chartUtils.getLegendProps)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = _objectWithoutProperties(props, _excluded);
                return /*#__PURE__*/ (0, _react.cloneElement)(item, _objectSpread(_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ _defineProperty(_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, _react.cloneElement)(tooltipItem, {
                    viewBox: _objectSpread(_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, _chartUtils.combineEventHandlers)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, _dataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
                    y: (0, _dataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, _dataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = _assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, _react.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            _defineProperty(_assertThisInitialized(_this), "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = _objectSpread(_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, _chartUtils.getMainColorOfGraphicItem)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, _reactUtils.filterProps)(activeDot, false)), (0, _types.adaptEventHandlers)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread(_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            _defineProperty(_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, _chartUtils.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, _dataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, _dataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, _isNilDefault.default)(activePoint)) return [
                            graphicalItem
                        ].concat(_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = _objectSpread(_objectSpread(_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, _react.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            _defineProperty(_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, _react.cloneElement)(element, _objectSpread(_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            _defineProperty(_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: renderAsIs
                },
                YAxis: {
                    handler: renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, _dataUtils.uniqueId)("recharts"), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, _throttleDefault.default)(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        _createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === "horizontal";
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === "Scatter";
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = _objectSpread(_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, _reactUtils.isChildrenEqual)([
                        (0, _reactUtils.findChildByType)(prevProps.children, (0, _tooltip.Tooltip))
                    ], [
                        (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, _reactUtils.findChildByType)(this.props.children, (0, _tooltip.Tooltip));
                    if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, _domutils.getOffset)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, _dataUtils.getAnyElementOfObject)(xAxisMap).scale;
                        var yScale = (0, _dataUtils.getAnyElementOfObject)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return _objectSpread(_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return _objectSpread(_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, _dataUtils.getAnyElementOfObject)(angleAxisMap);
                        return (0, _polarUtils.inRangeOfSector)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, _reactUtils.findChildByType)(children, (0, _tooltip.Tooltip));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, _types.adaptEventHandlers)(this.props, this.handleOuterEvent);
                    return _objectSpread(_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, _events.eventCenter).on((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, _events.eventCenter).removeListener((0, _events.SYNC_EVENT), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, _reactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = _slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = _slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, _reactUtils.getDisplayName)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _rectangle.isInRectangle)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, _polarUtils.inRangeOfSector)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, _activeShapeUtils.isFunnel)(graphicalItem, activeItem) || (0, _activeShapeUtils.isPie)(graphicalItem, activeItem) || (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem)) {
                            var activeIndex = (0, _activeShapeUtils.getActiveShapeIndexForTooltip)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: _objectSpread(_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, _activeShapeUtils.isScatter)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, _reactUtils.validateWidthHeight)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = _objectWithoutProperties(_this$props6, _excluded2);
                    var attrs = (0, _reactUtils.filterProps)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartLayoutContext.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application";
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartLayoutContext.ChartLayoutContextProvider), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
                        className: (0, _clsxDefault.default)("recharts-wrapper", className),
                        style: _objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        }
                    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _surface.Surface), _extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, _reactUtils.renderByOrder)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, _react.Component)), _defineProperty(_CategoricalChartWrapper, "displayName", chartName), _defineProperty(_CategoricalChartWrapper, "defaultProps", _objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps)), _defineProperty(_CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = createDefaultState(nextProps);
            return _objectSpread(_objectSpread(_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, _shallowEqual.shallowEqual)(margin, prevState.prevMargin)) {
            var _defaultState = createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = _objectSpread(_objectSpread({}, getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = _objectSpread(_objectSpread(_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return _objectSpread(_objectSpread(_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, _reactUtils.isChildrenEqual)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, _reactUtils.findChildByType)(children, (0, _brush.Brush));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, _isNilDefault.default)(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return _objectSpread(_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread(_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    }), _defineProperty(_CategoricalChartWrapper, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, _react.isValidElement)(option)) dot = /*#__PURE__*/ (0, _react.cloneElement)(option, props);
        else if ((0, _isFunctionDefault.default)(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dot.Dot), props);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _CategoricalChartWrapper;
};

},{"react":"BK2ob","lodash/isNil":"4xNOq","lodash/isFunction":"56sPA","lodash/range":"1TW0e","lodash/get":"1XYRd","lodash/sortBy":"2fKqG","lodash/throttle":"kGoYu","clsx":"bGtJT","tiny-invariant":"5dVKl","../container/Surface":"3GjFE","../container/Layer":"eHeGW","../component/Tooltip":"1NIRS","../component/Legend":"56zvs","../shape/Dot":"jRGax","../shape/Rectangle":"hrVg4","../util/ReactUtils":"56rQC","../cartesian/Brush":"5oEK0","../util/DOMUtils":"iMuyG","../util/DataUtils":"kHJdD","../util/ChartUtils":"eYWT4","../util/DetectReferenceElementsDomain":"6BkUJ","../util/PolarUtils":"iSQPa","../util/ShallowEqual":"36pLK","../util/Events":"845Jj","../util/types":"73B4U","./AccessibilityManager":"g1aY5","../util/isDomainSpecifiedByUser":"3zITj","../util/ActiveShapeUtils":"bLvU1","../component/Cursor":"27BAz","../context/chartLayoutContext":"5GThP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6BkUJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectReferenceElementsDomain", ()=>detectReferenceElementsDomain);
var _referenceDot = require("../cartesian/ReferenceDot");
var _referenceLine = require("../cartesian/ReferenceLine");
var _referenceArea = require("../cartesian/ReferenceArea");
var _ifOverflowMatches = require("./IfOverflowMatches");
var _reactUtils = require("./ReactUtils");
var _dataUtils = require("./DataUtils");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, _reactUtils.findAllByType)(children, (0, _referenceLine.ReferenceLine));
    var dots = (0, _reactUtils.findAllByType)(children, (0, _referenceDot.ReferenceDot));
    var elements = [].concat(_toConsumableArray(lines), _toConsumableArray(dots));
    var areas = (0, _reactUtils.findAllByType)(children, (0, _referenceArea.ReferenceArea));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, "extendDomain") && (0, _dataUtils.isNumber)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, _ifOverflowMatches.ifOverflowMatches)(el.props, "extendDomain") && (0, _dataUtils.isNumber)(el.props[key1]) && (0, _dataUtils.isNumber)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, _dataUtils.isNumber)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};

},{"../cartesian/ReferenceDot":"iewla","../cartesian/ReferenceLine":"2FQ3N","../cartesian/ReferenceArea":"6nv5z","./IfOverflowMatches":"7we0L","./ReactUtils":"56rQC","./DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"845Jj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventCenter", ()=>eventCenter);
parcelHelpers.export(exports, "SYNC_EVENT", ()=>SYNC_EVENT);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var eventCenter = new (0, _eventemitter3Default.default)();
var SYNC_EVENT = "recharts.syncMouseEvents";

},{"eventemitter3":"jB1JG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jB1JG":[function(require,module,exports) {
"use strict";
var has = Object.prototype.hasOwnProperty, prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"g1aY5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilityManager", ()=>AccessibilityManager);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var AccessibilityManager = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        _classCallCheck(this, AccessibilityManager);
        _defineProperty(this, "activeIndex", 0);
        _defineProperty(this, "coordinateList", []);
        _defineProperty(this, "layout", "horizontal");
    }
    _createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3zITj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */ parcelHelpers.export(exports, "isDomainSpecifiedByUser", ()=>isDomainSpecifiedByUser);
var _dataUtils = require("./DataUtils");
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, _dataUtils.isNumber)(domainStart) && (0, _dataUtils.isNumber)(domainEnd)) return true;
    }
    return false;
}

},{"./DataUtils":"kHJdD","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"27BAz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Cursor is the background, or a highlight,
 * that shows when user mouses over or activates
 * an area.
 *
 * It usually shows together with a tooltip
 * to emphasise which part of the chart does the tooltip refer to.
 */ parcelHelpers.export(exports, "Cursor", ()=>Cursor);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _curve = require("../shape/Curve");
var _cross = require("../shape/Cross");
var _getCursorRectangle = require("../util/cursor/getCursorRectangle");
var _rectangle = require("../shape/Rectangle");
var _getRadialCursorPoints = require("../util/cursor/getRadialCursorPoints");
var _sector = require("../shape/Sector");
var _getCursorPoints = require("../util/cursor/getCursorPoints");
var _reactUtils = require("../util/ReactUtils");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function Cursor(props) {
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
    var restProps;
    var cursorComp = (0, _curve.Curve);
    if (chartName === "ScatterChart") {
        restProps = activeCoordinate;
        cursorComp = (0, _cross.Cross);
    } else if (chartName === "BarChart") {
        restProps = (0, _getCursorRectangle.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, _rectangle.Rectangle);
    } else if (layout === "radial") {
        var _getRadialCursorPoint = (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, _sector.Sector);
    } else {
        restProps = {
            points: (0, _getCursorPoints.getCursorPoints)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, _curve.Curve);
    }
    var cursorProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        stroke: "#ccc",
        pointerEvents: "none"
    }, offset), restProps), (0, _reactUtils.filterProps)(element.props.cursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, _clsxDefault.default)("recharts-tooltip-cursor", element.props.cursor.className)
    });
    return /*#__PURE__*/ (0, _react.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, _react.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, _react.createElement)(cursorComp, cursorProps);
}

},{"react":"BK2ob","clsx":"bGtJT","../shape/Curve":"63XKr","../shape/Cross":"beK47","../util/cursor/getCursorRectangle":"aUyHP","../shape/Rectangle":"hrVg4","../util/cursor/getRadialCursorPoints":"daanz","../shape/Sector":"bmghA","../util/cursor/getCursorPoints":"g5k3f","../util/ReactUtils":"56rQC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aUyHP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorRectangle", ()=>getCursorRectangle);
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: "none",
        fill: "#ccc",
        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"daanz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Only applicable for radial layouts
 * @param {Object} activeCoordinate ChartCoordinate
 * @returns {Object} RadialCursorPoints
 */ parcelHelpers.export(exports, "getRadialCursorPoints", ()=>getRadialCursorPoints);
var _polarUtils = require("../PolarUtils");
function getRadialCursorPoints(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}

},{"../PolarUtils":"iSQPa","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g5k3f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorPoints", ()=>getCursorPoints);
var _polarUtils = require("../PolarUtils");
var _getRadialCursorPoints = require("./getRadialCursorPoints");
function getCursorPoints(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === "horizontal") {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === "vertical") {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === "centric") {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}

},{"../PolarUtils":"iSQPa","./getRadialCursorPoints":"daanz","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kwiN7":[function(require,module,exports) {
/**
 * @fileOverview Bar Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarChart", ()=>BarChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _bar = require("../cartesian/Bar");
var _xaxis = require("../cartesian/XAxis");
var _yaxis = require("../cartesian/YAxis");
var _cartesianUtils = require("../util/CartesianUtils");
var BarChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: "BarChart",
    GraphicalChild: (0, _bar.Bar),
    defaultTooltipEventType: "axis",
    validateTooltipEventTypes: [
        "axis",
        "item"
    ],
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, _xaxis.XAxis)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, _yaxis.YAxis)
        }
    ],
    formatAxisMap: (0, _cartesianUtils.formatAxisMap)
});

},{"./generateCategoricalChart":"2x1TI","../cartesian/Bar":"e8121","../cartesian/XAxis":"2b8KO","../cartesian/YAxis":"hUr9E","../util/CartesianUtils":"fF7Ih","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2XOME":[function(require,module,exports) {
/**
 * @fileOverview Pie Chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieChart", ()=>PieChart);
var _generateCategoricalChart = require("./generateCategoricalChart");
var _polarAngleAxis = require("../polar/PolarAngleAxis");
var _polarRadiusAxis = require("../polar/PolarRadiusAxis");
var _polarUtils = require("../util/PolarUtils");
var _pie = require("../polar/Pie");
var PieChart = (0, _generateCategoricalChart.generateCategoricalChart)({
    chartName: "PieChart",
    GraphicalChild: (0, _pie.Pie),
    validateTooltipEventTypes: [
        "item"
    ],
    defaultTooltipEventType: "item",
    legendContent: "children",
    axisComponents: [
        {
            axisType: "angleAxis",
            AxisComp: (0, _polarAngleAxis.PolarAngleAxis)
        },
        {
            axisType: "radiusAxis",
            AxisComp: (0, _polarRadiusAxis.PolarRadiusAxis)
        }
    ],
    formatAxisMap: (0, _polarUtils.formatAxisMap),
    defaultProps: {
        layout: "centric",
        startAngle: 0,
        endAngle: 360,
        cx: "50%",
        cy: "50%",
        innerRadius: 0,
        outerRadius: "80%"
    }
});

},{"./generateCategoricalChart":"2x1TI","../polar/PolarAngleAxis":"iqrFk","../polar/PolarRadiusAxis":"6wvEW","../util/PolarUtils":"iSQPa","../polar/Pie":"2dqJh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iZVHC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPaper", ()=>StyledPaper);
parcelHelpers.export(exports, "TooltipContent", ()=>TooltipContent);
var _jsxRuntime = require("react/jsx-runtime");
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
const StyledPaper = (0, _styles.styled)((0, _paperDefault.default))(({ theme })=>({
        display: "inline-flex",
        flexDirection: "column",
        padding: theme.spacing(3, 5),
        background: (0, _colors.COLORS).spaceCadet,
        boxShadow: "0 4px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "8px",
        color: (0, _colors.COLORS).white,
        textAlign: "center"
    }));
const TooltipContent = ({ active, payload, formatters, labelKey: dataLabelKey })=>{
    if (!active || !payload || !payload.length) return null;
    const { [payload[0].dataKey]: value, ...rest } = payload[0].payload;
    const labelKey = dataLabelKey || Object.keys(rest)[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPaper, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: false,
                sx: {
                    fontSize: 12
                },
                children: formatters?.label ? formatters.label(payload[0].payload[labelKey]) : payload[0].payload[labelKey]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                paragraph: false,
                sx: {
                    fontSize: 12,
                    fontWeight: 600
                },
                children: formatters?.data ? formatters.data(payload[0].value) : payload[0].value
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Paper":"9w8HO","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"arkVO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartDuration", ()=>ChartDuration);
parcelHelpers.export(exports, "dailyLimitWithoutBuffer", ()=>dailyLimitWithoutBuffer);
parcelHelpers.export(exports, "durationToQueryParams", ()=>durationToQueryParams);
parcelHelpers.export(exports, "chartDurationToDaysMap", ()=>chartDurationToDaysMap);
parcelHelpers.export(exports, "chartUseQueryStaleTimeMs", ()=>chartUseQueryStaleTimeMs);
parcelHelpers.export(exports, "getMonthlyWindowsDailyAverage", ()=>getMonthlyWindowsDailyAverage);
parcelHelpers.export(exports, "cumulativeSum", ()=>cumulativeSum);
parcelHelpers.export(exports, "filterHourlyActiveAccounts", ()=>filterHourlyActiveAccounts);
parcelHelpers.export(exports, "sumWindowsByStartDuration", ()=>sumWindowsByStartDuration);
var _startOfHour = require("date-fns/startOfHour");
var _isSameMonth = require("date-fns/isSameMonth");
const fiveMinutesWindowSize = 300;
const oneDayWindowSize = 86400;
var ChartDuration;
(function(ChartDuration) {
    ChartDuration["TODAY"] = "TODAY";
    ChartDuration["WEEK"] = "WEEK";
    ChartDuration["MONTH"] = "MONTH";
    ChartDuration["YEAR"] = "YEAR";
})(ChartDuration || (ChartDuration = {}));
const dailyLimitWithoutBuffer = 288 // full day for 5 minutes windows
;
const durationToQueryParams = {
    ["TODAY"]: {
        window_size_seconds: fiveMinutesWindowSize,
        window_step_seconds: fiveMinutesWindowSize,
        limit: dailyLimitWithoutBuffer + 24
    },
    ["WEEK"]: {
        window_size_seconds: oneDayWindowSize,
        window_step_seconds: oneDayWindowSize,
        limit: 7,
        offset: 1
    },
    ["MONTH"]: {
        window_size_seconds: oneDayWindowSize,
        window_step_seconds: oneDayWindowSize,
        limit: 30,
        offset: 1
    },
    ["YEAR"]: {
        window_size_seconds: oneDayWindowSize,
        window_step_seconds: oneDayWindowSize,
        limit: 365,
        offset: 1
    }
};
const chartDurationToDaysMap = {
    ["TODAY"]: 1,
    ["WEEK"]: 7,
    ["MONTH"]: 30,
    ["YEAR"]: 365
};
const chartUseQueryStaleTimeMs = durationToQueryParams["TODAY"].window_size_seconds * 1000;
const groupWindowsByMonth = (windows)=>{
    return windows?.reduce((acc, cur, index, arr)=>{
        if (index > 0 && (0, _isSameMonth.isSameMonth)(new Date(cur.window_end), new Date(arr[index - 1].window_end))) {
            acc[acc.length - 1].tx_volume += cur.tx_volume;
            acc[acc.length - 1].numberOfItemsInGroup += 1;
            return acc;
        }
        acc.push({
            window_end: cur.window_end,
            tx_volume: cur.tx_volume,
            numberOfItemsInGroup: 1
        });
        return acc;
    }, []);
};
const getMonthlyWindowsDailyAverage = (windows)=>{
    const monthlyWindows = groupWindowsByMonth(windows);
    return monthlyWindows?.map((item)=>({
            ...item,
            tx_volume: Math.round(item.tx_volume / item.numberOfItemsInGroup * 100) / 100
        }));
};
function cumulativeSum(items, accumulateField) {
    let acc = 0;
    return items.map((item)=>{
        acc += item[accumulateField];
        return {
            ...item,
            [accumulateField]: acc
        };
    });
}
const filterHourlyActiveAccounts = (windows)=>{
    return windows?.filter((value, index)=>index % 12 === 0);
};
const sumWindowsByStartDuration = (windows, sumKey, dateKey, startDurationFn)=>{
    if (!windows) return [];
    const durationMap = windows.reduce((accMap, item)=>{
        const key = startDurationFn(new Date(item[dateKey])).toISOString();
        return {
            ...accMap,
            [key]: (accMap[key] || 0) + item[sumKey]
        };
    }, {});
    // For daily charts we want to skip the first and last windows.
    // They are not full and we want to avoid chart drop.
    const filteredDurationMap = startDurationFn === (0, _startOfHour.startOfHour) ? Object.fromEntries(Object.entries(durationMap).slice(1, -1)) : durationMap;
    return Object.keys(filteredDurationMap).map((key)=>({
            [dateKey]: key,
            [sumKey]: filteredDurationMap[key]
        }));
};

},{"date-fns/startOfHour":"htuAf","date-fns/isSameMonth":"438i0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"htuAf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */ parcelHelpers.export(exports, "startOfHour", ()=>startOfHour);
var _toDateMjs = require("./toDate.mjs");
function startOfHour(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfHour;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"438i0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */ parcelHelpers.export(exports, "isSameMonth", ()=>isSameMonth);
var _toDateMjs = require("./toDate.mjs");
function isSameMonth(dateLeft, dateRight) {
    const _dateLeft = (0, _toDateMjs.toDate)(dateLeft);
    const _dateRight = (0, _toDateMjs.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
// Fallback for modularized imports:
exports.default = isSameMonth;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fLsgt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledBox", ()=>StyledBox);
parcelHelpers.export(exports, "DurationPills", ()=>DurationPills);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _chartUtils = require("../../utils/chart-utils");
var _colors = require("../../../styles/theme/colors");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        backgroundColor: (0, _colors.COLORS).brandDark,
        width: 14,
        height: 14,
        marginRight: theme.spacing(3),
        borderRadius: 4
    }));
const DurationPills = ({ handleChange, value })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const options = [
        {
            label: t("chartDuration.week"),
            value: (0, _chartUtils.ChartDuration).WEEK
        },
        {
            label: t("chartDuration.month"),
            value: (0, _chartUtils.ChartDuration).MONTH
        },
        {
            label: t("chartDuration.year"),
            value: (0, _chartUtils.ChartDuration).YEAR
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: options.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                onClick: ()=>handleChange(option.value),
                clickable: true,
                color: "secondary",
                label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "span",
                            sx: {
                                fontSize: 12
                            },
                            children: option.label
                        })
                    ]
                }),
                sx: {
                    mr: 2
                },
                variant: value === option.value ? "outlined-selected" : "outlined"
            }, option.value))
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","@mui/material/Chip":"aTO9B","@mui/material/Typography":"f5srd","../../utils/chart-utils":"arkVO","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aTO9B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chipDefault.default));
parcelHelpers.export(exports, "chipClasses", ()=>(0, _chipClassesDefault.default));
var _chip = require("./Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _chipClasses = require("./chipClasses");
var _chipClassesDefault = parcelHelpers.interopDefault(_chipClasses);
parcelHelpers.exportAll(_chipClasses, exports);
"use client";

},{"./Chip":"4c3El","./chipClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4c3El":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _cancel = require("../internal/svg-icons/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _unsupportedProp = require("../utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _chipClasses = require("./chipClasses");
var _chipClassesDefault = parcelHelpers.interopDefault(_chipClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, size, color, iconColor, onDelete, clickable, variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, _capitalizeDefault.default)(size)}`,
            `color${(0, _capitalizeDefault.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, _capitalizeDefault.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, _capitalizeDefault.default)(color)}`,
            `${variant}${(0, _capitalizeDefault.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, _capitalizeDefault.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, _capitalizeDefault.default)(size)}`,
            `avatarColor${(0, _capitalizeDefault.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, _capitalizeDefault.default)(size)}`,
            `iconColor${(0, _capitalizeDefault.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, _capitalizeDefault.default)(size)}`,
            `deleteIconColor${(0, _capitalizeDefault.default)(color)}`,
            `deleteIcon${(0, _capitalizeDefault.default)(variant)}Color${(0, _capitalizeDefault.default)(color)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _chipClasses.getChipUtilityClass), classes);
};
const ChipRoot = (0, _styledDefault.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { color, iconColor, clickable, onDelete, size, variant } = ownerState;
        return [
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles[`avatar${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles[`avatarColor${(0, _capitalizeDefault.default)(color)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles[`icon${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles[`iconColor${(0, _capitalizeDefault.default)(iconColor)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIcon${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIconColor${(0, _capitalizeDefault.default)(color)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIcon${(0, _capitalizeDefault.default)(variant)}Color${(0, _capitalizeDefault.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, _capitalizeDefault.default)(size)}`],
            styles[`color${(0, _capitalizeDefault.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, _capitalizeDefault.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, _capitalizeDefault.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, _capitalizeDefault.default)(color)}`]
        ];
    }
})(({ theme, ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, _extendsDefault.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, _chipClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, _chipClassesDefault.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, _chipClassesDefault.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, _chipClassesDefault.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, _chipClassesDefault.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, _chipClassesDefault.default).icon}`]: (0, _extendsDefault.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, _extendsDefault.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: (0, _extendsDefault.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, _chipClassesDefault.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, _chipClassesDefault.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, _chipClassesDefault.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, _chipClassesDefault.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, _chipClassesDefault.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, _chipClassesDefault.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, _chipClassesDefault.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const ChipLabel = (0, _styledDefault.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, _capitalizeDefault.default)(size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const Chip = /*#__PURE__*/ _react.forwardRef(function Chip(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className, clickable: clickableProp, color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled = false, icon: iconProp, label, onClick, onDelete, onKeyDown, onKeyUp, size = "medium", variant = "filled", tabIndex, skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const chipRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, _buttonBaseDefault.default) : ComponentProp || "div";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        disabled,
        size,
        color,
        iconColor: /*#__PURE__*/ _react.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const moreProps = component === (0, _buttonBaseDefault.default) ? (0, _extendsDefault.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ _react.isValidElement(deleteIconProp) ? /*#__PURE__*/ _react.cloneElement(deleteIconProp, {
        className: (0, _clsxDefault.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
        className: (0, _clsxDefault.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ _react.isValidElement(avatarProp)) avatar = /*#__PURE__*/ _react.cloneElement(avatarProp, {
        className: (0, _clsxDefault.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ _react.isValidElement(iconProp)) icon = /*#__PURE__*/ _react.cloneElement(iconProp, {
        className: (0, _clsxDefault.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ChipRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChipLabel, {
                className: (0, _clsxDefault.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
exports.default = Chip;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/composeClasses":"jj3MR","@mui/system/colorManipulator":"9FSVd","../internal/svg-icons/Cancel":"cambp","../utils/useForkRef":"5kA2S","../utils/unsupportedProp":"ieG2y","../utils/capitalize":"iHgWG","../ButtonBase":"1prwn","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./chipClasses":"dKP8n","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cambp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dKP8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChipUtilityClass", ()=>getChipUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getChipUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiChip", slot);
}
const chipClasses = (0, _generateUtilityClassesDefault.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
exports.default = chipClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3R3jX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardHeaderWithResponsiveActions", ()=>CardHeaderWithResponsiveActions);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _styles = require("@mui/material/styles");
const CardHeaderWithResponsiveActions = (0, _styles.styled)((0, _cardHeaderDefault.default))(({ theme })=>({
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-start",
            flexDirection: "column",
            [`.${(0, _cardHeader.cardHeaderClasses).action}`]: {
                marginTop: theme.spacing(4),
                marginBottom: theme.spacing(4)
            }
        }
    }));

},{"@mui/material/CardHeader":"dpqJL","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"a7R3w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TotalTransactions", ()=>TotalTransactions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _lineChart = require("../../components/charts/LineChart");
var _api = require("../../../oasis-nexus/api");
var _chartUtils = require("../../utils/chart-utils");
var _durationPills = require("../../components/DurationPills");
var _cardHeaderWithResponsiveActions = require("..//../components/CardHeaderWithResponsiveActions");
var _useScreensize = require("../../hooks/useScreensize");
const TotalTransactions = ({ chartContainerHeight = 450, scope })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const [chartDuration, setChartDuration] = (0, _react.useState)((0, _chartUtils.ChartDuration).MONTH);
    const statsParams = {
        ...(0, _chartUtils.durationToQueryParams)[chartDuration],
        // We want to start from the beginning of offset as cumulative sum generates a line chart that always goes up
        offset: 0
    };
    const dailyVolumeQuery = (0, _api.useGetLayerStatsTxVolume)(scope.network, scope.layer, statsParams, {
        query: {
            keepPreviousData: true,
            staleTime: (0, _chartUtils.chartUseQueryStaleTimeMs)
        }
    });
    const windows = dailyVolumeQuery.data?.data.windows ? (0, _chartUtils.cumulativeSum)(dailyVolumeQuery.data?.data.windows.slice().reverse(), "tx_volume") : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        sx: {
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithResponsiveActions.CardHeaderWithResponsiveActions), {
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _durationPills.DurationPills), {
                    handleChange: setChartDuration,
                    value: chartDuration
                }),
                disableTypography: true,
                component: "h3",
                title: t("totalTransactions.header")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                sx: {
                    height: chartContainerHeight
                },
                children: windows && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lineChart.LineChart), {
                    tooltipActiveDotRadius: 9,
                    cartesianGrid: true,
                    strokeWidth: 3,
                    dataKey: "tx_volume",
                    data: windows,
                    margin: {
                        bottom: 16,
                        top: isMobile ? 0 : 16
                    },
                    tickMargin: 16,
                    withLabels: true,
                    formatters: {
                        data: (value)=>t("totalTransactions.tooltip", {
                                value,
                                formatParams: {
                                    value: {
                                        maximumFractionDigits: 2
                                    }
                                }
                            }),
                        label: (value)=>t("common.formattedDateTime", {
                                timestamp: new Date(value)
                            })
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","../../components/charts/LineChart":"ez9P0","../../../oasis-nexus/api":"dJrPU","../../utils/chart-utils":"arkVO","../../components/DurationPills":"fLsgt","..//../components/CardHeaderWithResponsiveActions":"3R3jX","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ez9P0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineChart", ()=>LineChart);
var _jsxRuntime = require("react/jsx-runtime");
var _recharts = require("recharts");
var _colors = require("../../../styles/theme/colors");
var _react = require("react");
var _tooltip = require("./Tooltip");
var _reactI18Next = require("react-i18next");
const LineChartCmp = ({ cartesianGrid, data, dataKey, formatters, margin, strokeWidth = 2, tickMargin = 0, tooltipActiveDotRadius = 5, withLabels })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.ResponsiveContainer), {
        width: "100%",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.LineChart), {
            data: data,
            margin: margin,
            children: [
                cartesianGrid && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.CartesianGrid), {
                    vertical: false,
                    stroke: (0, _colors.COLORS).antiFlashWhite3
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Line), {
                    type: "monotone",
                    dataKey: dataKey,
                    stroke: (0, _colors.COLORS).brandDark,
                    strokeWidth: strokeWidth,
                    dot: false,
                    activeDot: {
                        r: tooltipActiveDotRadius,
                        fill: (0, _colors.COLORS).brandDark,
                        strokeWidth: tooltipActiveDotRadius * 4,
                        stroke: "#0000621A"
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.YAxis), {
                    domain: withLabels ? [
                        0,
                        "auto"
                    ] : [
                        "dataMin",
                        "dataMax"
                    ],
                    axisLine: false,
                    interval: 0,
                    tickLine: false,
                    mirror: !withLabels,
                    tick: withLabels ? {
                        fill: (0, _colors.COLORS).brandDark,
                        strokeWidth: 0
                    } : false,
                    type: "number",
                    tickMargin: tickMargin,
                    tickFormatter: (tick)=>t("common.valuePair", {
                            value: tick,
                            formatParams: {
                                value: {
                                    notation: "compact"
                                }
                            }
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Tooltip), {
                    cursor: false,
                    wrapperStyle: {
                        outline: "none"
                    },
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                        formatters: formatters
                    }),
                    offset: 15
                })
            ]
        })
    });
};
const LineChart = /*#__PURE__*/ (0, _react.memo)(LineChartCmp);

},{"react/jsx-runtime":"g88cO","recharts":"cL2Z5","../../../styles/theme/colors":"hYvW2","react":"BK2ob","./Tooltip":"iZVHC","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9P401":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeSnapshot", ()=>ParaTimeSnapshot);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _durationSelect = require("../../components/Snapshots/DurationSelect");
var _transactionsChartCard = require("./TransactionsChartCard");
var _tokenPriceCard = require("./TokenPriceCard");
var _nodes = require("./Nodes");
var _activeAccounts = require("./ActiveAccounts");
var _chartUtils = require("../../utils/chart-utils");
var _reactI18Next = require("react-i18next");
var _useConstant = require("../../hooks/useConstant");
var _config = require("../../../config");
var _content = require("../../utils/content");
var _testnetFaucet = require("./TestnetFaucet");
var _snapshot = require("app/components/Snapshots/Snapshot");
var _faucetLinks = require("../../utils/faucet-links");
const ParaTimeSnapshot = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const defaultChartDurationValue = (0, _useConstant.useConstant)(()=>(0, _chartUtils.ChartDuration).TODAY);
    const [chartDuration, setChartDuration] = (0, _react.useState)(defaultChartDurationValue);
    const paratime = (0, _content.getLayerLabels)(t)[scope.layer];
    const tokens = (0, _config.getTokensForScope)(scope);
    const mainToken = tokens[0];
    const mainTicker = mainToken.ticker;
    const faucetLink = (0, _faucetLinks.getFaucetLink)(scope.network, scope.layer, mainTicker);
    const handleDurationSelectedChange = (duration)=>{
        if (!duration) return;
        setChartDuration(duration);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _snapshot.Snapshot), {
            header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _durationSelect.DurationSelect), {
                defaultValue: defaultChartDurationValue,
                handleChange: handleDurationSelectedChange
            }),
            title: t("paraTimeSnapshot.header", {
                paratime
            }),
            scope: scope,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                    item: true,
                    xs: 22,
                    md: 6,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionsChartCard.TransactionsChartCard), {
                        scope: scope,
                        chartDuration: chartDuration
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                    item: true,
                    xs: 22,
                    md: 5,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activeAccounts.ActiveAccounts), {
                        scope: scope,
                        chartDuration: chartDuration
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                    item: true,
                    xs: 22,
                    md: 6,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nodes.Nodes), {
                        scope: scope
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _snapshot.StyledGrid), {
                    item: true,
                    xs: 22,
                    md: 5,
                    children: [
                        (0, _config.showFiatValues) && !mainToken.free && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenPriceCard.TokenPriceCard), {
                            token: mainToken
                        }),
                        faucetLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _testnetFaucet.TestnetFaucet), {
                            network: scope.network,
                            layer: scope.layer,
                            ticker: mainTicker
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","../../components/Snapshots/DurationSelect":"2oTY0","./TransactionsChartCard":"giibs","./TokenPriceCard":"63mzb","./Nodes":"fIG1r","./ActiveAccounts":"2Yshn","../../utils/chart-utils":"arkVO","react-i18next":"e210a","../../hooks/useConstant":"cQH4u","../../../config":"2PXMY","../../utils/content":"gyk1M","./TestnetFaucet":"fsDo6","app/components/Snapshots/Snapshot":"91gmN","../../utils/faucet-links":"2biO7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2oTY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DurationSelect", ()=>DurationSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _select = require("../../Select");
var _chartUtils = require("../../../utils/chart-utils");
var _reactI18Next = require("react-i18next");
const DurationSelectCmp = ({ defaultValue = (0, _chartUtils.ChartDuration).TODAY, handleChange })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const options = [
        {
            label: t("chartDuration.pastDay"),
            value: (0, _chartUtils.ChartDuration).TODAY
        },
        {
            label: t("chartDuration.pastWeek"),
            value: (0, _chartUtils.ChartDuration).WEEK
        },
        {
            label: t("chartDuration.pastMonth"),
            value: (0, _chartUtils.ChartDuration).MONTH
        },
        {
            label: t("chartDuration.pastYear"),
            value: (0, _chartUtils.ChartDuration).YEAR
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
        defaultValue: defaultValue,
        handleChange: handleChange,
        options: options
    });
};
const DurationSelect = /*#__PURE__*/ (0, _react.memo)(DurationSelectCmp);

},{"react/jsx-runtime":"g88cO","react":"BK2ob","../../Select":"cRZgF","../../../utils/chart-utils":"arkVO","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"giibs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionsChartCard", ()=>TransactionsChartCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _api = require("../../../oasis-nexus/api");
var _chartUtils = require("../../utils/chart-utils");
var _lineChart = require("../../components/charts/LineChart");
var _useScreensize = require("../../hooks/useScreensize");
var _react = require("react");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _snapshotCardDurationLabel = require("../../components/Snapshots/SnapshotCardDurationLabel");
var _percentageGain = require("../../components/PercentageGain");
var _startOfHour = require("date-fns/startOfHour");
const getLabels = (t)=>({
        [(0, _chartUtils.ChartDuration).TODAY]: t("chartDuration.lastHour"),
        [(0, _chartUtils.ChartDuration).WEEK]: t("chartDuration.lastDay"),
        [(0, _chartUtils.ChartDuration).MONTH]: t("chartDuration.lastDay"),
        [(0, _chartUtils.ChartDuration).YEAR]: t("chartDuration.lastDay")
    });
const TransactionsChartCardCmp = ({ scope, chartDuration })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const labels = getLabels(t);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const statsParams = (0, _chartUtils.durationToQueryParams)[chartDuration];
    const { data, isFetched } = (0, _api.useGetLayerStatsTxVolume)(scope.network, scope.layer, statsParams, {
        query: {
            staleTime: (0, _chartUtils.chartUseQueryStaleTimeMs)
        }
    });
    const isDailyChart = isFetched && chartDuration === (0, _chartUtils.ChartDuration).TODAY;
    const windows = data?.data?.windows;
    const lineChartData = isDailyChart ? (0, _chartUtils.sumWindowsByStartDuration)(windows, "tx_volume", "window_end", (0, _startOfHour.startOfHour)) : windows;
    const formatParams = isDailyChart ? {
        timestamp: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric"
        }
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: t("common.transactions"),
        badge: lineChartData && lineChartData.length >= 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _percentageGain.PercentageGain), {
            earliestValue: lineChartData[lineChartData.length - 1].tx_volume,
            latestValue: lineChartData[0].tx_volume
        }),
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCardDurationLabel.SnapshotCardDurationLabel), {
            label: labels[chartDuration],
            value: lineChartData?.length && lineChartData[0].tx_volume
        }),
        children: lineChartData && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lineChart.LineChart), {
            dataKey: "tx_volume",
            data: lineChartData.slice().reverse(),
            margin: {
                left: 0,
                right: isMobile ? 80 : 40
            },
            formatters: {
                data: (value)=>isDailyChart ? t("transactionStats.perHour", {
                        value: value.toLocaleString()
                    }) : t("transactionStats.perDay", {
                        value: value.toLocaleString()
                    }),
                label: (value)=>t("common.formattedDateTime", {
                        timestamp: new Date(value),
                        formatParams
                    })
            }
        })
    });
};
const TransactionsChartCard = /*#__PURE__*/ (0, _react.memo)(TransactionsChartCardCmp);

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../../oasis-nexus/api":"dJrPU","../../utils/chart-utils":"arkVO","../../components/charts/LineChart":"ez9P0","../../hooks/useScreensize":"2HEhN","react":"BK2ob","../../components/Snapshots/SnapshotCard":"b3UOK","../../components/Snapshots/SnapshotCardDurationLabel":"aukqY","../../components/PercentageGain":"xAdzo","date-fns/startOfHour":"htuAf","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b3UOK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCard", ()=>StyledCard);
parcelHelpers.export(exports, "SnapshotCard", ()=>SnapshotCard);
parcelHelpers.export(exports, "SnapshotTextCard", ()=>SnapshotTextCard);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _cardActions = require("@mui/material/CardActions");
var _cardActionsDefault = parcelHelpers.interopDefault(_cardActions);
var _styles = require("@mui/material/styles");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("styles/theme/colors");
const StyledCard = (0, _styles.styled)((0, _cardDefault.default))(({ theme })=>({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-between",
        "&": {
            padding: 0,
            margin: 0
        },
        height: 186
    }));
const StyledCardContent = (0, _styles.styled)((0, _cardContentDefault.default), {
    shouldForwardProp: (prop)=>prop !== "withContentPadding"
})(({ theme, withContentPadding })=>({
        position: "relative",
        paddingTop: theme.spacing(withContentPadding ? 4 : 0),
        height: "100%"
    }));
const SnapshotCard = ({ badge, children, title, label, withContentPadding = true, withConstantHeight = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCard, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                component: "h5",
                title: title,
                sx: {
                    pb: 0,
                    pl: 4,
                    pt: 4
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCardContent, {
                withContentPadding: withContentPadding,
                children: children
            }),
            (badge || label || withConstantHeight) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardActionsDefault.default), {
                sx: {
                    minHeight: 60
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        px: 3,
                        pb: 3
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: badge
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            variant: "h2",
                            sx: {
                                fontWeight: 400,
                                flex: 1
                            },
                            children: label
                        })
                    ]
                })
            })
        ]
    });
};
const SnapshotTextCard = ({ children, label, title })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SnapshotCard, {
        title: title,
        label: label,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "32px",
                    fontWeight: 700,
                    color: (0, _colors.COLORS).brandDark,
                    flex: 1,
                    textAlign: "center",
                    paddingLeft: 4,
                    paddingRight: 4
                },
                children: children
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/CardActions":"k0kVW","@mui/material/styles":"51PGx","@mui/material/Typography":"f5srd","styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aukqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnapshotCardDurationLabel", ()=>SnapshotCardDurationLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
const SnapshotCardDurationLabel = ({ label, value })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 3
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: 12,
                    color: (0, _colors.COLORS).grayMedium
                },
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: "inherit"
                },
                children: value.toLocaleString()
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"xAdzo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PercentageGain", ()=>PercentageGain);
var _jsxRuntime = require("react/jsx-runtime");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _north = require("@mui/icons-material/North");
var _northDefault = parcelHelpers.interopDefault(_north);
var _south = require("@mui/icons-material/South");
var _southDefault = parcelHelpers.interopDefault(_south);
const PercentageGain = ({ earliestValue, latestValue })=>{
    const ratio = (latestValue - earliestValue) / earliestValue;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
        color: ratio >= 0 ? "success" : "error",
        icon: ratio >= 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _northDefault.default), {
            sx: {
                fontSize: "14px"
            }
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _southDefault.default), {
            sx: {
                fontSize: "14px"
            }
        }),
        label: new Intl.NumberFormat(undefined, {
            style: "percent",
            maximumFractionDigits: 2,
            signDisplay: "never"
        }).format(ratio)
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Chip":"aTO9B","@mui/icons-material/North":"8tKHu","@mui/icons-material/South":"v45DF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8tKHu":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("8e924246407f7720");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("1a4a662e759410c8"));
var _jsxRuntime = require("ac4b11ea3178ce03");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m5 9 1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7z"
}), "North");

},{"8e924246407f7720":"hykHy","1a4a662e759410c8":"gQLSP","ac4b11ea3178ce03":"g88cO"}],"v45DF":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("fd7d4af9d9106c4d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("226f513fae961a5f"));
var _jsxRuntime = require("f727de925da57772");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m19 15-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7z"
}), "South");

},{"fd7d4af9d9106c4d":"hykHy","226f513fae961a5f":"gQLSP","f727de925da57772":"g88cO"}],"63mzb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenPriceCard", ()=>TokenPriceCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("@mui/material/styles");
var _coinGeckoReferral = require("../../components/CoinGeckoReferral");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _api = require("../../../coin-gecko/api");
var _colors = require("../../../styles/theme/colors");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _smallTokenLogo = require("../../components/logo/SmallTokenLogo");
var _config = require("../../../config");
var _useScopeParam = require("../../hooks/useScopeParam");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        position: "absolute",
        top: `-${theme.spacing(2)}`,
        left: theme.spacing(4)
    }));
const TokenPriceCard = ({ token })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useScopeParam)();
    const fiatCurrency = (0, _config.getFiatCurrencyForScope)(scope);
    const priceQuery = (0, _api.useTokenPrice)(token.ticker, fiatCurrency);
    const formatFiatParams = {
        value: {
            currency: fiatCurrency,
            maximumFractionDigits: 5
        }
    };
    const priceString = priceQuery.price ? t("common.fiatValueInUSD", {
        value: priceQuery.price,
        formatParams: formatFiatParams
    }) : "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: "6px"
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smallTokenLogo.SmallTokenLogo), {
                    ticker: token.ticker
                }),
                t("tokenPrice.header", {
                    ticker: token.ticker
                })
            ]
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coinGeckoReferral.CoinGeckoReferral), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            variant: "h2",
                            fontWeight: 700,
                            fontSize: "32px",
                            color: (0, _colors.COLORS).brandDark
                        },
                        children: priceString
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/styles":"51PGx","../../components/CoinGeckoReferral":"3Cord","../../components/Snapshots/SnapshotCard":"b3UOK","../../../coin-gecko/api":"2VRI5","../../../styles/theme/colors":"hYvW2","@mui/material/Typography":"f5srd","../../components/logo/SmallTokenLogo":"6YfVp","../../../config":"2PXMY","../../hooks/useScopeParam":"kKMKx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6YfVp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallTokenLogo", ()=>SmallTokenLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _ticker = require("../../../types/ticker");
var _smallOasisLogo = require("./SmallOasisLogo");
var _euroePng = require("../../../../public/euroe.png");
var _euroePngDefault = parcelHelpers.interopDefault(_euroePng);
const SmallTokenLogo = ({ ticker })=>{
    switch(ticker){
        case (0, _ticker.Ticker).ROSE:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smallOasisLogo.SmallOasisLogo), {});
        case (0, _ticker.Ticker).EUROe:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _euroePngDefault.default),
                width: 25,
                alt: ticker
            });
        default:
            return null;
    }
};

},{"react/jsx-runtime":"g88cO","../../../types/ticker":"898HF","./SmallOasisLogo":"4PoJr","../../../../public/euroe.png":"cGAI9","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4PoJr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SmallOasisLogo", ()=>SmallOasisLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _iconBlue192Png = require("../../../../public/Icon Blue 192.png");
var _iconBlue192PngDefault = parcelHelpers.interopDefault(_iconBlue192Png);
const SmallOasisLogo = ({ size = 25 })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        src: (0, _iconBlue192PngDefault.default),
        height: size,
        width: size,
        alt: ""
    });

},{"react/jsx-runtime":"g88cO","../../../../public/Icon Blue 192.png":"aRxf4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aRxf4":[function(require,module,exports) {
module.exports = require("1b30d40b9410b710").getBundleURL("sif1r") + "Icon Blue 192.195958a8.png";

},{"1b30d40b9410b710":"ccgWN"}],"cGAI9":[function(require,module,exports) {
module.exports = require("5d6965d7adf8a0c2").getBundleURL("sif1r") + "euroe.91b1e510.png";

},{"5d6965d7adf8a0c2":"ccgWN"}],"fIG1r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nodes", ()=>Nodes);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _offlineBolt = require("@mui/icons-material/OfflineBolt");
var _offlineBoltDefault = parcelHelpers.interopDefault(_offlineBolt);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _colors = require("../../../styles/theme/colors");
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _theme = require("../../../styles/theme");
var _config = require("../../../config");
const Nodes = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const runtimeStatusQuery = (0, _api.useGetRuntimeStatus)(scope.network, scope.layer);
    const activeNodes = runtimeStatusQuery.data?.data?.active_nodes;
    const hasActiveNodes = true // temporary workaround for BE bug
    ;
    // const hasActiveNodes = activeNodes !== 0 // This includes undefined while loading
    const title = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            pr: 4
        },
        children: [
            t("nodes.title"),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                arrow: true,
                placement: "top",
                title: hasActiveNodes ? t("nodes.tooltip") : t("nodes.unknown"),
                enterDelay: (0, _theme.tooltipDelay),
                enterNextDelay: (0, _theme.tooltipDelay),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {
                    htmlColor: (0, _colors.COLORS).brandDark
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: runtimeStatusQuery.isFetched && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offlineBoltDefault.default), {
                        fontSize: "large",
                        sx: {
                            color: (0, _colors.COLORS).eucalyptus,
                            mr: 3
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            fontSize: "48px",
                            fontWeight: 700,
                            color: hasActiveNodes ? (0, _colors.COLORS).brandDark : (0, _colors.COLORS).grayMedium
                        },
                        children: hasActiveNodes ? t("nodes.value", {
                            value: activeNodes || (0, _config.paraTimesConfig)[scope.layer][scope.network].activeNodes
                        }) : "-"
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/icons-material/OfflineBolt":"8EZOK","@mui/icons-material/Info":"kPVDs","../../components/Snapshots/SnapshotCard":"b3UOK","../../../styles/theme/colors":"hYvW2","../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","@mui/material/Tooltip":"3RLHy","../../../styles/theme":"i3yrR","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8EZOK":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("ff45bf98925162bb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("80fabfe97c85a868"));
var _jsxRuntime = require("cc3d7d609db45722");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02M11.48 20v-6.26H8L13 4v6.26h3.35z"
}), "OfflineBolt");

},{"ff45bf98925162bb":"hykHy","80fabfe97c85a868":"gQLSP","cc3d7d609db45722":"g88cO"}],"2Yshn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActiveAccountsWindows", ()=>getActiveAccountsWindows);
parcelHelpers.export(exports, "getChartLabelFormatParams", ()=>getChartLabelFormatParams);
parcelHelpers.export(exports, "ActiveAccounts", ()=>ActiveAccounts);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _startOfMonth = require("date-fns/startOfMonth");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _snapshotCardDurationLabel = require("../../components/Snapshots/SnapshotCardDurationLabel");
var _barChart = require("../../components/charts/BarChart");
var _api = require("../../../oasis-nexus/api");
var _chartUtils = require("../../utils/chart-utils");
const getActiveAccountsWindows = (duration, windows)=>{
    switch(duration){
        case (0, _chartUtils.ChartDuration).TODAY:
            return (0, _chartUtils.filterHourlyActiveAccounts)(windows);
        case (0, _chartUtils.ChartDuration).YEAR:
            return (0, _chartUtils.sumWindowsByStartDuration)(windows, "active_accounts", "window_end", (0, _startOfMonth.startOfMonth));
        default:
            return windows;
    }
};
const getChartLabelFormatParams = (duration)=>{
    switch(duration){
        case (0, _chartUtils.ChartDuration).TODAY:
            return {
                timestamp: {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric"
                }
            };
        case (0, _chartUtils.ChartDuration).YEAR:
            return {
                timestamp: {
                    year: "numeric",
                    month: "long"
                }
            };
        default:
            return undefined;
    }
};
const getLabels = (t)=>({
        [(0, _chartUtils.ChartDuration).TODAY]: t("chartDuration.lastHour"),
        [(0, _chartUtils.ChartDuration).WEEK]: t("chartDuration.lastDay"),
        [(0, _chartUtils.ChartDuration).MONTH]: t("chartDuration.lastDay"),
        [(0, _chartUtils.ChartDuration).YEAR]: t("chartDuration.lastMonth")
    });
const ActiveAccounts = ({ scope, chartDuration })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const labels = getLabels(t);
    const { limit, window_step_seconds } = {
        ...(0, _chartUtils.durationToQueryParams)[chartDuration],
        // By default we fetch data with additional buffer, but it does not apply to active accounts.
        // Active accounts daily windows are overlapping, so we cannot sum windows like in other daily charts.
        limit: chartDuration === (0, _chartUtils.ChartDuration).TODAY ? (0, _chartUtils.dailyLimitWithoutBuffer) : (0, _chartUtils.durationToQueryParams)[chartDuration].limit
    };
    const activeAccountsQuery = (0, _api.useGetLayerStatsActiveAccounts)(scope.network, scope.layer, {
        limit,
        window_step_seconds
    }, {
        query: {
            keepPreviousData: true,
            staleTime: (0, _chartUtils.chartUseQueryStaleTimeMs)
        }
    });
    const weeklyChart = activeAccountsQuery.isFetched && chartDuration === (0, _chartUtils.ChartDuration).WEEK;
    const windows = activeAccountsQuery.data?.data?.windows && getActiveAccountsWindows(chartDuration, activeAccountsQuery.data?.data?.windows);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: t("activeAccounts.title"),
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCardDurationLabel.SnapshotCardDurationLabel), {
            label: labels[chartDuration],
            value: windows?.length && windows[0].active_accounts
        }),
        children: windows && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _barChart.BarChart), {
            barSize: !weeklyChart ? 8 : undefined,
            data: windows.slice().reverse(),
            dataKey: "active_accounts",
            formatters: {
                data: (value)=>t("activeAccounts.tooltip", {
                        value
                    }),
                label: (value)=>t("common.formattedDateTime", {
                        timestamp: new Date(value),
                        formatParams: getChartLabelFormatParams(chartDuration)
                    })
            },
            withBarBackground: true
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","date-fns/startOfMonth":"kE9oR","../../components/Snapshots/SnapshotCard":"b3UOK","../../components/Snapshots/SnapshotCardDurationLabel":"aukqY","../../components/charts/BarChart":"1e1h7","../../../oasis-nexus/api":"dJrPU","../../utils/chart-utils":"arkVO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kE9oR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfMonth", ()=>startOfMonth);
var _toDateMjs = require("./toDate.mjs");
function startOfMonth(date) {
    const _date = (0, _toDateMjs.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfMonth;

},{"./toDate.mjs":"3SqwM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fsDo6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TestnetFaucet", ()=>TestnetFaucet);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _snapshotCardExternalLink = require("../../components/Snapshots/SnapshotCardExternalLink");
var _faucetLinks = require("../../utils/faucet-links");
const TestnetFaucet = ({ network, layer, ticker })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const link = (0, _faucetLinks.getFaucetLink)(network, layer, ticker);
    return link ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCardExternalLink.SnapshotCardExternalLink), {
        description: t("testnetFaucet.description"),
        label: t("testnetFaucet.request"),
        title: t("testnetFaucet.header"),
        url: link
    }) : null;
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Snapshots/SnapshotCardExternalLink":"3JVAB","../../utils/faucet-links":"2biO7","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3JVAB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnapshotCardExternalLink", ()=>SnapshotCardExternalLink);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _styles = require("@mui/material/styles");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _colors = require("../../../styles/theme/colors");
var _url = require("app/utils/url");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        gap: theme.spacing(5),
        padding: `0 ${theme.spacing(4)} ${theme.spacing(4)}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "space-between"
    }));
const SnapshotCardExternalLink = ({ description, label, title, url })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: title,
        withContentPadding: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    sx: {
                        fontSize: "12px",
                        color: (0, _colors.COLORS).grayMedium
                    },
                    children: description
                }),
                url && (0, _url.hasValidProtocol)(url) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    color: "secondary",
                    variant: "outlined",
                    children: label
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Button":"h2G5p","@mui/material/styles":"51PGx","@mui/material/Typography":"f5srd","../../components/Snapshots/SnapshotCard":"b3UOK","../../../styles/theme/colors":"hYvW2","app/utils/url":"bmAGl","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bmAGl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasValidProtocol", ()=>hasValidProtocol);
parcelHelpers.export(exports, "getHostname", ()=>getHostname);
const validProtocols = [
    "http:",
    "https:",
    "ftp:",
    "ipfs:",
    "data:",
    "mailto:"
];
const hasValidProtocol = (url)=>{
    if (!url) return false;
    try {
        const parsedUrl = new URL(url);
        return validProtocols.includes(parsedUrl.protocol);
    } catch (error) {
        return false;
    }
};
const getHostname = (url)=>{
    if (!url) return "";
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname;
    } catch (error) {
        return "";
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2biO7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFaucetLink", ()=>getFaucetLink);
var _ticker = require("types/ticker");
var _network = require("../../types/network");
var _api = require("../../oasis-nexus/api");
var _externalLinks = require("./externalLinks");
const faucetLinks = {
    [(0, _network.Network).testnet]: {
        [(0, _api.Layer).consensus]: {
            [(0, _ticker.Ticker).TEST]: (0, _externalLinks.faucets).oasisTestnet
        },
        [(0, _api.Layer).emerald]: {
            [(0, _ticker.Ticker).TEST]: `${(0, _externalLinks.faucets).oasisTestnet}?paratime=emerald`
        },
        [(0, _api.Layer).sapphire]: {
            [(0, _ticker.Ticker).TEST]: `${(0, _externalLinks.faucets).oasisTestnet}?paratime=sapphire`
        },
        [(0, _api.Layer).cipher]: {
            [(0, _ticker.Ticker).TEST]: `${(0, _externalLinks.faucets).oasisTestnet}?paratime=cipher`
        },
        [(0, _api.Layer).pontusx]: {
            [(0, _ticker.Ticker).EUROe]: `mailto:contact@delta-dao.com?subject=${encodeURIComponent("Request test tokens")}`
        }
    }
};
const getFaucetLink = (network, layer, ticker)=>faucetLinks[network]?.[layer]?.[ticker];

},{"types/ticker":"898HF","../../types/network":"f0o8N","../../oasis-nexus/api":"dJrPU","./externalLinks":"d3W8q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"91gmN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Snapshot", ()=>Snapshot);
parcelHelpers.export(exports, "StyledGrid", ()=>StyledGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _appendMobileSearch = require("../../components/AppendMobileSearch");
const Snapshot = ({ children, header, scope, title })=>{
    const theme = (0, _styles.useTheme)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    mb: 4
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    item: true,
                    xs: 12,
                    sx: {
                        px: isMobile ? 4 : 0
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appendMobileSearch.AppendMobileSearch), {
                        scope: scope,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                mb: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    variant: "h2",
                                    sx: {
                                        color: theme.palette.layout.main,
                                        fontWeight: 700,
                                        mr: 3,
                                        mb: isMobile ? 4 : 0
                                    },
                                    children: title
                                }),
                                header
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                rowSpacing: 1,
                columnSpacing: 4,
                columns: 22,
                children: children
            })
        ]
    });
};
const StyledGrid = (0, _styles.styled)((0, _gridDefault.default))(({ theme })=>({
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: theme.spacing(4)
        },
        [theme.breakpoints.up("sm")]: {
            paddingBottom: theme.spacing(5)
        }
    }));

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","@mui/material/Grid":"bu56N","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","../../components/AppendMobileSearch":"7MClM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hieAl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TopTokens", ()=>TopTokens);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _errors = require("../../../types/errors");
var _routeUtils = require("../../utils/route-utils");
var _tokenList = require("../../components/Tokens/TokenList");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const TopTokens = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const tokensQuery = (0, _api.useGetRuntimeEvmTokens)(network, layer, {
        limit
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("common.tokens"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getTopTokensRoute(scope),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenList), {
                    tokens: tokensQuery.data?.data.evm_tokens,
                    isLoading: tokensQuery.isLoading,
                    limit: limit,
                    pagination: false
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","../../../types/errors":"gdpNU","../../utils/route-utils":"b2kKi","../../components/Tokens/TokenList":"7bRlg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7bRlg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenTypeTag", ()=>TokenTypeTag);
parcelHelpers.export(exports, "TokenList", ()=>TokenList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _table = require("../../components/Table");
var _accountLink = require("../Account/AccountLink");
var _tokenLink = require("./TokenLink");
var _copyToClipboard = require("../CopyToClipboard");
var _contractVerificationIcon = require("../ContractVerificationIcon");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tokens = require("../../../types/tokens");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
var _roundedBalance = require("../RoundedBalance");
const TokenTypeTag = ({ tokenType, sx = {} })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            background: (0, _tokens.tokenBackgroundColor)[tokenType ?? "missing"],
            border: `1px solid ${(0, _tokens.tokenBorderColor)[tokenType ?? "missing"]}`,
            display: "inline-block",
            borderRadius: 2,
            py: 1,
            px: 3,
            fontSize: 12,
            height: (0, _contractVerificationIcon.verificationIconBoxHeight),
            verticalAlign: "middle",
            textAlign: "center",
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                children: (0, _tokens.getTokenTypeDescription)(t, tokenType)
            }),
            "\xa0",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                color: (0, _colors.COLORS).grayMedium,
                children: t("common.parentheses", {
                    subject: (0, _tokens.getTokenTypeStrictName)(t, tokenType ?? "missing")
                })
            })
        ]
    });
};
const TokenList = (props)=>{
    const { isLoading, tokens, pagination, limit } = props;
    const { t } = (0, _reactI18Next.useTranslation)();
    const tableColumns = [
        {
            key: "index",
            content: ""
        },
        {
            key: "name",
            content: t("common.name")
        },
        {
            key: "type",
            content: t("common.type")
        },
        {
            key: "contract",
            content: t("common.smartContract")
        },
        {
            key: "verification",
            content: t("contract.verification.title")
        },
        {
            key: "holders",
            content: t("tokens.holders"),
            align: (0, _table.TableCellAlign).Right
        },
        {
            key: "supply",
            content: t("tokens.totalSupply"),
            align: (0, _table.TableCellAlign).Right
        },
        {
            key: "ticker",
            content: t("common.ticker"),
            align: (0, _table.TableCellAlign).Left
        }
    ];
    const tableRows = tokens?.map((token, index)=>{
        return {
            key: token.contract_addr,
            data: [
                {
                    content: ((pagination ? (pagination.selectedPage - 1) * pagination.rowsPerPage : 0) + index + 1).toLocaleString(),
                    key: "index"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
                        scope: token,
                        address: token.eth_contract_addr ?? token.contract_addr,
                        name: token.name
                    }),
                    key: "name"
                },
                {
                    key: "type",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            pr: 4
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenTypeTag, {
                            tokenType: token.type,
                            sx: {
                                width: "100%"
                            }
                        })
                    })
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                scope: token,
                                address: token.eth_contract_addr ?? token.contract_addr,
                                alwaysTrim: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                value: token.eth_contract_addr ?? token.contract_addr
                            })
                        ]
                    }),
                    key: "contactAddress"
                },
                {
                    key: "verification",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            display: "inline-flex",
                            verticalAlign: "middle",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.VerificationIcon), {
                            address_eth: token.eth_contract_addr,
                            verified: token.is_verified,
                            noLink: true
                        })
                    })
                },
                {
                    content: token.num_holders.toLocaleString(),
                    key: "holdersCount",
                    align: (0, _table.TableCellAlign).Right
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        compactLargeNumbers: true,
                        value: token.total_supply
                    }),
                    key: "supply",
                    align: (0, _table.TableCellAlign).Right
                },
                {
                    content: token.symbol,
                    key: "ticker",
                    align: (0, _table.TableCellAlign).Left
                }
            ]
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("common.tokens"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Table":"j3qb1","../Account/AccountLink":"43Jgs","./TokenLink":"ksoba","../CopyToClipboard":"iTQvM","../ContractVerificationIcon":"6tjz3","@mui/material/Box":"4d7LG","../../../types/tokens":"38Dxq","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","../RoundedBalance":"af34T","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6tjz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "verificationIconBoxHeight", ()=>verificationIconBoxHeight);
parcelHelpers.export(exports, "ContractVerificationIcon", ()=>ContractVerificationIcon);
parcelHelpers.export(exports, "VerificationIcon", ()=>VerificationIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
const statusBgColor = {
    verified: (0, _colors.COLORS).honeydew,
    unverified: (0, _colors.COLORS).linen
};
const statusFgColor = {
    verified: (0, _colors.COLORS).brandExtraDark,
    unverified: (0, _colors.COLORS).brandExtraDark
};
const statusIcon = {
    verified: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {
        color: "success",
        fontSize: "small"
    }),
    unverified: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
        color: "error",
        fontSize: "small"
    })
};
const verificationIconBoxHeight = 28;
const StyledPill = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "verified" && prop !== "address_eth"
})(({ verified })=>{
    const status = verified ? "verified" : "unverified";
    return {
        display: "flex",
        flexShrink: 0,
        justifyContent: "center",
        height: verificationIconBoxHeight,
        fontSize: "12px",
        backgroundColor: statusBgColor[status],
        color: statusFgColor[status],
        borderRadius: 10,
        padding: 4,
        paddingLeft: 10,
        paddingRight: 5,
        "&&": {
            textDecoration: "none"
        }
    };
});
const Waiting = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
        variant: "text",
        sx: {
            display: "inline-block",
            width: "100%",
            height: verificationIconBoxHeight
        }
    });
const ContractVerificationIcon = ({ account, noLink = false })=>{
    if (!account) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Waiting, {});
    const verified = !!account.evm_contract?.verification;
    const address_eth = account.address_eth;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VerificationIcon, {
        address_eth: address_eth,
        verified: verified,
        noLink: noLink
    });
};
const VerificationIcon = ({ address_eth, verified, noLink = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [explainDelay, setExplainDelay] = (0, _react.useState)(false);
    const status = verified ? "verified" : "unverified";
    const statusLabel = {
        verified: t("contract.verification.isVerified"),
        unverified: t("contract.verification.isNotVerified")
    };
    const linkProps = {
        href: `https://sourcify.dev/#/lookup/${address_eth}`,
        rel: "noopener noreferrer",
        target: "_blank",
        sx: {
            fontWeight: 400,
            color: "inherit",
            textDecoration: "underline"
        },
        onClick: verified ? undefined : ()=>setExplainDelay(true)
    };
    const Component = noLink ? (0, _boxDefault.default) : (0, _linkDefault.default);
    const componentProps = noLink ? {} : linkProps;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPill, {
                component: Component,
                verified: verified,
                address_eth: address_eth,
                ...componentProps,
                children: [
                    statusLabel[status],
                    "\xa0 \xa0",
                    statusIcon[status]
                ]
            }),
            "\xa0 \xa0",
            !noLink && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "12px",
                    color: (0, _colors.COLORS).brandExtraDark
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        t: t,
                        i18nKey: verified ? "contract.verification.openInSourcify" : "contract.verification.verifyInSourcify",
                        components: {
                            SourcifyLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                ...linkProps
                            })
                        }
                    }),
                    " ",
                    explainDelay && t("contract.verification.explainVerificationDelay")
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Cancel":"l7K6K","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","@mui/material/Link":"fTbCF","@mui/material/Typography":"f5srd","@mui/material/Skeleton":"i7d9z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"38Dxq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTokenTypeDescription", ()=>getTokenTypeDescription);
parcelHelpers.export(exports, "tokenBackgroundColor", ()=>tokenBackgroundColor);
parcelHelpers.export(exports, "tokenBorderColor", ()=>tokenBorderColor);
parcelHelpers.export(exports, "getTokenTypePluralDescription", ()=>getTokenTypePluralDescription);
parcelHelpers.export(exports, "getTokenTypeStrictName", ()=>getTokenTypeStrictName);
parcelHelpers.export(exports, "getTokenTypePluralName", ()=>getTokenTypePluralName);
var _errors = require("./errors");
var _colors = require("../styles/theme/colors");
const getTokenTypeDescription = (t, tokenType)=>{
    switch(tokenType ?? "missing"){
        case "missing":
            return t("common.missing");
        case "ERC20":
            return t("common.token");
        case "ERC721":
            return t("common.nft");
        default:
            (0, _errors.exhaustedTypeWarning)("Unknown token type", tokenType);
            return "???";
    }
};
const tokenBackgroundColor = {
    missing: (0, _colors.COLORS).errorIndicatorBackground,
    ERC20: (0, _colors.COLORS).brandMedium15,
    ERC721: (0, _colors.COLORS).pink15
};
const tokenBorderColor = {
    missing: (0, _colors.COLORS).pink,
    ERC20: (0, _colors.COLORS).brandMedium,
    ERC721: (0, _colors.COLORS).pink
};
const getTokenTypePluralDescription = (t, tokenType)=>{
    switch(tokenType){
        case "ERC20":
            return t("common.tokens");
        case "ERC721":
            return t("common.nfts");
        default:
            (0, _errors.exhaustedTypeWarning)("Unknown token type", tokenType);
            return "???";
    }
};
const getTokenTypeStrictName = (t, tokenType)=>{
    switch(tokenType){
        case "missing":
            return t("common.missing");
        case "ERC20":
            return t("account.ERC20");
        case "ERC721":
            return t("account.ERC721");
        default:
            (0, _errors.exhaustedTypeWarning)("Unknown token type", tokenType);
            return tokenType;
    }
};
const getTokenTypePluralName = (t, tokenType)=>t("tokens.typeDescription", {
        spec: getTokenTypeStrictName(t, tokenType),
        description: getTokenTypePluralDescription(t, tokenType)
    });

},{"./errors":"gdpNU","../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"94Czq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRuntimeAccountDetailsProps", ()=>useRuntimeAccountDetailsProps);
parcelHelpers.export(exports, "RuntimeAccountDetailsPage", ()=>RuntimeAccountDetailsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _pageLayout = require("../../components/PageLayout");
var _routerTabs = require("../../components/RouterTabs");
var _api = require("../../../coin-gecko/api");
var _api1 = require("../../../oasis-nexus/api");
var _accountTokensCard = require("./AccountTokensCard");
var _hook = require("./hook");
var _useScopeParam = require("../../hooks/useScopeParam");
var _contractCodeCard = require("./ContractCodeCard");
var _hook1 = require("../TokenDashboardPage/hook");
var _accountTokenTransfersCard = require("./AccountTokenTransfersCard");
var _tokens = require("../../../types/tokens");
var _accountDetailsCard = require("./AccountDetailsCard");
var _accountEventsCard = require("./AccountEventsCard");
var _dappBanner = require("../../components/DappBanner");
var _config = require("../../../config");
const useRuntimeAccountDetailsProps = ()=>(0, _reactRouterDom.useOutletContext)();
const RuntimeAccountDetailsPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { address } = (0, _reactRouterDom.useLoaderData)();
    const { account, isLoading: isAccountLoading, isError } = (0, _hook.useAccount)(scope, address);
    const isContract = !!account?.evm_contract;
    const { token, isLoading: isTokenLoading } = (0, _hook1.useTokenInfo)(scope, address, isContract);
    const tokenPrices = (0, _api.useAllTokenPrices)((0, _config.getFiatCurrencyForScope)(scope));
    const { isLoading: areEventsLoading, isError: isEventsError, events } = (0, _hook.useAccountEvents)(scope, address);
    const tokenTransfersLink = (0, _reactRouterDom.useHref)(`token-transfers#${(0, _accountTokenTransfersCard.accountTokenTransfersContainerId)}`);
    const erc20Link = (0, _reactRouterDom.useHref)(`tokens/erc-20#${(0, _accountTokensCard.accountTokenContainerId)}`);
    const erc721Link = (0, _reactRouterDom.useHref)(`tokens/erc-721#${(0, _accountTokensCard.accountTokenContainerId)}`);
    const txLink = (0, _reactRouterDom.useHref)("");
    const showCode = isContract;
    const codeLink = (0, _reactRouterDom.useHref)(`code#${(0, _contractCodeCard.contractCodeContainerId)}`);
    const isLoading = isAccountLoading || isTokenLoading;
    const context = {
        scope,
        address,
        account
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountDetailsCard.AccountDetailsCard), {
                isLoading: isLoading,
                isError: isError,
                isContract: isContract,
                account: account,
                token: token,
                tokenPrices: tokenPrices
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dappBanner.DappBanner), {
                scope: scope,
                ethAddress: account?.address_eth
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routerTabs.RouterTabs), {
                tabs: [
                    {
                        label: t("common.transactions"),
                        to: txLink
                    },
                    {
                        label: t("common.transfers"),
                        to: tokenTransfersLink
                    },
                    {
                        label: (0, _tokens.getTokenTypePluralName)(t, (0, _api1.EvmTokenType).ERC20),
                        to: erc20Link
                    },
                    {
                        label: (0, _tokens.getTokenTypePluralName)(t, (0, _api1.EvmTokenType).ERC721),
                        to: erc721Link
                    },
                    {
                        label: t("contract.code"),
                        to: codeLink,
                        visible: showCode
                    }
                ],
                context: context
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountEventsCard.AccountEventsCard), {
                scope: scope,
                isLoading: areEventsLoading,
                isError: isEventsError,
                events: events
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","../../components/PageLayout":"24SOU","../../components/RouterTabs":"dUetQ","../../../coin-gecko/api":"2VRI5","../../../oasis-nexus/api":"dJrPU","./AccountTokensCard":"iagXb","./hook":"iVoy2","../../hooks/useScopeParam":"kKMKx","./ContractCodeCard":"ii2WJ","../TokenDashboardPage/hook":"iNjez","./AccountTokenTransfersCard":"uJl44","../../../types/tokens":"38Dxq","./AccountDetailsCard":"fvb2X","./AccountEventsCard":"2Sh7o","../../components/DappBanner":"dtzTP","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dUetQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouterTabs", ()=>RouterTabs);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _nonScrollingRouterLink = require("../NonScrollingRouterLink");
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
function getPathname(tab) {
    return new URL(tab.to, "https://a.b").pathname;
}
function RouterTabs({ tabs, context }) {
    const { pathname } = (0, _reactRouterDom.useLocation)();
    let targetTab = tabs.find((tab)=>getPathname(tab) === pathname);
    const matches = (0, _reactRouterDom.useMatches)();
    if (!targetTab) {
        /// the last index is the current route, -2 is the first parent in route hierarchy
        const parentPathname = matches?.at(-2)?.pathname;
        targetTab = tabs.find((tab)=>getPathname(tab) === parentPathname);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
                value: targetTab?.to,
                variant: "scrollable",
                scrollButtons: false,
                children: tabs.filter((tab)=>tab === targetTab || tab.visible !== false).map((tab)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
                        component: (0, _nonScrollingRouterLink.NonScrollingRouterLink),
                        value: tab.to,
                        label: tab.label,
                        to: tab.to
                    }, tab.to))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {
                context: context
            })
        ]
    });
}

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","../NonScrollingRouterLink":"bCac0","@mui/material/Tabs":"iZ9Ze","@mui/material/Tab":"3JDbc","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bCac0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonScrollingRouterLink", ()=>NonScrollingRouterLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
const NonScrollingRouterLink = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        ...props,
        preventScrollReset: true,
        ref: ref
    }));

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iZ9Ze":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "tabsClasses", ()=>(0, _tabsClassesDefault.default));
var _tabs = require("./Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tabsClasses = require("./tabsClasses");
var _tabsClassesDefault = parcelHelpers.interopDefault(_tabsClasses);
parcelHelpers.exportAll(_tabsClasses, exports);
"use client";

},{"./Tabs":"2cbWE","./tabsClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2cbWE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _rtlProvider = require("@mui/system/RtlProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _scrollLeft = require("../utils/scrollLeft");
var _animate = require("../internal/animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _scrollbarSize = require("./ScrollbarSize");
var _scrollbarSizeDefault = parcelHelpers.interopDefault(_scrollbarSize);
var _tabScrollButton = require("../TabScrollButton");
var _tabScrollButtonDefault = parcelHelpers.interopDefault(_tabScrollButton);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _tabsClasses = require("./tabsClasses");
var _tabsClassesDefault = parcelHelpers.interopDefault(_tabsClasses);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("../utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const useUtilityClasses = (ownerState)=>{
    const { vertical, fixed, hideScrollbar, scrollableX, scrollableY, centered, scrollButtonsHideMobile, classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tabsClasses.getTabsUtilityClass), classes);
};
const TabsRoot = (0, _styledDefault.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _tabsClassesDefault.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, _tabsClassesDefault.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, _tabsClassesDefault.default).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const TabsScroller = (0, _styledDefault.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const FlexContainer = (0, _styledDefault.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const TabsIndicator = (0, _styledDefault.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const TabsScrollbarSize = (0, _styledDefault.default)((0, _scrollbarSizeDefault.default))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/ _react.forwardRef(function Tabs(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, _useThemeDefault.default)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action, centered = false, children: childrenProp, className, component = "div", allowScrollButtonsMobile = false, indicatorColor = "primary", onChange, orientation = "horizontal", ScrollButtonComponent = (0, _tabScrollButtonDefault.default), scrollButtons = "auto", selectionFollowsFocus, slots = {}, slotProps = {}, TabIndicatorProps = {}, TabScrollButtonProps = {}, textColor = "primary", value, variant = "standard", visibleScrollbar = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        allowScrollButtonsMobile,
        indicatorColor,
        orientation,
        vertical,
        scrollButtons,
        textColor,
        variant,
        visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, _utils.useSlotProps)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState
    });
    const endScrollButtonIconProps = (0, _utils.useSlotProps)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState
    });
    const [mounted, setMounted] = _react.useState(false);
    const [indicatorStyle, setIndicatorStyle] = _react.useState(defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = _react.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = _react.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = _react.useState(false);
    const [scrollerStyle, setScrollerStyle] = _react.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = _react.useRef(null);
    const tabListRef = _react.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, isRtl ? "rtl" : "ltr"),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta,
            tabMeta
        };
    };
    const updateIndicatorState = (0, _useEventCallbackDefault.default)(()=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation = true } = {})=>{
        if (animation) (0, _animateDefault.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = _react.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, _clsxDefault.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonComponent, (0, _extendsDefault.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, _clsxDefault.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonComponent, (0, _extendsDefault.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, _clsxDefault.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, _useEventCallbackDefault.default)((animation)=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation
            });
        }
    });
    const updateScrollButtonState = (0, _useEventCallbackDefault.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    _react.useEffect(()=>{
        const handleResize = (0, _debounceDefault.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, _ownerWindowDefault.default)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ _react.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    _react.useEffect(()=>{
        setMounted(true);
    }, []);
    _react.useEffect(()=>{
        updateIndicatorState();
    });
    _react.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    _react.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsIndicator, (0, _extendsDefault.default)({}, TabIndicatorProps, {
        className: (0, _clsxDefault.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, _extendsDefault.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = _react.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ _react.cloneElement(child, (0, _extendsDefault.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected,
            selectionFollowsFocus,
            onChange,
            textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, _ownerDocumentDefault.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, nextItem);
                break;
            case "Home":
                event.preventDefault();
                moveFocus(list, null, nextItem);
                break;
            case "End":
                event.preventDefault();
                moveFocus(list, null, previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabsRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
exports.default = Tabs;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","react-is":"4ic4g","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/refType":"l5hTY","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","@mui/system/RtlProvider":"jz0y0","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../styles/useTheme":"3N7Mw","../utils/debounce":"bEAi9","../utils/scrollLeft":"jcIQj","../internal/animate":"2J1Kn","./ScrollbarSize":"jRzdz","../TabScrollButton":"6dbJb","../utils/useEventCallback":"2AJRL","./tabsClasses":"86TDo","../utils/ownerDocument":"27FrI","../utils/ownerWindow":"iuYVd","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jcIQj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectScrollType", ()=>(0, _utils.unstable_detectScrollType));
parcelHelpers.export(exports, "getNormalizedScrollLeft", ()=>(0, _utils.unstable_getNormalizedScrollLeft));
var _utils = require("@mui/utils");

},{"@mui/utils":"97HmB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2J1Kn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>animate);
function easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = ()=>{}) {
    const { ease = easeInOutSin, duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jRzdz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollbarSize);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "onChange"
];
const styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function ScrollbarSize(props) {
    const { onChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const scrollbarHeight = _react.useRef();
    const nodeRef = _react.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const handleResize = (0, _debounceDefault.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, _utils.ownerWindow)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    _react.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        style: styles,
        ref: nodeRef
    }, other));
}

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","prop-types":"hRUel","../utils/debounce":"bEAi9","../utils":"bu04F","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6dbJb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tabScrollButtonDefault.default));
parcelHelpers.export(exports, "tabScrollButtonClasses", ()=>(0, _tabScrollButtonClassesDefault.default));
var _tabScrollButton = require("./TabScrollButton");
var _tabScrollButtonDefault = parcelHelpers.interopDefault(_tabScrollButton);
var _tabScrollButtonClasses = require("./tabScrollButtonClasses");
var _tabScrollButtonClassesDefault = parcelHelpers.interopDefault(_tabScrollButtonClasses);
parcelHelpers.exportAll(_tabScrollButtonClasses, exports);
"use client";

},{"./TabScrollButton":"6b5JT","./tabScrollButtonClasses":"2npa3","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6b5JT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable jsx-a11y/aria-role */ var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _rtlProvider = require("@mui/system/RtlProvider");
var _keyboardArrowLeft = require("../internal/svg-icons/KeyboardArrowLeft");
var _keyboardArrowLeftDefault = parcelHelpers.interopDefault(_keyboardArrowLeft);
var _keyboardArrowRight = require("../internal/svg-icons/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tabScrollButtonClasses = require("./tabScrollButtonClasses");
var _tabScrollButtonClassesDefault = parcelHelpers.interopDefault(_tabScrollButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, orientation, disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tabScrollButtonClasses.getTabScrollButtonUtilityClass), classes);
};
const TabScrollButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, _tabScrollButtonClassesDefault.default).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const TabScrollButton = /*#__PURE__*/ _react.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className, slots = {}, slotProps = {}, direction } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const isRtl = (0, _rtlProvider.useRtl)();
    const ownerState = (0, _extendsDefault.default)({
        isRtl
    }, props);
    const classes = useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, _keyboardArrowLeftDefault.default);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, _keyboardArrowRightDefault.default);
    const startButtonIconProps = (0, _utils.useSlotProps)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState
    });
    const endButtonIconProps = (0, _utils.useSlotProps)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabScrollButtonRoot, (0, _extendsDefault.default)({
        component: "div",
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StartButtonIcon, (0, _extendsDefault.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(EndButtonIcon, (0, _extendsDefault.default)({}, endButtonIconProps))
    }));
});
exports.default = TabScrollButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","clsx":"bGtJT","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","@mui/system/RtlProvider":"jz0y0","../internal/svg-icons/KeyboardArrowLeft":"bXrgu","../internal/svg-icons/KeyboardArrowRight":"brPev","../ButtonBase":"1prwn","../styles/useThemeProps":"e7SGa","../styles/styled":"axRcE","./tabScrollButtonClasses":"2npa3","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bXrgu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"brPev":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2npa3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabScrollButtonUtilityClass", ()=>getTabScrollButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTabScrollButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTabScrollButton", slot);
}
const tabScrollButtonClasses = (0, _generateUtilityClassesDefault.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
exports.default = tabScrollButtonClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"86TDo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabsUtilityClass", ()=>getTabsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTabsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiTabs", slot);
}
const tabsClasses = (0, _generateUtilityClassesDefault.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
exports.default = tabsClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iagXb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accountTokenContainerId", ()=>accountTokenContainerId);
parcelHelpers.export(exports, "ContractLink", ()=>ContractLink);
parcelHelpers.export(exports, "AccountTokensCard", ()=>AccountTokensCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _cardEmptyState = require("../../components/CardEmptyState");
var _table = require("../../components/Table");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _config = require("../../config");
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _tokenLink = require("../../components/Tokens/TokenLink");
var _accountLink = require("../../components/Account/AccountLink");
var _tokens = require("../../../types/tokens");
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
const accountTokenContainerId = "tokens";
const ContractLink = ({ scope, address, alwaysTrim })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            alignContent: "center"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                scope: scope,
                address: address,
                alwaysTrim: alwaysTrim
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                value: address
            })
        ]
    });
};
const AccountTokensCard = ({ scope, account, type })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const locationHash = (0, _reactRouterDom.useLocation)().hash.replace("#", "");
    const tokenListLabel = (0, _tokens.getTokenTypePluralName)(t, type);
    const isERC721 = type === (0, _api.EvmTokenType).ERC721;
    const tableColumns = [
        {
            key: "name",
            content: t(isERC721 ? "common.collection" : "common.name")
        },
        {
            key: "contract",
            content: t("common.smartContract")
        },
        {
            key: "balance",
            align: (0, _table.TableCellAlign).Right,
            content: t(isERC721 ? "common.owned" : "common.balance")
        },
        {
            key: "ticker",
            align: (0, _table.TableCellAlign).Right,
            content: t("common.ticker")
        },
        ...isERC721 ? [
            {
                key: "link",
                content: ""
            }
        ] : []
    ];
    const { layer } = scope;
    if (layer === (0, _api.Layer).consensus) // There can be no ERC-20 or ERC-721 tokens on consensus
    throw (0, _errors.AppErrors).UnsupportedLayer;
    const tableRows = (account?.tokenBalances[type] || []).map((item)=>({
            key: item.token_contract_addr,
            data: [
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
                        scope: scope,
                        address: item.token_contract_addr_eth ?? item.token_contract_addr,
                        name: item.token_name || t("common.missing")
                    }),
                    key: "name"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                        id: item.token_contract_addr_eth ?? item.token_contract_addr,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContractLink, {
                            scope: scope,
                            address: item.token_contract_addr_eth ?? item.token_contract_addr,
                            alwaysTrim: true
                        })
                    }),
                    key: "hash"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: t("common.valueLong", (0, _getPreciseNumberFormat.getPreciseNumberFormat)(item.balance)),
                    key: "balance"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: item.token_symbol || t("common.missing"),
                    key: "ticker"
                },
                ...isERC721 ? [
                    {
                        align: (0, _table.TableCellAlign).Right,
                        key: "link",
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                            component: (0, _reactRouterDom.Link),
                            to: item.token_contract_addr_eth,
                            preventScrollReset: true,
                            children: t("common.viewAll")
                        })
                    }
                ] : []
            ],
            highlight: item.token_contract_addr_eth === locationHash || item.token_contract_addr === locationHash
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _linkableDiv.LinkableDiv), {
            id: accountTokenContainerId,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: tokenListLabel
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardContentDefault.default), {
                    children: [
                        !!account && !account?.tokenBalances[type]?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                            label: t("account.emptyTokenList", {
                                spec: (0, _tokens.getTokenTypeStrictName)(t, type),
                                description: (0, _tokens.getTokenTypePluralDescription)(t, type)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
                            columns: tableColumns,
                            rows: tableRows,
                            rowsNumber: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                            name: tokenListLabel,
                            isLoading: !account,
                            pagination: false
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Link":"fTbCF","../../components/CardEmptyState":"aiX1q","../../components/Table":"j3qb1","../../components/CopyToClipboard":"iTQvM","../../config":"in6G4","../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/Tokens/TokenLink":"ksoba","../../components/Account/AccountLink":"43Jgs","../../../types/tokens":"38Dxq","../../../locales/getPreciseNumberFormat":"gj0Jj","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iVoy2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAccount", ()=>useAccount);
parcelHelpers.export(exports, "useAccountTransactions", ()=>useAccountTransactions);
parcelHelpers.export(exports, "useAccountEvents", ()=>useAccountEvents);
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _config = require("../../config");
var _helpers = require("../../utils/helpers");
const useAccount = (scope, address)=>{
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) // There can be no ERC-20 or ERC-721 tokens on consensus
    throw (0, _errors.AppErrors).UnsupportedLayer;
    const query = (0, _api.useGetRuntimeAccountsAddress)(network, layer, address);
    const account = query.data?.data;
    const { isLoading, isError, isFetched } = query;
    return {
        account,
        isLoading,
        isError,
        isFetched
    };
};
const useAccountTransactions = (scope, address)=>{
    const { network, layer } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const query = (0, _api.useGetRuntimeTransactions)(network, layer, {
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: offset,
        rel: oasisAddress
    }, {
        query: {
            enabled: !!oasisAddress
        }
    });
    const { isFetched, isLoading, data } = query;
    const transactions = data?.data.transactions;
    if (isFetched && pagination.selectedPage > 1 && !transactions?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    const totalCount = data?.data.total_count;
    const isTotalCountClipped = data?.data.is_total_count_clipped;
    return {
        isLoading,
        isFetched,
        transactions,
        pagination,
        totalCount,
        isTotalCountClipped
    };
};
const useAccountEvents = (scope, address)=>{
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const query = (0, _api.useGetRuntimeEvents)(network, layer, {
        rel: oasisAddress
    }, {
        query: {
            enabled: !!oasisAddress
        }
    });
    const { isFetched, isLoading, isError, data } = query;
    const events = data?.data.events;
    return {
        isFetched,
        isLoading,
        isError,
        events
    };
};

},{"../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","../../components/Table/useSearchParamsPagination":"jOnBC","../../config":"in6G4","../../utils/helpers":"2aVNs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ii2WJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contractCodeContainerId", ()=>contractCodeContainerId);
parcelHelpers.export(exports, "ContractCodeCard", ()=>ContractCodeCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _hook = require("./hook");
var _cardEmptyState = require("../../components/CardEmptyState");
var _codeDisplay = require("../../components/CodeDisplay");
const contractCodeContainerId = "code";
const ContractCodeCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isFetched, account } = (0, _hook.useAccount)(scope, address);
    const contract = account?.evm_contract;
    const noCode = isFetched && !contract?.creation_bytecode && !contract?.runtime_bytecode;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            noCode && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("contract.noCode")
            }),
            contract && (contract.creation_bytecode || contract.runtime_bytecode) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _linkableDiv.LinkableDiv), {
                    id: contractCodeContainerId,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDisplay.RawDataDisplay), {
                            data: contract.creation_bytecode,
                            label: t("contract.creationByteCode")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDisplay.RawDataDisplay), {
                            data: contract.runtime_bytecode,
                            label: t("contract.runtimeByteCode"),
                            extraTopPadding: !!contract.creation_bytecode
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","../../components/PageLayout/LinkableDiv":"dLOUR","./hook":"iVoy2","../../components/CardEmptyState":"aiX1q","../../components/CodeDisplay":"9FPfq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9FPfq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RawDataDisplay", ()=>RawDataDisplay);
parcelHelpers.export(exports, "JsonCodeDisplay", ()=>JsonCodeDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _scrollableDataDisplay = require("../../components/ScrollableDataDisplay");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _useScreensize = require("../../hooks/useScreensize");
var _helpers = require("../../utils/helpers");
const CodeDisplay = ({ code, copyToClipboardValue, label, extraTopPadding })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (!code) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    my: 3,
                    pt: extraTopPadding ? 4 : 0
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h4",
                        component: "h4",
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: copyToClipboardValue,
                        label: isMobile ? t("common.copy") : t("contract.copyButton", {
                            subject: label
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollableDataDisplay.ScrollableDataDisplay), {
                data: code
            })
        ]
    });
};
const RawDataDisplay = ({ data, label, extraTopPadding })=>{
    const code = data === undefined ? undefined : (0, _helpers.base64ToHex)(data);
    if (!code) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CodeDisplay, {
        code: code,
        copyToClipboardValue: code,
        label: label,
        extraTopPadding: extraTopPadding
    });
};
const StyledPre = (0, _styles.styled)("pre")({
    margin: 0
});
const JsonCodeDisplay = ({ data, label })=>{
    const formattedJson = JSON.stringify(data, null, 2);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CodeDisplay, {
        code: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledPre, {
            children: formattedJson
        }),
        copyToClipboardValue: formattedJson,
        label: label
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","../../components/ScrollableDataDisplay":"b6r1y","../../components/CopyToClipboard":"iTQvM","../../hooks/useScreensize":"2HEhN","../../utils/helpers":"2aVNs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"b6r1y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollableDataDisplay", ()=>ScrollableDataDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _colors = require("../../../styles/theme/colors");
const ScrollableDataDisplay = ({ data, fontWeight = 700 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            padding: "10px 0px 0px 0px",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "10px"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                borderRadius: "5px",
                background: (0, _colors.COLORS).grayLight,
                border: `1px solid ${(0, _colors.COLORS).grayMedium}`,
                height: "349px",
                overflowY: "scroll",
                p: 4,
                width: "100%"
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                variant: "mono",
                fontSize: 16,
                sx: {
                    fontWeight,
                    overflowWrap: "anywhere"
                },
                color: (0, _colors.COLORS).brandExtraDark,
                children: data
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Typography":"f5srd","@mui/material/Box":"4d7LG","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iNjez":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTokenInfo", ()=>useTokenInfo);
parcelHelpers.export(exports, "useTokenTransfers", ()=>useTokenTransfers);
parcelHelpers.export(exports, "useNFTInstanceTransfers", ()=>useNFTInstanceTransfers);
parcelHelpers.export(exports, "_useTokenTransfers", ()=>_useTokenTransfers);
parcelHelpers.export(exports, "useTokenHolders", ()=>useTokenHolders);
parcelHelpers.export(exports, "useTokenInventory", ()=>useTokenInventory);
parcelHelpers.export(exports, "useAccountTokenInventory", ()=>useAccountTokenInventory);
parcelHelpers.export(exports, "useNFTInstance", ()=>useNFTInstance);
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _config = require("../../config");
var _useComprehensiveSearchParamsPagination = require("../../components/Table/useComprehensiveSearchParamsPagination");
var _helpers = require("../../utils/helpers");
const useTokenInfo = (scope, address, enabled = true)=>{
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) // There can be no ERC-20 or ERC-721 tokens on consensus
    throw (0, _errors.AppErrors).UnsupportedLayer;
    const query = (0, _api.useGetRuntimeEvmTokensAddress)(network, layer, address, {
        query: {
            enabled
        }
    });
    const token = query.data?.data;
    const { isLoading, isError, isFetched } = query;
    return {
        token,
        isLoading: isLoading && enabled,
        isError,
        isFetched
    };
};
const useTokenTransfers = (scope, params)=>{
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(params.address);
    return _useTokenTransfers(scope, oasisAddress ? {
        rel: oasisAddress
    } : undefined);
};
const useNFTInstanceTransfers = (scope, params)=>{
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(params.contract_address);
    return _useTokenTransfers(scope, oasisAddress ? {
        nft_id: params.nft_id,
        contract_address: oasisAddress
    } : undefined);
};
const _useTokenTransfers = (scope, params)=>{
    if (params && Object.values(params).some((value)=>value === undefined || value === null)) throw new Error("Must set params=undefined while some values are unavailable");
    const { network, layer } = scope;
    const pagination = (0, _useComprehensiveSearchParamsPagination.useComprehensiveSearchParamsPagination)({
        paramName: "page",
        pageSize: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
    });
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const query = (0, _api.useGetRuntimeEvents)(network, layer, {
        ...pagination.paramsForQuery,
        type: (0, _api.RuntimeEventType).evmlog,
        // The following is the hex-encoded signature for Transfer(address,address,uint256)
        evm_log_signature: "ddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
        ...params
    }, {
        query: {
            enabled: !!params
        }
    });
    const { isFetched, isLoading, data } = query;
    const results = pagination.getResults(data?.data);
    if (isFetched && pagination.selectedPage > 1 && !results.data?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return {
        isLoading,
        isFetched,
        results: pagination.getResults(data?.data)
    };
};
const useTokenHolders = (scope, address)=>{
    const { network, layer } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const query = (0, _api.useGetRuntimeEvmTokensAddressHolders)(network, layer, oasisAddress, {
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: offset
    }, {
        query: {
            enabled: !!oasisAddress
        }
    });
    const { isFetched, isLoading, data } = query;
    const holders = data?.data.holders;
    if (isFetched && pagination.selectedPage > 1 && !holders?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    const totalCount = data?.data.total_count;
    const isTotalCountClipped = data?.data.is_total_count_clipped;
    return {
        isLoading,
        isFetched,
        holders,
        pagination,
        totalCount,
        isTotalCountClipped
    };
};
// specific to NFT gallery only
const NUMBER_OF_INVENTORY_ITEMS = 15;
const useTokenInventory = (scope, address)=>{
    const { network, layer } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * NUMBER_OF_INVENTORY_ITEMS;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const query = (0, _api.useGetRuntimeEvmTokensAddressNfts)(network, layer, oasisAddress, {
        limit: NUMBER_OF_INVENTORY_ITEMS,
        offset: offset
    }, {
        query: {
            enabled: !!oasisAddress
        }
    });
    const { isFetched, isLoading, data } = query;
    const inventory = data?.data.evm_nfts;
    if (isFetched && pagination.selectedPage > 1 && !inventory?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    const totalCount = data?.data.total_count;
    const isTotalCountClipped = data?.data.is_total_count_clipped;
    return {
        isLoading,
        isFetched,
        inventory,
        pagination: {
            ...pagination,
            isTotalCountClipped,
            rowsPerPage: NUMBER_OF_INVENTORY_ITEMS
        },
        totalCount
    };
};
const useAccountTokenInventory = (scope, address, tokenAddress)=>{
    const { network, layer } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * NUMBER_OF_INVENTORY_ITEMS;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const oasisTokenAddress = (0, _helpers.getOasisAddressOrNull)(tokenAddress);
    const query = (0, _api.useGetRuntimeAccountsAddressNfts)(network, layer, oasisAddress, {
        limit: NUMBER_OF_INVENTORY_ITEMS,
        offset: offset,
        token_address: oasisTokenAddress
    }, {
        query: {
            enabled: !!oasisAddress && !!oasisTokenAddress
        }
    });
    const { isFetched, isLoading, data } = query;
    const inventory = data?.data.evm_nfts;
    if (isFetched && pagination.selectedPage > 1 && !inventory?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    const totalCount = data?.data.total_count;
    const isTotalCountClipped = data?.data.is_total_count_clipped;
    return {
        isLoading,
        isFetched,
        inventory,
        pagination: {
            ...pagination,
            rowsPerPage: NUMBER_OF_INVENTORY_ITEMS
        },
        isTotalCountClipped,
        totalCount
    };
};
const useNFTInstance = (scope, address, id)=>{
    const { network, layer } = scope;
    if (layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const oasisAddress = (0, _helpers.getOasisAddressOrNull)(address);
    const query = (0, _api.useGetRuntimeEvmTokensAddressNftsId)(network, layer, oasisAddress, id, {
        query: {
            enabled: !!oasisAddress
        }
    });
    const { data, isError, isFetched, isLoading } = query;
    if (isError) throw (0, _errors.AppErrors).InvalidAddress;
    const nft = data?.data;
    return {
        isLoading,
        isFetched,
        nft
    };
};

},{"../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","../../components/Table/useSearchParamsPagination":"jOnBC","../../config":"in6G4","../../components/Table/useComprehensiveSearchParamsPagination":"eMezg","../../utils/helpers":"2aVNs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eMezg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComprehensiveSearchParamsPagination", ()=>useComprehensiveSearchParamsPagination);
var _reactRouterDom = require("react-router-dom");
var _errors = require("../../../types/errors");
const knownListKeys = [
    "total_count",
    "is_total_count_clipped"
];
function findListIn(data) {
    const candidates = Object.keys(data).filter((key)=>!knownListKeys.includes(key) && Array.isArray(data[key]));
    switch(candidates.length){
        case 0:
            throw new Error("Data not found!");
        case 1:
            return data[candidates[0]];
        default:
            throw new Error("Data not found!");
    }
}
function useComprehensiveSearchParamsPagination({ paramName, pageSize, filter }) {
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const selectedPageString = searchParams.get(paramName);
    const selectedPage = parseInt(selectedPageString ?? "1", 10);
    if (isNaN(selectedPage) || !!selectedPageString && selectedPage.toString() !== selectedPageString) // This would be nicer, but this would also trigger react-error-overlay (besides our error boundary).
    // We don't want that, so now, we are stuck with throwing a string, instead of a proper error.
    // throw new AppError(AppErrors.InvalidPageNumber)
    throw (0, _errors.AppErrors).InvalidPageNumber;
    function linkToPage(page) {
        const newSearchParams = new URLSearchParams(searchParams);
        if (page > 1) newSearchParams.set(paramName, page.toString());
        else newSearchParams.delete(paramName);
        return {
            search: newSearchParams.toString()
        };
    }
    const limit = pageSize;
    const offset = (selectedPage - 1) * pageSize;
    const paramsForQuery = {
        offset,
        limit
    };
    return {
        selectedPage,
        offsetForQuery: offset,
        limitForQuery: limit,
        paramsForQuery,
        getResults: (queryResult, key)=>{
            const data = queryResult ? key ? queryResult[key] : findListIn(queryResult) : undefined;
            const filteredData = !!data && !!filter ? data.filter(filter) : data;
            const tableProps = {
                selectedPage,
                linkToPage,
                totalCount: queryResult?.total_count,
                isTotalCountClipped: queryResult?.is_total_count_clipped,
                rowsPerPage: pageSize
            };
            return {
                tablePaginationProps: tableProps,
                data: filteredData
            };
        }
    };
}

},{"react-router-dom":"5o0mA","../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"uJl44":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accountTokenTransfersContainerId", ()=>accountTokenTransfersContainerId);
parcelHelpers.export(exports, "AccountTokenTransfersCard", ()=>AccountTokenTransfersCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _hook = require("../TokenDashboardPage/hook");
var _tokenTransfers = require("../../components/Tokens/TokenTransfers");
const accountTokenTransfersContainerId = "transfers";
const AccountTokenTransfersCard = ({ scope, address, account })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: accountTokenTransfersContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("common.transfers")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccountTokenTransfers, {
                        scope: scope,
                        address: address,
                        account: account
                    })
                })
            })
        ]
    });
};
const AccountTokenTransfers = ({ scope, address, account })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, isFetched, results } = (0, _hook.useTokenTransfers)(scope, {
        address
    });
    const transfers = results.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !transfers?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("account.emptyTokenTransferList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTransfers.TokenTransfers), {
                transfers: transfers,
                ownAddress: account?.address_eth,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: results.tablePaginationProps,
                differentTokens: true
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../TokenDashboardPage/hook":"iNjez","../../components/Tokens/TokenTransfers":"fFZHn","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fFZHn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventBalance", ()=>EventBalance);
parcelHelpers.export(exports, "TokenTransfers", ()=>TokenTransfers);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _table = require("../Table");
var _api = require("../../../oasis-nexus/api");
var _colors = require("../../../styles/theme/colors");
var _blockLink = require("../Blocks/BlockLink");
var _accountLink = require("../Account/AccountLink");
var _trimLongString = require("../../utils/trimLongString");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _transactionLink = require("../Transactions/TransactionLink");
var _arrowForward = require("@mui/icons-material/ArrowForward");
var _arrowForwardDefault = parcelHelpers.interopDefault(_arrowForward);
var _tokenTransferIcon = require("./TokenTransferIcon");
var _roundedBalance = require("../RoundedBalance");
var _useScreensize = require("../../hooks/useScreensize");
var _helpers = require("../../utils/helpers");
var _tokenLink = require("./TokenLink");
var _placeholderLabel = require("../../utils/PlaceholderLabel");
var _tokenList = require("./TokenList");
var _parseEvmEvent = require("../../utils/parseEvmEvent");
var _age = require("../Age");
const iconSize = "28px";
const StyledCircle = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: iconSize,
        height: iconSize,
        color: (0, _colors.COLORS).eucalyptus,
        backgroundColor: (0, _colors.COLORS).lightGreen,
        borderRadius: iconSize,
        marginLeft: theme.spacing(3),
        marginRight: `-${theme.spacing(4)}`
    }));
const EventBalance = ({ event, tickerAsLink })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const base64address = event.body.address;
    const tokenEthAddress = (0, _helpers.getEthAccountAddressFromBase64)(base64address);
    const tokenType = event.evm_token?.type;
    const tokenDecimals = event.evm_token?.decimals;
    const ticker = event.evm_token?.symbol;
    if (tokenType === (0, _api.EvmTokenType).ERC20) {
        // We are calling it 'raw' since it's not yet normalized according to decimals.
        const rawValue = event.evm_log_params?.find((param)=>param.name === "value")?.value;
        const value = rawValue === undefined ? undefined : (0, _helpers.fromBaseUnits)(rawValue, tokenDecimals || 0);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
            value: value,
            ticker: ticker,
            scope: event,
            tokenAddress: tokenEthAddress,
            tickerAsLink: tickerAsLink
        });
    } else if (tokenType === (0, _api.EvmTokenType).ERC721) {
        const tokenID = event.evm_log_params?.find((param)=>param.name === "tokenID")?.value;
        return tokenID ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            t: t,
            i18nKey: "common.tokenInstance",
            components: {
                InstanceLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _placeholderLabel.PlaceholderLabel), {
                    label: tokenID
                }),
                TickerLink: tickerAsLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
                    scope: event,
                    address: tokenEthAddress,
                    name: ticker
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _placeholderLabel.PlaceholderLabel), {
                    label: ticker ?? t("common.missing")
                })
            }
        }) : t("common.missing");
    } else return tokenType;
};
const TokenTransfers = ({ isLoading, limit, pagination, transfers, differentTokens, ownAddress })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const tableColumns = [
        {
            key: "hash",
            content: t("common.hash")
        },
        {
            key: "block",
            content: t("common.block")
        },
        {
            key: "timestamp",
            content: t("common.age"),
            align: (0, _table.TableCellAlign).Right
        },
        {
            key: "type",
            content: t("common.type"),
            align: (0, _table.TableCellAlign).Center
        },
        {
            key: "from",
            content: t("common.from"),
            width: "150px"
        },
        {
            key: "to",
            content: t("common.to"),
            width: "150px"
        },
        ...differentTokens ? [
            {
                key: "tokenType",
                content: t("tokens.type"),
                align: (0, _table.TableCellAlign).Center
            }
        ] : [],
        {
            key: "value",
            align: (0, _table.TableCellAlign).Right,
            content: t("common.value"),
            width: "250px"
        }
    ];
    const tableRows = transfers?.map((transfer, index)=>{
        const { fromAddress, toAddress, isMinting, parsedEvmLogName } = (0, _parseEvmEvent.parseEvmEvent)(transfer);
        return {
            key: `event-${index + (pagination ? (pagination.selectedPage - 1) * pagination.rowsPerPage : 0)}`,
            data: [
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionLink.TransactionLink), {
                        scope: transfer,
                        alwaysTrim: isTablet,
                        hash: transfer.eth_tx_hash || transfer.tx_hash
                    }),
                    key: "hash"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: transfer,
                        height: transfer.round
                    }),
                    key: "round"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _age.Age), {
                        sinceTimestamp: transfer.timestamp
                    }),
                    key: "timestamp"
                },
                {
                    key: "type",
                    align: (0, _table.TableCellAlign).Center,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTransferIcon.TokenTransferIcon), {
                        method: parsedEvmLogName
                    })
                },
                {
                    key: "from",
                    align: (0, _table.TableCellAlign).Right,
                    content: isMinting || fromAddress === undefined ? "" : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            pr: 3
                        },
                        children: [
                            !!ownAddress && fromAddress.toLowerCase() === ownAddress.toLowerCase() ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "mono",
                                component: "span",
                                sx: {
                                    fontWeight: 700
                                },
                                children: (0, _trimLongString.trimLongString)(fromAddress)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                scope: transfer,
                                address: fromAddress,
                                alwaysTrim: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCircle, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowForwardDefault.default), {
                                    fontSize: "inherit"
                                })
                            })
                        ]
                    })
                },
                {
                    key: "to",
                    content: !toAddress ? "" : !!ownAddress && toAddress.toLowerCase() === ownAddress.toLowerCase() ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "mono",
                        component: "span",
                        sx: {
                            fontWeight: 700
                        },
                        children: (0, _trimLongString.trimLongString)(toAddress)
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: transfer,
                        address: toAddress,
                        alwaysTrim: true
                    })
                },
                ...differentTokens ? [
                    {
                        key: "tokenType",
                        content: transfer.evm_token ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenTypeTag), {
                            tokenType: transfer.evm_token.type
                        }) : t("common.missing"),
                        align: (0, _table.TableCellAlign).Center
                    }
                ] : [],
                {
                    key: "value",
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventBalance, {
                        event: transfer,
                        tickerAsLink: differentTokens
                    })
                }
            ],
            highlight: transfer.markAsNew
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("transactions.latest"),
        isLoading: isLoading,
        pagination: pagination,
        extraHorizontalSpaceOnMobile: true,
        alwaysWaitWhileLoading: true
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","react-i18next":"e210a","@mui/material/Box":"4d7LG","../Table":"j3qb1","../../../oasis-nexus/api":"dJrPU","../../../styles/theme/colors":"hYvW2","../Blocks/BlockLink":"g8oEe","../Account/AccountLink":"43Jgs","../../utils/trimLongString":"jHX4k","@mui/material/Typography":"f5srd","../Transactions/TransactionLink":"eIjbt","@mui/icons-material/ArrowForward":"bwHID","./TokenTransferIcon":"epRIa","../RoundedBalance":"af34T","../../hooks/useScreensize":"2HEhN","../../utils/helpers":"2aVNs","./TokenLink":"ksoba","../../utils/PlaceholderLabel":"6CHug","./TokenList":"7bRlg","../../utils/parseEvmEvent":"2rjsg","../Age":"eWnEg","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fvb2X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDetailsCard", ()=>AccountDetailsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _subPageCard = require("../../components/SubPageCard");
var _reactI18Next = require("react-i18next");
var _accountDetailsView = require("./AccountDetailsView");
const AccountDetailsCard = ({ isLoading, isError, isContract, account, token, tokenPrices })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
        featured: true,
        isLoadingTitle: isLoading,
        title: isContract ? t("contract.title") : t("account.title"),
        mainTitle: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountDetailsView.AccountDetailsView), {
            isLoading: isLoading,
            isError: isError,
            account: account,
            token: token,
            tokenPrices: tokenPrices
        })
    });
};

},{"react/jsx-runtime":"g88cO","../../components/SubPageCard":"dvWuD","react-i18next":"e210a","./AccountDetailsView":"jToPP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jToPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDetailsView", ()=>AccountDetailsView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _cardEmptyState = require("../../components/CardEmptyState");
var _account = require("../../components/Account");
const AccountDetailsView = ({ isLoading, isError, account, token, tokenPrices, showLayer })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return isError ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
        label: t("account.cantLoadDetails")
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _account.Account), {
        account: account,
        token: token,
        isLoading: isLoading,
        tokenPrices: tokenPrices,
        showLayer: showLayer
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/CardEmptyState":"aiX1q","../../components/Account":"6iHui","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6iHui":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Account", ()=>Account);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _useScreensize = require("../../hooks/useScreensize");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _skeleton = require("../../components/Skeleton");
var _tokenPills = require("./TokenPills");
var _accountLink = require("./AccountLink");
var _routeUtils = require("../../utils/route-utils");
var _accountTransactionsCard = require("../../pages/RuntimeAccountDetailsPage/AccountTransactionsCard");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _dashboardLink = require("../../pages/ParatimeDashboardPage/DashboardLink");
var _ticker = require("../../../types/ticker");
var _contractCreatorInfo = require("./ContractCreatorInfo");
var _contractVerificationIcon = require("../ContractVerificationIcon");
var _tokenLink = require("../Tokens/TokenLink");
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
var _accountAvatar = require("../AccountAvatar");
var _runtimeBalanceDisplay = require("../Balance/RuntimeBalanceDisplay");
var _hooks = require("../Balance/hooks");
var _fiatMoneyAmount = require("../Balance/FiatMoneyAmount");
var _config = require("../../../config");
const Account = ({ account, token, isLoading, tokenPrices, showLayer })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const address = account ? account.address_eth ?? account.address : undefined;
    const transactionsLabel = account ? account.stats.num_txns.toLocaleString() : "";
    const transactionsAnchor = account ? `${(0, _routeUtils.RouteUtils).getAccountRoute(account, account.address_eth ?? account.address)}#${0, _accountTransactionsCard.accountTransactionsContainerId}` : undefined;
    const nativeTokens = (0, _config.getTokensForScope)(account || {
        network: "mainnet",
        layer: "sapphire"
    });
    const nativeTickerNames = nativeTokens.map((token)=>(0, _ticker.getNameForTicker)(t, token.ticker));
    const contract = account?.evm_contract;
    const fiatValueInfo = (0, _hooks.calculateFiatValue)(account?.balances, tokenPrices, (0, _config.getFiatCurrencyForScope)(account));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
                numberOfRows: 8
            }),
            account && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                titleWidth: isMobile ? "100px" : "200px",
                children: [
                    showLayer && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.paratime")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardLink.DashboardLink), {
                                    scope: account
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledDescriptionList.StyledListTitleWithAvatar), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountAvatar.AccountAvatar), {
                            account: account
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                scope: account,
                                address: address
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                value: address
                            })
                        ]
                    }),
                    token && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.token")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
                                    scope: account,
                                    address: token.eth_contract_addr || token.contract_addr,
                                    name: token.name
                                })
                            })
                        ]
                    }),
                    contract && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("contract.verification.title")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.ContractVerificationIcon), {
                                    account: account
                                })
                            })
                        ]
                    }),
                    contract && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("contract.creator")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractCreatorInfo.ContractCreatorInfo), {
                                    scope: account,
                                    creationTxHash: contract.eth_creation_tx || contract.creation_tx,
                                    alwaysTrim: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.balance")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBalanceDisplay.RuntimeBalanceDisplay), {
                            balances: account.balances
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.tokens")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenPills.TokenPills), {
                            account: account,
                            tokens: account.evm_balances
                        })
                    }),
                    (0, _config.showFiatValues) && !fiatValueInfo.loading && fiatValueInfo.hasValue && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("common.fiatValue")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fiatMoneyAmount.FiatMoneyAmount), {
                                    ...fiatValueInfo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.transactions")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: account.stats.num_txns ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                            component: (0, _reactRouterDom.Link),
                            to: transactionsAnchor,
                            children: transactionsLabel
                        }) : transactionsLabel
                    }),
                    nativeTokens.length === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("account.totalReceived")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueInToken", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.stats.total_received),
                                    ticker: nativeTickerNames[0]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: t("account.totalSent")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                children: t("common.valueInToken", {
                                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.stats.total_sent),
                                    ticker: nativeTickerNames[0]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","../../hooks/useScreensize":"2HEhN","../../components/StyledDescriptionList":"bndrS","../../components/CopyToClipboard":"iTQvM","../../components/Skeleton":"eB5vc","./TokenPills":"beWB7","./AccountLink":"43Jgs","../../utils/route-utils":"b2kKi","../../pages/RuntimeAccountDetailsPage/AccountTransactionsCard":"3Ys4k","@mui/material/Link":"fTbCF","../../pages/ParatimeDashboardPage/DashboardLink":"k1EO2","../../../types/ticker":"898HF","./ContractCreatorInfo":"cv1gp","../ContractVerificationIcon":"6tjz3","../Tokens/TokenLink":"ksoba","../../../locales/getPreciseNumberFormat":"gj0Jj","../AccountAvatar":"aC04Z","../Balance/RuntimeBalanceDisplay":"4jk33","../Balance/hooks":"i9NMC","../Balance/FiatMoneyAmount":"gYaIm","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"beWB7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenPills", ()=>TokenPills);
parcelHelpers.export(exports, "Pill", ()=>Pill);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _showMoreTokensLink = require("./ShowMoreTokensLink");
var _roundedBalance = require("../RoundedBalance");
var _routeUtils = require("../../utils/route-utils");
const TokenPills = ({ account, tokens })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (!tokens.length) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        sx: {
            opacity: "0.5"
        },
        children: t("account.noTokens")
    });
    const pills = tokens.slice(0, isMobile ? 1 : 3);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            pills.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Pill, {
                    account: account,
                    pill: item
                }, item.token_contract_addr)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _showMoreTokensLink.ShowMoreTokensLink), {
                account: account,
                tokens: tokens,
                pills: pills
            })
        ]
    });
};
const Pill = ({ account, pill })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const tokenRoute = (0, _routeUtils.RouteUtils).getAccountTokensRoute(account, account.address_eth ?? account.address, pill.token_type, pill.token_contract_addr_eth ?? pill.token_contract_addr);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
        clickable: true,
        color: "tertiary",
        component: (0, _reactRouterDom.Link),
        to: tokenRoute,
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                value: pill.balance,
                ticker: pill.token_symbol || t("common.missing")
            })
        }),
        sx: {
            mr: 2
        },
        variant: "outlined"
    }, pill.token_contract_addr_eth ?? pill.token_contract_addr);
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Chip":"aTO9B","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","./ShowMoreTokensLink":"9K6M3","../RoundedBalance":"af34T","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9K6M3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLink", ()=>StyledLink);
parcelHelpers.export(exports, "ShowMoreTokensLink", ()=>ShowMoreTokensLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
var _api = require("../../../oasis-nexus/api");
var _routeUtils = require("../../utils/route-utils");
var _accountTokensCard = require("../../pages/RuntimeAccountDetailsPage/AccountTokensCard");
const StyledLink = (0, _styles.styled)((0, _reactRouterDom.Link))(({ theme })=>({
        color: (0, _colors.COLORS).brandDark,
        fontWeight: 700,
        textDecoration: "none",
        whiteSpace: "nowrap",
        marginLeft: theme.spacing(4)
    }));
const ShowMoreTokensLink = ({ account, tokens, pills })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const erc20link = (0, _routeUtils.RouteUtils).getAccountTokensRoute(account, account.address_eth ?? account.address, (0, _api.EvmTokenType).ERC20, (0, _accountTokensCard.accountTokenContainerId));
    const erc721Link = (0, _routeUtils.RouteUtils).getAccountTokensRoute(account, account.address_eth ?? account.address, (0, _api.EvmTokenType).ERC721, (0, _accountTokensCard.accountTokenContainerId));
    const additionalTokensCounter = tokens.length - pills.length;
    if (!additionalTokensCounter) return null;
    // link to ERC20 tab otherwise if there are only ERC721 tokens not included in pills link to the ERC721
    const pillsSymbols = new Set(pills.map(({ token_contract_addr })=>token_contract_addr));
    const showMoreItems = tokens.filter(({ token_contract_addr })=>!pillsSymbols.has(token_contract_addr));
    const hasERC20 = showMoreItems.some((item)=>item.token_type === (0, _api.EvmTokenType).ERC20);
    const targetShowMoreLink = hasERC20 ? erc20link : erc721Link;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledLink, {
        to: targetShowMoreLink,
        color: "inherit",
        children: t("account.showMore", {
            counter: additionalTokensCounter
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","react-i18next":"e210a","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","../../../oasis-nexus/api":"dJrPU","../../utils/route-utils":"b2kKi","../../pages/RuntimeAccountDetailsPage/AccountTokensCard":"iagXb","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3Ys4k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accountTransactionsContainerId", ()=>accountTransactionsContainerId);
parcelHelpers.export(exports, "AccountTransactionsCard", ()=>AccountTransactionsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _transactions = require("../../components/Transactions");
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _hook = require("./hook");
const accountTransactionsContainerId = "transactions";
const AccountTransactionsCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: accountTransactionsContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("account.transactionsListTitle")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccountTransactions, {
                        scope: scope,
                        address: address
                    })
                })
            })
        ]
    });
};
const AccountTransactions = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, isFetched, transactions, pagination, totalCount, isTotalCountClipped } = (0, _hook.useAccountTransactions)(scope, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !transactions?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("account.emptyTransactionList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.RuntimeTransactions), {
                transactions: transactions,
                ownAddress: address,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: {
                    selectedPage: pagination.selectedPage,
                    linkToPage: pagination.linkToPage,
                    totalCount,
                    isTotalCountClipped,
                    rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../components/Transactions":"k0qMF","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","./hook":"iVoy2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cv1gp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContractCreatorInfo", ()=>ContractCreatorInfo);
parcelHelpers.export(exports, "DelayedContractCreatorInfo", ()=>DelayedContractCreatorInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _transactionLink = require("../Transactions/TransactionLink");
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _accountLink = require("./AccountLink");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _useScreensize = require("../../hooks/useScreensize");
const TxSender = ({ scope, txHash, alwaysTrim })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const query = (0, _api.useGetRuntimeTransactionsTxHash)(scope.network, scope.layer, txHash);
    const tx = query.data?.data.transactions[0];
    const senderAddress = tx?.sender_0_eth || tx?.sender_0;
    return query.isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
        variant: "text",
        sx: {
            width: "25%"
        }
    }) : senderAddress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
        scope: scope,
        address: senderAddress,
        alwaysTrim: alwaysTrim
    }) : t("common.missing");
};
const ContractCreatorInfo = ({ scope, isLoading, creationTxHash, alwaysTrim })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
        variant: "text",
        sx: {
            width: "50%"
        }
    }) : creationTxHash === undefined ? t("common.missing") : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "flex-start" : "center",
            gap: isMobile ? 0 : 2,
            minWidth: "25%"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TxSender, {
                scope: scope,
                txHash: creationTxHash,
                alwaysTrim: alwaysTrim
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: t("contract.createdAt")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionLink.TransactionLink), {
                scope: scope,
                hash: creationTxHash,
                alwaysTrim: alwaysTrim
            })
        ]
    });
};
const DelayedContractCreatorInfo = ({ scope, contractOasisAddress, alwaysTrim })=>{
    const accountQuery = (0, _api.useGetRuntimeAccountsAddress)(scope.network, scope.layer, contractOasisAddress);
    const account = accountQuery.data?.data;
    const contract = account?.evm_contract;
    const creationTxHash = contract?.eth_creation_tx || contract?.creation_tx;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContractCreatorInfo, {
        scope: scope,
        isLoading: accountQuery.isLoading,
        creationTxHash: creationTxHash,
        alwaysTrim: alwaysTrim
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../Transactions/TransactionLink":"eIjbt","../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","./AccountLink":"43Jgs","@mui/material/Box":"4d7LG","@mui/material/Skeleton":"i7d9z","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"aC04Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountAvatar", ()=>AccountAvatar);
var _jsxRuntime = require("react/jsx-runtime");
var _useScreensize = require("../../hooks/useScreensize");
var _jazzIcon = require("../JazzIcon");
var _addressToJazzIconSeed = require("./addressToJazzIconSeed");
const AccountAvatar = ({ account })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (!account.address) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jazzIcon.JazzIcon), {
        diameter: isMobile ? 30 : 40,
        seed: (0, _addressToJazzIconSeed.addressToJazzIconSeed)(account)
    });
};

},{"react/jsx-runtime":"g88cO","../../hooks/useScreensize":"2HEhN","../JazzIcon":"fLElT","./addressToJazzIconSeed":"6NPVS","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fLElT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JazzIcon", ()=>JazzIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _jazzicon = require("@metamask/jazzicon");
var _jazziconDefault = parcelHelpers.interopDefault(_jazzicon);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const JazzIcon = /*#__PURE__*/ (0, _react.memo)(({ diameter, seed })=>{
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (ref?.current) {
            const icon = (0, _jazziconDefault.default)(diameter, seed);
            ref.current.replaceChildren(icon);
        }
    }, [
        diameter,
        ref,
        seed
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        ref: ref,
        sx: {
            height: diameter
        }
    });
});

},{"react/jsx-runtime":"g88cO","react":"BK2ob","@metamask/jazzicon":"azcWU","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"azcWU":[function(require,module,exports) {
var MersenneTwister = require("632bf711dc750cfe");
var paperGen = require("2e73a57693c664db");
var Color = require("a27f612defa7de29");
var colors = require("2fd502038527568");
var shapeCount = 4;
var svgns = "http://www.w3.org/2000/svg";
module.exports = generateIdenticon;
var generator;
function generateIdenticon(diameter, seed) {
    generator = new MersenneTwister(seed);
    var remainingColors = hueShift(colors.slice(), generator);
    var elements = paperGen(diameter, genColor(remainingColors));
    var container = elements.container;
    var svg = document.createElementNS(svgns, "svg");
    svg.setAttributeNS(null, "x", "0");
    svg.setAttributeNS(null, "y", "0");
    svg.setAttributeNS(null, "width", diameter);
    svg.setAttributeNS(null, "height", diameter);
    container.appendChild(svg);
    for(var i = 0; i < shapeCount - 1; i++)genShape(remainingColors, diameter, i, shapeCount - 1, svg);
    return container;
}
function genShape(remainingColors, diameter, i, total, svg) {
    var center = diameter / 2;
    var shape = document.createElementNS(svgns, "rect");
    shape.setAttributeNS(null, "x", "0");
    shape.setAttributeNS(null, "y", "0");
    shape.setAttributeNS(null, "width", diameter);
    shape.setAttributeNS(null, "height", diameter);
    var firstRot = generator.random();
    var angle = Math.PI * 2 * firstRot;
    var velocity = diameter / total * generator.random() + i * diameter / total;
    var tx = Math.cos(angle) * velocity;
    var ty = Math.sin(angle) * velocity;
    var translate = "translate(" + tx + " " + ty + ")";
    // Third random is a shape rotation on top of all of that.
    var secondRot = generator.random();
    var rot = firstRot * 360 + secondRot * 180;
    var rotate = "rotate(" + rot.toFixed(1) + " " + center + " " + center + ")";
    var transform = translate + " " + rotate;
    shape.setAttributeNS(null, "transform", transform);
    var fill = genColor(remainingColors);
    shape.setAttributeNS(null, "fill", fill);
    svg.appendChild(shape);
}
function genColor(colors) {
    var rand = generator.random();
    var idx = Math.floor(colors.length * generator.random());
    var color = colors.splice(idx, 1)[0];
    return color;
}
var wobble = 30;
function hueShift(colors, generator) {
    var amount = generator.random() * 30 - wobble / 2;
    return colors.map(function(hex) {
        var color = Color(hex);
        color.rotate(amount);
        return color.hexString();
    });
}

},{"632bf711dc750cfe":"8N9rF","2e73a57693c664db":"2QiPi","a27f612defa7de29":"eeJrk","2fd502038527568":"109qy"}],"8N9rF":[function(require,module,exports) {
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/ /*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/ var MersenneTwister = function(seed) {
    if (seed == undefined) seed = new Date().getTime();
    /* Period parameters */ this.N = 624;
    this.M = 397;
    this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
    this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
    this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
    this.mt = new Array(this.N); /* the array for the state vector */ 
    this.mti = this.N + 1; /* mti==N+1 means mt[N] is not initialized */ 
    if (seed.constructor == Array) this.init_by_array(seed, seed.length);
    else this.init_seed(seed);
};
/* initializes mt[N] with a seed */ /* origin name init_genrand */ MersenneTwister.prototype.init_seed = function(s) {
    this.mt[0] = s >>> 0;
    for(this.mti = 1; this.mti < this.N; this.mti++){
        var s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
        this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
        /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
    /* for >32 bit machines */ }
};
/* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
    var i, j, k;
    this.init_seed(19650218);
    i = 1;
    j = 0;
    k = this.N > key_length ? this.N : key_length;
    for(; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        j++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
        if (j >= key_length) j = 0;
    }
    for(k = this.N - 1; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
    }
    this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
};
/* generates a random number on [0,0xffffffff]-interval */ /* origin name genrand_int32 */ MersenneTwister.prototype.random_int = function() {
    var y;
    var mag01 = new Array(0x0, this.MATRIX_A);
    /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
        var kk;
        if (this.mti == this.N + 1) /* if init_seed() has not been called, */ this.init_seed(5489); /* a default initial seed is used */ 
        for(kk = 0; kk < this.N - this.M; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        for(; kk < this.N - 1; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
        this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
        this.mti = 0;
    }
    y = this.mt[this.mti++];
    /* Tempering */ y ^= y >>> 11;
    y ^= y << 7 & 0x9d2c5680;
    y ^= y << 15 & 0xefc60000;
    y ^= y >>> 18;
    return y >>> 0;
};
/* generates a random number on [0,0x7fffffff]-interval */ /* origin name genrand_int31 */ MersenneTwister.prototype.random_int31 = function() {
    return this.random_int() >>> 1;
};
/* generates a random number on [0,1]-real-interval */ /* origin name genrand_real1 */ MersenneTwister.prototype.random_incl = function() {
    return this.random_int() * (1.0 / 4294967295.0);
/* divided by 2^32-1 */ };
/* generates a random number on [0,1)-real-interval */ MersenneTwister.prototype.random = function() {
    return this.random_int() * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on (0,1)-real-interval */ /* origin name genrand_real3 */ MersenneTwister.prototype.random_excl = function() {
    return (this.random_int() + 0.5) * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on [0,1) with 53-bit resolution*/ /* origin name genrand_res53 */ MersenneTwister.prototype.random_long = function() {
    var a = this.random_int() >>> 5, b = this.random_int() >>> 6;
    return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
};
/* These real versions are due to Isaku Wada, 2002/01/09 added */ module.exports = MersenneTwister;

},{}],"2QiPi":[function(require,module,exports) {
function newPaper(diameter, color) {
    var container = document.createElement("div");
    container.style.borderRadius = "50px";
    container.style.overflow = "hidden";
    container.style.padding = "0px";
    container.style.margin = "0px";
    container.style.width = "" + diameter + "px";
    container.style.height = "" + diameter + "px";
    container.style.display = "inline-block";
    container.style.background = color;
    return {
        container: container
    };
}
module.exports = newPaper;

},{}],"eeJrk":[function(require,module,exports) {
/* MIT license */ var clone = require("5dace8876896bf8a");
var convert = require("c094f2fb379d5867");
var string = require("71b6e3b39cf59f9f");
var Color = function(obj) {
    if (obj instanceof Color) return obj;
    if (!(this instanceof Color)) return new Color(obj);
    this.values = {
        rgb: [
            0,
            0,
            0
        ],
        hsl: [
            0,
            0,
            0
        ],
        hsv: [
            0,
            0,
            0
        ],
        hwb: [
            0,
            0,
            0
        ],
        cmyk: [
            0,
            0,
            0,
            0
        ],
        alpha: 1
    };
    // parse Color() argument
    var vals;
    if (typeof obj === "string") {
        vals = string.getRgba(obj);
        if (vals) this.setValues("rgb", vals);
        else if (vals = string.getHsla(obj)) this.setValues("hsl", vals);
        else if (vals = string.getHwb(obj)) this.setValues("hwb", vals);
        else throw new Error('Unable to parse color from string "' + obj + '"');
    } else if (typeof obj === "object") {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) this.setValues("rgb", vals);
        else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues("hsl", vals);
        else if (vals.v !== undefined || vals.value !== undefined) this.setValues("hsv", vals);
        else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues("hwb", vals);
        else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues("cmyk", vals);
        else throw new Error("Unable to parse color from object " + JSON.stringify(obj));
    }
};
Color.prototype = {
    rgb: function() {
        return this.setSpace("rgb", arguments);
    },
    hsl: function() {
        return this.setSpace("hsl", arguments);
    },
    hsv: function() {
        return this.setSpace("hsv", arguments);
    },
    hwb: function() {
        return this.setSpace("hwb", arguments);
    },
    cmyk: function() {
        return this.setSpace("cmyk", arguments);
    },
    rgbArray: function() {
        return this.values.rgb;
    },
    hslArray: function() {
        return this.values.hsl;
    },
    hsvArray: function() {
        return this.values.hsv;
    },
    hwbArray: function() {
        if (this.values.alpha !== 1) return this.values.hwb.concat([
            this.values.alpha
        ]);
        return this.values.hwb;
    },
    cmykArray: function() {
        return this.values.cmyk;
    },
    rgbaArray: function() {
        var rgb = this.values.rgb;
        return rgb.concat([
            this.values.alpha
        ]);
    },
    rgbaArrayNormalized: function() {
        var rgb = this.values.rgb;
        var glRgba = [];
        for(var i = 0; i < 3; i++)glRgba[i] = rgb[i] / 255;
        glRgba.push(this.values.alpha);
        return glRgba;
    },
    hslaArray: function() {
        var hsl = this.values.hsl;
        return hsl.concat([
            this.values.alpha
        ]);
    },
    alpha: function(val) {
        if (val === undefined) return this.values.alpha;
        this.setValues("alpha", val);
        return this;
    },
    red: function(val) {
        return this.setChannel("rgb", 0, val);
    },
    green: function(val) {
        return this.setChannel("rgb", 1, val);
    },
    blue: function(val) {
        return this.setChannel("rgb", 2, val);
    },
    hue: function(val) {
        if (val) {
            val %= 360;
            val = val < 0 ? 360 + val : val;
        }
        return this.setChannel("hsl", 0, val);
    },
    saturation: function(val) {
        return this.setChannel("hsl", 1, val);
    },
    lightness: function(val) {
        return this.setChannel("hsl", 2, val);
    },
    saturationv: function(val) {
        return this.setChannel("hsv", 1, val);
    },
    whiteness: function(val) {
        return this.setChannel("hwb", 1, val);
    },
    blackness: function(val) {
        return this.setChannel("hwb", 2, val);
    },
    value: function(val) {
        return this.setChannel("hsv", 2, val);
    },
    cyan: function(val) {
        return this.setChannel("cmyk", 0, val);
    },
    magenta: function(val) {
        return this.setChannel("cmyk", 1, val);
    },
    yellow: function(val) {
        return this.setChannel("cmyk", 2, val);
    },
    black: function(val) {
        return this.setChannel("cmyk", 3, val);
    },
    hexString: function() {
        return string.hexString(this.values.rgb);
    },
    rgbString: function() {
        return string.rgbString(this.values.rgb, this.values.alpha);
    },
    rgbaString: function() {
        return string.rgbaString(this.values.rgb, this.values.alpha);
    },
    percentString: function() {
        return string.percentString(this.values.rgb, this.values.alpha);
    },
    hslString: function() {
        return string.hslString(this.values.hsl, this.values.alpha);
    },
    hslaString: function() {
        return string.hslaString(this.values.hsl, this.values.alpha);
    },
    hwbString: function() {
        return string.hwbString(this.values.hwb, this.values.alpha);
    },
    keyword: function() {
        return string.keyword(this.values.rgb, this.values.alpha);
    },
    rgbNumber: function() {
        return this.values.rgb[0] << 16 | this.values.rgb[1] << 8 | this.values.rgb[2];
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.values.rgb;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    dark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    light: function() {
        return !this.dark();
    },
    negate: function() {
        var rgb = [];
        for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
        this.setValues("rgb", rgb);
        return this;
    },
    lighten: function(ratio) {
        this.values.hsl[2] += this.values.hsl[2] * ratio;
        this.setValues("hsl", this.values.hsl);
        return this;
    },
    darken: function(ratio) {
        this.values.hsl[2] -= this.values.hsl[2] * ratio;
        this.setValues("hsl", this.values.hsl);
        return this;
    },
    saturate: function(ratio) {
        this.values.hsl[1] += this.values.hsl[1] * ratio;
        this.setValues("hsl", this.values.hsl);
        return this;
    },
    desaturate: function(ratio) {
        this.values.hsl[1] -= this.values.hsl[1] * ratio;
        this.setValues("hsl", this.values.hsl);
        return this;
    },
    whiten: function(ratio) {
        this.values.hwb[1] += this.values.hwb[1] * ratio;
        this.setValues("hwb", this.values.hwb);
        return this;
    },
    blacken: function(ratio) {
        this.values.hwb[2] += this.values.hwb[2] * ratio;
        this.setValues("hwb", this.values.hwb);
        return this;
    },
    greyscale: function() {
        var rgb = this.values.rgb;
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues("rgb", [
            val,
            val,
            val
        ]);
        return this;
    },
    clearer: function(ratio) {
        this.setValues("alpha", this.values.alpha - this.values.alpha * ratio);
        return this;
    },
    opaquer: function(ratio) {
        this.setValues("alpha", this.values.alpha + this.values.alpha * ratio);
        return this;
    },
    rotate: function(degrees) {
        var hue = this.values.hsl[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        this.values.hsl[0] = hue;
        this.setValues("hsl", this.values.hsl);
        return this;
    },
    /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
    },
    toJSON: function() {
        return this.rgb();
    },
    clone: function() {
        var col = new Color();
        col.values = clone(this.values);
        return col;
    }
};
Color.prototype.getValues = function(space) {
    var vals = {};
    for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = this.values[space][i];
    if (this.values.alpha !== 1) vals.a = this.values.alpha;
    // {r: 255, g: 255, b: 255, a: 0.4}
    return vals;
};
Color.prototype.setValues = function(space, vals) {
    var spaces = {
        rgb: [
            "red",
            "green",
            "blue"
        ],
        hsl: [
            "hue",
            "saturation",
            "lightness"
        ],
        hsv: [
            "hue",
            "saturation",
            "value"
        ],
        hwb: [
            "hue",
            "whiteness",
            "blackness"
        ],
        cmyk: [
            "cyan",
            "magenta",
            "yellow",
            "black"
        ]
    };
    var maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    var i;
    var alpha = 1;
    if (space === "alpha") alpha = vals;
    else if (vals.length) {
        // [10, 10, 10]
        this.values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
    } else if (vals[space.charAt(0)] !== undefined) {
        // {r: 10, g: 10, b: 10}
        for(i = 0; i < space.length; i++)this.values[space][i] = vals[space.charAt(i)];
        alpha = vals.a;
    } else if (vals[spaces[space][0]] !== undefined) {
        // {red: 10, green: 10, blue: 10}
        var chans = spaces[space];
        for(i = 0; i < space.length; i++)this.values[space][i] = vals[chans[i]];
        alpha = vals.alpha;
    }
    this.values.alpha = Math.max(0, Math.min(1, alpha === undefined ? this.values.alpha : alpha));
    if (space === "alpha") return false;
    var capped;
    // cap values of the space prior converting all values
    for(i = 0; i < space.length; i++){
        capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
        this.values[space][i] = Math.round(capped);
    }
    // convert to all the other color spaces
    for(var sname in spaces){
        if (sname !== space) this.values[sname] = convert[space][sname](this.values[space]);
        // cap values
        for(i = 0; i < sname.length; i++){
            capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
            this.values[sname][i] = Math.round(capped);
        }
    }
    return true;
};
Color.prototype.setSpace = function(space, args) {
    var vals = args[0];
    if (vals === undefined) // color.rgb()
    return this.getValues(space);
    // color.rgb(10, 10, 10)
    if (typeof vals === "number") vals = Array.prototype.slice.call(args);
    this.setValues(space, vals);
    return this;
};
Color.prototype.setChannel = function(space, index, val) {
    if (val === undefined) // color.red()
    return this.values[space][index];
    else if (val === this.values[space][index]) // color.red(color.red())
    return this;
    // color.red(100)
    this.values[space][index] = val;
    this.setValues(space, this.values[space]);
    return this;
};
module.exports = Color;

},{"5dace8876896bf8a":"aVPlw","c094f2fb379d5867":"dZrDd","71b6e3b39cf59f9f":"eJwQ5"}],"aVPlw":[function(require,module,exports) {
var Buffer = require("ed8dd23fba769fd1").Buffer;
var clone = function() {
    "use strict";
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/ function clone(parent, circular, depth, prototype) {
        var filter;
        if (typeof circular === "object") {
            depth = circular.depth;
            prototype = circular.prototype;
            filter = circular.filter;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != "undefined";
        if (typeof circular == "undefined") circular = true;
        if (typeof depth == "undefined") depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth == 0) return parent;
            var child;
            var proto;
            if (typeof parent != "object") return parent;
            if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && Buffer.isBuffer(parent)) {
                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (typeof prototype == "undefined") {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === "object" && __objToStr(o) === "[object Date]";
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === "object" && __objToStr(o) === "[object Array]";
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === "object" && __objToStr(o) === "[object RegExp]";
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = "";
        if (re.global) flags += "g";
        if (re.ignoreCase) flags += "i";
        if (re.multiline) flags += "m";
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (0, module.exports) module.exports = clone;

},{"ed8dd23fba769fd1":"eHuUs"}],"dZrDd":[function(require,module,exports) {
var conversions = require("739980f7990d3c32");
var route = require("30ea0c7ee5f3dd94");
var convert = {};
var models = Object.keys(conversions);
function wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
models.forEach(function(fromModel) {
    convert[fromModel] = {};
    Object.defineProperty(convert[fromModel], "channels", {
        value: conversions[fromModel].channels
    });
    Object.defineProperty(convert[fromModel], "labels", {
        value: conversions[fromModel].labels
    });
    var routes = route(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
    });
});
module.exports = convert;

},{"739980f7990d3c32":"4SzfN","30ea0c7ee5f3dd94":"h4ohj"}],"4SzfN":[function(require,module,exports) {
/* MIT license */ var cssKeywords = require("efc99055946c4df8");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var reverseKeywords = {};
for(var key in cssKeywords)if (cssKeywords.hasOwnProperty(key)) reverseKeywords[cssKeywords[key]] = key;
var convert = module.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
// hide .channels and .labels properties
for(var model in convert)if (convert.hasOwnProperty(model)) {
    if (!("channels" in convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in convert[model])) throw new Error("missing channel labels property: " + model);
    if (convert[model].labels.length !== convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    var channels = convert[model].channels;
    var labels = convert[model].labels;
    delete convert[model].channels;
    delete convert[model].labels;
    Object.defineProperty(convert[model], "channels", {
        value: channels
    });
    Object.defineProperty(convert[model], "labels", {
        value: labels
    });
}
convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
convert.rgb.keyword = function(rgb) {
    var reversed = reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in cssKeywords)if (cssKeywords.hasOwnProperty(keyword)) {
        var value = cssKeywords[keyword];
        // Compute comparative distance
        var distance = comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
convert.keyword.rgb = function(keyword) {
    return cssKeywords[keyword];
};
convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
convert.rgb.lab = function(rgb) {
    var xyz = convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};
convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map(function(char) {
        return char + char;
    }).join("");
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
convert.gray.hsl = convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

},{"efc99055946c4df8":"8TkPL"}],"8TkPL":[function(require,module,exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"h4ohj":[function(require,module,exports) {
var conversions = require("22442592002c5ac3");
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys(conversions);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
    var graph = buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = conversions[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    var graph = deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = wrapConversion(toModel, graph);
    }
    return conversion;
};

},{"22442592002c5ac3":"4SzfN"}],"eJwQ5":[function(require,module,exports) {
/* MIT license */ var colorNames = require("9e8c28b9071d0061");
module.exports = {
    getRgba: getRgba,
    getHsla: getHsla,
    getRgb: getRgb,
    getHsl: getHsl,
    getHwb: getHwb,
    getAlpha: getAlpha,
    hexString: hexString,
    rgbString: rgbString,
    rgbaString: rgbaString,
    percentString: percentString,
    percentaString: percentaString,
    hslString: hslString,
    hslaString: hslaString,
    hwbString: hwbString,
    keyword: keyword
};
function getRgba(string) {
    if (!string) return;
    var abbr = /^#([a-fA-F0-9]{3})$/, hex = /^#([a-fA-F0-9]{6})$/, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, keyword = /(\D+)/;
    var rgb = [
        0,
        0,
        0
    ], a = 1, match = string.match(abbr);
    if (match) {
        match = match[1];
        for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
    } else if (match = string.match(hex)) {
        match = match[1];
        for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
    } else if (match = string.match(rgba)) {
        for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
        a = parseFloat(match[4]);
    } else if (match = string.match(per)) {
        for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        a = parseFloat(match[4]);
    } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") return [
            0,
            0,
            0,
            0
        ];
        rgb = colorNames[match[1]];
        if (!rgb) return;
    }
    for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
    if (!a && a != 0) a = 1;
    else a = scale(a, 0, 1);
    rgb[3] = a;
    return rgb;
}
function getHsla(string) {
    if (!string) return;
    var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
}
function getHwb(string) {
    if (!string) return;
    var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
}
function getRgb(string) {
    var rgba = getRgba(string);
    return rgba && rgba.slice(0, 3);
}
function getHsl(string) {
    var hsla = getHsla(string);
    return hsla && hsla.slice(0, 3);
}
function getAlpha(string) {
    var vals = getRgba(string);
    if (vals) return vals[3];
    else if (vals = getHsla(string)) return vals[3];
    else if (vals = getHwb(string)) return vals[3];
}
// generators
function hexString(rgb) {
    return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1]) + hexDouble(rgb[2]);
}
function rgbString(rgba, alpha) {
    if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
    return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}
function rgbaString(rgba, alpha) {
    if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
    return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
}
function percentString(rgba, alpha) {
    if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
    var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
    return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}
function percentaString(rgba, alpha) {
    var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
    return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}
function hslString(hsla, alpha) {
    if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
    return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}
function hslaString(hsla, alpha) {
    if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
    return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
}
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
    if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
    return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}
function keyword(rgb) {
    return reverseNames[rgb.slice(0, 3)];
}
// helpers
function scale(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}
//create a list of reverse color names
var reverseNames = {};
for(var name in colorNames)reverseNames[colorNames[name]] = name;

},{"9e8c28b9071d0061":"b02mx"}],"b02mx":[function(require,module,exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"109qy":[function(require,module,exports) {
module.exports = [
    "#01888C",
    "#FC7500",
    "#034F5D",
    "#F73F01",
    "#FC1960",
    "#C7144C",
    "#F3C100",
    "#1598F2",
    "#2465E1",
    "#F19E02"
];

},{}],"6NPVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addressToJazzIconSeed", ()=>addressToJazzIconSeed);
var _client = require("@oasisprotocol/client");
const ethAddressToSeed = (address_eth)=>{
    // https://github.com/oasisprotocol/oasis-wallet-ext/blob/da7ad67/src/popup/component/AccountIcon/index.js#L20-L25
    // https://github.com/MetaMask/metamask-extension/blob/v10.7.0/ui/helpers/utils/icon-factory.js#L84-L88
    const addr = address_eth.slice(2, 10);
    const seed = parseInt(addr, 16);
    return seed;
};
const oasisAddressToSeed = (address)=>{
    // https://github.com/oasisprotocol/oasis-wallet-ext/blob/da7ad67/src/popup/component/AccountIcon/index.js#L26
    const addressU8 = (0, _client.staking).addressFromBech32(address);
    const seed = addressU8[20] | addressU8[19] << 8 | addressU8[18] << 16 | addressU8[17] << 24;
    return seed;
};
function addressToJazzIconSeed(account) {
    return account.address_eth ? ethAddressToSeed(account.address_eth) : oasisAddressToSeed(account.address);
}

},{"@oasisprotocol/client":"1ax6t","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4jk33":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBalanceDisplay", ()=>RuntimeBalanceDisplay);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const RuntimeBalanceDisplay = ({ balances = [] })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (balances.length === 0 || balances[0].balance === undefined) return t("common.missing");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        children: balances.map((balance)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: t("common.valueInToken", {
                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(balance.balance),
                    ticker: balance.token_symbol
                })
            }, balance.token_symbol))
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../../locales/getPreciseNumberFormat":"gj0Jj","@mui/material/Box":"4d7LG","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i9NMC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasRuntimeBalance", ()=>hasRuntimeBalance);
parcelHelpers.export(exports, "calculateFiatValue", ()=>calculateFiatValue);
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
const hasRuntimeBalance = (balances = [])=>balances.some((balance)=>balance.token_decimals);
const calculateFiatValue = (balances = [], tokenPrices, fiatCurrency)=>{
    let hasValue = false;
    let value = new (0, _bignumberJsDefault.default)(0);
    let hasUsedCoinGecko = false;
    let loading = false;
    const unknown = [];
    balances.forEach((balance)=>{
        const priceInfo = tokenPrices[balance.token_symbol];
        if (priceInfo) {
            if (priceInfo.isLoading) loading = true;
            else {
                hasUsedCoinGecko = hasUsedCoinGecko || priceInfo.hasUsedCoinGecko;
                if (!priceInfo.isFree) {
                    const tokenFiatValue = priceInfo.price;
                    hasValue = true;
                    if (tokenFiatValue === undefined) unknown.push(balance.token_symbol);
                    else value = value.plus(new (0, _bignumberJsDefault.default)(balance.balance).multipliedBy(tokenFiatValue));
                }
            }
        } else {
            unknown.push(balance.token_symbol);
            hasValue = true;
        }
    });
    return {
        hasValue,
        hasUsedCoinGecko,
        loading,
        unknownTickers: unknown,
        value: value.toFixed(),
        fiatCurrency
    };
};

},{"bignumber.js":"cQ5xL","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2Sh7o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountEventsCard", ()=>AccountEventsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _subPageCard = require("app/components/SubPageCard");
var _reactI18Next = require("react-i18next");
var _runtimeEventsDetailedList = require("../../components/RuntimeEvents/RuntimeEventsDetailedList");
var _addressSwitch = require("../../components/AddressSwitch");
const AccountEventsCard = ({ scope, isLoading, isError, events })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
        title: t("common.events"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeEventsDetailedList.RuntimeEventsDetailedList), {
            scope: scope,
            events: events,
            isLoading: isLoading,
            isError: isError,
            addressSwitchOption: (0, _addressSwitch.AddressSwitchOption).ETH
        })
    });
};

},{"react/jsx-runtime":"g88cO","app/components/SubPageCard":"dvWuD","react-i18next":"e210a","../../components/RuntimeEvents/RuntimeEventsDetailedList":"8KNdh","../../components/AddressSwitch":"eKQmb","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7myxv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchResultsPage", ()=>SearchResultsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _searchUtils = require("../../components/Search/search-utils");
var _useScopeParam = require("../../hooks/useScopeParam");
var _hooks = require("./hooks");
var _searchResultsView = require("./SearchResultsView");
var _api = require("../../../coin-gecko/api");
var _config = require("../../../config");
const SearchResultsPage = ()=>{
    const searchParams = (0, _searchUtils.useParamSearch)();
    const scope = (0, _useScopeParam.useScopeParam)();
    const { results, isLoading } = (0, _hooks.useSearch)(scope, searchParams);
    const tokenPrices = (0, _api.useAllTokenPrices)((0, _config.getFiatCurrencyForScope)(scope));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsView.SearchResultsView), {
        wantedScope: scope,
        searchTerm: searchParams.searchTerm,
        searchResults: results,
        isLoading: isLoading,
        tokenPrices: tokenPrices
    });
};

},{"react/jsx-runtime":"g88cO","../../components/Search/search-utils":"bnM2G","../../hooks/useScopeParam":"kKMKx","./hooks":"dFLwi","./SearchResultsView":"fQhuH","../../../coin-gecko/api":"2VRI5","../../../config":"2PXMY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dFLwi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBlocksByHeightConditionally", ()=>useBlocksByHeightConditionally);
parcelHelpers.export(exports, "useBlocksByHashConditionally", ()=>useBlocksByHashConditionally);
parcelHelpers.export(exports, "useTransactionsConditionally", ()=>useTransactionsConditionally);
parcelHelpers.export(exports, "useRuntimeAccountConditionally", ()=>useRuntimeAccountConditionally);
parcelHelpers.export(exports, "useRuntimeTokenConditionally", ()=>useRuntimeTokenConditionally);
parcelHelpers.export(exports, "useNetworkProposalsConditionally", ()=>useNetworkProposalsConditionally);
parcelHelpers.export(exports, "useSearch", ()=>useSearch);
var _api = require("../../../oasis-nexus/api");
var _routeUtils = require("../../utils/route-utils");
function isDefined(item) {
    return item != null;
}
function useBlocksByHeightConditionally(currentScope, blockHeight) {
    const queries = (0, _routeUtils.RouteUtils).getVisibleScopes(currentScope).filter((scope)=>scope.layer !== (0, _api.Layer).consensus).map((scope)=>/**
       * Normally, calling React hooks from callbacks and other conditional code
       * is not a good idea, but in this case, we can be sure that the number of
       * enabled combinations will never change during runtime
       * (since it's hard-coded in route-utils.ts), so we can just ignore
       * the lint warning about abusing the rules of hooks.
       */ // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _api.useGetRuntimeBlockByHeight)(scope.network, scope.layer, parseInt(blockHeight), {
            query: {
                enabled: !!blockHeight
            }
        }));
    return {
        isLoading: queries.some((query)=>query.isInitialLoading),
        results: queries.map((query)=>query.data?.data).filter(isDefined)
    };
}
function useBlocksByHashConditionally(currentScope, blockHash) {
    const queries = (0, _routeUtils.RouteUtils).getVisibleScopes(currentScope).filter((scope)=>scope.layer !== (0, _api.Layer).consensus).map((scope)=>/**
       * Normally, calling React hooks from callbacks and other conditional code
       * is not a good idea, but in this case, we can be sure that the number of
       * enabled combinations will never change during runtime
       * (since it's hard-coded in route-utils.ts), so we can just ignore
       * the lint warning about abusing the rules of hooks.
       */ // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _api.useGetRuntimeBlockByHash)(scope.network, scope.layer, blockHash || "", {
            query: {
                enabled: !!blockHash
            }
        }));
    return {
        isLoading: queries.some((query)=>query.isInitialLoading),
        results: queries.map((query)=>query.data?.data).filter(isDefined)
    };
}
function useTransactionsConditionally(currentScope, txHash) {
    const queries = (0, _routeUtils.RouteUtils).getVisibleScopes(currentScope).filter((scope)=>scope.layer !== (0, _api.Layer).consensus).map((scope)=>// See explanation above
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _api.useGetRuntimeTransactionsTxHash)(scope.network, scope.layer, txHash, {
            query: {
                enabled: !!txHash
            }
        }));
    return {
        isLoading: queries.some((query)=>query.isInitialLoading),
        results: queries.flatMap((query)=>query.data?.data.transactions).filter(isDefined)
    };
}
function useRuntimeAccountConditionally(currentScope, address) {
    const queries = (0, _routeUtils.RouteUtils).getVisibleScopes(currentScope).filter((scope)=>scope.layer !== (0, _api.Layer).consensus).map((scope)=>// See explanation above
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _api.useGetRuntimeAccountsAddress)(scope.network, scope.layer, address, {
            query: {
                enabled: !!address
            }
        }));
    return {
        isLoading: queries.some((query)=>query.isInitialLoading),
        results: queries.map((query)=>query.data?.data).filter(isDefined)
    };
}
function useRuntimeTokenConditionally(currentScope, nameFragment) {
    const queries = (0, _routeUtils.RouteUtils).getVisibleScopes(currentScope).filter((scope)=>scope.layer !== (0, _api.Layer).consensus).map((scope)=>// See explanation above
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _api.useGetRuntimeEvmTokens)(scope.network, scope.layer, {
            name: nameFragment,
            limit: 10
        }, {
            query: {
                enabled: !!nameFragment
            }
        }));
    return {
        isLoading: queries.some((query)=>query.isInitialLoading),
        results: queries.map((query)=>query.data?.data).filter(isDefined)
    };
}
function useNetworkProposalsConditionally(nameFragment) {
    const queries = (0, _routeUtils.RouteUtils).getEnabledNetworksForLayer((0, _api.Layer).consensus).map((network)=>// eslint-disable-next-line react-hooks/rules-of-hooks
        (0, _api.useGetConsensusProposalsByName)(network, nameFragment));
    return {
        isLoading: queries.some((query)=>query.isInitialLoading),
        results: queries.map((query)=>query.results).filter(isDefined).flat()
    };
}
const useSearch = (currentScope, q)=>{
    const queries = {
        blockHeight: useBlocksByHeightConditionally(currentScope, q.blockHeight),
        blockHash: useBlocksByHashConditionally(currentScope, q.blockHash),
        txHash: useTransactionsConditionally(currentScope, q.txHash),
        oasisAccount: useRuntimeAccountConditionally(currentScope, q.consensusAccount),
        // TODO: remove evmBech32Account and use evmAccount when API is ready
        evmBech32Account: useRuntimeAccountConditionally(currentScope, q.evmBech32Account),
        tokens: useRuntimeTokenConditionally(currentScope, q.evmTokenNameFragment),
        proposals: useNetworkProposalsConditionally(q.networkProposalNameFragment)
    };
    const isLoading = Object.values(queries).some((query)=>query.isLoading);
    const blocks = [
        ...queries.blockHeight.results,
        ...queries.blockHash.results
    ];
    const transactions = queries.txHash.results || [];
    const accounts = [
        ...queries.oasisAccount.results || [],
        ...queries.evmBech32Account.results || []
    ].filter((0, _api.isAccountNonEmpty));
    const tokens = queries.tokens.results.map((l)=>l.evm_tokens).flat().sort((t1, t2)=>t2.num_holders - t1.num_holders);
    const proposals = queries.proposals.results;
    const results = isLoading ? [] : [
        ...blocks.map((block)=>({
                ...block,
                resultType: "block"
            })),
        ...transactions.map((tx)=>({
                ...tx,
                resultType: "transaction"
            })),
        ...accounts.filter((account)=>!account.evm_contract).map((account)=>({
                ...account,
                resultType: "account"
            })),
        ...accounts.filter((account)=>account.evm_contract).map((account)=>({
                ...account,
                resultType: "contract"
            })),
        ...tokens.map((token)=>({
                ...token,
                resultType: "token"
            })),
        ...proposals.map((proposal)=>({
                ...proposal,
                resultType: "proposal"
            }))
    ];
    return {
        isLoading,
        results
    };
};

},{"../../../oasis-nexus/api":"dJrPU","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fQhuH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchResultsView", ()=>SearchResultsView);
var _jsxRuntime = require("react/jsx-runtime");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _skeleton = require("../../components/Skeleton");
var _globalSearchResultsView = require("./GlobalSearchResultsView");
var _scopedSearchResultsView = require("./ScopedSearchResultsView");
var _layers = require("../../../types/layers");
var _useScreensize = require("../../hooks/useScreensize");
const SearchResultsView = ({ wantedScope, searchTerm, searchResults, isLoading, tokenPrices })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
                featured: true,
                isLoadingTitle: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
                    numberOfRows: 7
                })
            }) : wantedScope ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scopedSearchResultsView.ScopedSearchResultsView), {
                wantedScope: wantedScope,
                searchTerm: searchTerm,
                searchResults: searchResults.filter((0, _layers.getFilterForLayer)(wantedScope.layer)),
                tokenPrices: tokenPrices
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalSearchResultsView.GlobalSearchResultsView), {
                searchTerm: searchTerm,
                searchResults: searchResults,
                tokenPrices: tokenPrices
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Divider":"3hI6U","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../components/Skeleton":"eB5vc","./GlobalSearchResultsView":"9mYch","./ScopedSearchResultsView":"4xWIU","../../../types/layers":"gWCJy","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9mYch":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalSearchResultsView", ()=>GlobalSearchResultsView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _routeUtils = require("../../utils/route-utils");
var _noResults = require("./NoResults");
var _searchResultsList = require("./SearchResultsList");
var _network = require("../../../types/network");
var _notifications = require("./notifications");
var _theme = require("../../../styles/theme");
var _layers = require("../../../types/layers");
var _useRedirectIfSingleResult = require("./useRedirectIfSingleResult");
const GlobalSearchResultsView = ({ searchTerm, searchResults, tokenPrices })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [othersOpen, setOthersOpen] = (0, _react.useState)(false);
    (0, _useRedirectIfSingleResult.useRedirectIfSingleResult)(undefined, searchTerm, searchResults);
    const themes = (0, _theme.getThemesForNetworks)();
    const networkNames = (0, _network.getNetworkNames)(t);
    if (0, _routeUtils.fixedNetwork) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !searchResults.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noResults.NoResultsWhatsoever), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsList.SearchResultsList), {
                title: networkNames[0, _routeUtils.fixedNetwork],
                searchTerm: searchTerm,
                searchResults: searchResults,
                networkForTheme: (0, _routeUtils.fixedNetwork),
                tokenPrices: tokenPrices
            }, (0, _routeUtils.fixedNetwork))
        ]
    });
    const otherNetworks = (0, _routeUtils.RouteUtils).getEnabledNetworks().filter((0, _network.isNotMainnet));
    const notificationTheme = themes[(0, _network.Network).testnet];
    const mainnetResults = searchResults.filter((0, _network.isOnMainnet)).sort((0, _layers.orderByLayer));
    const otherResults = searchResults.filter((0, _network.isNotOnMainnet)).sort((0, _layers.orderByLayer));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !mainnetResults.length && (otherResults.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noResults.NoResultsOnMainnet), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noResults.NoResultsWhatsoever), {})),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsList.SearchResultsList), {
                title: networkNames[(0, _network.Network).mainnet],
                searchTerm: searchTerm,
                searchResults: mainnetResults,
                networkForTheme: (0, _network.Network).mainnet,
                tokenPrices: tokenPrices
            }, (0, _network.Network).mainnet),
            otherResults.length !== 0 && (othersOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.HideMoreResults), {
                        theme: notificationTheme,
                        onHide: ()=>setOthersOpen(false)
                    }),
                    otherNetworks.map((net)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsList.SearchResultsList), {
                            title: networkNames[net],
                            searchTerm: searchTerm,
                            searchResults: otherResults.filter((0, _network.getFilterForNetwork)(net)),
                            networkForTheme: net,
                            tokenPrices: tokenPrices
                        }, net))
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.ShowMoreResults), {
                theme: notificationTheme,
                hasWantedResults: !!mainnetResults.length,
                otherResultsCount: otherResults.length,
                onShow: ()=>setOthersOpen(true)
            }))
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","../../utils/route-utils":"b2kKi","./NoResults":"1MutG","./SearchResultsList":"kLi9z","../../../types/network":"f0o8N","./notifications":"lf4Wz","../../../styles/theme":"i3yrR","../../../types/layers":"gWCJy","./useRedirectIfSingleResult":"5OET2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1MutG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResults", ()=>NoResults);
parcelHelpers.export(exports, "NoResultsWhatsoever", ()=>NoResultsWhatsoever);
parcelHelpers.export(exports, "NoResultsOnNetwork", ()=>NoResultsOnNetwork);
parcelHelpers.export(exports, "NoResultsOnMainnet", ()=>NoResultsOnMainnet);
parcelHelpers.export(exports, "NoResultsInScope", ()=>NoResultsInScope);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _emptyState = require("../../components/EmptyState");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _searchSuggestionsLinksForNoResults = require("../../components/Search/SearchSuggestionsLinksForNoResults");
var _optionalBreak = require("../../components/OptionalBreak");
var _styles = require("@mui/material/styles");
var _searchScope = require("../../../types/searchScope");
var _network = require("../../../types/network");
const NoResults = ({ network, layer })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const theme = (0, _styles.useTheme)();
    const title = network ? t("search.noResults.scopeHeader", {
        scope: layer ? (0, _searchScope.getNameForScope)(t, {
            network,
            layer
        }) : (0, _network.getNetworkNames)(t)[network]
    }) : t("search.noResults.header");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
        title: title,
        description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: {
                textAlign: "center",
                a: {
                    color: theme.palette.layout.main,
                    textDecoration: "underline"
                }
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        t: t,
                        i18nKey: "search.noResults.description",
                        components: {
                            OptionalBreak: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionalBreak.OptionalBreak), {}),
                            HomeLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                component: (0, _reactRouterDom.Link),
                                to: "/"
                            })
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSuggestionsLinksForNoResults.SearchSuggestionsLinksForNoResults), {
                        scope: layer && network ? {
                            network,
                            layer
                        } : undefined
                    })
                })
            ]
        })
    });
};
const NoResultsWhatsoever = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NoResults, {});
const NoResultsOnNetwork = ({ network })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NoResults, {
        network: network
    });
const NoResultsOnMainnet = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NoResultsOnNetwork, {
        network: (0, _network.Network).mainnet
    });
const NoResultsInScope = ({ scope })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NoResults, {
        network: scope.network,
        layer: scope.layer
    });

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","../../components/EmptyState":"5d6vv","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../components/Search/SearchSuggestionsLinksForNoResults":"7MdD8","../../components/OptionalBreak":"2mW6j","@mui/material/styles":"51PGx","../../../types/searchScope":"6SEv5","../../../types/network":"f0o8N","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7MdD8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchSuggestionsLinksForNoResults", ()=>SearchSuggestionsLinksForNoResults);
var _jsxRuntime = require("react/jsx-runtime");
var _searchUtils = require("../../components/Search/search-utils");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _widgets = require("@mui/icons-material/Widgets");
var _widgetsDefault = parcelHelpers.interopDefault(_widgets);
var _repeat = require("@mui/icons-material/Repeat");
var _repeatDefault = parcelHelpers.interopDefault(_repeat);
var _accountBalanceWallet = require("@mui/icons-material/AccountBalanceWallet");
var _accountBalanceWalletDefault = parcelHelpers.interopDefault(_accountBalanceWallet);
var _token = require("@mui/icons-material/Token");
var _tokenDefault = parcelHelpers.interopDefault(_token);
var _routeUtils = require("../../utils/route-utils");
var _optionalBreak = require("../OptionalBreak");
var _useScreensize = require("../../hooks/useScreensize");
const iconSxProps = {
    fontSize: "18px",
    verticalAlign: "middle",
    marginBottom: 1
};
const empty = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
const SearchSuggestionsLinksForNoResults = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { suggestedBlock, suggestedTransaction, suggestedAccount, suggestedTokenFragment } = (scope?.network && scope?.layer && (0, _searchUtils.searchSuggestionTerms)[scope.network][scope.layer]) ?? (0, _searchUtils.searchSuggestionTerms)["mainnet"]["sapphire"];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
        t: t,
        i18nKey: "search.searchSuggestionsForNoResults",
        components: {
            OptionalBreak: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionalBreak.OptionalBreak), {}),
            BlockIcon: isMobile ? empty : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _widgetsDefault.default), {
                sx: iconSxProps
            }),
            BlockLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                component: (0, _reactRouterDom.Link),
                to: (0, _routeUtils.RouteUtils).getSearchRoute(scope, suggestedBlock)
            }),
            TransactionIcon: isMobile ? empty : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repeatDefault.default), {
                sx: iconSxProps
            }),
            TransactionLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                component: (0, _reactRouterDom.Link),
                to: (0, _routeUtils.RouteUtils).getSearchRoute(scope, suggestedTransaction)
            }),
            AccountIcon: isMobile ? empty : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountBalanceWalletDefault.default), {
                sx: iconSxProps
            }),
            AccountLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                component: (0, _reactRouterDom.Link),
                to: (0, _routeUtils.RouteUtils).getSearchRoute(scope, suggestedAccount)
            }),
            TokenIcon: isMobile ? empty : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDefault.default), {
                sx: iconSxProps
            }),
            TokenLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                component: (0, _reactRouterDom.Link),
                to: (0, _routeUtils.RouteUtils).getSearchRoute(scope, suggestedTokenFragment)
            })
        }
    });
};

},{"react/jsx-runtime":"g88cO","../../components/Search/search-utils":"bnM2G","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","@mui/icons-material/Widgets":"6Adxk","@mui/icons-material/Repeat":"cnQ0o","@mui/icons-material/AccountBalanceWallet":"409sQ","@mui/icons-material/Token":"3Dzi3","../../utils/route-utils":"b2kKi","../OptionalBreak":"2mW6j","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kLi9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchResultsList", ()=>SearchResultsList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _resultsGroupByType = require("./ResultsGroupByType");
var _runtimeBlockDetailPage = require("../RuntimeBlockDetailPage");
var _routeUtils = require("../../utils/route-utils");
var _runtimeTransactionDetailPage = require("../RuntimeTransactionDetailPage");
var _accountDetailsView = require("../RuntimeAccountDetailsPage/AccountDetailsView");
var _theme = require("../../../styles/theme");
var _subPageCard = require("../../components/SubPageCard");
var _resultListFrame = require("./ResultListFrame");
var _tokenDetails = require("../../components/Tokens/TokenDetails");
var _proposalDetailsPage = require("../ProposalDetailsPage");
const SearchResultsList = ({ title, networkForTheme, searchResults, tokenPrices, searchTerm = "" })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const numberOfResults = searchResults.length;
    if (!numberOfResults) return null;
    const theme = (0, _theme.getThemesForNetworks)()[networkForTheme];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultListFrame.ResultListFrame), {
        theme: theme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
            title: title,
            featured: true,
            subheader: t("search.results.count", {
                count: numberOfResults
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultsGroupByType.ResultsGroupByType), {
                    title: t("search.results.blocks.title"),
                    results: searchResults.filter((item)=>item.resultType === "block"),
                    resultComponent: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBlockDetailPage.RuntimeBlockDetailView), {
                            isLoading: false,
                            block: item,
                            showLayer: true
                        }),
                    link: (block)=>(0, _routeUtils.RouteUtils).getBlockRoute(block, block.round),
                    linkLabel: t("search.results.blocks.viewLink")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultsGroupByType.ResultsGroupByType), {
                    title: t("search.results.transactions.title"),
                    results: searchResults.filter((item)=>item.resultType === "transaction"),
                    resultComponent: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeTransactionDetailPage.RuntimeTransactionDetailView), {
                            isLoading: false,
                            transaction: item,
                            tokenPrices: tokenPrices,
                            showLayer: true
                        }),
                    link: (tx)=>(0, _routeUtils.RouteUtils).getTransactionRoute(tx, tx.eth_hash || tx.hash),
                    linkLabel: t("search.results.transactions.viewLink")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultsGroupByType.ResultsGroupByType), {
                    title: t("search.results.accounts.title"),
                    results: searchResults.filter((item)=>item.resultType === "account"),
                    resultComponent: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountDetailsView.AccountDetailsView), {
                            isLoading: false,
                            isError: false,
                            account: item,
                            tokenPrices: tokenPrices,
                            showLayer: true
                        }),
                    link: (acc)=>(0, _routeUtils.RouteUtils).getAccountRoute(acc, acc.address_eth ?? acc.address),
                    linkLabel: t("search.results.accounts.viewLink")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultsGroupByType.ResultsGroupByType), {
                    title: t("search.results.contracts.title"),
                    results: searchResults.filter((item)=>item.resultType === "contract"),
                    resultComponent: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountDetailsView.AccountDetailsView), {
                            isLoading: false,
                            isError: false,
                            account: item,
                            tokenPrices: tokenPrices,
                            showLayer: true
                        }),
                    link: (acc)=>(0, _routeUtils.RouteUtils).getAccountRoute(acc, acc.address_eth ?? acc.address),
                    linkLabel: t("search.results.contracts.viewLink")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultsGroupByType.ResultsGroupByType), {
                    title: t("search.results.tokens.title"),
                    results: searchResults.filter((item)=>item.resultType === "token"),
                    resultComponent: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDetails.TokenDetails), {
                            token: item,
                            highlightedPartOfName: searchTerm,
                            showLayer: true
                        }),
                    link: (token)=>(0, _routeUtils.RouteUtils).getTokenRoute(token, token.eth_contract_addr ?? token.contract_addr),
                    linkLabel: t("search.results.tokens.viewLink")
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resultsGroupByType.ResultsGroupByType), {
                    title: t("search.results.proposals.title"),
                    results: searchResults.filter((item)=>item.resultType === "proposal"),
                    resultComponent: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalDetailsPage.ProposalDetailView), {
                            proposal: item,
                            highlightedPart: searchTerm,
                            showLayer: true
                        }),
                    link: (proposal)=>(0, _routeUtils.RouteUtils).getProposalRoute(proposal.network, proposal.id),
                    linkLabel: t("search.results.proposals.viewLink")
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","./ResultsGroupByType":"j4XHg","../RuntimeBlockDetailPage":"jWfMQ","../../utils/route-utils":"b2kKi","../RuntimeTransactionDetailPage":"bZzL6","../RuntimeAccountDetailsPage/AccountDetailsView":"jToPP","../../../styles/theme":"i3yrR","../../components/SubPageCard":"dvWuD","./ResultListFrame":"4fIMt","../../components/Tokens/TokenDetails":"dKlp5","../ProposalDetailsPage":"eO7IX","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j4XHg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewResultButton", ()=>ViewResultButton);
/**
 * Component for displaying search results of the same type, from the same network.
 *
 * It doesn't actually run a search query, but uses existing results.
 */ parcelHelpers.export(exports, "ResultsGroupByType", ()=>ResultsGroupByType);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _styles = require("@mui/material/styles");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
const ViewResultButton = (()=>{
    const ViewResultButton = (0, _styles.styled)((0, _buttonDefault.default))({});
    ViewResultButton.defaultProps = {
        variant: "contained",
        color: "primary"
    };
    // Type cast is needed because styled type breaks `<ViewResultButton component={RouterLink}`
    return ViewResultButton;
})();
function ResultsGroupByType({ title, results, resultComponent, link, linkLabel }) {
    if (!results || results.length <= 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    mb: 5
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    variant: "h4",
                    component: "h4",
                    sx: {
                        display: "inline"
                    },
                    children: title
                })
            }),
            results.map((item, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        resultComponent(item),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                mt: 5
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ViewResultButton, {
                                component: (0, _reactRouterDom.Link),
                                to: link(item),
                                children: linkLabel
                            })
                        }),
                        i < results.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                            variant: "card"
                        })
                    ]
                }, i))
        ]
    });
}

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","@mui/material/Button":"h2G5p","@mui/material/Box":"4d7LG","@mui/material/Divider":"3hI6U","@mui/material/styles":"51PGx","@mui/material/Typography":"f5srd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4fIMt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResultListFrame", ()=>ResultListFrame);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("@mui/material/styles");
var _card = require("@mui/material/Card");
var _muiHelpers = require("../../utils/mui-helpers");
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _paper = require("@mui/material/Paper");
var _colors = require("../../../styles/theme/colors");
const ResultListFrame = (0, _styles.styled)((0, _boxDefault.default))(({ theme: wantedTheme })=>{
    const currentTheme = (0, _styles.useTheme)();
    const isMobile = (0, _useMediaQueryDefault.default)(wantedTheme.breakpoints.down("sm"));
    return isMobile ? {
        [`&& > div > .${(0, _paper.paperClasses).root}`]: currentTheme.palette.layout.border !== wantedTheme.palette.layout.networkBubbleBorder && wantedTheme.palette.layout.main !== wantedTheme.palette.layout.networkBubbleBorder ? {
            borderRadius: 0,
            border: `solid ${wantedTheme.palette.layout.networkBubbleBorder}`,
            borderWidth: "10px 1px"
        } : {}
    } : {
        marginBottom: 20,
        border: `solid 15px ${wantedTheme.palette.layout.networkBubbleBorder}`,
        background: (0, _colors.COLORS).white,
        borderRadius: 12,
        boxShadow: "-20px 4px 40px rgba(34, 47, 63, 0.24)",
        // Negative margins won't work with default Card overflow
        [`&& .${(0, _card.cardClasses).root}`]: {
            overflow: "initial"
        },
        [`&& .${(0, _card.cardClasses).root} > .${(0, _muiHelpers.boxClasses).root}`]: {
            background: wantedTheme.palette.layout.networkBubbleBorder,
            marginLeft: -78,
            marginTop: -48,
            marginRight: -78,
            paddingLeft: 64,
            paddingRight: 64
        }
    };
});

},{"@mui/material/Box":"4d7LG","@mui/material/styles":"51PGx","@mui/material/Card":"cTsx6","../../utils/mui-helpers":"jOE3S","@mui/material/useMediaQuery":"2E8dG","@mui/material/Paper":"9w8HO","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jOE3S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "boxClasses", ()=>boxClasses);
const boxClasses = {
    root: "MuiBox-root"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dKlp5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenDetails", ()=>TokenDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _skeleton = require("../Skeleton");
var _styledDescriptionList = require("../StyledDescriptionList");
var _useScreensize = require("../../hooks/useScreensize");
var _reactI18Next = require("react-i18next");
var _tokenLink = require("./TokenLink");
var _copyToClipboard = require("../CopyToClipboard");
var _accountLink = require("../Account/AccountLink");
var _dashboardLink = require("../../pages/ParatimeDashboardPage/DashboardLink");
var _contractVerificationIcon = require("../ContractVerificationIcon");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _colors = require("../../../styles/theme/colors");
var _tokenList = require("./TokenList");
var _roundedBalance = require("../RoundedBalance");
var _highlightedText = require("../HighlightedText");
const TokenDetails = ({ isLoading, token, showLayer, standalone = false, highlightedPartOfName })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 7
    });
    if (!token) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "100px" : "200px",
        standalone: standalone,
        children: [
            showLayer && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.paratime")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardLink.DashboardLink), {
                            scope: token
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.name")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
                        scope: token,
                        address: token.eth_contract_addr ?? token.contract_addr,
                        name: token.name,
                        highlightedPart: highlightedPartOfName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            ml: 3,
                            fontWeight: 700,
                            color: (0, _colors.COLORS).grayMedium,
                            whiteSpace: "nowrap"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedText.HighlightedText), {
                            text: token.symbol,
                            pattern: highlightedPartOfName
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.type")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenTypeTag), {
                    tokenType: token.type
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t(isMobile ? "common.smartContract_short" : "common.smartContract")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                            scope: token,
                            address: token.eth_contract_addr ?? token.contract_addr
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                            value: token.eth_contract_addr ?? token.contract_addr
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("contract.verification.title")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.VerificationIcon), {
                    address_eth: token.eth_contract_addr,
                    verified: token.is_verified
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t(isMobile ? "tokens.holders" : "tokens.holdersCount")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: token.num_holders.toLocaleString()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("tokens.totalSupply")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: token.total_supply ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                    compactLargeNumbers: true,
                    value: token.total_supply
                }) : t("common.missing")
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","../Skeleton":"eB5vc","../StyledDescriptionList":"bndrS","../../hooks/useScreensize":"2HEhN","react-i18next":"e210a","./TokenLink":"ksoba","../CopyToClipboard":"iTQvM","../Account/AccountLink":"43Jgs","../../pages/ParatimeDashboardPage/DashboardLink":"k1EO2","../ContractVerificationIcon":"6tjz3","@mui/material/Box":"4d7LG","../../../styles/theme/colors":"hYvW2","./TokenList":"7bRlg","../RoundedBalance":"af34T","../HighlightedText":"hpIrd","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"eO7IX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalDetailsPage", ()=>ProposalDetailsPage);
parcelHelpers.export(exports, "ProposalDetailView", ()=>ProposalDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _info = require("@mui/icons-material/Info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _useScopeParam = require("../../hooks/useScopeParam");
var _api = require("../../../oasis-nexus/api");
var _errors = require("../../../types/errors");
var _reactRouterDom = require("react-router-dom");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _styledDescriptionList = require("app/components/StyledDescriptionList");
var _roundedBalance = require("../../components/RoundedBalance");
var _dashboardLink = require("../ParatimeDashboardPage/DashboardLink");
var _useScreensize = require("../../hooks/useScreensize");
var _proposalStatusIcon = require("../../components/Proposals/ProposalStatusIcon");
var _skeleton = require("../../components/Skeleton");
var _accountLink = require("../../components/Account/AccountLink");
var _highlightedText = require("../../components/HighlightedText");
var _colors = require("styles/theme/colors");
var _proposalVotesCard = require("./ProposalVotesCard");
var _hooks = require("./hooks");
var _skeleton1 = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton1);
var _proposalType = require("../../../types/proposalType");
const ProposalDetailsPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    if (scope.layer !== (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    const { proposalId, searchTerm } = (0, _reactRouterDom.useLoaderData)();
    const { isLoading: areStatsLoading, allVotesCount, isComplete: areStatsComplete } = (0, _hooks.useVoteStats)(scope.network, proposalId);
    const { isLoading, data } = (0, _api.useGetConsensusProposalsProposalId)(scope.network, proposalId);
    if (!data?.data && !isLoading) throw (0, _errors.AppErrors).NotFoundProposalId;
    const proposal = data?.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
                featured: true,
                title: t("common.proposal"),
                mainTitle: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProposalDetailView, {
                    isLoading: isLoading,
                    proposal: proposal,
                    totalVotesLoading: areStatsLoading,
                    totalVotesProblematic: !areStatsComplete && !areStatsLoading,
                    totalVotes: allVotesCount,
                    highlightedPart: searchTerm
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalVotesCard.ProposalVotesCard), {})
        ]
    });
};
const VoteLoadingProblemIndicator = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: t("networkProposal.failedToLoadAllVotes"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
            color: "error",
            fontSize: "inherit",
            sx: {
                ml: 2
            }
        })
    });
};
const ProposalDetailView = ({ proposal, isLoading, totalVotesLoading, totalVotesProblematic, totalVotes, showLayer = false, standalone = false, highlightedPart })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 7
    });
    const proposalType = (0, _proposalType.getTypeNameForProposal)(t, proposal);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "100px" : "200px",
        standalone: standalone,
        children: [
            showLayer && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.network")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardLink.DashboardLink), {
                            scope: proposal
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("networkProposal.id")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: proposal.id
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.title")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedText.HighlightedText), {
                    text: proposal.handler,
                    pattern: highlightedPart
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.type")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: proposalType
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.submitter")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                    scope: proposal,
                    address: proposal.submitter
                })
            }),
            (totalVotes || totalVotesLoading || totalVotesProblematic) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.totalVotes")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                        children: [
                            totalVotesLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                                variant: "text",
                                sx: {
                                    width: "25%"
                                }
                            }) : totalVotes?.toLocaleString(),
                            totalVotesProblematic && /*#__PURE__*/ (0, _jsxRuntime.jsx)(VoteLoadingProblemIndicator, {})
                        ]
                    })
                ]
            }),
            proposal.invalid_votes !== "0" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.invalidVotes")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: proposal.invalid_votes
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.status")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalStatusIcon.ProposalStatusIcon), {
                        status: proposal.state
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("networkProposal.deposit")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                    value: proposal.deposit
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("networkProposal.create")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: t("networkProposal.createTooltip"),
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex"
                        },
                        gap: 2,
                        children: [
                            proposal.created_at,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {
                                htmlColor: (0, _colors.COLORS).brandDark
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("networkProposal.close")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                    title: t("networkProposal.closeTooltip"),
                    placement: "top",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex"
                        },
                        gap: 2,
                        children: [
                            proposal.closes_at,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {
                                htmlColor: (0, _colors.COLORS).brandDark
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Tooltip":"3RLHy","@mui/icons-material/Info":"kPVDs","@mui/icons-material/Cancel":"l7K6K","../../hooks/useScopeParam":"kKMKx","../../../oasis-nexus/api":"dJrPU","../../../types/errors":"gdpNU","react-router-dom":"5o0mA","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","app/components/StyledDescriptionList":"bndrS","../../components/RoundedBalance":"af34T","../ParatimeDashboardPage/DashboardLink":"k1EO2","../../hooks/useScreensize":"2HEhN","../../components/Proposals/ProposalStatusIcon":"kgUEx","../../components/Skeleton":"eB5vc","../../components/Account/AccountLink":"43Jgs","../../components/HighlightedText":"hpIrd","styles/theme/colors":"hYvW2","./ProposalVotesCard":"f5AF6","./hooks":"dMAbh","@mui/material/Skeleton":"i7d9z","../../../types/proposalType":"dM8CS","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kgUEx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalStatusIcon", ()=>ProposalStatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _colors = require("../../../styles/theme/colors");
var _api = require("../../../oasis-nexus/api");
var _badge = require("../../components/Badge");
const getStatuses = (t)=>({
        [(0, _api.ProposalState).active]: {
            backgroundColor: (0, _colors.COLORS).honeydew,
            icon: (0, _checkCircleDefault.default),
            iconColor: (0, _colors.COLORS).eucalyptus,
            label: t("networkProposal.state.active"),
            textColor: (0, _colors.COLORS).grayExtraDark
        },
        [(0, _api.ProposalState).passed]: {
            backgroundColor: (0, _colors.COLORS).eucalyptus,
            icon: (0, _checkCircleDefault.default),
            iconColor: (0, _colors.COLORS).honeydew,
            label: t("networkProposal.state.passed"),
            textColor: (0, _colors.COLORS).white
        },
        [(0, _api.ProposalState).rejected]: {
            backgroundColor: (0, _colors.COLORS).errorIndicatorBackground,
            icon: (0, _cancelDefault.default),
            iconColor: (0, _colors.COLORS).linen,
            label: t("networkProposal.state.rejected"),
            textColor: (0, _colors.COLORS).white
        },
        [(0, _api.ProposalState).failed]: {
            backgroundColor: (0, _colors.COLORS).linen,
            icon: (0, _cancelDefault.default),
            iconColor: (0, _colors.COLORS).errorIndicatorBackground,
            label: t("networkProposal.state.failed"),
            textColor: (0, _colors.COLORS).grayExtraDark
        }
    });
const ProposalStatusIcon = ({ status })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!(0, _api.ProposalState)[status]) return null;
    const statusConfig = getStatuses(t)[status];
    const IconComponent = statusConfig.icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        backgroundColor: statusConfig.backgroundColor,
        textColor: statusConfig.textColor,
        label: statusConfig.label,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconComponent, {
            sx: {
                color: statusConfig.iconColor
            },
            fontSize: "inherit"
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Cancel":"l7K6K","../../../styles/theme/colors":"hYvW2","../../../oasis-nexus/api":"dJrPU","../../components/Badge":"dHMgv","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dHMgv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("@mui/material/styles");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 3,
        flex: 1,
        borderRadius: 10,
        padding: theme.spacing(2, 2, 2, "10px"),
        fontSize: "12px",
        minWidth: "85px"
    }));
const StyledIcon = (0, _styles.styled)((0, _boxDefault.default))({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "18px"
});
const Badge = ({ backgroundColor, icon, label, textColor })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
        sx: {
            backgroundColor,
            color: textColor
        },
        children: [
            label,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIcon, {
                children: icon
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"f5AF6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVotesView", ()=>ProposalVotesView);
parcelHelpers.export(exports, "ProposalVotesCard", ()=>ProposalVotesCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _useScopeParam = require("../../hooks/useScopeParam");
var _subPageCard = require("../../components/SubPageCard");
var _reactI18Next = require("react-i18next");
var _table = require("../../components/Table");
var _hooks = require("./hooks");
var _proposalVoteIndicator = require("../../components/Proposals/ProposalVoteIndicator");
var _deferredValidatorLink = require("../../components/Validators/DeferredValidatorLink");
var _cardHeaderWithResponsiveActions = require("../../components/CardHeaderWithResponsiveActions");
var _voteTypeFilter = require("../../components/Proposals/VoteTypeFilter");
var _errors = require("../../../types/errors");
var _errorBoundary = require("../../components/ErrorBoundary");
const ProposalVotes = ({ isLoading, votes, rowsNumber, pagination })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const tableColumns = [
        {
            key: "index",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}),
            width: "50px"
        },
        {
            key: "voter",
            content: t("common.voter"),
            align: (0, _table.TableCellAlign).Left
        },
        {
            key: "vote",
            content: t("common.vote"),
            align: (0, _table.TableCellAlign).Right
        }
    ];
    const tableRows = votes?.map((vote)=>{
        return {
            key: `vote-${vote.index}`,
            data: [
                {
                    key: "index",
                    content: `#${vote.index + 1}`
                },
                {
                    key: "voter",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deferredValidatorLink.DeferredValidatorLink), {
                        network: scope.network,
                        address: vote.address,
                        isError: vote.haveValidatorsFailed,
                        validator: vote.validator
                    })
                },
                {
                    key: "vote",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                        light: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalVoteIndicator.ProposalVoteIndicator), {
                            vote: vote.vote
                        })
                    }),
                    align: (0, _table.TableCellAlign).Right
                }
            ]
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        name: t("common.votes"),
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: rowsNumber,
        isLoading: isLoading,
        pagination: pagination
    });
};
const ProposalVotesView = ()=>{
    const { network } = (0, _useScopeParam.useRequiredScopeParam)();
    const proposalId = parseInt((0, _reactRouterDom.useParams)().proposalId, 10);
    const { isLoading } = (0, _hooks.useAllVotes)(network, proposalId);
    const displayedVotes = (0, _hooks.useDisplayedVotes)(network, proposalId);
    if (!isLoading && displayedVotes.tablePaginationProps.selectedPage > 1 && !displayedVotes.data?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProposalVotes, {
        isLoading: isLoading,
        votes: displayedVotes.data,
        rowsNumber: (0, _hooks.PAGE_SIZE),
        pagination: displayedVotes.tablePaginationProps
    });
};
const ProposalVotesCard = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [wantedVoteType, setWantedVoteType] = (0, _hooks.useWantedVoteType)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithResponsiveActions.CardHeaderWithResponsiveActions), {
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _voteTypeFilter.VoteTypeFilter), {
                    onSelect: setWantedVoteType,
                    value: wantedVoteType
                }),
                disableTypography: true,
                component: "h3",
                title: t("common.votes")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                light: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProposalVotesView, {})
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","../../hooks/useScopeParam":"kKMKx","../../components/SubPageCard":"dvWuD","react-i18next":"e210a","../../components/Table":"j3qb1","./hooks":"dMAbh","../../components/Proposals/ProposalVoteIndicator":"lagPu","../../components/Validators/DeferredValidatorLink":"bKhMc","../../components/CardHeaderWithResponsiveActions":"3R3jX","../../components/Proposals/VoteTypeFilter":"ig75t","../../../types/errors":"gdpNU","../../components/ErrorBoundary":"246yY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dMAbh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAllVotes", ()=>useAllVotes);
parcelHelpers.export(exports, "useVoteStats", ()=>useVoteStats);
parcelHelpers.export(exports, "useWantedVoteType", ()=>useWantedVoteType);
parcelHelpers.export(exports, "PAGE_SIZE", ()=>PAGE_SIZE);
parcelHelpers.export(exports, "useDisplayedVotes", ()=>useDisplayedVotes);
var _api = require("../../../oasis-nexus/api");
var _vote = require("../../utils/vote");
var _useClientSidePagination = require("../../components/Table/useClientSidePagination");
var _config = require("../../config");
var _useTypedSearchParam = require("../../hooks/useTypedSearchParam");
const DEBUG_MODE = false;
const voteTable = {};
const getRandomVoteFor = (address)=>{
    const storedVote = voteTable[address];
    if (storedVote) return storedVote;
    const newVote = (0, _vote.getRandomVote)();
    voteTable[address] = newVote;
    return newVote;
};
const useValidatorMap = (network)=>{
    const { data, isLoading, isError } = (0, _api.useGetConsensusValidators)(network);
    return {
        isLoading,
        isError,
        map: data?.data?.map ?? new Map()
    };
};
const useAllVotes = (network, proposalId)=>{
    const query = (0, _api.useGetConsensusProposalsProposalIdVotes)(network, proposalId);
    const { map: validators, isLoading: areValidatorsLoading, isError: haveValidatorsFailed } = useValidatorMap(network);
    const { isLoading, isError, data } = query;
    const extendedVotes = (data?.data.votes || []).map((vote, index)=>({
            ...vote,
            index,
            areValidatorsLoading,
            haveValidatorsFailed,
            validator: validators.get(vote.address)
        }));
    return {
        isLoading,
        isError,
        loadedVotes: DEBUG_MODE ? extendedVotes.map((v)=>({
                ...v,
                vote: getRandomVoteFor(v.address)
            })) || [] : extendedVotes,
        total_count: data?.data.total_count ?? 0,
        is_total_count_clipped: data?.data.is_total_count_clipped ?? false
    };
};
const useVoteStats = (network, proposalId)=>{
    const { isLoading, isError, loadedVotes, is_total_count_clipped } = useAllVotes(network, proposalId);
    const tally = {
        yes: 0n,
        no: 0n,
        abstain: 0n
    };
    // TODO: instead of 1n, we should add the power of the vote, but that data is not available yet.
    loadedVotes.forEach((vote)=>tally[vote.vote] += 1n);
    const allVotesCount = loadedVotes.length;
    const allVotesPower = tally.yes + tally.no + tally.abstain;
    const isComplete = !isError && !is_total_count_clipped;
    return {
        isLoading,
        isError,
        isComplete,
        tally,
        allVotesCount,
        allVotesPower
    };
};
const useWantedVoteType = ()=>(0, _useTypedSearchParam.useTypedSearchParam)("vote", "any", {
        deleteParams: [
            "page"
        ]
    });
const useWantedVoteFilter = ()=>(0, _vote.getFilterForVoteType)(useWantedVoteType()[0]);
const PAGE_SIZE = (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
const useDisplayedVotes = (network, proposalId)=>{
    const filter = useWantedVoteFilter();
    const pagination = (0, _useClientSidePagination.useClientSidePagination)({
        paramName: "page",
        clientPageSize: PAGE_SIZE,
        serverPageSize: 1000,
        filter
    });
    // Get all the votes
    const allVotes = useAllVotes(network, proposalId);
    // Get the section of the votes that we should display in the table
    return pagination.getResults(allVotes);
};

},{"../../../oasis-nexus/api":"dJrPU","../../utils/vote":"3dSHE","../../components/Table/useClientSidePagination":"4WHuV","../../config":"in6G4","../../hooks/useTypedSearchParam":"j3fN8","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3dSHE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRandomVote", ()=>getRandomVote);
parcelHelpers.export(exports, "getFilterForVoteType", ()=>getFilterForVoteType);
var _vote = require("../../types/vote");
const getRandomVote = ()=>[
        (0, _vote.ProposalVoteValue).yes,
        (0, _vote.ProposalVoteValue).no,
        (0, _vote.ProposalVoteValue).abstain
    ][Math.floor(Math.random() * 3)];
const voteFilters = {
    any: ()=>true,
    yes: (vote)=>vote.vote === (0, _vote.ProposalVoteValue).yes,
    no: (vote)=>vote.vote === (0, _vote.ProposalVoteValue).no,
    abstain: (vote)=>vote.vote === (0, _vote.ProposalVoteValue).abstain
};
const getFilterForVoteType = (voteType)=>voteFilters[voteType];

},{"../../types/vote":"9vZKH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9vZKH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVoteValue", ()=>ProposalVoteValue);
const ProposalVoteValue = {
    yes: "yes",
    no: "no",
    abstain: "abstain"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4WHuV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClientSidePagination", ()=>useClientSidePagination);
var _reactRouterDom = require("react-router-dom");
var _errors = require("../../../types/errors");
const knownListKeys = [
    "total_count",
    "is_total_count_clipped"
];
function findListIn(data) {
    const candidates = Object.keys(data).filter((key)=>!knownListKeys.includes(key) && Array.isArray(data[key]));
    switch(candidates.length){
        case 0:
            throw new Error("Data not found!");
        case 1:
            return data[candidates[0]];
        default:
            throw new Error("Data not found!");
    }
}
function useClientSidePagination({ paramName, clientPageSize, serverPageSize, filter }) {
    const selectedServerPage = 1;
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const selectedClientPageString = searchParams.get(paramName);
    const selectedClientPage = parseInt(selectedClientPageString ?? "1", 10);
    if (isNaN(selectedClientPage) || !!selectedClientPageString && selectedClientPage.toString() !== selectedClientPageString) // This would be nicer, but this would also trigger react-error-overlay (besides our error boundary).
    // We don't want that, so now, we are stuck with throwing a string, instead of a proper error.
    // throw new AppError(AppErrors.InvalidPageNumber)
    throw (0, _errors.AppErrors).InvalidPageNumber;
    function linkToPage(page) {
        const newSearchParams = new URLSearchParams(searchParams);
        if (page > 1) newSearchParams.set(paramName, page.toString());
        else newSearchParams.delete(paramName);
        return {
            search: newSearchParams.toString()
        };
    }
    const limit = serverPageSize;
    const offset = (selectedServerPage - 1) * clientPageSize;
    const paramsForQuery = {
        offset,
        limit
    };
    return {
        selectedPage: selectedClientPage,
        offsetForQuery: offset,
        limitForQuery: limit,
        paramsForQuery,
        getResults: (queryResult, key)=>{
            const data = queryResult ? key ? queryResult[key] : findListIn(queryResult) : undefined;
            const filteredData = !!data && !!filter ? data.filter(filter) : data;
            const offset = (selectedClientPage - 1) * clientPageSize;
            const limit = clientPageSize;
            const dataWindow = filteredData ? filteredData.slice(offset, offset + limit) : undefined;
            const tableProps = {
                selectedPage: selectedClientPage,
                linkToPage,
                totalCount: filteredData ? // Remove this when server-side pagination is fixed,
                // and so the work-around in the pagination widget is fixed.
                filteredData.length - clientPageSize * (selectedClientPage - 1) : undefined,
                isTotalCountClipped: queryResult?.is_total_count_clipped,
                rowsPerPage: clientPageSize
            };
            return {
                tablePaginationProps: tableProps,
                data: dataWindow
            };
        }
    };
}

},{"react-router-dom":"5o0mA","../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"j3fN8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTypedSearchParam", ()=>useTypedSearchParam);
var _reactRouterDom = require("react-router-dom");
function useTypedSearchParam(paramName, defaultValue, defaultSetterOptions = {}) {
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const value = searchParams.get(paramName) ?? defaultValue;
    const setValue = (newValue, options = defaultSetterOptions)=>{
        const { replace, preventScrollReset = true, deleteParams = [] } = options;
        if (newValue === defaultValue) searchParams.delete(paramName);
        else searchParams.set(paramName, newValue);
        deleteParams.forEach((p)=>searchParams.delete(p));
        setSearchParams(searchParams, {
            replace,
            preventScrollReset
        });
    };
    return [
        value,
        setValue
    ];
}

},{"react-router-dom":"5o0mA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lagPu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVoteIndicator", ()=>ProposalVoteIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _removeCircle = require("@mui/icons-material/RemoveCircle");
var _removeCircleDefault = parcelHelpers.interopDefault(_removeCircle);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
var _vote = require("../../../types/vote");
var _errors = require("../../../types/errors");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 3,
        flex: 1,
        borderRadius: 10,
        padding: theme.spacing(2, 2, 2, "10px"),
        fontSize: "12px",
        minWidth: "85px"
    }));
const StyledIcon = (0, _styles.styled)((0, _boxDefault.default))({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "18px"
});
const getStatuses = (t)=>({
        [(0, _vote.ProposalVoteValue).abstain]: {
            backgroundColor: (0, _colors.COLORS).lightSilver,
            icon: (0, _removeCircleDefault.default),
            iconColor: (0, _colors.COLORS).grayMedium,
            label: t("networkProposal.vote.abstain"),
            textColor: (0, _colors.COLORS).grayExtraDark
        },
        [(0, _vote.ProposalVoteValue).yes]: {
            backgroundColor: (0, _colors.COLORS).honeydew,
            icon: (0, _checkCircleDefault.default),
            iconColor: (0, _colors.COLORS).eucalyptus,
            label: t("networkProposal.vote.yes"),
            textColor: (0, _colors.COLORS).grayExtraDark
        },
        [(0, _vote.ProposalVoteValue).no]: {
            backgroundColor: (0, _colors.COLORS).linen,
            icon: (0, _cancelDefault.default),
            iconColor: (0, _colors.COLORS).errorIndicatorBackground,
            label: t("networkProposal.vote.no"),
            textColor: (0, _colors.COLORS).grayExtraDark
        }
    });
const ProposalVoteIndicator = ({ vote })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (!(0, _vote.ProposalVoteValue)[vote]) throw (0, _errors.AppErrors).InvalidVote;
    const statusConfig = getStatuses(t)[vote];
    const IconComponent = statusConfig.icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
        sx: {
            backgroundColor: statusConfig.backgroundColor,
            color: statusConfig.textColor
        },
        children: [
            statusConfig.label,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIcon, {
                sx: {
                    color: statusConfig.iconColor
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconComponent, {
                    color: "inherit",
                    fontSize: "inherit"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Cancel":"l7K6K","@mui/icons-material/RemoveCircle":"bSTKe","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","../../../types/vote":"9vZKH","../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bSTKe":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("8e0fdccd70b8c128");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("54e1ac8db149d975"));
var _jsxRuntime = require("8cc4429248501fdc");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircle");

},{"8e0fdccd70b8c128":"hykHy","54e1ac8db149d975":"gQLSP","8cc4429248501fdc":"g88cO"}],"bKhMc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeferredValidatorLink", ()=>DeferredValidatorLink);
var _jsxRuntime = require("react/jsx-runtime");
var _api = require("../../../oasis-nexus/api");
var _validatorLink = require("./ValidatorLink");
const DeferredValidatorLink = ({ network, address, validator, isError })=>{
    const scope = {
        network,
        layer: (0, _api.Layer).consensus
    };
    if (isError) console.log("Warning: failed to look up validators!");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorLink.ValidatorLink), {
        address: address,
        network: scope.network,
        name: validator?.media?.name
    });
};

},{"react/jsx-runtime":"g88cO","../../../oasis-nexus/api":"dJrPU","./ValidatorLink":"18CFQ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"18CFQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorLink", ()=>ValidatorLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _useScreensize = require("../../hooks/useScreensize");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _trimLinkLabel = require("../TrimLinkLabel");
var _routeUtils = require("../../utils/route-utils");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
const ValidatorLink = ({ address, name, network, alwaysTrim })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const to = (0, _routeUtils.RouteUtils).getValidatorRoute(network, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
        variant: "mono",
        component: "span",
        sx: {
            color: (0, _colors.COLORS).brandDark,
            fontWeight: 700
        },
        children: isTablet ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabletValidatorLink, {
            address: address,
            name: name,
            to: to
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(DesktopValidatorLink, {
            address: address,
            alwaysTrim: alwaysTrim,
            name: name,
            to: to
        })
    });
};
const TrimValidatorEndLinkLabel = ({ name, to })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trimLinkLabel.TrimEndLinkLabel), {
        label: name,
        to: to,
        trimStart: 14
    });
const TabletValidatorLink = ({ address, name, to })=>{
    if (name) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrimValidatorEndLinkLabel, {
        name: name,
        to: to
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trimLinkLabel.TrimLinkLabel), {
        label: address,
        to: to
    });
};
const DesktopValidatorLink = ({ address, name, to, alwaysTrim })=>{
    if (alwaysTrim) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trimLinkLabel.TrimLinkLabel), {
        label: address,
        to: to
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        component: (0, _reactRouterDom.Link),
        to: to,
        children: name ?? address
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","../../hooks/useScreensize":"2HEhN","@mui/material/Link":"fTbCF","../TrimLinkLabel":"it9ks","../../utils/route-utils":"b2kKi","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ig75t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VoteTypeFilter", ()=>VoteTypeFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
var _vote = require("../../../types/vote");
const VoteTypeFilter = ({ onSelect, value })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const options = [
        {
            label: t("networkProposal.vote.all"),
            value: "any"
        },
        {
            label: t("networkProposal.vote.yes"),
            value: (0, _vote.ProposalVoteValue).yes
        },
        {
            label: t("networkProposal.vote.abstain"),
            value: (0, _vote.ProposalVoteValue).abstain
        },
        {
            label: t("networkProposal.vote.no"),
            value: (0, _vote.ProposalVoteValue).no
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: options.map((option)=>{
            const selected = option.value === value;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                onClick: ()=>onSelect(option.value),
                clickable: true,
                color: "secondary",
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            fontSize: 16
                        },
                        children: option.label
                    })
                }),
                sx: {
                    mr: 3,
                    borderColor: (0, _colors.COLORS).brandMedium,
                    backgroundColor: selected ? (0, _colors.COLORS).brandMedium : (0, _colors.COLORS).brandMedium15,
                    color: selected ? (0, _colors.COLORS).white : (0, _colors.COLORS).grayExtraDark
                },
                variant: selected ? "outlined-selected" : "outlined"
            }, option.value);
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Chip":"aTO9B","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","../../../types/vote":"9vZKH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dM8CS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalType", ()=>ProposalType);
parcelHelpers.export(exports, "detectProposalType", ()=>detectProposalType);
parcelHelpers.export(exports, "getProposalTypeNames", ()=>getProposalTypeNames);
parcelHelpers.export(exports, "getTypeNameForProposal", ()=>getTypeNameForProposal);
const ProposalType = {
    upgrade: "upgrade",
    parameterUpgrade: "parameterUpgrade",
    cancellation: "cancellation"
};
const detectProposalType = (proposal)=>{
    const { cancels, parameters_change } = proposal;
    if (cancels) return ProposalType.cancellation;
    if (parameters_change) return ProposalType.parameterUpgrade;
    return ProposalType.upgrade;
};
const getProposalTypeNames = (t)=>({
        [ProposalType.upgrade]: t("networkProposal.type.upgrade"),
        [ProposalType.parameterUpgrade]: t("networkProposal.type.parameterUpgrade"),
        [ProposalType.cancellation]: t("networkProposal.type.cancellation")
    });
const getTypeNameForProposal = (t, proposal)=>{
    const names = getProposalTypeNames(t);
    const wantedType = detectProposalType(proposal);
    return names[wantedType];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lf4Wz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HideMoreResults", ()=>HideMoreResults);
parcelHelpers.export(exports, "ShowMoreResults", ()=>ShowMoreResults);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _zoomOut = require("@mui/icons-material/ZoomOut");
var _zoomOutDefault = parcelHelpers.interopDefault(_zoomOut);
var _reactI18Next = require("react-i18next");
var _zoomIn = require("@mui/icons-material/ZoomIn");
var _zoomInDefault = parcelHelpers.interopDefault(_zoomIn);
const NotificationBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        marginTop: 30,
        marginBottom: 30,
        marginLeft: "5%",
        marginRight: "5%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "5px 10px",
        gap: 10,
        minHeight: 50,
        background: theme.palette.layout.secondary,
        color: theme.palette.layout.titleOnBackground,
        cursor: "pointer",
        borderRadius: 50
    }));
const HideMoreResults = ({ theme, onHide })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NotificationBox, {
        theme: theme,
        onClick: onHide,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _zoomOutDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    i18nKey: "search.otherResults.clickToHide"
                })
            })
        ]
    });
};
const ShowMoreResults = ({ theme, onShow, hasWantedResults, otherResultsCount })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NotificationBox, {
        theme: theme,
        onClick: onShow,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _zoomInDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    t: t,
                    i18nKey: hasWantedResults ? "search.otherResults.clickToShowMore" : "search.otherResults.clickToShowThem",
                    values: {
                        countLabel: t(hasWantedResults ? "search.results.moreCount" : "search.results.count", {
                            count: otherResultsCount
                        })
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/material/Box":"4d7LG","@mui/icons-material/ZoomOut":"2m37B","react-i18next":"e210a","@mui/icons-material/ZoomIn":"8kbt6","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2m37B":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("2c7134386ff2392e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("f62228ec801dbb4a"));
var _jsxRuntime = require("570e350d0cf4313b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14M7 9h5v1H7z"
}), "ZoomOut");

},{"2c7134386ff2392e":"hykHy","f62228ec801dbb4a":"gQLSP","570e350d0cf4313b":"g88cO"}],"8kbt6":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("7b26d00297c524a4");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7919fb867eb1900e"));
var _jsxRuntime = require("c63c63604b9618b3");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2z"
    }, "1")
], "ZoomIn");

},{"7b26d00297c524a4":"hykHy","7919fb867eb1900e":"gQLSP","c63c63604b9618b3":"g88cO"}],"5OET2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** If search only finds one result then redirect to it */ parcelHelpers.export(exports, "useRedirectIfSingleResult", ()=>useRedirectIfSingleResult);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _routeUtils = require("../../utils/route-utils");
var _searchScope = require("../../../types/searchScope");
var _network = require("../../../types/network");
var _errors = require("../../../types/errors");
function useRedirectIfSingleResult(scope, searchTerm, results) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    let shouldRedirect = results.length === 1;
    if (shouldRedirect) {
        const result = results[0];
        shouldRedirect = scope ? (0, _searchScope.isItemInScope)(result, scope) : result.network === (0, _network.Network).mainnet;
    }
    let redirectTo;
    if (shouldRedirect) {
        const item = results[0];
        switch(item.resultType){
            case "block":
                redirectTo = (0, _routeUtils.RouteUtils).getBlockRoute(item, item.round);
                break;
            case "transaction":
                redirectTo = (0, _routeUtils.RouteUtils).getTransactionRoute(item, item.eth_hash || item.hash);
                break;
            case "account":
                redirectTo = (0, _routeUtils.RouteUtils).getAccountRoute(item, item.address_eth ?? item.address);
                break;
            case "contract":
                redirectTo = (0, _routeUtils.RouteUtils).getAccountRoute(item, item.address_eth ?? item.address);
                break;
            case "token":
                redirectTo = `${(0, _routeUtils.RouteUtils).getTokenRoute(item, item.eth_contract_addr || item.contract_addr)}?q=${searchTerm}`;
                break;
            case "proposal":
                redirectTo = `${(0, _routeUtils.RouteUtils).getProposalRoute(item.network, item.id)}?q=${searchTerm}`;
                break;
            default:
                (0, _errors.exhaustedTypeWarning)("Unexpected result type", item);
        }
    }
    (0, _react.useEffect)(()=>{
        if (redirectTo) navigate(redirectTo, {
            replace: true
        });
    }, [
        redirectTo,
        navigate
    ]);
}

},{"react":"BK2ob","react-router-dom":"5o0mA","../../utils/route-utils":"b2kKi","../../../types/searchScope":"6SEv5","../../../types/network":"f0o8N","../../../types/errors":"gdpNU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4xWIU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScopedSearchResultsView", ()=>ScopedSearchResultsView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _network = require("../../../types/network");
var _searchScope = require("../../../types/searchScope");
var _theme = require("../../../styles/theme");
var _routeUtils = require("../../utils/route-utils");
var _searchResultsList = require("./SearchResultsList");
var _noResults = require("./NoResults");
var _notifications = require("./notifications");
var _useRedirectIfSingleResult = require("./useRedirectIfSingleResult");
const ScopedSearchResultsView = ({ wantedScope, searchTerm, searchResults, tokenPrices })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [othersOpen, setOthersOpen] = (0, _react.useState)(false);
    const networkNames = (0, _network.getNetworkNames)(t);
    const themes = (0, _theme.getThemesForNetworks)();
    const isInWantedScope = (0, _searchScope.getFilterForScope)(wantedScope);
    const isNotInWantedScope = (0, _searchScope.getInverseFilterForScope)(wantedScope);
    const wantedResults = searchResults.filter(isInWantedScope);
    const otherResults = searchResults.filter(isNotInWantedScope);
    const notificationTheme = themes[otherResults.some((0, _network.isOnMainnet)) ? (0, _network.Network).mainnet : (0, _network.Network).testnet];
    (0, _useRedirectIfSingleResult.useRedirectIfSingleResult)(wantedScope, searchTerm, searchResults);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            wantedResults.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsList.SearchResultsList), {
                title: (0, _searchScope.getNameForScope)(t, wantedScope),
                searchTerm: searchTerm,
                searchResults: wantedResults,
                networkForTheme: wantedScope.network,
                tokenPrices: tokenPrices
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noResults.NoResultsInScope), {
                scope: wantedScope
            }),
            othersOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.HideMoreResults), {
                        theme: notificationTheme,
                        onHide: ()=>setOthersOpen(false)
                    }),
                    (0, _routeUtils.RouteUtils).getEnabledNetworks().filter((net)=>net !== wantedScope.network).map((net)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsList.SearchResultsList), {
                            networkForTheme: net,
                            title: networkNames[net],
                            searchTerm: searchTerm,
                            searchResults: otherResults.filter((0, _network.getFilterForNetwork)(net)),
                            tokenPrices: tokenPrices
                        }, net))
                ]
            }) : !!otherResults.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.ShowMoreResults), {
                theme: notificationTheme,
                onShow: ()=>setOthersOpen(true),
                hasWantedResults: !!wantedResults.length,
                otherResultsCount: otherResults.length
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","../../../types/network":"f0o8N","../../../types/searchScope":"6SEv5","../../../styles/theme":"i3yrR","../../utils/route-utils":"b2kKi","./SearchResultsList":"kLi9z","./NoResults":"1MutG","./notifications":"lf4Wz","./useRedirectIfSingleResult":"5OET2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dYU3Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoutingErrorPage", ()=>RoutingErrorPage);
var _jsxRuntime = require("react/jsx-runtime");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _pageLayout = require("../../components/PageLayout");
var _errorDisplay = require("../../components/ErrorDisplay");
var _reactRouterDom = require("react-router-dom");
var _themeByNetwork = require("../../components/ThemeByNetwork");
var _useScopeParam = require("../../hooks/useScopeParam");
var _network = require("../../../types/network");
const RoutingErrorPage = ()=>{
    const scope = (0, _useScopeParam.useScopeParam)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeByNetwork.ThemeByNetwork), {
        isRootTheme: true,
        network: scope?.network ?? (0, _network.Network).mainnet,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                    variant: "layout"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDisplay.ErrorDisplay), {
                    error: (0, _reactRouterDom.useRouteError)()
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Divider":"3hI6U","../../components/PageLayout":"24SOU","../../components/ErrorDisplay":"enjir","react-router-dom":"5o0mA","../../components/ThemeByNetwork":"4frPX","../../hooks/useScopeParam":"kKMKx","../../../types/network":"f0o8N","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fj3RC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokensPage", ()=>TokensPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _errors = require("../../../types/errors");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _tokenList = require("../../components/Tokens/TokenList");
var _tokenDetails = require("../../components/Tokens/TokenDetails");
var _verticalList = require("../../components/VerticalList");
const PAGE_SIZE = (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
const TokensPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * PAGE_SIZE;
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    // Consensus is not yet enabled in ENABLED_LAYERS, just some preparation
    if (scope.layer === (0, _api.Layer).consensus) throw (0, _errors.AppErrors).UnsupportedLayer;
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const tokensQuery = (0, _api.useGetRuntimeEvmTokens)(scope.network, scope.layer, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + PAGE_SIZE : PAGE_SIZE,
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    }, {
        query: {
            refetchInterval: (0, _config.REFETCH_INTERVAL),
            // Keep showing data while loading more
            keepPreviousData: tableView === (0, _tableLayoutButton.TableLayout).Vertical
        }
    });
    const { isLoading, isFetched, data } = tokensQuery;
    const tokens = data?.data.evm_tokens;
    if (isFetched && pagination.selectedPage > 1 && !tokens?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout",
                sx: {
                    mb: 6
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: t("common.tokens"),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenList), {
                        isLoading: isLoading,
                        tokens: tokens,
                        limit: PAGE_SIZE,
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        }
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array(PAGE_SIZE).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDetails.TokenDetails), {
                                    isLoading: true,
                                    token: undefined,
                                    highlightedPartOfName: undefined,
                                    standalone: true
                                }, key)),
                            !isLoading && tokens.map((token)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDetails.TokenDetails), {
                                    token: token,
                                    highlightedPartOfName: undefined,
                                    standalone: true
                                }, token.contract_addr))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../../../types/errors":"gdpNU","../../components/TableLayoutButton":"5tkdC","../../components/LoadMoreButton":"aeVDT","../../hooks/useScopeParam":"kKMKx","../../components/Tokens/TokenList":"7bRlg","../../components/Tokens/TokenDetails":"dKlp5","../../components/VerticalList":"gcFw0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kpoS5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTokenDashboardProps", ()=>useTokenDashboardProps);
parcelHelpers.export(exports, "TokenDashboardPage", ()=>TokenDashboardPage);
var _jsxRuntime = require("react/jsx-runtime");
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _tokenTitleCard = require("./TokenTitleCard");
var _tokenSnapshot = require("./TokenSnapshot");
var _tokenDetailsCard = require("./TokenDetailsCard");
var _useScopeParam = require("../../hooks/useScopeParam");
var _reactRouterDom = require("react-router-dom");
var _hook = require("./hook");
var _errors = require("../../../types/errors");
var _routerTabs = require("../../components/RouterTabs");
var _reactI18Next = require("react-i18next");
var _contractCodeCard = require("../RuntimeAccountDetailsPage/ContractCodeCard");
var _tokenHoldersCard = require("./TokenHoldersCard");
var _tokenInventoryCard = require("./TokenInventoryCard");
var _dappBanner = require("../../components/DappBanner");
const useTokenDashboardProps = ()=>(0, _reactRouterDom.useOutletContext)();
const TokenDashboardPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { address, searchTerm } = (0, _reactRouterDom.useLoaderData)();
    const { token, isError } = (0, _hook.useTokenInfo)(scope, address);
    if (isError) throw (0, _errors.AppErrors).InvalidAddress;
    const tokenTransfersLink = (0, _reactRouterDom.useHref)(``);
    const tokenHoldersLink = (0, _reactRouterDom.useHref)(`holders#${(0, _tokenHoldersCard.tokenHoldersContainerId)}`);
    const codeLink = (0, _reactRouterDom.useHref)(`code#${(0, _contractCodeCard.contractCodeContainerId)}`);
    const inventoryLink = (0, _reactRouterDom.useHref)(`inventory#${(0, _tokenInventoryCard.tokenInventoryContainerId)}`);
    const context = {
        scope,
        address
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTitleCard.TokenTitleCard), {
                scope: scope,
                address: address,
                searchTerm: searchTerm
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dappBanner.DappBanner), {
                scope: scope,
                ethAddress: token?.eth_contract_addr
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenSnapshot.TokenSnapshot), {
                scope: scope,
                address: address
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout",
                sx: {
                    mt: isMobile ? 4 : 0
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenDetailsCard.TokenDetailsCard), {
                scope: scope,
                address: address,
                searchTerm: searchTerm
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routerTabs.RouterTabs), {
                tabs: [
                    {
                        label: t("common.transfers"),
                        to: tokenTransfersLink
                    },
                    {
                        label: t("tokens.holders"),
                        to: tokenHoldersLink
                    },
                    {
                        label: t("tokens.inventory"),
                        to: inventoryLink
                    },
                    {
                        label: t("contract.code"),
                        to: codeLink
                    }
                ],
                context: context
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","@mui/material/Divider":"3hI6U","./TokenTitleCard":"hFQv5","./TokenSnapshot":"elMWL","./TokenDetailsCard":"kaZvE","../../hooks/useScopeParam":"kKMKx","react-router-dom":"5o0mA","./hook":"iNjez","../../../types/errors":"gdpNU","../../components/RouterTabs":"dUetQ","react-i18next":"e210a","../RuntimeAccountDetailsPage/ContractCodeCard":"ii2WJ","./TokenHoldersCard":"76uS1","./TokenInventoryCard":"8nPci","../../components/DappBanner":"dtzTP","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hFQv5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenTitleCard", ()=>TokenTitleCard);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
var _hook = require("./hook");
var _contractVerificationIcon = require("../../components/ContractVerificationIcon");
var _accountLink = require("../../components/Account/AccountLink");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _reactI18Next = require("react-i18next");
var _highlightedText = require("../../components/HighlightedText");
var _titleCard = require("../../components/PageLayout/TitleCard");
const TokenTitleCard = ({ scope, address, searchTerm })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, token } = (0, _hook.useTokenInfo)(scope, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleCard.TitleCard), {
        details: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: token && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.VerificationIcon), {
                        address_eth: token.eth_contract_addr,
                        verified: token.is_verified,
                        noLink: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: token,
                        address: token.eth_contract_addr || token.contract_addr,
                        alwaysTrim: true
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: token.eth_contract_addr || token.contract_addr
                    })
                ]
            })
        }),
        isLoading: isLoading,
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                token?.name ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedText.HighlightedText), {
                    text: token.name,
                    pattern: searchTerm
                }) : t("common.missing"),
                "\xa0",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    component: "span",
                    sx: {
                        color: (0, _colors.COLORS).grayMedium,
                        fontSize: "24px",
                        fontWeight: 700
                    },
                    children: token?.symbol ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedText.HighlightedText), {
                        text: token.symbol,
                        pattern: searchTerm
                    }) : t("common.missing")
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","./hook":"iNjez","../../components/ContractVerificationIcon":"6tjz3","../../components/Account/AccountLink":"43Jgs","../../components/CopyToClipboard":"iTQvM","react-i18next":"e210a","../../components/HighlightedText":"hpIrd","../../components/PageLayout/TitleCard":"hNFSw","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hNFSw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCard", ()=>StyledCard);
parcelHelpers.export(exports, "TitleCard", ()=>TitleCard);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
const StyledCard = (0, _styles.styled)((0, _cardDefault.default))(()=>({
        "&": {
            paddingTop: "24px",
            marginBottom: "50px"
        }
    }));
const TitleSkeleton = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
        variant: "text",
        sx: {
            display: "inline-block",
            width: "100%"
        }
    });
const TitleCard = ({ isLoading, details, title })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCard, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSkeleton, {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    alignItems: "center"
                },
                gap: 3,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h2",
                        sx: {
                            display: "inline-flex",
                            fontWeight: 700,
                            flexWrap: "wrap"
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: details
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","@mui/material/Skeleton":"i7d9z","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"elMWL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenSnapshot", ()=>TokenSnapshot);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _reactI18Next = require("react-i18next");
var _appendMobileSearch = require("../../components/AppendMobileSearch");
var _tokenSupplyCard = require("./TokenSupplyCard");
var _tokenHoldersCountCard = require("./TokenHoldersCountCard");
var _tokenTypeCard = require("./TokenTypeCard");
var _tokenTotalTransactionsCard = require("./TokenTotalTransactionsCard");
var _snapshot = require("../../components/Snapshots/Snapshot");
const TokenSnapshot = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const theme = (0, _styles.useTheme)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    mb: 4
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    item: true,
                    xs: 12,
                    sx: {
                        px: isMobile ? 4 : 0
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appendMobileSearch.AppendMobileSearch), {
                        scope: scope,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h3",
                                sx: {
                                    color: theme.palette.layout.main,
                                    fontWeight: 700,
                                    mr: 3
                                },
                                children: t("tokenSnapshot.header")
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                rowSpacing: 1,
                columnSpacing: 4,
                columns: 22,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 5,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTotalTransactionsCard.TokenTotalTransactionsCard), {
                            scope: scope,
                            address: address
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenSupplyCard.TokenSupplyCard), {
                            scope: scope,
                            address: address
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 5,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenHoldersCountCard.TokenHoldersCountCard), {
                            scope: scope,
                            address: address
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTypeCard.TokenTypeCard), {
                            scope: scope,
                            address: address
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Grid":"bu56N","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","react-i18next":"e210a","../../components/AppendMobileSearch":"7MClM","./TokenSupplyCard":"9sfoC","./TokenHoldersCountCard":"7MZg3","./TokenTypeCard":"gGEKK","./TokenTotalTransactionsCard":"bBPXa","../../components/Snapshots/Snapshot":"91gmN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9sfoC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenSupplyCard", ()=>TokenSupplyCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _colors = require("../../../styles/theme/colors");
var _hook = require("./hook");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _roundedBalance = require("../../components/RoundedBalance");
const TokenSupplyCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, token, isFetched } = (0, _hook.useTokenInfo)(scope, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: t("tokens.totalSupply"),
        label: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
            variant: "text",
            sx: {
                width: "4em"
            }
        }) : token?.symbol,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                sx: {
                    width: "50%"
                }
            }) : isFetched && token && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "32px",
                    fontWeight: 700,
                    color: (0, _colors.COLORS).brandDark,
                    textAlign: "center",
                    width: "100%"
                },
                children: token.total_supply ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                    value: token.total_supply,
                    compactLargeNumbers: true
                }) : t("common.not_defined")
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../components/Snapshots/SnapshotCard":"b3UOK","../../../styles/theme/colors":"hYvW2","./hook":"iNjez","@mui/material/Skeleton":"i7d9z","../../components/RoundedBalance":"af34T","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7MZg3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenHoldersCountCard", ()=>TokenHoldersCountCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _colors = require("../../../styles/theme/colors");
var _hook = require("./hook");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
const TokenHoldersCountCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, token, isFetched } = (0, _hook.useTokenInfo)(scope, address);
    const title = t("tokens.holders");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: title,
        withConstantHeight: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                sx: {
                    width: "50%"
                }
            }) : isFetched && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "32px",
                    fontWeight: 700,
                    color: (0, _colors.COLORS).brandDark
                },
                children: t("tokens.holdersValue", {
                    value: token?.num_holders
                })
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../components/Snapshots/SnapshotCard":"b3UOK","../../../styles/theme/colors":"hYvW2","./hook":"iNjez","@mui/material/Skeleton":"i7d9z","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gGEKK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenTypeCard", ()=>TokenTypeCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _colors = require("../../../styles/theme/colors");
var _hook = require("./hook");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _tokens = require("../../../types/tokens");
const TokenTypeCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, token, isFetched } = (0, _hook.useTokenInfo)(scope, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: t("common.type"),
        withConstantHeight: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                sx: {
                    width: "50%"
                }
            }) : isFetched && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "32px",
                    fontWeight: 700,
                    color: (0, _colors.COLORS).brandDark,
                    textAlign: "center"
                },
                children: token?.type ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        (0, _tokens.getTokenTypeDescription)(t, token.type),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            component: "span",
                            sx: {
                                display: "flex",
                                fontSize: "24px",
                                fontWeight: 700,
                                color: (0, _colors.COLORS).grayMedium
                            },
                            children: [
                                "(",
                                (0, _tokens.getTokenTypeStrictName)(t, token.type),
                                ")"
                            ]
                        })
                    ]
                }) : "-"
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../components/Snapshots/SnapshotCard":"b3UOK","../../../styles/theme/colors":"hYvW2","./hook":"iNjez","@mui/material/Skeleton":"i7d9z","../../../types/tokens":"38Dxq","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bBPXa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenTotalTransactionsCard", ()=>TokenTotalTransactionsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _colors = require("../../../styles/theme/colors");
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _hook = require("./hook");
const TokenTotalTransactionsCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, token, isFetched } = (0, _hook.useTokenInfo)(scope, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: t("common.transfers"),
        withConstantHeight: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                sx: {
                    width: "50%"
                }
            }) : isFetched && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    fontSize: "32px",
                    fontWeight: 700,
                    color: (0, _colors.COLORS).brandDark
                },
                children: t("common.valuePair", {
                    value: token?.num_transfers
                })
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../components/Snapshots/SnapshotCard":"b3UOK","../../../styles/theme/colors":"hYvW2","@mui/material/Skeleton":"i7d9z","./hook":"iNjez","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kaZvE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenDetailsCard", ()=>TokenDetailsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _hook = require("./hook");
var _hook1 = require("../RuntimeAccountDetailsPage/hook");
var _skeleton = require("../../components/Skeleton");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _useScreensize = require("../../hooks/useScreensize");
var _reactI18Next = require("react-i18next");
var _accountLink = require("../../components/Account/AccountLink");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _contractVerificationIcon = require("../../components/ContractVerificationIcon");
var _contractCreatorInfo = require("../../components/Account/ContractCreatorInfo");
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _tokenList = require("../../components/Tokens/TokenList");
var _routeUtils = require("../../utils/route-utils");
var _tokenTransfersCard = require("../../pages/TokenDashboardPage/TokenTransfersCard");
var _tokenHoldersCard = require("../../pages/TokenDashboardPage/TokenHoldersCard");
var _roundedBalance = require("app/components/RoundedBalance");
var _highlightedText = require("../../components/HighlightedText");
var _runtimeBalanceDisplay = require("../../components/Balance/RuntimeBalanceDisplay");
const TokenDetailsCard = ({ scope, address, searchTerm })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { token, isLoading: tokenIsLoading } = (0, _hook.useTokenInfo)(scope, address);
    const { account, isLoading: accountIsLoading } = (0, _hook1.useAccount)(scope, address);
    const isLoading = tokenIsLoading || accountIsLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardContentDefault.default), {
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
                    numberOfRows: 7
                }),
                !isLoading && account && token && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                    titleWidth: isMobile ? "100px" : "200px",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("common.token")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highlightedText.HighlightedText), {
                                text: token.name,
                                pattern: searchTerm
                            })
                        }),
                        isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                    children: t("common.ticker")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                    children: token.symbol
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t(isMobile ? "common.smartContract_short" : "common.smartContract")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                    scope: account,
                                    address: account.address_eth || account.address
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                    value: account.address_eth || account.address
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("contract.verification.title")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.VerificationIcon), {
                                address_eth: token.eth_contract_addr,
                                verified: token.is_verified
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                            children: [
                                t("common.type"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenTypeTag), {
                                tokenType: token.type
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("contract.creator")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractCreatorInfo.DelayedContractCreatorInfo), {
                                scope: token,
                                contractOasisAddress: token.contract_addr,
                                alwaysTrim: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                            children: [
                                t("common.balance"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeBalanceDisplay.RuntimeBalanceDisplay), {
                                balances: account?.balances
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("tokens.totalSupply")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: token.total_supply ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                                value: token.total_supply,
                                ticker: token?.symbol
                            }) : t("common.not_defined")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("tokens.holders")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                component: (0, _reactRouterDom.Link),
                                to: `${(0, _routeUtils.RouteUtils).getTokenHoldersRoute(scope, token.eth_contract_addr)}#${(0, _tokenHoldersCard.tokenHoldersContainerId)}`,
                                children: t("tokens.holdersValue", {
                                    value: token?.num_holders
                                })
                            })
                        }),
                        token.num_transfers && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                    children: t("common.transfers")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                        component: (0, _reactRouterDom.Link),
                                        to: `${(0, _routeUtils.RouteUtils).getTokenRoute(scope, token.eth_contract_addr)}#${(0, _tokenTransfersCard.tokenTransfersContainerId)}`,
                                        children: token.num_transfers.toLocaleString()
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Card":"cTsx6","@mui/material/Link":"fTbCF","./hook":"iNjez","../RuntimeAccountDetailsPage/hook":"iVoy2","../../components/Skeleton":"eB5vc","../../components/StyledDescriptionList":"bndrS","../../hooks/useScreensize":"2HEhN","react-i18next":"e210a","../../components/Account/AccountLink":"43Jgs","../../components/CopyToClipboard":"iTQvM","../../components/ContractVerificationIcon":"6tjz3","../../components/Account/ContractCreatorInfo":"cv1gp","@mui/material/CardContent":"kMUKY","../../components/Tokens/TokenList":"7bRlg","../../utils/route-utils":"b2kKi","../../pages/TokenDashboardPage/TokenTransfersCard":"kCyMs","../../pages/TokenDashboardPage/TokenHoldersCard":"76uS1","app/components/RoundedBalance":"af34T","../../components/HighlightedText":"hpIrd","../../components/Balance/RuntimeBalanceDisplay":"4jk33","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kCyMs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tokenTransfersContainerId", ()=>tokenTransfersContainerId);
parcelHelpers.export(exports, "TokenTransfersCard", ()=>TokenTransfersCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _tokenTransfers = require("../../components/Tokens/TokenTransfers");
var _cardEmptyState = require("../../components/CardEmptyState");
var _hook = require("../RuntimeAccountDetailsPage/hook");
var _hook1 = require("./hook");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
const tokenTransfersContainerId = "tokenTransfers";
const TokenTransfersCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: tokenTransfersContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("common.transfers")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenTransfersView, {
                        scope: scope,
                        address: address
                    })
                })
            })
        ]
    });
};
const TokenTransfersView = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading: areTransfersLoading, isFetched, results } = (0, _hook1.useTokenTransfers)(scope, {
        address
    });
    const { isLoading: isTokenLoading } = (0, _hook1.useTokenInfo)(scope, address);
    const { isLoading: isAccountLoading, account } = (0, _hook.useAccount)(scope, address);
    const isLoading = isTokenLoading || isAccountLoading || areTransfersLoading;
    const transfers = results.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !transfers?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("account.emptyTokenTransferList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTransfers.TokenTransfers), {
                transfers: transfers,
                ownAddress: account?.address_eth,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: results.tablePaginationProps
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/Tokens/TokenTransfers":"fFZHn","../../components/CardEmptyState":"aiX1q","../RuntimeAccountDetailsPage/hook":"iVoy2","./hook":"iNjez","../../components/PageLayout/LinkableDiv":"dLOUR","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"76uS1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tokenHoldersContainerId", ()=>tokenHoldersContainerId);
parcelHelpers.export(exports, "TokenHoldersCard", ()=>TokenHoldersCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _hook = require("./hook");
var _tokenHolders = require("../../components/Tokens/TokenHolders");
const tokenHoldersContainerId = "holders";
const TokenHoldersCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: tokenHoldersContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("tokens.holders")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenHoldersView, {
                        scope: scope,
                        address: address
                    })
                })
            })
        ]
    });
};
const TokenHoldersView = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading: isTokenLoading, token } = (0, _hook.useTokenInfo)(scope, address);
    const { isLoading: areHoldersLoading, isFetched, holders, pagination, totalCount, isTotalCountClipped } = (0, _hook.useTokenHolders)(scope, address);
    const isLoading = isTokenLoading || areHoldersLoading;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !totalCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("tokens.emptyTokenHolderList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenHolders.TokenHolders), {
                holders: holders,
                decimals: token?.decimals ?? 0,
                totalSupply: token?.total_supply,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: {
                    selectedPage: pagination.selectedPage,
                    linkToPage: pagination.linkToPage,
                    totalCount,
                    isTotalCountClipped,
                    rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","./hook":"iNjez","../../components/Tokens/TokenHolders":"i8t4I","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"i8t4I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenHolders", ()=>TokenHolders);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _table = require("../Table");
var _accountLink = require("../Account/AccountLink");
var _helpers = require("../../utils/helpers");
var _roundedBalance = require("../RoundedBalance");
var _progressBar = require("../ProgressBar");
const TokenHolders = ({ isLoading, limit, pagination, holders, decimals, totalSupply })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const tableColumns = [
        {
            key: "rank",
            content: t("common.rank")
        },
        {
            key: "address",
            content: t("common.address")
        },
        {
            key: "quantity",
            content: t("common.quantity"),
            align: (0, _table.TableCellAlign).Right
        },
        {
            key: "percentage",
            content: t("common.percentage"),
            align: (0, _table.TableCellAlign).Right
        }
    ];
    const calculateRatio = (balance, totalSupply, decimals)=>{
        return 100 * parseFloat((0, _helpers.fromBaseUnits)(balance, decimals)) / parseFloat(totalSupply);
    };
    const tableRows = holders?.map((holder, index)=>{
        return {
            key: holder.holder_address,
            data: [
                {
                    key: "rank",
                    content: holder.rank.toLocaleString()
                },
                {
                    key: "address",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: holder,
                        address: holder.eth_holder_address || holder.holder_address,
                        alwaysTrim: true
                    })
                },
                {
                    key: "quantity",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        value: (0, _helpers.fromBaseUnits)(holder.balance, decimals)
                    }),
                    align: (0, _table.TableCellAlign).Right
                },
                {
                    key: "percentage",
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: totalSupply ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end"
                            },
                            gap: 4,
                            children: [
                                `${calculateRatio(holder.balance, totalSupply, decimals).toFixed(4)}%`,
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBar.ProgressBar), {
                                    value: calculateRatio(holder.balance, totalSupply, decimals),
                                    variant: "determinate"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: t("common.missing")
                        })
                    }),
                    align: (0, _table.TableCellAlign).Right
                }
            ],
            highlight: holder.markAsNew
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("transactions.latest"),
        isLoading: isLoading,
        pagination: pagination,
        extraHorizontalSpaceOnMobile: true
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","../Table":"j3qb1","../Account/AccountLink":"43Jgs","../../utils/helpers":"2aVNs","../RoundedBalance":"af34T","../ProgressBar":"5Dj8t","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8nPci":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tokenInventoryContainerId", ()=>tokenInventoryContainerId);
parcelHelpers.export(exports, "TokenInventoryCard", ()=>TokenInventoryCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _imageList = require("@mui/material/ImageList");
var _imageListDefault = parcelHelpers.interopDefault(_imageList);
var _imageListItem = require("@mui/material/ImageListItem");
var _imageListItemDefault = parcelHelpers.interopDefault(_imageListItem);
var _imageListItemBar = require("@mui/material/ImageListItemBar");
var _imageListItemBarDefault = parcelHelpers.interopDefault(_imageListItemBar);
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _routeUtils = require("../../utils/route-utils");
var _tablePagination = require("../../components/Table/TablePagination");
var _hook = require("./hook");
var _imageListItemImage = require("./ImageListItemImage");
var _nftlinks = require("./NFTLinks");
var _cardHeaderWithCounter = require("app/components/CardHeaderWithCounter");
const tokenInventoryContainerId = "inventory";
const TokenInventoryCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { inventory, isFetched, pagination, totalCount } = (0, _hook.useTokenInventory)(scope, address);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: tokenInventoryContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                        label: t("tokens.inventory"),
                        totalCount: totalCount,
                        isTotalCountClipped: pagination.isTotalCountClipped
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TokenInventoryView, {
                        inventory: inventory,
                        isFetched: isFetched,
                        pagination: pagination,
                        scope: scope,
                        totalCount: totalCount
                    })
                })
            })
        ]
    });
};
const TokenInventoryView = ({ inventory, isFetched, pagination, scope, totalCount })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !totalCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("tokens.emptyInventory")
            }),
            !!inventory?.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListDefault.default), {
                        gap: 10,
                        children: inventory?.map((instance)=>{
                            const owner = instance?.owner_eth ?? instance?.owner;
                            const to = (0, _routeUtils.RouteUtils).getNFTInstanceRoute(scope, instance.token?.contract_addr, instance.id);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _imageListItemDefault.default), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListItemImage.ImageListItemImage), {
                                        instance: instance,
                                        to: to
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListItemBarDefault.default), {
                                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nftlinks.NFTInstanceLink), {
                                            scope: scope,
                                            instance: instance
                                        }),
                                        subtitle: owner ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nftlinks.NFTOwnerLink), {
                                            scope: scope,
                                            owner: owner
                                        }) : undefined,
                                        position: "below"
                                    })
                                ]
                            }, instance.id);
                        })
                    }),
                    pagination && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablePagination.TablePagination), {
                            ...pagination,
                            totalCount: totalCount
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/ImageList":"50ELL","@mui/material/ImageListItem":"fZHXB","@mui/material/ImageListItemBar":"6jHZB","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../../utils/route-utils":"b2kKi","../../components/Table/TablePagination":"davz5","./hook":"iNjez","./ImageListItemImage":"1dxmo","./NFTLinks":"6inNA","app/components/CardHeaderWithCounter":"82LaW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"50ELL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _imageListDefault.default));
parcelHelpers.export(exports, "imageListClasses", ()=>(0, _imageListClassesDefault.default));
var _imageList = require("./ImageList");
var _imageListDefault = parcelHelpers.interopDefault(_imageList);
var _imageListClasses = require("./imageListClasses");
parcelHelpers.exportAll(_imageListClasses, exports);
var _imageListClassesDefault = parcelHelpers.interopDefault(_imageListClasses);
"use client";

},{"./ImageList":"uraG7","./imageListClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"uraG7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _imageListClasses = require("./imageListClasses");
var _imageListContext = require("./ImageListContext");
var _imageListContextDefault = parcelHelpers.interopDefault(_imageListContext);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "cols",
    "component",
    "rowHeight",
    "gap",
    "style",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _imageListClasses.getImageListUtilityClass), classes);
};
const ImageListRoot = (0, _styledDefault.default)("ul", {
    name: "MuiImageList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})(({ ownerState })=>{
    return (0, _extendsDefault.default)({
        display: "grid",
        overflowY: "auto",
        listStyle: "none",
        padding: 0,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch"
    }, ownerState.variant === "masonry" && {
        display: "block"
    });
});
const ImageList = /*#__PURE__*/ _react.forwardRef(function ImageList(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiImageList"
    });
    const { children, className, cols = 2, component = "ul", rowHeight = "auto", gap = 4, style: styleProp, variant = "standard" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const contextValue = _react.useMemo(()=>({
            rowHeight,
            gap,
            variant
        }), [
        rowHeight,
        gap,
        variant
    ]);
    _react.useEffect(()=>{}, []);
    const style = variant === "masonry" ? (0, _extendsDefault.default)({
        columnCount: cols,
        columnGap: gap
    }, styleProp) : (0, _extendsDefault.default)({
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap
    }, styleProp);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        gap,
        rowHeight,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageListRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, classes[variant], className),
        ref: ref,
        style: style,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListContextDefault.default).Provider, {
            value: contextValue,
            children: children
        })
    }));
});
exports.default = ImageList;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/composeClasses":"jj3MR","@mui/utils/integerPropType":"3uD7f","clsx":"bGtJT","prop-types":"hRUel","react":"BK2ob","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","./imageListClasses":"1umTS","./ImageListContext":"7eyeK","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1umTS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getImageListUtilityClass", ()=>getImageListUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getImageListUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiImageList", slot);
}
const imageListClasses = (0, _generateUtilityClassesDefault.default)("MuiImageList", [
    "root",
    "masonry",
    "quilted",
    "standard",
    "woven"
]);
exports.default = imageListClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7eyeK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const ImageListContext = /*#__PURE__*/ _react.createContext({});
exports.default = ImageListContext;

},{"react":"BK2ob","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fZHXB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _imageListItemDefault.default));
parcelHelpers.export(exports, "imageListItemClasses", ()=>(0, _imageListItemClassesDefault.default));
var _imageListItem = require("./ImageListItem");
var _imageListItemDefault = parcelHelpers.interopDefault(_imageListItem);
var _imageListItemClasses = require("./imageListItemClasses");
parcelHelpers.exportAll(_imageListItemClasses, exports);
var _imageListItemClassesDefault = parcelHelpers.interopDefault(_imageListItemClasses);
"use client";

},{"./ImageListItem":"jRR4J","./imageListItemClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jRR4J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactIs = require("react-is");
var _imageListContext = require("../ImageList/ImageListContext");
var _imageListContextDefault = parcelHelpers.interopDefault(_imageListContext);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _imageListItemClasses = require("./imageListItemClasses");
var _imageListItemClassesDefault = parcelHelpers.interopDefault(_imageListItemClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "cols",
    "component",
    "rows",
    "style"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        img: [
            "img"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _imageListItemClasses.getImageListItemUtilityClass), classes);
};
const ImageListItemRoot = (0, _styledDefault.default)("li", {
    name: "MuiImageListItem",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _imageListItemClassesDefault.default).img}`]: styles.img
            },
            styles.root,
            styles[ownerState.variant]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: "block",
        position: "relative"
    }, ownerState.variant === "standard" && {
        // For titlebar under list item
        display: "flex",
        flexDirection: "column"
    }, ownerState.variant === "woven" && {
        height: "100%",
        alignSelf: "center",
        "&:nth-of-type(even)": {
            height: "70%"
        }
    }, {
        [`& .${(0, _imageListItemClassesDefault.default).img}`]: (0, _extendsDefault.default)({
            objectFit: "cover",
            width: "100%",
            height: "100%",
            display: "block"
        }, ownerState.variant === "standard" && {
            height: "auto",
            flexGrow: 1
        })
    }));
const ImageListItem = /*#__PURE__*/ _react.forwardRef(function ImageListItem(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiImageListItem"
    });
    // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
    const { children, className, cols = 1, component = "li", rows = 1, style } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { rowHeight = "auto", gap, variant } = _react.useContext((0, _imageListContextDefault.default));
    let height = "auto";
    if (variant === "woven") height = undefined;
    else if (rowHeight !== "auto") height = rowHeight * rows + gap * (rows - 1);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        cols,
        component,
        gap,
        rowHeight,
        rows,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageListItemRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, classes[variant], className),
        ref: ref,
        style: (0, _extendsDefault.default)({
            height,
            gridColumnEnd: variant !== "masonry" ? `span ${cols}` : undefined,
            gridRowEnd: variant !== "masonry" ? `span ${rows}` : undefined,
            marginBottom: variant === "masonry" ? gap : undefined,
            breakInside: variant === "masonry" ? "avoid" : undefined
        }, style),
        ownerState: ownerState
    }, other, {
        children: _react.Children.map(children, (child)=>{
            if (!/*#__PURE__*/ _react.isValidElement(child)) return null;
            if (child.type === "img" || (0, _isMuiElementDefault.default)(child, [
                "Image"
            ])) return /*#__PURE__*/ _react.cloneElement(child, {
                className: (0, _clsxDefault.default)(classes.img, child.props.className)
            });
            return child;
        })
    }));
});
exports.default = ImageListItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/composeClasses":"jj3MR","@mui/utils/integerPropType":"3uD7f","clsx":"bGtJT","prop-types":"hRUel","react":"BK2ob","react-is":"4ic4g","../ImageList/ImageListContext":"7eyeK","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/isMuiElement":"b7VqP","./imageListItemClasses":"ayeMm","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ayeMm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getImageListItemUtilityClass", ()=>getImageListItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getImageListItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiImageListItem", slot);
}
const imageListItemClasses = (0, _generateUtilityClassesDefault.default)("MuiImageListItem", [
    "root",
    "img",
    "standard",
    "woven",
    "masonry",
    "quilted"
]);
exports.default = imageListItemClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6jHZB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _imageListItemBarDefault.default));
parcelHelpers.export(exports, "imageListItemBarClasses", ()=>(0, _imageListItemBarClassesDefault.default));
var _imageListItemBar = require("./ImageListItemBar");
var _imageListItemBarDefault = parcelHelpers.interopDefault(_imageListItemBar);
var _imageListItemBarClasses = require("./imageListItemBarClasses");
parcelHelpers.exportAll(_imageListItemBarClasses, exports);
var _imageListItemBarClassesDefault = parcelHelpers.interopDefault(_imageListItemBarClasses);
"use client";

},{"./ImageListItemBar":"lR8yF","./imageListItemBarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"lR8yF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _imageListItemBarClasses = require("./imageListItemBarClasses");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "actionIcon",
    "actionPosition",
    "className",
    "subtitle",
    "title",
    "position"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, position, actionIcon, actionPosition } = ownerState;
    const slots = {
        root: [
            "root",
            `position${(0, _capitalizeDefault.default)(position)}`
        ],
        titleWrap: [
            "titleWrap",
            `titleWrap${(0, _capitalizeDefault.default)(position)}`,
            actionIcon && `titleWrapActionPos${(0, _capitalizeDefault.default)(actionPosition)}`
        ],
        title: [
            "title"
        ],
        subtitle: [
            "subtitle"
        ],
        actionIcon: [
            "actionIcon",
            `actionIconActionPos${(0, _capitalizeDefault.default)(actionPosition)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _imageListItemBarClasses.getImageListItemBarUtilityClass), classes);
};
const ImageListItemBarRoot = (0, _styledDefault.default)("div", {
    name: "MuiImageListItemBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`]
        ];
    }
})(({ theme, ownerState })=>{
    return (0, _extendsDefault.default)({
        position: "absolute",
        left: 0,
        right: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        fontFamily: theme.typography.fontFamily
    }, ownerState.position === "bottom" && {
        bottom: 0
    }, ownerState.position === "top" && {
        top: 0
    }, ownerState.position === "below" && {
        position: "relative",
        background: "transparent",
        alignItems: "normal"
    });
});
const ImageListItemBarTitleWrap = (0, _styledDefault.default)("div", {
    name: "MuiImageListItemBar",
    slot: "TitleWrap",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.titleWrap,
            styles[`titleWrap${(0, _capitalizeDefault.default)(ownerState.position)}`],
            ownerState.actionIcon && styles[`titleWrapActionPos${(0, _capitalizeDefault.default)(ownerState.actionPosition)}`]
        ];
    }
})(({ theme, ownerState })=>{
    return (0, _extendsDefault.default)({
        flexGrow: 1,
        padding: "12px 16px",
        color: (theme.vars || theme).palette.common.white,
        overflow: "hidden"
    }, ownerState.position === "below" && {
        padding: "6px 0 12px",
        color: "inherit"
    }, ownerState.actionIcon && ownerState.actionPosition === "left" && {
        paddingLeft: 0
    }, ownerState.actionIcon && ownerState.actionPosition === "right" && {
        paddingRight: 0
    });
});
const ImageListItemBarTitle = (0, _styledDefault.default)("div", {
    name: "MuiImageListItemBar",
    slot: "Title",
    overridesResolver: (props, styles)=>styles.title
})(({ theme })=>{
    return {
        fontSize: theme.typography.pxToRem(16),
        lineHeight: "24px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
    };
});
const ImageListItemBarSubtitle = (0, _styledDefault.default)("div", {
    name: "MuiImageListItemBar",
    slot: "Subtitle",
    overridesResolver: (props, styles)=>styles.subtitle
})(({ theme })=>{
    return {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
    };
});
const ImageListItemBarActionIcon = (0, _styledDefault.default)("div", {
    name: "MuiImageListItemBar",
    slot: "ActionIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.actionIcon,
            styles[`actionIconActionPos${(0, _capitalizeDefault.default)(ownerState.actionPosition)}`]
        ];
    }
})(({ ownerState })=>{
    return (0, _extendsDefault.default)({}, ownerState.actionPosition === "left" && {
        order: -1
    });
});
const ImageListItemBar = /*#__PURE__*/ _react.forwardRef(function ImageListItemBar(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiImageListItemBar"
    });
    const { actionIcon, actionPosition = "right", className, subtitle, title, position = "bottom" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        position,
        actionPosition
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ImageListItemBarRoot, (0, _extendsDefault.default)({
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ImageListItemBarTitleWrap, {
                ownerState: ownerState,
                className: classes.titleWrap,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageListItemBarTitle, {
                        className: classes.title,
                        children: title
                    }),
                    subtitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageListItemBarSubtitle, {
                        className: classes.subtitle,
                        children: subtitle
                    }) : null
                ]
            }),
            actionIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImageListItemBarActionIcon, {
                ownerState: ownerState,
                className: classes.actionIcon,
                children: actionIcon
            }) : null
        ]
    }));
});
exports.default = ImageListItemBar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","@mui/utils/composeClasses":"jj3MR","clsx":"bGtJT","prop-types":"hRUel","react":"BK2ob","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../utils/capitalize":"iHgWG","./imageListItemBarClasses":"fmn24","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fmn24":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getImageListItemBarUtilityClass", ()=>getImageListItemBarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getImageListItemBarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiImageListItemBar", slot);
}
const imageListItemBarClasses = (0, _generateUtilityClassesDefault.default)("MuiImageListItemBar", [
    "root",
    "positionBottom",
    "positionTop",
    "positionBelow",
    "titleWrap",
    "titleWrapBottom",
    "titleWrapTop",
    "titleWrapBelow",
    "titleWrapActionPosLeft",
    "titleWrapActionPosRight",
    "title",
    "subtitle",
    "actionIcon",
    "actionIconActionPosLeft",
    "actionIconActionPosRight"
]);
exports.default = imageListItemBarClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1dxmo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImageListItemImage", ()=>ImageListItemImage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _openInBrowser = require("@mui/icons-material/OpenInBrowser");
var _openInBrowserDefault = parcelHelpers.interopDefault(_openInBrowser);
var _styles = require("@mui/material/styles");
var _nftImages = require("app/utils/nft-images");
var _url = require("app/utils/url");
var _noPreview = require("../../components/NoPreview");
var _nft = require("../../utils/nft");
var _useScreensize = require("app/hooks/useScreensize");
var _colors = require("styles/theme/colors");
const minMobileSize = "150px";
const minSize = "210px";
const StyledImage = (0, _styles.styled)("img", {
    shouldForwardProp: (prop)=>prop !== "isMobile"
})(({ isMobile })=>({
        minWidth: isMobile ? minMobileSize : minSize,
        minHeight: isMobile ? minMobileSize : minSize,
        width: "100%",
        height: "100%",
        maxHeight: minSize,
        objectFit: "cover",
        transition: "opacity 250ms ease-in-out",
        "&:hover, &:focus-visible": {
            opacity: 0.15
        }
    }));
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        fontSize: "14px",
        fontWeight: 500,
        color: (0, _colors.COLORS).white,
        transition: "opacity, background-color 250ms ease-in-out",
        opacity: 0,
        "&:hover, &:focus-visible": {
            opacity: 1,
            backgroundColor: "rgba(0,0,0,0.8)"
        }
    }));
const ImageListItemImage = ({ instance, to })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const [imageLoadError, setImageLoadError] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _linkDefault.default), {
        component: (0, _reactRouterDom.Link),
        to: to,
        sx: {
            display: "flex",
            position: "relative"
        },
        children: [
            (0, _url.hasValidProtocol)(instance.image) && !imageLoadError ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledImage, {
                onError: ()=>setImageLoadError(true),
                src: (0, _nftImages.processNftImageUrl)(instance.image),
                alt: (0, _nft.getNftInstanceLabel)(instance),
                loading: "lazy",
                isMobile: isMobile
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noPreview.NoPreview), {
                placeholderSize: isMobile ? minMobileSize : minSize
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
                gap: 3,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInBrowserDefault.default), {
                        sx: {
                            fontSize: "40px"
                        }
                    }),
                    t("common.view")
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Box":"4d7LG","@mui/material/Link":"fTbCF","@mui/icons-material/OpenInBrowser":"kBoDz","@mui/material/styles":"51PGx","app/utils/nft-images":"9LwD1","app/utils/url":"bmAGl","../../components/NoPreview":"igMfu","../../utils/nft":"bb1EZ","app/hooks/useScreensize":"2HEhN","styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kBoDz":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("4c8ab2e90ee2565d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b15287a2a43a784"));
var _jsxRuntime = require("eef497819c8ed47d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2m-7 6-4 4h3v6h2v-6h3z"
}), "OpenInBrowser");

},{"4c8ab2e90ee2565d":"hykHy","b15287a2a43a784":"gQLSP","eef497819c8ed47d":"g88cO"}],"9LwD1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "processNftImageUrl", ()=>processNftImageUrl);
var _errors = require("types/errors");
var _ipfs = require("./ipfs");
var _url = require("./url");
const processNftImageUrl = (url)=>{
    if (!url || !(0, _url.hasValidProtocol)(url)) throw new (0, _errors.AppError)((0, _errors.AppErrors).InvalidUrl);
    if (url && url.startsWith("ipfs:")) return (0, _ipfs.accessIpfsUrl)(url);
    return url;
};

},{"types/errors":"gdpNU","./ipfs":"2zX9a","./url":"bmAGl","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2zX9a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ipfsUrlPrefix", ()=>ipfsUrlPrefix);
parcelHelpers.export(exports, "accessIpfsUrl", ()=>accessIpfsUrl);
var _externalLinks = require("./externalLinks");
const ipfsUrlPrefix = "ipfs://";
const accessIpfsUrl = (url)=>{
    if (!url.toLowerCase().startsWith(ipfsUrlPrefix)) {
        console.log("Looking for", ipfsUrlPrefix, "found", url.toLowerCase());
        throw new Error(`Invalid IPFS URL, doesn't start with ${ipfsUrlPrefix}: ${url}`);
    }
    return `${(0, _externalLinks.ipfs).proxyPrefix}${url.substring(ipfsUrlPrefix.length)}`;
};

},{"./externalLinks":"d3W8q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"igMfu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoPreview", ()=>NoPreview);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _notInterested = require("@mui/icons-material/NotInterested");
var _notInterestedDefault = parcelHelpers.interopDefault(_notInterested);
var _colors = require("../../../styles/theme/colors");
const NoPreview = ({ placeholderSize })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        gap: 4,
        sx: {
            height: placeholderSize,
            width: placeholderSize,
            display: "flex",
            flex: 1,
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            color: (0, _colors.COLORS).grayMedium2
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notInterestedDefault.default), {
                sx: {
                    fontSize: "72px"
                }
            }),
            t("nft.noPreview")
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/icons-material/NotInterested":"kNHJK","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kNHJK":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("5f35d41357fc3d4");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("5f8465ef319fbbb6"));
var _jsxRuntime = require("4e943ab09e24ae82");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20m6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9"
}), "NotInterested");

},{"5f35d41357fc3d4":"hykHy","5f8465ef319fbbb6":"gQLSP","4e943ab09e24ae82":"g88cO"}],"bb1EZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNftInstanceLabel", ()=>getNftInstanceLabel);
const getNftInstanceLabel = (nft)=>nft.token.name ? `${nft.token.name} #${nft.id}` : `#${nft.id}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6inNA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NFTCollectionLink", ()=>NFTCollectionLink);
parcelHelpers.export(exports, "NFTInstanceLink", ()=>NFTInstanceLink);
parcelHelpers.export(exports, "NFTOwnerLink", ()=>NFTOwnerLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _routeUtils = require("../../utils/route-utils");
var _trimLongString = require("../../utils/trimLongString");
var _accountLink = require("../../components/Account/AccountLink");
const StyledTypography = (0, _styles.styled)((0, _typographyDefault.default))({
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});
const NFTCollectionLink = ({ scope, instance })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const to = (0, _routeUtils.RouteUtils).getTokenRoute(scope, instance.token?.contract_addr);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTypography, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "nft.collectionLink",
            t: t,
            components: {
                CollectionLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: to,
                    children: instance.token?.name ?? (0, _trimLongString.trimLongString)(instance.token?.eth_contract_addr, 5, 5)
                })
            }
        })
    });
};
const NFTInstanceLink = ({ scope, instance })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const to = (0, _routeUtils.RouteUtils).getNFTInstanceRoute(scope, instance.token?.eth_contract_addr, instance.id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTypography, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "nft.instanceIdLink",
            t: t,
            components: {
                InstanceLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: to,
                    children: instance.id
                })
            }
        })
    });
};
const NFTOwnerLink = ({ scope, owner, alwaysTrim })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTypography, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "nft.ownerLink",
            t: t,
            components: {
                OwnerLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                    scope: scope,
                    address: owner,
                    alwaysTrim: alwaysTrim
                })
            }
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","../../utils/route-utils":"b2kKi","../../utils/trimLongString":"jHX4k","../../components/Account/AccountLink":"43Jgs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"82LaW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardHeaderWithCounter", ()=>CardHeaderWithCounter);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("styles/theme/colors");
var _useScreensize = require("../../hooks/useScreensize");
const CardHeaderWithCounter = ({ label, totalCount, isTotalCountClipped, changeMobileColors })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            display: "flex",
            alignItems: "baseline"
        },
        gap: 2,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                fontWeight: 700,
                component: "span",
                color: isMobile && changeMobileColors ? (0, _colors.COLORS).white : (0, _colors.COLORS).brandExtraDark,
                fontSize: 24,
                children: label
            }),
            !!totalCount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                fontWeight: 700,
                component: "span",
                color: isMobile && changeMobileColors ? (0, _colors.COLORS).white : (0, _colors.COLORS).grayMedium,
                children: [
                    "(",
                    `${isTotalCountClipped ? " > " : ""}${totalCount}`,
                    ")"
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","styles/theme/colors":"hYvW2","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gDicp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accountNFTCollectionContainerId", ()=>accountNFTCollectionContainerId);
parcelHelpers.export(exports, "AccountNFTCollectionCard", ()=>AccountNFTCollectionCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _breadcrumbs = require("@mui/material/Breadcrumbs");
var _breadcrumbsDefault = parcelHelpers.interopDefault(_breadcrumbs);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _imageList = require("@mui/material/ImageList");
var _imageListDefault = parcelHelpers.interopDefault(_imageList);
var _imageListItem = require("@mui/material/ImageListItem");
var _imageListItemDefault = parcelHelpers.interopDefault(_imageListItem);
var _imageListItemBar = require("@mui/material/ImageListItemBar");
var _imageListItemBarDefault = parcelHelpers.interopDefault(_imageListItemBar);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _accountLink = require("app/components/Account/AccountLink");
var _copyToClipboard = require("app/components/CopyToClipboard");
var _routeUtils = require("app/utils/route-utils");
var _imageListItemImage = require("../TokenDashboardPage/ImageListItemImage");
var _cardEmptyState = require("../../components/CardEmptyState");
var _tablePagination = require("../../components/Table/TablePagination");
var _hook = require("../TokenDashboardPage/hook");
var _nftlinks = require("../TokenDashboardPage/NFTLinks");
var _cardHeaderWithCounter = require("app/components/CardHeaderWithCounter");
const accountNFTCollectionContainerId = "nftCollection";
const AccountNFTCollectionCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { address: contractAddress } = (0, _reactRouterDom.useLoaderData)();
    const { inventory, isFetched, isLoading, isTotalCountClipped, pagination, totalCount } = (0, _hook.useAccountTokenInventory)(scope, address, contractAddress);
    const firstToken = inventory?.length ? inventory?.[0].token : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: accountNFTCollectionContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    action: isFetched && firstToken && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            alignItems: "flex-start",
                            paddingY: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                scope: scope,
                                address: firstToken?.eth_contract_addr,
                                alwaysTrim: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                value: firstToken?.eth_contract_addr
                            })
                        ]
                    }),
                    disableTypography: true,
                    title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex"
                        },
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _breadcrumbsDefault.default), {
                                separator: "\u203A",
                                "aria-label": "breadcrumb",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        fontSize: 24,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                            preventScrollReset: true,
                                            component: (0, _reactRouterDom.Link),
                                            to: (0, _routeUtils.RouteUtils).getAccountTokensRoute(scope, address, "ERC721", ""),
                                            children: t("nft.accountCollection")
                                        })
                                    }),
                                    isFetched && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                                        label: firstToken?.name ? inventory?.[0].token.name : t("common.collection"),
                                        totalCount: totalCount,
                                        isTotalCountClipped: isTotalCountClipped
                                    })
                                ]
                            }),
                            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                                variant: "text",
                                sx: {
                                    width: "50%"
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccountNFTCollection, {
                        inventory: inventory,
                        isFetched: isFetched,
                        isLoading: isLoading,
                        totalCount: totalCount,
                        isTotalCountClipped: isTotalCountClipped,
                        pagination: pagination,
                        scope: scope
                    })
                })
            })
        ]
    });
};
const AccountNFTCollection = ({ inventory, isLoading, isFetched, isTotalCountClipped, pagination, scope, totalCount })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "rectangular",
                sx: {
                    height: 200
                }
            }),
            isFetched && !totalCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("tokens.emptyInventory")
            }),
            !!inventory?.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListDefault.default), {
                        gap: 10,
                        children: inventory?.map((instance)=>{
                            const to = (0, _routeUtils.RouteUtils).getNFTInstanceRoute(scope, instance.token?.contract_addr, instance.id);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _imageListItemDefault.default), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListItemImage.ImageListItemImage), {
                                        instance: instance,
                                        to: to
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageListItemBarDefault.default), {
                                        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nftlinks.NFTCollectionLink), {
                                            instance: instance,
                                            scope: scope
                                        }),
                                        subtitle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nftlinks.NFTInstanceLink), {
                                            instance: instance,
                                            scope: scope
                                        }),
                                        position: "below"
                                    })
                                ]
                            }, instance.id);
                        })
                    }),
                    pagination && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablePagination.TablePagination), {
                            ...pagination,
                            totalCount: totalCount,
                            isTotalCountClipped: isTotalCountClipped
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Box":"4d7LG","@mui/material/Breadcrumbs":"39X9q","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Link":"fTbCF","@mui/material/Typography":"f5srd","@mui/material/ImageList":"50ELL","@mui/material/ImageListItem":"fZHXB","@mui/material/ImageListItemBar":"6jHZB","@mui/material/Skeleton":"i7d9z","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","app/components/Account/AccountLink":"43Jgs","app/components/CopyToClipboard":"iTQvM","app/utils/route-utils":"b2kKi","../TokenDashboardPage/ImageListItemImage":"1dxmo","../../components/CardEmptyState":"aiX1q","../../components/Table/TablePagination":"davz5","../TokenDashboardPage/hook":"iNjez","../TokenDashboardPage/NFTLinks":"6inNA","app/components/CardHeaderWithCounter":"82LaW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"39X9q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _breadcrumbsDefault.default));
parcelHelpers.export(exports, "breadcrumbsClasses", ()=>(0, _breadcrumbsClassesDefault.default));
var _breadcrumbs = require("./Breadcrumbs");
var _breadcrumbsDefault = parcelHelpers.interopDefault(_breadcrumbs);
var _breadcrumbsClasses = require("./breadcrumbsClasses");
var _breadcrumbsClassesDefault = parcelHelpers.interopDefault(_breadcrumbsClasses);
parcelHelpers.exportAll(_breadcrumbsClasses, exports);
"use client";

},{"./Breadcrumbs":"8RTnR","./breadcrumbsClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8RTnR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _utils = require("@mui/base/utils");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _breadcrumbCollapsed = require("./BreadcrumbCollapsed");
var _breadcrumbCollapsedDefault = parcelHelpers.interopDefault(_breadcrumbCollapsed);
var _breadcrumbsClasses = require("./breadcrumbsClasses");
var _breadcrumbsClassesDefault = parcelHelpers.interopDefault(_breadcrumbsClasses);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _breadcrumbsClasses.getBreadcrumbsUtilityClass), classes);
};
const BreadcrumbsRoot = (0, _styledDefault.default)((0, _typographyDefault.default), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, _breadcrumbsClassesDefault.default).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const BreadcrumbsOl = (0, _styledDefault.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const BreadcrumbsSeparator = (0, _styledDefault.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const Breadcrumbs = /*#__PURE__*/ _react.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, _useThemePropsDefault.default)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children, className, component = "nav", slots = {}, slotProps = {}, expandText = "Show path", itemsAfterCollapse = 1, itemsBeforeCollapse = 1, maxItems = 8, separator = "/" } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [expanded, setExpanded] = _react.useState(false);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        expanded,
        expandText,
        itemsAfterCollapse,
        itemsBeforeCollapse,
        maxItems,
        separator
    });
    const classes = useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, _utils.useSlotProps)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState
    });
    const listRef = _react.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _breadcrumbCollapsedDefault.default), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = _react.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ _react.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbsRoot, (0, _extendsDefault.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
exports.default = Breadcrumbs;

},{"@babel/runtime/helpers/esm/extends":"8iXse","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","react":"BK2ob","react-is":"4ic4g","prop-types":"hRUel","clsx":"bGtJT","@mui/utils/integerPropType":"3uD7f","@mui/base/utils":"iiPtN","@mui/utils/composeClasses":"jj3MR","../styles/styled":"axRcE","../styles/useThemeProps":"e7SGa","../Typography":"f5srd","./BreadcrumbCollapsed":"e02C0","./breadcrumbsClasses":"hzLw6","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e02C0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _moreHoriz = require("../internal/svg-icons/MoreHoriz");
var _moreHorizDefault = parcelHelpers.interopDefault(_moreHoriz);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const _excluded = [
    "slots",
    "slotProps"
];
const BreadcrumbCollapsedButton = (0, _styledDefault.default)((0, _buttonBaseDefault.default))(({ theme })=>(0, _extendsDefault.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, _extendsDefault.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, _extendsDefault.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const BreadcrumbCollapsedIcon = (0, _styledDefault.default)((0, _moreHorizDefault.default))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function BreadcrumbCollapsed(props) {
    const { slots = {}, slotProps = {} } = props, otherProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbCollapsedButton, (0, _extendsDefault.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BreadcrumbCollapsedIcon, (0, _extendsDefault.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
exports.default = BreadcrumbCollapsed;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dS5Om","@babel/runtime/helpers/esm/extends":"8iXse","react":"BK2ob","prop-types":"hRUel","@mui/system/colorManipulator":"9FSVd","../styles/styled":"axRcE","../internal/svg-icons/MoreHoriz":"8J4qu","../ButtonBase":"1prwn","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8J4qu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
"use client";
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");

},{"react":"BK2ob","../../utils/createSvgIcon":"gZ3fr","react/jsx-runtime":"g88cO","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hzLw6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBreadcrumbsUtilityClass", ()=>getBreadcrumbsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getBreadcrumbsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)("MuiBreadcrumbs", slot);
}
const breadcrumbsClasses = (0, _generateUtilityClassesDefault.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
exports.default = breadcrumbsClasses;

},{"@mui/utils/generateUtilityClasses":"iDcJO","@mui/utils/generateUtilityClass":"PMtLM","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ia541":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNftDetailsProps", ()=>useNftDetailsProps);
parcelHelpers.export(exports, "NFTInstanceDashboardPage", ()=>NFTInstanceDashboardPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _useScopeParam = require("../../hooks/useScopeParam");
var _pageLayout = require("../../components/PageLayout");
var _instanceTitleCard = require("./InstanceTitleCard");
var _instanceDetailsCard = require("./InstanceDetailsCard");
var _instanceImageCard = require("./InstanceImageCard");
var _errors = require("../../../types/errors");
var _routerTabs = require("app/components/RouterTabs");
var _hook = require("../TokenDashboardPage/hook");
var _nftmetadataCard = require("./NFTMetadataCard");
const useNftDetailsProps = ()=>(0, _reactRouterDom.useOutletContext)();
const NFTInstanceDashboardPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { address, instanceId } = (0, _reactRouterDom.useParams)();
    if (!address || !instanceId) throw (0, _errors.AppErrors).InvalidUrl;
    const { isFetched, isLoading, nft } = (0, _hook.useNFTInstance)(scope, address, instanceId);
    const tokenTransfersLink = (0, _reactRouterDom.useHref)("");
    const metadataLink = (0, _reactRouterDom.useHref)(`metadata#${(0, _nftmetadataCard.nftMetadataId)}`);
    const context = {
        scope,
        address,
        instanceId
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _instanceTitleCard.InstanceTitleCard), {
                isFetched: isFetched,
                isLoading: isLoading,
                nft: nft,
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _instanceImageCard.InstanceImageCard), {
                isFetched: isFetched,
                isLoading: isLoading,
                nft: nft
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _instanceDetailsCard.InstanceDetailsCard), {
                isFetched: isFetched,
                isLoading: isLoading,
                nft: nft,
                scope: scope,
                contractAddress: address
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routerTabs.RouterTabs), {
                tabs: [
                    {
                        label: t("common.transfers"),
                        to: tokenTransfersLink
                    },
                    {
                        label: t("nft.metadata"),
                        to: metadataLink
                    }
                ],
                context: context
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","../../hooks/useScopeParam":"kKMKx","../../components/PageLayout":"24SOU","./InstanceTitleCard":"1cenC","./InstanceDetailsCard":"jQZtG","./InstanceImageCard":"hFb9U","../../../types/errors":"gdpNU","app/components/RouterTabs":"dUetQ","../TokenDashboardPage/hook":"iNjez","./NFTMetadataCard":"58s3H","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1cenC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstanceTitleCard", ()=>InstanceTitleCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
var _contractVerificationIcon = require("../../components/ContractVerificationIcon");
var _accountLink = require("../../components/Account/AccountLink");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _nft = require("../../utils/nft");
const InstanceTitleCard = ({ isFetched, isLoading, nft, scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const token = nft?.token;
    const displayAddress = token ? token.eth_contract_addr || token.contract_addr : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardContentDefault.default), {
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                    variant: "text"
                }),
                isFetched && token && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    sx: {
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        alignItems: "bottom"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            variant: "h2",
                            sx: {
                                fontWeight: 600,
                                paddingBottom: 3
                            },
                            children: [
                                (0, _nft.getNftInstanceLabel)(nft),
                                "\xa0",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                    component: "span",
                                    noWrap: true,
                                    sx: {
                                        color: (0, _colors.COLORS).grayMedium,
                                        fontWeight: 400
                                    },
                                    children: t("nft.instanceTitleSuffix")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.VerificationIcon), {
                                    address_eth: token.eth_contract_addr,
                                    verified: token.is_verified,
                                    noLink: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                    scope: scope,
                                    address: displayAddress,
                                    alwaysTrim: true
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                    value: displayAddress
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","@mui/material/Skeleton":"i7d9z","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","../../components/ContractVerificationIcon":"6tjz3","../../components/Account/AccountLink":"43Jgs","../../components/CopyToClipboard":"iTQvM","../../utils/nft":"bb1EZ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jQZtG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstanceDetailsCard", ()=>InstanceDetailsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _hook = require("../RuntimeAccountDetailsPage/hook");
var _skeleton = require("../../components/Skeleton");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _useScreensize = require("../../hooks/useScreensize");
var _reactI18Next = require("react-i18next");
var _accountLink = require("../../components/Account/AccountLink");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _contractVerificationIcon = require("../../components/ContractVerificationIcon");
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _tokenList = require("../../components/Tokens/TokenList");
var _tokenLink = require("../../components/Tokens/TokenLink");
const InstanceDetailsCard = ({ contractAddress, isFetched: isNftFetched, isLoading: isNftLoading, nft, scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { account, isFetched: isAccountFetched, isLoading: accountIsLoading } = (0, _hook.useAccount)(scope, contractAddress);
    const token = nft?.token;
    const isLoading = isNftLoading || accountIsLoading;
    const isFetched = isNftFetched || isAccountFetched;
    const owner = nft?.owner_eth ?? nft?.owner;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardContentDefault.default), {
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
                    numberOfRows: 7
                }),
                isFetched && account && nft && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
                    titleWidth: isMobile ? "100px" : "200px",
                    children: [
                        nft.name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                    children: t("common.name")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                    children: nft.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("nft.instanceTokenId")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: nft.id
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                            children: [
                                t("common.collection"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLink.TokenLink), {
                                scope: scope,
                                address: contractAddress,
                                name: token?.name
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                            children: [
                                t("common.type"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenList.TokenTypeTag), {
                                tokenType: token?.type
                            })
                        }),
                        owner && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                    children: t("nft.owner")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                            scope: scope,
                                            address: owner
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                            value: owner
                                        })
                                    ]
                                })
                            ]
                        }),
                        !!nft?.num_transfers && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                    children: t("common.transfers")
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                    children: nft.num_transfers.toLocaleString()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t(isMobile ? "common.smartContract_short" : "common.smartContract")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                                    scope: account,
                                    address: account.address_eth || account.address
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                                    value: account.address_eth || account.address
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                            children: t("contract.verification.title")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractVerificationIcon.VerificationIcon), {
                                address_eth: token?.eth_contract_addr,
                                verified: !!token?.is_verified
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Card":"cTsx6","../RuntimeAccountDetailsPage/hook":"iVoy2","../../components/Skeleton":"eB5vc","../../components/StyledDescriptionList":"bndrS","../../hooks/useScreensize":"2HEhN","react-i18next":"e210a","../../components/Account/AccountLink":"43Jgs","../../components/CopyToClipboard":"iTQvM","../../components/ContractVerificationIcon":"6tjz3","@mui/material/CardContent":"kMUKY","../../components/Tokens/TokenList":"7bRlg","../../components/Tokens/TokenLink":"ksoba","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hFb9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledImage", ()=>StyledImage);
parcelHelpers.export(exports, "InstanceImageCard", ()=>InstanceImageCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/base/Button");
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _contrast = require("@mui/icons-material/Contrast");
var _contrastDefault = parcelHelpers.interopDefault(_contrast);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _openInFull = require("@mui/icons-material/OpenInFull");
var _openInFullDefault = parcelHelpers.interopDefault(_openInFull);
var _styles = require("@mui/material/styles");
var _nftImages = require("../../utils/nft-images");
var _url = require("../../utils/url");
var _colors = require("../../../styles/theme/colors");
var _imagePreview = require("../../components/ImagePreview");
var _noPreview = require("../../components/NoPreview");
const imageSize = "350px";
const StyledImage = (0, _styles.styled)("img")({
    maxWidth: imageSize,
    maxHeight: imageSize
});
const StyledButton = (0, _styles.styled)((0, _button.Button), {
    shouldForwardProp: (prop)=>prop !== "darkMode"
})(({ darkMode })=>({
        cursor: "pointer",
        border: "none",
        width: 36,
        height: 36,
        borderRadius: 18,
        background: darkMode ? (0, _colors.COLORS).white : (0, _colors.COLORS).grayMedium,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: darkMode ? (0, _colors.COLORS).grayMedium : (0, _colors.COLORS).white
    }));
const DarkModeSwitch = ({ darkMode, onSetDarkMode })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: t("nft.switchBackgroundColor"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
            darkMode: darkMode,
            onClick: ()=>onSetDarkMode(!darkMode),
            "aria-label": t("nft.switchBackgroundColor"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contrastDefault.default), {})
        })
    });
};
const FullScreenButton = ({ darkMode, onClick })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: t("nft.openInFullscreen"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
            darkMode: darkMode,
            onClick: onClick,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInFullDefault.default), {})
        })
    });
};
const InstanceImageCard = ({ isFetched, isLoading, nft })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [darkMode, setDarkMode] = (0, _react.useState)(false);
    const [previewOpen, setPreviewOpen] = (0, _react.useState)(false);
    const handlePreviewOpen = ()=>setPreviewOpen(true);
    const handlePreviewClose = ()=>setPreviewOpen(false);
    const [imageLoadError, setImageLoadError] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        sx: {
            background: darkMode ? (0, _colors.COLORS).grayExtraDark : (0, _colors.COLORS).white
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                sx: {
                    background: darkMode ? (0, _colors.COLORS).grayExtraDark : (0, _colors.COLORS).white,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    minHeight: imageSize
                },
                children: [
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                        variant: "rectangular",
                        width: imageSize,
                        height: imageSize
                    }),
                    isFetched && !nft?.image && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noPreview.NoPreview), {
                        placeholderSize: imageSize
                    }),
                    isFetched && nft?.image && imageLoadError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            flex: 1,
                            display: "flex",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noPreview.NoPreview), {
                                    placeholderSize: imageSize
                                }),
                                (0, _url.hasValidProtocol)(nft.image) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                    href: nft.image,
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: t("nft.openInNewTab")
                                })
                            ]
                        })
                    }),
                    isFetched && nft && (0, _url.hasValidProtocol)(nft.image) && !imageLoadError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imagePreview.ImagePreview), {
                                    handlePreviewClose: handlePreviewClose,
                                    handlePreviewOpen: handlePreviewOpen,
                                    previewOpen: previewOpen,
                                    src: (0, _nftImages.processNftImageUrl)(nft.image),
                                    onError: ()=>setImageLoadError(true),
                                    title: nft.name,
                                    maxThumbnailSize: imageSize
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "right",
                                    gap: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FullScreenButton, {
                                        darkMode: darkMode,
                                        onClick: handlePreviewOpen
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DarkModeSwitch, {
                                        darkMode: darkMode,
                                        onSetDarkMode: setDarkMode
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/base/Button":"aDutu","@mui/material/CardContent":"kMUKY","@mui/material/Card":"cTsx6","@mui/icons-material/Contrast":"7ZgC8","@mui/material/Link":"fTbCF","@mui/material/Skeleton":"i7d9z","@mui/material/Tooltip":"3RLHy","@mui/icons-material/OpenInFull":"csEp6","@mui/material/styles":"51PGx","../../utils/nft-images":"9LwD1","../../utils/url":"bmAGl","../../../styles/theme/colors":"hYvW2","../../components/ImagePreview":"kBUcb","../../components/NoPreview":"igMfu","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7ZgC8":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("d90e1b7db72c05c3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("c9b60aa61d01aa93"));
var _jsxRuntime = require("77695f155f4c6548");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10m1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93z"
}), "Contrast");

},{"d90e1b7db72c05c3":"hykHy","c9b60aa61d01aa93":"gQLSP","77695f155f4c6548":"g88cO"}],"csEp6":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("e8c4b847c2ac9273");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("fb9ff158cd0e1dc4"));
var _jsxRuntime = require("fc02f619556efcc6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
}), "OpenInFull");

},{"e8c4b847c2ac9273":"hykHy","fb9ff158cd0e1dc4":"gQLSP","fc02f619556efcc6":"g88cO"}],"kBUcb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImagePreview", ()=>ImagePreview);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _backdrop = require("@mui/material/Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _modal = require("@mui/material/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _button = require("@mui/base/Button");
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
const StyledThumbnail = (0, _styles.styled)("img", {
    shouldForwardProp: (prop)=>prop !== "maxThumbnailSize"
})(({ maxThumbnailSize })=>({
        maxWidth: maxThumbnailSize,
        maxHeight: maxThumbnailSize
    }));
const StyledButton = (0, _styles.styled)((0, _button.Button))({
    cursor: "pointer",
    border: "none",
    background: "none"
});
const StyledImage = (0, _styles.styled)("img")({
    maxWidth: "80dvw",
    maxHeight: " 80dvh"
});
const ImagePreview = ({ handlePreviewClose, handlePreviewOpen, onError, previewOpen, src, title, maxThumbnailSize })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const label = title || t("nft.imagePreview");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
                    onClick: handlePreviewOpen,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledThumbnail, {
                        onError: onError,
                        src: src,
                        alt: label,
                        maxThumbnailSize: maxThumbnailSize
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
                "aria-labelledby": label,
                open: previewOpen,
                onClose: handlePreviewClose,
                closeAfterTransition: true,
                slots: {
                    backdrop: (0, _backdropDefault.default)
                },
                slotProps: {
                    backdrop: {
                        timeout: 500
                    }
                },
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                    in: previewOpen,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            position: "absolute"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                sx: {
                                    display: "flex",
                                    justifyContent: title ? "space-between" : "flex-end",
                                    alignItems: "center",
                                    mb: 3
                                },
                                children: [
                                    title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                        fontSize: "24px",
                                        fontWeight: 700,
                                        color: (0, _colors.COLORS).white,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                        "aria-label": "Close",
                                        onClick: handlePreviewClose,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
                                            sx: {
                                                fontSize: "40px",
                                                color: (0, _colors.COLORS).white
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledImage, {
                                src: src,
                                alt: label
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Backdrop":"6tOz3","@mui/material/Modal":"9y8oQ","@mui/material/Fade":"iV0ht","@mui/material/Typography":"f5srd","@mui/icons-material/Cancel":"l7K6K","@mui/material/IconButton":"hLmKV","@mui/base/Button":"aDutu","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"58s3H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nftMetadataId", ()=>nftMetadataId);
parcelHelpers.export(exports, "NFTMetadataCard", ()=>NFTMetadataCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _codeDisplay = require("../../components/CodeDisplay");
var _hook = require("../TokenDashboardPage/hook");
const nftMetadataId = "metadata";
const NFTMetadataCard = ({ scope, address, instanceId })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isFetched, nft } = (0, _hook.useNFTInstance)(scope, address, instanceId);
    const metadata = nft?.metadata;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            isFetched && !metadata && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("nft.noMetadata")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: metadata && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                        id: nftMetadataId,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _codeDisplay.JsonCodeDisplay), {
                            data: metadata,
                            label: t("nft.metadata")
                        })
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../../components/CodeDisplay":"9FPfq","../TokenDashboardPage/hook":"iNjez","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8ZszI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nftTokenTransfersContainerId", ()=>nftTokenTransfersContainerId);
parcelHelpers.export(exports, "NFTTokenTransfersCard", ()=>NFTTokenTransfersCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _tokenTransfers = require("../../components/Tokens/TokenTransfers");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _hook = require("../TokenDashboardPage/hook");
const nftTokenTransfersContainerId = "nftTokenTransfers";
const NFTTokenTransfersCard = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: nftTokenTransfersContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("common.transfers")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NFTTokenTransfersView, {
                        ...props
                    })
                })
            })
        ]
    });
};
const NFTTokenTransfersView = ({ scope, address, instanceId })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isLoading, isFetched, results } = (0, _hook.useNFTInstanceTransfers)(scope, {
        contract_address: address,
        nft_id: instanceId
    });
    const transfers = results.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !transfers?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("account.emptyTokenTransferList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenTransfers.TokenTransfers), {
                transfers: transfers,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: results.tablePaginationProps
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/Tokens/TokenTransfers":"fFZHn","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../TokenDashboardPage/hook":"iNjez","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2JtCh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusDashboardPage", ()=>ConsensusDashboardPage);
var _jsxRuntime = require("react/jsx-runtime");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _pageLayout = require("../../components/PageLayout");
var _useScreensize = require("../../hooks/useScreensize");
var _totalTransactions = require("../../components/TotalTransactions");
var _transactionsStats = require("../../components/TransactionsStats");
var _social = require("../../components/Social");
var _useScopeParam = require("../../hooks/useScopeParam");
var _learningMaterials = require("./LearningMaterials");
var _networkProposalsCard = require("./NetworkProposalsCard");
var _validators = require("./Validators");
var _consensusSnapshot = require("./ConsensusSnapshot");
var _latestConsensusBlocks = require("./LatestConsensusBlocks");
var _accountsCard = require("./AccountsCard");
var _latestConsensusTransactions = require("./LatestConsensusTransactions");
var _paraTimesCard = require("./ParaTimesCard");
const ConsensusDashboardPage = ()=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusSnapshot.ConsensusSnapshot), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout",
                sx: {
                    mt: isMobile ? 4 : 0
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        sx: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _totalTransactions.TotalTransactions), {
                            chartContainerHeight: 350,
                            scope: scope
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        sx: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _latestConsensusBlocks.LatestConsensusBlocks), {
                            scope: scope
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validators.ValidatorsCard), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimesCard.ParaTimesCard), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountsCard.AccountsCard), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _latestConsensusTransactions.LatestConsensusTransactions), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkProposalsCard.NetworkProposalsCard), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionsStats.TransactionsStats), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningMaterials.LearningMaterials), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _social.Social), {})
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Grid":"bu56N","@mui/material/Divider":"3hI6U","../../components/PageLayout":"24SOU","../../hooks/useScreensize":"2HEhN","../../components/TotalTransactions":"a7R3w","../../components/TransactionsStats":"efaZm","../../components/Social":"atjKu","../../hooks/useScopeParam":"kKMKx","./LearningMaterials":"e7b7Q","./NetworkProposalsCard":"8cdww","./Validators":"7otgT","./ConsensusSnapshot":"k6DeV","./LatestConsensusBlocks":"5ebZy","./AccountsCard":"gjeEa","./LatestConsensusTransactions":"ky9I3","./ParaTimesCard":"33KoF","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"e7b7Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LearningMaterials", ()=>LearningMaterials);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _unstableGrid2 = require("@mui/material/Unstable_Grid2");
var _unstableGrid2Default = parcelHelpers.interopDefault(_unstableGrid2);
var _learningMaterialsCard = require("app/components/LearningMaterialsCard");
var _learningSection = require("../../components/LearningMaterialsCard/LearningSection");
var _externalLinks = require("../../utils/externalLinks");
const LearningMaterials = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningMaterialsCard.LearningMaterialsCard), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
            container: true,
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                    xs: 12,
                    md: 3,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                        description: t("learningMaterials.consensus.description"),
                        title: t("learningMaterials.consensus.header"),
                        url: (0, _externalLinks.docs).consensus,
                        sx: {
                            height: "100%"
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
                    xs: 12,
                    md: 3,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                            sx: {
                                pb: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                                description: t("learningMaterials.consensus.transactionsDescription"),
                                title: t("learningMaterials.consensus.transactions"),
                                url: (0, _externalLinks.docs).consensusTransactions
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                            xs: 12,
                            md: 3,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                                description: t("learningMaterials.consensus.servicesDescription"),
                                title: t("learningMaterials.consensus.services"),
                                url: (0, _externalLinks.docs).consensusServices
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                    xs: 12,
                    md: 3,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                        description: t("learningMaterials.consensus.genesisDescription"),
                        title: t("learningMaterials.consensus.genesis"),
                        url: (0, _externalLinks.docs).consensusGenesis,
                        sx: {
                            height: "100%"
                        }
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unstableGrid2Default.default), {
                    xs: 12,
                    md: 3,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                            sx: {
                                pb: 3
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                                description: t("learningMaterials.consensus.vectorsDescription"),
                                title: t("learningMaterials.consensus.vectors"),
                                url: (0, _externalLinks.docs).consensusVectors
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableGrid2Default.default), {
                            xs: 12,
                            md: 3,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _learningSection.LearningSection), {
                                description: t("learningMaterials.consensus.cometDescription"),
                                title: t("learningMaterials.consensus.comet"),
                                url: (0, _externalLinks.docs).consensusComet
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Unstable_Grid2":"eN1IM","app/components/LearningMaterialsCard":"bPrsj","../../components/LearningMaterialsCard/LearningSection":"6r0Nd","../../utils/externalLinks":"d3W8q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8cdww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkProposalsCard", ()=>NetworkProposalsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _networkProposalsList = require("../../components/NetworkProposalsList");
var _routeUtils = require("app/utils/route-utils");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const NetworkProposalsCard = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const proposalsQuery = (0, _api.useGetConsensusProposals)(network, {
        limit
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("networkProposal.listTitle"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getProposalsRoute(network),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkProposalsList.NetworkProposalsList), {
                    proposals: proposalsQuery.data?.data.proposals,
                    isLoading: proposalsQuery.isLoading,
                    limit: limit,
                    pagination: false
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","../../components/NetworkProposalsList":"7TDXH","app/utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7TDXH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkProposalsList", ()=>NetworkProposalsList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _table = require("../../components/Table");
var _roundedBalance = require("../RoundedBalance");
var _proposalStatusIcon = require("../../components/Proposals/ProposalStatusIcon");
var _proposalLink = require("../Proposals/ProposalLink");
const NetworkProposalsList = ({ isLoading, limit, pagination, proposals, verbose })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const tableColumns = [
        {
            align: (0, _table.TableCellAlign).Center,
            key: "id",
            content: t("networkProposal.id")
        },
        {
            key: "handler",
            content: t("networkProposal.handler")
        },
        ...verbose ? [
            {
                key: "voting",
                content: "Voting"
            }
        ] : [],
        {
            align: (0, _table.TableCellAlign).Right,
            key: "deposit",
            content: t("networkProposal.deposit")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "create",
            content: t("networkProposal.create")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "close",
            content: t("networkProposal.close")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "state",
            content: t("common.status")
        }
    ];
    const tableRows = proposals?.map((proposal)=>({
            key: proposal.id.toString(),
            data: [
                {
                    align: (0, _table.TableCellAlign).Center,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: proposal.id
                    }),
                    key: "id"
                },
                {
                    align: (0, _table.TableCellAlign).Left,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalLink.ProposalLink), {
                        network: proposal.network,
                        proposalId: proposal.id,
                        label: proposal.handler
                    }),
                    key: "handler"
                },
                ...verbose ? [
                    {
                        key: "voting",
                        content: // TODO: add voting component when API is ready
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        })
                    }
                ] : [],
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        value: proposal.deposit
                    }),
                    key: "deposit"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: t("networkProposal.createTooltip"),
                        placement: "top",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: proposal.created_at
                        })
                    }),
                    key: "create"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: t("networkProposal.closeTooltip"),
                        placement: "top",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: proposal.closes_at
                        })
                    }),
                    key: "close"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalStatusIcon.ProposalStatusIcon), {
                        status: proposal.state
                    }),
                    key: "state"
                }
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("networkProposal.listTitle"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Tooltip":"3RLHy","../../components/Table":"j3qb1","../RoundedBalance":"af34T","../../components/Proposals/ProposalStatusIcon":"kgUEx","../Proposals/ProposalLink":"bOGFh","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bOGFh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalLink", ()=>ProposalLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _routeUtils = require("../../utils/route-utils");
const ProposalLink = ({ network, proposalId, label = proposalId })=>{
    const to = (0, _routeUtils.RouteUtils).getProposalRoute(network, proposalId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
        component: (0, _reactRouterDom.Link),
        to: to,
        children: label
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7otgT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorsCard", ()=>ValidatorsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _validators = require("../../components/Validators");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _routeUtils = require("app/utils/route-utils");
var _cardHeaderWithCounter = require("../../components/CardHeaderWithCounter");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const ValidatorsCard = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const validatorsQuery = (0, _api.useGetConsensusValidators)(network, {
        limit
    });
    const validators = validatorsQuery.data?.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                    label: t("validator.listTitle"),
                    totalCount: validators?.total_count,
                    isTotalCountClipped: validators?.is_total_count_clipped
                }),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getValidatorsRoute(scope.network),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validators.Validators), {
                    validators: validatorsQuery.data?.data.validators,
                    isLoading: validatorsQuery.isLoading,
                    limit: limit,
                    pagination: false
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../components/Validators":"kfkPi","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","app/utils/route-utils":"b2kKi","../../components/CardHeaderWithCounter":"82LaW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kfkPi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Validators", ()=>Validators);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _table = require("../../components/Table");
var _statusIcon = require("../StatusIcon");
var _roundedBalance = require("../RoundedBalance");
var _validatorImage = require("./ValidatorImage");
var _validatorCommission = require("./ValidatorCommission");
var _validatorCumulativeVoting = require("./ValidatorCumulativeVoting");
var _validatorLink = require("./ValidatorLink");
var _useScopeParam = require("../../hooks/useScopeParam");
const Validators = ({ isLoading, limit, pagination, validators })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = (0, _useScopeParam.useRequiredScopeParam)();
    const tableColumns = [
        {
            align: (0, _table.TableCellAlign).Center,
            key: "rank",
            content: t("common.rank")
        },
        {
            key: "name",
            content: t("validator.title")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "cumulativeVoting",
            content: t("validator.cumulativeVoting")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "voting",
            content: t("validator.voting")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "staked",
            content: t("common.staked")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "change",
            content: t("validator.change")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "delegators",
            content: t("validator.delegators")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "commission",
            content: t("validator.commission")
        },
        {
            key: "status",
            content: t("common.status")
        },
        {
            key: "uptime",
            content: t("validator.uptime")
        }
    ];
    const tableRows = validators?.map((validator, index)=>({
            key: validator.entity_address,
            data: [
                {
                    align: (0, _table.TableCellAlign).Center,
                    // TODO: replace index when rank is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: index + 1
                    }),
                    key: "rank"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorImage.ValidatorImage), {
                                address: validator.entity_address,
                                name: validator.media?.name,
                                logotype: validator.media?.logotype
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorLink.ValidatorLink), {
                                address: validator.entity_address,
                                name: validator.media?.name,
                                network: network
                            })
                        ]
                    }),
                    key: "name"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    // TODO: provide cumulative voting when it is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCumulativeVoting.ValidatorCumulativeVoting), {
                        containerMarginThemeSpacing: 5,
                        value: 0
                    }),
                    key: "cumulativeVoting"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    // TODO: provide voting when it is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "-"
                    }),
                    key: "voting"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        value: validator.escrow,
                        ticker: validator.ticker
                    }),
                    key: "staked"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    // TODO: provide change value when it is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "-"
                    }),
                    key: "change"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    // TODO: provide delegators when it is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "-"
                    }),
                    key: "delegators"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCommission.ValidatorCommission), {
                        commission: validator.current_rate
                    }),
                    key: "commission"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
                            success: validator.status,
                            error: undefined
                        })
                    }),
                    key: "status"
                },
                {
                    // TODO: provide uptime when it is implemented in the API
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "-"
                    }),
                    key: "uptime"
                }
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("validator.listTitle"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","../../components/Table":"j3qb1","../StatusIcon":"3VOhR","../RoundedBalance":"af34T","./ValidatorImage":"30hm1","./ValidatorCommission":"2dER2","./ValidatorCumulativeVoting":"8C0vP","./ValidatorLink":"18CFQ","../../hooks/useScopeParam":"kKMKx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"30hm1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorImage", ()=>ValidatorImage);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _imageNotSupported = require("@mui/icons-material/ImageNotSupported");
var _imageNotSupportedDefault = parcelHelpers.interopDefault(_imageNotSupported);
var _url = require("../../utils/url");
var _colors = require("styles/theme/colors");
var _circle = require("../Circle");
const StyledImage = (0, _styles.styled)("img")({
    width: "28px",
    height: "28px",
    borderRadius: 5
});
const ValidatorImage = ({ address, name, logotype })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: logotype && (0, _url.hasValidProtocol)(logotype) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledImage, {
            alt: name || address,
            src: logotype
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circle.Circle), {
            color: (0, _colors.COLORS).grayMedium2,
            size: 5,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageNotSupportedDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).grayMedium,
                    fontSize: 18
                }
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","@mui/icons-material/ImageNotSupported":"7Wp5Y","../../utils/url":"bmAGl","styles/theme/colors":"hYvW2","../Circle":"8Poag","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7Wp5Y":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("3885da2cf5c5340f");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("21ab8661f7ad4f5c"));
var _jsxRuntime = require("3ef86bb48a1cda4");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m21.9 21.9-8.49-8.49-9.82-9.82L2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31zM5 18l3.5-4.5 2.5 3.01L12.17 15l3 3zm16 .17L5.83 3H19c1.1 0 2 .9 2 2z"
}), "ImageNotSupported");

},{"3885da2cf5c5340f":"hykHy","21ab8661f7ad4f5c":"gQLSP","3ef86bb48a1cda4":"g88cO"}],"2dER2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorCommission", ()=>ValidatorCommission);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
const ValidatorCommission = ({ commission })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: t("common.valuePair", {
            value: commission / 100000,
            formatParams: {
                value: {
                    style: "percent",
                    maximumFractionDigits: 2
                }
            }
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8C0vP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorCumulativeVoting", ()=>ValidatorCumulativeVoting);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "value" && prop !== "containerMarginThemeSpacing"
})(({ containerMarginThemeSpacing, value, theme })=>({
        position: "relative",
        textAlign: "center",
        "&::before": {
            content: '""',
            width: `${value}%`,
            height: `calc(100% + ${theme.spacing(containerMarginThemeSpacing)})`,
            borderRight: "solid 5px #6665D860",
            backgroundColor: "#6665D820",
            position: "absolute",
            left: 0,
            top: `-${theme.spacing(containerMarginThemeSpacing - 1)}`
        }
    }));
const ValidatorCumulativeVoting = ({ containerMarginThemeSpacing, value })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        sx: {
            flex: 1
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
            value: value,
            containerMarginThemeSpacing: containerMarginThemeSpacing,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                component: "span",
                sx: {
                    position: "relative",
                    zIndex: 2
                },
                children: value ? value : "-"
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k6DeV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusSnapshot", ()=>ConsensusSnapshot);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _snapshot = require("../../components/Snapshots/Snapshot");
var _snapshotEpoch = require("./SnapshotEpoch");
var _snapshotDelegators = require("./SnapshotDelegators");
var _snapshotValidators = require("./SnapshotValidators");
var _snapshotStaked = require("./SnapshotStaked");
const ConsensusSnapshot = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _snapshot.Snapshot), {
        title: t("consensusSnapshot.title"),
        scope: scope,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                item: true,
                xs: 22,
                md: 5,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotEpoch.SnapshotEpoch), {
                    scope: scope
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                item: true,
                xs: 22,
                md: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotValidators.SnapshotValidators), {
                    scope: scope
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                item: true,
                xs: 22,
                md: 5,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotDelegators.SnapshotDelegators), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                item: true,
                xs: 22,
                md: 6,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotStaked.SnapshotStaked), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Snapshots/Snapshot":"91gmN","./SnapshotEpoch":"6RvHS","./SnapshotDelegators":"3Kxoe","./SnapshotValidators":"iCtxR","./SnapshotStaked":"3MUm6","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6RvHS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnapshotEpoch", ()=>SnapshotEpoch);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _api = require("../../../oasis-nexus/api");
var _colors = require("../../../styles/theme/colors");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _progressBar = require("../../components/ProgressBar");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        marginTop: `-${theme.spacing(3)}`,
        marginBottom: theme.spacing(3)
    }));
const SnapshotEpoch = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const statusQuery = (0, _api.useGetStatus)(scope.network);
    const blockHeight = statusQuery?.data?.data.latest_block;
    // TODO: provide epoch number when API is ready
    const epoch = undefined;
    const percentageValue = undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotTextCard), {
        title: t("currentEpoch"),
        label: blockHeight && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: 3
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: 12,
                    color: (0, _colors.COLORS).grayMedium
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    t: t,
                    i18nKey: "consensusSnapshot.blockHeight",
                    components: {
                        BlockHeight: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "span",
                            sx: {
                                fontSize: "24px",
                                color: (0, _colors.COLORS).grayExtraDark
                            },
                            children: blockHeight.toLocaleString()
                        })
                    }
                })
            })
        }),
        children: epoch && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                percentageValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBar.BrandProgressBar), {
                        value: percentageValue,
                        variant: "determinate"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    gap: 3,
                    sx: {
                        display: "flex",
                        alignItems: "baseline"
                    },
                    children: [
                        epoch.toLocaleString(),
                        percentageValue && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                            sx: {
                                fontSize: 12,
                                color: (0, _colors.COLORS).grayMedium
                            },
                            children: [
                                "(",
                                percentageValue,
                                ")"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","../../../oasis-nexus/api":"dJrPU","../../../styles/theme/colors":"hYvW2","../../components/Snapshots/SnapshotCard":"b3UOK","../../components/ProgressBar":"5Dj8t","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"3Kxoe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnapshotDelegators", ()=>SnapshotDelegators);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _useScreensize = require("../../hooks/useScreensize");
const SnapshotDelegators = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    // TODO: provide delegators number when API is ready
    const delegators = undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotTextCard), {
        title: t("validator.delegators"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                pb: isMobile ? 3 : 5
            },
            children: delegators
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","../../components/Snapshots/SnapshotCard":"b3UOK","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iCtxR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnapshotValidators", ()=>SnapshotValidators);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _api = require("../../../oasis-nexus/api");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
var _pieChart = require("../../components/charts/PieChart");
var _config = require("../../config");
// TODO: remove if backend will provide validators stats
function countValidatorsState(t, validators) {
    if (!validators) return [];
    return [
        {
            label: t("validator.active"),
            value: validators.filter((v)=>v.active).length
        },
        {
            label: t("validator.inactive"),
            value: validators.filter((v)=>!v.active).length
        }
    ];
}
const SnapshotValidators = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const validatorsQuery = (0, _api.useGetConsensusValidators)(network, {
        limit: (0, _config.API_MAX_TOTAL_COUNT)
    });
    const validators = validatorsQuery.data?.data.validators;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotCard), {
        title: t("validator.listTitle"),
        children: !!validators?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pieChart.PieChart), {
            compact: true,
            data: countValidatorsState(t, validators),
            dataKey: "value",
            formatters: {
                data: (value)=>value.toLocaleString(),
                label: (status)=>t("validator.groupStatus", {
                        status
                    })
            }
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../../oasis-nexus/api":"dJrPU","../../components/Snapshots/SnapshotCard":"b3UOK","../../components/charts/PieChart":"7mkAk","../../config":"in6G4","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7mkAk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PieChart", ()=>PieChart);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _recharts = require("recharts");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _circle = require("@mui/icons-material/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _tooltip = require("./Tooltip");
var _colors = require("../../../styles/theme/colors");
var _colors1 = require("../../../styles/theme/testnet/colors");
const colorPalette = [
    (0, _colors.COLORS).brandDark,
    (0, _colors.COLORS).brandMedium,
    (0, _colors1.COLORS).testnet,
    (0, _colors.COLORS).grayMedium2
];
const CustomLegend = (props)=>{
    const { activeLabel, compact, payload } = props;
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
        sx: {
            listStyleType: "none"
        },
        children: payload?.map((item)=>{
            if (!item.payload) return null;
            const payload = item.payload;
            const label = payload.name;
            const isActive = activeLabel === label;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                sx: {
                    padding: 0
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            width: compact ? 32 : 48,
                            height: compact ? 32 : 48,
                            display: "flex",
                            position: "relative",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            backgroundColor: isActive ? `${item.color}40` : "transparent"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circleDefault.default), {
                            sx: {
                                color: item.color,
                                fontSize: compact ? 12 : 18
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            color: isActive ? item.color : (0, _colors.COLORS).grayMedium,
                            fontSize: compact ? 12 : 18,
                            ml: 2,
                            fontWeight: isActive ? 700 : 400
                        },
                        children: [
                            label,
                            " (",
                            t("common.valuePair", {
                                value: payload.percent,
                                formatParams: {
                                    value: {
                                        style: "percent",
                                        maximumFractionDigits: 2
                                    }
                                }
                            }),
                            ")"
                        ]
                    })
                ]
            }, label);
        })
    });
};
const PieChartCmp = ({ compact, data, dataKey, formatters })=>{
    const [activeLabel, setActiveLabel] = (0, _react.useState)();
    if (!data.length) return null;
    const labelKey = Object.keys(data[0]).find((key)=>key !== dataKey);
    if (!labelKey) throw new Error("Not able to determine label key");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.ResponsiveContainer), {
        width: "100%",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.PieChart), {
            width: 100,
            height: 100,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Tooltip), {
                    cursor: false,
                    wrapperStyle: {
                        outline: "none"
                    },
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltip.TooltipContent), {
                        formatters: formatters,
                        labelKey: labelKey
                    }),
                    offset: 15
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Legend), {
                    width: compact ? 150 : 250,
                    layout: "vertical",
                    align: "left",
                    verticalAlign: "middle",
                    content: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomLegend, {
                            activeLabel: activeLabel,
                            compact: compact,
                            payload: props.payload
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Pie), {
                    onMouseEnter: (item, index)=>setActiveLabel(item[labelKey]),
                    onMouseLeave: ()=>setActiveLabel(undefined),
                    stroke: "none",
                    data: data,
                    innerRadius: compact ? 25 : 40,
                    outerRadius: compact ? 50 : 90,
                    paddingAngle: 0,
                    dataKey: dataKey,
                    children: data.map((item, index)=>{
                        const label = item[labelKey];
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Cell), {
                            fill: colorPalette[index % colorPalette.length],
                            name: label,
                            style: {
                                filter: activeLabel === label ? `drop-shadow(0px 0px 5px ${(0, _colors.COLORS).grayMedium}` : "none"
                            }
                        }, `${label}-${index}`);
                    })
                })
            ]
        })
    });
};
const PieChart = /*#__PURE__*/ (0, _react.memo)(PieChartCmp);

},{"react/jsx-runtime":"g88cO","react":"BK2ob","recharts":"cL2Z5","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/icons-material/Circle":"jUk3w","@mui/material/List":"2UkGG","@mui/material/ListItem":"iWY3X","@mui/material/Typography":"f5srd","./Tooltip":"iZVHC","../../../styles/theme/colors":"hYvW2","../../../styles/theme/testnet/colors":"i4QXC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jUk3w":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("ba8f5e0dacf8a15a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3c58a8fa928e416b"));
var _jsxRuntime = require("1ee3268420a9b07d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), "Circle");

},{"ba8f5e0dacf8a15a":"hykHy","3c58a8fa928e416b":"gQLSP","1ee3268420a9b07d":"g88cO"}],"3MUm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SnapshotStaked", ()=>SnapshotStaked);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("../../../styles/theme/colors");
var _roundedBalance = require("../../components/RoundedBalance");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
const SnapshotStaked = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    //  TODO: provide label and staked values when API is ready, validate percentageValue formatting
    const staked = undefined;
    const percentageValue = undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotTextCard), {
        title: t("common.staked"),
        label: percentageValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                display: "flex",
                alignItems: "center",
                gap: 3
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: 12,
                    color: (0, _colors.COLORS).grayMedium
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    t: t,
                    i18nKey: "consensusSnapshot.totalCirculation",
                    components: {
                        StakedPercentage: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            component: "span",
                            sx: {
                                fontSize: "24px",
                                color: (0, _colors.COLORS).grayExtraDark
                            },
                            children: t("common.valuePair", {
                                value: percentageValue,
                                formatParams: {
                                    value: {
                                        style: "percent",
                                        maximumFractionDigits: 2
                                    }
                                }
                            })
                        })
                    }
                })
            })
        }),
        children: staked && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            sx: {
                wordBreak: "break-all",
                lineHeight: 1
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                value: staked
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","../../../styles/theme/colors":"hYvW2","../../components/RoundedBalance":"af34T","../../components/Snapshots/SnapshotCard":"b3UOK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"5ebZy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LatestConsensusBlocks", ()=>LatestConsensusBlocks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _blocks = require("../../components/Blocks");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _routeUtils = require("../../utils/route-utils");
var _useScreensize = require("../../hooks/useScreensize");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const LatestConsensusBlocks = ({ scope })=>{
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const blocksQuery = (0, _api.useGetConsensusBlocks)(network, {
        limit
    }, {
        query: {
            cacheTime: 0
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        sx: {
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("blocks.latest"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getLatestBlocksRoute(scope),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blocks.ConsensusBlocks), {
                    isLoading: blocksQuery.isLoading,
                    blocks: blocksQuery.data?.data.blocks,
                    limit: limit,
                    pagination: false,
                    type: isMobile ? (0, _blocks.BlocksTableType).Mobile : (0, _blocks.BlocksTableType).DesktopLite
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../components/Blocks":"4KkfE","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","../../utils/route-utils":"b2kKi","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gjeEa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountsCard", ()=>AccountsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _colors = require("../../../styles/theme/colors");
var _accountList = require("app/components/AccountList");
var _routeUtils = require("app/utils/route-utils");
const limit = (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
const AccountsCard = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    // TODO: Add query param to sort by rank when API is ready
    const accountsQuery = (0, _api.useGetConsensusAccounts)(network, {
        limit
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("account.listTitle"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getAccountsRoute(scope.network),
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountList.AccountList), {
                    accounts: accountsQuery.data?.data.accounts,
                    isLoading: accountsQuery.isLoading,
                    limit: limit,
                    pagination: false
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../../styles/theme/colors":"hYvW2","app/components/AccountList":"8TblH","app/utils/route-utils":"b2kKi","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8TblH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountList", ()=>AccountList);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _table = require("../../components/Table");
var _roundedBalance = require("../../components/RoundedBalance");
var _accountLink = require("../Account/AccountLink");
var _accountSizeBadge = require("../AccountSizeBadge");
const AccountList = ({ isLoading, limit, pagination, accounts, verbose })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const tableColumns = [
        {
            align: (0, _table.TableCellAlign).Center,
            key: "size",
            content: t("common.size")
        },
        {
            key: "address",
            content: t("common.address")
        },
        ...verbose ? [
            {
                key: "creationDate",
                content: t("account.birth")
            }
        ] : [],
        {
            align: (0, _table.TableCellAlign).Right,
            key: "available",
            content: t("account.available")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "staked",
            content: t("common.staked")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "debonding",
            content: t("account.debonding")
        },
        {
            align: (0, _table.TableCellAlign).Right,
            key: "total",
            content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                children: t("account.totalBalance")
            })
        }
    ];
    const tableRows = accounts?.map((account)=>({
            key: account.address,
            data: [
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountSizeBadge.AccountSizeBadge), {
                            size: account.size
                        })
                    }),
                    key: "size"
                },
                {
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: account,
                        address: account.address,
                        alwaysTrim: true
                    }),
                    key: "address"
                },
                ...verbose ? [
                    {
                        // TODO: provide date when it is implemented in the API
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        }),
                        key: "creationDate"
                    }
                ] : [],
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        value: account.available,
                        ticker: account.ticker
                    }),
                    key: "available"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    // TODO: provide value via RoundedBalance when it is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "-"
                    }),
                    key: "staked"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    // TODO: provide value via RoundedBalance when it is implemented in the API
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: "-"
                    }),
                    key: "debonding"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                            value: account.total,
                            ticker: account.ticker
                        })
                    }),
                    key: "total"
                }
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: t("account.listTitle"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","../../components/Table":"j3qb1","../../components/RoundedBalance":"af34T","../Account/AccountLink":"43Jgs","../AccountSizeBadge":"4vuKT","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4vuKT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledBox", ()=>StyledBox);
parcelHelpers.export(exports, "AccountSizeBadge", ()=>AccountSizeBadge);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _styles = require("@mui/material/styles");
var _colors = require("styles/theme/colors");
const badgeSize = "27px";
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        background: "linear-gradient(88deg, #9747FF 1.71%, #3332CB 79.56%)",
        border: `2px solid ${(0, _colors.COLORS).brandExtraDark}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: badgeSize,
        minWidth: badgeSize,
        height: badgeSize,
        borderRadius: badgeSize,
        color: (0, _colors.COLORS).white,
        fontSize: "10px",
        fontWeight: 700
    }));
const AccountSizeBadge = ({ size })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        arrow: true,
        placement: "top",
        title: t("account.sizeTooltip", {
            size
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
            children: size
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Tooltip":"3RLHy","@mui/material/styles":"51PGx","styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ky9I3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LatestConsensusTransactions", ()=>LatestConsensusTransactions);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _reactRouterDom = require("react-router-dom");
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _api = require("../../../oasis-nexus/api");
var _transactions = require("../../components/Transactions");
var _config = require("../../config");
var _routeUtils = require("../../utils/route-utils");
var _useScreensize = require("../../hooks/useScreensize");
const LatestConsensusTransactions = ({ scope })=>{
    const { isTablet } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const transactionsQuery = (0, _api.useGetConsensusTransactions)(network, {
        limit: (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD)
    }, {
        query: {
            cacheTime: 0
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("transactions.latest"),
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    component: (0, _reactRouterDom.Link),
                    to: (0, _routeUtils.RouteUtils).getLatestTransactionsRoute(scope),
                    children: t("common.viewAll")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.ConsensusTransactions), {
                    transactions: transactionsQuery.data?.data.transactions,
                    isLoading: transactionsQuery.isLoading,
                    limit: (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD),
                    pagination: false,
                    verbose: !isTablet
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","react-router-dom":"5o0mA","@mui/material/Link":"fTbCF","../../../oasis-nexus/api":"dJrPU","../../components/Transactions":"k0qMF","../../config":"in6G4","../../utils/route-utils":"b2kKi","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"33KoF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimesCard", ()=>ParaTimesCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _styles = require("@mui/material/styles");
var _api = require("../../../oasis-nexus/api");
var _layers = require("../../../types/layers");
var _colors = require("../../../styles/theme/colors");
var _cardHeaderWithCounter = require("../../components/CardHeaderWithCounter");
var _routeUtils = require("../../utils/route-utils");
var _runtimePreview = require("./RuntimePreview");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        [theme.breakpoints.up("md")]: {
            paddingRight: theme.spacing(4),
            paddingLeft: theme.spacing(4)
        },
        [theme.breakpoints.down("md")]: {
            flexDirection: "column"
        },
        "> div:not(:last-child)": {
            [theme.breakpoints.down("md")]: {
                paddingBottom: theme.spacing(4),
                borderBottom: `1px solid ${(0, _colors.COLORS).grayMediumLight}`
            },
            [theme.breakpoints.up("md")]: {
                paddingRight: theme.spacing(5),
                marginRight: theme.spacing(5),
                borderRight: `1px solid ${(0, _colors.COLORS).grayMediumLight}`
            }
        }
    }));
function shouldIncludeLayer(layer) {
    return layer !== (0, _api.Layer).consensus && (0, _layers.isNotOnHiddenLayer)({
        layer
    });
}
const ParaTimesCard = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const { enabled, disabled } = (0, _routeUtils.RouteUtils).getAllLayersForNetwork(network);
    const enabledOasisRuntimes = enabled.filter(shouldIncludeLayer);
    const disabledOasisRuntimes = disabled.filter(shouldIncludeLayer);
    const runtimesNumber = enabledOasisRuntimes.length + disabledOasisRuntimes.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                    label: t("paratimes.listTitle"),
                    totalCount: runtimesNumber,
                    isTotalCountClipped: false
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
                    children: [
                        !!enabledOasisRuntimes.length && enabledOasisRuntimes.map((runtime)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimePreview.EnabledRuntimePreview), {
                                network: scope.network,
                                runtime: runtime
                            }, runtime)),
                        !!disabledOasisRuntimes.length && disabledOasisRuntimes.map((runtime)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimePreview.InactiveRuntimePreview), {
                                network: scope.network,
                                runtime: runtime
                            }, runtime))
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/styles":"51PGx","../../../oasis-nexus/api":"dJrPU","../../../types/layers":"gWCJy","../../../styles/theme/colors":"hYvW2","../../components/CardHeaderWithCounter":"82LaW","../../utils/route-utils":"b2kKi","./RuntimePreview":"idsRp","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"idsRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnabledRuntimePreview", ()=>EnabledRuntimePreview);
parcelHelpers.export(exports, "InactiveRuntimePreview", ()=>InactiveRuntimePreview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _filterNone = require("@mui/icons-material/FilterNone");
var _filterNoneDefault = parcelHelpers.interopDefault(_filterNone);
var _radioButtonUnchecked = require("@mui/icons-material/RadioButtonUnchecked");
var _radioButtonUncheckedDefault = parcelHelpers.interopDefault(_radioButtonUnchecked);
var _circle = require("@mui/icons-material/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _api = require("oasis-nexus/api");
var _colors = require("../../../styles/theme/colors");
var _hook = require("../../components/OfflineBanner/hook");
var _runtimeStatusIcon = require("../../components/RuntimeStatusIcon");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _blockLink = require("../../components/Blocks/BlockLink");
var _styledLinks = require("../../components/StyledLinks");
var _content = require("../../utils/content");
var _routeUtils = require("../../utils/route-utils");
var _chartUtils = require("../../utils/chart-utils");
var _transactionsChartCard = require("../ParatimeDashboardPage/TransactionsChartCard");
var _activeAccounts = require("../ParatimeDashboardPage/ActiveAccounts");
const StyledList = (0, _styles.styled)((0, _styledDescriptionList.InlineDescriptionList))(({ theme })=>({
        marginBottom: theme.spacing(4),
        "dt, dd": {
            display: "flex",
            padding: theme.spacing(2, 0)
        },
        dt: {
            alignItems: "start"
        },
        dd: {
            justifyContent: "end"
        }
    }));
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(()=>({
        border: `2px solid ${(0, _colors.COLORS).brandDark}`,
        borderRadius: "12px",
        height: "180px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 34px 24px -9px #324DAB1F",
        overflow: "hidden"
    }));
const StyledTypography = (0, _styles.styled)((0, _typographyDefault.default))(()=>({
        fontSize: "18px",
        fontWeight: 700,
        color: (0, _colors.COLORS).brandDark,
        flex: 1,
        minHeight: "44px",
        display: "flex",
        alignItems: "center"
    }));
const EnabledRuntimePreview = ({ network, runtime })=>{
    const query = (0, _api.useGetRuntimeStatus)(network, runtime);
    const { outOfDate } = (0, _hook.useRuntimeFreshness)({
        network,
        layer: runtime
    });
    const runtimeStatus = query?.data?.data;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimePreview, {
        network: network,
        runtime: runtime,
        status: {
            activeNodes: runtimeStatus?.active_nodes,
            latestBlock: runtimeStatus?.latest_block,
            outOfDate
        }
    });
};
const InactiveRuntimePreview = ({ network, runtime })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RuntimePreview, {
        network: network,
        runtime: runtime
    });
};
const RuntimePreview = ({ network, runtime, status })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [panel, setPanel] = (0, _react.useState)("transactions");
    const layerLabels = (0, _content.getLayerLabels)(t);
    const runtimeLabel = layerLabels[runtime];
    const dashboardLink = (0, _routeUtils.RouteUtils).getDashboardRoute({
        network,
        layer: runtime
    });
    const runtimeStatus = status ? status.outOfDate ? "outdated" : "stable" : "inactive";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        sx: {
            flex: 1,
            paddingY: 3
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    marginBottom: 4
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTypography, {
                    children: status ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                                component: (0, _reactRouterDom.Link),
                                to: dashboardLink,
                                children: runtimeLabel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledLinks.RouterLinkCircle), {
                                to: dashboardLink
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: runtimeLabel
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledList, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                        children: [
                            t("common.status"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runtimeStatusIcon.RuntimeStatusIcon), {
                                status: runtimeStatus
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("paratimes.blockNumber")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: status?.latestBlock ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                            scope: {
                                layer: runtime,
                                network
                            },
                            height: status.latestBlock
                        }) : "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                        children: [
                            t("paratimes.nodes"),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                        children: [
                            status?.activeNodes ? t("paratimes.activeNodes", {
                                nodes: status?.activeNodes
                            }) : "-",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    gap: 3,
                    sx: {
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    },
                    children: [
                        status && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            sx: {
                                width: "100%"
                            },
                            children: [
                                panel === "transactions" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionsChartCard.TransactionsChartCard), {
                                    scope: {
                                        layer: runtime,
                                        network
                                    },
                                    chartDuration: (0, _chartUtils.ChartDuration).TODAY
                                }),
                                panel === "accounts" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activeAccounts.ActiveAccounts), {
                                    scope: {
                                        layer: runtime,
                                        network
                                    },
                                    chartDuration: (0, _chartUtils.ChartDuration).TODAY
                                })
                            ]
                        }),
                        !status && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterNoneDefault.default), {
                                    sx: {
                                        color: (0, _colors.COLORS).brandDark,
                                        fontSize: "33px"
                                    }
                                }),
                                t("paratimes.noData")
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: 3
                },
                children: status && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PanelButton, {
                            activePanel: panel,
                            ariaLabel: t("common.transactions"),
                            panel: "transactions",
                            setPanel: setPanel
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PanelButton, {
                            activePanel: panel,
                            ariaLabel: t("account.listTitle"),
                            panel: "accounts",
                            setPanel: setPanel
                        })
                    ]
                })
            })
        ]
    });
};
const PanelButton = ({ activePanel, ariaLabel, panel, setPanel })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
            "aria-label": ariaLabel,
            onClick: ()=>setPanel(panel),
            children: panel === activePanel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circleDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).brandDark,
                    fontSize: "10px"
                }
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioButtonUncheckedDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).brandDark,
                    fontSize: "10px"
                }
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-router-dom":"5o0mA","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/IconButton":"hLmKV","@mui/material/Link":"fTbCF","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@mui/icons-material/FilterNone":"r3s4M","@mui/icons-material/RadioButtonUnchecked":"r3Pd6","@mui/icons-material/Circle":"jUk3w","oasis-nexus/api":"dJrPU","../../../styles/theme/colors":"hYvW2","../../components/OfflineBanner/hook":"cKMsd","../../components/RuntimeStatusIcon":"gUZhZ","../../components/StyledDescriptionList":"bndrS","../../components/Blocks/BlockLink":"g8oEe","../../components/StyledLinks":"Guhqk","../../utils/content":"gyk1M","../../utils/route-utils":"b2kKi","../../utils/chart-utils":"arkVO","../ParatimeDashboardPage/TransactionsChartCard":"giibs","../ParatimeDashboardPage/ActiveAccounts":"2Yshn","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"r3s4M":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("e62fc87c6aa7e7c8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("74cb4aa8fffc3424"));
var _jsxRuntime = require("eab8495df492399c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2m0 16H7V3h14z"
}), "FilterNone");

},{"e62fc87c6aa7e7c8":"hykHy","74cb4aa8fffc3424":"gQLSP","eab8495df492399c":"g88cO"}],"r3Pd6":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("cbba1c848ac3d4eb");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("2f17715f7d7d0a6a"));
var _jsxRuntime = require("7226bd1d3eff549b");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "RadioButtonUnchecked");

},{"cbba1c848ac3d4eb":"hykHy","2f17715f7d7d0a6a":"gQLSP","7226bd1d3eff549b":"g88cO"}],"gUZhZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeStatusIcon", ()=>RuntimeStatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _alarm = require("@mui/icons-material/Alarm");
var _alarmDefault = parcelHelpers.interopDefault(_alarm);
var _colors = require("../../../styles/theme/colors");
var _colors1 = require("../../../styles/theme/testnet/colors");
var _badge = require("../../components/Badge");
const getStatuses = (t)=>({
        stable: {
            backgroundColor: (0, _colors.COLORS).honeydew,
            icon: (0, _checkCircleDefault.default),
            iconColor: (0, _colors.COLORS).eucalyptus,
            label: t("paratimes.online")
        },
        outdated: {
            backgroundColor: (0, _colors1.COLORS).testnetLight,
            icon: (0, _warningDefault.default),
            iconColor: (0, _colors1.COLORS).testnet,
            label: t("paratimes.outdated")
        },
        inactive: {
            backgroundColor: (0, _colors.COLORS).brandLightBlue,
            icon: (0, _alarmDefault.default),
            iconColor: (0, _colors.COLORS).brandMedium,
            label: t("paratimes.inactive")
        }
    });
const RuntimeStatusIcon = ({ status })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const statusConfig = getStatuses(t)[status];
    const IconComponent = statusConfig.icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _badge.Badge), {
        backgroundColor: statusConfig.backgroundColor,
        textColor: (0, _colors.COLORS).grayExtraDark,
        label: statusConfig.label,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconComponent, {
            sx: {
                color: statusConfig.iconColor
            },
            fontSize: "inherit"
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/icons-material/CheckCircle":"lfaia","@mui/icons-material/Warning":"bYx0X","@mui/icons-material/Alarm":"chQ8g","../../../styles/theme/colors":"hYvW2","../../../styles/theme/testnet/colors":"i4QXC","../../components/Badge":"dHMgv","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"chQ8g":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("40c303d965bd1e60");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("bc03787cdef4fbeb"));
var _jsxRuntime = require("f4693eb676519521");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m22 5.72-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39 6.6 1.86 2 5.71l1.29 1.53zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9m0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7"
}), "Alarm");

},{"40c303d965bd1e60":"hykHy","bc03787cdef4fbeb":"gQLSP","f4693eb676519521":"g88cO"}],"gC0jq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorsPage", ()=>ValidatorsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _errors = require("../../../types/errors");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _validators = require("../../components/Validators");
var _cardHeaderWithCounter = require("../../components/CardHeaderWithCounter");
var _validatorDetailsPage = require("../ValidatorDetailsPage");
var _verticalList = require("../../components/VerticalList");
const ValidatorsPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { network } = scope;
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const validatorsQuery = (0, _api.useGetConsensusValidators)(network, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE) : (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    });
    const { isLoading, isFetched, data } = validatorsQuery;
    const validatorsData = data?.data;
    if (isFetched && offset && !validatorsData?.validators?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                    changeMobileColors: true,
                    label: t("validator.listTitle"),
                    totalCount: validatorsData?.total_count,
                    isTotalCountClipped: validatorsData?.is_total_count_clipped
                }),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validators.Validators), {
                        validators: validatorsQuery.data?.data.validators,
                        isLoading: validatorsQuery.isLoading,
                        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        }
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array((0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorDetailsPage.ValidatorDetailsView), {
                                    isLoading: true,
                                    validator: undefined,
                                    standalone: true
                                }, key)),
                            !isLoading && validatorsData?.validators.map((validator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorDetailsPage.ValidatorDetailsView), {
                                    validator: validator,
                                    standalone: true
                                }, validator.entity_address))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../../../types/errors":"gdpNU","../../components/TableLayoutButton":"5tkdC","../../components/LoadMoreButton":"aeVDT","../../hooks/useScopeParam":"kKMKx","../../components/Validators":"kfkPi","../../components/CardHeaderWithCounter":"82LaW","../ValidatorDetailsPage":"2dV6P","../../components/VerticalList":"gcFw0","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2dV6P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledGrid", ()=>StyledGrid);
parcelHelpers.export(exports, "ValidatorDetailsPage", ()=>ValidatorDetailsPage);
parcelHelpers.export(exports, "ValidatorDetailsView", ()=>ValidatorDetailsView);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _useScreensize = require("../../hooks/useScreensize");
var _api = require("../../../oasis-nexus/api");
var _routerTabs = require("../../components/RouterTabs");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _pageLayout = require("../../components/PageLayout");
var _skeleton = require("../../components/Skeleton");
var _statusIcon = require("../../components/StatusIcon");
var _validatorImage = require("../../components/Validators/ValidatorImage");
var _validatorCommission = require("../../components/Validators/ValidatorCommission");
var _validatorCumulativeVoting = require("../../components/Validators/ValidatorCumulativeVoting");
var _validatorTitleCard = require("./ValidatorTitleCard");
var _useScopeParam = require("app/hooks/useScopeParam");
var _validatorSnapshot = require("./ValidatorSnapshot");
var _signedBlocks = require("./SignedBlocks");
var _stakingTrend = require("./StakingTrend");
var _proposedBlocks = require("./ProposedBlocks");
var _tabAnchors = require("./tabAnchors");
const StyledGrid = (0, _styles.styled)((0, _gridDefault.default))(({ theme })=>({
        [theme.breakpoints.up("sm")]: {
            display: "flex"
        }
    }));
const ValidatorDetailsPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    // TODO: currently API does not work with address query param. Wait for API update or switch to entity_id
    const { address } = (0, _reactRouterDom.useLoaderData)();
    const validatorQuery = (0, _api.useGetConsensusValidatorsEntityId)(scope.network, address);
    const { isLoading, data } = validatorQuery;
    const validator = data?.data;
    const transactionsLink = (0, _reactRouterDom.useHref)("");
    const delegatorsLink = (0, _reactRouterDom.useHref)(`delegators#${(0, _tabAnchors.delegatorsContainerId)}`);
    const debondingDelegationsLink = (0, _reactRouterDom.useHref)(`debonding-delegations#${(0, _tabAnchors.debondingContainerId)}`);
    const context = {
        scope,
        address
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorTitleCard.ValidatorTitleCard), {
                isLoading: isLoading,
                network: scope.network,
                validator: validator
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorSnapshot.ValidatorSnapshot), {
                scope: scope,
                validator: validator
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout",
                sx: {
                    mt: isMobile ? 4 : 0
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ValidatorDetailsCard, {
                isLoading: isLoading,
                validator: validator
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                spacing: 4,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledGrid, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stakingTrend.StakingTrend), {
                            scope: scope
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledGrid, {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signedBlocks.SignedBlocks), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposedBlocks.ProposedBlocks), {
                scope: scope
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routerTabs.RouterTabs), {
                tabs: [
                    {
                        label: t("common.transactions"),
                        to: transactionsLink
                    },
                    {
                        label: t("validator.delegators"),
                        to: delegatorsLink
                    },
                    {
                        label: t("validator.undelegations"),
                        to: debondingDelegationsLink
                    }
                ],
                context: context
            })
        ]
    });
};
const ValidatorDetailsCard = ({ isLoading, validator })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ValidatorDetailsView, {
                detailsPage: true,
                isLoading: isLoading,
                validator: validator
            })
        })
    });
};
const ValidatorDetailsView = ({ detailsPage, isLoading, validator, standalone = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 10
    });
    if (!validator) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "160px" : "200px",
        standalone: standalone,
        children: [
            detailsPage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorImage.ValidatorImage), {
                            address: validator.entity_address,
                            name: validator.media?.name,
                            logotype: validator.media?.logotype
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: validator.media?.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.rank")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.address")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: validator.entity_address
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.delegators")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.status")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.startDate")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.votingPower")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.totalShare")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.participationRate")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.commissionRates")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCommission.ValidatorCommission), {
                            commission: validator.current_rate
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.commissionBounds")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: validator.current_commission_bound && validator.current_commission_bound.epoch_start ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCommission.ValidatorCommission), {
                                    commission: validator.current_commission_bound.lower
                                }),
                                "~",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCommission.ValidatorCommission), {
                                    commission: validator.current_commission_bound.upper
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: t("validator.boundsNotSet")
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.entityId")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: validator.entity_id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.nodeId")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: validator.node_id
                    })
                ]
            }),
            !detailsPage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.rank")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorImage.ValidatorImage), {
                            address: validator.entity_address,
                            name: validator.media?.name,
                            logotype: validator.media?.logotype
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.cumulativeVoting")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCumulativeVoting.ValidatorCumulativeVoting), {
                            containerMarginThemeSpacing: 4,
                            value: 0
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.voting")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.staked")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.change")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.delegators")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.commission")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorCommission.ValidatorCommission), {
                            commission: validator.current_rate
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.status")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
                            success: validator.status,
                            error: undefined
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("validator.uptime")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: "-"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Card":"cTsx6","@mui/material/CardContent":"kMUKY","@mui/material/Divider":"3hI6U","@mui/material/Grid":"bu56N","../../hooks/useScreensize":"2HEhN","../../../oasis-nexus/api":"dJrPU","../../components/RouterTabs":"dUetQ","../../components/StyledDescriptionList":"bndrS","../../components/PageLayout":"24SOU","../../components/Skeleton":"eB5vc","../../components/StatusIcon":"3VOhR","../../components/Validators/ValidatorImage":"30hm1","../../components/Validators/ValidatorCommission":"2dER2","../../components/Validators/ValidatorCumulativeVoting":"8C0vP","./ValidatorTitleCard":"1sYM7","app/hooks/useScopeParam":"kKMKx","./ValidatorSnapshot":"jw8w5","./SignedBlocks":"gkz9M","./StakingTrend":"iwCWl","./ProposedBlocks":"cigIH","./tabAnchors":"kXq1n","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1sYM7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorTitleCard", ()=>ValidatorTitleCard);
var _jsxRuntime = require("react/jsx-runtime");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _copyToClipboard = require("../../components/CopyToClipboard");
var _colors = require("styles/theme/colors");
var _validatorImage = require("app/components/Validators/ValidatorImage");
var _titleCard = require("app/components/PageLayout/TitleCard");
var _validatorLink = require("app/components/Validators/ValidatorLink");
const ValidatorTitleCard = ({ isLoading, network, validator })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleCard.TitleCard), {
        details: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: validator && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        sx: {
                            paddingLeft: 2
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorLink.ValidatorLink), {
                            address: validator.entity_address,
                            name: validator.entity_address,
                            network: network
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: validator.entity_address
                    })
                ]
            })
        }),
        isLoading: isLoading,
        title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: validator && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center"
                        },
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorImage.ValidatorImage), {
                                address: validator.entity_address,
                                name: validator.media?.name,
                                logotype: validator.media?.logotype
                            }),
                            validator?.media?.name
                        ]
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        component: "span",
                        sx: {
                            color: (0, _colors.COLORS).grayMedium,
                            fontSize: "24px",
                            fontWeight: 400
                        },
                        children: "(-)"
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Typography":"f5srd","@mui/material/Box":"4d7LG","../../components/CopyToClipboard":"iTQvM","styles/theme/colors":"hYvW2","app/components/Validators/ValidatorImage":"30hm1","app/components/PageLayout/TitleCard":"hNFSw","app/components/Validators/ValidatorLink":"18CFQ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"jw8w5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorSnapshot", ()=>ValidatorSnapshot);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _openInNew = require("@mui/icons-material/OpenInNew");
var _openInNewDefault = parcelHelpers.interopDefault(_openInNew);
var _reactI18Next = require("react-i18next");
var _appendMobileSearch = require("../../components/AppendMobileSearch");
var _externalLinkCard = require("./ExternalLinkCard");
var _uptimeCard = require("./UptimeCard");
var _votingPowerCard = require("./VotingPowerCard");
var _balanceDistributionCard = require("./BalanceDistributionCard");
var _snapshot = require("../../components/Snapshots/Snapshot");
var _url = require("../../utils/url");
const StyledTypography = (0, _styles.styled)((0, _typographyDefault.default))(()=>({
        fontSize: 18,
        fontWeight: 500,
        textTransform: "lowercase",
        "::first-letter": {
            textTransform: "uppercase"
        }
    }));
const ValidatorSnapshot = ({ scope, validator })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const theme = (0, _styles.useTheme)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                container: true,
                sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    mb: 4
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    item: true,
                    xs: 12,
                    sx: {
                        px: isMobile ? 4 : 0
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appendMobileSearch.AppendMobileSearch), {
                        scope: scope,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            sx: {
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                                variant: "h3",
                                sx: {
                                    color: theme.palette.layout.main,
                                    fontWeight: 700,
                                    mr: 3
                                },
                                children: t("validator.snapshot")
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                rowSpacing: 1,
                columnSpacing: 4,
                columns: 22,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _balanceDistributionCard.BalanceDistributionCard), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _votingPowerCard.VotingPowerCard), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 5,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uptimeCard.UptimeCard), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshot.StyledGrid), {
                        item: true,
                        xs: 22,
                        md: 5,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _externalLinkCard.ExternalLinkCard), {
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                gap: 2,
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTypography, {
                                        children: (0, _url.getHostname)(validator?.media?.website_link)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openInNewDefault.default), {
                                        sx: {
                                            fontSize: 20
                                        }
                                    })
                                ]
                            }),
                            link: validator?.media?.website_link
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Grid":"bu56N","@mui/material/Typography":"f5srd","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","@mui/icons-material/OpenInNew":"9yVXZ","react-i18next":"e210a","../../components/AppendMobileSearch":"7MClM","./ExternalLinkCard":"8gOqr","./UptimeCard":"9UEMb","./VotingPowerCard":"k1xiM","./BalanceDistributionCard":"euIn2","../../components/Snapshots/Snapshot":"91gmN","../../utils/url":"bmAGl","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"8gOqr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExternalLinkCard", ()=>ExternalLinkCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _snapshotCardExternalLink = require("app/components/Snapshots/SnapshotCardExternalLink");
const ExternalLinkCard = ({ label, link })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCardExternalLink.SnapshotCardExternalLink), {
        description: t("validator.externalLinkDescriotion"),
        label: label || link,
        title: t("validator.externalLink"),
        url: link
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","app/components/Snapshots/SnapshotCardExternalLink":"3JVAB","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9UEMb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UptimeCard", ()=>UptimeCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
const UptimeCard = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotTextCard), {
        title: t("validator.uptime"),
        children: "-"
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Snapshots/SnapshotCard":"b3UOK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"k1xiM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VotingPowerCard", ()=>VotingPowerCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
const VotingPowerCard = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotTextCard), {
        title: t("validator.votingPower"),
        children: "-"
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Snapshots/SnapshotCard":"b3UOK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"euIn2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BalanceDistributionCard", ()=>BalanceDistributionCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _snapshotCard = require("../../components/Snapshots/SnapshotCard");
const BalanceDistributionCard = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _snapshotCard.SnapshotTextCard), {
        title: t("validator.balanceDistribution"),
        children: "-"
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../components/Snapshots/SnapshotCard":"b3UOK","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"gkz9M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignedBlocks", ()=>SignedBlocks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _colors = require("styles/theme/colors");
var _blockStats = require("../../components/BlockStats");
const SignedBlocks = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    // TODO: provide data from the API and sync dataKey value
    const data = [];
    const dataKey = "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        sx: {
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("validator.signedBlocks"),
                sx: {
                    paddingBottom: 0
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: data && data.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                            sx: {
                                fontSize: "18px",
                                color: (0, _colors.COLORS).grayMedium,
                                paddingBottom: 4
                            },
                            children: t("validator.signedBlocksDescription")
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockStats.BlockStats), {
                            data: data,
                            dataKey: dataKey,
                            legendLabels: {
                                success: t("validator.signed"),
                                fail: t("validator.missed")
                            },
                            tooltipFormatter: (value)=>t("validator.blockWithHeight", {
                                    height: value
                                })
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Typography":"f5srd","styles/theme/colors":"hYvW2","../../components/BlockStats":"1W5KJ","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"1W5KJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockStats", ()=>BlockStats);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _styles = require("@mui/material/styles");
var _colors = require("../../../styles/theme/colors");
const StyledSquare = (0, _styles.styled)((0, _boxDefault.default), {
    shouldForwardProp: (prop)=>prop !== "success"
})(({ success })=>{
    return {
        display: "flex",
        width: "24px",
        height: "24px",
        borderRadius: "3px",
        backgroundColor: success ? (0, _colors.COLORS).eucalyptus : (0, _colors.COLORS).errorIndicatorBackground
    };
});
const BlockStats = ({ data, dataKey, legendLabels, tooltipFormatter })=>{
    const statusKey = Object.keys(data[0]).find((key)=>key !== dataKey);
    if (!statusKey) throw new Error("Not able to determine status key");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    display: "flex",
                    flexWrap: "wrap"
                },
                gap: 2,
                children: data.map((item)=>{
                    const title = tooltipFormatter ? tooltipFormatter(item[dataKey].toString()) : item[dataKey];
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                        title: title,
                        placement: "top",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSquare, {
                            success: item[statusKey]
                        })
                    }, item[dataKey]);
                })
            }),
            legendLabels && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                pt: 5,
                sx: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        gap: 3,
                        mr: 4,
                        sx: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSquare, {
                                success: true
                            }),
                            " ",
                            legendLabels.success
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        gap: 3,
                        sx: {
                            display: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSquare, {}),
                            " ",
                            legendLabels.fail
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Tooltip":"3RLHy","@mui/material/styles":"51PGx","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"iwCWl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StakingTrend", ()=>StakingTrend);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _lineChart = require("../../components/charts/LineChart");
var _useScreensize = require("../../hooks/useScreensize");
const StakingTrend = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    // TODO: provide data from the API is ready and sync dataKey value
    const windows = undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        sx: {
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("validator.stakingTrend")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                sx: {
                    height: 250
                },
                children: windows && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lineChart.LineChart), {
                    tooltipActiveDotRadius: 9,
                    cartesianGrid: true,
                    strokeWidth: 3,
                    dataKey: "volume",
                    data: windows,
                    margin: {
                        bottom: 16,
                        top: isMobile ? 0 : 16
                    },
                    tickMargin: 16,
                    withLabels: true,
                    formatters: {
                        data: (value)=>value.toLocaleString(),
                        label: (value)=>t("common.formattedDateTime", {
                                timestamp: new Date(value)
                            })
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../components/charts/LineChart":"ez9P0","../../hooks/useScreensize":"2HEhN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"cigIH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposedBlocks", ()=>ProposedBlocks);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
const ProposedBlocks = ({ scope })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("validator.proposedBlocks")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {})
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kXq1n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delegatorsContainerId", ()=>delegatorsContainerId);
parcelHelpers.export(exports, "debondingContainerId", ()=>debondingContainerId);
const delegatorsContainerId = "delegators";
const debondingContainerId = "debonding";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dn4i4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalsPage", ()=>ProposalsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _errors = require("../../../types/errors");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _networkProposalsList = require("../../components/NetworkProposalsList");
var _cardHeaderWithCounter = require("../../components/CardHeaderWithCounter");
var _validatorDetailsPage = require("../ValidatorDetailsPage");
var _verticalList = require("../../components/VerticalList");
var _proposalDetailsPage = require("../ProposalDetailsPage");
const ProposalsPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { network } = scope;
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const proposalsQuery = (0, _api.useGetConsensusProposals)(network, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE) : (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    });
    const { isLoading, isFetched, data } = proposalsQuery;
    const proposalsData = data?.data;
    if (isFetched && offset && !proposalsData?.proposals?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                    changeMobileColors: true,
                    label: t("networkProposal.listTitle"),
                    totalCount: proposalsData?.total_count,
                    isTotalCountClipped: proposalsData?.is_total_count_clipped
                }),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkProposalsList.NetworkProposalsList), {
                        proposals: proposalsData?.proposals,
                        isLoading: proposalsQuery.isLoading,
                        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        },
                        verbose: true
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array((0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorDetailsPage.ValidatorDetailsView), {
                                    isLoading: true,
                                    validator: undefined,
                                    standalone: true
                                }, key)),
                            !isLoading && proposalsData?.proposals.map((proposal)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _proposalDetailsPage.ProposalDetailView), {
                                    proposal: proposal,
                                    standalone: true
                                }, proposal.handler))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../../../types/errors":"gdpNU","../../components/TableLayoutButton":"5tkdC","../../components/LoadMoreButton":"aeVDT","../../hooks/useScopeParam":"kKMKx","../../components/NetworkProposalsList":"7TDXH","../../components/CardHeaderWithCounter":"82LaW","../ValidatorDetailsPage":"2dV6P","../../components/VerticalList":"gcFw0","../ProposalDetailsPage":"eO7IX","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"kDBzG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useValidatorDetailsProps", ()=>useValidatorDetailsProps);
var _reactRouterDom = require("react-router-dom");
const useValidatorDetailsProps = ()=>(0, _reactRouterDom.useOutletContext)();

},{"react-router-dom":"5o0mA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"g4WHj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebondingDelegationsCard", ()=>DebondingDelegationsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _delegations = require("../../components/Delegations");
var _tabAnchors = require("./tabAnchors");
const DebondingDelegationsCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const debondingQuery = (0, _api.useGetConsensusAccountsAddressDebondingDelegationsTo)(network, address, {
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset
    });
    const { isFetched, isLoading, data } = debondingQuery;
    const debondingDelegations = data?.data.debonding_delegations;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: (0, _tabAnchors.debondingContainerId),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("validator.undelegations")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DebondingDelegationsView, {
                        debondingDelegations: debondingDelegations,
                        isFetched: isFetched,
                        isLoading: isLoading,
                        pagination: {
                            ...pagination,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            totalCount: data?.data.total_count
                        }
                    })
                })
            })
        ]
    });
};
const DebondingDelegationsView = ({ debondingDelegations, isFetched, isLoading, pagination })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !debondingDelegations?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("validator.emptyDebondingList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _delegations.Delegations), {
                debonding: true,
                delegations: debondingDelegations,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: {
                    selectedPage: pagination.selectedPage,
                    linkToPage: pagination.linkToPage,
                    totalCount: pagination.totalCount,
                    isTotalCountClipped: pagination.isTotalCountClipped,
                    rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../../components/Table/useSearchParamsPagination":"jOnBC","../../components/Delegations":"6aJaP","./tabAnchors":"kXq1n","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6aJaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Delegations", ()=>Delegations);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _table = require("../Table");
var _roundedBalance = require("../RoundedBalance");
var _validatorLink = require("../Validators/ValidatorLink");
var _accountLink = require("../Account/AccountLink");
const Delegations = ({ debonding, delegations, isLoading, limit, linkType, pagination })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const tableColumns = [
        {
            key: "delegator",
            content: t("common.address")
        },
        {
            key: "amount",
            content: t("validator.amount"),
            align: (0, _table.TableCellAlign).Right
        },
        {
            key: "shares",
            content: t("validator.shares"),
            align: (0, _table.TableCellAlign).Right
        },
        ...debonding ? [
            {
                key: "debondingEnd",
                content: t("validator.debondingEnd"),
                align: (0, _table.TableCellAlign).Right
            }
        ] : []
    ];
    const tableRows = delegations?.map((delegation)=>({
            key: linkType === "validator" ? delegation.validator : delegation.delegator,
            data: [
                {
                    content: linkType === "validator" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorLink.ValidatorLink), {
                        address: delegation.validator,
                        alwaysTrim: true,
                        network: delegation.network
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: delegation,
                        address: delegation.delegator
                    }),
                    key: "delegator"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        value: delegation.amount
                    }),
                    key: "amount"
                },
                {
                    align: (0, _table.TableCellAlign).Right,
                    content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        compactLargeNumbers: true,
                        value: delegation.shares
                    }),
                    key: "shares"
                },
                ...debonding ? [
                    {
                        align: (0, _table.TableCellAlign).Right,
                        // TODO: Add when API returns correct value and provides current epoch
                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        }),
                        key: "debondingEnd"
                    }
                ] : []
            ]
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        columns: tableColumns,
        rows: tableRows,
        rowsNumber: limit,
        name: debonding ? t("validator.undelegations") : t("validator.delegators"),
        isLoading: isLoading,
        pagination: pagination
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../Table":"j3qb1","../RoundedBalance":"af34T","../Validators/ValidatorLink":"18CFQ","../Account/AccountLink":"43Jgs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"34BOw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegatorsCard", ()=>DelegatorsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _delegations = require("../../components/Delegations");
var _tabAnchors = require("./tabAnchors");
const DelegatorsCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const delegationsQuery = (0, _api.useGetConsensusAccountsAddressDelegationsTo)(network, address, {
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset
    });
    const { isFetched, isLoading, data } = delegationsQuery;
    const delegations = data?.data.delegations;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: (0, _tabAnchors.delegatorsContainerId),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("validator.delegators")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DelegatorsCardView, {
                        delegations: delegations,
                        isFetched: isFetched,
                        isLoading: isLoading,
                        pagination: {
                            ...pagination,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            totalCount: data?.data.total_count
                        }
                    })
                })
            })
        ]
    });
};
const DelegatorsCardView = ({ delegations, isFetched, isLoading, pagination })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !delegations?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("validator.emptyDelegationsList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _delegations.Delegations), {
                delegations: delegations,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: {
                    selectedPage: pagination.selectedPage,
                    linkToPage: pagination.linkToPage,
                    totalCount: pagination.totalCount,
                    isTotalCountClipped: pagination.isTotalCountClipped,
                    rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../../components/Table/useSearchParamsPagination":"jOnBC","../../components/Delegations":"6aJaP","./tabAnchors":"kXq1n","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"9G5XG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusBlocksPage", ()=>ConsensusBlocksPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _styles = require("@mui/material/styles");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _api = require("../../../oasis-nexus/api");
var _blocks = require("../../components/Blocks");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _consensusBlockDetailPage = require("../ConsensusBlockDetailPage");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _colors = require("../../../styles/theme/colors");
var _errors = require("../../../types/errors");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _consensusBlocks = require("../../components/Blocks/ConsensusBlocks");
const PAGE_SIZE = (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
const BlockDetails = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        flexDirection: "column",
        gap: `0 ${theme.spacing(2)}`,
        backgroundColor: (0, _colors.COLORS).brandDark
    }));
const ConsensusBlocksPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * PAGE_SIZE;
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const blocksQuery = (0, _api.useGetConsensusBlocks)(scope.network, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + PAGE_SIZE : PAGE_SIZE,
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    }, {
        query: {
            refetchInterval: (0, _config.REFETCH_INTERVAL),
            structuralSharing: (previousState, nextState)=>{
                const oldBlockIds = new Set(previousState?.data.blocks.map((block)=>block.height));
                return {
                    ...nextState,
                    data: {
                        ...nextState.data,
                        blocks: nextState.data.blocks.map((block)=>{
                            return {
                                ...block,
                                markAsNew: previousState ? !oldBlockIds.has(block.height) : false
                            };
                        })
                    }
                };
            },
            // Keep showing data while loading more
            keepPreviousData: tableView === (0, _tableLayoutButton.TableLayout).Vertical
        }
    });
    const { isLoading, isFetched, data } = blocksQuery;
    const blocks = data?.data.blocks;
    if (isFetched && offset && !blocks?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: t("blocks.title"),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusBlocks.ConsensusBlocks), {
                        isLoading: isLoading,
                        blocks: blocks,
                        limit: PAGE_SIZE,
                        type: (0, _blocks.BlocksTableType).Desktop,
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        }
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(BlockDetails, {
                        children: [
                            isLoading && [
                                ...Array(PAGE_SIZE).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusBlockDetailPage.ConsensusBlockDetailView), {
                                    isLoading: true,
                                    block: undefined,
                                    standalone: true
                                }, key)),
                            !isLoading && data?.data.blocks.map((block)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusBlockDetailPage.ConsensusBlockDetailView), {
                                    block: block,
                                    standalone: true
                                }, block.hash))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","@mui/material/styles":"51PGx","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../../oasis-nexus/api":"dJrPU","../../components/Blocks":"4KkfE","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../ConsensusBlockDetailPage":"4XeL7","@mui/material/Box":"4d7LG","../../../styles/theme/colors":"hYvW2","../../../types/errors":"gdpNU","../../components/TableLayoutButton":"5tkdC","../../components/LoadMoreButton":"aeVDT","../../hooks/useScopeParam":"kKMKx","../../components/Blocks/ConsensusBlocks":"1ZpvN","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"4XeL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusBlockDetailView", ()=>ConsensusBlockDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _useScreensize = require("../../hooks/useScreensize");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _skeleton = require("../../components/Skeleton");
var _useFormattedTimestamp = require("../../hooks/useFormattedTimestamp");
var _blockLink = require("../../components/Blocks/BlockLink");
var _dashboardLink = require("../ParatimeDashboardPage/DashboardLink");
const ConsensusBlockDetailView = ({ isLoading, block, showLayer, standalone = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const formattedTime = (0, _useFormattedTimestamp.useFormattedTimestampStringWithDistance)(block?.timestamp);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 7
    });
    if (!block) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const transactionLabel = block.num_transactions.toLocaleString();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "100px" : "200px",
        standalone: standalone,
        highlight: block.markAsNew,
        children: [
            showLayer && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.paratime")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardLink.DashboardLink), {
                            scope: block
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.height")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                        scope: block,
                        height: block.height
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: block.height.toString()
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.hash")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockHashLink), {
                        scope: block,
                        hash: block.hash,
                        height: block.height
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: block.hash.toString()
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.timestamp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: formattedTime
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.transactions")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: transactionLabel
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","../../hooks/useScreensize":"2HEhN","../../components/StyledDescriptionList":"bndrS","../../components/CopyToClipboard":"iTQvM","../../components/Skeleton":"eB5vc","../../hooks/useFormattedTimestamp":"kCD95","../../components/Blocks/BlockLink":"g8oEe","../ParatimeDashboardPage/DashboardLink":"k1EO2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"ffiOi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusAccountsPage", ()=>ConsensusAccountsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _errors = require("../../../types/errors");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _cardHeaderWithCounter = require("../../components/CardHeaderWithCounter");
var _verticalList = require("../../components/VerticalList");
var _accountList = require("app/components/AccountList");
var _consensusAccountDetailsPage = require("../ConsensusAccountDetailsPage");
const ConsensusAccountsPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const { t } = (0, _reactI18Next.useTranslation)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { network } = scope;
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const accountsQuery = (0, _api.useGetConsensusAccounts)(network, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE) : (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    });
    const { isLoading, isFetched, data } = accountsQuery;
    const accountsData = data?.data;
    if (isFetched && offset && !accountsData?.accounts?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderWithCounter.CardHeaderWithCounter), {
                    changeMobileColors: true,
                    label: t("account.listTitle"),
                    totalCount: accountsData?.total_count,
                    isTotalCountClipped: accountsData?.is_total_count_clipped
                }),
                mainTitle: true,
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountList.AccountList), {
                        accounts: accountsData?.accounts,
                        isLoading: isLoading,
                        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: accountsData?.total_count,
                            isTotalCountClipped: accountsData?.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        },
                        verbose: true
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array((0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountDetailsPage.ConsensusAccountDetailsView), {
                                    isLoading: true,
                                    account: undefined,
                                    standalone: true
                                }, key)),
                            !isLoading && accountsData?.accounts.map((account)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountDetailsPage.ConsensusAccountDetailsView), {
                                    account: account,
                                    standalone: true
                                }, account.address))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../../../types/errors":"gdpNU","../../components/TableLayoutButton":"5tkdC","../../components/LoadMoreButton":"aeVDT","../../hooks/useScopeParam":"kKMKx","../../components/CardHeaderWithCounter":"82LaW","../../components/VerticalList":"gcFw0","app/components/AccountList":"8TblH","../ConsensusAccountDetailsPage":"40iiU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"40iiU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusAccountDetailsPage", ()=>ConsensusAccountDetailsPage);
parcelHelpers.export(exports, "ConsensusAccountDetailsView", ()=>ConsensusAccountDetailsView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _api = require("../../../oasis-nexus/api");
var _useScreensize = require("../../hooks/useScreensize");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _pageLayout = require("../../components/PageLayout");
var _skeleton = require("../../components/Skeleton");
var _accountSizeBadge = require("../../components/AccountSizeBadge");
var _accountLink = require("../../components/Account/AccountLink");
var _roundedBalance = require("../..//components/RoundedBalance");
var _useScopeParam = require("../../hooks/useScopeParam");
var _consensusAccountDetailsCard = require("./ConsensusAccountDetailsCard");
var _routerTabs = require("../../components/RouterTabs");
var _balanceDistribution = require("./BalanceDistribution");
var _staking = require("./Staking");
const ConsensusAccountDetailsPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { network } = scope;
    const { address } = (0, _reactRouterDom.useLoaderData)();
    const accountQuery = (0, _api.useGetConsensusAccountsAddress)(network, address);
    const { isError, isLoading, data } = accountQuery;
    const account = data?.data;
    const transactionsLink = (0, _reactRouterDom.useHref)("");
    const context = {
        scope,
        address
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountDetailsCard.ConsensusAccountDetailsCard), {
                account: account,
                isError: isError,
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                container: true,
                spacing: 4,
                sx: {
                    mb: isMobile ? 4 : 5
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _balanceDistribution.BalanceDistribution), {
                            account: account,
                            isLoading: isLoading
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _staking.Staking), {
                            account: account,
                            isLoading: isLoading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routerTabs.RouterTabs), {
                tabs: [
                    {
                        label: t("common.transactions"),
                        to: transactionsLink
                    }
                ],
                context: context
            })
        ]
    });
};
const ConsensusAccountDetailsView = ({ account, isLoading, standalone = false })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 10
    });
    if (!account) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "160px" : "200px",
        standalone: standalone,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.size")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountSizeBadge.AccountSizeBadge), {
                    size: account.size
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.address")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: account,
                        address: account.address
                    }),
                    ","
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("account.birth")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("account.available")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                    value: account.available,
                    ticker: account.ticker
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.staked")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("account.debonding")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: t("account.totalBalance")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                        value: account.total,
                        ticker: account.ticker
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","react-router-dom":"5o0mA","@mui/material/Grid":"bu56N","../../../oasis-nexus/api":"dJrPU","../../hooks/useScreensize":"2HEhN","../../components/StyledDescriptionList":"bndrS","../../components/PageLayout":"24SOU","../../components/Skeleton":"eB5vc","../../components/AccountSizeBadge":"4vuKT","../../components/Account/AccountLink":"43Jgs","../..//components/RoundedBalance":"af34T","../../hooks/useScopeParam":"kKMKx","./ConsensusAccountDetailsCard":"fTlBx","../../components/RouterTabs":"dUetQ","./BalanceDistribution":"dOe1x","./Staking":"eqrMW","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"fTlBx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListTitle", ()=>StyledListTitle);
parcelHelpers.export(exports, "ConsensusAccountDetailsCard", ()=>ConsensusAccountDetailsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _styles = require("@mui/material/styles");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _getPreciseNumberFormat = require("../../../locales/getPreciseNumberFormat");
var _useScreensize = require("../../hooks/useScreensize");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _accountLink = require("../../components/Account/AccountLink");
var _accountSizeBadge = require("../../components/AccountSizeBadge");
var _skeleton = require("../../components/Skeleton");
var _subPageCard = require("../../components/SubPageCard");
var _copyToClipboard = require("../../components/CopyToClipboard");
var _accountAvatar = require("../../components/AccountAvatar");
var _cardEmptyState = require("../../components/CardEmptyState");
const StyledListTitle = (0, _styles.styled)("dt")(({ theme })=>({
        marginLeft: theme.spacing(4)
    }));
const ConsensusAccountDetailsCard = ({ account, isError, isLoading })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
        featured: true,
        isLoadingTitle: isLoading,
        title: t("account.title"),
        mainTitle: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsensusAccountDetails, {
            isError: isError,
            isLoading: isLoading,
            account: account
        })
    });
};
const ConsensusAccountDetails = ({ account, isError, isLoading })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: 7
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
        label: t("account.cantLoadDetails")
    });
    if (!account) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "160px" : "200px",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledDescriptionList.StyledListTitleWithAvatar), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    gap: 1,
                    sx: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountAvatar.AccountAvatar), {
                            account: account
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountSizeBadge.AccountSizeBadge), {
                            size: account.size
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                        scope: account,
                        address: account.address
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: account.address
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: t("account.totalBalance")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: t("common.valueInToken", {
                        ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.total),
                        ticker: account.ticker
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledListTitle, {
                children: t("account.available")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: t("common.valueInToken", {
                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.available),
                    ticker: account.ticker
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledListTitle, {
                children: t("common.staking")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: t("common.valueInToken", {
                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.delegations_balance),
                    ticker: account.ticker
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledListTitle, {
                children: t("account.debonding")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: t("common.valueInToken", {
                    ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.debonding_delegations_balance),
                    ticker: account.ticker
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("account.lastNonce")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: account.nonce
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("account.birth")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "-"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/styles":"51PGx","react-i18next":"e210a","@mui/material/Box":"4d7LG","../../../locales/getPreciseNumberFormat":"gj0Jj","../../hooks/useScreensize":"2HEhN","../../components/StyledDescriptionList":"bndrS","../../components/Account/AccountLink":"43Jgs","../../components/AccountSizeBadge":"4vuKT","../../components/Skeleton":"eB5vc","../../components/SubPageCard":"dvWuD","../../components/CopyToClipboard":"iTQvM","../../components/AccountAvatar":"aC04Z","../../components/CardEmptyState":"aiX1q","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dOe1x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BalanceDistribution", ()=>BalanceDistribution);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _pieChart = require("../../components/charts/PieChart");
var _useScreensize = require("../../hooks/useScreensize");
var _getPreciseNumberFormat = require("locales/getPreciseNumberFormat");
var _colors = require("../../../styles/theme/colors");
var _consensusAccountCardEmptyState = require("./ConsensusAccountCardEmptyState");
const BalanceDistribution = ({ account, isLoading })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                disableTypography: true,
                component: "h3",
                title: t("account.balanceDistribution")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardContentDefault.default), {
                children: [
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                        variant: "rectangular",
                        height: 300
                    }),
                    account && /*#__PURE__*/ (0, _jsxRuntime.jsx)(BalanceDistributionContent, {
                        account: account
                    })
                ]
            })
        ]
    });
};
const BalanceDistributionContent = ({ account })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const totalValue = t("common.valueInToken", {
        ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(account.total),
        ticker: account.ticker
    });
    if (account.total === "0") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountCardEmptyState.ConsensusAccountCardEmptyState), {
        label: t("account.noBalances")
    });
    const data = [
        {
            label: t("account.available"),
            value: Number(account.available)
        },
        {
            label: t("common.staking"),
            value: Number(account.delegations_balance)
        },
        {
            label: t("account.debonding"),
            value: Number(account.debonding_delegations_balance)
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    fontSize: isMobile ? "14px" : "24px",
                    fontWeight: isMobile ? 500 : 700,
                    color: (0, _colors.COLORS).brandDark,
                    mb: 3
                },
                children: t("account.totalValue", {
                    value: totalValue
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                sx: {
                    height: "250px"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pieChart.PieChart), {
                    compact: false,
                    data: data,
                    dataKey: "value",
                    formatters: {
                        data: (value)=>t("common.valueInToken", {
                                ...(0, _getPreciseNumberFormat.getPreciseNumberFormat)(value.toString()),
                                ticker: account.ticker
                            }),
                        label: (label)=>label
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Box":"4d7LG","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Skeleton":"i7d9z","@mui/material/Typography":"f5srd","../../components/charts/PieChart":"7mkAk","../../hooks/useScreensize":"2HEhN","locales/getPreciseNumberFormat":"gj0Jj","../../../styles/theme/colors":"hYvW2","./ConsensusAccountCardEmptyState":"hzdyU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hzdyU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusAccountCardEmptyState", ()=>ConsensusAccountCardEmptyState);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styles = require("@mui/material/styles");
var _stackedBarChart = require("@mui/icons-material/StackedBarChart");
var _stackedBarChartDefault = parcelHelpers.interopDefault(_stackedBarChart);
var _colors = require("../../../styles/theme/colors");
const StyledBox = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            minHeight: "150px",
            paddingTop: theme.spacing(3)
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: "200px",
            paddingTop: theme.spacing(6)
        }
    }));
const ConsensusAccountCardEmptyState = ({ children, label })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
        gap: 3,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackedBarChartDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).grayMedium,
                    fontSize: 40,
                    opacity: 0.5
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                sx: {
                    color: (0, _colors.COLORS).grayMedium,
                    fontWeight: 700,
                    maxWidth: "170px",
                    textAlign: "center",
                    opacity: 0.5
                },
                children: label
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"g88cO","@mui/material/Box":"4d7LG","@mui/material/Typography":"f5srd","@mui/material/styles":"51PGx","@mui/icons-material/StackedBarChart":"6rG0K","../../../styles/theme/colors":"hYvW2","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"6rG0K":[function(require,module,exports) {
"use strict";
"use client";
var _interopRequireDefault = require("82ab80c18ca431b6");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6d5564b35ae4124e"));
var _jsxRuntime = require("cdde783ca9d95dfc");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M4 9h4v11H4zm0-5h4v4H4zm6 3h4v4h-4zm6 3h4v4h-4zm0 5h4v5h-4zm-6-3h4v8h-4z"
}), "StackedBarChart");

},{"82ab80c18ca431b6":"hykHy","6d5564b35ae4124e":"gQLSP","cdde783ca9d95dfc":"g88cO"}],"eqrMW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Staking", ()=>Staking);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _link = require("@mui/material/Link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _colors = require("../../../styles/theme/colors");
var _api = require("../../../oasis-nexus/api");
var _useScopeParam = require("../../../app/hooks/useScopeParam");
var _errors = require("../../../types/errors");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _delegations = require("../..//components/Delegations");
var _externalLinks = require("../../utils/externalLinks");
var _i18Next = require("i18next");
var _consensusAccountCardEmptyState = require("./ConsensusAccountCardEmptyState");
const Staking = ({ account, isLoading })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        sx: {
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                action: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
                    href: (0, _externalLinks.docs).consensusStaking,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    sx: {
                        color: (0, _colors.COLORS).brandDark
                    },
                    children: t("validator.sharesDocs")
                }),
                disableTypography: true,
                component: "h3",
                title: t("common.staking")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardContentDefault.default), {
                children: [
                    isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                        variant: "rectangular",
                        height: 300
                    }),
                    account && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StakingContent, {
                        address: account?.address
                    })
                ]
            })
        ]
    });
};
const StakingContent = ({ address })=>{
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD);
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const { network } = scope;
    const delegationsQuery = (0, _api.useGetConsensusAccountsAddressDelegations)(network, address);
    const { isLoading, isFetched, data } = delegationsQuery;
    if (isFetched && offset && !delegationsQuery.data?.data?.delegations?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    if (isFetched && !delegationsQuery.data?.data.delegations.length) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusAccountCardEmptyState.ConsensusAccountCardEmptyState), {
        label: (0, _i18Next.t)("account.notStaking"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkDefault.default), {
            href: (0, _externalLinks.wallet).homepage,
            rel: "noopener noreferrer",
            target: "_blank",
            children: (0, _i18Next.t)("account.startStaking")
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: isFetched && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _delegations.Delegations), {
            delegations: delegationsQuery.data?.data.delegations,
            isLoading: isLoading,
            limit: (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD),
            linkType: "validator",
            pagination: {
                selectedPage: pagination.selectedPage,
                linkToPage: pagination.linkToPage,
                totalCount: data?.data.total_count,
                isTotalCountClipped: data?.data.is_total_count_clipped,
                rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_DASHBOARD)
            }
        })
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","@mui/material/Link":"fTbCF","@mui/material/Skeleton":"i7d9z","../../../styles/theme/colors":"hYvW2","../../../oasis-nexus/api":"dJrPU","../../../app/hooks/useScopeParam":"kKMKx","../../../types/errors":"gdpNU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../..//components/Delegations":"6aJaP","../../utils/externalLinks":"d3W8q","i18next":"2hToL","./ConsensusAccountCardEmptyState":"hzdyU","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"2hToL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeLanguage", ()=>changeLanguage);
parcelHelpers.export(exports, "createInstance", ()=>createInstance);
parcelHelpers.export(exports, "default", ()=>instance);
parcelHelpers.export(exports, "dir", ()=>dir);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "getFixedT", ()=>getFixedT);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadResources", ()=>loadResources);
parcelHelpers.export(exports, "reloadResources", ()=>reloadResources);
parcelHelpers.export(exports, "setDefaultNamespace", ()=>setDefaultNamespace);
parcelHelpers.export(exports, "t", ()=>t);
parcelHelpers.export(exports, "use", ()=>use);
const consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new Logger(this.logger, options);
    }
}
var baseLogger = new Logger();
class EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
const lastOfPathSeparatorRegExp = /###/g;
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(lastOfPathSeparatorRegExp, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
}
function setPath(object, path, newValue) {
    const { obj, k } = getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
}
function pushPath(object, path, newValue, concat) {
    const { obj, k } = getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    const { obj, k } = getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    const value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>_entityMap[s]);
    return data;
}
class RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
}
function getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class ResourceStore extends EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === "string" && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const checkedLoadedFor = {};
class Translator extends EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key,
                namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key,
            namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key, namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey,
            exactUsedKey,
            usedLng,
            usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let _rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const intlVersions = [
    "v4"
];
const suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    const rules = {};
    sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules(getCleanedCode(code === "dev" ? "en" : code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName,
        formatOptions
    };
}
function createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn(getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName, formatOptions } = parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class Connector extends EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            pushPath(q.loaded, [
                lng
            ], ns);
            removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng,
                ns,
                fcName,
                tried,
                wait,
                callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function noop() {}
function bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class I18n extends EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = transformOptions(options);
        this.services = {};
        this.logger = baseLogger;
        this.modules = {
            external: []
        };
        bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = Formatter;
            const lu = new LanguageUtil(this.options);
            this.store = new ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
const createInstance = instance.createInstance;
const dir = instance.dir;
const init = instance.init;
const loadResources = instance.loadResources;
const reloadResources = instance.reloadResources;
const use = instance.use;
const changeLanguage = instance.changeLanguage;
const getFixedT = instance.getFixedT;
const t = instance.t;
const exists = instance.exists;
const setDefaultNamespace = instance.setDefaultNamespace;
const hasLoadedNamespace = instance.hasLoadedNamespace;
const loadNamespaces = instance.loadNamespaces;
const loadLanguages = instance.loadLanguages;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"7Ptsx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusTransactionsPage", ()=>ConsensusTransactionsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _useScreensize = require("../../hooks/useScreensize");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _transactions = require("../../components/Transactions");
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
var _errors = require("../../../types/errors");
var _loadMoreButton = require("../../components/LoadMoreButton");
var _tableLayoutButton = require("../../components/TableLayoutButton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _verticalList = require("../../components/VerticalList");
var _consensusTransactionDetailPage = require("../ConsensusTransactionDetailPage");
const ConsensusTransactionsPage = ()=>{
    const [tableView, setTableView] = (0, _react.useState)((0, _tableLayoutButton.TableLayout).Horizontal);
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    (0, _react.useEffect)(()=>{
        if (!isMobile) setTableView((0, _tableLayoutButton.TableLayout).Horizontal);
    }, [
        isMobile,
        setTableView
    ]);
    const transactionsQuery = (0, _api.useGetConsensusTransactions)(scope.network, {
        limit: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? offset + (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE) : (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset: tableView === (0, _tableLayoutButton.TableLayout).Vertical ? 0 : offset
    }, {
        query: {
            refetchInterval: (0, _config.REFETCH_INTERVAL),
            structuralSharing: (previousState, nextState)=>{
                const oldTxHashes = new Set(previousState?.data.transactions.map((tx)=>tx.hash));
                return {
                    ...nextState,
                    data: {
                        ...nextState.data,
                        transactions: nextState.data.transactions.map((tx)=>{
                            return {
                                ...tx,
                                markAsNew: previousState ? !oldTxHashes.has(tx.hash) : false
                            };
                        })
                    }
                };
            },
            keepPreviousData: tableView === (0, _tableLayoutButton.TableLayout).Vertical
        }
    });
    const { isLoading, isFetched, data } = transactionsQuery;
    const transactions = data?.data.transactions;
    if (isFetched && pagination.selectedPage > 1 && !transactions?.length) throw (0, _errors.AppErrors).PageDoesNotExist;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pageLayout.PageLayout), {
        mobileFooterAction: tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadMoreButton.LoadMoreButton), {
            pagination: pagination,
            isLoading: isLoading
        }),
        children: [
            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {
                variant: "layout"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _subPageCard.SubPageCard), {
                title: t("transactions.latest"),
                action: isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableLayoutButton.TableLayoutButton), {
                    tableView: tableView,
                    setTableView: setTableView
                }),
                noPadding: tableView === (0, _tableLayoutButton.TableLayout).Vertical,
                mainTitle: true,
                children: [
                    tableView === (0, _tableLayoutButton.TableLayout).Horizontal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.ConsensusTransactions), {
                        transactions: data?.data.transactions,
                        isLoading: isLoading,
                        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                        pagination: {
                            selectedPage: pagination.selectedPage,
                            linkToPage: pagination.linkToPage,
                            totalCount: data?.data.total_count,
                            isTotalCountClipped: data?.data.is_total_count_clipped,
                            rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                        }
                    }),
                    tableView === (0, _tableLayoutButton.TableLayout).Vertical && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _verticalList.VerticalList), {
                        children: [
                            isLoading && [
                                ...Array((0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)).keys()
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionDetailPage.ConsensusTransactionDetailView), {
                                    isLoading: true,
                                    transaction: undefined
                                }, key)),
                            !isLoading && transactions?.map((transaction)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionDetailPage.ConsensusTransactionDetailView), {
                                    transaction: transaction
                                }, transaction.hash))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react":"BK2ob","react-i18next":"e210a","@mui/material/Divider":"3hI6U","../../hooks/useScreensize":"2HEhN","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../components/Transactions":"k0qMF","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Table/useSearchParamsPagination":"jOnBC","../../../types/errors":"gdpNU","../../components/LoadMoreButton":"aeVDT","../../components/TableLayoutButton":"5tkdC","../../hooks/useScopeParam":"kKMKx","../../components/VerticalList":"gcFw0","../ConsensusTransactionDetailPage":"hd24o","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"hd24o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusTransactionDetailPage", ()=>ConsensusTransactionDetailPage);
parcelHelpers.export(exports, "ConsensusTransactionDetailView", ()=>ConsensusTransactionDetailView);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
var _styles = require("@mui/material/styles");
var _api = require("../../../oasis-nexus/api");
var _styledDescriptionList = require("../../components/StyledDescriptionList");
var _pageLayout = require("../../components/PageLayout");
var _subPageCard = require("../../components/SubPageCard");
var _useScreensize = require("../../hooks/useScreensize");
var _errors = require("../../../types/errors");
var _skeleton = require("../../components/Skeleton");
var _useScopeParam = require("../../hooks/useScopeParam");
var _transactionLink = require("app/components/Transactions/TransactionLink");
var _copyToClipboard = require("app/components/CopyToClipboard");
var _statusIcon = require("app/components/StatusIcon");
var _blockLink = require("app/components/Blocks/BlockLink");
var _consensusTransactionMethod = require("app/components/ConsensusTransactionMethod");
var _useFormattedTimestamp = require("app/hooks/useFormattedTimestamp");
var _roundedBalance = require("app/components/RoundedBalance");
var _accountLink = require("app/components/Account/AccountLink");
const StyledDescriptionDetails = (0, _styles.styled)("dd")({
    "&&": {
        padding: 0
    }
});
const ConsensusTransactionDetailPage = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const scope = (0, _useScopeParam.useRequiredScopeParam)();
    const hash = (0, _reactRouterDom.useParams)().hash;
    const { isLoading, data } = (0, _api.useGetConsensusTransactionsTxHash)(scope.network, hash);
    const transaction = data?.data;
    if (!transaction && !isLoading) throw (0, _errors.AppErrors).NotFoundTxHash;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageLayout.PageLayout), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subPageCard.SubPageCard), {
            featured: true,
            title: t("transaction.header"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsensusTransactionDetailView, {
                isLoading: isLoading,
                transaction: transaction
            })
        })
    });
};
const ConsensusTransactionDetailView = ({ detailsPage, isLoading, transaction })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isMobile } = (0, _useScreensize.useScreenSize)();
    const formattedTimestamp = (0, _useFormattedTimestamp.useFormattedTimestampStringWithDistance)(transaction?.timestamp);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.TextSkeleton), {
        numberOfRows: detailsPage ? 13 : 7
    });
    if (!transaction) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styledDescriptionList.StyledDescriptionList), {
        titleWidth: isMobile ? "100px" : "200px",
        standalone: !detailsPage,
        highlight: transaction.markAsNew,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.hash")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionLink.TransactionLink), {
                        scope: transaction,
                        hash: transaction.hash
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyToClipboard.CopyToClipboard), {
                        value: transaction.hash
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.status")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                style: {
                    flexWrap: "wrap",
                    gap: "10px"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcon.StatusIcon), {
                    success: transaction.success,
                    error: transaction.error,
                    withText: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.type")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDescriptionDetails, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _consensusTransactionMethod.ConsensusTransactionMethod), {
                    method: transaction.method
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.timestamp")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: formattedTimestamp
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.height")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blockLink.BlockLink), {
                    scope: transaction,
                    height: transaction.block
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.from")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountLink.AccountLink), {
                    scope: transaction,
                    address: transaction.sender
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.to")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                children: t("common.value")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: "-"
                })
            }),
            detailsPage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("currentFiatValue.title")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.transactionFee")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _roundedBalance.RoundedBalance), {
                            value: transaction.fee,
                            ticker: transaction.ticker
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.gasUsed")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: t("common.nonce")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: transaction.nonce.toLocaleString()
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-router-dom":"5o0mA","react-i18next":"e210a","@mui/material/styles":"51PGx","../../../oasis-nexus/api":"dJrPU","../../components/StyledDescriptionList":"bndrS","../../components/PageLayout":"24SOU","../../components/SubPageCard":"dvWuD","../../hooks/useScreensize":"2HEhN","../../../types/errors":"gdpNU","../../components/Skeleton":"eB5vc","../../hooks/useScopeParam":"kKMKx","app/components/Transactions/TransactionLink":"eIjbt","app/components/CopyToClipboard":"iTQvM","app/components/StatusIcon":"3VOhR","app/components/Blocks/BlockLink":"g8oEe","app/components/ConsensusTransactionMethod":"2QV5X","app/hooks/useFormattedTimestamp":"kCD95","app/components/RoundedBalance":"af34T","app/components/Account/AccountLink":"43Jgs","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"bb6KB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConsensusAccountDetailsProps", ()=>useConsensusAccountDetailsProps);
var _reactRouterDom = require("react-router-dom");
const useConsensusAccountDetailsProps = ()=>(0, _reactRouterDom.useOutletContext)();

},{"react-router-dom":"5o0mA","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dgrrQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusAccountTransactionsCard", ()=>ConsensusAccountTransactionsCard);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardContent = require("@mui/material/CardContent");
var _cardContentDefault = parcelHelpers.interopDefault(_cardContent);
var _api = require("../../../oasis-nexus/api");
var _config = require("../../config");
var _transactions = require("../../components/Transactions");
var _errorBoundary = require("../../components/ErrorBoundary");
var _linkableDiv = require("../../components/PageLayout/LinkableDiv");
var _cardEmptyState = require("../../components/CardEmptyState");
var _useSearchParamsPagination = require("../../components/Table/useSearchParamsPagination");
const consensusAccountTransactionsContainerId = "transactions";
const ConsensusAccountTransactionsCard = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linkableDiv.LinkableDiv), {
                id: consensusAccountTransactionsContainerId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                    disableTypography: true,
                    component: "h3",
                    title: t("common.transactions")
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContentDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {
                    light: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsensusAccountTransactions, {
                        scope: scope,
                        address: address
                    })
                })
            })
        ]
    });
};
const ConsensusAccountTransactions = ({ scope, address })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { network } = scope;
    const pagination = (0, _useSearchParamsPagination.useSearchParamsPagination)("page");
    const offset = (pagination.selectedPage - 1) * (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE);
    const transactionsQuery = (0, _api.useGetConsensusTransactions)(network, {
        limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
        offset,
        rel: address
    });
    const { isFetched, isLoading, data } = transactionsQuery;
    const transactions = data?.data.transactions;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isFetched && !transactions?.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardEmptyState.CardEmptyState), {
                label: t("account.emptyTransactionList")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactions.ConsensusTransactions), {
                transactions: transactions,
                ownAddress: address,
                isLoading: isLoading,
                limit: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE),
                pagination: {
                    selectedPage: pagination.selectedPage,
                    linkToPage: pagination.linkToPage,
                    totalCount: data?.data.total_count,
                    isTotalCountClipped: data?.data.is_total_count_clipped,
                    rowsPerPage: (0, _config.NUMBER_OF_ITEMS_ON_SEPARATE_PAGE)
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"g88cO","react-i18next":"e210a","@mui/material/Card":"cTsx6","@mui/material/CardHeader":"dpqJL","@mui/material/CardContent":"kMUKY","../../../oasis-nexus/api":"dJrPU","../../config":"in6G4","../../components/Transactions":"k0qMF","../../components/ErrorBoundary":"246yY","../../components/PageLayout/LinkableDiv":"dLOUR","../../components/CardEmptyState":"aiX1q","../../components/Table/useSearchParamsPagination":"jOnBC","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"dwfBH":[function() {},{}],"2hqMu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "translationsJson", ()=>translationsJson);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _i18Next = require("i18next");
var _i18NextDefault = parcelHelpers.interopDefault(_i18Next);
var _reactI18Next = require("react-i18next");
var _translationJson = require("./en/translation.json");
var _translationJsonDefault = parcelHelpers.interopDefault(_translationJson);
const translationsJson = {
    en: {
        translation: (0, _translationJsonDefault.default)
    }
};
const i18n = (0, _i18NextDefault.default).use((0, _reactI18Next.initReactI18next)).init({
    resources: translationsJson,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    }
});

},{"i18next":"2hToL","react-i18next":"e210a","./en/translation.json":"h2ZVH","@parcel/transformer-js/src/esmodule-helpers.js":"lA3Ur"}],"h2ZVH":[function(require,module,exports) {
module.exports = JSON.parse('{"account":{"available":"Available","balanceDistribution":"Balance Distribution","birth":"Birth","cantLoadDetails":"Unfortunately we couldn\'t load the account details at this time. Please try again later.","debonding":"Debonding","emptyTokenList":"This account holds no {{spec}} {{description}}.","emptyTransactionList":"There are no transactions on record for this account.","emptyTokenTransferList":"There are no token transfers on record for this account.","failedToLookUpTickers":"We don\'t have the price for: {{tickers}}","ERC20":"ERC-20","ERC721":"ERC-721","lastNonce":"Last Nonce","listTitle":"Accounts","noTokens":"This account holds no tokens","noBalances":"This account currently has no balances.","notStaking":"This account is currently not staking.","showMore":"+ {{counter}} more","sizeTooltip":"This account is indicated as an {{size}} account based on sum of assets they own.","startStaking":"Start staking now","title":"Account","transactionsListTitle":"Account Transactions","totalBalance":"Total Balance","totalReceived":"Total Received","totalSent":"Total Sent","totalValue":"Total {{value}}"},"activeAccounts":{"title":"Active Accounts","tooltip":"{{value, number}} accounts"},"analyticsConsent":{"privacyPolicy":"Privacy Policy","settings":"Privacy settings","text":"At Oasis Foundation we believe in your privacy, so you can choose to browse our site without any tracking or by clicking \u201C{{acceptButtonLabel}}\u201D, you help us to improve our site and help us grow our ecosystem. View our <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink> for more information.","blockedText":"Our analytics tracking failed to load. Therefore, you will continue using the site with user tracking disabled. If you are willing to accept tracking please pause your adblocker and reload the page to accept tracking. View our <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink> for more information.","acceptButtonLabel":"Accept","declineButtonLabel":"Decline","reloadButtonLabel":"Reload page","closeButtonLabel":"Close"},"blocks":{"latest":"Latest Blocks","title":"Blocks","viewingFirst":"You are viewing the first block","viewingLatest":"You are viewing the latest block","viewNext":"View next block","viewPrevious":"View previous block"},"block":{"gasUsed":"{{value, number}} | {{percentage, number}}"},"banner":{"buildStaging":"Please note this is an internal launch meant to gather your feedback.","buildPreview":"Please note this is an experimental build of {{appTitle}} and that data that is shown might be incorrect."},"clipboard":{"label":"Copy to clipboard","success":"Copied!"},"coinGeckoReferral":"Data from <CoinGeckoLink>CoinGecko</CoinGeckoLink>","common":{"address":"Address","age":"Age","balance":"Balance","block":"Block","bytes":"{{value, number}}","cancel":"Cancel","collection":"Collection","consensusOnline":"Consensus Online","consensusOutOfDate":"Consensus out of date","copy":"Copy","data":"Data","emerald":"Emerald","cipher":"Cipher","consensus":"Consensus","eth":"ETH","events":"Events","failed":"Failed","fiatValue":"Fiat Value","fiatValueInUSD":"{{value, currency}}","fill":"Fill","formattedBlockTimestamp":"{{timestamp, dateTime}} ({{distance}})","formattedDateTime":"{{timestamp, dateTime}}","from":"From","gasUsed":"Gas Used","gasLimit":"Gas Limit","hash":"Hash","height":"Height","hide":"Hide","invalidVotes":"Invalid votes","loadMore":"Load more","lessThanAmount":"&lt; {{value, number}} <TickerLink />","method":"Method","missing":"n/a","name":"Name","network":"Network","nft":"NFT","nfts":"NFTs","nonce":"Nonce","not_defined":"Not defined","oasis":"Oasis","owned":"Owned","paratime":"Paratime","parentheses":"({{subject}})","percentage":"Percentage","pontusx":"Pontus-X","proposal":"Proposal","proposer":"Proposer","rank":"Rank","select":"Select","size":"Size","sapphire":"Sapphire","show":"Show","smartContract":"Smart Contract","smartContract_short":"Contract","staked":"Staked","staking":"Staking","submitter":"Submitter","success":"Success","status":"Status","ticker":"Ticker","timestamp":"Timestamp","title":"Title","to":"To","token":"Token","tokenInstance":"TokenID [<InstanceLink />] <TickerLink/>","tokens":"Tokens","totalVotes":"Total votes","transactions":"Transactions","transactionAbbreviation":"Txs","transactionFee":"Transaction Fee","transfers":"Transfers","type":"Type","quantity":"Quantity","unknown":"Unknown","value":"Value","valueLong":"{{value, number}}","valueInToken":"{{value, number}} {{ticker}}","roundedValueInToken":"{{value, number}}\u2026 <TickerLink />","valueInTokenWithLink":"{{value, number}} <TickerLink />","view":"View","viewAll":"View all","vote":"Vote","voter":"Voter","votes":"Votes","paraTimeOnline":"ParaTime Online","paraTimeOutOfDate":"ParaTime Out of date","mainnet":"Mainnet","testnet":"Testnet","valuePair":"{{value, number}}"},"contract":{"code":"Code","copyButton":"Copy {{subject}}","creationByteCode":"Creation ByteCode","creator":"Creator","createdAt":"at","noCode":"There is no bytecode on record for this account. (Are you sure this is a contract?)","title":"Contract","runtimeByteCode":"Runtime ByteCode","verification":{"title":"Verification","isVerified":"Verified","isNotVerified":"Unverified","openInSourcify":"Open in <SourcifyLink>Sourcify</SourcifyLink>","verifyInSourcify":"Verify through <SourcifyLink>Sourcify</SourcifyLink>","explainVerificationDelay":"If you have just verified a contract, it should take a few minutes to update here."}},"consensusSnapshot":{"blockHeight":"Block Height <BlockHeight />","title":"Consensus Snapshot","totalCirculation":"This is <StakedPercentage /> of the total circulation"},"currentEpoch":"Current Epoch","dapps":{"wrose":{"description":"Looking to wrap or unwrap your wROSE?","label":"Use our ROSE (un)wrapper"}},"networkProposal":{"close":"Closed","closeTooltip":"Voting ended on epoch shown.","create":"Created","createTooltip":"Voting created on epoch shown.","deposit":"Deposit","failedToLoadAllVotes":"Failed to load all the votes, number might be incomplete!","handler":"Title","id":"ID","listTitle":"Network Change Proposals","state":{"active":"Active","failed":"Failed","passed":"Passed","rejected":"Rejected"},"type":{"upgrade":"Upgrade","parameterUpgrade":"Parameter upgrade","cancellation":"Cancellation"},"vote":{"yes":"Yes","no":"No","abstain":"Abstained","all":"All votes"}},"nft":{"accountCollection":"ERC-721 Tokens","collectionLink":"Collection: <CollectionLink />","instanceIdLink":"ID: <InstanceLink />","instanceTokenId":"Token ID","instanceTitleSuffix":"(NFT Instance)","imagePreview":"Image preview","metadata":"Metadata","noMetadata":"There is no metadata on record for this NFT.","noPreview":"No preview available","openInFullscreen":"Open in fullscreen","openInNewTab":"Open in a new tab","owner":"Owner","ownerLink":"Owner: <OwnerLink />","switchBackgroundColor":"Switch between dark and light background"},"nodes":{"title":"Active nodes","unknown":"Consensus layer indexer is not caught up with the latest blocks. The number of active nodes is unknown.","tooltip":"Blockchain nodes are authorized devices that track the distributed ledger and serve as communication hubs in the network.","value":"{{value, number}}"},"errors":{"code":"error code","module":"module","error":"Error","loadFirstPage":"load the first page","unknown":"Unknown error","unsupportedLayer":"Unsupported layer","unsupportedNetwork":"Unsupported network","invalidAddress":"Invalid address","invalidBlockHeight":"Invalid block height","invalidPageNumber":"Invalid page number","invalidProposalId":"Invalid proposal ID","invalidTxHash":"Invalid transaction hash","notFoundBlockHeight":"Block not found","notFoundTx":"Transaction not found","notFoundProposal":"Proposal not found","pageDoesNotExist":"The page you are looking for does not exist.","validateURL":"Please validate provided URL","validateURLOrGoToFirstPage":"Please check the URL or <FirstPageLink />.","invalidUrl":"Invalid URL","invalidVote":"Invalid vote","revertedWithoutMessage":"reverted without a message","storage":"Access to browser storage denied"},"footer":{"mobileTitle":"OPF","title":"Oasis Protocol Foundation","version":"Version: <ReleaseLink>{{version}}</ReleaseLink> (commit: <CommitLink>{{sha}}</CommitLink>) built at {{buildTime}}","apiDocs":"API Documentation","github":"GitHub"},"learningMaterials":{"consensus":{"header":"What is the Consensus layer?","description":"Oasis Core is designed around the principle of modularity. The consensus layer is an interface that provides a number of important services to other parts of Oasis Core.","transactions":"How do transactions work?","transactionsDescription":"The consensus layer uses a common transaction...","services":"What services are required?","servicesDescription":"Each consensus backend needs to provide the following...","genesis":"Genesis Document","genesisDescription":"The genesis document contains a set of parameters that outline the initial state of the\xa0consensus layer\xa0and its services. For more details about the actual genesis document\'s API, see\xa0genesis API documentation.","vectors":"Transaction Test Vectors","vectorsDescription":"In order to test transaction generation, parsing...","comet":"CometBFT","cometDescription":"The CometBFT consensus backend lives in ..."},"emerald":{"header":"What is the Emerald network?","description":"The Emerald ParaTime is our official EVM Compatible ParaTime providing smart contract environment with full EVM compatibility.","gateway":"Web3 Gateway","gatewayDescription":"To get started building on our Emerald ParaTime, you can use our public Web3 gateway, fully compatible with Ethereum\'s Web3 gateway."},"sapphire":{"header":"What is the Sapphire network?","description":"The Sapphire ParaTime is our official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."},"header":"Learning materials","hardhat":{"header":"Add the {{ layer }} Testnet to Hardhat","description":"Open up your hardhat.config.ts and drop in these lines."},"pontusx":{"1":{"header":"What is the Pontus-X Network?","description":"The Pontus-X Network is our official confidential EVM Compatible ParaTime offering a smart contract development environment that is compatible with the Ethereum Virtual Machine (EVM) focused on building a Federated Data Economy."},"2":{"header":"Testnet Parameters","description":"The Testnet for Pontus-X may undergo frequent version upgrades."},"3":{"header":"Adding the Pontus-X Testnet to Hardhat","description":"To integrate with Pontus-X, open your hardhat.config.ts file and insert the following configurations."}},"token":{"header":"Token Metrics and Distribution","description":"Rose is the currency powering the Oasis network."},"testnet":{"header":"Testnet parameters","description":"The Testnet may be subject to frequent version upgrades."},"transfer":{"header":"How to Transfer ROSE into a ParaTime?","description":"Rose is the currency powering the {{layer}} network."}},"pageHeader":{"ribbon":"You are viewing {{network}} data"},"pagination":{"first":"First","last":"Last"},"social":{"description":"Be part of the community and stay in the loop on everything Oasis","discord":"Discord","header":"Join us","reddit":"Reddit","telegram":"Telegram","twitter":"X","youtube":"Youtube","linkedin":"LinkedIn","docs":"Documentation","home":"Home"},"tableLayoutButton":{"changeView":"Change view"},"testnetFaucet":{"description":"Drops are limited to 10 TEST tokens","header":"Oasis Testnet Faucet","request":"Request test tokens"},"tokens":{"typeDescription":"{{description}} ({{spec}})","emptyInventory":"Token has no inventory associated with it.","emptyTokenHolderList":"There are no holders on record for this token.","holders":"Holders","holdersValue":"{{ value, number }}","holdersCount":"Holders Count","inventory":"Inventory","totalSupply":"Total Supply","totalSupplyValue":"{{ value, number }} {{ticker}}","transferEventType":{"transfer":"Transfer","approval":"Approval","minting":"Minting","burning":"Burning","unavailable":"Unknown token transfer event"},"type":"Token Type"},"tokenSnapshot":{"header":"Token Snapshot"},"tokenPrice":{"header":"{{ticker}} Price"},"totalTransactions":{"header":"Total Transactions","tooltip":"{{value, number}} total transactions"},"transactions":{"encryption":{"dataNonce":"Data Nonce","encryptedData":"Data (encrypted)","encryptedResult":"Result (encrypted)","format":"Format","plain":"Plain","publicKey":"Public Key","resultNonce":"Result Nonce"},"latest":"Latest Transactions","method":{"stakingTransfer":"Transfer","stakingAddEscrow":"Start delegate","stakingReclaimEscrow":"Start undelegate","stakingAmendCommissionSchedule":"Amend commission schedule","stakingAllow":"Set delegate allowance","stakingWithdraw":"Continued delegate","roothashExecutorCommit":"Executor commit","roothashExecutorProposerTimeout":"Executor proposer timeout","registryRegisterEntity":"Register entity","registryRegisterNode":"Register node","registryRegisterRuntime":"Register runtime","governanceCastVote":"Cast vote","governanceSubmitProposal":"Submit proposal","beaconPVSSCommit":"PVSSCommit","beaconPVSSReveal":"PVSSReveal","beaconVRFProve":"VRFProve","unavailable":"Malformed transaction, method unavailable","accounts":{"transfer":"Transfer"},"consensus":{"deposit":"Consensus Deposit","delegate":"Consensus Delegate","undelegate":"Consensus Undelegate","withdraw":"Consensus Withdraw"},"evm":{"call":"Contract Call","create":"Contract Creation"}}},"transaction":{"header":"Transaction","warningMultipleTransactionsSameHash":"Please make sure you\'re looking at the right transaction. There is more than one transaction with this hash, which is extremely rare. We are showing the most recent successful one.","rawData":"Raw Data","tooltips":{"txTooltipEth":"Ethereum hash for the transaction","senderTooltipEth":"Ethereum address for the sender","recipientTooltipEth":"Ethereum address for the recipient","txTooltipOasis":"Oasis hash for the transaction","senderTooltipOasis":"Oasis address for the sender","recipientTooltipOasis":"Oasis address for the recipient","txTooltipHashUnavailable":"Hash not available in selected address format","txEncrypted":"This transaction is encrypted.","txNotEncrypted":"This transaction is <strong>not</strong> encrypted.","senderTooltipUnavailable":"Sender not available in selected address format","recipientTooltipUnavailable":"Recipient not available in selected address format"}},"runtimeEvent":{"cantLoadEvents":"Unfortunately we couldn\'t load the list of events. Please try again later.","noEvents":"No events","cantFindMatchingEvents":"We can\'t find any matching events.","accountsburn":"Tokens burnt","accountsmint":"Tokens minted","accountstransfer":"Transfer","consensusDeposit":"Deposit from consensus","consensusWithdrawal":"Withdrawal to consensus","consensusDelegate":"Delegate to consensus","consensusUndelegateStart":"Start to undelegate from consensus","consensusUndelegateDone":"Undelegate from consensus finished","evmLog":"EVM log message","filter":{"all":"All events","nonTx":"Non-transactional"},"gasUsed":"Gas used","fields":{"amount":"Amount","data":"Data","emittingContract":"Emitting contract","topics":"Topics","owner":"Owner","activeShares":"Active Shares","debondingShares":"Debonding Shares"}},"transactionStats":{"header":"Transactions Per Day","perDay":"{{value}} tx/day","perHour":"{{value}} tx/hour"},"select":{"placeholder":"Select"},"chartDuration":{"pastDay":"Past day","pastWeek":"Past week","pastMonth":"Past month","pastYear":"Past year","year":"Year","week":"Week","month":"Month","lastHour":"Last hour","lastDay":"Last day","lastMonth":"Last month"},"currentFiatValue":{"title":"Current fiat value","explanation":"This figure is calculated using the current rate. The value at the time of transaction might have been different."},"paraTimeSnapshot":{"header":"{{ paratime }} Snapshot"},"layerPicker":{"chainId":"Chain ID:","decimal":"Decimal: {{ id }}","comingSoonTitle":"Coming soon","comingSoonLabel":"(coming soon)","consensus":"The\xa0consensus layer\xa0is a scalable, high-throughput, secure, proof-of-stake consensus run by a decentralized set of validator nodes.","goToDashboard":"Go to dashboard","hex":"Hex: {{ id }}","readMore":"Read more about {{ layer }} on {{ network }} in Oasis Docs","rpcHttp":"RPC HTTP endpoint: {{ endpoint }}","rpcWebSockets":"RPC WebSockets endpoint: {{ endpoint }}","selected":"(active)","viewNetworks":"View Networks","viewLayers":"View layers","mainnet":{"emerald":"The Emerald ParaTime is our official EVM Compatible ParaTime providing smart contract environment with full EVM compatibility.","sapphire":"The Sapphire ParaTime is our official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility."},"testnet":{"emerald":"The Testnet of the EVM Compatible ParaTime providing a smart contract development environment.","sapphire":"The Testnet of the official confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility.","pontusx":"The Testnet of the official confidential EVM Compatible ParaTime offering a smart contract development environment that is compatible with the Ethereum Virtual Machine (EVM) focused on building a Federated Data Economy."}},"home":{"apiOffline":"Our {{ target }} API is offline. We\u2019re trying to reconnect","userOffline":"You are offline. We\u2019re trying to reconnect","layerOutOfDate":"We don\'t have fully up-to-date data about our {{ target }}. The data displayed here might be out of date.","layerUnavailable":"Data about {{ target }} is currently not available. Please check back later.","layerOutOfDateSince":"The last update we have about our {{ target }} is from {{ lastUpdate }}. The data displayed here might be out of date.","blocks":"Blocks","exploreBtnText":"Explore Oasis","link":"Oasis Explorer Home","txns":"Txns","zoomOutBtnText":"Zoom out","online":"Online","offline":"Offline","helpScreen":{"navigate":"Navigate using your finger","pinch":"Pinch to zoom in and out","tap":"Tap to view info","getStarted":"Get Started","infoIconAria":"Toggle info screen"},"tooltip":{"coming":"Coming soon","openConsensus":"Open Consensus","openParatime":"Open ParaTime","sapphireParaTimeDesc":"Confidential EVM Compatible ParaTime providing a smart contract development environment with EVM compatibility","emeraldParaTimeDesc":"EVM Compatible ParaTime providing smart contract environment with EVM compatibility.","cipherParaTimeDesc":"The Cipher ParaTime is a Confidential ParaTime for executing Wasm smart contracts.","pontusxParaTimeDesc":"Pontus-X ParaTime","consensusDesc":"Our scalable, high-throughput, secure, proof-of-stake consensus layer run by a decentralized set of validator nodes.","close":"Close"},"selectedNetwork":"Selected network","coming":"Coming","soon":"soon"},"paratimes":{"activeNodes":"{{nodes}} active","blockNumber":"Block number:","inactive":"Coming soon","listTitle":"ParaTimes","noData":"No data available","nodes":"Nodes:","online":"Online","outdated":"Out-of-date"},"search":{"placeholder":"Address, Block, Contract, Transaction hash, Token name, etc.","error":{"tooShort":"Please enter either at least 3 characters or a number in order to perform a search.","privacy":"It seems like you might accidentally entered a keyphrase for a wallet. Please note that your mnemonic is a secret key that should never be shared, even not with our {{ appName }}.\\nExecuting this search is highly unlikely to return any results. If you want to proceed nonetheless, please add \u201C{{ wordsOfPower }}\u201D in front of your search query to perform the search at your own risk."},"mobilePlaceholder":"Search Address, Block, Txn, Token, etc","noResults":{"header":"No results found","scopeHeader":"No results found on {{scope}}","description":"Please try another search query <OptionalBreak> or explore the <HomeLink>Oasis ecosystem</HomeLink>.</OptionalBreak>"},"otherResults":{"clickToShowThem":"We found <strong>{{ countLabel }}</strong> on other <strong>Networks</strong>. Click to open these results.","clickToShowMore":"We also found <strong>{{ countLabel }}</strong> on other <strong>Networks</strong>. Click to open these results.","clickToHide":"The results from other <strong>Networks</strong> are shown below. Click to hide those results."},"results":{"accounts":{"title":"Accounts","viewLink":"View Account"},"blocks":{"title":"Blocks","viewLink":"View Block"},"contracts":{"title":"Contracts","viewLink":"View Contract"},"tokens":{"title":"Tokens","viewLink":"View Token"},"transactions":{"title":"Transactions","viewLink":"View Transaction"},"proposals":{"title":"Proposals","viewLink":"View Proposal"},"count_one":"1 result","count_other":"{{ count }} results","moreCount_one":"1 more result","moreCount_other":"{{ count }} more results"},"searchBtnText":"Search","searchSuggestions":"Not sure what to look for? Try out a search: <OptionalBreak><BlockLink><BlockIcon/> Block</BlockLink>, <TransactionLink><TransactionIcon/> Transaction</TransactionLink>, <AccountLink><AccountIcon/> Address</AccountLink>, <TokenLink><TokenIcon/> Token</TokenLink> </OptionalBreak>.","searchSuggestionsForNoResults":"Alternatively, you can view a random <BlockLink><BlockIcon/> Block</BlockLink>, <OptionalBreak><TransactionLink><TransactionIcon/> Transaction</TransactionLink>, <AccountLink><AccountIcon/> Address</AccountLink> or <TokenLink><TokenIcon/> Token</TokenLink></OptionalBreak> <OptionalBreak>to discover our Explorer.</OptionalBreak>","wordsOfPower":"I COMMAND THEE TO SEARCH FOR"},"validator":{"active":"Active","amount":"Amount","balanceDistribution":"Balance Distribution","blockWithHeight":"Block {{height}}","boundsNotSet":"No bounds set (0% - 100%)","change":"Change (24h)","commission":"Commission","commissionBounds":"Commission Bounds","commissionRates":"Commission Rates","cumulativeVoting":"Cumulative Voting %","debondingEnd":"End of debonding","delegators":"Delegators","emptyDebondingList":"No one is debonding delegations from this validator.","emptyDelegationsList":"No one is delegating to this validator.","entityId":"Entity ID","externalLink":"External Link","externalLinkDescriotion":"Oasis is not responsible for any content on\u2028external pages.","groupStatus":"{{status}} validators","inactive":"Inactive","listTitle":"Validators","missed":"Missed","nodeId":"Node ID","participationRate":"Participation Rate","signed":"Signed","signedBlocks":"Signed Blocks","signedBlocksDescription":"Last 100 blocks","proposedBlocks":"Proposed Blocks","snapshot":"Validator Snapshot","shares":"Shares","sharesDocs":"How shares are calculated","staked":"Staked","stakingTrend":"Staking Trend","startDate":"Start Date","title":"Validator","totalShare":"Total Share","undelegations":"Undelegations","uptime":"Uptime","voting":"Voting %","votingPower":"Voting Power"}}');

},{}]},["9gZmm"], "9gZmm", "parcelRequire27e2")

//# sourceMappingURL=index.13649cf2.js.map
